webpackJsonp([2,4],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	__webpack_require__(150);
	__webpack_require__(158);
	__webpack_require__(160);
	__webpack_require__(165);
	__webpack_require__(168);
	__webpack_require__(170);
	__webpack_require__(173);
	__webpack_require__(174);
	__webpack_require__(177);
	__webpack_require__(167);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(182);
	__webpack_require__(184);
	__webpack_require__(186);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(194);
	__webpack_require__(195);
	__webpack_require__(204);
	__webpack_require__(206);
	__webpack_require__(208);
	__webpack_require__(209);
	__webpack_require__(211);
	__webpack_require__(213);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(221);
	__webpack_require__(223);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(227);
	__webpack_require__(229);
	__webpack_require__(231);
	__webpack_require__(233);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(238);
	__webpack_require__(240);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(253);
	__webpack_require__(255);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(265);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(270);
	__webpack_require__(272);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(297);
	__webpack_require__(298);
	__webpack_require__(301);
	__webpack_require__(303);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(315);
	__webpack_require__(245);
	__webpack_require__(175);
	__webpack_require__(153);
	__webpack_require__(152);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(321);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(328);
	__webpack_require__(329);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(332);
	__webpack_require__(333);
	__webpack_require__(334);
	__webpack_require__(335);
	__webpack_require__(336);
	__webpack_require__(337);
	__webpack_require__(338);
	__webpack_require__(339);
	__webpack_require__(340);
	__webpack_require__(341);
	__webpack_require__(342);
	__webpack_require__(343);
	__webpack_require__(344);
	__webpack_require__(345);
	__webpack_require__(346);
	__webpack_require__(347);
	__webpack_require__(348);
	__webpack_require__(349);
	__webpack_require__(350);
	__webpack_require__(351);
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(356);
	__webpack_require__(357);
	__webpack_require__(358);
	__webpack_require__(359);
	__webpack_require__(360);
	__webpack_require__(362);
	__webpack_require__(363);
	__webpack_require__(364);
	__webpack_require__(365);
	__webpack_require__(366);
	__webpack_require__(367);
	__webpack_require__(368);
	__webpack_require__(369);
	module.exports = __webpack_require__(370);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var moment = __webpack_require__(7);
	
	angular.module('account.index', ['common.header', 'common.footer', 'security.authorization', 'services.editionChecker']);
	
	angular.module('account.index').config(["$stateProvider", "securityAuthorizationProvider", function ($stateProvider, securityAuthorizationProvider) {
	  $stateProvider.state('account', {
	    url: '/account',
	    title: 'Account Area',
	    views: {
	      header: {
	        template: __webpack_require__(146),
	        controller: 'HeaderCtrl'
	      },
	      main: {
	        template: __webpack_require__(148),
	        controller: 'AccountCtrl'
	      },
	      footer: {
	        template: __webpack_require__(149),
	        controller: 'FooterCtrl'
	      }
	    },
	    resolve: {
	      user: ["User", "editionChecker", "$location", "$q", function (User, editionChecker, $location, $q) {
	        return User.current().$promise.then(function (user) {
	          if (!user._id) {
	            $location.path('/login');
	            return $q.reject('unauthorized');
	          }
	          editionChecker.check(user);
	          return user;
	        });
	      }],
	      initSearch: ["searchService", "Article", function (searchService, Article) {
	        searchService.setSearchFn(Article.search);
	        searchService.setRedirectBase('/account/edit-article');
	      }]
	    }
	  });
	}]);
	
	angular.module('account.index').controller('AccountCtrl', ["$scope", "user", function ($scope, user) {
	  // editionChecker.check();
	  $scope.dayOfYear = moment().format('DDD');
	  $scope.dayOfMonth = moment().format('D');
	  $scope.weekOfYear = moment().format('w');
	  $scope.dayOfWeek = moment().format('d');
	  $scope.weekYear = moment().format('gg');
	  $scope.hourOfDay = moment().format('H');
	}]);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["moment"] = __webpack_require__(8);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(10)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged and will be removed in an upcoming major release. Please refer to ' +
	            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 11,
		"./af.js": 11,
		"./ar": 12,
		"./ar-dz": 13,
		"./ar-dz.js": 13,
		"./ar-kw": 14,
		"./ar-kw.js": 14,
		"./ar-ly": 15,
		"./ar-ly.js": 15,
		"./ar-ma": 16,
		"./ar-ma.js": 16,
		"./ar-sa": 17,
		"./ar-sa.js": 17,
		"./ar-tn": 18,
		"./ar-tn.js": 18,
		"./ar.js": 12,
		"./az": 19,
		"./az.js": 19,
		"./be": 20,
		"./be.js": 20,
		"./bg": 21,
		"./bg.js": 21,
		"./bm": 22,
		"./bm.js": 22,
		"./bn": 23,
		"./bn-bd": 24,
		"./bn-bd.js": 24,
		"./bn.js": 23,
		"./bo": 25,
		"./bo.js": 25,
		"./br": 26,
		"./br.js": 26,
		"./bs": 27,
		"./bs.js": 27,
		"./ca": 28,
		"./ca.js": 28,
		"./cs": 29,
		"./cs.js": 29,
		"./cv": 30,
		"./cv.js": 30,
		"./cy": 31,
		"./cy.js": 31,
		"./da": 32,
		"./da.js": 32,
		"./de": 33,
		"./de-at": 34,
		"./de-at.js": 34,
		"./de-ch": 35,
		"./de-ch.js": 35,
		"./de.js": 33,
		"./dv": 36,
		"./dv.js": 36,
		"./el": 37,
		"./el.js": 37,
		"./en-au": 38,
		"./en-au.js": 38,
		"./en-ca": 39,
		"./en-ca.js": 39,
		"./en-gb": 40,
		"./en-gb.js": 40,
		"./en-ie": 41,
		"./en-ie.js": 41,
		"./en-il": 42,
		"./en-il.js": 42,
		"./en-in": 43,
		"./en-in.js": 43,
		"./en-nz": 44,
		"./en-nz.js": 44,
		"./en-sg": 45,
		"./en-sg.js": 45,
		"./eo": 46,
		"./eo.js": 46,
		"./es": 47,
		"./es-do": 48,
		"./es-do.js": 48,
		"./es-mx": 49,
		"./es-mx.js": 49,
		"./es-us": 50,
		"./es-us.js": 50,
		"./es.js": 47,
		"./et": 51,
		"./et.js": 51,
		"./eu": 52,
		"./eu.js": 52,
		"./fa": 53,
		"./fa.js": 53,
		"./fi": 54,
		"./fi.js": 54,
		"./fil": 55,
		"./fil.js": 55,
		"./fo": 56,
		"./fo.js": 56,
		"./fr": 57,
		"./fr-ca": 58,
		"./fr-ca.js": 58,
		"./fr-ch": 59,
		"./fr-ch.js": 59,
		"./fr.js": 57,
		"./fy": 60,
		"./fy.js": 60,
		"./ga": 61,
		"./ga.js": 61,
		"./gd": 62,
		"./gd.js": 62,
		"./gl": 63,
		"./gl.js": 63,
		"./gom-deva": 64,
		"./gom-deva.js": 64,
		"./gom-latn": 65,
		"./gom-latn.js": 65,
		"./gu": 66,
		"./gu.js": 66,
		"./he": 67,
		"./he.js": 67,
		"./hi": 68,
		"./hi.js": 68,
		"./hr": 69,
		"./hr.js": 69,
		"./hu": 70,
		"./hu.js": 70,
		"./hy-am": 71,
		"./hy-am.js": 71,
		"./id": 72,
		"./id.js": 72,
		"./is": 73,
		"./is.js": 73,
		"./it": 74,
		"./it-ch": 75,
		"./it-ch.js": 75,
		"./it.js": 74,
		"./ja": 76,
		"./ja.js": 76,
		"./jv": 77,
		"./jv.js": 77,
		"./ka": 78,
		"./ka.js": 78,
		"./kk": 79,
		"./kk.js": 79,
		"./km": 80,
		"./km.js": 80,
		"./kn": 81,
		"./kn.js": 81,
		"./ko": 82,
		"./ko.js": 82,
		"./ku": 83,
		"./ku.js": 83,
		"./ky": 84,
		"./ky.js": 84,
		"./lb": 85,
		"./lb.js": 85,
		"./lo": 86,
		"./lo.js": 86,
		"./lt": 87,
		"./lt.js": 87,
		"./lv": 88,
		"./lv.js": 88,
		"./me": 89,
		"./me.js": 89,
		"./mi": 90,
		"./mi.js": 90,
		"./mk": 91,
		"./mk.js": 91,
		"./ml": 92,
		"./ml.js": 92,
		"./mn": 93,
		"./mn.js": 93,
		"./mr": 94,
		"./mr.js": 94,
		"./ms": 95,
		"./ms-my": 96,
		"./ms-my.js": 96,
		"./ms.js": 95,
		"./mt": 97,
		"./mt.js": 97,
		"./my": 98,
		"./my.js": 98,
		"./nb": 99,
		"./nb.js": 99,
		"./ne": 100,
		"./ne.js": 100,
		"./nl": 101,
		"./nl-be": 102,
		"./nl-be.js": 102,
		"./nl.js": 101,
		"./nn": 103,
		"./nn.js": 103,
		"./oc-lnc": 104,
		"./oc-lnc.js": 104,
		"./pa-in": 105,
		"./pa-in.js": 105,
		"./pl": 106,
		"./pl.js": 106,
		"./pt": 107,
		"./pt-br": 108,
		"./pt-br.js": 108,
		"./pt.js": 107,
		"./ro": 109,
		"./ro.js": 109,
		"./ru": 110,
		"./ru.js": 110,
		"./sd": 111,
		"./sd.js": 111,
		"./se": 112,
		"./se.js": 112,
		"./si": 113,
		"./si.js": 113,
		"./sk": 114,
		"./sk.js": 114,
		"./sl": 115,
		"./sl.js": 115,
		"./sq": 116,
		"./sq.js": 116,
		"./sr": 117,
		"./sr-cyrl": 118,
		"./sr-cyrl.js": 118,
		"./sr.js": 117,
		"./ss": 119,
		"./ss.js": 119,
		"./sv": 120,
		"./sv.js": 120,
		"./sw": 121,
		"./sw.js": 121,
		"./ta": 122,
		"./ta.js": 122,
		"./te": 123,
		"./te.js": 123,
		"./tet": 124,
		"./tet.js": 124,
		"./tg": 125,
		"./tg.js": 125,
		"./th": 126,
		"./th.js": 126,
		"./tk": 127,
		"./tk.js": 127,
		"./tl-ph": 128,
		"./tl-ph.js": 128,
		"./tlh": 129,
		"./tlh.js": 129,
		"./tr": 130,
		"./tr.js": 130,
		"./tzl": 131,
		"./tzl.js": 131,
		"./tzm": 132,
		"./tzm-latn": 133,
		"./tzm-latn.js": 133,
		"./tzm.js": 132,
		"./ug-cn": 134,
		"./ug-cn.js": 134,
		"./uk": 135,
		"./uk.js": 135,
		"./ur": 136,
		"./ur.js": 136,
		"./uz": 137,
		"./uz-latn": 138,
		"./uz-latn.js": 138,
		"./uz.js": 137,
		"./vi": 139,
		"./vi.js": 139,
		"./x-pseudo": 140,
		"./x-pseudo.js": 140,
		"./yo": 141,
		"./yo.js": 141,
		"./zh-cn": 142,
		"./zh-cn.js": 142,
		"./zh-hk": 143,
		"./zh-hk.js": 143,
		"./zh-mo": 144,
		"./zh-mo.js": 144,
		"./zh-tw": 145,
		"./zh-tw.js": 145
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 10;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"navbar navbar-vavel\"> <div class=container> <div class=navbar-header> <a href=/account class=navbar-brand-admin> <img src=" + __webpack_require__(147) + " style=width:40px;height:40px> <span class=vavel-platform></span> </a> <button class=\"navbar-toggle btn navbar-btn\" ng-click=toggleAdminMenu()> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> </button> </div> <form class=\"navbar-form navbar-left\" role=search ng-show=isAuthenticated()> <div class=input-group> <input type=text class=form-control placeholder=Szukaj autocomplete=off ng-model=q ng-model-options=\"{ debounce: 500 }\" uib-typeahead=\"item as item.name for item in search($viewValue)\" typeahead-on-select=onSelect($item)> <span class=input-group-addon> <i class=\"fa fa-search\"></i> </span> </div> </form> <div ng-show=isAuthenticated()> <div class=\"navbar-collapse collapse admin-collapse\" collapse=adminMenuCollapsed> <ul class=\"nav navbar-nav navbar-right user-dropdown\"> <li class=my-articles ng-if=\"isAdmin() || isEditor()\"> <a href=\"/account/main-page?edition=varsovia&limit=50&skip=0&sort=-orderNumber&status=17\" style=\"background-position:-1091px -2px\"> {{localizedMessages.get(\"cover-page\") | uppercase }} </a> </li> <li class=my-articles> <a target=_self href=/account/my-articles style=\"background-position:-1091px -2px\"> {{localizedMessages.get(\"articles\") | uppercase }} </a> </li> <li class=my-articles> <a target=_self href=\"/account/my-articles?limit=50&show_inarticle=1&skip=0&sort=created_at-\" style=\"background-position:-1105px -2px\"> {{localizedMessages.get(\"videos\") | uppercase }} </a> </li> <li class=my-articles href=https://editor.intoleranciadiario.com/account/tags> <a href=/account/tags style=\"background-position:-1111px -2px\"> {{localizedMessages.get(\"tags\") | uppercase }} </a> </li> <li class=\"system-btn dropdown\" dropdown is-open=status.isopen> <a href=# style=\"background-position:-839px -2px\" class=\"dropdown-toggle navbar-dropdown-admin\" dropdown-toggle> {{localizedMessages.get(\"system\") | uppercase }} </a> <ul class=dropdown-menu> <li><a href=/admin/algolia>{{ localizedMessages.get(\"reindexing\") }}</a></li> <li><a href=/admin/recuentos ng-if=\"isAdmin() || isEditor()\">{{ localizedMessages.get(\"counts\") }}</a></li> <li class=divider ng-if=isAdmin()></li> <li class=dropdown-header ng-if=isAdmin()>{{ localizedMessages.get(\"account\") }}</li> <li><a href=/admin/users ng-click=closeAdminMenu() ng-if=isAdmin()>{{ localizedMessages.get(\"users\") }}</a></li> <li><a href=/admin/groups ng-click=closeAdminMenu() ng-if=isAdmin()>{{ localizedMessages.get(\"groups\") }}</a></li> <li><a href=/account/tags ng-click=closeAdminMenu()>{{ localizedMessages.get(\"tags\") }}</a></li> <li><a href=/account/roles ng-click=closeAdminMenu() ng-if=isAdmin()>{{ localizedMessages.get(\"roles\") }}</a></li> <li href=\"\" class=divider ng-if=isAdmin()></li> <li><a href=/admin/homepage ng-click=closeAdminMenu() ng-if=isAdmin()>{{ localizedMessages.get(\"home-page\") }}</a> </li><li><a href=/admin/gallery ng-click=closeAdminMenu() ng-if=isAdmin()>{{ localizedMessages.get(\"gallery\") }}</a> </li> <li><a href=/admin/categories/tree ng-click=closeAdminMenu() ng-if=isAdmin()>{{ localizedMessages.get(\"categories\") }}</a></li> <li href=\"\" class=divider ng-if=isAdmin()></li> <li><a href=/logout ng-click=closeAdminMenu() ng-if=isAdmin()>Wyloguj</a></li> </ul> </li> <li class=icon-menu> <a href=/account/settings title=\"Account settings\"> <span class=\"fa-stack fa-lg\"> <i class=\"fa fa-circle fa-stack-2x fa-inverse\"></i> <i class=\"fa fa-user fa-stack-1x\"></i> </span> </a> </li> <li class=icon-menu> <a href=/logout title=Wyloguj> <span class=\"fa-stack fa-lg\"> <i class=\"fa fa-circle fa-stack-2x fa-inverse\"></i> <i class=\"fa fa-sign-out fa-stack-1x\"></i> </span> </a> </li> </ul> </div> </div> </div> </div>";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=account> <div class=col-sm-6> <div class=page-header><h1>My Account</h1></div> <div class=row> <div class=col-sm-4> <div class=\"well stat\"> <div class=\"stat-value day-of-year\" ng-bind=dayOfYear></div> <div class=stat-label>Day of Year</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=\"stat-value day-of-month\" ng-bind=dayOfMonth></div> <div class=stat-label>Day of Month</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=\"stat-value week-of-year\" ng-bind=weekOfYear></div> <div class=stat-label>Week of Year</div> </div> </div> </div> <div class=row> <div class=col-sm-4> <div class=\"well stat\"> <div class=\"stat-value day-of-week\" ng-bind=dayOfWeek></div> <div class=stat-label>Day of Week</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=\"stat-value week-year\" ng-bind=weekYear></div> <div class=stat-label>Week Year</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=\"stat-value hour-of-day\" ng-bind=hourOfDay></div> <div class=stat-label>Hour of Day</div> </div> </div> </div> </div> <div class=\"col-sm-6 special\"> <div class=page-header><h1>Go Faster Everyday</h1></div> <i class=\"fa fa-dashboard super-awesome\"></i></div> </div> ";

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = "<div class=footer> <div class=container style=text-align:center;text-align:center;color:#000;font-size:12px> <svg width=250 height=30 viewBox=\"0 0 250 30\" fill=none xmlns=http://www.w3.org/2000/svg> <g clip-path=url(#clip0)> <path d=\"M18.1785 2.2423C18.1785 2.2423 9.97097 0.696582 5.76923 3.11313C3.61393 4.33229 1.76343 7.46726 1.30624 7.98976C0 9.51371 0 11.9956 0 14.8911C0 16.2844 0.587808 17.6559 0.870827 19.8548C2.0029 27.1697 5.89985 26.7343 7.96807 27.4527C12.7358 28.6937 22.0972 28.1059 23.5341 27.9752C25.7112 27.8011 30 28.3889 32.1118 22.2931C33.3745 18.6792 34.5501 19.2234 34.0711 12.9317C33.701 10.2757 31.4804 9.36131 30.3266 6.74883C29.1727 4.13635 23.6865 3.505 23.6865 3.505L18.1785 2.2423Z\" fill=#F79568 /> <path d=\"M21.7278 25.254C21.7278 25.254 22.1197 25.9506 23.8831 26.3425C24.1661 26.4731 23.8831 26.7561 23.8831 26.7561L20.4434 26.6255L20.5522 25.0363L21.7278 25.254Z\" fill=white /> <path d=\"M22.206 13.8896H20.2031V25.2539H22.206V13.8896Z\" fill=#FDE282 /> <path d=\"M14.5215 8.62119L15.4141 11.0813L16.089 14.7823C16.089 14.7823 15.806 15.1524 15.6971 15.3266C15.5882 15.5225 15.8495 15.6096 15.9584 15.5225C16.0672 15.4354 16.1978 15.1742 16.1978 15.1742C16.1978 15.1742 16.3285 15.9579 16.4373 16.2845C16.5462 16.611 16.8292 16.4586 16.8074 16.1756C16.7856 15.8926 16.7421 15.5443 16.7421 15.5443C16.7421 15.5443 16.9163 16.0015 17.0033 16.3062C17.0904 16.611 17.3734 16.3716 17.3299 16.1756C17.2864 15.9797 17.134 15.5443 17.134 15.5443C17.134 15.5443 17.221 15.6096 17.417 15.9361C17.6129 16.2627 17.7871 15.9797 17.7218 15.8708C17.6565 15.7402 17.0033 14.5428 17.0033 14.5428L16.5679 11.3208L15.5447 7.75037L14.5215 8.62119Z\" fill=#FFF0D3 /> <path d=\"M18.744 25.0798C18.744 25.0798 18.3521 25.7764 16.5887 26.1683C16.3057 26.2989 16.5887 26.5819 16.5887 26.5819L20.0284 26.4513L19.9196 24.8621L18.744 25.0798Z\" fill=white /> <path d=\"M20.224 4.98535H18.7871V6.63993H20.224V4.98535Z\" fill=#FFF0D3 /> <path d=\"M20.3326 5.76917C20.3326 5.76917 19.6577 6.66176 18.678 5.76917C17.0234 5.76917 16.588 6.53114 16.4791 6.98832C16.4138 7.24957 16.2832 11.7126 16.2832 11.7126L16.3267 14.1073H22.3355V12.1697C22.3355 12.1697 23.424 11.7126 23.424 11.1248C23.424 10.5369 22.7926 6.68353 22.5749 6.46583C22.3355 5.76917 20.3326 5.76917 20.3326 5.76917Z\" fill=#187278 /> <path d=\"M19.3985 5.42081C20.4686 5.42081 21.3361 4.23167 21.3361 2.76479C21.3361 1.29791 20.4686 0.108765 19.3985 0.108765C18.3284 0.108765 17.4609 1.29791 17.4609 2.76479C17.4609 4.23167 18.3284 5.42081 19.3985 5.42081Z\" fill=#FFF0D3 /> <path d=\"M21.4645 2.7648C21.3556 2.7648 20.6808 2.9825 20.3542 2.9825C20.0276 2.43824 20.0276 0.979601 20.0276 0.979601C20.0276 0.979601 18.6996 1.30616 17.5893 1.19731C17.6982 1.08845 17.807 0.870747 17.807 0.870747L17.4805 0.761894C17.4805 0.761894 18.4819 -0.0218506 19.5922 -0.0218506C20.376 -0.0218506 20.8114 0.522416 21.0291 1.08845C21.2468 1.65449 21.4645 2.7648 21.4645 2.7648Z\" fill=#1A4C4F /> <path d=\"M21.3344 3.46137C21.5147 3.46137 21.6609 3.25668 21.6609 3.00418C21.6609 2.75169 21.5147 2.547 21.3344 2.547C21.154 2.547 21.0078 2.75169 21.0078 3.00418C21.0078 3.25668 21.154 3.46137 21.3344 3.46137Z\" fill=#FFF0D3 /> <path d=\"M19.2874 2.67768C19.3836 2.67768 19.4616 2.5997 19.4616 2.50351C19.4616 2.40732 19.3836 2.32935 19.2874 2.32935C19.1913 2.32935 19.1133 2.40732 19.1133 2.50351C19.1133 2.5997 19.1913 2.67768 19.2874 2.67768Z\" fill=#187278 /> <path d=\"M18.1781 2.4383C18.2743 2.4383 18.3522 2.36032 18.3522 2.26413C18.3522 2.16794 18.2743 2.08997 18.1781 2.08997C18.0819 2.08997 18.0039 2.16794 18.0039 2.26413C18.0039 2.36032 18.0819 2.4383 18.1781 2.4383Z\" fill=#187278 /> <path d=\"M18.6796 2.43823L18.2441 3.65739L18.6796 3.76624\" stroke=#187278 stroke-width=1.645 stroke-miterlimit=10 /> <path d=\"M7.42346 9.01301C11.3422 9.33957 12.9968 6.55292 14.586 1.85045C14.6513 1.65452 10.4278 1.41504 10.4278 1.41504C10.4278 1.41504 9.57876 4.6371 6.85742 6.05219C7.27106 6.24813 7.40169 7.77208 7.42346 9.01301Z\" fill=#F7CD4F /> <path d=\"M11.8017 7.33115L13.2598 7.37268L13.3075 5.69701L11.8494 5.65548L11.8017 7.33115Z\" fill=#FFF0D3 /> <path d=\"M14.7063 3.49589C14.7484 2.01758 13.9057 0.794191 12.824 0.763379C11.7423 0.732568 10.8312 1.906 10.7891 3.38431C10.747 4.86263 11.5898 6.08601 12.6715 6.11682C13.7532 6.14764 14.6642 4.9742 14.7063 3.49589Z\" fill=#FFF0D3 /> <path d=\"M11.1249 3.62629C11.1321 3.3739 10.9917 3.16513 10.8115 3.15999C10.6312 3.15486 10.4792 3.3553 10.472 3.6077C10.4648 3.86009 10.6051 4.06886 10.7854 4.074C10.9657 4.07913 11.1177 3.87869 11.1249 3.62629Z\" fill=#FFF0D3 /> <path d=\"M12.8656 3.3526C12.9618 3.3526 13.0397 3.27463 13.0397 3.17844C13.0397 3.08225 12.9618 3.00427 12.8656 3.00427C12.7694 3.00427 12.6914 3.08225 12.6914 3.17844C12.6914 3.27463 12.7694 3.3526 12.8656 3.3526Z\" fill=#187278 /> <path d=\"M13.9984 3.2873C14.0946 3.2873 14.1726 3.20932 14.1726 3.11313C14.1726 3.01694 14.0946 2.93896 13.9984 2.93896C13.9022 2.93896 13.8242 3.01694 13.8242 3.11313C13.8242 3.20932 13.9022 3.2873 13.9984 3.2873Z\" fill=#187278 /> <path d=\"M13.5207 3.30908C13.5207 3.7445 13.8908 4.37585 13.8908 4.37585L13.4336 4.4847\" stroke=#187278 stroke-width=1.6602 stroke-miterlimit=10 /> <path d=\"M14.1723 4.59363C14.1723 4.59363 13.6716 5.81279 12.8008 4.68071\" stroke=#187278 stroke-width=1.9794 stroke-miterlimit=10 /> <path d=\"M12.6063 18.4614C12.6063 18.4614 12.5192 20.595 12.3886 21.444C12.5628 22.7067 12.2797 23.1421 12.0185 24.296C11.9096 25.428 11.9096 25.2974 11.9314 26.5601C11.6266 26.5601 9.27539 26.6254 9.27539 26.6254V26.473L11.0388 25.8635C11.0388 25.8635 11.1041 22.7502 11.0824 22.1624C11.0824 21.8794 11.0606 21.6182 11.0606 21.0304C11.0388 20.3119 10.8429 18.4832 10.8429 18.4832L12.6063 18.4614Z\" fill=#187278 /> <path d=\"M13.084 18.1785C13.084 18.1785 13.1711 20.312 13.3017 21.1611C13.1275 22.4237 13.4105 22.8592 13.6718 24.013C13.8024 25.1451 13.8024 25.0145 13.7589 26.2772C14.0637 26.2772 16.4149 26.3425 16.4149 26.3425V26.1901L14.6515 25.5805C14.6515 25.5805 14.5862 22.4673 14.5862 21.8795C14.5862 21.5965 14.6079 21.3352 14.6079 20.7474C14.6297 20.029 14.8256 18.2002 14.8256 18.2002L13.084 18.1785Z\" fill=#187278 /> <path d=\"M11.4257 9.31987L14.0371 9.24548L13.9627 6.63405L11.3513 6.70843L11.4257 9.31987Z\" fill=#FFF0D3 /> <path d=\"M10.4937 18.788H15.3704C15.3704 18.788 15.1962 14.6733 14.8914 13.8243C14.5866 12.9752 14.5866 11.7125 14.5866 11.7125L14.6737 8.88232L14.9567 8.79524L15.784 8.42514C15.784 8.42514 15.7187 7.20598 14.1948 6.7488C13.89 6.61817 13.7593 6.48755 13.7593 6.48755C13.7593 6.48755 13.3892 9.05649 12.3442 9.07826C11.604 9.10003 11.5823 7.96795 11.5823 7.96795L11.5387 6.55286C11.5387 6.55286 10.4284 6.70526 10.1454 7.01005C9.68822 7.57608 9.1875 8.53399 9.1875 8.53399L10.472 9.20888C10.472 9.20888 10.5591 11.2553 10.5808 11.9738C10.6026 12.6922 9.90593 14.1291 10.0801 14.8257C10.1236 15.8054 10.4937 18.788 10.4937 18.788Z\" fill=white /> <path d=\"M12.8662 2.02459C12.8662 2.02459 12.7573 2.28583 12.3219 2.67771C11.8865 3.06958 11.5164 2.96073 11.5164 2.96073L11.0157 6.22633L9.44818 6.42226L9.23047 6.44404C9.23047 6.44404 9.68765 3.13489 10.036 2.19875C10.3843 1.24084 10.9068 0.500639 11.4511 0.435327C11.9953 0.370015 12.1913 0.631263 12.1913 0.631263C12.1913 0.631263 12.3872 0.108767 13.737 0.391785C14.6078 0.565951 14.6296 1.26261 14.7385 1.67626C14.8691 2.0899 14.6296 2.63417 14.6296 2.63417L12.8662 2.02459Z\" fill=#F7CD4F /> <path d=\"M18.1348 4.04932C18.1348 4.04932 18.6355 5.26847 19.5063 4.1364\" stroke=#187278 stroke-width=1.9928 stroke-miterlimit=10 /> <path d=\"M24.8828 14.6297C25.5577 14.5862 25.8189 12.1697 25.8189 12.1697L28.2573 11.9302L29.52 14.7821C29.4982 14.7821 27.7565 15.1087 24.8828 14.6297Z\" fill=#F7CD4F /> <path d=\"M29.2602 19.2017L29.7392 19.267C29.7392 19.267 30.0439 20.1596 30.1093 20.4426C30.1746 20.7038 29.8915 20.7256 29.848 20.4861C29.7609 20.2684 29.6956 20.0725 29.6956 20.0725C29.6956 20.0725 29.7392 20.4426 29.7609 20.6168C29.7827 20.8345 29.4997 20.8345 29.4997 20.6385C29.4997 20.4426 29.4344 20.0725 29.4344 20.0725C29.4344 20.0725 29.4344 20.3773 29.4126 20.5514C29.3691 20.7256 29.1513 20.7474 29.1296 20.5079C29.1296 20.2684 29.1949 19.8112 29.1949 19.8112C29.1949 19.8112 29.086 19.8548 28.9554 19.9854C28.8248 20.116 28.7159 19.833 28.7812 19.7459C28.8683 19.6588 29.2602 19.2017 29.2602 19.2017Z\" fill=#FFF0D3 /> <path d=\"M24.4921 19.1364L24.884 19.4194C24.884 19.4194 24.7534 20.3555 24.6881 20.6385C24.6227 20.8998 24.3833 20.7909 24.4268 20.5732C24.4486 20.3337 24.4486 20.1378 24.4486 20.1378C24.4486 20.1378 24.318 20.4861 24.2744 20.6603C24.2091 20.878 23.9479 20.7474 24.0132 20.5732C24.0785 20.3991 24.2091 20.0507 24.2091 20.0507C24.2091 20.0507 24.0785 20.3337 23.9696 20.4644C23.8608 20.595 23.6431 20.5297 23.7519 20.312C23.839 20.0943 24.122 19.7242 24.122 19.7242C24.122 19.7242 24.0132 19.7242 23.839 19.7677C23.6648 19.8112 23.6866 19.5282 23.7955 19.4629C23.9261 19.3758 24.4921 19.1364 24.4921 19.1364Z\" fill=#FFF0D3 /> <path d=\"M28.5464 13.4641C28.7514 12.4261 28.3057 11.4638 27.5508 11.3147C26.7959 11.1655 26.0177 11.8861 25.8127 12.924C25.6076 13.962 26.0534 14.9244 26.8083 15.0735C27.5631 15.2226 28.3413 14.5021 28.5464 13.4641Z\" fill=#FFF0D3 /> <path d=\"M28.748 13.6852C28.7829 13.5083 28.7061 13.3441 28.5764 13.3184C28.4466 13.2928 28.3131 13.4154 28.2781 13.5924C28.2432 13.7693 28.32 13.9335 28.4498 13.9591C28.5795 13.9848 28.713 13.8621 28.748 13.6852Z\" fill=#FFF0D3 /> <path d=\"M27.1479 13.1059C27.208 13.1059 27.2568 13.0572 27.2568 12.997C27.2568 12.9369 27.208 12.8882 27.1479 12.8882C27.0878 12.8882 27.0391 12.9369 27.0391 12.997C27.0391 13.0572 27.0878 13.1059 27.1479 13.1059Z\" fill=#187278 /> <path d=\"M26.3862 12.7792C26.4463 12.7792 26.4951 12.7305 26.4951 12.6704C26.4951 12.6103 26.4463 12.5615 26.3862 12.5615C26.3261 12.5615 26.2773 12.6103 26.2773 12.6704C26.2773 12.7305 26.3261 12.7792 26.3862 12.7792Z\" fill=#187278 /> <path d=\"M26.5609 13.193L26.2344 13.6719L26.5392 13.8026\" stroke=#187278 stroke-width=1.1839 stroke-miterlimit=10 /> <path d=\"M25.9727 13.9767C25.9727 13.9767 26.321 14.7169 27.1483 14.2597\" stroke=#187278 stroke-width=1.1839 stroke-miterlimit=10 /> <path d=\"M26.9316 20.7256C26.9316 20.7256 27.1711 24.7749 27.3453 25.7764C27.4324 26.7561 27.3888 25.6458 27.3888 26.7561C27.5848 26.7561 28.7604 26.7996 28.7604 26.7996V26.5384L27.9549 26.1465C27.9549 26.1465 27.9113 24.4484 27.9331 23.9259C27.9331 23.6864 27.9331 23.4469 27.9331 22.9462C27.9331 22.3366 28.0419 20.7256 28.0419 20.7256H26.9316Z\" fill=#187278 /> <path d=\"M26.7352 20.3773C26.7352 20.3773 26.6916 24.4484 26.561 25.4281C26.5175 26.4078 26.4957 25.3193 26.561 26.4078C26.3651 26.4078 25.1895 26.5167 25.1895 26.5167V26.2554L25.9732 25.8418C25.9732 25.8418 25.9297 24.1436 25.8861 23.6212C25.8643 23.3817 25.8643 23.1422 25.8208 22.6415C25.7773 22.0319 25.6031 20.4426 25.6031 20.4426L26.7352 20.3773Z\" fill=#187278 /> <path d=\"M25.1016 22.968H28.7808L28.5413 19.071L25.4499 18.8969L25.1016 22.968Z\" fill=#F5EBBF /> <path d=\"M28.5405 19.071L28.4969 16.8504L29.1283 19.4411H29.8032C29.8032 19.4411 28.9106 15.7836 28.7146 15.4571C28.5187 15.1523 27.8221 15.1523 27.8221 15.1523C27.8221 15.1523 26.7553 15.4135 26.0586 15.1523C25.928 15.1087 25.362 15.1958 25.2967 15.5224C25.2096 15.8272 24.2734 19.2669 24.2734 19.2669L24.9048 19.5064L25.6014 16.8068L25.4491 19.1145L28.5405 19.071Z\" fill=white /> <path d=\"M27.8436 12.5615L28.1484 14.4774C28.1484 14.4774 28.9539 14.9345 29.7159 14.7168C28.6926 13.8242 28.9757 12.3656 28.6491 11.8867C28.3225 11.4077 27.7565 10.9723 27.0381 10.9723C26.2543 10.9723 25.906 11.6254 25.8407 11.8867C25.7754 12.1261 25.8189 12.3221 25.8189 12.3221L26.1019 12.3656L27.8436 12.5615Z\" fill=#F7CD4F /> <path d=\"M14.6082 12.3439H10.5371C10.3847 13.1058 9.90573 14.2162 10.0581 14.8257C10.0799 15.8272 9.79688 18.788 9.79688 18.788H15.5443C15.5443 18.788 15.5661 14.6733 15.2178 13.8243C15.0001 13.3671 14.7388 12.7793 14.6082 12.3439Z\" fill=#F5EBBF /> <path d=\"M10.4505 9.23072L10.0369 11.4513L9.86272 15.1959C9.86272 15.1959 10.1893 15.5224 10.3199 15.6966C10.4505 15.8708 10.2111 16.0014 10.1022 15.9143C9.99335 15.8272 9.81918 15.5878 9.81918 15.5878C9.81918 15.5878 9.79741 16.3933 9.7321 16.7198C9.66679 17.0464 9.362 16.9375 9.362 16.6763C9.362 16.3933 9.34023 16.0449 9.34023 16.0449C9.34023 16.0449 9.23137 16.5239 9.18783 16.8287C9.14429 17.1335 8.8395 16.9375 8.8395 16.7416C8.8395 16.5457 8.94835 16.0885 8.94835 16.0885C8.94835 16.0885 8.88304 16.1756 8.73065 16.5239C8.57825 16.8722 8.36054 16.6327 8.40409 16.5021C8.44763 16.3715 8.92658 15.087 8.92658 15.087L8.94835 11.8214L9.362 8.59937L10.4505 9.23072Z\" fill=#FFF0D3 /> <path d=\"M1.54554 16.2409L1.28429 16.6328C1.28429 16.6328 0.609397 16.5239 0.413461 16.4804C0.239295 16.4368 0.348149 16.1756 0.500543 16.2409C0.674709 16.2627 0.827104 16.2627 0.827104 16.2627C0.827104 16.2627 0.587626 16.1538 0.478773 16.0885C0.326378 16.0232 0.457002 15.7837 0.587626 15.849C0.71825 15.9143 0.935957 16.0232 0.935957 16.0232C0.935957 16.0232 0.740021 15.9143 0.652938 15.8055C0.565855 15.7184 0.652938 15.5007 0.805333 15.5878C0.957728 15.6749 1.19721 15.9361 1.19721 15.9361C1.19721 15.9361 1.21898 15.8272 1.19721 15.6531C1.17543 15.5007 1.39314 15.5007 1.43668 15.5878C1.43668 15.6749 1.54554 16.2409 1.54554 16.2409Z\" fill=#FFF0D3 /> <path d=\"M8.70792 15.3701L9.18688 15.4136C9.18688 15.4136 9.51344 14.804 9.60052 14.6299C9.66583 14.4557 9.40458 14.3904 9.36104 14.5428C9.27396 14.6952 9.18688 14.804 9.18688 14.804C9.18688 14.804 9.23042 14.5428 9.27396 14.4122C9.3175 14.2598 9.03448 14.2162 9.01271 14.3469C8.99094 14.4775 8.9474 14.7387 8.9474 14.7387C8.9474 14.7387 8.96917 14.521 8.9474 14.3904C8.92563 14.2598 8.68615 14.1945 8.68615 14.3686C8.66438 14.5428 8.72969 14.8911 8.72969 14.8911C8.72969 14.8911 8.62084 14.8476 8.51199 14.7387C8.40313 14.6299 8.27251 14.804 8.33782 14.8911C8.33782 14.9564 8.70792 15.3701 8.70792 15.3701Z\" fill=#FFF0D3 /> <path d=\"M5.73279 17.1903C6.36973 17.0645 6.74629 16.2549 6.57385 15.3821C6.40142 14.5092 5.7453 13.9037 5.10836 14.0295C4.47142 14.1553 4.09486 14.9649 4.2673 15.8377C4.43973 16.7106 5.09585 17.3162 5.73279 17.1903Z\" fill=#FFF0D3 /> <path d=\"M4.20164 15.1522C4.26695 15.1305 4.50643 15.0869 4.70236 15.0434C4.83299 14.6733 4.85476 14.608 4.85476 14.608C4.85476 14.608 5.68204 14.6515 6.33516 14.4556C6.24808 14.412 6.161 14.2814 6.161 14.2814L6.35694 14.1726C6.35694 14.1726 5.66027 13.8242 5.00715 13.9548C4.54997 14.0419 4.35403 14.4338 4.26695 14.7821C4.17987 15.1305 4.20164 15.1522 4.20164 15.1522Z\" fill=#3C5658 /> <path d=\"M4.34293 16.2575C4.44908 16.2366 4.51058 16.0953 4.48029 15.9419C4.45 15.7886 4.33939 15.6813 4.23323 15.7023C4.12707 15.7232 4.06557 15.8645 4.09586 16.0179C4.12616 16.1712 4.23677 16.2785 4.34293 16.2575Z\" fill=#FFF0D3 /> <path d=\"M5.46432 15.5441C5.52444 15.5441 5.57318 15.4954 5.57318 15.4353C5.57318 15.3752 5.52444 15.3264 5.46432 15.3264C5.4042 15.3264 5.35547 15.3752 5.35547 15.4353C5.35547 15.4954 5.4042 15.5441 5.46432 15.5441Z\" fill=#187278 /> <path d=\"M6.09518 15.2829C6.1553 15.2829 6.20403 15.2342 6.20403 15.174C6.20403 15.1139 6.1553 15.0652 6.09518 15.0652C6.03506 15.0652 5.98633 15.1139 5.98633 15.174C5.98633 15.2342 6.03506 15.2829 6.09518 15.2829Z\" fill=#187278 /> <path d=\"M5.94336 15.6095L6.22638 16.0014L5.96513 16.132\" stroke=#187278 stroke-width=1.0028 stroke-miterlimit=10 /> <path d=\"M6.44481 16.2626C6.44481 16.2626 6.14002 16.8939 5.44336 16.5021\" stroke=#187278 stroke-width=1.0028 stroke-miterlimit=10 /> <path d=\"M4.3107 21.161H6.87964L6.70547 25.9506L7.2062 26.1683V26.3642L5.89996 26.2553L5.59517 22.5543L5.29038 26.3207L3.85352 26.4295V26.2336L4.48487 25.907L4.3107 21.161Z\" fill=#3C5658 /> <path d=\"M6.90176 18.6574L7.09769 21.357H4.20219V18.2655L2.70002 17.6124L1.1543 16.6763L1.58971 16.0885L3.0048 16.894L4.39813 17.2641L6.70582 17.3512L8.01206 16.6545L8.51279 15.3483H9.29653L8.59987 17.1552L6.90176 18.6574Z\" fill=#3C6A6C /> <path d=\"M22.8389 12.0391H14.7402V12.6051H22.8389V12.0391Z\" fill=#187278 /> <path d=\"M21.5545 11.1682L22.2729 11.5383C22.2729 11.5383 22.2076 12.6922 22.164 13.0405C22.1205 13.3453 21.6633 13.1929 21.7286 12.9316C21.7504 12.6486 21.7069 12.3874 21.7069 12.3874C21.7069 12.3874 21.5545 12.801 21.4891 13.0187C21.4021 13.28 20.9667 13.084 21.0537 12.8881C21.1408 12.6704 21.2932 12.2567 21.2932 12.2567C21.2932 12.2567 21.119 12.6051 20.9667 12.7575C20.8143 12.9099 20.4442 12.801 20.553 12.5398C20.6619 12.2785 21.0755 11.8213 21.0755 11.8213C21.0755 11.8213 20.8796 11.7996 20.6183 11.8649C20.3571 11.9084 20.3353 11.5383 20.4877 11.4948C20.6401 11.4512 21.5545 11.1682 21.5545 11.1682Z\" fill=#FFF0D3 /> <path d=\"M23.8833 19.0057C23.8397 15.3918 21.4885 12.4745 18.593 12.4745C15.6975 12.4745 13.3245 15.3918 13.3027 19.0057H23.8833Z\" fill=#1A4C4F /> <path d=\"M22.707 19.0057C22.6635 15.9143 20.6605 13.4106 18.1787 13.4106C15.6968 13.4106 13.6722 15.9143 13.6504 19.0057H22.707Z\" fill=#FDE282 /> <path d=\"M20.0513 19.0057C20.8133 16.3062 19.4852 14.1509 18.179 14.1509C16.8728 14.1509 15.6101 16.3062 16.1326 19.0057H20.0513Z\" fill=#F79568 /> <path d=\"M12.9316 19.0275C12.9752 22.6414 15.3264 25.5587 18.2219 25.5587C21.1174 25.5587 23.4904 22.6414 23.5122 19.0275H12.9316Z\" fill=#1A4C4F /> <path d=\"M13.4539 23.5775H12.8008V26.9302H13.4539V23.5775Z\" fill=#1A4C4F /> <path d=\"M23.8172 23.5775H23.1641V26.9302H23.8172V23.5775Z\" fill=#1A4C4F /> <path d=\"M24.0563 24.8838H12.4961V24.9926H24.0563V24.8838Z\" fill=#1A4C4F /> <path d=\"M17.9165 17.5471C18.674 17.5471 19.288 16.933 19.288 16.1755C19.288 15.418 18.674 14.804 17.9165 14.804C17.159 14.804 16.5449 15.418 16.5449 16.1755C16.5449 16.933 17.159 17.5471 17.9165 17.5471Z\" fill=#F5EBBF /> <path d=\"M17.394 15.7836C17.4541 15.7836 17.5029 15.7349 17.5029 15.6748C17.5029 15.6147 17.4541 15.5659 17.394 15.5659C17.3339 15.5659 17.2852 15.6147 17.2852 15.6748C17.2852 15.7349 17.3339 15.7836 17.394 15.7836Z\" fill=#187278 /> <path d=\"M18.396 15.8925C18.4561 15.8925 18.5048 15.8438 18.5048 15.7837C18.5048 15.7235 18.4561 15.6748 18.396 15.6748C18.3358 15.6748 18.2871 15.7235 18.2871 15.7837C18.2871 15.8438 18.3358 15.8925 18.396 15.8925Z\" fill=#187278 /> <path d=\"M17.5685 16.8722C17.7368 16.8722 17.8733 16.6968 17.8733 16.4804C17.8733 16.2639 17.7368 16.0885 17.5685 16.0885C17.4001 16.0885 17.2637 16.2639 17.2637 16.4804C17.2637 16.6968 17.4001 16.8722 17.5685 16.8722Z\" fill=#F79568 /> <path d=\"M18.047 16.9374C18.2153 16.9374 18.3518 16.762 18.3518 16.5456C18.3518 16.3291 18.2153 16.1537 18.047 16.1537C17.8786 16.1537 17.7422 16.3291 17.7422 16.5456C17.7422 16.762 17.8786 16.9374 18.047 16.9374Z\" fill=#F79568 /> <path d=\"M17.7649 17.2205C17.9813 17.2205 18.1568 17.0451 18.1568 16.8286C18.1568 16.6122 17.9813 16.4368 17.7649 16.4368C17.5485 16.4368 17.373 16.6122 17.373 16.8286C17.373 17.0451 17.5485 17.2205 17.7649 17.2205Z\" stroke=#187278 stroke-width=1.2832 stroke-miterlimit=10 /> <path d=\"M43.9984 0.761934C44.0201 0.827246 44.0854 0.892558 44.1943 0.892558C44.7168 0.761934 45.2175 0.95787 45.74 0.914329C46.6979 0.892558 47.6776 0.783705 48.6137 0.914329C49.7023 1.00141 50.8126 1.06672 51.7269 1.74161C52.2059 2.08995 52.6631 2.50359 53.055 3.00431C53.4033 3.4615 53.4468 3.94045 53.6645 4.39764C53.6863 4.48472 53.6645 4.61535 53.6863 4.7242C53.8169 5.31201 53.7734 6.11752 53.8387 6.81418C53.904 7.55439 53.9258 8.31636 53.6863 9.07833L53.4686 9.49198C52.9461 10.3846 52.7284 11.0377 52.1841 11.3207C51.5963 11.6037 51.1174 12.0391 50.6166 12.3875C50.5296 12.4528 50.4207 12.5399 50.2901 12.5834C49.2886 12.9971 48.4178 13.6502 47.4817 14.1944L47.068 14.4121C46.4149 14.7387 46.3931 15.0653 46.3931 15.1741L46.3714 15.8272C46.5673 17.0246 46.2843 18.2002 46.3931 19.3759C46.4584 19.8548 46.2625 20.5079 46.2625 20.9434C46.2625 21.7053 46.2843 22.4455 46.4584 23.2075C46.4802 23.3599 46.5238 23.4905 46.4584 23.6211C46.4367 23.8389 46.306 23.9695 46.0666 23.8824C45.5223 23.6865 44.4991 24.1001 44.0637 23.0769C43.9766 22.7939 44.0419 21.9448 43.9113 21.8577C43.7589 21.7706 43.6936 23.3381 43.5629 23.3381C43.0187 23.3381 42.6921 23.0769 42.6703 22.5326C42.6486 22.119 42.605 21.7271 42.6703 21.3135C42.7574 20.4209 42.6703 19.3541 42.6703 18.4397V16.7416C42.6703 16.4804 42.5833 16.3497 42.2567 16.4151C41.9301 16.5021 41.8431 16.3497 41.9301 16.0667C42.0172 15.8708 42.1478 15.6095 42.322 15.6095C42.7357 15.5442 42.6486 15.283 42.6486 15.0217C42.5833 13.4542 42.4526 11.9085 42.4309 10.3193C42.4091 8.77355 42.4091 7.27137 42.4309 5.72565C42.4309 4.85482 42.5615 4.02754 42.6268 3.15671C42.6486 2.76484 42.6268 2.35119 42.605 1.95932C42.5833 1.76339 42.605 1.63276 42.5833 1.50214C42.5615 1.37151 41.9955 1.3062 41.9737 1.17558C42.039 0.95787 42.5179 0.979641 42.5833 0.696622C42.605 0.544227 42.9316 0.370062 43.1058 0.435374C43.3235 0.609539 43.7371 0.457144 43.9984 0.761934ZM45.6965 1.87224C45.7618 2.28588 45.9142 2.69952 45.8924 3.15671C45.8706 3.57035 45.8924 4.02754 45.8924 4.48472C45.8706 5.8345 45.8271 7.22783 45.9795 8.57761C46.0666 9.47021 45.9795 10.4063 46.1754 11.3207C46.2407 11.7997 46.306 12.2786 46.306 12.7794C46.306 12.9317 46.306 13.1712 46.4367 13.3672C46.5673 13.2801 46.6326 13.2148 46.6979 13.1495C47.0898 12.6052 47.7647 12.431 48.2436 11.9303C48.5049 11.669 48.8968 11.4731 49.0492 11.1683C49.5063 10.2322 49.8764 9.29604 50.0724 8.27282C50.0941 8.05511 50.203 7.94626 50.3989 7.92449C50.3989 8.38167 50.2683 8.92594 49.9853 9.68791C49.9635 9.81854 49.9853 9.81854 49.9853 9.88385C50.3119 9.88385 51.1174 7.75032 50.8126 6.79241C50.8126 6.77064 50.7908 6.7271 50.7255 6.7271C50.6384 6.79241 50.6384 6.94481 50.5078 7.07543C50.3119 6.8795 50.3772 6.68356 50.4207 6.48762C50.5078 6.09575 50.5078 5.96513 50.5513 5.6168C50.5731 5.35555 50.5513 4.94191 50.486 4.68066C50.4642 4.48472 50.4207 4.22347 50.2901 4.02754C50.0071 3.48327 49.7676 2.89546 49.3322 2.41651C49.1362 2.1988 48.9185 2.00286 48.5702 1.89401C47.6776 1.63276 46.7415 1.87224 45.8271 1.80693C45.7618 1.76339 45.74 1.80693 45.6965 1.87224Z\" fill=#F79568 /> <path d=\"M57.7363 9.53548C57.7363 9.68787 57.5404 9.79673 57.5404 9.99266C57.8016 10.0144 58.1282 10.2539 58.1935 9.73141C58.1935 9.64433 58.3241 9.6661 58.3894 9.64433C59.3256 9.55725 60.0658 9.97089 60.806 10.4498C60.8277 10.4498 60.8931 10.5152 60.8931 10.5805C61.1108 11.1247 61.5462 11.5166 61.9163 11.9738C62.3299 12.4963 62.3735 13.1276 62.5694 13.7154C62.6347 14.042 62.6565 14.3686 62.7 14.6734C62.7 15.3482 62.8524 16.0231 62.9613 16.698C63.0266 17.3076 63.1137 17.9172 62.7653 18.505C62.6347 18.7227 62.5694 19.0493 62.5694 19.3105C62.5912 20.0507 62.3517 20.6603 61.9816 21.2699C61.6986 21.8141 61.3938 22.2931 61.089 22.8374C60.8277 23.251 60.3706 23.3599 59.9569 23.5123C59.4344 22.968 60.2182 22.9898 60.2835 22.7067C60.0875 22.6197 59.8916 22.7285 59.761 22.7938C59.2385 23.1204 58.6724 23.2728 58.1499 23.534C57.7363 23.7517 57.3227 23.7517 56.8655 23.5123C56.1906 23.1204 55.5375 22.6414 54.9714 22.1189C54.2965 21.4658 53.8393 20.6385 53.5781 19.7024C53.2951 18.4397 53.3604 17.2205 53.4257 15.9578C53.4257 14.7604 53.7087 13.6066 54.0788 12.4745C54.4925 11.2771 55.102 10.341 56.2994 9.86204C56.5607 9.77495 56.7784 9.60079 57.0179 9.47017C57.2573 9.36131 57.4751 9.36131 57.7363 9.53548ZM57.5839 11.1465C57.4968 11.6037 57.2573 11.9738 57.1703 12.431C57.0396 12.8882 56.8872 13.3018 56.9526 13.8243C56.9743 14.4774 57.0832 15.1523 56.9743 15.7837C56.909 16.2626 56.8872 16.7198 56.9526 17.177C56.9526 17.5253 56.9743 17.9172 56.9526 18.2655C56.8655 19.4629 57.0832 20.5732 57.7145 21.6182C57.7798 21.7488 57.8016 21.9012 57.9975 21.8359C58.4547 21.6835 58.5418 22.0318 58.6724 22.3584C58.9555 22.2931 59.1514 22.1407 59.2167 21.9665C59.8263 21.2481 60.0875 20.4208 60.1746 19.55C60.3052 18.222 60.3706 16.9157 60.3923 15.5877L60.327 12.8882C60.3052 12.2133 60.044 11.6037 59.4997 11.19C59.2167 10.9723 58.9119 10.8417 58.6071 11.0377C58.2806 11.1683 57.9322 11.2118 57.5839 11.1465ZM59.4126 23.8606C59.5433 23.8388 59.6304 23.73 59.565 23.5776C59.5433 23.4252 59.4344 23.4905 59.282 23.5123C59.1949 23.5776 59.0861 23.5776 58.999 23.7735C59.1296 23.817 59.282 23.8606 59.4126 23.8606Z\" fill=#F79568 /> <path d=\"M73.5182 9.75312C73.5399 9.94905 73.7359 9.97082 73.91 9.97082C74.3237 9.99259 74.4978 10.2538 74.5849 10.6239C74.7373 11.1464 74.8026 11.6472 75.0639 12.1914C75.4557 11.8431 75.8694 11.5165 76.196 11.1247C77.524 9.62249 78.9608 9.70957 80.4848 10.1232C80.7678 10.2103 80.9637 10.4498 81.1379 10.6675C81.7475 11.4295 82.4224 12.3003 82.4224 13.4759C82.4224 14.2161 82.4224 14.9781 82.6183 15.7618V16.0448C82.4659 16.8721 82.553 17.743 82.5312 18.6138C82.5094 19.1363 82.3353 19.6152 82.1393 20.0724C82.1393 20.1377 81.9216 20.7255 81.7257 21.0956C81.4427 21.7052 81.312 21.7705 80.7678 22.5543C80.6372 22.7067 80.3106 22.9461 80.0929 23.0768C79.8752 22.4672 80.7678 22.3148 80.5501 21.727C80.2017 22.1406 80.0058 22.6849 79.4833 22.9461C79.4615 22.9679 79.418 23.0332 79.3962 23.0985C79.2656 23.2509 79.4833 23.5775 79.1785 23.6428C78.852 23.7299 78.5254 23.7299 78.1771 23.7299C77.4151 23.7081 76.8491 23.3162 76.3701 22.772C76.0436 22.4237 75.7605 22.0535 75.4122 21.6399C75.2598 22.3583 75.2816 23.0332 75.1945 23.7081C75.1074 24.7749 75.2163 25.8416 75.1727 26.8866C75.151 27.4962 75.151 28.084 74.9115 28.6501C74.8244 28.8678 74.8897 29.129 74.8462 29.3903C74.8244 29.5862 74.8462 29.7821 74.6502 29.9781C74.2366 29.5644 73.5182 29.4556 73.3222 28.5848C73.1916 28.9766 73.1263 29.1943 73.061 29.4556C72.6473 29.1726 72.4079 28.8025 72.2555 28.367C72.0378 27.5398 72.1248 26.6907 72.0378 25.8634C71.8418 24.2959 71.9725 22.7502 72.0595 21.161C72.1466 20.0289 72.1248 18.9186 72.2119 17.7865C72.3643 16.1537 72.2119 14.4991 72.2772 12.8663L72.3643 11.473C72.3861 10.994 72.3861 10.5151 72.3425 10.0144C72.2772 9.62249 72.4732 9.40479 72.865 9.40479C73.061 9.4701 73.3875 9.40478 73.5182 9.75312ZM76.9144 11.5165C76.1089 11.9302 75.6517 12.7357 75.2163 13.4759C75.151 13.5412 75.151 13.6283 75.151 13.6936C75.2816 14.8475 75.3469 15.9795 75.3687 17.1334C75.3904 18.026 75.4993 18.9621 75.3904 19.8983C75.3904 20.1595 75.4122 20.3554 75.5864 20.5514C76 21.0956 76.4137 21.6399 76.9362 22.0535C77.1539 22.2495 77.4151 22.3366 77.6981 22.4019C77.8287 22.4237 77.9158 22.4019 78.0247 22.2713C78.6778 21.1827 79.0479 20.0289 79.1132 18.7226V17.264C79.2003 16.0013 78.8955 14.7821 78.8955 13.5194C78.8955 12.9099 78.6996 12.3003 78.6125 11.6907C78.5472 11.2988 78.2642 11.0376 78.0247 11.1029C77.6546 11.2335 77.2409 11.3206 76.9144 11.5165Z\" fill=#F79568 /> <path d=\"M87.1911 0.870732C87.1693 1.15375 87.2781 1.2626 87.5394 1.48031C88.2143 2.08989 88.4102 2.6777 87.6918 3.24374C87.3652 3.46144 87.1475 3.91863 86.625 3.83154C86.4073 3.61384 86.0372 3.80977 85.7542 3.67915C84.6874 3.13488 84.535 2.28583 85.2752 1.2626C85.6018 0.80542 86.0808 0.544172 86.6686 0.457089C87.0604 0.413547 87.1911 0.522401 87.1911 0.870732ZM88.0401 10.624C88.0619 10.7111 88.0619 10.8417 88.1707 10.907C88.5191 10.6458 88.6279 10.6893 88.6279 11.103C88.6497 11.2553 88.6497 11.4295 88.6061 11.5819C88.5191 11.9085 88.5191 12.235 88.5844 12.5398C88.7368 13.8896 88.715 15.2394 88.7368 16.5892C88.7585 17.4164 88.8674 18.222 88.9545 19.071C88.9763 19.6588 89.0851 20.2249 89.1069 20.8127C89.1722 21.4658 89.0198 21.9448 89.6294 21.6835C90.3043 21.3569 90.4349 21.4005 91.3057 20.7909C91.5887 20.595 92.1983 20.116 92.5249 20.0289C92.7208 19.9418 92.8732 19.833 93.0038 19.7024C93.2868 19.4847 93.6134 19.2452 94.027 19.5717C93.8093 19.8983 93.5481 20.116 93.2651 20.3337C92.8079 20.6821 92.5466 20.878 92.2419 21.4005C92.0895 21.6835 91.9588 21.727 91.654 21.7488C91.4581 21.7488 91.2404 22.0101 91.0662 22.1407C90.8703 22.2931 90.6526 22.3366 90.4784 22.489C90.3478 22.6414 90.2607 22.8156 90.1301 22.9027C89.9777 23.0333 89.7382 23.0986 89.5423 23.1639L88.9327 23.3598C88.8021 23.4252 88.6497 23.4469 88.4755 23.4469C88.3884 23.4469 88.2796 23.4252 88.1925 23.4252C88.0619 23.4905 87.9966 23.6211 87.8659 23.6429C87.7353 23.6646 87.4523 23.5776 87.2781 23.4905C87.0169 23.3598 86.625 23.3381 86.342 23.0768C86.1896 22.9462 85.9501 22.9897 85.8195 22.8809C85.3405 22.3584 85.297 21.727 85.2099 21.0739C85.1228 20.2466 85.1446 19.3758 85.1881 18.505C85.2099 17.4818 85.2535 16.415 85.3405 15.3918C85.4276 14.4992 85.4929 13.5848 85.4276 12.6922C85.3623 12.0391 85.58 11.4077 85.4276 10.7329C85.4059 10.5151 85.6453 10.2757 85.8195 10.1233C86.1025 9.86202 86.4944 9.7314 86.8863 9.70963C87.5829 9.68786 87.8659 9.97088 88.0401 10.624Z\" fill=#F79568 /> <path d=\"M95.8135 9.75313C95.7482 9.97084 95.204 9.90553 95.1387 10.145C95.2693 10.2756 95.4217 10.2103 95.5523 10.1232C96.2707 9.73136 96.815 9.57897 97.6858 9.90553C97.8382 9.97084 98.0342 10.0362 98.1648 10.1015C98.4913 10.2539 98.5566 10.2539 98.8179 10.428L99.1662 10.6457C99.6234 10.9288 100.233 12.2568 100.32 13.28C100.385 14.042 100.32 14.5645 100.059 15.3482C99.9282 15.6748 99.8629 16.0666 99.4492 16.1755C99.3186 16.1973 99.3186 16.3061 99.2969 16.3932C98.7744 16.6762 98.5349 17.0028 97.7947 17.2858C97.4463 17.4164 97.1416 17.6123 96.8368 17.743C96.3796 17.8954 96.0313 18.2002 95.5088 18.4832C95.77 19.2234 95.9006 19.9418 96.3143 20.5514C96.5755 20.8997 96.7932 20.965 97.0545 21.3134C97.4028 21.7923 97.7294 21.9012 98.2736 21.7052C99.8847 21.0957 100.429 21.1827 101.888 20.2031C102.367 19.8765 102.367 19.7459 102.954 19.5935C103.281 19.4629 103.477 19.3105 103.76 19.1145C103.847 19.0492 103.956 18.9186 104.152 18.9839C104.239 19.7023 103.825 19.7459 103.477 20.0724C103.324 20.2031 103.15 20.2684 103.02 20.4861C102.693 20.8126 101.474 21.5746 101.343 21.6399C100.625 21.9883 100.93 21.7923 100.277 22.293C100.124 22.3801 99.6234 22.6414 99.471 22.772C98.9485 23.1203 98.4043 23.1203 98.143 23.3163C97.5334 23.7735 96.5755 23.7735 95.8353 23.7952C95.3781 23.7952 94.8121 23.6428 94.3767 23.2074C93.6147 22.4672 93.0269 21.7923 92.7003 20.7909C92.635 20.6602 92.635 20.5732 92.6132 20.4643C92.4826 19.9418 92.352 19.7241 92.3302 19.2016C92.3302 18.9404 92.3085 18.0478 92.2649 17.5035C92.1996 16.502 92.3302 14.9563 92.5479 13.9984C92.8092 12.8446 93.0704 11.6907 93.8106 10.711C94.2243 10.1885 94.7032 9.84022 95.3564 9.70959C95.4434 9.73136 95.7482 9.62251 95.8135 9.75313ZM94.8339 21.1392C95.1822 21.727 95.5088 22.293 96.1619 22.5978C96.1836 22.5325 96.2272 22.5108 96.249 22.4672C95.9877 22.1407 95.77 21.7923 95.487 21.5093C95.1604 21.1827 95.1386 20.7473 94.8774 20.3555C94.6379 20.6385 94.6597 20.8997 94.8339 21.1392ZM95.9442 11.2553C95.5958 11.7125 95.4652 12.5833 95.4217 13.1276C95.3346 14.2597 95.487 15.4353 95.3564 16.5456C95.3564 16.7633 95.3346 17.0899 95.3781 17.3511C95.5958 17.3293 95.9224 16.9592 96.053 16.8939C96.532 16.5674 96.8803 16.219 97.3157 15.9578C97.86 15.6094 97.7947 15.1305 97.9688 14.3903C97.9906 14.3032 97.9906 14.042 98.0341 13.9331C98.1212 13.4759 98.0342 12.8446 97.9471 12.5398C97.7947 12.0608 97.6858 11.7996 97.6205 11.4512C97.5552 11.19 97.4246 10.8634 97.2286 10.7764C96.532 10.4716 96.4014 10.6457 95.9442 11.2553ZM96.9238 22.5325C96.7932 22.2495 96.6408 22.1189 96.4013 22.0753C96.4884 22.3148 96.5973 22.4672 96.9238 22.5325Z\" fill=#F79568 /> <path d=\"M105.806 11.1683C105.806 11.2336 105.828 11.3207 105.872 11.386C105.872 11.4077 105.893 11.4513 105.937 11.5166C106.351 11.19 106.742 10.8417 107.156 10.5151C107.962 9.90557 108.658 9.77494 109.594 9.99265C110.117 10.1233 110.618 10.4063 111.01 10.8852C110.857 11.2118 110.552 11.2336 110.291 11.103C110.073 11.0159 109.943 11.0159 109.812 11.1683C109.594 11.4295 109.224 11.2553 109.072 11.6255L108.876 11.7778C107.94 12.1262 107.309 12.6487 106.851 13.6066C106.699 13.9985 106.764 14.3468 106.503 14.6951C106.307 14.9128 106.242 15.1741 106.285 15.5224C106.307 16.1102 106.351 16.7198 106.351 17.2858C106.372 18.5703 106.503 19.833 106.547 21.0739C106.568 21.6182 106.547 22.1407 106.547 22.685C106.547 22.968 106.089 24.013 105.937 24.1654C105.523 23.6429 105.175 23.6211 104.674 24.1001C104.457 24.3178 104.326 24.0347 104.152 24.0783C104.021 24.1654 104.152 24.2742 104.13 24.3613H103.999C103.346 23.7082 103.063 22.9462 103.063 22.0101C103.129 20.6603 102.998 19.3105 102.867 17.9172C102.802 17.3076 102.846 16.7198 102.889 16.1102C103.02 15.3047 103.02 14.4992 102.976 13.6937C102.976 13.3453 103.041 12.9752 103.041 12.6269C103.063 11.9738 103.041 11.3642 102.889 10.7546C102.824 10.6675 102.824 10.4934 102.976 10.4716C103.129 10.4063 103.129 10.6022 103.237 10.6675C103.52 10.5151 103.433 10.2104 103.433 9.94911C103.695 9.75317 104.021 9.79671 104.195 9.53546C104.261 9.44838 104.391 9.47015 104.478 9.53546C105.131 9.97088 105.763 10.2974 105.806 11.1683ZM110.792 11.8432C110.77 11.8649 110.705 11.9085 110.705 11.8649C110.182 11.669 109.812 11.7343 109.42 11.952C109.203 12.1479 108.941 12.3003 108.593 12.3439C108.68 12.0826 108.92 12.0609 109.05 11.9302L109.246 11.7778C109.442 11.7561 109.573 11.5819 109.79 11.4513C110.269 11.2553 110.465 11.3207 110.792 11.8432Z\" fill=#F79568 /> <path d=\"M125.922 9.14362C125.835 9.47018 125.835 9.60081 125.726 9.88383C125.465 10.7547 125.4 11.6255 125.313 12.5181C125.182 13.7155 124.834 14.8258 124.485 15.9578C124.202 16.9593 123.941 17.9607 123.767 18.984C123.614 19.8766 123.244 20.7256 123.005 21.5965C122.874 22.119 122.548 22.5544 122.417 23.0986C122.395 23.3163 122.286 23.3599 121.807 23.6211C121.263 23.3599 120.806 22.968 120.458 22.4891C120.262 22.5761 120.458 22.7068 120.327 22.8156C119.783 22.5544 119.369 22.0972 119.173 21.4876C118.956 20.7474 118.912 19.9854 118.847 19.2235C118.76 18.0696 118.716 16.9375 118.651 15.7837C118.651 15.6531 118.673 15.5007 118.52 15.37C118.324 15.566 118.237 15.849 118.172 16.1102C117.758 17.7213 117.105 19.267 116.844 20.9433C116.757 21.7053 116.387 22.4237 116.321 23.2075C116.321 23.3599 116.256 23.4905 116.169 23.5994C115.755 23.447 115.755 23.447 115.45 23.7953C115.124 24.2525 115.059 24.2089 114.558 23.9912C113.905 23.73 113.622 23.2728 113.469 22.5761C113.273 21.8359 113.208 21.074 113.121 20.3338C113.034 19.6589 113.034 18.984 112.838 18.3309C112.446 17.0464 112.294 15.6966 112.076 14.3686C111.88 13.1712 111.684 11.9956 111.423 10.82C111.401 10.6893 111.292 10.5587 111.401 10.4063C111.684 10.5369 111.532 10.9288 111.793 11.0812C111.88 10.7982 111.641 10.5369 111.706 10.2104C112.12 10.4063 112.359 9.94914 112.729 9.94914C112.86 9.36133 113.382 9.60081 113.731 9.55727C114.275 9.49196 114.688 9.9056 114.754 10.4499C114.819 10.907 114.884 11.3207 115.015 11.7343C115.146 12.2786 115.211 12.8229 115.233 13.3671C115.255 14.238 115.494 15.1088 115.559 15.9796C115.625 16.8069 115.69 17.656 115.886 18.4832L115.973 19.1364C116.234 18.8751 116.256 18.5486 116.365 18.3091C116.626 17.4383 116.887 16.5674 117.17 15.6966C117.497 14.7387 117.911 13.759 118.172 12.7358C118.237 12.5181 118.259 12.2786 118.237 12.0174C118.172 11.7561 118.15 11.4731 118.106 11.1901C118.041 10.5805 118.324 10.2539 118.934 10.4281C119.391 10.5152 119.87 10.6893 120.284 10.907C120.414 10.9941 120.545 11.103 120.632 11.2336C121.22 11.9738 121.459 12.8446 121.633 13.7808C121.916 15.4136 122.091 17.1335 122.112 18.8098C122.112 18.9404 122.091 19.0711 122.243 19.1364C122.395 19.0057 122.395 18.8098 122.461 18.6574C122.918 17.3729 123.201 16.0885 123.68 14.8258C123.81 14.4774 123.832 14.1073 123.897 13.759C124.05 12.8229 124.442 11.952 124.616 11.0159C124.681 10.6893 124.703 10.3628 124.812 10.058C124.834 9.86206 124.725 9.47018 125.16 9.51373C125.16 9.51373 125.182 9.3831 125.225 9.31779C125.225 9.33956 125.247 9.23071 125.443 9.10008C125.596 9.013 125.574 8.81706 125.726 8.83883C125.857 8.8606 125.944 8.99123 125.922 9.14362Z\" fill=#F79568 /> <path d=\"M132.932 9.66605C133.062 9.66605 132.061 10.2539 132.67 10.2539C132.888 10.2539 132.518 10.5369 132.061 10.7328C132.039 10.7546 131.865 10.8634 131.734 10.8852C131.386 10.9723 130.994 11.0376 130.798 11.3424C130.537 11.7343 129.906 11.8214 130.058 12.4309C130.08 12.5833 130.08 12.8228 130.08 13.0187C130.145 13.3671 131.081 14.2814 131.408 14.4991C132.126 15.0434 132.888 15.9578 133.215 16.502C133.672 17.264 134.042 19.2016 133.89 20.0724C133.737 20.6602 133.28 21.2916 132.932 21.9447C132.453 22.8809 131.255 23.1421 130.624 23.4251C130.493 23.4904 130.341 23.5122 130.232 23.5557C129.906 23.6864 129.078 23.6428 128.556 23.4904C128.207 23.4034 127.337 23.2074 127.598 23.1421C127.75 23.1203 127.924 23.2727 126.988 22.7502C126.117 22.2277 126.4 22.2713 126.161 21.8794C125.878 21.4005 126.313 21.6835 126.292 21.5964C126.27 21.444 125.769 21.0739 126.03 21.1392C126.161 21.161 126.117 21.1174 126.226 21.1174C126.488 21.1392 126.945 21.5964 126.901 21.3787C126.879 21.0957 126.292 20.7256 126.03 20.4425C125.9 19.9854 126.444 20.5732 126.771 20.7038C127.054 20.8344 127.38 21.161 127.99 21.2481C128.382 21.4658 129.013 21.4658 129.34 21.3787C129.688 21.0521 130.014 20.7256 130.08 20.3119C130.167 19.5499 130.014 18.3526 129.47 17.5035C128.948 16.698 128.12 15.936 127.445 15.2611C126.727 14.4556 126.575 13.2582 126.901 12.3003C127.119 11.5601 127.445 10.907 128.316 10.7328C128.447 10.711 128.578 10.6457 128.665 10.5151C129.187 10.1232 129.731 10.1232 130.297 10.0362C130.755 9.94907 131.234 9.84022 131.647 9.64428C132.039 9.4048 132.496 9.66605 132.932 9.66605ZM129.165 16.0884L129.775 17.0245C129.927 17.1769 130.123 17.4382 130.297 17.4382C130.297 17.3076 130.363 17.1552 130.297 17.0245C130.297 17.0245 130.167 16.8939 129.949 16.6109L129.144 15.5877L128.556 15.0652C128.338 15.0216 129.035 15.8707 129.165 16.0884Z\" fill=#F79568 /> <path d=\"M143.73 10.145C143.948 10.145 143.817 10.3628 143.948 10.4281C144.557 10.7764 144.274 11.1683 144.013 11.5819C144.013 11.6472 143.948 11.669 143.926 11.7343C143.643 12.3221 143.207 12.8228 143.12 13.563C143.033 14.2815 142.641 14.9564 142.402 15.653C142.054 16.6763 141.662 17.6559 141.117 18.5485C140.769 19.1363 140.639 19.8112 140.399 20.4208C140.247 20.878 140.181 21.3569 139.724 21.7053C140.53 21.727 141.292 21.64 142.097 21.5529C142.99 21.4223 143.926 21.4876 144.84 21.8794C144.644 22.206 144.165 22.2278 144.187 22.6414L144.1 22.7067C143.49 22.9027 142.881 23.0986 142.293 23.0333C141.422 22.9462 140.551 23.0333 139.724 23.0115C138.266 23.0115 136.959 23.6211 135.566 23.6864C134.978 23.7082 134.63 23.4687 134.412 22.7938C134.673 22.5979 135 22.7285 135.305 22.6414C135.326 22.4237 135.283 22.1625 135.37 21.923C135.435 21.64 135.022 21.7271 135.022 21.4005C136.981 18.1567 138.94 14.7387 140.29 11.0594C140.16 10.9723 140.029 10.9941 139.877 11.0376C139.049 11.2336 138.178 11.2554 137.264 11.1683C137.112 11.1465 136.937 11.103 136.785 11.1683C136.567 11.2554 136.306 11.2336 136.176 11.1465C135.697 10.7982 135.109 10.7982 134.434 10.4934C135.043 10.2974 135.522 10.145 136.045 10.145C136.807 10.1668 137.612 10.1668 138.396 10.1668C139.398 10.1668 140.355 10.1668 141.357 10.145C141.705 10.145 142.032 10.1233 142.38 10.058C142.859 9.97088 143.273 10.1668 143.73 10.145ZM138.636 21.7924C138.766 21.8794 138.853 21.8794 138.897 21.8577C139.223 21.2481 139.572 20.7038 139.702 20.0289L139.572 20.0072C139.245 20.595 138.962 21.2046 138.636 21.7924ZM141.313 11.2989C141.4 11.2771 141.444 11.1465 141.4 11.103C141.27 10.9723 141.139 10.9723 140.987 11.0812C141.009 11.2554 141.117 11.3642 141.313 11.2989Z\" fill=#F79568 /> <path d=\"M149.392 9.75313C149.326 9.97084 148.782 9.90553 148.717 10.145C148.847 10.2756 149 10.2103 149.13 10.1232C149.849 9.73136 150.393 9.57897 151.264 9.90553C151.416 9.97084 151.612 10.0362 151.743 10.1015C152.069 10.2539 152.135 10.2539 152.396 10.428L152.744 10.6457C153.202 10.9288 153.811 12.2568 153.898 13.28C153.964 14.042 153.898 14.5645 153.637 15.3482C153.506 15.6748 153.441 16.0666 153.027 16.1755C152.897 16.1973 152.897 16.3061 152.875 16.3932C152.352 16.6762 152.113 17.0028 151.373 17.2858C151.024 17.4164 150.72 17.6123 150.415 17.743C149.958 17.8954 149.609 18.2002 149.087 18.4832C149.348 19.2234 149.479 19.9418 149.892 20.5514C150.154 20.8997 150.371 20.965 150.633 21.3134C150.981 21.7923 151.308 21.9012 151.852 21.7052C153.463 21.0957 154.007 21.1827 155.466 20.2031C155.945 19.8765 155.945 19.7459 156.532 19.5935C156.859 19.4629 157.055 19.3105 157.338 19.1145C157.425 19.0492 157.534 18.9186 157.73 18.9839C157.817 19.7023 157.403 19.7459 157.055 20.0724C156.903 20.2031 156.728 20.2684 156.598 20.4861C156.271 20.8126 155.052 21.5746 154.921 21.6399C154.203 21.9883 154.508 21.7923 153.855 22.293C153.702 22.3801 153.202 22.6414 153.049 22.772C152.527 23.1203 151.982 23.1203 151.721 23.3163C151.112 23.7735 150.154 23.7735 149.413 23.7952C148.956 23.7952 148.39 23.6428 147.955 23.2074C147.193 22.4672 146.605 21.7923 146.278 20.7909C146.213 20.6602 146.213 20.5732 146.191 20.4643C146.061 19.9418 145.93 19.7241 145.908 19.2016C145.908 18.9404 145.887 18.0478 145.843 17.5035C145.778 16.502 145.908 14.9563 146.126 13.9984C146.387 12.8446 146.649 11.6907 147.389 10.711C147.802 10.1885 148.281 9.84022 148.934 9.70959C149 9.73136 149.326 9.62251 149.392 9.75313ZM148.39 21.1392C148.739 21.727 149.065 22.293 149.718 22.5978C149.74 22.5325 149.784 22.5108 149.805 22.4672C149.544 22.1407 149.326 21.7923 149.043 21.5093C148.717 21.1827 148.695 20.7473 148.434 20.3555C148.194 20.6385 148.238 20.8997 148.39 21.1392ZM149.522 11.2553C149.174 11.7125 149.043 12.5833 149 13.1276C148.913 14.2597 149.065 15.4353 148.934 16.5456C148.934 16.7633 148.913 17.0899 148.956 17.3511C149.174 17.3293 149.501 16.9592 149.631 16.8939C150.11 16.5674 150.458 16.219 150.894 15.9578C151.438 15.6094 151.373 15.1305 151.547 14.3903C151.569 14.3032 151.569 14.042 151.612 13.9331C151.699 13.4759 151.612 12.8446 151.525 12.5398C151.373 12.0608 151.264 11.7996 151.199 11.4512C151.133 11.19 151.003 10.8634 150.807 10.7764C150.088 10.4716 149.958 10.6457 149.522 11.2553ZM150.48 22.5325C150.35 22.2495 150.197 22.1189 149.958 22.0753C150.067 22.3148 150.154 22.4672 150.48 22.5325Z\" fill=#F79568 /> <path d=\"M169.288 0.957843C170.224 1.02316 171.182 1.02316 171.987 1.56742C172.445 1.91575 172.945 2.15523 173.468 2.3294C173.881 2.52533 174.186 2.85189 174.339 3.28731C174.73 4.24522 175.101 5.2249 175.013 6.31343C174.992 6.66176 175.166 6.96655 175.166 7.31488C175.188 8.70821 174.556 9.73143 173.598 10.624C173.141 11.0377 172.575 11.2989 172.053 11.6472C171.9 11.7779 171.77 11.9085 171.508 11.9738C171.53 11.6908 171.857 11.6255 171.857 11.3207C171.443 11.4078 171.182 11.7126 170.899 11.9738C170.768 12.1044 170.921 12.3004 171.051 12.3875C171.508 12.7793 171.922 13.2147 172.336 13.6502C173.011 14.3033 173.402 15.1088 173.729 15.9361C174.251 17.2859 174.796 18.6356 175.405 19.9201C175.492 20.1378 175.601 20.3773 175.623 20.6385C175.754 21.1175 175.95 21.64 176.167 22.0972C176.32 22.3584 176.254 22.5761 176.233 22.8374C176.211 23.1204 176.146 23.2946 175.819 23.3163C175.797 23.3163 175.732 23.4034 175.688 23.4687C175.558 23.6647 175.405 23.6864 175.231 23.534C174.905 23.251 174.622 23.0769 174.23 23.3816C174.164 23.447 173.968 23.447 173.881 23.3816C173.359 23.0551 172.749 22.7938 172.466 22.2278C172.336 21.9448 172.183 21.6835 172.009 21.4223C170.986 19.2888 170.072 17.1335 169.201 14.9564C169.07 14.6298 168.939 14.3468 168.743 14.0203C168.33 14.238 168.025 14.5427 168.134 15.0435V15.3047C167.873 16.5021 168.134 17.6777 168.134 18.9187C168.156 20.0507 168.265 21.2046 168.112 22.3367C168.047 22.6197 168.177 23.0115 167.633 22.9462C167.546 22.9245 167.481 23.0333 167.481 23.1422C167.415 23.2946 167.394 23.4687 167.35 23.6211C166.871 23.4252 166.545 23.0333 166.131 22.685C165.739 23.0769 165.304 23.1639 164.847 22.8809C164.324 22.5979 164.085 22.1625 164.041 21.5529C164.019 21.0304 164.172 20.5515 164.128 20.0507C164.063 18.5921 164.063 17.1117 163.997 15.6748C163.997 15.3918 163.932 15.1306 163.91 14.8475C163.584 13.2147 163.562 11.5384 163.649 9.86205C163.736 8.16394 163.736 6.4876 163.802 4.76771C163.823 3.9622 163.932 3.20022 163.867 2.35117C163.867 2.19877 163.889 2.02461 163.802 1.87221C163.453 1.87221 163.127 2.08992 162.778 2.06815C162.691 1.91575 162.974 1.8069 162.8 1.67628C162.539 1.41503 162.713 1.2844 162.952 1.19732C164.106 0.805449 165.304 0.609512 166.566 0.783678C167.481 0.892531 168.373 0.892531 169.288 0.957843ZM167.873 11.7126C168.069 11.6255 168.134 11.5819 168.156 11.5602C169.222 10.4934 170.311 9.49195 171.182 8.27279C171.77 7.44551 171.944 6.46583 172.118 5.50792C172.118 5.35552 172.096 5.2249 172.031 5.09427C171.9 4.83302 171.835 4.57178 171.878 4.28876C171.9 4.07105 171.813 3.89689 171.595 3.8098C171.443 3.74449 171.312 3.61387 171.138 3.52678C170.55 3.0696 170.006 2.56887 169.201 2.3294C168.722 2.19877 168.308 2.24231 167.786 2.24231C167.982 5.37729 167.96 8.4905 167.873 11.7126Z\" fill=#F79568 /> <path d=\"M181.742 9.53548C181.742 9.68787 181.546 9.79673 181.546 9.99266C181.807 10.0144 182.134 10.2539 182.199 9.73141C182.199 9.64433 182.33 9.6661 182.395 9.64433C183.331 9.55725 184.072 9.97089 184.812 10.4498C184.834 10.4498 184.899 10.5152 184.899 10.5805C185.117 11.1247 185.552 11.5166 185.922 11.9738C186.336 12.4963 186.379 13.1276 186.575 13.7154C186.641 14.042 186.662 14.3686 186.706 14.6734C186.706 15.3482 186.858 16.0231 186.967 16.698C187.032 17.3076 187.119 17.9172 186.771 18.505C186.641 18.7227 186.575 19.0493 186.575 19.3105C186.597 20.0507 186.358 20.6603 185.987 21.2699C185.704 21.8141 185.4 22.2931 185.095 22.8374C184.834 23.251 184.376 23.3599 183.963 23.5123C183.44 22.968 184.224 22.9898 184.289 22.7067C184.093 22.6197 183.897 22.7285 183.767 22.7938C183.244 23.1204 182.678 23.2728 182.156 23.534C181.742 23.7517 181.328 23.7517 180.871 23.5123C180.196 23.1204 179.543 22.6414 178.977 22.1189C178.302 21.4658 177.845 20.6385 177.584 19.7024C177.301 18.4397 177.366 17.2205 177.432 15.9578C177.432 14.7604 177.715 13.6066 178.085 12.4745C178.498 11.2771 179.108 10.341 180.305 9.86204C180.567 9.77495 180.784 9.60079 181.024 9.47017C181.263 9.36131 181.481 9.36131 181.742 9.53548ZM181.568 11.1465C181.481 11.6037 181.241 11.9738 181.154 12.431C181.024 12.8882 180.871 13.3018 180.937 13.8243C180.958 14.4774 181.067 15.1523 180.958 15.7837C180.893 16.2626 180.871 16.7198 180.937 17.177C180.937 17.5253 180.958 17.9172 180.937 18.2655C180.85 19.4629 181.067 20.5732 181.699 21.6182C181.764 21.7488 181.786 21.9012 181.982 21.8359C182.439 21.6835 182.526 22.0318 182.657 22.3584C182.94 22.2931 183.135 22.1407 183.201 21.9665C183.81 21.2481 184.072 20.4208 184.159 19.55C184.289 18.222 184.355 16.9157 184.376 15.5877L184.311 12.8882C184.289 12.2133 184.028 11.6037 183.484 11.19C183.201 10.9723 182.896 10.8417 182.591 11.0377C182.286 11.1683 181.938 11.2118 181.568 11.1465ZM183.418 23.8606C183.549 23.8388 183.636 23.73 183.571 23.5776C183.549 23.4252 183.44 23.4905 183.288 23.5123C183.201 23.5776 183.092 23.5776 183.005 23.7735C183.114 23.817 183.288 23.8606 183.418 23.8606Z\" fill=#F79568 /> <path d=\"M198.679 3.788C198.875 4.50643 199.005 5.24663 199.092 5.98683C199.158 6.63995 199.375 7.24953 199.375 7.88088C199.441 9.23067 199.288 10.5587 199.288 11.9085C199.31 12.5616 199.288 13.2365 199.158 13.8678C199.071 14.4774 199.027 15.0652 199.071 15.6748C199.092 16.132 199.092 16.5674 199.071 17.0028C199.049 17.4382 199.049 17.8083 199.136 18.222C199.201 18.7009 199.267 19.1799 199.201 19.7024C199.179 20.116 199.223 20.5079 199.288 20.9215C199.354 21.4005 199.68 21.5746 200.094 21.3352C200.986 20.7909 201.095 21.0521 201.727 20.2031C202.249 19.55 202.989 19.267 203.621 18.8098C203.751 18.7445 203.882 18.788 204.013 18.8098C204.034 19.0057 203.991 19.1581 203.882 19.2887C203.817 19.354 203.795 19.3758 203.751 19.4411C203.534 19.833 203.294 20.2031 202.815 20.2684C202.663 20.2902 202.597 20.4208 202.489 20.5514C202.14 21.0304 201.814 21.4222 201.335 21.7706C200.682 22.2495 200.725 22.3584 200.333 22.772C200.007 23.055 199.528 23.1857 199.049 23.2945C197.895 23.4905 197.22 23.3163 196.502 22.4019C196.371 22.2713 196.284 22.1189 196.153 21.9883C196.088 21.727 196.001 21.444 195.957 21.2699C195.696 20.2684 195.674 19.2016 195.566 18.1784C195.478 16.9593 195.304 15.7401 195.435 14.4992C195.5 13.8243 195.435 13.2365 195.152 12.6051C194.891 12.0173 194.499 11.6472 193.955 11.2118C193.802 11.5601 193.672 11.8649 193.236 11.8214C193.084 11.8214 193.018 11.9738 192.975 12.1044C192.953 12.3003 192.822 12.4527 192.714 12.6487C192.431 13.3236 192.169 13.9984 192.322 14.7822C192.452 15.2611 192.518 15.8054 192.452 16.2844C192.365 16.8722 192.365 17.4818 192.3 18.0478C192.278 19.0057 192.213 19.9418 192.518 20.8562C192.605 21.1175 192.648 21.3787 192.67 21.6182C192.757 22.2713 193.214 22.5543 193.824 22.3584C194.433 22.1625 194.564 22.0101 195.021 21.4876C195.087 21.4005 195.217 21.3569 195.304 21.3352L195.37 21.2045C195.5 21.3569 195.348 22.4237 195.152 22.8809C195.152 22.9027 194.629 23.6211 194.259 23.6864C193.193 23.7517 192.256 23.4687 191.299 22.9244C190.776 22.5979 190.297 22.0318 189.84 20.7038C189.753 20.4426 189.622 20.2249 189.492 19.9636C189.078 19.2234 189.1 18.3526 188.969 17.5471C188.773 16.4803 188.904 15.4571 189.034 14.3903C189.165 13.3889 189.426 12.431 189.905 11.5166C190.384 10.624 191.037 10.0144 192.104 9.84024C192.235 9.84024 192.322 9.75316 192.431 9.70962C192.757 9.62254 193.084 9.579 193.323 9.84024C193.41 9.92733 193.519 10.0362 193.606 10.058C194.325 10.2757 194.956 10.6458 195.478 11.2771C195.762 8.77348 195.957 6.24808 196.24 3.74445C196.632 3.48321 196.828 3.89685 197.111 4.07101C197.133 4.0057 197.177 3.98393 197.177 3.94039C197.09 3.41789 197.155 3.35258 197.634 3.39612C197.786 3.41789 197.96 3.46144 198.113 3.39612C198.439 3.35258 198.57 3.54852 198.679 3.788ZM192.431 22.9897C192.3 22.7938 191.603 22.2278 191.342 22.1625C191.451 22.3802 192.126 23.0115 192.431 22.9897ZM198.439 22.5108C198.461 22.6414 198.592 22.7067 198.722 22.6414C198.875 22.5761 198.809 22.489 198.744 22.3584C198.679 22.2713 198.657 22.1625 198.461 22.0971C198.418 22.206 198.418 22.3802 198.439 22.5108Z\" fill=#F79568 /> <path d=\"M210.544 10.145C210.762 10.145 210.632 10.3628 210.762 10.4281C211.372 10.7764 211.089 11.1683 210.827 11.5819C210.827 11.6472 210.762 11.669 210.74 11.7343C210.457 12.3221 210.022 12.8228 209.935 13.563C209.848 14.2815 209.456 14.9564 209.216 15.653C208.868 16.6763 208.476 17.6559 207.932 18.5485C207.584 19.1363 207.453 19.8112 207.214 20.4208C207.061 20.878 206.996 21.3569 206.539 21.7053C207.344 21.727 208.106 21.64 208.912 21.5529C209.804 21.4223 210.74 21.4876 211.655 21.8794C211.459 22.206 210.98 22.2278 211.002 22.6414L210.915 22.7067C210.305 22.9027 209.695 23.0986 209.108 23.0333C208.237 22.9462 207.366 23.0333 206.539 23.0115C205.08 23.0115 203.774 23.6211 202.38 23.6864C201.793 23.7082 201.444 23.4687 201.227 22.7938C201.488 22.5979 201.814 22.7285 202.119 22.6414C202.141 22.4237 202.097 22.1625 202.184 21.923C202.25 21.64 201.836 21.7271 201.836 21.4005C203.796 18.1567 205.755 14.7387 207.105 11.0594C206.974 10.9723 206.843 10.9941 206.691 11.0376C205.864 11.2336 204.993 11.2554 204.079 11.1683C203.926 11.1465 203.752 11.103 203.6 11.1683C203.382 11.2554 203.121 11.2336 202.99 11.1465C202.511 10.7982 201.923 10.7982 201.248 10.4934C201.858 10.2974 202.337 10.145 202.859 10.145C203.621 10.1668 204.427 10.1668 205.211 10.1668C206.212 10.1668 207.17 10.1668 208.171 10.145C208.52 10.145 208.846 10.1233 209.195 10.058C209.674 9.97088 210.087 10.1668 210.544 10.145ZM205.472 21.7924C205.602 21.8794 205.69 21.8794 205.733 21.8577C206.06 21.2481 206.408 20.7038 206.539 20.0289L206.408 20.0072C206.081 20.595 205.777 21.2046 205.472 21.7924ZM208.128 11.2989C208.215 11.2771 208.259 11.1465 208.215 11.103C208.084 10.9723 207.954 10.9723 207.801 11.0812C207.845 11.2554 207.932 11.3642 208.128 11.2989Z\" fill=#F79568 /> <path d=\"M214.984 0.870732C214.962 1.15375 215.071 1.2626 215.332 1.48031C216.007 2.08989 216.203 2.6777 215.485 3.24374C215.158 3.46144 214.94 3.91863 214.418 3.83154C214.2 3.61384 213.83 3.80977 213.547 3.67915C212.48 3.13488 212.328 2.28583 213.068 1.2626C213.395 0.80542 213.874 0.544172 214.462 0.457089C214.853 0.413547 214.984 0.522401 214.984 0.870732ZM215.833 10.624C215.855 10.7111 215.855 10.8417 215.964 10.907C216.312 10.6458 216.421 10.6893 216.421 11.103C216.443 11.2553 216.443 11.4295 216.399 11.5819C216.312 11.9085 216.312 12.235 216.377 12.5398C216.53 13.8896 216.508 15.2394 216.53 16.5892C216.551 17.4164 216.66 18.222 216.747 19.071C216.769 19.6588 216.878 20.2249 216.9 20.8127C216.965 21.4658 216.813 21.9448 217.422 21.6835C218.097 21.3569 218.228 21.4005 219.099 20.7909C219.382 20.595 219.991 20.116 220.318 20.0289C220.514 19.9418 220.666 19.833 220.797 19.7024C221.08 19.4847 221.406 19.2452 221.82 19.5717C221.602 19.8983 221.341 20.116 221.058 20.3337C220.601 20.6821 220.34 20.878 220.035 21.4005C219.882 21.6835 219.752 21.727 219.447 21.7488C219.251 21.7488 219.033 22.0101 218.859 22.1407C218.663 22.2931 218.446 22.3366 218.271 22.489C218.141 22.6414 218.054 22.8156 217.923 22.9027C217.771 23.0333 217.531 23.0986 217.335 23.1639L216.726 23.3598C216.595 23.4252 216.443 23.4469 216.268 23.4469C216.181 23.4469 216.073 23.4252 215.985 23.4252C215.855 23.4905 215.79 23.6211 215.659 23.6429C215.528 23.6646 215.245 23.5776 215.071 23.4905C214.81 23.3598 214.418 23.3381 214.135 23.0768C213.983 22.9462 213.743 22.9897 213.612 22.8809C213.134 22.3584 213.09 21.727 213.003 21.0739C212.916 20.2466 212.938 19.3758 212.981 18.505C213.003 17.4818 213.046 16.415 213.134 15.3918C213.221 14.4992 213.286 13.5848 213.221 12.6922C213.155 12.0391 213.373 11.4077 213.221 10.7329C213.199 10.5151 213.438 10.2757 213.612 10.1233C213.895 9.86202 214.287 9.7314 214.679 9.70963C215.376 9.68786 215.659 9.97088 215.833 10.624Z\" fill=#F79568 /> <path d=\"M229.571 10.4934L229.702 10.624C229.854 11.2772 230.246 11.8432 230.29 12.5834C230.29 14.1291 230.29 15.6748 230.159 17.177C230.094 17.939 230.181 18.7227 230.159 19.4629C230.137 20.0507 230.355 20.595 230.486 21.1393C230.551 21.4658 231.487 21.8142 231.748 21.6182C232.881 20.8563 233.773 20.2902 234.905 19.5282C234.992 19.4629 235.058 19.4412 235.188 19.5282C235.036 19.9419 234.862 20.6603 234.383 20.878C233.838 21.161 233.294 21.5311 232.924 22.0972C232.663 22.5108 232.402 22.6414 231.966 22.8592C231.618 23.2075 231.444 23.2728 230.943 23.447C230.725 23.5994 230.486 23.7953 230.116 23.8388C229.223 23.9041 228.418 23.5558 227.96 22.7503C227.438 21.923 227.242 20.9869 227.22 20.0507C227.155 18.984 227.155 17.9608 227.198 16.894C227.198 15.2612 227.22 13.7808 227.59 12.1698C227.677 11.7126 227.612 11.4949 227.569 11.0377C227.503 10.5805 227.155 10.3192 226.741 10.7547C225.587 11.8432 224.782 12.8229 224.238 14.325C223.911 15.283 223.955 16.2191 224.042 17.1552C224.063 17.5471 224.063 17.9172 224.042 18.3091C223.955 19.7677 223.824 21.2481 223.889 22.685C223.889 23.0333 223.759 23.1639 223.367 23.2728C223.214 23.3381 223.106 23.4252 223.018 23.4905C222.561 23.8171 222.213 23.7518 221.886 23.2293C221.799 23.0769 221.69 22.8374 221.495 22.7503C221.342 22.8374 221.429 23.0115 221.364 23.1422C221.081 23.0115 221.016 22.7503 220.907 22.4891C220.645 21.7489 220.428 21.0086 220.449 20.2031C220.449 18.7227 220.428 17.2641 220.428 15.7837V10.1233C220.428 9.66612 220.449 9.66612 220.885 9.73143C221.037 9.75321 221.211 9.79675 221.364 9.73143C221.647 9.60081 221.952 9.70966 222.126 9.86206C222.409 10.0798 222.735 10.2539 223.018 10.4716C223.345 10.7329 223.476 11.0594 223.432 11.4731C223.41 12.1262 223.519 12.7358 223.65 13.3671C223.868 13.2147 223.933 13.0188 223.998 12.8446C224.325 11.9738 224.869 11.2336 225.413 10.5369C226.066 9.77498 226.828 9.5355 227.83 9.70966C228.505 9.81852 228.984 10.2322 229.571 10.4934Z\" fill=#F79568 /> <path d=\"M241.676 10.4934C242.198 11.0377 242.416 11.6473 242.22 12.3657V12.5616C242.416 13.3889 242.351 14.0203 242.22 14.8693C242.155 15.1306 242.285 15.3918 242.285 15.6313C242.307 16.7198 242.373 17.8519 242.307 18.9404C242.307 19.3541 242.155 20.0725 242.111 20.4862C242.09 20.8127 242.177 21.2481 242.264 21.5747C242.743 21.64 243.026 21.4876 243.418 21.1611C244.506 20.7692 245.791 19.3323 246.357 19.0058C246.378 19.3976 246.226 19.833 245.812 20.3555C245.486 20.7039 244.528 21.4441 244.18 21.7706C243.701 22.1843 243.026 22.6415 242.481 22.968C241.894 23.3599 241.284 23.5123 240.348 23.4905C240.021 23.4905 239.869 23.2075 239.695 22.968C239.542 22.685 239.412 22.4891 239.216 22.2496C239.063 22.2496 238.955 22.3367 238.889 22.4455C238.824 22.5326 238.737 22.7068 238.628 22.7068C238.214 22.7285 238.105 23.0551 237.67 23.251C237.191 23.447 236.995 23.251 236.516 23.2728C236.32 23.2728 236.168 23.4034 236.494 23.4034C237.235 23.4034 236.364 23.6647 235.406 23.5994C234.949 23.5776 233.991 23.3164 233.73 22.9898C233.011 22.0972 232.859 21.8577 232.837 21.0957L232.772 19.833C232.706 18.5703 233.185 17.6995 233.73 17.0029C234.383 16.132 235.188 15.6531 236.233 15.3918C236.756 15.2394 237.3 15.1741 237.779 14.9129C238.127 14.7605 238.432 15.0435 238.802 14.9129C238.933 14.042 238.802 12.4746 238.737 11.6037C238.737 11.0812 238.584 10.9506 238.084 11.1465C237.126 11.5384 236.473 11.669 235.406 11.6908C235.319 11.7126 235.188 11.6908 235.123 11.7561C234.47 12.2133 234.056 11.5602 233.555 11.5384C233.534 11.3207 233.621 11.3207 233.686 11.3207C234.513 11.103 235.362 10.7764 235.907 10.7111C236.625 10.624 237.169 10.2975 237.844 10.058C238.171 9.97092 238.301 9.90561 238.606 9.8403C238.998 9.81853 239.325 9.86207 239.629 10.058C239.956 10.2104 240.239 10.4499 240.631 10.4063C240.718 10.1886 240.566 10.1886 240.37 10.058C240.108 10.0362 239.978 9.8403 240.217 9.8403C240.718 9.8403 241.328 10.1451 241.676 10.4934ZM233.664 22.0101C233.882 22.1407 233.947 22.402 234.143 22.5326C234.361 22.6632 234.47 22.9898 234.883 22.9463C234.535 22.5326 234.165 22.1843 233.947 21.7271C233.882 21.5965 233.621 21.1393 233.621 21.5965C233.621 21.7706 233.468 21.923 233.664 22.0101ZM238.388 16.0232C238.258 16.1756 238.236 16.2844 238.062 16.2844C237.975 16.2844 237.91 16.2627 237.714 16.415C237.387 16.6763 237.365 16.7634 237.039 17.0029C236.712 17.2206 236.451 17.5254 236.32 17.8737C235.732 19.2888 235.863 20.9651 236.342 21.4223C236.69 21.7489 236.886 22.0319 237.3 21.8795C237.583 21.7924 238.301 21.357 238.584 21.2699C238.78 21.2046 238.802 20.9869 238.802 20.7474C238.802 20.595 238.78 20.3991 238.802 20.1596C238.867 19.5718 238.606 19.0711 238.737 18.0914C238.802 17.6342 238.671 17.2641 238.759 16.8069C238.846 16.415 238.78 16.2191 238.78 15.8055C238.715 15.8272 238.454 15.9361 238.388 16.0232Z\" fill=#F79568 /> <path d=\"M249.493 1.132C249.711 2.26407 249.841 3.37438 249.623 4.54999C249.428 5.63853 249.297 7.05362 249.297 8.1857C249.319 9.01298 249.297 9.8185 249.362 10.624C249.362 10.8417 249.297 11.0812 249.275 11.2989C249.145 12.1262 249.123 12.9752 249.188 13.8025C249.275 14.6951 249.057 15.566 248.905 16.4368C248.84 16.7851 248.818 17.177 248.579 17.5253C248.513 17.6559 248.491 17.7866 248.252 17.7213C248.1 17.6559 248.1 17.939 247.969 18.0696C247.773 18.2655 247.621 17.743 247.621 17.4818C247.621 17.3947 247.555 17.2858 247.49 17.3294C247.207 17.5253 247.207 17.2641 247.163 17.1334C247.098 16.8504 247.011 16.6545 246.837 16.415C246.554 15.9578 246.51 15.4571 246.554 14.9128C246.554 14.8258 246.554 14.7604 246.576 14.6516C246.554 14.1944 246.576 13.7155 246.249 13.2583C245.922 12.7793 246.118 12.3004 246.118 11.7779C246.097 10.6893 245.966 9.55725 245.901 8.42518C245.879 7.77206 245.922 7.14071 245.748 6.53113C245.683 6.33519 245.683 6.11748 245.683 5.92155L245.596 4.22343C245.574 3.505 245.727 2.7648 245.618 2.0246C245.552 1.56741 246.205 1.41502 246.336 0.957832C246.423 0.609501 246.793 0.631272 246.859 0.89252C247.055 1.89397 247.512 1.82866 247.316 0.56596C247.229 -0.108931 247.773 -0.0871606 248.252 -0.0218485C248.731 0.130546 249.34 0.391794 249.493 1.132ZM248.383 20.312C248.927 20.595 249.21 20.9215 249.645 21.4005C249.711 21.4658 249.776 21.5529 249.732 21.6617C249.645 21.8795 249.667 22.0754 249.732 22.3149C249.798 22.5761 249.645 22.7938 249.406 22.9027C248.818 23.0986 248.339 23.7082 247.708 23.4905C247.359 23.4905 246.989 23.6429 246.772 23.4687C246.554 23.2728 246.619 22.8809 246.554 22.6414C246.532 22.489 246.467 22.3149 246.423 22.1625C246.336 21.7706 246.423 21.4223 246.706 21.2046C247.098 20.8562 247.468 20.5514 247.925 20.3337C248.078 20.1813 248.208 20.2249 248.383 20.312Z\" fill=#F79568 /> </g> <defs> <clipPath id=clip0> <rect width=249.753 height=30 fill=white /> </clipPath> </defs> </svg> <br/> <svg width=295 height=30 viewBox=\"0 0 295 30\" fill=none xmlns=http://www.w3.org/2000/svg> <g clip-path=url(#clip0)> <path d=\"M288.708 13.8742C288.669 13.8933 288.669 13.9506 288.688 13.9887L291.163 17.7101C291.182 17.7292 291.201 17.7483 291.221 17.7483C291.24 17.7483 291.259 17.7483 291.259 17.7292C291.297 17.7101 291.297 17.6529 291.278 17.6147L288.803 13.8933C288.784 13.8551 288.746 13.8551 288.708 13.8742Z\" fill=#414241 /> <path d=\"M273.918 15.3434C273.879 15.3434 273.841 15.3625 273.822 15.4006L272.824 20.2482C272.824 20.2864 272.843 20.3245 272.882 20.3436H272.901C272.939 20.3436 272.978 20.3245 272.978 20.2864L273.975 15.4388C273.994 15.4006 273.956 15.3434 273.918 15.3434Z\" fill=#414241 /> <path d=\"M270.411 9.82833C270.411 9.84741 270.411 9.84741 270.411 9.82833C270.468 9.82833 270.488 9.80924 270.507 9.75199C270.507 9.71382 270.488 9.67565 270.43 9.65657C269.298 9.52298 268.665 9.48482 267.399 9.6184C267.361 9.6184 267.322 9.65657 267.322 9.71382C267.322 9.75199 267.361 9.79016 267.418 9.79016C268.665 9.65657 269.26 9.69474 270.411 9.82833Z\" fill=#414241 /> <path d=\"M286.95 15.4007C286.95 15.3625 286.892 15.3244 286.854 15.3435C286.815 15.3435 286.777 15.4007 286.796 15.4389L287.794 20.2862C287.794 20.3244 287.832 20.3435 287.87 20.3435H287.89C287.928 20.3435 287.966 20.2862 287.947 20.248L286.95 15.4007Z\" fill=#414241 /> <path d=\"M294.255 13.626C294.255 13.6069 294.255 13.6069 294.235 13.5878C294.235 13.5878 294.235 13.5878 294.235 13.5687C293.871 12.8245 293.238 12.271 292.24 11.7558C293.948 11.5649 294.235 11.355 294.216 10.4962C294.216 10.4581 294.178 10.4199 294.14 10.4199C294.101 10.4199 294.082 10.439 294.063 10.4771C293.852 10.7252 293.027 10.6871 292.317 10.6298C293.046 10.4962 293.833 10.2481 294.178 9.73287C294.197 9.6947 294.197 9.65653 294.159 9.61837C293.679 9.25577 293.084 9.04585 292.49 8.95043C293.526 8.22524 293.449 7.69089 293.391 7.36647C293.391 7.3283 293.372 7.29013 293.372 7.25196C293.372 7.21379 293.334 7.17563 293.295 7.17563C293.257 7.17563 293.219 7.19471 293.219 7.23288C293.18 7.4428 292.509 7.76723 291.857 7.93898C292.413 7.51914 293.008 6.94662 293.065 6.45044C293.065 6.41227 293.046 6.3741 293.008 6.3741C292.394 6.22143 291.799 6.35502 291.396 6.45044C291.972 5.74433 292.049 4.92373 291.818 4.61838C291.799 4.5993 291.78 4.58022 291.761 4.58022C291.742 4.58022 291.703 4.5993 291.703 4.61838C291.473 5.01915 291.128 5.30541 290.802 5.5535C291.204 4.96189 291.511 4.25579 291.531 3.75961C291.531 3.72144 291.492 3.68327 291.454 3.68327C290.84 3.64511 290.284 3.8932 289.497 4.35121C289.785 3.96953 289.977 3.60694 290.092 3.35885C290.169 3.20618 290.38 2.72908 290.284 2.63366C290.264 2.61458 290.245 2.61458 290.226 2.61458C290.207 2.61458 290.188 2.61458 290.169 2.61458C288.96 2.61458 287.713 3.20618 286.888 3.72144C285.91 4.31304 284.989 5.09548 284.471 5.76342C282.821 7.9199 283.282 9.02676 283.55 9.42753C283.876 9.88554 284.394 10.0191 284.778 9.94279C284.836 10.1909 284.816 10.4008 284.701 10.5916C284.375 11.0878 283.512 11.2405 282.994 11.2977C282.994 10.9924 282.975 10.5535 282.783 10.0955C283.032 10 283.167 9.84737 283.186 9.63745C283.186 9.61837 283.186 9.59928 283.167 9.5802C282.745 9.14127 282.687 8.83593 282.629 8.49242C282.629 8.45425 282.61 8.43516 282.61 8.397C282.745 8.37791 282.86 8.28249 282.917 8.20616C282.936 8.16799 282.936 8.12982 282.898 8.09165C282.572 7.84356 282.687 7.09929 282.802 6.39319C282.84 6.08784 282.898 5.76342 282.917 5.47716C282.936 5.03823 282.84 4.67564 282.591 4.35121C282.86 4.21762 282.975 4.02678 282.975 3.70236C282.975 3.68327 282.975 3.66419 282.956 3.64511C282.936 3.62602 282.917 3.62602 282.898 3.62602C282.687 3.62602 282.476 3.62602 282.265 3.60694C282.399 3.49243 282.476 3.3016 282.399 3.05351C282.38 3.01534 282.342 2.99625 282.303 2.99625C282.227 3.01534 282.15 3.01534 281.996 3.01534C281.939 3.01534 281.881 3.01534 281.805 3.01534C282.15 2.08023 282.303 1.73672 282.917 0.610767C282.936 0.572599 282.917 0.534431 282.898 0.515347C282.86 0.496263 282.821 0.496263 282.802 0.515347C282.668 0.648934 282.495 0.687102 282.303 0.72527C282.111 0.782522 281.9 0.820689 281.785 0.992444C281.632 0.839773 281.478 0.839773 281.325 0.973361C281.306 0.935193 281.287 0.916109 281.267 0.877941C281.191 0.782522 281.076 0.744354 280.96 0.744354C280.999 0.553515 280.845 0.419928 280.711 0.324508C280.596 0.229089 280.5 0.152753 280.443 0.0191658C280.423 -0.019002 280.404 -0.0380859 280.366 -0.0380859C280.327 -0.0380859 280.308 -0.019002 280.289 0.0191658C280.251 0.152753 280.136 0.229089 280.02 0.305424C279.848 0.419928 279.675 0.534431 279.752 0.858857C279.714 0.858857 279.694 0.858857 279.656 0.858857C279.522 0.858857 279.445 0.916109 279.407 0.954277C279.387 0.973361 279.387 0.973361 279.387 0.992444C279.33 0.916109 279.234 0.877941 279.157 0.877941C279.1 0.877941 279.023 0.897025 278.927 0.973361C278.812 0.744354 278.582 0.72527 278.39 0.687102C278.236 0.668018 278.083 0.648934 277.987 0.553515C277.968 0.534431 277.91 0.534431 277.891 0.553515C277.853 0.572599 277.853 0.610767 277.872 0.648934C278.179 1.18328 278.505 1.94664 278.85 2.939C278.639 3.01534 278.409 3.28251 278.371 3.66419C278.141 3.68327 277.795 3.74053 277.584 4.02678C277.392 4.27487 277.373 4.61838 277.488 5.05731C277.488 5.0764 277.527 5.11457 277.546 5.11457C277.584 5.11457 277.603 5.11457 277.623 5.09548C277.718 4.96189 278.025 4.82831 278.313 4.82831C278.447 4.82831 278.601 4.84739 278.735 4.96189C278.697 4.98098 278.658 5.00006 278.62 5.01915C278.121 5.24815 277.603 5.49624 277.239 5.09548C277.22 5.0764 277.181 5.05731 277.162 5.0764C277.143 5.0764 277.105 5.11457 277.105 5.13365C277.028 5.45808 277.277 5.80159 277.68 5.91609C277.757 5.93517 277.853 5.93517 277.93 5.93517C278.332 5.93517 278.716 5.76342 279.081 5.57258C279.081 5.70617 279.1 5.85884 279.138 5.93517C279.157 5.95426 279.176 5.97334 279.196 5.97334C279.215 5.97334 279.215 5.97334 279.234 5.97334C279.387 5.91609 279.522 5.85884 279.637 5.82067C279.637 5.82067 279.656 5.82067 279.656 5.83975C280.155 6.04968 280.174 6.46952 280.136 6.69853C280.059 7.23288 279.598 7.84356 278.946 7.9199C278.927 7.9199 278.889 7.93898 278.889 7.95807C278.87 7.97715 278.87 8.01532 278.889 8.0344C278.965 8.18707 279.138 8.30158 279.292 8.397C279.023 8.85501 278.831 9.1031 278.083 9.42753C278.064 9.42753 278.045 9.44661 278.045 9.46569C278.006 9.59928 278.102 9.73287 278.236 9.84737C277.891 10.21 277.795 10.6871 277.757 11.3168C277.258 11.2596 276.376 11.0878 276.05 10.6107C275.934 10.4199 275.896 10.21 275.973 9.96188C276.356 10.0382 276.874 9.90462 277.201 9.44661C277.469 9.06493 277.929 7.93898 276.28 5.7825C275.282 4.4848 272.654 2.61458 270.525 2.65274C270.505 2.65274 270.486 2.65274 270.467 2.67183C270.371 2.76725 270.601 3.24434 270.659 3.37793C270.774 3.62602 270.966 3.98862 271.254 4.37029C270.448 3.91228 269.911 3.64511 269.297 3.68327C269.259 3.68327 269.22 3.72144 269.22 3.75961C269.259 4.25579 269.546 4.96189 269.949 5.5535C269.623 5.32449 269.297 5.01915 269.067 4.61838C269.048 4.5993 269.028 4.58022 269.009 4.58022C268.99 4.58022 268.952 4.5993 268.952 4.61838C268.721 4.94281 268.798 5.76342 269.374 6.45044C268.971 6.35502 268.357 6.22143 267.762 6.3741C267.724 6.3741 267.705 6.41227 267.705 6.45044C267.762 6.94662 268.376 7.51914 268.913 7.93898C268.261 7.76723 267.59 7.42372 267.551 7.23288C267.551 7.19471 267.513 7.17563 267.475 7.17563C267.436 7.17563 267.398 7.21379 267.398 7.25196C267.398 7.29013 267.398 7.3283 267.379 7.36647C267.34 7.69089 267.244 8.24433 268.28 8.95043C267.686 9.06493 267.091 9.25577 266.611 9.61837C266.573 9.63745 266.573 9.6947 266.592 9.73287C266.957 10.2481 267.724 10.4962 268.453 10.6298C267.762 10.6871 266.937 10.7252 266.726 10.4771C266.726 10.439 266.688 10.4199 266.65 10.4199C266.611 10.4199 266.573 10.439 266.573 10.4962C266.573 10.5153 266.573 10.5153 266.573 10.5344C266.554 11.3741 266.841 11.584 268.53 11.7748C267.513 12.2901 266.88 12.8626 266.515 13.626C266.496 13.6642 266.515 13.7023 266.554 13.7214C266.573 13.7214 266.573 13.7214 266.592 13.7214C266.88 13.8932 267.244 13.9886 267.705 13.9886C268.184 13.9886 268.76 13.8932 269.431 13.7214C269.297 13.7977 269.163 13.8741 269.009 13.9504C268.088 14.4466 267.244 14.9237 266.669 14.7519C266.63 14.7329 266.592 14.771 266.573 14.8092C266.573 14.8283 266.573 14.8474 266.573 14.8664C266.573 14.8664 266.573 14.8664 266.573 14.8855C266.726 15.229 266.937 15.5535 267.34 15.687C267.455 15.7252 267.59 15.7443 267.743 15.7443C268.223 15.7443 268.837 15.5344 269.604 15.1336C268.741 16.5077 268.319 17.8244 268.357 19.1412V19.1603C268.357 19.1985 268.395 19.2366 268.434 19.2366C269.297 19.1603 270.352 18.2061 271.292 17.0993C271.254 17.1756 271.196 17.2519 271.158 17.3283C270.544 18.397 269.777 19.7328 269.412 19.7901C269.374 19.7901 269.354 19.8092 269.354 19.8473C269.354 19.8855 269.354 19.9046 269.374 19.9237C270.007 20.4008 270.889 19.8664 271.234 19.5229C271.503 19.2366 271.829 18.8168 272.174 18.3015C272.136 19.1031 272.155 20.9542 272.52 21.5458C272.539 21.5649 272.558 21.584 272.577 21.584C272.596 21.584 272.596 21.584 272.616 21.5649C273.23 21.1832 273.978 20.0954 274.496 18.416C274.4 19.1031 274.323 19.5992 274.189 19.771C274.17 19.7901 274.17 19.8282 274.189 19.8664C274.208 19.8855 274.227 19.9046 274.246 19.9046H274.265C275.129 19.6756 275.378 18.6832 275.589 17.9008C275.627 17.7863 275.647 17.6718 275.685 17.5573C275.723 17.5954 275.762 17.6527 275.819 17.7099C275.839 17.729 275.858 17.729 275.896 17.729C276.318 17.6336 277.181 16.5267 277.316 15.0764C277.546 15.1718 277.834 15.229 278.121 15.229C278.352 15.229 278.601 15.1909 278.85 15.0954C278.869 15.0954 278.869 15.0954 278.869 15.0764C278.869 15.0764 278.87 15.0764 278.889 15.0764H278.908C278.927 15.2672 278.965 15.439 279.023 15.6298C277.91 15.458 277.699 15.7061 277.181 16.8512C276.798 17.6909 276.356 18.2443 275.934 18.397C275.915 18.397 275.896 18.416 275.877 18.4542C275.877 18.4733 275.877 18.5115 275.896 18.5305C275.954 18.5878 276.03 18.626 276.126 18.645C276.03 18.8359 275.839 19.1031 275.627 19.2366C275.608 19.2557 275.589 19.2748 275.589 19.313C275.589 19.3321 275.608 19.3702 275.627 19.3702C275.704 19.4084 275.781 19.4275 275.877 19.4275C275.723 19.5992 275.359 19.8282 275.225 19.8473C275.205 19.8473 275.186 19.8664 275.167 19.8855C275.148 19.9046 275.167 19.9428 275.167 19.9618C275.205 20.0191 275.282 20.0763 275.359 20.1145C275.225 20.2481 275.014 20.4199 274.687 20.5725C274.668 20.5916 274.649 20.6107 274.649 20.6298C274.649 20.6489 274.649 20.687 274.687 20.7061C274.841 20.8015 275.167 20.8969 275.551 20.916L274.879 21.7939C274.86 21.813 274.86 21.8321 274.86 21.8511C274.86 21.8702 274.879 21.8893 274.899 21.9084L274.918 21.9275L274.246 22.5572C274.227 22.5763 274.208 22.6145 274.227 22.6336C274.246 22.6717 274.265 22.6908 274.285 22.6908H274.304L273.69 23.1679C273.671 23.187 273.671 23.187 273.671 23.2061C273.671 23.2061 273.652 23.2252 273.652 23.2443C273.652 23.2824 273.671 23.3206 273.709 23.3397L273.249 23.7214C273.095 23.855 272.961 23.8931 272.865 23.874L271.695 23.6259C271.618 23.3779 271.369 23.2252 271.062 23.2061C270.736 23.2061 270.352 23.3588 270.237 23.7595C270.064 23.8931 269.949 24.1221 269.93 24.3702C269.911 24.6946 270.026 25 270.256 25.1908C270.275 25.2099 270.294 25.2099 270.333 25.2099C270.352 25.2099 270.371 25.1908 270.39 25.1527C270.467 24.8664 270.525 24.7901 270.659 24.6756C271.119 24.7901 271.33 24.6565 271.503 24.5229C271.637 24.6183 271.887 24.6946 272.117 24.7328C271.925 24.8664 271.695 25 271.465 25.0954C271.196 25 270.832 25.0572 270.659 25.3244C270.525 25.5343 270.448 26.0496 270.697 26.2786C270.697 26.4694 270.755 26.6412 270.889 26.7748C271.062 26.9465 271.311 27.061 271.58 27.042C271.599 27.042 271.637 27.0229 271.637 27.0038C271.657 26.9847 271.657 26.9465 271.637 26.9275C271.484 26.6412 271.599 26.4313 271.637 26.374C271.868 26.2595 271.925 26.0878 271.963 25.8015H272.002C272.27 25.7252 272.539 25.6488 272.808 25.4771C272.769 25.6298 272.75 25.7633 272.731 25.8778C272.52 25.916 272.251 26.0496 272.174 26.3168C272.098 26.5839 272.117 26.8511 272.232 27.042C272.27 27.1183 272.328 27.1756 272.405 27.2137C272.443 27.4046 272.558 27.5763 272.75 27.6717C272.999 27.7862 273.325 27.7671 273.575 27.6145C273.594 27.5954 273.613 27.5763 273.613 27.5572C273.613 27.5381 273.594 27.5 273.575 27.5C273.441 27.4046 273.383 27.3091 273.345 27.042C273.556 26.8702 273.613 26.603 273.517 26.2595C273.728 26.0496 273.805 25.8015 273.882 25.5534C273.901 25.4771 273.939 25.4007 273.959 25.3053C274.074 25.3817 274.246 25.4007 274.381 25.3817C274.457 25.6298 274.572 25.7252 274.745 25.8397V25.8588C274.726 26.0114 274.726 26.2023 274.553 26.3549C274.534 26.374 274.515 26.4122 274.534 26.4313C274.534 26.4504 274.572 26.4885 274.592 26.4885C274.745 26.5267 275.09 26.4885 275.321 26.2786C275.493 26.1259 275.589 25.9351 275.589 25.687C275.781 25.5343 275.877 25.229 275.781 25C275.685 24.7519 275.416 24.6183 275.071 24.6565C274.841 24.6565 274.726 24.5992 274.687 24.542C274.668 24.5038 274.668 24.4466 274.707 24.3893C274.745 24.313 274.822 24.2366 274.975 24.0458L275.052 23.9695C275.455 23.4542 276.798 21.9466 277.201 21.6221C277.373 21.8511 277.68 22.1947 278.198 22.2901C278.217 22.2901 278.236 22.2901 278.256 22.271C278.275 22.2519 278.294 22.2328 278.294 22.2137C278.294 22.1756 278.275 22.1374 278.256 22.0992C278.198 22.0038 278.102 21.8321 278.064 21.5458C278.121 21.5649 278.179 21.584 278.236 21.584H278.256C278.275 21.584 278.294 21.584 278.313 21.5649C278.332 21.5458 278.332 21.5267 278.332 21.5076C278.332 21.4885 278.332 21.4695 278.332 21.4504C278.294 21.0687 278.179 20.2099 279.215 18.9504C279.176 20 278.946 20.9733 278.505 21.8321C278.486 21.8511 278.486 21.8893 278.505 21.9084C278.524 21.9275 278.543 21.9466 278.582 21.9466C278.869 21.8893 278.985 21.8511 279.138 21.7366C279.004 22.271 278.754 22.6717 278.447 22.8053C278.275 22.8817 278.083 22.8626 277.891 22.729C277.872 22.7099 277.853 22.7099 277.814 22.7099C277.795 22.7099 277.776 22.729 277.757 22.7481C277.603 23.1488 277.699 23.5305 277.987 23.7786C278.256 24.0076 278.658 24.0649 279.023 23.9313C278.678 24.6374 277.929 24.8855 277.507 24.771C277.22 24.6946 277.085 24.4466 277.143 24.103C277.143 24.084 277.143 24.0458 277.124 24.0267C277.105 24.0076 277.085 24.0076 277.047 24.0076C276.51 24.084 276.184 24.3893 276.126 24.8473C276.069 25.2672 276.299 25.7061 276.625 25.9351C276.05 26.1832 275.704 26.7175 275.781 27.3282C275.838 27.9007 276.28 28.5496 277.105 28.6068C277.93 28.6641 278.793 28.0916 279.292 27.4236C279.292 29.1221 279.714 29.6183 280.078 30.0572L280.116 30.0954C280.136 30.1145 280.155 30.1145 280.174 30.1145C280.193 30.1145 280.212 30.0954 280.232 30.0954L280.289 30.0381C280.654 29.5992 281.076 29.103 281.076 27.4236C281.594 28.1107 282.38 28.5878 283.071 28.6068C283.915 28.645 284.471 28.0152 284.586 27.3855C284.663 26.8893 284.49 26.2214 283.761 25.916C284.087 25.7061 284.298 25.2481 284.26 24.8282C284.203 24.3702 283.876 24.0649 283.339 23.9885C283.32 23.9885 283.282 23.9885 283.263 24.0076C283.243 24.0267 283.243 24.0458 283.243 24.084C283.32 24.4275 283.186 24.6756 282.879 24.7519C282.457 24.8664 281.728 24.6374 281.363 23.9122C281.728 24.0458 282.111 23.9885 282.399 23.7595C282.687 23.5114 282.783 23.1298 282.629 22.729C282.629 22.7099 282.61 22.6908 282.572 22.6908C282.553 22.6908 282.534 22.6908 282.495 22.7099C282.303 22.8435 282.111 22.8626 281.939 22.7863C281.632 22.6527 281.383 22.2519 281.248 21.7176C281.402 21.8321 281.517 21.8702 281.805 21.9275C281.843 21.9275 281.862 21.9275 281.881 21.8893C281.9 21.8702 281.9 21.8321 281.881 21.813C281.459 20.9542 281.229 20.0191 281.21 18.9313C282.227 20.1718 282.131 21.0114 282.092 21.4122C282.092 21.4504 282.092 21.4695 282.092 21.4885C282.092 21.5076 282.092 21.5267 282.111 21.5458C282.131 21.5649 282.15 21.5649 282.169 21.5649H282.188C282.265 21.5649 282.303 21.5458 282.361 21.5267C282.342 21.813 282.227 21.9847 282.169 22.0801C282.131 22.1374 282.131 22.1565 282.131 22.1947C282.131 22.2137 282.15 22.2328 282.169 22.2519C282.188 22.271 282.207 22.271 282.227 22.271C282.745 22.1565 283.032 21.8321 283.224 21.6031C283.819 22.0801 284.394 22.8053 284.97 23.4924C285.162 23.7214 285.354 23.9695 285.545 24.1985C285.603 24.2748 285.622 24.332 285.603 24.3702C285.584 24.4466 285.449 24.5038 285.2 24.5611C284.663 24.5038 284.509 24.8473 284.471 24.9809C284.375 25.2862 284.529 25.687 284.778 25.8206C284.836 26.0305 284.951 26.2023 285.123 26.3359C285.334 26.4694 285.622 26.5076 285.776 26.4694C285.795 26.4694 285.833 26.4313 285.833 26.4122C285.833 26.3931 285.833 26.3549 285.814 26.3359C285.641 26.2023 285.641 26.0114 285.622 25.8397V25.8206C285.814 25.7252 285.91 25.6107 285.987 25.3626C286.121 25.3817 286.294 25.3626 286.409 25.2862C286.447 25.3626 286.466 25.458 286.485 25.5343C286.562 25.7824 286.639 26.0305 286.85 26.2404C286.754 26.603 286.811 26.8511 287.022 27.0229C286.965 27.3091 286.907 27.3855 286.792 27.4809C286.773 27.5 286.754 27.5191 286.754 27.5381C286.754 27.5572 286.773 27.5954 286.792 27.5954C287.042 27.7481 287.368 27.7671 287.617 27.6526C287.809 27.5572 287.943 27.4046 287.962 27.1946C288.039 27.1565 288.078 27.0992 288.135 27.0229C288.25 26.8511 288.269 26.5649 288.193 26.2977C288.116 26.0305 287.847 25.8778 287.636 25.8588C287.617 25.7443 287.598 25.6107 287.54 25.458C287.809 25.6488 288.097 25.7252 288.346 25.7824L288.385 25.8015C288.423 26.0878 288.48 26.2595 288.711 26.374C288.749 26.4313 288.864 26.6412 288.711 26.9275C288.691 26.9465 288.691 26.9847 288.711 27.0038C288.73 27.0229 288.749 27.042 288.768 27.042C289.037 27.042 289.286 26.9465 289.459 26.7748C289.593 26.6412 289.67 26.4504 289.651 26.2786C289.9 26.0687 289.823 25.5343 289.689 25.3244C289.516 25.0572 289.152 25 288.883 25.0954C288.691 25 288.48 24.8855 288.269 24.7328C288.5 24.7137 288.711 24.6183 288.845 24.5229C289.018 24.6565 289.229 24.7901 289.689 24.6756C289.804 24.7901 289.862 24.8855 289.958 25.1527C289.958 25.1717 289.977 25.1908 290.015 25.2099C290.034 25.2099 290.073 25.2099 290.092 25.1908C290.322 24.9809 290.437 24.6756 290.418 24.3702C290.399 24.103 290.284 23.8931 290.111 23.7595C289.996 23.3779 289.631 23.2061 289.286 23.2061C288.96 23.2061 288.711 23.3779 288.634 23.6259L287.464 23.874C287.349 23.8931 287.233 23.855 287.08 23.7214L286.6 23.3397C286.62 23.3206 286.639 23.3015 286.639 23.2824V23.2634C286.639 23.2443 286.639 23.2061 286.62 23.187L286.006 22.7099H286.025C286.063 22.7099 286.082 22.6908 286.082 22.6527C286.102 22.6145 286.082 22.5954 286.063 22.5763L285.411 21.9466L285.43 21.9275C285.449 21.9084 285.469 21.8893 285.469 21.8702C285.469 21.8511 285.469 21.8321 285.449 21.813L284.778 20.9542C285.2 20.9542 285.565 20.8588 285.737 20.7443C285.756 20.7252 285.776 20.7061 285.776 20.6679C285.776 20.6489 285.756 20.6107 285.737 20.6107C285.411 20.458 285.2 20.2863 285.066 20.1527C285.142 20.1145 285.219 20.0573 285.258 20C285.277 19.9809 285.277 19.9428 285.258 19.9237C285.238 19.9046 285.219 19.8855 285.2 19.8855C285.066 19.8664 284.701 19.6183 284.548 19.4657C284.644 19.4657 284.72 19.4466 284.797 19.4084C284.816 19.3893 284.836 19.3702 284.836 19.3512C284.836 19.3321 284.816 19.2939 284.797 19.2748C284.586 19.1412 284.394 18.8741 284.298 18.6832C284.394 18.6641 284.471 18.626 284.529 18.5687C284.548 18.5496 284.548 18.5305 284.548 18.4924C284.548 18.4733 284.529 18.4542 284.49 18.4351C283.915 18.2252 283.454 17.3855 283.243 16.8893C282.725 15.7443 282.514 15.5153 281.402 15.668C281.459 15.4962 281.498 15.3245 281.555 15.1336C281.805 15.229 282.054 15.2672 282.303 15.2672C282.591 15.2672 282.879 15.2099 283.109 15.1145C283.263 16.5649 284.126 17.6718 284.529 17.7672C284.548 17.7672 284.586 17.7672 284.605 17.7481C284.663 17.6909 284.72 17.6527 284.74 17.5954C284.778 17.7099 284.797 17.8244 284.836 17.9389C285.047 18.7214 285.296 19.7137 286.159 19.9428H286.178C286.198 19.9428 286.236 19.9237 286.236 19.9046C286.255 19.8855 286.255 19.8473 286.236 19.8092C286.102 19.6183 286.025 19.1412 285.929 18.4542C286.447 20.1336 287.195 21.2214 287.809 21.6031C287.828 21.6031 287.828 21.6221 287.847 21.6221C287.867 21.6221 287.905 21.6031 287.905 21.584C288.289 20.9924 288.308 19.1412 288.25 18.3397C288.596 18.855 288.922 19.2557 289.19 19.5611C289.516 19.9046 290.399 20.458 291.051 19.9618C291.07 19.9428 291.089 19.9046 291.07 19.8855C291.07 19.8473 291.032 19.8282 291.013 19.8282C290.629 19.771 289.862 18.4351 289.267 17.3664C289.229 17.2901 289.19 17.2138 289.133 17.1374C290.053 18.2443 291.128 19.1985 291.972 19.2748C292.01 19.2748 292.049 19.2366 292.049 19.1985C292.087 17.8817 291.684 16.5458 290.821 15.1718C291.588 15.5916 292.202 15.7825 292.682 15.7825C292.835 15.7825 292.95 15.7634 293.084 15.7252C293.487 15.5916 293.698 15.2672 293.852 14.9237C293.871 14.9046 293.871 14.8855 293.871 14.8664C293.852 14.8283 293.813 14.8092 293.775 14.8092C293.219 14.9619 292.355 14.5038 291.435 14.0077C291.281 13.9313 291.128 13.8359 290.974 13.7596C291.684 13.9504 292.279 14.0458 292.758 14.0458C293.219 14.0458 293.583 13.9695 293.852 13.7977H293.871C293.89 13.7977 293.89 13.7977 293.909 13.7977C294.255 13.7023 294.274 13.6642 294.255 13.626ZM292.106 10.7825C292.451 10.8016 292.816 10.8397 293.142 10.8397C293.526 10.8397 293.852 10.8016 294.044 10.6871C294.024 11.2977 293.737 11.4504 291.972 11.6413C291.876 11.6031 291.78 11.5649 291.684 11.5458C291.396 11.4313 291.07 11.3168 290.763 11.2405C290.955 11.126 291.109 10.9733 291.204 10.8016L291.281 10.7825C291.377 10.7634 291.492 10.7634 291.607 10.7443C291.761 10.7634 291.933 10.7825 292.106 10.7825ZM291.607 10.6107C291.588 10.6107 291.588 10.6107 291.588 10.6107C291.473 10.6298 291.377 10.6298 291.281 10.6489H291.204C290.84 10.2291 290.092 9.73287 289.42 9.59928C289.766 9.46569 290.073 9.29394 290.341 9.04585C291.089 8.96951 292.893 8.91226 294.024 9.71379C293.545 10.3054 292.432 10.4962 291.607 10.6107ZM292.912 6.54586C292.778 7.11838 291.838 7.88173 291.032 8.37791C290.993 8.397 290.993 8.45425 291.013 8.49242C291.032 8.53058 291.089 8.53058 291.128 8.5115C291.224 8.45425 291.396 8.33974 291.588 8.20616C291.588 8.20616 291.588 8.20616 291.607 8.20616C292.164 8.11074 292.969 7.8054 293.295 7.50005C293.334 7.82448 293.295 8.30158 292.317 8.93134C291.627 8.83593 290.955 8.85501 290.514 8.87409C290.687 8.64509 290.821 8.35883 290.898 7.99623C290.898 7.95807 290.878 7.9199 290.859 7.9199C290.322 7.69089 289.727 7.65272 289.171 7.8054C289.881 7.29013 290.61 6.88937 291.204 6.69853C291.224 6.69853 291.224 6.69853 291.243 6.69853C291.281 6.69853 291.32 6.67945 291.358 6.66036C291.684 6.56494 292.298 6.41227 292.912 6.54586ZM291.377 3.85503C291.32 4.42755 290.898 5.26724 290.418 5.83975C290.399 5.83975 290.399 5.83975 290.38 5.85884C290.226 5.99243 290.169 6.06876 290.092 6.1451C289.996 6.24052 289.938 6.29777 289.708 6.48861C289.67 6.50769 289.67 6.56494 289.689 6.60311C289.708 6.62219 289.727 6.64128 289.747 6.64128C289.766 6.64128 289.785 6.64128 289.804 6.62219C290.053 6.43135 290.111 6.35502 290.207 6.2596C290.264 6.20235 290.322 6.1451 290.437 6.03059C290.456 6.03059 290.456 6.03059 290.475 6.01151C290.514 5.99243 290.552 5.95426 290.591 5.93517C290.936 5.68708 291.415 5.36266 291.761 4.86648C291.876 5.22907 291.722 5.95426 291.147 6.56494C290.571 6.7367 289.862 7.11838 289.19 7.59547C289.478 7.17563 289.67 6.66036 289.593 6.10693C289.593 6.06876 289.555 6.04968 289.536 6.04968C288.749 5.93517 288.173 6.06876 287.732 6.43135C287.771 6.31685 287.79 6.22143 287.79 6.12601L287.809 6.10693C288.327 5.43899 288.691 5.11457 289.171 4.77106C289.19 4.77106 289.209 4.77106 289.209 4.75197C290.149 4.16037 290.744 3.83595 291.377 3.85503ZM283.013 11.4504C283.55 11.3932 284.49 11.2214 284.855 10.668C285.008 10.439 285.027 10.1909 284.951 9.90462C285.181 9.80921 285.296 9.71379 285.354 9.46569C285.354 9.44661 285.354 9.42753 285.334 9.40844C285.315 9.38936 285.296 9.37027 285.277 9.37027C284.893 9.33211 284.74 9.12218 284.663 8.95043C284.548 8.68326 284.605 8.33974 284.778 8.11074C284.931 7.9199 285.142 7.82448 285.373 7.86265C285.392 7.86265 285.43 7.86265 285.449 7.84356C285.469 7.82448 285.469 7.8054 285.469 7.76723C285.354 7.30921 285.469 6.92754 285.776 6.77487C286.082 6.62219 286.562 6.71761 286.888 7.15654C286.907 7.19471 286.946 7.19471 286.984 7.17563C287.31 7.02296 287.732 7.09929 287.982 7.34738C288.25 7.59547 288.308 7.95807 288.135 8.37791C288.116 8.41608 288.135 8.45425 288.173 8.47333C288.519 8.64509 288.73 8.91226 288.749 9.23669C288.768 9.5802 288.576 9.92371 288.212 10.1527C288.173 10.1718 288.173 10.2291 288.193 10.2672C288.404 10.5916 288.461 10.9352 288.365 11.2596C288.289 11.5268 288.097 11.7558 287.847 11.8703C287.828 11.8893 287.809 11.9084 287.809 11.9275C287.656 12.8054 287.502 13.1107 286.524 13.1871C286.485 13.1871 286.466 13.2061 286.466 13.2443C286.217 13.855 285.737 13.9313 285.085 13.8741C285.066 13.8741 285.027 13.8741 285.008 13.8932C284.644 14.3321 284.145 14.4275 283.723 14.1603C283.685 14.1412 283.646 14.1412 283.627 14.1794C283.397 14.4084 282.668 14.6183 282.073 14.4466C282.112 14.2558 282.131 14.084 282.15 13.9313C282.188 13.9313 282.227 13.9122 282.265 13.8932C282.284 13.8932 282.303 13.8741 282.303 13.855C282.361 13.7214 282.399 13.6069 282.438 13.4542C282.706 13.397 282.994 13.3397 283.301 13.2825C284.529 13.0344 285.91 12.7672 286.831 12.1184C287.521 11.6413 287.79 10.2672 287.54 9.48478C287.905 9.42753 288.116 9.35119 288.231 9.19852C288.25 9.17944 288.25 9.14127 288.25 9.12218C288.116 8.74051 287.943 8.626 287.713 8.47333C287.694 8.45425 287.675 8.45425 287.656 8.43516C287.751 8.18707 287.656 7.76723 287.636 7.63364C287.636 7.59547 287.598 7.57639 287.56 7.57639C287.329 7.57639 287.118 7.63364 286.907 7.76723C286.754 7.50005 286.428 7.13746 286.044 7.08021C286.025 7.08021 285.987 7.08021 285.967 7.09929C285.814 7.27105 285.737 7.76723 285.776 8.16799C285.488 8.20616 285.277 8.30158 285.085 8.45425C285.066 8.47333 285.047 8.5115 285.066 8.54967C285.181 8.83593 285.392 9.06493 285.66 9.19852C285.565 9.52295 285.545 9.90462 285.641 10.21C285.66 10.2481 285.68 10.2672 285.718 10.2672H285.737C285.756 10.2672 285.756 10.2672 285.756 10.2481C285.929 10.2291 286.102 10.1718 286.294 10.0764C286.485 11.3932 285.027 11.7176 282.821 12.1947C282.86 12.0802 282.879 11.9657 282.898 11.813C282.936 11.813 282.975 11.7748 282.975 11.7558V11.7367C282.975 11.7176 282.975 11.6794 282.975 11.6222C282.994 11.5458 282.994 11.5077 283.013 11.4504C282.994 11.4504 283.013 11.4504 283.013 11.4504ZM278.62 13.7405C278.505 13.4733 278.428 13.2443 278.39 12.8626C278.524 12.8435 278.678 12.8245 278.85 12.6909C278.965 12.8245 279.215 12.939 279.464 12.9771C279.675 12.9962 280.059 12.9962 280.366 12.71C280.615 12.9008 280.884 12.9962 281.172 12.9962C281.44 12.9962 281.709 12.9008 281.958 12.729C282.112 12.8054 282.227 12.8435 282.399 12.8435C282.38 13.1871 282.303 13.4733 282.207 13.7405C282.111 13.7787 281.881 13.7787 281.325 13.626C281.306 13.626 281.267 13.626 281.248 13.6451C280.73 14.0458 280.078 14.0458 279.522 13.6451C279.503 13.626 279.483 13.626 279.464 13.626C278.889 13.7977 278.697 13.7787 278.62 13.7405ZM273.306 7.74814C273.498 7.74814 273.652 7.8054 273.824 7.9199C273.767 8.0344 273.728 8.16799 273.709 8.28249C273.517 8.30158 273.383 8.33974 273.268 8.37791C273.23 8.22524 273.249 7.95807 273.306 7.74814ZM273.978 9.42753L274.208 8.79776L274.764 8.77867C274.975 9.12218 275.11 9.67562 274.994 10.0955C274.649 10.0191 274.131 9.75195 273.978 9.42753ZM282.783 12.3283C285.066 11.8321 286.696 11.4886 286.428 9.96188C286.581 9.86646 286.716 9.75195 286.831 9.63745C286.927 10.0764 287.022 11.1069 286.178 11.6985C285.603 12.0993 284.548 12.3092 283.435 12.5382C283.167 12.5955 282.898 12.6527 282.629 12.71C282.706 12.5573 282.745 12.4428 282.783 12.3283ZM285.756 10.0764C285.641 9.67562 285.795 9.1031 286.006 8.75959L286.562 8.77867L286.792 9.42753C286.62 9.73287 286.121 10.0191 285.756 10.0764ZM282.553 12.8817C282.572 12.8817 282.572 12.8817 282.591 12.8817C282.879 12.8054 283.186 12.7481 283.493 12.6909C284.625 12.4619 285.68 12.2329 286.294 11.8321C287.272 11.1642 287.08 9.94279 286.984 9.54203C287.099 9.52295 287.253 9.52295 287.406 9.52295C287.656 10.2291 287.406 11.5649 286.773 12.0039C285.891 12.6145 284.509 12.9008 283.301 13.1298C283.013 13.1871 282.764 13.2443 282.495 13.3016C282.514 13.168 282.534 13.0344 282.553 12.8817ZM287.464 9.33211C287.445 9.33211 287.445 9.33211 287.425 9.35119C287.253 9.35119 287.08 9.37027 286.927 9.37027L286.696 8.70234L287.003 8.397C287.003 8.397 287.003 8.397 287.022 8.397C287.138 8.397 287.368 8.43516 287.483 8.5115C287.502 8.5115 287.502 8.53058 287.521 8.53058C287.56 8.54967 287.598 8.58784 287.636 8.60692C287.847 8.74051 287.982 8.83593 288.097 9.14127C287.982 9.23669 287.79 9.29394 287.464 9.33211ZM287.502 8.35883C287.387 8.30158 287.214 8.28249 287.061 8.26341C287.042 8.16799 286.984 8.01532 286.946 7.90082C287.118 7.78631 287.291 7.72906 287.483 7.72906C287.54 7.95807 287.56 8.20616 287.502 8.35883ZM286.792 7.9199C286.792 7.93898 286.792 7.93898 286.792 7.9199C286.85 8.0344 286.888 8.18707 286.927 8.28249L286.581 8.626L286.044 8.60692C285.967 8.5115 285.948 8.397 285.929 8.28249C285.929 8.26341 285.929 8.26341 285.929 8.24433V8.22524C285.871 7.84356 285.948 7.40463 286.044 7.25196C286.409 7.3283 286.696 7.72906 286.792 7.9199ZM285.776 8.32066C285.795 8.43516 285.814 8.54967 285.891 8.66417C285.814 8.77867 285.756 8.89318 285.699 9.04585C285.488 8.93135 285.315 8.75959 285.219 8.53058C285.373 8.41608 285.545 8.33974 285.776 8.32066ZM282.476 12.71C282.265 12.729 282.169 12.6909 281.977 12.5764C281.958 12.5573 281.92 12.5573 281.9 12.5764C281.421 12.939 280.865 12.939 280.404 12.5382C280.366 12.5191 280.327 12.5191 280.289 12.5382C280.02 12.8245 279.675 12.8435 279.483 12.8054C279.215 12.7672 278.985 12.6336 278.927 12.5382C278.908 12.5191 278.889 12.5 278.869 12.5C278.85 12.5 278.831 12.5 278.812 12.5191C278.582 12.71 278.352 12.71 278.217 12.6909L278.179 12.5955C278.141 12.4619 278.102 12.3474 278.083 12.2519C278.083 12.2329 278.083 12.2138 278.064 12.2138C278.025 12.0611 278.006 11.9275 277.987 11.6985C278.236 11.6031 278.505 11.3932 278.716 11.126C278.869 11.4695 279.061 11.6603 279.445 11.9084C279.464 11.9275 279.483 11.9275 279.522 11.9084C279.925 11.7558 280.232 11.4886 280.443 11.1642C280.692 11.584 281.037 11.8512 281.287 11.9466H281.306H281.325C281.689 11.813 281.862 11.584 282.073 11.2405C282.246 11.4504 282.553 11.6603 282.745 11.7558C282.687 12.1184 282.649 12.271 282.476 12.71ZM278.025 12.6527L278.045 12.6909C277.795 12.6336 277.565 12.5955 277.316 12.5382C276.203 12.3092 275.167 12.0802 274.592 11.6985C273.748 11.1069 273.843 10.0764 273.939 9.63745C274.035 9.77104 274.189 9.88554 274.342 9.98096C274.093 11.4886 275.704 11.8512 277.949 12.3283C277.949 12.4237 277.987 12.5191 278.025 12.6527ZM275.071 9.04585C275.014 8.91226 274.956 8.77867 274.899 8.68326C274.975 8.56875 274.994 8.43516 275.014 8.32066C275.244 8.35883 275.416 8.41608 275.57 8.53058C275.455 8.74051 275.282 8.93135 275.071 9.04585ZM274.841 8.22524C274.841 8.24432 274.841 8.26341 274.841 8.26341V8.28249C274.822 8.397 274.803 8.5115 274.726 8.60692L274.17 8.626L273.824 8.35883V8.33974C273.843 8.24433 273.901 8.05349 273.978 7.9199V7.90082V7.88173C274.093 7.67181 274.361 7.3283 274.707 7.23288C274.822 7.38555 274.899 7.82448 274.841 8.22524ZM273.268 8.54967C273.287 8.54967 273.287 8.54967 273.306 8.53058C273.345 8.49242 273.46 8.45425 273.69 8.43516L274.074 8.74051L273.843 9.38936C273.709 9.37028 273.536 9.35119 273.345 9.37027C273.019 9.33211 272.827 9.27486 272.731 9.17944C272.846 8.87409 272.98 8.77867 273.191 8.64509C273.191 8.58784 273.23 8.56875 273.268 8.54967ZM273.383 9.50386C273.536 9.50386 273.69 9.52295 273.805 9.52295C273.709 9.92371 273.517 11.1451 274.496 11.813C275.11 12.2138 276.165 12.4428 277.277 12.6718C277.584 12.729 277.891 12.8054 278.179 12.8626C278.198 12.8626 278.198 12.8626 278.217 12.8626C278.236 13.0153 278.256 13.1489 278.294 13.2825C278.045 13.2252 277.757 13.168 277.488 13.1107C276.28 12.8626 274.899 12.5955 274.016 11.9848C273.383 11.5458 273.114 10.21 273.383 9.50386ZM281.383 2.04206C281.363 2.08023 281.325 2.09931 281.267 2.11839C281.248 2.11839 281.229 2.11839 281.21 2.11839C281.191 2.11839 281.172 2.11839 281.152 2.11839C281.037 2.04206 280.98 1.96572 280.98 1.90847C280.96 1.79397 281.056 1.67946 281.172 1.50771C281.191 1.48863 281.191 1.48863 281.21 1.46954C281.229 1.54588 281.267 1.62221 281.325 1.71763C281.383 1.81305 281.44 1.96572 281.383 2.04206ZM279.56 1.06878C279.618 1.01153 279.733 1.01153 279.886 1.06878C279.925 1.06878 279.944 1.06878 279.963 1.0497C279.982 1.03061 279.982 0.992444 279.982 0.973361C279.867 0.668018 279.982 0.591683 280.155 0.477179C280.251 0.419928 280.347 0.362676 280.404 0.267256C280.481 0.362676 280.558 0.439011 280.634 0.496263C280.826 0.648934 280.903 0.72527 280.788 0.897025C280.769 0.935193 280.769 0.973361 280.788 0.992444C280.807 1.01153 280.865 1.03061 280.884 1.01153C280.98 0.954277 281.095 0.973361 281.172 1.0497C281.21 1.10695 281.229 1.1642 281.229 1.22145C281.229 1.22145 281.229 1.22145 281.229 1.24054C281.172 1.31687 281.133 1.39321 281.076 1.45046C280.941 1.6413 280.826 1.79397 280.845 1.96572C280.865 2.02297 280.884 2.09931 280.941 2.15656C280.807 2.15656 280.692 2.15656 280.673 2.15656C280.577 2.13748 280.538 2.11839 280.5 1.98481C280.5 1.96572 280.519 1.8703 280.538 1.81305C280.615 1.56496 280.711 1.18328 280.5 0.897025C280.481 0.877941 280.443 0.858857 280.423 0.858857C280.385 0.858857 280.366 0.858857 280.347 0.897025C280.136 1.18328 280.251 1.56496 280.308 1.81305C280.327 1.8703 280.347 1.94664 280.347 1.98481C280.308 2.11839 280.27 2.13748 280.174 2.15656C280.155 2.15656 280.021 2.15656 279.886 2.15656C279.925 2.11839 279.925 2.06114 279.944 2.02297C279.963 1.85122 279.848 1.69855 279.733 1.56496C279.656 1.46954 279.579 1.37412 279.56 1.29779C279.56 1.2787 279.56 1.2787 279.541 1.2787V1.25962C279.522 1.1642 279.522 1.10695 279.56 1.06878ZM280.404 1.03061C280.481 1.20237 280.443 1.43137 280.404 1.60313C280.366 1.43137 280.327 1.20237 280.404 1.03061ZM279.541 2.11839C279.272 1.98481 279.33 1.8703 279.426 1.66038C279.445 1.60313 279.464 1.56496 279.503 1.50771C279.522 1.54588 279.56 1.58405 279.579 1.62221C279.675 1.73672 279.771 1.8703 279.752 1.96572C279.752 2.02297 279.694 2.08023 279.637 2.11839C279.598 2.11839 279.579 2.11839 279.541 2.11839ZM278.39 0.858857C278.639 0.897025 278.793 0.916109 278.85 1.1642C278.85 1.20237 278.889 1.22145 278.908 1.22145C278.946 1.22145 278.965 1.22145 278.985 1.18328C279.042 1.08786 279.119 1.0497 279.176 1.0497C279.253 1.0497 279.311 1.12603 279.368 1.24054C279.368 1.24054 279.368 1.25962 279.387 1.25962C279.387 1.25962 279.387 1.2787 279.387 1.29779C279.407 1.39321 279.349 1.50771 279.292 1.62221C279.215 1.77488 279.119 1.96572 279.292 2.13748C279.157 2.11839 279.1 2.08023 279.004 1.98481C278.965 1.94664 278.927 1.94664 278.889 1.98481C278.85 2.02297 278.85 2.06114 278.889 2.09931C279.004 2.21381 279.1 2.30923 279.349 2.30923C279.368 2.30923 279.368 2.30923 279.387 2.30923C279.407 2.30923 279.503 2.30923 279.618 2.30923C279.963 2.30923 280.136 2.30923 280.155 2.30923C280.232 2.30923 280.327 2.27107 280.385 2.19473C280.443 2.27107 280.538 2.30923 280.615 2.30923C280.654 2.30923 280.826 2.30923 281.172 2.30923C281.191 2.30923 281.191 2.30923 281.21 2.30923C281.229 2.30923 281.248 2.30923 281.267 2.30923C281.363 2.30923 281.421 2.30923 281.44 2.30923C281.459 2.30923 281.459 2.30923 281.478 2.30923C281.709 2.30923 281.766 2.25198 281.862 2.15656C281.881 2.13748 281.881 2.11839 281.9 2.11839C281.939 2.08023 281.92 2.04206 281.9 2.00389C281.862 1.96572 281.824 1.98481 281.785 2.00389C281.766 2.02297 281.747 2.04206 281.747 2.06114C281.689 2.11839 281.67 2.15656 281.517 2.15656C281.594 2.00389 281.536 1.79397 281.44 1.67946C281.325 1.52679 281.306 1.39321 281.344 1.31687V1.29779C281.383 1.22145 281.459 1.12603 281.536 1.12603C281.613 1.12603 281.689 1.22145 281.728 1.2787C281.747 1.29779 281.766 1.31687 281.805 1.31687C281.843 1.31687 281.862 1.29779 281.862 1.25962C281.9 1.08786 282.073 1.0497 282.323 0.973361C282.418 0.954277 282.514 0.916109 282.629 0.877941C282.112 1.83214 281.958 2.21381 281.632 3.11076C281.594 3.11076 281.555 3.11076 281.536 3.11076C281.306 3.11076 281.037 3.09167 280.73 3.05351C280.308 3.01534 279.829 2.95809 279.311 2.95809C279.196 2.95809 279.1 2.95809 279.004 2.95809C278.716 2.08023 278.428 1.37412 278.141 0.858857C278.236 0.839773 278.313 0.839773 278.39 0.858857ZM277.718 5.74433C277.507 5.68708 277.296 5.51533 277.258 5.30541C277.699 5.61075 278.217 5.36266 278.697 5.15273C278.774 5.11457 278.85 5.0764 278.927 5.05731C279.33 4.92373 279.656 4.90464 280.001 5.01915C280.116 5.05731 280.155 5.1909 280.136 5.26724C280.136 5.28632 280.116 5.30541 280.059 5.28632C279.733 5.13365 279.407 5.05731 279.157 5.38174C279.138 5.38174 279.138 5.38174 279.119 5.38174L279.042 5.41991C278.62 5.62983 278.16 5.83975 277.718 5.74433ZM279.253 5.49624C279.407 5.26724 279.618 5.24815 280.001 5.41991C280.136 5.45808 280.232 5.41991 280.27 5.30541C280.327 5.15273 280.232 4.92373 280.04 4.86648C279.675 4.73289 279.311 4.75197 278.889 4.88556C278.754 4.73289 278.543 4.65655 278.294 4.65655C278.045 4.65655 277.757 4.75197 277.584 4.88556C277.507 4.54205 277.546 4.29396 277.68 4.10312C277.872 3.85503 278.236 3.79778 278.409 3.79778H278.428C278.85 3.79778 279.196 4.08404 279.387 4.58022C279.407 4.61838 279.426 4.63747 279.464 4.63747C280.193 4.5993 280.596 4.92373 280.788 5.20999C280.884 5.32449 280.903 5.61075 280.807 5.74433C280.788 5.7825 280.73 5.82067 280.596 5.7825C280.577 5.76342 280.538 5.74433 280.519 5.76342C279.963 5.57258 279.771 5.59166 279.253 5.80159C279.234 5.70617 279.234 5.57258 279.253 5.49624ZM278.198 9.52295C278.965 9.19852 279.157 8.91226 279.445 8.43516C279.483 8.43516 279.503 8.43516 279.541 8.43516C280.136 8.43516 280.577 7.95807 280.73 7.15654C280.73 7.11838 280.711 7.08021 280.673 7.06112C280.634 7.06112 280.596 7.08021 280.577 7.11838C280.519 7.40463 280.27 8.33974 279.464 8.26341C279.407 8.22524 279.234 8.12982 279.119 8.01532C279.771 7.86265 280.232 7.23288 280.308 6.69853C280.366 6.29777 280.212 5.95426 279.905 5.76342C280.078 5.76342 280.251 5.80159 280.519 5.89701C280.654 6.06876 280.654 6.22143 280.634 6.43135C280.634 6.46952 280.634 6.50769 280.634 6.54586C280.634 6.58403 280.673 6.62219 280.711 6.62219C280.749 6.62219 280.788 6.58403 280.788 6.54586C280.788 6.50769 280.788 6.46952 280.788 6.43135C280.788 6.2596 280.807 6.08784 280.711 5.93517C280.826 5.93517 280.884 5.85884 280.922 5.82067C281.056 5.64892 281.037 5.28632 280.903 5.11457C280.692 4.80922 280.27 4.44663 279.503 4.4848C279.234 3.83595 278.793 3.68327 278.505 3.66419C278.563 3.32068 278.774 3.11076 278.908 3.07259H278.927C279.042 3.07259 279.176 3.07259 279.292 3.07259C279.809 3.07259 280.289 3.11076 280.692 3.16801C280.999 3.20618 281.267 3.22526 281.498 3.22526C281.555 3.22526 281.594 3.22526 281.651 3.22526H281.67C281.785 3.22526 281.881 3.22526 281.958 3.22526C282.073 3.22526 282.15 3.22526 282.207 3.22526C282.265 3.49243 282.054 3.60694 281.958 3.64511C281.824 3.64511 281.747 3.62602 281.574 3.58785C281.536 3.56877 281.498 3.60694 281.478 3.64511C281.459 3.68327 281.498 3.72144 281.536 3.74053C281.728 3.79778 281.805 3.79778 281.958 3.81686H281.996C282.207 3.83595 282.495 3.85503 282.764 3.85503C282.745 4.08404 282.649 4.19854 282.438 4.29396H282.418C282.342 4.33213 282.227 4.31304 281.996 4.25579C281.958 4.25579 281.92 4.27487 281.9 4.31304C281.9 4.35121 281.92 4.38938 281.958 4.40846C282.112 4.44663 282.227 4.46571 282.323 4.46571C282.342 4.46571 282.361 4.46571 282.38 4.46571C282.629 4.79014 282.725 5.11457 282.706 5.53441C282.687 5.82067 282.649 6.12601 282.591 6.43135C282.476 7.17563 282.38 7.90081 282.687 8.22524C282.629 8.26341 282.553 8.30158 282.476 8.30158H282.457C281.9 8.12982 281.939 7.69089 282.054 6.92754C282.15 6.29777 282.265 5.59166 281.9 4.92373C281.881 4.88556 281.824 4.86648 281.805 4.88556C281.766 4.90464 281.747 4.96189 281.766 4.98098C282.092 5.61075 281.996 6.29777 281.9 6.88937C281.785 7.59547 281.709 8.20616 282.399 8.43516C282.399 8.47333 282.418 8.5115 282.418 8.54967C282.476 8.89318 282.534 9.23669 282.956 9.6947C282.936 9.84737 282.783 9.94279 282.629 9.98096C282.534 10 282.38 10 282.246 9.88554C282.131 9.79012 282.035 9.59928 281.977 9.37027C281.977 9.37027 281.977 9.37028 281.977 9.35119C281.939 9.19852 281.92 9.00768 281.92 8.79776C281.92 8.75959 281.881 8.72142 281.843 8.72142C281.805 8.72142 281.766 8.75959 281.766 8.79776C281.766 9.02676 281.785 9.2176 281.824 9.38936C281.881 10.0191 281.651 10.3245 281.478 10.5535C281.229 10.4771 280.96 10.3436 280.826 9.96188C280.98 9.67562 281.037 9.35119 281.114 9.04585C281.152 8.87409 281.191 8.72142 281.229 8.58784C281.248 8.54967 281.229 8.5115 281.172 8.49242C281.133 8.47333 281.095 8.49242 281.076 8.54967C281.037 8.68325 280.999 8.85501 280.96 9.02676C280.903 9.31302 280.826 9.63745 280.692 9.90462L280.673 9.92371C280.654 9.94279 280.654 9.96188 280.634 9.98096C280.634 9.98096 280.634 10 280.615 10C280.385 10.3817 279.944 10.5726 279.426 10.4962C279.445 9.88554 279.656 9.50386 280.327 8.83593C281.133 7.90082 281.881 6.71761 281.344 5.05731C281.325 5.01915 281.287 5.00006 281.248 5.00006C281.21 5.01915 281.191 5.05731 281.191 5.09548C281.709 6.67945 280.98 7.8054 280.212 8.72142C279.905 9.02676 279.694 9.27486 279.56 9.50386C279.426 9.65653 278.812 9.94279 278.313 9.75195C278.313 9.75195 278.313 9.75195 278.294 9.75195C278.275 9.67562 278.217 9.5802 278.198 9.52295ZM278.39 9.90462C278.524 9.94279 278.658 9.96188 278.774 9.96188C279.042 9.96188 279.311 9.88554 279.503 9.79012C279.407 10.0191 279.368 10.2672 279.368 10.5535C279.368 10.5916 279.387 10.6298 279.426 10.6298C280.02 10.7443 280.538 10.5344 280.826 10.1145C281.018 10.5344 281.383 10.6489 281.574 10.7061H281.594C281.613 10.7061 281.632 10.6871 281.651 10.668C281.785 10.4962 281.996 10.2291 282.054 9.79012C282.092 9.86646 282.15 9.94279 282.207 9.98096C282.342 10.0955 282.495 10.1145 282.61 10.1145C282.879 10.6871 282.84 11.2787 282.802 11.5458C282.802 11.5649 282.802 11.5649 282.802 11.584C282.629 11.5077 282.227 11.2596 282.111 11.0115C282.092 10.9924 282.073 10.9733 282.054 10.9733C282.035 10.9733 281.996 10.9924 281.977 11.0115C281.747 11.3741 281.613 11.6222 281.287 11.7367C281.037 11.6413 280.692 11.355 280.481 10.9161C280.462 10.897 280.443 10.8779 280.404 10.8779C280.385 10.8779 280.347 10.897 280.327 10.9161C280.136 11.2787 279.848 11.5458 279.445 11.6985C279.081 11.4504 278.927 11.2596 278.754 10.897C278.735 10.8779 278.716 10.8588 278.697 10.8588C278.678 10.8588 278.639 10.8588 278.62 10.897C278.409 11.1832 278.141 11.4313 277.891 11.5268C277.891 11.5268 277.872 11.5268 277.872 11.5077C277.93 10.6871 278.064 10.2481 278.39 9.90462ZM277.757 11.4504C277.757 11.5268 277.757 11.584 277.757 11.6603C277.757 11.6794 277.776 11.6985 277.795 11.7176C277.814 11.7367 277.834 11.7367 277.834 11.7367C277.853 11.9084 277.872 12.0229 277.891 12.1374C275.723 11.6794 274.304 11.3359 274.476 10.0382C274.668 10.1336 274.86 10.21 275.033 10.229H275.052C275.052 10.229 275.052 10.229 275.071 10.229C275.11 10.229 275.148 10.1909 275.148 10.1527V10.1336C275.244 9.84737 275.205 9.48478 275.129 9.17944C275.416 9.02676 275.627 8.79776 275.723 8.53058C275.743 8.49242 275.723 8.47333 275.704 8.43516C275.512 8.26341 275.301 8.18707 275.014 8.14891C275.052 7.76723 274.994 7.25196 274.822 7.08021C274.803 7.06112 274.783 7.06112 274.745 7.06112C274.361 7.13746 274.035 7.50005 273.882 7.76723C273.671 7.63364 273.46 7.57639 273.23 7.57639C273.191 7.57639 273.172 7.59547 273.153 7.63364C273.114 7.76723 273.019 8.16799 273.114 8.43516C273.095 8.45425 273.076 8.45425 273.057 8.47333C272.827 8.626 272.654 8.74051 272.52 9.12218C272.52 9.14127 272.52 9.17944 272.539 9.19852C272.635 9.35119 272.865 9.42753 273.21 9.48478C272.961 10.2672 273.23 11.6222 273.92 12.1184C274.822 12.7481 276.222 13.0344 277.45 13.2825C277.757 13.3397 278.045 13.397 278.313 13.4542H278.332C278.371 13.5878 278.428 13.7023 278.486 13.8359C278.505 13.8741 278.524 13.8741 278.563 13.8741C278.601 13.8932 278.62 13.8932 278.678 13.8932C278.697 14.0077 278.716 14.1985 278.754 14.3893C278.754 14.3893 278.754 14.3893 278.735 14.3893C278.121 14.5993 277.354 14.3893 277.124 14.1412C277.105 14.1222 277.066 14.1031 277.028 14.1222C276.606 14.3893 276.107 14.2939 275.743 13.855C275.723 13.8359 275.704 13.8168 275.666 13.8359C275.014 13.9122 274.534 13.8359 274.285 13.2061C274.265 13.1871 274.246 13.168 274.227 13.1489C273.249 13.0726 273.114 12.7672 272.942 11.8893C272.942 11.8703 272.923 11.8512 272.903 11.8321C272.654 11.7176 272.481 11.4886 272.385 11.2214C272.29 10.897 272.347 10.5535 272.558 10.229C272.577 10.1909 272.577 10.1527 272.539 10.1145C272.194 9.88554 271.983 9.54203 272.002 9.19852C272.021 8.87409 272.232 8.60692 272.577 8.43516C272.616 8.41608 272.635 8.37791 272.616 8.33974C272.462 7.9199 272.52 7.5573 272.788 7.30921C273.057 7.06112 273.46 6.98479 273.786 7.13746C273.824 7.15654 273.863 7.13746 273.882 7.11838C274.208 6.67945 274.707 6.58403 274.994 6.7367C275.301 6.88937 275.416 7.25196 275.301 7.72906C275.301 7.74814 275.301 7.78631 275.321 7.8054C275.34 7.82448 275.359 7.84356 275.397 7.82448C275.647 7.78631 275.858 7.88173 275.992 8.07257C276.165 8.30158 276.222 8.64509 276.107 8.91226C276.03 9.08402 275.877 9.29394 275.493 9.33211C275.474 9.33211 275.455 9.35119 275.436 9.37027C275.416 9.38936 275.416 9.40844 275.416 9.42753C275.474 9.6947 275.608 9.77104 275.819 9.86646C275.743 10.1527 275.781 10.4199 275.915 10.6298C276.28 11.2214 277.239 11.3932 277.757 11.4504ZM269.009 4.84739C269.335 5.34357 269.815 5.668 270.179 5.91609C270.218 5.93517 270.256 5.97334 270.294 5.99243L270.314 6.01151C270.429 6.12601 270.506 6.18326 270.563 6.2596C270.659 6.35502 270.717 6.43135 270.966 6.62219C270.985 6.64128 271.004 6.64128 271.023 6.64128C271.043 6.64128 271.062 6.62219 271.081 6.60311C271.1 6.56494 271.1 6.52677 271.062 6.48861C270.832 6.31685 270.774 6.24052 270.678 6.1451C270.621 6.06876 270.544 6.01151 270.39 5.85884L270.371 5.83975C269.872 5.26724 269.45 4.40846 269.393 3.83595C270.026 3.81686 270.621 4.16037 271.561 4.7138C271.58 4.7138 271.58 4.7138 271.599 4.73289C272.079 5.0764 272.462 5.40082 272.98 6.06876L272.999 6.08784C273.019 6.18326 273.038 6.29777 273.057 6.39319C272.596 6.03059 272.04 5.91609 271.254 6.01151C271.215 6.01151 271.196 6.04968 271.196 6.06876C271.119 6.62219 271.311 7.13746 271.599 7.5573C270.908 7.06112 270.218 6.69853 269.642 6.52677C269.067 5.95426 268.894 5.20999 269.009 4.84739ZM267.513 7.50005C267.82 7.8054 268.645 8.11074 269.201 8.20616C269.201 8.20616 269.201 8.20616 269.22 8.20616C269.412 8.33974 269.566 8.43516 269.681 8.5115C269.719 8.53058 269.757 8.53058 269.796 8.49242C269.815 8.45425 269.815 8.41608 269.777 8.37791C268.971 7.88173 268.012 7.11838 267.897 6.54586C268.51 6.41227 269.124 6.58403 269.508 6.67945C269.546 6.69853 269.585 6.69853 269.623 6.69853C270.218 6.88937 270.966 7.29013 271.676 7.8054C271.139 7.65272 270.544 7.69089 270.007 7.93898C269.968 7.95807 269.949 7.99623 269.968 8.01532C270.026 8.37791 270.16 8.66417 270.333 8.89318C269.892 8.85501 269.22 8.83593 268.53 8.95043C267.513 8.28249 267.475 7.82448 267.513 7.50005ZM266.765 9.71379C267.877 8.91226 269.7 8.96951 270.448 9.04585C270.697 9.29394 271.023 9.46569 271.369 9.59928C270.697 9.73287 269.949 10.2291 269.585 10.6489H269.508C269.412 10.6298 269.297 10.6298 269.182 10.6107H269.163C268.338 10.4962 267.225 10.3054 266.765 9.71379ZM266.726 10.6871C266.918 10.8016 267.263 10.8397 267.628 10.8397C267.954 10.8397 268.319 10.8207 268.645 10.7825C268.817 10.7634 268.99 10.7634 269.143 10.7443C269.259 10.7634 269.374 10.7634 269.47 10.7825L269.546 10.8016C269.642 10.9733 269.796 11.126 269.988 11.2405C269.7 11.3168 269.374 11.4313 269.067 11.5458C268.971 11.584 268.875 11.6222 268.779 11.6413C267.033 11.4504 266.746 11.2977 266.726 10.6871ZM266.707 13.6069C267.091 12.8435 267.743 12.3092 268.856 11.7939C268.952 11.7558 269.048 11.7176 269.143 11.6985C269.489 11.5649 269.892 11.4123 270.218 11.3741C270.621 11.5649 271.1 11.6413 271.561 11.584C271.043 11.9848 270.601 12.6527 270.486 13.2443C270.448 13.2634 270.41 13.2825 270.371 13.3016C268.568 13.8932 267.359 14.0077 266.707 13.6069ZM268.568 19.0649C268.53 17.3283 269.316 15.5535 270.928 13.6832C270.947 13.6451 270.947 13.6069 270.928 13.5687C270.889 13.5496 270.851 13.5496 270.812 13.5687C270.448 13.9886 270.122 14.4084 269.834 14.8283H269.815C268.721 15.439 267.935 15.668 267.436 15.4962C267.129 15.4008 266.937 15.1527 266.822 14.9046C266.861 14.9046 266.899 14.9046 266.957 14.9046C267.551 14.9046 268.319 14.4848 269.124 14.0458C269.546 13.8168 269.988 13.5687 270.41 13.397C270.448 13.3779 270.486 13.3779 270.505 13.3588H270.525L270.582 13.3779C271.043 13.4733 271.848 13.6451 272.539 13.3016C272.232 13.8741 272.098 14.7328 272.155 15.4008C272.155 15.439 272.194 15.458 272.213 15.4771C272.232 15.4771 272.251 15.4771 272.29 15.4771C271.465 16.7939 269.796 18.855 268.568 19.0649ZM271.158 19.3893C270.889 19.6756 270.179 20.1336 269.642 19.8664C270.045 19.6183 270.601 18.7023 271.35 17.3855C271.676 16.8321 271.963 16.2977 272.232 15.9161C272.232 15.9161 272.232 15.9161 272.232 15.897C272.328 15.7634 272.405 15.6298 272.501 15.4962C272.558 15.4962 272.635 15.4771 272.692 15.4771C272.501 16.2786 272.366 17.1947 272.251 17.9389C271.829 18.5878 271.465 19.0649 271.158 19.3893ZM272.654 21.374C272.309 20.6679 272.309 18.5305 272.385 18.0344V18.0153C272.501 17.2519 272.635 16.2786 272.846 15.458C273.325 15.3244 273.824 15 274.17 14.5993C274.016 15.4008 274.4 16.0687 274.668 16.4886C274.707 16.5649 274.745 16.6222 274.783 16.6794C274.381 19.1794 273.421 20.8397 272.654 21.374ZM274.476 19.6756C274.572 19.3893 274.649 18.9504 274.726 18.3206C274.783 17.8817 274.86 17.3283 274.975 16.7176C275.129 16.6603 275.282 16.584 275.397 16.4886C275.493 16.8893 275.551 17.0802 275.647 17.3473C275.608 17.5 275.551 17.6527 275.512 17.8244C275.321 18.5305 275.11 19.3702 274.476 19.6756ZM275.954 17.5382C275.858 17.4618 275.838 17.3855 275.8 17.3283V17.3092C275.8 17.3092 275.8 17.3092 275.8 17.2901C275.704 17.0229 275.647 16.813 275.551 16.3741C276.184 15.8588 276.414 15.0764 276.491 14.7138C276.491 14.6756 276.472 14.6374 276.433 14.6183C276.395 14.6183 276.356 14.6374 276.337 14.6756C276.261 15.0382 276.05 15.7825 275.436 16.2596C275.416 16.2596 275.416 16.2786 275.397 16.2977C275.263 16.3931 275.11 16.4886 274.937 16.5649C274.899 16.5077 274.879 16.4504 274.841 16.3931C274.534 15.8779 274.074 15.0954 274.515 14.1412C274.534 14.1031 274.515 14.0649 274.476 14.0458C274.438 14.0267 274.4 14.0458 274.381 14.084C273.978 14.8283 273.019 15.4199 272.347 15.3626C272.29 14.5611 272.501 13.5306 272.942 13.0916C272.961 13.0725 272.98 13.0535 272.999 13.0535C273.038 13.0153 273.038 12.9771 272.999 12.939C272.98 12.9008 272.923 12.9008 272.884 12.939C272.865 12.958 272.846 12.9771 272.827 12.9962C272.136 13.5878 271.196 13.397 270.659 13.2825C270.659 13.2634 270.64 13.2634 270.64 13.2443C270.793 12.5382 271.445 11.7176 272.079 11.4504C272.117 11.4313 272.136 11.3932 272.117 11.355C272.098 11.3168 272.059 11.2977 272.021 11.3168C271.465 11.5458 270.774 11.4886 270.275 11.2405L270.256 11.2214C270.026 11.1069 269.834 10.9542 269.738 10.7634C270.179 10.2481 271.158 9.71379 271.772 9.75195C271.81 9.75195 271.848 9.73287 271.848 9.6947C271.848 9.65653 271.829 9.61837 271.791 9.59928C271.023 9.35119 270.294 8.9886 270.122 8.07257C270.793 7.8054 271.561 7.84356 272.174 8.20616C272.213 8.22524 272.251 8.22524 272.27 8.18707C272.29 8.14891 272.29 8.11074 272.251 8.09165C271.772 7.70998 271.273 6.98479 271.35 6.20235C272.194 6.10693 272.769 6.27868 273.21 6.77487C273.23 6.81303 273.287 6.81303 273.306 6.79395C273.345 6.77486 273.345 6.7367 273.345 6.69853C273.095 6.1451 273.114 5.68708 273.249 5.09548C274.649 5.1909 275.416 6.60311 275.512 7.00387C275.532 7.04204 275.57 7.08021 275.608 7.06112C275.647 7.04204 275.685 7.00387 275.666 6.9657C275.57 6.54586 274.726 5.00006 273.191 4.94281C273.153 4.94281 273.114 4.96189 273.114 5.00006C273.057 5.30541 272.999 5.59166 273.019 5.87792C272.539 5.28632 272.174 4.98098 271.695 4.63747H271.676C270.985 3.85503 270.697 3.09167 270.64 2.84358C272.769 2.86267 275.34 4.80922 276.184 5.91609C277.776 7.97715 277.354 9.02676 277.105 9.38936C276.798 9.80921 276.299 9.92371 275.992 9.82829H275.973C275.781 9.75195 275.704 9.6947 275.647 9.56111C275.954 9.50386 276.184 9.33211 276.299 9.06493C276.433 8.74051 276.376 8.33974 276.165 8.07257C276.011 7.86265 275.781 7.74814 275.532 7.76723C275.627 7.27105 275.474 6.88937 275.11 6.71761C274.764 6.54586 274.208 6.62219 273.824 7.09929C273.46 6.9657 272.999 7.04204 272.712 7.3283C272.424 7.59547 272.347 8.01532 272.481 8.47333C272.117 8.66417 271.906 8.9886 271.887 9.33211C271.868 9.71379 272.059 10.0955 272.424 10.3436C272.232 10.6871 272.174 11.0497 272.27 11.3932C272.366 11.6985 272.558 11.9466 272.827 12.0802C272.98 12.939 273.172 13.3397 274.189 13.4351C274.496 14.1222 275.071 14.1794 275.685 14.1222C275.954 14.4275 276.28 14.5802 276.606 14.5611C276.721 14.7138 276.97 14.9046 277.277 15.0573C277.105 16.4313 276.28 17.4046 275.954 17.5382ZM276.759 14.4466C276.855 14.4275 276.97 14.3893 277.066 14.3321C277.296 14.5038 277.738 14.6756 278.198 14.6756C278.39 14.6756 278.601 14.6565 278.793 14.5802C278.812 14.6947 278.85 14.8283 278.889 14.9237C277.91 15.2863 277.085 14.7901 276.759 14.4466ZM278.831 13.9122C278.985 13.8932 279.196 13.855 279.464 13.7977C279.752 14.0077 280.078 14.1031 280.404 14.1031C280.73 14.1031 281.037 14.0077 281.325 13.7977C281.632 13.8932 281.862 13.9313 282.035 13.9313C282.016 14.1985 281.939 14.6183 281.824 14.9046C281.805 14.9046 281.766 14.8855 281.728 14.8855C281.689 14.8664 281.632 14.8664 281.594 14.8474C281.574 14.8474 281.555 14.8474 281.536 14.8664C281.344 15.0191 280.788 15.0382 280.443 14.771C280.404 14.7519 280.366 14.7519 280.347 14.771C280.097 15.0191 279.483 15 279.292 14.8664C279.272 14.8474 279.253 14.8474 279.234 14.8474C279.196 14.8474 279.157 14.8664 279.119 14.8664C279.081 14.8664 279.061 14.8855 279.023 14.8855C278.927 14.5611 278.85 14.1412 278.831 13.9122ZM279.157 15.0191C279.176 15.0191 279.215 15 279.234 15C279.483 15.1527 280.078 15.1718 280.404 14.9237C280.615 15.0573 280.865 15.1145 281.095 15.1145C281.306 15.1145 281.478 15.0764 281.594 15C281.613 15 281.651 15.0191 281.67 15.0191C281.594 15.3626 281.498 15.6489 281.402 15.9161L281.152 15.8015C281.133 15.7825 281.095 15.7825 281.076 15.8015C280.615 16.0687 280.116 16.0687 279.656 15.8015C279.637 15.7825 279.598 15.7825 279.579 15.8015L279.33 15.9161C279.272 15.6107 279.176 15.3244 279.157 15.0191ZM281.037 17.729C281.056 18.4924 280.769 19.5229 280.385 20.1718H280.366C280.021 19.6183 279.656 18.3779 279.675 17.729C279.675 17.0802 279.541 16.5267 279.407 16.0687L279.656 15.9542C279.905 16.0878 280.155 16.1641 280.404 16.1641C280.654 16.1641 280.903 16.0878 281.152 15.9542L281.383 16.0687C281.191 16.5649 281.037 17.0038 281.037 17.729ZM275.071 23.7595L274.994 23.8359C274.841 24.0267 274.764 24.1221 274.707 24.1985C274.649 24.313 274.63 24.4084 274.687 24.5038C274.764 24.6374 274.956 24.7137 275.225 24.6946C275.493 24.6565 275.704 24.7519 275.762 24.9237C275.819 25.0954 275.762 25.3244 275.608 25.4389C275.589 25.4389 275.551 25.458 275.551 25.4962C275.532 25.5153 275.532 25.5343 275.551 25.5725C275.551 25.7824 275.474 25.9351 275.34 26.0496C275.205 26.1641 275.033 26.2214 274.899 26.2214C274.994 26.0687 275.014 25.8969 275.014 25.7633C275.033 25.7633 275.071 25.7633 275.09 25.7633C275.205 25.7633 275.321 25.7443 275.397 25.687C275.436 25.6679 275.455 25.6107 275.416 25.5725C275.397 25.5343 275.34 25.5152 275.301 25.5534C275.186 25.6298 275.014 25.6107 274.956 25.5916H274.937C274.764 25.4962 274.687 25.4198 274.611 25.1717C274.592 25.1336 274.553 25.1145 274.515 25.1145C274.381 25.1527 274.15 25.1145 274.093 25.0191C274.074 25 274.054 24.9809 274.016 24.9809C273.997 24.9809 273.959 25 273.959 25.0191C273.901 25.1336 273.863 25.2672 273.824 25.3817C273.748 25.6298 273.671 25.8588 273.46 26.0496C273.441 26.0687 273.421 26.1068 273.441 26.1259C273.536 26.4504 273.498 26.6794 273.306 26.813C273.287 26.832 273.268 26.8511 273.268 26.8893C273.306 27.1565 273.364 27.3091 273.479 27.4236C273.287 27.5 273.076 27.5 272.903 27.4236C272.808 27.3855 272.712 27.3091 272.654 27.1755C272.731 27.1755 272.827 27.1756 272.923 27.1565C272.961 27.1374 272.999 27.0992 272.98 27.061C272.961 27.0229 272.923 26.9847 272.884 27.0038C272.596 27.0801 272.501 26.9656 272.443 26.8702C272.347 26.7366 272.347 26.4885 272.405 26.2786C272.462 26.0496 272.731 25.9542 272.884 25.9351C272.923 25.9351 272.961 25.8969 272.961 25.8588C272.961 25.687 273.019 25.4389 273.095 25.1908V25.1717C273.172 24.9046 273.268 24.6565 273.345 24.542C273.364 24.5038 273.345 24.4656 273.306 24.4275C273.268 24.4084 273.23 24.4275 273.191 24.4656C273.114 24.5992 273.019 24.8473 272.923 25.1145C272.616 25.3817 272.328 25.458 272.002 25.5534L271.925 25.5725C271.887 25.5725 271.868 25.6107 271.868 25.6488C271.848 25.9351 271.791 26.0687 271.599 26.1641C271.599 26.1641 271.58 26.1641 271.58 26.1832C271.503 26.2595 271.388 26.5076 271.484 26.813C271.311 26.7939 271.139 26.7175 271.043 26.603C270.966 26.5076 270.908 26.4122 270.889 26.2977C270.966 26.3168 271.043 26.3168 271.1 26.3168C271.139 26.3168 271.177 26.2786 271.177 26.2404C271.177 26.2023 271.139 26.1641 271.1 26.1641C271.004 26.1641 270.908 26.145 270.87 26.1069L270.851 26.0878C270.697 25.9542 270.717 25.5153 270.832 25.3435C270.985 25.1145 271.292 25.1145 271.484 25.1908C271.503 25.1908 271.522 25.1908 271.541 25.1908C271.848 25.0572 272.194 24.8473 272.443 24.6565C272.654 24.542 272.808 24.3702 272.942 24.2175L272.884 24.1603L272.827 24.103C272.692 24.2557 272.558 24.3893 272.366 24.5038C272.098 24.542 271.733 24.4084 271.58 24.2939C271.561 24.2748 271.522 24.2748 271.484 24.2939L271.465 24.313C271.292 24.4466 271.119 24.5611 270.697 24.4466C270.678 24.4466 270.64 24.4466 270.621 24.4656C270.467 24.5992 270.39 24.6946 270.333 24.9237C270.199 24.7519 270.122 24.542 270.141 24.313C270.16 24.1603 270.199 24.0076 270.275 23.9122C270.294 24.0267 270.352 24.1412 270.429 24.2175C270.448 24.2366 270.467 24.2366 270.486 24.2366C270.505 24.2366 270.525 24.2366 270.544 24.2175C270.582 24.1794 270.582 24.1412 270.544 24.103C270.448 24.0076 270.41 23.8359 270.429 23.7786C270.429 23.7595 270.429 23.7404 270.429 23.7404C270.525 23.4351 270.832 23.3015 271.1 23.3015C271.311 23.3015 271.561 23.3969 271.599 23.645C271.599 23.6832 271.637 23.7023 271.656 23.7023L272.865 23.9695C273.019 24.0076 273.191 23.9504 273.383 23.7786L273.959 23.3206C274.074 23.3397 274.17 23.3588 274.265 23.3588H274.285C274.323 23.3588 274.361 23.3206 274.361 23.2824C274.361 23.2443 274.323 23.2061 274.285 23.2061C274.189 23.2061 274.093 23.187 273.959 23.1679C273.959 23.1679 273.959 23.1679 273.939 23.1679L274.534 22.6908C274.592 22.6908 274.63 22.6908 274.687 22.6908C274.783 22.6908 274.86 22.6908 274.937 22.6718C274.975 22.6718 275.014 22.6336 275.014 22.5954C275.014 22.5572 274.975 22.5191 274.937 22.5191C274.841 22.5382 274.726 22.5382 274.592 22.5191C274.572 22.5191 274.572 22.5 274.553 22.5H274.515L275.09 21.9656C275.148 21.9656 275.205 21.9656 275.263 21.9656C275.359 21.9656 275.455 21.9656 275.551 21.9466C275.589 21.9466 275.627 21.9084 275.627 21.8511C275.627 21.813 275.589 21.7748 275.532 21.7748C275.397 21.7939 275.263 21.7939 275.129 21.7939L275.09 21.7748L275.781 20.8779C275.915 20.8779 276.03 20.8588 276.165 20.8397C276.145 21.0496 276.184 21.355 276.261 21.5267C276.28 21.4885 276.337 21.4885 276.376 21.5076C276.414 21.5267 276.414 21.584 276.395 21.6221C276.376 21.6412 276.376 21.6412 276.356 21.6603C276.356 21.6603 276.356 21.6603 276.376 21.6603C276.376 21.6603 276.376 21.6603 276.395 21.6603C276.702 21.6031 276.932 21.4885 277.162 21.2977C277.181 21.3359 277.201 21.355 277.201 21.374C276.817 21.7176 275.436 23.3015 275.071 23.7595ZM277.124 21.145C276.932 21.3359 276.721 21.4504 276.452 21.5076C276.376 21.355 276.318 21.0115 276.376 20.8206C276.587 20.7634 276.817 20.687 277.009 20.5534C277.009 20.7824 277.066 20.9924 277.124 21.145ZM283.128 24.7901C283.474 24.6946 283.646 24.4275 283.608 24.0458C284.145 24.1603 284.26 24.5229 284.298 24.7328C284.337 25.1527 284.087 25.6107 283.742 25.7443C283.704 25.7633 283.685 25.7824 283.685 25.8206C283.685 25.8588 283.704 25.8778 283.742 25.8969C284.529 26.1259 284.72 26.7748 284.644 27.2519C284.548 27.8244 284.049 28.3778 283.301 28.3397C282.591 28.3015 281.747 27.7672 281.287 27.0038C281.267 26.9656 281.229 26.9656 281.191 26.9656C281.152 26.9847 281.133 27.0038 281.133 27.042C281.172 28.8549 280.749 29.3511 280.385 29.79C280.02 29.3702 279.637 28.8549 279.675 27.042C279.675 27.0038 279.656 26.9847 279.618 26.9656C279.579 26.9465 279.541 26.9656 279.522 27.0038C279.004 27.8244 278.083 28.3778 277.316 28.3206C276.587 28.2633 276.203 27.6908 276.145 27.1755C276.088 26.6985 276.299 26.1069 277.047 25.8778C277.085 25.8588 277.105 25.8397 277.105 25.8015C277.105 25.7633 277.085 25.7443 277.047 25.7252C276.683 25.5916 276.433 25.1336 276.491 24.7137C276.51 24.5038 276.644 24.1412 277.181 24.0267C277.143 24.3893 277.316 24.6756 277.661 24.771C278.236 24.9237 279.1 24.5229 279.426 23.7023C279.464 23.6832 279.503 23.645 279.541 23.6069C279.694 23.4733 279.848 23.3015 279.925 23.1488C280.02 23.4542 280.136 23.7595 280.289 24.0076L280.327 25.8778C280.327 25.916 280.366 25.9542 280.404 25.9542C280.443 25.9542 280.481 25.916 280.481 25.8778L280.443 23.9695C280.577 23.7214 280.692 23.4542 280.788 23.1298C280.922 23.3206 281.152 23.5496 281.363 23.6641C281.689 24.5611 282.553 24.9618 283.128 24.7901ZM283.78 20.5534C284.011 20.7061 284.279 20.8015 284.548 20.8397C284.625 21.1069 284.586 21.3168 284.529 21.5458C284.183 21.5076 283.8 21.2977 283.646 21.1641C283.723 21.0115 283.78 20.7824 283.78 20.5534ZM285.545 21.813C285.526 21.813 285.507 21.813 285.488 21.813C285.373 21.813 285.258 21.8321 285.162 21.813C285.123 21.813 285.085 21.8321 285.085 21.8893C285.085 21.9275 285.104 21.9656 285.162 21.9656C285.2 21.9656 285.258 21.9656 285.296 21.9656C285.373 21.9656 285.449 21.9656 285.507 21.9656C285.526 21.9656 285.545 21.9656 285.545 21.9656L286.121 22.5191H286.082C286.063 22.5191 286.063 22.5191 286.044 22.5382C285.948 22.5382 285.814 22.5382 285.699 22.5382C285.66 22.5382 285.622 22.5572 285.622 22.6145C285.622 22.6527 285.641 22.6908 285.699 22.6908C285.776 22.6908 285.852 22.6908 285.929 22.6908C285.987 22.6908 286.044 22.6908 286.082 22.6908L286.696 23.1679C286.6 23.187 286.505 23.2061 286.428 23.2061C286.389 23.2061 286.351 23.2443 286.351 23.2824C286.351 23.3206 286.389 23.3588 286.428 23.3588C286.505 23.3588 286.6 23.3397 286.696 23.3206L287.272 23.7786C287.464 23.9313 287.636 23.9885 287.79 23.9695L288.998 23.7023C289.037 23.7023 289.056 23.6641 289.056 23.645C289.113 23.3969 289.363 23.3015 289.555 23.3015H289.574C289.823 23.3015 290.111 23.4351 290.207 23.7214C290.188 23.7404 290.188 23.7595 290.188 23.7786C290.207 23.855 290.169 24.0267 290.073 24.103C290.034 24.1412 290.034 24.1794 290.073 24.2175C290.092 24.2366 290.111 24.2366 290.13 24.2366C290.149 24.2366 290.169 24.2366 290.188 24.2175C290.264 24.1412 290.322 24.0076 290.341 23.8931C290.437 24.0076 290.495 24.1412 290.495 24.313C290.514 24.542 290.437 24.7519 290.303 24.9237C290.226 24.6946 290.149 24.5992 289.996 24.4656C289.977 24.4466 289.958 24.4466 289.919 24.4466C289.497 24.5801 289.325 24.4466 289.152 24.313L289.133 24.2939C289.113 24.2748 289.075 24.2748 289.037 24.2939C288.902 24.4084 288.576 24.542 288.308 24.5038C288.116 24.3893 287.962 24.2366 287.847 24.103C287.809 24.0649 287.771 24.0649 287.732 24.103C287.694 24.1412 287.694 24.1794 287.732 24.2175C287.867 24.3511 288.02 24.5229 288.25 24.6374C288.557 24.8664 288.826 25.0572 289.113 25.1717C289.133 25.1717 289.152 25.1717 289.171 25.1717C289.344 25.0954 289.67 25.0954 289.823 25.3244C289.938 25.4962 289.977 25.9351 289.804 26.0687C289.804 26.0687 289.785 26.0687 289.785 26.0878C289.747 26.1259 289.651 26.145 289.555 26.145C289.516 26.145 289.478 26.1641 289.478 26.2214C289.478 26.2786 289.497 26.2977 289.555 26.2977C289.631 26.2977 289.708 26.2977 289.766 26.2786C289.747 26.3931 289.708 26.4885 289.612 26.584C289.497 26.6985 289.344 26.7748 289.171 26.7939C289.286 26.4885 289.171 26.2404 289.075 26.1641L289.056 26.145C288.864 26.0496 288.826 25.9351 288.787 25.6298C288.787 25.5916 288.768 25.5725 288.73 25.5534L288.634 25.5343C288.327 25.458 288.001 25.3626 287.694 25.0954C287.598 24.8091 287.483 24.542 287.406 24.4084C287.387 24.3702 287.329 24.3511 287.291 24.3893C287.253 24.4084 287.233 24.4656 287.272 24.5038C287.349 24.6374 287.464 24.9046 287.56 25.1717C287.56 25.1908 287.56 25.1908 287.579 25.2099C287.656 25.458 287.732 25.7061 287.732 25.8588C287.732 25.8969 287.771 25.9351 287.809 25.9351C287.962 25.9351 288.231 26.0496 288.289 26.2786C288.346 26.5076 288.327 26.7366 288.25 26.8702C288.193 26.9656 288.097 27.061 287.809 27.0038C287.771 26.9847 287.732 27.0229 287.713 27.061C287.694 27.0992 287.732 27.1374 287.771 27.1565C287.867 27.1756 287.962 27.1946 288.039 27.1755C287.982 27.3091 287.886 27.3855 287.79 27.4236C287.617 27.5 287.406 27.5 287.214 27.4236C287.329 27.3091 287.387 27.1565 287.425 26.8893C287.425 26.8511 287.425 26.832 287.387 26.813C287.195 26.6794 287.157 26.4504 287.253 26.1259C287.253 26.1068 287.253 26.0687 287.234 26.0496C287.022 25.8588 286.946 25.6298 286.869 25.3817C286.831 25.2672 286.792 25.1527 286.735 25.0382C286.716 25.0191 286.696 25 286.677 25C286.658 25 286.62 25 286.6 25.0382C286.543 25.1145 286.313 25.1527 286.178 25.1336C286.14 25.1336 286.102 25.1527 286.082 25.1908C286.025 25.4198 285.948 25.5153 285.795 25.5916C285.776 25.5916 285.756 25.5916 285.737 25.5916C285.68 25.6298 285.507 25.6298 285.392 25.5534C285.354 25.5343 285.315 25.5343 285.277 25.5725C285.258 25.6107 285.258 25.6488 285.296 25.687C285.373 25.7443 285.488 25.7633 285.603 25.7633C285.622 25.7633 285.66 25.7633 285.68 25.7633C285.68 25.8969 285.699 26.0687 285.814 26.2404C285.699 26.2404 285.565 26.2023 285.43 26.1069C285.277 26.0114 285.181 25.8588 285.142 25.6679C285.142 25.6488 285.123 25.6298 285.104 25.6107C284.893 25.5152 284.778 25.1908 284.836 24.9237C284.893 24.6946 285.104 24.5801 285.411 24.6183H285.43C285.756 24.542 285.91 24.4656 285.967 24.332C286.006 24.2366 285.967 24.1221 285.871 24.0076C285.68 23.7786 285.488 23.5496 285.296 23.3015C284.72 22.5954 284.126 21.8702 283.531 21.3931C283.55 21.374 283.55 21.355 283.569 21.3359C283.742 21.4695 284.03 21.6221 284.318 21.6794C284.682 22.0611 285.123 22.5954 285.545 23.1107C285.756 23.3588 285.967 23.6259 286.159 23.855C286.313 24.0458 286.37 24.2366 286.389 24.332V24.3511C286.389 24.3893 286.428 24.4084 286.466 24.4084H286.485C286.524 24.3893 286.562 24.3511 286.543 24.313V24.2939C286.505 24.1603 286.466 23.9504 286.274 23.7404C286.063 23.4924 285.852 23.2443 285.66 22.9962C285.296 22.5382 284.912 22.0802 284.567 21.7176H284.586C284.625 21.7176 284.663 21.6985 284.663 21.6603C284.72 21.3931 284.778 21.1641 284.701 20.8779C284.759 20.8779 284.797 20.8969 284.855 20.8969L285.565 21.7939L285.545 21.813ZM283.378 16.8893C283.627 17.4618 284.049 18.187 284.586 18.4542C284.548 18.4733 284.509 18.4733 284.471 18.4733C284.471 18.4733 284.471 18.4733 284.452 18.4733C283.857 18.397 283.474 18.1298 283.358 17.7099C283.358 17.6909 283.339 17.6718 283.32 17.6527C283.263 17.6336 283.186 17.6145 283.128 17.5763C282.495 17.3473 282.303 17.271 282.016 16.8321C281.996 16.7939 281.939 16.7939 281.9 16.813C281.862 16.8321 281.862 16.8893 281.881 16.9275C282.188 17.4237 282.418 17.5 283.071 17.7481C283.109 17.7672 283.167 17.7863 283.224 17.8054C283.378 18.2634 283.78 18.5496 284.414 18.645C284.49 18.8168 284.663 19.084 284.874 19.2748C284.855 19.2748 284.836 19.2748 284.797 19.2748H284.778C284.337 19.2939 283.8 19.0076 283.339 18.4924C283.32 18.4733 283.32 18.4733 283.301 18.4733C282.86 18.3779 282.476 18.2825 282.016 17.8626C281.977 17.8244 281.939 17.8435 281.9 17.8626C281.862 17.9008 281.881 17.9389 281.9 17.9771C282.38 18.416 282.783 18.5305 283.224 18.626C283.665 19.1221 284.164 19.4084 284.625 19.4275C284.72 19.6183 285.085 19.8473 285.296 19.9618C285.277 19.9809 285.238 20 285.2 20.0191C284.548 20.1336 283.665 19.8664 283.301 19.2176C283.282 19.1985 283.263 19.1794 283.243 19.1794C282.879 19.1603 282.476 18.9886 282.092 18.6832C282.054 18.6641 282.016 18.6641 281.977 18.7023C281.958 18.7405 281.958 18.7786 281.996 18.8168C282.38 19.1221 282.802 19.2939 283.186 19.3321C283.55 19.9046 284.279 20.1908 284.912 20.1908C284.989 20.1908 285.066 20.1908 285.142 20.1718C285.258 20.2863 285.469 20.4771 285.776 20.6489C285.373 20.8015 284.394 20.8779 283.723 20.3626C283.685 20.3435 283.646 20.3435 283.608 20.3817C283.589 20.4008 283.589 20.4198 283.589 20.4389V20.458C283.646 20.8397 283.435 21.2405 283.358 21.355C283.358 21.355 283.339 21.355 283.339 21.374L283.32 21.3931C283.167 21.584 282.936 21.8702 282.553 22.0038C282.629 21.8702 282.706 21.6603 282.706 21.3359C283.109 20.8969 283.263 20.458 283.186 19.8473C283.186 19.8092 283.147 19.771 283.09 19.771C283.051 19.771 283.013 19.8092 283.013 19.8664C283.071 20.4198 282.936 20.8397 282.572 21.2214C282.572 21.2214 282.572 21.2214 282.553 21.2214C282.476 21.2786 282.457 21.2977 282.399 21.3168C282.457 20.8588 282.534 19.9428 281.344 18.5687C281.325 18.5496 281.325 18.5305 281.306 18.5305C281.267 18.5115 281.229 18.5305 281.21 18.5687C281.191 18.5878 281.191 18.6069 281.191 18.626C281.191 19.7519 281.402 20.7443 281.824 21.6412C281.613 21.584 281.536 21.5458 281.325 21.374C281.306 21.355 281.267 21.355 281.229 21.374C281.21 21.3931 281.191 21.4313 281.191 21.4504C281.306 22.1374 281.632 22.6717 282.016 22.8435C282.227 22.9198 282.438 22.9198 282.649 22.8053C282.725 23.1107 282.649 23.3779 282.438 23.5687C282.188 23.7786 281.805 23.8168 281.44 23.645L281.421 23.6259C281.21 23.5305 280.903 23.2443 280.807 23.0343C280.807 23.0153 280.788 22.9962 280.769 22.9962C280.807 22.8244 280.845 22.6527 280.865 22.4618C281.076 22.9389 281.383 23.2252 282.054 23.2634C282.092 23.2634 282.131 23.2252 282.131 23.187C282.131 23.1488 282.092 23.1107 282.054 23.1107C281.363 23.0725 281.133 22.7672 280.922 22.1947C280.922 22.1947 280.922 22.1756 280.903 22.1756C280.941 21.7748 280.96 21.3168 280.96 20.8206C280.96 20.7824 280.922 20.7443 280.884 20.7443C280.845 20.7443 280.807 20.7824 280.807 20.8206C280.826 22.1947 280.654 23.187 280.27 23.874C279.733 22.9198 279.714 21.4504 279.733 20.8397C279.733 20.8015 279.694 20.7634 279.656 20.7634C279.618 20.7634 279.579 20.8015 279.579 20.8397C279.579 21.126 279.56 21.6221 279.637 22.1565C279.387 22.8244 279.081 23.0725 278.467 23.1107C278.428 23.1107 278.39 23.1488 278.39 23.187C278.39 23.2252 278.428 23.2634 278.467 23.2634C279.119 23.2252 279.445 22.9198 279.656 22.4618C279.694 22.6717 279.733 22.8626 279.771 23.0725C279.733 23.0725 279.714 23.0916 279.694 23.1107C279.618 23.2443 279.464 23.416 279.311 23.5687C279.292 23.5878 279.253 23.6069 279.234 23.6259H279.215C278.85 23.8359 278.447 23.8168 278.179 23.5878C277.968 23.3969 277.891 23.1298 277.968 22.8244C278.179 22.9389 278.39 22.9389 278.582 22.8626C278.965 22.6908 279.272 22.1756 279.407 21.4695C279.407 21.4313 279.407 21.4122 279.368 21.3931C279.349 21.374 279.311 21.374 279.272 21.3931C279.061 21.5649 278.985 21.6221 278.774 21.6603C279.196 20.7443 279.426 19.7328 279.426 18.626C279.426 18.5878 279.407 18.5687 279.368 18.5496C279.33 18.5305 279.311 18.5496 279.292 18.5687C278.102 19.9428 278.179 20.8969 278.236 21.3359C278.179 21.3359 278.16 21.3168 278.083 21.2405C277.699 20.8397 277.565 20.4389 277.642 19.8855C277.642 19.8473 277.623 19.8092 277.565 19.7901C277.527 19.7901 277.488 19.8092 277.469 19.8664C277.392 20.4771 277.546 20.916 277.949 21.3359C277.949 21.6603 278.045 21.8702 278.102 22.0038C277.699 21.8702 277.488 21.584 277.335 21.3931L277.316 21.374L277.296 21.355C277.22 21.2405 277.009 20.8397 277.066 20.458V20.4389C277.066 20.4198 277.066 20.4008 277.047 20.3817C277.028 20.3435 276.97 20.3435 276.932 20.3626C276.567 20.6489 276.088 20.7443 275.685 20.7634H275.666C275.34 20.7634 275.052 20.7061 274.879 20.6489C275.205 20.4771 275.416 20.2672 275.532 20.1527C275.589 20.1527 275.666 20.1718 275.743 20.1718C276.376 20.1718 277.085 19.9046 277.45 19.313C277.834 19.2748 278.256 19.1031 278.639 18.7977C278.678 18.7786 278.678 18.7214 278.658 18.6832C278.639 18.645 278.582 18.645 278.543 18.6641C278.16 18.9695 277.757 19.1221 277.392 19.1603C277.373 19.1603 277.335 19.1794 277.335 19.1985C276.951 19.8664 276.05 20.0954 275.416 19.9809H275.397L275.378 19.9618C275.608 19.8473 275.973 19.5992 276.05 19.4275C276.472 19.3702 276.951 19.084 277.373 18.626C277.814 18.5305 278.236 18.416 278.697 17.9771C278.735 17.9389 278.735 17.9008 278.697 17.8626C278.658 17.8244 278.62 17.8244 278.582 17.8626C278.141 18.2825 277.738 18.3779 277.296 18.4733C277.277 18.4733 277.258 18.4924 277.258 18.4924C276.798 19.0076 276.28 19.2939 275.839 19.2557C275.819 19.2557 275.819 19.2557 275.819 19.2557C275.819 19.2557 275.819 19.2557 275.8 19.2557C276.011 19.0649 276.184 18.7977 276.261 18.626C276.855 18.5305 277.239 18.2443 277.373 17.7863C277.431 17.7672 277.469 17.7481 277.527 17.729C278.16 17.5 278.409 17.4046 278.716 16.9084C278.735 16.8702 278.735 16.8321 278.697 16.7939C278.658 16.7748 278.62 16.7748 278.582 16.813C278.313 17.2519 278.121 17.3283 277.469 17.5573C277.412 17.5763 277.354 17.5954 277.277 17.6336C277.258 17.6336 277.239 17.6527 277.239 17.6909C277.124 18.1107 276.779 18.3779 276.203 18.4542C276.165 18.4542 276.126 18.4542 276.107 18.4351C276.644 18.1679 277.047 17.4428 277.316 16.8702C277.834 15.7061 278.025 15.5916 279.061 15.7634C279.081 15.8397 279.1 15.897 279.119 15.9733C279.272 16.4886 279.426 17.042 279.426 17.729C279.426 18.4542 279.829 19.8282 280.212 20.3435L280.232 22.8435C280.232 22.8817 280.27 22.9198 280.308 22.9198C280.347 22.9198 280.385 22.8817 280.385 22.8435L280.366 20.3626C280.807 19.6947 281.133 18.5687 281.114 17.729C281.095 17.0229 281.248 16.584 281.44 16.0878C281.478 15.9924 281.517 15.8779 281.555 15.7825C282.668 15.6107 282.86 15.7252 283.378 16.8893ZM281.958 14.9428C281.996 14.8474 282.035 14.7138 282.073 14.5993C282.246 14.6565 282.418 14.6756 282.591 14.6756C283.051 14.6756 283.512 14.5229 283.723 14.3321C283.819 14.3893 283.915 14.4275 284.03 14.4466C283.704 14.7901 282.898 15.2672 281.958 14.9428ZM284.816 17.5382C284.49 17.4046 283.665 16.4313 283.531 14.9809C283.838 14.8283 284.068 14.6374 284.183 14.4848C284.509 14.5038 284.855 14.3512 285.104 14.0458C285.699 14.1031 286.294 14.0649 286.6 13.3588C287.617 13.2634 287.809 12.8817 287.962 12.0039C288.231 11.8703 288.423 11.6031 288.519 11.3168C288.615 10.9733 288.557 10.6107 288.365 10.2672C288.73 10 288.922 9.61837 288.902 9.25577C288.883 8.89318 288.672 8.58784 288.308 8.397C288.461 7.93898 288.384 7.53822 288.078 7.25196C287.79 6.98479 287.329 6.88937 286.965 7.02296C286.581 6.54586 286.044 6.46952 285.68 6.64128C285.315 6.81303 285.162 7.19471 285.258 7.69089C285.258 7.69089 285.258 7.69089 285.238 7.69089C284.989 7.69089 284.778 7.8054 284.605 7.99623C284.394 8.28249 284.337 8.68325 284.471 8.9886C284.586 9.25577 284.816 9.42753 285.123 9.48478C285.066 9.63745 284.97 9.67562 284.797 9.75195H284.778C284.452 9.84737 283.953 9.73287 283.646 9.31302C283.397 8.95043 282.975 7.9199 284.567 5.83975C285.411 4.73289 287.982 2.78633 290.111 2.76725C290.053 2.99625 289.766 3.75961 289.094 4.54205C289.094 4.54205 289.075 4.54205 289.075 4.56113C288.596 4.88556 288.231 5.1909 287.751 5.80159C287.751 5.53441 287.713 5.24815 287.656 4.94281C287.656 4.90464 287.617 4.88556 287.579 4.88556C286.044 4.94281 285.219 6.48861 285.104 6.90845C285.085 6.94662 285.123 6.98479 285.162 7.00387C285.2 7.02296 285.238 6.98479 285.258 6.94662C285.354 6.54586 286.121 5.13365 287.521 5.03823C287.636 5.62983 287.656 6.08784 287.425 6.64128C287.406 6.67945 287.425 6.71761 287.464 6.7367C287.502 6.75578 287.54 6.75578 287.56 6.71761C288.001 6.22143 288.576 6.04968 289.42 6.1451C289.497 6.92754 288.998 7.65272 288.519 8.0344C288.48 8.05349 288.48 8.11074 288.5 8.12982C288.519 8.16799 288.576 8.16799 288.596 8.14891C289.209 7.78631 289.977 7.72906 290.648 8.01532C290.456 8.95043 289.727 9.31302 288.979 9.54203C288.941 9.56111 288.922 9.59928 288.922 9.63745C288.922 9.67562 288.96 9.6947 288.998 9.6947C289.612 9.65653 290.591 10.1909 291.032 10.7061C290.917 10.897 290.725 11.0497 290.514 11.1642C290.495 11.1642 290.495 11.1642 290.495 11.1832C289.996 11.4313 289.286 11.4886 288.749 11.2596C288.711 11.2405 288.672 11.2596 288.653 11.2977C288.634 11.3359 288.653 11.3741 288.691 11.3932C289.324 11.6603 289.977 12.4809 290.13 13.1871C290.13 13.1871 290.13 13.2061 290.111 13.2061V13.2252C289.574 13.3397 288.634 13.5306 287.943 12.939C287.924 12.9199 287.905 12.9008 287.886 12.8817C287.847 12.8626 287.809 12.8626 287.771 12.8817C287.751 12.9199 287.751 12.958 287.771 12.9962C287.79 13.0153 287.809 13.0344 287.828 13.0344C288.289 13.4733 288.48 14.5038 288.442 15.3054C288.308 15.3244 288.154 15.3054 288.001 15.2672H287.982C287.387 15.1145 286.716 14.6183 286.409 14.0458C286.389 14.0077 286.351 13.9886 286.313 14.0077C286.274 14.0267 286.255 14.0649 286.274 14.1031C286.735 15.0573 286.255 15.8397 285.948 16.355C285.91 16.4122 285.891 16.4695 285.852 16.5267C285.68 16.4504 285.526 16.3741 285.373 16.2596C285.373 16.2405 285.354 16.2405 285.334 16.2405C284.72 15.7634 284.509 15 284.433 14.6565C284.433 14.6183 284.375 14.5802 284.337 14.5993C284.298 14.5993 284.26 14.6565 284.279 14.6947C284.356 15.0573 284.586 15.8397 285.219 16.355C285.123 16.7939 285.066 16.9847 284.97 17.271C284.97 17.271 284.97 17.271 284.97 17.2901L284.951 17.3092C284.931 17.3855 284.893 17.4618 284.816 17.5382ZM285.258 17.8435C285.219 17.6718 285.162 17.5 285.123 17.3664C285.219 17.0993 285.277 16.8893 285.373 16.5077C285.507 16.6031 285.641 16.6794 285.795 16.7367C285.91 17.3473 285.987 17.9008 286.044 18.3397C286.121 18.9504 286.198 19.4084 286.294 19.6947C285.66 19.3702 285.449 18.5305 285.258 17.8435ZM288.116 21.374C287.368 20.8397 286.389 19.1985 285.987 16.6794C286.025 16.6222 286.063 16.5649 286.102 16.4886C286.351 16.0687 286.754 15.4008 286.6 14.5993C286.965 15 287.464 15.3244 287.943 15.458C288.154 16.2786 288.289 17.2328 288.404 18.0153V18.0344C288.461 18.5115 288.461 20.6679 288.116 21.374ZM289.44 17.3855C290.188 18.7023 290.744 19.6183 291.147 19.8664C290.61 20.1336 289.9 19.6756 289.631 19.3893C289.325 19.0649 288.96 18.5878 288.538 17.958C288.442 17.2138 288.308 16.2977 288.097 15.4962C288.154 15.5153 288.231 15.5153 288.289 15.5153C288.385 15.6489 288.48 15.8015 288.576 15.9351C288.826 16.3168 289.113 16.8321 289.44 17.3855ZM293.833 14.9428C293.871 14.9428 293.909 14.9428 293.967 14.9428C293.833 15.1909 293.66 15.439 293.353 15.5344C292.854 15.687 292.068 15.4771 290.974 14.8474H290.955C290.667 14.4275 290.341 14.0077 289.977 13.5878C289.958 13.5496 289.9 13.5496 289.862 13.5878C289.823 13.6069 289.823 13.6642 289.862 13.7023C291.473 15.5725 292.26 17.3283 292.221 19.084C290.993 18.8931 289.325 16.8321 288.48 15.5344C288.5 15.5344 288.538 15.5344 288.557 15.5344C288.596 15.5344 288.615 15.4962 288.615 15.458C288.672 14.7901 288.557 13.9313 288.231 13.3588C288.922 13.7023 289.727 13.5306 290.188 13.4351L290.245 13.4161C290.264 13.4161 290.264 13.4161 290.264 13.397C290.725 13.5878 291.185 13.8359 291.646 14.084C292.471 14.5229 293.238 14.9428 293.833 14.9428ZM290.303 13.2252C290.188 12.6336 289.747 11.9848 289.229 11.5649C289.689 11.6222 290.188 11.5458 290.571 11.355C290.898 11.4123 291.281 11.5458 291.646 11.6794C291.742 11.7176 291.838 11.7558 291.933 11.7748C291.933 11.7748 291.933 11.7748 291.953 11.7748C293.046 12.2901 293.698 12.8245 294.082 13.5878C293.391 13.9886 292.144 13.8741 290.303 13.2252Z\" fill=#414241 /> <path d=\"M293.061 13.187C292.563 12.958 292.217 12.7862 291.91 12.6335C291.316 12.3473 290.894 12.1373 289.877 11.7747C289.839 11.7556 289.8 11.7747 289.781 11.8129C289.762 11.851 289.781 11.8892 289.819 11.9083C290.836 12.2709 291.258 12.4809 291.834 12.7671C292.141 12.9198 292.486 13.0916 293.004 13.3206C293.023 13.3206 293.023 13.3206 293.042 13.3206C293.081 13.3206 293.1 13.3015 293.119 13.2824C293.1 13.2443 293.1 13.2061 293.061 13.187Z\" fill=#414241 /> <path d=\"M289.243 5.91601C289.262 5.91601 289.262 5.93509 289.282 5.93509C289.301 5.93509 289.339 5.91601 289.339 5.89692C289.684 5.38165 290.337 4.7328 290.95 4.33204C290.989 4.31295 290.989 4.2557 290.97 4.21753C290.95 4.17936 290.893 4.17936 290.855 4.19845C290.222 4.6183 289.55 5.26715 289.205 5.8015C289.186 5.83967 289.205 5.89692 289.243 5.91601Z\" fill=#414241 /> <path d=\"M270.969 11.9083C271.008 11.8892 271.027 11.851 271.008 11.8129C270.988 11.7747 270.95 11.7556 270.912 11.7747C269.895 12.1373 269.473 12.3473 268.878 12.6335C268.571 12.7862 268.226 12.958 267.708 13.187C267.67 13.2061 267.65 13.2443 267.67 13.2824C267.689 13.3015 267.708 13.3206 267.746 13.3206C267.766 13.3206 267.766 13.3206 267.785 13.3206C268.283 13.0916 268.648 12.9198 268.955 12.7671C269.53 12.4618 269.952 12.2518 270.969 11.9083Z\" fill=#414241 /> <path d=\"M290.855 7.80523C290.874 7.82432 290.893 7.82432 290.912 7.82432C290.932 7.82432 290.951 7.82432 290.97 7.80523C291.469 7.3663 291.68 7.23271 292.294 6.90829C292.332 6.8892 292.351 6.83195 292.332 6.81287C292.313 6.7747 292.255 6.75561 292.236 6.7747C291.603 7.09913 291.392 7.23271 290.874 7.69073C290.817 7.70981 290.816 7.76707 290.855 7.80523Z\" fill=#414241 /> <path d=\"M290.279 9.77118C290.279 9.80935 290.317 9.84752 290.355 9.84752C291.506 9.71393 292.101 9.67576 293.348 9.80935C293.386 9.80935 293.425 9.79027 293.444 9.73302C293.444 9.69485 293.425 9.65668 293.367 9.6376C292.12 9.48492 291.487 9.52309 290.336 9.67576C290.298 9.69485 290.259 9.73302 290.279 9.77118Z\" fill=#414241 /> <path d=\"M279.212 2.67184H281.59C281.629 2.67184 281.667 2.63367 281.667 2.5955C281.667 2.55733 281.629 2.51917 281.59 2.51917H279.212C279.173 2.51917 279.135 2.55733 279.135 2.5955C279.135 2.63367 279.173 2.67184 279.212 2.67184Z\" fill=#414241 /> <path d=\"M278.855 4.00782C278.682 3.89329 278.471 3.83603 278.26 3.8742C278.222 3.8742 278.183 3.91238 278.202 3.96964C278.202 4.00782 278.241 4.046 278.298 4.02691C278.471 4.00782 278.644 4.046 278.778 4.14144C278.797 4.16052 278.816 4.16052 278.816 4.16052C278.835 4.16052 278.874 4.14144 278.874 4.12235C278.912 4.08417 278.893 4.046 278.855 4.00782Z\" fill=#414241 /> <path d=\"M281.041 24.1226C281.022 24.0844 280.965 24.0653 280.926 24.0844C280.888 24.1035 280.869 24.1417 280.888 24.1799C280.888 25.0768 280.85 26.1837 280.37 26.947C279.795 26.0692 279.795 24.5997 279.814 24.1608C279.814 24.1417 279.814 24.1417 279.814 24.1226C279.814 24.1035 279.795 24.0844 279.775 24.0653C279.737 24.0463 279.699 24.0653 279.66 24.1035C279.219 24.886 278.26 25.2867 277.627 25.1531C277.301 25.0768 277.109 24.886 277.07 24.5806C277.07 24.5424 277.032 24.5043 276.994 24.5043C276.955 24.5043 276.917 24.5424 276.917 24.5806C276.955 24.9432 277.205 25.2104 277.588 25.2867C277.684 25.3058 277.78 25.3058 277.876 25.3058C278.452 25.3058 279.181 24.9814 279.641 24.3707C279.641 24.7142 279.66 25.2676 279.775 25.802C279.756 25.802 279.737 25.8211 279.737 25.8402C279.104 27.1569 278.145 27.5768 277.473 27.386C277.051 27.2715 276.821 26.947 276.84 26.5463C276.84 26.5081 276.802 26.4699 276.764 26.4699C276.725 26.4699 276.687 26.5081 276.687 26.5463C276.648 27.0234 276.955 27.4241 277.435 27.5386C277.55 27.5577 277.665 27.5768 277.78 27.5768C278.452 27.5768 279.257 27.1188 279.833 25.9928C279.929 26.3745 280.063 26.7562 280.293 27.0424L280.312 28.7982C280.312 28.8363 280.351 28.8745 280.389 28.8745C280.428 28.8745 280.466 28.8363 280.466 28.7982L280.447 27.0424C280.639 26.7371 280.773 26.3936 280.869 26.0119C281.444 27.0806 282.288 27.5386 282.979 27.5386C283.113 27.5386 283.228 27.5195 283.343 27.5005C283.823 27.3669 284.111 26.9852 284.092 26.5272C284.092 26.489 284.053 26.4508 284.015 26.4508C283.977 26.4508 283.938 26.489 283.938 26.5272C283.957 26.9089 283.727 27.2333 283.305 27.3287C282.615 27.5005 281.579 27.0997 280.946 25.7638C281.041 25.2867 281.061 24.8096 281.061 24.3325C281.521 24.9241 282.269 25.2486 282.883 25.2486C282.979 25.2486 283.094 25.2295 283.19 25.2104C283.593 25.1341 283.842 24.8669 283.881 24.5043C283.881 24.4661 283.861 24.4279 283.804 24.4279C283.766 24.4279 283.727 24.447 283.727 24.5043C283.689 24.905 283.363 25.0386 283.171 25.0768C282.48 25.3058 281.483 24.9241 281.041 24.1226Z\" fill=#414241 /> <path d=\"M283.573 25.8588C283.554 25.8588 283.535 25.8397 283.516 25.8588C283.496 25.8588 283.496 25.8588 283.477 25.8588C283.381 25.8969 283.285 25.916 283.17 25.9351C283.113 25.9351 283.055 25.9351 282.998 25.9351C282.537 25.9351 282.019 25.7443 281.616 25.4198C281.597 25.4008 281.578 25.4008 281.559 25.4008C281.54 25.4008 281.52 25.4008 281.501 25.4198C281.482 25.4389 281.463 25.4771 281.463 25.4962C281.674 26.2786 282.134 26.813 282.671 26.9656C282.748 26.9847 282.825 27.0038 282.921 27.0038C282.94 27.0038 282.978 27.0038 282.998 27.0038C283.209 26.9847 283.4 26.8893 283.516 26.7366C283.669 26.5267 283.688 26.2405 283.592 25.916C283.611 25.8969 283.592 25.8779 283.573 25.8588ZM282.959 26.8511C282.537 26.8511 282.019 26.5076 281.731 25.7252C282.134 25.9733 282.671 26.145 283.17 26.0878C283.266 26.0878 283.362 26.0687 283.458 26.0305C283.516 26.2977 283.477 26.5267 283.343 26.6794C283.266 26.7748 283.132 26.813 282.998 26.8321C282.978 26.8511 282.978 26.8511 282.959 26.8511Z\" fill=#414241 /> <path d=\"M274.173 24.5229C274.193 24.561 274.212 24.5801 274.25 24.5801H274.269C274.308 24.561 274.327 24.5229 274.327 24.4847C274.25 24.2366 274.557 23.8931 275.056 23.3397C275.44 22.9198 275.9 22.3855 276.418 21.6794C276.399 21.6794 276.38 21.6603 276.36 21.6412C276.341 21.6221 276.322 21.5839 276.303 21.5458C275.785 22.271 275.305 22.8053 274.922 23.2252C274.384 23.8168 274.058 24.1794 274.173 24.5229Z\" fill=#414241 /> <path d=\"M280.389 16.1831C280.351 16.1831 280.312 16.2213 280.312 16.2594V18.7404C280.312 18.7785 280.351 18.8167 280.389 18.8167C280.428 18.8167 280.466 18.7785 280.466 18.7404V16.2594C280.466 16.2213 280.447 16.1831 280.389 16.1831Z\" fill=#414241 /> <path d=\"M272.055 13.8742C272.017 13.8551 271.979 13.8551 271.94 13.8933L269.466 17.6147C269.447 17.6529 269.447 17.691 269.485 17.7292C269.504 17.7292 269.504 17.7483 269.523 17.7483C269.542 17.7483 269.581 17.7292 269.581 17.7101L272.055 13.9887C272.113 13.9506 272.094 13.8933 272.055 13.8742Z\" fill=#414241 /> <path d=\"M269.869 7.82432C269.888 7.82432 269.907 7.82432 269.926 7.80523C269.945 7.76707 269.945 7.7289 269.926 7.69073C269.408 7.2518 269.197 7.11821 268.564 6.7747C268.526 6.75561 268.487 6.7747 268.449 6.81287C268.43 6.85103 268.449 6.8892 268.487 6.90829C269.101 7.23271 269.312 7.3663 269.811 7.80523C269.83 7.82432 269.849 7.82432 269.869 7.82432Z\" fill=#414241 /> <path d=\"M281.072 4.00778C281.11 4.00778 281.129 3.98869 281.148 3.95053C281.168 3.91236 281.148 3.87419 281.11 3.85511C280.611 3.68335 280.113 3.51159 279.71 3.41617C279.556 3.37801 279.384 3.33984 279.268 3.53068C279.249 3.56885 279.249 3.60701 279.288 3.64518C279.326 3.66427 279.364 3.66427 279.403 3.6261C279.441 3.54976 279.499 3.54976 279.671 3.58793C279.69 3.58793 279.69 3.58793 279.71 3.60701C279.633 3.81694 279.652 4.02686 279.767 4.17953C279.863 4.31312 280.017 4.38946 280.17 4.38946C280.189 4.38946 280.228 4.38946 280.247 4.38946C280.362 4.37037 280.592 4.27495 280.726 3.93144C280.822 3.96961 280.937 4.00778 281.053 4.04594C281.053 4.00778 281.072 4.00778 281.072 4.00778ZM280.228 4.19862C280.093 4.2177 279.959 4.16045 279.882 4.06503C279.786 3.95052 279.786 3.77877 279.844 3.6261C279.863 3.6261 279.901 3.64518 279.921 3.64518C279.844 3.75969 279.844 3.89327 279.921 4.00778C279.94 4.02686 279.959 4.04594 279.997 4.04594C280.017 4.04594 280.017 4.04594 280.036 4.02686C280.074 4.00778 280.093 3.95052 280.055 3.91236C280.036 3.85511 279.997 3.79785 280.055 3.70243C280.055 3.68335 280.055 3.68335 280.074 3.66427C280.228 3.72152 280.4 3.75969 280.573 3.81694C280.515 4.04594 280.381 4.17953 280.228 4.19862Z\" fill=#414241 /> <path d=\"M271.503 5.95413C271.522 5.95413 271.542 5.95413 271.542 5.93505C271.58 5.91596 271.58 5.85871 271.561 5.82054C271.215 5.28619 270.525 4.63734 269.911 4.21749C269.873 4.19841 269.834 4.19841 269.796 4.23658C269.777 4.27474 269.777 4.31291 269.815 4.35108C270.429 4.75184 271.081 5.4007 271.426 5.91596C271.446 5.93505 271.484 5.95413 271.503 5.95413Z\" fill=#414241 /> <path d=\"M287.732 4.79011C287.751 4.80919 287.77 4.80919 287.77 4.80919C287.789 4.80919 287.808 4.79011 287.828 4.77102C288.23 4.25576 288.518 4.06492 289.075 3.66415C289.19 3.58782 289.305 3.4924 289.439 3.39698C289.477 3.37789 289.477 3.32064 289.458 3.28247C289.439 3.24431 289.381 3.24431 289.343 3.26339C289.209 3.35881 289.094 3.45423 288.979 3.53057C288.403 3.93133 288.115 4.14125 287.693 4.65652C287.693 4.71377 287.713 4.75194 287.732 4.79011Z\" fill=#414241 /> <path d=\"M278.083 26.9656C278.64 26.8321 279.081 26.2787 279.292 25.4964C279.292 25.4582 279.292 25.4201 279.254 25.4201C279.234 25.401 279.196 25.401 279.158 25.4201C278.678 25.8017 277.93 26.0879 277.278 25.8589C277.239 25.8399 277.201 25.8589 277.182 25.8971C277.182 25.8971 277.182 25.9162 277.163 25.9162C277.047 26.2787 277.105 26.584 277.297 26.7939C277.431 26.9275 277.604 27.0038 277.815 27.0038C277.911 27.0038 277.987 27.0038 278.083 26.9656ZM277.431 26.6985C277.297 26.5459 277.239 26.3169 277.316 26.0498C277.911 26.2215 278.601 26.0307 279.081 25.7063C278.87 26.2978 278.486 26.7176 278.045 26.8321C277.796 26.8893 277.565 26.8321 277.431 26.6985Z\" fill=#414241 /> <path d=\"M271.771 3.53057C271.656 3.45423 271.541 3.35881 271.407 3.26339C271.369 3.24431 271.33 3.24431 271.292 3.28247C271.273 3.32064 271.273 3.35881 271.311 3.39698C271.445 3.4924 271.56 3.58782 271.676 3.66415C272.232 4.06492 272.52 4.25576 272.922 4.77102C272.942 4.79011 272.961 4.80919 272.98 4.80919C272.999 4.80919 273.018 4.80919 273.038 4.79011C273.076 4.77102 273.076 4.71377 273.057 4.6756C272.635 4.14125 272.347 3.95041 271.771 3.53057Z\" fill=#414241 /> <path d=\"M5.8879 13.855C6.25238 14.6184 6.61687 15.3436 7.00054 16.0497H7.0389C7.48012 15.2863 7.88298 14.4657 8.28583 13.6451L9.80132 10.5726C10.5303 9.10309 10.9907 8.22523 11.0291 7.48096C11.5854 7.53821 11.9115 7.53821 12.2376 7.53821C12.6405 7.53821 13.1776 7.51912 13.6764 7.48096C13.7723 7.53821 13.7723 7.82447 13.6956 7.88172L13.3503 7.91989C12.3335 8.01531 12.1993 8.32065 12.2184 9.44661C12.2568 11.1451 12.276 14.1222 12.3911 16.4313C12.4486 17.2329 12.4295 17.6718 13.1776 17.729L13.6956 17.7863C13.7915 17.8817 13.7723 18.1298 13.6572 18.1871C12.9858 18.1489 12.3335 18.1298 11.758 18.1298C11.2017 18.1298 10.4727 18.1489 9.80132 18.1871C9.68622 18.1107 9.66704 17.8817 9.76296 17.7863L10.2234 17.729C11.0099 17.6527 11.0099 17.3855 11.0099 16.355L10.9523 9.65653H10.914C10.7989 9.82828 10.185 11.126 9.85888 11.7558L8.42011 14.5611C7.69114 15.9733 6.96217 17.481 6.67442 18.2252C6.63605 18.2825 6.5785 18.2825 6.52095 18.2825C6.48258 18.2825 6.40585 18.2634 6.36748 18.2252C6.09891 17.3665 5.31239 15.8016 4.94791 15.0191L3.48996 11.9084C3.14466 11.1642 2.81854 10.3245 2.45406 9.59928H2.41569C2.35814 10.5916 2.30059 11.5268 2.26222 12.4619C2.20467 13.4352 2.14712 14.8665 2.14712 16.2405C2.14712 17.4237 2.24304 17.6909 2.87609 17.729L3.48996 17.7863C3.60506 17.8817 3.58588 18.1489 3.47078 18.1871C2.91446 18.1489 2.2814 18.1298 1.66753 18.1298C1.14958 18.1298 0.574075 18.1489 0.0177547 18.1871C-0.0781627 18.1107 -0.11653 17.8626 -0.0206123 17.7863L0.343874 17.729C1.0153 17.6336 1.2455 17.5382 1.34141 16.4123C1.43733 15.3436 1.51407 14.4657 1.60998 12.8817C1.68672 11.5458 1.76345 10.1718 1.78263 9.29393C1.821 8.28248 1.68672 8.03439 0.70836 7.91989L0.458974 7.88172C0.382241 7.7863 0.401424 7.53821 0.516525 7.48096C0.996112 7.51912 1.37978 7.53821 1.80182 7.53821C2.1663 7.53821 2.60752 7.53821 3.14466 7.48096C3.08711 8.11073 3.48996 9.10309 3.98873 10.1336L5.8879 13.855Z\" fill=#414241 /> <path d=\"M15.7689 13.5306C15.7689 12.9008 15.7689 12.8245 15.3277 12.5382L15.1742 12.4428C15.1167 12.3856 15.1167 12.1947 15.1934 12.1566C15.5579 12.023 16.4787 11.6031 16.8624 11.3741C16.9391 11.3741 17.0158 11.4123 17.0158 11.4695C16.9775 12.023 16.9583 12.8054 16.9583 13.4542V16.355C16.9583 17.5191 16.9966 17.6718 17.5721 17.7481L17.9175 17.8053C18.0326 17.8817 17.9942 18.1679 17.8791 18.2061C17.3995 18.1679 16.9199 18.1488 16.3636 18.1488C15.7881 18.1488 15.2893 18.1679 14.8481 18.2061C14.733 18.1488 14.6946 17.8817 14.8097 17.8053L15.155 17.7481C15.7497 17.6718 15.7689 17.5 15.7689 16.355V13.5306ZM17.1117 8.95048C17.1117 9.523 16.7089 9.79017 16.2485 9.79017C15.7497 9.79017 15.4236 9.42758 15.4236 8.98865C15.4236 8.45431 15.8073 8.12988 16.2869 8.12988C16.7664 8.12988 17.1117 8.49247 17.1117 8.95048Z\" fill=#414241 /> <path d=\"M19.778 13.5305C19.778 12.9007 19.778 12.8244 19.3368 12.5381L19.1833 12.4427C19.1257 12.3855 19.1257 12.1946 19.2025 12.1565C19.567 12.0229 20.4878 11.603 20.8139 11.374C20.8714 11.374 20.9674 11.4122 20.9865 11.4885C20.9482 11.8511 20.9482 12.0992 20.9482 12.2519C20.9482 12.3473 21.0057 12.4236 21.1208 12.4236C21.7922 12.0038 22.5596 11.603 23.3845 11.603C24.7273 11.603 25.2836 12.5191 25.2836 13.5878V16.3549C25.2836 17.5191 25.322 17.6717 25.8975 17.7481L26.262 17.8053C26.3771 17.8817 26.3387 18.1679 26.2236 18.2061C25.744 18.1679 25.2645 18.1488 24.7081 18.1488C24.1326 18.1488 23.6339 18.1679 23.2118 18.2061C23.0967 18.1488 23.0584 17.8817 23.1735 17.8053L23.4804 17.7481C24.0751 17.6526 24.0943 17.5 24.0943 16.3549V13.9504C24.0943 13.0343 23.6722 12.3664 22.5788 12.3664C21.9649 12.3664 21.4278 12.6145 21.1976 12.9198C20.9865 13.187 20.9482 13.416 20.9482 13.8931V16.3549C20.9482 17.5191 20.9865 17.6526 21.562 17.7481L21.8498 17.8053C21.9649 17.8817 21.9265 18.1679 21.8114 18.2061C21.3702 18.1679 20.9098 18.1488 20.3343 18.1488C19.7588 18.1488 19.26 18.1679 18.8188 18.2061C18.7037 18.1488 18.6653 17.8817 18.7804 17.8053L19.1257 17.7481C19.7204 17.6717 19.7396 17.5 19.7396 16.3549V13.5305H19.778Z\" fill=#414241 /> <path d=\"M28.142 13.5306C28.142 12.9008 28.142 12.8245 27.7007 12.5382L27.5473 12.4428C27.4897 12.3856 27.4897 12.1947 27.5664 12.1566C27.9309 12.023 28.8517 11.6031 29.2354 11.3741C29.3121 11.3741 29.3889 11.4123 29.3889 11.4695C29.3505 12.023 29.3313 12.8054 29.3313 13.4542V16.355C29.3313 17.5191 29.3697 17.6718 29.9452 17.7481L30.2905 17.8053C30.4056 17.8817 30.3672 18.1679 30.2521 18.2061C29.7726 18.1679 29.293 18.1488 28.7366 18.1488C28.1611 18.1488 27.6624 18.1679 27.2211 18.2061C27.106 18.1488 27.0677 17.8817 27.1828 17.8053L27.5281 17.7481C28.1228 17.6718 28.142 17.5 28.142 16.355V13.5306ZM29.4848 8.95048C29.4848 9.523 29.0819 9.79017 28.6215 9.79017C28.1228 9.79017 27.7967 9.42758 27.7967 8.98865C27.7967 8.45431 28.1803 8.12988 28.6599 8.12988C29.1395 8.12988 29.4848 8.49247 29.4848 8.95048Z\" fill=#414241 /> <path d=\"M34.9704 11.8704C35.1239 12.233 35.2198 12.7292 35.2198 13.1681C35.1623 13.2826 34.9129 13.3208 34.8361 13.2254C34.5676 12.5192 34.0688 12.0612 33.4166 12.0612C32.7835 12.0612 32.3807 12.462 32.3807 13.0345C32.3807 13.7025 33.0521 14.046 33.6276 14.3704C34.4908 14.8475 35.2774 15.401 35.2774 16.546C35.2774 17.7674 34.1455 18.3781 32.9562 18.3781C32.1888 18.3781 31.6325 18.2254 31.2297 17.901C31.0954 17.5957 30.9995 16.8132 31.0378 16.2788C31.1146 16.1834 31.3256 16.1643 31.4023 16.2598C31.6709 17.1376 32.1888 17.9201 33.1096 17.9201C33.6851 17.9201 34.1839 17.5766 34.1839 16.8895C34.1839 16.1453 33.5317 15.7445 32.937 15.401C31.997 14.8666 31.3448 14.3132 31.3448 13.4162C31.3448 12.2521 32.3231 11.5841 33.5509 11.5841C34.2223 11.5841 34.8361 11.7368 34.9704 11.8704Z\" fill=#414241 /> <path d=\"M38.4014 12.4809C38.1329 12.4809 38.1137 12.5382 38.1137 12.8626V15.8779C38.1137 16.813 38.2288 17.6717 39.2838 17.6717C39.4372 17.6717 39.5907 17.6336 39.725 17.5954C39.8784 17.5382 40.0894 17.3664 40.1278 17.3664C40.262 17.3664 40.3196 17.5382 40.2812 17.6336C39.9935 17.9771 39.418 18.3779 38.5933 18.3779C37.2122 18.3779 36.9053 17.6145 36.9053 16.6412V12.9389C36.9053 12.5 36.8861 12.4809 36.56 12.4809H36.0997C36.0038 12.4237 35.9846 12.2328 36.0421 12.1374C36.5025 11.9847 36.9053 11.7748 37.0779 11.6412C37.2889 11.4504 37.5958 11.0114 37.7493 10.687C37.826 10.6488 38.0178 10.6488 38.0945 10.7633V11.4885C38.0945 11.7748 38.1137 11.7939 38.3823 11.7939H40.1853C40.3771 11.9466 40.3388 12.3664 40.2045 12.4618H38.4014V12.4809Z\" fill=#414241 /> <path d=\"M42.1854 14.0269C41.7634 14.0269 41.7442 14.0651 41.7442 14.4658C41.7442 16.088 42.7034 17.4812 44.4299 17.4812C44.967 17.4812 45.4082 17.3285 45.9262 16.6987C46.0797 16.6414 46.1948 16.756 46.2139 16.8895C45.6768 17.9773 44.5258 18.3781 43.6817 18.3781C42.6266 18.3781 41.8017 17.9201 41.3413 17.3094C40.8618 16.6796 40.6699 15.9353 40.6699 15.2101C40.6699 13.2254 41.9744 11.5841 43.9119 11.5841C45.2931 11.5841 46.2139 12.5383 46.2139 13.4925C46.2139 13.7215 46.1756 13.8551 46.1564 13.9124C46.0988 14.0078 45.8878 14.0269 45.1972 14.0269H42.1854ZM43.183 13.5498C44.3723 13.5498 44.7368 13.4925 44.8711 13.3971C44.9286 13.3589 44.967 13.3017 44.967 13.0918C44.967 12.6337 44.6601 12.0803 43.7201 12.0803C42.7609 12.0803 41.936 12.9391 41.9168 13.4735C41.9168 13.5116 41.9168 13.5498 42.0319 13.5498H43.183Z\" fill=#414241 /> <path d=\"M47.6892 13.5305C47.6892 12.9007 47.6892 12.8244 47.248 12.5381L47.0945 12.4427C47.0369 12.3855 47.0369 12.1946 47.1137 12.1565C47.4782 12.0229 48.3414 11.603 48.7443 11.374C48.821 11.3931 48.8786 11.4313 48.8786 11.4885V12.4046C48.8786 12.4809 48.8977 12.5381 48.9361 12.5572C49.4924 12.0992 50.1255 11.5839 50.7202 11.5839C51.123 11.5839 51.4491 11.832 51.4491 12.2328C51.4491 12.7672 51.0079 12.9771 50.7585 12.9771C50.6051 12.9771 50.5091 12.9198 50.394 12.8626C50.1447 12.7099 49.9145 12.6145 49.6843 12.6145C49.4349 12.6145 49.2239 12.7672 49.1088 12.9389C48.9553 13.1679 48.8977 13.6259 48.8977 14.1794V16.374C48.8977 17.5381 48.9361 17.729 49.55 17.7672L50.1255 17.8244C50.2406 17.9007 50.2022 18.187 50.0871 18.2252C49.3198 18.187 48.8594 18.1679 48.2839 18.1679C47.7084 18.1679 47.2096 18.187 46.7876 18.2252C46.6725 18.1679 46.6341 17.9007 46.7492 17.8244L47.0561 17.7672C47.6508 17.6717 47.67 17.5191 47.67 16.374V13.5305H47.6892Z\" fill=#414241 /> <path d=\"M55.7083 11.8704C55.8617 12.233 55.9576 12.7292 55.9576 13.1681C55.9001 13.2826 55.6507 13.3208 55.574 13.2254C55.3055 12.5192 54.8067 12.0612 54.1546 12.0612C53.5216 12.0612 53.1188 12.462 53.1188 13.0345C53.1188 13.7025 53.7901 14.046 54.3656 14.3704C55.2287 14.8475 56.0152 15.401 56.0152 16.546C56.0152 17.7674 54.8835 18.3781 53.6942 18.3781C52.927 18.3781 52.3707 18.2254 51.9679 17.901C51.8336 17.5957 51.7377 16.8132 51.7761 16.2788C51.8528 16.1834 52.0638 16.1643 52.1405 16.2598C52.4091 17.1376 52.927 17.9201 53.8477 17.9201C54.4231 17.9201 54.9218 17.5766 54.9218 16.8895C54.9218 16.1453 54.2697 15.7445 53.675 15.401C52.7352 14.8666 52.083 14.3132 52.083 13.4162C52.083 12.2521 53.0612 11.5841 54.2889 11.5841C54.9602 11.5841 55.5548 11.7368 55.7083 11.8704Z\" fill=#414241 /> <path d=\"M59.1439 12.4809C58.8753 12.4809 58.8561 12.5382 58.8561 12.8626V15.8779C58.8561 16.813 58.9712 17.6717 60.0263 17.6717C60.1798 17.6717 60.3333 17.6336 60.4676 17.5954C60.621 17.5382 60.832 17.3664 60.8704 17.3664C61.0047 17.3664 61.0622 17.5382 61.0239 17.6336C60.7361 17.9771 60.1606 18.3779 59.3357 18.3779C57.9545 18.3779 57.6476 17.6145 57.6476 16.6412V12.9389C57.6476 12.5 57.6284 12.4809 57.3023 12.4809H56.8419C56.746 12.4237 56.7268 12.2328 56.7843 12.1374C57.2447 11.9847 57.6476 11.7748 57.8202 11.6412C58.0312 11.4504 58.3382 11.0114 58.4917 10.687C58.5684 10.6488 58.7602 10.6488 58.837 10.7633V11.4885C58.837 11.7748 58.8561 11.7939 59.1247 11.7939H60.928C61.1198 11.9466 61.0814 12.3664 60.9471 12.4618H59.1439V12.4809Z\" fill=#414241 /> <path d=\"M62.7273 13.3589C62.3628 12.462 62.171 12.2902 61.7489 12.1948L61.4996 12.1375C61.4228 12.0612 61.4036 11.8131 61.5571 11.7559C62.0559 11.794 62.5163 11.8131 62.9959 11.8131C63.4946 11.8131 63.9742 11.794 64.3963 11.7559C64.5306 11.8131 64.5497 12.0612 64.4346 12.1375L64.0701 12.2139C63.8399 12.2521 63.7057 12.3475 63.7057 12.4429C63.7057 12.5383 63.7824 12.8437 63.955 13.2826L64.9526 15.7445C65.1061 16.1071 65.2403 16.4124 65.2403 16.4315C65.2979 16.3933 65.413 16.1262 65.6048 15.6681L66.3913 13.7215C66.6024 13.2063 66.6215 12.9963 66.5448 12.7864C66.3913 12.4238 66.1611 12.3093 65.7967 12.233L65.5473 12.1757C65.4322 12.0803 65.4705 11.8322 65.6048 11.794C66.0077 11.8322 66.5256 11.8513 66.9477 11.8513C67.4464 11.8513 67.926 11.8322 68.4823 11.794C68.6358 11.8513 68.6358 12.0994 68.5399 12.1757L68.1946 12.233C67.5424 12.3666 67.5807 12.4047 67.7726 12.9773C67.9452 13.5116 68.8276 15.5536 69.0003 15.9926C69.0962 16.2407 69.1538 16.4124 69.2113 16.4506C69.2497 16.4124 69.3264 16.2598 69.4415 15.9926C69.6525 15.5346 70.3048 13.817 70.535 13.149C70.6693 12.7864 70.6884 12.5765 70.6884 12.462C70.6884 12.3666 70.5925 12.2902 70.4007 12.2521L69.9978 12.1948C69.8636 12.1185 69.9019 11.8513 70.017 11.8131C70.4774 11.8513 70.8803 11.8704 71.3023 11.8704C71.6093 11.8704 71.9929 11.8513 72.3574 11.8131C72.4917 11.8704 72.5109 12.1185 72.415 12.1948L72.0888 12.2521C71.7052 12.3284 71.5517 12.5574 71.2256 13.2635C70.7844 14.1605 70.017 16.088 69.7101 16.9086C69.4799 17.4812 69.2881 17.9583 69.1538 18.3781C69.0962 18.4354 69.0195 18.4354 68.9427 18.4354C68.8852 18.4354 68.8085 18.4163 68.7701 18.3781C68.6742 18.0919 68.3864 17.2521 68.0987 16.6033L67.3313 14.7521C67.2162 14.4658 66.9669 13.9315 66.9669 13.9315C66.9669 13.9315 66.7175 14.4277 66.6024 14.7139L65.7583 16.7178C65.4705 17.4048 65.2403 17.9964 65.1061 18.359C65.0485 18.4163 64.991 18.4163 64.9142 18.4163C64.8567 18.4163 64.7608 18.3972 64.7224 18.359C64.6265 18.0155 64.3579 17.3666 64.2428 17.0231L62.7273 13.3589Z\" fill=#414241 /> <path d=\"M79.0557 14.9046C79.0557 16.9085 77.6745 18.3588 75.641 18.3588C73.7802 18.3588 72.3223 17.0611 72.3223 15.0382C72.3223 13.0153 73.8569 11.5649 75.7561 11.5649C77.5785 11.584 79.0557 12.939 79.0557 14.9046ZM75.5835 12.0611C74.5092 12.0611 73.7227 13.0726 73.7227 14.8474C73.7227 16.3169 74.3941 17.8817 75.8137 17.8817C77.2332 17.8817 77.6745 16.3932 77.6745 15.1718C77.6553 13.7978 77.1181 12.0611 75.5835 12.0611Z\" fill=#414241 /> <path d=\"M85.7301 9.96187C85.7301 8.43516 85.6725 8.16798 85.0203 8.07256L84.5023 8.01531C84.3872 7.93897 84.3872 7.6718 84.5215 7.61454C85.4232 7.53821 86.5358 7.48096 88.128 7.48096C89.1256 7.48096 90.0847 7.55729 90.8329 7.95806C91.6002 8.35882 92.1757 9.08401 92.1757 10.21C92.1757 11.7367 90.9672 12.5764 90.1615 12.9008C90.0847 12.9962 90.1615 13.1489 90.2382 13.2825C91.5235 15.3626 92.3868 16.6413 93.4802 17.5573C93.7488 17.8054 94.1517 17.9771 94.5929 18.0153C94.6696 18.0535 94.6888 18.168 94.6121 18.2443C94.4586 18.3016 94.2092 18.3207 93.9023 18.3207C92.5211 18.3207 91.6962 17.9199 90.5643 16.2977C90.1423 15.7061 89.4901 14.5993 88.9721 13.8741C88.7227 13.5115 88.4733 13.3588 87.8211 13.3588C87.0921 13.3588 87.0537 13.3779 87.0537 13.7214V15.7443C87.0537 17.4237 87.0921 17.6336 88.0321 17.7481L88.3774 17.8054C88.4733 17.8817 88.435 18.168 88.339 18.2061C87.6101 18.168 87.0538 18.1489 86.4207 18.1489C85.7493 18.1489 85.1546 18.168 84.4064 18.2061C84.3105 18.1489 84.2721 17.9199 84.3681 17.8054L84.7709 17.7481C85.7109 17.6336 85.7493 17.4237 85.7493 15.7443V9.96187H85.7301ZM87.0537 12.2519C87.0537 12.5382 87.0538 12.71 87.1113 12.7863C87.1689 12.8436 87.3991 12.8626 88.2239 12.8626C88.7994 12.8626 89.4133 12.8054 89.8929 12.4428C90.3341 12.0993 90.6986 11.5458 90.6986 10.4581C90.6986 9.17943 89.9121 7.97714 88.1088 7.97714C87.1113 7.97714 87.0537 8.03439 87.0537 8.49241V12.2519Z\" fill=#414241 /> <path d=\"M101.116 14.9046C101.116 16.9085 99.735 18.3588 97.7015 18.3588C95.8408 18.3588 94.3828 17.0611 94.3828 15.0382C94.3828 13.0153 95.9175 11.5649 97.8167 11.5649C99.6583 11.584 101.116 12.939 101.116 14.9046ZM97.644 12.0611C96.5697 12.0611 95.7832 13.0726 95.7832 14.8474C95.7832 16.3169 96.4546 17.8817 97.8742 17.8817C99.2938 17.8817 99.735 16.3932 99.735 15.1718C99.735 13.7978 99.1787 12.0611 97.644 12.0611Z\" fill=#414241 /> <path d=\"M108.288 15.7827C108.288 17.0613 108.307 17.6529 108.749 17.6529C108.921 17.6529 109.209 17.5766 109.439 17.5002C109.554 17.5384 109.574 17.9392 109.42 18.0155C108.749 18.1109 107.732 18.359 107.291 18.5308C107.195 18.5308 107.118 18.4735 107.118 18.3972V18.13C107.118 17.8819 107.118 17.6911 107.08 17.6338H107.022C106.312 18.1109 105.756 18.3781 104.989 18.3781C103.185 18.3781 101.996 16.985 101.996 15.2865C101.996 13.0346 103.703 11.5842 105.91 11.5842C106.466 11.5842 106.811 11.6605 106.984 11.7368C107.061 11.7368 107.08 11.6414 107.08 11.5078V9.06505C107.08 8.11084 107.061 8.01542 106.581 7.72915L106.427 7.63373C106.351 7.57648 106.351 7.36656 106.427 7.3093C106.83 7.17571 107.598 6.9467 108.173 6.64136C108.231 6.64136 108.307 6.67953 108.327 6.73678C108.307 7.21388 108.269 8.01542 108.269 8.72153V15.7827H108.288ZM107.08 13.3781C107.08 13.0536 107.022 12.92 106.907 12.7483C106.658 12.4048 106.178 12.0803 105.545 12.0803C104.068 12.0803 103.32 13.359 103.32 14.7521C103.32 16.2216 104.145 17.5957 105.737 17.5957C106.178 17.5957 106.715 17.4048 106.984 17.1376C107.08 17.0422 107.099 16.7941 107.099 16.546V13.3781H107.08Z\" fill=#414241 /> <path d=\"M111.916 18.1298C111.053 18.1298 110.42 18.1489 110.228 18.1871C110.17 18.1489 110.132 18.0917 110.132 18.0344C110.458 17.6528 111.206 16.5077 111.686 15.668L113.393 12.7673C113.642 12.3092 113.546 12.2902 113.239 12.2902H112.127C111.647 12.2902 111.264 12.3474 111.014 12.5382C110.746 12.7482 110.573 13.1108 110.439 13.4734C110.362 13.5688 110.113 13.5306 110.074 13.4161C110.113 12.9963 110.381 11.9276 110.611 11.5268C110.669 11.4886 110.765 11.4886 110.803 11.5268C110.861 11.794 111.033 11.8131 111.954 11.8131H114.256C114.697 11.8131 115.004 11.8131 115.235 11.7558C115.292 11.794 115.33 11.8321 115.311 11.9085C114.966 12.3665 114.582 12.9772 114.122 13.7405L112.165 17.0039C111.82 17.5764 111.858 17.6528 112.472 17.6528H113.028C113.662 17.6528 114.486 17.6528 114.928 17.1757C115.1 16.9848 115.273 16.6413 115.446 16.2405C115.561 16.1833 115.753 16.2024 115.81 16.336C115.657 17.1184 115.426 17.8818 115.215 18.1871C114.678 18.1489 114.141 18.1298 113.412 18.1298H111.916Z\" fill=#414241 /> <path d=\"M117.251 13.5306C117.251 12.9008 117.251 12.8245 116.81 12.5382L116.657 12.4428C116.599 12.3856 116.599 12.1947 116.676 12.1566C117.04 12.023 117.961 11.6031 118.345 11.3741C118.422 11.3741 118.498 11.4123 118.498 11.4695C118.46 12.023 118.441 12.8054 118.441 13.4542V16.355C118.441 17.5191 118.479 17.6718 119.055 17.7481L119.4 17.8053C119.515 17.8817 119.477 18.1679 119.362 18.2061C118.882 18.1679 118.402 18.1488 117.846 18.1488C117.271 18.1488 116.772 18.1679 116.331 18.2061C116.215 18.1488 116.177 17.8817 116.292 17.8053L116.637 17.7481C117.232 17.6718 117.251 17.5 117.251 16.355V13.5306ZM118.594 8.95048C118.594 9.523 118.191 9.79017 117.731 9.79017C117.232 9.79017 116.906 9.42758 116.906 8.98865C116.906 8.45431 117.29 8.12988 117.769 8.12988C118.249 8.12988 118.594 8.49247 118.594 8.95048Z\" fill=#414241 /> <path d=\"M121.258 13.5305C121.258 12.9007 121.258 12.8244 120.817 12.5381L120.664 12.4427C120.606 12.3855 120.606 12.1946 120.683 12.1565C121.047 12.0229 121.968 11.603 122.294 11.374C122.352 11.374 122.448 11.4122 122.467 11.4885C122.429 11.8511 122.429 12.0992 122.429 12.2519C122.429 12.3473 122.486 12.4236 122.601 12.4236C123.273 12.0038 124.04 11.603 124.865 11.603C126.208 11.603 126.764 12.5191 126.764 13.5878V16.3549C126.764 17.5191 126.802 17.6717 127.378 17.7481L127.742 17.8053C127.858 17.8817 127.819 18.1679 127.704 18.2061C127.224 18.1679 126.745 18.1488 126.189 18.1488C125.613 18.1488 125.114 18.1679 124.692 18.2061C124.577 18.1488 124.539 17.8817 124.654 17.8053L124.961 17.7481C125.556 17.6526 125.575 17.5 125.575 16.3549V13.9504C125.575 13.0343 125.153 12.3664 124.059 12.3664C123.445 12.3664 122.908 12.6145 122.678 12.9198C122.467 13.187 122.429 13.416 122.429 13.8931V16.3549C122.429 17.5191 122.467 17.6526 123.043 17.7481L123.33 17.8053C123.445 17.8817 123.407 18.1679 123.292 18.2061C122.851 18.1679 122.39 18.1488 121.815 18.1488C121.239 18.1488 120.74 18.1679 120.299 18.2061C120.184 18.1488 120.146 17.8817 120.261 17.8053L120.606 17.7481C121.201 17.6717 121.22 17.5 121.22 16.3549V13.5305H121.258Z\" fill=#414241 /> <path d=\"M127.99 21.4506C127.99 21.0117 128.278 20.8018 128.642 20.8018H128.949C129.198 20.8018 129.371 20.6873 129.486 20.5155C129.947 19.7903 130.273 19.1224 130.426 18.7216C130.484 18.588 130.58 18.2636 130.58 18.0346C130.58 17.7101 130.522 17.5193 130.311 16.9277L129.045 13.4925C128.776 12.7292 128.661 12.3475 128.086 12.233L127.683 12.1566C127.587 12.0803 127.606 11.794 127.741 11.7559C128.259 11.794 128.738 11.8131 129.275 11.8131C129.716 11.8131 130.158 11.794 130.676 11.7559C130.81 11.8131 130.829 12.0803 130.714 12.1566L130.311 12.233C130.081 12.2902 129.947 12.3284 129.947 12.4429C129.947 12.6337 130.311 13.6834 130.407 13.9505L130.925 15.4391C131.021 15.6872 131.328 16.546 131.385 16.5842C131.443 16.546 131.692 16.0498 131.98 15.4009L132.536 14.1223C132.901 13.2826 133.093 12.691 133.093 12.5192C133.093 12.4047 132.997 12.2902 132.709 12.252L132.21 12.1757C132.095 12.0994 132.114 11.8131 132.249 11.7749C132.767 11.8131 133.246 11.8322 133.668 11.8322C134.071 11.8322 134.436 11.8131 134.896 11.7749C135.03 11.8322 135.049 12.0803 134.934 12.1757L134.666 12.2139C134.129 12.3093 133.841 12.7673 133.285 13.9124L132.383 15.7635C131.846 16.8323 130.522 19.6376 129.736 21.3934C129.467 22.0041 129.064 22.1567 128.7 22.1567C128.22 22.1377 127.99 21.8514 127.99 21.4506Z\" fill=#414241 /> <path d=\"M140.306 13.5306C140.306 12.9008 140.306 12.8245 139.865 12.5382L139.711 12.4428C139.654 12.3856 139.654 12.1947 139.731 12.1566C140.095 12.023 141.016 11.6031 141.399 11.3741C141.476 11.3741 141.553 11.4123 141.553 11.4695C141.515 12.023 141.495 12.8054 141.495 13.4542V16.355C141.495 17.5191 141.534 17.6718 142.109 17.7481L142.455 17.8053C142.57 17.8817 142.531 18.1679 142.416 18.2061C141.937 18.1679 141.457 18.1488 140.901 18.1488C140.325 18.1488 139.826 18.1679 139.385 18.2061C139.27 18.1488 139.232 17.8817 139.347 17.8053L139.692 17.7481C140.287 17.6718 140.306 17.5 140.306 16.355V13.5306ZM141.649 8.95048C141.649 9.523 141.246 9.79017 140.786 9.79017C140.287 9.79017 139.961 9.42758 139.961 8.98865C139.961 8.45431 140.344 8.12988 140.824 8.12988C141.304 8.12988 141.649 8.49247 141.649 8.95048Z\" fill=#414241 /> <path d=\"M150.299 15.7252C150.299 17.4046 150.338 17.6145 151.374 17.729L151.815 17.7863C151.911 17.8626 151.873 18.1489 151.777 18.1871C150.856 18.1489 150.319 18.1298 149.666 18.1298C148.995 18.1298 148.4 18.1489 147.69 18.1871C147.594 18.1298 147.555 17.8817 147.651 17.7863L147.997 17.729C148.937 17.5955 148.975 17.4046 148.975 15.7252V9.79012C148.975 8.41607 148.937 8.1489 148.208 8.07256L147.632 8.01531C147.517 7.91989 147.536 7.6718 147.671 7.61454C148.534 7.50004 149.532 7.48096 150.875 7.48096C152.218 7.48096 153.216 7.65271 153.984 8.12981C154.732 8.58783 155.269 9.42752 155.269 10.5344C155.269 12.0229 154.348 12.7481 153.657 13.0916C152.947 13.4352 152.084 13.5687 151.432 13.5687C151.316 13.5115 151.316 13.2825 151.412 13.2443C153.158 12.9199 153.792 11.9466 153.792 10.5344C153.792 8.96951 152.871 7.95806 151.182 7.95806C150.319 7.95806 150.319 8.01531 150.319 8.53058V15.7252H150.299Z\" fill=#414241 /> <path d=\"M162.06 14.9046C162.06 16.9085 160.678 18.3588 158.645 18.3588C156.784 18.3588 155.326 17.0611 155.326 15.0382C155.326 13.0153 156.861 11.5649 158.76 11.5649C160.602 11.584 162.06 12.939 162.06 14.9046ZM158.587 12.0611C157.513 12.0611 156.727 13.0726 156.727 14.8474C156.727 16.3169 157.398 17.8817 158.818 17.8817C160.237 17.8817 160.678 16.3932 160.678 15.1718C160.678 13.7978 160.122 12.0611 158.587 12.0611Z\" fill=#414241 /> <path d=\"M164.711 16.3361C164.711 17.5002 164.75 17.6529 165.325 17.7293L165.709 17.7865C165.824 17.8628 165.785 18.1491 165.67 18.1873C165.133 18.1491 164.673 18.13 164.097 18.13C163.522 18.13 163.023 18.1491 162.543 18.1873C162.428 18.13 162.39 17.8628 162.505 17.7865L162.87 17.7293C163.464 17.6529 163.483 17.4812 163.483 16.3361V9.06505C163.483 8.11084 163.464 8.01542 162.985 7.72916L162.87 7.63373C162.793 7.57648 162.793 7.36656 162.87 7.3093C163.272 7.17571 164.04 6.9467 164.615 6.64136C164.673 6.64136 164.75 6.67953 164.769 6.73678C164.75 7.21388 164.711 8.01542 164.711 8.72153V16.3361Z\" fill=#414241 /> <path d=\"M167.548 13.5306C167.548 12.9008 167.548 12.8245 167.107 12.5382L166.954 12.4428C166.896 12.3856 166.896 12.1947 166.973 12.1566C167.337 12.023 168.258 11.6031 168.642 11.3741C168.718 11.3741 168.795 11.4123 168.795 11.4695C168.757 12.023 168.738 12.8054 168.738 13.4542V16.355C168.738 17.5191 168.776 17.6718 169.351 17.7481L169.697 17.8053C169.812 17.8817 169.774 18.1679 169.658 18.2061C169.179 18.1679 168.699 18.1488 168.143 18.1488C167.567 18.1488 167.069 18.1679 166.627 18.2061C166.512 18.1488 166.474 17.8817 166.589 17.8053L166.934 17.7481C167.529 17.6718 167.548 17.5 167.548 16.355V13.5306ZM168.891 8.95048C168.891 9.523 168.488 9.79017 168.028 9.79017C167.529 9.79017 167.203 9.42758 167.203 8.98865C167.203 8.45431 167.587 8.12988 168.066 8.12988C168.546 8.12988 168.891 8.49247 168.891 8.95048Z\" fill=#414241 /> <path d=\"M172.343 12.4809C172.075 12.4809 172.055 12.5382 172.055 12.8626V15.8779C172.055 16.813 172.17 17.6717 173.226 17.6717C173.379 17.6717 173.533 17.6336 173.667 17.5954C173.82 17.5382 174.031 17.3664 174.07 17.3664C174.204 17.3664 174.262 17.5382 174.223 17.6336C173.935 17.9771 173.36 18.3779 172.535 18.3779C171.154 18.3779 170.847 17.6145 170.847 16.6412V12.9389C170.847 12.5 170.828 12.4809 170.502 12.4809H170.041C169.945 12.4237 169.926 12.2328 169.984 12.1374C170.444 11.9847 170.847 11.7748 171.019 11.6412C171.23 11.4504 171.537 11.0114 171.691 10.687C171.768 10.6488 171.959 10.6488 172.036 10.7633V11.4885C172.036 11.7748 172.055 11.7939 172.324 11.7939H174.127C174.319 11.9466 174.281 12.3664 174.146 12.4618H172.343V12.4809Z\" fill=#414241 /> <path d=\"M175.066 21.4506C175.066 21.0117 175.354 20.8018 175.718 20.8018H176.025C176.275 20.8018 176.447 20.6873 176.562 20.5155C177.023 19.7903 177.349 19.1224 177.502 18.7216C177.56 18.588 177.656 18.2636 177.656 18.0346C177.656 17.7101 177.598 17.5193 177.387 16.9277L176.121 13.4925C175.853 12.7292 175.738 12.3475 175.162 12.233L174.759 12.1566C174.663 12.0803 174.682 11.794 174.817 11.7559C175.335 11.794 175.814 11.8131 176.351 11.8131C176.793 11.8131 177.234 11.794 177.752 11.7559C177.886 11.8131 177.905 12.0803 177.79 12.1566L177.387 12.233C177.157 12.2902 177.023 12.3284 177.023 12.4429C177.023 12.6337 177.387 13.6834 177.483 13.9505L178.001 15.4391C178.097 15.6872 178.404 16.546 178.462 16.5842C178.519 16.546 178.769 16.0498 179.056 15.4009L179.613 14.1223C179.977 13.2826 180.169 12.691 180.169 12.5192C180.169 12.4047 180.073 12.2902 179.785 12.252L179.286 12.1757C179.171 12.0994 179.191 11.8131 179.325 11.7749C179.843 11.8131 180.322 11.8322 180.744 11.8322C181.147 11.8322 181.512 11.8131 181.972 11.7749C182.106 11.8322 182.126 12.0803 182.011 12.1757L181.742 12.233C181.205 12.3284 180.917 12.7864 180.361 13.9315L179.459 15.7826C178.922 16.8513 177.598 19.6567 176.812 21.4125C176.543 22.0232 176.14 22.1758 175.776 22.1758C175.315 22.1377 175.066 21.8514 175.066 21.4506Z\" fill=#414241 /> <path d=\"M182.932 9.065C182.932 8.11081 182.912 8.01539 182.433 7.72913L182.279 7.63371C182.203 7.57646 182.203 7.36654 182.279 7.30929C182.682 7.1757 183.45 6.9467 184.025 6.64136C184.083 6.64136 184.159 6.67952 184.179 6.73678C184.159 7.21387 184.121 8.01539 184.121 8.72149V14.2367C184.121 14.4466 184.14 14.4848 184.409 14.4848C184.773 14.4848 185.08 14.313 185.502 13.855L186.174 13.1489C186.634 12.6718 186.73 12.481 186.73 12.4047C186.73 12.3283 186.653 12.2711 186.365 12.252L185.982 12.1947C185.828 12.1375 185.828 11.8321 185.982 11.794H186.346C187.056 11.794 188.015 11.7558 188.917 11.6604C189.032 11.7176 189.051 11.9848 188.955 12.0611L188.437 12.1566C188.111 12.2138 187.843 12.3856 187.421 12.71C186.787 13.2062 186.25 13.7787 185.943 14.0649C185.752 14.2367 185.732 14.313 185.828 14.4466C186.097 14.8092 186.365 15.1146 186.903 15.7252C187.536 16.4313 188.092 17.0611 188.418 17.3664C188.648 17.5764 188.974 17.6718 189.262 17.729L189.492 17.7672C189.607 17.8435 189.588 18.1298 189.454 18.168C188.994 18.1298 188.437 18.1107 187.919 18.1107C187.267 18.1107 186.711 18.1298 186.231 18.168C186.097 18.1107 186.078 17.8244 186.193 17.7672L186.481 17.7099C186.73 17.6718 186.883 17.6527 186.883 17.5573C186.883 17.4619 186.826 17.3474 186.615 17.0993L184.888 15.1146C184.735 14.9619 184.562 14.8855 184.39 14.8855C184.102 14.8855 184.083 14.9428 184.083 15.439V16.3168C184.083 17.4809 184.121 17.6336 184.696 17.7099L185.08 17.7672C185.195 17.8435 185.157 18.1298 185.042 18.168C184.505 18.1298 184.044 18.1107 183.469 18.1107C182.893 18.1107 182.394 18.1298 181.915 18.168C181.8 18.1107 181.761 17.8435 181.896 17.7672L182.26 17.7099C182.855 17.6336 182.874 17.4619 182.874 16.3168V9.065H182.932Z\" fill=#414241 /> <path d=\"M191.122 13.5306C191.122 12.9008 191.122 12.8245 190.681 12.5382L190.528 12.4428C190.47 12.3856 190.47 12.1947 190.547 12.1566C190.911 12.023 191.832 11.6031 192.216 11.3741C192.293 11.3741 192.369 11.4123 192.369 11.4695C192.331 12.023 192.312 12.8054 192.312 13.4542V16.355C192.312 17.5191 192.35 17.6718 192.926 17.7481L193.271 17.8053C193.386 17.8817 193.348 18.1679 193.233 18.2061C192.753 18.1679 192.273 18.1488 191.717 18.1488C191.142 18.1488 190.643 18.1679 190.202 18.2061C190.087 18.1488 190.048 17.8817 190.163 17.8053L190.509 17.7481C191.103 17.6718 191.122 17.5 191.122 16.355V13.5306ZM192.465 8.95048C192.465 9.523 192.062 9.79017 191.602 9.79017C191.103 9.79017 190.777 9.42758 190.777 8.98865C190.777 8.45431 191.161 8.12988 191.64 8.12988C192.12 8.12988 192.465 8.49247 192.465 8.95048Z\" fill=#414241 /> <path d=\"M201.347 18.397C199.985 18.397 199.141 17.9771 198.834 17.8054C198.642 17.4428 198.431 16.3168 198.393 15.5535C198.469 15.439 198.719 15.4008 198.776 15.4962C199.026 16.3168 199.678 17.9008 201.558 17.9008C202.92 17.9008 203.572 17.0229 203.572 16.0496C203.572 15.3435 203.419 14.5611 202.248 13.7978L200.714 12.8054C199.908 12.2711 198.968 11.355 198.968 10.0383C198.968 8.51156 200.157 7.27112 202.268 7.27112C202.766 7.27112 203.342 7.36654 203.764 7.48104C203.975 7.53829 204.205 7.57646 204.32 7.57646C204.474 7.95813 204.608 8.85507 204.608 9.54209C204.55 9.63751 204.282 9.69476 204.205 9.59934C203.994 8.83599 203.553 7.78638 201.999 7.78638C200.407 7.78638 200.081 8.83599 200.081 9.58025C200.081 10.5154 200.848 11.1833 201.462 11.565L202.747 12.3665C203.764 12.9962 204.761 13.9314 204.761 15.4581C204.781 17.1947 203.438 18.397 201.347 18.397Z\" fill=#414241 /> <path d=\"M206.493 13.5308C206.493 12.901 206.493 12.8247 206.052 12.5384L205.899 12.443C205.841 12.3858 205.841 12.1949 205.918 12.1568C206.34 11.985 207.106 11.6033 207.509 11.298C207.605 11.298 207.663 11.3361 207.701 11.4125C207.663 11.6987 207.643 11.9468 207.643 12.1568C207.643 12.2713 207.682 12.3667 207.797 12.3667C208.008 12.2713 209.024 11.6033 210.059 11.6033C211.689 11.6033 212.743 12.9201 212.743 14.5422C212.743 16.7751 211.095 18.3781 208.794 18.3781C208.506 18.3781 208.046 18.34 207.912 18.3209C207.758 18.359 207.682 18.4354 207.682 18.7789V20.4583C207.682 21.6033 207.72 21.7369 208.295 21.8323L208.928 21.9087C209.043 21.985 209.005 22.2713 208.89 22.3094C208.123 22.2713 207.643 22.2522 207.087 22.2522C206.512 22.2522 206.014 22.2713 205.573 22.3094C205.458 22.2522 205.419 21.985 205.534 21.9087L205.879 21.8514C206.474 21.7751 206.493 21.6033 206.493 20.4583V13.5308ZM207.701 16.5079C207.701 17.0232 207.854 17.214 208.18 17.4812C208.506 17.7293 209.005 17.8438 209.35 17.8438C210.673 17.8438 211.459 16.6224 211.459 14.943C211.459 13.6644 210.73 12.3476 209.273 12.3476C208.583 12.3476 208.084 12.5957 207.893 12.8056C207.739 12.9774 207.701 13.2255 207.701 13.7598V16.5079Z\" fill=#414241 /> <path d=\"M220.341 14.9046C220.341 16.9085 218.96 18.3588 216.926 18.3588C215.065 18.3588 213.607 17.0611 213.607 15.0382C213.607 13.0153 215.142 11.5649 217.041 11.5649C218.883 11.584 220.341 12.939 220.341 14.9046ZM216.869 12.0611C215.794 12.0611 215.008 13.0726 215.008 14.8474C215.008 16.3169 215.679 17.8817 217.099 17.8817C218.518 17.8817 218.96 16.3932 218.96 15.1718C218.96 13.7978 218.403 12.0611 216.869 12.0611Z\" fill=#414241 /> <path d=\"M223.467 12.2139V16.3552C223.467 17.5193 223.505 17.672 224.081 17.7483L224.464 17.8056C224.58 17.8819 224.541 18.1682 224.426 18.2064C223.889 18.1682 223.429 18.1491 222.853 18.1491C222.278 18.1491 221.779 18.1682 221.299 18.2064C221.184 18.1491 221.146 17.8819 221.261 17.8056L221.625 17.7483C222.22 17.672 222.239 17.5002 222.239 16.3552V12.8819L221.203 13.4735C221.05 13.4162 220.916 13.2063 220.954 12.9964L222.239 12.233V9.06505C222.239 8.11084 222.22 8.01542 221.74 7.72916L221.587 7.63373C221.51 7.57648 221.51 7.36656 221.587 7.3093C221.99 7.17571 222.757 6.9467 223.333 6.64136C223.39 6.64136 223.467 6.67953 223.486 6.73678C223.467 7.21388 223.429 8.01542 223.429 8.72153V11.5269L224.426 10.9162C224.618 10.9735 224.752 11.2406 224.714 11.3933L223.467 12.2139Z\" fill=#414241 /> <path d=\"M226.613 14.0269C226.191 14.0269 226.172 14.0651 226.172 14.4658C226.172 16.088 227.131 17.4812 228.858 17.4812C229.395 17.4812 229.836 17.3285 230.354 16.6987C230.507 16.6414 230.623 16.756 230.642 16.8895C230.105 17.9773 228.954 18.3781 228.109 18.3781C227.054 18.3781 226.229 17.9201 225.769 17.3094C225.289 16.6796 225.098 15.9353 225.098 15.2101C225.098 13.2254 226.402 11.5841 228.34 11.5841C229.721 11.5841 230.642 12.5383 230.642 13.4925C230.642 13.7215 230.603 13.8551 230.584 13.9124C230.527 14.0078 230.316 14.0269 229.625 14.0269H226.613ZM227.611 13.5498C228.8 13.5498 229.165 13.4925 229.299 13.3971C229.356 13.3589 229.395 13.3017 229.395 13.0918C229.395 12.6337 229.088 12.0803 228.148 12.0803C227.189 12.0803 226.364 12.9391 226.345 13.4735C226.345 13.5116 226.345 13.5498 226.46 13.5498H227.611Z\" fill=#414241 /> <path d=\"M236.606 11.8512C236.741 11.9657 236.856 12.2138 236.856 12.5001C236.856 12.7863 236.702 13.0917 236.491 13.0917C236.415 13.0917 236.338 13.0535 236.261 12.9772C235.897 12.5382 235.302 12.1184 234.65 12.1184C233.518 12.1184 232.424 12.9962 232.424 14.7138C232.424 15.9733 233.288 17.4619 235.033 17.4619C235.973 17.4619 236.453 17.042 236.837 16.4886C236.971 16.4504 237.105 16.5649 237.124 16.7176C236.568 17.9008 235.36 18.3588 234.42 18.3588C233.556 18.3588 232.77 18.0917 232.213 17.5382C231.657 16.9848 231.273 16.2023 231.273 15.1527C231.273 13.4161 232.501 11.5649 235.187 11.5649C235.551 11.584 236.184 11.6604 236.606 11.8512Z\" fill=#414241 /> <path d=\"M239.312 18.1298C238.449 18.1298 237.816 18.1489 237.624 18.1871C237.567 18.1489 237.528 18.0917 237.528 18.0344C237.854 17.6528 238.603 16.5077 239.082 15.668L240.789 12.7673C241.039 12.3092 240.943 12.2902 240.636 12.2902H239.523C239.044 12.2902 238.66 12.3474 238.411 12.5382C238.142 12.7482 237.969 13.1108 237.835 13.4734C237.758 13.5688 237.509 13.5306 237.471 13.4161C237.509 12.9963 237.778 11.9276 238.008 11.5268C238.065 11.4886 238.161 11.4886 238.2 11.5268C238.257 11.794 238.43 11.8131 239.351 11.8131H241.653C242.094 11.8131 242.401 11.8131 242.631 11.7558C242.689 11.794 242.727 11.8321 242.708 11.9085C242.363 12.3665 241.979 12.9772 241.518 13.7405L239.562 17.0039C239.216 17.5764 239.255 17.6528 239.869 17.6528H240.425C241.058 17.6528 241.883 17.6528 242.324 17.1757C242.497 16.9848 242.669 16.6413 242.842 16.2405C242.957 16.1833 243.149 16.2024 243.207 16.336C243.053 17.1184 242.823 17.8818 242.612 18.1871C242.075 18.1489 241.538 18.1298 240.809 18.1298H239.312Z\" fill=#414241 /> <path d=\"M244.622 13.5305C244.622 12.9007 244.622 12.8244 244.181 12.5381L244.027 12.4427C243.969 12.3855 243.969 12.1946 244.046 12.1565C244.411 12.0229 245.332 11.603 245.658 11.374C245.715 11.374 245.811 11.4122 245.83 11.4885C245.792 11.8511 245.792 12.0992 245.792 12.2519C245.792 12.3473 245.849 12.4236 245.965 12.4236C246.636 12.0038 247.403 11.603 248.228 11.603C249.571 11.603 250.127 12.5191 250.127 13.5878V16.3549C250.127 17.5191 250.166 17.6717 250.741 17.7481L251.106 17.8053C251.221 17.8817 251.182 18.1679 251.067 18.2061C250.588 18.1679 250.108 18.1488 249.552 18.1488C248.976 18.1488 248.478 18.1679 248.056 18.2061C247.94 18.1488 247.902 17.8817 248.017 17.8053L248.324 17.7481C248.919 17.6526 248.938 17.5 248.938 16.3549V13.9504C248.938 13.0343 248.516 12.3664 247.423 12.3664C246.809 12.3664 246.272 12.6145 246.041 12.9198C245.83 13.187 245.792 13.416 245.792 13.8931V16.3549C245.792 17.5191 245.83 17.6526 246.406 17.7481L246.694 17.8053C246.809 17.8817 246.77 18.1679 246.655 18.2061C246.214 18.1679 245.754 18.1488 245.178 18.1488C244.603 18.1488 244.104 18.1679 243.663 18.2061C243.547 18.1488 243.509 17.8817 243.624 17.8053L243.97 17.7481C244.564 17.6717 244.583 17.5 244.583 16.3549V13.5305H244.622Z\" fill=#414241 /> <path d=\"M253.125 14.0269C252.703 14.0269 252.684 14.0651 252.684 14.4658C252.684 16.088 253.643 17.4812 255.369 17.4812C255.906 17.4812 256.348 17.3285 256.866 16.6987C257.019 16.6414 257.134 16.756 257.153 16.8895C256.616 17.9773 255.465 18.3781 254.621 18.3781C253.566 18.3781 252.741 17.9201 252.281 17.3094C251.801 16.6796 251.609 15.9353 251.609 15.2101C251.609 13.2254 252.914 11.5841 254.851 11.5841C256.233 11.5841 257.153 12.5383 257.153 13.4925C257.153 13.7215 257.115 13.8551 257.096 13.9124C257.038 14.0078 256.827 14.0269 256.137 14.0269H253.125ZM254.122 13.5498C255.312 13.5498 255.676 13.4925 255.811 13.3971C255.868 13.3589 255.906 13.3017 255.906 13.0918C255.906 12.6337 255.6 12.0803 254.66 12.0803C253.7 12.0803 252.875 12.9391 252.856 13.4735C252.856 13.5116 252.856 13.5498 252.971 13.5498H254.122Z\" fill=#414241 /> <path d=\"M258.569 13.5308C258.569 12.901 258.569 12.8247 258.128 12.5384L257.974 12.443C257.917 12.3858 257.917 12.1949 257.994 12.1568C258.358 12.0232 259.279 11.6033 259.663 11.3743C259.739 11.3743 259.816 11.4125 259.816 11.4697C259.778 12.0232 259.758 12.8056 259.758 13.4545V17.3476C259.758 18.5117 259.643 19.3132 259.413 19.8476C258.934 21.0117 258.07 21.7751 256.958 22.4621C256.766 22.4239 256.67 22.2522 256.728 22.0995C257.15 21.8896 257.456 21.6415 257.687 21.3743C258.262 20.7064 258.55 19.5423 258.55 17.5766V13.5308H258.569ZM259.912 8.95066C259.912 9.50409 259.509 9.79035 259.049 9.79035C258.55 9.79035 258.224 9.42776 258.224 8.96974C258.224 8.43539 258.607 8.11096 259.087 8.11096C259.567 8.11096 259.912 8.49264 259.912 8.95066Z\" fill=#414241 /> </g> <defs> <clipPath id=clip0> <rect width=294.255 height=30 fill=white /> </clipPath> </defs> </svg> <br/> <div>Projekt dofinansowany ze środków Pełnomocnika Rządu ds. Polityki Demograficznej</div> <div>Fundacja Instytut Wiedzy o Rodzinie i Społeczeństwie z siedzibą w Poznaniu 60-602, ul. Klin 9/2, Copyright 2020 © All rights reserved.</div> <div> <a href=http://iworis.pl/polityka-prywatnosci style=color:#cb3550> Polityka prywatności </a>,&nbsp; <a href=http://iworis.pl/regulamin style=color:#cb3550> Regulamin </a> </div> </div> </div>";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.add-article-live', ['common.header', 'common.footer', 'config', 'directives.contenteditable', 'account.settings.social', 'security.service', 'security.authorization', 'services.accountResource', 'services.utility', 'services.formErrors', 'ui.bootstrap', 'directives.serverError', 'ngTagsInput', 'ngFileUpload', 'toggle-switch', 'angular-growl', 'ckeditor', 'resources.User', 'resources.Category', 'resources.Article', 'resources.Tag', 'filters.rawHtml', 'ckeditorPlaceholder', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.add-article-live', {
	    url: '/add-article-live',
	    title: 'Add Article live',
	    views: {
	      'main@': {
	        template: __webpack_require__(151),
	        controller: 'AddLiveArticleCtrl',
	        resolve: {
	          categories: ["Category", function (Category) {
	            var options = [];
	            var generateCategoryOptions = function generateCategoryOptions(items, container) {
	              items.forEach(function (item) {
	                if (!item.path) {
	                  return;
	                }
	                var depth = item.path.split('/').filter(Boolean).length;
	                var indent = new Array(5).join(String.fromCharCode(160));
	                container.push({
	                  _id: item._id,
	                  id: item.id,
	                  path: item.path,
	                  sefriendly: item.sefriendly,
	                  parent: item.parent,
	                  parent_id: item.parent_id,
	                  name: item.name,
	                  _name: new Array(depth).join(indent) + item.name
	                });
	                if (item.children) {
	                  generateCategoryOptions(item.children, container);
	                }
	              });
	              return container;
	            };
	
	            return Category.getPermittedTree().$promise.then(function (data) {
	              generateCategoryOptions(data, options);
	              return options;
	            });
	          }],
	          locations: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type: 'location' });
	          }],
	          playersAndTeams: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
	          }]
	        }
	      }
	    }
	  });
	}]).controller('AddLiveArticleCtrl', ["$scope", "$location", "$log", "$interval", "security", "utility", "growl", "user", "categories", "locations", "playersAndTeams", "adminResource", "SOCIAL", "STATUSES", "Upload", "APP_IMG_URLS", "formErrors", "dateFilter", "Article", "Tag", "localizedMessages", function ($scope, $location, $log, $interval, security, utility, growl, user, categories, locations, playersAndTeams, adminResource, SOCIAL, STATUSES, Upload, APP_IMG_URLS, formErrors, dateFilter, Article, Tag, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  var urlGenerated = false;
	  var now = new Date();
	  var timer = null;
	  var currentDateTime = moment();
	  var slugify = __webpack_require__(152);
	
	  $scope.statuses = _.filter(STATUSES, function (status) {
	    return ~user.permissions.statuses.indexOf(status.id);
	  });
	  if (user.permissions.statuses[0] === '*') {
	    $scope.statuses = STATUSES;
	  }
	  $scope.notas = {
	    titulo: '',
	    nota: '',
	    id: 0
	  };
	  $scope.categories = categories;
	  $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
	    return { _id: p._id, name: p.name };
	  }) : [];
	  $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
	    return {
	      _id: p._id,
	      name: p.name,
	      type: p.role.role_type
	    };
	  }) : [];
	  $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function (e) {
	    return e.type === 'profile';
	  }) : [];
	  $scope.alerts = [];
	  $scope.uploading = false;
	  $scope.imgUrl = APP_IMG_URLS['base'];
	  $scope.isSaving = false;
	  $scope.autosaveTimer = 180;
	  $scope.accordion = {
	    score: true,
	    publishing_date: true,
	    url: true,
	    image: true,
	    published_by: false
	  };
	
	  $scope.isAdmin = false;
	  if (user.permissions.is_admin) {
	    $scope.isAdmin = true;
	    console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
	  }
	  $scope.data = {
	    title: '',
	    sefriendly: '',
	    status: {
	      id: '0',
	      value: localizedMessages.get('pending')
	    },
	    image: '',
	    video: '',
	    image_caption: '',
	    body: '',
	    isbodylive: true,
	    bodylive: [],
	    abstract: '',
	    equipo_local: '',
	    equipo_visitante: '',
	    goals: '',
	    goles_local: '',
	    goles_visitante: '',
	    referee: '',
	    incidents: '',
	    category: '',
	    tags: '',
	    author: {
	      picture: user.account.avatar,
	      twitter: user.account.twitter,
	      plus: user.account.plus,
	      name: user.account.name.full,
	      username: user.username
	    },
	    orderNumber: 0,
	    last_edited_by: {
	      name: user.account.name.full,
	      username: user.username
	    },
	    published_by: {
	      name: '',
	      username: ''
	    },
	    startDate: currentDateTime.local().format('YYYY-MM-DD HH:mm'),
	    endDate: currentDateTime.local().format('YYYY-MM-DD HH:mm'),
	    publish_date: currentDateTime.local().format('YYYY-MM-DD HH:mm')
	  };
	
	  var startTimer = function startTimer() {
	    return $interval(function () {
	      if ($scope.autosaveTimer <= 0) {
	        $scope.save();
	      }
	      $scope.autosaveTimer -= 1;
	    }, 1000);
	  };
	
	  var resetTimer = function resetTimer() {
	    $scope.autosaveTimer = 180;
	    $interval.cancel(timer);
	  };
	
	  $scope.autosaveChanged = function () {
	    if ($scope.autosave) {
	      timer = startTimer();
	    } else {
	      resetTimer();
	    }
	  };
	
	  $scope.titleChanged = function () {
	    $scope.data.title = $scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " ");
	    if ($scope.data.sefriendly) {
	      return;
	    }
	    $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " "));
	  };
	
	  $scope.canChangeAuthor = function () {
	    return user.permissions.is_editor && $scope.canChangeCategory();
	  };
	
	  $scope.canChangeCategory = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	    // return ~user.permissions.categories.indexOf(article.category.id);
	  };
	
	  $scope.save = function () {
	    resetTimer();
	    $scope.autosaveChanged();
	    $scope.data.sefriendly = slugify($scope.data.sefriendly);
	    //validate
	    if (!$scope.data.title) {
	      growl.error('Title is required');
	      return;
	    }
	
	    if (!$scope.data.category) {
	      growl.error('Category is required');
	      return;
	    }
	
	    if ($scope.data.bodylive.length === 0) {
	      growl.error('Body is required');
	      return;
	    }
	
	    $scope.isSaving = true;
	
	    var data = angular.copy($scope.data);
	    data.edition = data.category.path.split("/")[1];
	    data.status = parseInt(data.status.id, null);
	    data.show_inarticle = 21;
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text)
	      };
	    });
	
	    data.publish_date = (data.publish_date ? moment(data.publish_date) : currentDateTime).toISOString();
	    data.startDate = (data.startDate ? moment(data.startDate) : currentDateTime).toISOString();
	    data.endDate = (data.endDate ? moment(data.endDate) : currentDateTime).toISOString();
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.published_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	    /*
	    if(endDatebtn){
	      data.endDate = new Date();
	    }else{
	      data.endDate = new Date()+90min;
	    }*/
	
	    var catArray = data.category.parent == "/" ? [] : data.category.parent.substring(1).split('/');
	    var pDate = new Date(data.publish_date);
	    var pMonth = pDate.getUTCMonth() + 1;
	    var dateSeg = '/' + pDate.getUTCFullYear() + '/' + ('0' + pMonth).slice(-2) + '/' + ('0' + pDate.getUTCDate()).slice(-2) + '/';
	    data.url_segment = dateSeg;
	    if (catArray.length == 0) {
	      data.url_segment = '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length == 1) {
	      data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length > 1) {
	      data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
	    }
	
	    Article.save(data, function (result) {
	      setTimeout(function () {
	        growl.info('Article have been created.');
	        $location.path('/account/edit-article-live/' + result.article_id);
	      }, 1000);
	    }, formErrors.growlErrors).$promise.then(function () {
	      setTimeout(function () {
	        $scope.isSaving = false;
	      }, 5000);
	    });
	  };
	
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    if (!$scope.isSaving) {
	      return true;
	    }
	  });
	
	  $scope.agregarNota = function () {
	    var text = angular.copy($scope.notas.nota);
	    text = CKEDITOR.instances.editor.getData();
	    if (text === '') {
	      alert('please enter a comment');
	      return false;
	    }
	    $scope.isSaving = true;
	
	    console.log("text: ", text);
	    text = text.replace('<p>', '');
	    text = text.replace('</p>', '');
	    var now = new Date();
	    var fecha = new Date().toISOString();
	    //var fecha = new Date(now.getTime() + now.getTimezoneOffset() * 60000).toISOString();
	    var idiv = $scope.data.bodylive.length + 1;
	    var titulo = $scope.notas.titulo.replace(/<[^>]*>|&nbsp;/g, "");;
	    var newBody = [{
	      postId: idiv,
	      title: titulo,
	      date: fecha,
	      description: text
	    }];
	    $scope.data.bodylive = newBody;
	    $scope.notas = {
	      titulo: '',
	      nota: '',
	      id: idiv
	    };
	    $scope.save();
	    setTimeout(function () {
	      $scope.isSaving = false;
	    }, 3000);
	    //console.log($scope.data.body);
	  };
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.thumbnail = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.loadTags = function (query) {
	    return Tag.search({ q: query }).$promise.then(function (tags) {
	      if (!tags) return [];
	      return tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.name,
	          name: tag.name,
	          sefriendly: slugify(tag.name)
	        };
	      });
	    });
	  };
	
	  $scope.changePT1 = function (pt1) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt1;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_local_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.changePT2 = function (pt2) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt2;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_visitante_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.loadProfiles = function (query) {
	    return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
	      if (!profiles) return [];
	      var searchName = query.toLowerCase();
	      return profiles.data.filter(function (p) {
	        var name = p.name.toLowerCase();
	        return name.indexOf(searchName) > -1;
	      }).map(function (p) {
	        return {
	          _id: p._id,
	          name: p.name
	        };
	      });
	    });
	  };
	}]);

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "<style>body{background:#f6f6f6}#editor{background-color:#f4f9ff;border:5px solid #d1eaff;border-radius:10px;padding:20px 30px 0 30px;min-height:180px;margin-bottom:20px}.comment-container h2{background-color:#fff;font-weight:300;color:#333;padding:15px 30px;text-align:center;font-size:20px;font-family:'Open Sans','Ubuntu Condensed',Arial;letter-spacing:0}@media (max-width:768px){.col-sm-8{padding-left:0;padding-right:0}}.date-container{padding:20px;background-color:#fff;width:100%;-webkit-box-shadow:0 3px 12px -9px rgba(0,0,0,.75);-moz-box-shadow:0 3px 12px -9px rgba(0,0,0,.75);box-shadow:0 3px 12px -9px rgba(0,0,0,.75);border:1px solid #eee;clear:both;margin-bottom:15px}.ubuntu{font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif}.comment-container{background-color:#fff;-webkit-box-shadow:0 2px 17px -9px rgba(0,0,0,.75);-moz-box-shadow:0 2px 17px -9px rgba(0,0,0,.75);box-shadow:0 2px 17px -9px rgba(0,0,0,.75);padding:20px}.droid{font-family:'Open Sans',Georgia,'Times New Roman',Times,serif;font-size:19px}.open-sans{font-family:'Open Sans',sans-serif}.image_caption_news{font-size:11px;font-style:italic;color:#777;background-color:#eee;padding:15px;border-bottom:1px #ddd solid;border-top:1px #ddd solid;margin-bottom:20px}.page-header{padding-bottom:10px;margin:0 0 18px}#save{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}#agregarNota{width:100%;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff;margin-top:15px}.side-row{padding:10px;color:#fff;background:#28a5e4}.toggle-switch{min-width:64px;border-color:#848484;font-size:11px}.toggle-switch span{line-height:inherit}.toggle-switch .switch-left{background:#63c663;color:#fff}.toggle-switch .switch-right{background:#c43939;color:#fff}.no-margin{margin:0}.no-border{border:0;border-radius:0}oi-select{width:200px}oi-select .select-dropdown,oi-select .select-search-list-item,oi-select .select-search-list-item_input input{font-size:13px;white-space:nowrap}oi-select .select-dropdown{max-height:200px}oi-select .select-search-list-item_selection{box-shadow:none}.right-sidebar .form-inline{border-bottom:1px solid #e4e3e3}.right-sidebar .form-inline.no-border{border:0;border-radius:0}.right-sidebar .panel{margin:0}.right-sidebar .panel-body{background-color:#f9f9f9}.right-sidebar .form-inline .form-group{margin:10px 0;width:100%}.right-sidebar .form-inline label{font-size:12px;font-weight:400}.right-sidebar .form-inline input{float:right;height:26px}.right-sidebar oi-select .select-search{background:#eee}.right-sidebar .form-inline input,.right-sidebar .form-inline select,.right-sidebar .form-inline textarea{font-size:12px;font-weight:400;width:130px;margin-left:30px;border-radius:0;background:#eee}.right-sidebar .form-inline textarea{width:250px;margin-left:0}.right-sidebar input[type=datetime-local]{margin-left:0;width:100%}.right-sidebar tags-input .host{position:static}.margin-sidebar{margin-top:138px}.fixed-save{position:fixed;top:0;width:293px}.fixed-publishing{position:fixed;top:96px;width:293px}.dragover{padding:10px;border:2px dashed #28a5e4}</style> <div class=row id=add-article-live style=margin-top:10px> <div class=col-xs-12> <div class=page-header> <form class=form-inline> <div class=pull-right> </div> <div class=form-group> <oi-select oi-options=\"option._name for option in categories track by option.id\" oi-select-options=selectSettings ng-model=data.category placeholder=\"Choose Category\"></oi-select> </div> <div class=form-group style=padding-right:10px> <oi-select oi-options=\"option.value for option in statuses track by option.id\" oi-select-options=selectSettings ng-model=data.status placeholder=\"Wybierz status\"></oi-select> </div> <div class=form-group> <label for=Live-event>{{localizedMessages.get('live-event') | uppercase }}</label> </div> </form> </div> </div> </div> <div class=\"row w990\"> <div class=col-sm-8> <h1 ng-model=data.title class=\"text-center ubuntu\" contenteditable=true placeholder=\"Add your title here\" style=margin-top:0 ng-blur=titleChanged()></h1> <h4 ng-model=data.abstract class=\"text-justify open-sans\" contenteditable=true placeholder=\"Add the description of your article in 2 or 3 lines here. If you don't have a good idea for description, answer to 5W: who, what? where? why? how?\"></h4> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-upload ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ngf-thumbnail=\"thumbnail || (data.image ? imgUrl + data.image : false) || imgUrl + 'medium_upload-6536040818.png'\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15)\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <figcaption ng-model=data.image_caption contenteditable=true class=\"text-center image_caption_news\" id=image_caption placeholder=\"Add image caption and photo source here\" style=min-height:20px> </figcaption> <form class=\"date-container form-inline no-border\"> <div style=text-align:center;margin-bottom:20px;font-size:16px;font-weight:300><span style=font-weight:700;background-color:#5db971;color:#fff;padding:10px;line-height:200%>At What Time this Event will Start and End?</span><br><br>¿A que hora empieza y acabará este evento?</div> <div class=\"form-group datetime group2\" style=margin-right:3% id=startDate> <label for=startDatess>Start Date > </label> <input ng-model=data.startDate data-field=datetime type=text class=form-control id=startDatess placeholder=\"yyyy-MM-dd HH:mm\" readonly=readonly> </div> <div class=\"form-group datetime group3\" style=margin-right:0 id=endDate> <label for=endDatess>End Date > </label> <input ng-model=data.endDate data-field=datetime type=text class=form-control id=endDatess placeholder=\"yyyy-MM-dd HH:mm\" readonly=readonly> </div> <br><br> <span style=\"text-align:center;font-weight:300;font-size:11.5px;font-family:Open Sans\">** Add here Time when Game Starts and when it will End more or less. <b>Is needed for appear in Lives Carrousel OK</b></span> </form> <h2 style=\"font-weight:100;font-family:'Open Sans',Ubuntu,Arial;font-size:22px;margin-top:30px;margin-bottom:0;text-align:center;padding:10px;color:#fff;background-color:#2277c0;letter-spacing:0\">Add your 1st comment for the LIVE here &gt;</h2> <div class=comment-container> <h2 ng-model=notas.titulo strip-br=true class=\"text-center ubuntu\" contenteditable=true placeholder=\"Add your Short Title Comment here (Optional), example: minute of event, actions etc in short text\"></h2> <article id=editor ng-model=notas.nota ckeditor=ckOptions contenteditable=true ready=onReady() class=\"text-justify article-content droid\" spellcheck=false style=position:relative;min-height:200px placeholder=\"Add your LIVE comments here! Ideal is 3 or 4 lines lenght per each comment.  When be added click in 'Add comment' button and it will be published in real time in the LIVE article.\"> </article> <button type=button id=agregarNota ng-click=agregarNota() ng-disabled=isSaving> <span ng-hide=isSaving>{{ localizedMessages.get('add-comment') }}</span> </button> </div> <br> <br> <article id=live-comment ng-repeat=\"body in data.bodylive\" contenteditable={{isAdmin}} class=\"text-justify article-content live\" spellcheck=false style=position:relative> <h2>{{body.title}}</h2> <i>{{body.date}}</i> <div ng-bind-html=body.description></div> </article> <br> <br> <div> <h5><strong>{{ localizedMessages.get('allowing-spaces') }}</strong></h5> <p>{{ localizedMessages.get('allowing-spaces-helper') }}</p> <tags-input ng-model=data.tags replace-spaces-with-dashes=false> <auto-complete source=loadTags($query) min-length=2 debounce-delay=1 max-results=10></auto-complete> </tags-input> </div>  </div> <div class=\"col-sm-4 right-sidebar\"> <button type=button id=save class=\"btn btn-lg btn-block\" ng-click=save() ng-disabled=isSaving> <i class=\"fas fa-spinner fa-spin\" ng-show=isSaving></i> <span ng-hide=isSaving>{{ localizedMessages.get('save') }}</span> </button> <h4 class=\"text-muted well no-margin no-border\">{{ localizedMessages.get('news') }}</h4> <div class=\"well no-margin no-border\"> <form class=\"form-inline no-border\"> <div class=form-group> <label for=author>{{ localizedMessages.get('author') }}</label> <input ng-model=data.author.name type=text class=form-control id=author ng-disabled=!canChangeAuthor()> </div> </form> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.url = !accordion.url\"> <strong>{{ localizedMessages.get('url') | uppercase }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.url> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=url>{{ localizedMessages.get('url') | uppercase }} {{ localizedMessages.get('slug') }}:</label> <input ng-model=data.sefriendly type=text class=form-control id=url> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.image = !accordion.image\"> <strong>{{ localizedMessages.get('image') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.image> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=image>{{ localizedMessages.get('image') }}:</label> <input ng-model=data.image type=text class=form-control id=image> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.published_by = !accordion.published_by\"> <strong>{{ localizedMessages.get('publishing') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.published_by> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=\"form-group datetime group1\" id=publish_date> <label for=publishing-date>{{ localizedMessages.get('publishing-date') }}</label> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\"> </div> </form> <br/> <form class=\"form-inline no-border\"> <div class=form-group> <label for=last-edited-by>{{ localizedMessages.get('last-edited-by') }}</label> <input ng-model=data.last_edited_by.name ng-disabled=true type=text class=form-control id=last-edited-by> </div> </form> <form class=\"form-inline no-border\"> <div class=form-group> <label for=published-by>{{ localizedMessages.get('published-by') }}</label> <input ng-model=data.published_by.name ng-disabled=!canChangeAuthor() type=text class=form-control id=published-by> </div> </form> </div> </div> </div> </div> </div> <div id=dtBox1></div> <div id=dtBox2></div> <div id=dtBox3></div> <script>var dateValue,dateValueStartDate,dateValueEndDate;$(function(){var e=$('[contentEditable=\"true\"]'),a=null,t=function(e){(a=$(this)).text().trim().length||a.empty()};e.on(\"input\",t),e.each(t),$(window).on(\"scroll\",function(e){143<$(window).scrollTop()?($(\"#save\").addClass(\"fixed-save\"),$(\"#autosave\").addClass(\"fixed-autosave\"),$(\"#publishing\").addClass(\"fixed-publishing\"),$(\".right-sidebar\").addClass(\"margin-sidebar\")):($(\"#save\").removeClass(\"fixed-save\"),$(\"#autosave\").removeClass(\"fixed-autosave\"),$(\"#publishing\").removeClass(\"fixed-publishing\"),$(\".right-sidebar\").removeClass(\"margin-sidebar\"))}),$(\"#dtBox1\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",parentElement:\".group1\",settingValueOfElement:function(e,a,t){dateValue=a}}),$(\"#dtBox2\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",parentElement:\".group2\",settingValueOfElement:function(e,a,t){dateValueStartDate=a}}),$(\"#dtBox3\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",parentElement:\".group3\",settingValueOfElement:function(e,a,t){dateValueEndDate=a}})});var changesSaved=!0;window.onbeforeunload=function(){if(1==changesSaved)return\"add live You havent saved your changes. Are you sure you want to leave the page?\"}</script> ";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var latinize = __webpack_require__(153);
	var decode = __webpack_require__(154).Html5Entities.decode;
	
	module.exports = function (str) {
	  if (typeof str === 'string') {
	    str = latinize(decode(str.toLowerCase()));
	    str = str.replace(/-/g, ' ');
	    str = str.replace(/[^a-z0-9 ]+/gi, '');
	    str = str.trim().replace(/ /g, '-');
	    str = str.replace(/[-]{2}/g, '');
	    return str;
	  } else {
	    return str;
	  }
	};

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';
	
	var characters = {
	  'Á': 'A',
	  'Ă': 'A',
	  'Ắ': 'A',
	  'Ặ': 'A',
	  'Ằ': 'A',
	  'Ẳ': 'A',
	  'Ẵ': 'A',
	  'Ǎ': 'A',
	  'Â': 'A',
	  'Ấ': 'A',
	  'Ậ': 'A',
	  'Ầ': 'A',
	  'Ẩ': 'A',
	  'Ẫ': 'A',
	  'Ä': 'A',
	  'Ǟ': 'A',
	  'Ȧ': 'A',
	  'Ǡ': 'A',
	  'Ạ': 'A',
	  'Ȁ': 'A',
	  'À': 'A',
	  'Ả': 'A',
	  'Ȃ': 'A',
	  'Ā': 'A',
	  'Ą': 'A',
	  'Å': 'A',
	  'Ǻ': 'A',
	  'Ḁ': 'A',
	  'Ⱥ': 'A',
	  'Ã': 'A',
	  'Ꜳ': 'AA',
	  'Æ': 'AE',
	  'Ǽ': 'AE',
	  'Ǣ': 'AE',
	  'Ꜵ': 'AO',
	  'Ꜷ': 'AU',
	  'Ꜹ': 'AV',
	  'Ꜻ': 'AV',
	  'Ꜽ': 'AY',
	  'Ḃ': 'B',
	  'Ḅ': 'B',
	  'Ɓ': 'B',
	  'Ḇ': 'B',
	  'Ƀ': 'B',
	  'Ƃ': 'B',
	  'Ć': 'C',
	  'Č': 'C',
	  'Ç': 'C',
	  'Ḉ': 'C',
	  'Ĉ': 'C',
	  'Ċ': 'C',
	  'Ƈ': 'C',
	  'Ȼ': 'C',
	  'Ď': 'D',
	  'Ḑ': 'D',
	  'Ḓ': 'D',
	  'Ḋ': 'D',
	  'Ḍ': 'D',
	  'Ɗ': 'D',
	  'Ḏ': 'D',
	  'ǲ': 'D',
	  'ǅ': 'D',
	  'Đ': 'D',
	  'Ƌ': 'D',
	  'Ǳ': 'DZ',
	  'Ǆ': 'DZ',
	  'É': 'E',
	  'Ĕ': 'E',
	  'Ě': 'E',
	  'Ȩ': 'E',
	  'Ḝ': 'E',
	  'Ê': 'E',
	  'Ế': 'E',
	  'Ệ': 'E',
	  'Ề': 'E',
	  'Ể': 'E',
	  'Ễ': 'E',
	  'Ḙ': 'E',
	  'Ë': 'E',
	  'Ė': 'E',
	  'Ẹ': 'E',
	  'Ȅ': 'E',
	  'È': 'E',
	  'Ẻ': 'E',
	  'Ȇ': 'E',
	  'Ē': 'E',
	  'Ḗ': 'E',
	  'Ḕ': 'E',
	  'Ę': 'E',
	  'Ɇ': 'E',
	  'Ẽ': 'E',
	  'Ḛ': 'E',
	  'Ꝫ': 'ET',
	  'Ḟ': 'F',
	  'Ƒ': 'F',
	  'Ǵ': 'G',
	  'Ğ': 'G',
	  'Ǧ': 'G',
	  'Ģ': 'G',
	  'Ĝ': 'G',
	  'Ġ': 'G',
	  'Ɠ': 'G',
	  'Ḡ': 'G',
	  'Ǥ': 'G',
	  'Ḫ': 'H',
	  'Ȟ': 'H',
	  'Ḩ': 'H',
	  'Ĥ': 'H',
	  'Ⱨ': 'H',
	  'Ḧ': 'H',
	  'Ḣ': 'H',
	  'Ḥ': 'H',
	  'Ħ': 'H',
	  'Í': 'I',
	  'Ĭ': 'I',
	  'Ǐ': 'I',
	  'Î': 'I',
	  'Ï': 'I',
	  'Ḯ': 'I',
	  'İ': 'I',
	  'Ị': 'I',
	  'Ȉ': 'I',
	  'Ì': 'I',
	  'Ỉ': 'I',
	  'Ȋ': 'I',
	  'Ī': 'I',
	  'Į': 'I',
	  'Ɨ': 'I',
	  'Ĩ': 'I',
	  'Ḭ': 'I',
	  'Ꝺ': 'D',
	  'Ꝼ': 'F',
	  'Ᵹ': 'G',
	  'Ꞃ': 'R',
	  'Ꞅ': 'S',
	  'Ꞇ': 'T',
	  'Ꝭ': 'IS',
	  'Ĵ': 'J',
	  'Ɉ': 'J',
	  'Ḱ': 'K',
	  'Ǩ': 'K',
	  'Ķ': 'K',
	  'Ⱪ': 'K',
	  'Ꝃ': 'K',
	  'Ḳ': 'K',
	  'Ƙ': 'K',
	  'Ḵ': 'K',
	  'Ꝁ': 'K',
	  'Ꝅ': 'K',
	  'Ĺ': 'L',
	  'Ƚ': 'L',
	  'Ľ': 'L',
	  'Ļ': 'L',
	  'Ḽ': 'L',
	  'Ḷ': 'L',
	  'Ḹ': 'L',
	  'Ⱡ': 'L',
	  'Ꝉ': 'L',
	  'Ḻ': 'L',
	  'Ŀ': 'L',
	  'Ɫ': 'L',
	  'ǈ': 'L',
	  'Ł': 'L',
	  'Ǉ': 'LJ',
	  'Ḿ': 'M',
	  'Ṁ': 'M',
	  'Ṃ': 'M',
	  'Ɱ': 'M',
	  'Ń': 'N',
	  'Ň': 'N',
	  'Ņ': 'N',
	  'Ṋ': 'N',
	  'Ṅ': 'N',
	  'Ṇ': 'N',
	  'Ǹ': 'N',
	  'Ɲ': 'N',
	  'Ṉ': 'N',
	  'Ƞ': 'N',
	  'ǋ': 'N',
	  'Ñ': 'N',
	  'Ǌ': 'NJ',
	  'Ó': 'O',
	  'Ŏ': 'O',
	  'Ǒ': 'O',
	  'Ô': 'O',
	  'Ố': 'O',
	  'Ộ': 'O',
	  'Ồ': 'O',
	  'Ổ': 'O',
	  'Ỗ': 'O',
	  'Ö': 'O',
	  'Ȫ': 'O',
	  'Ȯ': 'O',
	  'Ȱ': 'O',
	  'Ọ': 'O',
	  'Ő': 'O',
	  'Ȍ': 'O',
	  'Ò': 'O',
	  'Ỏ': 'O',
	  'Ơ': 'O',
	  'Ớ': 'O',
	  'Ợ': 'O',
	  'Ờ': 'O',
	  'Ở': 'O',
	  'Ỡ': 'O',
	  'Ȏ': 'O',
	  'Ꝋ': 'O',
	  'Ꝍ': 'O',
	  'Ō': 'O',
	  'Ṓ': 'O',
	  'Ṑ': 'O',
	  'Ɵ': 'O',
	  'Ǫ': 'O',
	  'Ǭ': 'O',
	  'Ø': 'O',
	  'Ǿ': 'O',
	  'Õ': 'O',
	  'Ṍ': 'O',
	  'Ṏ': 'O',
	  'Ȭ': 'O',
	  'Ƣ': 'OI',
	  'Ꝏ': 'OO',
	  'Ɛ': 'E',
	  'Ɔ': 'O',
	  'Ȣ': 'OU',
	  'Ṕ': 'P',
	  'Ṗ': 'P',
	  'Ꝓ': 'P',
	  'Ƥ': 'P',
	  'Ꝕ': 'P',
	  'Ᵽ': 'P',
	  'Ꝑ': 'P',
	  'Ꝙ': 'Q',
	  'Ꝗ': 'Q',
	  'Ŕ': 'R',
	  'Ř': 'R',
	  'Ŗ': 'R',
	  'Ṙ': 'R',
	  'Ṛ': 'R',
	  'Ṝ': 'R',
	  'Ȑ': 'R',
	  'Ȓ': 'R',
	  'Ṟ': 'R',
	  'Ɍ': 'R',
	  'Ɽ': 'R',
	  'Ꜿ': 'C',
	  'Ǝ': 'E',
	  'Ś': 'S',
	  'Ṥ': 'S',
	  'Š': 'S',
	  'Ṧ': 'S',
	  'Ş': 'S',
	  'Ŝ': 'S',
	  'Ș': 'S',
	  'Ṡ': 'S',
	  'Ṣ': 'S',
	  'Ṩ': 'S',
	  'ß': 'ss',
	  'Ť': 'T',
	  'Ţ': 'T',
	  'Ṱ': 'T',
	  'Ț': 'T',
	  'Ⱦ': 'T',
	  'Ṫ': 'T',
	  'Ṭ': 'T',
	  'Ƭ': 'T',
	  'Ṯ': 'T',
	  'Ʈ': 'T',
	  'Ŧ': 'T',
	  'Ɐ': 'A',
	  'Ꞁ': 'L',
	  'Ɯ': 'M',
	  'Ʌ': 'V',
	  'Ꜩ': 'TZ',
	  'Ú': 'U',
	  'Ŭ': 'U',
	  'Ǔ': 'U',
	  'Û': 'U',
	  'Ṷ': 'U',
	  'Ü': 'U',
	  'Ǘ': 'U',
	  'Ǚ': 'U',
	  'Ǜ': 'U',
	  'Ǖ': 'U',
	  'Ṳ': 'U',
	  'Ụ': 'U',
	  'Ű': 'U',
	  'Ȕ': 'U',
	  'Ù': 'U',
	  'Ủ': 'U',
	  'Ư': 'U',
	  'Ứ': 'U',
	  'Ự': 'U',
	  'Ừ': 'U',
	  'Ử': 'U',
	  'Ữ': 'U',
	  'Ȗ': 'U',
	  'Ū': 'U',
	  'Ṻ': 'U',
	  'Ų': 'U',
	  'Ů': 'U',
	  'Ũ': 'U',
	  'Ṹ': 'U',
	  'Ṵ': 'U',
	  'Ꝟ': 'V',
	  'Ṿ': 'V',
	  'Ʋ': 'V',
	  'Ṽ': 'V',
	  'Ꝡ': 'VY',
	  'Ẃ': 'W',
	  'Ŵ': 'W',
	  'Ẅ': 'W',
	  'Ẇ': 'W',
	  'Ẉ': 'W',
	  'Ẁ': 'W',
	  'Ⱳ': 'W',
	  'Ẍ': 'X',
	  'Ẋ': 'X',
	  'Ý': 'Y',
	  'Ŷ': 'Y',
	  'Ÿ': 'Y',
	  'Ẏ': 'Y',
	  'Ỵ': 'Y',
	  'Ỳ': 'Y',
	  'Ƴ': 'Y',
	  'Ỷ': 'Y',
	  'Ỿ': 'Y',
	  'Ȳ': 'Y',
	  'Ɏ': 'Y',
	  'Ỹ': 'Y',
	  'Ź': 'Z',
	  'Ž': 'Z',
	  'Ẑ': 'Z',
	  'Ⱬ': 'Z',
	  'Ż': 'Z',
	  'Ẓ': 'Z',
	  'Ȥ': 'Z',
	  'Ẕ': 'Z',
	  'Ƶ': 'Z',
	  'Ĳ': 'IJ',
	  'Œ': 'OE',
	  'ᴀ': 'A',
	  'ᴁ': 'AE',
	  'ʙ': 'B',
	  'ᴃ': 'B',
	  'ᴄ': 'C',
	  'ᴅ': 'D',
	  'ᴇ': 'E',
	  'ꜰ': 'F',
	  'ɢ': 'G',
	  'ʛ': 'G',
	  'ʜ': 'H',
	  'ɪ': 'I',
	  'ʁ': 'R',
	  'ᴊ': 'J',
	  'ᴋ': 'K',
	  'ʟ': 'L',
	  'ᴌ': 'L',
	  'ᴍ': 'M',
	  'ɴ': 'N',
	  'ᴏ': 'O',
	  'ɶ': 'OE',
	  'ᴐ': 'O',
	  'ᴕ': 'OU',
	  'ᴘ': 'P',
	  'ʀ': 'R',
	  'ᴎ': 'N',
	  'ᴙ': 'R',
	  'ꜱ': 'S',
	  'ᴛ': 'T',
	  'ⱻ': 'E',
	  'ᴚ': 'R',
	  'ᴜ': 'U',
	  'ᴠ': 'V',
	  'ᴡ': 'W',
	  'ʏ': 'Y',
	  'ᴢ': 'Z',
	  'á': 'a',
	  'ă': 'a',
	  'ắ': 'a',
	  'ặ': 'a',
	  'ằ': 'a',
	  'ẳ': 'a',
	  'ẵ': 'a',
	  'ǎ': 'a',
	  'â': 'a',
	  'ấ': 'a',
	  'ậ': 'a',
	  'ầ': 'a',
	  'ẩ': 'a',
	  'ẫ': 'a',
	  'ä': 'a',
	  'ǟ': 'a',
	  'ȧ': 'a',
	  'ǡ': 'a',
	  'ạ': 'a',
	  'ȁ': 'a',
	  'à': 'a',
	  'ả': 'a',
	  'ȃ': 'a',
	  'ā': 'a',
	  'ą': 'a',
	  'ᶏ': 'a',
	  'ẚ': 'a',
	  'å': 'a',
	  'ǻ': 'a',
	  'ḁ': 'a',
	  'ⱥ': 'a',
	  'ã': 'a',
	  'ꜳ': 'aa',
	  'æ': 'ae',
	  'ǽ': 'ae',
	  'ǣ': 'ae',
	  'ꜵ': 'ao',
	  'ꜷ': 'au',
	  'ꜹ': 'av',
	  'ꜻ': 'av',
	  'ꜽ': 'ay',
	  'ḃ': 'b',
	  'ḅ': 'b',
	  'ɓ': 'b',
	  'ḇ': 'b',
	  'ᵬ': 'b',
	  'ᶀ': 'b',
	  'ƀ': 'b',
	  'ƃ': 'b',
	  'ɵ': 'o',
	  'ć': 'c',
	  'č': 'c',
	  'ç': 'c',
	  'ḉ': 'c',
	  'ĉ': 'c',
	  'ɕ': 'c',
	  'ċ': 'c',
	  'ƈ': 'c',
	  'ȼ': 'c',
	  'ď': 'd',
	  'ḑ': 'd',
	  'ḓ': 'd',
	  'ȡ': 'd',
	  'ḋ': 'd',
	  'ḍ': 'd',
	  'ɗ': 'd',
	  'ᶑ': 'd',
	  'ḏ': 'd',
	  'ᵭ': 'd',
	  'ᶁ': 'd',
	  'đ': 'd',
	  'ɖ': 'd',
	  'ƌ': 'd',
	  'ı': 'i',
	  'ȷ': 'j',
	  'ɟ': 'j',
	  'ʄ': 'j',
	  'ǳ': 'dz',
	  'ǆ': 'dz',
	  'é': 'e',
	  'ĕ': 'e',
	  'ě': 'e',
	  'ȩ': 'e',
	  'ḝ': 'e',
	  'ê': 'e',
	  'ế': 'e',
	  'ệ': 'e',
	  'ề': 'e',
	  'ể': 'e',
	  'ễ': 'e',
	  'ḙ': 'e',
	  'ë': 'e',
	  'ė': 'e',
	  'ẹ': 'e',
	  'ȅ': 'e',
	  'è': 'e',
	  'ẻ': 'e',
	  'ȇ': 'e',
	  'ē': 'e',
	  'ḗ': 'e',
	  'ḕ': 'e',
	  'ⱸ': 'e',
	  'ę': 'e',
	  'ᶒ': 'e',
	  'ɇ': 'e',
	  'ẽ': 'e',
	  'ḛ': 'e',
	  'ꝫ': 'et',
	  'ḟ': 'f',
	  'ƒ': 'f',
	  'ᵮ': 'f',
	  'ᶂ': 'f',
	  'ǵ': 'g',
	  'ğ': 'g',
	  'ǧ': 'g',
	  'ģ': 'g',
	  'ĝ': 'g',
	  'ġ': 'g',
	  'ɠ': 'g',
	  'ḡ': 'g',
	  'ᶃ': 'g',
	  'ǥ': 'g',
	  'ḫ': 'h',
	  'ȟ': 'h',
	  'ḩ': 'h',
	  'ĥ': 'h',
	  'ⱨ': 'h',
	  'ḧ': 'h',
	  'ḣ': 'h',
	  'ḥ': 'h',
	  'ɦ': 'h',
	  'ẖ': 'h',
	  'ħ': 'h',
	  'ƕ': 'hv',
	  'í': 'i',
	  'ĭ': 'i',
	  'ǐ': 'i',
	  'î': 'i',
	  'ï': 'i',
	  'ḯ': 'i',
	  'ị': 'i',
	  'ȉ': 'i',
	  'ì': 'i',
	  'ỉ': 'i',
	  'ȋ': 'i',
	  'ī': 'i',
	  'į': 'i',
	  'ᶖ': 'i',
	  'ɨ': 'i',
	  'ĩ': 'i',
	  'ḭ': 'i',
	  'ꝺ': 'd',
	  'ꝼ': 'f',
	  'ᵹ': 'g',
	  'ꞃ': 'r',
	  'ꞅ': 's',
	  'ꞇ': 't',
	  'ꝭ': 'is',
	  'ǰ': 'j',
	  'ĵ': 'j',
	  'ʝ': 'j',
	  'ɉ': 'j',
	  'ḱ': 'k',
	  'ǩ': 'k',
	  'ķ': 'k',
	  'ⱪ': 'k',
	  'ꝃ': 'k',
	  'ḳ': 'k',
	  'ƙ': 'k',
	  'ḵ': 'k',
	  'ᶄ': 'k',
	  'ꝁ': 'k',
	  'ꝅ': 'k',
	  'ĺ': 'l',
	  'ƚ': 'l',
	  'ɬ': 'l',
	  'ľ': 'l',
	  'ļ': 'l',
	  'ḽ': 'l',
	  'ȴ': 'l',
	  'ḷ': 'l',
	  'ḹ': 'l',
	  'ⱡ': 'l',
	  'ꝉ': 'l',
	  'ḻ': 'l',
	  'ŀ': 'l',
	  'ɫ': 'l',
	  'ᶅ': 'l',
	  'ɭ': 'l',
	  'ł': 'l',
	  'ǉ': 'lj',
	  'ſ': 's',
	  'ẜ': 's',
	  'ẛ': 's',
	  'ẝ': 's',
	  'ḿ': 'm',
	  'ṁ': 'm',
	  'ṃ': 'm',
	  'ɱ': 'm',
	  'ᵯ': 'm',
	  'ᶆ': 'm',
	  'ń': 'n',
	  'ň': 'n',
	  'ņ': 'n',
	  'ṋ': 'n',
	  'ȵ': 'n',
	  'ṅ': 'n',
	  'ṇ': 'n',
	  'ǹ': 'n',
	  'ɲ': 'n',
	  'ṉ': 'n',
	  'ƞ': 'n',
	  'ᵰ': 'n',
	  'ᶇ': 'n',
	  'ɳ': 'n',
	  'ñ': 'n',
	  'ǌ': 'nj',
	  'ó': 'o',
	  'ŏ': 'o',
	  'ǒ': 'o',
	  'ô': 'o',
	  'ố': 'o',
	  'ộ': 'o',
	  'ồ': 'o',
	  'ổ': 'o',
	  'ỗ': 'o',
	  'ö': 'o',
	  'ȫ': 'o',
	  'ȯ': 'o',
	  'ȱ': 'o',
	  'ọ': 'o',
	  'ő': 'o',
	  'ȍ': 'o',
	  'ò': 'o',
	  'ỏ': 'o',
	  'ơ': 'o',
	  'ớ': 'o',
	  'ợ': 'o',
	  'ờ': 'o',
	  'ở': 'o',
	  'ỡ': 'o',
	  'ȏ': 'o',
	  'ꝋ': 'o',
	  'ꝍ': 'o',
	  'ⱺ': 'o',
	  'ō': 'o',
	  'ṓ': 'o',
	  'ṑ': 'o',
	  'ǫ': 'o',
	  'ǭ': 'o',
	  'ø': 'o',
	  'ǿ': 'o',
	  'õ': 'o',
	  'ṍ': 'o',
	  'ṏ': 'o',
	  'ȭ': 'o',
	  'ƣ': 'oi',
	  'ꝏ': 'oo',
	  'ɛ': 'e',
	  'ᶓ': 'e',
	  'ɔ': 'o',
	  'ᶗ': 'o',
	  'ȣ': 'ou',
	  'ṕ': 'p',
	  'ṗ': 'p',
	  'ꝓ': 'p',
	  'ƥ': 'p',
	  'ᵱ': 'p',
	  'ᶈ': 'p',
	  'ꝕ': 'p',
	  'ᵽ': 'p',
	  'ꝑ': 'p',
	  'ꝙ': 'q',
	  'ʠ': 'q',
	  'ɋ': 'q',
	  'ꝗ': 'q',
	  'ŕ': 'r',
	  'ř': 'r',
	  'ŗ': 'r',
	  'ṙ': 'r',
	  'ṛ': 'r',
	  'ṝ': 'r',
	  'ȑ': 'r',
	  'ɾ': 'r',
	  'ᵳ': 'r',
	  'ȓ': 'r',
	  'ṟ': 'r',
	  'ɼ': 'r',
	  'ᵲ': 'r',
	  'ᶉ': 'r',
	  'ɍ': 'r',
	  'ɽ': 'r',
	  'ↄ': 'c',
	  'ꜿ': 'c',
	  'ɘ': 'e',
	  'ɿ': 'r',
	  'ś': 's',
	  'ṥ': 's',
	  'š': 's',
	  'ṧ': 's',
	  'ş': 's',
	  'ŝ': 's',
	  'ș': 's',
	  'ṡ': 's',
	  'ṣ': 's',
	  'ṩ': 's',
	  'ʂ': 's',
	  'ᵴ': 's',
	  'ᶊ': 's',
	  'ȿ': 's',
	  'ɡ': 'g',
	  'ᴑ': 'o',
	  'ᴓ': 'o',
	  'ᴝ': 'u',
	  'ť': 't',
	  'ţ': 't',
	  'ṱ': 't',
	  'ț': 't',
	  'ȶ': 't',
	  'ẗ': 't',
	  'ⱦ': 't',
	  'ṫ': 't',
	  'ṭ': 't',
	  'ƭ': 't',
	  'ṯ': 't',
	  'ᵵ': 't',
	  'ƫ': 't',
	  'ʈ': 't',
	  'ŧ': 't',
	  'ᵺ': 'th',
	  'ɐ': 'a',
	  'ᴂ': 'ae',
	  'ǝ': 'e',
	  'ᵷ': 'g',
	  'ɥ': 'h',
	  'ʮ': 'h',
	  'ʯ': 'h',
	  'ᴉ': 'i',
	  'ʞ': 'k',
	  'ꞁ': 'l',
	  'ɯ': 'm',
	  'ɰ': 'm',
	  'ᴔ': 'oe',
	  'ɹ': 'r',
	  'ɻ': 'r',
	  'ɺ': 'r',
	  'ⱹ': 'r',
	  'ʇ': 't',
	  'ʌ': 'v',
	  'ʍ': 'w',
	  'ʎ': 'y',
	  'ꜩ': 'tz',
	  'ú': 'u',
	  'ŭ': 'u',
	  'ǔ': 'u',
	  'û': 'u',
	  'ṷ': 'u',
	  'ü': 'u',
	  'ǘ': 'u',
	  'ǚ': 'u',
	  'ǜ': 'u',
	  'ǖ': 'u',
	  'ṳ': 'u',
	  'ụ': 'u',
	  'ű': 'u',
	  'ȕ': 'u',
	  'ù': 'u',
	  'ủ': 'u',
	  'ư': 'u',
	  'ứ': 'u',
	  'ự': 'u',
	  'ừ': 'u',
	  'ử': 'u',
	  'ữ': 'u',
	  'ȗ': 'u',
	  'ū': 'u',
	  'ṻ': 'u',
	  'ų': 'u',
	  'ᶙ': 'u',
	  'ů': 'u',
	  'ũ': 'u',
	  'ṹ': 'u',
	  'ṵ': 'u',
	  'ᵫ': 'ue',
	  'ꝸ': 'um',
	  'ⱴ': 'v',
	  'ꝟ': 'v',
	  'ṿ': 'v',
	  'ʋ': 'v',
	  'ᶌ': 'v',
	  'ⱱ': 'v',
	  'ṽ': 'v',
	  'ꝡ': 'vy',
	  'ẃ': 'w',
	  'ŵ': 'w',
	  'ẅ': 'w',
	  'ẇ': 'w',
	  'ẉ': 'w',
	  'ẁ': 'w',
	  'ⱳ': 'w',
	  'ẘ': 'w',
	  'ẍ': 'x',
	  'ẋ': 'x',
	  'ᶍ': 'x',
	  'ý': 'y',
	  'ŷ': 'y',
	  'ÿ': 'y',
	  'ẏ': 'y',
	  'ỵ': 'y',
	  'ỳ': 'y',
	  'ƴ': 'y',
	  'ỷ': 'y',
	  'ỿ': 'y',
	  'ȳ': 'y',
	  'ẙ': 'y',
	  'ɏ': 'y',
	  'ỹ': 'y',
	  'ź': 'z',
	  'ž': 'z',
	  'ẑ': 'z',
	  'ʑ': 'z',
	  'ⱬ': 'z',
	  'ż': 'z',
	  'ẓ': 'z',
	  'ȥ': 'z',
	  'ẕ': 'z',
	  'ᵶ': 'z',
	  'ᶎ': 'z',
	  'ʐ': 'z',
	  'ƶ': 'z',
	  'ɀ': 'z',
	  'ﬀ': 'ff',
	  'ﬃ': 'ffi',
	  'ﬄ': 'ffl',
	  'ﬁ': 'fi',
	  'ﬂ': 'fl',
	  'ĳ': 'ij',
	  'œ': 'oe',
	  'ﬆ': 'st',
	  'ₐ': 'a',
	  'ₑ': 'e',
	  'ᵢ': 'i',
	  'ⱼ': 'j',
	  'ₒ': 'o',
	  'ᵣ': 'r',
	  'ᵤ': 'u',
	  'ᵥ': 'v',
	  'ₓ': 'x',
	  'Ё': 'YO',
	  'Й': 'I',
	  'Ц': 'TS',
	  'У': 'U',
	  'К': 'K',
	  'Е': 'E',
	  'Н': 'N',
	  'Г': 'G',
	  'Ш': 'SH',
	  'Щ': 'SCH',
	  'З': 'Z',
	  'Х': 'H',
	  'Ъ': "'",
	  'ё': 'yo',
	  'й': 'i',
	  'ц': 'ts',
	  'у': 'u',
	  'к': 'k',
	  'е': 'e',
	  'н': 'n',
	  'г': 'g',
	  'ш': 'sh',
	  'щ': 'sch',
	  'з': 'z',
	  'х': 'h',
	  'ъ': "'",
	  'Ф': 'F',
	  'Ы': 'I',
	  'В': 'V',
	  'А': 'a',
	  'П': 'P',
	  'Р': 'R',
	  'О': 'O',
	  'Л': 'L',
	  'Д': 'D',
	  'Ж': 'ZH',
	  'Э': 'E',
	  'ф': 'f',
	  'ы': 'i',
	  'в': 'v',
	  'а': 'a',
	  'п': 'p',
	  'р': 'r',
	  'о': 'o',
	  'л': 'l',
	  'д': 'd',
	  'ж': 'zh',
	  'э': 'e',
	  'Я': 'Ya',
	  'Ч': 'CH',
	  'С': 'S',
	  'М': 'M',
	  'И': 'I',
	  'Т': 'T',
	  'Ь': "'",
	  'Б': 'B',
	  'Ю': 'YU',
	  'я': 'ya',
	  'ч': 'ch',
	  'с': 's',
	  'м': 'm',
	  'и': 'i',
	  'т': 't',
	  'ь': "'",
	  'б': 'b',
	  'ю': 'yu'
	};
	
	module.exports = function (str) {
	  if (typeof str === 'string') {
	    return str.replace(/[^A-Za-z0-9]/g, function (x) {
	      return characters[x] || x;
	    });
	  } else {
	    return str;
	  }
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var xml_entities_1 = __webpack_require__(155);
	exports.XmlEntities = xml_entities_1.XmlEntities;
	var html4_entities_1 = __webpack_require__(156);
	exports.Html4Entities = html4_entities_1.Html4Entities;
	var html5_entities_1 = __webpack_require__(157);
	exports.Html5Entities = html5_entities_1.Html5Entities;
	exports.AllHtmlEntities = html5_entities_1.Html5Entities;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ALPHA_INDEX = {
	    '&lt': '<',
	    '&gt': '>',
	    '&quot': '"',
	    '&apos': '\'',
	    '&amp': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&apos;': '\'',
	    '&amp;': '&'
	};
	var CHAR_INDEX = {
	    60: 'lt',
	    62: 'gt',
	    34: 'quot',
	    39: 'apos',
	    38: 'amp'
	};
	var CHAR_S_INDEX = {
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    '\'': '&apos;',
	    '&': '&amp;'
	};
	var XmlEntities = /** @class */ (function () {
	    function XmlEntities() {
	    }
	    XmlEntities.prototype.encode = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        return str.replace(/[<>"'&]/g, function (s) {
	            return CHAR_S_INDEX[s];
	        });
	    };
	    XmlEntities.encode = function (str) {
	        return new XmlEntities().encode(str);
	    };
	    XmlEntities.prototype.decode = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        return str.replace(/&#?[0-9a-zA-Z]+;?/g, function (s) {
	            if (s.charAt(1) === '#') {
	                var code = s.charAt(2).toLowerCase() === 'x' ?
	                    parseInt(s.substr(3), 16) :
	                    parseInt(s.substr(2));
	                if (isNaN(code) || code < -32768 || code > 65535) {
	                    return '';
	                }
	                return String.fromCharCode(code);
	            }
	            return ALPHA_INDEX[s] || s;
	        });
	    };
	    XmlEntities.decode = function (str) {
	        return new XmlEntities().decode(str);
	    };
	    XmlEntities.prototype.encodeNonUTF = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLength = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLength) {
	            var c = str.charCodeAt(i);
	            var alpha = CHAR_INDEX[c];
	            if (alpha) {
	                result += "&" + alpha + ";";
	                i++;
	                continue;
	            }
	            if (c < 32 || c > 126) {
	                result += '&#' + c + ';';
	            }
	            else {
	                result += str.charAt(i);
	            }
	            i++;
	        }
	        return result;
	    };
	    XmlEntities.encodeNonUTF = function (str) {
	        return new XmlEntities().encodeNonUTF(str);
	    };
	    XmlEntities.prototype.encodeNonASCII = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLenght = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLenght) {
	            var c = str.charCodeAt(i);
	            if (c <= 255) {
	                result += str[i++];
	                continue;
	            }
	            result += '&#' + c + ';';
	            i++;
	        }
	        return result;
	    };
	    XmlEntities.encodeNonASCII = function (str) {
	        return new XmlEntities().encodeNonASCII(str);
	    };
	    return XmlEntities;
	}());
	exports.XmlEntities = XmlEntities;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HTML_ALPHA = ['apos', 'nbsp', 'iexcl', 'cent', 'pound', 'curren', 'yen', 'brvbar', 'sect', 'uml', 'copy', 'ordf', 'laquo', 'not', 'shy', 'reg', 'macr', 'deg', 'plusmn', 'sup2', 'sup3', 'acute', 'micro', 'para', 'middot', 'cedil', 'sup1', 'ordm', 'raquo', 'frac14', 'frac12', 'frac34', 'iquest', 'Agrave', 'Aacute', 'Acirc', 'Atilde', 'Auml', 'Aring', 'Aelig', 'Ccedil', 'Egrave', 'Eacute', 'Ecirc', 'Euml', 'Igrave', 'Iacute', 'Icirc', 'Iuml', 'ETH', 'Ntilde', 'Ograve', 'Oacute', 'Ocirc', 'Otilde', 'Ouml', 'times', 'Oslash', 'Ugrave', 'Uacute', 'Ucirc', 'Uuml', 'Yacute', 'THORN', 'szlig', 'agrave', 'aacute', 'acirc', 'atilde', 'auml', 'aring', 'aelig', 'ccedil', 'egrave', 'eacute', 'ecirc', 'euml', 'igrave', 'iacute', 'icirc', 'iuml', 'eth', 'ntilde', 'ograve', 'oacute', 'ocirc', 'otilde', 'ouml', 'divide', 'oslash', 'ugrave', 'uacute', 'ucirc', 'uuml', 'yacute', 'thorn', 'yuml', 'quot', 'amp', 'lt', 'gt', 'OElig', 'oelig', 'Scaron', 'scaron', 'Yuml', 'circ', 'tilde', 'ensp', 'emsp', 'thinsp', 'zwnj', 'zwj', 'lrm', 'rlm', 'ndash', 'mdash', 'lsquo', 'rsquo', 'sbquo', 'ldquo', 'rdquo', 'bdquo', 'dagger', 'Dagger', 'permil', 'lsaquo', 'rsaquo', 'euro', 'fnof', 'Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon', 'Zeta', 'Eta', 'Theta', 'Iota', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Xi', 'Omicron', 'Pi', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'Phi', 'Chi', 'Psi', 'Omega', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigmaf', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'thetasym', 'upsih', 'piv', 'bull', 'hellip', 'prime', 'Prime', 'oline', 'frasl', 'weierp', 'image', 'real', 'trade', 'alefsym', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'crarr', 'lArr', 'uArr', 'rArr', 'dArr', 'hArr', 'forall', 'part', 'exist', 'empty', 'nabla', 'isin', 'notin', 'ni', 'prod', 'sum', 'minus', 'lowast', 'radic', 'prop', 'infin', 'ang', 'and', 'or', 'cap', 'cup', 'int', 'there4', 'sim', 'cong', 'asymp', 'ne', 'equiv', 'le', 'ge', 'sub', 'sup', 'nsub', 'sube', 'supe', 'oplus', 'otimes', 'perp', 'sdot', 'lceil', 'rceil', 'lfloor', 'rfloor', 'lang', 'rang', 'loz', 'spades', 'clubs', 'hearts', 'diams'];
	var HTML_CODES = [39, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 34, 38, 60, 62, 338, 339, 352, 353, 376, 710, 732, 8194, 8195, 8201, 8204, 8205, 8206, 8207, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8240, 8249, 8250, 8364, 402, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 977, 978, 982, 8226, 8230, 8242, 8243, 8254, 8260, 8472, 8465, 8476, 8482, 8501, 8592, 8593, 8594, 8595, 8596, 8629, 8656, 8657, 8658, 8659, 8660, 8704, 8706, 8707, 8709, 8711, 8712, 8713, 8715, 8719, 8721, 8722, 8727, 8730, 8733, 8734, 8736, 8743, 8744, 8745, 8746, 8747, 8756, 8764, 8773, 8776, 8800, 8801, 8804, 8805, 8834, 8835, 8836, 8838, 8839, 8853, 8855, 8869, 8901, 8968, 8969, 8970, 8971, 9001, 9002, 9674, 9824, 9827, 9829, 9830];
	var alphaIndex = {};
	var numIndex = {};
	(function () {
	    var i = 0;
	    var length = HTML_ALPHA.length;
	    while (i < length) {
	        var a = HTML_ALPHA[i];
	        var c = HTML_CODES[i];
	        alphaIndex[a] = String.fromCharCode(c);
	        numIndex[c] = a;
	        i++;
	    }
	})();
	var Html4Entities = /** @class */ (function () {
	    function Html4Entities() {
	    }
	    Html4Entities.prototype.decode = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        return str.replace(/&(#?[\w\d]+);?/g, function (s, entity) {
	            var chr;
	            if (entity.charAt(0) === "#") {
	                var code = entity.charAt(1).toLowerCase() === 'x' ?
	                    parseInt(entity.substr(2), 16) :
	                    parseInt(entity.substr(1));
	                if (!(isNaN(code) || code < -32768 || code > 65535)) {
	                    chr = String.fromCharCode(code);
	                }
	            }
	            else {
	                chr = alphaIndex[entity];
	            }
	            return chr || s;
	        });
	    };
	    Html4Entities.decode = function (str) {
	        return new Html4Entities().decode(str);
	    };
	    Html4Entities.prototype.encode = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLength = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLength) {
	            var alpha = numIndex[str.charCodeAt(i)];
	            result += alpha ? "&" + alpha + ";" : str.charAt(i);
	            i++;
	        }
	        return result;
	    };
	    Html4Entities.encode = function (str) {
	        return new Html4Entities().encode(str);
	    };
	    Html4Entities.prototype.encodeNonUTF = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLength = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLength) {
	            var cc = str.charCodeAt(i);
	            var alpha = numIndex[cc];
	            if (alpha) {
	                result += "&" + alpha + ";";
	            }
	            else if (cc < 32 || cc > 126) {
	                result += "&#" + cc + ";";
	            }
	            else {
	                result += str.charAt(i);
	            }
	            i++;
	        }
	        return result;
	    };
	    Html4Entities.encodeNonUTF = function (str) {
	        return new Html4Entities().encodeNonUTF(str);
	    };
	    Html4Entities.prototype.encodeNonASCII = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLength = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLength) {
	            var c = str.charCodeAt(i);
	            if (c <= 255) {
	                result += str[i++];
	                continue;
	            }
	            result += '&#' + c + ';';
	            i++;
	        }
	        return result;
	    };
	    Html4Entities.encodeNonASCII = function (str) {
	        return new Html4Entities().encodeNonASCII(str);
	    };
	    return Html4Entities;
	}());
	exports.Html4Entities = Html4Entities;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ENTITIES = [['Aacute', [193]], ['aacute', [225]], ['Abreve', [258]], ['abreve', [259]], ['ac', [8766]], ['acd', [8767]], ['acE', [8766, 819]], ['Acirc', [194]], ['acirc', [226]], ['acute', [180]], ['Acy', [1040]], ['acy', [1072]], ['AElig', [198]], ['aelig', [230]], ['af', [8289]], ['Afr', [120068]], ['afr', [120094]], ['Agrave', [192]], ['agrave', [224]], ['alefsym', [8501]], ['aleph', [8501]], ['Alpha', [913]], ['alpha', [945]], ['Amacr', [256]], ['amacr', [257]], ['amalg', [10815]], ['amp', [38]], ['AMP', [38]], ['andand', [10837]], ['And', [10835]], ['and', [8743]], ['andd', [10844]], ['andslope', [10840]], ['andv', [10842]], ['ang', [8736]], ['ange', [10660]], ['angle', [8736]], ['angmsdaa', [10664]], ['angmsdab', [10665]], ['angmsdac', [10666]], ['angmsdad', [10667]], ['angmsdae', [10668]], ['angmsdaf', [10669]], ['angmsdag', [10670]], ['angmsdah', [10671]], ['angmsd', [8737]], ['angrt', [8735]], ['angrtvb', [8894]], ['angrtvbd', [10653]], ['angsph', [8738]], ['angst', [197]], ['angzarr', [9084]], ['Aogon', [260]], ['aogon', [261]], ['Aopf', [120120]], ['aopf', [120146]], ['apacir', [10863]], ['ap', [8776]], ['apE', [10864]], ['ape', [8778]], ['apid', [8779]], ['apos', [39]], ['ApplyFunction', [8289]], ['approx', [8776]], ['approxeq', [8778]], ['Aring', [197]], ['aring', [229]], ['Ascr', [119964]], ['ascr', [119990]], ['Assign', [8788]], ['ast', [42]], ['asymp', [8776]], ['asympeq', [8781]], ['Atilde', [195]], ['atilde', [227]], ['Auml', [196]], ['auml', [228]], ['awconint', [8755]], ['awint', [10769]], ['backcong', [8780]], ['backepsilon', [1014]], ['backprime', [8245]], ['backsim', [8765]], ['backsimeq', [8909]], ['Backslash', [8726]], ['Barv', [10983]], ['barvee', [8893]], ['barwed', [8965]], ['Barwed', [8966]], ['barwedge', [8965]], ['bbrk', [9141]], ['bbrktbrk', [9142]], ['bcong', [8780]], ['Bcy', [1041]], ['bcy', [1073]], ['bdquo', [8222]], ['becaus', [8757]], ['because', [8757]], ['Because', [8757]], ['bemptyv', [10672]], ['bepsi', [1014]], ['bernou', [8492]], ['Bernoullis', [8492]], ['Beta', [914]], ['beta', [946]], ['beth', [8502]], ['between', [8812]], ['Bfr', [120069]], ['bfr', [120095]], ['bigcap', [8898]], ['bigcirc', [9711]], ['bigcup', [8899]], ['bigodot', [10752]], ['bigoplus', [10753]], ['bigotimes', [10754]], ['bigsqcup', [10758]], ['bigstar', [9733]], ['bigtriangledown', [9661]], ['bigtriangleup', [9651]], ['biguplus', [10756]], ['bigvee', [8897]], ['bigwedge', [8896]], ['bkarow', [10509]], ['blacklozenge', [10731]], ['blacksquare', [9642]], ['blacktriangle', [9652]], ['blacktriangledown', [9662]], ['blacktriangleleft', [9666]], ['blacktriangleright', [9656]], ['blank', [9251]], ['blk12', [9618]], ['blk14', [9617]], ['blk34', [9619]], ['block', [9608]], ['bne', [61, 8421]], ['bnequiv', [8801, 8421]], ['bNot', [10989]], ['bnot', [8976]], ['Bopf', [120121]], ['bopf', [120147]], ['bot', [8869]], ['bottom', [8869]], ['bowtie', [8904]], ['boxbox', [10697]], ['boxdl', [9488]], ['boxdL', [9557]], ['boxDl', [9558]], ['boxDL', [9559]], ['boxdr', [9484]], ['boxdR', [9554]], ['boxDr', [9555]], ['boxDR', [9556]], ['boxh', [9472]], ['boxH', [9552]], ['boxhd', [9516]], ['boxHd', [9572]], ['boxhD', [9573]], ['boxHD', [9574]], ['boxhu', [9524]], ['boxHu', [9575]], ['boxhU', [9576]], ['boxHU', [9577]], ['boxminus', [8863]], ['boxplus', [8862]], ['boxtimes', [8864]], ['boxul', [9496]], ['boxuL', [9563]], ['boxUl', [9564]], ['boxUL', [9565]], ['boxur', [9492]], ['boxuR', [9560]], ['boxUr', [9561]], ['boxUR', [9562]], ['boxv', [9474]], ['boxV', [9553]], ['boxvh', [9532]], ['boxvH', [9578]], ['boxVh', [9579]], ['boxVH', [9580]], ['boxvl', [9508]], ['boxvL', [9569]], ['boxVl', [9570]], ['boxVL', [9571]], ['boxvr', [9500]], ['boxvR', [9566]], ['boxVr', [9567]], ['boxVR', [9568]], ['bprime', [8245]], ['breve', [728]], ['Breve', [728]], ['brvbar', [166]], ['bscr', [119991]], ['Bscr', [8492]], ['bsemi', [8271]], ['bsim', [8765]], ['bsime', [8909]], ['bsolb', [10693]], ['bsol', [92]], ['bsolhsub', [10184]], ['bull', [8226]], ['bullet', [8226]], ['bump', [8782]], ['bumpE', [10926]], ['bumpe', [8783]], ['Bumpeq', [8782]], ['bumpeq', [8783]], ['Cacute', [262]], ['cacute', [263]], ['capand', [10820]], ['capbrcup', [10825]], ['capcap', [10827]], ['cap', [8745]], ['Cap', [8914]], ['capcup', [10823]], ['capdot', [10816]], ['CapitalDifferentialD', [8517]], ['caps', [8745, 65024]], ['caret', [8257]], ['caron', [711]], ['Cayleys', [8493]], ['ccaps', [10829]], ['Ccaron', [268]], ['ccaron', [269]], ['Ccedil', [199]], ['ccedil', [231]], ['Ccirc', [264]], ['ccirc', [265]], ['Cconint', [8752]], ['ccups', [10828]], ['ccupssm', [10832]], ['Cdot', [266]], ['cdot', [267]], ['cedil', [184]], ['Cedilla', [184]], ['cemptyv', [10674]], ['cent', [162]], ['centerdot', [183]], ['CenterDot', [183]], ['cfr', [120096]], ['Cfr', [8493]], ['CHcy', [1063]], ['chcy', [1095]], ['check', [10003]], ['checkmark', [10003]], ['Chi', [935]], ['chi', [967]], ['circ', [710]], ['circeq', [8791]], ['circlearrowleft', [8634]], ['circlearrowright', [8635]], ['circledast', [8859]], ['circledcirc', [8858]], ['circleddash', [8861]], ['CircleDot', [8857]], ['circledR', [174]], ['circledS', [9416]], ['CircleMinus', [8854]], ['CirclePlus', [8853]], ['CircleTimes', [8855]], ['cir', [9675]], ['cirE', [10691]], ['cire', [8791]], ['cirfnint', [10768]], ['cirmid', [10991]], ['cirscir', [10690]], ['ClockwiseContourIntegral', [8754]], ['clubs', [9827]], ['clubsuit', [9827]], ['colon', [58]], ['Colon', [8759]], ['Colone', [10868]], ['colone', [8788]], ['coloneq', [8788]], ['comma', [44]], ['commat', [64]], ['comp', [8705]], ['compfn', [8728]], ['complement', [8705]], ['complexes', [8450]], ['cong', [8773]], ['congdot', [10861]], ['Congruent', [8801]], ['conint', [8750]], ['Conint', [8751]], ['ContourIntegral', [8750]], ['copf', [120148]], ['Copf', [8450]], ['coprod', [8720]], ['Coproduct', [8720]], ['copy', [169]], ['COPY', [169]], ['copysr', [8471]], ['CounterClockwiseContourIntegral', [8755]], ['crarr', [8629]], ['cross', [10007]], ['Cross', [10799]], ['Cscr', [119966]], ['cscr', [119992]], ['csub', [10959]], ['csube', [10961]], ['csup', [10960]], ['csupe', [10962]], ['ctdot', [8943]], ['cudarrl', [10552]], ['cudarrr', [10549]], ['cuepr', [8926]], ['cuesc', [8927]], ['cularr', [8630]], ['cularrp', [10557]], ['cupbrcap', [10824]], ['cupcap', [10822]], ['CupCap', [8781]], ['cup', [8746]], ['Cup', [8915]], ['cupcup', [10826]], ['cupdot', [8845]], ['cupor', [10821]], ['cups', [8746, 65024]], ['curarr', [8631]], ['curarrm', [10556]], ['curlyeqprec', [8926]], ['curlyeqsucc', [8927]], ['curlyvee', [8910]], ['curlywedge', [8911]], ['curren', [164]], ['curvearrowleft', [8630]], ['curvearrowright', [8631]], ['cuvee', [8910]], ['cuwed', [8911]], ['cwconint', [8754]], ['cwint', [8753]], ['cylcty', [9005]], ['dagger', [8224]], ['Dagger', [8225]], ['daleth', [8504]], ['darr', [8595]], ['Darr', [8609]], ['dArr', [8659]], ['dash', [8208]], ['Dashv', [10980]], ['dashv', [8867]], ['dbkarow', [10511]], ['dblac', [733]], ['Dcaron', [270]], ['dcaron', [271]], ['Dcy', [1044]], ['dcy', [1076]], ['ddagger', [8225]], ['ddarr', [8650]], ['DD', [8517]], ['dd', [8518]], ['DDotrahd', [10513]], ['ddotseq', [10871]], ['deg', [176]], ['Del', [8711]], ['Delta', [916]], ['delta', [948]], ['demptyv', [10673]], ['dfisht', [10623]], ['Dfr', [120071]], ['dfr', [120097]], ['dHar', [10597]], ['dharl', [8643]], ['dharr', [8642]], ['DiacriticalAcute', [180]], ['DiacriticalDot', [729]], ['DiacriticalDoubleAcute', [733]], ['DiacriticalGrave', [96]], ['DiacriticalTilde', [732]], ['diam', [8900]], ['diamond', [8900]], ['Diamond', [8900]], ['diamondsuit', [9830]], ['diams', [9830]], ['die', [168]], ['DifferentialD', [8518]], ['digamma', [989]], ['disin', [8946]], ['div', [247]], ['divide', [247]], ['divideontimes', [8903]], ['divonx', [8903]], ['DJcy', [1026]], ['djcy', [1106]], ['dlcorn', [8990]], ['dlcrop', [8973]], ['dollar', [36]], ['Dopf', [120123]], ['dopf', [120149]], ['Dot', [168]], ['dot', [729]], ['DotDot', [8412]], ['doteq', [8784]], ['doteqdot', [8785]], ['DotEqual', [8784]], ['dotminus', [8760]], ['dotplus', [8724]], ['dotsquare', [8865]], ['doublebarwedge', [8966]], ['DoubleContourIntegral', [8751]], ['DoubleDot', [168]], ['DoubleDownArrow', [8659]], ['DoubleLeftArrow', [8656]], ['DoubleLeftRightArrow', [8660]], ['DoubleLeftTee', [10980]], ['DoubleLongLeftArrow', [10232]], ['DoubleLongLeftRightArrow', [10234]], ['DoubleLongRightArrow', [10233]], ['DoubleRightArrow', [8658]], ['DoubleRightTee', [8872]], ['DoubleUpArrow', [8657]], ['DoubleUpDownArrow', [8661]], ['DoubleVerticalBar', [8741]], ['DownArrowBar', [10515]], ['downarrow', [8595]], ['DownArrow', [8595]], ['Downarrow', [8659]], ['DownArrowUpArrow', [8693]], ['DownBreve', [785]], ['downdownarrows', [8650]], ['downharpoonleft', [8643]], ['downharpoonright', [8642]], ['DownLeftRightVector', [10576]], ['DownLeftTeeVector', [10590]], ['DownLeftVectorBar', [10582]], ['DownLeftVector', [8637]], ['DownRightTeeVector', [10591]], ['DownRightVectorBar', [10583]], ['DownRightVector', [8641]], ['DownTeeArrow', [8615]], ['DownTee', [8868]], ['drbkarow', [10512]], ['drcorn', [8991]], ['drcrop', [8972]], ['Dscr', [119967]], ['dscr', [119993]], ['DScy', [1029]], ['dscy', [1109]], ['dsol', [10742]], ['Dstrok', [272]], ['dstrok', [273]], ['dtdot', [8945]], ['dtri', [9663]], ['dtrif', [9662]], ['duarr', [8693]], ['duhar', [10607]], ['dwangle', [10662]], ['DZcy', [1039]], ['dzcy', [1119]], ['dzigrarr', [10239]], ['Eacute', [201]], ['eacute', [233]], ['easter', [10862]], ['Ecaron', [282]], ['ecaron', [283]], ['Ecirc', [202]], ['ecirc', [234]], ['ecir', [8790]], ['ecolon', [8789]], ['Ecy', [1069]], ['ecy', [1101]], ['eDDot', [10871]], ['Edot', [278]], ['edot', [279]], ['eDot', [8785]], ['ee', [8519]], ['efDot', [8786]], ['Efr', [120072]], ['efr', [120098]], ['eg', [10906]], ['Egrave', [200]], ['egrave', [232]], ['egs', [10902]], ['egsdot', [10904]], ['el', [10905]], ['Element', [8712]], ['elinters', [9191]], ['ell', [8467]], ['els', [10901]], ['elsdot', [10903]], ['Emacr', [274]], ['emacr', [275]], ['empty', [8709]], ['emptyset', [8709]], ['EmptySmallSquare', [9723]], ['emptyv', [8709]], ['EmptyVerySmallSquare', [9643]], ['emsp13', [8196]], ['emsp14', [8197]], ['emsp', [8195]], ['ENG', [330]], ['eng', [331]], ['ensp', [8194]], ['Eogon', [280]], ['eogon', [281]], ['Eopf', [120124]], ['eopf', [120150]], ['epar', [8917]], ['eparsl', [10723]], ['eplus', [10865]], ['epsi', [949]], ['Epsilon', [917]], ['epsilon', [949]], ['epsiv', [1013]], ['eqcirc', [8790]], ['eqcolon', [8789]], ['eqsim', [8770]], ['eqslantgtr', [10902]], ['eqslantless', [10901]], ['Equal', [10869]], ['equals', [61]], ['EqualTilde', [8770]], ['equest', [8799]], ['Equilibrium', [8652]], ['equiv', [8801]], ['equivDD', [10872]], ['eqvparsl', [10725]], ['erarr', [10609]], ['erDot', [8787]], ['escr', [8495]], ['Escr', [8496]], ['esdot', [8784]], ['Esim', [10867]], ['esim', [8770]], ['Eta', [919]], ['eta', [951]], ['ETH', [208]], ['eth', [240]], ['Euml', [203]], ['euml', [235]], ['euro', [8364]], ['excl', [33]], ['exist', [8707]], ['Exists', [8707]], ['expectation', [8496]], ['exponentiale', [8519]], ['ExponentialE', [8519]], ['fallingdotseq', [8786]], ['Fcy', [1060]], ['fcy', [1092]], ['female', [9792]], ['ffilig', [64259]], ['fflig', [64256]], ['ffllig', [64260]], ['Ffr', [120073]], ['ffr', [120099]], ['filig', [64257]], ['FilledSmallSquare', [9724]], ['FilledVerySmallSquare', [9642]], ['fjlig', [102, 106]], ['flat', [9837]], ['fllig', [64258]], ['fltns', [9649]], ['fnof', [402]], ['Fopf', [120125]], ['fopf', [120151]], ['forall', [8704]], ['ForAll', [8704]], ['fork', [8916]], ['forkv', [10969]], ['Fouriertrf', [8497]], ['fpartint', [10765]], ['frac12', [189]], ['frac13', [8531]], ['frac14', [188]], ['frac15', [8533]], ['frac16', [8537]], ['frac18', [8539]], ['frac23', [8532]], ['frac25', [8534]], ['frac34', [190]], ['frac35', [8535]], ['frac38', [8540]], ['frac45', [8536]], ['frac56', [8538]], ['frac58', [8541]], ['frac78', [8542]], ['frasl', [8260]], ['frown', [8994]], ['fscr', [119995]], ['Fscr', [8497]], ['gacute', [501]], ['Gamma', [915]], ['gamma', [947]], ['Gammad', [988]], ['gammad', [989]], ['gap', [10886]], ['Gbreve', [286]], ['gbreve', [287]], ['Gcedil', [290]], ['Gcirc', [284]], ['gcirc', [285]], ['Gcy', [1043]], ['gcy', [1075]], ['Gdot', [288]], ['gdot', [289]], ['ge', [8805]], ['gE', [8807]], ['gEl', [10892]], ['gel', [8923]], ['geq', [8805]], ['geqq', [8807]], ['geqslant', [10878]], ['gescc', [10921]], ['ges', [10878]], ['gesdot', [10880]], ['gesdoto', [10882]], ['gesdotol', [10884]], ['gesl', [8923, 65024]], ['gesles', [10900]], ['Gfr', [120074]], ['gfr', [120100]], ['gg', [8811]], ['Gg', [8921]], ['ggg', [8921]], ['gimel', [8503]], ['GJcy', [1027]], ['gjcy', [1107]], ['gla', [10917]], ['gl', [8823]], ['glE', [10898]], ['glj', [10916]], ['gnap', [10890]], ['gnapprox', [10890]], ['gne', [10888]], ['gnE', [8809]], ['gneq', [10888]], ['gneqq', [8809]], ['gnsim', [8935]], ['Gopf', [120126]], ['gopf', [120152]], ['grave', [96]], ['GreaterEqual', [8805]], ['GreaterEqualLess', [8923]], ['GreaterFullEqual', [8807]], ['GreaterGreater', [10914]], ['GreaterLess', [8823]], ['GreaterSlantEqual', [10878]], ['GreaterTilde', [8819]], ['Gscr', [119970]], ['gscr', [8458]], ['gsim', [8819]], ['gsime', [10894]], ['gsiml', [10896]], ['gtcc', [10919]], ['gtcir', [10874]], ['gt', [62]], ['GT', [62]], ['Gt', [8811]], ['gtdot', [8919]], ['gtlPar', [10645]], ['gtquest', [10876]], ['gtrapprox', [10886]], ['gtrarr', [10616]], ['gtrdot', [8919]], ['gtreqless', [8923]], ['gtreqqless', [10892]], ['gtrless', [8823]], ['gtrsim', [8819]], ['gvertneqq', [8809, 65024]], ['gvnE', [8809, 65024]], ['Hacek', [711]], ['hairsp', [8202]], ['half', [189]], ['hamilt', [8459]], ['HARDcy', [1066]], ['hardcy', [1098]], ['harrcir', [10568]], ['harr', [8596]], ['hArr', [8660]], ['harrw', [8621]], ['Hat', [94]], ['hbar', [8463]], ['Hcirc', [292]], ['hcirc', [293]], ['hearts', [9829]], ['heartsuit', [9829]], ['hellip', [8230]], ['hercon', [8889]], ['hfr', [120101]], ['Hfr', [8460]], ['HilbertSpace', [8459]], ['hksearow', [10533]], ['hkswarow', [10534]], ['hoarr', [8703]], ['homtht', [8763]], ['hookleftarrow', [8617]], ['hookrightarrow', [8618]], ['hopf', [120153]], ['Hopf', [8461]], ['horbar', [8213]], ['HorizontalLine', [9472]], ['hscr', [119997]], ['Hscr', [8459]], ['hslash', [8463]], ['Hstrok', [294]], ['hstrok', [295]], ['HumpDownHump', [8782]], ['HumpEqual', [8783]], ['hybull', [8259]], ['hyphen', [8208]], ['Iacute', [205]], ['iacute', [237]], ['ic', [8291]], ['Icirc', [206]], ['icirc', [238]], ['Icy', [1048]], ['icy', [1080]], ['Idot', [304]], ['IEcy', [1045]], ['iecy', [1077]], ['iexcl', [161]], ['iff', [8660]], ['ifr', [120102]], ['Ifr', [8465]], ['Igrave', [204]], ['igrave', [236]], ['ii', [8520]], ['iiiint', [10764]], ['iiint', [8749]], ['iinfin', [10716]], ['iiota', [8489]], ['IJlig', [306]], ['ijlig', [307]], ['Imacr', [298]], ['imacr', [299]], ['image', [8465]], ['ImaginaryI', [8520]], ['imagline', [8464]], ['imagpart', [8465]], ['imath', [305]], ['Im', [8465]], ['imof', [8887]], ['imped', [437]], ['Implies', [8658]], ['incare', [8453]], ['in', [8712]], ['infin', [8734]], ['infintie', [10717]], ['inodot', [305]], ['intcal', [8890]], ['int', [8747]], ['Int', [8748]], ['integers', [8484]], ['Integral', [8747]], ['intercal', [8890]], ['Intersection', [8898]], ['intlarhk', [10775]], ['intprod', [10812]], ['InvisibleComma', [8291]], ['InvisibleTimes', [8290]], ['IOcy', [1025]], ['iocy', [1105]], ['Iogon', [302]], ['iogon', [303]], ['Iopf', [120128]], ['iopf', [120154]], ['Iota', [921]], ['iota', [953]], ['iprod', [10812]], ['iquest', [191]], ['iscr', [119998]], ['Iscr', [8464]], ['isin', [8712]], ['isindot', [8949]], ['isinE', [8953]], ['isins', [8948]], ['isinsv', [8947]], ['isinv', [8712]], ['it', [8290]], ['Itilde', [296]], ['itilde', [297]], ['Iukcy', [1030]], ['iukcy', [1110]], ['Iuml', [207]], ['iuml', [239]], ['Jcirc', [308]], ['jcirc', [309]], ['Jcy', [1049]], ['jcy', [1081]], ['Jfr', [120077]], ['jfr', [120103]], ['jmath', [567]], ['Jopf', [120129]], ['jopf', [120155]], ['Jscr', [119973]], ['jscr', [119999]], ['Jsercy', [1032]], ['jsercy', [1112]], ['Jukcy', [1028]], ['jukcy', [1108]], ['Kappa', [922]], ['kappa', [954]], ['kappav', [1008]], ['Kcedil', [310]], ['kcedil', [311]], ['Kcy', [1050]], ['kcy', [1082]], ['Kfr', [120078]], ['kfr', [120104]], ['kgreen', [312]], ['KHcy', [1061]], ['khcy', [1093]], ['KJcy', [1036]], ['kjcy', [1116]], ['Kopf', [120130]], ['kopf', [120156]], ['Kscr', [119974]], ['kscr', [120000]], ['lAarr', [8666]], ['Lacute', [313]], ['lacute', [314]], ['laemptyv', [10676]], ['lagran', [8466]], ['Lambda', [923]], ['lambda', [955]], ['lang', [10216]], ['Lang', [10218]], ['langd', [10641]], ['langle', [10216]], ['lap', [10885]], ['Laplacetrf', [8466]], ['laquo', [171]], ['larrb', [8676]], ['larrbfs', [10527]], ['larr', [8592]], ['Larr', [8606]], ['lArr', [8656]], ['larrfs', [10525]], ['larrhk', [8617]], ['larrlp', [8619]], ['larrpl', [10553]], ['larrsim', [10611]], ['larrtl', [8610]], ['latail', [10521]], ['lAtail', [10523]], ['lat', [10923]], ['late', [10925]], ['lates', [10925, 65024]], ['lbarr', [10508]], ['lBarr', [10510]], ['lbbrk', [10098]], ['lbrace', [123]], ['lbrack', [91]], ['lbrke', [10635]], ['lbrksld', [10639]], ['lbrkslu', [10637]], ['Lcaron', [317]], ['lcaron', [318]], ['Lcedil', [315]], ['lcedil', [316]], ['lceil', [8968]], ['lcub', [123]], ['Lcy', [1051]], ['lcy', [1083]], ['ldca', [10550]], ['ldquo', [8220]], ['ldquor', [8222]], ['ldrdhar', [10599]], ['ldrushar', [10571]], ['ldsh', [8626]], ['le', [8804]], ['lE', [8806]], ['LeftAngleBracket', [10216]], ['LeftArrowBar', [8676]], ['leftarrow', [8592]], ['LeftArrow', [8592]], ['Leftarrow', [8656]], ['LeftArrowRightArrow', [8646]], ['leftarrowtail', [8610]], ['LeftCeiling', [8968]], ['LeftDoubleBracket', [10214]], ['LeftDownTeeVector', [10593]], ['LeftDownVectorBar', [10585]], ['LeftDownVector', [8643]], ['LeftFloor', [8970]], ['leftharpoondown', [8637]], ['leftharpoonup', [8636]], ['leftleftarrows', [8647]], ['leftrightarrow', [8596]], ['LeftRightArrow', [8596]], ['Leftrightarrow', [8660]], ['leftrightarrows', [8646]], ['leftrightharpoons', [8651]], ['leftrightsquigarrow', [8621]], ['LeftRightVector', [10574]], ['LeftTeeArrow', [8612]], ['LeftTee', [8867]], ['LeftTeeVector', [10586]], ['leftthreetimes', [8907]], ['LeftTriangleBar', [10703]], ['LeftTriangle', [8882]], ['LeftTriangleEqual', [8884]], ['LeftUpDownVector', [10577]], ['LeftUpTeeVector', [10592]], ['LeftUpVectorBar', [10584]], ['LeftUpVector', [8639]], ['LeftVectorBar', [10578]], ['LeftVector', [8636]], ['lEg', [10891]], ['leg', [8922]], ['leq', [8804]], ['leqq', [8806]], ['leqslant', [10877]], ['lescc', [10920]], ['les', [10877]], ['lesdot', [10879]], ['lesdoto', [10881]], ['lesdotor', [10883]], ['lesg', [8922, 65024]], ['lesges', [10899]], ['lessapprox', [10885]], ['lessdot', [8918]], ['lesseqgtr', [8922]], ['lesseqqgtr', [10891]], ['LessEqualGreater', [8922]], ['LessFullEqual', [8806]], ['LessGreater', [8822]], ['lessgtr', [8822]], ['LessLess', [10913]], ['lesssim', [8818]], ['LessSlantEqual', [10877]], ['LessTilde', [8818]], ['lfisht', [10620]], ['lfloor', [8970]], ['Lfr', [120079]], ['lfr', [120105]], ['lg', [8822]], ['lgE', [10897]], ['lHar', [10594]], ['lhard', [8637]], ['lharu', [8636]], ['lharul', [10602]], ['lhblk', [9604]], ['LJcy', [1033]], ['ljcy', [1113]], ['llarr', [8647]], ['ll', [8810]], ['Ll', [8920]], ['llcorner', [8990]], ['Lleftarrow', [8666]], ['llhard', [10603]], ['lltri', [9722]], ['Lmidot', [319]], ['lmidot', [320]], ['lmoustache', [9136]], ['lmoust', [9136]], ['lnap', [10889]], ['lnapprox', [10889]], ['lne', [10887]], ['lnE', [8808]], ['lneq', [10887]], ['lneqq', [8808]], ['lnsim', [8934]], ['loang', [10220]], ['loarr', [8701]], ['lobrk', [10214]], ['longleftarrow', [10229]], ['LongLeftArrow', [10229]], ['Longleftarrow', [10232]], ['longleftrightarrow', [10231]], ['LongLeftRightArrow', [10231]], ['Longleftrightarrow', [10234]], ['longmapsto', [10236]], ['longrightarrow', [10230]], ['LongRightArrow', [10230]], ['Longrightarrow', [10233]], ['looparrowleft', [8619]], ['looparrowright', [8620]], ['lopar', [10629]], ['Lopf', [120131]], ['lopf', [120157]], ['loplus', [10797]], ['lotimes', [10804]], ['lowast', [8727]], ['lowbar', [95]], ['LowerLeftArrow', [8601]], ['LowerRightArrow', [8600]], ['loz', [9674]], ['lozenge', [9674]], ['lozf', [10731]], ['lpar', [40]], ['lparlt', [10643]], ['lrarr', [8646]], ['lrcorner', [8991]], ['lrhar', [8651]], ['lrhard', [10605]], ['lrm', [8206]], ['lrtri', [8895]], ['lsaquo', [8249]], ['lscr', [120001]], ['Lscr', [8466]], ['lsh', [8624]], ['Lsh', [8624]], ['lsim', [8818]], ['lsime', [10893]], ['lsimg', [10895]], ['lsqb', [91]], ['lsquo', [8216]], ['lsquor', [8218]], ['Lstrok', [321]], ['lstrok', [322]], ['ltcc', [10918]], ['ltcir', [10873]], ['lt', [60]], ['LT', [60]], ['Lt', [8810]], ['ltdot', [8918]], ['lthree', [8907]], ['ltimes', [8905]], ['ltlarr', [10614]], ['ltquest', [10875]], ['ltri', [9667]], ['ltrie', [8884]], ['ltrif', [9666]], ['ltrPar', [10646]], ['lurdshar', [10570]], ['luruhar', [10598]], ['lvertneqq', [8808, 65024]], ['lvnE', [8808, 65024]], ['macr', [175]], ['male', [9794]], ['malt', [10016]], ['maltese', [10016]], ['Map', [10501]], ['map', [8614]], ['mapsto', [8614]], ['mapstodown', [8615]], ['mapstoleft', [8612]], ['mapstoup', [8613]], ['marker', [9646]], ['mcomma', [10793]], ['Mcy', [1052]], ['mcy', [1084]], ['mdash', [8212]], ['mDDot', [8762]], ['measuredangle', [8737]], ['MediumSpace', [8287]], ['Mellintrf', [8499]], ['Mfr', [120080]], ['mfr', [120106]], ['mho', [8487]], ['micro', [181]], ['midast', [42]], ['midcir', [10992]], ['mid', [8739]], ['middot', [183]], ['minusb', [8863]], ['minus', [8722]], ['minusd', [8760]], ['minusdu', [10794]], ['MinusPlus', [8723]], ['mlcp', [10971]], ['mldr', [8230]], ['mnplus', [8723]], ['models', [8871]], ['Mopf', [120132]], ['mopf', [120158]], ['mp', [8723]], ['mscr', [120002]], ['Mscr', [8499]], ['mstpos', [8766]], ['Mu', [924]], ['mu', [956]], ['multimap', [8888]], ['mumap', [8888]], ['nabla', [8711]], ['Nacute', [323]], ['nacute', [324]], ['nang', [8736, 8402]], ['nap', [8777]], ['napE', [10864, 824]], ['napid', [8779, 824]], ['napos', [329]], ['napprox', [8777]], ['natural', [9838]], ['naturals', [8469]], ['natur', [9838]], ['nbsp', [160]], ['nbump', [8782, 824]], ['nbumpe', [8783, 824]], ['ncap', [10819]], ['Ncaron', [327]], ['ncaron', [328]], ['Ncedil', [325]], ['ncedil', [326]], ['ncong', [8775]], ['ncongdot', [10861, 824]], ['ncup', [10818]], ['Ncy', [1053]], ['ncy', [1085]], ['ndash', [8211]], ['nearhk', [10532]], ['nearr', [8599]], ['neArr', [8663]], ['nearrow', [8599]], ['ne', [8800]], ['nedot', [8784, 824]], ['NegativeMediumSpace', [8203]], ['NegativeThickSpace', [8203]], ['NegativeThinSpace', [8203]], ['NegativeVeryThinSpace', [8203]], ['nequiv', [8802]], ['nesear', [10536]], ['nesim', [8770, 824]], ['NestedGreaterGreater', [8811]], ['NestedLessLess', [8810]], ['nexist', [8708]], ['nexists', [8708]], ['Nfr', [120081]], ['nfr', [120107]], ['ngE', [8807, 824]], ['nge', [8817]], ['ngeq', [8817]], ['ngeqq', [8807, 824]], ['ngeqslant', [10878, 824]], ['nges', [10878, 824]], ['nGg', [8921, 824]], ['ngsim', [8821]], ['nGt', [8811, 8402]], ['ngt', [8815]], ['ngtr', [8815]], ['nGtv', [8811, 824]], ['nharr', [8622]], ['nhArr', [8654]], ['nhpar', [10994]], ['ni', [8715]], ['nis', [8956]], ['nisd', [8954]], ['niv', [8715]], ['NJcy', [1034]], ['njcy', [1114]], ['nlarr', [8602]], ['nlArr', [8653]], ['nldr', [8229]], ['nlE', [8806, 824]], ['nle', [8816]], ['nleftarrow', [8602]], ['nLeftarrow', [8653]], ['nleftrightarrow', [8622]], ['nLeftrightarrow', [8654]], ['nleq', [8816]], ['nleqq', [8806, 824]], ['nleqslant', [10877, 824]], ['nles', [10877, 824]], ['nless', [8814]], ['nLl', [8920, 824]], ['nlsim', [8820]], ['nLt', [8810, 8402]], ['nlt', [8814]], ['nltri', [8938]], ['nltrie', [8940]], ['nLtv', [8810, 824]], ['nmid', [8740]], ['NoBreak', [8288]], ['NonBreakingSpace', [160]], ['nopf', [120159]], ['Nopf', [8469]], ['Not', [10988]], ['not', [172]], ['NotCongruent', [8802]], ['NotCupCap', [8813]], ['NotDoubleVerticalBar', [8742]], ['NotElement', [8713]], ['NotEqual', [8800]], ['NotEqualTilde', [8770, 824]], ['NotExists', [8708]], ['NotGreater', [8815]], ['NotGreaterEqual', [8817]], ['NotGreaterFullEqual', [8807, 824]], ['NotGreaterGreater', [8811, 824]], ['NotGreaterLess', [8825]], ['NotGreaterSlantEqual', [10878, 824]], ['NotGreaterTilde', [8821]], ['NotHumpDownHump', [8782, 824]], ['NotHumpEqual', [8783, 824]], ['notin', [8713]], ['notindot', [8949, 824]], ['notinE', [8953, 824]], ['notinva', [8713]], ['notinvb', [8951]], ['notinvc', [8950]], ['NotLeftTriangleBar', [10703, 824]], ['NotLeftTriangle', [8938]], ['NotLeftTriangleEqual', [8940]], ['NotLess', [8814]], ['NotLessEqual', [8816]], ['NotLessGreater', [8824]], ['NotLessLess', [8810, 824]], ['NotLessSlantEqual', [10877, 824]], ['NotLessTilde', [8820]], ['NotNestedGreaterGreater', [10914, 824]], ['NotNestedLessLess', [10913, 824]], ['notni', [8716]], ['notniva', [8716]], ['notnivb', [8958]], ['notnivc', [8957]], ['NotPrecedes', [8832]], ['NotPrecedesEqual', [10927, 824]], ['NotPrecedesSlantEqual', [8928]], ['NotReverseElement', [8716]], ['NotRightTriangleBar', [10704, 824]], ['NotRightTriangle', [8939]], ['NotRightTriangleEqual', [8941]], ['NotSquareSubset', [8847, 824]], ['NotSquareSubsetEqual', [8930]], ['NotSquareSuperset', [8848, 824]], ['NotSquareSupersetEqual', [8931]], ['NotSubset', [8834, 8402]], ['NotSubsetEqual', [8840]], ['NotSucceeds', [8833]], ['NotSucceedsEqual', [10928, 824]], ['NotSucceedsSlantEqual', [8929]], ['NotSucceedsTilde', [8831, 824]], ['NotSuperset', [8835, 8402]], ['NotSupersetEqual', [8841]], ['NotTilde', [8769]], ['NotTildeEqual', [8772]], ['NotTildeFullEqual', [8775]], ['NotTildeTilde', [8777]], ['NotVerticalBar', [8740]], ['nparallel', [8742]], ['npar', [8742]], ['nparsl', [11005, 8421]], ['npart', [8706, 824]], ['npolint', [10772]], ['npr', [8832]], ['nprcue', [8928]], ['nprec', [8832]], ['npreceq', [10927, 824]], ['npre', [10927, 824]], ['nrarrc', [10547, 824]], ['nrarr', [8603]], ['nrArr', [8655]], ['nrarrw', [8605, 824]], ['nrightarrow', [8603]], ['nRightarrow', [8655]], ['nrtri', [8939]], ['nrtrie', [8941]], ['nsc', [8833]], ['nsccue', [8929]], ['nsce', [10928, 824]], ['Nscr', [119977]], ['nscr', [120003]], ['nshortmid', [8740]], ['nshortparallel', [8742]], ['nsim', [8769]], ['nsime', [8772]], ['nsimeq', [8772]], ['nsmid', [8740]], ['nspar', [8742]], ['nsqsube', [8930]], ['nsqsupe', [8931]], ['nsub', [8836]], ['nsubE', [10949, 824]], ['nsube', [8840]], ['nsubset', [8834, 8402]], ['nsubseteq', [8840]], ['nsubseteqq', [10949, 824]], ['nsucc', [8833]], ['nsucceq', [10928, 824]], ['nsup', [8837]], ['nsupE', [10950, 824]], ['nsupe', [8841]], ['nsupset', [8835, 8402]], ['nsupseteq', [8841]], ['nsupseteqq', [10950, 824]], ['ntgl', [8825]], ['Ntilde', [209]], ['ntilde', [241]], ['ntlg', [8824]], ['ntriangleleft', [8938]], ['ntrianglelefteq', [8940]], ['ntriangleright', [8939]], ['ntrianglerighteq', [8941]], ['Nu', [925]], ['nu', [957]], ['num', [35]], ['numero', [8470]], ['numsp', [8199]], ['nvap', [8781, 8402]], ['nvdash', [8876]], ['nvDash', [8877]], ['nVdash', [8878]], ['nVDash', [8879]], ['nvge', [8805, 8402]], ['nvgt', [62, 8402]], ['nvHarr', [10500]], ['nvinfin', [10718]], ['nvlArr', [10498]], ['nvle', [8804, 8402]], ['nvlt', [60, 8402]], ['nvltrie', [8884, 8402]], ['nvrArr', [10499]], ['nvrtrie', [8885, 8402]], ['nvsim', [8764, 8402]], ['nwarhk', [10531]], ['nwarr', [8598]], ['nwArr', [8662]], ['nwarrow', [8598]], ['nwnear', [10535]], ['Oacute', [211]], ['oacute', [243]], ['oast', [8859]], ['Ocirc', [212]], ['ocirc', [244]], ['ocir', [8858]], ['Ocy', [1054]], ['ocy', [1086]], ['odash', [8861]], ['Odblac', [336]], ['odblac', [337]], ['odiv', [10808]], ['odot', [8857]], ['odsold', [10684]], ['OElig', [338]], ['oelig', [339]], ['ofcir', [10687]], ['Ofr', [120082]], ['ofr', [120108]], ['ogon', [731]], ['Ograve', [210]], ['ograve', [242]], ['ogt', [10689]], ['ohbar', [10677]], ['ohm', [937]], ['oint', [8750]], ['olarr', [8634]], ['olcir', [10686]], ['olcross', [10683]], ['oline', [8254]], ['olt', [10688]], ['Omacr', [332]], ['omacr', [333]], ['Omega', [937]], ['omega', [969]], ['Omicron', [927]], ['omicron', [959]], ['omid', [10678]], ['ominus', [8854]], ['Oopf', [120134]], ['oopf', [120160]], ['opar', [10679]], ['OpenCurlyDoubleQuote', [8220]], ['OpenCurlyQuote', [8216]], ['operp', [10681]], ['oplus', [8853]], ['orarr', [8635]], ['Or', [10836]], ['or', [8744]], ['ord', [10845]], ['order', [8500]], ['orderof', [8500]], ['ordf', [170]], ['ordm', [186]], ['origof', [8886]], ['oror', [10838]], ['orslope', [10839]], ['orv', [10843]], ['oS', [9416]], ['Oscr', [119978]], ['oscr', [8500]], ['Oslash', [216]], ['oslash', [248]], ['osol', [8856]], ['Otilde', [213]], ['otilde', [245]], ['otimesas', [10806]], ['Otimes', [10807]], ['otimes', [8855]], ['Ouml', [214]], ['ouml', [246]], ['ovbar', [9021]], ['OverBar', [8254]], ['OverBrace', [9182]], ['OverBracket', [9140]], ['OverParenthesis', [9180]], ['para', [182]], ['parallel', [8741]], ['par', [8741]], ['parsim', [10995]], ['parsl', [11005]], ['part', [8706]], ['PartialD', [8706]], ['Pcy', [1055]], ['pcy', [1087]], ['percnt', [37]], ['period', [46]], ['permil', [8240]], ['perp', [8869]], ['pertenk', [8241]], ['Pfr', [120083]], ['pfr', [120109]], ['Phi', [934]], ['phi', [966]], ['phiv', [981]], ['phmmat', [8499]], ['phone', [9742]], ['Pi', [928]], ['pi', [960]], ['pitchfork', [8916]], ['piv', [982]], ['planck', [8463]], ['planckh', [8462]], ['plankv', [8463]], ['plusacir', [10787]], ['plusb', [8862]], ['pluscir', [10786]], ['plus', [43]], ['plusdo', [8724]], ['plusdu', [10789]], ['pluse', [10866]], ['PlusMinus', [177]], ['plusmn', [177]], ['plussim', [10790]], ['plustwo', [10791]], ['pm', [177]], ['Poincareplane', [8460]], ['pointint', [10773]], ['popf', [120161]], ['Popf', [8473]], ['pound', [163]], ['prap', [10935]], ['Pr', [10939]], ['pr', [8826]], ['prcue', [8828]], ['precapprox', [10935]], ['prec', [8826]], ['preccurlyeq', [8828]], ['Precedes', [8826]], ['PrecedesEqual', [10927]], ['PrecedesSlantEqual', [8828]], ['PrecedesTilde', [8830]], ['preceq', [10927]], ['precnapprox', [10937]], ['precneqq', [10933]], ['precnsim', [8936]], ['pre', [10927]], ['prE', [10931]], ['precsim', [8830]], ['prime', [8242]], ['Prime', [8243]], ['primes', [8473]], ['prnap', [10937]], ['prnE', [10933]], ['prnsim', [8936]], ['prod', [8719]], ['Product', [8719]], ['profalar', [9006]], ['profline', [8978]], ['profsurf', [8979]], ['prop', [8733]], ['Proportional', [8733]], ['Proportion', [8759]], ['propto', [8733]], ['prsim', [8830]], ['prurel', [8880]], ['Pscr', [119979]], ['pscr', [120005]], ['Psi', [936]], ['psi', [968]], ['puncsp', [8200]], ['Qfr', [120084]], ['qfr', [120110]], ['qint', [10764]], ['qopf', [120162]], ['Qopf', [8474]], ['qprime', [8279]], ['Qscr', [119980]], ['qscr', [120006]], ['quaternions', [8461]], ['quatint', [10774]], ['quest', [63]], ['questeq', [8799]], ['quot', [34]], ['QUOT', [34]], ['rAarr', [8667]], ['race', [8765, 817]], ['Racute', [340]], ['racute', [341]], ['radic', [8730]], ['raemptyv', [10675]], ['rang', [10217]], ['Rang', [10219]], ['rangd', [10642]], ['range', [10661]], ['rangle', [10217]], ['raquo', [187]], ['rarrap', [10613]], ['rarrb', [8677]], ['rarrbfs', [10528]], ['rarrc', [10547]], ['rarr', [8594]], ['Rarr', [8608]], ['rArr', [8658]], ['rarrfs', [10526]], ['rarrhk', [8618]], ['rarrlp', [8620]], ['rarrpl', [10565]], ['rarrsim', [10612]], ['Rarrtl', [10518]], ['rarrtl', [8611]], ['rarrw', [8605]], ['ratail', [10522]], ['rAtail', [10524]], ['ratio', [8758]], ['rationals', [8474]], ['rbarr', [10509]], ['rBarr', [10511]], ['RBarr', [10512]], ['rbbrk', [10099]], ['rbrace', [125]], ['rbrack', [93]], ['rbrke', [10636]], ['rbrksld', [10638]], ['rbrkslu', [10640]], ['Rcaron', [344]], ['rcaron', [345]], ['Rcedil', [342]], ['rcedil', [343]], ['rceil', [8969]], ['rcub', [125]], ['Rcy', [1056]], ['rcy', [1088]], ['rdca', [10551]], ['rdldhar', [10601]], ['rdquo', [8221]], ['rdquor', [8221]], ['CloseCurlyDoubleQuote', [8221]], ['rdsh', [8627]], ['real', [8476]], ['realine', [8475]], ['realpart', [8476]], ['reals', [8477]], ['Re', [8476]], ['rect', [9645]], ['reg', [174]], ['REG', [174]], ['ReverseElement', [8715]], ['ReverseEquilibrium', [8651]], ['ReverseUpEquilibrium', [10607]], ['rfisht', [10621]], ['rfloor', [8971]], ['rfr', [120111]], ['Rfr', [8476]], ['rHar', [10596]], ['rhard', [8641]], ['rharu', [8640]], ['rharul', [10604]], ['Rho', [929]], ['rho', [961]], ['rhov', [1009]], ['RightAngleBracket', [10217]], ['RightArrowBar', [8677]], ['rightarrow', [8594]], ['RightArrow', [8594]], ['Rightarrow', [8658]], ['RightArrowLeftArrow', [8644]], ['rightarrowtail', [8611]], ['RightCeiling', [8969]], ['RightDoubleBracket', [10215]], ['RightDownTeeVector', [10589]], ['RightDownVectorBar', [10581]], ['RightDownVector', [8642]], ['RightFloor', [8971]], ['rightharpoondown', [8641]], ['rightharpoonup', [8640]], ['rightleftarrows', [8644]], ['rightleftharpoons', [8652]], ['rightrightarrows', [8649]], ['rightsquigarrow', [8605]], ['RightTeeArrow', [8614]], ['RightTee', [8866]], ['RightTeeVector', [10587]], ['rightthreetimes', [8908]], ['RightTriangleBar', [10704]], ['RightTriangle', [8883]], ['RightTriangleEqual', [8885]], ['RightUpDownVector', [10575]], ['RightUpTeeVector', [10588]], ['RightUpVectorBar', [10580]], ['RightUpVector', [8638]], ['RightVectorBar', [10579]], ['RightVector', [8640]], ['ring', [730]], ['risingdotseq', [8787]], ['rlarr', [8644]], ['rlhar', [8652]], ['rlm', [8207]], ['rmoustache', [9137]], ['rmoust', [9137]], ['rnmid', [10990]], ['roang', [10221]], ['roarr', [8702]], ['robrk', [10215]], ['ropar', [10630]], ['ropf', [120163]], ['Ropf', [8477]], ['roplus', [10798]], ['rotimes', [10805]], ['RoundImplies', [10608]], ['rpar', [41]], ['rpargt', [10644]], ['rppolint', [10770]], ['rrarr', [8649]], ['Rrightarrow', [8667]], ['rsaquo', [8250]], ['rscr', [120007]], ['Rscr', [8475]], ['rsh', [8625]], ['Rsh', [8625]], ['rsqb', [93]], ['rsquo', [8217]], ['rsquor', [8217]], ['CloseCurlyQuote', [8217]], ['rthree', [8908]], ['rtimes', [8906]], ['rtri', [9657]], ['rtrie', [8885]], ['rtrif', [9656]], ['rtriltri', [10702]], ['RuleDelayed', [10740]], ['ruluhar', [10600]], ['rx', [8478]], ['Sacute', [346]], ['sacute', [347]], ['sbquo', [8218]], ['scap', [10936]], ['Scaron', [352]], ['scaron', [353]], ['Sc', [10940]], ['sc', [8827]], ['sccue', [8829]], ['sce', [10928]], ['scE', [10932]], ['Scedil', [350]], ['scedil', [351]], ['Scirc', [348]], ['scirc', [349]], ['scnap', [10938]], ['scnE', [10934]], ['scnsim', [8937]], ['scpolint', [10771]], ['scsim', [8831]], ['Scy', [1057]], ['scy', [1089]], ['sdotb', [8865]], ['sdot', [8901]], ['sdote', [10854]], ['searhk', [10533]], ['searr', [8600]], ['seArr', [8664]], ['searrow', [8600]], ['sect', [167]], ['semi', [59]], ['seswar', [10537]], ['setminus', [8726]], ['setmn', [8726]], ['sext', [10038]], ['Sfr', [120086]], ['sfr', [120112]], ['sfrown', [8994]], ['sharp', [9839]], ['SHCHcy', [1065]], ['shchcy', [1097]], ['SHcy', [1064]], ['shcy', [1096]], ['ShortDownArrow', [8595]], ['ShortLeftArrow', [8592]], ['shortmid', [8739]], ['shortparallel', [8741]], ['ShortRightArrow', [8594]], ['ShortUpArrow', [8593]], ['shy', [173]], ['Sigma', [931]], ['sigma', [963]], ['sigmaf', [962]], ['sigmav', [962]], ['sim', [8764]], ['simdot', [10858]], ['sime', [8771]], ['simeq', [8771]], ['simg', [10910]], ['simgE', [10912]], ['siml', [10909]], ['simlE', [10911]], ['simne', [8774]], ['simplus', [10788]], ['simrarr', [10610]], ['slarr', [8592]], ['SmallCircle', [8728]], ['smallsetminus', [8726]], ['smashp', [10803]], ['smeparsl', [10724]], ['smid', [8739]], ['smile', [8995]], ['smt', [10922]], ['smte', [10924]], ['smtes', [10924, 65024]], ['SOFTcy', [1068]], ['softcy', [1100]], ['solbar', [9023]], ['solb', [10692]], ['sol', [47]], ['Sopf', [120138]], ['sopf', [120164]], ['spades', [9824]], ['spadesuit', [9824]], ['spar', [8741]], ['sqcap', [8851]], ['sqcaps', [8851, 65024]], ['sqcup', [8852]], ['sqcups', [8852, 65024]], ['Sqrt', [8730]], ['sqsub', [8847]], ['sqsube', [8849]], ['sqsubset', [8847]], ['sqsubseteq', [8849]], ['sqsup', [8848]], ['sqsupe', [8850]], ['sqsupset', [8848]], ['sqsupseteq', [8850]], ['square', [9633]], ['Square', [9633]], ['SquareIntersection', [8851]], ['SquareSubset', [8847]], ['SquareSubsetEqual', [8849]], ['SquareSuperset', [8848]], ['SquareSupersetEqual', [8850]], ['SquareUnion', [8852]], ['squarf', [9642]], ['squ', [9633]], ['squf', [9642]], ['srarr', [8594]], ['Sscr', [119982]], ['sscr', [120008]], ['ssetmn', [8726]], ['ssmile', [8995]], ['sstarf', [8902]], ['Star', [8902]], ['star', [9734]], ['starf', [9733]], ['straightepsilon', [1013]], ['straightphi', [981]], ['strns', [175]], ['sub', [8834]], ['Sub', [8912]], ['subdot', [10941]], ['subE', [10949]], ['sube', [8838]], ['subedot', [10947]], ['submult', [10945]], ['subnE', [10955]], ['subne', [8842]], ['subplus', [10943]], ['subrarr', [10617]], ['subset', [8834]], ['Subset', [8912]], ['subseteq', [8838]], ['subseteqq', [10949]], ['SubsetEqual', [8838]], ['subsetneq', [8842]], ['subsetneqq', [10955]], ['subsim', [10951]], ['subsub', [10965]], ['subsup', [10963]], ['succapprox', [10936]], ['succ', [8827]], ['succcurlyeq', [8829]], ['Succeeds', [8827]], ['SucceedsEqual', [10928]], ['SucceedsSlantEqual', [8829]], ['SucceedsTilde', [8831]], ['succeq', [10928]], ['succnapprox', [10938]], ['succneqq', [10934]], ['succnsim', [8937]], ['succsim', [8831]], ['SuchThat', [8715]], ['sum', [8721]], ['Sum', [8721]], ['sung', [9834]], ['sup1', [185]], ['sup2', [178]], ['sup3', [179]], ['sup', [8835]], ['Sup', [8913]], ['supdot', [10942]], ['supdsub', [10968]], ['supE', [10950]], ['supe', [8839]], ['supedot', [10948]], ['Superset', [8835]], ['SupersetEqual', [8839]], ['suphsol', [10185]], ['suphsub', [10967]], ['suplarr', [10619]], ['supmult', [10946]], ['supnE', [10956]], ['supne', [8843]], ['supplus', [10944]], ['supset', [8835]], ['Supset', [8913]], ['supseteq', [8839]], ['supseteqq', [10950]], ['supsetneq', [8843]], ['supsetneqq', [10956]], ['supsim', [10952]], ['supsub', [10964]], ['supsup', [10966]], ['swarhk', [10534]], ['swarr', [8601]], ['swArr', [8665]], ['swarrow', [8601]], ['swnwar', [10538]], ['szlig', [223]], ['Tab', [9]], ['target', [8982]], ['Tau', [932]], ['tau', [964]], ['tbrk', [9140]], ['Tcaron', [356]], ['tcaron', [357]], ['Tcedil', [354]], ['tcedil', [355]], ['Tcy', [1058]], ['tcy', [1090]], ['tdot', [8411]], ['telrec', [8981]], ['Tfr', [120087]], ['tfr', [120113]], ['there4', [8756]], ['therefore', [8756]], ['Therefore', [8756]], ['Theta', [920]], ['theta', [952]], ['thetasym', [977]], ['thetav', [977]], ['thickapprox', [8776]], ['thicksim', [8764]], ['ThickSpace', [8287, 8202]], ['ThinSpace', [8201]], ['thinsp', [8201]], ['thkap', [8776]], ['thksim', [8764]], ['THORN', [222]], ['thorn', [254]], ['tilde', [732]], ['Tilde', [8764]], ['TildeEqual', [8771]], ['TildeFullEqual', [8773]], ['TildeTilde', [8776]], ['timesbar', [10801]], ['timesb', [8864]], ['times', [215]], ['timesd', [10800]], ['tint', [8749]], ['toea', [10536]], ['topbot', [9014]], ['topcir', [10993]], ['top', [8868]], ['Topf', [120139]], ['topf', [120165]], ['topfork', [10970]], ['tosa', [10537]], ['tprime', [8244]], ['trade', [8482]], ['TRADE', [8482]], ['triangle', [9653]], ['triangledown', [9663]], ['triangleleft', [9667]], ['trianglelefteq', [8884]], ['triangleq', [8796]], ['triangleright', [9657]], ['trianglerighteq', [8885]], ['tridot', [9708]], ['trie', [8796]], ['triminus', [10810]], ['TripleDot', [8411]], ['triplus', [10809]], ['trisb', [10701]], ['tritime', [10811]], ['trpezium', [9186]], ['Tscr', [119983]], ['tscr', [120009]], ['TScy', [1062]], ['tscy', [1094]], ['TSHcy', [1035]], ['tshcy', [1115]], ['Tstrok', [358]], ['tstrok', [359]], ['twixt', [8812]], ['twoheadleftarrow', [8606]], ['twoheadrightarrow', [8608]], ['Uacute', [218]], ['uacute', [250]], ['uarr', [8593]], ['Uarr', [8607]], ['uArr', [8657]], ['Uarrocir', [10569]], ['Ubrcy', [1038]], ['ubrcy', [1118]], ['Ubreve', [364]], ['ubreve', [365]], ['Ucirc', [219]], ['ucirc', [251]], ['Ucy', [1059]], ['ucy', [1091]], ['udarr', [8645]], ['Udblac', [368]], ['udblac', [369]], ['udhar', [10606]], ['ufisht', [10622]], ['Ufr', [120088]], ['ufr', [120114]], ['Ugrave', [217]], ['ugrave', [249]], ['uHar', [10595]], ['uharl', [8639]], ['uharr', [8638]], ['uhblk', [9600]], ['ulcorn', [8988]], ['ulcorner', [8988]], ['ulcrop', [8975]], ['ultri', [9720]], ['Umacr', [362]], ['umacr', [363]], ['uml', [168]], ['UnderBar', [95]], ['UnderBrace', [9183]], ['UnderBracket', [9141]], ['UnderParenthesis', [9181]], ['Union', [8899]], ['UnionPlus', [8846]], ['Uogon', [370]], ['uogon', [371]], ['Uopf', [120140]], ['uopf', [120166]], ['UpArrowBar', [10514]], ['uparrow', [8593]], ['UpArrow', [8593]], ['Uparrow', [8657]], ['UpArrowDownArrow', [8645]], ['updownarrow', [8597]], ['UpDownArrow', [8597]], ['Updownarrow', [8661]], ['UpEquilibrium', [10606]], ['upharpoonleft', [8639]], ['upharpoonright', [8638]], ['uplus', [8846]], ['UpperLeftArrow', [8598]], ['UpperRightArrow', [8599]], ['upsi', [965]], ['Upsi', [978]], ['upsih', [978]], ['Upsilon', [933]], ['upsilon', [965]], ['UpTeeArrow', [8613]], ['UpTee', [8869]], ['upuparrows', [8648]], ['urcorn', [8989]], ['urcorner', [8989]], ['urcrop', [8974]], ['Uring', [366]], ['uring', [367]], ['urtri', [9721]], ['Uscr', [119984]], ['uscr', [120010]], ['utdot', [8944]], ['Utilde', [360]], ['utilde', [361]], ['utri', [9653]], ['utrif', [9652]], ['uuarr', [8648]], ['Uuml', [220]], ['uuml', [252]], ['uwangle', [10663]], ['vangrt', [10652]], ['varepsilon', [1013]], ['varkappa', [1008]], ['varnothing', [8709]], ['varphi', [981]], ['varpi', [982]], ['varpropto', [8733]], ['varr', [8597]], ['vArr', [8661]], ['varrho', [1009]], ['varsigma', [962]], ['varsubsetneq', [8842, 65024]], ['varsubsetneqq', [10955, 65024]], ['varsupsetneq', [8843, 65024]], ['varsupsetneqq', [10956, 65024]], ['vartheta', [977]], ['vartriangleleft', [8882]], ['vartriangleright', [8883]], ['vBar', [10984]], ['Vbar', [10987]], ['vBarv', [10985]], ['Vcy', [1042]], ['vcy', [1074]], ['vdash', [8866]], ['vDash', [8872]], ['Vdash', [8873]], ['VDash', [8875]], ['Vdashl', [10982]], ['veebar', [8891]], ['vee', [8744]], ['Vee', [8897]], ['veeeq', [8794]], ['vellip', [8942]], ['verbar', [124]], ['Verbar', [8214]], ['vert', [124]], ['Vert', [8214]], ['VerticalBar', [8739]], ['VerticalLine', [124]], ['VerticalSeparator', [10072]], ['VerticalTilde', [8768]], ['VeryThinSpace', [8202]], ['Vfr', [120089]], ['vfr', [120115]], ['vltri', [8882]], ['vnsub', [8834, 8402]], ['vnsup', [8835, 8402]], ['Vopf', [120141]], ['vopf', [120167]], ['vprop', [8733]], ['vrtri', [8883]], ['Vscr', [119985]], ['vscr', [120011]], ['vsubnE', [10955, 65024]], ['vsubne', [8842, 65024]], ['vsupnE', [10956, 65024]], ['vsupne', [8843, 65024]], ['Vvdash', [8874]], ['vzigzag', [10650]], ['Wcirc', [372]], ['wcirc', [373]], ['wedbar', [10847]], ['wedge', [8743]], ['Wedge', [8896]], ['wedgeq', [8793]], ['weierp', [8472]], ['Wfr', [120090]], ['wfr', [120116]], ['Wopf', [120142]], ['wopf', [120168]], ['wp', [8472]], ['wr', [8768]], ['wreath', [8768]], ['Wscr', [119986]], ['wscr', [120012]], ['xcap', [8898]], ['xcirc', [9711]], ['xcup', [8899]], ['xdtri', [9661]], ['Xfr', [120091]], ['xfr', [120117]], ['xharr', [10231]], ['xhArr', [10234]], ['Xi', [926]], ['xi', [958]], ['xlarr', [10229]], ['xlArr', [10232]], ['xmap', [10236]], ['xnis', [8955]], ['xodot', [10752]], ['Xopf', [120143]], ['xopf', [120169]], ['xoplus', [10753]], ['xotime', [10754]], ['xrarr', [10230]], ['xrArr', [10233]], ['Xscr', [119987]], ['xscr', [120013]], ['xsqcup', [10758]], ['xuplus', [10756]], ['xutri', [9651]], ['xvee', [8897]], ['xwedge', [8896]], ['Yacute', [221]], ['yacute', [253]], ['YAcy', [1071]], ['yacy', [1103]], ['Ycirc', [374]], ['ycirc', [375]], ['Ycy', [1067]], ['ycy', [1099]], ['yen', [165]], ['Yfr', [120092]], ['yfr', [120118]], ['YIcy', [1031]], ['yicy', [1111]], ['Yopf', [120144]], ['yopf', [120170]], ['Yscr', [119988]], ['yscr', [120014]], ['YUcy', [1070]], ['yucy', [1102]], ['yuml', [255]], ['Yuml', [376]], ['Zacute', [377]], ['zacute', [378]], ['Zcaron', [381]], ['zcaron', [382]], ['Zcy', [1047]], ['zcy', [1079]], ['Zdot', [379]], ['zdot', [380]], ['zeetrf', [8488]], ['ZeroWidthSpace', [8203]], ['Zeta', [918]], ['zeta', [950]], ['zfr', [120119]], ['Zfr', [8488]], ['ZHcy', [1046]], ['zhcy', [1078]], ['zigrarr', [8669]], ['zopf', [120171]], ['Zopf', [8484]], ['Zscr', [119989]], ['zscr', [120015]], ['zwj', [8205]], ['zwnj', [8204]]];
	var alphaIndex = {};
	var charIndex = {};
	createIndexes(alphaIndex, charIndex);
	var Html5Entities = /** @class */ (function () {
	    function Html5Entities() {
	    }
	    Html5Entities.prototype.decode = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        return str.replace(/&(#?[\w\d]+);?/g, function (s, entity) {
	            var chr;
	            if (entity.charAt(0) === "#") {
	                var code = entity.charAt(1) === 'x' ?
	                    parseInt(entity.substr(2).toLowerCase(), 16) :
	                    parseInt(entity.substr(1));
	                if (!(isNaN(code) || code < -32768 || code > 65535)) {
	                    chr = String.fromCharCode(code);
	                }
	            }
	            else {
	                chr = alphaIndex[entity];
	            }
	            return chr || s;
	        });
	    };
	    Html5Entities.decode = function (str) {
	        return new Html5Entities().decode(str);
	    };
	    Html5Entities.prototype.encode = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLength = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLength) {
	            var charInfo = charIndex[str.charCodeAt(i)];
	            if (charInfo) {
	                var alpha = charInfo[str.charCodeAt(i + 1)];
	                if (alpha) {
	                    i++;
	                }
	                else {
	                    alpha = charInfo[''];
	                }
	                if (alpha) {
	                    result += "&" + alpha + ";";
	                    i++;
	                    continue;
	                }
	            }
	            result += str.charAt(i);
	            i++;
	        }
	        return result;
	    };
	    Html5Entities.encode = function (str) {
	        return new Html5Entities().encode(str);
	    };
	    Html5Entities.prototype.encodeNonUTF = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLength = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLength) {
	            var c = str.charCodeAt(i);
	            var charInfo = charIndex[c];
	            if (charInfo) {
	                var alpha = charInfo[str.charCodeAt(i + 1)];
	                if (alpha) {
	                    i++;
	                }
	                else {
	                    alpha = charInfo[''];
	                }
	                if (alpha) {
	                    result += "&" + alpha + ";";
	                    i++;
	                    continue;
	                }
	            }
	            if (c < 32 || c > 126) {
	                result += '&#' + c + ';';
	            }
	            else {
	                result += str.charAt(i);
	            }
	            i++;
	        }
	        return result;
	    };
	    Html5Entities.encodeNonUTF = function (str) {
	        return new Html5Entities().encodeNonUTF(str);
	    };
	    Html5Entities.prototype.encodeNonASCII = function (str) {
	        if (!str || !str.length) {
	            return '';
	        }
	        var strLength = str.length;
	        var result = '';
	        var i = 0;
	        while (i < strLength) {
	            var c = str.charCodeAt(i);
	            if (c <= 255) {
	                result += str[i++];
	                continue;
	            }
	            result += '&#' + c + ';';
	            i++;
	        }
	        return result;
	    };
	    Html5Entities.encodeNonASCII = function (str) {
	        return new Html5Entities().encodeNonASCII(str);
	    };
	    return Html5Entities;
	}());
	exports.Html5Entities = Html5Entities;
	function createIndexes(alphaIndex, charIndex) {
	    var i = ENTITIES.length;
	    while (i--) {
	        var e = ENTITIES[i];
	        var alpha = e[0];
	        var chars = e[1];
	        var chr = chars[0];
	        var addChar = (chr < 32 || chr > 126) || chr === 62 || chr === 60 || chr === 38 || chr === 34 || chr === 39;
	        var charInfo = void 0;
	        if (addChar) {
	            charInfo = charIndex[chr] = charIndex[chr] || {};
	        }
	        if (chars[1]) {
	            var chr2 = chars[1];
	            alphaIndex[alpha] = String.fromCharCode(chr) + String.fromCharCode(chr2);
	            addChar && (charInfo[chr2] = alpha);
	        }
	        else {
	            alphaIndex[alpha] = String.fromCharCode(chr);
	            addChar && (charInfo[''] = alpha);
	        }
	    }
	}


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.add-article', ['common.header', 'common.footer', 'config', 'directives.contenteditable', 'account.settings.social', 'security.service', 'security.authorization', 'services.accountResource', 'services.utility', 'services.formErrors', 'ui.bootstrap', 'directives.serverError', 'ngTagsInput', 'ngFileUpload', 'toggle-switch', 'angular-growl', 'ckeditor', 'resources.User', 'resources.Category', 'resources.Article', 'resources.Tag', 'filters.rawHtml', 'ckeditorPlaceholder', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.add-article', {
	    url: '/add-article',
	    title: 'Add Article',
	    views: {
	      'main@': {
	        template: __webpack_require__(159),
	        controller: 'AddArticleCtrl',
	        resolve: {
	          categories: ["Category", function (Category) {
	            var options = [];
	            var generateCategoryOptions = function generateCategoryOptions(items, container) {
	              items.forEach(function (item) {
	                if (!item.path) {
	                  return;
	                }
	                var depth = item.path.split('/').filter(Boolean).length;
	                var indent = new Array(5).join(String.fromCharCode(160));
	                container.push({
	                  _id: item._id,
	                  id: item.id,
	                  path: item.path,
	                  sefriendly: item.sefriendly,
	                  parent: item.parent,
	                  parent_id: item.parent_id,
	                  name: item.name,
	                  _name: new Array(depth).join(indent) + item.name
	                });
	                if (item.children) {
	                  generateCategoryOptions(item.children, container);
	                }
	              });
	              return container;
	            };
	
	            return Category.getPermittedTree().$promise.then(function (data) {
	              generateCategoryOptions(data, options);
	              return options;
	            });
	          }],
	          locations: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type: 'location' });
	          }],
	          playersAndTeams: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
	          }]
	        }
	      }
	    }
	  });
	}]).controller('AddArticleCtrl', ["$scope", "$location", "$log", "$interval", "security", "utility", "growl", "user", "categories", "locations", "playersAndTeams", "adminResource", "SOCIAL", "STATUSES", "ARTICLE_STYLES", "APP_IMG_URLS", "Upload", "formErrors", "dateFilter", "Article", "Tag", "localizedMessages", function ($scope, $location, $log, $interval, security, utility, growl, user, categories, locations, playersAndTeams, adminResource, SOCIAL, STATUSES, ARTICLE_STYLES, APP_IMG_URLS, Upload, formErrors, dateFilter, Article, Tag, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  var urlGenerated = false;
	  var now = new Date();
	  var timer = null;
	  var currentDateTime = moment();
	  var slugify = __webpack_require__(152);
	
	  $scope.statuses = _.filter(STATUSES, function (status) {
	    return ~user.permissions.statuses.indexOf(status.id);
	  });
	  if (user.permissions.statuses[0] === '*') {
	    $scope.statuses = STATUSES;
	  }
	  $scope.statuses.map(function (s) {
	    s.value = s.value.split("?").join('');
	  });
	  $scope.categories = categories;
	  $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
	    return { _id: p._id, name: p.name };
	  }) : [];
	  $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
	    return {
	      _id: p._id,
	      name: p.name,
	      type: p.role.role_type
	    };
	  }) : [];
	  $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function (e) {
	    return e.type === 'profile';
	  }) : [];
	  $scope.article_styles = ARTICLE_STYLES;
	  $scope.alerts = [];
	  $scope.uploading = false;
	  $scope.isSaving = false;
	  $scope.autosaveTimer = 180;
	  $scope.imgUrl = APP_IMG_URLS['base'];
	  $scope.accordion = {
	    score: true,
	    publishing_date: true,
	    url: true,
	    image: true,
	    published_by: false
	  };
	
	  $scope.ckOptions = {
	    language: 'pl',
	    uiColor: '#08152B'
	  };
	
	  $scope.isAdmin = false;
	  if (user.permissions.is_admin) {
	    $scope.isAdmin = true;
	    console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
	  }
	  $scope.data = {
	    title: '',
	    sefriendly: '',
	    status: {
	      id: '0',
	      value: localizedMessages.get('pending')
	    },
	    image: '',
	    video: '',
	    image_caption: '',
	    body: '',
	    abstract: '',
	    equipo_local: '',
	    equipo_visitante: '',
	    goals: '',
	    goles_local: '',
	    goles_visitante: '',
	    referee: '',
	    incidents: '',
	    show_inarticle: ARTICLE_STYLES[1],
	    category: '',
	    tags: '',
	    author: {
	      picture: user.account.avatar || user.account.picture,
	      twitter: user.account.twitter,
	      plus: user.account.plus,
	      name: user.account.name.full,
	      username: user.username
	    },
	    orderNumber: 0,
	    last_edited_by: {
	      name: user.account.name.full,
	      username: user.username
	    },
	    published_by: {
	      name: '',
	      username: ''
	    },
	    publish_date: currentDateTime.local().format('YYYY-MM-DD HH:mm')
	  };
	
	  var startTimer = function startTimer() {
	    return $interval(function () {
	      if ($scope.autosaveTimer <= 0) {
	        $scope.save();
	      }
	      $scope.autosaveTimer -= 1;
	    }, 1000);
	  };
	
	  var resetTimer = function resetTimer() {
	    $scope.autosaveTimer = 180;
	    $interval.cancel(timer);
	  };
	
	  $scope.autosaveChanged = function () {
	    if ($scope.autosave) {
	      timer = startTimer();
	    } else {
	      resetTimer();
	    }
	  };
	
	  $scope.titleChanged = function () {
	    $scope.data.title = $scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " ");
	    if ($scope.data.sefriendly) {
	      return;
	    }
	    $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " "));
	    // console.log('>>>', $scope.data.sefriendly);
	  };
	
	  $scope.canChangeAuthor = function () {
	    return user.permissions.is_editor && $scope.canChangeCategory();
	  };
	
	  $scope.canChangeCategory = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	
	    // return ~user.permissions.categories.indexOf(article.category.id);
	  };
	
	  $scope.save = function () {
	    resetTimer();
	    $scope.autosaveChanged();
	    $scope.data.sefriendly = slugify($scope.data.sefriendly);
	
	    //validate
	    if (!$scope.data.title) {
	      growl.error('Title is required');
	      return;
	    }
	
	    if (!$scope.data.category) {
	      growl.error('Category is required');
	      return;
	    }
	
	    if (!$scope.data.body) {
	      growl.error('Body is required');
	      return;
	    }
	
	    $scope.isSaving = true;
	
	    var data = angular.copy($scope.data);
	
	    data.edition = data.category.path.split("/")[1];
	    data.show_inarticle = parseInt(data.show_inarticle.id, null);
	    data.status = parseInt(data.status.id, null);
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text)
	      };
	    });
	
	    data.publish_date = (data.publish_date ? moment(data.publish_date) : currentDateTime).toISOString();
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.published_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    var catArray = data.category.parent == "/" ? [] : data.category.parent.substring(1).split('/');
	    var pDate = new Date(data.publish_date);
	    var pMonth = pDate.getUTCMonth() + 1;
	    var dateSeg = '/' + pDate.getUTCFullYear() + '/' + ('0' + pMonth).slice(-2) + '/' + ('0' + pDate.getUTCDate()).slice(-2) + '/';
	    data.url_segment = dateSeg;
	    if (catArray.length == 0) {
	      data.url_segment = '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length == 1) {
	      data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length > 1) {
	      data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
	    }
	
	    // console.log( '>>> data.body', data.body );
	    Article.save(data, function (result) {
	      setTimeout(function () {
	        growl.info('Article have been created.');
	        $location.path('/account/edit-article/' + result.article_id);
	      }, 1000);
	    }, formErrors.growlErrors).$promise.then(function () {
	      setTimeout(function () {
	        $scope.isSaving = false;
	      }, 5000);
	    });
	  };
	
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    if (!$scope.isSaving) {
	      return true;
	      //var answer = confirm("Are you sure you want to navigate away from this page");
	      //if (!answer) {
	      //  event.preventDefault();
	      //}
	    }
	  });
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.thumbnail = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.loadTags = function (query) {
	    return Tag.search({ q: query }).$promise.then(function (tags) {
	      if (!tags) return [];
	      return tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.nametag,
	          name: tag.nametag,
	          oficial: tag.oficial,
	          sefriendly: tag.name
	        };
	      });
	    });
	  };
	  try {
	    $('span.input').each(function (element) {
	      $(this).text("Dodaj tag");
	    });
	  } catch (error) {}
	
	  $scope.changePT1 = function (pt1) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt1;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_local_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.changePT2 = function (pt2) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt2;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_visitante_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.loadProfiles = function (query) {
	    return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
	      if (!profiles) return [];
	      var searchName = query.toLowerCase();
	      return profiles.data.filter(function (p) {
	        var name = p.name.toLowerCase();
	        return name.indexOf(searchName) > -1;
	      }).map(function (p) {
	        return {
	          _id: p._id,
	          name: p.name
	        };
	      });
	    });
	  };
	}]);

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports = "<style>.ubuntu{font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif}.droid{font-family:'Open Sans',Georgia,'Times New Roman',Times,serif;font-size:19px}.open-sans{font-family:'Open Sans',sans-serif}h2{font-family:Open Sans,Georgia;font-size:30px;padding-top:10px;margin-bottom:15px;padding-left:0;padding-right:5px;font-weight:700;letter-spacing:-1px;line-height:120%}p{font-size:19px;color:#444;margin:0 0 30px 0;padding-top:0;font-family:Open Sans,Georgia,\"Times New Roman\",Times,serif;line-height:145%;text-align:justify}.image_caption_news{font-size:11px;font-style:italic;color:#777;background-color:#eee;padding:15px;border-bottom:1px #ddd solid;border-top:1px #ddd solid;margin-bottom:20px}.page-header{padding-bottom:10px;margin:0 0 18px}#save{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}#switch{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}.side-row{padding:10px;color:#fff;background:#28a5e4}.toggle-switch{min-width:64px;border-color:#848484;font-size:11px}.toggle-switch span{line-height:inherit}.toggle-switch .switch-left{background:#63c663;color:#fff}.toggle-switch .switch-right{background:#c43939;color:#fff}.no-margin{margin:0}.no-border{border:0;border-radius:0}oi-select{width:200px}oi-select .select-dropdown,oi-select .select-search-list-item,oi-select .select-search-list-item_input input{font-size:13px;white-space:nowrap}oi-select .select-dropdown{max-height:200px}oi-select .select-search-list-item_selection{box-shadow:none}.right-sidebar .form-inline{border-bottom:1px solid #e4e3e3}.right-sidebar .form-inline.no-border{border:0;border-radius:0}.right-sidebar .panel{margin:0}.right-sidebar .panel-body{background-color:#f9f9f9}.right-sidebar .form-inline .form-group{margin:10px 0;width:100%}.right-sidebar .form-inline label{font-size:12px;font-weight:400}.right-sidebar .form-inline input{float:right;height:26px}.right-sidebar oi-select .select-search{background:#eee}.right-sidebar .form-inline input,.right-sidebar .form-inline select,.right-sidebar .form-inline textarea{font-size:12px;font-weight:400;width:150px;margin-left:30px;border-radius:0;background:#eee}.right-sidebar .form-inline textarea{width:250px;margin-left:0}.right-sidebar input[type=datetime-local]{margin-left:0;width:100%}.right-sidebar tags-input .host{position:static}.margin-sidebar{margin-top:98px}.fixed-save{position:fixed;top:0;width:293px}.fixed-publishing{position:fixed;top:96px;width:293px}.dragover{padding:10px;border:2px dashed #28a5e4}.PhotoFull img{width:700px}.PhotoRight{width:400px;float:right;margin:1em}.PhotoRight figcaption{margin:0}.PhotoMinifull{width:440px}.PhotoMinifull+article{width:440px}.Newspapermode{display:none}.Liveevent figcaption{margin-bottom:0}.Liveevent{margin-bottom:20px}.Liveevent+article{font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,\"Times New Roman\",Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article{background-color:#fff;font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,\"Times New Roman\",Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article img{margin:auto;display:block;border:10px #fff solid;border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;-moz-box-shadow:0 0 3px rgba(0,0,0,.15);-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15)}.Liveevent+article p{border-bottom:1px solid grey;margin:0;padding:10px 10px}.score_number{background-color:#fff;font-size:44px;color:#222;line-height:44px;padding:7px 20px;font-weight:700;-moz-border-radius:55px;-webkit-border-radius:55px;border-radius:55px;text-align:center;max-width:30px;overflow:hidden}#score_bar{padding-top:25px;padding-bottom:60px;width:100%;min-height:65px;background:-moz-linear-gradient(top,#fff 0,#eee 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),color-stop(100%,#eee));background:-webkit-linear-gradient(top,#fff 0,#eee 100%);background:-o-linear-gradient(top,#fff 0,#eee 100%);background:-ms-linear-gradient(top,#fff 0,#eee 100%);background:linear-gradient(top,#fff 0,#eee 100%);border-radius:0;border-bottom:4px #fff solid;margin-bottom:20px}#score_team{width:31%;font-size:24px;color:#222;font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif;text-align:center;font-weight:777;padding-top:10px}</style> <div class=row id=add-article style=margin-top:10px> <div class=col-xs-12> <div class=page-header> <form class=form-inline> <div class=pull-right> </div> <div class=form-group> <oi-select oi-options=\"option._name for option in categories track by option.id\" oi-select-options=selectSettings ng-model=data.category placeholder=\"Wybierz kategorie\"></oi-select> </div> <div class=form-group> <oi-select oi-options=\"option.value for option in statuses track by option.id\" ng-model=data.status placeholder=\"Wybierz status\"></oi-select> </div> <div class=form-group> <oi-select oi-options=\"option.value for option in article_styles track by option.id\" oi-select-options=selectSettings ng-model=data.show_inarticle placeholder=\"Wybierz format\"></oi-select> </div> </form> </div> </div> </div> <div class=\"row w990\"> <div class=col-sm-8> <form> <h1 ng-model=data.title class=\"text-center ubuntu\" contenteditable=true placeholder=\"{{localizedMessages.get('add-title')}}\" style=margin-top:0 ng-blur=titleChanged()></h1> <h4 ng-model=data.abstract class=\"text-justify open-sans\" contenteditable=true placeholder=\"{{localizedMessages.get('add-description-article')}}\"></h4> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-upload ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ngf-thumbnail=\"thumbnail || (data.image ? imgUrl + data.image : false) || imgUrl + 'upload-iworis-1603084085694.png'\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15)\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <figcaption ng-model=data.image_caption contenteditable=true class=\"text-center image_caption_news\" id=image_caption placeholder=\"{{localizedMessages.get('add-image-caption')}}\" style=min-height:20px> </figcaption> <article ng-model=data.body ckeditor=ckOptions contenteditable=true ready=onReady() class=\"text-justify article-content droid\" spellcheck=false style=position:relative placeholder=\"{{localizedMessages.get('start-writing')}}\"> </article> <br> <br> <div> <h5><strong>{{localizedMessages.get('allowing-spaces')}}</strong></h5> <p>{{localizedMessages.get('allowing-spaces-helper')}}</p> <tags-input ng-model=data.tags replace-spaces-with-dashes=false add-from-autocomplete-only=true> <auto-complete source=loadTags($query) debounce-delay=1 template=tag-item-template></auto-complete> </tags-input> <script type=text/ng-template id=tag-item-template> <div style=\"height: 18px;\" ng-class=\"{greenTag: !!data.oficial}\">\r\n                        <span ng-bind-html=\"$highlight($getDisplayText())\"></span>\r\n                    </div> </script> </div> </form> </div> <div class=\"col-sm-4 right-sidebar\"> <button type=button id=save class=\"btn btn-lg btn-block\" ng-click=save() ng-disabled=isSaving> <i class=\"fas fa-spinner fa-spin\" ng-show=isSaving></i> <span ng-hide=isSaving>{{localizedMessages.get('save')}}</span> </button> <h4 class=\"text-muted well no-margin no-border\">{{localizedMessages.get('noticias')}}</h4> <div class=\"well no-margin no-border\"> <form class=\"form-inline no-border\"> <div class=form-group> <label for=author>{{localizedMessages.get('author')}}</label> <input ng-model=data.author.name type=text class=form-control id=author ng-disabled=!canChangeAuthor()> </div> </form> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.url = !accordion.url\"> <strong>{{ localizedMessages.get('url') | uppercase }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.url> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=url>{{ localizedMessages.get('url') | uppercase }} {{ localizedMessages.get('slug') }}:</label> <input ng-model=data.sefriendly type=text class=form-control id=url> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.image = !accordion.image\"> <strong>Image ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.image> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=image>{{ localizedMessages.get('image') }}:</label> <input ng-model=data.image type=text class=form-control id=image> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.published_by = !accordion.published_by\"> <strong>{{ localizedMessages.get('publishing') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.published_by> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=\"form-group datetime\" id=publish_date> <label for=publishing-date>{{ localizedMessages.get('publishing-date') }}</label> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\"> </div> </form> <br/> <form class=\"form-inline no-border\"> <div class=form-group> <label for=last-edited-by>{{ localizedMessages.get('last-edited-by') }}</label> <input ng-model=data.last_edited_by.name ng-disabled=true type=text class=form-control id=last-edited-by> </div> </form> <form class=\"form-inline no-border\"> <div class=form-group> <label for=published-by>{{ localizedMessages.get('published-by') }}</label> <input ng-model=data.published_by.name ng-disabled=!canChangeAuthor() type=text class=form-control id=published-by> </div> </form> </div> </div> </div> </div> </div> <div id=dtBox></div> <script>var dateValue;$(function(){var e=$('[contentEditable=\"true\"]'),a=null,s=function(e){(a=$(this)).text().trim().length||a.empty()};e.on(\"input\",s),e.each(s),$(window).on(\"scroll\",function(e){143<$(window).scrollTop()?($(\"#save\").addClass(\"fixed-save\"),$(\"#autosave\").addClass(\"fixed-autosave\"),$(\"#publishing\").addClass(\"fixed-publishing\"),$(\".right-sidebar\").addClass(\"margin-sidebar\")):($(\"#save\").removeClass(\"fixed-save\"),$(\"#autosave\").removeClass(\"fixed-autosave\"),$(\"#publishing\").removeClass(\"fixed-publishing\"),$(\".right-sidebar\").removeClass(\"margin-sidebar\"))}),$(\"#dtBox\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",settingValueOfElement:function(e,a,s){dateValue=a}})});var changesSaved=!0;window.onbeforeunload=function(){if(1==changesSaved)return\"add You havent saved your changes. Are you sure you want to leave the page?\"}</script> ";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var countries = __webpack_require__(161);
	angular.module('account.add-video', ['common.header', 'common.footer', 'config', 'directives.contenteditable', 'account.settings.social', 'security.service', 'security.authorization', 'services.accountResource', 'services.utility', 'services.formErrors', 'ui.bootstrap', 'directives.serverError', 'ngTagsInput', 'ngFileUpload', 'toggle-switch', 'angular-growl', 'ckeditor', 'resources.User', 'resources.Category', 'resources.Article', 'resources.Tag', 'filters.rawHtml', 'ckeditorPlaceholder', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.add-video', {
	    url: '/add-video',
	    title: 'Add Video',
	    views: {
	      'main@': {
	        template: __webpack_require__(162),
	        controller: 'AddVideoCtrl',
	        resolve: {
	          categories: ["Category", function (Category) {
	            var options = [];
	            var generateCategoryOptions = function generateCategoryOptions(items, container) {
	              items.forEach(function (item) {
	                if (!item.path) {
	                  return;
	                }
	                var depth = item.path.split('/').filter(Boolean).length;
	                var indent = new Array(5).join(String.fromCharCode(160));
	                container.push({
	                  _id: item._id,
	                  id: item.id,
	                  path: item.path,
	                  sefriendly: item.sefriendly,
	                  parent: item.parent,
	                  parent_id: item.parent_id,
	                  name: item.name,
	                  _name: new Array(depth).join(indent) + item.name
	                });
	                if (item.children) {
	                  generateCategoryOptions(item.children, container);
	                }
	              });
	              return container;
	            };
	
	            return Category.getPermittedTree({ type: 'video' }).$promise.then(function (data) {
	              generateCategoryOptions(data, options);
	              return options;
	            });
	          }],
	          locations: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type: 'location' });
	          }],
	          playersAndTeams: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
	          }]
	        }
	      }
	    }
	  });
	}]).controller('AddVideoCtrl', ["$scope", "$location", "$log", "$interval", "$sce", "security", "utility", "growl", "user", "categories", "locations", "playersAndTeams", "adminResource", "SOCIAL", "STATUSES", "ARTICLE_STYLES", "APP_IMG_URLS", "Upload", "formErrors", "dateFilter", "Article", "Tag", "localizedMessages", function ($scope, $location, $log, $interval, $sce, security, utility, growl, user, categories, locations, playersAndTeams, adminResource, SOCIAL, STATUSES, ARTICLE_STYLES, APP_IMG_URLS, Upload, formErrors, dateFilter, Article, Tag, localizedMessages) {
	  var urlGenerated = false;
	  var now = new Date();
	  var timer = null;
	  var currentDateTime = moment();
	  var slugify = __webpack_require__(152);
	  $scope.countries = [];
	  _.forIn(countries, function (value, key) {
	    $scope.countries.push({
	      _id: key,
	      name: value
	    });
	  });
	
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	
	  $scope.statuses = _.filter(STATUSES, function (status) {
	    return ~user.permissions.statuses.indexOf(status.id);
	  });
	
	  var isProgram = user && user.account && user.account.is_program ? true : false;
	
	  $scope.statuses = _.filter(STATUSES, function (status) {
	    return ~user.permissions.statuses.indexOf(status.id);
	  });
	  if (user.permissions.statuses[0] === '*') {
	    $scope.statuses = STATUSES;
	  }
	  $scope.categories = categories;
	  $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
	    return { _id: p._id, name: p.name };
	  }) : [];
	  $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
	    return {
	      _id: p._id,
	      name: p.name,
	      type: p.role.role_type
	    };
	  }) : [];
	  $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function (e) {
	    return e.type === 'profile';
	  }) : [];
	  $scope.article_styles = ARTICLE_STYLES;
	  // $scope.video_types = VIDEO_TYPES;
	  $scope.alerts = [];
	  $scope.uploading = false;
	  $scope.completed = false;
	  $scope.durations = [];
	  $scope.isSaving = false;
	  $scope.autosaveTimer = 180;
	  $scope.imgUrl = APP_IMG_URLS['base'];
	  $scope.accordion = {
	    score: true,
	    publishing_date: true,
	    url: true,
	    image: true,
	    published_by: false
	  };
	
	  $scope.isAdmin = false;
	  if (user.permissions.is_admin) {
	    $scope.isAdmin = true;
	  }
	  $scope.data = {
	    title: '',
	    sefriendly: '',
	    status: {
	      id: '0',
	      value: localizedMessages.get('pending')
	    },
	    type: 'video',
	    image: '',
	    video: '',
	    duration: 0,
	    video_type: isProgram ? 'program' : 'video',
	    media_id: '',
	    mediaCloud_id: '',
	    arrThumbs: [],
	    location: {
	      lat: 0,
	      lon: 0
	    },
	    locationInfo: {},
	    image_caption: '',
	    readyToStream: false,
	    body: '',
	    abstract: '',
	    equipo_local: '',
	    equipo_visitante: '',
	    goals: '',
	    goles_local: '',
	    goles_visitante: '',
	    referee: '',
	    incidents: '',
	    show_inarticle: ARTICLE_STYLES[2],
	    category: '',
	    tags: '',
	    author: {
	      picture: user.account.avatar || user.account.picture,
	      avatar: user.account.avatar,
	      twitter: user.account.twitter,
	      plus: user.account.plus,
	      name: user.account.name.full,
	      username: user.username
	    },
	    orderNumber: 0,
	    last_edited_by: {
	      name: user.account.name.full,
	      username: user.username
	    },
	    published_by: {
	      name: '',
	      username: ''
	    },
	    publish_date: currentDateTime.local().format('YYYY-MM-DD HH:mm')
	  };
	
	  // ==search place google==
	  var input = document.getElementById('pac-input');
	  // var searchBox = new window.google.maps.places.Autocomplete(input);
	  // searchBox.addListener('place_changed', function () {
	  //   var place = searchBox.getPlace();
	  //   if (!place.geometry) {
	  //     growl.error('Can not get location');
	  //     return;
	  //   }
	  //   var lat = place.geometry.location.lat();
	  //   var lon = place.geometry.location.lng();
	  //   $scope.data.location = { lat: lat, lon: lon };
	  //   $scope.data.locationInfo = {
	  //     lat: lat,
	  //     lon: lon,
	  //     geometry: place.geometry,
	  //     name: place.name,
	  //     id: place.id,
	  //     icon: place.icon,
	  //     formatted_address: place.formatted_address,
	  //     place_id: place.place_id,
	  //     types: place.types,
	  //     url: place.url,
	  //     vicinity: place.vicinity
	  //   };
	  // });
	  // ==search place google==
	
	  $scope.progressPercentage = 0;
	  $scope.videoUrl = '';
	  $scope.onChangeVideoUrl = function () {
	    $scope.videoUrl = $scope.data.video;
	  };
	
	  var startTimer = function startTimer() {
	    return $interval(function () {
	      if ($scope.autosaveTimer <= 0) {
	        $scope.save();
	      }
	      $scope.autosaveTimer -= 1;
	    }, 1000);
	  };
	
	  var resetTimer = function resetTimer() {
	    $scope.autosaveTimer = 180;
	    $interval.cancel(timer);
	  };
	
	  $scope.autosaveChanged = function () {
	    if ($scope.autosave) {
	      timer = startTimer();
	    } else {
	      resetTimer();
	    }
	  };
	
	  $scope.titleChanged = function () {
	    $scope.data.title = $scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' ');
	    if ($scope.data.sefriendly) {
	      return;
	    }
	    $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' '));
	    // console.log('>>>', $scope.data.sefriendly);
	  };
	
	  $scope.canChangeAuthor = function () {
	    return user.permissions.is_editor && $scope.canChangeCategory();
	  };
	
	  $scope.canChangeCategory = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	
	    // return ~user.permissions.categories.indexOf(article.category.id);
	  };
	
	  $scope.onReady = function () {
	    CKEDITOR.on('dialogDefinition', function (ev) {
	      // Take the dialog name and its definition from the event data
	
	      var dialogName = ev.data.name;
	      var dialogDefinition = ev.data.definition;
	      if (dialogName == 'image2' || dialogName == 'link') {
	        // Remove upload tab
	        dialogDefinition.removeContents('Upload');
	        dialogDefinition.removeContents('upload');
	      }
	    });
	  };
	
	  $scope.save = function () {
	    if ($scope.uploading) {
	      growl.error('Please wait for the upload process to complete');
	      return;
	    }
	    resetTimer();
	    $scope.autosaveChanged();
	    $scope.data.sefriendly = slugify($scope.data.sefriendly);
	
	    if (!$scope.data.video) {
	      growl.error('Video is required');
	      return;
	    }
	    //validate
	    if (!$scope.data.title) {
	      growl.error('Title is required');
	      return;
	    }
	
	    if (!$scope.data.category) {
	      growl.error('Category is required');
	      return;
	    }
	
	    // if (!$scope.data.body) {
	    //   growl.error('Body is required');
	    //   return;
	    // }
	
	    $scope.isSaving = true;
	
	    var data = angular.copy($scope.data);
	
	    data.edition = data.category.path.split('/')[1];
	    data.type = {
	      id: '1',
	      value: 'Wideo'
	    };
	    data.show_inarticle = 1;
	    data.status = parseInt(data.status.id, null);
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text),
	        avatar: tag.avatar || ''
	      };
	    });
	
	    data.publish_date = (data.publish_date ? moment(data.publish_date) : currentDateTime).toISOString();
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.published_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    var catArray = data.category.parent == '/' ? [] : data.category.parent.substring(1).split('/');
	    var pDate = new Date(data.publish_date);
	    var pMonth = pDate.getUTCMonth() + 1;
	    var dateSeg = '/' + pDate.getUTCFullYear() + '/' + ('0' + pMonth).slice(-2) + '/' + ('0' + pDate.getUTCDate()).slice(-2) + '/';
	    data.url_segment = dateSeg;
	    if (catArray.length == 0) {
	      data.url_segment = '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length == 1) {
	      data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length > 1) {
	      data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
	    }
	
	    data.abstract = CKEDITOR.instances.editor.getData();
	
	    // console.log( '>>> data.body', data.body );
	    Article.save(data, function (result) {
	      setTimeout(function () {
	        growl.info('Article have been created.');
	        $location.path('/account/edit-article/' + result.article_id);
	      }, 1000);
	    }, formErrors.growlErrors).$promise.then(function () {
	      setTimeout(function () {
	        $scope.isSaving = false;
	      }, 5000);
	    });
	  };
	
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    if (!$scope.isSaving) {
	      return true;
	      //var answer = confirm("Are you sure you want to navigate away from this page");
	      //if (!answer) {
	      //  event.preventDefault();
	      //}
	    }
	  });
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  $scope.createThumb = function (id) {
	    return 'https://cloudflarestream.com/' + id + '/thumbnails/thumbnail.jpg';
	  };
	
	  $scope.canGetInfo = true;
	
	  $scope.getInfoVideo = function () {
	    if ($scope.canGetInfo) {
	      Article.getInfoVideo({ mediaId: $scope.data.mediaCloud_id }).$promise.then(function (data) {
	        if (data && data.readyToStream && data.duration && data.duration > 0) {
	          do {
	            var num = Math.floor(Math.random() * Math.floor(data.duration - 0.5));
	            if ($scope.durations.indexOf(num) < 0) {
	              $scope.data.arrThumbs.push($scope.createThumb(data.uid) + '?time=' + num + 's');
	              $scope.durations.push(num);
	            }
	          } while ($scope.durations.length < 3);
	          $scope.data.readyToStream = data.readyToStream;
	          $scope.thumbnail = $scope.createThumb(data.uid);
	          $scope.data.duration = data.duration;
	          growl.success('Completed');
	        } else {
	          growl.error('Inprogress, check again after 10s');
	        }
	      });
	      $scope.canGetInfo = false;
	      window.setTimeout(function () {
	        $scope.canGetInfo = true;
	      }, 10000);
	    }
	  };
	
	  $scope.$watch('fileImage', function (file) {
	    if (!file) return;
	    $scope.uploadImage(file);
	  });
	
	  // upload on file select or drop
	  $scope.uploadImage = function (file) {
	    $scope.uploadingImage = true;
	    $scope.thumbnailImage = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploadingImage = false;
	      $scope.thumbnailImage = APP_IMG_URLS.base + resp.data.filename;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploadingImage = false;
	      $scope.thumbnailImage = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress Image: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.durations = [];
	    $scope.progressPercentage = 0;
	    // return;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.data.video = resp.data.filename;
	      $scope.isMultipart = resp.data.multipart;
	      $scope.uploading = false;
	      $scope.completed = true;
	      growl.info('Uploaded successfully!.');
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.completed = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      $scope.progressPercentage = progressPercentage;
	      console.log('progress Video: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.loadTags = function (query) {
	    return Tag.search({ q: query }).$promise.then(function (tags) {
	      if (!tags) return [];
	      return tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.name,
	          name: tag.name,
	          sefriendly: slugify(tag.name),
	          avatar: tag.avatar || ''
	        };
	      });
	    });
	  };
	
	  $scope.changePT1 = function (pt1) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt1;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_local_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.changePT2 = function (pt2) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt2;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_visitante_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.loadProfiles = function (query) {
	    return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
	      if (!profiles) return [];
	      var searchName = query.toLowerCase();
	      return profiles.data.filter(function (p) {
	        var name = p.name.toLowerCase();
	        return name.indexOf(searchName) > -1;
	      }).map(function (p) {
	        return {
	          _id: p._id,
	          name: p.name
	        };
	      });
	    });
	  };
	}]);

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = {"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, The Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Cote D'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and Mcdonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic Of","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Democratic People's Republic of Korea","KR":"Korea, Republic of","XK":"Kosovo","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libyan Arab Jamahiriya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, The Former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territory, Occupied","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Viet Nam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<style>.ubuntu{font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif}.droid{font-family:'Open Sans',Georgia,'Times New Roman',Times,serif;font-size:19px}.open-sans{font-family:'Open Sans',sans-serif}h2{font-family:Open Sans,Georgia;font-size:30px;padding-top:10px;margin-bottom:15px;padding-left:0;padding-right:5px;font-weight:700;letter-spacing:-1px;line-height:120%}p{font-size:12px;color:#444;margin:0 0 30px 0;padding-top:0;font-family:Open Sans,Georgia,'Times New Roman',Times,serif;line-height:145%;text-align:justify}.box-input{padding:15px;background:#e1e1e1;border-radius:20px}.box-input>p{margin-bottom:20px}.image_caption_news{font-size:11px;font-style:italic;color:#777;background-color:#eee;padding:15px;border-bottom:1px #ddd solid;border-top:1px #ddd solid;margin-bottom:20px}.page-header{padding-bottom:10px;margin:0 0 18px}#save{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}#switch{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}.side-row{padding:10px;color:#fff;background:#28a5e4}.toggle-switch{min-width:64px;border-color:#848484;font-size:11px}.toggle-switch span{line-height:inherit}.toggle-switch .switch-left{background:#63c663;color:#fff}.toggle-switch .switch-right{background:#c43939;color:#fff}.no-margin{margin:0}.no-border{border:0;border-radius:0}oi-select{width:200px}oi-select .select-dropdown,oi-select .select-search-list-item,oi-select .select-search-list-item_input input{font-size:13px;white-space:nowrap}oi-select .select-dropdown{max-height:200px}oi-select .select-search-list-item_selection{box-shadow:none}.right-sidebar .form-inline{border-bottom:1px solid #e4e3e3}.right-sidebar .form-inline.no-border{border:0;border-radius:0}.right-sidebar .panel{margin:0}.right-sidebar .panel-body{background-color:#f9f9f9}.right-sidebar .form-inline .form-group{margin:10px 0;width:100%}.right-sidebar .form-inline label{font-size:12px;font-weight:400}.right-sidebar .form-inline input{float:right;height:26px}.right-sidebar oi-select .select-search{background:#eee}.right-sidebar .form-inline input,.right-sidebar .form-inline select,.right-sidebar .form-inline textarea{font-size:12px;font-weight:400;width:150px;margin-left:30px;border-radius:0;background:#eee}.right-sidebar .form-inline textarea{width:250px;margin-left:0}.right-sidebar input[type=datetime-local]{margin-left:0;width:100%}.right-sidebar tags-input .host{position:static}.margin-sidebar{margin-top:98px}.fixed-save{position:fixed;top:0;width:293px}.fixed-publishing{position:fixed;top:96px;width:293px}.dragover{padding:10px;border:2px dashed #28a5e4}.PhotoFull img{width:700px}.PhotoRight{width:400px;float:right;margin:1em}.PhotoRight figcaption{margin:0}.PhotoMinifull{width:440px}.PhotoMinifull+article{width:440px}.Newspapermode{display:none}.Liveevent figcaption{margin-bottom:0}.Liveevent{margin-bottom:20px}.Liveevent+article{font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,'Times New Roman',Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article{background-color:#fff;font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,'Times New Roman',Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article img{margin:auto;display:block;border:10px #fff solid;border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;-moz-box-shadow:0 0 3px rgba(0,0,0,.15);-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15)}.Liveevent+article p{border-bottom:1px solid grey;margin:0;padding:10px 10px}.score_number{background-color:#fff;font-size:44px;color:#222;line-height:44px;padding:7px 20px;font-weight:700;-moz-border-radius:55px;-webkit-border-radius:55px;border-radius:55px;text-align:center;max-width:30px;overflow:hidden}#score_bar{padding-top:25px;padding-bottom:60px;width:100%;min-height:65px;background:-moz-linear-gradient(top,#fff 0,#eee 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),color-stop(100%,#eee));background:-webkit-linear-gradient(top,#fff 0,#eee 100%);background:-o-linear-gradient(top,#fff 0,#eee 100%);background:-ms-linear-gradient(top,#fff 0,#eee 100%);background:linear-gradient(top,#fff 0,#eee 100%);border-radius:0;border-bottom:4px #fff solid;margin-bottom:20px}#score_team{width:31%;font-size:24px;color:#222;font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif;text-align:center;font-weight:777;padding-top:10px}.video-block{background-color:#eee;color:#666;display:flex;flex-direction:column}.youtube-player{height:300px}.form-group-flex{display:flex;justify-content:flex-start;align-items:center}.form-group-flex .form-control-flex{flex-grow:1;margin-left:10px}</style> <div class=row id=add-video style=margin-top:10px> <div class=col-xs-12> <div class=page-header> <form class=form-inline> <div class=form-group> <oi-select oi-options=\"option._name for option in categories track by option.id\" oi-select-options=selectSettings ng-model=data.category placeholder=\"Wybierz kategorie\"></oi-select> </div> <div class=form-group> <oi-select oi-options=\"option.value for option in statuses track by option.id\" oi-select-options=selectSettings ng-model=data.status placeholder=\"Wybierz status\"></oi-select> </div> <div class=form-group style=display:none> <oi-select oi-options=\"option.value for option in article_styles track by option.id\" oi-select-options=selectSettings ng-model=data.show_inarticle placeholder=\"Wybierz format\"></oi-select> </div> <div class=form-group> <label for=\"\">{{localizedMessages.get('add-video')}}</label> </div> </form> </div> </div> </div> <div class=\"row w990\"> <div class=col-sm-8> <form> <div ng-class=\"{'not-upload': !uploading || !completed, 'video-uploading': uploading || completed}\"> <h1 ng-model=data.title class=\"text-center ubuntu\" contenteditable=true placeholder=\"{{localizedMessages.get('add-title')}}\" style=margin-top:0 ng-blur=titleChanged()></h1> <article id=editor ng-model=data.abstract ckeditor=ckOptions contenteditable=true ready=onReady() class=\"text-justify article-content droid\" spellcheck=false style=position:relative placeholder=\"{{localizedMessages.get('add-description')}}\"></article> </div> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-image-upload ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=fileImage name=fileImage accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ngf-thumbnail=\"thumbnailImage || (data.image ? imgUrl + data.image : false) || imgUrl + 'upload-iworis-1603084085694.png'\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15)\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploadingImage> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <figcaption ng-model=data.image_caption contenteditable=true class=\"text-center image_caption_news\" id=image_caption placeholder=\"{{localizedMessages.get('add-image-caption')}}\" style=min-height:20px> </figcaption> <figure class=article-image ng-class=\"{'no-image': !data.image,'box-upload': !completed,'box-uploading': uploading || completed}\" type=file id=file-upload ngf-drop-available=true ngf-drop-disabled=\"{{uploading || completed ? 'true' : 'false'}}\" ngf-select-disabled=\"{{uploading || completed ? 'true' : 'false'}}\" ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-pattern=\"'video/*'\" ngf-select ngf-drop ng-model=file name=file accept=video/* ngf-max-size=3000MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;position:relative;border:solid .5px #ebebeb;padding:15px\"> <div class=upload-header ng-class=\"{'video-uploading': uploading || completed}\"> <h4>{{localizedMessages.get('upload-video')}}</h4> </div> <div class=\"row row-uploading\" ng-if=\"uploading || completed\"> <div class=col-sm-4> <div class=upload-thumb> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> </div> <img ng-if=data.image src={{data.image}} title=\"\" alt=\"\" class=article-image ng-if=\"!uploading && completed && thumbnail\"/> </div> <div class=upload-status> <h4>Upload status:</h4> <span ng-if=uploading>Uploading video</span> <span ng-if=!uploading>Upload finish</span> </div> </div> <div class=col-sm-8> <div class=upload-progress> <div class=upload-bar ng-class=\"!uploading ? 'completed' : ''\" ng-style=\"{'width':progressPercentage +'%'}\"> <span class=upload-percent ng-show=\"progressPercentage < 100\">UPLOADING {{progressPercentage | number:0}}%</span> <span class=upload-percent ng-show=\"progressPercentage >= 100\">100% completed</span> </div> </div> <div class=progress-text> <img src=" + __webpack_require__(163) + " alt=\"\"/> <span ng-if=uploading>Video is still uploading. Please keep this page open until it's done.</span> <span ng-if=!uploading>Completed</span> </div> </div> <div class=\"col-sm-12 row-upload-thumb\"> <div class=\"alert alert-success\" role=alert ng-if=\"completed && !data.readyToStream && !isMultipart\"> Video upload is completed! </div> <div class=\"alert alert-warning\" role=alert ng-if=\"completed && !data.readyToStream && isMultipart\"> Video upload is larger than 100MB, multipart uploading in running in background! </div> <div class=upload-thumb-list ng-if=\"uploading || !completed\"> <div class=upload-thumb-item> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> </div> <div class=upload-thumb-item> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> </div> <div class=upload-thumb-item> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> </div> </div> <div class=upload-thumb-list ng-if=completed> <div class=upload-thumb-item ng-click=selectThumb(thumb) ng-repeat=\"thumb in data.arrThumbs\"> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> <img src={{thumb}} title=\"\" alt=\"\" class=article-image ng-if=\"!uploading && completed && data.arrThumbs && data.arrThumbs.length\"/> </div> </div> </div> </div> <div ng-if=\"!uploading && !completed\" style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ng-if=!thumbnail src=" + __webpack_require__(164) + " title=\"\" alt=\"\" class=article-image style=\"max-width:100%;width:140px;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15);background:#ebebeb;border-radius:50%\"/> <img ngf-thumbnail=thumbnail title=\"\" alt=\"\" class=article-image style=\"max-width:30%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15);margin-top:20px\"/> <div class=upload-text> <strong>{{localizedMessages.get('drag-drop')}}</strong> <p>Your video will be private until you publish it</p> <p>{{localizedMessages.get('accept')}}: MP4, MKV, MOV, AVI, FLV, MPEG-2 TS, MPEG-2 PS, MXF, LXF, GXF, 3GP, WebM, MPG</p> </div> <div class=\"file btn btn-lg btn-primary\"> {{localizedMessages.get('select-file')}} <input type=file id=file-upload ngf-drag-over-class=\"'dragover'\" ngf-select=upload($file) ng-model=file name=file accept=video/* ngf-pattern=\"'video/*'\" ngf-max-size=3000MB required ngf-model-invalid=errorFiles ngf-select-disabled=\"{{completed || uploading ? 'true' : 'false'}}\"/> </div> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <br/> <div ng-class=\"{'not-upload': !uploading || !completed, 'video-uploading': uploading || completed}\"> <br/> <div> <h5><strong>{{localizedMessages.get('when')}}</strong></h5> <div class=box-input> <p>{{localizedMessages.get('video-date')}}</p> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\"/> </div> </div> <br/> <div> <h5><strong>{{localizedMessages.get('who')}}</strong></h5> <div class=box-input> <p>{{localizedMessages.get('add-tags')}}</p> <tags-input ng-model=data.tags replace-spaces-with-dashes=false> <auto-complete source=loadTags($query) min-length=2 debounce-delay=1 max-results=10></auto-complete> </tags-input> </div> </div> </div> </form> </div> <div class=\"col-sm-4 right-sidebar\"> <button type=button id=save class=\"btn btn-lg btn-block\" ng-click=save() ng-disabled=isSaving> <i class=\"fas fa-spinner fa-spin\" ng-show=isSaving></i> <span ng-hide=isSaving>{{localizedMessages.get('save')}}</span> </button> <h4 class=\"text-muted well no-margin no-border\">{{localizedMessages.get('noticias')}}</h4> <div class=\"well no-margin no-border\"> <form class=\"form-inline no-border\"> <div class=form-group> <label for=author>{{localizedMessages.get('author')}}</label> <input ng-model=data.author.name type=text class=form-control id=author ng-disabled=!canChangeAuthor() /> </div> </form> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.url = !accordion.url\"> <strong>URL ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.url> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=url>URL slug:</label> <input ng-model=data.sefriendly type=text class=form-control id=url /> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.image = !accordion.image\"> <strong>{{localizedMessages.get('image')}} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.image> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=image>{{localizedMessages.get('image')}}:</label> <input ng-model=data.image type=text class=form-control id=image /> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.published_by = !accordion.published_by\"> <strong>{{localizedMessages.get('publishing')}} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.published_by> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=\"form-group datetime\" id=publish_date> <label for=publishing-date>{{localizedMessages.get('publishing-date')}}</label> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\"/> </div> </form> <br/> <form class=\"form-inline no-border\"> <div class=form-group> <label for=last-edited-by>{{localizedMessages.get('last-edited-by')}}</label> <input ng-model=data.last_edited_by.name ng-disabled=true type=text class=form-control id=last-edited-by /> </div> </form> <form class=\"form-inline no-border\"> <div class=form-group> <label for=published-by>{{localizedMessages.get('published-by')}}</label> <input ng-model=data.published_by.name ng-disabled=!canChangeAuthor() type=text class=form-control id=published-by /> </div> </form> </div> </div> </div> </div> </div> <div id=dtBox></div> <script>var dateValue;$(function(){var e=$('[contentEditable=\"true\"]'),a=null,s=function(e){(a=$(this)).text().trim().length||a.empty()};e.on(\"input\",s),e.each(s),$(window).on(\"scroll\",function(e){143<$(window).scrollTop()?($(\"#save\").addClass(\"fixed-save\"),$(\"#autosave\").addClass(\"fixed-autosave\"),$(\"#publishing\").addClass(\"fixed-publishing\"),$(\".right-sidebar\").addClass(\"margin-sidebar\")):($(\"#save\").removeClass(\"fixed-save\"),$(\"#autosave\").removeClass(\"fixed-autosave\"),$(\"#publishing\").removeClass(\"fixed-publishing\"),$(\".right-sidebar\").removeClass(\"margin-sidebar\"))}),$(\"#dtBox\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",settingValueOfElement:function(e,a,s){dateValue=a}})});var changesSaved=!0;window.onbeforeunload=function(){if(1==changesSaved)return\"add You havent saved your changes. Are you sure you want to leave the page?\"}</script> ";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAW5JREFUeNrs3M1Nw0AUhVH8xB5KSAksvKcFOoAS6ADogBIogRJg7yLSiRkvKCD8xG/enE8aeUOA3CMSRFCmdV0vtF9hAgAABACAAAAQAAACAEAAAAgAAAEAIAAABACAAADI1jzPb9sBsNP47XK/nZ4RovPxv+sWIQqM3zVCFBm/W4QoNH6XCFFs/O4QouD4XSFE0fG7QYjC43eBEMXHT48QA4yfGiEGGT8tQgw0fkqEGGz8dAgx4PipEGLQ8dMgxMDjp0CIwcffHSGMvy/CdM63Kmh38K5dHk+4yU07V3/wpT9P+NjXZVneSwL8AOyjXW5/+3naoFPW++jfUgAAEAAAAgBAAAAIAAABACAAAASgfpfJv7/t1bPrygCTd0/3EARAADwJn6N5ng/tcki+yXFZlmPV34Ie2nlKDvDSzrOHIM8BAgBAAIrnTxF+AgAIAAABACAAAAQAgAAAEAAAAgBAAAAIAAABAKB/6EuAAQAF82CN0JLhMgAAAABJRU5ErkJggg=="

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.edit-article-live', ['common.header', 'common.footer', 'config', 'directives.contenteditable', 'account.settings.social', 'security.service', 'security.authorization', 'services.accountResource', 'services.utility', 'services.formErrors', 'ui.bootstrap', 'directives.serverError', 'ngTagsInput', 'ngFileUpload', 'toggle-switch', 'angular-growl', 'ckeditor', 'resources.User', 'resources.Tag', 'resources.Category', 'resources.Article', 'filters.rawHtml', 'ckeditorPlaceholder', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.edit-article-live', {
	    url: '/edit-article-live/:id',
	    title: 'Edit Article live',
	    views: {
	      'main@': {
	        template: __webpack_require__(166),
	        controller: 'EditArticleliveCtrl',
	        resolve: {
	          locations: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type: 'location' });
	          }],
	          playersAndTeams: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
	          }]
	        }
	      }
	    }
	  });
	}]).controller('EditArticleliveCtrl', ["$scope", "$location", "$log", "$interval", "$stateParams", "security", "utility", "growl", "user", "SOCIAL", "STATUSES", "Upload", "APP_IMG_URLS", "formErrors", "dateFilter", "Article", "Category", "Tag", "socket", "$window", "locations", "playersAndTeams", "localizedMessages", "adminResource", function ($scope, $location, $log, $interval, $stateParams, security, utility, growl, user, SOCIAL, STATUSES, Upload, APP_IMG_URLS, formErrors, dateFilter, Article, Category, Tag, socket, $window, locations, playersAndTeams, localizedMessages, adminResource) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  $scope.pinComment = false;
	  $scope.dataLoaded = false;
	  var urlGenerated = false;
	  var timer = null;
	  var slugify = __webpack_require__(152);
	
	  $scope.editPermit = false;
	  $scope.imgUrl = APP_IMG_URLS.base;
	
	  var toFormatArticleDate = __webpack_require__(167).toFormatArticleDate;
	  var prepareBeforeEmitArticleChanged = __webpack_require__(167).prepareBeforeEmitArticleChanged;
	  var prepareForEditArticle = __webpack_require__(167).prepareForEditArticle;
	
	  var publishDatePrev = moment();
	  var startDatePrev;
	  var endDatePrev;
	
	  var init = function init(article, categories) {
	
	    if (article.status) {
	      if ([1, 3, 17, 18].indexOf(article.status) >= 0) {
	        publishDatePrev = moment(article.publish_date);
	      }
	    }
	
	    startDatePrev = moment(article.startDate);
	    endDatePrev = moment(article.endDate);
	
	    // console.log( '>>>', article.startDate );
	
	    $scope.categories = categories;
	    $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
	      return { _id: p._id, name: p.name };
	    }) : [];
	    $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
	      return {
	        _id: p._id,
	        name: p.name,
	        type: p.role.role_type
	      };
	    }) : [];
	    $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function (e) {
	      return e.type === 'profile';
	    }) : [];
	    $scope.statuses = _.filter(STATUSES, function (status) {
	      return ~user.permissions.statuses.indexOf(status.id);
	    });
	    if (user.permissions.statuses[0] === '*') {
	      $scope.statuses = STATUSES;
	    }
	
	    $scope.notas = {
	      titulo: '',
	      nota: '',
	      id: 0
	    };
	    $scope.isAdmin = false;
	    // console.log("user.permissions.is_admin------->>>>>>>" + user.permissions.is_admin);
	    if (user.permissions.is_admin) {
	      $scope.isAdmin = true;
	      // console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
	    }
	
	    // console.log( '>>>', startDatePrev.format('LLL'), startDatePrev.local().format('YYYY-MM-DD HH:mm') );
	
	    $scope.data = {
	      _id: article._id,
	      article_id: article.article_id,
	      title: _.unescape(article.title),
	      sefriendly: article.sefriendly,
	      status: _.find(STATUSES, { id: '' + article.status }),
	      orderNumber: article.orderNumber,
	      image: article.image,
	      video: article.video,
	      image_caption: _.unescape(article.image_caption),
	      body: _.unescape(article.body),
	      isbodylive: article.isbodylive ? article.isbodylive : false,
	      bodylive: article.bodylive ? article.bodylive : [],
	      abstract: _.unescape(article.abstract),
	
	      equipo_local: article.equipo_local_new ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local_new._id }) : article.equipo_local ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local }) : undefined,
	
	      equipo_visitante: article.equipo_visitante_new ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante_new._id }) : article.equipo_visitante ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante }) : undefined,
	
	      goals: article.goals,
	      goles_local: article.goles_local,
	      goles_visitante: article.goles_visitante,
	
	      referee: article.referee_new ? _.find($scope.profilesList, { _id: article.referee_new._id }) : !!article.referee ? _.find($scope.profilesList, { _id: article.referee }) : undefined,
	
	      incidents: article.incidents,
	      category: article.category ? _.find(categories, { id: article.category.id }) : '',
	      tags: [],
	      author: article.author,
	      last_edited_by: article.last_edited_by,
	
	      startDate: toFormatArticleDate(startDatePrev),
	      endDate: toFormatArticleDate(endDatePrev),
	
	      published_by: article.published_by,
	      publish_date: toFormatArticleDate(publishDatePrev),
	
	      team1: article.team1,
	      team2: article.team2,
	      team1players: angular.isArray(article.team1players) ? article.team1players.map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [],
	      team2players: angular.isArray(article.team2players) ? article.team2players.map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [],
	      created_at: article.created_at,
	
	      stadium: article.stadium_new ? _.find($scope.stadiumsList, { _id: article.stadium_new._id }) : !!article.stadium ? _.find($scope.stadiumsList, { _id: article.stadium }) : undefined
	    };
	    $scope.changePT1(article.equipo_local);
	    $scope.changePT2(article.equipo_visitante);
	
	    var listenerFunction = null;
	
	    //send user name of person who start editing and  id of edited topic
	    socket.emit('connectDocs', {
	      userName: user.account.name.full,
	      artId: article.article_id,
	      userId: user._id,
	      docs: $scope.data
	    });
	
	    var internalChange = false;
	    var listenData = false;
	    socket.on('startEditing', function (data) {
	      $scope.editPermit = true;
	      $scope.editing = "Editing by: " + user.account.name.full;
	
	      if (data) {
	        $scope.data = prepareForEditArticle(data.data);
	      }
	
	      listenerFunction = $scope.$watchCollection("data", _.debounce(function (newValue, oldValue) {
	        if (!_.isEqual(newValue, oldValue) && !internalChange) {
	          socket.emit('articleChanged', {
	            artId: article.article_id,
	            data: prepareBeforeEmitArticleChanged(newValue)
	          });
	        }
	        internalChange = false;
	      }, 1000));
	      listenData = true;
	    });
	
	    socket.on('startWatching', function (articleRoom) {
	      $scope.data = articleRoom.docs;
	      var user = _.find(articleRoom.users, function (user) {
	        return user.userId === articleRoom.editing;
	      });
	      $scope.editing = "editing by: " + user.name;
	    });
	
	    socket.on('newcomer', function (watchers) {
	      $scope.watching = watchers.reduce(function (prev, obj) {
	        return prev + obj.name + ', ';
	      }, "watching by: ");
	    });
	
	    //send user name of person who ends editing and  id of edited topic
	    $scope.$on('$locationChangeStart', function (event) {
	      if ($scope.editPermit) {
	        socket.emit('endEdit');
	        socket.off('applyChanges');
	      }
	    });
	
	    var windowElement = angular.element($window);
	    windowElement.on('beforeunload', function (event) {
	      // do whatever you want in here before the page unloads.
	      if ($scope.editPermit) {
	        socket.emit('endEdit');
	        socket.off('applyChanges');
	      }
	      // the following line of code will prevent reload or navigating away.
	      event.preventDefault();
	    });
	
	    //recieving changes from other editors
	    socket.on('applyChanges', function (data) {
	      if (data.editing === user._id) {
	        $scope.editPermit = true;
	        if (!listenerFunction) {
	          listenerFunction = $scope.$watchCollection("data", _.debounce(function (newValue, oldValue) {
	            if (!_.isEqual(newValue, oldValue) && !internalChange) {
	              socket.emit('articleChanged', {
	                artId: article.article_id,
	                data: prepareBeforeEmitArticleChanged(newValue)
	              });
	            }
	            internalChange = false;
	          }, 1000));
	        }
	      } else {
	        $scope.editPermit = false;
	        if (listenerFunction) {
	          listenerFunction();
	          listenerFunction = null;
	        }
	      }
	      var users = data.users;
	      var editor = _.find(users, function (us) {
	        return us.userId === data.editing;
	      });
	      var watchers = users.filter(function (us) {
	        return us.userId !== data.editing;
	      });
	      $scope.editing = "editing by: " + editor.name;
	      $scope.watching = watchers.reduce(function (prev, obj) {
	        return prev + obj.name + ', ';
	      }, "watching by: ");
	
	      if (!_.isEqual($scope.data, data.docs)) {
	        $scope.data = prepareForEditArticle(data.docs);
	        internalChange = true;
	      }
	    });
	
	    $scope.switch = function () {
	      socket.emit('changeEditPermit', {
	        artId: article.article_id,
	        userId: user._id
	      });
	    };
	
	    if (article.tags) {
	      $scope.data.tags = article.tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.name,
	          sefriendly: slugify(tag.name)
	        };
	      });
	    }
	
	    if ($scope.data.status == undefined) {
	      $scope.data.status = {
	        id: '0',
	        value: localizedMessages.get('pending')
	      };
	    }
	    $scope.dataLoaded = true;
	  };
	
	  $scope.uploading = false;
	  $scope.isSaving = false;
	  $scope.autosaveTimer = 180;
	  $scope.accordion = {
	    score: true,
	    publishing_date: true,
	    url: true,
	    image: true,
	    published_by: false
	  };
	
	  var startTimer = function startTimer() {
	    return $interval(function () {
	      if ($scope.autosaveTimer <= 0) {
	        $scope.save();
	      }
	      $scope.autosaveTimer -= 1;
	    }, 1000);
	  };
	
	  var resetTimer = function resetTimer() {
	    $scope.autosaveTimer = 180;
	    $interval.cancel(timer);
	  };
	
	  $scope.autosaveChanged = function () {
	    if ($scope.autosave) {
	      timer = startTimer();
	    } else {
	      resetTimer();
	    }
	  };
	
	  $scope.canChangeAuthor = function () {
	    return user.permissions.is_editor && $scope.canChangeCategory();
	  };
	
	  $scope.canChangeStatus = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	    //return ~user.permissions.statuses.indexOf(article.status + '');
	  };
	
	  $scope.canChangeCategory = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	    //return ~user.permissions.categories.indexOf(article.category.id);
	  };
	
	  $scope.canChangeFormat = function () {
	    return true;
	  };
	
	  $scope.titleChanged = function () {
	    $scope.data.title = $scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " ");
	    if ($scope.data.sefriendly) {
	      return;
	    }
	    $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " "));
	  };
	
	  $scope.saveBtnText = "Save";
	  $scope.switchBtnText = "Switch";
	
	  $scope.save = function () {
	    resetTimer();
	    $scope.autosaveChanged();
	    $scope.data.sefriendly = slugify($scope.data.sefriendly);
	    if (!$scope.data.title) {
	      growl.error('Title is required');
	      return;
	    }
	    if (!$scope.data.category) {
	      growl.error('Category is required');
	      return;
	    }
	    if (!$scope.data.body && !$scope.data.isbodylive) {
	      growl.error('Body is required');
	      return;
	    }
	
	    if ($scope.data.bodylive.length === 0 && $scope.data.isbodylive) {
	      growl.error('Body is required');
	      return;
	    }
	
	    $scope.isSaving = true;
	
	    var data = angular.copy($scope.data);
	    data.edition = data.category.path.split("/")[1];
	    data.show_inarticle = 21;
	    data.status = parseInt(data.status.id, null);
	    // data.categories = data.category.path.split('/').filter(Boolean).map(function(item) {return {sefriendly: item};}).reverse();
	    // delete data['category'];
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text)
	      };
	    });
	
	    data.publish_date = (data.publish_date ? moment(data.publish_date) : publishDatePrev).toISOString();
	    data.startDate = (data.startDate ? moment(data.startDate) : startDatePrev).toISOString();
	    data.endDate = (data.endDate ? moment(data.endDate) : endDatePrev).toISOString();
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.published_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    var catArray = data.category.parent == "/" ? [] : data.category.parent.substring(1).split('/');
	    var pDate = new Date(data.created_at);
	    var pMonth = pDate.getUTCMonth() + 1;
	    var dateSeg = '/' + pDate.getUTCFullYear() + '/' + ('0' + pMonth).slice(-2) + '/' + ('0' + pDate.getUTCDate()).slice(-2) + '/';
	    data.url_segment = dateSeg;
	    if (catArray.length == 0) {
	      data.url_segment = '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length == 1) {
	      data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length > 1) {
	      data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
	    }
	
	    // console.log("$startDate------->>>>>>>" + data.startDate);
	    //console.log( '>>>', data );
	
	    Article.update(data, function (result) {
	      setTimeout(function () {
	        //growl.info('Changes saved!');
	        $scope.data.last_edited_by = data.last_edited_by;
	      }, 1000);
	    }, formErrors.growlErrors).$promise.then(function () {
	      $scope.saveBtnText = "Saved!";
	      $scope.isSaving = false;
	      // setTimeout(function () {
	      //   $scope.saveBtnText = "Saved!";
	      // }, 500);
	    });
	  };
	
	  $scope.addComment = function () {
	    var text = angular.copy($scope.notas.nota);
	
	    if (CKEDITOR.instances.editor) {
	      text = CKEDITOR.instances.editor.getData();
	      CKEDITOR.instances.editor.focusManager.blur(true);
	    }
	
	    if (text === '') {
	      alert('please enter a comment');
	      return;
	    }
	    text = text.replace('<p>', '');
	    text = text.replace('</p>', '');
	    var now = new Date();
	    var fecha = new Date().toISOString();
	    //var fecha = new Date(now.getTime() + now.getTimezoneOffset() * 60000).toISOString();
	    if (!$scope.data.isbodylive) {
	      var idiv = $scope.notas.id + 1;
	      var div1 = "<div id=post'" + idiv + "' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'>";
	      var headline = "<h2 itemprop='headline'>";
	      var tiempo = "<a href=" + "http://188.165.235.121:7790/account/edit-article-live/" + $scope.data.article_id + "#post" + idiv + "' itemprop='url'><time datetime='" + fecha + "' data-relativeformat='med' itemprop='datePublished' title='" + fecha + "'GMT'>" + fecha + "</time></a>";
	      var comentario = "";
	      var keyWord = "<img ";
	      var position = text.indexOf(keyWord);
	      if (position !== -1) {
	        var itemprop = "itemprop='image'";
	        var imagen2 = text.replace('<img', '<img ' + itemprop);
	        comentario = imagen2;
	        // console.log("imagen------->" + comentario);
	      } else {
	        if (text != "") {
	          var letra = "<p itemprop='articleBody'>" + text + "</p>";
	          comentario = letra;
	        } else {
	          return;
	        }
	      }
	      // console.log("comentario------->" + comentario);.on
	      var titulo = $scope.notas.titulo;
	      var tituloTotal = "";
	      if (titulo != "") {
	        tituloTotal = headline + titulo + "</h2>";
	        // console.log("tituloTotal----->" + tituloTotal);
	      }
	      var bocomentario = div1 + tituloTotal + tiempo + comentario + "</div>";
	      //console.log("bocomentario----->"+bocomentario);
	      $scope.data.body = bocomentario + $scope.data.body;
	    } else {
	      var titulo = $scope.notas.titulo.replace(/<[^>]*>|&nbsp;/g, "");
	      var idiv = $scope.data.bodylive.length + 1;
	      var newBodyLive = $scope.data.bodylive;
	      newBodyLive.splice($scope.pinComment ? 1 : 0, 0, {
	        postId: idiv,
	        title: titulo,
	        date: fecha,
	        description: text
	      });
	      $scope.data.bodylive = newBodyLive;
	    }
	    $scope.notas = {
	      titulo: '',
	      nota: '',
	      id: idiv
	    };
	    $scope.save();
	  };
	
	  $scope.setPinComment = function (body, index) {
	    if (index > 0) {
	      $scope.pinComment = true;
	      var i0 = $scope.data.bodylive[0];
	      $scope.data.bodylive[0] = $scope.data.bodylive[index];
	      $scope.data.bodylive[index] = i0;
	    } else {
	      $scope.pinComment = !$scope.pinComment;
	    }
	    // console.log(index, $scope.data.bodylive);
	    $scope.save();
	  };
	
	  $scope.editBodyLive = function (body, index) {
	    $scope.data.bodylive[index] = body;
	    $scope.save();
	  };
	
	  $scope.notify = function () {
	    var data = angular.copy($scope.data);
	    data.edition = data.category.path.split("/")[1];
	    data.show_inarticle = 21;
	    data.status = parseInt(data.status.id, null);
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text)
	      };
	    });
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.notify = 1;
	      //console.log($scope.data.title);
	      Article.update(data, function (result) {
	        setTimeout(function () {
	          //growl.info('Changes saved!');
	          $scope.data.last_edited_by = data.last_edited_by;
	          // $location.path('/edit-article/' + result.data._id);
	        }, 1000);
	      }, formErrors.growlErrors).$promise.then(function () {
	        $scope.saveBtnText = "Saved!";
	        $scope.isSaving = false;
	        setTimeout(function () {
	          $scope.saveBtnText = "Saved!";
	        }, 500);
	      });
	    }
	  };
	
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    if (!$scope.isSaving) {
	      var answer = confirm("Are you sure you want to navigate away from this page");
	      if (!answer) {
	        event.preventDefault();
	      }
	    }
	  });
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.thumbnail = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.loadTags = function (query) {
	    return Tag.search({ q: query }).$promise.then(function (tags) {
	      if (!tags) return [];
	      return tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.nametag,
	          name: tag.nametag,
	          sefriendly: slugify(tag.name)
	        };
	      });
	    });
	  };
	
	  $scope.delete = function (article) {
	    if ($scope.isAdmin) {
	      if (!confirm('Are you sure you want to delete this article?')) {
	        return;
	      }
	      Article.delete({ id: article._id }, function (result) {
	        setTimeout(function () {
	          growl.info('Article removed!');
	          $location.path('/account/my-articles');
	        }, 1000);
	      }, formErrors.growlErrors);
	    }
	  };
	
	  async.parallel({
	    article: function article(cb) {
	      Article.query({ id: $stateParams.id }).$promise.then(function (result) {
	        return cb(null, result);
	      });
	    },
	    categories: function categories(cb) {
	      var options = [];
	      var generateCategoryOptions = function generateCategoryOptions(items, container) {
	        items.forEach(function (item) {
	
	          if (!item.path) {
	            return;
	          }
	          var depth = item.path.split('/').filter(Boolean).length;
	          var indent = new Array(5).join(String.fromCharCode(160));
	          container.push({
	            id: item.id,
	            path: item.path,
	            sefriendly: item.sefriendly,
	            parent: item.parent,
	            parent_id: item.parent_id,
	            name: item.name,
	            _name: new Array(depth).join(indent) + item.name
	          });
	          if (item.children) {
	            generateCategoryOptions(item.children, container);
	          }
	        });
	        return container;
	      };
	      Category.getPermittedTree().$promise.then(function (data) {
	        generateCategoryOptions(data, options);
	        cb(null, options);
	      });
	    }
	  }, function (err, results) {
	    if (err) return console.log(err);
	    if (results.article.error) {
	      $location.path('/unauthorized');
	    } else {
	      if (results.article.show_inarticle == 21 || results.article.show_inarticle == 22) {
	        init(results.article, results.categories);
	      } else {
	        $scope.isSaving = true;
	        $location.path('/account/edit-article/' + results.article.article_id);
	      }
	    }
	  });
	
	  $scope.changePT1 = function (pt1) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt1;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_local_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.changePT2 = function (pt2) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt2;
	    });
	    if (playerOrTeam.length) {
	      $scope.data.equipo_visitante_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.loadProfiles = function (query) {
	    return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
	      if (!profiles) return [];
	      var searchName = query.toLowerCase();
	      return profiles.data.filter(function (p) {
	        var name = p.name.toLowerCase();
	        return name.indexOf(searchName) > -1;
	      }).map(function (p) {
	        return {
	          _id: p._id,
	          name: p.name
	        };
	      });
	    });
	  };
	}]);

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = "<style>.ubuntu{font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif}#editor{background-color:#f4f9ff;border:5px solid #d1eaff;border-radius:10px;padding:20px 30px 0 30px;min-height:180px;margin-bottom:20px}.comment-container h2{background-color:#fff;font-weight:300;color:#333;padding:15px 30px;text-align:center;font-size:20px;font-family:'Open Sans','Ubuntu Condensed',Arial;letter-spacing:0}@media (max-width:768px){.col-sm-8{padding-left:0;padding-right:0}}.droid{font-family:'Open Sans',Georgia,'Times New Roman',Times,serif;font-size:19px}.open-sans{font-family:'Open Sans',sans-serif}.live{font-family:'Open Sans','Droid Serif',Georgia,'Times New Roman',Times,serif}article figure{display:block;-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;margin:0;position:relative}article figure{margin-bottom:10px}article figcaption{text-align:center;font-size:11px;padding:10px;color:#fff;font-family:Open Sans,Georgia,sans-serif;position:absolute;bottom:15px;right:15px;text-shadow:2px 2px 2px #000}.live h2{text-align:left;font-size:18px;font-weight:700;margin-top:0;margin-bottom:10px}.live time{font-size:10px;display:none}.image_caption_news{font-size:11px;font-style:italic;color:#777;background-color:#eee;padding:15px;border-bottom:1px #ddd solid;border-top:1px #ddd solid;margin-bottom:20px}.page-header{padding-bottom:10px;margin:0 0 18px}#save{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}#switch{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}.side-row{padding:10px;color:#fff;background:#28a5e4}.toggle-switch{min-width:64px;border-color:#848484;font-size:11px}.toggle-switch span{line-height:inherit}.toggle-switch .switch-left{background:#63c663;color:#fff}.toggle-switch .switch-right{background:#c43939;color:#fff}.no-margin{margin:0}.no-border{border:0;border-radius:0}oi-select{width:200px}oi-select .select-dropdown,oi-select .select-search-list-item,oi-select .select-search-list-item_input input{font-size:13px;white-space:nowrap}oi-select .select-dropdown{max-height:200px}oi-select .select-search-list-item_selection{box-shadow:none}.right-sidebar .form-inline{border-bottom:1px solid #e4e3e3}.right-sidebar .form-inline.no-border{border:0;border-radius:0}.right-sidebar .panel{margin:0}.right-sidebar .panel-body{background-color:#f9f9f9}.right-sidebar .form-inline .form-group{margin:10px 0;width:100%}.right-sidebar .form-inline label{font-size:12px;font-weight:400}.right-sidebar .form-inline input{float:right;height:26px}.right-sidebar oi-select .select-search{background:#eee}.right-sidebar .form-inline input,.right-sidebar .form-inline select,.right-sidebar .form-inline textarea{font-size:12px;font-weight:400;width:150px;margin-left:30px;border-radius:0;background:#eee}.right-sidebar .form-inline textarea{width:250px;margin-left:0}.right-sidebar input[type=datetime-local]{margin-left:0;width:100%}.right-sidebar tags-input .host{position:static}.margin-sidebar{margin-top:98px}.fixed-save{position:fixed;top:0;width:293px}.fixed-publishing{position:fixed;top:96px;width:293px}.dragover{padding:10px;border:2px dashed #28a5e4}.PhotoFull img{width:700px}.PhotoRight{width:400px;float:right;margin:1em}.PhotoRight figcaption{margin:0}.PhotoMinifull{width:440px}.PhotoMinifull+article{width:440px}.Newspapermode{display:none}.Liveevent figcaption{margin-bottom:0}.Liveevent{margin-bottom:20px}.Liveevent+article{font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,\"Times New Roman\",Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article{background-color:#fff;font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,\"Times New Roman\",Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article img{margin:auto;display:block;border:10px #fff solid;border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;-moz-box-shadow:0 0 3px rgba(0,0,0,.15);-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15)}.Liveevent+article p{border-bottom:1px solid grey;margin:0;padding:10px 10px}.score_number{background-color:#fff;font-size:44px;color:#222;line-height:44px;padding:7px 20px;font-weight:700;-moz-border-radius:55px;-webkit-border-radius:55px;border-radius:55px;text-align:center;max-width:30px;overflow:hidden}#score_bar{padding-top:25px;padding-bottom:60px;width:100%;min-height:65px;background:-moz-linear-gradient(top,#fff 0,#eee 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),color-stop(100%,#eee));background:-webkit-linear-gradient(top,#fff 0,#eee 100%);background:-o-linear-gradient(top,#fff 0,#eee 100%);background:-ms-linear-gradient(top,#fff 0,#eee 100%);background:linear-gradient(top,#fff 0,#eee 100%);border-radius:0;border-bottom:4px #fff solid;margin-bottom:20px}#score_team{width:31%;font-size:24px;color:#222;font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif;text-align:center;font-weight:777;padding-top:10px}.date-container{padding:20px;background-color:#fff;width:100%;-webkit-box-shadow:0 3px 12px -9px rgba(0,0,0,.75);-moz-box-shadow:0 3px 12px -9px rgba(0,0,0,.75);box-shadow:0 3px 12px -9px rgba(0,0,0,.75);border:1px solid #eee;clear:both;margin-bottom:15px}.comment-container{background-color:#fff;-webkit-box-shadow:0 2px 17px -9px rgba(0,0,0,.75);-moz-box-shadow:0 2px 17px -9px rgba(0,0,0,.75);box-shadow:0 2px 17px -9px rgba(0,0,0,.75);padding:20px}#editor{font-size:19px!important}#agregarNota{width:100%;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}.phrase-live{margin-bottom:70px;font-size:18px;text-align:center;color:#999;font-weight:700}article{font-size:16px}body{background:#f6f6f6}#live-comment div{background-color:#fff;border-bottom:1px solid #ddd;margin-bottom:10px;padding:15px 20px 10px 20px}.image_caption_news{margin-bottom:0}.datetime input:first-child,.datetime label{margin-right:10px}.body-live-form{background-color:#fff;border-bottom:1px solid #ddd;padding:5px 5px 30px 5px}.body-live-form .form-group{margin-bottom:2px}.body-live-form .body-live-edit{padding:2px;display:none}.body-live-form .pin-button{margin:0 10px;background:#2fcbdc36}.body-live-form:hover .body-live-edit{display:block}.pin-comment-button{display:block!important;background:#3b2fdc36!important}.pin-comment{background:#2fcbdc36}</style> <div class=row id=add-article style=margin-top:10px> <div class=col-xs-12> <div class=page-header> <button class=\"btn btn-danger pull-right\" ng-click=delete(data) ng-if=isAdmin>{{ localizedMessages.get('delete') }}</button> <form class=form-inline> <div class=pull-right> </div> <div class=form-group> <oi-select oi-options=\"option._name for option in categories track by option.id\" oi-select-options=selectSettings ng-model=data.category placeholder=\"Choose Category1\" ng-disabled=!canChangeCategory()></oi-select> </div> <div class=form-group style=padding-right:10px> <oi-select oi-options=\"option.value for option in statuses track by option.id\" oi-select-options=selectSettings ng-model=data.status placeholder=\"Wybierz status\" ng-disabled=!canChangeStatus()></oi-select> </div> <div class=form-group> <label for=Live-event>{{ localizedMessages.get('live-event') | uppercase }}</label> </div> </form> </div> </div> </div> <div class=\"row w990\"> <div class=col-sm-8> <h1 ng-model=data.title strip-br=true class=\"text-center ubuntu\" contenteditable={{editPermit}} placeholder=\"Add your title here\" style=margin-top:0 ng-blur=titleChanged()></h1> <h4 ng-model=data.abstract strip-br=true class=\"text-justify open-sans\" contenteditable={{editPermit}} placeholder=\"Add the description of your article in 2 or 3 lines here. If you don't have a good idea for description, answer to 5W: who, what? where? why? how?\"></h4> <div ng-class=howToShow> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-upload ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ngf-thumbnail=\"thumbnail || (data.image ? imgUrl + data.image : false) || imgUrl + 'medium_upload-6536040818.png'\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15)\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <figcaption ng-model=data.image_caption contenteditable={{editPermit}} class=\"text-center image_caption_news\" id=image_caption placeholder=\"Add image caption and photo source here\" style=min-height:20px> </figcaption> <div ng-show=\"howToShow == 'Liveevent'\" style=\"text-align:center;background-color:#eee;padding:20px 0;color:#666;font-family:Tahoma,Geneva,sans-serif\"> <b>{{ localizedMessages.get('what-do-live-finish') }}:</b> <br> - {{ localizedMessages.get('change-title') }}<br> - {{ localizedMessages.get('quit-heading') }} <br><br> <b>{{ localizedMessages.get('latin-languages') }}:</b> {{ localizedMessages.get('title-from') }}:<br> {{ localizedMessages.get('title-from-example') }} <br><br> <b>{{ localizedMessages.get('english') | uppercase }}:</b> {{ localizedMessages.get('title-from') }}:<br> {{ localizedMessages.get('title-from-example2') }} </div> <div id=score_bar ng-show=data.equipo_local style=margin-bottom:0> <div id=score_team style=float:left>{{data.equipo_local.name}}</div> <div style=float:left;width:38%> <div id=score_count style=\"margin:0 auto;width:100%;text-align:center\"> <span class=score_number style=margin-right:7px>{{data.goles_local+\"\"}}</span> <span class=score_number>{{data.goles_visitante+\"\"}}</span> </div> </div> <div id=score_team style=float:right>{{data.equipo_visitante.name}}</div> </div> </div> <form class=\"date-container form-inline no-border\"> <div style=text-align:center;margin-bottom:20px;font-size:16px;font-weight:300><span style=font-weight:700;background-color:#5db971;color:#fff;padding:10px;line-height:200%>At What Time this Event will Start and End?</span><br><br>¿A que hora empieza y acabará este evento?</div> <div class=\"form-group datetime group2\" style=margin-right:3% id=startDate> <label for=startDatess>{{ localizedMessages.get('start-date') }} > </label> <input ng-model=data.startDate data-field=datetime type=text class=form-control id=startDatess placeholder=\"yyyy-MM-dd HH:mm\" readonly=readonly> </div> <div class=\"form-group datetime group3\" style=margin-right:0 id=endDate> <label for=endDatess>{{ localizedMessages.get('end-date') }} > </label> <input ng-model=data.endDate data-field=datetime type=text class=form-control id=endDatess placeholder=\"yyyy-MM-dd HH:mm\" readonly=readonly> </div> <br><br> <span style=\"text-align:center;font-weight:300;font-size:11.5px;font-family:Open Sans\">** {{ localizedMessages.get('add-time-when-helper') }} <b>{{ localizedMessages.get('add-time-when-helper-carrousel') }}</b></span> </form> <h2 style=\"font-weight:100;font-family:'Open Sans',Ubuntu,Arial;font-size:22px;margin-top:30px;margin-bottom:0;text-align:center;padding:10px;color:#fff;background-color:#2277c0;letter-spacing:0\">{{ localizedMessages.get('add-comment-live') }} ></h2> <div class=comment-container> <h2 ng-model=notas.titulo strip-br=true class=\"text-center ubuntu\" contenteditable={{editPermit}} placeholder=\"Can add a title for the comment clicking here (optional)\" style=margin-top:0></h2> <article id=editor ng-model=notas.nota ckeditor=ckOptions contenteditable=true ready=onReady() class=\"text-justify article-content droid\" spellcheck=false style=position:relative;min-height:200px placeholder=\"Add your LIVE COMMENT HERE! Ideal is 3 or 4 lines of lenght. When be added click in 'Add comment' button and it will be published in real time in the LIVE article.\"> </article> <button type=button id=agregarNota ng-click=addComment()> <span>{{ localizedMessages.get('add-comment') }}</span> </button> </div> <div class=phrase-live style=margin-top:20px>{{ localizedMessages.get('live-content-reader') }}:</div> <div ng-if=\"data.isbodylive === false\"> <article id=live-comment ng-model=data.body contenteditable={{isAdmin}} class=\"text-justify article-content live\" spellcheck=false style=position:relative> </article> </div> <div ng-else> <section ng-repeat=\"body in data.bodylive\" class=\"text-justify article-content live\" spellcheck=false> <form class=\"form-horizontal body-live-form\" ng-class=\"{'pin-comment': pinComment && $index === 0}\"> <div class=form-group> <label class=\"col-sm-2 control-label\" for=bodylive-title style=width:16.6%>{{ localizedMessages.get('title') }}</label> <div class=col-sm-10> <input type=text class=form-control id=bodylive-title ng-model=body.title /> </div> </div> <div class=form-group> <label class=\"col-sm-2 control-label\" for=bodylive-date style=width:16.6%>{{ localizedMessages.get('date') }}</label> <div class=col-sm-10> <input type=text class=form-control id=bodylive-date ng-model=body.date /> </div> </div> <div class=form-group> <label class=\"col-sm-2 control-label\" for=bodylive-desc style=width:16.6%>{{ localizedMessages.get('description') }}</label> <div class=col-sm-10> <textarea id=bodylive-desc class=form-control rows=2 ng-model=body.description /> </div> </div> <button type=submit class=\"btn btn-default body-live-edit pull-right\" ng-click=editBodyLive(body,$index)>{{ localizedMessages.get('save') }}</button> <button class=\"btn btn-default body-live-edit pin-button pull-right\" ng-class=\"{'pin-comment-button': pinComment && $index === 0}\" ng-click=setPinComment(body,$index)> <span ng-if=\"$index || !pinComment\">{{ localizedMessages.get('pin') }}</span> <span ng-if=\"$index === 0 && pinComment\">{{ localizedMessages.get('unpin') }}</span> </button> </form> </section> </div> <br> <br> <div> <h5><strong>{{ localizedMessages.get('tags') | uppercase }}</strong></h5> <p>{{ localizedMessages.get('tags-helper') }}</p> <tags-input ng-model=data.tags replace-spaces-with-dashes=false add-from-autocomplete-only=true> <auto-complete source=loadTags($query) debounce-delay=1></auto-complete> </tags-input> </div>  </div> <div class=\"col-sm-4 right-sidebar\"> <button type=button id=save class=\"btn btn-lg btn-block\" ng-click=save() ng-disabled=\"isSaving || !editPermit\"> <img src=http://www.vavel.com/user/img/486.GIF ng-show=isSaving /> <span ng-hide=isSaving>{{saveBtnText}}</span> </button> <button ng-show=!editPermit type=button id=switch class=\"btn btn-lg btn-block\" ng-click=switch() ng-disabled=editPermit> <img src=http://www.vavel.com/user/img/486.GIF ng-show=isSaving /> <span ng-hide=isSaving>{{switchBtnText}}</span> </button> <div class=\"clearfix side-row\" id=autosave> <small>{{ localizedMessages.get('autosave') }} <span ng-hide=autosave> {{ localizedMessages.get('is-off') }}</span> <span ng-show=autosave> {{ localizedMessages.get('in') }} {{autosaveTimer}}</span> <br> <span style=color:#dbfffd>{{editing}}</span> <br> <span style=color:#f9dbff>{{watching}}</span> </small> <div class=pull-right> </div> </div> <h4 class=\"text-muted well no-margin no-border\">{{ localizedMessages.get('news') }}</h4> <div class=\"well no-margin no-border\"> <form class=\"form-inline no-border\"> <div class=form-group> <label for=author>{{ localizedMessages.get('author') }}</label> <input ng-model=data.author.name type=text class=form-control id=author ng-disabled=!canChangeAuthor()> </div> </form> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.url = !accordion.url\"> <strong>{{ localizedMessages.get('url') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" collapse=accordion.url> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=url>{{ localizedMessages.get('url') }} {{ localizedMessages.get('slug') }}:</label> <input ng-model=data.sefriendly type=text class=form-control id=url> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.image = !accordion.image\"> <strong>{{ localizedMessages.get('image') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" collapse=accordion.image> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=image>{{ localizedMessages.get('image') }}:</label> <input ng-model=data.image type=text class=form-control id=image> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.published_by = !accordion.published_by\"> <strong>{{ localizedMessages.get('publishing') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.published_by> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=\"form-group datetime group1\" id=publish_date> <label for=publishing-date>{{ localizedMessages.get('publishing-date') }}</label> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\" readonly=readonly> </div> </form> <br/> <form class=\"form-inline no-border\"> <div class=form-group> <label for=last-edited-by>{{ localizedMessages.get('last-edited-by') }}</label> <input ng-model=data.last_edited_by.name ng-disabled=true type=text class=form-control id=last-edited-by> </div> </form> <form class=\"form-inline no-border\"> <div class=form-group> <label for=published-by>{{ localizedMessages.get('published-by') }}</label> <input ng-model=data.published_by.name ng-disabled=!canChangeAuthor() type=text class=form-control id=published-by> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\" ng-if=isAdmin> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.notificacion = !accordion.notificacion\"> <strong>{{ localizedMessages.get('notificacions') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.notificacion> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=notificacion>{{ localizedMessages.get('notifications-message') }}:</label> <input ng-model=data.notificacion type=text class=form-control id=notificacion> <button type=button id=notificacion ng-click=notify()> <span>{{ localizedMessages.get('send-notification') }}</span> </button> </div> </form> </div> </div> </div> </div> </div> <div id=dtBox1></div> <div id=dtBox2></div> <div id=dtBox3></div> <script>var dateValue,dateValueStartDate,dateValueEndDate;$(function(){var e=$('[contentEditable=\"true\"]'),a=null,t=function(e){(a=$(this)).text().trim().length||a.empty()};e.on(\"input\",t),e.each(t),$(window).on(\"scroll\",function(e){143<$(window).scrollTop()?($(\"#save\").addClass(\"fixed-save\"),$(\"#autosave\").addClass(\"fixed-autosave\"),$(\"#publishing\").addClass(\"fixed-publishing\"),$(\".right-sidebar\").addClass(\"margin-sidebar\")):($(\"#save\").removeClass(\"fixed-save\"),$(\"#autosave\").removeClass(\"fixed-autosave\"),$(\"#publishing\").removeClass(\"fixed-publishing\"),$(\".right-sidebar\").removeClass(\"margin-sidebar\"))}),$(\"#dtBox1\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",parentElement:\".group1\",settingValueOfElement:function(e,a,t){dateValue=a}}),$(\"#dtBox2\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",parentElement:\".group2\",settingValueOfElement:function(e,a,t){dateValueStartDate=a}}),$(\"#dtBox3\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",parentElement:\".group3\",settingValueOfElement:function(e,a,t){dateValueEndDate=a}})});var changesSaved=!0;window.onbeforeunload=function(){if(1==changesSaved)return\"live edit You havent saved your changes. Are you sure you want to leave the page?\"}</script> ";

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	function articleFormatDate(date) {
	  if (date) {
	    var m = date.isMoment ? date : moment(date);
	    return m.local().format('YYYY-MM-DD HH:mm');
	  }
	
	  return null;
	}
	
	exports.toFormatArticleDate = articleFormatDate;
	
	exports.prepareBeforeEmitArticleChanged = function (src) {
	  var data = _.clone(src);
	  if (data.publish_date) data.publish_date = moment(data.publish_date).toISOString();
	  if (data.startDate) data.startDate = moment(data.startDate).toISOString();
	  if (data.endDate) data.endDate = moment(data.endDate).toISOString();
	
	  return data;
	};
	
	exports.prepareForEditArticle = function (src) {
	  var data = _.clone(src);
	  if (data.publish_date) data.publish_date = articleFormatDate(data.publish_date);
	  if (data.startDate) data.startDate = articleFormatDate(data.startDate);
	  if (data.endDate) data.endDate = articleFormatDate(data.endDate);
	
	  return data;
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.edit-article', ['common.header', 'common.footer', 'config', 'directives.contenteditable', 'account.settings.social', 'security.service', 'security.authorization', 'services.accountResource', 'services.utility', 'services.formErrors', 'ui.bootstrap', 'directives.serverError', 'ngTagsInput', 'ngFileUpload', 'toggle-switch', 'angular-growl', 'ckeditor', 'resources.User', 'resources.Tag', 'resources.Category', 'resources.Article', 'resources.AdminUser', 'filters.rawHtml', 'services.localizedMessages', 'ckeditorPlaceholder']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.edit-article', {
	    url: '/edit-article/:id',
	    title: 'Edit Article',
	    views: {
	      'main@': {
	        template: __webpack_require__(169),
	        controller: 'EditArticleCtrl',
	        resolve: {
	          locations: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type: 'location' });
	          }],
	          playersAndTeams: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
	          }],
	          listOfUsers: ["AdminUser", function (AdminUser) {
	            return AdminUser.getAll().$promise.then(function (result) {
	              return result.data;
	            });
	          }]
	        }
	      }
	    }
	  });
	}]).controller('EditArticleCtrl', ["$scope", "$location", "$log", "$interval", "$stateParams", "$sce", "$uibModal", "security", "utility", "growl", "user", "SOCIAL", "STATUSES", "ARTICLE_STYLES", "APP_IMG_URLS", "Upload", "formErrors", "dateFilter", "Article", "Category", "User", "Tag", "socket", "$window", "locations", "playersAndTeams", "listOfUsers", "localizedMessages", "adminResource", function ($scope, $location, $log, $interval, $stateParams, $sce, $uibModal, security, utility, growl, user, SOCIAL, STATUSES, ARTICLE_STYLES, APP_IMG_URLS, Upload, formErrors, dateFilter, Article, Category, User, Tag, socket, $window, locations, playersAndTeams, listOfUsers, localizedMessages, adminResource) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  $scope.dataLoaded = false;
	  $scope.imgUrl = APP_IMG_URLS['base'];
	
	  var urlGenerated = false;
	  var timer = null;
	  var slugify = __webpack_require__(152);
	
	  var toFormatArticleDate = __webpack_require__(167).toFormatArticleDate;
	  var prepareBeforeEmitArticleChanged = __webpack_require__(167).prepareBeforeEmitArticleChanged;
	  var prepareForEditArticle = __webpack_require__(167).prepareForEditArticle;
	
	  $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
	    return { _id: p._id, name: p.name };
	  }) : [];
	
	  $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
	    return {
	      _id: p._id,
	      name: p.name,
	      type: p.role.role_type
	    };
	  }) : [];
	
	  $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function (e) {
	    return e.type === 'profile';
	  }) : [];
	  $scope.editPermit = false;
	
	  var publishDate = moment();
	  var init = function init(article, categories) {
	    // console.log( '>>> init', article.publish_date, article.status, [1, 3, 17, 18].indexOf(article.status) );
	    if (article.status) {
	      if ([1, 3, 17, 18].indexOf(article.status) >= 0) {
	        publishDate = moment(article.publish_date);
	      }
	    }
	
	    $scope.categories = categories;
	    $scope.statuses = _.filter(STATUSES, function (status) {
	      return ~user.permissions.statuses.indexOf(status.id);
	    });
	    if (user.permissions.statuses[0] === '*') {
	      $scope.statuses = STATUSES;
	    }
	    $scope.statuses.map(function (s) {
	      s.value = s.value.split("?").join('');
	    });
	    $scope.$watch('data.show_inarticle', function (newVal, oldVal) {
	      $scope.howToShow = newVal.value.replace(/ /g, "");
	    });
	
	    $scope.isAdmin = false;
	    if (user.permissions.is_admin) {
	      $scope.isAdmin = true;
	      // console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
	    }
	    $scope.data = {
	      _id: article._id,
	      article_id: article.article_id,
	      title: _.unescape(article.title),
	      sefriendly: article.sefriendly,
	      status: _.find(STATUSES, { id: '' + article.status }),
	      orderNumber: article.orderNumber,
	      image: article.image,
	      video: article.video,
	      image_caption: _.unescape(article.image_caption),
	      body: _.unescape(article.body),
	      abstract: _.unescape(article.abstract),
	
	      equipo_local: article.equipo_local_new ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local_new._id }) : article.equipo_local ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local }) : undefined,
	
	      equipo_visitante: article.equipo_visitante_new ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante_new._id }) : article.equipo_visitante ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante }) : undefined,
	
	      goals: article.goals,
	      goles_local: article.goles_local,
	      goles_visitante: article.goles_visitante,
	
	      referee: article.referee_new ? _.find($scope.profilesList, { _id: article.referee_new._id }) : !!article.referee ? _.find($scope.profilesList, { _id: article.referee }) : undefined,
	
	      incidents: article.incidents,
	      show_inarticle: _.find(ARTICLE_STYLES, { id: '' + article.show_inarticle }),
	      category: article.category ? _.find(categories, { id: article.category.id }) : '',
	      tags: [],
	      author: article.author,
	      last_edited_by: article.last_edited_by,
	      published_by: article.published_by,
	      publish_date: toFormatArticleDate(publishDate),
	      team1: article.team1,
	      team2: article.team2,
	      team1players: angular.isArray(article.team1players) ? article.team1players.map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [],
	      team2players: angular.isArray(article.team2players) ? article.team2players.map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [],
	      created_at: article.created_at,
	
	      stadium: article.stadium_new ? _.find($scope.stadiumsList, { _id: article.stadium_new._id }) : !!article.stadium ? _.find($scope.stadiumsList, { _id: article.stadium }) : undefined
	    };
	
	    $scope.videoUrl = article.video;
	
	    $scope.changePT1(article.equipo_local);
	    $scope.changePT2(article.equipo_visitante);
	
	    $scope.listOfUsers = {
	      username: article.author.username,
	      options: listOfUsers.filter(function (p) {
	        return p.account.groups && p.account.groups.length > 0;
	      }).map(function (u) {
	        var full = u.account.name.full;
	        if (!full) {
	          full = u.account.name.first + ' ' + u.account.name.last;
	        }
	        if (full === ' ') full = u.username;
	        return {
	          username: u.username,
	          picture: u.account.picture,
	          name: full || u.username
	        };
	      })
	    };
	    $scope.editPermit = true;
	    var listenerFunction = null;
	    //send user name of person who start editing and  id of edited topic
	    socket.emit('connectDocs', {
	      userName: user.account.name.full,
	      artId: article.article_id,
	      userId: user._id,
	      docs: $scope.data
	    });
	    var internalChange = false;
	    var listenData = false;
	
	    socket.on('startEditing', function (data) {
	      // console.log( '>>> startEditing', data );
	      $scope.editPermit = true;
	      $scope.editing = "Editing by: " + user.account.name.full;
	      if (data) {
	        $scope.data = prepareForEditArticle(data.data);
	      }
	      listenerFunction = $scope.$watchCollection("data", _.debounce(function (newValue, oldValue) {
	        if (!_.isEqual(newValue, oldValue) && !internalChange) {
	          // console.log('emit articleChanged', article.article_id, prepareBeforeEmitArticleChanged(newValue));
	          socket.emit('articleChanged', {
	            artId: article.article_id,
	            data: prepareBeforeEmitArticleChanged(newValue)
	          });
	        }
	        internalChange = false;
	      }, 1000));
	      listenData = true;
	    });
	
	    socket.on('startWatching', function (articleRoom) {
	      $scope.data = articleRoom.docs;
	      var user = _.find(articleRoom.users, function (user) {
	        return user.userId === articleRoom.editing;
	      });
	      $scope.editing = "editing by: " + user.name;
	    });
	
	    socket.on('newcomer', function (watchers) {
	      $scope.watching = watchers.reduce(function (prev, obj) {
	        return prev + obj.name + ', ';
	      }, "watching by: ");
	    });
	
	    //send user name of person who ends editing and  id of edited topic
	    $scope.$on('$locationChangeStart', function (event) {
	      console.log('change route', $scope.editPermit);
	      if ($scope.editPermit) {
	        socket.emit('endEdit');
	        socket.off('applyChanges');
	      }
	    });
	
	    var windowElement = angular.element($window);
	    windowElement.on('beforeunload', function (event) {
	      // do whatever you want in here before the page unloads.
	      if ($scope.editPermit) {
	        socket.emit('endEdit');
	        socket.off('applyChanges');
	      }
	      // the following line of code will prevent reload or navigating away.
	      event.preventDefault();
	    });
	
	    //recieving changes from other editors
	    socket.on('applyChanges', function (data) {
	      // console.log( '>>> on applyChanges', data );
	      if (data.editing === user._id) {
	        $scope.editPermit = true;
	        if (!listenerFunction) {
	          listenerFunction = $scope.$watchCollection("data", _.debounce(function (newValue, oldValue) {
	            if (!_.isEqual(newValue, oldValue) && !internalChange) {
	              console.log('emit articleChanged');
	              socket.emit('articleChanged', {
	                artId: article.article_id,
	                data: prepareBeforeEmitArticleChanged(newValue)
	              });
	            }
	            internalChange = false;
	          }, 1000));
	        }
	      } else {
	        $scope.editPermit = false;
	        if (listenerFunction) {
	          listenerFunction();
	          listenerFunction = null;
	        }
	      }
	      var users = data.users;
	
	      var editor = _.find(users, function (us) {
	        return us.userId === data.editing;
	      });
	      var watchers = users.filter(function (us) {
	        return us.userId !== data.editing;
	      });
	      $scope.editing = "editing by: " + editor.name;
	      if (watchers.length > 0) {
	        $scope.watching = watchers.reduce(function (prev, obj) {
	          return prev + obj.name + ', ';
	        }, "watching by: ");
	      } else {
	        $scope.watching = "";
	      }
	
	      if (!_.isEqual($scope.data, data.docs)) {
	        $scope.data = prepareForEditArticle(data.docs);
	        internalChange = true;
	      }
	    });
	
	    $scope.switch = function () {
	      console.log('gorgojo');
	      socket.emit('changeEditPermit', {
	        artId: article.article_id,
	        userId: user._id
	      });
	    };
	
	    if (article.tags) {
	      $scope.data.tags = article.tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.name,
	          sefriendly: slugify(tag.name)
	        };
	      });
	    }
	
	    if ($scope.data.status === undefined) {
	      $scope.data.status = {
	        id: '0',
	        value: localizedMessages.get('pending')
	      };
	    }
	
	    $scope.$watch('data.show_inarticle', function (newVal, oldVal) {
	      $scope.data.show_inarticle = _.find(ARTICLE_STYLES, { id: '' + newVal.id });
	    });
	    $scope.dataLoaded = true;
	  };
	
	  $scope.article_styles = ARTICLE_STYLES;
	  $scope.uploading = false;
	  $scope.isSaving = false;
	  $scope.autosaveTimer = 180;
	  $scope.accordion = {
	    score: true,
	    publishing_date: true,
	    url: true,
	    image: true,
	    published_by: false
	  };
	
	  var startTimer = function startTimer() {
	    return $interval(function () {
	      if ($scope.autosaveTimer <= 0) {
	        $scope.save();
	      }
	      $scope.autosaveTimer -= 1;
	    }, 1000);
	  };
	
	  var resetTimer = function resetTimer() {
	    $scope.autosaveTimer = 180;
	    $interval.cancel(timer);
	  };
	
	  $scope.autosaveChanged = function () {
	    if ($scope.autosave) {
	      timer = startTimer();
	    } else {
	      resetTimer();
	    }
	  };
	
	  $scope.canChangeAuthor = function () {
	    return user.permissions.is_editor && $scope.canChangeCategory();
	  };
	
	  $scope.canChangeStatus = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	    //return ~user.permissions.statuses.indexOf(article.status + '');
	  };
	
	  $scope.canChangeCategory = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	    //return ~user.permissions.categories.indexOf(article.category.id);
	  };
	
	  $scope.canChangeFormat = function () {
	    return true;
	  };
	
	  $scope.titleChanged = function () {
	    $scope.data.title = $scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " ");
	    if ($scope.data.sefriendly) {
	      return;
	    }
	    $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " "));
	  };
	
	  $scope.saveBtnText = "Save";
	  $scope.switchBtnText = "Switch";
	
	  $scope.save = function () {
	    resetTimer();
	    $scope.autosaveChanged();
	    $scope.data.sefriendly = slugify($scope.data.sefriendly);
	    if (!$scope.data.title) {
	      growl.error('Title is required');
	      return;
	    }
	    if (!$scope.data.category) {
	      growl.error('Category is required');
	      return;
	    }
	    if (!$scope.data.body) {
	      growl.error('Body is required');
	      return;
	    }
	
	    $scope.isSaving = true;
	
	    var data = angular.copy($scope.data);
	    data.edition = data.category.path.split("/")[1];
	    data.show_inarticle = parseInt(data.show_inarticle.id, null);
	    data.status = parseInt(data.status.id, null);
	    // data.categories = data.category.path.split('/').filter(Boolean).map(function(item) {return {sefriendly: item};}).reverse();
	    // delete data['category'];
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text)
	      };
	    });
	
	    data.publish_date = (data.publish_date ? moment(data.publish_date) : publishDate).toISOString();
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.published_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    var catArray = data.category.parent == "/" ? [] : data.category.parent.substring(1).split('/');
	    var pDate = new Date(data.created_at);
	    var pMonth = pDate.getUTCMonth() + 1;
	    var dateSeg = '/' + pDate.getUTCFullYear() + '/' + ('0' + pMonth).slice(-2) + '/' + ('0' + pDate.getUTCDate()).slice(-2) + '/';
	    data.url_segment = dateSeg;
	    if (catArray.length == 0) {
	      data.url_segment = '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length == 1) {
	      data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length > 1) {
	      data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
	    }
	
	    data.body = CKEDITOR.instances.editor.getData();
	
	    // console.log("$startDate------->>>>>>>" + data.startDate);
	
	    Article.update(data, function (result) {
	      setTimeout(function () {
	        //growl.info('Changes saved!');
	        $scope.data.last_edited_by = data.last_edited_by;
	      }, 1000);
	    }, formErrors.growlErrors).$promise.then(function () {
	      $scope.saveBtnText = "Saved!";
	      $scope.isSaving = false;
	      setTimeout(function () {
	        $scope.saveBtnText = "Saved!";
	      }, 500);
	    }).catch(function (error) {
	      $scope.saveBtnText = "Error!";
	      $scope.isSaving = false;
	      alert(error.data);
	    });
	  };
	
	  $scope.onChangeVideoUrl = function () {
	    $scope.videoUrl = $scope.data.video;
	  };
	
	  $scope.notify = function () {
	    var data = angular.copy($scope.data);
	    data.edition = data.category.path.split("/")[1];
	    data.show_inarticle = parseInt(data.show_inarticle.id, null);
	    data.status = parseInt(data.status.id, null);
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text)
	      };
	    });
	
	    // console.log( '>>> notify', dateValue, data.publish_date );
	    if (dateValue) {
	      data.publish_date = moment(dateValue).toISOString();
	    } else {
	      data.publish_date = publishDate.toISOString();
	    }
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.notify = 1;
	      //console.log($scope.data.title);
	      Article.update(data, function (result) {
	        setTimeout(function () {
	          //growl.info('Changes saved!');
	          $scope.data.last_edited_by = data.last_edited_by;
	          // $location.path('/edit-article/' + result.data._id);
	        }, 1000);
	      }, formErrors.growlErrors).$promise.then(function () {
	        $scope.saveBtnText = "Saved!";
	        $scope.isSaving = false;
	        setTimeout(function () {
	          $scope.saveBtnText = "Saved!";
	        }, 500);
	      });
	    }
	  };
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    if (!$scope.isSaving) {
	      var answer = confirm("Are you sure you want to navigate away from this page");
	      if (!answer) {
	        event.preventDefault();
	      }
	    }
	  });
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.thumbnail = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.loadTags = function (query) {
	    return Tag.search({ q: query }).$promise.then(function (tags) {
	      if (!tags) return [];
	      return tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.nametag,
	          name: tag.nametag,
	          oficial: tag.oficial,
	          sefriendly: tag.name
	        };
	      });
	    });
	  };
	
	  $scope.delete = function (tag) {
	    if (!confirm('Are you sure you want to delete this article?')) {
	      return;
	    }
	    Article.delete({ id: tag._id }, function (result) {
	      setTimeout(function () {
	        growl.info('Article removed!');
	        $location.path('/account/my-articles');
	      }, 1000);
	    }, formErrors.growlErrors);
	  };
	
	  async.parallel({
	    article: function article(cb) {
	      Article.query({ id: $stateParams.id }).$promise.then(function (result) {
	        return cb(null, result);
	      });
	    },
	    categories: function categories(cb) {
	      var options = [];
	      var generateCategoryOptions = function generateCategoryOptions(items, container) {
	        items.forEach(function (item) {
	
	          if (!item.path) {
	            return;
	          }
	          var depth = item.path.split('/').filter(Boolean).length;
	          var indent = new Array(5).join(String.fromCharCode(160));
	          container.push({
	            id: item.id,
	            path: item.path,
	            sefriendly: item.sefriendly,
	            parent: item.parent,
	            parent_id: item.parent_id,
	            name: item.name,
	            _name: new Array(depth).join(indent) + item.name
	          });
	          if (item.children) {
	            generateCategoryOptions(item.children, container);
	          }
	        });
	        return container;
	      };
	      Category.getPermittedTree().$promise.then(function (data) {
	        generateCategoryOptions(data, options);
	        cb(null, options);
	      });
	    }
	  }, function (err, results) {
	    if (err) return console.log(err);
	    if (results.article.error) {
	      $location.path('/unauthorized');
	    } else {
	      if (results.article.show_inarticle != 21 && results.article.show_inarticle != 22) {
	        init(results.article, results.categories);
	      } else {
	        $scope.isSaving = true;
	        $location.path('/account/edit-article-live/' + results.article.article_id);
	      }
	    }
	  });
	
	  $scope.changePT1 = function (pt1) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt1;
	    });
	    // console.log( '>>>1', playerOrTeam );
	    if (playerOrTeam.length) {
	      $scope.data.equipo_local_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.changePT2 = function (pt2) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt2;
	    });
	    // console.log( '>>>2', playerOrTeam );
	    if (playerOrTeam.length) {
	      $scope.data.equipo_visitante_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.loadProfiles = function (query) {
	    return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
	      if (!profiles) return [];
	      var searchName = query.toLowerCase();
	      return profiles.data.filter(function (p) {
	        var name = p.name.toLowerCase();
	        return name.indexOf(searchName) > -1;
	      }).map(function (p) {
	        return {
	          _id: p._id,
	          name: p.name
	        };
	      });
	    });
	  };
	
	  $scope.changedAuthor = function () {
	    var username = $scope.listOfUsers.username;
	    $scope.data.author = $scope.listOfUsers.options.find(function (u) {
	      return u.username === username;
	    });
	  }; // changeAuthor
	}]);

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "<style>.ubuntu{font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif}.droid{font-family:'Open Sans',Georgia,'Times New Roman',Times,serif;font-size:19px}.open-sans{font-family:'Open Sans',sans-serif}.image_caption_news{font-size:11px;font-style:italic;color:#777;background-color:#eee;padding:15px;border-bottom:1px #ddd solid;border-top:1px #ddd solid;margin-bottom:20px}.page-header{padding-bottom:10px;margin:0 0 18px}#save{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}#switch{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}.greenTag:before{content:\"\";display:inline-block;width:10px;height:15px;margin-right:5px;background-color:green!important}.greenTag:after{content:\"\";display:inline-block;width:10px;height:15px;margin-left:5px;background-color:green!important}article figure{display:block;-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;margin:0;position:relative}article figure{margin-bottom:10px}article figcaption{text-align:center;font-size:11px;padding:10px;color:#fff;font-family:Open Sans,Georgia,sans-serif;position:absolute;bottom:15px;right:15px;text-shadow:2px 2px 2px #000}.side-row{padding:10px;color:#fff;background:#28a5e4}.toggle-switch{min-width:64px;border-color:#848484;font-size:11px}.toggle-switch span{line-height:inherit}.toggle-switch .switch-left{background:#63c663;color:#fff}.toggle-switch .switch-right{background:#c43939;color:#fff}.no-margin{margin:0}.no-border{border:0;border-radius:0}oi-select{width:200px}oi-select .select-dropdown,oi-select .select-search-list-item,oi-select .select-search-list-item_input input{font-size:13px;white-space:nowrap}oi-select .select-dropdown{max-height:200px}oi-select .select-search-list-item_selection{box-shadow:none}.right-sidebar .form-inline{border-bottom:1px solid #e4e3e3}.right-sidebar .form-inline.no-border{border:0;border-radius:0}.right-sidebar .panel{margin:0}.right-sidebar .panel-body{background-color:#f9f9f9}.right-sidebar .form-inline .form-group{margin:10px 0;width:100%}.right-sidebar .form-inline label{font-size:12px;font-weight:400}.right-sidebar .form-inline input{float:right;height:26px}.right-sidebar oi-select .select-search{background:#eee}.right-sidebar .form-inline input,.right-sidebar .form-inline select,.right-sidebar .form-inline textarea{font-size:12px;font-weight:400;width:150px;margin-left:30px;border-radius:0;background:#eee}.right-sidebar .form-inline textarea{width:250px;margin-left:0}.right-sidebar input[type=datetime-local]{margin-left:0;width:100%}.right-sidebar tags-input .host{position:static}.margin-sidebar{margin-top:98px}.fixed-save{position:fixed;top:0;width:293px}.fixed-publishing{position:fixed;top:96px;width:293px}.dragover{padding:10px;border:2px dashed #28a5e4}.PhotoFull img{width:700px}.PhotoRight{width:400px;float:right;margin:1em}.PhotoRight figcaption{margin:0}.PhotoMinifull{width:440px}.PhotoMinifull+article{width:440px}.Newspapermode{display:none}.Liveevent figcaption{margin-bottom:0}.Liveevent{margin-bottom:20px}.Liveevent+article{font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,\"Times New Roman\",Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.video-block{background-color:#eee;color:#666;display:flex;flex-direction:column}.youtube-player{height:300px}.form-group-flex{display:flex;justify-content:flex-start;align-items:center}.form-group-flex .form-control-flex{flex-grow:1;margin-left:10px}.form-group label{font-weight:700}h2{font-family:Open Sans,Georgia;font-size:30px;padding-top:10px;margin-bottom:15px;padding-left:0;padding-right:5px;font-weight:700;letter-spacing:-1px;line-height:120%}p{font-size:19px;color:#444;margin:0 0 30px 0;padding-top:0;font-family:Open Sans,Georgia,\"Times New Roman\",Times,serif;line-height:145%;text-align:justify}.Liveevent+article{background-color:#fff;font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,\"Times New Roman\",Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article img{margin:auto;display:block;border:10px #fff solid;border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;-moz-box-shadow:0 0 3px rgba(0,0,0,.15);-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15)}.Liveevent+article p{border-bottom:1px solid grey;margin:0;padding:10px 10px}.score_number{background-color:#fff;font-size:44px;color:#222;line-height:44px;padding:7px 20px;font-weight:700;-moz-border-radius:55px;-webkit-border-radius:55px;border-radius:55px;text-align:center;max-width:30px;overflow:hidden}#score_bar{padding-top:0;padding-bottom:0;margin-bottom:20px;width:100%;min-height:65px;background:-moz-linear-gradient(top,#fff 0,#eee 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),color-stop(100%,#eee));background:-webkit-linear-gradient(top,#fff 0,#eee 100%);background:-o-linear-gradient(top,#fff 0,#eee 100%);background:-ms-linear-gradient(top,#fff 0,#eee 100%);background:linear-gradient(top,#fff 0,#eee 100%);border-radius:0;border-bottom:4px #fff solid;margin-bottom:20px}#score_team{width:31%;font-size:24px;color:#222;font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif;text-align:center;font-weight:777;padding-top:10px}.author-change-panel{font-weight:700}.author-change-panel .form-group{margin-bottom:unset}.author-change-panel .btn{margin-top:10px;width:100%;height:26px;padding:2px;border-radius:10px}.author-change-panel .btn:hover,.btn.focus,.btn:focus{outline:0}</style> <div class=loading ng-hide=dataLoaded></div> <div class=row id=add-article style=margin-top:10px> <div class=col-xs-12> <div class=page-header> <button class=\"btn btn-danger pull-right\" ng-click=delete(data) ng-if=isAdmin>Delete</button> <form class=form-inline> <div class=pull-right> </div> <div class=form-group> <oi-select oi-options=\"option._name for option in categories track by option.id\" oi-select-options=selectSettings ng-model=data.category placeholder=\"Wybierz kategorie\" ng-disabled=!canChangeCategory()></oi-select> </div> <div class=form-group> <oi-select oi-options=\"option.value for option in statuses track by option.id\" ng-model=data.status placeholder=\"Wybierz status\" ng-disabled=!canChangeStatus()></oi-select> </div> <div class=form-group> <oi-select oi-options=\"option.value for option in article_styles track by option.id\" oi-select-options=selectSettings ng-model=data.show_inarticle placeholder=\"Wybierz format\" ng-disabled=!canChangeFormat()></oi-select> </div> </form> </div> </div> </div> <div class=\"row w990\"> <div class=col-sm-8> <h1 ng-model=data.title strip-br=true class=\"text-center ubuntu\" contenteditable={{editPermit}} ondragstart=return!1 spellcheck=false placeholder=\"{{localizedMessages.get('add-title')}}\" style=margin-top:0 ng-blur=titleChanged()></h1> <h4 ng-model=data.abstract strip-br=true class=\"text-justify open-sans\" contenteditable={{editPermit}} placeholder=\"{{localizedMessages.get('add-description-article')}}\"></h4> <div ng-class=howToShow> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-upload ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ngf-thumbnail=\"thumbnail || (data.image ? imgUrl + data.image : false) || imgUrl + 'upload-iworis-1603084085694.png'\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15)\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <figcaption ng-model=data.image_caption contenteditable={{editPermit}} class=\"text-center image_caption_news\" id=image_caption placeholder=\"{{localizedMessages.get('add-image-caption')}}\" style=min-height:20px> </figcaption> <div ng-show=\"howToShow == 'Liveevent'\" style=\"text-align:center;background-color:#eee;padding:20px 0;color:#666;font-family:Tahoma,Geneva,sans-serif\"> <b>{{ localizedMessages.get('what-do-live-finish')}}</b> <br> - {{ localizedMessages.get('change-title')}}<br> - {{ localizedMessages.get('quit-heading')}} <br><br> <b>{{ localizedMessages.get('latin-languages')}}:</b> {{ localizedMessages.get('title-from')}}:<br> {{ localizedMessages.get('title-from-example') | rawHtml }} <br><br> <b>{{ localizedMessages.get('english') | uppercase }}:</b> {{ localizedMessages.get('title-from')}}:<br> {{ localizedMessages.get('title-from-example2') | rawHtml }} </div> <div id=score_bar ng-show=data.equipo_local> <div id=score_team style=float:left>{{data.equipo_local.name}}</div> <div style=float:left;width:38%> <div id=score_count style=\"margin:0 auto;width:100%;text-align:center\"> <span class=score_number style=margin-right:7px>{{data.goles_local+\"\"}}</span> <span class=score_number>{{data.goles_visitante+\"\"}}</span> </div> </div> <div id=score_team style=float:right>{{data.equipo_visitante.name}}</div> </div> </div> <div ng-show=\"data.show_inarticle.id == '1'\" class=video-block> <div class=\"well no-margin no-border\"> <form class=\"form-inline no-border\"> <div class=form-group-flex> <label for=video-url>{{ localizedMessages.get('youtube-id')}}</label> <input ng-model=data.video type=text class=form-control-flex id=video-url ng-change=onChangeVideoUrl()> </div> </form> </div> </div> <article id=editor ng-model=data.body ckeditor=ckOptions contenteditable=true ready=onReady() class=\"text-justify article-content droid\" spellcheck=false style=position:relative placeholder=\"{{localizedMessages.get('start-writing')}}\"> </article> <br> <br> <div> <h5><strong>{{ localizedMessages.get('allowing-spaces')}}</strong></h5> <p>{{ localizedMessages.get('allowing-spaces-helper')}}</p> <tags-input ng-model=data.tags replace-spaces-with-dashes=false add-from-autocomplete-only=true> <auto-complete source=loadTags($query) debounce-delay=1 template=tag-item-template></auto-complete> </tags-input> <script type=text/ng-template id=tag-item-template> <div style=\"height: 18px;\" ng-class=\"{greenTag: !!data.oficial}\">\r\n          <span ng-bind-html=\"$highlight($getDisplayText())\"></span>\r\n        </div> </script> </div>  </div> <div class=\"col-sm-4 right-sidebar\"> <button type=button id=save class=\"btn btn-lg btn-block\" ng-click=save() ng-disabled=\"isSaving || !editPermit\"> <img src=http://www.vavel.com/user/img/486.GIF ng-show=isSaving /> <span ng-hide=isSaving>{{saveBtnText}}</span> </button> <button ng-show=!editPermit type=button id=switch class=\"btn btn-lg btn-block\" ng-click=switch() ng-disabled=editPermit> <img src=http://www.vavel.com/user/img/486.GIF ng-show=isSaving /> <span ng-hide=isSaving>{{switchBtnText}}</span> </button> <div class=\"clearfix side-row\" id=autosave> <small>Autosave <span ng-hide=autosave> {{ localizedMessages.get('is-off')}}</span> <span ng-show=autosave> {{ localizedMessages.get('in')}} {{autosaveTimer}}</span> <br> <span style=color:#dbfffd>{{editing}}</span> <br> <span style=color:#f9dbff>{{watching}}</span> </small> <div class=pull-right> </div> </div> <div class=\"panel panel-default author-change-panel\"> <div class=panel-heading>{{ localizedMessages.get('author')}}</div> <div class=panel-body> <div class=form-group> <input ng-model=data.author.name type=text class=form-control id=author disabled=disabled ng-if=!canChangeAuthor()> <select type=text name=author class=form-control ng-model=listOfUsers.username ng-change=changedAuthor() ng-if=canChangeAuthor()> <option ng-repeat=\"u in listOfUsers.options\" value={{u.username}}>{{u.name}}</option> </select> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.url = !accordion.url\"> <strong>{{ localizedMessages.get('url') | uppercase }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" collapse=accordion.url> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=url>{{ localizedMessages.get('incidents-cap') | uppercase}} {{ localizedMessages.get('slug') }}:</label> <input ng-model=data.sefriendly type=text class=form-control id=url> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.image = !accordion.image\"> <strong>{{ localizedMessages.get('image') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" collapse=accordion.image> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=image>{{ localizedMessages.get('image') }}:</label> <input ng-model=data.image type=text class=form-control id=image> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.published_by = !accordion.published_by\"> <strong>{{ localizedMessages.get('publishing') }} ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.published_by> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=\"form-group datetime\" id=publish_date-group> <label for=publish_date>{{ localizedMessages.get('publishing-date') }}</label> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\"> </div> </form> <br/> <form class=\"form-inline no-border\"> <div class=form-group> <label for=last-edited-by>{{ localizedMessages.get('last-edited-by') }}</label> <input ng-model=data.last_edited_by.name ng-disabled=true type=text class=form-control id=last-edited-by> </div> </form> <form class=\"form-inline no-border\"> <div class=form-group> <label for=published-by>{{ localizedMessages.get('published-by') }}</label> <input ng-model=data.published_by.name ng-disabled=!canChangeAuthor() type=text class=form-control id=published-by> </div> </form> </div> </div> </div> </div> </div> <div id=dtBox></div> <script>var dateValue;$(function(){var e=$('[contentEditable=\"true\"]'),a=null,s=function(e){(a=$(this)).text().trim().length||a.empty()};e.on(\"input\",s),e.each(s),$(window).on(\"scroll\",function(e){143<$(window).scrollTop()?($(\"#save\").addClass(\"fixed-save\"),$(\"#switch\").addClass(\"fixed-save\"),$(\"#autosave\").addClass(\"fixed-autosave\"),$(\"#publishing\").addClass(\"fixed-publishing\"),$(\".right-sidebar\").addClass(\"margin-sidebar\")):($(\"#save\").removeClass(\"fixed-save\"),$(\"#switch\").removeClass(\"fixed-save\"),$(\"#autosave\").removeClass(\"fixed-autosave\"),$(\"#publishing\").removeClass(\"fixed-publishing\"),$(\".right-sidebar\").removeClass(\"margin-sidebar\"))}),$(\"#dtBox\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",settingValueOfElement:function(e,a,s){dateValue=a}})});var changesSaved=!0;window.onbeforeunload=function(){if(1==changesSaved)return\"pepepe You havent saved your changes. Are you sure you want to leave the page?\"}</script> ";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.edit-video', ['common.header', 'common.footer', 'config', 'directives.contenteditable', 'account.settings.social', 'security.service', 'security.authorization', 'services.accountResource', 'services.utility', 'services.formErrors', 'ui.bootstrap', 'directives.serverError', 'ngTagsInput', 'ngFileUpload', 'toggle-switch', 'angular-growl', 'ckeditor', 'resources.User', 'resources.Tag', 'resources.Category', 'resources.Article', 'resources.AdminUser', 'filters.rawHtml', 'ckeditorPlaceholder']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.edit-video', {
	    url: '/edit-video/:id',
	    title: 'Edit Article',
	    views: {
	      'main@': {
	        template: __webpack_require__(171),
	        controller: 'EditVideoCtrl',
	        resolve: {
	          locations: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type: 'location' });
	          }],
	          playersAndTeams: ["adminResource", function (adminResource) {
	            return adminResource.searchTags({ type1: 'profile', type2: 'organization' });
	          }],
	          listOfUsers: ["AdminUser", function (AdminUser) {
	            return AdminUser.getAll().$promise.then(function (result) {
	              return result.data;
	            });
	          }]
	        }
	      }
	    }
	  });
	}]).controller('EditVideoCtrl', ["$scope", "$location", "$log", "$interval", "$stateParams", "$sce", "$uibModal", "security", "utility", "growl", "user", "SOCIAL", "STATUSES", "ARTICLE_STYLES", "VIDEO_TYPES", "APP_IMG_URLS", "HOST_URL", "Upload", "formErrors", "dateFilter", "Article", "Category", "User", "Tag", "socket", "$window", "locations", "playersAndTeams", "listOfUsers", "adminResource", function ($scope, $location, $log, $interval, $stateParams, $sce, $uibModal, security, utility, growl, user, SOCIAL, STATUSES, ARTICLE_STYLES, VIDEO_TYPES, APP_IMG_URLS, HOST_URL, Upload, formErrors, dateFilter, Article, Category, User, Tag, socket, $window, locations, playersAndTeams, listOfUsers, adminResource) {
	  $scope.dataLoaded = false;
	  $scope.imgUrl = APP_IMG_URLS['base'];
	  $scope.nameLocation = '';
	
	  var urlGenerated = false;
	  var timer = null;
	  var slugify = __webpack_require__(152);
	
	  var toFormatArticleDate = __webpack_require__(167).toFormatArticleDate;
	  var prepareBeforeEmitArticleChanged = __webpack_require__(167).prepareBeforeEmitArticleChanged;
	  var prepareForEditArticle = __webpack_require__(167).prepareForEditArticle;
	  var isProgram = user && user.account && user.account.is_program ? true : false;
	  $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
	    return { _id: p._id, name: p.name };
	  }) : [];
	
	  $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
	    return {
	      _id: p._id,
	      name: p.name,
	      type: p.role.role_type
	    };
	  }) : [];
	
	  $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function (e) {
	    return e.type === 'profile';
	  }) : [];
	  $scope.editPermit = false;
	
	  var publishDate = moment();
	  var init = function init(article, categories) {
	    // console.log( '>>> init', article.publish_date, article.status, [1, 3, 17, 18].indexOf(article.status) );
	    if (article.status) {
	      if ([1, 3, 17, 18].indexOf(article.status) >= 0) {
	        publishDate = moment(article.publish_date);
	      }
	    }
	
	    $scope.categories = categories;
	    $scope.statuses = _.filter(STATUSES, function (status) {
	      return ~user.permissions.statuses.indexOf(status.id);
	    });
	    if (user.permissions.statuses[0] === '*') {
	      $scope.statuses = STATUSES;
	    }
	
	    $scope.$watch('data.show_inarticle', function (newVal, oldVal) {
	      $scope.howToShow = newVal.value.replace(/ /g, '');
	      $scope.data.type = newVal.type;
	    });
	
	    $scope.$watch('data.locationInfo', function (newVal, oldVal) {
	      if (newVal && newVal.lat && newVal.lon) {
	        $scope.nameLocation = newVal.formatted_address;
	      }
	    });
	
	    $scope.isAdmin = false;
	    if (user.permissions.is_admin) {
	      $scope.isAdmin = true;
	      // console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
	    }
	    $scope.data = {
	      _id: article._id,
	      article_id: article.article_id,
	      title: _.unescape(article.title),
	      sefriendly: article.sefriendly,
	      status: _.find(STATUSES, { id: '' + article.status }),
	      orderNumber: article.orderNumber,
	      image: article.image,
	      video: article.video,
	      mediaCloud_id: article.mediaCloud_id,
	      media_id: article.media_id,
	      arrThumbs: article.arrThumbs || [],
	      readyToStream: article.readyToStream,
	      duration: article.duration,
	      video_type: isProgram ? 'program' : 'video',
	      type: 'video',
	      location: article.location && article.location,
	      locationInfo: article.locationInfo && article.locationInfo,
	      image_caption: _.unescape(article.image_caption),
	      body: _.unescape(article.body),
	      abstract: _.unescape(article.abstract),
	
	      equipo_local: article.equipo_local_new ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local_new._id }) : article.equipo_local ? _.find($scope.playersAndTeamsList, { _id: article.equipo_local }) : undefined,
	
	      equipo_visitante: article.equipo_visitante_new ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante_new._id }) : article.equipo_visitante ? _.find($scope.playersAndTeamsList, { _id: article.equipo_visitante }) : undefined,
	
	      goals: article.goals,
	      goles_local: article.goles_local,
	      goles_visitante: article.goles_visitante,
	
	      referee: article.referee_new ? _.find($scope.profilesList, { _id: article.referee_new._id }) : !!article.referee ? _.find($scope.profilesList, { _id: article.referee }) : undefined,
	
	      incidents: article.incidents,
	      show_inarticle: _.find(ARTICLE_STYLES, { id: '' + article.show_inarticle }),
	      category: article.category ? _.find(categories, { id: article.category.id }) : '',
	      tags: [],
	      author: article.author,
	      last_edited_by: article.last_edited_by,
	      published_by: article.published_by,
	      publish_date: toFormatArticleDate(publishDate),
	      team1: article.team1,
	      team2: article.team2,
	      team1players: angular.isArray(article.team1players) ? article.team1players.map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [],
	      team2players: angular.isArray(article.team2players) ? article.team2players.map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [],
	      created_at: article.created_at,
	
	      stadium: article.stadium_new ? _.find($scope.stadiumsList, { _id: article.stadium_new._id }) : !!article.stadium ? _.find($scope.stadiumsList, { _id: article.stadium }) : undefined
	    };
	
	    if ($scope.data && (!$scope.data.arrThumbs || $scope.data.arrThumbs && !$scope.data.arrThumbs.length)) {
	      if ($scope.data.readyToStream && $scope.data.duration && $scope.data.duration > 0) {
	        do {
	          var num = Math.floor(Math.random() * Math.floor($scope.data.duration - 0.5));
	          if ($scope.durations.indexOf(num) < 0) {
	            $scope.data.arrThumbs.push($scope.createThumb($scope.data.mediaCloud_id) + '?time=' + num + 's');
	            $scope.durations.push(num);
	          }
	        } while ($scope.durations.length < 3);
	        $scope.thumbnail = $scope.createThumb($scope.data.mediaCloud_id);
	        $scope.data.image = $scope.durations.length ? $scope.createThumb($scope.data.mediaCloud_id) + '?time=' + $scope.durations[0] + 's' : $scope.createThumb($scope.data.mediaCloud_id) + '?time=0s';
	      }
	    }
	
	    $scope.start_at = 0;
	    $scope.iframe = '<iframe src="' + HOST_URL + $scope.data.article_id + '/iframe"' + ' height="338" width="600" allowfullscreen frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>';
	    $scope.changeStartAt = function (value) {
	      if (value !== null && value > -1) {
	        $scope.iframe = '<iframe src="' + HOST_URL + $scope.data.article_id + '/iframe?start=' + value + '"' + ' height="338" width="600" allowfullscreen frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>';
	      }
	    };
	    // ==search place google==
	    var input = document.getElementById('pac-input');
	    var searchBox = new window.google.maps.places.Autocomplete(input);
	    searchBox.addListener('place_changed', function () {
	      var place = searchBox.getPlace();
	      if (!place.geometry) {
	        growl.error('Can not get location');
	        input.value = $scope.nameLocation;
	        return;
	      }
	      var lat = place.geometry.location.lat();
	      var lon = place.geometry.location.lng();
	      $scope.data.location = { lat: lat, lon: lon };
	      $scope.data.locationInfo = {
	        lat: lat,
	        lon: lon,
	        geometry: place.geometry,
	        name: place.name,
	        id: place.id,
	        icon: place.icon,
	        formatted_address: place.formatted_address,
	        place_id: place.place_id,
	        types: place.types,
	        url: place.url,
	        vicinity: place.vicinity
	      };
	    });
	    // ==search place google==
	
	    $scope.thumbnail = $scope.data.type === 'video' ? article.image : APP_IMG_URLS.base + article.image;
	
	    $scope.videoUrl = article.video;
	
	    $scope.changePT1(article.equipo_local);
	    $scope.changePT2(article.equipo_visitante);
	
	    $scope.listOfUsers = {
	      username: article.author.username,
	      options: listOfUsers.filter(function (p) {
	        return p.account.groups && p.account.groups.length > 0;
	      }).map(function (u) {
	        var full = u.account.name.full;
	        if (!full) {
	          full = u.account.name.first + ' ' + u.account.name.last;
	        }
	        if (full === ' ') full = u.username;
	        return {
	          username: u.username,
	          picture: u.account.picture,
	          name: full || u.username
	        };
	      })
	    };
	
	    var listenerFunction = null;
	    //send user name of person who start editing and  id of edited topic
	    socket.emit('connectDocs', {
	      userName: user.account.name.full,
	      artId: article.article_id,
	      userId: user._id,
	      docs: $scope.data
	    });
	    var internalChange = false;
	    var listenData = false;
	
	    socket.on('startEditing', function (data) {
	      // console.log( '>>> startEditing', data );
	      $scope.editPermit = true;
	      $scope.editing = 'Editing by: ' + user.account.name.full;
	      if (data) {
	        $scope.data = prepareForEditArticle(data.data);
	      }
	      listenerFunction = $scope.$watchCollection('data', _.debounce(function (newValue, oldValue) {
	        if (!_.isEqual(newValue, oldValue) && !internalChange) {
	          // console.log('emit articleChanged', article.article_id, prepareBeforeEmitArticleChanged(newValue));
	          socket.emit('articleChanged', {
	            artId: article.article_id,
	            data: prepareBeforeEmitArticleChanged(newValue)
	          });
	        }
	        internalChange = false;
	      }, 1000));
	      listenData = true;
	    });
	
	    socket.on('startWatching', function (articleRoom) {
	      $scope.data = articleRoom.docs;
	      var user = _.find(articleRoom.users, function (user) {
	        return user.userId === articleRoom.editing;
	      });
	      $scope.editing = 'editing by: ' + user.name;
	    });
	
	    socket.on('newcomer', function (watchers) {
	      $scope.watching = watchers.reduce(function (prev, obj) {
	        return prev + obj.name + ', ';
	      }, 'watching by: ');
	    });
	
	    //send user name of person who ends editing and  id of edited topic
	    $scope.$on('$locationChangeStart', function (event) {
	      if ($scope.editPermit) {
	        socket.emit('endEdit');
	        socket.off('applyChanges');
	      }
	    });
	
	    var windowElement = angular.element($window);
	    windowElement.on('beforeunload', function (event) {
	      // do whatever you want in here before the page unloads.
	      if ($scope.editPermit) {
	        socket.emit('endEdit');
	        socket.off('applyChanges');
	      }
	      // the following line of code will prevent reload or navigating away.
	      event.preventDefault();
	    });
	
	    //recieving changes from other editors
	    socket.on('applyChanges', function (data) {
	      // console.log( '>>> on applyChanges', data );
	      if (data.editing === user._id) {
	        $scope.editPermit = true;
	        if (!listenerFunction) {
	          listenerFunction = $scope.$watchCollection('data', _.debounce(function (newValue, oldValue) {
	            if (!_.isEqual(newValue, oldValue) && !internalChange) {
	              console.log('emit articleChanged');
	              socket.emit('articleChanged', {
	                artId: article.article_id,
	                data: prepareBeforeEmitArticleChanged(newValue)
	              });
	            }
	            internalChange = false;
	          }, 1000));
	        }
	      } else {
	        $scope.editPermit = false;
	        if (listenerFunction) {
	          listenerFunction();
	          listenerFunction = null;
	        }
	      }
	      var users = data.users;
	
	      var editor = _.find(users, function (us) {
	        return us.userId === data.editing;
	      });
	      var watchers = users.filter(function (us) {
	        return us.userId !== data.editing;
	      });
	      $scope.editing = 'editing by: ' + editor.name;
	      if (watchers.length > 0) {
	        $scope.watching = watchers.reduce(function (prev, obj) {
	          return prev + obj.name + ', ';
	        }, 'watching by: ');
	      } else {
	        $scope.watching = '';
	      }
	
	      if (!_.isEqual($scope.data, data.docs)) {
	        $scope.data = prepareForEditArticle(data.docs);
	        internalChange = true;
	      }
	    });
	
	    $scope.switch = function () {
	      socket.emit('changeEditPermit', {
	        artId: article.article_id,
	        userId: user._id
	      });
	    };
	
	    if (article.tags) {
	      $scope.data.tags = article.tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.name,
	          sefriendly: slugify(tag.name),
	          avatar: tag.avatar || ''
	        };
	      });
	    }
	
	    if ($scope.data.status === undefined) {
	      $scope.data.status = {
	        id: '0',
	        value: localizedMessages.get('pending')
	      };
	    }
	
	    $scope.$watch('data.show_inarticle', function (newVal, oldVal) {
	      $scope.data.show_inarticle = _.find(ARTICLE_STYLES, { id: '' + newVal.id });
	    });
	    $scope.dataLoaded = true;
	  };
	
	  $scope.article_styles = ARTICLE_STYLES;
	  $scope.video_types = VIDEO_TYPES;
	  $scope.uploading = false;
	  $scope.completed = false;
	  $scope.durations = [];
	  $scope.progressPercentage = 0;
	  $scope.isSaving = false;
	  $scope.autosaveTimer = 180;
	  $scope.accordion = {
	    score: true,
	    publishing_date: true,
	    url: true,
	    image: true,
	    published_by: false
	  };
	
	  var startTimer = function startTimer() {
	    return $interval(function () {
	      if ($scope.autosaveTimer <= 0) {
	        $scope.save();
	      }
	      $scope.autosaveTimer -= 1;
	    }, 1000);
	  };
	
	  var resetTimer = function resetTimer() {
	    $scope.autosaveTimer = 180;
	    $interval.cancel(timer);
	  };
	
	  $scope.autosaveChanged = function () {
	    if ($scope.autosave) {
	      timer = startTimer();
	    } else {
	      resetTimer();
	    }
	  };
	
	  $scope.canChangeAuthor = function () {
	    return user.permissions.is_editor && $scope.canChangeCategory();
	  };
	
	  $scope.canChangeStatus = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	    //return ~user.permissions.statuses.indexOf(article.status + '');
	  };
	
	  $scope.canChangeCategory = function () {
	    if (user.permissions.is_admin) return true;
	    return true;
	    //return ~user.permissions.categories.indexOf(article.category.id);
	  };
	
	  $scope.canChangeFormat = function () {
	    return true;
	  };
	
	  $scope.titleChanged = function () {
	    $scope.data.title = $scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' ');
	    if ($scope.data.sefriendly) {
	      return;
	    }
	    $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, '').replace(/  /g, ' '));
	  };
	
	  $scope.saveBtnText = 'Save';
	  $scope.switchBtnText = 'Switch';
	
	  $scope.onReady = function () {
	    CKEDITOR.on('dialogDefinition', function (ev) {
	      // Take the dialog name and its definition from the event data
	
	      var dialogName = ev.data.name;
	      var dialogDefinition = ev.data.definition;
	      if (dialogName == 'image2' || dialogName == 'link') {
	        // Remove upload tab
	        dialogDefinition.removeContents('Upload');
	        dialogDefinition.removeContents('upload');
	      }
	    });
	  };
	
	  $scope.save = function () {
	    if ($scope.uploading) {
	      growl.error('Please wait for the upload process to complete');
	      return;
	    }
	    resetTimer();
	    $scope.autosaveChanged();
	    $scope.data.sefriendly = slugify($scope.data.sefriendly);
	
	    if (!$scope.data.video) {
	      growl.error('Video is required');
	      return;
	    }
	    if (!$scope.data.title) {
	      growl.error('Title is required');
	      return;
	    }
	    if (!$scope.data.category) {
	      growl.error('Category is required');
	      return;
	    }
	    // if (!$scope.data.body) {
	    //   growl.error('Body is required');
	    //   return;
	    // }
	
	    $scope.isSaving = true;
	
	    var data = angular.copy($scope.data);
	    data.edition = data.category.path.split('/')[1];
	    data.type = data.show_inarticle.type;
	    // data.video_type = data.video_type.value;
	    data.show_inarticle = parseInt(data.show_inarticle.id, null);
	    data.status = parseInt(data.status.id, null);
	    // data.categories = data.category.path.split('/').filter(Boolean).map(function(item) {return {sefriendly: item};}).reverse();
	    // delete data['category'];
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text),
	        avatar: tag.avatar || ''
	      };
	    });
	
	    data.publish_date = (data.publish_date ? moment(data.publish_date) : publishDate).toISOString();
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.published_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    var catArray = data.category.parent == '/' ? [] : data.category.parent.substring(1).split('/');
	    var pDate = new Date(data.created_at);
	    var pMonth = pDate.getUTCMonth() + 1;
	    var dateSeg = '/' + pDate.getUTCFullYear() + '/' + ('0' + pMonth).slice(-2) + '/' + ('0' + pDate.getUTCDate()).slice(-2) + '/';
	    data.url_segment = dateSeg;
	    if (catArray.length == 0) {
	      data.url_segment = '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length == 1) {
	      data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
	    } else if (catArray.length > 1) {
	      data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
	    }
	
	    data.abstract = CKEDITOR.instances.editor.getData();
	
	    // console.log("$startDate------->>>>>>>" + data.startDate);
	
	    Article.update(data, function (result) {
	      setTimeout(function () {
	        //growl.info('Changes saved!');
	        $scope.data.last_edited_by = data.last_edited_by;
	      }, 1000);
	    }, formErrors.growlErrors).$promise.then(function (resp) {
	      // $scope.data = resp;
	      $scope.saveBtnText = 'Saved!';
	      $scope.isSaving = false;
	      setTimeout(function () {
	        $scope.saveBtnText = 'Saved!';
	      }, 500);
	    });
	  };
	
	  $scope.onChangeVideoUrl = function () {
	    $scope.videoUrl = $scope.data.video;
	  };
	
	  $scope.notify = function () {
	    var data = angular.copy($scope.data);
	    data.edition = data.category.path.split('/')[1];
	    data.show_inarticle = parseInt(data.show_inarticle.id, null);
	    data.status = parseInt(data.status.id, null);
	    data.category = {
	      id: data.category.id,
	      name: data.category.name,
	      sefriendly: data.category.sefriendly,
	      parent: data.category.parent,
	      parent_id: data.category.parent_id
	    };
	
	    data.tags = data.tags || [];
	    data.tags = data.tags.map(function (tag) {
	      return {
	        name: tag.text,
	        sefriendly: slugify(tag.text),
	        avatar: tag.avatar || ''
	      };
	    });
	
	    // console.log( '>>> notify', dateValue, data.publish_date );
	    if (dateValue) {
	      data.publish_date = moment(dateValue).toISOString();
	    } else {
	      data.publish_date = publishDate.toISOString();
	    }
	
	    if (!$scope.canChangeAuthor()) {
	      data.last_edited_by = {
	        name: user.account.name.full,
	        username: user.username
	      };
	    }
	
	    if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
	      data.notify = 1;
	      //console.log($scope.data.title);
	      Article.update(data, function (result) {
	        setTimeout(function () {
	          //growl.info('Changes saved!');
	          $scope.data.last_edited_by = data.last_edited_by;
	          // $location.path('/edit-article/' + result.data._id);
	        }, 1000);
	      }, formErrors.growlErrors).$promise.then(function () {
	        $scope.saveBtnText = 'Saved!';
	        $scope.isSaving = false;
	        setTimeout(function () {
	          $scope.saveBtnText = 'Saved!';
	        }, 500);
	      });
	    }
	  };
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    if (!$scope.isSaving) {
	      var answer = confirm('Are you sure you want to navigate away from this page');
	      if (!answer) {
	        event.preventDefault();
	      }
	    }
	  });
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  $scope.createThumb = function (id) {
	    return 'https://cloudflarestream.com/' + id + '/thumbnails/thumbnail.jpg';
	  };
	
	  $scope.selectThumb = function (thumb) {
	    $scope.data.image = thumb;
	  };
	
	  $scope.canGetInfo = true;
	
	  $scope.getInfoVideo = function () {
	    if ($scope.canGetInfo) {
	      Article.query({ id: $stateParams.id }).$promise.then(function (result) {
	        console.log(result);
	        if (!result.readyToStream) {
	          return growl.error('Inprogress');
	        }
	        $scope.data.arrThumbs = result.arrThumbs;
	        $scope.data.readyToStream = result.readyToStream;
	        $scope.thumbnail = $scope.createThumb(result.mediaCloud_id);
	        $scope.data.duration = result.duration;
	        $scope.data.image = result.image;
	      });
	      // Article.getInfoVideo({ mediaId: $scope.data.mediaCloud_id }).$promise.then(function(data) {
	      //   if (data && data.readyToStream && data.duration && data.duration > 0) {
	      //     do {
	      //       var num = Math.floor(Math.random() * Math.floor(data.duration - 0.5));
	      //       if ($scope.durations.indexOf(num) < 0) {
	      //         $scope.data.arrThumbs.push($scope.createThumb(data.uid) + '?time=' + num + 's');
	      //         $scope.durations.push(num);
	      //       }
	      //     } while ($scope.durations.length < 3);
	      //     $scope.data.readyToStream = data.readyToStream;
	      //     $scope.thumbnail = $scope.createThumb(data.uid);
	      //     $scope.data.image = $scope.durations.length
	      //       ? $scope.createThumb(data.uid) + '?time=' + $scope.durations[0] + 's'
	      //       : $scope.createThumb(data.uid) + '?time=0s';
	      //     $scope.data.duration = data.duration;
	      //   } else {
	      //     growl.error('Inprogress');
	      //   }
	      // });
	      $scope.canGetInfo = false;
	      window.setTimeout(function () {
	        $scope.canGetInfo = true;
	      }, 10000);
	    }
	  };
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.durations = [];
	    $scope.progressPercentage = 0;
	    $scope.data.image = '';
	    $scope.data.arrThumbs = [];
	
	    // return;
	    Upload.upload({
	      url: $scope.data.show_inarticle.type === 'video' ? '/api/media/upload-video' : '/api/articles/upload',
	      data: { file: file, videoId: $stateParams.id }
	    }).then(function (resp) {
	      if (resp.data.duration && resp.data.duration > 0 && resp.data.readyToStream) {
	        do {
	          var num = Math.floor(Math.random() * Math.floor(resp.data.duration - 0.5));
	          if ($scope.durations.indexOf(num) < 0) {
	            $scope.data.arrThumbs.push($scope.createThumb(resp.data.mediaCloudId) + '?time=' + num + 's');
	            $scope.durations.push(num);
	          }
	        } while ($scope.durations.length < 3);
	      }
	
	      window.setTimeout(function () {
	        $scope.data.readyToStream = resp.data.readyToStream;
	        $scope.thumbnail = $scope.createThumb(resp.data.mediaCloudId);
	        $scope.data.image = $scope.durations.length ? $scope.createThumb(resp.data.mediaCloudId) + '?time=' + $scope.durations[0] + 's' : $scope.createThumb(resp.data.mediaCloudId) + '?time=0s';
	        $scope.data.video = resp.data.preview;
	        $scope.data.duration = resp.data.duration;
	        $scope.uploading = false;
	        $scope.completed = true;
	      }, 500);
	      $scope.data.media_id = resp.data._id;
	      $scope.data.mediaCloud_id = resp.data.mediaCloudId;
	      growl.info('Uploaded successfully!.');
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      $scope.progressPercentage = progressPercentage;
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.loadTags = function (query) {
	    return Tag.search({ q: query }).$promise.then(function (tags) {
	      if (!tags) return [];
	      return tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.nametag,
	          name: tag.nametag,
	          oficial: tag.oficial,
	          sefriendly: tag.name,
	          avatar: tag.avatar || ''
	        };
	      });
	    });
	  };
	
	  $scope.delete = function (tag) {
	    if (!confirm('Are you sure you want to delete this article?')) {
	      return;
	    }
	    Article.delete({ id: tag._id }, function (result) {
	      setTimeout(function () {
	        growl.info('Article removed!');
	        $location.path('/account/my-articles');
	      }, 1000);
	    }, formErrors.growlErrors);
	  };
	
	  async.parallel({
	    article: function article(cb) {
	      Article.query({ id: $stateParams.id }).$promise.then(function (result) {
	        return cb(null, result);
	      });
	    },
	    categories: function categories(cb) {
	      var options = [];
	      var generateCategoryOptions = function generateCategoryOptions(items, container) {
	        items.forEach(function (item) {
	          if (!item.path) {
	            return;
	          }
	          var depth = item.path.split('/').filter(Boolean).length;
	          var indent = new Array(5).join(String.fromCharCode(160));
	          container.push({
	            id: item.id,
	            path: item.path,
	            sefriendly: item.sefriendly,
	            parent: item.parent,
	            parent_id: item.parent_id,
	            name: item.name,
	            _name: new Array(depth).join(indent) + item.name
	          });
	          if (item.children) {
	            generateCategoryOptions(item.children, container);
	          }
	        });
	        return container;
	      };
	      Category.getPermittedTree({ type: 'video' }).$promise.then(function (data) {
	        generateCategoryOptions(data, options);
	        cb(null, options);
	      });
	    }
	  }, function (err, results) {
	    if (err) return console.log(err);
	    if (results.article.error) {
	      $location.path('/unauthorized');
	    } else {
	      if (results.article.show_inarticle != 21 && results.article.show_inarticle != 22) {
	        init(results.article, results.categories);
	      } else {
	        $scope.isSaving = true;
	        $location.path('/account/edit-article-live/' + results.article.article_id);
	      }
	    }
	  });
	
	  $scope.changePT1 = function (pt1) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt1;
	    });
	    // console.log( '>>>1', playerOrTeam );
	    if (playerOrTeam.length) {
	      $scope.data.equipo_local_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.changePT2 = function (pt2) {
	    var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
	      return e._id === pt2;
	    });
	    // console.log( '>>>2', playerOrTeam );
	    if (playerOrTeam.length) {
	      $scope.data.equipo_visitante_name = playerOrTeam[0].name;
	    }
	  };
	
	  $scope.loadProfiles = function (query) {
	    return adminResource.searchTags({ type: 'profile', name: query }).then(function (profiles) {
	      if (!profiles) return [];
	      var searchName = query.toLowerCase();
	      return profiles.data.filter(function (p) {
	        var name = p.name.toLowerCase();
	        return name.indexOf(searchName) > -1;
	      }).map(function (p) {
	        return {
	          _id: p._id,
	          name: p.name
	        };
	      });
	    });
	  };
	
	  $scope.changedAuthor = function () {
	    var username = $scope.listOfUsers.username;
	    $scope.data.author = $scope.listOfUsers.options.find(function (u) {
	      return u.username === username;
	    });
	  }; // changeAuthor
	}]);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<style>.ubuntu{font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif}.droid{font-family:'Open Sans',Georgia,'Times New Roman',Times,serif;font-size:19px}.open-sans{font-family:'Open Sans',sans-serif}h2{font-family:Open Sans,Georgia;font-size:30px;padding-top:10px;margin-bottom:15px;padding-left:0;padding-right:5px;font-weight:700;letter-spacing:-1px;line-height:120%}p{font-size:19px;color:#444;margin:0 0 30px 0;padding-top:0;font-family:Open Sans,Georgia,'Times New Roman',Times,serif;line-height:145%;text-align:justify}.image_caption_news{font-size:11px;font-style:italic;color:#777;background-color:#eee;padding:15px;border-bottom:1px #ddd solid;border-top:1px #ddd solid;margin-bottom:20px}.page-header{padding-bottom:10px;margin:0 0 18px}#save{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}#switch{border-bottom-left-radius:0;border-bottom-right-radius:0;font-size:26px;font-weight:700;background-image:linear-gradient(to bottom,#1c84de 0,#2a689c 100%);color:#fff}.side-row{padding:10px;color:#fff;background:#28a5e4}.toggle-switch{min-width:64px;border-color:#848484;font-size:11px}.toggle-switch span{line-height:inherit}.toggle-switch .switch-left{background:#63c663;color:#fff}.toggle-switch .switch-right{background:#c43939;color:#fff}.no-margin{margin:0}.no-border{border:0;border-radius:0}oi-select{width:200px}oi-select .select-dropdown,oi-select .select-search-list-item,oi-select .select-search-list-item_input input{font-size:13px;white-space:nowrap}oi-select .select-dropdown{max-height:200px}oi-select .select-search-list-item_selection{box-shadow:none}.right-sidebar .form-inline{border-bottom:1px solid #e4e3e3}.right-sidebar .form-inline.no-border{border:0;border-radius:0}.right-sidebar .panel{margin:0}.right-sidebar .panel-body{background-color:#f9f9f9}.right-sidebar .form-inline .form-group{margin:10px 0;width:100%}.right-sidebar .form-inline label{font-size:12px;font-weight:400}.right-sidebar .form-inline input{float:right;height:26px}.right-sidebar oi-select .select-search{background:#eee}.right-sidebar .form-inline input,.right-sidebar .form-inline select,.right-sidebar .form-inline textarea{font-size:12px;font-weight:400;width:150px;margin-left:30px;border-radius:0;background:#eee}.right-sidebar .form-inline textarea{width:250px;margin-left:0}.right-sidebar input[type=datetime-local]{margin-left:0;width:100%}.right-sidebar tags-input .host{position:static}.margin-sidebar{margin-top:98px}.fixed-save{position:fixed;top:0;width:293px}.fixed-publishing{position:fixed;top:96px;width:293px}.dragover{padding:10px;border:2px dashed #28a5e4}.PhotoFull img{width:700px}.PhotoRight{width:400px;float:right;margin:1em}.PhotoRight figcaption{margin:0}.PhotoMinifull{width:440px}.PhotoMinifull+article{width:440px}.Newspapermode{display:none}.Liveevent figcaption{margin-bottom:0}.Liveevent{margin-bottom:20px}.Liveevent+article{font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,'Times New Roman',Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article{background-color:#fff;font-size:16px;color:#555;margin-top:0;padding-top:0;font-family:Georgia,'Times New Roman',Times,serif;line-height:140%;text-align:justify;margin-bottom:20px}.Liveevent+article img{margin:auto;display:block;border:10px #fff solid;border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;-moz-box-shadow:0 0 3px rgba(0,0,0,.15);-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15)}.Liveevent+article p{border-bottom:1px solid grey;margin:0;padding:10px 10px}.score_number{background-color:#fff;font-size:44px;color:#222;line-height:44px;padding:7px 20px;font-weight:700;-moz-border-radius:55px;-webkit-border-radius:55px;border-radius:55px;text-align:center;max-width:30px;overflow:hidden}#score_bar{padding-top:25px;padding-bottom:60px;width:100%;min-height:65px;background:-moz-linear-gradient(top,#fff 0,#eee 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),color-stop(100%,#eee));background:-webkit-linear-gradient(top,#fff 0,#eee 100%);background:-o-linear-gradient(top,#fff 0,#eee 100%);background:-ms-linear-gradient(top,#fff 0,#eee 100%);background:linear-gradient(top,#fff 0,#eee 100%);border-radius:0;border-bottom:4px #fff solid;margin-bottom:20px}#score_team{width:31%;font-size:24px;color:#222;font-family:'Ubuntu Condensed',Arial,Helvetica,sans-serif;text-align:center;font-weight:777;padding-top:10px}.video-block{background-color:#eee;color:#666;display:flex;flex-direction:column}.youtube-player{height:300px}.form-group-flex{display:flex;justify-content:flex-start;align-items:center}.form-group-flex .form-control-flex{flex-grow:1;margin-left:10px}.box-input{padding:15px;background:#e1e1e1;border-radius:20px}.box-input>p{font-size:12px;margin-bottom:20px}</style> <div class=row id=add-video style=margin-top:10px> <div class=col-xs-12> <div class=page-header> <button class=\"btn btn-danger pull-right\" ng-click=delete(data) ng-if=isAdmin>Delete</button> <form class=form-inline> <div class=pull-right> <span class=ubuntu style=font-size:20px;font-weight:700>VAVEL</span> <span class=ubuntu style=font-size:16px;color:#999;font-weight:700;margin-right:10px>Online Editor</span> <img src=" + __webpack_require__(172) + " alt=\"\" width=30px /> </div> <div class=form-group> <oi-select oi-options=\"option._name for option in categories track by option.id\" oi-select-options=selectSettings ng-model=data.category placeholder=\"{{localizedMessages.get('choose-category')}}\"></oi-select> </div> <div class=form-group> <oi-select oi-options=\"option.value for option in statuses track by option.id\" oi-select-options=selectSettings ng-model=data.status placeholder=\"Wybierz status\"></oi-select> </div> <div class=form-group style=display:none> <oi-select oi-options=\"option.value for option in article_styles track by option.id\" oi-select-options=selectSettings ng-model=data.show_inarticle placeholder=\"Wybierz format\"></oi-select> </div> <div class=form-group> <label for=video>EDIT VIDEO</label> </div> </form> </div> </div> </div> <div class=\"row w990\"> <div class=col-sm-8> <form> <h1 ng-model=data.title class=\"text-center ubuntu\" contenteditable=true placeholder=\"{{localizedMessages.get('add-title')}}\" style=margin-top:0 ng-blur=titleChanged()></h1> <article id=editor ng-model=data.abstract ckeditor=ckOptions contenteditable=true ready=onReady() class=\"text-justify article-content droid\" spellcheck=false style=position:relative placeholder=\"Add the description of your article in 2 or 3 lines here. If you don't have a good idea for description, answer to 5W: who, what? where? why? how?\"></article> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-upload ngf-drop-available=true ngf-drop-disabled=\"{{uploading || completed ? 'true' : 'false'}}\" ngf-select-disabled=true ngf-drag-over-class=\"'dragover'\" ngf-pattern=\"'video/*'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=video/* ngf-max-size=3000MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;position:relative;border:solid .5px #ebebeb;padding:15px\"> <div class=\"row row-uploading\" ng-if=\"uploading || completed\"> <div class=col-sm-4> <div class=upload-thumb> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> <img ng-if=data.image src={{data.image}} title=\"\" alt=\"\" class=article-image ng-if=\"!uploading && completed && thumbnail\"/> </div> <div class=upload-status> <h4>Upload status:</h4> <span ng-if=uploading>Uploading video</span> <span ng-if=!uploading>Upload finish</span> </div> </div> <div class=col-sm-8> <div class=upload-progress> <div class=upload-bar ng-class=\"!uploading ? 'completed' : ''\" ng-style=\"{'width':progressPercentage +'%'}\"> <span class=upload-percent ng-show=\"progressPercentage < 100\">UPLOADING {{progressPercentage | number:0}}%</span> <span class=upload-percent ng-show=\"progressPercentage >= 100\">100% completed</span> </div> </div> <div class=progress-text> <img src=" + __webpack_require__(163) + " alt=\"\"/> <span ng-if=uploading>Video is still uploading. Please keep this page open until it's done.</span> <span ng-if=!uploading>Completed</span> </div> </div> <div class=col-sm-12> <h4>VIDEO THUMBNAIL</h4> <div class=\"alert alert-warning\" role=alert ng-if=\"completed && !data.readyToStream\"> <i class=\"fa fa-exclamation-triangle\"></i> Video conversion process is not completed, can be checked when the process is completed! </div> <div class=upload-thumb-list ng-if=\"uploading || !completed\"> <div class=upload-thumb-item> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> </div> <div class=upload-thumb-item> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> </div> <div class=upload-thumb-item> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> </div> </div> <div class=upload-thumb-list ng-if=completed> <div class=upload-thumb-item ng-click=selectThumb(thumb) ng-repeat=\"thumb in data.arrThumbs\"> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=\"uploading || !completed\"> <i class=\"fas fa-spinner fa-spin\"></i> </div> <img src={{thumb}} title=\"\" alt=\"\" class=article-image ng-if=\"!uploading && completed && data.arrThumbs && data.arrThumbs.length\"/> </div> </div> </div> </div> <div ng-if=\"!uploading && !completed\" style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ng-if=!data.image src=" + __webpack_require__(164) + " title=\"\" alt=\"\" class=article-image style=\"max-width:100%;width:140px;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15);background:#ebebeb;border-radius:50%\"/> <img ng-if=data.image src=\"{{data.image}}&width=1200\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15);margin-top:20px\"/> <div class=\"alert alert-warning\" role=alert ng-if=\"!data.readyToStream && data.mediaCloud_id && data.video && dataLoaded\"> <i class=\"fa fa-exclamation-triangle\"></i> Video conversion process is not completed, can be checked when the process is completed! </div> <div ng-if=\"data && data.arrThumbs && data.arrThumbs.length\"> <h5><strong>Change thumbnail for this video</strong></h5> <div class=row-thumbnails> <div class=thumb-list> <div class=thumb-item ng-repeat=\"thumb in data.arrThumbs\"> <img ng-click=selectThumb(thumb) src={{thumb}} title=\"\" alt=\"\" class=article-image /> </div> </div> </div> </div> <div class=upload-text> <strong>Drag and drop a file you want to upload</strong> <p>Your video will be private until you publish it</p> <p>Accept: MP4, MKV, MOV, AVI, FLV, MPEG-2 TS, MPEG-2 PS, MXF, LXF, GXF, 3GP, WebM, MPG</p> </div> <div class=\"file btn btn-lg btn-primary\"> Select file <input type=file id=file-upload ngf-drag-over-class=\"'dragover'\" ngf-select=upload($file) ng-model=file name=file accept=video/* ngf-pattern=\"'video/*'\" ngf-max-size=3000MB required ngf-model-invalid=errorFiles ngf-select-disabled=\"{{completed || uploading ? 'true' : 'false'}}\"/> </div> <div class=loader style=position:absolute;top:0;left:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <div> <h5><strong>Iframe</strong></h5> <div class=\"embed box-input\"> <p>Start at (seconds)</p> <input class=form-control type=number ng-model=start_at placeholder=0 ng-change=changeStartAt(start_at) /> <textarea classname=\"embed-render form-control\" rows=4 type=text disabled=disabled value=\"\" style=width:100%;margin-top:5px ng-model=iframe /> </div> </div> <br/> <div> <h5><strong>Where?</strong></h5> <div class=box-input> <p>In what location was this video done?</p> <input class=form-control id=pac-input class=controls value={{nameLocation}} type=text placeholder=\"Search places\"/> </div> </div> <br/> <div> <h5><strong>When?</strong></h5> <div class=box-input> <p>What date was this video done?</p> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\"/> </div> </div> <br/> <div> <h5><strong>Who?</strong></h5> <div class=box-input> <p>Add tags, what people, events or location appear in this video?</p> <tags-input ng-model=data.tags replace-spaces-with-dashes=false> <auto-complete source=loadTags($query) min-length=2 debounce-delay=1 max-results=10></auto-complete> </tags-input> </div> </div> </form> </div> <div class=\"col-sm-4 right-sidebar\"> <button type=button id=save class=\"btn btn-lg btn-block\" ng-click=save() ng-disabled=\"isSaving || !editPermit\"> <img src=http://www.vavel.com/user/img/486.GIF ng-show=isSaving /> <span ng-hide=isSaving>{{saveBtnText}}</span> </button> <h4 class=\"text-muted well no-margin no-border\">Noticias</h4> <div class=\"well no-margin no-border\"> <form class=\"form-inline no-border\"> <div class=form-group> <label for=author>Author</label> <input ng-model=data.author.name type=text class=form-control id=author ng-disabled=!canChangeAuthor() /> </div> </form> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.url = !accordion.url\"> <strong>URL ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.url> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=url>URL slug:</label> <input ng-model=data.sefriendly type=text class=form-control id=url /> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.image = !accordion.image\"> <strong>Image ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.image> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=image>Image:</label> <input ng-model=data.image type=text class=form-control id=image /> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\"> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.published_by = !accordion.published_by\"> <strong>Publishing ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.published_by> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=\"form-group datetime\" id=publish_date> <label for=publishing-date>Publishing date</label> <input ng-model=data.publish_date data-field=datetime type=text class=form-control id=publish_date placeholder=\"yyyy-MM-dd HH:mm\"/> </div> </form> <br/> <form class=\"form-inline no-border\"> <div class=form-group> <label for=last-edited-by>Last edited by</label> <input ng-model=data.last_edited_by.name ng-disabled=true type=text class=form-control id=last-edited-by /> </div> </form> <form class=\"form-inline no-border\"> <div class=form-group> <label for=published-by>Published by</label> <input ng-model=data.published_by.name ng-disabled=!canChangeAuthor() type=text class=form-control id=published-by /> </div> </form> </div> </div> </div> <div class=\"panel panel-default no-border\" ng-if=isAdmin> <div class=panel-heading> <a class=panel-title href=# ng-click=\"accordion.image = !accordion.image\"> <strong>Notificaciones ▼</strong> </a> </div> <div class=\"panel-collapse collapse\" uib-collapse=accordion.image> <div class=panel-body> <form class=\"form-inline no-border\"> <div class=form-group> <label for=image>Mensaje de Notificación1:</label> <input ng-model=data.notificacion type=text class=form-control id=image /> </div> </form> </div> </div> </div> </div> </div> <div id=dtBox></div> <script>var dateValue;$(function(){var e=$('[contentEditable=\"true\"]'),a=null,s=function(e){(a=$(this)).text().trim().length||a.empty()};e.on(\"input\",s),e.each(s),$(window).on(\"scroll\",function(e){143<$(window).scrollTop()?($(\"#save\").addClass(\"fixed-save\"),$(\"#autosave\").addClass(\"fixed-autosave\"),$(\"#publishing\").addClass(\"fixed-publishing\"),$(\".right-sidebar\").addClass(\"margin-sidebar\")):($(\"#save\").removeClass(\"fixed-save\"),$(\"#autosave\").removeClass(\"fixed-autosave\"),$(\"#publishing\").removeClass(\"fixed-publishing\"),$(\".right-sidebar\").removeClass(\"margin-sidebar\"))}),$(\"#dtBox\").DateTimePicker({isPopup:!0,dateTimeFormat:\"yyyy-MM-dd HH:mm\",settingValueOfElement:function(e,a,s){dateValue=a}})});var changesSaved=!0;window.onbeforeunload=function(){if(1==changesSaved)return\"add You havent saved your changes. Are you sure you want to leave the page?\"}</script> ";

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account', ['account.my-articles', 'account.add-article', 'account.add-article-live', 'account.edit-article', 'account.edit-article-live', 'account.add-video', 'account.index', 'account.settings', 'account.verification', 'account.main-page', 'account.tags', 'account.roles']
	//'account.sports'
	);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var removeHtmlTags = __webpack_require__(175).removeHtmlTags;
	
	angular.module('account.main-page', ['security.authorization', 'services.adminResource', 'resources.Article', 'angular-growl', 'resources.Category']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.main-page', {
	    url: '/main-page',
	    title: 'Manage Articles',
	    views: {
	      'main@': {
	        template: __webpack_require__(176),
	        controller: 'MainPageController'
	      }
	    },
	    resolve: {
	      user: ["User", "$state", function (User, $state) {
	        return User.current(function (user) {
	          if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
	            return user;
	          }
	
	          return $state.go('unauthorized');
	        }).$promise;
	      }]
	    }
	  });
	}]).controller('MainPageController', ["$scope", "$route", "$location", "$log", "utility", "growl", "STATUSES", "ARTICLE_STYLES", "DEFAULT_EDITION", "APP_IMG_URLS", "Category", "Article", "socket", "localizedMessages", function ($scope, $route, $location, $log, utility, growl, STATUSES, ARTICLE_STYLES, DEFAULT_EDITION, APP_IMG_URLS, Category, Article, socket, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  $scope.imgUrl200 = APP_IMG_URLS['200'];
	  $scope.imgUrlNoPhoto = APP_IMG_URLS['NO_PHOTO_200'];
	
	  var maxKey = 0;
	  $scope.dataLoaded = false;
	  $scope.getOption = function (category) {
	    $scope.query.cat_sefriendly = category.sefriendly ? category.sefriendly : undefined;
	    $scope.chosenLocale = category.sefriendly ? category.sefriendly : '';
	    fetchData();
	  };
	
	  $scope.getArticlesByStatus = function (statusCode, edition) {
	    $scope.dropStatus = statusCode;
	    $scope.query.cat_sefriendly = undefined;
	    $scope.query.edition = edition;
	    $scope.query.status = $scope.dropStatus;
	    fetchData();
	  };
	
	  $scope.getLimit = function () {
	    $scope.query.limit = $scope.query.limit;
	    fetchData();
	  };
	
	  // local var
	  var deserializeData = function deserializeData(data) {
	    if (!data) return;
	    $scope.page = data.meta.page;
	    $scope.query = data.meta.query;
	    $scope.mainArticles = data.data.map(function (a) {
	      a.title = removeHtmlTags(a.title);
	      return a;
	    });
	  };
	
	  var fetchData = function fetchData() {
	    $scope.dataLoaded = true;
	    $scope.query.sort = "-orderNumber";
	    // console.log( '>>>', $scope.query );
	    Article.query($scope.query).$promise.then(function (data) {
	      $scope.locale = _.find($scope.editions, { sefriendly: $scope.chosenLocale });
	      // console.log(data)
	      deserializeData(data);
	      //update url in browser addr bar
	      //$scope.query.sort = "orderNumber";
	      if (data.data[0]) {
	        maxKey = data.data[0].orderNumber;
	      }
	      // console.log(maxKey)
	      $location.search($scope.query);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  $scope.fetchArticles = function (offset) {
	    $scope.query.skip = offset;
	    fetchData();
	  };
	
	  $scope.dropToMainCallback = function (event, index, item, external, type) {
	    return item;
	  };
	  $scope.dropToMyCallback = function (event, index, item, external, type) {
	    item.status = 1;
	    Article.update(item, function (result) {}).$promise.then(function () {});
	    return item;
	  };
	
	  $scope.$watchCollection('query', function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	    //fetchData();
	  });
	
	  $scope.getLabel = function (status) {
	    var status = _.find(STATUSES, { id: status + '' });
	    return status ? status.value.split("?").join('') : '';
	  };
	
	  $scope.getStyle = function (status) {
	    var status = _.find(STATUSES, { id: status + '' });
	    return {
	      color: status ? status.color : '',
	      background: status ? status.background : ''
	    };
	  };
	
	  $scope.saveOrder = function () {
	    $scope.dataLoaded = false;
	
	    var newOrders = $scope.mainArticles.map(function (value, index) {
	      return { index: index, value: value };
	    });
	
	    async.mapSeries(newOrders, function (item, cbMap) {
	      item.value.orderNumber = maxKey - item.index;
	      Article.update(item.value, function () {
	        cbMap(null);
	      });
	    }, function () {
	      $scope.dataLoaded = true;
	      growl.info('Order saved!');
	    });
	  };
	
	  $scope.limits = [{ label: "1 Materiałów", value: 1 }, { label: "5 Materiałów", value: 5 }, { label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }];
	  $scope.query = $location.search();
	  $scope.dropStatus = 17;
	  $scope.query.limit = $scope.query.limit || 50;
	  $scope.query.status = $scope.dropStatus;
	  //get categories list
	  async.parallel({
	    categories: function categories(cb) {
	      var options = [];
	      var generateCategoryOptions = function generateCategoryOptions(items, container) {
	        items.forEach(function (item) {
	          if (!item.path) {
	            return;
	          }
	          var depth = item.path.split('/').filter(Boolean).length;
	          var indent = new Array(5).join(String.fromCharCode(160));
	          container.push({
	            _id: item.id,
	            path: item.path,
	            sefriendly: item.sefriendly,
	            parent: item.parent,
	            name: item.name,
	            _name: new Array(depth).join(indent) + item.name
	          });
	          if (item.children) {
	            generateCategoryOptions(item.children, container);
	          }
	        });
	        return container;
	      };
	      Category.getPermittedTree().$promise.then(function (data) {
	        generateCategoryOptions(data, options);
	        cb(null, options);
	      });
	    }
	  }, function (err, results) {
	    if (err) return console.log(err);
	    $scope.viewEditions = {
	      es: false,
	      ar: false,
	      br: false,
	      it: false,
	      en: false,
	      mx: false,
	      "en-us": false,
	      lat: false,
	      pt: false,
	      fr: false,
	      ru: false,
	      arb: false
	    };
	    $scope.editions = [];
	    results.categories.forEach(function (category) {
	      $scope.editions.push(category);
	      $scope.viewEditions[category.path] = true;
	    });
	    fetchData();
	    $scope.categories = results.categories;
	  });
	}]);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var htmlDecode = __webpack_require__(154).Html5Entities.decode;
	
	module.exports.removeHtmlTags = function (str) {
	  return str ? htmlDecode(str).replace(/<(?:.|\n)*?>/gm, '') : str;
	};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = "<style>.thumbnail{height:100%}.thumbnail h4{display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;font-family:Open sans,Arial;font-size:12px;font-weight:600;text-align:left;margin-bottom:10px;margin-top:0}.typeFilters li{cursor:pointer;display:inline-block;padding:.1em}.typeFilters li:hover{text-decoration:underline}.saveOrder{margin-left:2em;list-style:none;padding:5px}ul[dnd-list]{min-height:42px;padding-left:0}ul[dnd-list] .dndDraggingSource{display:none}ul[dnd-list] .dndPlaceholder{background-color:#ddd;min-height:350px}ul[dnd-list] li{background-color:#fff;width:10%;font-size:12px;margin-bottom:10px;display:inline;float:left;height:270px;margin-left:1%}@media (max-width:990px){ul[dnd-list] li{width:15%;height:340px}}@media (max-width:767px){ul[dnd-list] li{width:30%;height:370px}}@media (max-width:410px){ul[dnd-list] li{width:48%;height:340px}}ul[dnd-list] li.selected{background-color:#dff0d8;color:#3c763d}</style> <div class=loading ng-hide=dataLoaded></div> <div class=row id=admin-groups-index ng-init=\"showFilters=false\"> <div class=col-xs-12> <div class=page-header> <h1>Materiały strony głównej</h1> </div> <div class=row style=\"margin:0 0 20px\"> <table class=\"table center\"> <tr class=typeFilters ng-show=true> <td ng-click=\"getArticlesByStatus(17, 'varsovia')\" ng-class=\"{true: 'underline', false: ''}[dropStatus == 17]\">Top 4 Warszawa </td> <td ng-click=\"getArticlesByStatus(17, 'poznan')\" ng-class=\"{true: 'underline', false: ''}[dropStatus == 17]\">Top 4 Poznan </td> <td ng-click=\"getArticlesByStatus(18, 'varsovia')\" ng-class=\"{true: 'underline', false: ''}[dropStatus == 18]\">Strona główna Warszawa </td> <td ng-click=\"getArticlesByStatus(18, 'poznan')\" ng-class=\"{true: 'underline', false: ''}[dropStatus == 18]\">Strona główna Poznań </td> </tr> </table> <div class=\"form-group col-sm-8\"> <label>Kategorie</label> <oi-select class=ng-not-empty oi-options=\"option._name for option in editions track by option.id \" ng-change=getOption(locale) oi-select-options=selectSettings ng-model=locale placeholder=\"Wybierz kategorie\" ng-selected=option[0]._name></oi-select> </div> <div class=\"form-group col-sm-2\"> <label>Limit</label> <select name=limit class=form-control ng-model=query.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\" ng-change=getLimit()> </select> </div> <div class=\"form-group col-sm-2\"> <label></label> <div class=saveOrder ng-click=saveOrder()> <div class=\"btn btn-primary\"> Zapisz kolejność </div> </div> </div> </div> <ul class=\"articleList row\" dnd-list=mainArticles dnd-drop=\"dropToMainCallback(event, index, item, external, type)\"> <li ng-repeat=\"article in mainArticles\" dnd-draggable=article dnd-moved=\"mainArticles.splice($index, 1)\" dnd-effect-allowed=move> <div class=thumbnail> <a href=# ng-href=\"{{ article.show_inarticle == 21 ? '/account/edit-article-live/' + article.article_id :'/account/edit-article/' + article.article_id }}\"> <img style=width:100%;display:block ng-src=\"{{ article.image ? imgUrl200 + article.image : imgUrlNoPhoto }}\"> </a> <div class=label style=display:block;border-radius:0;text-align:right ng-style=getStyle(article.status)> {{ getLabel(article.status) }} </div> <span ng-if=article.editing style=color:red> {{ article.editing }} </span> <span ng-if=article.watching style=color:#ff6b44> {{ article.watching }} </span> <div class=caption> <h4 title=\"{{ article.title }}\">{{ article.title }}</h4> <p class=text-muted style=margin:0> {{ article.publish_date | date: 'dd MMM yyyy' }} </p> <a href=# style=max-height:1.5em;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap> <strong>{{ article.author.name || 'Anonymous' }}</strong> </a> </div> </div> </li> </ul> <paginator page-model=page on-navigate=fetchArticles($offset)></paginator> </div> </div> ";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var htmlDecode = __webpack_require__(154).Html5Entities.decode;
	
	angular.module('account.my-articles', ['security.authorization', 'services.adminResource', 'resources.Article', 'ngTagsInput', 'resources.Tag', 'resources.User', 'resources.Category', 'config', 'services.algoliaResource', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('account.my-articles', {
	        url: '/my-articles',
	        title: 'Manage Articles',
	        views: {
	            'main@': {
	                template: __webpack_require__(178),
	                controller: 'MyArticlesController'
	            }
	        }
	    });
	}]).controller('MyArticlesController', ["$scope", "$route", "$location", "$log", "utility", "STATUSES", "ARTICLE_STYLES", "APP_IMG_URLS", "Category", "Tag", "Article", "socket", "algoliaResource", "localizedMessages", function ($scope, $route, $location, $log, utility, STATUSES, ARTICLE_STYLES, APP_IMG_URLS, Category, Tag, Article, socket, algoliaResource, localizedMessages) {
	    $scope.localizedMessages = localizedMessages;
	    STATUSES = STATUSES.map(function (status) {
	        return Object.assign(status, { value: localizedMessages.get(status.value) });
	    });
	    $scope.imgUrl200 = APP_IMG_URLS['200'];
	    $scope.imgUrlNoPhoto = APP_IMG_URLS['NO_PHOTO_200'];
	
	    $scope.dataLoaded = false;
	    $scope.loadTags = function (query) {
	        return Tag.search({ q: query }).$promise.then(function (tags) {
	            if (!tags) return [];
	            return tags.map(function (tag) {
	                return {
	                    _id: tag._id,
	                    text: tag.name,
	                    name: tag.name,
	                    sefriendly: slugify(tag.name)
	                };
	            });
	        });
	    };
	    // $scope.loadAutors = function (query) {
	    //     return User.search({q: query}).$promise.then(function (users) {
	    //         if (!users) return [];
	    //         return users.map(function (user) {
	    //             return {
	    //                 _id: tag._id,
	    //                 text: tag.name,
	    //                 name: tag.name,
	    //                 sefriendly: slugify(tag.name)
	    //             }
	    //         })
	    //     });
	    // };
	
	    var slugify = function slugify(text) {
	        if (typeof text !== 'string') return text;
	        return text.toString().toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u').replace(/ã/g, 'a').replace(/ñ/g, 'n').replace(/ç/g, 'c').replace(/ü/g, 'u').replace(/^\s+|\s+$/g, "").replace(/[_|\s]+/g, "-").replace(/[^a-z\u0400-\u04FF0-9-]+/g, "").replace(/[-]+/g, "-").replace(/^-+|-+$/g, "");
	    };
	
	    $scope.$watchCollection('data.categories', function (newVal, oldVal) {
	        var temp = "";
	        if (newVal) {
	            newVal.forEach(function (category) {
	                temp += "," + category.id;
	            });
	            $scope.query.categories = temp.replace(',', '');
	        }
	    });
	    $scope.tempTags = [];
	    $scope.applyFilters = function () {
	        for (name in $scope.temp) {
	            if (name == 'keywords') {
	                $scope.query[name] = $scope.temp[name].replace(/  /g, " ").split(' ');
	                continue;
	            }
	            if (name == 'tags') {
	                $scope.tempTags = [];
	                $scope.temp[name].forEach(function (tag) {
	                    $scope.tempTags.push(tag.name);
	                });
	                $scope.query[name] = $scope.tempTags.join(',');
	                $scope.tempTags = $scope.temp[name];
	                $scope.temp[name] = [];
	                continue;
	            }
	            if (name == 'categories') {
	                var temp = [];
	                $scope.temp[name].forEach(function (categories) {
	                    temp.push(categories.id);
	                });
	                $scope.query[name] = temp.join(',');
	                continue;
	            }
	            $scope.query[name] = $scope.temp[name];
	        }
	        $scope.query.skip = 0;
	        // $scope.resetFilters();
	        // console.log( '>>>1', $scope.query );
	        Article.query($scope.query).$promise.then(function (data) {
	            deserializeData(data);
	            //update url in browser addr bar
	            $location.search($scope.query);
	            $scope.temp['tags'] = $scope.tempTags;
	        }, function (e) {
	            $log.error(e);
	        });
	    };
	    $scope.resetFilters = function () {
	        for (name in $scope.temp) {
	            if (Array.isArray($scope.temp[name])) {
	                $scope.temp[name] = [];
	                continue;
	            }
	            $scope.temp[name] = "";
	        }
	    };
	
	    //add info about users who edit some articles
	    socket.on('editUpdate', function (data) {
	        if (data && $scope.articles) {
	            for (var i = 0; i < $scope.articles.length; i++) {
	                if (data[$scope.articles[i].article_id + "_"] && data[$scope.articles[i].article_id + "_"].length) {
	                    $scope.articles[i].editing = "editing by: " + data[$scope.articles[i].article_id + "_"][0].replace(/\/.*/, '');
	                } else {
	                    $scope.articles[i].editing = "";
	                }
	                if (data[$scope.articles[i].article_id + "_"] && data[$scope.articles[i].article_id + "_"].length) {
	                    $scope.articles[i].watching = "watching by: ";
	                    for (var j = 1; j < data[$scope.articles[i].article_id + "_"].length; j++) {
	                        $scope.articles[i].watching += data[$scope.articles[i].article_id + "_"][j].replace(/\/.*/, '') + "  ";
	                    }
	                } else {
	                    $scope.articles[i].watching = "";
	                }
	            }
	        }
	    });
	    // local var
	    var deserializeData = function deserializeData(data) {
	        if (!data) return;
	        $scope.page = data.meta.page;
	        $scope.query = data.meta.query;
	        $scope.articles = data.data.map(function (article) {
	            // console.log( '>>', article );
	            article.title = htmlDecode(article.title);
	            return article;
	        });
	    };
	
	    $scope.query = _.assign({ limit: 50, skip: 0 }, $location.search());
	    $scope.statuses = STATUSES;
	    $scope.statuses.map(function (s) {
	        s.value = s.value.split("?").join('');
	    });
	    $scope.article_styles = ARTICLE_STYLES;
	    $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	    $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	    $scope.fetchArticles = function (offset) {
	        $scope.query.skip = offset;
	    };
	
	    $scope.dropStatus = 17;
	    $scope.chosenLocale = '1234';
	    Article.query({
	        status: $scope.dropStatus,
	        edition: $scope.chosenLocale,
	        sort: "orderNumber"
	    }).$promise.then(function (data) {
	        //                console.log( '>>>', data );
	        $scope.mainArticles = data.data;
	    }, function (e) {
	        $log.error(e);
	    });
	
	    $scope.getArticlesByStatus = function (statusCode, edition) {
	        console.log('params', statusCode, edition);
	        $scope.dropStatus = statusCode;
	        Article.query({
	            status: statusCode,
	            edition: edition,
	            sort: "orderNumber"
	        }).$promise.then(function (data) {
	            $scope.mainArticles = data.data;
	        }, function (e) {
	            $log.error(e);
	        });
	    };
	
	    $scope.saveOrder = function () {
	        setTimeout(function () {
	            growl.info('Order saved!');
	        }, 500);
	        $scope.mainArticles.forEach(function (article, index) {
	            article.orderNumber = index;
	            Article.update(article, function (result) {
	                console.log('saved');
	            });
	        });
	    };
	
	    $scope.dropToMainCallback = function (event, index, item, external, type) {
	        item.status = $scope.dropStatus;
	        item.edition = $scope.chosenLocale;
	        // Article.update(item, function (result) {}).$promise.then(function () {});
	        return item;
	    };
	    $scope.dropToMyCallback = function (event, index, item, external, type) {
	        item.status = 1;
	        // Article.update(item, function (result) {}).$promise.then(function () {});
	        return item;
	    };
	    $scope.$watchCollection('locale', function (newState, oldState) {
	
	        if (newState || (typeof newState === 'undefined' ? 'undefined' : _typeof(newState)) != 'object') {
	            return;
	        }
	        // console.log( '>>>', newState );
	        $scope.chosenLocale = newState.sefriendly;
	        Article.query({
	            status: $scope.dropStatus,
	            edition: $scope.chosenLocale,
	            sort: "orderNumber"
	        }).$promise.then(function (data) {
	            $scope.mainArticles = data.data;
	        }, function (e) {
	            $log.error(e);
	        });
	    });
	
	    var queryTimer = null;
	    var endFlag = true;
	    $scope.$watchCollection('query', function (newState, oldState) {
	        if (angular.equals(newState, oldState)) {
	            return;
	        }
	
	        if (!queryTimer && endFlag) {
	            queryTimer = setTimeout(function () {
	                endFlag = false;
	                Article.query($scope.query).$promise.then(function (data) {
	
	                    deserializeData(data);
	                    //update url in browser addr bar
	                    $location.search($scope.query);
	                    queryTimer = null;
	                    endFlag = true;
	                }, function (e) {
	                    $log.error(e);
	                    endFlag = true;
	                });
	            }, 50);
	        } else if (endFlag) {
	            clearInterval(queryTimer);
	            queryTimer = setTimeout(function () {
	                Article.query($scope.query).$promise.then(function (data) {
	                    deserializeData(data);
	                    //update url in browser addr bar
	                    $location.search($scope.query);
	                    queryTimer = null;
	                }, function (e) {
	                    $log.error(e);
	                });
	            }, 50);
	        }
	    });
	
	    // $scope vars
	    //select elements and their associating options
	    $scope.getLabel = function (status) {
	        var status = _.find(STATUSES, { id: status + '' });
	        return status ? status.value : '';
	    };
	
	    $scope.getStyle = function (status) {
	        var status = _.find(STATUSES, { id: status + '' });
	        return {
	            color: status ? status.color : '',
	            background: status ? status.background : ''
	        };
	    };
	    $scope.query.sort = /*'created_at';*/"created_at-";
	    Article.query($scope.query).$promise.then(function (data) {
	
	        deserializeData(data);
	        //update url in browser addr bar
	        $location.search($scope.query);
	    }, function (e) {
	        $log.error(e);
	    });
	
	    async.parallel({
	        categories: function categories(cb) {
	            var options = [];
	            var generateCategoryOptions = function generateCategoryOptions(items, container) {
	                items.forEach(function (item) {
	                    if (!item.path) {
	                        return;
	                    }
	                    var depth = item.path.split('/').filter(Boolean).length;
	                    var indent = new Array(5).join(String.fromCharCode(160));
	                    container.push({
	                        _id: item._id,
	                        id: item.id,
	                        path: item.path,
	                        sefriendly: item.sefriendly,
	                        parent: item.parent,
	                        parent_id: item.parent_id,
	                        name: item.name,
	                        _name: new Array(depth).join(indent) + (depth > 1 ? '- ' : '') + item.name
	                    });
	                    if (item.children) {
	                        generateCategoryOptions(item.children, container);
	                    }
	                });
	                return container;
	            };
	            Category.getPermittedTree().$promise.then(function (data) {
	                generateCategoryOptions(data, options);
	                cb(null, options);
	            });
	        }
	    }, function (err, results) {
	        if (err) return console.log(err);
	        $scope.dataLoaded = true;
	        $scope.categories = results.categories;
	    });
	
	    $scope.algoliaReindexing = function () {
	        algoliaResource.indexingArticles().then(function (result) {
	            $scope.algoliaSuccess = true;
	        }).catch(function (error) {
	            $scope.algoliaError = true;
	        });
	    };
	}]);

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = "<style>.thumbnail h4{display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;font-family:Ubuntu,Ubuntu Condensed,Tahoma;font-size:16px}.thumbnail{min-height:320px}.container{width:auto!important}@media screen and (max-width:500px){.thumbnail{min-height:340px!important}}@media screen and (max-width:750px){.thumbnail{min-height:460px}.add-article,.add-bio,.add-live{min-width:30%}}@media screen and (min-width:1500px){.thumbnail{min-height:365px}}@media screen and (min-width:1600px){.thumbnail{min-height:385px}}@media screen and (min-width:1700px){.thumbnail{min-height:395px}}@media screen and (min-width:1800px){.thumbnail{min-height:420px}}.caption a,.caption p{font-size:12px!important}</style> <div class=loading ng-hide=dataLoaded></div> <div class=row id=admin-groups-index ng-init=\"showFilters=false\" ng-show=dataLoaded> <div class=col-xs-12> <div class=page-header> <a href=/account/add-article class=\"add-article btn btn-default pull-right\">{{localizedMessages.get('new-article')}}</a> <a href=/account/add-video class=\"new-video btn btn-default pull-right\">{{localizedMessages.get('new-video')}}</a> <a href=# class=\"btn btn-default pull-right search-filters-button\" style=margin-right:10px ng-click=\"showFilters=!showFilters\">{{localizedMessages.get('search-filters')}}</a> <h1>{{localizedMessages.get('my-content')}}</h1> </div> <form class=filters> <div class=row ng-show=showFilters> <div class=\"form-group col-sm-12\"> <label>{{localizedMessages.get('keywords')}}</label> <input type=text name=keywords class=form-control ng-model=temp.keywords> </div> <div class=\"form-group col-sm-12\"> <label>{{localizedMessages.get('author')}}</label> <input type=text name=author class=form-control ng-model=temp.author> </div> <div class=\"form-group col-sm-12\"> <label>{{localizedMessages.get('tag')}}</label> <tags-input ng-model=temp.tags keyproperty=$index key-property=_id replace-spaces-with-dashes=false> <auto-complete source=loadTags($query) min-length=2 debounce-delay=1 max-results=10></auto-complete> </tags-input> </div> <div class=\"form-group col-sm-12\"> <label>{{localizedMessages.get('date-from')}}</label> <input type=date name=tag class=form-control ng-model=temp.min_date> </div> <div class=\"form-group col-sm-12\"> <label>{{localizedMessages.get('date-to')}}</label> <input type=date name=tag class=form-control ng-model=temp.max_date> </div> <div class=\"form-group col-sm-12\"> <label>{{localizedMessages.get('categories')}}</label> <select multiple=multiple ng-model=temp.categories ng-options=\"option._name for option in categories track by option.id\" class=filter-categories> </select> </div> <div class=\"form-group col-sm-12\"> <input type=button ng-click=applyFilters() class=\"btn btn-info\" value=\"{{localizedMessages.get('search')}}\"> <input type=button class=\"btn btn-danger\" ng-click=resetFilters() value=\"{{localizedMessages.get('reset-filters')}}\"> </div> </div> <div class=row ng-hide=showFilters> <div class=\"form-group col-sm-4\"> <label>{{ localizedMessages.get('status') }}</label> <select name=status class=form-control ng-model=query.status ng-model-options=\"{ debounce: 500 }\" ng-options=\"status.id as status.value for status in statuses\"> <option value=\"\">{{ localizedMessages.get('all') }}</option> </select> </div> <div class=\"form-group col-sm-4\"> <label>{{ localizedMessages.get('display') }}</label> <select name=show_inarticle class=form-control ng-model=query.show_inarticle ng-model-options=\"{ debounce: 500 }\" ng-options=\"article_style.id as article_style.value for article_style in article_styles\"> <option value=\"\">{{ localizedMessages.get('all') }}</option> </select> </div> <div class=\"form-group col-sm-4\"> <label>{{ localizedMessages.get('limit') }}</label> <select name=limit class=form-control ng-model=query.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\"> </select> </div> </div> </form> <div class=row> <div class=\"col-sm-2 module-article-home\" ng-repeat=\"article in articles\"> <div class=thumbnail> <a href=# ng-href=\"{{article.show_inarticle == 21 ? '/account/edit-article-live/' + article.article_id :'/account/edit-article/' + article.article_id}}\"> <img style=width:100%;display:block;height:120px ng-src=\"{{article.image ? imgUrl200 + article.image : imgUrlNoPhoto}}\"> </a> <div class=label style=display:block;border-radius:0;text-align:right ng-style=getStyle(article.status)> {{ getLabel(article.status) }} </div> <span ng-if=article.editing style=background-color:#c52c2c;padding:5px> {{ article.editing }} </span> <span ng-if=article.watching style=color:#ff6b44> {{ article.watching }} </span> <div class=caption> <h4 class=main-articles-title title=\"{{article.title | rawHtml}}\">{{article.title | rawHtml}}</h4> <p class=text-muted style=margin:0> {{article.created_at | date: 'dd MMM yyyy'}} </p> <a href=# style=max-height:1.5em;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap> <strong>{{article.author.name || 'Anonymous'}}</strong> </a> </div> </div> </div> </div> <paginator page-model=page on-navigate=fetchArticles($offset)></paginator> </div> </div> ";

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account.roles', ['account.roles.index', 'account.roles.add', 'account.roles.edit']);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.roles.add', ['security.authorization', 'services.utility', 'services.adminResource', 'directives.serverError', 'resources.Role', 'ui.bootstrap.dropdown', 'services.formErrors', 'ngFileUpload']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.roles.add', {
	    url: '/add',
	    title: 'Account Roles / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(181),
	        controller: 'AccountRoleAddCtrl'
	      }
	    },
	    resolve: {
	      user: ["User", "$state", "$location", function (User, $state, $location) {
	
	        return User.current(function (user) {
	          if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
	            return user;
	          }
	          return $state.go('unauthorized');
	        }).$promise;
	      }]
	    }
	  });
	}]).controller('AccountRoleAddCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "Role", "formErrors", "growl", "dateFilter", "Upload", function ($scope, $route, $location, $log, utility, adminResource, Role, formErrors, growl, dateFilter, Upload) {
	  var slugify = function slugify(text) {
	    if (typeof text !== 'string') return text;
	    return text.toString().toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u').replace(/ã/g, 'a').replace(/ñ/g, 'n').replace(/ç/g, 'c').replace(/ü/g, 'u').replace(/^\s+|\s+$/g, "").replace(/[_|\s]+/g, "-").replace(/[^a-z\u0400-\u04FF0-9-]+/g, "").replace(/[-]+/g, "-").replace(/^-+|-+$/g, "");
	  };
	  $scope.dataLoaded = true;
	  $scope.roleTypesList = [];
	  $scope.languagesList = [];
	  $scope.data = {
	    name: null,
	    //sport: null,
	    type: null
	  };
	
	  $scope.role = {
	    name: "",
	    //sport: "",
	    type: ""
	  };
	
	  adminResource.getRoleTypes().then(function (types) {
	    $scope.roleTypesList = types;
	  });
	
	  /*adminResource.getSports().then(function (sports) {
	    $scope.sportsList = sports && sports.data ? sports.data : [];
	  })*/
	
	  adminResource.getLanguages().then(function (languages) {
	    $scope.languagesList = languages;
	  });
	
	  $scope.addTranslation = function ($event) {
	    $event.preventDefault();
	    var translation = {
	      name: "",
	      languageTag: ""
	    };
	    if (!$scope.role.translations) {
	      $scope.role.translations = [];
	    }
	    $scope.role.translations.push(translation);
	  };
	
	  $scope.removeTranslation = function (index, $event) {
	    $event.preventDefault();
	    $scope.role.translations.splice(index, 1);
	  };
	
	  $scope.submit = function () {
	    var data = angular.copy($scope.role);
	
	    $scope.dataLoaded = false;
	    Role.save(data, function (result) {
	      $scope.dataLoaded = true;
	      growl.info('Role saved!');
	      $location.path('/account/roles/edit/' + result._id);
	    }, function (error) {
	      formErrors.growlErrors(error);
	      $scope.dataLoaded = true;
	    });
	  };
	}]);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "<div class=loading ng-hide=dataLoaded></div> <div class=row id=account-roles-detail> <div class=col-xs-12> <div class=page-header> <h1><a href=/account/roles>Account Roles</a> / Add new</h1> </div> <form novalidate=\"\" name=detailForm ng-submit=submit()> <div class=row> <alert ng-repeat=\"alert in detailAlerts\" type=\"{{ alert.type }}\" close=closeDetailAlert($index)>{{ alert.msg }}</alert> <div class=col-xs-6> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.name)}\"> <label class=control-label for=name>Name:</label> <input type=text name=name id=name class=form-control ng-model=role.name required> </div> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.type)}\"> <label class=control-label for=type>Type:</label> <select name=type id=type class=form-control ng-model=role.type required> <option ng-repeat=\"type in roleTypesList\" ng-bind=type.translations.en value={{type.name}}></option> </select> </div> </div> </div> <div class=row> <div class=col-xs-12> <button class=\"btn btn-primary pull-right\" ng-click=addTranslation($event)>Add translation </button> </div> <div class=col-xs-12 ng-repeat=\"item in role.translations \"> <div class=col-xs-6> <div class=form-group> <label class=control-label>Name:</label> <input type=text name=name class=form-control ng-model=item.name ng-required=required> </div> </div> <div class=col-xs-6> <div class=form-group> <label class=control-label for=language>Language:</label> <div class=form-inline> <select name=language id=language class=form-control ng-model=item.languageTag required> <option ng-repeat=\"lang in languagesList\" ng-bind=lang.name value={{lang.tag}}></option> </select> <button class=\"btn btn-danger\" ng-click=removeTranslation($index,$event)>Remove this translation</button> </div> </div> </div> </div> </div> <div class=form-group> <button type=submit class=\"btn btn-primary\">Save</button> </div> <alert ng-repeat=\"alert in detailAlerts\" type=\"{{ alert.type }}\" close=closeDetailAlert($index)>{{ alert.msg }}</alert> </form> </div> </div> ";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.roles.edit', ['security.authorization', 'services.utility', 'services.adminResource', 'directives.serverError', 'ui.bootstrap.dropdown', 'services.formErrors', 'ngFileUpload']);
	
	angular.module('account.roles.edit').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.roles.edit', {
	    url: '/edit/:id',
	    title: 'Account Roles / Edit',
	    views: {
	      'main@': {
	        template: __webpack_require__(183),
	        controller: 'AccountRolesEditCtrl',
	        resolve: {
	          role: ["$stateParams", "adminResource", function ($stateParams, adminResource) {
	            return adminResource.findRole($stateParams.id);
	          }]
	          /*sports: function(adminResource) {
	            return adminResource.getSports();
	          },*/
	        }
	      }
	    }
	  });
	}]).controller('AccountRolesEditCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "role", "Role", "formErrors", "growl", "dateFilter", "Upload", "user", function ($scope, $route, $location, $log, utility, adminResource, role, Role, formErrors, growl, dateFilter, Upload, user) {
	  //, sport
	  var slugify = function slugify(text) {
	    if (typeof text !== 'string') return text;
	    return text.toString().toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u').replace(/ã/g, 'a').replace(/ñ/g, 'n').replace(/ç/g, 'c').replace(/ü/g, 'u').replace(/^\s+|\s+$/g, "").replace(/[_|\s]+/g, "-").replace(/[^a-z\u0400-\u04FF0-9-]+/g, "").replace(/[-]+/g, "-").replace(/^-+|-+$/g, "");
	  };
	  $scope.dataLoaded = true;
	  //$scope.sportsList = !!sports && sports.data ? sports.data : [];
	  $scope.roleTypesList = [];
	  $scope.languagesList = [];
	
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    var answer = confirm("Are you sure you want to navigate away from this page");
	    if (!answer) {
	      event.preventDefault();
	    }
	  });
	
	  $scope.closeDetailAlert = function () {
	    $scope.detailAlerts = [];
	  };
	
	  var deserializeData = function deserializeData(data) {
	    $scope.role = data;
	    //$scope.role.sport = !!data.sport ? _.find($scope.sportsList, {name: data.sport}) : undefined;
	  };
	
	  $scope.addTranslation = function ($event) {
	    $event.preventDefault();
	    var translation = {
	      name: "",
	      languageTag: ""
	    };
	    if (!$scope.role.translations) {
	      $scope.role.translations = [];
	    }
	    $scope.role.translations.push(translation);
	  };
	
	  $scope.removeTranslation = function (index, $event) {
	    $event.preventDefault();
	    $scope.role.translations.splice(index, 1);
	  };
	
	  $scope.submit = function () {
	    var data = angular.copy($scope.role);
	    if (data.sport && data.sport.name) {
	      data.sport = data.sport.name;
	    }
	
	    $scope.dataLoaded = false;
	    Role.update(data, function (result) {
	      $scope.dataLoaded = true;
	      growl.info('Role saved!');
	    }, function (error) {
	      formErrors.growlErrors(error);
	      $scope.dataLoaded = true;
	    });
	  };
	
	  $scope.delete = function (tag) {
	    if (!confirm('Are you sure you want to delete this role?')) {
	      return;
	    }
	    Role.delete({ id: role._id }, function (result) {
	      setTimeout(function () {
	        growl.info('Role removed!');
	        $location.path('/account/roles');
	      }, 1000);
	    }, function (error) {
	      formErrors.growlErrors(error);
	      $scope.dataLoaded = true;
	    });
	  };
	
	  $scope.canEdit = function () {
	    return user.permissions.is_admin || !$scope.showOriginalVersion;
	  };
	  $scope.isAdmin = function () {
	    return user.permissions.is_admin;
	  };
	
	  deserializeData(role);
	  adminResource.getRoleTypes().then(function (types) {
	    $scope.roleTypesList = types;
	  });
	
	  /*adminResource.getSports().then(function(sports){
	    $scope.sportsList = sports && sports.data ? sports.data : [];
	  });*/
	  adminResource.getLanguages().then(function (languages) {
	    $scope.languagesList = languages;
	  });
	}]);

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	module.exports = "<div class=loading ng-hide=dataLoaded></div> <div class=row id=account-roles-detail> <div class=col-xs-12> <div class=page-header> <button class=\"btn btn-danger pull-right\" ng-click=delete(role) ng-if=isAdmin()>Delete</button> <h1><a href=/account/roles>Account Roles</a> / Edit</h1> </div> <form novalidate=\"\" name=detailForm ng-submit=submit()> <div class=row> <alert ng-repeat=\"alert in detailAlerts\" type=\"{{ alert.type }}\" close=closeDetailAlert($index)>{{ alert.msg }}</alert> <div class=col-xs-6> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.name)}\"> <label class=control-label for=name>Name:</label> <input type=text name=name id=name class=form-control ng-model=role.name required> </div> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.type)}\"> <label class=control-label for=type>Type:</label> <select name=type id=type class=form-control ng-model=role.type required> <option ng-repeat=\"type in roleTypesList\" ng-bind=type.translations.en value={{type.name}}></option> </select> </div> </div> </div> <div class=row> <div class=col-xs-12> <button class=\"btn btn-primary pull-right\" ng-click=addTranslation($event)>Add translation </button> </div> <div class=col-xs-12 ng-repeat=\"item in role.translations \"> <div class=col-xs-6> <div class=form-group> <label class=control-label>Name:</label> <input type=text name=name class=form-control ng-model=item.name ng-required=required> </div> </div> <div class=col-xs-6> <div class=form-group> <label class=control-label for=language>Language:</label> <div class=form-inline> <select name=language id=language class=form-control ng-model=item.languageTag required> <option ng-repeat=\"lang in languagesList\" ng-bind=lang.name value={{lang.tag}}></option> </select> <button class=\"btn btn-danger\" ng-click=removeTranslation($index,$event)>Remove this translation</button> </div> </div> </div> </div> </div> <div class=form-group> <button type=submit class=\"btn btn-primary\">Save</button> </div> <alert ng-repeat=\"alert in detailAlerts\" type=\"{{ alert.type }}\" close=closeDetailAlert($index)>{{ alert.msg }}</alert> </form> </div> </div> ";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('account.roles.index', ['security.authorization', 'services.utility', 'resources.Role', 'services.adminResource', 'services.search', 'filters.timeAgo']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.roles', {
	    url: '/roles?limit&oficial&skip&name',
	    title: 'Manage Roles',
	    views: {
	      'main@': {
	        template: __webpack_require__(185),
	        controller: 'RolesIndexCtrl'
	      }
	    },
	    resolve: {
	      user: ["User", "$state", "$location", function (User, $state, $location) {
	        return User.current(function (user) {
	          if (user && user.is_active && user.permissions.is_admin) {
	            return user;
	          }
	          return $state.go('unauthorized');
	        }).$promise;
	      }],
	      initSearch: ["searchService", "Role", "$state", function (searchService, Role, $state) {
	        searchService.setSearchFn(Role.search);
	        searchService.setRedirectBase('/account/roles/edit');
	      }]
	    }
	  });
	}]).controller('RolesIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "searchService", "$stateParams", "user", function ($scope, $route, $location, $log, utility, adminResource, searchService, $stateParams, user) {
	  $scope.isAdmin = user.permissions.is_admin;
	  $scope.search = searchService.search;
	
	  // // typeahead-on-select="getRole($item)"
	  // $scope.getRole = function ($item) {
	  //     $scope.role = $item.name + ' performance';
	  //     $scope.query.name = $scope.query.role.name;
	  // };
	
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.page = data.meta.page;
	    $scope.roles = data.data;
	  };
	
	  var fetchData = function fetchData() {
	    //console.log("$scope.query------->>>>>>>>"+JSON.stringify($scope.query));
	    adminResource.searchRoles($scope.query).then(function (data) {
	      // console.log("data------->>>>>>>>"+JSON.stringify(data));
	      deserializeData(data);
	      //update url in browser addr bar
	      // $location.search($scope.query);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  $scope.$watchCollection('query', _.debounce(function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	    fetchData();
	  }, 700));
	
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  $scope.query = $location.search();
	  $scope.query.limit = $scope.query.limit || $scope.limits[0].value;
	  $scope.query.name = $scope.query.name || '';
	  fetchData();
	
	  $scope.openTabByType = function (type) {
	    $scope.roles = [];
	    $scope.query.type = type;
	  };
	}]);

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = "<style>.nav.nav-tabs>li{margin-bottom:0!important}.nav.nav-tabs>li>a{border-bottom:0!important}.nav.nav-tabs>li>a:hover{color:#333;background-color:#e6e6e6;border-color:#adadad;border-bottom:0!important}</style> <div class=row id=account-roles-index> <div class=col-xs-12> <div class=page-header ng-if=isAdmin> <a ng-href=/account/roles/add class=\"btn btn-default pull-right\">Add New</a> <h1>Roles</h1> </div> <form class=filters> <div class=row> <div class=col-sm-3> <label>name</label> <input id=role-name type=text class=form-control placeholder=All autocomplete=off ng-model=query.name> </div> <div class=col-sm-2> <label>Limit</label> <select name=limit class=form-control ng-model=query.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\"> </select> </div> </div> </form> <br> <uib-tabset active=0> <uib-tab index=0 heading=\"All Roles\" select=\"openTabByType(undefined)\"></uib-tab> <uib-tab index=1 heading=\"Profile Roles\" select=\"openTabByType('profile')\"></uib-tab> <uib-tab index=2 heading=\"Organization Roles\" select=\"openTabByType('organization')\"></uib-tab> <uib-tab index=3 heading=\"Event Roles\" select=\"openTabByType('event')\"></uib-tab> <uib-tab index=4 heading=\"Location Roles\" select=\"openTabByType('location')\"></uib-tab> </uib-tabset> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>name</th> <th>type</th> </tr> </thead> <tbody> <tr ng-repeat=\"role in roles\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/account/roles/edit/{{role._id}}>Edit</a></td> <td ng-bind=role.name></td> <td ng-bind=role.type></td> </tr> </tbody> </table> <paginator page-model=page on-navigate=\"query.skip = $offset\" ng-show=\"roles.length>0\"></paginator> </div> </div> ";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var countries = __webpack_require__(161);
	var editions = __webpack_require__(187);
	
	var userpassword = null;
	
	angular.module('account.settings', ['resources.User', 'ui.bootstrap', 'ngFileUpload', 'services.formErrors', 'security', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.settings', {
	    url: '/settings',
	    title: 'Account Settings',
	    views: {
	      'main@': {
	        template: __webpack_require__(188),
	        controller: 'AccountSettingsCtrl'
	      }
	    },
	    resolve: {
	      user: ["User", "$location", "$q", function (User, $location, $q) {
	        return User.current().$promise.then(function (user) {
	          if (!user._id) {
	            $location.path('/login');
	            return $q.reject('unauthorized');
	          }
	          return user;
	        });
	      }]
	    }
	  });
	}]).controller('AccountSettingsCtrl', ["$scope", "User", "user", "formErrors", "$uibModal", "growl", "Upload", "APP_IMG_URLS", "localizedMessages", function ($scope, User, user, formErrors, $uibModal, growl, Upload, APP_IMG_URLS, localizedMessages) {
	  $scope.dataLoaded = true;
	  $scope.localizedMessages = localizedMessages;
	  $scope.user = user;
	  userpassword = user.password;
	  $scope.imgUrl = APP_IMG_URLS.base;
	  // console.log("----------->1>>>>>", user.account);
	  $scope.countries = [];
	  _.forIn(countries, function (value, key) {
	    $scope.countries.push({
	      _id: key,
	      name: value
	    });
	  });
	  $scope.editions = [];
	  _.forIn(editions, function (value, key) {
	    $scope.editions.push({
	      _id: key,
	      name: value
	    });
	  });
	  $scope.user.account.country = _.find($scope.countries, { _id: user.account.country });
	  $scope.user.account.editions = [];
	  user.account.groups.forEach(function (group) {
	    if (editions[group._id]) {
	      $scope.user.account.editions.push({
	        _id: group._id,
	        name: editions[group._id]
	      });
	    }
	  });
	
	  $scope.submit = function (data) {
	    $scope.dataLoaded = false;
	
	    // console.log('>>>', data);
	    var data = _.pick(angular.copy(data), ['_id', 'account', 'username', 'email', 'twitter', 'facebook', 'google', 'is_active']);
	    var groups = _.map(data.account.groups, '_id').filter(function (id) {
	      return !editions[id];
	    });
	    data.password = userpassword;
	    // console.log("----------->2>>>>>"+userpassword);
	    data.account.country = data.account.country._id;
	    data.account.groups = groups.concat(_.map(data.account.editions, '_id'));
	    delete data.account['editions'];
	
	    if (!data.full) {
	      data.full = ((data.first || '') + ' ' + (data.last || '')).trim();
	    }
	    // console.log( '>>>', data );
	    User.updateAccount(data, function (result) {
	      // $scope.user = result;
	      $scope.dataLoaded = true;
	      growl.info('Changes saved!');
	    }, formErrors.growlErrors);
	  };
	
	  $scope.changePassword = function () {
	    var modalInstance = $uibModal.open({
	      animation: true,
	      backdrop: true,
	      templateUrl: 'changePassword.tpl.html',
	      controller: 'ChangePasswordCtrl'
	    });
	  };
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  // upload on file select or drop
	  $scope.upload1 = function (file) {
	    $scope.uploading = true;
	    $scope.user.account.picture = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.user.account.picture = resp.data.filename;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.$watch('file1', function (file) {
	    if (!file) return;
	    $scope.upload1(file);
	  });
	
	  $scope.generateThumb = function (file, rejFile) {
	    if (file === null && rejFile === undefined) {
	      growl.info('Max image size is 10MB!', 3);
	    }
	  };
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    console.log(file.size);
	    $scope.uploading = true;
	    $scope.user.account.avatar = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.user.account.avatar = resp.data.filename;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.changeLogin = function () {
	    var modalInstance = $uibModal.open({
	      animation: true,
	      backdrop: true,
	      templateUrl: 'changeLogin.tpl.html',
	      controller: 'ChangeLoginCtrl',
	      resolve: {
	        data: $scope.user
	      }
	    });
	  };
	}]).controller('ChangePasswordCtrl', ["$scope", "$uibModalInstance", "User", "formErrors", "growl", "security", function ($scope, $uibModalInstance, User, formErrors, growl, security) {
	  $scope.submit = function (data) {
	    // console.log('>>> user:', userpassword);
	    // User.current().$promise.then(function (user) {
	    //   console.log( '>>>', user );
	    // });
	
	    var d = {
	      oldPassword: userpassword,
	      password: security.createHash(data.password),
	      confirm_password: security.createHash(data.confirm_password)
	    };
	    User.changePassword(d, function (result) {
	      $scope.data = {};
	      growl.info('Changes saved!');
	      $uibModalInstance.close();
	    }, formErrors.growlErrors);
	  };
	}]).controller('ChangeLoginCtrl', ["$scope", "$uibModalInstance", "User", "formErrors", "growl", "data", function ($scope, $uibModalInstance, User, formErrors, growl, data) {
	  $scope.data = {
	    username: data.username,
	    email: data.email
	  };
	
	  $scope.submit = function (data) {
	    User.changeLogin(data, function (result) {
	      $scope.data = {};
	      growl.info('Changes saved!');
	      $uibModalInstance.close();
	    }, formErrors.growlErrors);
	  };
	}]);

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = {"5b75912c19279aabe8b1897a":"English","5b75912c19279aabe8b189cb":"English (USA)","5b75912c19279aabe8b1899e":"Brasil","5b75912c19279aabe8b18a28":"Russia","5b75912c19279aabe8b189e0":"Portugal","5b75912c19279aabe8b189d4":"Germany","5b75912c19279aabe8b1895c":"Spain","5b75912c19279aabe8b189ad":"México","5b75912c19279aabe8b189b0":"Argentina","5b75912c19279aabe8b18977":"Colombia","5b75912c19279aabe8b18997":"Latin America","5b75912c19279aabe8b18a53":"Indonesia","5b75912c19279aabe8b18968":"Italia","5b75912c19279aabe8b18971":"France","5b75912c19279aabe8b189bc":"Arabic"}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = "<div class=loading ng-hide=dataLoaded></div> <div class=row> <div class=col-xs-12> <div class=page-header> <button type=button class=\"btn btn-info pull-right\" ng-click=changeLogin()>{{localizedMessages.get('change-login')}}</button> <button type=button class=\"btn btn-success pull-right\" style=margin-right:10px ng-click=changePassword()>{{localizedMessages.get('change-password')}}</button> <h1>{{localizedMessages.get('account-settings')}}</h1> </div> </div> </div> <form novalidate name=accountForm id=accountForm ng-submit=submit(user)> <div class=row> <div class=col-sm-6> <div class=form-group> <label class=control-label for=first>{{localizedMessages.get('first-name')}}:</label> <input type=text name=first id=first class=form-control ng-model=user.account.name.first required> </div> <div class=form-group> <label class=control-label for=last>{{localizedMessages.get('last-name')}}:</label> <input type=text name=last id=last class=form-control ng-model=user.account.name.last required> </div> <div class=form-group> <label class=control-label for=occupation>{{localizedMessages.get('occupation')}}:</label> <input type=text name=occupation id=occupation class=form-control ng-model=user.account.occupation> </div> <div class=form-group ng-hide=hasCountry()> <label class=control-label for=country>{{localizedMessages.get('country')}}:</label> <oi-select oi-options=\"country.name for country in countries track by country._id\" ng-model=user.account.country placeholder=\"\" required></oi-select> </div> <div class=form-group> <label class=control-label for=bio>{{localizedMessages.get('bio')}}:</label> <input type=text name=bio id=bio class=form-control ng-model=user.account.bio> </div> <div class=form-group ng-class=\"{'has-error': !accountForm.www.$valid}\"> <label class=control-label for=www>{{localizedMessages.get('website')}}:</label> <input type=text name=www id=www class=form-control ng-model=user.account.www> <span class=help-block ng-show=accountForm.www.$error.server ng-repeat=\"message in accountForm.www.$error.server\">{{message}}</span> </div> <div class=form-group> <label class=control-label for=twitter>Twitter:</label> <input type=text name=twitter id=twitter class=form-control ng-model=user.twitter> </div> <div class=form-group> <label class=control-label for=facebook>Facebook:</label> <input type=text name=facebook id=facebook class=form-control ng-model=user.facebook> </div> <div class=form-group> <label class=control-label for=google>Google:</label> <input type=text name=google id=google class=form-control ng-model=user.google> </div> </div> <div class=col-sm-6> <div class=form-group>  </div> <div class=form-group> <label class=control-label for=file>Avatar:{{imgUrl + user.account.avatar}}</label> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles ngf-resize=\"{width: 200, height: 200, centerCrop: true}\" style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{imgUrl + user.account.avatar}}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> </div> <div class=\"form-group col-md-12\" ng-show=\"!user.permissions.is_admin || !user.permissions.is_editor\"> <label class=control-label>Edition:</label> <oi-select name=editions oi-options=\"item.name for item in editions track by item._id\" ng-model=user.account.editions placeholder=\"Select writer Editions\" multiple=multiple></oi-select> </div> <div class=col-sm-12> <div class=\"form-group pull-right\"> <button type=submit class=\"btn btn-primary\">{{localizedMessages.get('update')}}</button> </div> </div> </div> </form> <script type=text/ng-template id=changePassword.tpl.html> <form novalidate name=\"passwordForm\" ng-submit=\"submit(data)\">\r\n    <div class=\"modal-header\">\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span></button>\r\n      <h3 class=\"modal-title\">{{localizedMessages.get('change-password')}}</h3>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n          <div class=\"form-group\" ng-class=\"{'has-error': !passwordForm.password.$valid && passwordForm.password.$touched}\">\r\n              <label class=\"control-label\" for=\"password\">Password:</label>\r\n              <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"data.password\" required server-error>\r\n              <span class=\"help-block\" ng-show=\"passwordForm.password.$error.server\" ng-repeat=\"message in passwordForm.password.$error.server\">{{message}}</span>\r\n          </div>\r\n          <div class=\"form-group\" ng-class=\"{'has-error': !passwordForm.confirm_password.$valid && passwordForm.confirm_password.$touched}\">\r\n              <label class=\"control-label\" for=\"confirm_password\">Confirm password:</label>\r\n              <input type=\"password\" name=\"confirm_password\" class=\"form-control\" ng-model=\"data.confirm_password\" required server-error>\r\n              <span class=\"help-block\" ng-show=\"passwordForm.confirm_password.$error.server\" ng-repeat=\"message in passwordForm.confirm_password.$error.server\">{{message}}</span>\r\n          </div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <div class=\"form-group\">\r\n          <button type=\"submit\" class=\"btn btn-primary btn-update\">{{localizedMessages.get('update')}}</button>\r\n      </div>\r\n    </div>\r\n  </form> </script> <script type=text/ng-template id=changeLogin.tpl.html> <form novalidate name=\"loginForm\" ng-submit=\"submit(data)\">\r\n    <div class=\"modal-header\">\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span></button>\r\n      <h3 class=\"modal-title\">{{localizedMessages.get('change-login')}}</h3>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <div class=\"form-group\" ng-class=\"{'has-error': !loginForm.username.$valid && loginForm.username.$touched}\">\r\n        <label class=\"control-label\" for=\"username\">Username:</label>\r\n        <input type=\"text\" name=\"username\" class=\"form-control\" ng-model=\"data.username\" required server-error>\r\n        <span class=\"help-block\" ng-show=\"loginForm.username.$error.server\" ng-repeat=\"message in loginForm.username.$error.server\">{{message}}</span>\r\n      </div>\r\n      <div class=\"form-group\" ng-class=\"{'has-error': !loginForm.email.$valid && loginForm.email.$touched}\">\r\n        <label class=\"control-label\" for=\"email\">Email:</label>\r\n        <input type=\"text\" name=\"email\" class=\"form-control\" ng-model=\"data.email\" required server-error>\r\n        <span class=\"help-block\" ng-show=\"loginForm.email.$error.server\" ng-repeat=\"message in loginForm.email.$error.server\">{{message}}</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <div class=\"form-group\">\r\n          <button type=\"submit\" class=\"btn btn-primary btn-update\">Update</button>\r\n      </div>\r\n    </div>\r\n  </form> </script> ";

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account.settings.social.facebook', ['security']);
	angular.module('account.settings.social.facebook').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/account/settings/facebook/callback', {
	    resolve: {
	      connect: ['$log', '$q', '$location', '$route', 'security', function ($log, $q, $location, $route, security) {
	        var params = $route.current.params;
	        var search = {};
	        var promise = security.socialConnect('facebook', params).then(function (data) {
	          if (data.success) {
	            search.success = 'true';
	          } else {
	            search.success = 'false';
	            search.reason = data.errors[0];
	          }
	          return $q.reject();
	        }).catch(function () {
	          search.provider = 'facebook';
	          search.success = search.success || 'false';
	          $location.search({}); //remove search param "code" added by facebook
	          $location.search(search);
	          $location.path('/account/settings');
	          return $q.reject();
	        });
	        return promise;
	      }]
	    },
	    reloadOnSearch: false
	  });
	}]);

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account.settings.social.google', ['security']);
	angular.module('account.settings.social.google').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/account/settings/google/callback', {
	    resolve: {
	      connect: ['$log', '$q', '$location', '$route', 'security', function ($log, $q, $location, $route, security) {
	        var params = $route.current.params;
	        var search = {};
	        var promise = security.socialConnect('google', params).then(function (data) {
	          if (data.success) {
	            search.success = 'true';
	          } else {
	            search.success = 'false';
	            search.reason = data.errors[0];
	          }
	          return $q.reject();
	        }).catch(function () {
	          search.provider = 'google';
	          search.success = search.success || 'false';
	          $location.search({}); //remove search param "code" added by google
	          $location.search(search);
	          $location.path('/account/settings');
	          return $q.reject();
	        });
	        return promise;
	      }]
	    },
	    reloadOnSearch: false
	  });
	}]);

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account.settings.social.twitter', ['security']);
	angular.module('account.settings.social.twitter').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/account/settings/twitter/callback', {
	    resolve: {
	      connect: ['$log', '$q', '$location', '$route', 'security', function ($log, $q, $location, $route, security) {
	        var params = $route.current.params;
	        var search = {};
	        var promise = security.socialConnect('twitter', params).then(function (data) {
	          if (data.success) {
	            search.success = 'true';
	          } else {
	            search.success = 'false';
	            search.reason = data.errors[0];
	          }
	          return $q.reject();
	        }).catch(function () {
	          search.provider = 'twitter';
	          search.success = search.success || 'false';
	          $location.search({}); //remove search param "code" added by twitter
	          $location.search(search);
	          $location.path('/account/settings');
	          return $q.reject();
	        });
	        return promise;
	      }]
	    },
	    reloadOnSearch: false
	  });
	}]);

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account.settings.social', ['account.settings.social.google', 'account.settings.social.facebook', 'account.settings.social.twitter']);

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	function CarouselTags(adminResource) {
	  this.waitCarouselTags = true;
	  this.data = [];
	  this.api = adminResource;
	  this.results = null;
	  this.error = null;
	
	  this.api.searchTags({
	    viewAsCarousel: true
	  }).then(function (data) {
	    if (data.data) {
	      data.data.forEach(this.push.bind(this));
	    }
	    this.waitCarouselTags = false;
	  }.bind(this), function (e) {
	    console.error(e);
	    this.waitCarouselTags = false;
	  }.bind(this));
	}
	
	CarouselTags.prototype.parse = function (tag) {
	  return {
	    sefriendly: tag.sefriendly,
	    name: tag.name
	  };
	};
	
	CarouselTags.prototype.save = function () {
	  this.waitCarouselTags = true;
	  this.error = null;
	
	  this.api.saveCarouselTags(this.data.map(function (t) {
	    return t.sefriendly;
	  })).then(function (data, err) {
	    if (err) {
	      this.error = err;
	    } else if (!data) {
	      this.error = 'error save data';
	    } else {
	      this.results = data;
	    }
	    this.waitCarouselTags = false;
	  }.bind(this), function (e) {
	    console.error(e);
	    this.error = e;
	    this.waitCarouselTags = false;
	  }.bind(this));
	};
	
	CarouselTags.prototype.push = function (tag) {
	  this.data.push(this.parse(tag));
	};
	
	CarouselTags.prototype.array = function () {
	  return this.data;
	};
	
	CarouselTags.prototype.set = function (tag) {
	  var index = this.data.findIndex(function (t) {
	    return t.sefriendly === tag.sefriendly;
	  });
	
	  if (index >= 0) {
	    this.data.splice(index, 1);
	  } else {
	    this.push(tag);
	  }
	};
	
	CarouselTags.prototype.isInArray = function (tag) {
	  if (tag.sefriendly) {
	    return this.data.some(function (t) {
	      return t.sefriendly === tag.sefriendly;
	    });
	  }
	  return false;
	};
	
	module.exports = CarouselTags;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account.tags', ['account.tags.index', 'account.tags.add', 'account.tags.detail']);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var countries = __webpack_require__(161);
	angular.module('account.tags.add', ['security.authorization', 'services.utility', 'services.adminResource', 'services.localizedMessages', 'directives.serverError', 'resources.Tag', 'ui.bootstrap.dropdown', 'services.formErrors', 'ngFileUpload']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.tags.add', {
	    url: '/add',
	    title: 'Account Tags / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(196),
	        controller: 'AccountTagAddCtrl'
	      }
	    },
	    resolve: {
	      user: ["User", "$state", "$location", function (User, $state, $location) {
	
	        return User.current(function (user) {
	          if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
	            return user;
	          }
	          return $state.go('unauthorized');
	        }).$promise;
	      }]
	    }
	  });
	}]).controller('AccountTagAddCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "Tag", "formErrors", "growl", "dateFilter", "Upload", "localizedMessages", "APP_IMG_URLS", function ($scope, $route, $location, $log, utility, adminResource, Tag, formErrors, growl, dateFilter, Upload, localizedMessages, APP_IMG_URLS) {
	  $scope.localizedMessages = localizedMessages;
	  var slugify = __webpack_require__(197);
	  $scope.dataLoaded = true;
	  $scope.imgUrl = APP_IMG_URLS.base;
	
	  $scope.countries = [];
	  _.forIn(countries, function (value, key) {
	    $scope.countries.push({
	      _id: key,
	      name: value
	    });
	  });
	
	  $scope.data = {
	    avatar_url: null,
	    big_avatar_url: null
	  };
	
	  $scope.tag = {
	    avatar: "",
	    big_avatar: "",
	    bios: [{
	      bio: "",
	      rol: "",
	      language: ""
	    }]
	  };
	
	  $scope.$watch('avatar', function (file) {
	    if (!file) return;
	    $scope.uploadAvatar(file);
	  });
	  $scope.$watch('big_avatar', function (file) {
	    if (!file) return;
	    $scope.uploadBigAvatar(file);
	  });
	
	  $scope.uploadAvatar = function (file) {
	    $scope.avatar_uploading = true;
	    $scope.tag.avatar = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.avatar_uploading = false;
	      $scope.tag.avatar = resp.data.filename;
	      $scope.data.avatar_url = APP_IMG_URLS.base + resp.data.filename;
	    }, function (resp) {
	      $scope.avatar_uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.uploadBigAvatar = function (file) {
	    $scope.big_avatar_uploading = true;
	    $scope.tag.big_avatar = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.big_avatar_uploading = false;
	      $scope.tag.big_avatar = resp.data.filename;
	      $scope.data.big_avatar_url = APP_IMG_URLS.base + resp.data.filename;
	    }, function (resp) {
	      $scope.big_avatar_uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.generateThumb = function (file, rejFile) {
	    if (file === null && rejFile === undefined) {
	      growl.info('Max image size is 10MB!', 3);
	    }
	  };
	
	  $scope.addNewChoice = function ($event) {
	    $event.preventDefault();
	    var newBio = {
	      bio: "",
	      rol: "",
	      language: ""
	    };
	    $scope.tag.bios.push(newBio);
	  };
	  $scope.closeDetailAlert = function () {
	    $scope.detailAlerts = [];
	  };
	
	  $scope.removeChoice = function (index, $event) {
	    $event.preventDefault();
	    $scope.tag.bios.splice(index, 1);
	  };
	
	  $scope.submit = function () {
	    var oficialsave = 0;
	    if ($scope.tag.oficial) {
	      oficialsave = 1;
	    }
	    var data = angular.copy($scope.tag);
	    data.sefriendly = slugify(data.name);
	    data.oficial = oficialsave;
	    data.place = {};
	    data.place.country = data.country ? data.country.name : "";
	    data.place.city = data.city;
	    data.start_date = dateFilter(data.start_date, 'yyyy-MM-dd');
	    data.end_date = dateFilter(data.end_date, 'yyyy-MM-dd');
	    var nolang = data.bios.filter(function (item) {
	      return !item.language;
	    });
	    if (nolang.length > 0) {
	      $scope.detailAlerts = [];
	      $scope.detailAlerts.push({
	        type: 'danger',
	        msg: 'Missing language'
	      });
	    } else {
	      $scope.dataLoaded = false;
	      Tag.save(data, function (result) {
	        $scope.dataLoaded = true;
	        growl.info('Tag saved!');
	        $location.path('/account/tags/edit/' + result._id);
	      }, formErrors.growlErrors);
	    }
	  };
	}]);

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = "<div class=loading ng-hide=dataLoaded></div> <div class=row id=admin-tags-detail> <div class=col-xs-12> <div class=page-header> <h1><a href=/admin/tags>{{localizedMessages.get('account.tags')}}</a> / Add new</h1> </div> <form novalidate=\"\" name=detailForm ng-submit=submit()> <div class=row> <alert ng-repeat=\"alert in detailAlerts\" type=\"{{ alert.type }}\" close=closeDetailAlert($index)>{{ alert.msg }}</alert> <div class=col-xs-6> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.name)}\"> <label class=control-label for=name>{{localizedMessages.get('name')}}:</label> <input type=text name=name id=name class=form-control ng-model=tag.name required> </div> <div class=form-group ng-hide=hasCountry()> <label class=control-label for=country>{{localizedMessages.get('country')}}:</label> <oi-select oi-options=\"country.name for country in countries track by country._id\" ng-model=tag.country placeholder=\"\" required> </oi-select> </div> <div class=form-group> <label class=control-label for=city>{{localizedMessages.get('city')}}:</label> <input type=text name=city id=city class=form-control ng-model=tag.city> </div> <div class=row> <div class=col-xs-6> <div class=\"form-group datetime\"> <label for=start-date>{{localizedMessages.get('start-date')}}</label> <div class=dropdown> <a class=dropdown-toggle id=start-date-dropdown role=button data-toggle=dropdown data-target=# href=#> <div class=input-group> <input type=text class=form-control data-ng-model=tag.start_date> <span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> </div> </a> <ul class=dropdown-menu role=menu aria-labelledby=dLabel> <datetimepicker data-ng-model=tag.start_date data-datetimepicker-config=\"{ dropdownSelector: '#start-date-dropdown', modelType: 'YYYY-MM-DD' ,minView : 'day'}\"/> </ul> </div> </div> </div> <div class=col-xs-6> <div class=\"form-group datetime\"> <label for=end-date>{{localizedMessages.get('end-date')}}</label> <div class=dropdown> <a class=dropdown-toggle id=end-date-dropdown role=button data-toggle=dropdown data-target=# href=#> <div class=input-group> <input type=text class=form-control data-ng-model=tag.end_date> <span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> </div> </a> <ul class=dropdown-menu role=menu aria-labelledby=dLabel> <datetimepicker data-ng-model=tag.end_date data-datetimepicker-config=\"{ dropdownSelector: '#end-date-dropdown', modelType: 'YYYY-MM-DD' ,minView : 'day'}\"/> </ul> </div> </div> </div> </div> </div> <div class=col-xs-6> <div class=form-group style=margin-top:25px> <label class=control-label for=oficial>{{localizedMessages.get('oficial')}}:</label> <toggle-switch ng-model=tag.oficial class=switch-primary> <toggle-switch> </toggle-switch></toggle-switch></div> <div class=form-group> <label class=control-label for=big_avatar>{{localizedMessages.get('big-avatar')}}:</label> <figure class=article-image ng-class=\"{'no-image': !data.big_avatar_url}\" type=file id=big_avatar ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=big_avatar name=big_avatar accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles ngf-validate=\"{size: {min: 10, max: '10MB'}}\" ngf-resize=\"{width: 1280}\" ngf-resize-if=\"$width > 1280\" ngf-change=\"generateThumb($file, $rejectedFile)\" style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{ data.big_avatar_url }}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=big_avatar_uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> <div class=form-group> <label class=control-label for=avatar>{{localizedMessages.get('avatar')}}:</label> <figure class=article-image ng-class=\"{'no-image': !data.avatar_url}\" type=file id=avatar ng-model=avatar name=avatar ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop accept=image/* required ngf-model-invalid=errorFiles ngf-resize=\"{width: 200, height: 200, centerCrop: true}\" style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{ data.avatar_url }}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=avatar_uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> </div> </div> <div class=row> <div class=col-xs-12> <button class=\"btn btn-primary pull-right\" ng-click=addNewChoice($event)>{{localizedMessages.get('add-new-bio-language')}} </button> </div> <div class=col-xs-12 ng-repeat=\"item in tag.bios \"> <div class=col-xs-6> <div class=form-group> <label class=control-label>{{localizedMessages.get('bio')}}:</label> <div ckeditor=ckOptions ng-model=item.bio ready=onReady()></div> </div> </div> <div class=col-xs-6> <div class=form-group> <label class=control-label>{{localizedMessages.get('role')}}:</label> <input type=text name=rol class=form-control ng-model=item.rol> </div> <div class=form-inline> <label class=control-label>{{localizedMessages.get('language')}}:</label> <input type=text name=lang class=form-control ng-model=item.language ng-required=required> <button class=\"btn btn-danger\" ng-click=removeChoice($index,$event)>{{localizedMessages.get('remove-language')}} </button> </div> </div> </div> </div> <div class=form-group> <button type=submit class=\"btn btn-primary\">{{localizedMessages.get('save')}}</button> </div> <alert ng-repeat=\"alert in detailAlerts\" type=\"{{ alert.type }}\" close=closeDetailAlert($index)>{{ alert.msg }}</alert> </form> </div> </div> ";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(198);
	var dasherize = __webpack_require__(202);
	var cleanDiacritics = __webpack_require__(203);
	
	module.exports = function slugify(str) {
	  return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(199);
	var defaultToWhiteSpace = __webpack_require__(200);
	var nativeTrim = String.prototype.trim;
	
	module.exports = function trim(str, characters) {
	  str = makeString(str);
	  if (!characters && nativeTrim) return nativeTrim.call(str);
	  characters = defaultToWhiteSpace(characters);
	  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
	};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/**
	 * Ensure some object is a coerced to a string
	 **/
	module.exports = function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var escapeRegExp = __webpack_require__(201);
	
	module.exports = function defaultToWhiteSpace(characters) {
	  if (characters == null)
	    return '\\s';
	  else if (characters.source)
	    return characters.source;
	  else
	    return '[' + escapeRegExp(characters) + ']';
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(199);
	
	module.exports = function escapeRegExp(str) {
	  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(198);
	
	module.exports = function dasherize(str) {
	  return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	
	var makeString = __webpack_require__(199);
	
	var from  = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž',
	  to    = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';
	
	from += from.toUpperCase();
	to += to.toUpperCase();
	
	to = to.split('');
	
	// for tokens requireing multitoken output
	from += 'ß';
	to.push('ss');
	
	
	module.exports = function cleanDiacritics(str) {
	  return makeString(str).replace(/.{1}/g, function(c){
	    var index = from.indexOf(c);
	    return index === -1 ? c : to[index];
	  });
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var countries = __webpack_require__(161);
	
	angular.module('account.tags.detail', ['security.authorization', 'services.utility', 'services.adminResource', 'directives.serverError', 'ui.bootstrap.dropdown', 'services.formErrors', 'ngFileUpload', 'services.localizedMessages']);
	
	angular.module('account.tags.detail').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.tags.edit', {
	    url: '/edit/:id',
	    title: 'Account Tags / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(205),
	        controller: 'AccountTagsDetailCtrl',
	        resolve: {
	          tag: ["$stateParams", "adminResource", function ($stateParams, adminResource) {
	            return adminResource.findTag($stateParams.id);
	          }],
	          roles: ["adminResource", function (adminResource) {
	            return adminResource.searchRoles({});
	          }],
	          languages: ["adminResource", function (adminResource) {
	            return adminResource.getLanguages();
	          }]
	        }
	      }
	    }
	  });
	}]);
	
	angular.module('account.tags.detail').controller('AccountTagsDetailCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "tag", "Tag", "formErrors", "growl", "dateFilter", "Upload", "user", "roles", "languages", "localizedMessages", "APP_IMG_URLS", function ($scope, $route, $location, $log, utility, adminResource, tag, Tag, formErrors, growl, dateFilter, Upload, user, roles, languages, localizedMessages, APP_IMG_URLS) {
	  $scope.localizedMessages = localizedMessages;
	  var slugify = __webpack_require__(152);
	
	  $scope.dataLoaded = true;
	  $scope.imgUrl = APP_IMG_URLS.base;
	  $scope.mergeTags = [];
	
	  $scope.countries = [];
	  _.forIn(countries, function (value, key) {
	    $scope.countries.push({
	      _id: key,
	      name: value
	    });
	  });
	
	  $scope.rolesList = roles.data ? roles.data.map(function (role) {
	    return {
	      _id: role._id,
	      role_name: role.name,
	      role_type: role.type
	      //role_sport: role.sport,
	    };
	  }) : [];
	  $scope.languagesList = !!languages ? languages : [];
	
	  $scope.$on('$locationChangeStart', function (event, next, current) {
	    var answer = confirm("Are you sure you want to navigate away from this page");
	    if (!answer) {
	      event.preventDefault();
	    }
	  });
	
	  $scope.$watch('avatar', function (file) {
	    if (!file) return;
	    $scope.uploadAvatar(file);
	  });
	  $scope.$watch('big_avatar', function (file) {
	    if (!file) return;
	    $scope.uploadBigAvatar(file);
	  });
	
	  $scope.uploadAvatar = function (file) {
	    $scope.avatar_uploading = true;
	    $scope.tag.avatar = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.avatar_uploading = false;
	      $scope.tag.avatar = resp.data.filename;
	      $scope.data.avatar_url = APP_IMG_URLS.base + resp.data.filename;
	    }, function (resp) {
	      $scope.avatar_uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.uploadBigAvatar = function (file) {
	    $scope.big_avatar_uploading = true;
	    $scope.tag.big_avatar = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.big_avatar_uploading = false;
	      $scope.tag.big_avatar = resp.data.filename;
	      $scope.data.big_avatar_url = APP_IMG_URLS.base + resp.data.filename;
	    }, function (resp) {
	      $scope.big_avatar_uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.generateThumb = function (file, rejFile) {
	    if (file === null && rejFile === undefined) {
	      growl.info('Max image size is 10MB!', 3);
	    }
	  };
	
	  $scope.addNewChoice = function ($event) {
	    $event.preventDefault();
	    var newBio = {
	      bio: "",
	      rol: "",
	      language: ""
	    };
	    if (!$scope.tag.bios) {
	      $scope.tag.bios = [];
	    }
	    $scope.tag.bios.push(newBio);
	  };
	
	  $scope.removeChoice = function (index, $event) {
	    $event.preventDefault();
	    $scope.tag.bios.splice(index, 1);
	  };
	  $scope.closeDetailAlert = function () {
	    $scope.detailAlerts = [];
	  };
	
	  // local vars
	  var createDraftIfNotExists = function createDraftIfNotExists(tag) {
	    if (!$scope.checkIsDraftExists()) {
	      // admin/user has no drafts
	      var countryIndex = _.findIndex($scope.countries, { name: tag.place.country });
	
	      if (!!tag.drafts && tag.drafts.length > 4) {
	        alert("Sorry, this tag already has maximum number of proposals. Please, try again later.");
	        $scope.showOriginalVersion = true;
	        return $scope.tagRoot;
	      }
	
	      return {
	        avatar: !!tag.avatar ? tag.avatar : "",
	        big_avatar: !!tag.big_avatar ? tag.big_avatar : "",
	        bios: !!tag.bios ? angular.copy(tag.bios) : [],
	        city: !!tag.place && !!tag.place.city ? tag.place.city : "",
	        country: $scope.countries[countryIndex],
	        created_at: new Date().toISOString(), //dateFilter(new Date(), 'yyyy-MM-dd HH:mm'),
	        name: !!tag.name ? tag.name : "",
	        shortName: '',
	        officialName: '',
	        oficial: !!tag.oficial ? tag.oficial : 0,
	        place: {
	          city: !!tag.place && !!tag.place.city ? tag.place.city : "",
	          country: !!tag.place && !!tag.place.country ? tag.place.country : ""
	        },
	        sefriendly: !!tag.sefriendly ? tag.sefriendly : "",
	        updated_at: !!tag.updated_at ? tag.updated_at : "",
	        start_date: tag.start_date,
	        end_date: tag.end_date,
	        organization: angular.isArray(tag.organization) ? tag.organization.map(function (e) {
	          return Object.assign(e, { text: e.name });
	        }) : [],
	        event: angular.isArray(tag.event) ? tag.event.map(function (e) {
	          return Object.assign(e, { text: e.name });
	        }) : [],
	        role: tag.role,
	        draftProposer: user.username
	      };
	    } else {
	      var id = _.findIndex(tag.drafts, { draftProposer: user.username });
	      if (!!$scope.draftProposer) {
	        id = _.findIndex(tag.drafts, { draftProposer: $scope.draftProposer });
	      }
	      if (!!tag.drafts[id].place) {
	        var countryIndex = _.findIndex($scope.countries, { name: tag.drafts[id].place.country });
	        tag.drafts[id].city = !!tag.drafts[id].place.city ? tag.drafts[id].place.city : "";
	        tag.drafts[id].country = !!tag.drafts[id].place.country ? $scope.countries[countryIndex] : "";
	      }
	      return tag.drafts[id];
	    }
	  };
	  var deserializeData = function deserializeData(data) {
	    deserializeAccountTag(data.record || data);
	  };
	  var deserializeAccountTag = function deserializeAccountTag(data) {
	    $scope.tagRoot = data;
	    var countryIndex = _.findIndex($scope.countries, { name: data.place.country });
	    $scope.tagRoot.country = $scope.countries[countryIndex];
	    $scope.tagRoot.city = data.place.city;
	    $scope.tagRoot.organization = angular.isArray(data.organization) ? _.uniqBy(data.organization, '_id').map(function (e) {
	      return Object.assign(e, { text: e.name });
	    }) : [];
	    $scope.tagRoot.event = angular.isArray(data.event) ? _.uniqBy(data.event, '_id').map(function (e) {
	      return Object.assign(e, { text: e.name });
	    }) : [];
	    $scope.tagRoot.role = data.role;
	
	    if (!$scope.isAdmin()) {
	      $scope.showOriginalVersion = false;
	      $scope.tag = createDraftIfNotExists(data);
	    } else {
	      $scope.tag = $scope.tagRoot;
	    }
	
	    $scope.data = {
	      avatar_url: APP_IMG_URLS.base + $scope.tag.avatar,
	      big_avatar_url: APP_IMG_URLS.base + $scope.tag.big_avatar
	    };
	  };
	  $scope.submit = function () {
	    if ($scope.showOriginalVersion) {
	      var oficialsave = 0;
	      if ($scope.tag.oficial) {
	        oficialsave = 1;
	      }
	      data = angular.copy($scope.tag);
	      data.sefriendly = slugify(data.name);
	
	      data.oficial = oficialsave;
	      data.place = {};
	      data.place.country = data.country ? data.country.name : "";
	      data.place.city = data.city;
	      data.start_date = dateFilter(data.start_date, 'yyyy-MM-dd');
	      data.end_date = dateFilter(data.end_date, 'yyyy-MM-dd');
	
	      var nolang = data.bios.filter(function (item) {
	        return !item.language;
	      });
	      if (nolang.length > 0) {
	        $scope.detailAlerts = [];
	        $scope.detailAlerts.push({
	          type: 'danger',
	          msg: 'Missing language'
	        });
	      } else {
	        $scope.dataLoaded = false;
	
	        // console.log( '>>>', data );
	        Tag.update(data, function (result) {
	          // console.log( '>>>', result);
	          $scope.dataLoaded = true;
	          growl.info('Tag saved!');
	        }, formErrors.growlErrors);
	      }
	    } else {
	      var data = angular.copy($scope.tagRoot); // published tag must not change
	      data.hasDrafts = true;
	      var id = _.findIndex(data.drafts, { draftProposer: $scope.isAdmin() ? $scope.draftProposer : user.username });
	      if (id < 0) {
	        id = data.drafts.push(angular.copy($scope.tag)) - 1; // save draft as property of published tag
	      } else {
	        data.drafts[id] = $scope.tag;
	      }
	      //data.draftProposer = user.username; // this propertiy is assigned on draft creation
	      data.drafts[id].sefriendly = slugify(data.name);
	      data.drafts[id].oficial = data.drafts[id].oficial ? 1 : 0;
	      data.drafts[id].place = {};
	      data.drafts[id].place.country = data.drafts[id].country ? data.drafts[id].country.name : "";
	      data.drafts[id].place.city = data.drafts[id].city;
	      data.drafts[id].start_date = dateFilter(data.drafts[id].start_date, 'yyyy-MM-dd');
	      data.drafts[id].end_date = dateFilter(data.drafts[id].end_date, 'yyyy-MM-dd');
	      data.drafts[id].updated_at = new Date().toISOString(); //dateFilter(new Date(), 'yyyy-MM-dd HH:mm');
	
	      var nolang = data.drafts[id].bios.filter(function (item) {
	        return !item.language;
	      });
	      if (nolang.length > 0) {
	        $scope.detailAlerts = [];
	        $scope.detailAlerts.push({
	          type: 'danger',
	          msg: 'Missing language'
	        });
	      } else {
	        $scope.dataLoaded = false;
	
	        Tag.update(data, function (result) {
	          $scope.dataLoaded = true;
	          // update client's data indicating successfull creation of tag draft
	          $scope.tagRoot.hasDrafts = true;
	          $scope.tagRoot.drafts[id] = $scope.tag;
	          $scope.tagRoot.drafts[id].created_at = $scope.tag.created_at = data.drafts[id].created_at;
	          $scope.tagRoot.drafts[id].draftProposer = result.drafts[id].draftProposer;
	          $scope.checkIsDraftExists(); // update draft related variables
	          growl.info('Tag saved!');
	        }, formErrors.growlErrors);
	      }
	    }
	  };
	
	  $scope.delete = function (tag) {
	    if ($scope.showOriginalVersion) {
	      if (!confirm('Are you sure you want to delete this tag?')) {
	        return;
	      }
	      Tag.delete({ id: tag._id }, function (result) {
	        setTimeout(function () {
	          growl.info('Tag removed!');
	          $location.path('/account/tags');
	        }, 1000);
	      }, formErrors.growlErrors);
	    } else {
	      if (!confirm('Are you sure you want to delete this draft tag?')) {
	        return;
	      }
	      var data = angular.copy($scope.tagRoot);
	      data.hasDrafts = false;
	      var id = _.findIndex(data.drafts, { draftProposer: $scope.draftProposer });
	      //data.draftProposer = user.username;
	      data.drafts.splice(id, 1);
	
	      //data.proposer = user.username;
	      $scope.dataLoaded = false;
	
	      Tag.update(data, function (result) {
	        $scope.dataLoaded = true;
	        // update client's data indicating successfull deletion of tag draft
	        $scope.tagRoot.hasDrafts = false;
	        $scope.tagRoot.drafts.splice(id, 1);
	        $scope.checkIsDraftExists(); // update draft related variables
	        $scope.showOriginalVersion = true;
	        $scope.switchViewMode(true);
	        growl.info('Draft is removed!');
	      }, formErrors.growlErrors);
	    }
	  };
	  $scope.doHumanReadableDateString = function (d) {
	    return dateFilter(d, 'yyyy-MM-dd HH:mm');
	  };
	
	  $scope.showOriginalVersion = true;
	  $scope.isDraftExists = false;
	  $scope.draftProposedString = "";
	  $scope.draftProposer = false;
	
	  /** checkIsDraftExists
	   * check tagRoot for defined draft subdocument, draft.name and valid draft.created_at date
	   */
	  $scope.checkIsDraftExists = function () {
	    var id = _.findIndex($scope.tagRoot.drafts, { draftProposer: user.username });
	    var $s = $scope;
	    $s.isDraftExists = $s.isAdmin() ? $s.tagRoot.hasDrafts && $s.tagRoot.drafts.length > 0 : id >= 0; //!(Object.keys(tag.draft).length === 0 && tag.draft.constructor === Object)
	    return $scope.isDraftExists;
	  };
	
	  $scope.switchViewMode = function (showOriginalVersion, draftProposer) {
	    $scope.showOriginalVersion = showOriginalVersion;
	    $scope.draftProposer = draftProposer;
	    if ($scope.showOriginalVersion) {
	      $scope.tag = $scope.tagRoot;
	    } else {
	      var draft = createDraftIfNotExists($scope.tagRoot);
	      if ($scope.isAdmin()) {
	        if (!!$scope.tag.drafts && !$scope.tag.draftProposer) {
	          // save original only if we switch from original to draft
	          $scope.tagRoot = $scope.tag;
	        }
	      } else {
	        $scope.tagRoot = $scope.tag;
	      }
	      $scope.tag = draft;
	      $scope.data = {
	        avatar_url: APP_IMG_URLS.base + $scope.tag.avatar,
	        big_avatar_url: APP_IMG_URLS.base + $scope.tag.big_avatar
	      };
	      $scope.tag.organization = angular.isArray(draft.organization) ? _.uniqBy(draft.organization, '_id').map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [];
	      $scope.tag.event = angular.isArray(draft.event) ? _.uniqBy(draft.event, '_id').map(function (e) {
	        return Object.assign(e, { text: e.name });
	      }) : [];
	    }
	  };
	  $scope.canEdit = function () {
	    return user.permissions.is_admin || !$scope.showOriginalVersion;
	  };
	  $scope.isAdmin = function () {
	    return user.permissions.is_admin;
	  };
	
	  $scope.applyDraft = function (tag) {
	    if ($scope.isAdmin()) {
	      if ($scope.tagRoot.drafts.length > 0 && confirm("Are you sure you want to apply this draft and delete all others")) {
	        // save original
	        $scope.tagRoot.drafts = [{
	          avatar: $scope.tagRoot.avatar,
	          big_avatar: $scope.tagRoot.big_avatar,
	          city: $scope.tagRoot.city,
	          name: $scope.tagRoot.name,
	          shortName: $scope.tagRoot.shortName,
	          officialName: $scope.tagRoot.officialName,
	          oficial: $scope.tagRoot.oficial,
	          sefriendly: $scope.tagRoot.sefriendly,
	          updated_at: $scope.tagRoot.updated_at,
	          created_at: $scope.tagRoot.created_at,
	          start_date: $scope.tagRoot.start_date,
	          end_date: $scope.tagRoot.end_date,
	          place: angular.copy($scope.tagRoot.place),
	          country: $scope.tagRoot.country,
	          bios: angular.copy($scope.tagRoot.bios),
	          organization: angular.copy($scope.tagRoot.organization),
	          event: angular.copy($scope.tagRoot.event),
	          role: $scope.tagRoot.role,
	          draftProposer: user.username
	        }];
	        $scope.tag._id = $scope.tagRoot._id; // ensure tagRoot's id will not change after submit
	        $scope.tagRoot.avatar = $scope.tag.avatar;
	        $scope.tagRoot.big_avatar = $scope.tag.big_avatar;
	        $scope.tagRoot.city = $scope.tag.city;
	        $scope.tagRoot.name = $scope.tag.name;
	        $scope.tagRoot.shortName = $scope.tag.shortName;
	        $scope.tagRoot.officialName = $scope.tag.officialName;
	        $scope.tagRoot.oficial = $scope.tag.oficial;
	        $scope.tagRoot.sefriendly = $scope.tag.sefriendly;
	        $scope.tagRoot.updated_at = $scope.tag.updated_at;
	        $scope.tagRoot.created_at = $scope.tag.created_at;
	        $scope.tagRoot.start_date = $scope.tag.start_date;
	        $scope.tagRoot.end_date = $scope.tag.end_date;
	        $scope.tagRoot.place = angular.copy($scope.tag.place);
	        $scope.tagRoot.country = $scope.tag.country;
	        $scope.tagRoot.bios = angular.copy($scope.tag.bios);
	        $scope.tagRoot.organization = angular.copy($scope.tag.organization);
	        $scope.tagRoot.event = angular.copy($scope.tag.event);
	        $scope.tagRoot.role = $scope.tag.role;
	        $scope.showOriginalVersion = true;
	
	        $scope.submit();
	      }
	    }
	  };
	
	  $scope.loadOrganizations = function (query) {
	    return adminResource.searchTags({ type: 'organization' }).then(function (organizationTags) {
	      if (!organizationTags) return [];
	      var searchName = query.toLowerCase();
	      return organizationTags.data.filter(function (o) {
	        var orgName = o.name.toLowerCase();
	        var tagName = $scope.tag.name.toLowerCase();
	        return orgName !== tagName && orgName.indexOf(searchName) > -1;
	      }).map(function (o) {
	        return {
	          _id: o._id,
	          name: o.name
	        };
	      });
	    });
	  };
	
	  $scope.loadEvents = function (query) {
	    return adminResource.searchTags({ type: 'event' }).then(function (eventTags) {
	      if (!eventTags) return [];
	      var searchName = query.toLowerCase();
	      return eventTags.data.filter(function (e) {
	        var evntName = e.name.toLowerCase();
	        var tagName = $scope.tag.name.toLowerCase();
	        return evntName !== tagName && evntName.indexOf(searchName) > -1;
	      }).map(function (e) {
	        return {
	          _id: e._id,
	          name: e.name
	        };
	      });
	    });
	  };
	
	  $scope.loadTags = function (query) {
	    return Tag.search({ q: query }).$promise.then(function (tags) {
	      if (!tags) return [];
	      return tags.map(function (tag) {
	        return {
	          _id: tag._id,
	          text: tag.nametag,
	          name: tag.nametag,
	          oficial: tag.oficial,
	          sefriendly: tag.name
	        };
	      });
	    });
	  };
	
	  $scope.runMergeTag = function (tags) {
	    $scope.dataLoaded = false;
	    Tag.mergeTags({
	      tagId: $scope.tag._id,
	      tags: $scope.mergeTags.map(function (t) {
	        return t._id;
	      })
	    }, function () {
	      $scope.dataLoaded = true;
	      $scope.mergeTags = [];
	    }, function (e) {
	      $scope.dataLoaded = true;
	      console.error(e);
	    });
	  };
	
	  deserializeData(tag);
	  $scope.checkIsDraftExists();
	}]);

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports = "<style>#admin-tags-detail tags-input{padding:0;height:auto}#admin-tags-detail tags-input .tags .input{float:right}.tag-merge{border-top:1px solid #eee;border-bottom:1px solid #eee;width:100%}.tag-merge .container{margin:20px 0;display:flex;flex-direction:column;align-items:flex-start;max-width:800px}.tag-merge .container tags-input{margin:10px 0;width:100%}.tag-merge .container tags-input .tags .input{float:left!important}.please-wait{position:fixed;top:0;bottom:0;right:0;left:0;opacity:50%;z-index:9999;background-color:#000;display:flex;justify-content:center;align-items:center}</style> <div class=please-wait ng-if=!dataLoaded> <svg x=0px y=0px width=100px height=100px viewBox=\"0 0 24 30\"> <rect x=0 y=10 width=4 height=10 fill=#FF6700 opacity=0.2> <animate attributeName=opacity attributeType=XML values=\"0.2; 1; .2\" begin=0s dur=0.6s repeatCount=indefinite /> <animate attributeName=height attributeType=XML values=\"10; 20; 10\" begin=0s dur=0.6s repeatCount=indefinite /> <animate attributeName=y attributeType=XML values=\"10; 5; 10\" begin=0s dur=0.6s repeatCount=indefinite /> </rect> <rect x=8 y=10 width=4 height=10 fill=#FF6700 opacity=0.2> <animate attributeName=opacity attributeType=XML values=\"0.2; 1; .2\" begin=0.15s dur=0.6s repeatCount=indefinite /> <animate attributeName=height attributeType=XML values=\"10; 20; 10\" begin=0.15s dur=0.6s repeatCount=indefinite /> <animate attributeName=y attributeType=XML values=\"10; 5; 10\" begin=0.15s dur=0.6s repeatCount=indefinite /> </rect> <rect x=16 y=10 width=4 height=10 fill=#FF6700 opacity=0.2> <animate attributeName=opacity attributeType=XML values=\"0.2; 1; .2\" begin=0.3s dur=0.6s repeatCount=indefinite /> <animate attributeName=height attributeType=XML values=\"10; 20; 10\" begin=0.3s dur=0.6s repeatCount=indefinite /> <animate attributeName=y attributeType=XML values=\"10; 5; 10\" begin=0.3s dur=0.6s repeatCount=indefinite /> </rect> </svg> </div> <div class=row id=admin-tags-detail> <div class=col-xs-12> <div class=page-header> <button class=\"btn btn-danger pull-right\" ng-click=delete(tag) ng-if=\"isAdmin() && isDraftExists\">Delete </button> <h1><a href=/account/tags>{{localizedMessages.get('tags')}}</a> / {{ tag.name }}</h1> </div> <div class=col-xs-12 ng-if=\"isAdmin() && isDraftExists\"> <div class=btn-group style=margin-top:25px ng-if=true> <label class=\"btn btn-success\" ng-class=\"{'active':!draftProposer}\" ng-click=\"switchViewMode(true, false)\">Original</label> <label class=\"btn btn-primary\" ng-class=\"{'active': draft.draftProposer == draftProposer}\" ng-repeat=\"draft in tagRoot.drafts\" ng-click=\"switchViewMode(false, draft.draftProposer)\" title=\"tag proposal\">{{draft.draftProposer}}</label> <button class=\"btn btn-warning pull-right\" ng-click=applyDraft(tag) ng-hide=showOriginalVersion>{{localizedMessages.get('apply-selected-draft')}} </button> </div> <div class=\"draft-info pull-right\"> <table> <tr> <td><b>{{localizedMessages.get('created-at')}}:</b></td> <td>{{doHumanReadableDateString(tag.created_at)}}</td> </tr> <tr> <td><b>{{localizedMessages.get('updated-at')}}:</b></td> <td>{{doHumanReadableDateString(tag.updated_at)}}</td> </tr> </table> </div> </div> <br> <form novalidate=\"\" name=detailForm> <div class=row> <div class=col-xs-6> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.name)}\"> <label class=control-label for=name>Name:</label> <input type=text name=name id=name class=form-control ng-model=tag.name required ng-disabled=!isAdmin()> <span class=help-block ng-show=\"showError(detailForm.name, 'required')\">{{localizedMessages.get('forms.field.required')}}</span> </div> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.officialName)}\"> <label class=control-label for=official-name>{{localizedMessages.get('official-name')}} > <span style=color:#999;margin-left:10px;font-size:12px;font-weight:300>{{localizedMessages.get('club-name-optional')}}</span></label> <input type=text name=official-name id=official-name class=form-control ng-model=tag.officialName required ng-disabled=!canEdit()> <span class=help-block ng-show=\"showError(detailForm.officialName, 'required')\">{{localizedMessages.get('forms.field.required')}}</span> </div> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.shortName)}\"> <label class=control-label for=short-name>{{localizedMessages.get('shortname')}} > <span style=color:#999;margin-left:10px;font-size:12px;font-weight:300>{{localizedMessages.get('score-carrousel-optional')}}</span></label> <input type=text name=short-name id=short-name class=form-control ng-model=tag.shortName required ng-disabled=!canEdit()> <span class=help-block ng-show=\"showError(detailForm.shortName, 'required')\">{{localizedMessages.get('forms.field.required')}}</span> </div> <div class=form-group ng-hide=hasCountry()> <label class=control-label for=country>{{localizedMessages.get('country')}}:</label> <oi-select oi-options=\"country.name for country in countries track by country._id\" ng-model=tag.country placeholder=\"\" required ng-disabled=!canEdit()> </oi-select> </div> <div class=form-group> <label class=control-label for=city>{{localizedMessages.get('city')}}:</label> <input type=text name=city id=city class=form-control ng-model=tag.city ng-disabled=!canEdit()> </div> <div class=row> <div class=col-xs-6> <div class=\"form-group datetime\"> <label for=start-date>{{localizedMessages.get('start-date')}}</label> <div class=dropdown> <a class=dropdown-toggle id=start-date-dropdown role=button data-toggle=dropdown data-target=# href=#> <div class=input-group> <input type=text class=form-control data-ng-model=tag.start_date ng-disabled=!canEdit()> <span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> </div> </a> <ul class=dropdown-menu role=menu aria-labelledby=dLabel> <datetimepicker data-ng-model=tag.start_date data-datetimepicker-config=\"{ dropdownSelector: '#start-date-dropdown', modelType: 'YYYY-MM-DD' ,minView : 'day'}\" ng-disabled=!canEdit() /> </ul> </div> </div> </div> <div class=col-xs-6> <div class=\"form-group datetime\"> <label for=end-date>{{localizedMessages.get('end-date')}}</label> <div class=dropdown> <a class=dropdown-toggle id=end-date-dropdown role=button data-toggle=dropdown data-target=# href=#> <div class=input-group> <input type=text class=form-control data-ng-model=tag.end_date ng-disabled=!canEdit()> <span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> </div> </a> <ul class=dropdown-menu role=menu aria-labelledby=dLabel> <datetimepicker data-ng-model=tag.end_date data-datetimepicker-config=\"{ dropdownSelector: '#end-date-dropdown', modelType: 'YYYY-MM-DD' ,minView : 'day'}\" ng-disabled=!canEdit() /> </ul> </div> </div> </div> </div> <form> <div class=form-group> <label class=control-label>{{localizedMessages.get('role')}}:</label> <select class=form-control ng-model=tag.role required ng-disabled=!canEdit() ng-options=\"role as role.role_name for role in rolesList | filter: {role_name: '!'+tag.name} track by role._id\"> </select> </div> </form> </div> <div class=col-xs-6> <div class=form-group style=margin-top:25px> <label class=control-label for=oficial>{{localizedMessages.get('official')}}:</label> <toggle-switch ng-model=tag.oficial class=switch-primary ng-disabled=!canEdit()> <toggle-switch> </toggle-switch></toggle-switch></div> <div class=form-group> <label class=control-label for=big_avatar>{{localizedMessages.get('big-avatar')}} <span style=color:#999;margin-left:10px;font-size:12px;font-weight:300>{{localizedMessages.get('big-avatar-helper')}}</span></label> <figure class=article-image ng-class=\"{'no-image': !data.big_avatar_url}\" type=file id=big_avatar ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=big_avatar name=big_avatar accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles ngf-validate=\"{size: {min: 10, max: '10MB'}}\" ngf-resize=\"{width: 1280}\" ngf-resize-if=\"$width > 1280\" ngf-change=\"generateThumb($file, $rejectedFile)\" ng-disabled=!canEdit() style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{ data.big_avatar_url }}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=big_avatar_uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> <div class=form-group> <label class=control-label for=avatar>{{localizedMessages.get('avatar')}} <span style=color:#999;margin-left:10px;font-size:12px;font-weight:300>{{localizedMessages.get('avatar-helper')}}</span></label> <figure class=article-image ng-class=\"{'no-image': !data.avatar_url}\" type=file id=avatar ng-model=avatar name=avatar ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop accept=image/* required ngf-model-invalid=errorFiles ngf-resize=\"{width: 200, height: 200, centerCrop: true}\" ng-disabled=!canEdit() style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{ data.avatar_url }}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=avatar_uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> </div> </div> <div class=row> <div class=col-xs-12> <button class=\"btn btn-primary pull-right\" type=button ng-click=addNewChoice($event) ng-if=canEdit()> {{localizedMessages.get('add-bio-language')}} </button> </div> <div class=col-xs-12 ng-repeat=\"item in tag.bios \"> <div class=col-xs-6> <div class=form-group> <label class=control-label>{{localizedMessages.get('bio')}}:</label> <div ckeditor=ckOptions ng-model=item.bio ready=onReady() contenteditable=!canEdit()></div> </div> </div> <div class=col-xs-6> <div class=form-inline> <label class=control-label>{{localizedMessages.get('language')}}:</label> <select class=form-control ng-model=item.language required ng-disabled=!canEdit()> <option ng-repeat=\"lang in languagesList\" ng-bind=lang.name value={{lang.tag}}></option> </select> <button class=\"btn btn-danger\" ng-click=removeChoice($index,$event) ng-disabled=!canEdit()>{{localizedMessages.get('remove-language')}} </button> </div> </div> </div> </div> <div class=form-group> <button type=button class=\"btn btn-primary\" ng-click=submit() ng-disabled=!canEdit()>{{localizedMessages.get('save')}}</button> </div> <alert ng-repeat=\"alert in detailAlerts\" type=\"{{ alert.type }}\" close=closeDetailAlert($index)>{{ alert.msg }} </alert> </form> <div class=tag-merge> <div class=container> <h3>{{localizedMessages.get('tag-merge')}}</h3> <span class=info>{{localizedMessages.get('tag-merge-helper')}}</span> <tags-input ng-model=mergeTags replace-spaces-with-dashes=false add-from-autocomplete-only=true> <auto-complete source=loadTags($query) debounce-delay=1 template=tag-item-template></auto-complete> </tags-input> <script type=text/ng-template id=tag-item-template> <div style=\"height: 18px;\" ng-class=\"{greenTag: !!data.oficial}\">\r\n              <span ng-bind-html=\"$highlight($getDisplayText())\"></span>\r\n            </div> </script> <button type=button class=btn ng-click=runMergeTag()>{{localizedMessages.get('merge')}}</button> </div> </div> </div> </div> ";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var SETTINGS_CAROUSEL = 'carousel.tag.name';
	var CarouselTags = __webpack_require__(193);
	
	angular.module('account.tags.index', ['security.authorization', 'services.utility', 'resources.Tag', 'services.adminResource', 'services.search', 'filters.timeAgo', 'services.formErrors', 'services.algoliaResource', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('account.tags', {
	    url: '/tags?limit&oficial&skip&tag',
	    title: 'Manage Tags',
	    views: {
	      'main@': {
	        template: __webpack_require__(207),
	        controller: 'TagsIndexCtrl',
	        resolve: {
	          roles: ["adminResource", function (adminResource) {
	            return adminResource.searchRoles({ type: 'profile' });
	          }]
	        }
	      }
	    },
	    resolve: {
	      initSearch: ["searchService", "Tag", "$state", function (searchService, Tag, $state) {
	        searchService.setSearchFn(Tag.search);
	        searchService.setRedirectBase('/account/tags/edit');
	      }]
	    }
	  });
	}]).controller('TagsIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "searchService", "$stateParams", "user", "roles", "Tag", "formErrors", "algoliaResource", "localizedMessages", function ($scope, $route, $location, $log, utility, adminResource, searchService, $stateParams, user, roles, Tag, formErrors, algoliaResource, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  $scope.loadingIndicator = false;
	  $scope.carouselTags = new CarouselTags(adminResource);
	
	  // Old code
	  // Settings.get( {name: _CAROUSEL}).$promise.then( function (data) {
	  //   $scope.carouselTag = data.value || 'not set';
	  // }, function(e) {
	  //   console.error(e);
	  // });
	
	  $scope.isTagAdmin = user.permissions.is_admin || user.permissions.is_editor;
	  $scope.search = searchService.search;
	  $scope.isDraftsTab = false;
	  $scope.draftTags = [];
	  $scope.openDraftsTab = function () {
	    $scope.query.searchDrafts = $scope.isDraftsTab = true;
	    $scope.tags = [];
	  };
	  $scope.openTagsTab = function () {
	    $scope.tags = [];
	    $scope.query.searchDrafts = $scope.isDraftsTab = false;
	  };
	  //$scope.tags = tags.data;
	  $scope.getTag = function ($item) {
	    //hola javi 2
	    // $location.path('/account/tags/edit/' + $item._id);
	
	    // console.log("------->>>>>>>>"+$scope.query.tag.name);
	    $scope.tag = $item.name + ' performance';
	    $scope.query.tag = $scope.query.tag.name;
	    $scope.query.oficial = 2;
	  };
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.page = data.meta.page;
	    // $scope.query = data.meta.query;
	    if ($scope.isDraftsTab) {
	      $scope.draftTags = _.map(data.data, function (e) {
	        e.draftProposers = _.map(e.drafts, function (draft) {
	          return draft.draftProposer;
	        }).join(', ');
	        return e;
	      });
	    } else {
	      $scope.tags = data.data;
	    }
	  };
	
	  $scope.removeTag = function (tag) {
	    if (!confirm('Would you like to delete tag "' + tag.name + '" and all references in articles ? DANGER: tag cannot be restored after deletion !')) {
	      return;
	    }
	
	    $scope.loadingIndicator = true;
	    Tag.delete({
	      id: tag._id
	    }, function (result) {
	      fetchData();
	    }, function (e) {
	      $scope.loadingIndicator = false;
	      formErrors.growlErrors(e);
	    });
	  };
	
	  var fetchData = function fetchData() {
	    adminResource.searchTags($scope.query).then(function (data) {
	      deserializeData(data);
	      $scope.loadingIndicator = false;
	    }, function (e) {
	      $log.error(e);
	      $scope.loadingIndicator = false;
	    });
	  };
	
	  $scope.$watchCollection('query', _.debounce(function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	    $scope.loadingIndicator = true;
	    fetchData();
	  }, 700));
	
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	  roles = roles && roles.data ? roles.data.map(function (r) {
	    return {
	      _id: r._id,
	      id: r.role_id,
	      name: r.name
	    };
	  }) : [];
	  $scope.roles = [{
	    _id: null,
	    id: null,
	    name: 'No role'
	  }].concat(roles);
	
	  $scope.query = $location.search();
	  $scope.query.limit = $scope.query.limit || $scope.limits[0].value;
	  $scope.query.tag = $scope.query.tag || '';
	  $scope.query.oficial = $scope.query.oficial || 1;
	  fetchData();
	
	  $scope.algoliaReindexing = function () {
	    algoliaResource.indexingTags().then(function (result) {
	      $scope.algoliaSuccess = true;
	    }).catch(function (error) {
	      $scope.algoliaError = true;
	    });
	  };
	}]);

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	module.exports = "<style>.nav.nav-tabs>li{margin-bottom:0!important}.nav.nav-tabs>li>a{border-bottom:0!important}.nav.nav-tabs>li>a:hover{color:#333;background-color:#e6e6e6;border-color:#adadad;border-bottom:0!important}.carousel-tags-header{border-bottom:1px solid #eee;display:flex;align-content:center;align-items:center;margin:20px 0 4px 0}.carousel-tags-header h3{font-size:18px;font-weight:600;font-family:Arial;margin:0}.carousel-tags-header .error{color:red;font-size:14px;margin:0 0 0 10px}.carousel-tag{display:flex;align-items:center;height:30px;font-family:Arial}.carousel-tag span{font-weight:700;margin:0 5px}.selected{background:red;color:#fff}.loading-indicator{width:50%;overflow:hidden;display:flex;justify-content:center;margin:10px auto}.table-carousel-tags{max-width:50%;width:50%;border-bottom:1px solid #eee;margin-bottom:5px}.table-carousel-tags tr td{border-top:none!important;padding:1px!important}.table-carousel-tags .name{font-weight:600}.row-for-button-save{display:flex;width:50%;justify-content:flex-end}.dot-floating{position:relative;width:10px;height:10px;border-radius:5px;background-color:#9880ff;color:#9880ff;animation:dotFloating 3s infinite cubic-bezier(.15,.6,.9,.1)}.dot-floating::after,.dot-floating::before{content:'';display:inline-block;position:absolute;top:0}.dot-floating::before{left:-12px;width:10px;height:10px;border-radius:5px;background-color:#9880ff;color:#9880ff;animation:dotFloatingBefore 3s infinite ease-in-out}.dot-floating::after{left:-24px;width:10px;height:10px;border-radius:5px;background-color:#9880ff;color:#9880ff;animation:dotFloatingAfter 3s infinite cubic-bezier(.4,0,1,1)}@keyframes dotFloating{0%{left:calc(-50% - 5px)}75%{left:calc(50% + 105px)}100%{left:calc(50% + 105px)}}@keyframes dotFloatingBefore{0%{left:-50px}50%{left:-12px}75%{left:-50px}100%{left:-50px}}@keyframes dotFloatingAfter{0%{left:-100px}50%{left:-24px}75%{left:-100px}100%{left:-100px}}.close{position:relative;display:inline-block;width:30px;height:30px;overflow:hidden;border-radius:5px}.close:hover{opacity:1}.close:hover::after,.close:hover::before{background:red}.close::after,.close::before{content:'';position:absolute;width:100%;top:50%;left:0;background:#000;height:6px;margin-top:-2px}.close::before{-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg)}.close::after{-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);-ms-transform:rotate(-45deg);-o-transform:rotate(-45deg);transform:rotate(-45deg)}</style> <div class=row id=admin-tags-index> <div class=col-xs-12> <div class=page-header ng-if=isTagAdmin> <a ng-href=/account/tags/add class=\"btn btn-default pull-right\">{{localizedMessages.get('add-new')}}</a> <h1>Tagi</h1> </div> <div class=carousel-tags-header> <h3>{{localizedMessages.get('tag-carousel')}}</h3> <span class=error ng-show=\"carouselTags.error !== null\" ng-bind=carouselTags.error></span> <span class=error ng-show=\"carouselTags.error !== null\" style=font-weight:700>{{localizedMessages.get('pls-contact-issues')}}</span> </div> <table class=\"table table-striped table-carousel-tags\"> <thead></thead> <tbody> <div class=loading-indicator ng-show=\"carouselTags.waitCarouselTags || loadingIndicator\"> <div class=dot-floating></div> </div> <tr ng-repeat=\"ct in carouselTags.array()\"> <td ng-bind=ct.name class=name></td> <td ng-bind=ct.sefriendly></td> </tr> </tbody> </table> <div class=row-for-button-save> <button class=\"btn btn-default pull-right\" ng-click=carouselTags.save()>{{localizedMessages.get('save-changes')}}</button> </div> <div> <div ng-bind=carouselTags.result().deleted></div> <div ng-bind=carouselTags.result().added></div> </div> <form class=filters> <div class=row> <div class=col-sm-3> <label>Tag</label> <input id=tag-name type=text class=form-control placeholder=tag autocomplete=off ng-model=query.tag typeahead-on-select=getTag($item)> </div> <div class=col-sm-2> <label>{{localizedMessages.get('limit')}}</label> <select name=limit class=form-control ng-model=query.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\"> </select> </div> <div class=col-sm-3> <label>{{localizedMessages.get('role')}}</label> <select name=role class=form-control ng-model=query.role ng-model-options=\"{ debounce: 500 }\" ng-options=\"role._id as role.name for role in roles track by role._id\"> </select> </div> </div> </form> <br> <uib-tabset active=0> <uib-tab index=0 heading=Tags select=openTagsTab()> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>{{localizedMessages.get('sefriendly')}}</th> <th>{{localizedMessages.get('name')}}</th> <th>{{localizedMessages.get('oficial')}}</th> <th>{{localizedMessages.get('created')}}</th> <th ng-if=isTagAdmin></th> </tr> </thead> <tbody> <tr ng-repeat=\"tag in tags\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/account/tags/edit/{{tag._id}}>Edytuj</a></td> <td ng-bind=tag.sefriendly></td> <td ng-bind=tag.name></td> <td>{{tag.oficial ? 'yes' : 'no'}}</td> <td class=stretch> <span class=\"badge badge-clear\" ng-bind=\"(tag.created_at | timeAgo)\"></span> </td> <td><a class=close ng-click=removeTag(tag) ng-if=isTagAdmin></a></td> </tr> <tr ng-show=\"users.length === 0\"> <td colspan=5>{{localizedMessages.get('no-documents-attached')}}</td> </tr> </tbody> </table> <paginator page-model=page on-navigate=\"query.skip = $offset\" ng-show=\"tags.length>0\"></paginator> </uib-tab> <uib-tab index=1 heading=\"Drafts proposed\" select=openDraftsTab()> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>{{localizedMessages.get('sefriendly')}}</th> <th>{{localizedMessages.get('name')}}</th> <th>{{localizedMessages.get('oficial')}}</th> <th>{{localizedMessages.get('created')}}</th> <th>{{localizedMessages.get('proposers')}}</th> </tr> </thead> <tbody> <tr ng-repeat=\"tag in draftTags\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/account/tags/edit/{{tag._id}}>{{localizedMessages.get('edit')}}</a></td> <td ng-bind=tag.sefriendly></td> <td ng-bind=tag.name></td> <td>{{tag.oficial ? localizedMessages.get('yes') : localizedMessages.get('no')}}</td> <td class=stretch> <span class=\"badge badge-clear pull-right\" ng-bind=\"(tag.created_at | timeAgo)\"></span> </td> <td ng-bind=tag.draftProposers></td> </tr> <tr ng-show=\"users.length === 0\"> <td colspan=5>{{localizedMessages.get('no-documents-attached')}}</td> </tr> </tbody> </table> <paginator page-model=page on-navigate=\"query.skip = $offset\" ng-show=\"tags.length>0\"></paginator> </uib-tab> </uib-tabset> </div> </div> ";

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('account.verification', ['security', 'services.utility', 'services.accountResource', 'directives.serverError', 'ui.bootstrap']);
	angular.module('account.verification').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/account/verification', {
	    templateUrl: 'account/verification/account-verification.tpl.html',
	    controller: 'AccountVerificationCtrl',
	    title: 'Verification Required',
	    resolve: {
	      upsertVerificationToken: ['$q', '$location', 'accountResource', 'securityAuthorization', function ($q, $location, restResource, securityAuthorization) {
	        //lazy upsert verification only for un-verified user, otherwise redirect to /account
	        var redirectUrl;
	        var promise = securityAuthorization.requireUnverifiedUser().then(restResource.upsertVerification, function (reason) {
	          //rejected either user is verified already or isn't authenticated
	          redirectUrl = reason === 'verified-client' ? '/account' : '/login';
	          return $q.reject();
	        }).then(function (data) {
	          if (!data.success) {
	            return $q.reject();
	          }
	        }).catch(function () {
	          redirectUrl = redirectUrl || '/account';
	          $location.path(redirectUrl);
	          return $q.reject();
	        });
	        return promise; //promise resolved if data.success == true
	      }]
	    }
	  }).when('/account/verification/:token', {
	    resolve: {
	      verify: ['$q', '$location', '$route', 'accountResource', 'securityAuthorization', function ($q, $location, $route, restResource, securityAuthorization) {
	        //attemp to verify account only for un-verified user
	        var redirectUrl;
	        var promise = securityAuthorization.requireUnverifiedUser().then(function () {
	          return restResource.verifyAccount($route.current.params.token);
	        }, function () {
	          redirectUrl = '/account';
	          return $q.reject();
	        }).then(function (data) {
	          if (data.success) {
	            redirectUrl = '/account';
	          }
	          return $q.reject();
	        }).catch(function () {
	          redirectUrl = redirectUrl || '/account/verification';
	          $location.path(redirectUrl);
	          return $q.reject();
	        });
	        return promise; //promise never resolves, will always redirect
	      }]
	    }
	  });
	}]);
	angular.module('account.verification').controller('AccountVerificationCtrl', ['$scope', '$location', '$log', 'accountResource', 'security', 'utility', function ($scope, $location, $log, restResource, security, utility) {
	  //model def
	  $scope.formVisible = false;
	  $scope.email = security.currentUser.email;
	  $scope.errfor = {}; //for email server-side validation
	  $scope.alerts = [];
	
	  // method def
	  $scope.showForm = function () {
	    $scope.formVisible = true;
	  };
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.closeAlert = function (ind) {
	    $scope.alerts.splice(ind, 1);
	  };
	  $scope.submit = function () {
	    $scope.alerts = [];
	    restResource.resendVerification($scope.email).then(function (data) {
	      if (data.success) {
	        $scope.alerts.push({
	          type: 'success',
	          msg: 'Verification email successfully re-sent.'
	        });
	        $scope.formVisible = false;
	        $scope.verificationForm.$setPristine();
	      } else {
	        //error due to server side validation
	        $scope.errfor = data.errfor;
	        angular.forEach(data.errfor, function (err, field) {
	          $scope.verificationForm[field].$setValidity('server', false);
	        });
	      }
	    }, function (x) {
	      $scope.alerts.push({
	        type: 'danger',
	        msg: 'Error sending verification email: ' + x
	      });
	    });
	  };
	}]);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.index', ['common.header', 'common.footer', 'resources.User', 'security.authorization', 'services.adminResource']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin', {
	    url: '/admin',
	    title: 'Admin Area',
	    views: {
	      header: {
	        template: __webpack_require__(146),
	        controller: 'HeaderCtrl'
	      },
	      main: {
	        template: __webpack_require__(210),
	        controller: 'AdminCtrl'
	      },
	      footer: {
	        template: __webpack_require__(149),
	        controller: 'FooterCtrl'
	      }
	    },
	    resolve: {
	      user: ["User", "$state", "$location", function (User, $state, $location) {
	
	        return User.current(function (user) {
	          if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
	            return user;
	          }
	          if ($location.path().indexOf("diagrams") > -1) {
	            return user;
	          }
	          return $state.go('unauthorized');
	        }).$promise;
	      }],
	      initSearch: ["searchService", "Article", function (searchService, Article) {
	        searchService.setSearchFn(Article.search);
	        searchService.setRedirectBase('/account/edit-article');
	      }]
	    }
	  });
	}]).controller('AdminCtrl', ['$scope', '$log', function ($scope, $log) {
	  // $scope.user = {
	  //   users: stats['User'],
	  //   accounts: stats['Account'],
	  //   admins: stats['Admin'],
	  //   groups: stats['AdminGroup']
	  // };
	  // $scope.pivoted = {
	  //   categories: stats['Category'],
	  //   statuses: stats['Status']
	  // };
	}]);

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin> <div class=col-sm-6> <div class=page-header><h1>Admin Area</h1></div> <div class=row> <div class=col-sm-4> <div class=\"well stat\"> <div class=stat-value ng-bind=user.users></div> <div class=stat-label>Users</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=stat-value ng-bind=user.accounts></div> <div class=stat-label>Accounts</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=stat-value ng-bind=user.admins></div> <div class=stat-label>Admins</div> </div> </div> </div> <div class=row> <div class=col-sm-4> <div class=\"well stat\"> <div class=stat-value ng-bind=user.groups></div> <div class=stat-label>Groups</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=stat-value ng-bind=pivoted.categories></div> <div class=stat-label>Categories</div> </div> </div> <div class=col-sm-4> <div class=\"well stat\"> <div class=stat-value ng-bind=pivoted.statuses></div> <div class=stat-label>Statuses</div> </div> </div> </div> </div> <div class=\"col-sm-6 special\"> <div class=page-header><h1>Super Dashboard</h1></div> <i class=\"fa fa-gears super-awesome\"></i></div> </div>";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.administrators.detail', ['ngRoute', 'security.authorization', 'services.utility', 'services.adminResource', 'directives.serverError', 'ui.bootstrap']);
	
	angular.module('admin.administrators.detail').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.administrators.edit', {
	    url: '/:id',
	    title: 'Administrators / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(212),
	        controller: 'AdministratorsDetailCtrl',
	        resolve: {
	          administrator: ["adminResource", "$stateParams", function (adminResource, $stateParams) {
	            return adminResource.findAdministrator($stateParams.id);
	          }]
	        },
	        middlewares: ['isAdmin']
	      }
	    }
	  });
	}]);
	
	angular.module('admin.administrators.detail').controller('AdministratorsDetailCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'administrator', function ($scope, $route, $location, $log, utility, adminResource, data) {
	  // local vars
	  var deserializeData = function deserializeData(data) {
	    $scope.groups = data.adminGroups;
	    deserializeAdministrator(data.record);
	  };
	  var deserializeAdministrator = function deserializeAdministrator(administrator) {
	    $scope.selectedNewGroup = null;
	    $scope.administrator = administrator;
	  };
	  var closeAlert = function closeAlert(alert, ind) {
	    alert.splice(ind, 1);
	  };
	  var isExistingGroup = function isExistingGroup(selectedGroup) {
	    var flag = false;
	    var groups = $scope.administrator.groups;
	    angular.forEach(groups, function (group, ind) {
	      if (group._id === selectedGroup._id) {
	        flag = true;
	      }
	    });
	    return flag;
	  };
	  var isExistingPermission = function isExistingPermission(newPermission) {
	    var flag = false;
	    var permissions = $scope.administrator.permissions;
	    angular.forEach(permissions, function (permission, ind) {
	      if (permission.name === newPermission) {
	        flag = true;
	      }
	    });
	    return flag;
	  };
	  // $scope vars
	  $scope.contactAlerts = [];
	  $scope.loginAlerts = [];
	  $scope.deleteAlerts = [];
	  $scope.groupAlerts = [];
	  $scope.permissionAlerts = [];
	  $scope.canSave = utility.canSave;
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.closeContactAlert = function (ind) {
	    closeAlert($scope.contactAlerts, ind);
	  };
	  $scope.closeLoginAlert = function (ind) {
	    closeAlert($scope.loginAlerts, ind);
	  };
	  $scope.closeDeleteAlert = function (ind) {
	    closeAlert($scope.deleteAlerts, ind);
	  };
	  $scope.closeGroupAlert = function (ind) {
	    closeAlert($scope.groupAlerts, ind);
	  };
	  $scope.closePermissionAlert = function (ind) {
	    closeAlert($scope.permissionAlerts, ind);
	  };
	  $scope.updateAdmin = function () {
	    var data = {
	      first: $scope.administrator.name.first,
	      middle: $scope.administrator.name.middle,
	      last: $scope.administrator.name.last
	    };
	    $scope.contactAlerts = [];
	    adminResource.updateAdministrator($scope.administrator._id, data).then(function (result) {
	      if (result.success) {
	        deserializeAdministrator(result.admin);
	        $scope.contactAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	      } else {
	        angular.forEach(result.errors, function (err, index) {
	          $scope.contactAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.contactAlerts.push({ type: 'danger', msg: 'Error updating administrator: ' + x });
	    });
	  };
	  $scope.linkUser = function () {
	    $scope.loginAlerts = [];
	    var newUsername = $scope.administrator.newUsername;
	    $scope.administrator.newUsername = '';
	    adminResource.adminLinkUser($scope.administrator._id, { newUsername: newUsername }).then(function (result) {
	      $scope.loginForm.$setPristine();
	      if (result.success) {
	        deserializeAdministrator(result.admin);
	      } else {
	        angular.forEach(result.errors, function (err, index) {
	          $scope.loginAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.loginAlerts.push({ type: 'danger', msg: 'Error linking user: ' + x });
	    });
	  };
	  $scope.unlinkUser = function () {
	    $scope.loginAlerts = [];
	    if (confirm('Are you sure?')) {
	      adminResource.adminUnlinkUser($scope.administrator._id).then(function (result) {
	        if (result.success) {
	          deserializeAdministrator(result.admin);
	        } else {
	          angular.forEach(result.errors, function (err, index) {
	            $scope.loginAlerts.push({ type: 'danger', msg: err });
	          });
	        }
	      }, function (x) {
	        $scope.loginAlerts.push({ type: 'danger', msg: 'Error unlinking user: ' + x });
	      });
	    }
	  };
	  $scope.addGroup = function () {
	    if (!$scope.selectedNewGroup) {
	      alert('Please select a group.');
	    } else if (isExistingGroup($scope.selectedNewGroup)) {
	      alert('That group already exists.');
	    } else {
	      $scope.administrator.groups.push(angular.copy($scope.selectedNewGroup));
	    }
	    $scope.selectedNewGroup = null; //reset selectedGroup after user interaction
	  };
	  $scope.deleteGroup = function (index) {
	    if (confirm('Are you sure?')) {
	      $scope.administrator.groups.splice(index, 1);
	    }
	  };
	  $scope.saveGroups = function () {
	    $scope.groupAlerts = [];
	    var groups = $scope.administrator.groups;
	    adminResource.saveAdminGroups($scope.administrator._id, { groups: groups }).then(function (result) {
	      if (result.success) {
	        $scope.groupAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	        deserializeAdministrator(result.admin);
	      } else {
	        //error due to server side validation
	        angular.forEach(result.errors, function (err, index) {
	          $scope.groupAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.groupAlerts.push({ type: 'danger', msg: 'Error saving admin groups: ' + x });
	    });
	  };
	  $scope.addPermission = function () {
	    if (!$scope.newPermission) {
	      alert('Please enter a name.');
	    } else if (isExistingPermission($scope.newPermission)) {
	      alert('That name already exists.');
	    } else {
	      $scope.administrator.permissions.push({
	        name: angular.copy($scope.newPermission),
	        permit: true
	      });
	    }
	    $scope.newPermission = null; //reset newPermission after user interaction
	  };
	  $scope.togglePermission = function (index) {
	    $scope.administrator.permissions[index]['permit'] = !$scope.administrator.permissions[index]['permit'];
	  };
	  $scope.deletePermission = function (index) {
	    if (confirm('Are you sure?')) {
	      $scope.administrator.permissions.splice(index, 1);
	    }
	  };
	  $scope.saveSettings = function () {
	    $scope.permissionAlerts = [];
	    var permissions = $scope.administrator.permissions;
	    adminResource.saveAdminPermissions($scope.administrator._id, { permissions: permissions }).then(function (result) {
	      if (result.success) {
	        $scope.permissionAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	        deserializeAdministrator(result.admin);
	      } else {
	        //error due to server side validation
	        angular.forEach(result.errors, function (err, index) {
	          $scope.permissionAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.permissionAlerts.push({ type: 'danger', msg: 'Error saving admin permissions: ' + x });
	    });
	  };
	  $scope.deleteAdministrator = function () {
	    $scope.deleteAlerts = [];
	    if (confirm('Are you sure?')) {
	      adminResource.deleteAdministrator($scope.administrator._id).then(function (result) {
	        if (result.success) {
	          // redirect to admin administrators index page
	          $location.path('/admin/administrators');
	        } else {
	          //error due to server side validation
	          angular.forEach(result.errors, function (err, index) {
	            $scope.deleteAlerts.push({ type: 'danger', msg: err });
	          });
	        }
	      }, function (x) {
	        $scope.deleteAlerts.push({ type: 'danger', msg: 'Error deleting administrator: ' + x });
	      });
	    }
	  };
	
	  //initialize
	  deserializeData(data);
	}]);

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-administrators-detail> <div class=col-xs-12> <div class=page-header> <h1><a href=/admin/administrators>Administrators</a> / {{administrator.name.full}}</h1> </div> <form name=contactForm><fieldset> <legend>Contact Info</legend> <alert ng-repeat=\"alert in contactAlerts\" type={{alert.type}} close=closeContactAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(contactForm.first)}\"> <label class=control-label for=first>First Name:</label> <input type=text name=first id=first class=form-control ng-model=administrator.name.first required> <span class=help-block ng-show=\"showError(contactForm.first, 'required')\">This field is required</span> </div> <div class=form-group ng-class=\"{'has-error': hasError(contactForm.middle)}\"> <label class=control-label for=middle>Middle Name:</label> <input type=text name=middle id=middle class=form-control ng-model=administrator.name.middle> </div> <div class=form-group ng-class=\"{'has-error': hasError(contactForm.last)}\"> <label class=control-label for=last>Last Name:</label> <input type=text name=last id=last class=form-control ng-model=administrator.name.last required> <span class=help-block ng-show=\"showError(contactForm.last, 'required')\">This field is required</span> </div> <div class=form-group> <button type=button class=\"btn btn-primary\" ng-disabled=!canSave(contactForm) ng-click=updateAdmin()>Update</button> </div> </fieldset></form> <form name=loginForm><fieldset> <legend>Login</legend> <alert ng-repeat=\"alert in loginAlerts\" type={{alert.type}} close=closeLoginAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': loginForm.newUsername && hasError(loginForm.newUsername)}\"> <label class=control-label>Username:</label> <div class=input-group ng-show=\"administrator.user && administrator.user.name\"> <input type=text name=username class=form-control ng-model=administrator.user.name disabled=disabled> <div class=input-group-btn> <button type=button class=\"btn btn-warning\" ng-click=unlinkUser()>Unlink</button> <a type=button class=\"btn btn-default\" ng-href=/admin/users/{{administrator.user.id}}>Open</a> </div> </div> <div class=input-group ng-if=\"!(administrator.user && administrator.user.name)\"> <input type=text name=newUsername placeholder=\"enter a username\" class=form-control ng-model=administrator.newUsername required> <div class=input-group-btn> <button type=button class=\"btn btn-success\" ng-disabled=\"!(loginForm.newUsername.$dirty && loginForm.newUsername.$valid)\" ng-click=linkUser()>Link</button> </div> </div> <span class=help-block ng-if=\"!(administrator.user && administrator.user.name)\" ng-show=\"showError(loginForm.newUsername, 'required')\">This field is required</span> </div> </fieldset></form> <form name=groupForm><fieldset> <legend>Groups</legend> <alert ng-repeat=\"alert in groupAlerts\" type={{alert.type}} close=closeGroupAlert($index)>{{alert.msg}}</alert> <div class=form-group> <label class=control-label>Add Membership:</label> <div class=input-group> <select name=newMembership class=form-control ng-options=\"group as group.name for group in groups\" ng-model=selectedNewGroup></select> <div class=input-group-btn> <button type=button class=\"btn btn-success\" ng-click=addGroup()>Add</button> </div> </div> </div> <div class=form-group> <label class=control-label>Memberships:</label> <div class=groups> <div class=input-group ng-repeat=\"group in administrator.groups\"> <input disabled=disabled class=form-control ng-model=group.name> <div class=input-group-btn> <button type=button class=\"btn btn-danger btn-delete\" ng-click=deleteGroup($index)><i class=\"fa fa-trash-o fa-inverse\"></i></button> </div> </div> <span class=badge ng-show=\"administrator.groups.length === 0\">no memberships defined</span> </div> </div> <div class=form-group> <button type=button class=\"btn btn-primary\" ng-click=saveGroups()>Save Groups</button> </div> </fieldset></form> <form name=deleteForm><fieldset> <legend>Danger Zone</legend> <alert ng-repeat=\"alert in deleteAlerts\" type={{alert.type}} close=closeDeleteAlert($index)>{{alert.msg}}</alert> <div class=form-group> <span class=help-block> <span class=\"label label-danger\">If you do this, it cannot be undone.</span>&nbsp;<span class=text-muted>You may also create orphaned document relationships too.</span> </span> </div> <div class=form-group> <button type=button class=\"btn btn-danger btn-delete\" ng-click=deleteAdministrator()>Delete</button> </div> </fieldset></form> </div> </div> ";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.administrators.index', ['security.authorization', 'services.utility', 'services.adminResource']);
	
	angular.module('admin.administrators.index').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.administrators', {
	    url: '/administrators',
	    title: 'Manage Administrators',
	    views: {
	      'main@': {
	        template: __webpack_require__(214),
	        controller: 'AdministratorsIndexCtrl',
	        resolve: {
	          administrators: ["adminResource", "$location", function (adminResource, $location) {
	            return adminResource.findAdministrators($location.search());
	          }]
	        }
	      }
	    }
	  });
	}]);
	
	angular.module('admin.administrators.index').controller('AdministratorsIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'administrators', function ($scope, $route, $location, $log, utility, adminResource, data) {
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.items = data.items;
	    $scope.pages = data.pages;
	    $scope.filters = data.filters;
	    $scope.administrators = data.data;
	  };
	
	  var fetchAdministrators = function fetchAdministrators() {
	    adminResource.findAdministrators($scope.filters).then(function (data) {
	      deserializeData(data);
	
	      //update url in browser addr bar
	      $location.search($scope.filters);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  // $scope methods
	  $scope.canSave = utility.canSave;
	  $scope.filtersUpdated = function () {
	    //reset pagination after filter(s) is updated
	    $scope.filters.page = undefined;
	    fetchAdministrators();
	  };
	  $scope.prev = function () {
	    $scope.filters.page = $scope.pages.prev;
	    fetchAdministrators();
	  };
	  $scope.next = function () {
	    $scope.filters.page = $scope.pages.next;
	    fetchAdministrators();
	  };
	  $scope.addAdmin = function () {
	    adminResource.addAdministrator($scope.fullname).then(function (data) {
	      $scope.fullname = '';
	      if (data.success) {
	        $route.reload();
	      } else if (data.errors && data.errors.length > 0) {
	        alert(data.errors[0]);
	      } else {
	        alert('unknown error.');
	      }
	    }, function (e) {
	      $scope.fullname = '';
	      $log.error(e);
	    });
	  };
	
	  // $scope vars
	  //select elements and their associating options
	  $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  //initialize $scope variables
	  deserializeData(data);
	}]);

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-administrators-index> <div class=col-xs-12> <div class=page-header> <h1>Administrators</h1> </div> <form class=filters> <div class=row> <div class=col-sm-4> <label>Name Search</label> <input name=search type=text class=form-control ng-model=filters.search ng-model-options=\"{ debounce: 500 }\" ng-change=filtersUpdated()> </div> <div class=col-sm-4> <label>Sort By</label> <select name=sort class=form-control ng-model=filters.sort ng-model-options=\"{ debounce: 500 }\" ng-options=\"sort.value as sort.label for sort in sorts\" ng-change=filtersUpdated()> </select> </div> <div class=col-sm-4> <label>Limit</label> <select name=limit class=form-control ng-model=filters.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\" ng-change=filtersUpdated()> </select> </div> </div> </form> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th class=stretch>name</th> <th>id</th> </tr> </thead> <tbody> <tr ng-repeat=\"administrator in administrators\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/admin/administrators/{{administrator._id}}>Edit</a></td> <td class=nowrap ng-bind=administrator.name.full></td> <td ng-bind=administrator._id></td> </tr> <tr ng-show=\"administrators.length === 0\"> <td colspan=3>no documents matched</td> </tr> </tbody> </table> <div class=well ng-if=\"pages.total > 1\"> <div class=\"btn-group pull-left\"> <button disabled=disabled class=\"btn btn-default\">Strona {{pages.current}} z {{pages.total}}</button> <button disabled=disabled class=\"btn btn-default\">Wiersz {{items.begin}} - {{items.end}} z {{items.total}}</button> </div> <div class=\"btn-group pull-right\"> <button class=\"btn btn-default\" ng-class=\"{disabled: !pages.hasPrev}\" ng-click=prev()>&#x2190;</button> <button class=\"btn btn-default\" ng-class=\"{disabled: !pages.hasNext}\" ng-click=next()> &#x2192;</button> </div> <div class=clearfix></div> </div> </div> </div> ";

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.administrators', ['admin.administrators.index', 'admin.administrators.detail']);

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.articles.detail', ['security.authorization', 'services.utility', 'services.adminResource', 'directives.serverError', 'ui.bootstrap', 'ui.bootstrap.dropdown']);
	
	// angular.module('admin.articles.detail').config(function($stateProvider) {
	//   $stateProvider
	//     .state('admin.articles.detail', {
	//       url: '/:id',
	//       title: 'Article / Details',
	//       views: {
	//         'main@': {
	//           template: require('./article.tpl.html'),
	//           controller: 'ArticleDetailCtrl',
	//           resolve: {
	//             article: function(adminResource, $stateParams) {
	//               return adminResource.findArticle($stateParams.id);
	//             },
	//             categories: function(adminResource) {
	//               var options = [];
	//
	//               var generateCategoryOptions = function(items, container) {
	//                 items.forEach(function(item) {
	//                   if (!item.path) {
	//                     return;
	//                   }
	//
	//                   //console.log(item);
	//                   var depth = item.path.split('/').filter(Boolean).length;
	//                   var indent = (new Array(7)).join(String.fromCharCode(160));
	//
	//                   container.push({
	//                     _id: item._id,
	//                     path: item.path,
	//                     name: (new Array(depth)).join(indent) + item.name
	//                   });
	//
	//                   if (item.children) {
	//                     generateCategoryOptions(item.children, container);
	//                   }
	//                 });
	//
	//                 return container;
	//               };
	//
	//               return adminResource.getMenusTree().then(function(data) {
	//                 generateCategoryOptions(data, options);
	//                 return options;
	//               });
	//             }
	//           }
	//         }
	//       }
	//     });
	// });
	//
	// angular.module('admin.articles.detail').controller('ArticleDetailCtrl', [
	//   '$scope',
	//   '$route',
	//   '$location',
	//   '$log',
	//   'utility',
	//   'adminResource',
	//   'article',
	//   'categories',
	//   'STATUSES',
	//   'ARTICLE_STYLES',
	//   function($scope, $route, $location, $log, utility, adminResource, data, categories, STATUSES, ARTICLE_STYLES) {
	//     $scope.statuses = STATUSES;
	//     $scope.categories = categories;
	//     $scope.article_styles = ARTICLE_STYLES;
	//
	//     $scope.accordion = {
	//       status: true,
	//       category: true,
	//       article_style: true,
	//       author: true
	//     };
	//
	//     // local vars
	//     var deserializeData = function(data){
	//       //$scope.statuses = data.statuses;
	//       deserializeAccountGroup(data.record || data);
	//     };
	//     var deserializeAccountGroup = function (data){
	//       var path = '/' + _.map(data.categories, 'sefriendly').reverse().join('/');
	//       $scope.article = data;
	//       $scope.article.status = _.find(STATUSES, {id: data.status + ''});
	//       $scope.article.category = _.find($scope.categories, {path: path});
	//       $scope.article.show_inarticle = _.find(ARTICLE_STYLES, {id: data.show_inarticle + ''});
	//     };
	//     var closeAlert = function(alert, ind){
	//       alert.splice(ind, 1);
	//     };
	//     var isExistingPermission = function(newPermission){
	//       var flag = false;
	//       angular.forEach($scope.group.permissions, function(permission, ind){
	//         if(permission.name === newPermission){
	//           flag = true;
	//         }
	//       });
	//       return flag;
	//     };
	//     //$scope vars
	//     $scope.ckOptions = {
	//       skin: 'moono',
	//       extraPlugins: 'justify,autogrow',
	//       autoGrow_minHeight: 250
	//     };
	//     $scope.detailAlerts = [];
	//     $scope.deleteAlerts = [];
	//     $scope.statusAlerts = [];
	//     $scope.permissionAlerts = [];
	//     $scope.categoryAlerts = [];
	//     $scope.canSave = utility.canSave;
	//     $scope.hasError = utility.hasError;
	//     $scope.showError = utility.showError;
	//     $scope.closeDetailAlert = function(ind){
	//       closeAlert($scope.detailAlerts, ind);
	//     };
	//     $scope.closeDeleteAlert = function(ind){
	//       closeAlert($scope.deleteAlerts, ind);
	//     };
	//     $scope.closePermissionAlert = function(ind){
	//       closeAlert($scope.permissionAlerts, ind);
	//     };
	//     $scope.update = function(){
	//       $scope.detailAlerts = [];
	//       adminResource.updateAccountGroup($scope.group._id, { name: $scope.group.name }).then(function(result){
	//         if(result.success){
	//           deserializeAccountGroup(result.AccountGroup);
	//           $scope.detailAlerts.push({ type: 'info', msg: 'Changes have been saved.'});
	//         }else{
	//           angular.forEach(result.errors, function(err, index){
	//             $scope.detailAlerts.push({ type: 'danger', msg: err });
	//           });
	//         }
	//       }, function(x){
	//         $scope.detailAlerts.push({ type: 'danger', msg: 'Error updating admin group: ' + x });
	//       });
	//     };
	//     $scope.addPermission = function(){
	//       if(!$scope.newPermission){
	//         alert('Please enter a name.');
	//       } else if(isExistingPermission($scope.newPermission)){
	//         alert('That name already exists.');
	//       }else{
	//         $scope.group.permissions.push({
	//           name: angular.copy($scope.newPermission),
	//           permit: true
	//         });
	//       }
	//       $scope.newPermission = null;  //reset newPermission after user interaction
	//     };
	//     $scope.togglePermission = function(index){
	//       $scope.group.permissions[index]['permit'] = !$scope.group.permissions[index]['permit'];
	//     };
	//     $scope.deletePermission = function(index){
	//       if(confirm('Are you sure?')){
	//         $scope.group.permissions.splice(index, 1);
	//       }
	//     };
	//     $scope.saveSettings = function(){
	//       $scope.permissionAlerts = [];
	//       var permissions = $scope.group.permissions;
	//       adminResource.saveAccountGroupPermissions($scope.group._id, {permissions: permissions}).then(function (result) {
	//         if (result.success) {
	//           $scope.permissionAlerts.push({type: 'info', msg: 'Changes have been saved.'});
	//           deserializeAccountGroup(result.AccountGroup);
	//         } else {
	//           //error due to server side validation
	//           angular.forEach(result.errors, function (err, index) {
	//             $scope.permissionAlerts.push({type: 'danger', msg: err});
	//           });
	//         }
	//       }, function (x) {
	//         $scope.permissionAlerts.push({type: 'danger', msg: 'Error saving admin group permissions: ' + x});
	//       });
	//     };
	//     $scope.changeStatus = function(){
	//       $scope.statusAlerts = [];
	//       if($scope.selectedStatus && $scope.selectedStatus._id){
	//         if($scope.selectedStatus._id === $scope.group.status.id){
	//           // status selected is the current status
	//           $scope.statusAlerts.push({ type: 'danger', msg: 'That is the current status.'});
	//         }else{
	//           // update status
	//           var data = {
	//             id: $scope.selectedStatus._id,
	//             name: $scope.selectedStatus.name
	//           };
	//           adminResource.newAccountGroupStatus($scope.group._id, data).then(function(result){
	//             if(result.success){
	//               deserializeAccountGroup(result.AccountGroup);
	//             }else{
	//               //error due to server side validation
	//               angular.forEach(result.errors, function(err, index){
	//                 $scope.statusAlerts.push({ type: 'danger', msg: err});
	//               });
	//             }
	//           }, function(x){
	//             $scope.statusAlerts.push({ type: 'danger', msg: 'Error adding new status: ' + x});
	//           });
	//         }
	//       }else{ //no status is selected
	//         $scope.statusAlerts.push({ type: 'danger', msg: 'Please choose a status.'});
	//       }
	//     };
	//     $scope.deleteAccountGroup = function(){
	//       $scope.deleteAlerts =[];
	//       if(confirm('Are you sure?')){
	//         adminResource.deleteAccountGroup($scope.group._id).then(function(result){
	//           if(result.success){
	//             //redirect to admin account-groups index page
	//             $location.path('/admin/account-groups');
	//           }else{
	//             //error due to server side validation
	//             angular.forEach(result.errors, function(err, index){
	//               $scope.deleteAlerts.push({ type: 'danger', msg: err});
	//             });
	//           }
	//         }, function(x){
	//           $scope.deleteAlerts.push({ type: 'danger', msg: 'Error deleting admin group: ' + x });
	//         });
	//       }
	//     };
	//
	//
	//     $scope.statusModel = [];
	//     $scope.statusData = STATUSES;
	//     $scope.selectSettings = {
	//       closeList: false
	//     };
	//     $scope.saveStatus = function() {
	//       adminResource.saveAccountGroupStatus($scope.group._id, $scope.statusModel).then(function (result) {
	//         if(result.success){
	//           //deserializeAccountGroup(result.AccountGroup);
	//           $scope.statusAlerts.push({type: 'info', msg: 'Changes have been saved.'});
	//         }else{
	//           //error due to server side validation
	//           angular.forEach(result.errors, function(err, index){
	//             $scope.statusAlerts.push({ type: 'danger', msg: err});
	//           });
	//         }
	//       }, function(x){
	//         $scope.statusAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
	//       });
	//     };
	//
	//     $scope.toggleNode = function(node) {
	//       var modelValue = node.$nodeScope.$modelValue;
	//       adminResource.findCategoriesByPath(modelValue.path).then(function(result) {
	//         node.$nodeScope.$modelValue.children = result.data;
	//         node.toggle();
	//       });
	//     };
	//
	//     $scope.toggleCategorySelection = function(id) {
	//       var idx = $scope.group.categories.indexOf(id);
	//       if (idx > -1) {
	//         $scope.group.categories.splice(idx, 1);
	//       }
	//       else {
	//         $scope.group.categories.push(id);
	//       }
	//     };
	//
	//     $scope.saveCategories = function() {
	//       adminResource.saveAccountGroupCategories($scope.group._id, $scope.group.categories).then(function (result) {
	//         if(result.success){
	//           $scope.categoryAlerts.push({type: 'info', msg: 'Changes have been saved.'});
	//         }else{
	//           //error due to server side validation
	//           angular.forEach(result.errors, function(err, index){
	//             $scope.categoryAlerts.push({ type: 'danger', msg: err});
	//           });
	//         }
	//       }, function(x){
	//         $scope.categoryAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x});
	//       });
	//     };
	//
	//     //initialize
	//     deserializeData(data);
	//   }
	// ]);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.articles.index', ['directives.paginator', 'security.authorization', 'services.utility', 'services.search', 'services.adminResource', 'services.localizedMessages']);
	
	angular.module('admin.articles.index').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.articles', {
	    url: '/articles',
	    title: 'Manage Articles',
	    views: {
	      'main@': {
	        template: __webpack_require__(178),
	        controller: 'ArticlesIndexCtrl'
	      }
	    }
	  });
	}]);
	
	angular.module('admin.articles.index').controller('ArticlesIndexCtrl', ["$scope", "$rootScope", "$route", "$location", "$log", "utility", "searchService", "STATUSES", "adminResource", "articles", "localizedMessages", function ($scope, $rootScope, $route, $location, $log, utility, searchService, STATUSES, adminResource, articles, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  searchService.setSearchFn(adminResource.searchArticles);
	
	  searchService.setRedirectBase('/admin/articles');
	
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.page = data.meta.page;
	    $scope.query = data.meta.query;
	    $scope.articles = data.data.map(function (article) {
	      article.title = _.unescape(article.title);
	      article.title = article.title.replace(/&#039;/g, "'"); // TO DO tmp fix as unescape does not process this characters
	      return article;
	    });
	  };
	
	  $scope.query = {};
	  //select elements and their associating options
	  $scope.statuses = STATUSES;
	  $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'article_id \u25B2', value: "article_id" }, { label: 'article_id \u25BC', value: "-article_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  $scope.$watchCollection('query', function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	
	    adminResource.findArticles($scope.query).then(function (data) {
	      deserializeData(data);
	      //update url in browser addr bar
	      $location.search($scope.query);
	    }, function (e) {
	      $log.error(e);
	    });
	  });
	
	  $scope.fetchArticles = function (offset) {
	    $scope.query.skip = offset;
	  };
	
	  $scope.getLabel = function (status) {
	    return _.find(STATUSES, { id: status + '' }).value;
	  };
	
	  $scope.getStyle = function (status) {
	    var status = _.find(STATUSES, { id: status + '' });
	    return {
	      color: status.color,
	      background: status.background
	    };
	  };
	
	  //initialize $scope variables
	  deserializeData(articles);
	}]);

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.articles', ['admin.articles.index', 'admin.articles.detail']);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var slug = function slug(str) {
	  str = str.replace(/^\s+|\s+$/g, ''); // trim
	  str = str.toLowerCase();
	  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
	  var to = "aaaaaeeeeeiiiiooooouuuunc------";
	  for (var i = 0, l = from.length; i < l; i++) {
	    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
	  }
	  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
	  .replace(/\s+/g, '-') // collapse whitespace and replace by -
	  .replace(/-+/g, '-'); // collapse dashes
	  return str;
	};
	
	var recursiveUpdate = function recursiveUpdate(categories, adminResource) {
	  try {
	    for (var i = 0; i < categories.length; i++) {
	      var category = categories[i];
	      category.order = i;
	      adminResource.updateCategory(category.id, category);
	      if (category.children && category.children.length) {
	        recursiveUpdate(category.children, adminResource);
	      }
	    }
	  } catch (error) {
	    console.log(error);
	  }
	};
	
	angular.module('admin.categories.tree', ['security.authorization', 'services.utility', 'services.adminResource', 'services.formErrors', 'resources.AdminCategory']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.categories.tree', {
	    url: '/tree',
	    title: 'Manage Categories',
	    middlewares: ['isAdmin'],
	    views: {
	      'main@': {
	        template: __webpack_require__(220),
	        controller: 'CategoriesTreeCtrl'
	      }
	    }
	  });
	}]).controller('CategoriesTreeCtrl', ["$scope", "$route", "$location", "$log", "$uibModal", "utility", "AdminCategory", "adminResource", "$timeout", function ($scope, $route, $location, $log, $uibModal, utility, AdminCategory, adminResource, $timeout) {
	
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.categories = data;
	  };
	
	  $scope.treeOptions = {
	    dropped: function dropped(e) {
	      var destIndex = e.dest.index;
	      var sourceIndex = e.source.index;
	      var destParentValue = e.dest.nodesScope.$nodeScope ? e.dest.nodesScope.$nodeScope.$modelValue : {};
	      var sourceParentValue = e.source.nodesScope.$nodeScope ? e.source.nodesScope.$nodeScope.$modelValue : {};
	
	      //check if position is changed
	      if (destIndex === sourceIndex && _.isEqual(destParentValue, sourceParentValue)) {
	        return console.log('no changes');
	      }
	
	      //get the changes
	      var parent_path = destParentValue.path || '/';
	
	      var order = e.source.nodeScope.$modelValue.order;
	      var id = e.source.nodeScope.$modelValue._id;
	      var prevNode = e.dest.nodesScope.$modelValue[destIndex - 1];
	      var nextNode = e.dest.nodesScope.$modelValue[destIndex + 1];
	      var destcat = null;
	      if (prevNode) {
	        order = prevNode.order + 1;
	        destcat = prevNode;
	      } else if (!prevNode && nextNode) {
	        order = nextNode.order - 1;
	        destcat = nextNode;
	      }
	
	      var ppath = e.source.nodeScope.$modelValue.path.split('/').filter(Boolean);
	      ppath.pop();
	
	      var changes = {
	        sefriendly: e.source.nodeScope.$modelValue.sefriendly,
	        parent: '/' + ppath.join('/'),
	        dest: parent_path,
	        order: order,
	        destcat: destcat
	      };
	
	      var parent_path2 = destParentValue.path || '';
	      /*adminResource.updateCategoryPosition(id, changes).then(function(result) {
	        e.source.nodeScope.$modelValue.order = changes.order;
	        e.source.nodeScope.$modelValue.sefriendly = changes.sefriendly;
	        e.source.nodeScope.$modelValue.parent = changes.parent;
	        e.source.nodeScope.$modelValue.path = parent_path2 + '/' + changes.sefriendly;
	        e.source.nodeScope.$modelValue.view_subcat = changes.view_subcat;
	      });*/
	
	      /* Update all order field fixed */
	
	      try {
	        $timeout(function () {
	          recursiveUpdate($scope.categories, adminResource);
	        }, 1000);
	      } catch (error) {
	        console.log("setTimeout error:", error);
	      }
	    }
	  };
	
	  $scope.toggleNode = function (node) {
	    var modelValue = node.$nodeScope.$modelValue;
	    var pathLength = modelValue.path.split('/').filter(Boolean).length;
	    var objPath = 'children' + new Array(pathLength).join('.[0].children');
	    var children = {};
	
	    adminResource.getCategoriesTree({ path: modelValue.path, depth: 2 }).then(function (result) {
	      if (!result.length) {
	        return;
	      }
	
	      result = result[0];
	      modelValue.children = _.get(result, objPath);
	      node.toggle();
	    });
	  };
	
	  var generateCategoryOptions = function generateCategoryOptions(items, container) {
	    items.forEach(function (item) {
	      if (!item.path) {
	        return;
	      }
	      var depth = item.path.split('/').filter(Boolean).length;
	      var indent = new Array(5).join(String.fromCharCode(160));
	      container.push({
	        _id: item._id,
	        path: item.path,
	        sefriendly: item.sefriendly,
	        parent: item.parent,
	        parent_id: item.parent_id,
	        name: item.name,
	        view_subcat: item.view_subcat,
	        _name: new Array(depth).join(indent) + item.name
	      });
	      if (item.children) {
	        generateCategoryOptions(item.children, container);
	      }
	    });
	    return container;
	  };
	
	  $scope.addCategory = function () {
	    //show modal
	    var dialog = $uibModal.open({
	      templateUrl: 'add_category.tpl.html',
	      controller: 'AddCategoryCtrl',
	      resolve: {
	        options: function options() {
	          var options = [];
	          return AdminCategory.getTree().$promise.then(function (data) {
	            generateCategoryOptions(data, options);
	            return options;
	          });
	        }
	      }
	    });
	    dialog.result.then(function handleClose(result) {
	      dialog.close();
	      dialog = null;
	      AdminCategory.getTree({ path: '/', depth: 2 }, function (categories) {
	        //initialize $scope variables
	        deserializeData(categories);
	      });
	    }, function handleDismiss() {
	      dialog = null;
	    });
	  };
	
	  $scope.editItem = function (node) {
	    var modelValue = node.$nodeScope.$modelValue;
	
	    //show modal
	    var dialog = $uibModal.open({
	      templateUrl: 'edit_category.tpl.html',
	      controller: 'EditCategoryCtrl',
	      resolve: {
	        data: function data() {
	          return modelValue;
	        },
	        options: function options() {
	          var options = [];
	          return AdminCategory.getTree().$promise.then(function (data) {
	            generateCategoryOptions(data, options);
	            return options;
	          });
	        }
	      }
	    });
	    dialog.result.then(function handleClose(result) {
	      dialog.close();
	      dialog = null;
	      if (!result) {
	        return node.remove();
	      }
	      node.$nodeScope.$modelValue.name = result.name;
	      node.$nodeScope.$modelValue.path = result.parent + '/' + result.sefriendly;
	      node.$nodeScope.$modelValue.sefriendly = result.sefriendly;
	      node.$nodeScope.$modelValue.view_subcat = result.view_subcat;
	      AdminCategory.getTree({ path: '/', depth: 2 }, function (categories) {
	        //initialize $scope variables
	        deserializeData(categories);
	      });
	    }, function handleDismiss() {
	      dialog = null;
	    });
	  };
	
	  AdminCategory.getTree({ path: '/', depth: 2 }, function (categories) {
	    //initialize $scope variables
	    deserializeData(categories);
	  });
	}]).controller('AddCategoryCtrl', ["$scope", "$uibModalInstance", "$log", "AdminCategory", "options", "formErrors", function ($scope, $uibModalInstance, $log, AdminCategory, options, formErrors) {
	
	  $scope.options = options;
	  $scope.hasEditedName = false;
	  $scope.rootUrl = '';
	  $scope.data = {
	    name: '',
	    sefriendly: '',
	    parent: '',
	    view_subcat: false
	  };
	
	  $scope.changedName = function () {
	    if (!$scope.hasEditedName) {
	      $scope.data.sefriendly = slug($scope.data.name || '');
	    }
	  };
	
	  $scope.editedName = function () {
	    if ($scope.data.sefriendly !== '') {
	      $scope.hasEditedName = true;
	    }
	  };
	
	  $scope.editSefriendly = function () {
	    $scope.showSefriendly = true;
	  };
	
	  $scope.saveSefriendly = function () {
	    $scope.showSefriendly = false;
	  };
	
	  $scope.changedParent = function () {
	    $scope.rootUrl = location.href.replace(location.pathname, '');
	    if ($scope.data.parent) {
	      $scope.rootUrl += $scope.data.parent.path;
	    }
	
	    $scope.rootUrl += '/';
	  };
	
	  $scope.save = function () {
	    var view_subcat = 2;
	    if ($scope.data.view_subcat) {
	      view_subcat = 1;
	    }
	    // console.log( '>>>', $scope.data );
	    var parentPath = $scope.data.parent ? $scope.data.parent.path : '/';
	    var parent_id = $scope.data.parent ? $scope.data.parent.parent_id : [];
	    var dataCopy = {
	      name: $scope.data.name,
	      parent: parentPath || '/',
	      parent_id: parent_id,
	      sefriendly: $scope.data.sefriendly,
	      view_subcat: view_subcat
	    };
	    AdminCategory.save(dataCopy, function (result) {
	      $uibModalInstance.close(result);
	    }, formErrors.growlErrors);
	  };
	
	  $scope.changedParent();
	}]).controller('EditCategoryCtrl', ["$scope", "$uibModalInstance", "AdminCategory", "growl", "options", "data", "formErrors", "APP_IMG_URLS", "Upload", function ($scope, $uibModalInstance, AdminCategory, growl, options, data, formErrors, APP_IMG_URLS, Upload) {
	  var parent = '';
	  var parentPath = data.path.substring(0, data.path.lastIndexOf("/"));
	  var sefriendly = data.path.substring(data.path.lastIndexOf("/")).replace('/', '');
	  var view_subcatedit = false;
	  options.forEach(function (item) {
	    if (item.path === parentPath) {
	      parent = item;
	    }
	  });
	  if (data.view_subcat === 1) {
	    view_subcatedit = true;
	  }
	
	  $scope.imgUrl = APP_IMG_URLS.base;
	  $scope.options = options;
	  $scope.hasEditedName = true;
	  $scope.rootUrl = '';
	  // console.log( '>>', data );
	  $scope.data = {
	    _id: data._id,
	    id: data.id,
	    old_path: data.path,
	    name: data.name,
	    sefriendly: sefriendly,
	    parent: parent,
	    parent_id: data.parent_id,
	    view_subcat: view_subcatedit,
	    image: data.image
	  };
	  $scope.changedName = function () {
	    if (!$scope.hasEditedName) {
	      $scope.data.sefriendly = slug($scope.data.name || '');
	    }
	  };
	  $scope.editedName = function () {
	    if ($scope.data.sefriendly !== '') {
	      $scope.hasEditedName = true;
	    }
	  };
	  $scope.editSefriendly = function () {
	    $scope.showSefriendly = true;
	  };
	  $scope.saveSefriendly = function () {
	    $scope.showSefriendly = false;
	  };
	  $scope.changedParent = function () {
	    $scope.rootUrl = location.href.replace(location.pathname, '');
	    if ($scope.data.parent) {
	      $scope.rootUrl += $scope.data.parent.path;
	    }
	
	    $scope.rootUrl += '/';
	  };
	  $scope.save = function () {
	    var view_subcateditsave = 2;
	    if ($scope.data.view_subcat) {
	      view_subcateditsave = 1;
	    }
	    var parentPath = $scope.data.parent ? $scope.data.parent.path : '/';
	    var dataCopy = {
	      _id: data._id,
	      id: $scope.data.id,
	      name: $scope.data.name,
	      old_path: $scope.data.old_path,
	      image: $scope.data.image,
	      parent: parentPath || '/',
	      parent_id: $scope.data.parent_id || '',
	      path: parentPath + '/' + $scope.data.sefriendly,
	      sefriendly: $scope.data.sefriendly,
	      view_subcat: view_subcateditsave
	    };
	    AdminCategory.update(dataCopy, function (result) {
	      $uibModalInstance.close(result);
	    }, formErrors.growlErrors);
	  };
	  $scope.delete = function () {
	    if (!confirm('Deleting parent will delete all children. Are you sure you want to continue?')) {
	      return;
	    }
	    AdminCategory.delete({ id: data._id }, function (result) {
	      $uibModalInstance.close(null);
	    }, formErrors.growlErrors);
	  };
	
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  $scope.upload = function (file) {
	    console.log('>>>', file.size);
	    $scope.uploading = true;
	    $scope.image = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.data.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
	    });
	  };
	
	  $scope.changedParent();
	}]);

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-categories-index> <div class=col-xs-12> <div class=page-header> <button class=\"btn btn-success pull-right\" ng-click=addCategory()> <span class=\"glyphicon glyphicon-plus\"></span> Add Category </button> <h1>Categories</h1> </div> <div ui-tree=treeOptions id=tree-root> <ol ui-tree-nodes ng-model=categories> <li ng-repeat=\"category in categories\" ui-tree-node data-collapsed={{!!category.children.length}} ng-include=\"'nodes_renderer.tpl.html'\"> </li> </ol> </div> </div> </div> <script type=text/ng-template id=nodes_renderer.tpl.html> <div ui-tree-handle class=\"tree-node tree-node-content\">\r\n        <div class=\"label-container\">\r\n            <a href=\"#\" ng-click=\"editItem(this)\" data-nodrag=\"\" class=\"angular-ui-tree-label\">{{category.name}}</a>\r\n        </div>\r\n        <a class=\"pull-right btn btn-default btn-xs\" data-nodrag ng-click=\"toggleNode(this)\"\r\n           ng-class=\"{\r\n            'hidden': !category.children.length\r\n           }\"\r\n           style=\"margin-right: 8px;\">\r\n            <span class=\"glyphicon\"\r\n                  ng-class=\"{\r\n                    'glyphicon-chevron-left': collapsed,\r\n                    'glyphicon-chevron-down': !collapsed\r\n                  }\">\r\n            </span>\r\n        </a>\r\n    </div>\r\n    <ol ui-tree-nodes=\"\" ng-model=\"category.children\" ng-class=\"{hidden: collapsed}\">\r\n        <li ng-repeat=\"category in category.children\" ui-tree-node data-collapsed=\"{{!!category.children.length}}\" ng-include=\"'nodes_renderer.tpl.html'\">\r\n        </li>\r\n    </ol> </script> <script type=text/ng-template id=add_category.tpl.html> <form name=\"form\" novalidate class=\"login-form\">\r\n        <div class=\"modal-header\">\r\n            <h4>Add Category</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <alert ng-repeat=\"alert in alerts\" type=\"{{alert.type}}\" close=\"closeAlert($index)\">{{alert.msg}}</alert>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"name\">Name:</label>\r\n                <input type=\"text\" name=\"name\" id=\"name\" class=\"form-control\" ng-keyup=\"changedName()\" ng-blur=\"editedName()\" ng-model=\"data.name\" required>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"sefriendly\">Url:</label>\r\n                <span class=\"text-muted\">\r\n                    <span ng-bind=\"rootUrl\" style=\"margin-right: -4px;\"></span>\r\n                    <span class=\"text-success\" ng-bind=\"data.sefriendly\" ng-if=\"!showSefriendly\"></span>\r\n                </span>\r\n                <span class=\"edit-sefriendly\" ng-if=\"showSefriendly\">\r\n                    <input type=\"text\" name=\"sefriendly\" id=\"sefriendly\" ng-model=\"data.sefriendly\">\r\n                    <button class=\"btn btn-default\" ng-click=\"saveSefriendly()\">Ok</button>\r\n                </span>\r\n                <button class=\"btn btn-default btn-sm\" ng-click=\"editSefriendly()\" ng-if=\"!showSefriendly\" style=\"margin-left: 10px\">Edit</button>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"parent\">Parent:</label>\r\n                <select type=\"text\" name=\"parent\" id=\"parent\" class=\"form-control\"\r\n                        ng-model=\"data.parent\"\r\n                        ng-options=\"option._name for option in options\"\r\n                        ng-change=\"changedParent()\"\r\n                        required>\r\n                    <option value=\"\">Root</option>\r\n                </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"view_subcat\">View subcat:</label>\r\n                <toggle-switch\r\n                    ng-model=\"data.view_subcat\"\r\n                    class=\"switch-primary\">\r\n                <toggle-switch>\r\n            </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-primary\" ng-click=\"save()\">Save</button>\r\n        </div>\r\n    </form> </script> <script type=text/ng-template id=edit_category.tpl.html> <form name=\"form\" novalidate class=\"login-form\">\r\n        <div class=\"modal-header\">\r\n            <h4>Edit Category</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"name\">Name:</label>\r\n                <input type=\"text\" name=\"name\" id=\"name\" class=\"form-control\" ng-keyup=\"changedName()\" ng-blur=\"editedName()\" ng-model=\"data.name\" required>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"sefriendly\">Link:</label>\r\n                <span class=\"text-muted\">\r\n                    <span ng-bind=\"rootUrl\" style=\"margin-right: -4px;\"></span>\r\n                    <span class=\"text-success\" ng-bind=\"data.sefriendly\" ng-if=\"!showSefriendly\"></span>\r\n                </span>\r\n                <span class=\"edit-sefriendly\" ng-if=\"showSefriendly\">\r\n                    <input type=\"text\" name=\"sefriendly\" id=\"sefriendly\" ng-model=\"data.sefriendly\">\r\n                    <button class=\"btn btn-default\" ng-click=\"saveSefriendly()\">Ok</button>\r\n                </span>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"parent\">Parent:</label>\r\n                <select type=\"text\" name=\"parent\" id=\"parent\" class=\"form-control\"\r\n                        ng-model=\"data.parent\"\r\n                        ng-options=\"option._name for option in options\"\r\n                        ng-change=\"changedParent()\"\r\n                        ng-disabled=\"true\"\r\n                        required>\r\n                    <option value=\"\">Root</option>\r\n                </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"view_subcat\">View subcat:</label>\r\n                <toggle-switch\r\n                    ng-model=\"data.view_subcat\"\r\n                    class=\"switch-primary\"\r\n                    ng-change=\"autosaveChanged()\">\r\n                <toggle-switch>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"image\">Image:</label>\r\n                <span class=\"text-muted\" id=\"image\">\r\n                    <span ng-bind=\"data.image\" style=\"margin-right: -4px;\"></span>\r\n                </span>\r\n                <figure\r\n                    class=\"category-image\"\r\n                    ng-class=\"{'no-image': !data.image}\"\r\n                    type=\"file\"\r\n                    id=\"file\"\r\n                    ngf-drop-available=\"true\"\r\n                    ngf-drop-disabled=\"false\"\r\n                    ngf-drag-over-class=\"'dragover'\"\r\n                    ngf-hide-on-drop-not-available=\"true\"\r\n                    ngf-select\r\n                    ngf-drop\r\n                    ng-model=\"file\"\r\n                    name=\"file\"\r\n                    accept=\"image/*\"\r\n                    ngf-max-size=\"10MB\"\r\n                    ngf-model-invalid=\"errorFiles\"\r\n                    ngf-validate=\"{size: {min: 10, max: '10MB'}}\"\r\n                    ngf-resize=\"{width: 1280}\"\r\n                    ngf-resize-if=\"$width > 1280\"\r\n                    style=\"padding: 1.2em;border-radius:10px;background-color:#FFF; text-align:center;-webkit-box-shadow: 0 0 3px rgba(0,0,0,0.15); -o-box-shadow: 0 0 3px rgba(0,0,0,0.15); box-shadow: 0 0 3px rgba(0,0,0,0.15);border-top-left-radius: 10px; -moz-border-radius-topleft: 10px; -webkit-border-radius-topleft: 10px; border-top-right-radius: 10px; -moz-border-radius-topright: 10px; -webkit-border-radius-topright: 10px; position: relative;\">\r\n                    <div\r\n                        style=\"background-color:transparent; display: block; cursor: pointer;\"\r\n                        for=\"file-upload\">\r\n                        <img class=\"img-responsive\" ng-src=\"{{imgUrl + data.image}}\">\r\n                        <div class=\"loader\" style=\"position: absolute; top: -20px; background: rgba(0, 0, 0, .25); width: 100%; height: 100%;\" ng-if=\"uploading\">\r\n                            <i class=\"fas fa-spinner fa-spin\" style=\"margin-top: 130px;\"></i>\r\n                        </div>\r\n                    </div>\r\n                </figure>\r\n            </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-primary\" ng-click=\"save()\">Save</button>\r\n            <button class=\"btn btn-danger\" ng-click=\"delete()\">Delete</button>\r\n        </div>\r\n    </form> </script> ";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.categories.index', ['ui.tree', 'security.authorization', 'services.utility', 'services.adminResource']);
	
	angular.module('admin.categories.index').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.categories', {
	    url: '/categories',
	    title: 'Manage Categories',
	    views: {
	      'main@': {
	        template: __webpack_require__(222),
	        controller: 'CategoriesIndexCtrl'
	        // resolve: {
	        //   categories: function(adminResource, $location) {
	        //     return adminResource.findCategories($location.search());
	        //   }
	        // }
	      }
	    }
	  });
	}]);
	
	angular.module('admin.categories.index').controller('CategoriesIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'categories', function ($scope, $route, $location, $log, utility, adminResource, data) {
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.items = data.items;
	    $scope.pages = data.pages;
	    $scope.filters = data.filters;
	    $scope.categories = data.data;
	  };
	
	  var fetchCategories = function fetchCategories() {
	    adminResource.findCategories($scope.filters).then(function (data) {
	      deserializeData(data);
	
	      //update url in browser addr bar
	      $location.search($scope.filters);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  // $scope methods
	  $scope.canSave = utility.canSave;
	  $scope.filtersUpdated = function () {
	    //reset pagination after filter(s) is updated
	    $scope.filters.page = undefined;
	    fetchCategories();
	  };
	  $scope.prev = function () {
	    $scope.filters.page = $scope.pages.prev;
	    fetchCategories();
	  };
	  $scope.next = function () {
	    $scope.filters.page = $scope.pages.next;
	    fetchCategories();
	  };
	  $scope.addCategory = function () {
	    adminResource.addCategory($scope.add).then(function (data) {
	      $scope.add = {};
	      if (data.success) {
	        $route.reload();
	      } else if (data.errors && data.errors.length > 0) {
	        alert(data.errors[0]);
	      } else {
	        alert('unknown error.');
	      }
	    }, function (e) {
	      $scope.add = {};
	      $log.error(e);
	    });
	  };
	
	  // $scope vars
	  //select elements and their associating options
	  $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  //initialize $scope variables
	  deserializeData(data);
	}]);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-categories-index> <div class=col-xs-12> <div class=page-header> <div class=\"btn-group btn-group pull-right\" role=group> <a href=# type=button class=\"btn btn-default active\">List</a> <a href=/admin/categories/tree type=button class=\"btn btn-default\">Tree</a> </div> <h1>Categories</h1> </div> <form class=filters> <div class=row> <div class=col-sm-3> <label>Pivot Search</label> <input name=pivot type=text class=form-control ng-model=filters.pivot ng-model-options=\"{ debounce: 500 }\" ng-change=filtersUpdated()> </div> <div class=col-sm-3> <label>Name Search</label> <input name=name type=text class=form-control ng-model=filters.name ng-model-options=\"{ debounce: 500 }\" ng-change=filtersUpdated()> </div> <div class=col-sm-3> <label>Sort By</label> <select name=sort class=form-control ng-model=filters.sort ng-model-options=\"{ debounce: 500 }\" ng-options=\"sort.value as sort.label for sort in sorts\" ng-change=filtersUpdated()> </select> </div> <div class=col-sm-3> <label>Limit</label> <select name=limit class=form-control ng-model=filters.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\" ng-change=filtersUpdated()> </select> </div> </div> </form> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>id</th> <th class=stretch>name</th> <th>sefriendly</th> </tr> </thead> <tbody> <tr ng-repeat=\"category in categories\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/admin/categories/{{category._id}}>Edit</a></td> <td ng-bind=category.id></td> <td ng-bind=category.category_name></td> <td class=nowrap ng-bind=category.sefriendly></td> </tr> <tr ng-show=\"categories.length === 0\"> <td colspan=4>no documents matched</td> </tr> </tbody> </table> <div class=well ng-if=\"pages.total > 1\"> <div class=\"btn-group pull-left\"> <button disabled=disabled class=\"btn btn-default\">Strona {{pages.current}} z {{pages.total}}</button> <button disabled=disabled class=\"btn btn-default\">Wiersz {{items.begin}} - {{items.end}} z {{items.total}}</button> </div> <div class=\"btn-group pull-right\"> <button class=\"btn btn-default\" ng-class=\"{disabled: !pages.hasPrev}\" ng-click=prev()>&#x2190;</button> <button class=\"btn btn-default\" ng-class=\"{disabled: !pages.hasNext}\" ng-click=next()> &#x2192;</button> </div> <div class=clearfix></div> </div> </div> </div> ";

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.categories.detail', ['ngRoute', 'security.authorization', 'services.utility', 'services.adminResource', 'ui.bootstrap']);
	// angular.module('admin.categories.detail').config(['$routeProvider', function($routeProvider){
	//   $routeProvider
	//     .when('/admin/categories/:id', {
	//       templateUrl: 'admin/categories/admin-category.tpl.html',
	//       controller: 'AdminCategoriesDetailCtrl',
	//       title: 'Categories / Details',
	//       resolve: {
	//         category: ['$q', '$route', '$location', 'securityAuthorization', 'adminResource', function($q, $route, $location, securityAuthorization, adminResource){
	//           //get app stats only for admin-user, otherwise redirect to /account
	//           var redirectUrl;
	//           var promise = securityAuthorization.requireAdminUser()
	//             .then(function(){
	//               var id = $route.current.params.id || '';
	//               if(id){
	//                 return adminResource.findCategory(id);
	//               }else{
	//                 redirectUrl = '/admin/categories';
	//                 return $q.reject();
	//               }
	//             }, function(reason){
	//               //rejected either user is un-authorized or un-authenticated
	//               redirectUrl = reason === 'unauthorized-client'? '/account': '/login';
	//               return $q.reject();
	//             })
	//             .catch(function(){
	//               redirectUrl = redirectUrl || '/account';
	//               $location.path(redirectUrl);
	//               return $q.reject();
	//             });
	//           return promise;
	//         }]
	//       }
	//     });
	// }]);
	angular.module('admin.categories.detail').controller('AdminCategoriesDetailCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'category', function ($scope, $route, $location, $log, utility, adminResource, data) {
	
	  var deserializeData = function deserializeData(data) {
	    $scope.category = data;
	  };
	  var closeAlert = function closeAlert(alert, ind) {
	    alert.splice(ind, 1);
	  };
	  //$scope vars
	  $scope.detailAlerts = [];
	  $scope.deleteAlerts = [];
	  $scope.canSave = utility.canSave;
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.closeDetailAlert = function (ind) {
	    closeAlert($scope.detailAlerts, ind);
	  };
	  $scope.closeDeleteAlert = function (ind) {
	    closeAlert($scope.deleteAlerts, ind);
	  };
	  $scope.update = function () {
	    $scope.detailAlerts = [];
	    var data = {
	      name: $scope.category.name,
	      pivot: $scope.category.pivot
	    };
	    adminResource.updateCategory($scope.category._id, data).then(function (result) {
	      if (result.success) {
	        deserializeData(result.category);
	        $scope.detailAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	      } else {
	        angular.forEach(result.errors, function (err, index) {
	          $scope.detailAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.detailAlerts.push({ type: 'danger', msg: 'Error updating category: ' + x });
	    });
	  };
	  $scope.deleteCategory = function () {
	    $scope.deleteAlerts = [];
	    if (confirm('Are you sure?')) {
	      adminResource.deleteCategory($scope.category._id).then(function (result) {
	        if (result.success) {
	          //redirect to admin categories index page
	          $location.path('/admin/categories');
	        } else {
	          //error due to server side validation
	          angular.forEach(result.errors, function (err, index) {
	            $scope.deleteAlerts.push({ type: 'danger', msg: err });
	          });
	        }
	      }, function (x) {
	        $scope.deleteAlerts.push({ type: 'danger', msg: 'Error deleting category: ' + x });
	      });
	    }
	  };
	
	  //initialize
	  deserializeData(data);
	}]);

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.categories', ['admin.categories.index', 'admin.categories.tree', 'admin.categories.detail']);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.cover.index', ['security.authorization', 'services.utility', 'services.adminResource', 'services.search', 'services.formErrors', 'resources.User']);
	
	angular.module('admin.cover.index').config(["$stateProvider", function ($stateProvider) {
	
	    $stateProvider.state('admin.cover', {
	        url: '/cover',
	        title: 'Admin / Cover',
	        views: {
	            'main@': {
	                template: __webpack_require__(226),
	                controller: 'AdminCoverCtrl',
	                resolve: {
	                    // pre-load resources
	                }
	            }
	        }
	    });
	}]);
	
	angular.module('admin.cover.index').controller('AdminCoverCtrl', ["$scope", "$state", "formErrors", "$location", "user", "growl", "Upload", "$sce", "APP_IMG_URLS", function ($scope, $state, formErrors, $location, user, growl, Upload, $sce, APP_IMG_URLS) {
	    $scope.uploading = false;
	    $scope.imgUrl = APP_IMG_URLS.base;
	    $scope.coverImg = 'diario.jpg?r=' + Math.random();
	    $scope.coverPdf = $sce.trustAsResourceUrl(APP_IMG_URLS.base + 'diario.pdf?r=' + Math.random());
	
	    $scope.$watch('file', function (file) {
	        if (!file) return;
	        $scope.upload(file);
	    });
	
	    // upload on Image Cover file select or drop
	    $scope.upload = function (file) {
	        console.log(file.size);
	        $scope.uploading = true;
	        $scope.coverImg = null;
	        Upload.upload({
	            url: '/api/articles/upload?type=cover-image',
	            data: {
	                file: file
	            }
	        }).then(function (resp) {
	            $scope.uploading = false;
	            $scope.coverImg = 'diario.jpg?r=' + Math.random();
	        }, function (resp) {
	            $scope.uploading = false;
	            $scope.coverImg = 'diario.jpg?r=' + Math.random();
	            console.log('Error status: ' + resp.status);
	        }, function (evt) {
	            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	            console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	        });
	    };
	
	    $scope.$watch('file1', function (file) {
	        if (!file) return;
	        $scope.upload1(file);
	    });
	
	    // upload on PDF file select or drop
	    $scope.upload1 = function (file) {
	        $scope.uploading = true;
	        Upload.upload({
	            url: '/api/articles/upload?type=cover-pdf',
	            data: {
	                file: file
	            }
	        }).then(function () {
	            $scope.uploading = false;
	            $scope.coverPdf = $sce.trustAsResourceUrl(APP_IMG_URLS.base + 'diario.pdf?r=' + Math.random());
	        }, function (resp) {
	            $scope.uploading = false;
	            $scope.coverPdf = $sce.trustAsResourceUrl(APP_IMG_URLS.base + 'diario.pdf?r=' + Math.random());
	            console.log('Error status: ' + resp.status);
	        }, function (evt) {
	            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	            console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	        });
	    };
	}]);

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=col-xs-12> <div class=page-header> <h1>Cover</h1> </div> </div> </div> <form novalidate name=coverForm id=coverForm ng-submit=submit()> <div class=row> <div class=col-sm-6> <p>Attention: file on frontend immadiately changed, after you uploaded new one!</p> <p>Note: only *.jpg file accepted.</p> <div class=form-group> <label class=control-label for=file> Cover Image: <a href=\"{{imgUrl + coverImg}}\" target=_blank>{{imgUrl + coverImg}}</a> </label> <figure class=article-image ng-class=\"{'no-image': !data.cover}\" type=file id=file ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/jpg ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{imgUrl + coverImg}}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> <div class=form-group style=margin-top:50px;min-height:100px> <label class=control-label for=file1> PDF: <a href={{coverPdf}} target=_blank>{{coverPdf}}</a> </label> <figure class=article-image ng-class=\"{'no-image': !data.pdf}\" type=file id=file1 ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file1 name=file1 accept=application/pdf required ngf-model-invalid=errorFiles ngf-validate=\"{size: {min: 10, max: '10MB'}}\" style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <iframe name=pdf-preview ng-src={{coverPdf}} height=200 style=width:100%></iframe> <p style=\"border:1px solid;border-radius:7px;border-color:#aaa;margin-top:10px;padding:10px\"> Haz click para subir nuevo pdf </p> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> </div> </div> </form> ";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.diagrams.index', ['security.authorization', 'services.utility', 'services.adminResource', 'services.search', 'resources.AdminGroup', 'resources.AdminCategory', 'resources.AdminUser', 'resources.Category', 'resources.Article', 'services.formErrors', 'resources.User', 'chart.js', 'services.algoliaResource', 'services.localizedMessages', 'daterangepicker']);
	
	angular.module('admin.diagrams.index').config(["$stateProvider", function ($stateProvider) {
	
	  $stateProvider.state('admin.diagrams', {
	    url: '/algolia',
	    title: 'Admin / Diagrams',
	    views: {
	      'main@': {
	        template: __webpack_require__(228),
	        controller: 'AdminDiagramsCtrl',
	        resolve: {
	          userDetails: ["$stateParams", "adminResource", function ($stateParams, adminResource) {
	            //alert('dsfg');
	          }],
	          groups: ["AdminGroup", function (AdminGroup) {
	            //alert('sdfgsdf');
	          }]
	        }
	      }
	    }
	  });
	}]);
	
	angular.module('admin.diagrams.index').controller('AdminDiagramsCtrl', ["$scope", "$state", "adminResource", "AdminCategory", "localizedMessages", "algoliaResource", "searchService", "groups", "AdminUser", "Category", "Article", "formErrors", "growl", "userDetails", "$location", "user", function ($scope, $state, adminResource, AdminCategory, localizedMessages, algoliaResource, searchService, groups, AdminUser, Category, Article, formErrors, growl, userDetails, $location, user) {
	  $scope.localizedMessages = localizedMessages;
	  $scope.algoliaArticlesReindexing = function () {
	    algoliaResource.indexingArticles().then(function (result) {
	      $scope.algoliaSuccessArticles = true;
	    }).catch(function (error) {
	      $scope.algoliaErrorArticles = true;
	    });
	  };
	  $scope.algoliaAuthorReindexing = function () {
	    algoliaResource.indexingAuthors().then(function (result) {
	      $scope.algoliaSuccessAuthor = true;
	    }).catch(function (error) {
	      $scope.algoliaErrorAuthor = true;
	    });
	  };
	  $scope.algoliaTagsReindexing = function () {
	    algoliaResource.indexingTags().then(function (result) {
	      $scope.algoliaSuccessTags = true;
	    }).catch(function (error) {
	      $scope.algoliaErrorTags = true;
	    });
	  };
	
	  //   $scope.dataLoaded = false
	  // var generateCategoryOptions = function (items, container) {
	  //     angular.forEach(items, function (item, key) {
	  //       if (!item.path) {
	  //         return;
	  //       }
	  //       var depth = item.path.split('/').filter(Boolean).length;
	  //       var indent = (new Array(5)).join(String.fromCharCode(160));
	  //       container.push({
	  //         _id: item.id,
	  //         path: item.path,
	  //         sefriendly: item.sefriendly,
	  //         parent: item.parent,
	  //         name: item.name,
	  //         _name: (new Array(depth)).join(indent) + item.name
	  //       });
	  //       if (item.children) {
	  //         generateCategoryOptions(item.children, container);
	  //       }
	  //     });
	  //     return container;
	  //   };
	
	  //   searchService.setSearchFn(AdminUser.search);
	
	  //   searchService.setRedirectBase('/admin/diagrams');
	
	  //   $scope.q = '';
	  //   $scope.disableInput = false;
	  //   if (!user.permissions.is_editor && !user.permissions.is_admin) {
	  //     $scope.q = user.account.name.full;
	  //     $scope.disableInput = true;
	
	  //     $scope.author = user.account.name.full + ' performance';
	  //     $scope.author_username = user.username;
	  //   }
	
	  //   $scope.period_type = 'month';
	
	  //   $scope.showCategory = false;
	
	  //   $scope.categoryName = null;
	
	  //   $scope.hasEditedName = false;
	
	  //   $scope.categories = {};
	
	  //   $scope.diagramData = [[]];
	
	
	  //   $scope.search = searchService.search;
	
	  //   $scope.onSelect = searchService.onSelect;
	
	  //   $scope.changeDiagramType = changeDiagramType;
	
	  //   $scope.getAuthor = function ($item) {
	  //     $scope.author = $item.name + ' performance';
	  //     $scope.author_username = $item.username;
	  //   };
	
	  //   var options = [
	  //     {
	  //       _id: 0,
	  //       path: null,
	  //       sefriendly: null,
	  //       parent: null,
	  //       name: 'Root',
	  //       _name: 'Root'
	  //     }
	  //   ];
	  //   Category.getPermittedTree().$promise.then(function (data) {
	  //     $scope.options = generateCategoryOptions(data, options);
	  //     if ($scope.options.length > 0)
	  //       $scope.showCategory = true;
	  //   });
	
	  //   // AdminCategory.getTree(function (data) {
	  //   //     $scope.options = generateCategoryOptions(data, options);
	  //   //     if ($scope.options.length > 0)
	  //   //         $scope.showCategory = true;
	  //   // });
	
	  //   $scope.rootUrl = '';
	  //   $scope.data = {
	  //     name: '',
	  //     sefriendly: '',
	  //     parent: ''
	  //   };
	
	
	  //   $scope.changedParent = function () {
	  //     if ($scope.data.parent) {
	  //       $scope.categoryName = $scope.data.parent.name;
	  //     }
	  //   };
	
	
	  //   $scope.min_date = threeMonthsBack();
	  //   $scope.max_date = getCurrentDate();
	
	  //   //$scope.series = ['Articles'];
	  //   console.log($scope.period_type)
	
	  //   $scope.getAllArticlles = Article.getAllArticles({
	  //     min_date: $scope.min_date,
	  //     max_date: $scope.max_date,
	  //     period_type: $scope.period_type
	  //   }, fillDiagramData);
	
	
	  //   $scope.diagramClick = function (points, evt) {
	
	  //   };
	
	  //   $scope.datePickerOptions = {
	  //     locale: {
	  //       applyClass: "btn-green",
	  //       applyLabel: "Apply",
	  //       cancelLabel: "Cancel",
	  //       customRangeLabel: "Custom range",
	  //       format: "YYYY-MM-DD",
	  //       fromLabel: "From",
	  //       toLabel: "To"
	  //     },
	  //     ranges: {
	  //       "Last 7 Days": [
	  //         $scope.min_date,
	  //         $scope.max_date
	  //       ],
	  //       "Last 30 Days": [
	  //         getLastMonthDate(),
	  //         $scope.max_date
	  //       ],
	  //       "Last 3 Months": [
	  //         threeMonthsBack(),
	  //         $scope.max_date
	  //       ],
	  //       "Last Year": [
	  //         oneYearBack(),
	  //         $scope.max_date
	  //       ]
	  //     }
	  //   };
	  //   $scope.datePicker = {};
	  //   $scope.datePicker.date = {startDate: $scope.min_date, endDate: $scope.max_date};
	
	
	  //   $scope.makeDiagram = function () {
	  //     var categories = {};
	  //     angular.forEach($scope.categories.selected, function (value, key) {
	  //       categories[key] = value._id;
	  //     });
	  //     // console.log( '>>', $scope.datePicker.date.startDate.format('YYYY-MM-DD'), convertDateFormat($scope.datePicker.date.startDate));
	  //     Article.getAllArticles(
	  //       {
	  //         min_date: $scope.datePicker.date.startDate.format('YYYY-MM-DD'), // convertDateFormat($scope.datePicker.date.startDate),
	  //         max_date: $scope.datePicker.date.endDate.format('YYYY-MM-DD'), // convertDateFormat($scope.datePicker.date.endDate),
	  //         author_username: $scope.author_username,
	  //         categories: categories,
	  //         period_type: $scope.period_type
	  //       },
	  //       fillDiagramData
	  //     );
	  //   }
	
	  //   function getLastWeekDate() {
	
	  //     var date = new Date();
	  //     var dateInt = date.setDate(date.getDate() - 7);
	  //     var lastMontDate = new Date(dateInt);
	  //     var year = lastMontDate.getFullYear();
	  //     var month = lastMontDate.getMonth() + 1;
	  //     if (month < 9)
	  //       month = '0' + month;
	  //     var day = lastMontDate.getDate();
	  //     if (day < 10)
	  //       day = '0' + day;
	  //     return year + '-' + month + '-' + day;
	
	  //   }
	
	  //   function getLastMonthDate() {
	
	  //     var date = new Date();
	  //     var dateInt = date.setMonth(date.getMonth() - 1);
	  //     var lastMontDate = new Date(dateInt);
	  //     var year = lastMontDate.getFullYear();
	  //     var month = lastMontDate.getMonth() + 1;
	  //     if (month < 9)
	  //       month = '0' + month;
	  //     var day = lastMontDate.getDate();
	  //     if (day < 10)
	  //       day = '0' + day;
	  //     return year + '-' + month + '-' + day;
	
	  //   }
	
	  //   function threeMonthsBack() {
	  //     var date = new Date();
	  //     date.setMonth(date.getMonth() - 3);
	  //     return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
	  //   }
	
	  //   function getCurrentDate() {
	  //     var date = new Date();
	  //     var year = date.getFullYear();
	  //     var month = date.getMonth() + 1;
	  //     if (month < 9)
	  //       month = '0' + month;
	  //     var day = date.getDate();
	  //     if (day < 10)
	  //       day = '0' + day;
	  //     return year + '-' + month + '-' + day;
	
	  //   }
	
	  //   function oneYearBack() {
	  //     var date = new Date();
	  //     date.setFullYear(date.getFullYear() - 1);
	  //     return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
	  //   };
	
	  //   function convertDateFormat(inputDate) {
	  //     inputDate = new Date(inputDate);
	  //     var day = inputDate.getDate();
	  //     var month = inputDate.getMonth();
	  //     var year = inputDate.getFullYear();
	  //     if (month < 9) {
	  //       month = "0" + (month + 1);
	  //     }
	  //     if (day < 10) {
	  //       day = "0" + day;
	  //     }
	  //     return year + "-" + month + "-" + day;
	  //   }
	
	  //   function fillDiagramData(data) {
	  //     $scope.labels = [];
	  //     $scope.tablearticles = [];
	  //     $scope.totalarticles = 0;
	  //     $scope.diagramData = [[]];
	  //     angular.forEach(data.data, function (value) {
	  //       $scope.totalarticles += value.count;
	  //       $scope.labels.push(value.label);
	  //       $scope.tablearticles.push({
	  //         fecha: value.label,
	  //         count: value.count
	  //       });
	  //       $scope.diagramData[0].push(value.count);
	  //     });
	  //     $scope.tablearticles.reverse();
	  //     $scope.dataLoaded = true
	  //   }
	
	  //   function changeDiagramType(period_type) {
	  //     $scope.dataLoaded = false
	
	  //     $scope.period_type = period_type;
	  //     $scope.diagramData[0] = [];
	  //     $scope.makeDiagram()
	  //   }
	}]);

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	module.exports = "<div class=container> <div class=\"page-header ng-scope\"> <h1>Algolia Reindexing</h1> </div> <br/> <div class=row> <div class=\"form-group col-sm-4 text-center\"> <button class=\"add-article btn btn-default\" ng-click=algoliaArticlesReindexing() style=width:100%>{{ localizedMessages.get('reindexing-articles') }}</button> <div ng-if=algoliaSuccessArticles style=color:#389864>{{ localizedMessages.get('algolia-reindexing-success') }}</div> <div ng-if=algoliaErrorArticles style=color:#db4a4a>{{ localizedMessages.get('algolia-reindexing-error') }}</div> </div> </div> <div class=row> <div class=\"form-group col-sm-4 text-center\"> <button class=\"add-article btn btn-default\" ng-click=algoliaAuthorReindexing() style=width:100%>{{ localizedMessages.get('reindexing-author') }}</button> <div ng-if=algoliaSuccessAuthor style=color:#389864>{{ localizedMessages.get('algolia-reindexing-success') }}</div> <div ng-if=algoliaErrorAuthor style=color:#db4a4a>{{ localizedMessages.get('algolia-reindexing-error') }}</div> </div> </div> <div class=row> <div class=\"form-group col-sm-4 text-center\"> <button class=\"add-article btn btn-default\" ng-click=algoliaTagsReindexing() style=width:100%>{{ localizedMessages.get('reindexing-tags') }}</button> <div ng-if=algoliaSuccessTags style=color:#389864>{{ localizedMessages.get('algolia-reindexing-success') }}</div> <div ng-if=algoliaErrorTags style=color:#db4a4a>{{ localizedMessages.get('algolia-reindexing-error') }}</div> </div> </div> </div> ";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.editions.index', ['security.authorization', 'services.utility', 'resources.Category', 'resources.Article', 'services.formErrors', 'chart.js', 'daterangepicker']);
	
	angular.module('admin.editions.index').config(["$stateProvider", function ($stateProvider) {
	
	    $stateProvider.state('admin.editions', {
	        url: '/editions',
	        title: 'Admin / Edition',
	        views: {
	            'main@': {
	                template: __webpack_require__(230),
	                controller: 'AdminEditionCtrl'
	            }
	        }
	    });
	}]);
	
	angular.module('admin.editions.index').controller('AdminEditionCtrl', ["$scope", "$state", "Article", "Category", "formErrors", "growl", "$location", function ($scope, $state, Article, Category, formErrors, growl, $location) {
	
	    var generateCategoryOptions = function generateCategoryOptions(items, container) {
	        angular.forEach(items, function (item, key) {
	            if (!item.path) {
	                return;
	            }
	            var depth = item.path.split('/').filter(Boolean).length;
	            var indent = new Array(5).join(String.fromCharCode(160));
	            container.push({
	                _id: item.id,
	                path: item.path,
	                sefriendly: item.sefriendly,
	                parent: item.parent,
	                name: item.name,
	                _name: new Array(depth).join(indent) + item.name
	            });
	        });
	        return container;
	    };
	
	    $scope.period_type = 'month';
	
	    $scope.series = [];
	
	    //$scope.orderByField = 'fecha';
	
	    //$scope.reverseSort = true;
	
	    $scope.changeDiagramType = changeDiagramType;
	
	    $scope.editiones = {};
	
	    // $scope.editions = [
	    //     { _id:1, name: 'VAVEL España', sefriendly: 'es' },
	    //     { _id:2, name: 'VAVEL Brasil', sefriendly: 'br' },
	    //     { _id:3, name: 'VAVEL Italia', sefriendly: 'it' },
	    //     { _id:4, name: 'VAVEL Argentina', sefriendly: 'ar' },
	    //     { _id:5, name: 'VAVEL UK', sefriendly: 'en' },
	    //     { _id:6, name: 'VAVEL México', sefriendly: 'mx' },
	    //     { _id:7, name: 'VAVEL USA', sefriendly: 'en-us' },
	    //     { _id:8, name: 'VAVEL Colombia', sefriendly: 'lat' },
	    //     { _id:9, name: 'VAVEL Portugal', sefriendly: 'pt' },
	    //     { _id:10, name: 'VAVEL France', sefriendly: 'fr' },
	    //     { _id:11, name: 'VAVEL Deutsch', sefriendly: 'ru' },
	    //     { _id:11, name: 'VAVEL Arabe', sefriendly: 'arb' }
	    // ];
	
	    $scope.editions = [];
	
	    var options = [];
	
	    Category.getPermittedTree().$promise.then(function (data) {
	        $scope.options = generateCategoryOptions(data, options);
	        $scope.options.forEach(function (category) {
	            if (category.parent == "/") {
	                $scope.editions.push(category);
	            }
	        });
	    });
	
	    $scope.min_date = threeMonthsBack();
	    $scope.max_date = getCurrentDate();
	
	    console.log($scope.period_type);
	
	    $scope.diagramClick = function (points, evt) {
	        console.log(points, evt);
	    };
	
	    $scope.datePickerOptions = {
	        locale: {
	            applyClass: "btn-green",
	            applyLabel: "Apply",
	            cancelLabel: "Cancel",
	            customRangeLabel: "Custom range",
	            format: "YYYY-MM-DD",
	            fromLabel: "From",
	            toLabel: "To"
	        },
	        ranges: {
	            "Last 7 Days": [$scope.min_date, $scope.max_date],
	            "Last 30 Days": [getLastMonthDate(), $scope.max_date],
	            "Last 3 Months": [threeMonthsBack(), $scope.max_date],
	            "Last Year": [oneYearBack(), $scope.max_date]
	        }
	    };
	    $scope.datePicker = {};
	    $scope.datePicker.date = { startDate: $scope.min_date, endDate: $scope.max_date };
	
	    $scope.makeDiagram = function () {
	        var editions = {};
	        angular.forEach($scope.editiones.selected, function (value, key) {
	            editions[key] = value.sefriendly;
	        });
	        Article.getAllEditions({
	            min_date: convertDateFormat($scope.datePicker.date.startDate),
	            max_date: convertDateFormat($scope.datePicker.date.endDate),
	            editions: editions,
	            period_type: $scope.period_type
	        }, fillDiagramData);
	    };
	
	    function getLastWeekDate() {
	        var date = new Date();
	        var dateInt = date.setDate(date.getDate() - 7);
	        var lastMontDate = new Date(dateInt);
	        var year = lastMontDate.getFullYear();
	        var month = lastMontDate.getMonth() + 1;
	        if (month < 9) month = '0' + month;
	        var day = lastMontDate.getDate();
	        if (day < 10) day = '0' + day;
	        return year + '-' + month + '-' + day;
	    }
	
	    function getLastMonthDate() {
	        var date = new Date();
	        var dateInt = date.setMonth(date.getMonth() - 1);
	        var lastMontDate = new Date(dateInt);
	        var year = lastMontDate.getFullYear();
	        var month = lastMontDate.getMonth() + 1;
	        if (month < 9) month = '0' + month;
	        var day = lastMontDate.getDate();
	        if (day < 10) day = '0' + day;
	        return year + '-' + month + '-' + day;
	    }
	
	    function threeMonthsBack() {
	        var date = new Date();
	        date.setMonth(date.getMonth() - 3);
	        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	    }
	
	    function getCurrentDate() {
	        var date = new Date();
	        var year = date.getFullYear();
	        var month = date.getMonth() + 1;
	        if (month < 9) month = '0' + month;
	        var day = date.getDate();
	        if (day < 10) day = '0' + day;
	        return year + '-' + month + '-' + day;
	    }
	
	    function oneYearBack() {
	        var date = new Date();
	        date.setFullYear(date.getFullYear() - 1);
	        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	    };
	
	    function convertDateFormat(inputDate) {
	        inputDate = new Date(inputDate);
	        var day = inputDate.getDate();
	        var month = inputDate.getMonth();
	        var year = inputDate.getFullYear();
	        if (month < 9) {
	            month = "0" + (month + 1);
	        }
	        if (day < 10) {
	            day = "0" + day;
	        }
	        return year + "-" + month + "-" + day;
	    }
	
	    function fillDiagramData(data) {
	        angular.forEach($scope.editiones.selected, function (value) {
	            console.log("value.name>>>>" + value.name);
	
	            if ('es' === value.sefriendly) {
	                $scope.es = [];
	            }
	            if ('br' === value.sefriendly) {
	                $scope.br = [];
	            }
	            if ('it' === value.sefriendly) {
	                $scope.it = [];
	            }
	            if ('ar' === value.sefriendly) {
	                $scope.ar = [];
	            }
	            if ('en' === value.sefriendly) {
	                $scope.en = [];
	            }
	            if ('mx' === value.sefriendly) {
	                $scope.mx = [];
	            }
	            if ('en-us' === value.sefriendly) {
	                $scope.enus = [];
	            }
	            if ('lat' === value.sefriendly) {
	                $scope.lat = [];
	            }
	            if ('pt' === value.sefriendly) {
	                $scope.pt = [];
	            }
	            if ('fr' === value.sefriendly) {
	                $scope.fr = [];
	            }
	            if ('ru' === value.sefriendly) {
	                $scope.ru = [];
	            }
	            if ('arb' === value.sefriendly) {
	                $scope.arb = [];
	            }
	        });
	        $scope.labels = [];
	        $scope.tablas = [];
	        $scope.paises = [];
	        $scope.diagramData = [[]];
	        $scope.totalcountpormes = 0;
	        var countpormes = 0;
	        var difes = 0;var difbr = 0;var difit = 0;var difar = 0;var difen = 0;var difmx = 0;var difenus = 0;var diflat = 0;
	        var difpt = 0;var diffr = 0;var difru = 0;var difarb = 0;
	
	        var xes = 0;var xbr = 0;var xit = 0;var xar = 0;var xen = 0;var xmx = 0;var xenus = 0;var xlat = 0;var xpt = 0;
	        var xfr = 0;var xru = 0;var xarb = 0;
	        var ban = 0;
	        angular.forEach(data.data, function (value) {
	            $scope.labels.push(value.label);
	            countpormes = 0;
	            $scope.paises = [];
	            $scope.paisesdif = [];
	            angular.forEach(value.count, function (count) {
	                //console.log("count.count>>>>"+count.count);
	                //console.log("$scope.totalcountpormes>>>"+$scope.totalcountpormes);
	                countpormes += count.count;
	                $scope.totalcountpormes += count.count;
	                if ('es' === count.edition) {
	                    console.log("edition>" + count.edition + " >count.count>" + count.count + "--difes--" + difes + "-xes-" + xes);
	                    $scope.es.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difes = count.count - xes;
	                    if (xes > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difes });
	                    }
	                    xes = count.count;
	                }
	                if ('br' === count.edition) {
	                    $scope.br.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difbr = count.count - xbr;
	                    if (xbr > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difbr });
	                    }
	                    xbr = count.count;
	                }
	                if ('it' === count.edition) {
	                    $scope.it.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difit = count.count - xit;
	                    if (xit > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difit });
	                    }
	                    xit = count.count;
	                }
	                if ('ar' === count.edition) {
	                    $scope.ar.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difar = count.count - xar;
	                    if (xar > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difar });
	                    }
	                    xar = count.count;
	                }
	                if ('en' === count.edition) {
	                    $scope.en.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difen = count.count - xen;
	                    if (xen > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difen });
	                    }
	                    xen = count.count;
	                }
	                if ('mx' === count.edition) {
	                    $scope.mx.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difmx = count.count - xmx;
	                    if (xmx > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difmx });
	                    }
	                    xmx = count.count;
	                }
	                if ('en-us' === count.edition) {
	                    $scope.enus.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difenus = count.count - xenus;
	                    if (xenus > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difenus });
	                    }
	                    xenus = count.count;
	                }
	                if ('lat' === count.edition) {
	                    $scope.lat.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    diflat = count.count - xlat;
	                    if (xlat > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: diflat });
	                    }
	                    xlat = count.count;
	                }
	                if ('pt' === count.edition) {
	                    $scope.pt.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difpt = count.count - xpt;
	                    if (xpt > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difpt });
	                    }
	                    xpt = count.count;
	                }
	                if ('fr' === count.edition) {
	                    $scope.fr.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    diffr = count.count - xfr;
	                    if (xfr > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: diffr });
	                    }
	                    xfr = count.count;
	                }
	                if ('ru' === count.edition) {
	                    $scope.ru.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difru = count.count - xru;
	                    if (xru > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difru });
	                    }
	                    xru = count.count;
	                }
	                if ('arb' === count.edition) {
	                    $scope.arb.push(count.count);
	                    $scope.paises.push({ edition: count.edition, count: count.count });
	                    difarb = count.count - xarb;
	                    if (xarb > 0) {
	                        $scope.paisesdif.push({ edition: count.edition, count: difarb });
	                    }
	                    xarb = count.count;
	                }
	            });
	            if (ban > 0) {
	                $scope.tablas.push({
	                    fecha: "Dif",
	                    pais: $scope.paisesdif,
	                    totalpormes: ""
	                });
	            }
	
	            ban++;
	            $scope.tablas.push({
	                fecha: value.label,
	                pais: $scope.paises,
	                totalpormes: countpormes
	            });
	        });
	        $scope.tablas.reverse();
	        $scope.series = [];
	        $scope.totalpaises = [];
	        $scope.totalpais = [];
	        $scope.series.push("");
	        angular.forEach($scope.editiones.selected, function (value) {
	            console.log("value.name>>>>" + value.name);
	            $scope.series.push(value.name);
	            if ('es' === value.sefriendly) {
	                $scope.diagramData.push($scope.es);
	                var count = 0;
	                angular.forEach($scope.es, function (countpais) {
	                    console.log("count---->1>>>>" + count);
	                    console.log("countpais---->1>>>>" + countpais);
	                    count += countpais;
	                    console.log("count---->2>>>>" + count);
	                });
	                console.log("count---->3>>>>" + count);
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('br' === value.sefriendly) {
	                $scope.diagramData.push($scope.br);
	                var count = 0;
	                angular.forEach($scope.br, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('it' === value.sefriendly) {
	                $scope.diagramData.push($scope.it);
	                var count = 0;
	                angular.forEach($scope.it, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('ar' === value.sefriendly) {
	                $scope.diagramData.push($scope.ar);
	                var count = 0;
	                angular.forEach($scope.ar, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('en' === value.sefriendly) {
	                $scope.diagramData.push($scope.en);
	                var count = 0;
	                angular.forEach($scope.en, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('mx' === value.sefriendly) {
	                $scope.diagramData.push($scope.mx);
	                var count = 0;
	                angular.forEach($scope.mx, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('en-us' === value.sefriendly) {
	                $scope.diagramData.push($scope.enus);
	                var count = 0;
	                angular.forEach($scope.enus, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('lat' === value.sefriendly) {
	                $scope.diagramData.push($scope.lat);
	                var count = 0;
	                angular.forEach($scope.lat, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('pt' === value.sefriendly) {
	                $scope.diagramData.push($scope.pt);
	                var count = 0;
	                angular.forEach($scope.pt, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('fr' === value.sefriendly) {
	                $scope.diagramData.push($scope.fr);
	                var count = 0;
	                angular.forEach($scope.fr, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('ru' === value.sefriendly) {
	                $scope.diagramData.push($scope.ru);
	                var count = 0;
	                angular.forEach($scope.ru, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	            if ('arb' === value.sefriendly) {
	                $scope.diagramData.push($scope.arb);
	                var count = 0;
	                angular.forEach($scope.arb, function (countpais) {
	                    count += countpais;
	                });
	                $scope.totalpais.push({
	                    edition: value.sefriendly,
	                    count: count
	                });
	            }
	        });
	        console.log("$scope.totalpais>>>>" + $scope.totalpais);
	        console.log("$scope.es>>>>" + $scope.es);
	    }
	
	    function changeDiagramType(period_type) {
	        $scope.period_type = period_type;
	        $scope.diagramData[0] = [];
	    }
	}]);

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = "<div class=container> <div class=row> <div class=col-md-4> <div class=col-md-12> <div class=form-group> <input date-range-picker class=\"form-control date-picker\" type=text ng-model=datePicker.date options=datePickerOptions /> </div> </div> <div class=\"form-group col-md-12\"> <label class=control-label for=parent>Edition:</label> <select type=text multiple=multiple name=parent id=parent class=form-control ng-model=editiones.selected ng-options=\"item as item.name for item in editions\" required size=10> </select> <div class=\"btn btn-default\" ng-click=makeDiagram()>Search Now</div> </div> </div> <div class=\"col-md-8 diagram\"> <div class=btn-group> <div class=\"btn btn-default\" data-ng-class=\"period_type == 'month' ? 'active' : ''\" data-ng-click=\"changeDiagramType('month')\"> Mes </div> </div> <canvas id=line class=\"chart chart-line\" chart-data=diagramData chart-labels=labels chart-series=series chart-click=diagramClick> </canvas> </div> </div> <div class=row> <div class=col-md-12> <table class=\"table table-responsive table-condensed\"> <thead> <tr> <th class=stretch>Paises</th> <th class=stretch ng-show=es>VAVEL España</th> <th class=stretch ng-show=br>VAVEL Brasil</th> <th class=stretch ng-show=it>VAVEL Italia</th> <th class=stretch ng-show=ar>VAVEL Argentina</th> <th class=stretch ng-show=en>VAVEL UK</th> <th class=stretch ng-show=mx>VAVEL México</th> <th class=stretch ng-show=enus>VAVEL USA</th> <th class=stretch ng-show=lat>VAVEL Colombia</th> <th class=stretch ng-show=pt>VAVEL Portugal</th> <th class=stretch ng-show=fr>VAVEL France</th> <th class=stretch ng-show=ru>VAVEL Deutsch</th> <th class=stretch ng-show=arb>VAVEL Arabe</th> <th class=stretch>Por mes</th> </tr> </thead> <tbody> <tr ng-repeat=\"tabla in tablas\"> <td>{{tabla.fecha}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'es'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'br'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'it'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'ar'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'en'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'mx'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'en-us'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'lat'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'pt'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'fr'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'ru'\">{{pais.count}}</td> <td ng-repeat=\"pais in tabla.pais\" ng-show=\"pais.edition === 'arb'\">{{pais.count}}</td> <td>{{tabla.totalpormes}}</td> </tr> <tr> <td>Total</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'es'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'br'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'it'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'ar'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'en'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'mx'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'en-us'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'lat'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'pt'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'fr'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'ru'\">{{paiss.count}}</td> <td ng-repeat=\"paiss in totalpais\" ng-show=\"paiss.edition === 'arb'\">{{paiss.count}}</td> <td>{{totalcountpormes}}</td> </tr> </tbody> </table> </div> </div> </div> ";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.recuentos.index', ['security.authorization', 'services.utility', 'resources.AdminCategory', 'resources.Category', 'resources.Article', 'services.formErrors', 'chart.js', 'services.localizedMessages', 'daterangepicker']);
	
	angular.module('admin.recuentos.index').config(["$stateProvider", function ($stateProvider) {
	
	    $stateProvider.state('admin.recuentos', {
	        url: '/recuentos',
	        title: 'Admin / Recuentos',
	        views: {
	            'main@': {
	                template: __webpack_require__(232),
	                controller: 'AdminRecuentosCtrl'
	            }
	        }
	    });
	}]);
	
	angular.module('admin.recuentos.index').controller('AdminRecuentosCtrl', ["$scope", "$state", "AdminCategory", "searchService", "Category", "Article", "localizedMessages", "formErrors", "$location", function ($scope, $state, AdminCategory, searchService, Category, Article, localizedMessages, formErrors, $location) {
	    $scope.localizedMessages = localizedMessages;
	
	    var generateCategoryOptions = function generateCategoryOptions(items, container) {
	        angular.forEach(items, function (item, key) {
	            if (!item.path) {
	                return;
	            }
	            var depth = item.path.split('/').filter(Boolean).length;
	            var indent = new Array(5).join(String.fromCharCode(160));
	            container.push({
	                _id: item.id,
	                path: item.path,
	                sefriendly: item.sefriendly,
	                parent: item.parent,
	                name: item.name,
	                _name: new Array(depth).join(indent) + item.name
	            });
	            if (item.children) {
	                generateCategoryOptions(item.children, container);
	            }
	        });
	        return container;
	    };
	
	    searchService.setRedirectBase('/admin/recuentos');
	
	    $scope.q = '';
	
	    $scope.period_type = 'month';
	
	    $scope.showCategory = false;
	
	    $scope.categoryName = null;
	
	    $scope.hasEditedName = false;
	
	    $scope.categories = {};
	
	    $scope.diagramData = [[]];
	
	    $scope.orderByField = 'category';
	
	    $scope.reverseSort = true;
	
	    $scope.onSelect = searchService.onSelect;
	
	    $scope.changeDiagramType = changeDiagramType;
	
	    var options = [{
	        _id: 0,
	        path: null,
	        sefriendly: null,
	        parent: null,
	        name: 'Root',
	        _name: 'Root'
	    }];
	
	    Category.getPermittedTree().$promise.then(function (data) {
	        $scope.options = generateCategoryOptions(data, options);
	        if ($scope.options.length > 0) $scope.showCategory = true;
	    });
	
	    // AdminCategory.getTree(function (data) {
	    //     $scope.options = generateCategoryOptions(data, options);
	    //     if ($scope.options.length > 0)
	    //         $scope.showCategory = true;
	    // });
	
	    $scope.rootUrl = '';
	    $scope.data = {
	        name: '',
	        sefriendly: '',
	        parent: ''
	    };
	
	    $scope.changedParent = function () {
	        if ($scope.data.parent) {
	            $scope.categoryName = $scope.data.parent.name;
	        }
	    };
	
	    $scope.min_date = threeMonthsBack();
	    $scope.max_date = getCurrentDate();
	
	    //$scope.series = ['Articles'];
	    console.log($scope.period_type);
	
	    $scope.getAllArticlles = Article.getAllArticles({
	        min_date: $scope.min_date,
	        max_date: $scope.max_date,
	        period_type: $scope.period_type
	    }, fillDiagramData);
	
	    $scope.diagramClick = function (points, evt) {};
	
	    $scope.datePickerOptions = {
	        locale: {
	            applyClass: "btn-green",
	            applyLabel: "Apply",
	            cancelLabel: "Cancel",
	            customRangeLabel: "Custom range",
	            format: "YYYY-MM-DD",
	            fromLabel: "From",
	            toLabel: "To"
	        },
	        ranges: {
	            "Last 7 Days": [$scope.min_date, $scope.max_date],
	            "Last 30 Days": [getLastMonthDate(), $scope.max_date],
	            "Last 3 Months": [threeMonthsBack(), $scope.max_date],
	            "Last Year": [oneYearBack(), $scope.max_date]
	        }
	    };
	    $scope.datePicker = {};
	    $scope.datePicker.date = { startDate: $scope.min_date, endDate: $scope.max_date };
	
	    $scope.makeDiagram = function () {
	        var categories = {};
	        angular.forEach($scope.categories.selected, function (value, key) {
	            categories[key] = value._id;
	        });
	        Article.getAllRecuentos({
	            //min_date: convertDateFormat($scope.datePicker.date.startDate),
	            //max_date: convertDateFormat($scope.datePicker.date.endDate),
	            min_date: $scope.datePicker.date.startDate,
	            max_date: $scope.datePicker.date.endDate,
	            categories: categories,
	            period_type: $scope.period_type
	        }, fillDiagramData);
	    };
	
	    function getLastWeekDate() {
	
	        var date = new Date();
	        var dateInt = date.setDate(date.getDate() - 7);
	        var lastMontDate = new Date(dateInt);
	        var year = lastMontDate.getFullYear();
	        var month = lastMontDate.getMonth() + 1;
	        if (month < 9) month = '0' + month;
	        var day = lastMontDate.getDate();
	        if (day < 10) day = '0' + day;
	        return year + '-' + month + '-' + day;
	    }
	
	    function getLastMonthDate() {
	
	        var date = new Date();
	        var dateInt = date.setMonth(date.getMonth() - 1);
	        var lastMontDate = new Date(dateInt);
	        var year = lastMontDate.getFullYear();
	        var month = lastMontDate.getMonth() + 1;
	        if (month < 9) month = '0' + month;
	        var day = lastMontDate.getDate();
	        if (day < 10) day = '0' + day;
	        return year + '-' + month + '-' + day;
	    }
	
	    function threeMonthsBack() {
	        var date = new Date();
	        date.setMonth(date.getMonth() - 3);
	        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	    }
	
	    function getCurrentDate() {
	        var date = new Date();
	        var year = date.getFullYear();
	        var month = date.getMonth() + 1;
	        if (month < 9) month = '0' + month;
	        var day = date.getDate();
	        if (day < 10) day = '0' + day;
	        return year + '-' + month + '-' + day;
	    }
	
	    function oneYearBack() {
	        var date = new Date();
	        date.setFullYear(date.getFullYear() - 1);
	        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	    };
	
	    function convertDateFormat(inputDate) {
	        inputDate = new Date(inputDate);
	        var day = inputDate.getDate();
	        var month = inputDate.getMonth();
	        var year = inputDate.getFullYear();
	        if (month < 9) {
	            month = "0" + (month + 1);
	        }
	        if (day < 10) {
	            day = "0" + day;
	        }
	        return year + "-" + month + "-" + day;
	    }
	
	    function fillDiagramData(data) {
	        console.log(data.data);
	        $scope.labels = [];
	        $scope.fechasdif = [];
	        $scope.tablearticles = [];
	        $scope.tablearticlescat = [];
	        $scope.tablearticlescatgraf = [];
	        $scope.diagramData = [[]];
	        $scope.series = [];
	        $scope.series.push("");
	        angular.forEach($scope.categories.selected, function (cat) {
	            $scope.series.push(cat.name);
	            $scope.tablearticlescat = [];
	            $scope.tablearticlescatgraf = [];
	            var dif = 0;
	            var x = 0;
	            angular.forEach(data.data, function (value) {
	
	                angular.forEach(value.count, function (count) {
	                    if (cat._id == count.category) {
	                        console.log("id>" + cat._id + " >name>" + cat.name + "--dif--" + dif + "-x-" + x);
	                        dif = count.count - x;
	                        if (x > 0) {
	                            $scope.tablearticlescat.push(dif);
	                        }
	                        $scope.tablearticlescat.push(count.count);
	                        $scope.tablearticlescatgraf.push(count.count);
	                        x = count.count;
	                    }
	                });
	            });
	            $scope.diagramData.push($scope.tablearticlescatgraf);
	            $scope.tablearticles.push({
	                category: cat.name,
	                count: $scope.tablearticlescat.reverse()
	            });
	        });
	
	        var ban = 0;
	        angular.forEach(data.data, function (value) {
	            $scope.labels.push(value.label);
	            if (ban > 0) {
	                $scope.fechasdif.push("Dif");
	            }
	            $scope.fechasdif.push(value.label);
	            ban++;
	        });
	        console.log("$scope.series->>>>" + JSON.stringify($scope.series));
	        $scope.fechasdif.reverse();
	    }
	
	    function changeDiagramType(period_type) {
	        $scope.period_type = period_type;
	        $scope.diagramData[0] = [];
	    }
	}]);

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = "<div class=container> <div class=row> <div class=col-md-4> <div class=col-md-12> <h4>{{localizedMessages.get('recounts')}}</h4> </div> <div class=col-md-12> <div class=form-group> <input date-range-picker class=\"form-control date-picker\" type=text ng-model=datePicker.date options=datePickerOptions /> </div> </div> <div class=\"form-group col-md-12\" ng-if=showCategory> <label class=control-label for=parent>Categories:</label> <select type=text multiple=multiple name=parent id=parent class=form-control ng-model=categories.selected ng-options=\"item as item._name for item in options\" required size=10> </select> <div class=\"btn btn-default\" ng-click=makeDiagram()>{{localizedMessages.get('search')}}</div> </div> </div> <div class=\"col-md-8 diagram\"> <div class=btn-group> <div class=\"btn btn-default\" data-ng-class=\"period_type == 'month' ? 'active' : ''\" data-ng-click=\"changeDiagramType('month')\"> {{localizedMessages.get('month')}} </div> <div class=\"btn btn-default\" data-ng-class=\"period_type == 'week' ? 'active' : ''\" data-ng-click=\"changeDiagramType('week')\"> {{localizedMessages.get('week')}} </div> <div class=\"btn btn-default\" data-ng-class=\"period_type == 'day' ? 'active' : ''\" data-ng-click=\"changeDiagramType('day')\"> {{localizedMessages.get('day')}} </div> <div class=\"btn btn-default\" data-ng-class=\"period_type == 'hour' ? 'active' : ''\" data-ng-click=\"changeDiagramType('hour')\"> {{localizedMessages.get('hour')}} </div> </div> <canvas id=line class=\"chart chart-line\" chart-data=diagramData chart-labels=labels chart-legend=true chart-series=series chart-click=diagramClick> </canvas> </div> </div> <div class=row> <div class=col-md-12> <span class=label>Ordered By: {{orderByField}}, Reverse Sort: {{reverseSort}}</span><br><br> <table class=\"table table-responsive table-condensed\"> <thead> <tr> <th>{{localizedMessages.get('categories')}}</th> <th ng-repeat=\"label in fechasdif  track by $index\">{{label}}</th> </tr> </thead> <tbody> <tr ng-repeat=\"tablearticle in tablearticles\"> <td>{{tablearticle.category}}</td> <td ng-repeat=\"item in tablearticle.count track by $index\">{{item}}</td> </tr> </tbody> </table> </div> </div> </div> ";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.gallery.index', ['security.authorization', 'config', 'services.utility', 'resources.AdminGroup', 'resources.AdminUser', 'services.adminResource', 'services.search', 'filters.timeAgo', 'services.algoliaResource', 'directives.croppic', 'resources.Album', 'resources.Image', 'ngFileUpload', 'angular-growl', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.gallery', {
	    url: '/gallery',
	    title: 'Manage gallery',
	    views: {
	      'main@': {
	        template: __webpack_require__(234),
	        controller: 'GalleryIndexCtrl',
	        resolve: {
	          groups: ["AdminGroup", function (AdminGroup) {
	            return AdminGroup.query().$promise;
	          }]
	        }
	      }
	    },
	    resolve: {
	      initSearch: ["searchService", "AdminUser", function (searchService, AdminUser) {
	        searchService.setSearchFn(AdminUser.search);
	        searchService.setRedirectBase('/admin/gallery/edit');
	      }]
	    }
	  });
	}]).controller('GalleryIndexCtrl', ["$scope", "$route", "APP_IMG_URLS", "$location", "$log", "utility", "Upload", "growl", "Album", "adminResource", "AdminUser", "algoliaResource", "searchService", "groups", "localizedMessages", function ($scope, $route, APP_IMG_URLS, $location, $log, utility, Upload, growl, Album, adminResource, AdminUser, algoliaResource, searchService, groups, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  $scope.album = { title: "", description: "" };
	  $scope.image = { title: "", description: "" };
	  $scope.imgUrl = APP_IMG_URLS['base'];
	  $scope.file = {};
	  $scope.fileType = "";
	
	  var slugify = __webpack_require__(152);
	
	  $scope.search = searchService.search;
	  $scope.groups = groups.data;
	  $scope.images = [];
	  $scope.albums = [];
	
	  $scope.deleteImage = function (data) {
	    var obj = $scope;
	    if (confirm("Chcesz usunąć obraz?")) {
	      adminResource.deleteImage(data._id).then(function (result) {
	        growl.info('Image Deleted!');
	        fetchData();
	      });
	    }
	  };
	  $scope.deleteAlbum = function (data) {
	    console.log(data);
	    var obj = $scope;
	    if (confirm("Czy chcesz usunąć album i wszystkie jego obrazy?")) {
	      adminResource.deleteAlbum(data._id).then(function (result) {
	        growl.info('Album Deleted!');
	        fetchData();
	      });
	    }
	  };
	
	  $scope.submitAlbum = function ($event) {
	    var obj = $scope;
	    if ($scope.album && $scope.album.image) {
	      $scope.album.file = $scope.album.image;
	    }
	    if ($scope.album._id) {
	      adminResource.editAlbum($scope.album).then(function (result) {
	        growl.info('Album Updated!');
	        console.log("r:", result);
	        obj.album = {};
	        $scope.a_file = {};
	        setTimeout(function () {
	          return location.reload();
	        }, 2000);
	      });
	    } else {
	      var newObj = Object.assign($scope.album, {
	        slug: slugify($scope.album.title.replace(/<.+?>/g, "").replace(/  /g, " "))
	      });
	      adminResource.addAlbum(newObj).then(function (result) {
	        growl.info('Album Created!');
	        console.log("r:", result);
	        obj.album = {};
	        $scope.a_file = {};
	        setTimeout(function () {
	          return location.reload();
	        }, 2000);
	      });
	    }
	  };
	  $scope.submitImage = function ($event) {
	    var obj = $scope;
	    if ($scope.image && $scope.image.image) {
	      $scope.image.file = $scope.image.image;
	    }
	    if ($scope.image._id) {
	      adminResource.editImage($scope.image).then(function (result) {
	        growl.info('Image Updated!');
	        obj.image = {};
	        $scope.file = {};
	        setTimeout(function () {
	          return location.reload();
	        }, 2000);
	      });
	    } else {
	      if (!$scope.file || !$scope.file.name || !$scope.image.title || !$scope.image.description || !$scope.image.album_id) {
	        growl.error('Invalid data!');
	        return;
	      }
	      var newObj = Object.assign($scope.image, {
	        slug: slugify($scope.album.title.replace(/<.+?>/g, "").replace(/  /g, " "))
	      });
	      adminResource.addImage(newObj).then(function (result) {
	        growl.info('Image Created!');
	        console.log("r:", result);
	        $scope.file = {};
	        obj.image = {};
	        //fetchData();
	        setTimeout(function () {
	          return location.reload();
	        }, 2000);
	      });
	    }
	  };
	
	  var fetchData = function fetchData() {
	    $scope.a_uploading = false;
	    $scope.a_thumbnail = "";
	    $scope.uploading = false;
	    $scope.thumbnail = "";
	    $scope.album.image = "";
	    $scope.image.image = "";
	    adminResource.getAlbums().then(function (data) {
	      $scope.albums = data;
	
	      adminResource.getImages().then(function (data2) {
	        $scope.images = data2;
	        $scope.images.map(function (img) {
	          var album = $scope.albums.filter(function (obj) {
	            return img.album_id == obj._id;
	          })[0];
	          img.album = album;
	          return img;
	        });
	        //update url in browser addr bar
	        //$location.search($scope.query);
	      }, function (e) {
	        $log.error(e);
	      });
	      //update url in browser addr bar
	      $location.search($scope.query);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  $scope.$watchCollection('query', function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	    fetchData();
	  });
	
	  $scope.sorts = [{ label: 'id \u25B2', value: "_uid" }, { label: 'id \u25BC', value: "-_uid" }, { label: 'username \u25B2', value: "username" }, { label: 'username \u25BC', value: "-username" }, { label: 'email \u25B2', value: "email" }, { label: 'email \u25BC', value: "-email" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  $scope.query = $location.search();
	  $scope.query.limit = $scope.query.limit || 10;
	  $scope.query.is_active = '';
	  $scope.query.group = '';
	  $scope.query.author = '';
	
	  fetchData();
	
	  $scope.selectUpload = function (type) {
	    $scope.fileType = type;
	  };
	  $scope.$watch('file', function (file) {
	    $scope.upload(file);
	  });
	  $scope.$watch('a_file', function (file) {
	    $scope.a_upload(file);
	  });
	
	  $scope.upload = function (file) {
	    console.log("upload");
	    if (!file.name) return;
	    $scope.uploading = true;
	    $scope.thumbnail = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
	      $scope.image.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.a_upload = function (file) {
	    if (!file.name) return;
	    $scope.a_uploading = true;
	    $scope.a_thumbnail = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.a_uploading = false;
	      $scope.a_thumbnail = APP_IMG_URLS.base + resp.data.filename;
	      $scope.album.image = resp.data.filename;
	    }, function (resp) {
	      $scope.a_uploading = false;
	      $scope.a_thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.editImage = function (img) {
	    img.date = new Date(img.date);
	    $scope.image = angular.copy(img);
	  };
	  $scope.editAlbum = function (album) {
	    $scope.album = angular.copy(album);
	  };
	}]);

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports = "<link rel=stylesheet type=text/css href=//cdn.datatables.net/1.10.22/css/jquery.dataTables.min.css> <script charset=utf8 src=//cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js></script> <script> $(document).ready( function () {\n    var localePL = {language: {\n      \"decimal\":        \"\",\n      \"emptyTable\":     \"Pane niedostępne w tabeli\",\n      \"info\":           \"Showing _START_ to _END_ of _TOTAL_ entries\",\n      \"infoEmpty\":      \"wyświetlanie od 0 do 0 z 0 wpisów\",\n      \"infoFiltered\":   \"Przefiltrowano z MAX wszystkich wpisów\",\n      \"infoPostFix\":    \"\",\n      \"thousands\":      \",\",\n      \"lengthMenu\":     \"Pokaż pozycje _MENU_\",\n      \"loadingRecords\": \"Ładowanie...\",\n      \"processing\":     \"Przetwarzanie...\",\n      \"search\":         \"Szukaj:\",\n      \"zeroRecords\":    \"Nie znaleziono pasujacego wyniku\",\n      \"paginate\": {\n          \"first\":      \"Pierwszy\",\n          \"last\":       \"Ostatni\",\n          \"next\":       \"Następny\",\n          \"previous\":   \"Poprzedni\"\n      },\n      \"aria\": {\n          \"sortAscending\":  \": Aktywuj, aby posortować kolumny rosnąco\",\n          \"sortDescending\": \": Aktywuj, aby posortować kolumny malejąco \"\n      }\n    }}\n    setTimeout(() => {\n      $('#myTable').dataTable(localePL);\n      $('#myTable2').dataTable(localePL);\n    }, 1000)\n  } ); </script> <div class=row id=admin-users-index> <div class=col-xs-12> <div class=page-header> <h1>Obrazy</h1> </div> <form class=filters> <div class=page-header> <h3>Dodaj nowy obraz</h3> </div> <div class=row> <label>Tytuł</label> <input class=form-control ng-model=image.title /> <br/> <label>Opis</label> <br/> <input class=form-control ng-model=image.description /> <br/> <label>Data</label> <input class=form-control type=date ng-model=image.date /> <br/> <label>Album</label> <select class=form-control ng-model=image.album_id> <option ng-repeat=\"obj in albums\" ng-bind=obj.title value={{obj._id}}></option> </select> </div> <div class=row> {{ file.name }} <figure ng-click=\"selectUpload('image')\" class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-upload ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative;border:solid 1px #b49999;border-radius:10px;width:15%;margin-top:1%\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img ngf-thumbnail=\"thumbnail || (data.image ? imgUrl + data.image : false) || imgUrl + 'upload-iworis-1603084085694.png'\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15)\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <br/> <input type=button class=\"btn btn-primary\" value=\"{{image._id ? 'Aktualizacja' : 'Stwórz'}}\" ng-click=this.submitImage() /> </div> </form> <table class=\"table table-striped\" id=myTable> <thead> <tr> <th></th> <th>Tytuł</th> <th>opis</th> <th>data</th> <th style=width:100px>Plik</th> <th>Album</th> </tr> </thead> <tbody> <tr ng-repeat=\"img in images\"> <td> <input type=button class=\"btn btn-secondary\" value=Edytować ng-click=this.editImage(img) /> <input type=button class=\"btn btn-danger\" value=Usunąć ng-click=this.deleteImage(img) /> </td> <td>{{img.title}}</td> <td>{{img.description}}</td> <td>{{img.date | date: 'dd MMM yyyy'}}</td> <td> <img style=position:relative;object-fit:cover;width:100%;max-width:200px src=https://d3h1htyejpzygs.cloudfront.net/media/{{img.file}} /> </td> <td>{{img.album.title}}</td> </tr> </tbody> </table> <div class=page-header> <h1>Albums</h1> </div> <form class=filters> <div class=row> <div class=page-header> <h3>Dodaj nowy album</h3> </div> <label>Tytuł albumu</label><br/> <input class=form-control ng-model=album.title /> <label>opis</label><br/> <input class=form-control ng-model=album.description /> {{ a_file.name }} <figure ng-click=\"selectUpload('album')\" class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file-a-upload ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=a_file name=a_file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles style=\"background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative;border:solid 1px #b49999;border-radius:10px;width:15%;margin-top:1%\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-a-upload> <img ngf-thumbnail=\"a_thumbnail || (data.image ? imgUrl + data.image : false) || imgUrl + 'upload-iworis-1603084085694.png'\" title=\"\" alt=\"\" class=article-image style=\"max-width:100%;margin:0 auto;text-align:center;border:none;-webkit-box-shadow:0 0 0 transparent;-o-box-shadow:0 0 0 transparent;box-shadow:0 0 0 rgba(0,0,0,.15)\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=a_uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> <br/> <input type=button class=\"btn btn-primary\" value=\"{{album._id ? 'Aktualizacja' : 'Stwórz'}}\" ng-click=this.submitAlbum() /> </div> </form> <div class=row> <div class=page-header> <h3>Album z okładką</h3> </div> </div> <table class=\"table table-striped\" id=myTable2> <thead> <tr> <th></th> <th>Tytuł</th> <th>Opis</th> <th>Plik</th> </tr> </thead> <tbody> <tr ng-repeat=\"obj in albums\"> <td> <input type=button class=\"btn btn-secondary\" value=Edytować ng-click=this.editAlbum(obj) /> <input type=button class=\"btn btn-danger\" value=Usunąć ng-click=this.deleteAlbum(obj) /> </td> <td>{{obj.title}}</td> <td>{{obj.description}}</td> <td> <img style=position:relative;object-fit:cover;width:100%;max-width:200px src=https://d3h1htyejpzygs.cloudfront.net/media/{{obj.file}} /> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.gallery', ['admin.gallery.index']
	// 'admin.gallery.add',
	//'admin.gallery.detail'
	);

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.groups.add', ['security.authorization', 'services.utility', 'services.adminResource', 'directives.serverError', 'resources.AdminGroup', 'ui.bootstrap.dropdown', 'services.formErrors']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.groups.add', {
	    url: '/add',
	    title: 'Account Groups / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(237),
	        controller: 'AccountGroupAddCtrl'
	        // resolve: {
	        //   categories: function(adminResource) {
	        //     return adminResource.getCategoriesTree({path: '/', depth: 2});
	        //   }
	        // }
	      }
	    }
	  });
	}]).controller('AccountGroupAddCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "STATUSES", "AdminGroup", "formErrors", "growl", "localizedMessages", function ($scope, $route, $location, $log, utility, adminResource, STATUSES, AdminGroup, formErrors, growl, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  adminResource.getCategoriesTree({ path: '/', depth: 2 }).then(function (categories) {
	    $scope.categories = categories;
	  });
	
	  $scope.group = {
	    statuses: [],
	    categories: []
	  };
	  $scope.statusModel = [];
	  $scope.STATUSES = STATUSES;
	  $scope.selectSettings = {
	    closeList: false
	  };
	  // local vars
	  $scope.isChecked = function (id) {
	    return ~$scope.group.categories.indexOf(id) || ~$scope.group.categories.indexOf(id.toString());
	  };
	  $scope.selectAllStatus = function () {
	    $scope.group.statuses = STATUSES;
	  };
	  $scope.submit = function () {
	    var data = angular.copy($scope.group);
	    data.sefriendly = data.name.replace(/[^A-Za-z0-9\s-]/g, '').replace(/[\s-]+/g, '-');
	    data.statuses = data.statuses.map(function (status) {
	      return status.id;
	    });
	    AdminGroup.save(data, function (result) {
	      growl.info('Group saved!');
	      $location.path('/admin/groups/' + result._id);
	    }, formErrors.growlErrors);
	  };
	  $scope.changeStatus = function () {
	    $scope.statusAlerts = [];
	    if ($scope.selectedStatus && $scope.selectedStatus._id) {
	      if ($scope.selectedStatus._id === $scope.group.status.id) {
	        // status selected is the current status
	        $scope.statusAlerts.push({ type: 'danger', msg: 'That is the current status.' });
	      } else {
	        // update status
	        var data = {
	          id: $scope.selectedStatus._id,
	          name: $scope.selectedStatus.name
	        };
	        adminResource.newAccountGroupStatus($scope.group._id, data).then(function (result) {
	          if (result.success) {
	            deserializeAccountGroup(result.AccountGroup);
	          } else {
	            //error due to server side validation
	            angular.forEach(result.errors, function (err, index) {
	              $scope.statusAlerts.push({ type: 'danger', msg: err });
	            });
	          }
	        }, function (x) {
	          $scope.statusAlerts.push({ type: 'danger', msg: 'Error adding new status: ' + x });
	        });
	      }
	    } else {
	      //no status is selected
	      $scope.statusAlerts.push({ type: 'danger', msg: 'Please choose a status.' });
	    }
	  };
	
	  $scope.saveStatus = function () {
	    var data = $scope.group.statuses.length === STATUSES.length ? ['*'] : $scope.group.statuses;
	    adminResource.saveAccountGroupStatus($scope.group._id, data).then(function (result) {
	      if (result.success) {
	        //deserializeAccountGroup(result.AccountGroup);
	        $scope.statusAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	      } else {
	        //error due to server side validation
	        angular.forEach(result.errors, function (err, index) {
	          $scope.statusAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.statusAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x });
	    });
	  };
	
	  $scope.toggleNode = function (node) {
	    var modelValue = node.$nodeScope.$modelValue;
	    var pathLength = modelValue.path.split('/').filter(Boolean).length;
	    var objPath = 'children' + new Array(pathLength).join('.[0].children');
	    var children = {};
	
	    adminResource.getCategoriesTree({ path: modelValue.path, depth: 2 }).then(function (result) {
	      if (!result.length) {
	        return;
	      }
	
	      result = result[0];
	
	      modelValue.children = _.get(result, objPath);
	      node.toggle();
	    });
	  };
	
	  var categorySelection = function categorySelection(children) {
	    for (var i = 0; i < children.length; i++) {
	      $log.log('categorySelection---------->' + JSON.stringify(children[i]));
	      $scope.group.categories.push(children[i].id.toString());
	      if (children[i].children.length > 0) {
	        categorySelection(children[i].children);
	      }
	    }
	  };
	  var categoryDeSelection = function categoryDeSelection(children) {
	    for (var i = 0; i < children.length; i++) {
	      $scope.group.categories.splice($scope.group.categories.indexOf(children[i].id.toString()), 1);
	      if (children[i].children.length > 0) {
	        categoryDeSelection(children[i].children);
	      }
	    }
	  };
	
	  $scope.toggleCategorySelection = function (categories) {
	    var idx = $scope.group.categories.indexOf(categories.id.toString());
	    $log.log('');
	    if (idx > -1) {
	      $scope.group.categories.splice(idx, 1);
	      if (categories.children.length > 0) {
	        categoryDeSelection(categories.children);
	      }
	    } else {
	      $scope.group.categories.push(categories.id.toString());
	      if (categories.children.length > 0) {
	        categorySelection(categories.children);
	      }
	    }
	  };
	
	  $scope.saveCategories = function () {
	    adminResource.saveAccountGroupCategories($scope.group._id, $scope.group.categories).then(function (result) {
	      if (result.success) {
	        $scope.categoryAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	      } else {
	        //error due to server side validation
	        angular.forEach(result.errors, function (err, index) {
	          $scope.categoryAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.categoryAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x });
	    });
	  };
	
	  //initialize
	  // deserializeData(data);
	}]);

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-groups-detail> <div class=col-xs-12> <div class=page-header> <h1><a href=/admin/groups>Account Groups</a> / Add new</h1> </div> <form novalidate=\"\" name=detailForm ng-submit=submit()><fieldset> <legend>Details</legend> <alert ng-repeat=\"alert in detailAlerts\" type={{alert.type}} close=closeDetailAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.name)}\"> <label class=control-label for=name>Name:</label> <input type=text name=name id=name class=form-control ng-model=group.name required> <span class=help-block ng-show=\"showError(detailForm.name, 'required')\">This field is required</span> </div> <legend>Allowed statuses</legend> <div class=form-group> <label class=control-label for=name>Statuses:</label> <oi-select name=statuses oi-options=\"item.value for item in STATUSES track by item.id\" ng-model=group.statuses placeholder=\"Select status\" multiple=multiple></oi-select> </div> <legend>Categories</legend> <alert ng-repeat=\"alert in categoryAlerts\" type={{alert.type}} close=closeCategoryAlert($index)>{{alert.msg}}</alert> <div class=form-group> <div ui-tree id=tree-root> <ol ui-tree-nodes ng-model=categories> <li ng-repeat=\"category in categories\" ui-tree-node data-nodrag data-collapsed={{!!category.children.length}} ng-include=\"'checkbox_nodes.tpl.html'\"> </li> </ol> </div> </div> <div class=form-group> <button type=submit class=\"btn btn-primary\">Save</button> </div> </fieldset></form> </div> </div> <script type=text/ng-template id=checkbox_nodes.tpl.html> <div ui-tree-handle class=\"tree-node tree-node-content\">\r\n        <input type=\"checkbox\" ng-click=\"toggleCategorySelection(category)\" ng-checked=\"isChecked(category.id)\">\r\n        <div class=\"label-container\">\r\n            <a href=\"#\" data-nodrag class=\"angular-ui-tree-label\">{{category.name}}</a>\r\n        </div>\r\n        <a class=\"pull-right btn btn-default btn-xs\" data-nodrag ng-click=\"toggleNode(this)\"\r\n           ng-class=\"{\r\n            'hidden': !category.children.length\r\n           }\"\r\n           style=\"margin-right: 8px;\">\r\n            <span class=\"glyphicon\"\r\n                  ng-class=\"{\r\n                    'glyphicon-chevron-left': collapsed,\r\n                    'glyphicon-chevron-down': !collapsed\r\n                  }\">\r\n            </span>\r\n        </a>\r\n    </div>\r\n    <ol ui-tree-nodes=\"\" ng-model=\"category.children\" ng-class=\"{hidden: collapsed}\">\r\n        <li ng-repeat=\"category in category.children\" ui-tree-node data-nodrag data-collapsed=\"{{!!category.children.length}}\" data-nodrag ng-include=\"'checkbox_nodes.tpl.html'\">\r\n        </li>\r\n    </ol> </script> ";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.groups.detail', ['security.authorization', 'services.utility', 'services.adminResource', 'directives.serverError', 'ui.bootstrap.dropdown', 'services.formErrors', 'resources.Category']);
	
	angular.module('admin.groups.detail').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.groups.edit', {
	    url: '/edit/:id',
	    title: 'Account Groups / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(239),
	        controller: 'AccountGroupsDetailCtrl',
	        resolve: {
	          group: ["$stateParams", "adminResource", function ($stateParams, adminResource) {
	            return adminResource.findAccountGroup($stateParams.id);
	          }],
	          categories: ["adminResource", function (adminResource) {
	            return adminResource.getCategoriesTree({ path: '/', depth: 2 });
	          }]
	        }
	      }
	    }
	  });
	}]);
	
	angular.module('admin.groups.detail').controller('AccountGroupsDetailCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "group", "categories", "STATUSES", "AdminGroup", "formErrors", "growl", "localizedMessages", function ($scope, $route, $location, $log, utility, adminResource, group, categories, STATUSES, AdminGroup, formErrors, growl, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  STATUSES = STATUSES.map(function (status) {
	    return Object.assign(status, { value: localizedMessages.get(status.value) });
	  });
	  $scope.statusModel = [];
	  $scope.STATUSES = STATUSES;
	  $scope.categories = categories;
	  $scope.selectSettings = {
	    closeList: false
	  };
	
	  // local vars
	  var deserializeData = function deserializeData(data) {
	    deserializeAccountGroup(data.record || data);
	  };
	  var deserializeAccountGroup = function deserializeAccountGroup(data) {
	    if (data.statuses.length && data.statuses[0] === '*') {
	      data.statuses = STATUSES;
	    } else {
	      data.statuses = data.statuses.map(function (stat) {
	        return _.find(STATUSES, { id: stat });
	      });
	    }
	
	    data.categories = data.categories || [];
	    $scope.group = data;
	  };
	
	  $scope.submit = function () {
	    var data = angular.copy($scope.group);
	    data.statuses = data.statuses.map(function (status) {
	      $log.log('submit----------1>' + JSON.stringify(status));
	      if (status) {
	        return status.id;
	      }
	    });
	    $log.log('submit----------1>' + JSON.stringify(data));
	    AdminGroup.update(data, function (result) {
	      growl.info('Group saved!');
	      // $location.path('/admin/groups/edit/' + result._id);
	    }, formErrors.growlErrors);
	  };
	  $scope.delete = function (group) {
	    if (!confirm('Are you sure you want to delete this group?')) {
	      return;
	    }
	    AdminGroup.delete({ id: group.id }, function (result) {
	      setTimeout(function () {
	        growl.info('Group removed!');
	        $location.path('/admin/groups');
	      }, 1000);
	    }, formErrors.growlErrors);
	  };
	
	  $scope.isChecked = function (id) {
	    return ~$scope.group.categories.indexOf(id) || ~$scope.group.categories.indexOf(id.toString());
	  };
	  $scope.selectAllStatus = function () {
	    $scope.group.statuses = STATUSES;
	  };
	  $scope.changeStatus = function () {
	    $scope.statusAlerts = [];
	    if ($scope.selectedStatus && $scope.selectedStatus._id) {
	      if ($scope.selectedStatus._id === $scope.group.status.id) {
	        // status selected is the current status
	        $scope.statusAlerts.push({ type: 'danger', msg: 'That is the current status.' });
	      } else {
	        // update status
	        var data = {
	          id: $scope.selectedStatus._id,
	          name: $scope.selectedStatus.name
	        };
	        adminResource.newAccountGroupStatus($scope.group.id, data).then(function (result) {
	          if (result.success) {
	            deserializeAccountGroup(result.AccountGroup);
	          } else {
	            //error due to server side validation
	            angular.forEach(result.errors, function (err, index) {
	              $scope.statusAlerts.push({ type: 'danger', msg: err });
	            });
	          }
	        }, function (x) {
	          $scope.statusAlerts.push({ type: 'danger', msg: 'Error adding new status: ' + x });
	        });
	      }
	    } else {
	      //no status is selected
	      $scope.statusAlerts.push({ type: 'danger', msg: 'Please choose a status.' });
	    }
	  };
	  $scope.deleteAccountGroup = function () {
	    $scope.deleteAlerts = [];
	    if (confirm('Are you sure?')) {
	      adminResource.deleteAccountGroup($scope.group.id).then(function (result) {
	        if (result.success) {
	          //redirect to admin groups index page
	          $location.path('/admin/groups');
	        } else {
	          //error due to server side validation
	          angular.forEach(result.errors, function (err, index) {
	            $scope.deleteAlerts.push({ type: 'danger', msg: err });
	          });
	        }
	      }, function (x) {
	        $scope.deleteAlerts.push({ type: 'danger', msg: 'Error deleting admin group: ' + x });
	      });
	    }
	  };
	
	  $scope.saveStatus = function () {
	    var data = $scope.group.statuses.length === STATUSES.length ? ['*'] : $scope.group.statuses;
	    adminResource.saveAccountGroupStatus($scope.group.id, data).then(function (result) {
	      if (result.success) {
	        //deserializeAccountGroup(result.AccountGroup);
	        $scope.statusAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	      } else {
	        //error due to server side validation
	        angular.forEach(result.errors, function (err, index) {
	          $scope.statusAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.statusAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x });
	    });
	  };
	
	  $scope.toggleNode = function (node) {
	    var modelValue = node.$nodeScope.$modelValue;
	    var pathLength = modelValue.path.split('/').filter(Boolean).length;
	    var objPath = 'children' + new Array(pathLength).join('.[0].children');
	    var children = {};
	
	    adminResource.getCategoriesTree({ path: modelValue.path, depth: 2 }).then(function (result) {
	      if (!result.length) {
	        return;
	      }
	
	      result = result[0];
	
	      modelValue.children = _.get(result, objPath);
	      node.toggle();
	    });
	  };
	
	  var categorySelection = function categorySelection(children) {
	    for (var i = 0; i < children.length; i++) {
	      $log.log('categorySelection---------->' + JSON.stringify(children[i]));
	      $scope.group.categories.push(children[i].id.toString());
	      if (children[i].children.length > 0) {
	        categorySelection(children[i].children);
	      }
	    }
	  };
	  var categoryDeSelection = function categoryDeSelection(children) {
	    for (var i = 0; i < children.length; i++) {
	      $scope.group.categories.splice($scope.group.categories.indexOf(children[i].id.toString()), 1);
	      if (children[i].children.length > 0) {
	        categoryDeSelection(children[i].children);
	      }
	    }
	  };
	
	  $scope.toggleCategorySelection = function (categories) {
	    var idx = $scope.group.categories.indexOf(categories.id.toString());
	    $log.log('');
	    if (idx > -1) {
	      $scope.group.categories.splice(idx, 1);
	      if (categories.children.length > 0) {
	        categoryDeSelection(categories.children);
	      }
	    } else {
	      $scope.group.categories.push(categories.id.toString());
	      if (categories.children.length > 0) {
	        categorySelection(categories.children);
	      }
	    }
	  };
	
	  $scope.saveCategories = function () {
	    adminResource.saveAccountGroupCategories($scope.group.id, $scope.group.categories).then(function (result) {
	      if (result.success) {
	        $scope.categoryAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	      } else {
	        //error due to server side validation
	        angular.forEach(result.errors, function (err, index) {
	          $scope.categoryAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.categoryAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x });
	    });
	  };
	
	  //initialize
	  deserializeData(group);
	}]);

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-groups-detail> <div class=col-xs-12> <div class=page-header> <button class=\"btn btn-danger pull-right\" ng-click=delete(group)>Delete</button> <h1><a href=/admin/groups>Groups</a> / {{group.name}}</h1> </div> <form novalidate=\"\" name=detailForm ng-submit=submit()><fieldset> <legend>Details</legend> <alert ng-repeat=\"alert in detailAlerts\" type={{alert.type}} close=closeDetailAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(detailForm.name)}\"> <label class=control-label for=name>Name:</label> <input type=text name=name id=name class=form-control ng-model=group.name required> <span class=help-block ng-show=\"showError(detailForm.name, 'required')\">This field is required</span> </div> <legend>Allowed statuses</legend> <div class=form-group> <label class=control-label for=name>Statuses:</label> <oi-select name=statuses oi-options=\"item.value for item in STATUSES track by item.id\" ng-model=group.statuses placeholder=\"Select status\" multiple=multiple></oi-select> </div> <legend>Categories</legend> <alert ng-repeat=\"alert in categoryAlerts\" type={{alert.type}} close=closeCategoryAlert($index)>{{alert.msg}}</alert> <div class=form-group> <div ui-tree id=tree-root> <ol ui-tree-nodes ng-model=categories> <li ng-repeat=\"category in categories\" ui-tree-node data-nodrag data-collapsed={{!!category.children.length}} ng-include=\"'checkbox_nodes.tpl.html'\"> </li> </ol> </div> </div> <div class=form-group> <button type=submit class=\"btn btn-primary\">Save</button> </div> </fieldset></form> </div> </div> <script type=text/ng-template id=checkbox_nodes.tpl.html> <div ui-tree-handle class=\"tree-node tree-node-content\">\r\n        <input type=\"checkbox\" ng-click=\"toggleCategorySelection(category)\" ng-checked=\"isChecked(category.id)\">\r\n        <div class=\"label-container\">\r\n            <a href=\"#\" data-nodrag class=\"angular-ui-tree-label\">{{category.name}}</a>\r\n        </div>\r\n        <a class=\"pull-right btn btn-default btn-xs\" data-nodrag ng-click=\"toggleNode(this)\"\r\n           ng-class=\"{\r\n            'hidden': !category.children.length\r\n           }\"\r\n           style=\"margin-right: 8px;\">\r\n            <span class=\"glyphicon\"\r\n                  ng-class=\"{\r\n                    'glyphicon-chevron-left': collapsed,\r\n                    'glyphicon-chevron-down': !collapsed\r\n                  }\">\r\n            </span>\r\n        </a>\r\n    </div>\r\n    <ol ui-tree-nodes=\"\" ng-model=\"category.children\" ng-class=\"{hidden: collapsed}\">\r\n        <li ng-repeat=\"category in category.children\" ui-tree-node data-nodrag data-collapsed=\"{{!!category.children.length}}\" data-nodrag ng-include=\"'checkbox_nodes.tpl.html'\">\r\n        </li>\r\n    </ol> </script> ";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.groups.index', ['security.authorization', 'services.utility', 'services.adminResource', 'resources.AdminGroup', 'services.search']);
	
	angular.module('admin.groups.index').config(["$stateProvider", function ($stateProvider) {
	  var main = {
	    template: __webpack_require__(241),
	    controller: 'AccountGroupsIndexCtrl'
	  };
	
	  $stateProvider.state('admin.groups', {
	    url: '/groups',
	    title: 'Manage Account Groups',
	    views: {
	      'main@': main
	    }
	  });
	}]);
	
	angular.module('admin.groups.index').controller('AccountGroupsIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "searchService", "AdminGroup", function ($scope, $route, $location, $log, utility, adminResource, searchService, AdminGroup) {
	
	  searchService.setSearchFn(AdminGroup.search);
	
	  searchService.setRedirectBase('/admin/groups/edit');
	
	  var fetchData = function fetchData() {
	    adminResource.findAccountGroups($scope.query).then(function (data) {
	      deserializeData(data);
	      //update url in browser addr bar
	      $location.search($scope.query);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  var deserializeData = function deserializeData(data) {
	    $scope.page = data.meta.page;
	    $scope.query = data.meta.query;
	    $scope.groups = data.data;
	  };
	
	  $scope.$watchCollection('query', function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	
	    fetchData();
	  });
	
	  //select elements and their associating options
	  $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  $scope.query = $location.search();
	  $scope.query.limit = $scope.query.limi || 10;
	  fetchData();
	}]);

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-groups-index> <div class=col-xs-12> <div class=page-header> <a ng-href=/admin/groups/add class=\"btn btn-default pull-right\">Add New</a> <h1>User Groups</h1> </div> <form class=filters> <div class=row> <div class=col-sm-6> <label>Sort By</label> <select name=sort class=form-control ng-model=query.sort ng-model-options=\"{ debounce: 500 }\" ng-options=\"sort.value as sort.label for sort in sorts\"> </select> </div> <div class=col-sm-6> <label>Limit</label> <select name=limit class=form-control ng-model=query.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\"> </select> </div> </div> </form> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th class=stretch>name</th> <th>id</th> </tr> </thead> <tbody> <tr ng-repeat=\"group in groups\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/admin/groups/edit/{{group._id}}>Edit</a></td> <td ng-bind=group.name></td> <td class=nowrap ng-bind=group._id></td> </tr> <tr ng-show=\"groups.length === 0\"> <td colspan=3>no documents matched</td> </tr> </tbody> </table> <paginator page-model=page on-navigate=\"query.skip = $offset\"></paginator> </div> </div> ";

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.groups', ['admin.groups.index', 'admin.groups.add', 'admin.groups.detail']);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var SETTING_BREAKING_NEWS = 'homepage.breaking-news';
	var SETTING_TRENDING_TAGS = 'homepage.trending-tags';
	var SETTING_SPONSOR = 'homepage.sponsor';
	var SETTING_LIVE_VIDEO_ID = 'global.liveYouTubeId';
	
	angular.module('admin.homepage.index', ['resources.Settings', 'resources.Tag', 'ngFileUpload']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.homepage', {
	    url: '/homepage',
	    title: 'Home page settings',
	    views: {
	      'main@': {
	        template: __webpack_require__(244),
	        controller: 'HomePageCtrl',
	        resolve: {
	          setting: ["Settings", function (Settings) {
	            return Settings.get([SETTING_BREAKING_NEWS, SETTING_TRENDING_TAGS, SETTING_SPONSOR, SETTING_LIVE_VIDEO_ID]).$promise;
	          }]
	          // collectTags: function (Tag) {
	          //   return Tag.query().$promise;
	          // }
	
	        }
	      }
	    }
	  });
	}]).controller('HomePageCtrl', ["$scope", "$log", "setting", "Settings", "Upload", "APP_IMG_URLS", "Tag", function ($scope, $log, setting, Settings, Upload, APP_IMG_URLS, Tag) {
	
	  $scope.collectTags = [];
	  $scope.dataLoaded = false;
	  Tag.query().$promise.then(function (res) {
	    $scope.collectTags = res.data;
	    $scope.dataLoaded = true;
	  }, function (err) {
	    $scope.dataLoaded = true;
	    console.error('error loading tags');
	    console.error(err);
	  });
	  // console.log( '>>', $scope.tags );
	
	  var ActionStates = __webpack_require__(245).StateClass;
	  if (setting[0].value) {
	    var value = JSON.parse(setting[0].value);
	    $scope.text = value.text;
	    $scope.url = value.url;
	  } else {
	    $scope.text = '';
	    $scope.url = '';
	  }
	  if (setting[1].value) {
	    $scope.tags = JSON.parse(setting[1].value);
	  } else {
	    $scope.tags = [];
	  }
	
	  if (setting[2].value) {
	    $scope.sponsor = JSON.parse(setting[2].value);
	  } else {
	    $scope.sponsor = {
	      image: null,
	      url: ''
	    };
	  }
	
	  if (setting[3].value) {
	    $scope.youtubeLiveId = setting[3].value;
	  } else {
	    $scope.youtubeLiveId = "";
	  }
	
	  $scope.image_uploading = false;
	  $scope.$watch('sponsor', function (file) {
	    if (file && file.type && file.type.startsWith('image/')) {
	      $scope.uploadSponsorImage(file);
	    }
	  });
	
	  $scope.uploadSponsorImage = function (file) {
	    $scope.image_uploading = true;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.image_uploading = false;
	      $scope.sponsor.image = APP_IMG_URLS.base + resp.data.filename;
	    }, function (resp) {
	      $scope.image_uploading = false;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	    });
	  };
	
	  $scope.error = null;
	  $scope.status = new ActionStates();
	  $scope.statusRemoveBanner = new ActionStates();
	
	  $scope.initStates = function () {
	    $scope.error = null;
	    $scope.status.reset();
	    $scope.statusRemoveBanner.reset();
	  };
	
	  $scope.save = function (e) {
	    console.log('>>>', $scope.sponsor);
	
	    $scope.initStates();
	    $scope.status.waiting();
	    Settings.set([{
	      name: SETTING_BREAKING_NEWS,
	      value: JSON.stringify({
	        text: $scope.text,
	        url: $scope.url
	      })
	    }, {
	      name: SETTING_TRENDING_TAGS,
	      value: JSON.stringify($scope.tags.map(function (t) {
	        return {
	          _id: t._id,
	          name: t.name,
	          sefriendly: t.sefriendly,
	          oficial: t.oficial,
	          avatar: t.avatar
	        };
	      }))
	    }, {
	      name: SETTING_SPONSOR,
	      value: JSON.stringify({
	        image: $scope.sponsor.image,
	        url: $scope.sponsor.url
	      })
	    }, {
	      name: SETTING_LIVE_VIDEO_ID,
	      value: $scope.youtubeLiveId
	    }]).$promise.then(function (data) {
	      // console.log( '>>', data );
	      if (data.error) {
	        $scope.error = data.error;
	        $scope.status.error();
	      } else {
	        $scope.status.saveOk();
	      }
	    }, function (e) {
	      $log.error(e);
	      $scope.error = e.statusText;
	      $scope.status.error();
	    });
	  };
	
	  $scope.removeBanner = function () {
	    $scope.initStates();
	    $scope.statusRemoveBanner.waiting();
	    Settings.set({
	      name: SETTING_BREAKING_NEWS,
	      value: null
	    }).$promise.then(function (data) {
	      if (data.error) {
	        $scope.error = data.error;
	        $scope.statusRemoveBanner.error();
	      } else {
	        $scope.text = '';
	        $scope.url = '';
	        $scope.statusRemoveBanner.saveOk();
	      }
	    }, function (e) {
	      $log.error(e);
	      $scope.error = e.statusText;
	      $scope.statusRemoveBanner.error();
	    });
	  };
	}]);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = "<style>.form-group button{width:130px}</style> <div class=loading ng-hide=\"dataLoaded || !image_uploading\"></div> <div class=row id=admin-homepage-index> <div class=page-header> <h1>Home page settings</h1> </div> <div class=\"alert alert-danger\" role=alert ng-bind=error ng-if=\"error !== null\"></div> <div class=\"alert alert-success\" role=alert ng-if=status.isSaveOk()>Save is ok</div> <div class=\"alert alert-success\" role=alert ng-if=statusRemoveBanner.isSaveOk()>Removed banner is ok</div> <form novalidate=\"\" name=homepageForm ng-submit=save()> <div class=\"panel panel-default\"> <div class=panel-heading>BREAKING NEWS banner</div> <div class=panel-body> <div class=form-group> <label class=control-label for=text>Text:</label> <input type=text name=text id=text class=form-control ng-model=text required> <label class=control-label for=url>URL:</label> <input type=text name=text id=url class=form-control ng-model=url required> <span class=help-block>for example /articles/12345.html</span> </div> </div> </div> <div class=\"panel panel-default\"> <div class=panel-heading>Trending tags</div> <div class=panel-body> <div class=form-group> <label class=control-label for=text>Dodaj tag:</label> <oi-select name=tags oi-options=\"item.name for item in collectTags track by item._id\" ng-model=tags placeholder=\"Select tags\" multiple=multiple></oi-select> </div> </div> </div> <div class=\"panel panel-default\"> <div class=panel-heading>Global settings</div> <div class=panel-body> <div class=form-group> <label class=control-label for=youtubeLiveId>Live video YouTube ID:</label> <input type=text name=youtubeLiveId id=youtubeLiveId class=form-control ng-model=youtubeLiveId required> </div> </div> </div> <div class=\"panel panel-default\"> <div class=panel-heading>Sponsor</div> <div class=panel-body> <div class=form-group> <label class=control-label for=sponsor_url>URL:</label> <input type=text name=sponsor_url id=sponsor_url class=form-control ng-model=sponsor.url required> </div> <div class=form-group> <label class=control-label for=text>IMAGE:</label> <figure class=article-image ng-class=\"{'no-image': !sponsor.image}\" type=file id=sponsor ng-model=sponsor name=sponsor ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop accept=image/* required ngf-model-invalid=errorFiles ngf-resize=\"{width: 200, height: 200, centerCrop: true}\" style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{ sponsor.image }}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=image_uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> </div> </div> <div class=form-group> <button class=\"btn btn-primary\" ng-disabled=status.isWaiting() type=submit> <span ng-if=!status.isWaiting()>Save</span> <span ng-if=status.isWaiting()>Waiting...</span> </button> <button class=btn ng-click=removeBanner() ng-disabled=statusRemoveBanner.isWaiting()> <span ng-if=!statusRemoveBanner.isWaiting()>Remove banner</span> <span ng-if=statusRemoveBanner.isWaiting()>Waiting...</span> </button> </div> </form> </div> ";

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	var ERROR = -1;
	var NO_STATE = 0;
	var SAVE_OK = 1;
	var NOT_SAVED = 2;
	var WAITING = 3;
	
	function ActionStates() {
	  this.state = NO_STATE;
	}
	
	ActionStates.prototype.setState = function (state) {
	  this.state = state;
	};
	
	ActionStates.prototype.is = function (state) {
	  return this.state === state;
	};
	
	ActionStates.prototype.reset = function () {
	  this.setState(NO_STATE);
	};
	
	ActionStates.prototype.notSaved = function () {
	  this.setState(NOT_SAVED);
	};
	
	ActionStates.prototype.isNotSaved = function () {
	  return this.is(NOT_SAVED);
	};
	
	ActionStates.prototype.saveOk = function () {
	  this.setState(SAVE_OK);
	};
	
	ActionStates.prototype.isSaveOk = function () {
	  return this.is(SAVE_OK);
	};
	
	ActionStates.prototype.error = function () {
	  this.setState(ERROR);
	};
	
	ActionStates.prototype.isError = function () {
	  return this.is(ERROR);
	};
	
	ActionStates.prototype.waiting = function () {
	  this.setState(WAITING);
	};
	
	ActionStates.prototype.isWaiting = function () {
	  return this.is(WAITING);
	};
	
	module.exports = {
	  StateClass: ActionStates,
	  ERROR: ERROR,
	  NO_STATE: NO_STATE,
	  SAVE_OK: SAVE_OK,
	  NOT_SAVED: NOT_SAVED,
	  WAITING: WAITING
	};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.homepage', ['admin.homepage.index']);

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin', ['admin.index', 'admin.users', 'admin.subscribers', 'admin.gallery',
	//'admin.politics',
	'admin.groups', 'admin.diagrams.index', 'admin.editions.index', 'admin.recuentos.index', 'admin.statuses', 'admin.categories', 'admin.articles', 'admin.menus', 'admin.reindexing', 'admin.cover.index', 'admin.homepage']);
	
	// require ('./cover/cover.js');

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.menus', ['admin.menus.index', 'admin.menus.tree']);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.menus.tree', ['ui.tree', 'security.authorization', 'services.utility', 'resources.Category', 'services.adminResource']);
	
	angular.module('admin.menus.tree').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.menus.tree', {
	    url: '/tree',
	    title: 'Manage Menus',
	    views: {
	      'main@': {
	        template: __webpack_require__(250),
	        controller: 'MenusTreeCtrl',
	        resolve: {
	          menus: ["adminResource", function (adminResource) {
	            return adminResource.getMenusTree({ path: '/', depth: 2 });
	          }]
	        }
	      }
	    }
	  });
	}]);
	
	angular.module('admin.menus.tree').controller('MenusTreeCtrl', ['$scope', '$route', '$location', '$log', '$modal', 'utility', 'adminResource', 'menus', 'Category', function ($scope, $route, $location, $log, $modal, utility, adminResource, data, Category) {
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.menus = data;
	  };
	
	  var fetchMenus = function fetchMenus() {
	
	    adminResource.findMenus($scope.filters).then(function (data) {
	      deserializeData(data);
	
	      //update url in browser addr bar
	      $location.search($scope.filters);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  // $scope methods
	  $scope.canSave = utility.canSave;
	  $scope.filtersUpdated = function () {
	    //reset pagination after filter(s) is updated
	    $scope.filters.page = undefined;
	    fetchMenus();
	  };
	  $scope.prev = function () {
	    $scope.filters.page = $scope.pages.prev;
	    fetchMenus();
	  };
	  $scope.next = function () {
	    $scope.filters.page = $scope.pages.next;
	    fetchMenus();
	  };
	
	  $scope.toggleNode = function (node) {
	    var modelValue = node.$nodeScope.$modelValue;
	    var pathLength = modelValue.path.split('/').filter(Boolean).length;
	    var objPath = 'children' + new Array(pathLength).join('.[0].children');
	    var children = {};
	
	    adminResource.getMenusTree({ path: modelValue.path, depth: 2 }).then(function (result) {
	      if (!result.length) {
	        return;
	      }
	
	      result = result[0];
	      modelValue.children = _.get(result, objPath);
	      node.toggle();
	    });
	  };
	
	  var generateCategoryOptions = function generateCategoryOptions(items, container) {
	
	    items.forEach(function (item) {
	
	      if (!item.path) {
	        return;
	      }
	
	      //console.log(item);
	      var depth = item.path.split('/').filter(Boolean).length;
	      var indent = new Array(7).join(String.fromCharCode(160));
	
	      container.push({
	        _id: item._id,
	        id: item.name,
	        path: item.path,
	        name: new Array(depth).join(indent) + item.name
	      });
	
	      if (item.children) {
	        generateCategoryOptions(item.children, container);
	      }
	    });
	
	    return container;
	  };
	
	  function getOrderedMenu(menu, parent) {
	    var flat = [];
	    menu.forEach(function (m) {
	      flat.push({
	        _id: m._id,
	        sefriendly: m.sefriendly,
	        parent: parent ? parent : '/',
	        order: 0
	      });
	      if (m.children.length) {
	        flat = flat.concat(getOrderedMenu(m.children, parent + '/' + m.sefriendly));
	      }
	    });
	
	    return flat;
	  }
	
	  var ActionStates = __webpack_require__(245);
	  $scope.menuState = new ActionStates.StateClass();
	  $scope.treeOptions = {
	    dropped: function dropped(e) {
	      $scope.menuState.notSaved();
	    }
	  };
	
	  $scope.saveMenuOrder = function () {
	    $scope.menuState.waiting();
	    var orderedMenu = getOrderedMenu($scope.menus, '');
	    orderedMenu = orderedMenu.map(function (m, index) {
	      m.order = index + 1;
	      return m;
	    });
	
	    adminResource.updateMenus(orderedMenu).then(function (result) {
	      if (result.ok) $scope.menuState.saveOk();else $scope.menuState.error();
	    }, function (error) {
	      $scope.menuState.error();
	    });
	  };
	
	  $scope.addMenu = function () {
	    //show modal
	    var dialog = $modal.open({
	      templateUrl: 'add_menu.tpl.html',
	      controller: 'AddMenuCtrl',
	      resolve: {
	        options: function options() {
	          var options = [];
	          return adminResource.getMenusTree().then(function (data) {
	            generateCategoryOptions(data, options);
	            return options;
	          });
	        },
	        categories: function categories() {
	          //$log.log("addMenu-->categories.----->");
	          var optionscat = [];
	          var genCatOptions = function genCatOptions(items, container) {
	            items.forEach(function (item) {
	              if (!item.path) {
	                return;
	              }
	              var depth = item.path.split('/').filter(Boolean).length;
	              var indent = new Array(7).join(String.fromCharCode(160));
	              container.push({
	                _id: item._id,
	                id: item.id,
	                path: item.path,
	                name: new Array(depth).join(indent) + item.name
	              });
	              if (item.children) {
	                genCatOptions(item.children, container);
	              }
	            });
	            return container;
	          };
	          return Category.getPermittedTree().$promise.then(function (data) {
	            //$log.log("options.-----1>"+JSON.stringify(data));
	            genCatOptions(data, optionscat);
	            //$log.log("options.-----2>"+JSON.stringify(optionscat));
	            return optionscat;
	          });
	        }
	      }
	    });
	    dialog.result.then(function handleClose(result) {
	      dialog.close();
	      dialog = null;
	      //if (node.$nodeScope.collapsed) {
	      //  $scope.toggleNode(node);
	      //}
	    }, function handleDismiss() {
	      dialog = null;
	    });
	  };
	
	  $scope.editItem = function (node) {
	    var modelValue = node.$nodeScope.$modelValue;
	
	    //show modal
	    var dialog = $modal.open({
	      templateUrl: 'edit_menu.tpl.html',
	      controller: 'EditMenuCtrl',
	      resolve: {
	        data: function data() {
	          return modelValue;
	        },
	        options: function options() {
	          var options = [];
	          return adminResource.getMenusTree().then(function (data) {
	            generateCategoryOptions(data, options);
	            return options;
	          });
	        },
	        categories: function categories() {
	          //$log.log("editItem-->categories.----->");
	          var optionscat = [];
	          var genCatOptions = function genCatOptions(items, container) {
	            items.forEach(function (item) {
	              if (!item.path) {
	                return;
	              }
	              var depth = item.path.split('/').filter(Boolean).length;
	              var indent = new Array(7).join(String.fromCharCode(160));
	              container.push({
	                _id: item._id,
	                id: item.id,
	                path: item.path,
	                name: new Array(depth).join(indent) + item.name
	              });
	              if (item.children) {
	                genCatOptions(item.children, container);
	              }
	            });
	            return container;
	          };
	          return Category.getPermittedTree().$promise.then(function (data) {
	            //$log.log("options.-----1>"+JSON.stringify(data));
	            genCatOptions(data, optionscat);
	            //$log.log("options.-----2>"+JSON.stringify(optionscat));
	            return optionscat;
	          });
	        }
	      }
	    });
	    dialog.result.then(function handleClose(result) {
	      dialog.close();
	      dialog = null;
	
	      if (!result) {
	        return node.remove();
	      }
	
	      node.$nodeScope.$modelValue.name = result.name;
	      node.$nodeScope.$modelValue.path = result.path;
	      node.$nodeScope.$modelValue.alias = result.alias;
	      node.$nodeScope.$modelValue.sefriendly = result.sefriendly;
	      node.$nodeScope.$modelValue.redirect = result.redirect;
	      node.$nodeScope.$modelValue.cat_id = result.cat_id;
	    }, function handleDismiss() {
	      dialog = null;
	    });
	  };
	
	  // $scope vars
	  //select elements and their associating options
	  $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  //initialize $scope variables
	  deserializeData(data.map(function (item) {
	    var temp = angular.copy(item);
	    //delete temp['children'];
	
	    return temp;
	  }));
	}]);
	
	var slug = function slug(str) {
	  str = str.replace(/^\s+|\s+$/g, ''); // trim
	  str = str.toLowerCase();
	
	  // remove accents, swap ñ for n, etc
	  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
	  var to = "aaaaaeeeeeiiiiooooouuuunc------";
	  for (var i = 0, l = from.length; i < l; i++) {
	    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
	  }
	
	  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
	  .replace(/\s+/g, '-') // collapse whitespace and replace by -
	  .replace(/-+/g, '-'); // collapse dashes
	
	  return str;
	};
	
	angular.module('admin.menus.tree').controller('AddMenuCtrl', ['$scope', '$modalInstance', 'adminResource', 'options', 'Category', 'categories', function ($scope, $modalInstance, adminResource, options, Category, categories) {
	
	  $scope.options = options;
	  $scope.categories = categories;
	  $scope.hasEditedName = false;
	  $scope.rootUrl = '';
	  $scope.data = {
	    name: '',
	    sefriendly: '',
	    alias: '',
	    redirect: '',
	    parent: '',
	    cat_id: ''
	  };
	
	  $scope.changedName = function () {
	    if (!$scope.hasEditedName) {
	      $scope.data.sefriendly = slug($scope.data.name || '');
	    }
	  };
	
	  $scope.editedName = function () {
	    if ($scope.data.sefriendly !== '') {
	      $scope.hasEditedName = true;
	    }
	  };
	
	  $scope.editSefriendly = function () {
	    $scope.showSefriendly = true;
	  };
	
	  $scope.saveSefriendly = function () {
	    $scope.showSefriendly = false;
	  };
	
	  $scope.changedParent = function () {
	    $scope.rootUrl = location.href.replace(location.pathname, '');
	    if ($scope.data.parent) {
	      $scope.rootUrl += $scope.data.parent.path;
	    }
	
	    $scope.rootUrl += '/';
	  };
	
	  $scope.save = function () {
	    var parentPath = $scope.data.parent ? $scope.data.parent.path : '';
	    var data = {
	      name: $scope.data.name,
	      path: parentPath + '/' + $scope.data.sefriendly,
	      alias: $scope.data.alias,
	      redirect: $scope.data.redirect,
	      sefriendly: $scope.data.sefriendly,
	      parent: parentPath || '/',
	      cat_id: $scope.data.cat_id.id || -1
	    };
	    adminResource.addMenu(data).then(function (result) {
	      $modalInstance.close(result.data);
	    });
	  };
	
	  $scope.changedParent();
	}]);
	
	angular.module('admin.menus.tree').controller('EditMenuCtrl', ['$scope', '$modalInstance', 'adminResource', 'options', 'data', 'Category', 'categories', function ($scope, $modalInstance, adminResource, options, data, Category, categories) {
	  var parent = '';
	  var cat_id = '';
	  var parentPath = data.path.substring(0, data.path.lastIndexOf("/"));
	  var sefriendly = data.path.substring(data.path.lastIndexOf("/")).replace('/', '');
	  options.forEach(function (item) {
	    if (item.path === parentPath) {
	      parent = item;
	    }
	  });
	  categories.forEach(function (item) {
	    if (item.id === data.cat_id) {
	      cat_id = item;
	    }
	  });
	
	  $scope.options = options;
	  $scope.categories = categories;
	  $scope.hasEditedName = true;
	  $scope.rootUrl = '';
	  $scope.data = {
	    _id: data._id,
	    path: data.path,
	    name: data.name,
	    sefriendly: sefriendly,
	    alias: data.alias,
	    redirect: data.redirect,
	    parent: parent,
	    order: data.order,
	    cat_id: cat_id
	  };
	
	  $scope.changedName = function () {
	    if (!$scope.hasEditedName) {
	      $scope.data.sefriendly = slug($scope.data.name || '');
	    }
	  };
	
	  $scope.editedName = function () {
	    if ($scope.data.sefriendly !== '') {
	      $scope.hasEditedName = true;
	    }
	  };
	
	  $scope.editSefriendly = function () {
	    $scope.showSefriendly = true;
	  };
	
	  $scope.saveSefriendly = function () {
	    $scope.showSefriendly = false;
	  };
	
	  $scope.changedParent = function () {
	    $scope.rootUrl = location.href.replace(location.pathname, '');
	    if ($scope.data.parent) {
	      $scope.rootUrl += $scope.data.parent.path;
	    }
	
	    $scope.rootUrl += '/';
	  };
	
	  $scope.save = function () {
	    var catid = -1;
	    if ($scope.data.cat_id) {
	      catid = $scope.data.cat_id.id;
	    }
	
	    var parentPath = $scope.data.parent ? $scope.data.parent.path : '';
	    var data = {
	      _id: $scope.data._id,
	      name: $scope.data.name,
	      path: parentPath + '/' + $scope.data.sefriendly,
	      alias: $scope.data.alias,
	      redirect: $scope.data.redirect,
	      sefriendly: $scope.data.sefriendly,
	      parent: parentPath || '/',
	      order: $scope.data.order,
	      cat_id: catid
	    };
	    adminResource.updateMenu($scope.data._id, data).then(function (result) {
	      $modalInstance.close(data);
	    });
	  };
	
	  $scope.delete = function () {
	    if (!confirm('Deleting parent will delete all children. Are you sure you want to continue?')) {
	      return;
	    }
	
	    adminResource.deleteMenu(data._id).then(function (result) {
	      $modalInstance.close(null);
	    });
	  };
	
	  $scope.changedParent();
	}]);

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = "<style>.menu-row{display:flex;justify-content:flex-end}.menu-row button{margin:0 10px}.menu-row .error{width:100%;align-self:center;color:red;font-size:14px}.menu-row .info{width:100%;align-self:center;font-size:14px;font-weight:700}.save-button{min-width:200px;max-width:200px}</style> <div class=row id=admin-categories-index> <div class=col-xs-12> <div class=\"page-header clearfix\"> <h1>Menus</h1> <div class=menu-row> <div class=error ng-show=menuState.isError()>Not saved, please contact <a href=mailto:contacto@intoleranciadiario.com>us</a> to resolve this issue</div> <div class=info ng-show=menuState.isSaveOk()>Menu order is saved ok</div> <div class=info ng-show=menuState.isNotSaved() style=font-weight:300;color:green>Menu order has not saved yet</div> <button class=\"save-button btn pull-right\" ng-click=saveMenuOrder() data-ng-disabled=menuState.isWaiting()> <span ng-show=!menuState.isWaiting()>Save Menu Order</span> <span ng-show=menuState.isWaiting()>Please wait</span> </button> <button class=\"btn btn-success pull-right\" ng-click=addMenu()> <span class=\"glyphicon glyphicon-plus\"></span> Add Menu </button> </div> </div> <div ui-tree=treeOptions id=tree-root> <ol ui-tree-nodes ng-model=menus> <li ng-repeat=\"menu in menus\" ui-tree-node data-collapsed={{!!menu.children.length}} ng-include=\"'nodes_renderer.tpl.html'\"> </li> </ol> </div> </div> </div> <script type=text/ng-template id=nodes_renderer.tpl.html> <div ui-tree-handle class=\"tree-node tree-node-content\">\r\n        <div class=\"label-container\">\r\n            <a href=\"#\" ng-click=\"editItem(this)\" data-nodrag=\"\" class=\"angular-ui-tree-label\">{{menu.name}}</a>\r\n        </div>\r\n        <a class=\"pull-right btn btn-default btn-xs\" data-nodrag ng-click=\"toggleNode(this)\"\r\n           ng-class=\"{\r\n            'hidden': !menu.children.length\r\n           }\"\r\n           style=\"margin-right: 8px;\">\r\n            <span class=\"glyphicon\"\r\n                  ng-class=\"{\r\n                    'glyphicon-chevron-left': collapsed,\r\n                    'glyphicon-chevron-down': !collapsed\r\n                  }\">\r\n            </span>\r\n        </a>\r\n    </div>\r\n    <ol ui-tree-nodes=\"\" ng-model=\"menu.children\" ng-class=\"{hidden: collapsed}\">\r\n        <li ng-repeat=\"menu in menu.children\" ui-tree-node data-collapsed=\"{{!!menu.children.length}}\" ng-include=\"'nodes_renderer.tpl.html'\">\r\n        </li>\r\n    </ol> </script> <script type=text/ng-template id=add_menu.tpl.html> <form name=\"form\" novalidate class=\"login-form\">\r\n        <div class=\"modal-header\">\r\n            <h4>Add Menu</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <alert ng-repeat=\"alert in alerts\" type=\"{{alert.type}}\" close=\"closeAlert($index)\">{{alert.msg}}</alert>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"name\">Name:</label>\r\n                <input type=\"text\" name=\"name\" id=\"name\" class=\"form-control\" ng-keyup=\"changedName()\" ng-blur=\"editedName()\" ng-model=\"data.name\" required>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"sefriendly\">Link:</label>\r\n                <span class=\"text-muted\">\r\n                    <span ng-bind=\"rootUrl\" style=\"margin-right: -4px;\"></span>\r\n                    <span class=\"text-success\" ng-bind=\"data.sefriendly\" ng-if=\"!showSefriendly\"></span>\r\n                </span>\r\n                <span class=\"edit-sefriendly\" ng-if=\"showSefriendly\">\r\n                    <input type=\"text\" name=\"sefriendly\" id=\"sefriendly\" ng-model=\"data.sefriendly\">\r\n                    <button class=\"btn btn-default\" ng-click=\"saveSefriendly()\">Ok</button>\r\n                </span>\r\n                <button class=\"btn btn-default btn-sm\" ng-click=\"editSefriendly()\" ng-if=\"!showSefriendly\" style=\"margin-left: 10px\">Edit</button>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"alias\">Alias:</label>\r\n                <input type=\"text\" name=\"alias\" id=\"alias\" class=\"form-control\" ng-model=\"data.alias\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"alias\">Redirect:</label>\r\n                <input type=\"text\" name=\"redirect\" id=\"redirect\" class=\"form-control\" ng-model=\"data.redirect\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"parent\">Parent:</label>\r\n                <select type=\"text\" name=\"parent\" id=\"parent\" class=\"form-control\"\r\n                        ng-model=\"data.parent\"\r\n                        ng-options=\"(addSpaces(option.path) + option.name) for option in options track by option.path\"\r\n                        ng-change=\"changedParent()\"\r\n                        required>\r\n                    <option value=\"\">Root</option>\r\n                </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"cat_id\">Categoria:</label>\r\n                <select type=\"text\" name=\"cat_id\" id=\"cat_id\" class=\"form-control\"\r\n                        ng-model=\"data.cat_id\"\r\n                        ng-options=\"(addSpaces(option.path) + option.name) for option in categories track by option.path\"\r\n                        ng-change=\"changedParent()\"\r\n                        required>\r\n                    <option value=\"\">...select...</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-primary\" ng-click=\"save()\">Save</button>\r\n        </div>\r\n    </form> </script> <script type=text/ng-template id=edit_menu.tpl.html> <form name=\"form\" novalidate class=\"login-form\">\r\n        <div class=\"modal-header\">\r\n            <h4>Edit Menu</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <alert ng-repeat=\"alert in alerts\" type=\"{{alert.type}}\" close=\"closeAlert($index)\">{{alert.msg}}</alert>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"name\">Name:</label>\r\n                <input type=\"text\" name=\"name\" id=\"name\" class=\"form-control\" ng-keyup=\"changedName()\" ng-blur=\"editedName()\" ng-model=\"data.name\" required>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"sefriendly\">Link:</label>\r\n                <span class=\"text-muted\">\r\n                    <span ng-bind=\"rootUrl\" style=\"margin-right: -4px;\"></span>\r\n                    <span class=\"text-success\" ng-bind=\"data.sefriendly\" ng-if=\"!showSefriendly\"></span>\r\n                </span>\r\n                <span class=\"edit-sefriendly\" ng-if=\"showSefriendly\">\r\n                    <input type=\"text\" name=\"sefriendly\" id=\"sefriendly\" ng-model=\"data.sefriendly\">\r\n                    <button class=\"btn btn-default\" ng-click=\"saveSefriendly()\">Ok</button>\r\n                </span>\r\n                <button class=\"btn btn-default btn-sm\" ng-click=\"editSefriendly()\" ng-if=\"!showSefriendly\" style=\"margin-left: 10px\">Edit</button>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"alias\">Alias:</label>\r\n                <input type=\"text\" name=\"alias\" id=\"alias\" class=\"form-control\" ng-model=\"data.alias\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"alias\">Redirect:</label>\r\n                <input type=\"text\" name=\"redirect\" id=\"redirect\" class=\"form-control\" ng-model=\"data.redirect\">\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"parent\">Parent:</label>\r\n                <select type=\"text\" name=\"parent\" id=\"parent\" class=\"form-control\"\r\n                        ng-model=\"data.parent\"\r\n                        ng-options=\"(addSpaces(option.path) + option.name) for option in options track by option.path\"\r\n                        ng-change=\"changedParent()\"\r\n                        required>\r\n                    <option value=\"\">Root</option>\r\n                </select>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <label class=\"control-label\" for=\"cat_id\">Categoria:</label>\r\n                <select type=\"text\" name=\"cat_id\" id=\"cat_id\" class=\"form-control\"\r\n                        ng-model=\"data.cat_id\"\r\n                        ng-options=\"(addSpaces(option.path) + option.name) for option in categories track by option.path\"\r\n                        ng-change=\"changedParent()\"\r\n                        required>\r\n                    <option value=\"\">...select...</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-primary\" ng-click=\"save()\">Save</button>\r\n            <button class=\"btn btn-danger\" ng-click=\"delete()\">Delete</button>\r\n        </div>\r\n    </form> </script> ";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.menus.index', ['ngRoute', 'security.authorization', 'services.utility', 'services.adminResource']);
	
	angular.module('admin.menus.index').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.menus', {
	    url: '/menus',
	    title: 'Manage Menus',
	    views: {
	      'main@': {
	        template: __webpack_require__(252),
	        controller: 'MenusIndexCtrl',
	        resolve: {
	          menus: ["adminResource", "$location", function (adminResource, $location) {
	            return adminResource.findMenus($location.search());
	          }]
	        },
	        middlewares: ['isAdmin']
	      }
	    }
	  });
	}]);
	
	angular.module('admin.menus.index').controller('MenusIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'menus', function ($scope, $route, $location, $log, utility, adminResource, data) {
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.items = data.items;
	    $scope.pages = data.pages;
	    $scope.filters = data.filters;
	    $scope.menus = data.data;
	  };
	
	  var fetchMenus = function fetchMenus() {
	    adminResource.findMenus($scope.filters).then(function (data) {
	      deserializeData(data);
	
	      //update url in browser addr bar
	      $location.search($scope.filters);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  // $scope methods
	  $scope.canSave = utility.canSave;
	  $scope.filtersUpdated = function () {
	    //reset pagination after filter(s) is updated
	    $scope.filters.page = undefined;
	    fetchMenus();
	  };
	  $scope.prev = function () {
	    $scope.filters.page = $scope.pages.prev;
	    fetchMenus();
	  };
	  $scope.next = function () {
	    $scope.filters.page = $scope.pages.next;
	    fetchMenus();
	  };
	  $scope.addCategory = function () {
	    adminResource.addCategory($scope.add).then(function (data) {
	      $scope.add = {};
	      if (data.success) {
	        $route.reload();
	      } else if (data.errors && data.errors.length > 0) {
	        alert(data.errors[0]);
	      } else {
	        alert('unknown error.');
	      }
	    }, function (e) {
	      $scope.add = {};
	      $log.error(e);
	    });
	  };
	
	  // $scope vars
	  //select elements and their associating options
	  $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  //initialize $scope variables
	  deserializeData(data);
	}]);

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-categories-index> <div class=col-xs-12> <div class=page-header> <div class=\"btn-group btn-group pull-right\" role=group> <a href=# type=button class=\"btn btn-default active\">List</a> </div> <h1>Menus</h1> </div> <form class=filters> <div class=row> <div class=col-sm-3> <label>Pivot Search</label> <input name=pivot type=text class=form-control ng-model=filters.pivot ng-model-options=\"{ debounce: 500 }\" ng-change=filtersUpdated()> </div> <div class=col-sm-3> <label>Name Search</label> <input name=name type=text class=form-control ng-model=filters.name ng-model-options=\"{ debounce: 500 }\" ng-change=filtersUpdated()> </div> <div class=col-sm-3> <label>Sort By</label> <select name=sort class=form-control ng-model=filters.sort ng-model-options=\"{ debounce: 500 }\" ng-options=\"sort.value as sort.label for sort in sorts\" ng-change=filtersUpdated()> </select> </div> <div class=col-sm-3> <label>Limit</label> <select name=limit class=form-control ng-model=filters.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\" ng-change=filtersUpdated()> </select> </div> </div> </form> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>id</th> <th class=stretch>name</th> <th>sefriendly</th> </tr> </thead> <tbody> <tr ng-repeat=\"menu in menus\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/admin/menus/{{menu.id}}>Edit</a></td> <td ng-bind=menu.id></td> <td ng-bind=menu.category_name></td> <td class=nowrap ng-bind=menu.sefriendly></td> </tr> <tr ng-show=\"menus.length === 0\"> <td colspan=4>no documents matched</td> </tr> </tbody> </table> <div class=well ng-if=\"pages.total > 1\"> <div class=\"btn-group pull-left\"> <button disabled=disabled class=\"btn btn-default\">Strona {{pages.current}} z {{pages.total}}</button> <button disabled=disabled class=\"btn btn-default\">Wiersz {{items.begin}} - {{items.end}} z {{items.total}}</button> </div> <div class=\"btn-group pull-right\"> <button class=\"btn btn-default\" ng-class=\"{disabled: !pages.hasPrev}\" ng-click=prev()>&#x2190;</button> <button class=\"btn btn-default\" ng-class=\"{disabled: !pages.hasNext}\" ng-click=next()> &#x2192;</button> </div> <div class=clearfix></div> </div> </div> </div>";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.politics.add', ['services.formErrors']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.politics.add', {
	    url: '/add',
	    title: 'Politics / Add new',
	    views: {
	      'main@': {
	        template: __webpack_require__(254),
	        controller: 'PoliticsAddCtrl'
	      }
	    }
	  });
	}]).controller('PoliticsAddCtrl', ["$scope", "formErrors", "$location", function ($scope, formErrors, $location) {}]);

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-politics-detail> <div class=col-xs-12> <div class=page-header> <h1><a ng-href=/admin/politics>Politics</a> / Add Politic</h1> </div> </div> </div> ";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.politics.index', ['security.authorization', 'services.utility', 'resources.AdminGroup', 'resources.AdminUser', 'services.adminResource', 'services.search', 'filters.timeAgo', 'directives.croppic']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.politics', {
	    url: '/politics',
	    title: 'Manage Politics',
	    views: {
	      'main@': {
	        template: __webpack_require__(256),
	        controller: 'PoliticsIndexCtrl'
	      }
	    }
	  });
	}]).controller('PoliticsIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "AdminUser", function ($scope, $route, $location, $log, utility, adminResource, AdminUser) {}]);

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-politics-index> <div class=col-xs-12> <div class=page-header> <a ng-href=/admin/politics/add class=\"btn btn-default pull-right\">Add New</a> <h1>Politics</h1> </div> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>Name</th> </tr> </thead> <tbody> <tr ng-repeat=\"politic in politics\"> </tr> <tr ng-show=\"users.length === 0\"> <td colspan=5>no items matched</td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.politics', ['admin.politics.index', 'admin.politics.add']);

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.reindexing', ['admin.reindexing.index']);

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.reindexing.index', ['services.utility', 'services.algoliaResource', 'services.localizedMessages']);
	
	angular.module('admin.reindexing.index').config(["$stateProvider", function ($stateProvider) {
	    $stateProvider.state('admin.reindexing', {
	        url: '/reindexing',
	        title: 'Algolia Reindexing',
	        templateUrl: './reindexing.tpl.html'
	    });
	}]);
	
	angular.module('admin.reindexing.index').controller('ReindexingIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'reindexing', function ($scope, localizedMessages, algoliaResource) {
	    $scope.localizedMessages = localizedMessages;
	    $scope.algoliaArticlesReindexing = function () {
	        algoliaResource.indexingArticles().then(function (result) {
	            $scope.algoliaSuccess = true;
	        }).catch(function (error) {
	            $scope.algoliaError = true;
	        });
	    };
	    $scope.algoliaAuthorReindexing = function () {
	        algoliaResource.indexingAuthors().then(function (result) {
	            $scope.algoliaSuccess = true;
	        }).catch(function (error) {
	            $scope.algoliaError = true;
	        });
	    };
	    $scope.algoliaTagsReindexing = function () {
	        algoliaResource.indexingTags().then(function (result) {
	            $scope.algoliaSuccess = true;
	        }).catch(function (error) {
	            $scope.algoliaError = true;
	        });
	    };
	}]);

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.statuses.detail', ['ngRoute', 'security.authorization', 'services.utility', 'services.adminResource', 'ui.bootstrap']);
	angular.module('admin.statuses.detail').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/admin/statuses/:id', {
	    templateUrl: 'admin/statuses/admin-status.tpl.html',
	    controller: 'AdminStatusesDetailCtrl',
	    title: 'Statuses / Details',
	    resolve: {
	      status: ['$q', '$route', '$location', 'securityAuthorization', 'adminResource', function ($q, $route, $location, securityAuthorization, adminResource) {
	        //get app stats only for admin-user, otherwise redirect to /account
	        var redirectUrl;
	        var promise = securityAuthorization.requireAdminUser().then(function () {
	          var id = $route.current.params.id || '';
	          if (id) {
	            return adminResource.findStatus(id);
	          } else {
	            redirectUrl = '/admin/statuses';
	            return $q.reject();
	          }
	        }, function (reason) {
	          //rejected either user is un-authorized or un-authenticated
	          redirectUrl = reason === 'unauthorized-client' ? '/account' : '/login';
	          return $q.reject();
	        }).catch(function () {
	          redirectUrl = redirectUrl || '/account';
	          $location.path(redirectUrl);
	          return $q.reject();
	        });
	        return promise;
	      }]
	    }
	  });
	}]);
	angular.module('admin.statuses.detail').controller('AdminStatusesDetailCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'status', function ($scope, $route, $location, $log, utility, adminResource, data) {
	  // local vars
	  var deserializeData = function deserializeData(data) {
	    $scope.status = data;
	  };
	  var closeAlert = function closeAlert(alert, ind) {
	    alert.splice(ind, 1);
	  };
	  //$scope vars
	  $scope.detailAlerts = [];
	  $scope.deleteAlerts = [];
	  $scope.canSave = utility.canSave;
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.closeDetailAlert = function (ind) {
	    closeAlert($scope.detailAlerts, ind);
	  };
	  $scope.closeDeleteAlert = function (ind) {
	    closeAlert($scope.deleteAlerts, ind);
	  };
	  $scope.update = function () {
	    $scope.detailAlerts = [];
	    var data = {
	      name: $scope.status.name,
	      pivot: $scope.status.pivot
	    };
	    adminResource.updateStatus($scope.status._id, data).then(function (result) {
	      if (result.success) {
	        deserializeData(result.status);
	        $scope.detailAlerts.push({ type: 'info', msg: 'Changes have been saved.' });
	      } else {
	        angular.forEach(result.errors, function (err, index) {
	          $scope.detailAlerts.push({ type: 'danger', msg: err });
	        });
	      }
	    }, function (x) {
	      $scope.detailAlerts.push({ type: 'danger', msg: 'Error updating status: ' + x });
	    });
	  };
	  $scope.deleteStatus = function () {
	    $scope.deleteAlerts = [];
	    if (confirm('Are you sure?')) {
	      adminResource.deleteStatus($scope.status._id).then(function (result) {
	        if (result.success) {
	          //redirect to admin statuses index page
	          $location.path('/admin/statuses');
	        } else {
	          //error due to server side validation
	          angular.forEach(result.errors, function (err, index) {
	            $scope.deleteAlerts.push({ type: 'danger', msg: err });
	          });
	        }
	      }, function (x) {
	        $scope.deleteAlerts.push({ type: 'danger', msg: 'Error deleting status: ' + x });
	      });
	    }
	  };
	
	  //initialize
	  deserializeData(data);
	}]);

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.statuses.index', ['ngRoute', 'security.authorization', 'services.utility', 'services.adminResource']);
	angular.module('admin.statuses.index').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/admin/statuses', {
	    templateUrl: 'admin/statuses/admin-statuses.tpl.html',
	    controller: 'StatusesIndexCtrl',
	    title: 'Manage Statuses',
	    resolve: {
	      statuses: ['$q', '$location', '$log', 'securityAuthorization', 'adminResource', function ($q, $location, $log, securityAuthorization, adminResource) {
	        //get app stats only for admin-user, otherwise redirect to /account
	        var redirectUrl;
	        var promise = securityAuthorization.requireAdminUser().then(function () {
	          //handles url with query(search) parameter
	          return adminResource.findStatuses($location.search());
	        }, function (reason) {
	          //rejected either user is un-authorized or un-authenticated
	          redirectUrl = reason === 'unauthorized-client' ? '/account' : '/login';
	          return $q.reject();
	        }).catch(function () {
	          redirectUrl = redirectUrl || '/account';
	          $location.search({});
	          $location.path(redirectUrl);
	          return $q.reject();
	        });
	        return promise;
	      }]
	    },
	    reloadOnSearch: false
	  });
	}]);
	angular.module('admin.statuses.index').controller('StatusesIndexCtrl', ['$scope', '$route', '$location', '$log', 'utility', 'adminResource', 'statuses', function ($scope, $route, $location, $log, utility, adminResource, data) {
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.items = data.items;
	    $scope.pages = data.pages;
	    $scope.filters = data.filters;
	    $scope.statuses = data.data;
	  };
	
	  var fetchStatuses = function fetchStatuses() {
	    adminResource.findStatuses($scope.filters).then(function (data) {
	      deserializeData(data);
	
	      //update url in browser addr bar
	      $location.search($scope.filters);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  // $scope methods
	  $scope.canSave = utility.canSave;
	  $scope.filtersUpdated = function () {
	    //reset pagination after filter(s) is updated
	    $scope.filters.page = undefined;
	    fetchStatuses();
	  };
	  $scope.prev = function () {
	    $scope.filters.page = $scope.pages.prev;
	    fetchStatuses();
	  };
	  $scope.next = function () {
	    $scope.filters.page = $scope.pages.next;
	    fetchStatuses();
	  };
	  $scope.addStatus = function () {
	    adminResource.addStatus($scope.add).then(function (data) {
	      $scope.add = {};
	      if (data.success) {
	        $route.reload();
	      } else if (data.errors && data.errors.length > 0) {
	        alert(data.errors[0]);
	      } else {
	        alert('unknown error.');
	      }
	    }, function (e) {
	      $scope.add = {};
	      $log.error(e);
	    });
	  };
	
	  // $scope vars
	  //select elements and their associating options
	  $scope.sorts = [{ label: 'id \u25B2', value: "_id" }, { label: 'id \u25BC', value: "-_id" }, { label: 'name \u25B2', value: "name" }, { label: 'name \u25BC', value: "-name" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  //initialize $scope variables
	  deserializeData(data);
	}]);

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.statuses', ['admin.statuses.index', 'admin.statuses.detail']);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.subscribers.detail', ['resources.AdminGroup', 'resources.Subscriber', 'services.formErrors', 'directives.croppic', 'security']);
	
	angular.module('admin.subscribers.detail').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.subscribers.edit', {
	    url: '/edit/:id',
	    title: 'Subscriber / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(264),
	        controller: 'SubscriberDetailCtrl',
	        resolve: {
	          userDetails: ["adminResource", "$stateParams", function (adminResource, $stateParams) {
	            return adminResource.findSubscriber($stateParams.id);
	          }],
	          groups: ["AdminGroup", function (AdminGroup) {
	            return AdminGroup.query().$promise;
	          }]
	        }
	      }
	    }
	  });
	}]);
	
	angular.module('admin.subscribers.detail').controller('SubscriberDetailCtrl', ["$scope", "groups", "Subscriber", "formErrors", "growl", "security", "userDetails", "$location", "Upload", "APP_IMG_URLS", "$uibModal", function ($scope, groups, Subscriber, formErrors, growl, security, userDetails, $location, Upload, APP_IMG_URLS, $uibModal) {
	  $scope.groups = groups.data;
	  $scope.user = userDetails;
	  $scope.imgUrl = APP_IMG_URLS.base;
	  // console.log( '>>>', userDetails );
	  $scope.user.passwordnew = "";
	
	  $scope.submit = function (data) {
	    var email = data.email;
	    delete data.email;
	    data.psw = false;
	    if (data.passwordnew) {
	      data.psw = true;
	      data.password = security.createHash(data.passwordnew);
	    }
	
	    var toSubmit = angular.copy(data);
	
	    if (toSubmit.account.groups) {
	      toSubmit.account.groups = _.map(toSubmit.account.groups, '_id');
	    }
	
	    toSubmit.passwordnew = data.passwordnew;
	
	    Subscriber.update(toSubmit, function (result) {
	      growl.info('Subscriber Updated!');
	      $scope.user.email = email;
	    }, formErrors.growlErrors);
	  };
	
	  /***/
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  /*
	  $scope.coverOptions = {
	    objW: 500,
	    objH: 350,
	    cropUrl: '/upload/profile/' + resp.data.filename + '/coverPhoto'
	  };
	   $scope.avatarOptions = {
	    objW: 200,
	    objH: 200,
	    cropUrl: '/upload/profile/' + resp.data.filename + '/photo'
	  };
	  */
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.user.account.avatar = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.user.account.avatar = resp.data.filename;
	      $scope.groups.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
	    });
	  };
	  /*
	  $('#image-cropper').cropit({
	    imageBackground: true,
	    imageBackgroundBorderWidth: 15 // Width of background border
	  });*/
	
	  $scope.$watch('file1', function (file) {
	    if (!file) return;
	    $scope.upload1(file);
	  });
	
	  $scope.generateThumb = function (file, rejFile) {
	    if (file === null && rejFile === undefined) {
	      growl.info('Max image size is 10MB!', 3);
	    }
	  };
	
	  // upload on file select or drop
	  $scope.upload1 = function (file) {
	    $scope.uploading = true;
	    $scope.user.account.picture = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.user.account.picture = resp.data.filename;
	      $scope.groups.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
	    });
	  };
	
	  $scope.delete = function (data) {
	    if (!confirm('Are you sure you want to delete this user?')) {
	      return;
	    }
	    Subscriber.delete({ id: data._id }, function (result) {
	      setTimeout(function () {
	        growl.info('User deleted!');
	        $location.path('/admin/subscribers');
	      }, 1000);
	    }, formErrors.growlErrors);
	  };
	}]);

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-users-detail> <div class=col-xs-12> <div class=page-header> <button ng-href=/admin/users/add class=\"btn btn-danger pull-right\" ng-click=delete(user)>Delete</button> <h1><a ng-href=/admin/subscribers>Subscriber</a> / Edit new</h1> </div> <form novalidate name=addForm class=padded-form ng-submit=submit(user)><fieldset> <div class=col-xs-6> <legend>Login info</legend> <alert ng-repeat=\"alert in identityAlerts\" type={{alert.type}} close=closeIdentityAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(addForm.username)}\"> <label class=control-label for=username>Username:</label> <input type=text name=username class=form-control ng-model=user.username required server-error> </div> <div class=form-group ng-class=\"{'has-error': hasError(addForm.email)}\"> <label class=\"control-lab el\" for=email>Email:</label> <input type=email name=email class=form-control ng-model=user.email autocomplete=new-email required server-error disabled=true> </div> <div class=form-group ng-class=\"{'has-error': hasError(addForm.password) && passwordForm.password.$touched}\"> <label class=control-label for=password>Password:</label> <input type=password name=password class=form-control ng-model=user.passwordnew required server-error> </div> </div> <div class=col-xs-6> <legend>Name</legend> <div class=form-group> <label class=control-label for=first>First:</label> <input type=text name=first class=form-control ng-model=user.first_name required> </div> <div class=form-group> <label class=control-label for=middle>Middle:</label> <input type=text name=middle class=form-control ng-model=user.last_name> </div> </div> <div class=col-xs-12> <div class=form-group> <button type=submit class=\"btn btn-primary\">Save</button> </div> </div> </fieldset> </form> </div> </div> ";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.subscribers.index', ['security.authorization', 'services.utility', 'resources.AdminGroup', 'resources.AdminUser', 'services.adminResource', 'services.search', 'filters.timeAgo', 'services.algoliaResource', 'directives.croppic', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.subscribers', {
	    url: '/subscribers',
	    title: 'Manage Subscribers',
	    views: {
	      'main@': {
	        template: __webpack_require__(266),
	        controller: 'SubscribersIndexCtrl',
	        resolve: {
	          groups: ["AdminGroup", function (AdminGroup) {
	            return AdminGroup.query().$promise;
	          }]
	        }
	      }
	    },
	    resolve: {
	      initSearch: ["searchService", "AdminUser", function (searchService, AdminUser) {
	        searchService.setSearchFn(AdminUser.search);
	        searchService.setRedirectBase('/admin/subscribers/edit');
	      }]
	    }
	  });
	}]).controller('SubscribersIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "AdminUser", "algoliaResource", "searchService", "groups", "localizedMessages", function ($scope, $route, $location, $log, utility, adminResource, AdminUser, algoliaResource, searchService, groups, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  $scope.search = searchService.search;
	  $scope.groups = groups.data;
	
	  $scope.getAuthor = function ($item) {
	    $scope.author = $item.name + ' performance';
	    $scope.query.author = $item.username;
	  };
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.page = data.meta.page;
	    $scope.query = data.meta.query;
	    $scope.users = data.data;
	    console.log(data);
	  };
	
	  var fetchData = function fetchData() {
	    adminResource.findSubscribers($scope.query).then(function (data) {
	      deserializeData(data);
	      //update url in browser addr bar
	      $location.search($scope.query);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  $scope.$watchCollection('query', function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	    fetchData();
	  });
	
	  //select elements and their associating options
	  /*if (query.groups) {
	    query.groups = _.map(query.groups, '_id');
	  }
	  $scope.groups = [
	    {label: "Editor ESPAÑA", value: "57d72a2d9dd8590130bf71ed"},
	    {label: "Writer Spain", value: "57d72a2d9dd8590130bf71f2"},
	    {label: "Editor ITALIA", value: "57d72a2d9dd8590130bf71f4"}
	  ];*/
	  $scope.roles = [{ label: "any", value: "" }, { label: "admin", value: "admin" }, { label: "account", value: "account" }];
	  $scope.isActives = [{ label: "either", value: "" }, { label: "yes", value: "yes" }, { label: "no", value: "no" }];
	  $scope.sorts = [{ label: 'id \u25B2', value: "_uid" }, { label: 'id \u25BC', value: "-_uid" }, { label: 'username \u25B2', value: "username" }, { label: 'username \u25BC', value: "-username" }, { label: 'email \u25B2', value: "email" }, { label: 'email \u25BC', value: "-email" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  $scope.query = $location.search();
	  $scope.query.limit = $scope.query.limit || 10;
	  $scope.query.is_active = '';
	  $scope.query.group = '';
	  $scope.query.author = '';
	
	  fetchData();
	
	  $scope.algoliaReindexing = function () {
	    algoliaResource.indexingAuthors().then(function (result) {
	      $scope.algoliaSuccess = true;
	    }).catch(function (error) {
	      $scope.algoliaError = true;
	    });
	  };
	}]);

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-users-index> <div class=col-xs-12> <div class=page-header> <h1>Subscribers</h1> </div> <form class=filters> <div class=row> <div class=col-sm-2> <label>Limit</label> <select name=limit class=form-control ng-model=query.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\"> </select> </div> </div> </form> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>Username</th> <th>Email</th> <th>First Name</th> <th>Last Name</th> <th> </th> </tr> </thead> <tbody> <tr ng-repeat=\"user in users\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/admin/subscribers/edit/{{user._id}}>Edit</a></td> <td ng-bind=user.username></td> <td ng-bind=user.email></td> <td ng-bind=user.first_name></td> <td ng-bind=user.last_name></td> <td class=stretch> <span class=\"badge badge-clear pull-right\" ng-bind=\"(user.created_at | timeAgo)\"></span> </td> </tr> <tr ng-show=\"users.length === 0\"> <td colspan=5>no documents matched</td> </tr> </tbody> </table> <paginator page-model=page on-navigate=\"query.skip = $offset\"></paginator> </div> </div> ";

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.subscribers', ['admin.subscribers.index',
	// 'admin.subscribers.add',
	'admin.subscribers.detail']);

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.users.add', ['resources.AdminGroup', 'resources.AdminUser', 'services.formErrors', 'security']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.users.add', {
	    url: '/add',
	    title: 'Users / Add new',
	    views: {
	      'main@': {
	        template: __webpack_require__(269),
	        controller: 'AdminAddUserCtrl',
	        resolve: {
	          groups: ["AdminGroup", function (AdminGroup) {
	            return AdminGroup.query().$promise;
	          }]
	        }
	      }
	    }
	  });
	}]).controller('AdminAddUserCtrl', ["$scope", "groups", "AdminUser", "formErrors", "growl", "$location", "security", function ($scope, groups, AdminUser, formErrors, growl, $location, security) {
	  $scope.groups = groups.data;
	
	  $scope.submit = function (data) {
	    var toSubmit = angular.copy(data);
	    toSubmit.is_active = true;
	
	    if (toSubmit.account.groups) {
	      toSubmit.account.groups = _.map(toSubmit.account.groups, '_id');
	    }
	
	    toSubmit.password = security.createHash(toSubmit.password);
	
	    AdminUser.save(toSubmit, function (result) {
	      growl.info('User saved!');
	      $location.path('/admin/users/edit/' + result._id);
	    }, formErrors.growlErrors);
	  };
	}]);

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-users-detail> <div class=col-xs-12> <div class=page-header> <h1><a ng-href=/admin/users>Users</a> / Add new</h1> </div> <form novalidate name=addForm class=padded-form ng-submit=submit(user)><fieldset> <div class=col-xs-6> <legend>Login info</legend> <alert ng-repeat=\"alert in identityAlerts\" type={{alert.type}} close=closeIdentityAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(addForm.username)}\"> <label class=control-label for=username>Username:</label> <input type=text name=username class=form-control ng-model=user.username required server-error> </div> <div class=form-group ng-class=\"{'has-error': hasError(addForm.email)}\"> <label class=\"control-lab el\" for=email>Email:</label> <input type=email name=email class=form-control ng-model=user.email autocomplete=new-email required server-error> </div> <div class=form-group> <label class=control-label for=password>Password:</label> <input type=password name=password class=form-control ng-model=user.password autocomplete=new-password> </div> </div> <div class=col-xs-6> <legend>Name</legend> <div class=form-group> <label class=control-label for=first>First:</label> <input type=text name=first class=form-control ng-model=user.account.name.first required> </div> <div class=form-group> <label class=control-label for=middle>Middle:</label> <input type=text name=middle class=form-control ng-model=user.account.name.middle> </div> <div class=form-group> <label class=control-label for=last>Last:</label> <input type=text name=last class=form-control ng-model=user.account.name.last required> </div> </div> <div class=col-xs-12> <legend>Details</legend> <div class=form-group> <label class=control-label for=occupation>Occupation:</label> <input type=text name=occupation class=form-control ng-model=user.account.occupation> </div> <div class=form-group> <label class=control-label for=country>Country:</label> <input type=text name=country class=form-control ng-model=user.account.country> </div> <div class=form-group> <label class=control-label for=picture>Picture:</label> <input type=text name=picture class=form-control ng-model=user.account.picture> </div> <div class=form-group> <label class=control-label for=avatar>Avatar:</label> <input type=text name=avatar class=form-control ng-model=user.account.avatar> </div> <div class=form-group> <label class=control-label for=bio>Bio:</label> <input type=text name=bio class=form-control ng-model=user.account.bio> </div> <div class=form-group> <label class=control-label for=www>Website:</label> <input type=text name=www class=form-control ng-model=user.account.www> </div> <legend>Roles</legend> <div class=form-group> <label class=control-label>Groups:</label> <oi-select name=groups oi-options=\"item.name for item in groups track by item._id\" ng-model=user.account.groups placeholder=\"Select groups\" multiple=multiple></oi-select> </div> <div class=form-group> <button type=submit class=\"btn btn-primary\">Save</button> </div> </div> </fieldset></form> </div> </div> ";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.users.detail', ['resources.AdminGroup', 'resources.AdminUser', 'services.formErrors', 'directives.croppic', 'security']);
	
	angular.module('admin.users.detail').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.users.edit', {
	    url: '/edit/:id',
	    title: 'Users / Details',
	    views: {
	      'main@': {
	        template: __webpack_require__(271),
	        controller: 'UsersDetailCtrl',
	        resolve: {
	          userDetails: ["adminResource", "$stateParams", function (adminResource, $stateParams) {
	            return adminResource.findUser($stateParams.id);
	          }],
	          groups: ["AdminGroup", function (AdminGroup) {
	            return AdminGroup.query().$promise;
	          }]
	        }
	      }
	    }
	  });
	}]);
	
	angular.module('admin.users.detail').controller('UsersDetailCtrl', ["$scope", "groups", "AdminUser", "formErrors", "growl", "security", "userDetails", "$location", "Upload", "APP_IMG_URLS", "$uibModal", function ($scope, groups, AdminUser, formErrors, growl, security, userDetails, $location, Upload, APP_IMG_URLS, $uibModal) {
	  $scope.groups = groups.data;
	  $scope.user = userDetails;
	  $scope.imgUrl = APP_IMG_URLS.base;
	  // console.log( '>>>', userDetails );
	  $scope.user.passwordnew = "";
	
	  $scope.submit = function (data) {
	    data.psw = false;
	    if (data.passwordnew) {
	      data.psw = true;
	      data.password = security.createHash(data.passwordnew);
	    }
	
	    var toSubmit = angular.copy(data);
	
	    if (toSubmit.account.groups) {
	      toSubmit.account.groups = _.map(toSubmit.account.groups, '_id');
	    }
	
	    toSubmit.passwordnew = data.passwordnew;
	
	    AdminUser.update(toSubmit, function (result) {
	      growl.info('User saved!');
	    }, formErrors.growlErrors);
	  };
	
	  /***/
	  $scope.$watch('file', function (file) {
	    if (!file) return;
	    $scope.upload(file);
	  });
	
	  /*
	  $scope.coverOptions = {
	    objW: 500,
	    objH: 350,
	    cropUrl: '/upload/profile/' + resp.data.filename + '/coverPhoto'
	  };
	    $scope.avatarOptions = {
	    objW: 200,
	    objH: 200,
	    cropUrl: '/upload/profile/' + resp.data.filename + '/photo'
	  };
	  */
	
	  // upload on file select or drop
	  $scope.upload = function (file) {
	    $scope.uploading = true;
	    $scope.user.account.avatar = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.user.account.avatar = resp.data.filename;
	      $scope.groups.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
	    });
	  };
	  /*
	  $('#image-cropper').cropit({
	    imageBackground: true,
	    imageBackgroundBorderWidth: 15 // Width of background border
	  });*/
	
	  $scope.$watch('file1', function (file) {
	    if (!file) return;
	    $scope.upload1(file);
	  });
	
	  $scope.generateThumb = function (file, rejFile) {
	    if (file === null && rejFile === undefined) {
	      growl.info('Max image size is 10MB!', 3);
	    }
	  };
	
	  // upload on file select or drop
	  $scope.upload1 = function (file) {
	    $scope.uploading = true;
	    $scope.user.account.picture = file;
	    Upload.upload({
	      url: '/api/articles/upload',
	      data: { file: file }
	    }).then(function (resp) {
	      $scope.uploading = false;
	      $scope.user.account.picture = resp.data.filename;
	      $scope.groups.image = resp.data.filename;
	    }, function (resp) {
	      $scope.uploading = false;
	      $scope.thumbnail = null;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	      //console.log('progress: ' + progressPercentage + '% ' + evt.config.groups.file.name);
	    });
	  };
	
	  $scope.delete = function (data) {
	    if (!confirm('Are you sure you want to delete this user?')) {
	      return;
	    }
	    AdminUser.delete({ id: data._id }, function (result) {
	      setTimeout(function () {
	        growl.info('User deleted!');
	        $location.path('/admin/users');
	      }, 1000);
	    }, formErrors.growlErrors);
	  };
	}]);

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-users-detail> <div class=col-xs-12> <div class=page-header> <button ng-href=/admin/users/add class=\"btn btn-danger pull-right\" ng-click=delete(user)>Delete</button> <h1><a ng-href=/admin/users>Users 1</a> / {{user.username}}</h1> </div> <form novalidate name=addForm class=padded-form ng-submit=submit(user)><fieldset> <div class=col-xs-6> <legend>Login info</legend> <alert ng-repeat=\"alert in identityAlerts\" type={{alert.type}} close=closeIdentityAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(addForm.username)}\"> <label class=control-label for=username>Username:</label> <input type=text name=username class=form-control ng-model=user.username required server-error> </div> <div class=form-group ng-class=\"{'has-error': hasError(addForm.email)}\"> <label class=control-label for=email>Email:</label> <input type=email name=email class=form-control ng-model=user.email autocomplete=new-email required server-error> </div> <div class=form-group ng-class=\"{'has-error': hasError(addForm.password) && passwordForm.password.$touched}\"> <label class=control-label for=password>Password:</label> <input type=password name=password class=form-control ng-model=user.passwordnew required server-error> </div> </div> <div class=col-xs-6> <legend>Name</legend> <div class=form-group> <label class=control-label for=first>First:</label> <input type=text name=first class=form-control ng-model=user.account.name.first required> </div> <div class=form-group> <label class=control-label for=last>Last:</label> <input type=text name=last class=form-control ng-model=user.account.name.last required> </div> </div> <div class=col-xs-12> <legend>Details</legend> <div class=col-xs-6> <div class=form-group> <label class=control-label for=occupation>Occupation:</label> <input type=text name=occupation class=form-control ng-model=user.account.occupation> </div> <div class=form-group> <label class=control-label for=bio>Bio:</label> <input type=text name=bio class=form-control ng-model=user.account.bio> </div> <div class=form-group> <label class=control-label for=www>Website:</label> <input type=text name=www class=form-control ng-model=user.account.www> </div> <div class=form-group> <label class=control-label for=country>Country:</label> <input type=text name=country class=form-control ng-model=user.account.country> </div> <div class=form-group> <label class=control-label for=blog_name>Blog Name:</label> <input type=text name=blog_name class=form-control ng-model=user.account.blog_name> </div> </div> <div class=col-xs-6> <div class=form-group> <label class=control-label for=file1>Picture:{{user.account.picture}}</label> <figure class=article-image ng-class=\"{'no-image': !data.image}\" type=file id=file1 ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file1 name=file1 accept=image/* required ngf-model-invalid=errorFiles ngf-validate=\"{size: {min: 10, max: '10MB'}}\" ngf-resize=\"{width: 1280}\" ngf-resize-if=\"$width > 1280\" ngf-change=\"generateThumb($file, $rejectedFile)\" style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{imgUrl + user.account.picture}}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> <div class=form-group> <label class=control-label for=file>Avatar:{{user.account.avatar}}</label> <figure class=article-image ng-class=\"{'no-image': !user.account.image}\" type=file id=file ngf-drop-available=true ngf-drop-disabled=false ngf-drag-over-class=\"'dragover'\" ngf-hide-on-drop-not-available=true ngf-select ngf-drop ng-model=file name=file accept=image/* ngf-max-size=10MB required ngf-model-invalid=errorFiles ngf-resize=\"{width: 200, height: 200, centerCrop: true}\" style=\"padding:1.2em;border-radius:10px;background-color:#fff;text-align:center;-webkit-box-shadow:0 0 3px rgba(0,0,0,.15);-o-box-shadow:0 0 3px rgba(0,0,0,.15);box-shadow:0 0 3px rgba(0,0,0,.15);border-top-left-radius:10px;-moz-border-radius-topleft:10px;-webkit-border-radius-topleft:10px;border-top-right-radius:10px;-moz-border-radius-topright:10px;-webkit-border-radius-topright:10px;position:relative\"> <div style=background-color:transparent;display:block;cursor:pointer for=file-upload> <img class=img-responsive src=\"{{imgUrl + user.account.avatar}}\"> <div class=loader style=position:absolute;top:0;background:rgba(0,0,0,.25);width:100%;height:100% ng-if=uploading> <i class=\"fas fa-spinner fa-spin\" style=margin-top:130px></i> </div> </div> </figure> </div> </div> <legend>Roles</legend> <div class=form-group> <label class=control-label>Groups:</label> <oi-select name=groups oi-options=\"item.name for item in groups track by item._id\" ng-model=user.account.groups placeholder=\"Select groups\" multiple=multiple></oi-select> </div> <legend>Sociable network</legend> <div class=form-group> <label class=control-label>Twitter:</label> <input type=text name=twitter id=twitter class=form-control ng-model=user.twitter> </div> <div class=form-group> <label class=control-label>Facebool:</label> <input type=text name=facebook id=facebook class=form-control ng-model=user.facebook> </div> <div class=form-group> <label class=control-label>Google:</label> <input type=text name=google id=google class=form-control ng-model=user.google> </div> <div class=form-group> <button type=submit class=\"btn btn-primary\">Save</button> </div> </div> </fieldset></form> </div> </div> ";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('admin.users.index', ['security.authorization', 'services.utility', 'resources.AdminGroup', 'resources.AdminUser', 'services.adminResource', 'services.search', 'filters.timeAgo', 'services.algoliaResource', 'directives.croppic', 'services.localizedMessages']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('admin.users', {
	    url: '/users',
	    title: 'Manage Users',
	    views: {
	      'main@': {
	        template: __webpack_require__(273),
	        controller: 'UsersIndexCtrl',
	        resolve: {
	          groups: ["AdminGroup", function (AdminGroup) {
	            return AdminGroup.query().$promise;
	          }]
	        }
	      }
	    },
	    resolve: {
	      initSearch: ["searchService", "AdminUser", function (searchService, AdminUser) {
	        searchService.setSearchFn(AdminUser.search);
	        searchService.setRedirectBase('/admin/users/edit');
	      }]
	    }
	  });
	}]).controller('UsersIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "AdminUser", "algoliaResource", "searchService", "groups", "localizedMessages", function ($scope, $route, $location, $log, utility, adminResource, AdminUser, algoliaResource, searchService, groups, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  $scope.search = searchService.search;
	  $scope.groups = groups.data;
	
	  $scope.getAuthor = function ($item) {
	    $scope.author = $item.name + ' performance';
	    $scope.query.author = $item.username;
	  };
	  // local var
	  var deserializeData = function deserializeData(data) {
	    $scope.page = data.meta.page;
	    $scope.query = data.meta.query;
	    $scope.users = data.data;
	  };
	
	  var fetchData = function fetchData() {
	    adminResource.findUsers($scope.query).then(function (data) {
	      deserializeData(data);
	      //update url in browser addr bar
	      $location.search($scope.query);
	    }, function (e) {
	      $log.error(e);
	    });
	  };
	
	  $scope.$watchCollection('query', function (newState, oldState) {
	    if (angular.equals(newState, oldState)) {
	      return;
	    }
	    fetchData();
	  });
	
	  //select elements and their associating options
	  /*if (query.groups) {
	    query.groups = _.map(query.groups, '_id');
	  }
	  $scope.groups = [
	    {label: "Editor ESPAÑA", value: "57d72a2d9dd8590130bf71ed"},
	    {label: "Writer Spain", value: "57d72a2d9dd8590130bf71f2"},
	    {label: "Editor ITALIA", value: "57d72a2d9dd8590130bf71f4"}
	  ];*/
	  $scope.roles = [{ label: "any", value: "" }, { label: "admin", value: "admin" }, { label: "account", value: "account" }];
	  $scope.isActives = [{ label: "Tak", value: "yes" }, { label: "Nie", value: "no" }];
	  $scope.sorts = [{ label: 'id \u25B2', value: "_uid" }, { label: 'id \u25BC', value: "-_uid" }, { label: 'username \u25B2', value: "username" }, { label: 'username \u25BC', value: "-username" }, { label: 'email \u25B2', value: "email" }, { label: 'email \u25BC', value: "-email" }];
	  $scope.limits = [{ label: "10 Materiałów", value: 10 }, { label: "20 Materiałów", value: 20 }, { label: "50 Materiałów", value: 50 }, { label: "100 Materiałów", value: 100 }];
	
	  $scope.query = $location.search();
	  $scope.query.limit = $scope.query.limit || 10;
	  $scope.query.is_active = '';
	  $scope.query.group = '';
	  $scope.query.author = '';
	
	  fetchData();
	
	  $scope.algoliaReindexing = function () {
	    algoliaResource.indexingAuthors().then(function (result) {
	      $scope.algoliaSuccess = true;
	    }).catch(function (error) {
	      $scope.algoliaError = true;
	    });
	  };
	}]);

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=admin-users-index> <div class=col-xs-12> <div class=page-header> <a ng-href=/admin/users/add class=\"btn btn-default pull-right\">Dodaj nowego użytkownika</a> <h1>Użytkownicy</h1> </div> <form class=filters> <div class=row> <div class=col-sm-3> <label>Użytkownik</label> <input id=author-name type=text class=form-control placeholder=All autocomplete=off ng-model=query.author ng-model-options=\"{ debounce: 500 }\" uib-typeahead=\"item as item.name for item in search($viewValue)\" typeahead-on-select=getAuthor($item)> </div> <div class=col-sm-3> <label>Grupy</label> <select name=group class=form-control ng-model=query.group ng-model-options=\"{ debounce: 500 }\" ng-options=\"item._id as item.name for item in groups\" placeholder=\"Select groups\"> </select> </div> <div class=col-sm-2> <label>Jest Aktywny</label> <select name=isActive class=form-control ng-model=query.is_active ng-model-options=\"{ debounce: 500 }\" ng-options=\"isActive.value as isActive.label for isActive in isActives\"> </select> </div> <div class=col-sm-2> <label>Wyszykaj</label> <select name=sort class=form-control ng-model=query.sort ng-model-options=\"{ debounce: 500 }\" ng-options=\"sort.value as sort.label for sort in sorts\"> </select> </div> <div class=col-sm-2> <label>Limit</label> <select name=limit class=form-control ng-model=query.limit ng-model-options=\"{ debounce: 500 }\" ng-options=\"limit.value as limit.label for limit in limits\"> </select> </div> </div> </form> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>Nazwa użytkownika</th> <th class=stretch>email</th> <th>Aktywność</th> <th>Zapisany</th> </tr> </thead> <tbody> <tr ng-repeat=\"user in users\"> <td><a class=\"btn btn-default btn-sm\" ng-href=/admin/users/edit/{{user._id}}>Edytuj</a></td> <td ng-bind=user.username></td> <td ng-bind=user.email></td> <td>{{user.is_active ? 'tak' : 'nie'}}</td> <td class=stretch> <span class=\"badge badge-clear pull-right\" ng-bind=\"(user.created_at | timeAgo)\"></span> </td> </tr> <tr ng-show=\"users.length === 0\"> <td colspan=5>no documents matched</td> </tr> </tbody> </table> <paginator page-model=page on-navigate=\"query.skip = $offset\"></paginator> </div> </div> ";

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('admin.users', ['admin.users.index', 'admin.users.add', 'admin.users.detail']);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(276);
	__webpack_require__(280);
	__webpack_require__(282);
	__webpack_require__(284);
	__webpack_require__(286);
	__webpack_require__(288);
	__webpack_require__(290);
	__webpack_require__(292);
	
	angular.module('app', ['ngAnimate', 'ui.router', 'config', 'base', 'signup', 'login', 'account', 'admin', 'unauthorized',
	//'cache.index',
	'services.i18nNotifications', 'services.httpRequestTracker', 'filters.rawHtml', 'filters.stripHtml', 'security', 'ui.bootstrap', 'angular-growl', 'directives.uiRouterTitle', 'oi.select', 'dndLists', 'ui.bootstrap.datetimepicker', 'angular-md5']);
	
	angular.module('app').config(["$urlRouterProvider", "$locationProvider", "$stateProvider", "$urlMatcherFactoryProvider", function ($urlRouterProvider, $locationProvider, $stateProvider, $urlMatcherFactoryProvider) {
	  $locationProvider.html5Mode({
	    enabled: true,
	    requireBase: false
	  });
	  $urlMatcherFactoryProvider.strictMode(false);
	
	  $stateProvider.state('index', {
	    url: '/',
	    resolve: {
	      isAdmin: ["User", "$state", function (User, $state) {
	        return User.current(function (user) {
	          if (user && user.is_active && user.is_admin) {
	            return;
	          }
	
	          return $state.go('login');
	        }).$promise;
	      }]
	    }
	  }).state('logout', {
	    url: '/logout',
	    views: {
	      main: {
	        controller: ["security", function (security) {
	          security.logout('/login');
	        }]
	      }
	    }
	  });
	}]);
	
	angular.module('app').config(['growlProvider', function (growlProvider) {
	  growlProvider.globalTimeToLive(3000);
	  growlProvider.globalPosition('top-center');
	}]);
	
	// Node.js Express backend csurf module csrf/xsrf token cookie name
	angular.module('app').config(['$httpProvider', 'XSRF_COOKIE_NAME', function ($httpProvider, XSRF_COOKIE_NAME) {
	  $httpProvider.defaults.xsrfCookieName = XSRF_COOKIE_NAME;
	}]);
	
	angular.module('app').run(["$rootScope", "$state", "User", function ($rootScope, $state, User) {
	
	  $rootScope.$on('$stateChangeError', function (e, toState, toParams, fromState, fromParams, error) {
	    if (error === "unauthorized") {
	      $state.go("unauthorized");
	    }
	  });
	}]);
	
	angular.module('app').controller('AppCtrl', ["$scope", function ($scope) {
	
	  // $scope.notifications = i18nNotifications;
	  //
	  // $scope.removeNotification = function (notification) {
	  //   i18nNotifications.remove(notification);
	  // };
	  //
	  // $scope.$on('$routeChangeError', function(event, current, previous, rejection){
	  //   i18nNotifications.pushForCurrentRoute('errors.route.changeError', 'error', {}, {rejection: rejection});
	  // });
	}]);
	//factory to work with socket.io
	angular.module('app').factory('socket', ["$rootScope", function ($rootScope) {
	  var socket = io.connect();
	  return {
	    on: function on(eventName, callback) {
	      socket.on(eventName, function () {
	        var args = arguments;
	        $rootScope.$apply(function () {
	          callback.apply(socket, args);
	        });
	      });
	    },
	    emit: function emit(eventName, data, callback) {
	      socket.emit(eventName, data, function () {
	        var args = arguments;
	        $rootScope.$apply(function () {
	          if (callback) {
	            callback.apply(socket, args);
	          }
	        });
	      });
	    },
	    off: function off(eventName) {
	      socket.off(eventName);
	    }
	  };
	}]);
	
	/**
	 * angular-drag-and-drop-lists v1.4.0
	 *
	 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
	 * Copyright (c) 2014-2016 Google Inc.
	 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
	 *
	 * License: MIT
	 */
	angular.module('dndLists', []).directive('dndDraggable', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround', function ($parse, $timeout, dndDropEffectWorkaround, dndDragTypeWorkaround) {
	  return function (scope, element, attr) {
	    // Set the HTML5 draggable attribute on the element
	    element.attr("draggable", "true");
	
	    // If the dnd-disable-if attribute is set, we have to watch that
	    if (attr.dndDisableIf) {
	      scope.$watch(attr.dndDisableIf, function (disabled) {
	        element.attr("draggable", !disabled);
	      });
	    }
	
	    /**
	     * When the drag operation is started we have to prepare the dataTransfer object,
	     * which is the primary way we communicate with the target element
	     */
	    element.on('dragstart', function (event) {
	      event = event.originalEvent || event;
	
	      // Check whether the element is draggable, since dragstart might be triggered on a child.
	      if (element.attr('draggable') == 'false') return true;
	
	      // Serialize the data associated with this element. IE only supports the Text drag type
	      event.dataTransfer.setData("Text", angular.toJson(scope.$eval(attr.dndDraggable)));
	
	      // Only allow actions specified in dnd-effect-allowed attribute
	      event.dataTransfer.effectAllowed = attr.dndEffectAllowed || "move";
	
	      // Add CSS classes. See documentation above
	      element.addClass("dndDragging");
	      $timeout(function () {
	        element.addClass("dndDraggingSource");
	      }, 0);
	
	      // Workarounds for stupid browsers, see description below
	      dndDropEffectWorkaround.dropEffect = "none";
	      dndDragTypeWorkaround.isDragging = true;
	
	      // Save type of item in global state. Usually, this would go into the dataTransfer
	      // typename, but we have to use "Text" there to support IE
	      dndDragTypeWorkaround.dragType = attr.dndType ? scope.$eval(attr.dndType) : undefined;
	
	      // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
	      if (event._dndHandle && event.dataTransfer.setDragImage) {
	        event.dataTransfer.setDragImage(element[0], 0, 0);
	      }
	
	      // Invoke callback
	      $parse(attr.dndDragstart)(scope, { event: event });
	
	      event.stopPropagation();
	    });
	
	    element.on('dragend', function (event) {
	      event = event.originalEvent || event;
	
	      var dropEffect = dndDropEffectWorkaround.dropEffect;
	      scope.$apply(function () {
	        switch (dropEffect) {
	          case "move":
	            $parse(attr.dndMoved)(scope, { event: event });
	            break;
	          case "copy":
	            $parse(attr.dndCopied)(scope, { event: event });
	            break;
	          case "none":
	            $parse(attr.dndCanceled)(scope, { event: event });
	            break;
	        }
	        $parse(attr.dndDragend)(scope, { event: event, dropEffect: dropEffect });
	      });
	
	      // Clean up
	      element.removeClass("dndDragging");
	      $timeout(function () {
	        element.removeClass("dndDraggingSource");
	      }, 0);
	      dndDragTypeWorkaround.isDragging = false;
	      event.stopPropagation();
	    });
	    element.on('click', function (event) {
	      if (!attr.dndSelected) return;
	
	      event = event.originalEvent || event;
	      scope.$apply(function () {
	        $parse(attr.dndSelected)(scope, { event: event });
	      });
	
	      // Prevent triggering dndSelected in parent elements.
	      event.stopPropagation();
	    });
	
	    element.on('selectstart', function () {
	      if (this.dragDrop) this.dragDrop();
	    });
	  };
	}]).directive('dndList', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround', function ($parse, $timeout, dndDropEffectWorkaround, dndDragTypeWorkaround) {
	  return function (scope, element, attr) {
	    // While an element is dragged over the list, this placeholder element is inserted
	    // at the location where the element would be inserted after dropping
	    var placeholder = getPlaceholderElement();
	    var placeholderNode = placeholder[0];
	    var listNode = element[0];
	    placeholder.remove();
	
	    var horizontal = attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList);
	    var externalSources = attr.dndExternalSources && scope.$eval(attr.dndExternalSources);
	
	    element.on('dragenter', function (event) {
	      event = event.originalEvent || event;
	      if (!isDropAllowed(event)) return true;
	      event.preventDefault();
	    });
	
	    element.on('dragover', function (event) {
	      event = event.originalEvent || event;
	
	      if (!isDropAllowed(event)) return true;
	
	      // First of all, make sure that the placeholder is shown
	      // This is especially important if the list is empty
	      if (placeholderNode.parentNode != listNode) {
	        element.append(placeholder);
	      }
	
	      if (event.target !== listNode) {
	        // Try to find the node direct directly below the list node.
	        var listItemNode = event.target;
	        while (listItemNode.parentNode !== listNode && listItemNode.parentNode) {
	          listItemNode = listItemNode.parentNode;
	        }
	
	        if (listItemNode.parentNode === listNode && listItemNode !== placeholderNode) {
	          // If the mouse pointer is in the upper half of the child element,
	          // we place it before the child element, otherwise below it.
	          if (isMouseInFirstHalf(event, listItemNode)) {
	            listNode.insertBefore(placeholderNode, listItemNode);
	          } else {
	            listNode.insertBefore(placeholderNode, listItemNode.nextSibling);
	          }
	        }
	      } else {
	
	        if (isMouseInFirstHalf(event, placeholderNode, true)) {
	          // Check if we should move the placeholder element one spot towards the top.
	          // Note that display none elements will have offsetTop and offsetHeight set to
	          // zero, therefore we need a special check for them.
	          while (placeholderNode.previousElementSibling && (isMouseInFirstHalf(event, placeholderNode.previousElementSibling, true) || placeholderNode.previousElementSibling.offsetHeight === 0)) {
	            listNode.insertBefore(placeholderNode, placeholderNode.previousElementSibling);
	          }
	        } else {
	          // Check if we should move the placeholder element one spot towards the bottom
	          while (placeholderNode.nextElementSibling && !isMouseInFirstHalf(event, placeholderNode.nextElementSibling, true)) {
	            listNode.insertBefore(placeholderNode, placeholderNode.nextElementSibling.nextElementSibling);
	          }
	        }
	      }
	
	      // At this point we invoke the callback, which still can disallow the drop.
	      // We can't do this earlier because we want to pass the index of the placeholder.
	      if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, getPlaceholderIndex())) {
	        return stopDragover();
	      }
	
	      element.addClass("dndDragover");
	      event.preventDefault();
	      event.stopPropagation();
	      return false;
	    });
	
	    element.on('drop', function (event) {
	      event = event.originalEvent || event;
	
	      if (!isDropAllowed(event)) return true;
	
	      // The default behavior in Firefox is to interpret the dropped element as URL and
	      // forward to it. We want to prevent that even if our drop is aborted.
	      event.preventDefault();
	
	      // Unserialize the data that was serialized in dragstart. According to the HTML5 specs,
	      // the "Text" drag type will be converted to text/plain, but IE does not do that.
	      var data = event.dataTransfer.getData("Text") || event.dataTransfer.getData("text/plain");
	      var transferredObject;
	      try {
	        transferredObject = JSON.parse(data);
	      } catch (e) {
	        return stopDragover();
	      }
	
	      // Invoke the callback, which can transform the transferredObject and even abort the drop.
	      var index = getPlaceholderIndex();
	      if (attr.dndDrop) {
	        transferredObject = invokeCallback(attr.dndDrop, event, index, transferredObject);
	        if (!transferredObject) {
	          return stopDragover();
	        }
	      }
	      if (transferredObject !== true) {
	        scope.$apply(function () {
	          scope.$eval(attr.dndList).splice(index, 0, transferredObject);
	        });
	      }
	      invokeCallback(attr.dndInserted, event, index, transferredObject);
	      if (event.dataTransfer.dropEffect === "none") {
	        if (event.dataTransfer.effectAllowed === "copy" || event.dataTransfer.effectAllowed === "move") {
	          dndDropEffectWorkaround.dropEffect = event.dataTransfer.effectAllowed;
	        } else {
	          dndDropEffectWorkaround.dropEffect = event.ctrlKey ? "copy" : "move";
	        }
	      } else {
	        dndDropEffectWorkaround.dropEffect = event.dataTransfer.dropEffect;
	      }
	      stopDragover();
	      event.stopPropagation();
	      return false;
	    });
	    element.on('dragleave', function (event) {
	      event = event.originalEvent || event;
	
	      element.removeClass("dndDragover");
	      $timeout(function () {
	        if (!element.hasClass("dndDragover")) {
	          placeholder.remove();
	        }
	      }, 100);
	    });
	    function isMouseInFirstHalf(event, targetNode, relativeToParent) {
	      var mousePointer = horizontal ? event.offsetX || event.layerX : event.offsetY || event.layerY;
	      var targetSize = horizontal ? targetNode.offsetWidth : targetNode.offsetHeight;
	      var targetPosition = horizontal ? targetNode.offsetLeft : targetNode.offsetTop;
	      targetPosition = relativeToParent ? targetPosition : 0;
	      return mousePointer < targetPosition + targetSize / 2;
	    }
	
	    function getPlaceholderElement() {
	      var placeholder;
	      angular.forEach(element.children(), function (childNode) {
	        var child = angular.element(childNode);
	        if (child.hasClass('dndPlaceholder')) {
	          placeholder = child;
	        }
	      });
	      return placeholder || angular.element("<li class='dndPlaceholder'></li>");
	    }
	
	    function getPlaceholderIndex() {
	      return Array.prototype.indexOf.call(listNode.children, placeholderNode);
	    }
	
	    function isDropAllowed(event) {
	      if (!dndDragTypeWorkaround.isDragging && !externalSources) return false;
	      if (!hasTextMimetype(event.dataTransfer.types)) return false;
	      if (attr.dndAllowedTypes && dndDragTypeWorkaround.isDragging) {
	        var allowed = scope.$eval(attr.dndAllowedTypes);
	        if (angular.isArray(allowed) && allowed.indexOf(dndDragTypeWorkaround.dragType) === -1) {
	          return false;
	        }
	      }
	      if (attr.dndDisableIf && scope.$eval(attr.dndDisableIf)) return false;
	
	      return true;
	    }
	
	    function stopDragover() {
	      placeholder.remove();
	      element.removeClass("dndDragover");
	      return true;
	    }
	
	    function invokeCallback(expression, event, index, item) {
	      return $parse(expression)(scope, {
	        event: event,
	        index: index,
	        item: item || undefined,
	        external: !dndDragTypeWorkaround.isDragging,
	        type: dndDragTypeWorkaround.isDragging ? dndDragTypeWorkaround.dragType : undefined
	      });
	    }
	
	    function hasTextMimetype(types) {
	      if (!types) return true;
	      for (var i = 0; i < types.length; i++) {
	        if (types[i] === "Text" || types[i] === "text/plain") return true;
	      }
	
	      return false;
	    }
	  };
	}]).directive('dndNodrag', function () {
	  return function (scope, element, attr) {
	    element.attr("draggable", "true");
	    element.on('dragstart', function (event) {
	      event = event.originalEvent || event;
	
	      if (!event._dndHandle) {
	        if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
	          event.preventDefault();
	        }
	        event.stopPropagation();
	      }
	    });
	
	    element.on('dragend', function (event) {
	      event = event.originalEvent || event;
	      if (!event._dndHandle) {
	        event.stopPropagation();
	      }
	    });
	  };
	}).directive('dndHandle', function () {
	  return function (scope, element, attr) {
	    element.attr("draggable", "true");
	
	    element.on('dragstart dragend', function (event) {
	      event = event.originalEvent || event;
	      event._dndHandle = true;
	    });
	  };
	}).factory('dndDragTypeWorkaround', function () {
	  return {};
	}).factory('dndDropEffectWorkaround', function () {
	  return {};
	});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(277);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./angular-toggle-switch.css", function() {
				var newContent = require("!!../css-loader/index.js!./angular-toggle-switch.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, ".toggle-switch{border:1px solid;cursor:pointer;display:inline-block;text-align:left;overflow:hidden;line-height:8px;min-width:100px}.toggle-switch.disabled>div>span.knob{background:#aaa}.toggle-switch span{cursor:pointer;display:inline-block;float:left;height:100%;line-height:20px;padding:4px;text-align:center;width:33%;white-space:nowrap;box-sizing:border-box;-o-box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}.toggle-switch>div{position:relative;width:150%}.toggle-switch .knob{background:red;border-left:1px solid #ccc;border-right:1px solid #ccc;background-color:#f5f5f5;width:34%;z-index:100}.toggle-switch .switch-on{left:0}.toggle-switch .switch-off{left:-50%}.toggle-switch .switch-left,.toggle-switch .switch-right{z-index:1}.toggle-switch .switch-left{color:#fff;background:#005fcc}.toggle-switch .switch-right{color:#333;background:#f0f0f0}.toggle-switch-animate{transition:left .5s;-o-transition:left .5s;-moz-transition:left .5s;-webkit-transition:left .5s}", ""]);
	
	// exports


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(281);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./angular-toggle-switch-bootstrap.css", function() {
				var newContent = require("!!../css-loader/index.js!./angular-toggle-switch-bootstrap.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, ".toggle-switch{display:inline-block;cursor:pointer;border-radius:4px;border:1px solid;border-color:#ccc;position:relative;text-align:left;overflow:hidden;line-height:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;min-width:100px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.toggle-switch .knob{color:#333;background:#fff;border:3px}.toggle-switch .switch-left{color:#fff;background:#428bca}.toggle-switch .switch-right{color:#000;background:#eee}", ""]);
	
	// exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(283);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./select.css", function() {
				var newContent = require("!!../../css-loader/index.js!./select.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, "oi-select{display:block;position:relative;width:100%}oi-select .select-search{cursor:text;border:1px solid #d9d9d9;background-color:#fff;overflow:hidden!important;box-sizing:border-box;border-radius:4px}oi-select .select-search-list{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-pack:start;justify-content:flex-start;margin:0;padding:2px 4px;list-style:none}oi-select .select-search-list-item{font-size:14px;margin:2px 4px 2px 0;vertical-align:middle;white-space:normal}oi-select .select-search-list-item_selection{cursor:pointer;background:#efefef;border-color:#ebebeb}oi-select .select-search-list-item_selection:hover{border-color:#e5e5e5}oi-select .select-search-list-item_selection.focused,oi-select .select-search-list-item_selection:active{border:1px solid #fff;border-radius:0;box-shadow:inset 0 0 10px 5px #fff}oi-select .select-search-list-item_selection.focused .close{display:none}oi-select .select-search-list-item_selection-remove{padding-left:2px}oi-select .select-search-list-item_loader{float:right;margin-top:6px;width:16px;height:16px;background:top url(\"data:image/gif;base64,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\")}oi-select .select-search-list-item_input{-ms-flex-positive:1;flex-grow:1;margin:4px 0 5px 5px}oi-select .select-search-list-item_input input{padding:0;outline:0;border:0;width:100%}oi-select .select-search-list-item_hide{position:fixed;width:0;height:0;margin:0;opacity:0;pointer-events:none;text-indent:-9999em}oi-select .select-dropdown{position:absolute;width:inherit;overflow-y:scroll;max-height:100px;min-width:160px;font-size:14px;background-color:#fff;border-radius:0 0 4px 4px;border:1px solid #66afe9;border-top:0;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);background-clip:padding-box;z-index:1000}oi-select .select-dropdown-optgroup{margin:0;padding:0}oi-select .select-dropdown-optgroup-header{font-weight:bolder;padding:3px 10px}oi-select .select-dropdown-optgroup-option{padding:3px 20px}oi-select .select-dropdown-optgroup-option.active:not(.disabled){background-color:#f1f1f1;cursor:pointer}oi-select .select-dropdown-optgroup-option.disabled{color:#aaa}oi-select:not(.multiple) .select-search-list-item_selection{color:#000;width:100%;border-color:#fff;text-align:left}oi-select:not(.multiple) .select-search-list-item_selection:not(:active){background:none}oi-select:not(.multiple):not(.cleanMode) .select-search-list-item_selection-remove{display:none}oi-select:not(.multiple):not(.cleanMode) .select-search:after{content:\"\";position:absolute;display:block;right:10px;width:0;height:0;margin-top:-19px;border-color:#000 transparent transparent;border-style:solid;border-width:5px 5px 0}oi-select[disabled=disabled] .select-search{cursor:not-allowed;background:#eee;border:1px solid #bdbdbd;opacity:.5}oi-select[disabled=disabled] .select-search-list-item_selection{cursor:not-allowed;box-shadow:none;border-color:transparent}oi-select[disabled=disabled] .select-search-list-item_selection-remove{visibility:hidden}oi-select[disabled=disabled] .select-search-list-item_input input:disabled{cursor:not-allowed;background:none}oi-select.focused .select-search{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}oi-select.invalid-item .select-dropdown,oi-select.invalid-item .select-search,oi-select.limited .select-dropdown,oi-select.limited .select-search{border-color:#f1bc28;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(230,189,46,.6)}oi-select.open .select-search{border-radius:4px 4px 0 0;border-bottom:1px solid rgba(0,0,0,.075)}oi-select.open:not(.multiple) .select-search:after{border-color:transparent transparent #000;border-width:0 5px 5px}oi-select.loading:not(.multiple) .select-search:after{border-width:0}oi-select.emptyList .select-dropdown-optgroup-option strong{font-weight:400}", ""]);
	
	// exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(285);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./ng-tags-input.css", function() {
				var newContent = require("!!../../css-loader/index.js!./ng-tags-input.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, "tags-input{display:block}tags-input *,tags-input :after,tags-input :before{box-sizing:border-box}tags-input .host{position:relative;margin-top:5px;margin-bottom:5px;height:100%}tags-input .host:active{outline:none}tags-input .tags{-moz-appearance:textfield;-webkit-appearance:textfield;padding:1px;overflow:hidden;word-wrap:break-word;cursor:text;background-color:#fff;border:1px solid #a9a9a9;box-shadow:inset 1px 1px 1px 0 #d3d3d3;height:100%}tags-input .tags.focused{outline:none;box-shadow:0 0 3px 1px rgba(5,139,242,.6)}tags-input .tags .tag-list{margin:0;padding:0;list-style-type:none}tags-input .tags .tag-item{margin:2px;padding:0 5px;display:inline-block;float:left;font:14px Helvetica Neue,Helvetica,Arial,sans-serif;height:26px;line-height:25px;border:1px solid #acacac;border-radius:3px;background:linear-gradient(180deg,#f0f9ff 0,#cbebff 47%,#a1dbff)}tags-input .tags .tag-item.selected{background:linear-gradient(180deg,#febbbb 0,#fe9090 45%,#ff5c5c)}tags-input .tags .tag-item .remove-button{margin:0 0 0 5px;padding:0;border:none;background:none;cursor:pointer;vertical-align:middle;font:700 16px Arial,sans-serif;color:#585858}tags-input .tags .tag-item .remove-button:active{color:red}tags-input .tags .input{border:0;outline:none;margin:2px;padding:0;padding-left:5px;float:left;height:26px;font:14px Helvetica Neue,Helvetica,Arial,sans-serif}tags-input .tags .input.invalid-tag{color:red}tags-input .tags .input::-ms-clear{display:none}tags-input.ng-invalid .tags{box-shadow:0 0 3px 1px rgba(255,0,0,.6)}tags-input[disabled] .host:focus{outline:none}tags-input[disabled] .tags{background-color:#eee;cursor:default}tags-input[disabled] .tags .tag-item{opacity:.65;background:linear-gradient(180deg,#f0f9ff 0,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62))}tags-input[disabled] .tags .tag-item .remove-button{cursor:default}tags-input[disabled] .tags .tag-item .remove-button:active{color:#585858}tags-input[disabled] .tags .input{background-color:#eee;cursor:default}tags-input .autocomplete{margin-top:5px;position:absolute;padding:5px 0;z-index:999;width:100%;background-color:#fff;border:1px solid rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}tags-input .autocomplete .suggestion-list{margin:0;padding:0;list-style-type:none;max-height:280px;overflow-y:auto;position:relative}tags-input .autocomplete .suggestion-item{padding:5px 10px;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:16px Helvetica Neue,Helvetica,Arial,sans-serif;color:#000;background-color:#fff}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#fff;background-color:#0097cf}tags-input .autocomplete .suggestion-item em{font:normal 700 16px Helvetica Neue,Helvetica,Arial,sans-serif;color:#000;background-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(287);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./ng-tags-input.bootstrap.css", function() {
				var newContent = require("!!../../css-loader/index.js!./ng-tags-input.bootstrap.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, "tags-input{box-shadow:none;border:none;padding:0;min-height:34px}tags-input .host{margin:0}tags-input .tags{-moz-appearance:none;-webkit-appearance:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}tags-input .tags .tag-item{color:#fff;background:#428bca;border:1px solid #357ebd;border-radius:4px}tags-input .tags .tag-item.selected{color:#fff;background:#d9534f;border:1px solid #d43f3a}tags-input .tags .tag-item .remove-button:hover{text-decoration:none}tags-input .tags.focused{border:1px solid #66afe9;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}tags-input .autocomplete{border-radius:4px}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#262626;background-color:#f5f5f5}tags-input .autocomplete .suggestion-item em{color:#000;background-color:#fff}tags-input.ng-invalid .tags{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}tags-input[disabled] .tags{background-color:#eee}tags-input[disabled] .tags .tag-item{background:#337ab7;opacity:.65}tags-input[disabled] .tags .input{background-color:#eee}.input-group tags-input{padding:0;display:table-cell}.input-group tags-input:not(:first-child) .tags{border-top-left-radius:0;border-bottom-left-radius:0}.input-group tags-input:not(:last-child) .tags{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-lg tags-input:first-child .tags{border-top-left-radius:6px;border-bottom-left-radius:6px}.input-group-lg tags-input:last-child .tags{border-top-right-radius:6px;border-bottom-right-radius:6px}.input-group-sm tags-input:first-child .tags{border-top-left-radius:3px;border-bottom-left-radius:3px}.input-group-sm tags-input:last-child .tags{border-top-right-radius:3px;border-bottom-right-radius:3px}.input-group-lg tags-input,tags-input.ti-input-lg{min-height:46px}.input-group-lg tags-input .tags,tags-input.ti-input-lg .tags{border-radius:6px}.input-group-lg tags-input .tags .tag-item,tags-input.ti-input-lg .tags .tag-item{height:38px;line-height:37px;font-size:18px;border-radius:6px}.input-group-lg tags-input .tags .tag-item .remove-button,tags-input.ti-input-lg .tags .tag-item .remove-button{font-size:20px}.input-group-lg tags-input .tags .input,tags-input.ti-input-lg .tags .input{height:38px;font-size:18px}.input-group-sm tags-input,tags-input.ti-input-sm{min-height:30px}.input-group-sm tags-input .tags,tags-input.ti-input-sm .tags{border-radius:3px}.input-group-sm tags-input .tags .tag-item,tags-input.ti-input-sm .tags .tag-item{height:22px;line-height:21px;font-size:12px;border-radius:3px}.input-group-sm tags-input .tags .tag-item .remove-button,tags-input.ti-input-sm .tags .tag-item .remove-button{font-size:16px}.input-group-sm tags-input .tags .input,tags-input.ti-input-sm .tags .input{height:22px;font-size:12px}.has-feedback tags-input .tags{padding-right:30px}.has-success tags-input .tags{border-color:#3c763d}.has-success tags-input .tags.focused{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-error tags-input .tags{border-color:#a94442}.has-error tags-input .tags.focused{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-warning tags-input .tags{border-color:#8a6d3b}.has-warning tags-input .tags.focused{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}", ""]);
	
	// exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(289);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./angular-growl.css", function() {
				var newContent = require("!!../../css-loader/index.js!./angular-growl.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, ".growl-container.growl-fixed{position:fixed;float:right;width:90%;max-width:400px;z-index:9999}.growl-container.growl-fixed.top-right{top:10px;right:15px}.growl-container.growl-fixed.bottom-right{bottom:10px;right:15px}.growl-container.growl-fixed.middle-right{top:49%;right:15px}.growl-container.growl-fixed.top-left{top:10px;left:15px}.growl-container.growl-fixed.bottom-left{bottom:10px;left:15px}.growl-container.growl-fixed.middle-left{top:49%;left:15px}.growl-container.growl-fixed.top-center{top:10px;left:50%;margin-left:-200px}.growl-container.growl-fixed.bottom-center{bottom:10px;left:50%;margin-left:-200px}.growl-container.growl-fixed.middle-center{top:49%;left:50%;margin-left:-200px}.growl-container>.growl-item{padding:10px;padding-right:35px;margin-bottom:10px;cursor:pointer}.growl-container>button{border:none;outline:none}.growl-container>.growl-item.ng-enter,.growl-container>.growl-item.ng-leave{transition:all .5s linear}.growl-container>.growl-item.ng-enter,.growl-container>.growl-item.ng-leave.ng-leave-active{opacity:0}.growl-container>.growl-item.ng-enter.ng-enter-active,.growl-container>.growl-item.ng-leave{opacity:1}.growl-container>div.growl-item{background-position:12px;background-repeat:no-repeat}.growl-title{font-size:16px}.growl-item.icon>.growl-message,.growl-item.icon>.growl-title{margin:0 0 0 40px}.growl-container>.alert-info.icon{background-image:url(\"data:image/png;base64,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\")}.growl-container>.alert-error.icon{background-image:url(\"data:image/png;base64,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\")}.growl-container>.alert-success.icon{background-image:url(\"data:image/png;base64,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\")}.growl-container>.alert-warning.icon{background-image:url(\"data:image/png;base64,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\")}", ""]);
	
	// exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(291);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./angular-ui-tree.css", function() {
				var newContent = require("!!../../css-loader/index.js!./angular-ui-tree.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, ".angular-ui-tree-dropzone,.angular-ui-tree-empty{border:1px dashed #bbb;min-height:100px;background-color:#e5e5e5;background-image:linear-gradient(45deg,#fff 25%,transparent 0,transparent 75%,#fff 0,#fff),linear-gradient(45deg,#fff 25%,transparent 0,transparent 75%,#fff 0,#fff);background-size:60px 60px;background-position:0 0,30px 30px}.angular-ui-tree-empty{pointer-events:none}.angular-ui-tree-nodes{position:relative;margin:0;padding:0;list-style:none}.angular-ui-tree-nodes .angular-ui-tree-nodes{padding-left:20px}.angular-ui-tree-node,.angular-ui-tree-placeholder{position:relative;margin:0;padding:0;min-height:20px;line-height:20px}.angular-ui-tree-hidden{display:none}.angular-ui-tree-placeholder{margin:10px;padding:0;min-height:30px}.angular-ui-tree-handle{cursor:move;text-decoration:none;font-weight:700;box-sizing:border-box;min-height:20px;line-height:20px}.angular-ui-tree-drag{position:absolute;pointer-events:none;z-index:999;opacity:.8}.angular-ui-tree-drag .tree-node-content{margin-top:0}", ""]);
	
	// exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(293);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(279)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./DateTimePicker.css", function() {
				var newContent = require("!!../../css-loader/index.js!./DateTimePicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(278)();
	// imports
	
	
	// module
	exports.push([module.id, ".dtpicker-overlay{z-index:2000;display:none;min-width:300px;background:rgba(0,0,0,.2);font-size:12px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.dtpicker-mobile{position:fixed;top:0;left:0;width:100%;height:100%}.dtpicker-overlay *{box-sizing:border-box;-ms-box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.dtpicker-bg{width:100%;height:100%;font-family:Arial}.dtpicker-cont{border:1px solid #ecf0f1}.dtpicker-mobile .dtpicker-cont{position:relative;top:50%;transform:translateY(-50%);border:none}.dtpicker-content{margin:0 auto;padding:1em 0;max-width:500px;background:#fff}.dtpicker-mobile .dtpicker-content{width:97%}.dtpicker-subcontent{position:relative}.dtpicker-header{margin:.2em 1em}.dtpicker-header .dtpicker-title{color:#2980b9;text-align:center;font-size:1.1em}.dtpicker-header .dtpicker-close{position:absolute;top:-.7em;right:.3em;padding:.5em .5em 1em 1em;color:#ff3b30;font-size:1.5em;cursor:pointer}.dtpicker-header .dtpicker-close:hover{color:#ff3b30}.dtpicker-header .dtpicker-value{padding:.8em .2em .2em;color:#ff3b30;text-align:center;font-size:1.4em}.dtpicker-components{overflow:hidden;margin:1em;font-size:1.3em}.dtpicker-components *{margin:0;padding:0}.dtpicker-components .dtpicker-compOutline{display:inline-block;float:left}.dtpicker-comp2{width:50%}.dtpicker-comp3{width:33.3%}.dtpicker-comp4{width:25%}.dtpicker-comp5{width:20%}.dtpicker-comp6{width:16.66%}.dtpicker-comp7{width:14.285%}.dtpicker-components .dtpicker-comp{margin:2%;text-align:center}.dtpicker-components .dtpicker-comp>*{display:block;height:30px;color:#2980b9;text-align:center;line-height:30px}.dtpicker-components .dtpicker-comp>:hover{color:#2980b9}.dtpicker-components .dtpicker-compButtonEnable{opacity:1}.dtpicker-components .dtpicker-compButtonDisable{opacity:.5}.dtpicker-components .dtpicker-compButton{background:#fff;font-size:140%;cursor:pointer}.dtpicker-components .dtpicker-compValue{margin:.4em 0;width:100%;border:none;background:#fff;font-size:100%;-webkit-appearance:none;-moz-appearance:none}.dtpicker-overlay .dtpicker-compValue:focus{outline:none;background:#f2fcff}.dtpicker-buttonCont{overflow:hidden;margin:.2em 1em}.dtpicker-buttonCont .dtpicker-button{display:block;padding:.6em 0;width:47%;background:#ff3b30;color:#fff;text-align:center;font-size:1.3em;cursor:pointer}.dtpicker-buttonCont .dtpicker-button:hover{color:#fff}.dtpicker-singleButton .dtpicker-button{margin:.2em auto}.dtpicker-twoButtons .dtpicker-buttonSet{float:left}.dtpicker-twoButtons .dtpicker-buttonClear{float:right}", ""]);
	
	// exports


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('base', ['ngRoute', 'security', 'services.utility', 'services.accountResource', 'services.adminResource', 'services.editionResource', 'services.algoliaResource', 'ui.bootstrap']);
	angular.module('base').controller('AdminHeaderCtrl', ['$scope', 'adminResource', function ($scope, adminResource) {
	
	  var clearSearchDropdown = function clearSearchDropdown() {
	    $scope.resultIsOpen = false;
	    $scope.result = {};
	  };
	  var showSearchDropdown = function showSearchDropdown(data) {
	    $scope.result = data;
	    $scope.resultIsOpen = true;
	  };
	
	  $scope.showDropdownHeader = function (header) {
	    var users = $scope.result.users;
	    var accounts = $scope.result.accounts;
	    var administrators = $scope.result.administrators;
	    if (!(users && accounts && administrators)) {
	      return false;
	    }
	    switch (header) {
	      case 'noDocsMatched':
	        return users.length === 0 && accounts.length === 0 && administrators.length === 0;
	      case 'Users':
	        return users.length !== 0;
	      case 'Accounts':
	        return accounts.length !== 0;
	      case 'Administrators':
	        return administrators.length !== 0;
	      default:
	        return false;
	    }
	  };
	
	  $scope.update = function () {
	    clearSearchDropdown();
	    if ($scope.query) {
	      // no need to search backend if query string is empty
	      adminResource.search($scope.query).then(function (data) {
	        showSearchDropdown(data);
	      }, function (e) {
	        clearSearchDropdown();
	      });
	    }
	  };
	
	  $scope.closeAdminMenu = function () {
	    $scope.adminMenuCollapsed = true;
	  };
	
	  $scope.toggleAdminMenu = function () {
	    $scope.adminMenuCollapsed = !$scope.adminMenuCollapsed;
	  };
	
	  // set $scope vars initial value
	  $scope.resultIsOpen = false;
	  $scope.query = "";
	  $scope.result = {};
	  $scope.adminMenuCollapsed = true;
	}]);
	
	angular.module('base').controller('ContactCtrl', ['$scope', 'utility', 'accountResource', function ($scope, utility, restResource) {
	  // local var
	  var successAlert = { type: 'success', msg: 'We have received your message. Thank you.' };
	  var errorAlert = { type: 'warning', msg: 'Error submitting your message. Please try again.' };
	
	  // model def
	  $scope.msg = {};
	  $scope.alerts = [];
	
	  // method def
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.canSave = utility.canSave;
	  $scope.closeAlert = function (ind) {
	    $scope.alerts.splice(ind, 1);
	  };
	  $scope.submit = function () {
	    var msg = $scope.msg;
	    $scope.alerts = [];
	    restResource.sendMessage({
	      name: msg.name,
	      email: msg.email,
	      message: msg.message
	    }).then(function (data) {
	      $scope.msgForm.$setPristine();
	      $scope.msg = {};
	      if (data.success) {
	        $scope.alerts.push(successAlert);
	      } else {
	        //TODO: optionally do case study errfor/errors
	        $scope.alerts.push(errorAlert);
	      }
	    }, function (x) {
	      $scope.msgForm.$setPristine();
	      $scope.msg = {};
	      $scope.alerts.push(errorAlert);
	    });
	  };
	}]);

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('common.footer', []).controller('FooterCtrl', ["$scope", function ($scope) {}]);

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('common.header', ['ui.bootstrap.typeahead', 'services.search', 'services.localizedMessages']).controller('HeaderCtrl', ["$templateCache", "$scope", "$rootScope", "$location", "searchService", "security", "user", "localizedMessages", function ($templateCache, $scope, $rootScope, $location, searchService, security, user, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  $scope.q = '';
	
	  $scope.search = searchService.search;
	  $scope.onSelect = searchService.onSelect;
	  // console.log(user)
	  $scope.isAuthenticated = function () {
	    return !!user._id;
	  };
	
	  $scope.isAdmin = function () {
	    return !!user && user.permissions && user.permissions.is_admin;
	  };
	
	  $scope.isEditor = function () {
	    return !!user && user.permissions && user.permissions.is_editor;
	  };
	
	  $scope.logout = function () {
	    return security.logout();
	  };
	
	  $scope.isActive = function (viewLocation) {
	    return $location.path() === viewLocation;
	  };
	
	  $scope.resetRedis = function () {
	    console.log('reset redis');
	  };
	}]);

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	"use strict";
	
	var a = {
	  "meta": {
	    "page": {
	      "currentPage": 1,
	      "prevPage": 0,
	      "hasPrev": false,
	      "nextPage": 0,
	      "hasNext": false,
	      "pages": 1,
	      "offset": 0,
	      "limit": 10,
	      "total": 6
	    },
	
	    "query": {
	      "edition": "en-us", "limit": 10, "skip": 0, "sort": "-orderNumber", "status": "17"
	    }
	  },
	
	  "data": [{
	    "_id": "588ca0315ea429da6bc8b939",
	    "article_id": 1424014,
	    "title": "vivo Emanuel",
	    "sefriendly": "vivo-emanuel",
	    "status": 17,
	    "equipo_local": "",
	    "equipo_visitante": "",
	    "goals": "",
	    "goles_local": 0,
	    "goles_visitante": 0,
	    "referee": "",
	    "incidents": "",
	    "show_inarticle": 21,
	    "startDate": "2017-01-30T06:00:00.000Z",
	    "endDate": "2017-01-30T07:00:00.000Z",
	    "updated_at": "2017-02-25T16:34:50.701Z",
	    "created_at": "2017-01-28T13:44:17.068Z",
	    "tags": [],
	    "publish_date": "2017-01-30T08:02:00.000Z",
	    "published_by": { "username": "avito", "name": "Javier Robles" },
	    "last_edited_by": { "username": "avito", "name": "Javier Robles" },
	    "author": {
	      "picture": "https://img.vavel.com/vavel1-1484746810232.jpg",
	      "name": "Javier Robles",
	      "username": "avito"
	    },
	    "category": { "id": 598, "name": "NFL", "sefriendly": "nfl", "parent": "/en-us", "parent_id": [1013, 598] },
	    "orderNumber": 5,
	    "edition": "en-us",
	    "abstract": "splitodss",
	    "body": "<div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>22</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-30T05:35:52.074Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-30T05:35:52.074Z'GMT'>2017-01-30T05:35:52.074Z</time></a><p itemprop='articleBody'>1-2-3:02\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>21</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-30T05:21:18.841Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-30T05:21:18.841Z'GMT'>2017-01-30T05:21:18.841Z</time></a><p itemprop='articleBody'>zdfsdfsd\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>20</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-30T05:20:16.244Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-30T05:20:16.244Z'GMT'>2017-01-30T05:20:16.244Z</time></a><p itemprop='articleBody'>1-2-19:13\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>19</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-30T05:14:37.579Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-30T05:14:37.579Z'GMT'>2017-01-30T05:14:37.579Z</time></a><p itemprop='articleBody'>1-2-5\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>18</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-30T04:01:07.222Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-30T04:01:07.222Z'GMT'>2017-01-30T04:01:07.222Z</time></a><p itemprop='articleBody'>18\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>17</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T21:13:16.601Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T21:13:16.601Z'GMT'>2017-01-28T21:13:16.601Z</time></a><p itemprop='articleBody'>2-3-3\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>16</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T21:12:20.044Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T21:12:20.044Z'GMT'>2017-01-28T21:12:20.044Z</time></a><p itemprop='articleBody'>2-3-8\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>15</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T21:04:38.851Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T21:04:38.851Z'GMT'>2017-01-28T21:04:38.851Z</time></a><p itemprop='articleBody'>7-8-6\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>14</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:58:27.026Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:58:27.026Z'GMT'>2017-01-28T20:58:27.026Z</time></a><p itemprop='articleBody'>16-6-12\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>13</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:49:04.742Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:49:04.742Z'GMT'>2017-01-28T20:49:04.742Z</time></a><p itemprop='articleBody'>12-13-14\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>12</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:47:59.172Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:47:59.172Z'GMT'>2017-01-28T20:47:59.172Z</time></a><p itemprop='articleBody'>12-14-13\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>11</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:38:17.972Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:38:17.972Z'GMT'>2017-01-28T20:38:17.972Z</time></a><p itemprop='articleBody'>12-13-15\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>10</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:34:08.801Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:34:08.801Z'GMT'>2017-01-28T20:34:08.801Z</time></a><p itemprop='articleBody'>14-15\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>9</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:33:05.406Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:33:05.406Z'GMT'>2017-01-28T20:33:05.406Z</time></a><p itemprop='articleBody'>13---->13:20\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>8</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:24:26.645Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:24:26.645Z'GMT'>2017-01-28T20:24:26.645Z</time></a><p itemprop='articleBody'>12 --13\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>7</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:22:32.539Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:22:32.539Z'GMT'>2017-01-28T20:22:32.539Z</time></a><p itemprop='articleBody'>12:00\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:06:42.437Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:06:42.437Z'GMT'>2017-01-28T20:06:42.437Z</time></a><p itemprop='articleBody'>dfgsdfsd\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>5</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T20:02:17.191Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T20:02:17.191Z'GMT'>2017-01-28T20:02:17.191Z</time></a><p itemprop='articleBody'>10\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>4</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T18:59:12.463Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T18:59:12.463Z'GMT'>2017-01-28T18:59:12.463Z</time></a><p itemprop='articleBody'>9:00\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>3</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T18:54:56.430Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T18:54:56.430Z'GMT'>2017-01-28T18:54:56.430Z</time></a><p itemprop='articleBody'>mismo 9:00\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>2</h2><a href=http://188.165.235.121:7790/account/edit-article-live/1424014#post1' itemprop='url'><time datetime='2017-01-28T18:49:08.492Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T18:49:08.492Z'GMT'>2017-01-28T18:49:08.492Z</time></a><p itemprop='articleBody'>mismo\n</p></div><div id=post'1' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'><h2 itemprop='headline'>listo</h2><a href=http://188.165.235.121:7790/account/edit-article-live/undefined#post1' itemprop='url'><time datetime='2017-01-28T18:44:16.209Z' data-relativeformat='med' itemprop='datePublished' title='2017-01-28T18:44:16.209Z'GMT'>2017-01-28T18:44:16.209Z</time></a><p itemprop='articleBody'>8:43\n\n<p>8:50</p>\n</p></div> ",
	    "image_caption": "",
	    "video": "",
	    "image": "america-morelia-en-vivo-1485819223743.jpg"
	  }, {
	    "_id": "587c265a8b313ec3518b4659",
	    "article_id": 724186,
	    "title": "Bruce Arena named Head Coach of United States Men&#039;s National Team",
	    "sefriendly": "bruce-arena-named-head-coach-of-united-states-national-team",
	    "status": 17,
	    "equipo_local": "",
	    "equipo_visitante": "",
	    "team1": "",
	    "team2": "",
	    "goals": "",
	    "goles_local": 0,
	    "goles_visitante": 0,
	    "referee": "",
	    "incidents": "",
	    "show_inarticle": 3,
	    "startDate": "2017-01-16T08:02:05.751Z",
	    "endDate": "2017-01-16T08:02:05.751Z",
	    "updated_at": "2017-02-25T16:34:50.681Z",
	    "created_at": "2016-11-22T17:33:00.000Z",
	    "tags": [{ "name": "United States", "sefriendly": "united-states" }, {
	      "name": "Soccer",
	      "sefriendly": "soccer"
	    }, { "name": "Bruce Arena", "sefriendly": "bruce-arena" }, { "name": "USMNT", "sefriendly": "usmnt" }],
	    "publish_date": "2016-11-22T17:33:00.000Z",
	    "published_by": { "username": "Noel John Alberto", "name": "Noel John Alberto" },
	    "last_edited_by": { "username": "Noel John Alberto", "name": "Noel John Alberto" },
	    "author": {
	      "picture": "1010886-1001266786560599-305479290663200612-n-9207308813.jpg",
	      "twitter": "RobertoRojas97",
	      "plus": "",
	      "name": "Roberto Rojas",
	      "username": "blaugranar"
	    },
	    "category": { "id": 1016, "name": "Soccer", "sefriendly": "soccer", "parent": "/en-us", "parent_id": [1013, 1016] },
	    "orderNumber": 4,
	    "edition": "en-us",
	    "abstract": "A second spell for the most successful national coach in the history of soccer in the United States.",
	    "body": "<p>Following the <a href=\"https://www.ussoccer.com/stories/2016/11/21/19/34/161121-mnt-us-soccer-parts-ways-with-jurgen-klinsmann\" rel=\"nofollow\">firing</a> of head coach<strong> Jurgen Klinsmann</strong> on Monday, U.S Soccer president<strong> Sunil Gulat</strong>i <a href=\"http://www.ussoccer.com/stories/2016/11/22/17/42/161121-mnt-bruce-arena-named-head-coach-of-us-mens-national-team\" rel=\"nofollow\">announced</a> that <strong>Bruce Arena </strong>will become the new manager of the United States&#39; men&#39;s national soccer team, returning to the national team for the first time in 10 years. Arena, who will assume the role on December 1, will be formally introduced during a teleconference with U.S. President Gulati on Tuesday at 2 p.m. ET.</p>\r\n\r\n<h2><strong>The Return of the Best</strong></h2>\r\n\r\n<p>Arena is no stranger to soccer in the United States. He is widely considered the most successful coach in the history of the United States, having guided the team to many achievements during his first spell in charge from 1998 to 2006. Arena lead the U.S. to its best finish in the <strong>FIFA World Cup</strong> in more than 80 years with a quarterfinal appearance in 2002 in South Korea and Japan and has amassed the most wins of any coach in USMNT history.</p>\r\n\r\n<p>He has also lead the national team to two <strong>CONCACAF Gold Cups </strong>in 2002 and 2005, as well as winning the final round for FIFA World Cup qualification, otherwise known as &quot;T<em>he Hexagonal&quot;</em> for the tournaments in 2002 and 2006. After leaving the national team in 2006, he took charge of the <strong>New York Red Bulls</strong> and most recently, the<strong> Los Angeles Galaxy</strong> in <strong>Major League Soccer.</strong></p>\r\n\r\n<figure class=\"image\"><img alt=\"Bruce Arena returns to the USMNT after 10 years. Source: U.S Soccer\" height=\"458\" src=\"https://img.vvlcdn.com/b/130102%20bruceArena%20800x600.jpg\" width=\"610\" />\r\n<figcaption>Bruce Arena returns to the USMNT after 10 years. Source: U.S Soccer</figcaption>\r\n</figure>\r\n\r\n<h2><strong>A Challenge Expected</strong></h2>\r\n\r\n<p>President Gulati is hoping that Arena&#39;s experience&nbsp;will help the United States qualify for the 2018 FIFA World Cup in Russia, following two losses in their opening matches in the Hex against <strong>Mexico</strong> and <strong>Costa Rica.</strong>&nbsp;<em>&ldquo;When we considered the possible candidates to take over the Men&rsquo;s National Team at this time, Bruce was at the top of the list</em>,&rdquo; said Gulati.&nbsp;</p>\r\n\r\n<p>Arena stated that he is <em>&quot;looking forward to working with a strong group of players that understand the challenge in front of them after the first two games of the Hex.&quot;&nbsp;</em></p>\r\n",
	    "image_caption": "Bruce Arena returns. Source: U.S Soccer",
	    "video": "",
	    "image": "060617-mnt-arena-3941254592.jpg"
	  }, {
	    "_id": "587c26598b313ec3518b45a7",
	    "article_id": 724364,
	    "title": "Audi 2016 MLS Cup Playoffs: Seattle Sounders defeat Colorado Rapids 2-1 in Western Conference Final first leg",
	    "sefriendly": "audi-2016-mls-cup-playoffs-seattle-sounders-defeat-colorado-rapids-2-1-in-western-conference-final-first-leg",
	    "status": 17,
	    "equipo_local": "Seattle Sounders",
	    "equipo_visitante": "Colorado Rapids",
	    "team1": "Stefan Frei; Tyrone Mears, Román Torres, Chad Marshall, Joevin Jones; Osvaldo Alonso (C), Cristian Roldan; Nicolás Lodeiro, Erik Friberg (Brad Evans, 69&#039;), Jordan Morris (Andreas Ivanschitz, 77&#039;); Nelson Valdez",
	    "team2": "Zac MacMath; Erik Miller, Jared Watts, Axel Sjöberg, Marc Burch; Sam Cronin (C), Jermaine Jones, Shkëlzen Gashi (Micheal Azira, 77&#039;), Sébastien Le Toux, Dominque Badji (Marlon Hairston, 70&#039;); Kevin Doyle",
	    "goals": "0-1, min. 13, Doyle. 1-1, min 19, Morris. 2-1, min 61. Lodeiro.",
	    "goles_local": 2,
	    "goles_visitante": 1,
	    "referee": "Chris Penso (USA). Burch (min. 34, yellow card).  Doyle (min. 58, yellow card). Cronin (min 67, yellow card)",
	    "incidents": "Western Conference Final leg one between the Seattle Sounders and Colorado Rapids. The match was played at CenturyLink Field in front of 42,774 spectators.",
	    "show_inarticle": 3,
	    "startDate": "2017-01-16T08:01:36.571Z",
	    "endDate": "2017-01-16T08:01:36.571Z",
	    "updated_at": "2017-02-25T16:34:50.625Z",
	    "created_at": "2016-11-23T03:39:00.000Z",
	    "tags": [{ "name": "mls", "sefriendly": "mls" }, {
	      "name": "Major League Soccer",
	      "sefriendly": "major-league-soccer"
	    }, { "name": "seattle sounders", "sefriendly": "seattle-sounders" }, {
	      "name": "Colorado Rapids",
	      "sefriendly": "colorado-rapids"
	    }, {
	      "name": "Western Conference Finals",
	      "sefriendly": "western-conference-finals"
	    }, { "name": "Audi 2016 MLS Cup Playoffs", "sefriendly": "audi-2016-mls-cup-playoffs" }, {
	      "name": "Kevin Doyle",
	      "sefriendly": "kevin-doyle"
	    }, { "name": "Jordan Morris", "sefriendly": "jordan-morris" }],
	    "publish_date": "2016-11-23T03:39:00.000Z",
	    "published_by": { "username": "Chris Blakely", "name": "Chris Blakely" },
	    "last_edited_by": { "username": "Chris Blakely", "name": "Chris Blakely" },
	    "author": {
	      "picture": "chris-profile-5508043235.jpg",
	      "twitter": "therealcblakely",
	      "plus": "",
	      "name": "Chris Blakely",
	      "username": "chris-blakely"
	    },
	    "category": { "id": 1016, "name": "Soccer", "sefriendly": "soccer", "parent": "/en-us", "parent_id": [1013, 1016] },
	    "orderNumber": 3,
	    "edition": "en-us",
	    "abstract": "The Seattle Sounders and Colorado Rapids battled in the first leg of the Western Conference Finals at CenturyLink Field in Seattle, WA. After conceding an early goal, the Sounders were able to come back and win the first leg 2-1.",
	    "body": "<p>For the third time in their eight-year history, the <a href=\"https://www.vavel.com/en-us/tag/seattle-sounders\"><strong>Seattle Sounders</strong></a> were hosting a game in the <strong>Western Conference Finals</strong>. This time around they were hosting the best defense in <a href=\"https://www.vavel.com/en-us/tag/mls\"><strong>MLS</strong></a>, the <a href=\"https://www.vavel.com/en-us/tag/colorado-rapids\"><strong>Colorado Rapids</strong></a>.</p>\n\n<p>Heading into the game, there were many doubts&nbsp;who would and who would not be playing. The Sounders were coy on the health of <strong>Jordan Morris</strong> leading up to the game. Morris was pulled at halftime in the Sounders game against <strong>FC Dallas</strong> due to a hamstring strain. The Rapids were also being coy on the health of <strong>Shk&euml;lzen Gashi</strong>. He was also injured in their game against the <strong>LA Galaxy</strong>. In the end, both star players found themselves in the Starting XI for their respective teams.</p>\n\n<h2>Rapids strike first</h2>\n\n<p>The Sounders and Rapids felt each other out for the first ten minutes of the match. The first real chance of the game came in just the fourth minute of the match. <strong>Dominque Badji</strong> sent in a cross to the near post but luckily for Seattle they cleared it out for a corner.</p>\n\n<p>In the 13th minute, the Rapids got on the board. <strong>Jermaine Jones</strong> sent in a ball that was dummied by Gashi and fell to the feet of <strong>Kevin Doyle</strong>. As Doyle put his shot on frame, <strong>Chad Marshall</strong> flashed in front of goal. The ball took a deflection off Marshall and found itself in the back of the net. If not for the deflection, it appeared <strong>Stefan Frei</strong> would have had the goal covered.</p>\n\n<h2>Sounders respond quickly</h2>\n\n<p>The Sounders did exactly what they needed to do after conceding the first goal, they attacked. Their persistence would finally pay off in the 19th minute. After <strong>Cristian Roldan</strong> took control of the ball at midfield, he headed straight toward the goal. Once he reached the outside of the penalty box, he took a perspective shot. <strong>Zac MacMath</strong> was able to stop the initial shot but was not able to do anything with Morris&rsquo; follow-up.</p>\n\n<p>The latter part of the first half started to get chippy. In the 34th minute, we saw our first card of the night issued by referee <strong>Chris Penso</strong>. After the ball went out of play, the Rapids kept playing the ball as <strong>Nicol&aacute;s Lodeiro</strong> was trying to gather it for the throw in. <strong>Marc Burch</strong> picked up the ball and swung his right arm and contacted Lodeiro&rsquo;s face. Penso decided to only issue a yellow card and the Rapids, and Burch was lucky he was not sent off.</p>\n\n<h2>The Sounders start second half off aggressively</h2>\n\n<p>The Sounders came out aggressively in the first few minutes of the second half looking for the go-ahead goal. The Sounders had a handful of chances with the first coming inside a minute of the second half. Morris made a run into the box but was not able to control the ball with his feet and the Sounders lost their chance.</p>\n\n<p>The Sounders had a few other chances with crosses being pumped into the box but Colorado was able to clear them.</p>\n\n<h2>Lodeiro breaks deadlock</h2>\n\n<p>In the 60tjh minute, the Sounders caught a break when Lodeiro was fouled in the box by Burch. It was the correct call by Penso to reward Seattle with a penalty. Lodeiro stepped up to take and converted it to give Seattle a 2-1 lead.</p>\n\n<p>Over the next ten minutes, the Rapids really controlled the game. Sam Cronin picked up a yellow in the 67th minute and will now miss the second leg due to yellow card accumulation.</p>\n\n<h2>Seattle sees it out</h2>\n\n<p>The Sounders were able to see the game through and have a one goal lead heading into leg two. However, Colorado has a huge advantage with the one away goal. If the Rapids win 1-0 on Sunday, they will be through to the MLS Cup Final.&nbsp;</p>\n\n<h2>What&rsquo;s next</h2>\n\n<p>The Sounders will now travel to Commerce City, CO to take on the Rapids in the second leg of the Western Conference Finals this coming Sunday. Kickoff is scheduled for 1:00 pm PT.&nbsp;</p>\n",
	    "image_caption": "Jordan Morris waves to the crowd after tying the game | courtesy Major League SoccerTwitter - @MLS",
	    "video": "",
	    "image": "morris-4508180595.jpg"
	  }, {
	    "_id": "587c265b8b313ec3518b4a82",
	    "article_id": 723121,
	    "title": "Arizona Coyotes take the bite out of San Jose Sharks",
	    "sefriendly": "arizonacoyotes",
	    "status": 17,
	    "equipo_local": "San Jose Sharks",
	    "equipo_visitante": "Arizona Coyotes",
	    "team1": "",
	    "team2": "",
	    "goals": "",
	    "goles_local": 2,
	    "goles_visitante": 3,
	    "referee": "",
	    "incidents": "",
	    "show_inarticle": 3,
	    "startDate": "2017-01-16T08:02:08.938Z",
	    "endDate": "2017-01-16T08:02:08.938Z",
	    "updated_at": "2017-02-25T16:34:50.602Z",
	    "created_at": "2016-11-20T07:26:00.000Z",
	    "tags": [{ "name": "#Arizona Coyotes", "sefriendly": "arizona-coyotes" }, {
	      "name": "NHL",
	      "sefriendly": "nhl"
	    }, { "name": "Tucson Roadrunners", "sefriendly": "tucson-roadrunners" }],
	    "publish_date": "2016-11-20T07:26:00.000Z",
	    "published_by": { "username": "Kyle Sennikoff", "name": "Kyle Sennikoff" },
	    "last_edited_by": { "username": "William Grigsby", "name": "William Grigsby" },
	    "author": {
	      "picture": "img-0665-1-3977734954.jpg",
	      "twitter": "bgguy626",
	      "plus": "",
	      "name": "William Grigsby",
	      "username": "bgguy626"
	    },
	    "category": { "id": 1015, "name": "NHL", "sefriendly": "nhl", "parent": "/en-us", "parent_id": [1013, 1015] },
	    "orderNumber": 2,
	    "edition": "en-us",
	    "abstract": "The Arizona Coyotes fresh off a two game road trip came home to face the rival San Jose Sharks in a pivitol Pacific Division matchup.",
	    "body": "<p>The <a href=\"https://www.vavel.com/en-us/tag/arizona-coyotes/\"><strong>Arizona Coyotes</strong></a> started a three game home stand and hoped to catch the travel weary <strong>San Jose Sharks</strong> off guard. &nbsp;</p>\n\n<p><strong>More from the Arizona Coyotes -&gt;&gt;&nbsp;</strong><a href=\"https://www.vavel.com/en-us/nhl/722450-arizona-coyotes-lose-in-overtime-to-vancouver-canucks.html\">Arizona Coyotes lose another overtime game to Vancouver Canucks</a></p>\n\n<p>The opening on the roster due to Richardson&#39;s injury was filled by <a href=\"https://www.vavel.com/en-us/nhl/655484-arizona-coyotes-christian-dvorak-nhl-ready.html\"><strong>Christian Dvorak</strong> </a>who was called up from the AHL <strong>Tucson Roadrunners</strong>. That leaves the team with one veteran center in <strong>Martin Hanzal</strong>, with <strong>Laurent Dauphin</strong>, Dvorak, and <strong>Dylan Strome</strong> all&nbsp;being rookies.</p>\n\n<p>The Coyotes will be without center&nbsp;Brad Richardson&nbsp;for an indefinite period of time due to a severe leg injury, when he broke both his tibia and fibula bones in the Vancouver game.</p>\n\n<h2>First period&nbsp;saw the Coyotes score quickly</h2>\n\n<p>The Coyotes got on the scoreboard swiftly when at 1:55,&nbsp;<a href=\"https://www.vavel.com/en-us/nhl/703590-arizona-coyotes-tobias-rieder-finally-signs-contract.html\"><strong>Tobias Rieder</strong></a> scored his fifth goal of the season, with a nifty pass from <strong>Jordan Martinook</strong> as they skated in on a two-on-one break.&nbsp;It was Rieder&#39;s third goal in his last four games.&nbsp;</p>\n\n<p>The period saw a donnybrook fight between <strong>Micheal Haley</strong> of the Sharks against the Coyotes&#39; tough guy <strong>Ryan White</strong>. Both pugilists got in some shots as if it were Saturday night at the fights.</p>\n\n<figure class=\"image\"><img alt=\"Mike Smith's 43 saves were key to the Coyotes' victory. Source: Christian Petersen/Getty Images North America)\" height=\"400\" src=\"https://img.vvlcdn.com/b/smitty%20vs%20sharks.jpg\" width=\"600\" />\n<figcaption>Mike Smith&#39;s 43 saves were key to the Coyotes&#39; victory. Source: Christian Petersen/Getty Images North America)</figcaption>\n</figure>\n\n<p>The story of this initial period was the Sharks gathering 17 shots on <strong>Mike Smith</strong>, who managed to stop&nbsp;them all. That&#39;s too many shots for your goalie to stop&nbsp;and the Coyotes need to limit such an arsenal of rubber on their netminder.</p>\n\n<h2>Second period power play finally clicked</h2>\n\n<p>The Coyotes scored their second goal at 7:53 of the period when<strong> Max Domi</strong> lit the light on a shot from the left side which Sharks&#39; goalie <strong>Martin Jones</strong> couldn&#39;t see, thanks to&nbsp;Hanzal&#39;s huge body screening him.&nbsp;</p>\n\n<p>The game&nbsp;would have seemed one-sided at this point if one were to see the shots on goal by the Sharks totaling 23 by the 12:00 minute mark, compared to the Coyotes 13. For whatever reason, the Coyotes maintained a two goal lead as the second stanza ended.</p>\n\n<p>Most of that credit was due to some outstanding goaltending by Smith.&nbsp;</p>\n\n<h2>Third period letdown</h2>\n\n<p>All the shots on net by the Sharks finally paid off when Coyotes&#39; nemisis <strong>Joe Pavelski</strong> deflected a<strong> Justin Braun</strong> shot from the right point by Smith to ruin&nbsp;his shoutout bid at 0:41 of the period.</p>\n\n<p>The Sharks followed up their first goal with the tiebreaker at 10:28 when <strong>Tommy Wingles</strong>&nbsp;scored on a deflection&nbsp;through a maze of players from the point. It seemed inevitable with the barrage of shots by the Sharks, that one would hit the mark.&nbsp;</p>\n\n<p>All of a sudden, the hard work the Coyotes displayed got them very little but a tied game. And, the period ended as a tied game, meaning this was the third consecutive overtime game for the Yotes.</p>\n\n<h2>Overtime winner</h2>\n\n<p>The Coyotes really needed a win, and <a href=\"https://www.nhl.com/video/hanzal-scores-ot-game-winner/t-283078120/c-46526103\" rel=\"follow\">Martin Hanzal</a> gave them that with his overtime winner at 1:16. <strong>Alex Goligoski</strong> shot from the left point before Hanzal deflected it perfectly past Jones to end the game. <strong>Radim Vrbata</strong> also recorded an assist on the goal, giving him his 300th career point with the team, tying him with 16 other former Coyotes&#39; players to accomplish that feat.</p>\n\n<p>It took the Desert Dogs three overtime games to get two points in one, and this one really was a needed win.They dedicated to their injured teammate <strong>Brad Richardson</strong> who remains in a Vancouver hospital recovering.</p>\n\n<figure class=\"image\"><img alt=\"Thoughts and prayers go out to Craig Cunningham as he collapsed before a game in Tucson. Source: Christian Petersen/Getty Images North America)\" height=\"831\" src=\"https://img.vvlcdn.com/b/cunningham.jpg\" width=\"601\" />\n<figcaption>Thoughts and prayers go out to Craig Cunningham as he collapsed before a game in Tucson. Source: Christian Petersen/Getty Images North America)</figcaption>\n</figure>\n\n<p>An added note: The Coyotes had another player go down in Tucson this evening as <strong>Craig Cunningham</strong> collasped during the pre-game warmup. The game was called off due to the seriousness of what happened to Cunningham. His uniform was cut open, and chest compressions were being performed on him.&nbsp;</p>\n\n<p>According to a statement by Coyote&#39;s GM <strong>John Chayka</strong>:</p>\n\n<p><em>&quot;Arizona Coyotes center Craig Cunningham suffered a medical emergency on the ice prior to the start of tonight&#39;s game between the Tucson Roadrunners and the Manitoba Moose at the Tucson Convention Center. Cunningham was taken to a local hospital where he is receiving medical treatment. Our thoughts and prayers are with Craig and his family. We will provide a medical update once we receive more information.</em></p>\n",
	    "image_caption": "Arizona Coyotes&#039; Martin Hanzal got the game winner in this important game.  Source: Christian Petersen/Getty Images North America)",
	    "video": "",
	    "image": "hanzal-ot-bob-1466992939.jpg"
	  }, {
	    "_id": "587c26598b313ec3518b45b7",
	    "article_id": 724348,
	    "title": "New Orleans Pelicans steamroll Atlanta Hawks, 112-94",
	    "sefriendly": "new-orleans-pelicans-steamroll-atlanta-hawks-112-94",
	    "status": 17,
	    "equipo_local": "New Orleans Pelicans",
	    "equipo_visitante": "Atlanta Hawks",
	    "team1": "",
	    "team2": "",
	    "goals": "",
	    "goles_local": 112,
	    "goles_visitante": 94,
	    "referee": "",
	    "incidents": "",
	    "show_inarticle": 3,
	    "startDate": "2017-01-16T08:01:46.498Z",
	    "endDate": "2017-01-16T08:01:46.498Z",
	    "updated_at": "2017-02-25T16:34:50.657Z",
	    "created_at": "2016-11-23T01:14:00.000Z",
	    "tags": [{ "name": "NBA", "sefriendly": "nba" }, {
	      "name": "Atlanta Hawks",
	      "sefriendly": "atlanta-hawks"
	    }, { "name": "New Orleans Pelicans", "sefriendly": "new-orleans-pelicans" }, {
	      "name": "Indiana Pacers",
	      "sefriendly": "indiana-pacers"
	    }, { "name": "Minnesota Timberwolves", "sefriendly": "minnesota-timberwolves" }],
	    "publish_date": "2016-11-23T01:14:00.000Z",
	    "published_by": { "username": "Sully Akbari", "name": "Sully Akbari" },
	    "last_edited_by": { "username": "Sully Akbari", "name": "Sully Akbari" },
	    "author": {
	      "picture": "austin-cam-5603661374.jpg",
	      "twitter": "austin_mc10",
	      "plus": "",
	      "name": "Austin  McConnell",
	      "username": "austin_mcconnell"
	    },
	    "category": { "id": 313, "name": "NBA", "sefriendly": "nba", "parent": "/en-us", "parent_id": [1013, 313] },
	    "orderNumber": 1,
	    "edition": "en-us",
	    "abstract": "Despite an early injury to superstar Anthony Davis, the red-hot New Orleans Pelicans easily handled the struggling Atlanta Hawks.",
	    "body": "<p>The league&rsquo;s top-ranked defensive team, the <strong>Atlanta Hawks</strong>, failed to look the part in Tuesday&rsquo;s loss to the <strong>New Orleans Pelicans</strong>. The game got out of hand early, even as Pelicans big man <strong>Anthony Davis</strong> left the game with what seemed to be a knee injury in the first quarter. Led by stellar shooting performances from <strong>Tim Frazier</strong>, <strong>Terrence Jones,</strong> and <strong>E&rsquo;Twaun Moore</strong>, New Orleans sprinted to the lead with an 18-1 run in the first half and didn&rsquo;t look back.</p>\r\n\r\n<h2>No Davis, No Problem</h2>\r\n\r\n<p>The story of the Pelicans this season and in seasons past has been the large number of injuries sustained by their key players. Davis missed a chunk of this game spanning from the middle of the first quarter to early in the fourth, yet still managed to score 13 in 18 minutes. The team is also missing <strong>Tyreke Evans</strong>, and point guard <strong>Jrue Holiday</strong> came off the bench as he looks to get back into game shape.</p>\r\n\r\n<p>Despite all of this, New Orleans found plenty of production from their other pieces. Frazier, who has filled in at the point guard spot while Holiday has been away, had one of the best games of his career putting up 21 points while dishing out 14 assists. The veteran Jones also contributed 17 points as he continued his good run of play against the Hawks. Moore and Holiday were also in double digits, and the Pelicans shot 53 percent&nbsp;overall on the night, giving fans hope that the team is turning things around after a 2-10 start.</p>\r\n\r\n<h2>Another Dud for Atlanta</h2>\r\n\r\n<p>Coming off a winless weekend, this is not the performance that head coach <strong>Mike Budenholzer</strong> wanted to see from his Hawks squad. The top-ranked defensive team in the NBA couldn&rsquo;t stop the Pelicans, even when All-Star center Anthony Davis was sidelined. The bench unit, which has been a driving force for the team early in the season, has struggled to produce the same numbers over the last few games.&nbsp;On top of that, they shot just 46 percent&nbsp;from the field, leading to the&nbsp;blowout.</p>\r\n\r\n<figure class=\"image\"><img alt=\"The Hawks had very few answers for the Pelicans on both ends of the floor. (Photo by Kevin Cox/Getty Images)\" height=\"430\" src=\"https://img.vvlcdn.com/b/Screen%20Shot%202016-11-22%20at%209_56_22%20PM.png\" width=\"610\" />\r\n<figcaption><strong>The Hawks had very few answers for the Pelicans on both ends of the floor.<br />\r\n(Photo by Kevin Cox/Getty Images)</strong></figcaption>\r\n</figure>\r\n\r\n<p>There were very few bright spots for Atlanta, with the entire starting lineup registering double-digit negatives in the plus-minus category. <strong>Dennis Schroder</strong> and <strong>Kyle Korver</strong> both finished with 14 points, and <strong>Paul Millsap</strong> chipped in ten. <strong>Kent Bazemore</strong> was very disappointing, shooting 0-6 from the floor, and <strong>Dwight Howard</strong> was unable to get anything going inside the paint. While this three game losing streak is troubling for the team that was first in the East, games like these should be more of the exception and not the norm.</p>\r\n\r\n<h2>Up Next</h2>\r\n\r\n<p>The Hawks have a quick turnaround, traveling to face former Hawk <strong>Jeff Teague</strong> and the <strong>Indiana Pacers</strong> tomorrow night. This is the beginning of a five-game road trip for Atlanta, who will be looking to get back to winning ways once again.</p>\r\n\r\n<p>The Pelicans are also in action tomorrow night on national television, facing off against <strong>Karl-Anthony Towns</strong> and the <strong>Minnesota Timberwolves</strong> on ESPN.</p>\r\n",
	    "image_caption": "Tim Frazier had a career night against Schroder and the Hawks. (Photo by Kevin Cox/Getty Images)",
	    "video": "",
	    "image": "frazier-5280999639.jpg"
	  }, {
	    "_id": "587c26598b313ec3518b45a4",
	    "article_id": 724367,
	    "title": "New York Knicks defeat Portland Trail Blazers 107-103, to win fifth straight game at home",
	    "sefriendly": "new-york-knicks-defeat-portland-trail-blazers-to-win-fifth-straight-game-at-home",
	    "status": 17,
	    "equipo_local": "Portland Trail Blazers ",
	    "equipo_visitante": "New York Knicks ",
	    "team1": "",
	    "team2": "",
	    "goals": "",
	    "goles_local": 103,
	    "goles_visitante": 107,
	    "referee": "",
	    "incidents": "",
	    "show_inarticle": 3,
	    "startDate": "2017-01-16T08:01:36.552Z",
	    "endDate": "2017-01-16T08:01:36.552Z",
	    "updated_at": "2017-02-25T16:34:50.574Z",
	    "created_at": "2016-11-23T03:22:00.000Z",
	    "tags": [{ "name": "New York Knicks", "sefriendly": "new-york-knicks" }, {
	      "name": "Portland Trail Blazers",
	      "sefriendly": "portland-trail-blazers"
	    }, { "name": "Carmelo Anthony", "sefriendly": "carmelo-anthony" }, {
	      "name": "Derrick Rose",
	      "sefriendly": "derrick-rose"
	    }, { "name": "C.J.McCollum", "sefriendly": "c-j-mccollum" }, {
	      "name": "Kristaps Porzingis",
	      "sefriendly": "kristaps-porzingis"
	    }, { "name": "Brandon Jennings", "sefriendly": "brandon-jennings" }, {
	      "name": "Mindaugas Kuzminskas",
	      "sefriendly": "mindaugas-kuzminskas"
	    }, { "name": "Damian Lillard", "sefriendly": "damian-lillard" }],
	    "publish_date": "2016-11-23T03:22:00.000Z",
	    "published_by": { "username": "Sully Akbari", "name": "Sully Akbari" },
	    "last_edited_by": { "username": "Jose Rosas", "name": "Jose Rosas" },
	    "author": { "picture": "", "twitter": "", "plus": "", "name": "VAVEL", "username": "vavel" },
	    "category": { "id": 313, "name": "NBA", "sefriendly": "nba", "parent": "/en-us", "parent_id": [1013, 313] },
	    "orderNumber": 0,
	    "edition": "en-us",
	    "abstract": "The New York Knicks (7-7) defended home court once more with a 107-103 victory over the Portland Trail Blazers (8-8). Their winning streak at Madison Square Garden is extended to five.",
	    "body": "<p>The <a href=\"https://www.vavel.com/en-us/tag/new-york-knicks/\"><strong>New York Knicks</strong></a> contained <strong>Damian Lillard</strong>,<strong> C.J. McCollum</strong> and the rest <a href=\"https://www.vavel.com/en-us/tag/portland-trail-blazers/\"><strong>Portland Trail Blazers</strong></a>, 107-103, to keep their winning streak at home alive. With the victory, they also managed to reach the .500 mark.</p>\n\n<h2><strong>Portland&rsquo;s Shots on Target in the First Frame</strong></h2>\n\n<p>The Trailblazers started the game converting on their first four three-pointers of the game. They ended the first 12 minutes of the game shooting 80 percent from downtown and outscored the Knickerbockers 33-28.</p>\n\n<h2><strong>Knicks Take Lead in Second Period</strong></h2>\n\n<figure class=\"image\"><img alt=\"New York Knicks Forward Kristaps Porzingis does a slam dunk. Photo Courtesy of Adam Hunger-USA TODAY Sports. \" height=\"404\" src=\"https://img.vvlcdn.com/b/Knicks%20Vs%20Trail%20Blazers%20Photo%203.jpg\" width=\"606\" />\n<figcaption>New York Knicks Forward Kristaps Porzingis does a slam dunk. Photo Courtesy of Adam Hunger-USA TODAY Sports.</figcaption>\n</figure>\n\n<p>After dropping only five points in the first stanza of the game, <strong>Kristaps Porzingis</strong> scored 12 points and made the Knicks lead by as many as seven. <strong>Brandon Jennings</strong> came out and sparked the bench by showcasing his playmaking ability with four assists. The Knicks won the frame 32-25 and held a two-point lead at halftime.</p>\n\n<h2><strong>Anthony Struggles and Teammates Carry Load</strong></h2>\n\n<p><strong>Carmelo Anthony</strong> went 2-for-9 from the field in the third quarter.&nbsp;Yet New York was able to remain in the contest with the game tied at 81 heading into the final 12 minutes of regulation. Anthony&#39;s scoring drought continued to haunt him in the fourth period and went scoreless.&nbsp;</p>\n\n<p>Lillard, who has made a name for having big scoring fourth quarters, started the period on the bench.</p>\n\n<p>Meanwhile, Derrick Rose and Porzingis made sure their presence was in full effect. Porzingis hit some huge clutch shots in the frame and went for nine points. Rose then made consecutive field goals to give the Knicks a 102-101 lead. With 2:37 left in the game, he continued his excellent play by dishing a pass to the rookie <strong>Mindaugas Kuzminskas</strong> who hit a three-pointer. Rose sealed the deal by converting on a jumper with 6.8 seconds left. &nbsp;</p>\n\n<h2><strong>Top Performers</strong></h2>\n\n<p><strong><iframe allowfullscreen=\"allowfullscreen\" frameborder=\"0\" height=\"315\" src=\"//www.youtube.com/embed/F3ByuDhZpCQ\" width=\"560\"></iframe></strong></p>\n\n<p>Porzingis concluded with 31 points and was one rebound shy of a double-double. Rose ended with 18 points and Anthony summed 17. Jennings finished with only four points but tallied 11 assists with no turnovers. Lillard was held to an 8-of-18 shooting night and had 22 points. McCollum scored 16 points on 6-of-17 shooting. <strong>Maurice Harkless</strong> added 15 points and<strong> Ed Davis</strong> had 14.</p>\n\n<h2><strong>Quotes</strong></h2>\n\n<figure class=\"image\"><img alt=\"New York Knicks Guard Brandon Jennings reacting. Photo Courtesy of  Adam Hunger-USA TODAY Sports.\" height=\"409\" src=\"https://img.vvlcdn.com/b/knicks%20vs%20trail%20blazers%20photo%202-1.jpg\" width=\"614\" />\n<figcaption>New York Knicks Guard Brandon Jennings reacting. Photo Courtesy of Adam Hunger-USA TODAY Sports.</figcaption>\n</figure>\n\n<p>Jennings told the media after the game <em>&ldquo;I&rsquo;ve always been a true point guard. I&rsquo;ve always set the ball to other players.&rdquo;</em></p>\n\n<p>Knicks head coach <strong>Jeff Hornacek</strong> had the following to say about Jennings, <em>&ldquo;He was huge. Brandon Doesn&rsquo;t have to score to have an impact on the game.&rdquo;</em></p>\n\n<p>Coach also commented on his team&rsquo;s defense and said <em>&ldquo;It&#39;s been better the last six games. We have to transfer this defense when we do go on the road.&rdquo;</em></p>\n\n<h2><strong>Other Things to Note</strong></h2>\n\n<p>-For the Knicks, <strong>Joakim Noah </strong>(illness) and <strong>Lance Thomas </strong>(ankle) did not play.</p>\n\n<p>-For the Trail Blazers, <strong>Al-Farouq Aminu </strong>(calf) and<strong> Festus Ezeli </strong>(knee) did not play.</p>\n\n<p>-The lead changed hands 20 times and the game was tied 11 times.</p>\n\n<p>-New York went 8-for-8 from the free throw line.</p>\n\n<p>-The Trail Blazers snapped a four-game winning streak at Madison Square Garden. Their last loss had come in March of 2012, just a few months before drafting Lillard.</p>\n\n<p>-Kuzminskas played the entire fourth quarter and achieved a new career-high of 10 points.</p>\n\n<h2><strong>Up Next</strong></h2>\n\n<p>New York will be back home on Friday, Nov. 25 &nbsp;for a showdown with the <strong>Charlotte Hornets</strong>. Gametime at 7:30 p.m. E.T.</p>\n\n<p>Portland will have little time to rest as they head to the <strong>Quick Loans Arena</strong> on Wednesday, Nov. 22 with a meeting against the <strong>Cleveland Cavaliers</strong>. Tip-off shortly after 7:10 P.M. EST.&nbsp;&nbsp;&nbsp;&nbsp;</p>\n\n<p>&nbsp;&nbsp;</p>\n\n<p>&nbsp;</p>\n",
	    "image_caption": "New York Knicks Guard Brandon Jennings Celebrating with Forward Kristaps Porzingis. Photo Courtesy of Adam Hunger-USA TODAY Sports.",
	    "video": "",
	    "image": "knicks-vs-trail-blazers-recap-photo-1-6207376881.jpg"
	  }]
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//----- angular app configuration-----
	angular.module('config', []);
	angular.module('config').constant('ENABLE_SOCIAL', {
	  facebook: true,
	  google: true,
	  twitter: true
	}).constant('REQUIRE_ACCOUNT_VERIFICATION', false).constant('STATUSES', [{
	  id: '0',
	  value: 'status-editing-not-ready',
	  color: '#fff',
	  background: '#d04444'
	}, {
	  id: '-3',
	  value: 'status-ready-to-publish',
	  color: '#333',
	  background: '#f5f74c'
	}, {
	  id: '3',
	  value: 'status-published',
	  color: '#FFF',
	  background: '#d49772'
	}, {
	  id: '17',
	  value: 'status-top-four',
	  color: '#FFF',
	  background: '#b455a8'
	}, {
	  id: '18',
	  value: 'status-hompage',
	  color: '#fff',
	  background: '#389864'
	}, {
	  id: '90',
	  value: 'status-author-zone',
	  color: '#FFF',
	  background: '#fed442'
	}, {
	  id: '-2',
	  value: 'status-discard',
	  color: '#333',
	  background: '#cbcbcb'
	}, {
	  id: '-1',
	  value: 'status-archived',
	  color: '#333',
	  background: '#cbcbcb'
	}]).constant('ARTICLE_STYLES', [{
	  id: '3',
	  value: 'Artykuł'
	}, {
	  id: '1',
	  value: 'Wideo'
	}]).constant('APPLICATION', 'iworis').constant('DEFAULT_EDITION', 'mx').constant('XSRF_COOKIE_NAME', '_csrfToken').constant('I18N.MESSAGES', {
	  "en": __webpack_require__(299),
	  "es": __webpack_require__(299),
	  "pl": __webpack_require__(300)
	}).constant('APP_IMG_URLS', {
	  "base": 'https://d3h1htyejpzygs.cloudfront.net/media/',
	  "200": 'https://d3h1htyejpzygs.cloudfront.net/media/',
	  "NO_PHOTO_200": "https://d3h1htyejpzygs.cloudfront.net/media/not-found-iworis-1603084029701.png"
	});
	angular.module('config').config(['$provide', 'ENABLE_SOCIAL', function ($provide, ENABLE_SOCIAL) {
	  var setting = {
	    'facebook': {
	      text: 'Facebook',
	      icon: 'fa-facebook-square',
	      login: '/login/facebook',
	      connect: '/account/settings/facebook/'
	    },
	    'google': {
	      text: 'Google',
	      icon: 'fa-google-plus-square',
	      login: '/login/google',
	      connect: '/account/settings/google/'
	    },
	    'twitter': {
	      text: 'Twitter',
	      icon: 'fa-twitter-square',
	      login: '/login/twitter',
	      connect: '/account/settings/twitter/'
	    }
	
	  };
	  var social = {};
	  angular.forEach(ENABLE_SOCIAL, function (enable, key) {
	    if (enable) {
	      social[key] = setting[key];
	    }
	  });
	
	  // programmatically set constant, 'SOCIAL', in config module
	  $provide.constant('SOCIAL', social);
	}]);

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = {"a-new-account":"a New Account","account-settings":"Account Settings","first-name":"First Name","last-name":"Last name","occupation":"Occupation","website":"Website","change-password":"Change password","change-login":"Change login","abstract":"Abstract","account":"Account","account.tags":"Account Tags","add-bio-language":"Add new BIO in a language","add-video":"Add video","pending":"Pending","upload-video":"Upload video","drag-drop":"Drag and drop a file you want to upload","add-comment":"Add comment","accept":"Accept","when":"When?","who":"Who?","add-tags":"Add tags, what people, events or location appear in this video?","video-date":"What date was this video done?","select-file":"Select file","add-new":"Add New","add-new-bio-language":"Add new BIO in a language","add-time-when-helper":"Add here Time when Game Starts and when it will End more or less","add-time-when-helper-carrousel":"Is needed for appear in Lives Carrousel OK","aktualnosci":"News/Updates","reindexing":"Reindexing","reindexing-articles":"Reindexing Articles","reindexing-tags":"Reindexing Tags","reindexing-author":"Reindexing author","algolia-reindexing":"Algolia Reindexing","algolia-reindexing-error":"There is an error reindexing with algolia","algolia-reindexing-success":"Algolia was reindexing successfully","all":"All","allowing-spaces":"Allowing Spaces","allowing-spaces-helper":"By overriding the trigger keys you can have spaces, comma's and any other character in your tags!","apply-selected-draft":"Apply Selected Draft","article-style":"Article Style","articles":"Articles","author":"Author","autosave":"Auto Save","avatar":"Avatar","avatar-helper":"(for logos use png transparent background)","big-avatar":"Big Avatar","big-avatar-helper":"(add bob effect and no use images with logos if possible)","bio":"Bio","bios":"Bios","body":"Body","carousel":"Carousel","categories":"Categories","category":"Category","change-title":"Change Title","city":"City","club-name-optional":"(* Optional - Full name of club, person or event)","confirm-password":"Confirm Passowrd","country":"Country","counts":"Counts","cover-page":"Cover Page","create-password":"Create Password","created":"Created","created-at":"Created At","crud.project.remove.success":"A project with id '{{id}}' was removed successfully.","crud.project.save.error":"Something went wrong when saving a project...","crud.project.save.success":"A project with id '{{id}}' was saved successfully.","crud.user.remove.error":"Something went wrong when removing user with id '{{id}}'.","crud.user.remove.success":"A user with id '{{id}}' was removed successfully.","crud.user.save.error":"Something went wrong when saving a user...","crud.user.save.success":"A user with id '{{id}}' was saved successfully.","danger-zone":"Danger Zone","date":"date","date-from":"Date From","date-to":"Date to","delete":"Delete","delete-helper1":"If you do this, it cannot be undone.","delete-helper2":"You may also create orphaned document relationships too.","description":"Description","diagrams":"Diagrams","direct":"Direct","display":"Display","edit":"Edytuj","editions":"Editions","edukacja":"Education","end-date":"End Date","english":"English","enter-your-email":"Enter your email","errors.route.changeError":"Route change error","event":"Event","firstname":"Firstname","forgot-password":"Forgot your password?","forms.field.required":"This field is required","goal-helper":" - Ex: 0-1, min. 21, Sneijder. 1-1, min. 60, Ibrahimovic. 2-1, min. 68, Boateng.","groups":"Groups","home-page":"Home Page","gallery":"Gallery","image":"Image","image-caption":"Image Caption","in":"in","incidents-cap":"INCIDENTS","incidents-helper":" - Ex: Italian Super Cup between Scudetto champions, AC Milan, and the champion of Copa, Inter. The match was played at the Beijing National Stadium (Bird Nest). 25,000 spectators.","is-off":"is OFF","keywords":"Keywords","language":"Language","last-edited-by":"Last edited by","lastname":"Lastname","latin-languages":"LATIN LANGUAGES","limit":"Limit","live-content-reader":"LIVE content the reader is following","live-event":"Live Event","login.error.invalidCredentials":"Login failed.  Please check your credentials and try again.","login.error.serverError":"There was a problem with authenticating: {{exception}}.","login.reason.notAuthenticated":"You must be logged in to access this part of the application.","login.reason.notAuthorized":"You do not have the necessary access permissions.  Do you want to login as someone else?","logout":"Wyloguj","mediacje":"Consulting","menus":"Menus","merge":"merge","my-content":"My content","name":"Name","new-article":"New Article","new-biography":"New Biography","new-live":"New Live","new-video":"New Video","news":"News","no":"No","no-documents-attached":"No documents attached","noticias":"News","start-writing":"Start writting the text of your article here. Is suggested complete your article with heading2, links and bolds for make an easy and more quality reading","notifications":"Notifications","notifications-message":"Notifications message","official":"Official","official-name":"Official name","oficial":"Oficial","online-editor":"Online Editor","or":"or","organization":"Organization","password":"Password","pick-username":"Pick an username","player-team1":"Player / Team 1","player-team2":"Player / Team 2","pls-contact-issues":"please contact us to resolve issue","podroe":"travel","praca":"Work","prawo":"Law","proposers":"proposer(s)","psycholog":"Psychologist","published-by":"Published by","publishing":"Publishing","publishing-date":"Publishing Date","quit-heading":"Quit heading 2 / quitar encabezados 2 del cuerpo del texto","referee-capital":"REFEREE","refers":"Refers","register":"Register","remove-language":"Remove this Language","required-field":"This field is required","rodzina":"Family","role":"Role","roles":"Roles","root":"Root","save":"Save","save-changes":"Save Changes","score-capital":"SCORE","score-carrousel-optional":"(* Optional - For Score Carrousel, like FCB, RMA, ATM)","score-player1":"Score Player1","score-player2":"Score Player2","score-result":"SCORE - Resultado - Resultato","search-filters":"Search Filters","search":"Search","reset-filters":"Reset filters","sefriendly":"Sefriendly","send-notification":"Send Notification","shortname":"Short name","sign-in":"Sign In","sign-up":"Sign Up","slug":"Slug","stadium":"Stadium","start-date":"Start Date","status":"Status","status-archived":"Archived","add-title":"Add your title here","add-description":"Add the description of your article in 2 or 3 lines here. If you don't have a good idea for description, answer to 5W: who, what? where? why? how?","add-description-article":"Add a description","status-author-zone":"Author zone","add-image-caption":"Add image caption and photo source here","status-discard":"Discard","choose-category":"Choose Category","status-editing-not-ready":"Editing, not ready","status-hompage":"Homepage","status-no-use-this-status":"no use this status","status-published":"published","status-ready-to-publish":"Ready to publish","status-top-four":"Top 4","system":"System","tag":"Tag","tag-carousel":"Carousel Tags","tag-merge":"Tage Merge","tag-merge-helper":"You can merge selected tags with current. Selected tags will delete after merge","tags":"Tags","tags-helper":"By overriding the trigger keys you can have spaces, comma's and any other character in your tags!","team-capital":"TEAM","title":"Title","title-from":"Title from","title-from-example":"<i>Elche vs Sevilla en vivo y en directo online en Champions League 2015 (0-2)</i><br>a (pon tu título como si fueras el cronista): <br><i>El Sevilla vence doble en el Martínez Valero</i>","title-from-example2":"<i>Arsenal vs Liverpool Live Result and EPL Scores 2015 (0-2)</i><br> to (put your own title like if you were covering the review): <br><i>Liverpool conquists Highbury</i>","update":"Update","updated-at":"Created At","url":"url","username-or-email":"Username or Email","users":"Users","subscribers":"Subscribers","vavel":"VAVEL","videos":"Videos","what-do-live-finish":"WHAT TO DO WHEN THE LIVE/GAME FINISH","wychowanie":"Upbringing","yes":"Yes","youtube-id":"Video filename","recounts":"Recounts","month":"Month","week":"Week","day":"Day","hour":"hour"}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = {"a-new-account":"a New Account","abstract":"Streszczenie","account-settings":"Ustawienia konta","first-name":"Imię","last-name":"Nazwisko","occupation":"Zawód","account":"Konto","account.tags":"Tagi konta","add-bio-language":"Dodaj nowe BIO w języku","add-title":"Dodaj tutaj swój tytuł","add-description":"Dodaj kilkuzdaniowy opis Twojego wideo, by zachęcić czytelników.","add-description-article":"Dodaj kilkuzdaniowy opis artykułu, by zachęcić czytelników.","start-writing":"Tutaj skopiuj i wklej zawartość Twojego artykułu, by tekst był bardziej przejrzysty, lepszy jakościowo użyj nagłówków, linków i pogrubionej czcionki.","add-image-caption":"Dodaj opis do zdjęcia i źródło zdjęcia/grafiki","choose-category":"Wybierz kategorie","upload-video":"Wstaw wideo","accept":"Akceptujemy","when":"Kiedy?","who":"Kto?","add-tags":"Dodaj tagi, ludzi, event lub lokalizacja pojawia się w tym wideo?","video-date":"Kiedy to wideo zostało stworzone","select-file":"Wybierz plik","drag-drop":"Ściągnij i upuść plik, który chcesz dodać ( Twoje wideo będzie prywatne do momentu opublikowania)","add-video":"Dodaj wideo","add-comment":"Dodaj komentarz","website":"Strona Internetowa","change-password":"Zmień hasło","change-login":"Zmień login","pending":"W toku","add-new":"Dodaj nowy","add-new-bio-language":"Dodaj nowe BIO w języku","add-time-when-helper":"Dodaj tutaj Czas rozpoczęcia (gry) i mniej więcej kiedy się zakończy","add-time-when-helper-carrousel":"Jest potrzebny do pojawienia się w Lives Carrousel OK","all":"Wszystko","allowing-spaces":"Zezwalanie na spacje","allowing-spaces-helper":"Zastępując klawisze wyzwalacza, możesz mieć spacje, przecinki i inne znaki w tagach!","apply-selected-draft":"Wersje robocza","article-style":"Style Artykułu","articles":"Artykuły","author":"Autor","autosave":"Autozapis","avatar":"Awatar","avatar-helper":"(w przypadku logo użyj przezroczystego tła png)","big-avatar":"Duży Awatar","big-avatar-helper":"(dodaj efekt bob i nie używaj obrazów z logo, jeśli to możliwe)","bio":"Bio","bios":"Biografie","body":"Body","carousel":"Karuzela","categories":"Kategorie","category":"Kategoria","change-title":"Zmiana tytułu","city":"Miasto","club-name-optional":"(*Opcjonalnie - pełna nazwa klubu, osoby lub wydarzenia)","country":"Kraj","counts":"KPI","cover-page":"Strona tytułowa","create-password":"Stwórz hasło","created":"Utworzony","created-at":"Utworzony w","crud.project.remove.success":"Projekt o identyfikatorze ‘{{id}}’ został pomyślnie usunięty.","crud.project.save.error":"Coś poszło nie tak podczas zapisywania projektu…","crud.project.save.success":"Projekt o identyfikatorze “{{id}} został pomyślnie zapisany.","crud.user.remove.error":"Coś poszło nie tak podczas usuwania projektu o identyfikatorze ‘{{id}}’.","crud.user.remove.success":"Użytkownik o identyfikatorze ‘{{id}}’ został pomyślnie usunięty.","crud.user.save.error":"Coś poszło nie tak podczas zapisywania użytkownika...","crud.user.save.success":"Użytkownik o identyfikatorze ‘{{id}}’ został pomyślnie zapisany.","danger-zone":"Strefa niebezpieczeństwa","date":"data","delete":"Usuń","delete-helper1":"Jeśli to zrobisz, nie będzie można tego cofnąć.","delete-helper2":"Możesz także tworzyć relacje z dokumentami osieroconymi.","description":"opis","diagrams":"Diagramy","direct":"Bezpośredni","display":"Pokazać","edit":"edycja","editions":"Edycje","end-date":"Końcowa data","english":"Angielski","reindexing":"Reindeksować","enter-your-email":"Enter your email","errors.route.changeError":"Błąd zmiany trasy","event":"Wydarzenie","firstname":"Imię","forgot-password":"Zapomniałeś hasła?","forms.field.required":"To pole jest wymagane","goal-helper":" - Ex: 0-1, min. 21, Sneijder. 1-1, min. 60, Ibrahimovic. 2-1, min. 68, Boateng.","groups":"Grupy","home-page":"Strona główna","gallery":"Galeria","image":"Zdjęcie","image-caption":"Tytul zdjęcia","in":"w","incidents-cap":"INCYDENTY","incidents-helper":"-Superpuchar Włoch pomiędzy mistrzami Scudetto, AC Milan i mistrzem Copa, Inter. Mecz został rozegrany na Beijing National Stadium (Bird Nest). 25 000 widzów.","is-off":"jest WYŁĄCZONY","language":"Języki","last-edited-by":"Ostatnio edytowane przez","lastname":"Lastname","latin-languages":"JĘZYKI ŁACIŃSKIE","limit":"Limit","live-content-reader":"Treści NA ŻYWO, które czytelnik śledzi","live-event":"Na żywo Wydarzenie","login.error.invalidCredentials":"Logowanie nie powiodło się. Sprawdź swoje dane logowania i spróbuj ponownie","login.error.serverError":"Wystąpił problem z uwierzytelnianiem: {{wyjątek}}.","login.reason.notAuthenticated":"Musisz być zalogowany, aby uzyskać dostęp do tej części aplikacji.","login.reason.notAuthorized":"YNie masz niezbędnych uprawnień dostępu. Czy chcesz się zalogować jako ktoś inny?","logout":"Wyloguj","menus":"Menu","merge":"łączyć","my-content":"Moja treść","name":"Nazwa","new-article":"Nowy artykuł","new-biography":"Nowa Tag","new-live":"Nowe życie","new-video":"Nowe wideo","news":"Aktualności","no":"Nie","no-documents-attached":"Brak załączonych dokumentów","noticias":"Aktualności","notifications":"Powiadomienia","notifications-message":"Wiadomość z powiadomieniem","official":"Oficjalny","official-name":"Imię oficjalne","oficial":"Oficjalnie","or":"or","organization":"Organizacja","password":"hasło","pick-username":"Pick an username","player-team1":"Gracz/zespół 1","player-team2":"Gracz/zespół 2","pls-contact-issues":"prosze o kontakt zeby rozwiazac problem","proposers":"Wnioskodawcy","published-by":"Opublikowany przez","publishing":"Publikowanie","publishing-date":"Data Publikowania","quit-heading":"Porzucić nagłówek 2/ usuń nagłówki 2 z tekstu podstawowego","referee-capital":"REFEREE","refers":"Odnosisię","register":"Register","keywords":"Słowa Klucze","remove-language":"Usuń ten język","required-field":"This field is required","role":"Uprawnienia","roles":"Uprawnienia","root":"Źródło","save":"Zapisz","save-changes":"Zapisz Zmiany","score-capital":"SCORE","score-carrousel-optional":"(* Optional - For Score Carrousel, like FCB, RMA, ATM)","score-player1":"Wynik Gracz1","score-player2":"Wynik Gracz2","score-result":"SCORE - Resultado - Resultato","search-filters":"Filtry wyszukiwania","sefriendly":"Sefriendly","send-notification":"Wyślij Powiadomienie","shortname":"Krótka nazwa","sign-in":"Zaloguj się","sign-up":"Sign Up","signIn":"Zaloguj się","slug":"Slug","stadium":"Stadium","start-date":"Data rozpoczęcia","status":"Status","status-archived":"Zarchizowane","status-author-zone":"Strefa autora","status-discard":"Dezaktywuj","status-editing-not-ready":"Edytowane, nie gotowe","status-hompage":"Strona główna","status-published":"Opublikowane","status-ready-to-publish":"Gotowe do publikacji","status-no-use-this-status":" ","status-top-four":"Top 4","search":"Wyszukaj","reset-filters":"Usuń filtry","system":"System","tag-carousel":"Tagi karuzeli","tag-merge":"łączenie tagów","tag-merge-helper":"Możesz scalić wybrane tagi z aktualnymi. Wybrane tagi zostaną usunięte po scaleniu","tags":"Tagi","date-from":"Dodaj tag","tag":"Tagi","date-to":"Data - Od","tags-helper":"Zastępując klawisze wyzwalaczy, możesz mieć spacje, przecinki i inne znaki w tagach!","team-capital":"TEAM","title":"Tytul","title-from":"Tytuł od","title-from-example":"<i> Elche vs Sevilla na żywo i bezpośrednio online w Lidze Mistrzów 2015 (0-2) </i><br>a (wpisz swój tytuł tak, jakbyś był kronikarzem): <br><i>Sevilla wygrywa podwójnie z Martínez Valero</i>","update":"Uaktualnij","updated-at":"Utworzono w","url":"url","username-or-email":"Nazwa użytkownika lub email","users":"Użytkownicy","subscribers":"Subscribers","vavel":"VAVEL","videos":"Wideo","what-do-live-finish":"co-zrobić-na żywo-zakończenie”: “CO ZROBIĆ PO ZAKOŃCZENIU NA ŻYWO / GRY","yes":"Tak","youtube-id":"Wideo ID Youtube","recounts":"KPIs","month":"Miesiąc","week":"Tydzień","day":"Dzień","hour":"Godzina"}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('login.change_pass', ['security.service', 'services.utility', 'ui.bootstrap']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('login-change-pass', {
	    url: '/change_password',
	    views: {
	      header: {
	        template: __webpack_require__(146),
	        resolve: {
	          user: ["User", "$q", "$timeout", "$state", function (User, $q, $timeout, $state) {
	            return User.current(function (user) {
	              if (user._id) {
	                $timeout(function () {
	                  $state.go('account');
	                });
	                return $q.reject();
	              }
	              return user;
	            }).$promise;
	          }]
	        },
	        controller: 'HeaderCtrl'
	      },
	      main: {
	        template: __webpack_require__(302),
	        controller: 'LoginChangePassCtrl',
	        title: 'Update your password ?'
	      },
	      footer: {
	        template: __webpack_require__(149),
	        controller: 'FooterCtrl'
	      }
	    }
	  });
	}]).controller('LoginChangePassCtrl', ['$scope', '$location', '$log', 'security', 'utility', function ($scope, $location, $log, security, utility) {
	  // local variable
	  var resetSuccess = function resetSuccess(data) {
	    $scope.passwordForm.$setPristine();
	    $scope.user = {
	      email: $location.search().email,
	      token: $location.search().token
	    };
	    if (data) {
	      $scope.alerts.push({
	        type: 'info',
	        msg: 'Password was changed successfully. Try to login again.'
	      });
	    } else {
	      angular.forEach(data.errors, function (err, index) {
	        $scope.alerts.push({
	          type: 'danger',
	          msg: err
	        });
	      });
	    }
	  };
	  var resetError = function resetError() {
	    $scope.alerts.push({
	      type: 'danger',
	      msg: 'Reset password error, Please try again'
	    });
	  };
	  // model def
	  $scope.user = {
	    email: $location.search().email,
	    token: $location.search().token
	  };
	  $scope.alerts = [];
	
	  // method def
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.canSave = utility.canSave;
	  $scope.closeAlert = function (ind) {
	    $scope.alerts.splice(ind, 1);
	  };
	  $scope.submit = function () {
	    security.changepass($scope.user).then(resetSuccess, resetError);
	  };
	}]);

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-sm-6> <div class=page-header><h1>Change your password?</h1></div> <form name=passwordForm> <alert ng-repeat=\"alert in alerts\" type={{alert.type}} close=closeAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': !passwordForm.password.$valid && passwordForm.password.$touched}\"> <label class=control-label for=password>Password:</label> <input type=password name=password class=form-control ng-model=user.password required server-error> <span class=help-block ng-show=passwordForm.password.$error.server ng-repeat=\"message in passwordForm.password.$error.server\">{{message}}</span> </div> <div class=form-group ng-class=\"{'has-error': !passwordForm.confirm_password.$valid && passwordForm.confirm_password.$touched}\"> <label class=control-label for=confirm_password>Confirm password:</label> <input type=password name=confirm_password class=form-control ng-model=user.confirm_password required server-error> <span class=help-block ng-show=passwordForm.confirm_password.$error.server ng-repeat=\"message in passwordForm.confirm_password.$error.server\">{{message}}</span> </div> <div class=form-group> <button type=button class=\"btn btn-primary btn-forgot\" ng-disabled=!canSave(passwordForm) ng-click=submit()>Update</button> &nbsp;<a href=/login class=\"btn btn-link\">Back to Login</a> </div> </form> </div> </div> ";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('login.forgot', ['security.service', 'services.utility', 'ui.bootstrap']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('login-forgot', {
	    url: '/login/forgot',
	    views: {
	      header: {
	        template: __webpack_require__(146),
	        resolve: {
	          user: ["User", "$q", "$timeout", "$state", function (User, $q, $timeout, $state) {
	            return User.current(function (user) {
	              if (user._id) {
	                $timeout(function () {
	                  $state.go('account');
	                });
	                return $q.reject();
	              }
	              return user;
	            }).$promise;
	          }]
	        },
	        controller: 'HeaderCtrl'
	      },
	      main: {
	        template: __webpack_require__(304),
	        controller: 'LoginForgotCtrl',
	        title: 'Forgot Your Password ?'
	      },
	      footer: {
	        template: __webpack_require__(149),
	        controller: 'FooterCtrl'
	      }
	    }
	  });
	}]).controller('LoginForgotCtrl', ['$scope', '$location', '$log', 'security', 'utility', function ($scope, $location, $log, security, utility) {
	  // local variable
	  var resetSuccess = function resetSuccess(data) {
	    $scope.loginForgotForm.$setPristine();
	    $scope.user = {};
	    if (data) {
	      $scope.alerts.push({
	        type: 'info',
	        msg: 'If an account matched that address, an email will be sent with instructions.'
	      });
	    } else {
	      angular.forEach(data.errors, function (err, index) {
	        $scope.alerts.push({
	          type: 'danger',
	          msg: err
	        });
	      });
	    }
	  };
	  var resetError = function resetError() {
	    $scope.alerts.push({
	      type: 'danger',
	      msg: 'Error resetting your account, Please try again'
	    });
	  };
	  // model def
	  $scope.user = {};
	  $scope.alerts = [];
	
	  // method def
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.canSave = utility.canSave;
	  $scope.closeAlert = function (ind) {
	    $scope.alerts.splice(ind, 1);
	  };
	  $scope.submit = function () {
	    security.loginForgot($scope.user).then(resetSuccess, resetError);
	  };
	}]);

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-sm-6> <div class=page-header><h1>Forgot Your Password?</h1></div> <form name=loginForgotForm> <alert ng-repeat=\"alert in alerts\" type={{alert.type}} close=closeAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(loginForgotForm.email)}\"> <label class=control-label for=email>Enter Your Email Or Username:</label> <input type=text name=email id=email class=form-control ng-model=user.email required> </div> <div class=form-group> <button type=button class=\"btn btn-primary btn-forgot\" ng-disabled=!canSave(loginForgotForm) ng-click=submit()>Send Reset</button> &nbsp;<a href=/login class=\"btn btn-link\">Back to Login</a> </div> </form> </div> </div> ";

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('login', ['login.index', 'login.forgot', 'login.reset', 'login.social', 'login.change_pass']);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('login.index', ['ngRoute', 'config', 'security.service', 'directives.serverError', 'services.utility', 'ui.bootstrap', 'services.localizedMessages']);
	
	angular.module('login.index').config(["$stateProvider", function ($stateProvider) {
		$stateProvider.state('login', {
			url: '/login',
			views: {
				header: {
					template: __webpack_require__(146),
					controller: 'HeaderCtrl'
				},
				main: {
					template: __webpack_require__(307),
					controller: 'LoginCtrl',
					title: 'Login'
				},
				footer: {
					template: __webpack_require__(149),
					controller: 'FooterCtrl'
				}
			},
			resolve: {
				user: ["User", "$q", "$timeout", "$state", function (User, $q, $timeout, $state) {
					return User.current(function (user) {
						if (user._id) {
							$timeout(function () {
								$state.go('account');
							});
							return $q.reject();
						}
						return user;
					}).$promise;
				}]
			}
		});
	}]);
	
	angular.module('login.index').controller('LoginCtrl', ['$scope', '$location', '$log', 'security', 'utility', 'SOCIAL', 'localizedMessages', function ($scope, $location, $log, security, utility, SOCIAL, localizedMessages) {
		$scope.localizedMessages = localizedMessages;
	
		// local variable
		var loginSuccess = function loginSuccess(data) {
			if (data) {
				//account/user created, redirect...
				return $location.path('/account/my-articles');
			} else {
				//error due to server side validation
				$scope.errfor = data.errfor;
				angular.forEach(data.errfor, function (err, field) {
					$scope.loginForm[field].$setValidity('server', false);
				});
				angular.forEach(data.errors, function (err, index) {
					$scope.alerts.push({
						type: 'danger',
						msg: err
					});
				});
			}
		};
		var loginError = function loginError(err) {
			console.log(err);
			$scope.alerts.push({
				type: 'danger',
				msg: err.data.message
			});
		};
		// model def
		$scope.user = {};
		$scope.alerts = [];
		if ($location.$$search.verified && $location.$$search.verified == "true") {
			$scope.alerts.push({
				type: 'success',
				msg: "Verification successful, you can enter usig your username and password."
			});
		} else if ($location.$$search.verified && $location.$$search.verified == "false") {
			$scope.alerts.push({
				type: 'danger',
				msg: "Unsuccessful verification."
			});
		}
	
		if ($location.$$search.mailSent) {
			$scope.alerts.push({
				type: 'success',
				msg: "Verification link sent to email you specified."
			});
		}
		$scope.errfor = {};
		$scope.social = angular.equals({}, SOCIAL) ? null : SOCIAL;
	
		// method def
		$scope.hasError = utility.hasError;
		$scope.showError = utility.showError;
		$scope.canSave = utility.canSave;
		$scope.closeAlert = function (ind) {
			$scope.alerts.splice(ind, 1);
		};
		$scope.submit = function () {
			$scope.alerts = [];
			security.login($scope.user.username, $scope.user.password).then(loginSuccess, loginError);
		};
	}]);

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=col-sm-6> <div class=page-header> <h1>{{ localizedMessages.get('sign-in') }}</h1> </div> <form name=loginForm> <alert ng-repeat=\"alert in alerts\" type={{alert.type}} close=closeAlert($index)>{{alert.msg}}</alert> <div class=form-group ng-class=\"{'has-error': hasError(loginForm.username)}\"> <label class=control-label for=username>{{ localizedMessages.get('username-or-email') }}:</label> <input type=text name=username id=username class=form-control ng-model=user.username required server-error> <span class=help-block ng-show=\"showError(loginForm.username, 'required')\"> {{ localizedMessages.get('required-field') }} </span> <span class=help-block ng-show=\"showError(loginForm.username, 'server')\">{{errfor.username}}</span> </div> <div class=form-group ng-class=\"{'has-error': hasError(loginForm.password)}\"> <label class=control-label for=password>{{ localizedMessages.get('password') }}:</label> <input type=password name=password id=password class=form-control ng-model=user.password required server-error> <span class=help-block ng-show=\"showError(loginForm.password, 'required')\"> {{ localizedMessages.get('required-field') }} </span> <span class=help-block ng-show=\"showError(loginForm.password, 'server')\">{{errfor.password}}</span> </div> <div class=row> <div class=\"form-group col-md-6\"> <button type=submit class=\"btn btn-primary btn-login\" ng-disabled=!canSave(loginForm) ng-click=submit()>{{ localizedMessages.get('sign-in') }}</button> </div> <div class=\"col-md-6 form-group\"> <a ng-href=/login/forgot class=\"btn btn-link pull-right\">{{ localizedMessages.get('forgot-password') }}</a> </div> </div> </form> </div> </div>";

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('login.reset', ['security.service', 'services.utility', 'ui.bootstrap']);
	angular.module('login.reset').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/login/reset', {
	    templateUrl: 'login/reset/login-reset.tpl.html',
	    controller: 'LoginResetCtrl',
	    title: 'Reset Your Password'
	  }).when('/login/reset/:email/:token', {
	    templateUrl: 'login/reset/login-reset.tpl.html',
	    controller: 'LoginResetCtrl'
	  });
	}]);
	angular.module('login.reset').controller('LoginResetCtrl', ['$scope', '$location', '$routeParams', '$log', 'security', 'utility', function ($scope, $location, $routeParams, $log, security, utility) {
	  // local variable
	  var warningAlert = {
	    type: 'warning',
	    msg: 'You do not have a valid reset request.'
	  };
	  var successAlert = {
	    type: 'info',
	    msg: 'Your password has been reset. Please login to confirm.'
	  };
	  var resetSuccess = function resetSuccess(data) {
	    $scope.resetForm.$setPristine();
	    $scope.user = {};
	    if (data.success) {
	      $scope.success = true;
	      $scope.alerts.push(successAlert);
	    } else {
	      angular.forEach(data.errors, function (err, index) {
	        $scope.alerts.push({
	          type: 'danger',
	          msg: err
	        });
	      });
	    }
	  };
	  var resetError = function resetError() {
	    $scope.alerts.push({
	      type: 'danger',
	      msg: 'Error resetting your password, Please try again'
	    });
	  };
	  // model def
	  $scope.user = {};
	  $scope.alerts = [];
	  $scope.email = $routeParams.email;
	  $scope.id = $routeParams.token;
	  $scope.success = false;
	
	  //initial behavior
	  if (!($scope.email && $scope.id)) {
	    $scope.alerts.push(warningAlert);
	  }
	
	  // method def
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.canSave = utility.canSave;
	  $scope.closeAlert = function (ind) {
	    $scope.alerts.splice(ind, 1);
	  };
	  $scope.submit = function () {
	    security.loginReset($scope.id, $scope.email, $scope.user).then(resetSuccess, resetError);
	  };
	}]);

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('login.social', ['login.social.google', 'login.social.facebook', 'login.social.twitter']);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('login.social.facebook', ['security.service']);
	angular.module('login.social.facebook').config(["$urlRouterProvider", function ($urlRouterProvider) {
	  $urlRouterProvider.when('/login/facebook/callback', ["$location", "$location2", "security", function ($location, $location2, security) {
	    // console.log( '>> login-facebook', security );
	    var promise = security.socialLogin('facebook', $location.search()).then(function (data) {
	      $location.search({});
	
	      if (!data.success) {
	        return;
	      }
	
	      if (security.isAdmin()) {
	        return $location.path('/admin');
	      }
	
	      $location.path('/account');
	    }).catch(function () {
	      $location.search({});
	      $location.path('/login');
	    });
	
	    return promise;
	  }]);
	}]);

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('login.social.google', ['security.service']);
	angular.module('login.social.google').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/login/google/callback', {
	    resolve: {
	      verify: ['$log', '$q', '$location', '$route', 'security', function ($log, $q, $location, $route, security) {
	        var redirectUrl;
	        var params = $route.current.params;
	        var promise = security.socialLogin('google', params).then(function (data) {
	          if (data.success) {
	            // redirectUrl = data.defaultReturnUrl || '/account'
	            redirectUrl = '/account';
	          }
	          return $q.reject();
	        }).catch(function () {
	          redirectUrl = redirectUrl || '/login';
	          $location.search({}); //remove search params added by passport/google
	          $location.path(redirectUrl);
	          return $q.reject();
	        });
	        return promise;
	      }]
	    },
	    reloadOnSearch: false
	  });
	}]);

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('login.social.twitter', ['security.service']);
	angular.module('login.social.twitter').config(['$routeProvider', function ($routeProvider) {
	  $routeProvider.when('/login/twitter/callback', {
	    resolve: {
	      verify: ['$log', '$q', '$location', '$route', 'security', function ($log, $q, $location, $route, security) {
	        var redirectUrl;
	        var params = $route.current.params;
	        var promise = security.socialLogin('twitter', params).then(function (data) {
	          if (data.success) {
	            // redirectUrl = data.defaultReturnUrl || '/account'
	            redirectUrl = '/account';
	          }
	          return $q.reject();
	        }).catch(function () {
	          redirectUrl = redirectUrl || '/login';
	          $location.search({}); //remove search params added by passport/twitter
	          $location.path(redirectUrl);
	          return $q.reject();
	        });
	        return promise;
	      }]
	    },
	    reloadOnSearch: false
	  });
	}]);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var countries = __webpack_require__(161);
	var editions = __webpack_require__(187);
	
	angular.module('signup', ['config', 'services.utility', 'security.service', 'directives.serverError', 'ui.bootstrap', 'security', 'services.localizedMessages']);
	
	angular.module('signup').config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('signup', {
	    url: '/signup',
	    title: 'Sign Up',
	    views: {
	      header: {
	        template: __webpack_require__(146),
	        resolve: {
	          user: ["User", "$q", "$timeout", "$state", function (User, $q, $timeout, $state) {
	            return User.current(function (user) {
	              if (user._id) {
	                $timeout(function () {
	                  $state.go('account');
	                });
	                return $q.reject();
	              }
	              return user;
	            }).$promise;
	          }]
	        },
	        controller: 'HeaderCtrl'
	      },
	      main: {
	        template: __webpack_require__(314),
	        controller: 'SignupCtrl'
	      },
	      footer: {
	        template: __webpack_require__(149),
	        controller: 'FooterCtrl'
	      }
	    }
	  });
	}]);
	
	angular.module('signup').controller('SignupCtrl', ["$scope", "$location", "$log", "utility", "security", "SOCIAL", "localizedMessages", function ($scope, $location, $log, utility, security, SOCIAL, localizedMessages) {
	  $scope.localizedMessages = localizedMessages;
	  // local variable
	  var signupSuccess = function signupSuccess(data) {
	    if (data.success) {
	      //account/user created, redirect...
	      var url = data.defaultReturnUrl || '/';
	      return $location.path('/account/my-articles');
	      return $location.path(url);
	    } else {
	      //error due to server side validation
	      $location.$$search.mailSent = true;
	      return $location.path('/login');
	      $scope.errfor = data.errfor;
	      angular.forEach(data.errfor, function (err, field) {
	        $scope.signupForm[field].$setValidity('server', false);
	      });
	    }
	  };
	  var signupError = function signupError(msg) {
	
	    $scope.alerts.push({
	      type: 'danger',
	      msg: msg.data.message
	    });
	  };
	
	  $scope.countries = [];
	  _.forIn(countries, function (value, key) {
	    $scope.countries.push({
	      _id: key,
	      name: value
	    });
	  });
	  $scope.editions = [];
	  _.forIn(editions, function (value, key) {
	    $scope.editions.push({
	      _id: key,
	      name: value
	    });
	  });
	
	  // model def
	  $scope.user = {};
	  $scope.alerts = [];
	  $scope.errfor = {};
	  $scope.social = angular.equals({}, SOCIAL) ? null : SOCIAL;
	
	  // method def
	  $scope.hasError = utility.hasError;
	  $scope.showError = utility.showError;
	  $scope.canSave = utility.canSave;
	  $scope.closeAlert = function (ind) {
	    $scope.alerts.splice(ind, 1);
	  };
	  $scope.submit = function () {
	    var user = _.clone($scope.user);
	    user.password = security.createHash(user.password);
	    security.signup(user).then(signupSuccess, signupError);
	  };
	}]);

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports = "<div class=row id=signup> <div class=col-sm-6> <div class=page-header><h1>{{ localizedMessages.get('sign-up') }}</h1></div> <form name=signupForm> <alert ng-repeat=\"alert in alerts\" type={{alert.type}} close=closeAlert($index)>{{alert.msg}}</alert> <div class=form-group> <label class=control-label for=firstname>{{ localizedMessages.get('firstname') }}:</label> <input type=text name=firstname id=firstname class=form-control ng-model=user.account.name.first> </div> <div class=form-group> <label class=control-label for=lastname>{{ localizedMessages.get('lastname') }}:</label> <input type=text name=lastname id=lastname class=form-control ng-model=user.account.name.last> </div> <div class=form-group ng-class=\"{'has-error': hasError(signupForm.username)}\"> <label class=control-label for=username>{{ localizedMessages.get('pick-username') }}:</label> <input type=text name=username id=username class=form-control ng-model=user.username required server-error> <span class=help-block ng-show=\"showError(signupForm.username, 'required')\">{{ localizedMessages.get('required-field') }}</span> <span class=help-block ng-show=\"showError(signupForm.username, 'server')\">{{errfor.username}}</span> </div> <div class=form-group ng-class=\"{'has-error': hasError(signupForm.email)}\"> <label class=control-label for=email>{{ localizedMessages.get('enter-your-email') }}:</label> <input type=email name=email id=email class=form-control ng-model=user.email required server-error> <span class=help-block ng-show=\"showError(signupForm.email, 'required')\">{{ localizedMessages.get('required-field') }}</span> <span class=help-block ng-show=\"showError(signupForm.email, 'email')\">{{ localizedMessages.get('validEmail') }}</span> <span class=help-block ng-show=\"showError(signupForm.email, 'server')\">{{errfor.email}}</span> </div> <div class=form-group ng-class=\"{'has-error': hasError(signupForm.password)}\"> <label class=control-label for=password>{{ localizedMessages.get('create-password') }}:</label> <input type=password name=password id=password class=form-control ng-model=user.password required server-error> <span class=help-block ng-show=\"showError(signupForm.password, 'required')\">{{ localizedMessages.get('required-field') }}</span> <span class=help-block ng-show=\"showError(signupForm.password, 'server')\">{{errfor.password}}</span> </div> <div class=form-group ng-class=\"{'has-error': user.password != passwordConfirm}\"> <label class=control-label for=passwordConfirm>{{ localizedMessages.get('confirm-password') }}:</label> <input type=password name=passwordConfirm id=passwordConfirm class=form-control ng-model=passwordConfirm required server-error> </div> <div class=\"form-group panel panel-default\"> <div class=panel-heading>Term of Use</div> <div class=panel-body id=termOfUse style=max-height:90px;overflow:hidden;overflow-y:scroll;text-align:justify> <p>Terms of Service &amp; Cookie Policy</p> <p>Iworis Family PRIVACY POLICY</p> <p>Our Commitment to You</p> <p>Iworis Family (&ldquo;Iworis Family&rdquo;) are dedicated to providing internet users with the highest level of transparency and control over the use of their data. In order for us to provide you with our services we are required to collect and process certain personal information about you and your activity.</p> <p>By entrusting us with your information, we would like to assure you of our commitment to keep such information private. We have taken measurable steps to protect the confidentiality, security and integrity of this Information. We encourage you to review the following information carefully.</p> <p>&nbsp;</p> <p>Grounds for data collection</p> <p>Processing of your &ldquo;Personal Data&rdquo; (meaning any information which may potentially allow your identification with reasonable means) is necessary for the performance of our contractual obligations towards you and providing you with our services and the operation of our website (hereinafter the &ldquo;Services&rdquo; and &ldquo;Website&rdquo;), to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</p> <p>When you use our Service, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</p> <p>&nbsp;</p> <p>How do we receive data about you?</p> <p>We receive your Personal Data from various sources:</p> <p>Registration information - When you voluntarily provide us your personal details in order to create an account or register to our Services (for example, your name and email address);</p> <p>When you communicate with us - For example when you send us an email, we collect the Personal Information you provided us with.</p> <p>Technical information - When operating our services, we use various technological tracking tools to collect information regarding your use of the Website. Along with our partners, we may use tracking technologies such as cookies, JavaScript, beacons and Local Storage such as HTML5, which are used to store content information and preferences. You can learn more about the tracking tools we use by visiting our Cookie Policy.</p> <p>Third party information &ndash; We may receive your data from third party providers who help us with the provision and maintenance of our Services, such as social networks (for example your name and user name, when you register or log-in to our Service), traffic analytics vendors, fraud prevention agencies and others.</p> <p>What type of data we collect?</p> <p>Personal Data</p> <p>In the course of using the Service, we may ask you to provide us with certain Personal Data to provide and improve the Service, to contact or identify you, to enable you to access certain parts of the Website, and as otherwise indicated in this Policy. We collect the following Personal Data about you:</p> <p>Registration information &ndash; your name, your email address, and your age range. If you connect your account to a social network (for example: if you log in via Facebook), we will also collect certain details, such as your Facebook token, profile and profile photo. &nbsp;</p> <p>When using our Services &ndash; our webserver will collect your IP-address and UDID.</p> <p>Non-Personal Data</p> <p>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:</p> <p>Technical information &ndash; this category includes data such as website visits, the browser you are using and its display settings, your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), and cookie information and your general location (city and country).</p> <p>Information from third parties &ndash; this category includes information we receive from our business partners. This may include pseudonymous advertiser identifiers that some Advertisers or other third party ad platforms choose to share with us. This information is also used to enhance data points about a particular unique browser or device.</p> <p>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data. Further Personal Data will only be stored and processed if you voluntarily provide it to us, e.g. through a contact form.</p> <p>&nbsp;</p> <p>Tracking Technologies</p> <p>When you visit or access our Services we use (and authorize 3rd parties to use) pixels, cookies, events and other technologies. Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Website&rsquo;s performance, perform analytics and customize your experience on it. In addition, we may merge information we have with information collected through these tracking technologies with information we may obtain from other sources and, as a result, such information may become Personal Data.</p> <p>To learn more about our Tracking Technologies please visit our&nbsp;Cookie Policy page.</p> <p>&nbsp;</p> <p>How do we use the data we collect?</p> <p>Provision of service - for the provision and improvement of our Services, including for support and to respond to your queries.</p> <p>Service announcements - we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Services and offer you service offers.</p> <p>Marketing and advertising purposes - by subscribing to our newsletter you will receive tips and announcements straight to your email account. We may also use your Personal Data in the following ways: we may send you promotional material concerning our Services, or our partners&#39; services, which we believe might interest you; we may also display certain adverts on our site, which we believe will be relevant for you. We make our best efforts to make sure you see only relevant ads and receive relevant communications from us, including but not limited to, by building an automated profile based on your Personal Data. You may however choose not to receive our promotional or marketing emails (all or any part thereof) by clicking on the &ldquo;unsubscribe&rdquo; link in the emails that you receive from us. Please note that even if you unsubscribe from our newsletter, we may continue to send you service-related updates and notifications, or reply to your queries and feedback you provide us. You may also object to the use of your Personal Data for advertising purposes by disabling your cookies, as described in our Cookie Policy.</p> <p>Opt-out of receiving marketing materials - If you do not want us to use or share your Personal Data for marketing purposes, you may opt-out in accordance with this &quot;Opt-out&quot; section. Please note that even if you opt-out, we may still use and share your Personal Data with third parties for non-marketing purposes (for example to fulfill your requests, communicate with you and respond to your inquiries, etc.). In such cases, the companies with whom we share your Personal Data are authorized to use your Personal Data only as necessary to provide these non-marketing services.</p> <p>Analytics, surveys and research - from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and think of new and exciting features for our users.</p> <p>Protecting our interests - we may use your Personal Data when we believe it&rsquo;s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of Iworis Family, its users and/or partners.</p> <p>Enforcing of policies - we may use your Personal Data in order to enforce our policies, including but limited to our Terms .</p> <p>Compliance with legal and regulatory requirements - we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</p> <p>&nbsp;</p> <p>With whom do we share your Personal Data?</p> <p>Internal concerned parties - we share your information with companies in our group, as well as our employees, in order to provide you with our services.</p> <p>Business partners - we share your information with business partners, such as storage and analytics providers who help us provide you with our service. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with this Privacy Policy and may not use your Personal Data for any other purpose.</p> <p>Compliance with laws and law enforcement entities - we cooperate with government and law enforcement officials and private parties to enforce and comply with the law. We will disclose any data about you to government or law enforcement officials or private parties as we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party&#39;s property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable. We also may be required to disclose an individual&rsquo;s Personal Data in response to a lawful request by public authorities, including meeting national security or law enforcement requirements.</p> <p>Merger and acquisitions &ndash; we may share your data if we enter into a business transaction such as a merger, acquisition, reorganization, bankruptcy, or sale of some or all of our assets. Any party that acquires our assets as part of such a transaction may continue to use your data in accordance with the terms of this Privacy Policy.</p> <p>&nbsp;</p> <p>Transfer of data outside the EEA</p> <p>Please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</p> <p>&nbsp;</p> <p>How we protect your information</p> <p>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn&rsquo;t publicly available. We limit access of your information only to those employees or partners on a &ldquo;need to know&rdquo; basis, in order to enable the carrying out of the agreement between us.</p> <p>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You need to help us prevent unauthorized access to your account by protecting your password appropriately and limiting access to your account. You will be solely responsible for keeping your password confidential and for all use of your password and your account, including any unauthorized use. You should also be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the service, and you do so at your own risk.</p> <p>&nbsp;</p> <p>Retention</p> <p>We will retain your Personal Data for as long as necessary to provide our services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing client personal data, trading information, account opening documents, communications and anything else as required by applicable laws and regulations.</p> <p>&nbsp;</p> <p>EU User Rights</p> <p>You may request to:</p> <p>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.</p> <p>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.</p> <p>Request rectification of your Personal Data that is in our control.</p> <p>Request erasure of your Personal Data.</p> <p>Object to the processing of Personal Data by us.</p> <p>Request to restrict processing of your Personal Data by us.</p> <p>Lodge a complaint with a supervisory authority.</p> <p>However, please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements. Users outside the EU are welcome to contact us for any questions or requests at the details below.</p> <p>&nbsp;</p> <p>How to contact us?</p> <p>If you wish to exercise any of the aforementioned rights, or receive more information, please contact our Data Protection Officer (&ldquo;DPO&rdquo;) using the details provided below:</p> <p>&nbsp;</p> <p>Att. Iworis Family Media,</p> <p>Email: info@Iworis Family.com</p> <p>Calle Vallandes 12, Madrid</p> <p>&nbsp;</p> <p>Our Policy toward Children</p> <p>We understand the importance of protecting children&rsquo;s privacy, especially in an online environment. The Site and Services are not designed for or directed at children under the age of 16 years old (&ldquo;Minors&rdquo;). We do not knowingly collect Personal Data from Minors. If a parent or guardian becomes aware that his or her child has provided us with Personal Data, he or she should contact us using the details provided above.</p> <p>&nbsp;</p> <p>Updates to this Policy</p> <p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our website (as reflected in the &quot;Last Updated&quot; heading). You are advised to check for updates regularly. In the event of material changes, we will provide you with a notice. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.</p> <p>&nbsp;</p> <p>Iworis Family COOKIE POLICY</p> <p>Revised at: May 22, 2018</p> <p>Introduction</p> <p>When you visit or access our website, or when you interact or engage with our representatives (&ldquo;Service&rdquo;), we will use (and authorize third parties to use) web beacons, cookies, pixel tags, scripts, tags, API and other technologies (&quot;Tracking Technologies&quot;). This is explained in this policy (&ldquo;Cookie Policy&rdquo;) which is a part of our Privacy Policy.</p> <p>The Tracking Technologies allow us to automatically collect information about you and your online behavior in order to enhance your navigation on our Service, improve our Service performance and customize your experience on it. We also use this information to collect statistics about the usage of our Service, perform analytics, deliver content which is tailored to your interests and to administer services to our users, writers, customers and partners. We also allow third parties to collect information about you through Tracking Technologies.</p> <p>What are cookies?</p> <p>Cookies are small text files (composed only of letters and numbers) that a web server places on your computer or mobile device when you visit a webpage. When used, the cookie can help make our Services more user-friendly, for example by remembering your language preferences and settings. You can find more information about cookies at&nbsp;www.allaboutcookies.org.</p> <p>Cookies are widely used in order to make websites work in an efficient way. The use of cookies allows you to navigate between pages efficiently. Cookies remember your preferences, and make the interaction between you and the Services smoother and more efficient.</p> <p>Storing Tracking Technologies</p> <p>We store Tracking Technologies when you visit or access our Services (typically, when you are visiting our websites) &ndash; these are called &quot;First Party Tracking Technologies&quot;. In addition, Tracking Technologies are stored by other third parties (for example our analytics service providers, business partners and advertisers) who run content on our Services &ndash; these are called &quot;Third Party Tracking Technologies&quot;.</p> <p>Both types of Tracking Technologies may be stored either for the duration of your visit on our Services or for repeat visits.</p> <p>What types of Tracking Technologies do we use?</p> <p>There are five main types of Tracking Technologies:</p> <p>Strictly necessary Tracking Technologies<br/> These Tracking Technologies are essential to enable you to login, navigate around and use the features of our Services, or to provide a service requested by you (such as your username). We do not need to obtain your consent in order to use these Tracking Technologies. These Tracking Technologies can be used for security and integrity reasons - for example to detect violation of our policies and for support or security features.</p> <p>Functionality Tracking Technologies<br/> These Tracking Technologies allow our Services to remember choices you make (such as your language) and provide enhanced and personalized features. For example, these Tracking Technologies are used for authentication (to remember when you are logged-in) and support other features of our Services.</p> <p>Performance Tracking Technologies<br/> These Tracking Technologies collect information about your online activity (for example the duration of your visit on our Services), including behavioral data and content engagement metrics. These Tracking Technologies are used for analytics, research and to perform statistics (based on aggregated information).</p> <p>Marketing or Advertising Tracking Technologies</p> <p>These Tracking Technologies are used to deliver tailored offers and advertisements to you, based on your derived interests, as well as to perform email marketing campaigns. They can also be used to limit the number of times you see an advertisement as well as help measure the effectiveness of the advertising campaign. They are usually placed by our advertisers (for example advertising networks) and provide them insights about the people who see and interact with their ads, visit their websites or use their app.</p> <p>Social media Tracking Technologies<br/> Our website includes social media features, such as the Facebook &quot;Like&quot; or &quot;Share&quot; buttons, or third party log-in services. These features are either hosted by a third party or hosted directly on our Services. Your interactions with these features are governed by the privacy statement of the company providing these features.</p> <p>Below are the cookies you can find on our Services:</p> <p>Tracking Technologies</p> <p>Type</p> <p>Purpose</p> <p>Analytics Cookies</p> <p>First party Tracking Technology</p> <p>Performance Tracking Technologies</p> <p>These Tracking Technologies are used to collect information regarding how you interact with the content on our Services, attribution purposes (for example, the referral URL), etc. We use the information to compile reports, calculate the revenues due to us and, help us improve the Services and to offer personalized products and content.</p> <p>Facebook Cookie</p> <p>&nbsp;</p> <p>Third party Tracking Technology</p> <p>Functionality Tracking Technologies<br/> We use cookies to verify your account and determine when you&rsquo;re logged in so we can make it easier for you to access the Facebook Products and show you the appropriate experience and features. We use cookies to help us keep your account, data and the Facebook Products safe and secure. To view the full description of Facebook&rsquo;s use of cookies on our site please visit the Facebook privacy policy and Cookie Policy</p> <p>Google Analytics</p> <p>Third party Tracking Technology</p> <p>Performance Tracking Technologies<br/> This cookie is used to collect information about how visitors use our Platform. We use the information to compile reports and to help us improve the Platform. The cookies collect information in an anonymous form, including the number of visitors to the Platform, where visitors have come to the Platform from and the pages they visited.&nbsp;<br/> Google&rsquo;s Privacy Policy</p> <p>DoubleClick (by Google)</p> <p>Third party Tracking Technology</p> <p>Marketing or Advertising Tracking Technologies DoubleClick uses cookies to improve advertising. Some common applications are to target advertising based on what&rsquo;s relevant to a user, to improve reporting on campaign performance, and to avoid showing ads the user has already seen.</p> <p>Google&rsquo;s Cookie Policy</p> <p>OpenX</p> <p>Third party Tracking Technology</p> <p>Marketing or Advertising Tracking Technologies</p> <p>These cookies collect information about your browsing habits in order to make advertising more relevant to you and your interests. They are also used to limit the number of times you see an advertisement as well as help measure the effectiveness of an advertising campaign. The cookies remember the websites you visit and that information is shared with other parties such as advertisers. More information can be found on OpenX&rsquo;s Privacy Policy</p> <p>PermimeterX</p> <p>Third party Tracking Technology</p> <p>Performance Tracking Technologies<br/> PerimeterX uses cookies and other tracking technologies in order to identify and protect publishers against bots and other fraud types. More information can be found on PerimeterX Privacy Policy.</p> <p>Moat</p> <p>Third party Tracking Technology</p> <p>Performance Tracking Technologies<br/> Moat uses cookies and other tracking technologies in order to identify and protect publishers against bots and other fraud types. More information can be found on Moat&rsquo;s Privacy Policy.</p> <p>comScore</p> <p>Third party Tracking Technology</p> <p>Performance Tracking Technologies</p> <p>comScore collects certain personal information about your use of our Website (for example, your IP address). This information allows comScore to provide us with its services, such as site ranking.</p> <p>comScore complies with the EU-U.S. and the Swiss-U.S. Privacy Shield Framework regarding the collection, use, and retention of Personal Information.&nbsp;To learn more, please view comScore&rsquo;s&nbsp;Privacy Shield Statement, its Privacy Policy and its&nbsp;GDPR Privacy Policy here.&nbsp;</p> <p>&nbsp;</p> <p>How to manage your cookie settings</p> <p>There are various ways in which you can manage and control your cookie settings. Please remember that, by deleting or blocking cookies, some of the features of the Services may not work properly or as effectively.</p> <p>Turning off cookies via your web browser<br/> Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device.</p> <p>Information about cookies is usually found in the &quot;Help&quot; section of the web browser. Below are some links to some commonly used web browsers:</p> <p>Google Chrome</p> <p>Internet Explorer</p> <p>Mozilla Firefox</p> <p>Safari (Desktop)</p> <p>Safari (Mobile)</p> <p>Android Browser</p> <p>Opera</p> <p>Opera Mobile</p> <p>For other browsers, please consult the documentation that your browser manufacturer provides.</p> <p>Turning off third party cookies<br/> You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;Network Advertising Initiative.</p> <p>Other helpful resources</p> <p>To learn more about advertisers&rsquo; use of cookies the following links may be helpful:</p> <p>European Interactive Digital Advertising Alliance (EU)</p> <p>Internet Advertising Bureau (US)</p> <p>Internet Advertising Bureau (EU)</p> <p><br/> &nbsp;</p> <p>Terms of Service</p> <p>Last modified on October 31, 2013.</p> <p>These Terms of Use apply to your use of the Iworis Family community, the related mobile device software applications (the &ldquo;Mobile Software&rdquo;) and on the Iworis Family website at www.Iworis Family.com (the &quot;Website&quot;, and together with the Facebook Application and Mobile Software, the &quot;Service&quot;).</p> <p>Accepting these Terms of Use</p> <p>Our offer of the Service, including all information, tools and services available from the Service to you is conditioned upon your acceptance of all the terms, conditions, policies and notices stated herein. Your use of the Service or any part thereof constitutes your agreement and is subject to these Terms of Use and all applicable laws, rules and regulations. If you do not agree to these Terms of Use you may not and should not use the Service or any part thereof.</p> <p>Changes and Amendments to Terms of Use</p> <p>We reserve the right to amend, add or delete portions of these Terms of Use at any time and at our sole discretion. While we may and may not post notices on the Service informing of changes in these terms of use, you are solely responsible for reviewing these Terms of Use periodically to ensure you are aware of any changes. The last revision of these Terms of Use shall be reflected in the &quot;Last modified by&quot; heading above. Your continuing use of the Service following any change or amendment to these Terms of Use constitutes your acceptance of such change or update. If you do not agree or wish to be bound by these Terms of Use as currently drafted and as may be amended from time to time, you should not use the Service or cease your use of the Service immediately.</p> <p>Privacy Policy</p> <p>We understand you want to keep your information private, and that you value our emphasis on keeping your information safe and discrete. As a result we have drafted a privacy policy (the &quot;Privacy Policy&quot;) which details the ways in which we collect, use and disclose personal information from users of the Service. The Privacy Policy is incorporated into, subject to and a part of the Service&#39;s Terms of Use. Your use of the Service signifies your acknowledgement of, and agreement to, the Service&rsquo;s Privacy Policy. If you do not agree to the Privacy Policy, you may not and should not use the Service. The definitions in the Service&#39;s Terms of Use apply to this Policy unless stated otherwise.</p> <p>Limitation on Use</p> <p>You may not register or use the Service if you are under 14 years of age and/or if you are legally unable to enter into a legally binding agreement without the consent of your parents or legal guardian. The following uses of the Service or any part thereof are prohibited: Commercial use, unless specifically and explicitly allowed by us in a prior written consent; Damaging or infringing the rights of third parties in any way, including infringing on any third party&#39;s intellectual property; Illegal use, including without limitation fraud, pornography trafficking, drug dealing, sports betting and gambling; Distributing SPAM; Using users contact information for marketing purposes; Bullying, intimidating, stalking or harassing any person; Duplicating, copying, reproducing, modifying, transmitting, performing, broadcasting, rebroadcasting, publishing, selling, creating derivatives of, translating, distributing or redistributing the Service, the Service IP, third parties User Content or any part thereof or their products, unless specifically and explicitly allowed by us in a prior written consent; Altering, modifying, decompiling, disassembling, reverse engineering or otherwise attempting to discover or to learn information regarding the Service&#39;s (including its content&#39;s) source code and structure; Any automatic use which is intended or designed to gather information about or from the Service, including without limitation Bots, Crawlers, Spiders, Robots, Sifters and Load Testers; Uploading of any sort of malware, spyware or other malicious code; Circumventing or bypassing any measure designed to limit access to the Service or any part thereof; Damaging, disabling, impairing or flooding the Service; Competing with the Service.</p> <p>Securing your password</p> <p>You are responsible for protecting the confidentiality of the password associated with your use of the Service and your Facebook account and for restricting access to your computer while logged into the Service. You agree that you will be responsible for any and all statements, acts or omissions made during any use of the Service through your account. If you have any reason to believe or become aware of any loss, theft or unauthorized use of your password, notify us immediately to&nbsp;info@Iworis Family.com.&nbsp;We may assume that any communications we receive under your name, account or user have been made by you unless we receive notice otherwise. An Iworis Family employee will never ask you for your password, neither personally nor by email.</p> <p>Termination, Changes to the Service and Removal of Content</p> <p>You understand, acknowledge and agree that we may terminate your access to the Service at our sole discretion, at any time, with or without reason or notice to you and without any liability on our part for such termination. Regardless of the aforementioned, we reserve the right to terminate your access to the Service if we reasonably determine that you have infringed these Terms of Use. We reserve the right to remove or make any changes to the Service, its features, contents, materials, accessibility or any part thereof we see fit at or sole discretion and without liability on our part for such removal or change. We have no obligation to store, distribute, update, correct or use any information uploaded to the Service.</p> <p>Content Creator Terms of Use</p> <p>The Service allows you to upload content to the Service directly in various forms, including without limitation statuses, links, images, comments, articles and conversations (collectively referred to herein as User Content). You affirm, represent and warrant that you own all required rights, titles and interests in your User Content to upload it to the Service and that your User Content is accurate where it might be reasonably relied upon. You shall be held liable to any damages or losses incurred by us as a result of Copyright Infringement through your User Content, including payment of damages and statutory damages resulting from contributory or direct (meaning, even in the event that the content was edited and re-published by us) infringement. We reserve the right to remove any and all of your User Content if we reasonably determine that it is infringing upon any third party&#39;s intellectual property rights. We reserve the right to edit your content in any way we see fit. We reserve the right to terminate your access to the Service, if we reasonably determine that you are a Repeat Infringer (as defined below). You acknowledge that you expect and shall receive no compensation, payment or interests as a result of uploading your User Content, other than agreed between us explicitly and in writing beforehand. You agree to allow any and all other users of the Service to access your User Content and to &quot;follow&quot; your profile freely and without compensation to you of any sort on their behalf. You hereby grant us a world-wide, non-revocable, royalty-free, sub-licensable and transferable license to use your User Content, including without limitation copyrighted works, trade secrets, ideas, inventions, utility models, designs, patents, software and other intellectual property, in any way we see fit at our sole discretion, including without limitation reproduction, distribution, making of derivatives, modification, adaptation, publication, translation and display. For the avoidance of doubt, we may include your User Content in our outgoing feed to third parties (e.g. RSS feed), which may publish said feed (including your User Content) outside of the Service. In addition to abiding by these Terms of Use, your User Content must also abide by Facebook&#39;s terms of use. You may not upload User Content which: May encourage acts of violence; Infringes third parties&#39; intellectual property; Contains or constitutes SPAM or chain mail; Infringes third parties&#39; right to privacy or publicity rights; Contains confidential or proprietary information; Is defamatory, fraudulent, libelous, abusive, obscene, unlawful, threatening, hateful, harassing, racial, sexist or otherwise inappropriate by reasonable standards; Advertise or solicit third parties&#39; business or contains commercial content of any sort; Impersonate another person without proper notice; Contain any form of malware; Interfere with the service in any way. We do not guarantee and we have no obligation to post, transmit, distribute, upload, publish or display any User Content and may refuse to do so at our sole discretion.</p> <p>Notice and Takedown</p> <p>We take copyright infringement very seriously, and we are committed to comply with the applicable copyright and intellectual property legislation. As a result, and in accordance with the Digital Millennium Copyright Act, we have a Notice &amp; Takedown mechanism, designed to enable intellectual property owners to report an infringing use of the Service, while preserving our users&#39; freedom to share. Upon receiving of a Takedown Notice (as defined below), we shall make our best reasonable efforts to remove the infringing content from the Service immediately, and, in the event that the infringing content was uploaded by a user and that user is a Repeat Infringer (as defined below), to terminate said user&#39;s access to the Service. In order to allow us to fully comply with the law, an adequate takedown notice (&quot;Takedown Notice&quot;) shall comply with the following: The Takedown Notice shall be sent via email as a single PDF format document to&nbsp;info@Iworis Family.com; The Takedown notice shall clearly include the following details: The identity (including register/identification number) of the notifying party; The date; The address, website URL and jurisdiction of the notifying party; The Takedown Notice shall clearly detail the copyright violation using screen shots, searches and so forth. The Takedown Notice shall identify the copyright violator User Name; and Clearly state that the person signing the Takedown Notice under penalty of perjury has given accurate information; that he/she is the owner or acting on behalf of the owner of the copyright; and that the aforementioned use of the copyrighted work constitutes an infringement to the best knowledge. If you receive notification from us stating that a Takedown Notice was received regarding content or activity for which you are responsible, you may contend the Takedown Notice within seven days, in which case the content shall be re-uploaded and your contact details (which must be contained in the contention) be given to the Notice&#39;s sender. A &quot;Repeat Infringer&quot; shall be defined as: A user which three Takedown Notices were received regarding content uploaded by him within a period of one year; or A user which a total of ten (10) Takedown Notices were received regarding content uploaded by him.</p> <p>Cross Platform Publication</p> <p>When you upload User Content you agree and acknowledge that we may display the content in any part of the Service we see fit, regardless of the part of the Service to which you uploaded your User Content (&quot;Cross Platform Publication&quot;). For example, we may choose to publish user content which you posted on the Website on the Facebook Application. You agree and acknowledge that you are not entitled to any notification of or compensation due to Cross Platform Publication of your User Content at any time. In addition we may choose to post information regarding your use of the Service on your Facebook profile wall, including your User Content, statuses, comments, vBets and content you have read. We will attempt to prompt for your approval to post information on your Facebook profile wall.</p> <p>Intellectual Property Rights</p> <p>Unless stated otherwise herein, we and our affiliates, subsidiaries, licensors and subcontractors reserve and retain any and all rights, claims, titles and interests in and to any and all intellectual property in the Service and the Service&#39;s content, including without limitation, in copyrighted works, trademarks, service marks, trade secrets, ideas, inventions, utility models, designs, patents, software and other intellectual property, all registered or not, contained in the Service. You do not acquire any right, title, interest or claim in any part of the Service or the Service&#39;s content as a result of your use of the Service or any part thereof. Any transfer of rights shall be deemed null and void without our explicit prior written consent.</p> <p>Third Party Sites</p> <p>During your use of the Service you will encounter pages which contain content stored on third party sites, embedded or framed into the Service (for example, news snippets and YouTube videos), as well as links to third party websites. We are not responsible for third party sites or content. These Terms of Use applies only to your use of the Service alone. We have no control over nor do we take any responsibility for third party websites&#39; content, policies and practices, including without limitation third party websites to which hyperlinks are contained in the Service. By using the Service you hereby agree that we shall not be responsible for any damage, claim or liability in connection with your use of any third party sites, including without limitation third party sites to which you have arrived via the Service.</p> <p>Disconnecting from the Service</p> <p>If you wish to disconnect from the Service, please email&nbsp;info@Iworis Family.com</p> <p>Disclaimers</p> <p>You hereby agree that the Service is given automatically by our systems and with no explicit knowledge of yours or anyone else&#39;s use of the Service. The Service is provided &#39;AS-IS&#39; and &#39;AS-AVAILABLE&#39;, and your use of the Service is at your own risk. We explicitly and expressly disclaim and you waive all warranties, guarantees and representations of any kind, whether express or implied, including without limitation warranties given in the course of dealing with us and are not stated herein and warranties regarding fitness for any particular purpose and promises of specific results, all to the fullest extent of the law. We explicitly and expressly disclaim and you waive all warranties, guarantees and representations regarding the Service, its content or any part thereof being available, uninterrupted, correct, error-free, accurate, complete, reliable, current, malware-free, continual and secure. Any reliance you make on the Service, its content or any part thereof is at your own risk. We explicitly and expressly disclaim and you waive all warranties, guarantees and representations regarding other users&#39; User Content including without limitation its accuracy, usefulness and safety. User Content does not represent us in any way and you access and use it at your own risk.</p> <p>Limitation on Warranties</p> <p>We do not warrant, endorse, guarantee or responsible for any third party, including advertisers, other users and service providers, to the fullest extent of the law, including without limitation for conduct or actions which are defamatory, offensive, illegal or infringing these terms of use in any way. Downloading materials from the Service shall be done at your own risk, and we shall not be responsible for any damage to your computer or loss of data as a result. YOU ACKNOWLEDGE AND AGREE THAT YOU SHALL BE SOLELY RESPONSIBLE FOR YOUR USE OF THE SERVICE. YOU ACKNOWLEDGE AND AGREE THAT THE SERVICE IS PROVIDED TO YOU AT NO CHARGE, AND AS SUCH AND REGARDLESS, WE, OUR AFFILIATES, SUPPLIERS, EMPLOYEES, OFFICERS, REPRESENTATIVES AND THIRD PARTY CONTENT PROVIDERS SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, EXEMPLARY, STATUTORY, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR OTHER DAMAGES, LOSS OR INJURIES SUFFERED BY YOU OR BY ANY THIRD PARTY, ARISING OUT OF OR IN ANY WAY RELATED TO THE SERVICE, ACTIONS, OMMISIONS, ERRORS, FAILURE TO PERFORM, INTERUPTION, DELETION, DEFECTS, DELAYS, MALWARE, FILE CORRUPTION, COMMUNICATION FAILURE, UNAUTHORIZED ACCESS, LOSS OF DATA, DENIAL OF SERVICE, CHANGES TO THE SERVICE, WHETHER BASED ON CONTRACT (INCLUDING THESE TERMS), TORT, STRICT LIABILITY OR OTHERWISE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF DAMAGE BEFOREHAND OR AFTERWARDS. Your sole and exclusive remedy for any of the above claims or any dispute with us is to discontinue your use of the Service, or, if such limitation of liability is deemed null or invalid by an appropriate jurisdiction, our liability to damages or losses caused to you or to any third party due to any of the aforementioned claims in connection with the Service, its content or any part thereof is limited to one hundred (100) USD. Notwithstanding the aforementioned any cause of action arising in relation to the Service must be commenced and brought before an authorized jurisdiction within one (1) year of its accrual or it is permanently barred.</p> <p>Indemnification</p> <p>You agree to indemnify, defend and hold harmless us, our officers, employees, directors, contractors, agent and service providers from against any losses, liabilities, expenses and damages, including reasonable attorney&#39;s fees resulting from your use of the service and any violation of these Terms of Use.</p> <p>Jurisdiction</p> <p>By using the Service you agree to apply and to govern the Spanin law and no other law over your relationship and disputes with us, and to give the Spanish district court of Madrid sole jurisdiction over any disputes between you and us.</p> <p>Abuse Report</p> <p>If you believe that anyone is abusing the Service or using the Service in contradictions or violation with the terms stated herein, you may report this via e-mail to:&nbsp;info@Iworis Family.com</p> <p>General</p> <p>We may assign our rights according to this Agreement to any third party at our sole discretion. You may not assign your rights according to this Agreement, without our prior written consent. If any part of these Terms of Use is deemed invalid for any reason, such invalidity will not affect the validity of the rest of these Terms. Any cause of action relating to the Service you might have is limited in time to one (1) year from the arising incident, and will be permanently barred afterwards. Failure to assert any right in regard to these Terms of Use on our behalf shall not constitute concession, yield or relinquishment of any sort. You consent to receive electronic communications from us, including promotional material, and agree that email communication to the email address associated with your Facebook account, notices posted on the Service or messages displayed when you enter the Service satisfy any legal requirement that such communication be in writing. If you have any question or comments regarding these Terms of Use or the Service, please contact us at:&nbsp;info@Iworis Family.com</p> </div> </div> <div class=form-group ng-class=\"{'has-error': false}\"> <input type=checkbox name=termOfUseCheck id=termOfUseCheck ng-model=user.termOfUse required server-error> <label class=control-label for=termOfUseCheck>I have readen and accept the terms of use.</label> <span class=help-block ng-show=\"showError(signupForm.password, 'required')\">{{ localizedMessages.get('required-field') }}</span> </div> <div class=form-group> <button type=button class=\"btn btn-primary btn-signup\" ng-disabled=\"!canSave(signupForm) || user.password != passwordConfirm\" ng-click=submit()>Create My Account</button> &nbsp;<a href=/login class=\"btn btn-link\">Already have an account?</a> </div> </form> </div> <div class=\"col-sm-6 marketing\"> <div class=page-header><h1>Iworis Family</h1></div> <p class=lead>A freedom's platform to read and write about any topic and connect with readers!</p> <i class=\"fa fa-thumbs-o-up super-awesome\"></i> </div> </div> ";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('unauthorized', ['ngRoute', 'config', 'security.service', 'directives.serverError', 'services.utility', 'ui.bootstrap']).config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('unauthorized', {
	    url: '/unauthorized',
	    views: {
	      header: {
	        template: __webpack_require__(146),
	        resolve: {
	          user: ["User", function (User) {
	            return User.current(function (user) {
	              return user;
	            }).$promise;
	          }]
	        },
	        controller: 'HeaderCtrl'
	      },
	      main: {
	        template: __webpack_require__(316),
	        title: 'Unauthorized'
	      },
	      footer: {
	        template: __webpack_require__(149),
	        controller: 'FooterCtrl'
	      }
	    }
	  });
	}]);

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = "<h1>Unauthorized access.</h1> <p class=lead> Please relogin as other user <a href=/login>here</a>. </p> ";

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*
	Copyright (c) 2003-2016, CKSource - Frederico Knabben. All rights reserved.
	For licensing, see LICENSE.md or http://ckeditor.com/license
	*/(function(){window.CKEDITOR&&window.CKEDITOR.dom||(window.CKEDITOR||(window.CKEDITOR=function(){var a=/(^|.*[\\\/])ckeditor\.js(?:\?.*|;.*)?$/i,e={timestamp:"G87D",version:"4.5.11 (Standard)",revision:"3876e73",rnd:Math.floor(900*Math.random())+100,_:{pending:[],basePathSrcPattern:a},status:"unloaded",basePath:function(){var b=window.CKEDITOR_BASEPATH||"";if(!b)for(var c=document.getElementsByTagName("script"),e=0;e<c.length;e++){var f=c[e].src.match(a);if(f){b=f[1];break;}}-1==b.indexOf(":/")&&"//"!=b.slice(0,2)&&(b=0===b.indexOf("/")?location.href.match(/^.*?:\/\/[^\/]*/)[0]+b:location.href.match(/^[^\?]*\/(?:)/)[0]+b);if(!b)throw'The CKEditor installation path could not be automatically detected. Please set the global variable "CKEDITOR_BASEPATH" before creating editor instances.';return b;}(),getUrl:function getUrl(a){-1==a.indexOf(":/")&&0!==a.indexOf("/")&&(a=this.basePath+a);this.timestamp&&"/"!=a.charAt(a.length-1)&&!/[&?]t=/.test(a)&&(a+=(0<=a.indexOf("?")?"\x26":"?")+"t\x3d"+this.timestamp);return a;},domReady:function(){function a(){try{document.addEventListener?(document.removeEventListener("DOMContentLoaded",a,!1),b()):document.attachEvent&&"complete"===document.readyState&&(document.detachEvent("onreadystatechange",a),b());}catch(f){}}function b(){for(var a;a=c.shift();){a();}}var c=[];return function(f){function b(){try{document.documentElement.doScroll("left");}catch(g){setTimeout(b,1);return;}a();}c.push(f);"complete"===document.readyState&&setTimeout(a,1);if(1==c.length)if(document.addEventListener)document.addEventListener("DOMContentLoaded",a,!1),window.addEventListener("load",a,!1);else if(document.attachEvent){document.attachEvent("onreadystatechange",a);window.attachEvent("onload",a);f=!1;try{f=!window.frameElement;}catch(k){}document.documentElement.doScroll&&f&&b();}};}()},b=window.CKEDITOR_GETURL;if(b){var c=e.getUrl;e.getUrl=function(a){return b.call(e,a)||c.call(e,a);};}return e;}()),CKEDITOR.event||(CKEDITOR.event=function(){},CKEDITOR.event.implementOn=function(a){var e=CKEDITOR.event.prototype,b;for(b in e){null==a[b]&&(a[b]=e[b]);}},CKEDITOR.event.prototype=function(){function a(a){var d=e(this);return d[a]||(d[a]=new b(a));}var e=function e(a){a=a.getPrivate&&a.getPrivate()||a._||(a._={});return a.events||(a.events={});},b=function b(a){this.name=a;this.listeners=[];};b.prototype={getListenerIndex:function getListenerIndex(a){for(var b=0,e=this.listeners;b<e.length;b++){if(e[b].fn==a)return b;}return-1;}};return{define:function define(b,d){var e=a.call(this,b);CKEDITOR.tools.extend(e,d,!0);},on:function on(b,d,e,m,f){function h(a,g,f,h){a={name:b,sender:this,editor:a,data:g,listenerData:m,stop:f,cancel:h,removeListener:k};return!1===d.call(e,a)?!1:a.data;}function k(){n.removeListener(b,d);}var g=a.call(this,b);if(0>g.getListenerIndex(d)){g=g.listeners;e||(e=this);isNaN(f)&&(f=10);var n=this;h.fn=d;h.priority=f;for(var v=g.length-1;0<=v;v--){if(g[v].priority<=f)return g.splice(v+1,0,h),{removeListener:k};}g.unshift(h);}return{removeListener:k};},once:function once(){var a=Array.prototype.slice.call(arguments),b=a[1];a[1]=function(a){a.removeListener();return b.apply(this,arguments);};return this.on.apply(this,a);},capture:function capture(){CKEDITOR.event.useCapture=1;var a=this.on.apply(this,arguments);CKEDITOR.event.useCapture=0;return a;},fire:function(){var a=0,b=function b(){a=1;},l=0,m=function m(){l=1;};return function(f,h,k){var g=e(this)[f];f=a;var n=l;a=l=0;if(g){var v=g.listeners;if(v.length)for(var v=v.slice(0),r,q=0;q<v.length;q++){if(g.errorProof)try{r=v[q].call(this,k,h,b,m);}catch(t){}else r=v[q].call(this,k,h,b,m);!1===r?l=1:"undefined"!=typeof r&&(h=r);if(a||l)break;}}h=l?!1:"undefined"==typeof h?!0:h;a=f;l=n;return h;};}(),fireOnce:function fireOnce(a,b,l){b=this.fire(a,b,l);delete e(this)[a];return b;},removeListener:function removeListener(a,b){var l=e(this)[a];if(l){var m=l.getListenerIndex(b);0<=m&&l.listeners.splice(m,1);}},removeAllListeners:function removeAllListeners(){var a=e(this),b;for(b in a){delete a[b];}},hasListeners:function hasListeners(a){return(a=e(this)[a])&&0<a.listeners.length;}};}()),CKEDITOR.editor||(CKEDITOR.editor=function(){CKEDITOR._.pending.push([this,arguments]);CKEDITOR.event.call(this);},CKEDITOR.editor.prototype.fire=function(a,e){a in{instanceReady:1,loaded:1}&&(this[a]=!0);return CKEDITOR.event.prototype.fire.call(this,a,e,this);},CKEDITOR.editor.prototype.fireOnce=function(a,e){a in{instanceReady:1,loaded:1}&&(this[a]=!0);return CKEDITOR.event.prototype.fireOnce.call(this,a,e,this);},CKEDITOR.event.implementOn(CKEDITOR.editor.prototype)),CKEDITOR.env||(CKEDITOR.env=function(){var a=navigator.userAgent.toLowerCase(),e=a.match(/edge[ \/](\d+.?\d*)/),b=-1<a.indexOf("trident/"),b=!(!e&&!b),b={ie:b,edge:!!e,webkit:!b&&-1<a.indexOf(" applewebkit/"),air:-1<a.indexOf(" adobeair/"),mac:-1<a.indexOf("macintosh"),quirks:"BackCompat"==document.compatMode&&(!document.documentMode||10>document.documentMode),mobile:-1<a.indexOf("mobile"),iOS:/(ipad|iphone|ipod)/.test(a),isCustomDomain:function isCustomDomain(){if(!this.ie)return!1;var a=document.domain,b=window.location.hostname;return a!=b&&a!="["+b+"]";},secure:"https:"==location.protocol};b.gecko="Gecko"==navigator.product&&!b.webkit&&!b.ie;b.webkit&&(-1<a.indexOf("chrome")?b.chrome=!0:b.safari=!0);var c=0;b.ie&&(c=e?parseFloat(e[1]):b.quirks||!document.documentMode?parseFloat(a.match(/msie (\d+)/)[1]):document.documentMode,b.ie9Compat=9==c,b.ie8Compat=8==c,b.ie7Compat=7==c,b.ie6Compat=7>c||b.quirks);b.gecko&&(e=a.match(/rv:([\d\.]+)/))&&(e=e[1].split("."),c=1E4*e[0]+100*(e[1]||0)+1*(e[2]||0));b.air&&(c=parseFloat(a.match(/ adobeair\/(\d+)/)[1]));b.webkit&&(c=parseFloat(a.match(/ applewebkit\/(\d+)/)[1]));b.version=c;b.isCompatible=!(b.ie&&7>c)&&!(b.gecko&&4E4>c)&&!(b.webkit&&534>c);b.hidpi=2<=window.devicePixelRatio;b.needsBrFiller=b.gecko||b.webkit||b.ie&&10<c;b.needsNbspFiller=b.ie&&11>c;b.cssClass="cke_browser_"+(b.ie?"ie":b.gecko?"gecko":b.webkit?"webkit":"unknown");b.quirks&&(b.cssClass+=" cke_browser_quirks");b.ie&&(b.cssClass+=" cke_browser_ie"+(b.quirks?"6 cke_browser_iequirks":b.version));b.air&&(b.cssClass+=" cke_browser_air");b.iOS&&(b.cssClass+=" cke_browser_ios");b.hidpi&&(b.cssClass+=" cke_hidpi");return b;}()),"unloaded"==CKEDITOR.status&&function(){CKEDITOR.event.implementOn(CKEDITOR);CKEDITOR.loadFullCore=function(){if("basic_ready"!=CKEDITOR.status)CKEDITOR.loadFullCore._load=1;else{delete CKEDITOR.loadFullCore;var a=document.createElement("script");a.type="text/javascript";a.src=CKEDITOR.basePath+"ckeditor.js";document.getElementsByTagName("head")[0].appendChild(a);}};CKEDITOR.loadFullCoreTimeout=0;CKEDITOR.add=function(a){(this._.pending||(this._.pending=[])).push(a);};(function(){CKEDITOR.domReady(function(){var a=CKEDITOR.loadFullCore,e=CKEDITOR.loadFullCoreTimeout;a&&(CKEDITOR.status="basic_ready",a&&a._load?a():e&&setTimeout(function(){CKEDITOR.loadFullCore&&CKEDITOR.loadFullCore();},1E3*e));});})();CKEDITOR.status="basic_loaded";}(),"use strict",CKEDITOR.VERBOSITY_WARN=1,CKEDITOR.VERBOSITY_ERROR=2,CKEDITOR.verbosity=CKEDITOR.VERBOSITY_WARN|CKEDITOR.VERBOSITY_ERROR,CKEDITOR.warn=function(a,e){CKEDITOR.verbosity&CKEDITOR.VERBOSITY_WARN&&CKEDITOR.fire("log",{type:"warn",errorCode:a,additionalData:e});},CKEDITOR.error=function(a,e){CKEDITOR.verbosity&CKEDITOR.VERBOSITY_ERROR&&CKEDITOR.fire("log",{type:"error",errorCode:a,additionalData:e});},CKEDITOR.on("log",function(a){if(window.console&&window.console.log){var e=console[a.data.type]?a.data.type:"log",b=a.data.errorCode;if(a=a.data.additionalData)console[e]("[CKEDITOR] Error code: "+b+".",a);else console[e]("[CKEDITOR] Error code: "+b+".");console[e]("[CKEDITOR] For more information about this error go to http://docs.ckeditor.com/#!/guide/dev_errors-section-"+b);}},null,null,999),CKEDITOR.dom={},function(){var a=[],e=CKEDITOR.env.gecko?"-moz-":CKEDITOR.env.webkit?"-webkit-":CKEDITOR.env.ie?"-ms-":"",b=/&/g,c=/>/g,d=/</g,l=/"/g,m=/&(lt|gt|amp|quot|nbsp|shy|#\d{1,5});/g,f={lt:"\x3c",gt:"\x3e",amp:"\x26",quot:'"',nbsp:" ",shy:"­"},h=function h(a,g){return"#"==g[0]?String.fromCharCode(parseInt(g.slice(1),10)):f[g];};CKEDITOR.on("reset",function(){a=[];});CKEDITOR.tools={arrayCompare:function arrayCompare(a,g){if(!a&&!g)return!0;if(!a||!g||a.length!=g.length)return!1;for(var f=0;f<a.length;f++){if(a[f]!=g[f])return!1;}return!0;},getIndex:function getIndex(a,g){for(var f=0;f<a.length;++f){if(g(a[f]))return f;}return-1;},clone:function clone(a){var g;if(a&&a instanceof Array){g=[];for(var f=0;f<a.length;f++){g[f]=CKEDITOR.tools.clone(a[f]);}return g;}if(null===a||"object"!=(typeof a==="undefined"?"undefined":_typeof(a))||a instanceof String||a instanceof Number||a instanceof Boolean||a instanceof Date||a instanceof RegExp||a.nodeType||a.window===a)return a;g=new a.constructor();for(f in a){g[f]=CKEDITOR.tools.clone(a[f]);}return g;},capitalize:function capitalize(a,g){return a.charAt(0).toUpperCase()+(g?a.slice(1):a.slice(1).toLowerCase());},extend:function extend(a){var g=arguments.length,f,b;"boolean"==typeof(f=arguments[g-1])?g--:"boolean"==typeof(f=arguments[g-2])&&(b=arguments[g-1],g-=2);for(var h=1;h<g;h++){var c=arguments[h],d;for(d in c){if(!0===f||null==a[d])if(!b||d in b)a[d]=c[d];}}return a;},prototypedCopy:function prototypedCopy(a){var g=function g(){};g.prototype=a;return new g();},copy:function copy(a){var g={},f;for(f in a){g[f]=a[f];}return g;},isArray:function isArray(a){return"[object Array]"==Object.prototype.toString.call(a);},isEmpty:function isEmpty(a){for(var g in a){if(a.hasOwnProperty(g))return!1;}return!0;},cssVendorPrefix:function cssVendorPrefix(a,g,f){if(f)return e+a+":"+g+";"+a+":"+g;f={};f[a]=g;f[e+a]=g;return f;},cssStyleToDomStyle:function(){var a=document.createElement("div").style,g="undefined"!=typeof a.cssFloat?"cssFloat":"undefined"!=typeof a.styleFloat?"styleFloat":"float";return function(a){return"float"==a?g:a.replace(/-./g,function(a){return a.substr(1).toUpperCase();});};}(),buildStyleHtml:function buildStyleHtml(a){a=[].concat(a);for(var g,f=[],b=0;b<a.length;b++){if(g=a[b])/@import|[{}]/.test(g)?f.push("\x3cstyle\x3e"+g+"\x3c/style\x3e"):f.push('\x3clink type\x3d"text/css" rel\x3dstylesheet href\x3d"'+g+'"\x3e');}return f.join("");},htmlEncode:function htmlEncode(a){return void 0===a||null===a?"":String(a).replace(b,"\x26amp;").replace(c,"\x26gt;").replace(d,"\x26lt;");},htmlDecode:function htmlDecode(a){return a.replace(m,h);},htmlEncodeAttr:function htmlEncodeAttr(a){return CKEDITOR.tools.htmlEncode(a).replace(l,"\x26quot;");},htmlDecodeAttr:function htmlDecodeAttr(a){return CKEDITOR.tools.htmlDecode(a);},transformPlainTextToHtml:function transformPlainTextToHtml(a,g){var f=g==CKEDITOR.ENTER_BR,b=this.htmlEncode(a.replace(/\r\n/g,"\n")),b=b.replace(/\t/g,"\x26nbsp;\x26nbsp; \x26nbsp;"),h=g==CKEDITOR.ENTER_P?"p":"div";if(!f){var c=/\n{2}/g;if(c.test(b))var d="\x3c"+h+"\x3e",e="\x3c/"+h+"\x3e",b=d+b.replace(c,function(){return e+d;})+e;}b=b.replace(/\n/g,"\x3cbr\x3e");f||(b=b.replace(new RegExp("\x3cbr\x3e(?\x3d\x3c/"+h+"\x3e)"),function(a){return CKEDITOR.tools.repeat(a,2);}));b=b.replace(/^ | $/g,"\x26nbsp;");return b=b.replace(/(>|\s) /g,function(a,g){return g+"\x26nbsp;";}).replace(/ (?=<)/g,"\x26nbsp;");},getNextNumber:function(){var a=0;return function(){return++a;};}(),getNextId:function getNextId(){return"cke_"+this.getNextNumber();},getUniqueId:function getUniqueId(){for(var a="e",g=0;8>g;g++){a+=Math.floor(65536*(1+Math.random())).toString(16).substring(1);}return a;},override:function override(a,g){var f=g(a);f.prototype=a.prototype;return f;},setTimeout:function setTimeout(a,g,f,b,h){h||(h=window);f||(f=h);return h.setTimeout(function(){b?a.apply(f,[].concat(b)):a.apply(f);},g||0);},trim:function(){var a=/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g;return function(g){return g.replace(a,"");};}(),ltrim:function(){var a=/^[ \t\n\r]+/g;return function(g){return g.replace(a,"");};}(),rtrim:function(){var a=/[ \t\n\r]+$/g;return function(g){return g.replace(a,"");};}(),indexOf:function indexOf(a,g){if("function"==typeof g)for(var f=0,b=a.length;f<b;f++){if(g(a[f]))return f;}else{if(a.indexOf)return a.indexOf(g);f=0;for(b=a.length;f<b;f++){if(a[f]===g)return f;}}return-1;},search:function search(a,g){var f=CKEDITOR.tools.indexOf(a,g);return 0<=f?a[f]:null;},bind:function bind(a,g){return function(){return a.apply(g,arguments);};},createClass:function createClass(a){var g=a.$,f=a.base,b=a.privates||a._,h=a.proto;a=a.statics;!g&&(g=function g(){f&&this.base.apply(this,arguments);});if(b)var c=g,g=function g(){var a=this._||(this._={}),g;for(g in b){var f=b[g];a[g]="function"==typeof f?CKEDITOR.tools.bind(f,this):f;}c.apply(this,arguments);};f&&(g.prototype=this.prototypedCopy(f.prototype),g.prototype.constructor=g,g.base=f,g.baseProto=f.prototype,g.prototype.base=function(){this.base=f.prototype.base;f.apply(this,arguments);this.base=arguments.callee;});h&&this.extend(g.prototype,h,!0);a&&this.extend(g,a,!0);return g;},addFunction:function addFunction(f,g){return a.push(function(){return f.apply(g||this,arguments);})-1;},removeFunction:function removeFunction(f){a[f]=null;},callFunction:function callFunction(f){var g=a[f];return g&&g.apply(window,Array.prototype.slice.call(arguments,1));},cssLength:function(){var a=/^-?\d+\.?\d*px$/,g;return function(f){g=CKEDITOR.tools.trim(f+"")+"px";return a.test(g)?g:f||"";};}(),convertToPx:function(){var a;return function(g){a||(a=CKEDITOR.dom.element.createFromHtml('\x3cdiv style\x3d"position:absolute;left:-9999px;top:-9999px;margin:0px;padding:0px;border:0px;"\x3e\x3c/div\x3e',CKEDITOR.document),CKEDITOR.document.getBody().append(a));return /%$/.test(g)?g:(a.setStyle("width",g),a.$.clientWidth);};}(),repeat:function repeat(a,g){return Array(g+1).join(a);},tryThese:function tryThese(){for(var a,g=0,f=arguments.length;g<f;g++){var b=arguments[g];try{a=b();break;}catch(h){}}return a;},genKey:function genKey(){return Array.prototype.slice.call(arguments).join("-");},defer:function defer(a){return function(){var g=arguments,f=this;window.setTimeout(function(){a.apply(f,g);},0);};},normalizeCssText:function normalizeCssText(a,g){var f=[],b,h=CKEDITOR.tools.parseCssText(a,!0,g);for(b in h){f.push(b+":"+h[b]);}f.sort();return f.length?f.join(";")+";":"";},convertRgbToHex:function convertRgbToHex(a){return a.replace(/(?:rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\))/gi,function(a,f,b,h){a=[f,b,h];for(f=0;3>f;f++){a[f]=("0"+parseInt(a[f],10).toString(16)).slice(-2);}return"#"+a.join("");});},normalizeHex:function normalizeHex(a){return a.replace(/#(([0-9a-f]{3}){1,2})($|;|\s+)/gi,function(a,f,b,h){a=f.toLowerCase();3==a.length&&(a=a.split(""),a=[a[0],a[0],a[1],a[1],a[2],a[2]].join(""));return"#"+a+h;});},parseCssText:function parseCssText(a,g,f){var b={};f&&(a=new CKEDITOR.dom.element("span").setAttribute("style",a).getAttribute("style")||"");a&&(a=CKEDITOR.tools.normalizeHex(CKEDITOR.tools.convertRgbToHex(a)));if(!a||";"==a)return b;a.replace(/&quot;/g,'"').replace(/\s*([^:;\s]+)\s*:\s*([^;]+)\s*(?=;|$)/g,function(a,f,h){g&&(f=f.toLowerCase(),"font-family"==f&&(h=h.replace(/\s*,\s*/g,",")),h=CKEDITOR.tools.trim(h));b[f]=h;});return b;},writeCssText:function writeCssText(a,g){var f,b=[];for(f in a){b.push(f+":"+a[f]);}g&&b.sort();return b.join("; ");},objectCompare:function objectCompare(a,g,f){var b;if(!a&&!g)return!0;if(!a||!g)return!1;for(b in a){if(a[b]!=g[b])return!1;}if(!f)for(b in g){if(a[b]!=g[b])return!1;}return!0;},objectKeys:function objectKeys(a){var g=[],f;for(f in a){g.push(f);}return g;},convertArrayToObject:function convertArrayToObject(a,g){var f={};1==arguments.length&&(g=!0);for(var b=0,h=a.length;b<h;++b){f[a[b]]=g;}return f;},fixDomain:function fixDomain(){for(var a;;){try{a=window.parent.document.domain;break;}catch(g){a=a?a.replace(/.+?(?:\.|$)/,""):document.domain;if(!a)break;document.domain=a;}}return!!a;},eventsBuffer:function eventsBuffer(a,g,f){function b(){c=new Date().getTime();h=!1;f?g.call(f):g();}var h,c=0;return{input:function input(){if(!h){var g=new Date().getTime()-c;g<a?h=setTimeout(b,a-g):b();}},reset:function reset(){h&&clearTimeout(h);h=c=0;}};},enableHtml5Elements:function enableHtml5Elements(a,g){for(var f="abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup main mark meter nav output progress section summary time video".split(" "),b=f.length,h;b--;){h=a.createElement(f[b]),g&&a.appendChild(h);}},checkIfAnyArrayItemMatches:function checkIfAnyArrayItemMatches(a,g){for(var f=0,b=a.length;f<b;++f){if(a[f].match(g))return!0;}return!1;},checkIfAnyObjectPropertyMatches:function checkIfAnyObjectPropertyMatches(a,g){for(var f in a){if(f.match(g))return!0;}return!1;},transparentImageData:"data:image/gif;base64,R0lGODlhAQABAPABAP///wAAACH5BAEKAAAALAAAAAABAAEAAAICRAEAOw\x3d\x3d",getCookie:function getCookie(a){a=a.toLowerCase();for(var g=document.cookie.split(";"),f,b,h=0;h<g.length;h++){if(f=g[h].split("\x3d"),b=decodeURIComponent(CKEDITOR.tools.trim(f[0]).toLowerCase()),b===a)return decodeURIComponent(1<f.length?f[1]:"");}return null;},setCookie:function setCookie(a,g){document.cookie=encodeURIComponent(a)+"\x3d"+encodeURIComponent(g)+";path\x3d/";},getCsrfToken:function getCsrfToken(){var a=CKEDITOR.tools.getCookie("ckCsrfToken");if(!a||40!=a.length){var a=[],g="";if(window.crypto&&window.crypto.getRandomValues)a=new Uint8Array(40),window.crypto.getRandomValues(a);else for(var f=0;40>f;f++){a.push(Math.floor(256*Math.random()));}for(f=0;f<a.length;f++){var b="abcdefghijklmnopqrstuvwxyz0123456789".charAt(a[f]%36),g=g+(.5<Math.random()?b.toUpperCase():b);}a=g;CKEDITOR.tools.setCookie("ckCsrfToken",a);}return a;},escapeCss:function escapeCss(a){return a?window.CSS&&CSS.escape?CSS.escape(a):isNaN(parseInt(a.charAt(0),10))?a:"\\3"+a.charAt(0)+" "+a.substring(1,a.length):"";}};}(),CKEDITOR.dtd=function(){var a=CKEDITOR.tools.extend,e=function e(a,g){for(var f=CKEDITOR.tools.clone(a),b=1;b<arguments.length;b++){g=arguments[b];for(var h in g){delete f[h];}}return f;},b={},c={},d={address:1,article:1,aside:1,blockquote:1,details:1,div:1,dl:1,fieldset:1,figure:1,footer:1,form:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,header:1,hgroup:1,hr:1,main:1,menu:1,nav:1,ol:1,p:1,pre:1,section:1,table:1,ul:1},l={command:1,link:1,meta:1,noscript:1,script:1,style:1},m={},f={"#":1},h={center:1,dir:1,noframes:1};a(b,{a:1,abbr:1,area:1,audio:1,b:1,bdi:1,bdo:1,br:1,button:1,canvas:1,cite:1,code:1,command:1,datalist:1,del:1,dfn:1,em:1,embed:1,i:1,iframe:1,img:1,input:1,ins:1,kbd:1,keygen:1,label:1,map:1,mark:1,meter:1,noscript:1,object:1,output:1,progress:1,q:1,ruby:1,s:1,samp:1,script:1,select:1,small:1,span:1,strong:1,sub:1,sup:1,textarea:1,time:1,u:1,"var":1,video:1,wbr:1},f,{acronym:1,applet:1,basefont:1,big:1,font:1,isindex:1,strike:1,style:1,tt:1});a(c,d,b,h);e={a:e(b,{a:1,button:1}),abbr:b,address:c,area:m,article:c,aside:c,audio:a({source:1,track:1},c),b:b,base:m,bdi:b,bdo:b,blockquote:c,body:c,br:m,button:e(b,{a:1,button:1}),canvas:b,caption:c,cite:b,code:b,col:m,colgroup:{col:1},command:m,datalist:a({option:1},b),dd:c,del:b,details:a({summary:1},c),dfn:b,div:c,dl:{dt:1,dd:1},dt:c,em:b,embed:m,fieldset:a({legend:1},c),figcaption:c,figure:a({figcaption:1},c),footer:c,form:c,h1:b,h2:b,h3:b,h4:b,h5:b,h6:b,head:a({title:1,base:1},l),header:c,hgroup:{h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},hr:m,html:a({head:1,body:1},c,l),i:b,iframe:f,img:m,input:m,ins:b,kbd:b,keygen:m,label:b,legend:b,li:c,link:m,main:c,map:c,mark:b,menu:a({li:1},c),meta:m,meter:e(b,{meter:1}),nav:c,noscript:a({link:1,meta:1,style:1},b),object:a({param:1},b),ol:{li:1},optgroup:{option:1},option:f,output:b,p:b,param:m,pre:b,progress:e(b,{progress:1}),q:b,rp:b,rt:b,ruby:a({rp:1,rt:1},b),s:b,samp:b,script:f,section:c,select:{optgroup:1,option:1},small:b,source:m,span:b,strong:b,style:f,sub:b,summary:a({h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},b),sup:b,table:{caption:1,colgroup:1,thead:1,tfoot:1,tbody:1,tr:1},tbody:{tr:1},td:c,textarea:f,tfoot:{tr:1},th:c,thead:{tr:1},time:e(b,{time:1}),title:f,tr:{th:1,td:1},track:m,u:b,ul:{li:1},"var":b,video:a({source:1,track:1},c),wbr:m,acronym:b,applet:a({param:1},c),basefont:m,big:b,center:c,dialog:m,dir:{li:1},font:b,isindex:m,noframes:c,strike:b,tt:b};a(e,{$block:a({audio:1,dd:1,dt:1,figcaption:1,li:1,video:1},d,h),$blockLimit:{article:1,aside:1,audio:1,body:1,caption:1,details:1,dir:1,div:1,dl:1,fieldset:1,figcaption:1,figure:1,footer:1,form:1,header:1,hgroup:1,main:1,menu:1,nav:1,ol:1,section:1,table:1,td:1,th:1,tr:1,ul:1,video:1},$cdata:{script:1,style:1},$editable:{address:1,article:1,aside:1,blockquote:1,body:1,details:1,div:1,fieldset:1,figcaption:1,footer:1,form:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,header:1,hgroup:1,main:1,nav:1,p:1,pre:1,section:1},$empty:{area:1,base:1,basefont:1,br:1,col:1,command:1,dialog:1,embed:1,hr:1,img:1,input:1,isindex:1,keygen:1,link:1,meta:1,param:1,source:1,track:1,wbr:1},$inline:b,$list:{dl:1,ol:1,ul:1},$listItem:{dd:1,dt:1,li:1},$nonBodyContent:a({body:1,head:1,html:1},e.head),$nonEditable:{applet:1,audio:1,button:1,embed:1,iframe:1,map:1,object:1,option:1,param:1,script:1,textarea:1,video:1},$object:{applet:1,audio:1,button:1,hr:1,iframe:1,img:1,input:1,object:1,select:1,table:1,textarea:1,video:1},$removeEmpty:{abbr:1,acronym:1,b:1,bdi:1,bdo:1,big:1,cite:1,code:1,del:1,dfn:1,em:1,font:1,i:1,ins:1,label:1,kbd:1,mark:1,meter:1,output:1,q:1,ruby:1,s:1,samp:1,small:1,span:1,strike:1,strong:1,sub:1,sup:1,time:1,tt:1,u:1,"var":1},$tabIndex:{a:1,area:1,button:1,input:1,object:1,select:1,textarea:1},$tableContent:{caption:1,col:1,colgroup:1,tbody:1,td:1,tfoot:1,th:1,thead:1,tr:1},$transparent:{a:1,audio:1,canvas:1,del:1,ins:1,map:1,noscript:1,object:1,video:1},$intermediate:{caption:1,colgroup:1,dd:1,dt:1,figcaption:1,legend:1,li:1,optgroup:1,option:1,rp:1,rt:1,summary:1,tbody:1,td:1,tfoot:1,th:1,thead:1,tr:1}});return e;}(),CKEDITOR.dom.event=function(a){this.$=a;},CKEDITOR.dom.event.prototype={getKey:function getKey(){return this.$.keyCode||this.$.which;},getKeystroke:function getKeystroke(){var a=this.getKey();if(this.$.ctrlKey||this.$.metaKey)a+=CKEDITOR.CTRL;this.$.shiftKey&&(a+=CKEDITOR.SHIFT);this.$.altKey&&(a+=CKEDITOR.ALT);return a;},preventDefault:function preventDefault(a){var e=this.$;e.preventDefault?e.preventDefault():e.returnValue=!1;a&&this.stopPropagation();},stopPropagation:function stopPropagation(){var a=this.$;a.stopPropagation?a.stopPropagation():a.cancelBubble=!0;},getTarget:function getTarget(){var a=this.$.target||this.$.srcElement;return a?new CKEDITOR.dom.node(a):null;},getPhase:function getPhase(){return this.$.eventPhase||2;},getPageOffset:function getPageOffset(){var a=this.getTarget().getDocument().$;return{x:this.$.pageX||this.$.clientX+(a.documentElement.scrollLeft||a.body.scrollLeft),y:this.$.pageY||this.$.clientY+(a.documentElement.scrollTop||a.body.scrollTop)};}},CKEDITOR.CTRL=1114112,CKEDITOR.SHIFT=2228224,CKEDITOR.ALT=4456448,CKEDITOR.EVENT_PHASE_CAPTURING=1,CKEDITOR.EVENT_PHASE_AT_TARGET=2,CKEDITOR.EVENT_PHASE_BUBBLING=3,CKEDITOR.dom.domObject=function(a){a&&(this.$=a);},CKEDITOR.dom.domObject.prototype=function(){var a=function a(_a,b){return function(c){"undefined"!=typeof CKEDITOR&&_a.fire(b,new CKEDITOR.dom.event(c));};};return{getPrivate:function getPrivate(){var a;(a=this.getCustomData("_"))||this.setCustomData("_",a={});return a;},on:function on(e){var b=this.getCustomData("_cke_nativeListeners");b||(b={},this.setCustomData("_cke_nativeListeners",b));b[e]||(b=b[e]=a(this,e),this.$.addEventListener?this.$.addEventListener(e,b,!!CKEDITOR.event.useCapture):this.$.attachEvent&&this.$.attachEvent("on"+e,b));return CKEDITOR.event.prototype.on.apply(this,arguments);},removeListener:function removeListener(a){CKEDITOR.event.prototype.removeListener.apply(this,arguments);if(!this.hasListeners(a)){var b=this.getCustomData("_cke_nativeListeners"),c=b&&b[a];c&&(this.$.removeEventListener?this.$.removeEventListener(a,c,!1):this.$.detachEvent&&this.$.detachEvent("on"+a,c),delete b[a]);}},removeAllListeners:function removeAllListeners(){var a=this.getCustomData("_cke_nativeListeners"),b;for(b in a){var c=a[b];this.$.detachEvent?this.$.detachEvent("on"+b,c):this.$.removeEventListener&&this.$.removeEventListener(b,c,!1);delete a[b];}CKEDITOR.event.prototype.removeAllListeners.call(this);}};}(),function(a){var e={};CKEDITOR.on("reset",function(){e={};});a.equals=function(a){try{return a&&a.$===this.$;}catch(c){return!1;}};a.setCustomData=function(a,c){var d=this.getUniqueId();(e[d]||(e[d]={}))[a]=c;return this;};a.getCustomData=function(a){var c=this.$["data-cke-expando"];return(c=c&&e[c])&&a in c?c[a]:null;};a.removeCustomData=function(a){var c=this.$["data-cke-expando"],c=c&&e[c],d,l;c&&(d=c[a],l=a in c,delete c[a]);return l?d:null;};a.clearCustomData=function(){this.removeAllListeners();var a=this.$["data-cke-expando"];a&&delete e[a];};a.getUniqueId=function(){return this.$["data-cke-expando"]||(this.$["data-cke-expando"]=CKEDITOR.tools.getNextNumber());};CKEDITOR.event.implementOn(a);}(CKEDITOR.dom.domObject.prototype),CKEDITOR.dom.node=function(a){return a?new CKEDITOR.dom[a.nodeType==CKEDITOR.NODE_DOCUMENT?"document":a.nodeType==CKEDITOR.NODE_ELEMENT?"element":a.nodeType==CKEDITOR.NODE_TEXT?"text":a.nodeType==CKEDITOR.NODE_COMMENT?"comment":a.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT?"documentFragment":"domObject"](a):this;},CKEDITOR.dom.node.prototype=new CKEDITOR.dom.domObject(),CKEDITOR.NODE_ELEMENT=1,CKEDITOR.NODE_DOCUMENT=9,CKEDITOR.NODE_TEXT=3,CKEDITOR.NODE_COMMENT=8,CKEDITOR.NODE_DOCUMENT_FRAGMENT=11,CKEDITOR.POSITION_IDENTICAL=0,CKEDITOR.POSITION_DISCONNECTED=1,CKEDITOR.POSITION_FOLLOWING=2,CKEDITOR.POSITION_PRECEDING=4,CKEDITOR.POSITION_IS_CONTAINED=8,CKEDITOR.POSITION_CONTAINS=16,CKEDITOR.tools.extend(CKEDITOR.dom.node.prototype,{appendTo:function appendTo(a,e){a.append(this,e);return a;},clone:function clone(a,e){function b(c){c["data-cke-expando"]&&(c["data-cke-expando"]=!1);if(c.nodeType==CKEDITOR.NODE_ELEMENT||c.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT)if(e||c.nodeType!=CKEDITOR.NODE_ELEMENT||c.removeAttribute("id",!1),a){c=c.childNodes;for(var d=0;d<c.length;d++){b(c[d]);}}}function c(b){if(b.type==CKEDITOR.NODE_ELEMENT||b.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT){if(b.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var d=b.getName();":"==d[0]&&b.renameNode(d.substring(1));}if(a)for(d=0;d<b.getChildCount();d++){c(b.getChild(d));}}}var d=this.$.cloneNode(a);b(d);d=new CKEDITOR.dom.node(d);CKEDITOR.env.ie&&9>CKEDITOR.env.version&&(this.type==CKEDITOR.NODE_ELEMENT||this.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT)&&c(d);return d;},hasPrevious:function hasPrevious(){return!!this.$.previousSibling;},hasNext:function hasNext(){return!!this.$.nextSibling;},insertAfter:function insertAfter(a){a.$.parentNode.insertBefore(this.$,a.$.nextSibling);return a;},insertBefore:function insertBefore(a){a.$.parentNode.insertBefore(this.$,a.$);return a;},insertBeforeMe:function insertBeforeMe(a){this.$.parentNode.insertBefore(a.$,this.$);return a;},getAddress:function getAddress(a){for(var e=[],b=this.getDocument().$.documentElement,c=this.$;c&&c!=b;){var d=c.parentNode;d&&e.unshift(this.getIndex.call({$:c},a));c=d;}return e;},getDocument:function getDocument(){return new CKEDITOR.dom.document(this.$.ownerDocument||this.$.parentNode.ownerDocument);},getIndex:function getIndex(a){function e(a,f){var h=f?a.nextSibling:a.previousSibling;return h&&h.nodeType==CKEDITOR.NODE_TEXT?b(h)?e(h,f):h:null;}function b(a){return!a.nodeValue||a.nodeValue==CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE;}var c=this.$,d=-1,l;if(!this.$.parentNode||a&&c.nodeType==CKEDITOR.NODE_TEXT&&b(c)&&!e(c)&&!e(c,!0))return-1;do{a&&c!=this.$&&c.nodeType==CKEDITOR.NODE_TEXT&&(l||b(c))||(d++,l=c.nodeType==CKEDITOR.NODE_TEXT);}while(c=c.previousSibling);return d;},getNextSourceNode:function getNextSourceNode(a,e,b){if(b&&!b.call){var c=b;b=function b(a){return!a.equals(c);};}a=!a&&this.getFirst&&this.getFirst();var d;if(!a){if(this.type==CKEDITOR.NODE_ELEMENT&&b&&!1===b(this,!0))return null;a=this.getNext();}for(;!a&&(d=(d||this).getParent());){if(b&&!1===b(d,!0))return null;a=d.getNext();}return!a||b&&!1===b(a)?null:e&&e!=a.type?a.getNextSourceNode(!1,e,b):a;},getPreviousSourceNode:function getPreviousSourceNode(a,e,b){if(b&&!b.call){var c=b;b=function b(a){return!a.equals(c);};}a=!a&&this.getLast&&this.getLast();var d;if(!a){if(this.type==CKEDITOR.NODE_ELEMENT&&b&&!1===b(this,!0))return null;a=this.getPrevious();}for(;!a&&(d=(d||this).getParent());){if(b&&!1===b(d,!0))return null;a=d.getPrevious();}return!a||b&&!1===b(a)?null:e&&a.type!=e?a.getPreviousSourceNode(!1,e,b):a;},getPrevious:function getPrevious(a){var e=this.$,b;do{b=(e=e.previousSibling)&&10!=e.nodeType&&new CKEDITOR.dom.node(e);}while(b&&a&&!a(b));return b;},getNext:function getNext(a){var e=this.$,b;do{b=(e=e.nextSibling)&&new CKEDITOR.dom.node(e);}while(b&&a&&!a(b));return b;},getParent:function getParent(a){var e=this.$.parentNode;return e&&(e.nodeType==CKEDITOR.NODE_ELEMENT||a&&e.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT)?new CKEDITOR.dom.node(e):null;},getParents:function getParents(a){var e=this,b=[];do{b[a?"push":"unshift"](e);}while(e=e.getParent());return b;},getCommonAncestor:function getCommonAncestor(a){if(a.equals(this))return this;if(a.contains&&a.contains(this))return a;var e=this.contains?this:this.getParent();do{if(e.contains(a))return e;}while(e=e.getParent());return null;},getPosition:function getPosition(a){var e=this.$,b=a.$;if(e.compareDocumentPosition)return e.compareDocumentPosition(b);if(e==b)return CKEDITOR.POSITION_IDENTICAL;if(this.type==CKEDITOR.NODE_ELEMENT&&a.type==CKEDITOR.NODE_ELEMENT){if(e.contains){if(e.contains(b))return CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_PRECEDING;if(b.contains(e))return CKEDITOR.POSITION_IS_CONTAINED+CKEDITOR.POSITION_FOLLOWING;}if("sourceIndex"in e)return 0>e.sourceIndex||0>b.sourceIndex?CKEDITOR.POSITION_DISCONNECTED:e.sourceIndex<b.sourceIndex?CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_FOLLOWING;}e=this.getAddress();a=a.getAddress();for(var b=Math.min(e.length,a.length),c=0;c<b;c++){if(e[c]!=a[c])return e[c]<a[c]?CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_FOLLOWING;}return e.length<a.length?CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_IS_CONTAINED+CKEDITOR.POSITION_FOLLOWING;},getAscendant:function getAscendant(a,e){var b=this.$,c,d;e||(b=b.parentNode);"function"==typeof a?(d=!0,c=a):(d=!1,c=function c(b){b="string"==typeof b.nodeName?b.nodeName.toLowerCase():"";return"string"==typeof a?b==a:b in a;});for(;b;){if(c(d?new CKEDITOR.dom.node(b):b))return new CKEDITOR.dom.node(b);try{b=b.parentNode;}catch(l){b=null;}}return null;},hasAscendant:function hasAscendant(a,e){var b=this.$;e||(b=b.parentNode);for(;b;){if(b.nodeName&&b.nodeName.toLowerCase()==a)return!0;b=b.parentNode;}return!1;},move:function move(a,e){a.append(this.remove(),e);},remove:function remove(a){var e=this.$,b=e.parentNode;if(b){if(a)for(;a=e.firstChild;){b.insertBefore(e.removeChild(a),e);}b.removeChild(e);}return this;},replace:function replace(a){this.insertBefore(a);a.remove();},trim:function trim(){this.ltrim();this.rtrim();},ltrim:function ltrim(){for(var a;this.getFirst&&(a=this.getFirst());){if(a.type==CKEDITOR.NODE_TEXT){var e=CKEDITOR.tools.ltrim(a.getText()),b=a.getLength();if(e)e.length<b&&(a.split(b-e.length),this.$.removeChild(this.$.firstChild));else{a.remove();continue;}}break;}},rtrim:function rtrim(){for(var a;this.getLast&&(a=this.getLast());){if(a.type==CKEDITOR.NODE_TEXT){var e=CKEDITOR.tools.rtrim(a.getText()),b=a.getLength();if(e)e.length<b&&(a.split(e.length),this.$.lastChild.parentNode.removeChild(this.$.lastChild));else{a.remove();continue;}}break;}CKEDITOR.env.needsBrFiller&&(a=this.$.lastChild)&&1==a.type&&"br"==a.nodeName.toLowerCase()&&a.parentNode.removeChild(a);},isReadOnly:function isReadOnly(a){var e=this;this.type!=CKEDITOR.NODE_ELEMENT&&(e=this.getParent());CKEDITOR.env.edge&&e&&e.is("textarea","input")&&(a=!0);if(!a&&e&&"undefined"!=typeof e.$.isContentEditable)return!(e.$.isContentEditable||e.data("cke-editable"));for(;e;){if(e.data("cke-editable"))return!1;if(e.hasAttribute("contenteditable"))return"false"==e.getAttribute("contenteditable");e=e.getParent();}return!0;}}),CKEDITOR.dom.window=function(a){CKEDITOR.dom.domObject.call(this,a);},CKEDITOR.dom.window.prototype=new CKEDITOR.dom.domObject(),CKEDITOR.tools.extend(CKEDITOR.dom.window.prototype,{focus:function focus(){this.$.focus();},getViewPaneSize:function getViewPaneSize(){var a=this.$.document,e="CSS1Compat"==a.compatMode;return{width:(e?a.documentElement.clientWidth:a.body.clientWidth)||0,height:(e?a.documentElement.clientHeight:a.body.clientHeight)||0};},getScrollPosition:function getScrollPosition(){var a=this.$;if("pageXOffset"in a)return{x:a.pageXOffset||0,y:a.pageYOffset||0};a=a.document;return{x:a.documentElement.scrollLeft||a.body.scrollLeft||0,y:a.documentElement.scrollTop||a.body.scrollTop||0};},getFrame:function getFrame(){var a=this.$.frameElement;return a?new CKEDITOR.dom.element.get(a):null;}}),CKEDITOR.dom.document=function(a){CKEDITOR.dom.domObject.call(this,a);},CKEDITOR.dom.document.prototype=new CKEDITOR.dom.domObject(),CKEDITOR.tools.extend(CKEDITOR.dom.document.prototype,{type:CKEDITOR.NODE_DOCUMENT,appendStyleSheet:function appendStyleSheet(a){if(this.$.createStyleSheet)this.$.createStyleSheet(a);else{var e=new CKEDITOR.dom.element("link");e.setAttributes({rel:"stylesheet",type:"text/css",href:a});this.getHead().append(e);}},appendStyleText:function appendStyleText(a){if(this.$.createStyleSheet){var e=this.$.createStyleSheet("");e.cssText=a;}else{var b=new CKEDITOR.dom.element("style",this);b.append(new CKEDITOR.dom.text(a,this));this.getHead().append(b);}return e||b.$.sheet;},createElement:function createElement(a,e){var b=new CKEDITOR.dom.element(a,this);e&&(e.attributes&&b.setAttributes(e.attributes),e.styles&&b.setStyles(e.styles));return b;},createText:function createText(a){return new CKEDITOR.dom.text(a,this);},focus:function focus(){this.getWindow().focus();},getActive:function getActive(){var a;try{a=this.$.activeElement;}catch(e){return null;}return new CKEDITOR.dom.element(a);},getById:function getById(a){return(a=this.$.getElementById(a))?new CKEDITOR.dom.element(a):null;},getByAddress:function getByAddress(a,e){for(var b=this.$.documentElement,c=0;b&&c<a.length;c++){var d=a[c];if(e)for(var l=-1,m=0;m<b.childNodes.length;m++){var f=b.childNodes[m];if(!0!==e||3!=f.nodeType||!f.previousSibling||3!=f.previousSibling.nodeType)if(l++,l==d){b=f;break;}}else b=b.childNodes[d];}return b?new CKEDITOR.dom.node(b):null;},getElementsByTag:function getElementsByTag(a,e){CKEDITOR.env.ie&&8>=document.documentMode||!e||(a=e+":"+a);return new CKEDITOR.dom.nodeList(this.$.getElementsByTagName(a));},getHead:function getHead(){var a=this.$.getElementsByTagName("head")[0];return a=a?new CKEDITOR.dom.element(a):this.getDocumentElement().append(new CKEDITOR.dom.element("head"),!0);},getBody:function getBody(){return new CKEDITOR.dom.element(this.$.body);},getDocumentElement:function getDocumentElement(){return new CKEDITOR.dom.element(this.$.documentElement);},getWindow:function getWindow(){return new CKEDITOR.dom.window(this.$.parentWindow||this.$.defaultView);},write:function write(a){this.$.open("text/html","replace");CKEDITOR.env.ie&&(a=a.replace(/(?:^\s*<!DOCTYPE[^>]*?>)|^/i,'$\x26\n\x3cscript data-cke-temp\x3d"1"\x3e('+CKEDITOR.tools.fixDomain+")();\x3c/script\x3e"));this.$.write(a);this.$.close();},find:function find(a){return new CKEDITOR.dom.nodeList(this.$.querySelectorAll(a));},findOne:function findOne(a){return(a=this.$.querySelector(a))?new CKEDITOR.dom.element(a):null;},_getHtml5ShivFrag:function _getHtml5ShivFrag(){var a=this.getCustomData("html5ShivFrag");a||(a=this.$.createDocumentFragment(),CKEDITOR.tools.enableHtml5Elements(a,!0),this.setCustomData("html5ShivFrag",a));return a;}}),CKEDITOR.dom.nodeList=function(a){this.$=a;},CKEDITOR.dom.nodeList.prototype={count:function count(){return this.$.length;},getItem:function getItem(a){return 0>a||a>=this.$.length?null:(a=this.$[a])?new CKEDITOR.dom.node(a):null;}},CKEDITOR.dom.element=function(a,e){"string"==typeof a&&(a=(e?e.$:document).createElement(a));CKEDITOR.dom.domObject.call(this,a);},CKEDITOR.dom.element.get=function(a){return(a="string"==typeof a?document.getElementById(a)||document.getElementsByName(a)[0]:a)&&(a.$?a:new CKEDITOR.dom.element(a));},CKEDITOR.dom.element.prototype=new CKEDITOR.dom.node(),CKEDITOR.dom.element.createFromHtml=function(a,e){var b=new CKEDITOR.dom.element("div",e);b.setHtml(a);return b.getFirst().remove();},CKEDITOR.dom.element.setMarker=function(a,e,b,c){var d=e.getCustomData("list_marker_id")||e.setCustomData("list_marker_id",CKEDITOR.tools.getNextNumber()).getCustomData("list_marker_id"),l=e.getCustomData("list_marker_names")||e.setCustomData("list_marker_names",{}).getCustomData("list_marker_names");a[d]=e;l[b]=1;return e.setCustomData(b,c);},CKEDITOR.dom.element.clearAllMarkers=function(a){for(var e in a){CKEDITOR.dom.element.clearMarkers(a,a[e],1);}},CKEDITOR.dom.element.clearMarkers=function(a,e,b){var c=e.getCustomData("list_marker_names"),d=e.getCustomData("list_marker_id"),l;for(l in c){e.removeCustomData(l);}e.removeCustomData("list_marker_names");b&&(e.removeCustomData("list_marker_id"),delete a[d]);},function(){function a(a,b){return-1<(" "+a+" ").replace(l," ").indexOf(" "+b+" ");}function e(a){var b=!0;a.$.id||(a.$.id="cke_tmp_"+CKEDITOR.tools.getNextNumber(),b=!1);return function(){b||a.removeAttribute("id");};}function b(a,b){var c=CKEDITOR.tools.escapeCss(a.$.id);return"#"+c+" "+b.split(/,\s*/).join(", #"+c+" ");}function c(a){for(var b=0,c=0,g=m[a].length;c<g;c++){b+=parseInt(this.getComputedStyle(m[a][c])||0,10)||0;}return b;}var d=document.createElement("_").classList,d="undefined"!==typeof d&&null!==String(d.add).match(/\[Native code\]/gi),l=/[\n\t\r]/g;CKEDITOR.tools.extend(CKEDITOR.dom.element.prototype,{type:CKEDITOR.NODE_ELEMENT,addClass:d?function(a){this.$.classList.add(a);return this;}:function(f){var b=this.$.className;b&&(a(b,f)||(b+=" "+f));this.$.className=b||f;return this;},removeClass:d?function(a){var b=this.$;b.classList.remove(a);b.className||b.removeAttribute("class");return this;}:function(f){var b=this.getAttribute("class");b&&a(b,f)&&((b=b.replace(new RegExp("(?:^|\\s+)"+f+"(?\x3d\\s|$)"),"").replace(/^\s+/,""))?this.setAttribute("class",b):this.removeAttribute("class"));return this;},hasClass:function hasClass(f){return a(this.$.className,f);},append:function append(a,b){"string"==typeof a&&(a=this.getDocument().createElement(a));b?this.$.insertBefore(a.$,this.$.firstChild):this.$.appendChild(a.$);return a;},appendHtml:function appendHtml(a){if(this.$.childNodes.length){var b=new CKEDITOR.dom.element("div",this.getDocument());b.setHtml(a);b.moveChildren(this);}else this.setHtml(a);},appendText:function appendText(a){null!=this.$.text&&CKEDITOR.env.ie&&9>CKEDITOR.env.version?this.$.text+=a:this.append(new CKEDITOR.dom.text(a));},appendBogus:function appendBogus(a){if(a||CKEDITOR.env.needsBrFiller){for(a=this.getLast();a&&a.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.rtrim(a.getText());){a=a.getPrevious();}a&&a.is&&a.is("br")||(a=this.getDocument().createElement("br"),CKEDITOR.env.gecko&&a.setAttribute("type","_moz"),this.append(a));}},breakParent:function breakParent(a,b){var c=new CKEDITOR.dom.range(this.getDocument());c.setStartAfter(this);c.setEndAfter(a);var g=c.extractContents(!1,b||!1),d;c.insertNode(this.remove());if(CKEDITOR.env.ie&&!CKEDITOR.env.edge){for(c=new CKEDITOR.dom.element("div");d=g.getFirst();){d.$.style.backgroundColor&&(d.$.style.backgroundColor=d.$.style.backgroundColor),c.append(d);}c.insertAfter(this);c.remove(!0);}else g.insertAfterNode(this);},contains:document.compareDocumentPosition?function(a){return!!(this.$.compareDocumentPosition(a.$)&16);}:function(a){var b=this.$;return a.type!=CKEDITOR.NODE_ELEMENT?b.contains(a.getParent().$):b!=a.$&&b.contains(a.$);},focus:function(){function a(){try{this.$.focus();}catch(b){}}return function(b){b?CKEDITOR.tools.setTimeout(a,100,this):a.call(this);};}(),getHtml:function getHtml(){var a=this.$.innerHTML;return CKEDITOR.env.ie?a.replace(/<\?[^>]*>/g,""):a;},getOuterHtml:function getOuterHtml(){if(this.$.outerHTML)return this.$.outerHTML.replace(/<\?[^>]*>/,"");var a=this.$.ownerDocument.createElement("div");a.appendChild(this.$.cloneNode(!0));return a.innerHTML;},getClientRect:function getClientRect(){var a=CKEDITOR.tools.extend({},this.$.getBoundingClientRect());!a.width&&(a.width=a.right-a.left);!a.height&&(a.height=a.bottom-a.top);return a;},setHtml:CKEDITOR.env.ie&&9>CKEDITOR.env.version?function(a){try{var b=this.$;if(this.getParent())return b.innerHTML=a;var c=this.getDocument()._getHtml5ShivFrag();c.appendChild(b);b.innerHTML=a;c.removeChild(b);return a;}catch(g){this.$.innerHTML="";b=new CKEDITOR.dom.element("body",this.getDocument());b.$.innerHTML=a;for(b=b.getChildren();b.count();){this.append(b.getItem(0));}return a;}}:function(a){return this.$.innerHTML=a;},setText:function(){var a=document.createElement("p");a.innerHTML="x";a=a.textContent;return function(b){this.$[a?"textContent":"innerText"]=b;};}(),getAttribute:function(){var a=function a(_a2){return this.$.getAttribute(_a2,2);};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(a){switch(a){case"class":a="className";break;case"http-equiv":a="httpEquiv";break;case"name":return this.$.name;case"tabindex":return a=this.$.getAttribute(a,2),0!==a&&0===this.$.tabIndex&&(a=null),a;case"checked":return a=this.$.attributes.getNamedItem(a),(a.specified?a.nodeValue:this.$.checked)?"checked":null;case"hspace":case"value":return this.$[a];case"style":return this.$.style.cssText;case"contenteditable":case"contentEditable":return this.$.attributes.getNamedItem("contentEditable").specified?this.$.getAttribute("contentEditable"):null;}return this.$.getAttribute(a,2);}:a;}(),getAttributes:function getAttributes(a){var b={},c=this.$.attributes,g;a=CKEDITOR.tools.isArray(a)?a:[];for(g=0;g<c.length;g++){-1===CKEDITOR.tools.indexOf(a,c[g].name)&&(b[c[g].name]=c[g].value);}return b;},getChildren:function getChildren(){return new CKEDITOR.dom.nodeList(this.$.childNodes);},getComputedStyle:document.defaultView&&document.defaultView.getComputedStyle?function(a){var b=this.getWindow().$.getComputedStyle(this.$,null);return b?b.getPropertyValue(a):"";}:function(a){return this.$.currentStyle[CKEDITOR.tools.cssStyleToDomStyle(a)];},getDtd:function getDtd(){var a=CKEDITOR.dtd[this.getName()];this.getDtd=function(){return a;};return a;},getElementsByTag:CKEDITOR.dom.document.prototype.getElementsByTag,getTabIndex:function getTabIndex(){var a=this.$.tabIndex;return 0!==a||CKEDITOR.dtd.$tabIndex[this.getName()]||0===parseInt(this.getAttribute("tabindex"),10)?a:-1;},getText:function getText(){return this.$.textContent||this.$.innerText||"";},getWindow:function getWindow(){return this.getDocument().getWindow();},getId:function getId(){return this.$.id||null;},getNameAtt:function getNameAtt(){return this.$.name||null;},getName:function getName(){var a=this.$.nodeName.toLowerCase();if(CKEDITOR.env.ie&&8>=document.documentMode){var b=this.$.scopeName;"HTML"!=b&&(a=b.toLowerCase()+":"+a);}this.getName=function(){return a;};return this.getName();},getValue:function getValue(){return this.$.value;},getFirst:function getFirst(a){var b=this.$.firstChild;(b=b&&new CKEDITOR.dom.node(b))&&a&&!a(b)&&(b=b.getNext(a));return b;},getLast:function getLast(a){var b=this.$.lastChild;(b=b&&new CKEDITOR.dom.node(b))&&a&&!a(b)&&(b=b.getPrevious(a));return b;},getStyle:function getStyle(a){return this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)];},is:function is(){var a=this.getName();if("object"==_typeof(arguments[0]))return!!arguments[0][a];for(var b=0;b<arguments.length;b++){if(arguments[b]==a)return!0;}return!1;},isEditable:function isEditable(a){var b=this.getName();return this.isReadOnly()||"none"==this.getComputedStyle("display")||"hidden"==this.getComputedStyle("visibility")||CKEDITOR.dtd.$nonEditable[b]||CKEDITOR.dtd.$empty[b]||this.is("a")&&(this.data("cke-saved-name")||this.hasAttribute("name"))&&!this.getChildCount()?!1:!1!==a?(a=CKEDITOR.dtd[b]||CKEDITOR.dtd.span,!(!a||!a["#"])):!0;},isIdentical:function isIdentical(a){var b=this.clone(0,1);a=a.clone(0,1);b.removeAttributes(["_moz_dirty","data-cke-expando","data-cke-saved-href","data-cke-saved-name"]);a.removeAttributes(["_moz_dirty","data-cke-expando","data-cke-saved-href","data-cke-saved-name"]);if(b.$.isEqualNode)return b.$.style.cssText=CKEDITOR.tools.normalizeCssText(b.$.style.cssText),a.$.style.cssText=CKEDITOR.tools.normalizeCssText(a.$.style.cssText),b.$.isEqualNode(a.$);b=b.getOuterHtml();a=a.getOuterHtml();if(CKEDITOR.env.ie&&9>CKEDITOR.env.version&&this.is("a")){var c=this.getParent();c.type==CKEDITOR.NODE_ELEMENT&&(c=c.clone(),c.setHtml(b),b=c.getHtml(),c.setHtml(a),a=c.getHtml());}return b==a;},isVisible:function isVisible(){var a=(this.$.offsetHeight||this.$.offsetWidth)&&"hidden"!=this.getComputedStyle("visibility"),b,c;a&&CKEDITOR.env.webkit&&(b=this.getWindow(),!b.equals(CKEDITOR.document.getWindow())&&(c=b.$.frameElement)&&(a=new CKEDITOR.dom.element(c).isVisible()));return!!a;},isEmptyInlineRemoveable:function isEmptyInlineRemoveable(){if(!CKEDITOR.dtd.$removeEmpty[this.getName()])return!1;for(var a=this.getChildren(),b=0,c=a.count();b<c;b++){var g=a.getItem(b);if(g.type!=CKEDITOR.NODE_ELEMENT||!g.data("cke-bookmark"))if(g.type==CKEDITOR.NODE_ELEMENT&&!g.isEmptyInlineRemoveable()||g.type==CKEDITOR.NODE_TEXT&&CKEDITOR.tools.trim(g.getText()))return!1;}return!0;},hasAttributes:CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(){for(var a=this.$.attributes,b=0;b<a.length;b++){var c=a[b];switch(c.nodeName){case"class":if(this.getAttribute("class"))return!0;case"data-cke-expando":continue;default:if(c.specified)return!0;}}return!1;}:function(){var a=this.$.attributes,b=a.length,c={"data-cke-expando":1,_moz_dirty:1};return 0<b&&(2<b||!c[a[0].nodeName]||2==b&&!c[a[1].nodeName]);},hasAttribute:function(){function a(b){var f=this.$.attributes.getNamedItem(b);if("input"==this.getName())switch(b){case"class":return 0<this.$.className.length;case"checked":return!!this.$.checked;case"value":return b=this.getAttribute("type"),"checkbox"==b||"radio"==b?"on"!=this.$.value:!!this.$.value;}return f?f.specified:!1;}return CKEDITOR.env.ie?8>CKEDITOR.env.version?function(b){return"name"==b?!!this.$.name:a.call(this,b);}:a:function(a){return!!this.$.attributes.getNamedItem(a);};}(),hide:function hide(){this.setStyle("display","none");},moveChildren:function moveChildren(a,b){var c=this.$;a=a.$;if(c!=a){var g;if(b)for(;g=c.lastChild;){a.insertBefore(c.removeChild(g),a.firstChild);}else for(;g=c.firstChild;){a.appendChild(c.removeChild(g));}}},mergeSiblings:function(){function a(b,f,g){if(f&&f.type==CKEDITOR.NODE_ELEMENT){for(var c=[];f.data("cke-bookmark")||f.isEmptyInlineRemoveable();){if(c.push(f),f=g?f.getNext():f.getPrevious(),!f||f.type!=CKEDITOR.NODE_ELEMENT)return;}if(b.isIdentical(f)){for(var d=g?b.getLast():b.getFirst();c.length;){c.shift().move(b,!g);}f.moveChildren(b,!g);f.remove();d&&d.type==CKEDITOR.NODE_ELEMENT&&d.mergeSiblings();}}}return function(b){if(!1===b||CKEDITOR.dtd.$removeEmpty[this.getName()]||this.is("a"))a(this,this.getNext(),!0),a(this,this.getPrevious());};}(),show:function show(){this.setStyles({display:"",visibility:""});},setAttribute:function(){var a=function a(_a3,b){this.$.setAttribute(_a3,b);return this;};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(b,c){"class"==b?this.$.className=c:"style"==b?this.$.style.cssText=c:"tabindex"==b?this.$.tabIndex=c:"checked"==b?this.$.checked=c:"contenteditable"==b?a.call(this,"contentEditable",c):a.apply(this,arguments);return this;}:CKEDITOR.env.ie8Compat&&CKEDITOR.env.secure?function(b,c){if("src"==b&&c.match(/^http:\/\//))try{a.apply(this,arguments);}catch(g){}else a.apply(this,arguments);return this;}:a;}(),setAttributes:function setAttributes(a){for(var b in a){this.setAttribute(b,a[b]);}return this;},setValue:function setValue(a){this.$.value=a;return this;},removeAttribute:function(){var a=function a(_a4){this.$.removeAttribute(_a4);};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(a){"class"==a?a="className":"tabindex"==a?a="tabIndex":"contenteditable"==a&&(a="contentEditable");this.$.removeAttribute(a);}:a;}(),removeAttributes:function removeAttributes(a){if(CKEDITOR.tools.isArray(a))for(var b=0;b<a.length;b++){this.removeAttribute(a[b]);}else for(b in a=a||this.getAttributes(),a){a.hasOwnProperty(b)&&this.removeAttribute(b);}},removeStyle:function removeStyle(a){var b=this.$.style;if(b.removeProperty||"border"!=a&&"margin"!=a&&"padding"!=a)b.removeProperty?b.removeProperty(a):b.removeAttribute(CKEDITOR.tools.cssStyleToDomStyle(a)),this.$.style.cssText||this.removeAttribute("style");else{var c=["top","left","right","bottom"],g;"border"==a&&(g=["color","style","width"]);for(var b=[],d=0;d<c.length;d++){if(g)for(var e=0;e<g.length;e++){b.push([a,c[d],g[e]].join("-"));}else b.push([a,c[d]].join("-"));}for(a=0;a<b.length;a++){this.removeStyle(b[a]);}}},setStyle:function setStyle(a,b){this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)]=b;return this;},setStyles:function setStyles(a){for(var b in a){this.setStyle(b,a[b]);}return this;},setOpacity:function setOpacity(a){CKEDITOR.env.ie&&9>CKEDITOR.env.version?(a=Math.round(100*a),this.setStyle("filter",100<=a?"":"progid:DXImageTransform.Microsoft.Alpha(opacity\x3d"+a+")")):this.setStyle("opacity",a);},unselectable:function unselectable(){this.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select","none"));if(CKEDITOR.env.ie){this.setAttribute("unselectable","on");for(var a,b=this.getElementsByTag("*"),c=0,g=b.count();c<g;c++){a=b.getItem(c),a.setAttribute("unselectable","on");}}},getPositionedAncestor:function getPositionedAncestor(){for(var a=this;"html"!=a.getName();){if("static"!=a.getComputedStyle("position"))return a;a=a.getParent();}return null;},getDocumentPosition:function getDocumentPosition(a){var b=0,c=0,g=this.getDocument(),d=g.getBody(),e="BackCompat"==g.$.compatMode;if(document.documentElement.getBoundingClientRect&&(CKEDITOR.env.ie?8!==CKEDITOR.env.version:1)){var l=this.$.getBoundingClientRect(),m=g.$.documentElement,t=m.clientTop||d.$.clientTop||0,p=m.clientLeft||d.$.clientLeft||0,w=!0;CKEDITOR.env.ie&&(w=g.getDocumentElement().contains(this),g=g.getBody().contains(this),w=e&&g||!e&&w);w&&(CKEDITOR.env.webkit||CKEDITOR.env.ie&&12<=CKEDITOR.env.version?(b=d.$.scrollLeft||m.scrollLeft,c=d.$.scrollTop||m.scrollTop):(c=e?d.$:m,b=c.scrollLeft,c=c.scrollTop),b=l.left+b-p,c=l.top+c-t);}else for(t=this,p=null;t&&"body"!=t.getName()&&"html"!=t.getName();){b+=t.$.offsetLeft-t.$.scrollLeft;c+=t.$.offsetTop-t.$.scrollTop;t.equals(this)||(b+=t.$.clientLeft||0,c+=t.$.clientTop||0);for(;p&&!p.equals(t);){b-=p.$.scrollLeft,c-=p.$.scrollTop,p=p.getParent();}p=t;t=(l=t.$.offsetParent)?new CKEDITOR.dom.element(l):null;}a&&(l=this.getWindow(),t=a.getWindow(),!l.equals(t)&&l.$.frameElement&&(a=new CKEDITOR.dom.element(l.$.frameElement).getDocumentPosition(a),b+=a.x,c+=a.y));document.documentElement.getBoundingClientRect||!CKEDITOR.env.gecko||e||(b+=this.$.clientLeft?1:0,c+=this.$.clientTop?1:0);return{x:b,y:c};},scrollIntoView:function scrollIntoView(a){var b=this.getParent();if(b){do{if((b.$.clientWidth&&b.$.clientWidth<b.$.scrollWidth||b.$.clientHeight&&b.$.clientHeight<b.$.scrollHeight)&&!b.is("body")&&this.scrollIntoParent(b,a,1),b.is("html")){var c=b.getWindow();try{var g=c.$.frameElement;g&&(b=new CKEDITOR.dom.element(g));}catch(d){}}}while(b=b.getParent());}},scrollIntoParent:function scrollIntoParent(a,b,c){var g,d,e,l;function m(b,g){/body|html/.test(a.getName())?a.getWindow().$.scrollBy(b,g):(a.$.scrollLeft+=b,a.$.scrollTop+=g);}function t(a,b){var g={x:0,y:0};if(!a.is(w?"body":"html")){var c=a.$.getBoundingClientRect();g.x=c.left;g.y=c.top;}c=a.getWindow();c.equals(b)||(c=t(CKEDITOR.dom.element.get(c.$.frameElement),b),g.x+=c.x,g.y+=c.y);return g;}function p(a,b){return parseInt(a.getComputedStyle("margin-"+b)||0,10)||0;}!a&&(a=this.getWindow());e=a.getDocument();var w="BackCompat"==e.$.compatMode;a instanceof CKEDITOR.dom.window&&(a=w?e.getBody():e.getDocumentElement());CKEDITOR.env.webkit&&(e=this.getEditor(!1))&&(e._.previousScrollTop=null);e=a.getWindow();d=t(this,e);var z=t(a,e),A=this.$.offsetHeight;g=this.$.offsetWidth;var u=a.$.clientHeight,x=a.$.clientWidth;e=d.x-p(this,"left")-z.x||0;l=d.y-p(this,"top")-z.y||0;g=d.x+g+p(this,"right")-(z.x+x)||0;d=d.y+A+p(this,"bottom")-(z.y+u)||0;(0>l||0<d)&&m(0,!0===b?l:!1===b?d:0>l?l:d);c&&(0>e||0<g)&&m(0>e?e:g,0);},setState:function setState(a,b,c){b=b||"cke";switch(a){case CKEDITOR.TRISTATE_ON:this.addClass(b+"_on");this.removeClass(b+"_off");this.removeClass(b+"_disabled");c&&this.setAttribute("aria-pressed",!0);c&&this.removeAttribute("aria-disabled");break;case CKEDITOR.TRISTATE_DISABLED:this.addClass(b+"_disabled");this.removeClass(b+"_off");this.removeClass(b+"_on");c&&this.setAttribute("aria-disabled",!0);c&&this.removeAttribute("aria-pressed");break;default:this.addClass(b+"_off"),this.removeClass(b+"_on"),this.removeClass(b+"_disabled"),c&&this.removeAttribute("aria-pressed"),c&&this.removeAttribute("aria-disabled");}},getFrameDocument:function getFrameDocument(){var a=this.$;try{a.contentWindow.document;}catch(b){a.src=a.src;}return a&&new CKEDITOR.dom.document(a.contentWindow.document);},copyAttributes:function copyAttributes(a,b){var c=this.$.attributes;b=b||{};for(var g=0;g<c.length;g++){var d=c[g],e=d.nodeName.toLowerCase(),l;if(!(e in b))if("checked"==e&&(l=this.getAttribute(e)))a.setAttribute(e,l);else if(!CKEDITOR.env.ie||this.hasAttribute(e))l=this.getAttribute(e),null===l&&(l=d.nodeValue),a.setAttribute(e,l);}""!==this.$.style.cssText&&(a.$.style.cssText=this.$.style.cssText);},renameNode:function renameNode(a){if(this.getName()!=a){var b=this.getDocument();a=new CKEDITOR.dom.element(a,b);this.copyAttributes(a);this.moveChildren(a);this.getParent(!0)&&this.$.parentNode.replaceChild(a.$,this.$);a.$["data-cke-expando"]=this.$["data-cke-expando"];this.$=a.$;delete this.getName;}},getChild:function(){function a(b,c){var g=b.childNodes;if(0<=c&&c<g.length)return g[c];}return function(b){var c=this.$;if(b.slice)for(b=b.slice();0<b.length&&c;){c=a(c,b.shift());}else c=a(c,b);return c?new CKEDITOR.dom.node(c):null;};}(),getChildCount:function getChildCount(){return this.$.childNodes.length;},disableContextMenu:function disableContextMenu(){function a(b){return b.type==CKEDITOR.NODE_ELEMENT&&b.hasClass("cke_enable_context_menu");}this.on("contextmenu",function(b){b.data.getTarget().getAscendant(a,!0)||b.data.preventDefault();});},getDirection:function getDirection(a){return a?this.getComputedStyle("direction")||this.getDirection()||this.getParent()&&this.getParent().getDirection(1)||this.getDocument().$.dir||"ltr":this.getStyle("direction")||this.getAttribute("dir");},data:function data(a,b){a="data-"+a;if(void 0===b)return this.getAttribute(a);!1===b?this.removeAttribute(a):this.setAttribute(a,b);return null;},getEditor:function getEditor(a){var b=CKEDITOR.instances,c,g,d;a=a||void 0===a;for(c in b){if(g=b[c],g.element.equals(this)&&g.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO||!a&&(d=g.editable(),d.equals(this)||d.contains(this)))return g;}return null;},find:function find(a){var c=e(this);a=new CKEDITOR.dom.nodeList(this.$.querySelectorAll(b(this,a)));c();return a;},findOne:function findOne(a){var c=e(this);a=this.$.querySelector(b(this,a));c();return a?new CKEDITOR.dom.element(a):null;},forEach:function forEach(a,b,c){if(!(c||b&&this.type!=b))var g=a(this);if(!1!==g){c=this.getChildren();for(var d=0;d<c.count();d++){g=c.getItem(d),g.type==CKEDITOR.NODE_ELEMENT?g.forEach(a,b):b&&g.type!=b||a(g);}}}});var m={width:["border-left-width","border-right-width","padding-left","padding-right"],height:["border-top-width","border-bottom-width","padding-top","padding-bottom"]};CKEDITOR.dom.element.prototype.setSize=function(a,b,d){"number"==typeof b&&(!d||CKEDITOR.env.ie&&CKEDITOR.env.quirks||(b-=c.call(this,a)),this.setStyle(a,b+"px"));};CKEDITOR.dom.element.prototype.getSize=function(a,b){var d=Math.max(this.$["offset"+CKEDITOR.tools.capitalize(a)],this.$["client"+CKEDITOR.tools.capitalize(a)])||0;b&&(d-=c.call(this,a));return d;};}(),CKEDITOR.dom.documentFragment=function(a){a=a||CKEDITOR.document;this.$=a.type==CKEDITOR.NODE_DOCUMENT?a.$.createDocumentFragment():a;},CKEDITOR.tools.extend(CKEDITOR.dom.documentFragment.prototype,CKEDITOR.dom.element.prototype,{type:CKEDITOR.NODE_DOCUMENT_FRAGMENT,insertAfterNode:function insertAfterNode(a){a=a.$;a.parentNode.insertBefore(this.$,a.nextSibling);},getHtml:function getHtml(){var a=new CKEDITOR.dom.element("div");this.clone(1,1).appendTo(a);return a.getHtml().replace(/\s*data-cke-expando=".*?"/g,"");}},!0,{append:1,appendBogus:1,clone:1,getFirst:1,getHtml:1,getLast:1,getParent:1,getNext:1,getPrevious:1,appendTo:1,moveChildren:1,insertBefore:1,insertAfterNode:1,replace:1,trim:1,type:1,ltrim:1,rtrim:1,getDocument:1,getChildCount:1,getChild:1,getChildren:1}),function(){function a(a,b){var g=this.range;if(this._.end)return null;if(!this._.start){this._.start=1;if(g.collapsed)return this.end(),null;g.optimize();}var c,d=g.startContainer;c=g.endContainer;var f=g.startOffset,k=g.endOffset,h,e=this.guard,n=this.type,l=a?"getPreviousSourceNode":"getNextSourceNode";if(!a&&!this._.guardLTR){var m=c.type==CKEDITOR.NODE_ELEMENT?c:c.getParent(),B=c.type==CKEDITOR.NODE_ELEMENT?c.getChild(k):c.getNext();this._.guardLTR=function(a,b){return(!b||!m.equals(a))&&(!B||!a.equals(B))&&(a.type!=CKEDITOR.NODE_ELEMENT||!b||!a.equals(g.root));};}if(a&&!this._.guardRTL){var C=d.type==CKEDITOR.NODE_ELEMENT?d:d.getParent(),F=d.type==CKEDITOR.NODE_ELEMENT?f?d.getChild(f-1):null:d.getPrevious();this._.guardRTL=function(a,b){return(!b||!C.equals(a))&&(!F||!a.equals(F))&&(a.type!=CKEDITOR.NODE_ELEMENT||!b||!a.equals(g.root));};}var E=a?this._.guardRTL:this._.guardLTR;h=e?function(a,b){return!1===E(a,b)?!1:e(a,b);}:E;this.current?c=this.current[l](!1,n,h):(a?c.type==CKEDITOR.NODE_ELEMENT&&(c=0<k?c.getChild(k-1):!1===h(c,!0)?null:c.getPreviousSourceNode(!0,n,h)):(c=d,c.type==CKEDITOR.NODE_ELEMENT&&((c=c.getChild(f))||(c=!1===h(d,!0)?null:d.getNextSourceNode(!0,n,h)))),c&&!1===h(c)&&(c=null));for(;c&&!this._.end;){this.current=c;if(!this.evaluator||!1!==this.evaluator(c)){if(!b)return c;}else if(b&&this.evaluator)return!1;c=c[l](!1,n,h);}this.end();return this.current=null;}function e(b){for(var g,c=null;g=a.call(this,b);){c=g;}return c;}CKEDITOR.dom.walker=CKEDITOR.tools.createClass({$:function $(a){this.range=a;this._={};},proto:{end:function end(){this._.end=1;},next:function next(){return a.call(this);},previous:function previous(){return a.call(this,1);},checkForward:function checkForward(){return!1!==a.call(this,0,1);},checkBackward:function checkBackward(){return!1!==a.call(this,1,1);},lastForward:function lastForward(){return e.call(this);},lastBackward:function lastBackward(){return e.call(this,1);},reset:function reset(){delete this.current;this._={};}}});var b={block:1,"list-item":1,table:1,"table-row-group":1,"table-header-group":1,"table-footer-group":1,"table-row":1,"table-column-group":1,"table-column":1,"table-cell":1,"table-caption":1},c={absolute:1,fixed:1};CKEDITOR.dom.element.prototype.isBlockBoundary=function(a){return"none"!=this.getComputedStyle("float")||this.getComputedStyle("position")in c||!b[this.getComputedStyle("display")]?!!(this.is(CKEDITOR.dtd.$block)||a&&this.is(a)):!0;};CKEDITOR.dom.walker.blockBoundary=function(a){return function(b){return!(b.type==CKEDITOR.NODE_ELEMENT&&b.isBlockBoundary(a));};};CKEDITOR.dom.walker.listItemBoundary=function(){return this.blockBoundary({br:1});};CKEDITOR.dom.walker.bookmark=function(a,b){function g(a){return a&&a.getName&&"span"==a.getName()&&a.data("cke-bookmark");}return function(c){var d,f;d=c&&c.type!=CKEDITOR.NODE_ELEMENT&&(f=c.getParent())&&g(f);d=a?d:d||g(c);return!!(b^d);};};CKEDITOR.dom.walker.whitespaces=function(a){return function(b){var g;b&&b.type==CKEDITOR.NODE_TEXT&&(g=!CKEDITOR.tools.trim(b.getText())||CKEDITOR.env.webkit&&b.getText()==CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE);return!!(a^g);};};CKEDITOR.dom.walker.invisible=function(a){var b=CKEDITOR.dom.walker.whitespaces(),g=CKEDITOR.env.webkit?1:0;return function(c){b(c)?c=1:(c.type==CKEDITOR.NODE_TEXT&&(c=c.getParent()),c=c.$.offsetWidth<=g);return!!(a^c);};};CKEDITOR.dom.walker.nodeType=function(a,b){return function(g){return!!(b^g.type==a);};};CKEDITOR.dom.walker.bogus=function(a){function b(a){return!l(a)&&!m(a);}return function(g){var c=CKEDITOR.env.needsBrFiller?g.is&&g.is("br"):g.getText&&d.test(g.getText());c&&(c=g.getParent(),g=g.getNext(b),c=c.isBlockBoundary()&&(!g||g.type==CKEDITOR.NODE_ELEMENT&&g.isBlockBoundary()));return!!(a^c);};};CKEDITOR.dom.walker.temp=function(a){return function(b){b.type!=CKEDITOR.NODE_ELEMENT&&(b=b.getParent());b=b&&b.hasAttribute("data-cke-temp");return!!(a^b);};};var d=/^[\t\r\n ]*(?:&nbsp;|\xa0)$/,l=CKEDITOR.dom.walker.whitespaces(),m=CKEDITOR.dom.walker.bookmark(),f=CKEDITOR.dom.walker.temp(),h=function h(a){return m(a)||l(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.is(CKEDITOR.dtd.$inline)&&!a.is(CKEDITOR.dtd.$empty);};CKEDITOR.dom.walker.ignored=function(a){return function(b){b=l(b)||m(b)||f(b);return!!(a^b);};};var k=CKEDITOR.dom.walker.ignored();CKEDITOR.dom.walker.empty=function(a){return function(b){for(var g=0,c=b.getChildCount();g<c;++g){if(!k(b.getChild(g)))return!!a;}return!a;};};var g=CKEDITOR.dom.walker.empty(),n=CKEDITOR.dom.walker.validEmptyBlockContainers=CKEDITOR.tools.extend(function(a){var b={},g;for(g in a){CKEDITOR.dtd[g]["#"]&&(b[g]=1);}return b;}(CKEDITOR.dtd.$block),{caption:1,td:1,th:1});CKEDITOR.dom.walker.editable=function(a){return function(b){b=k(b)?!1:b.type==CKEDITOR.NODE_TEXT||b.type==CKEDITOR.NODE_ELEMENT&&(b.is(CKEDITOR.dtd.$inline)||b.is("hr")||"false"==b.getAttribute("contenteditable")||!CKEDITOR.env.needsBrFiller&&b.is(n)&&g(b))?!0:!1;return!!(a^b);};};CKEDITOR.dom.element.prototype.getBogus=function(){var a=this;do{a=a.getPreviousSourceNode();}while(h(a));return a&&(CKEDITOR.env.needsBrFiller?a.is&&a.is("br"):a.getText&&d.test(a.getText()))?a:!1;};}(),CKEDITOR.dom.range=function(a){this.endOffset=this.endContainer=this.startOffset=this.startContainer=null;this.collapsed=!0;var e=a instanceof CKEDITOR.dom.document;this.document=e?a:a.getDocument();this.root=e?a.getBody():a;},function(){function a(a){a.collapsed=a.startContainer&&a.endContainer&&a.startContainer.equals(a.endContainer)&&a.startOffset==a.endOffset;}function e(a,b,c,d,f){function k(a,b,g,c){var d=g?a.getPrevious():a.getNext();if(c&&l)return d;u||c?b.append(a.clone(!0,f),g):(a.remove(),m&&b.append(a));return d;}function h(){var a,b,g,c=Math.min(I.length,H.length);for(a=0;a<c;a++){if(b=I[a],g=H[a],!b.equals(g))return a;}return a-1;}function e(){var b=R-1,c=E&&J&&!x.equals(D);b<P-1||b<T-1||c?(c?a.moveToPosition(D,CKEDITOR.POSITION_BEFORE_START):T==b+1&&F?a.moveToPosition(H[b],CKEDITOR.POSITION_BEFORE_END):a.moveToPosition(H[b+1],CKEDITOR.POSITION_BEFORE_START),d&&(b=I[b+1])&&b.type==CKEDITOR.NODE_ELEMENT&&(c=CKEDITOR.dom.element.createFromHtml('\x3cspan data-cke-bookmark\x3d"1" style\x3d"display:none"\x3e\x26nbsp;\x3c/span\x3e',a.document),c.insertAfter(b),b.mergeSiblings(!1),a.moveToBookmark({startNode:c}))):a.collapse(!0);}a.optimizeBookmark();var l=0===b,m=1==b,u=2==b;b=u||m;var x=a.startContainer,D=a.endContainer,y=a.startOffset,B=a.endOffset,C,F,E,J,G,M;if(u&&D.type==CKEDITOR.NODE_TEXT&&x.equals(D))x=a.document.createText(x.substring(y,B)),c.append(x);else{D.type==CKEDITOR.NODE_TEXT?u?M=!0:D=D.split(B):0<D.getChildCount()?B>=D.getChildCount()?(D=D.getChild(B-1),F=!0):D=D.getChild(B):J=F=!0;x.type==CKEDITOR.NODE_TEXT?u?G=!0:x.split(y):0<x.getChildCount()?0===y?(x=x.getChild(y),C=!0):x=x.getChild(y-1):E=C=!0;for(var I=x.getParents(),H=D.getParents(),R=h(),P=I.length-1,T=H.length-1,O=c,K,ca,W,U=-1,L=R;L<=P;L++){ca=I[L];W=ca.getNext();for(L!=P||ca.equals(H[L])&&P<T?b&&(K=O.append(ca.clone(0,f))):C?k(ca,O,!1,E):G&&O.append(a.document.createText(ca.substring(y)));W;){if(W.equals(H[L])){U=L;break;}W=k(W,O);}O=K;}O=c;for(L=R;L<=T;L++){if(c=H[L],W=c.getPrevious(),c.equals(I[L]))b&&(O=O.getChild(0));else{L!=T||c.equals(I[L])&&T<P?b&&(K=O.append(c.clone(0,f))):F?k(c,O,!1,J):M&&O.append(a.document.createText(c.substring(0,B)));if(L>U)for(;W;){W=k(W,O,!0);}O=K;}}u||e();}}function b(){var a=!1,b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(!0),d=CKEDITOR.dom.walker.bogus();return function(f){return c(f)||b(f)?!0:d(f)&&!a?a=!0:f.type==CKEDITOR.NODE_TEXT&&(f.hasAscendant("pre")||CKEDITOR.tools.trim(f.getText()).length)||f.type==CKEDITOR.NODE_ELEMENT&&!f.is(l)?!1:!0;};}function c(a){var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(1);return function(d){return c(d)||b(d)?!0:!a&&m(d)||d.type==CKEDITOR.NODE_ELEMENT&&d.is(CKEDITOR.dtd.$removeEmpty);};}function d(a){return function(){var b;return this[a?"getPreviousNode":"getNextNode"](function(a){!b&&k(a)&&(b=a);return h(a)&&!(m(a)&&a.equals(b));});};}var l={abbr:1,acronym:1,b:1,bdo:1,big:1,cite:1,code:1,del:1,dfn:1,em:1,font:1,i:1,ins:1,label:1,kbd:1,q:1,samp:1,small:1,span:1,strike:1,strong:1,sub:1,sup:1,tt:1,u:1,"var":1},m=CKEDITOR.dom.walker.bogus(),f=/^[\t\r\n ]*(?:&nbsp;|\xa0)$/,h=CKEDITOR.dom.walker.editable(),k=CKEDITOR.dom.walker.ignored(!0);CKEDITOR.dom.range.prototype={clone:function clone(){var a=new CKEDITOR.dom.range(this.root);a._setStartContainer(this.startContainer);a.startOffset=this.startOffset;a._setEndContainer(this.endContainer);a.endOffset=this.endOffset;a.collapsed=this.collapsed;return a;},collapse:function collapse(a){a?(this._setEndContainer(this.startContainer),this.endOffset=this.startOffset):(this._setStartContainer(this.endContainer),this.startOffset=this.endOffset);this.collapsed=!0;},cloneContents:function cloneContents(a){var b=new CKEDITOR.dom.documentFragment(this.document);this.collapsed||e(this,2,b,!1,"undefined"==typeof a?!0:a);return b;},deleteContents:function deleteContents(a){this.collapsed||e(this,0,null,a);},extractContents:function extractContents(a,b){var c=new CKEDITOR.dom.documentFragment(this.document);this.collapsed||e(this,1,c,a,"undefined"==typeof b?!0:b);return c;},createBookmark:function createBookmark(a){var b,c,d,f,k=this.collapsed;b=this.document.createElement("span");b.data("cke-bookmark",1);b.setStyle("display","none");b.setHtml("\x26nbsp;");a&&(d="cke_bm_"+CKEDITOR.tools.getNextNumber(),b.setAttribute("id",d+(k?"C":"S")));k||(c=b.clone(),c.setHtml("\x26nbsp;"),a&&c.setAttribute("id",d+"E"),f=this.clone(),f.collapse(),f.insertNode(c));f=this.clone();f.collapse(!0);f.insertNode(b);c?(this.setStartAfter(b),this.setEndBefore(c)):this.moveToPosition(b,CKEDITOR.POSITION_AFTER_END);return{startNode:a?d+(k?"C":"S"):b,endNode:a?d+"E":c,serializable:a,collapsed:k};},createBookmark2:function(){function a(b){var g=b.container,d=b.offset,f;f=g;var k=d;f=f.type!=CKEDITOR.NODE_ELEMENT||0===k||k==f.getChildCount()?0:f.getChild(k-1).type==CKEDITOR.NODE_TEXT&&f.getChild(k).type==CKEDITOR.NODE_TEXT;f&&(g=g.getChild(d-1),d=g.getLength());if(g.type==CKEDITOR.NODE_ELEMENT&&0<d){a:{for(f=g;d--;){if(k=f.getChild(d).getIndex(!0),0<=k){d=k;break a;}}d=-1;}d+=1;}if(g.type==CKEDITOR.NODE_TEXT){f=g;for(k=0;(f=f.getPrevious())&&f.type==CKEDITOR.NODE_TEXT;){k+=f.getText().replace(CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE,"").length;}f=k;g.getText()?d+=f:(k=g.getPrevious(c),f?(d=f,g=k?k.getNext():g.getParent().getFirst()):(g=g.getParent(),d=k?k.getIndex(!0)+1:0));}b.container=g;b.offset=d;}function b(a,g){var c=g.getCustomData("cke-fillingChar");if(c){var d=a.container;c.equals(d)&&(a.offset-=CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE.length,0>=a.offset&&(a.offset=d.getIndex(),a.container=d.getParent()));}}var c=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_TEXT,!0);return function(c){var d=this.collapsed,f={container:this.startContainer,offset:this.startOffset},k={container:this.endContainer,offset:this.endOffset};c&&(a(f),b(f,this.root),d||(a(k),b(k,this.root)));return{start:f.container.getAddress(c),end:d?null:k.container.getAddress(c),startOffset:f.offset,endOffset:k.offset,normalized:c,collapsed:d,is2:!0};};}(),moveToBookmark:function moveToBookmark(a){if(a.is2){var b=this.document.getByAddress(a.start,a.normalized),c=a.startOffset,d=a.end&&this.document.getByAddress(a.end,a.normalized);a=a.endOffset;this.setStart(b,c);d?this.setEnd(d,a):this.collapse(!0);}else b=(c=a.serializable)?this.document.getById(a.startNode):a.startNode,a=c?this.document.getById(a.endNode):a.endNode,this.setStartBefore(b),b.remove(),a?(this.setEndBefore(a),a.remove()):this.collapse(!0);},getBoundaryNodes:function getBoundaryNodes(){var a=this.startContainer,b=this.endContainer,c=this.startOffset,d=this.endOffset,f;if(a.type==CKEDITOR.NODE_ELEMENT)if(f=a.getChildCount(),f>c)a=a.getChild(c);else if(1>f)a=a.getPreviousSourceNode();else{for(a=a.$;a.lastChild;){a=a.lastChild;}a=new CKEDITOR.dom.node(a);a=a.getNextSourceNode()||a;}if(b.type==CKEDITOR.NODE_ELEMENT)if(f=b.getChildCount(),f>d)b=b.getChild(d).getPreviousSourceNode(!0);else if(1>f)b=b.getPreviousSourceNode();else{for(b=b.$;b.lastChild;){b=b.lastChild;}b=new CKEDITOR.dom.node(b);}a.getPosition(b)&CKEDITOR.POSITION_FOLLOWING&&(a=b);return{startNode:a,endNode:b};},getCommonAncestor:function getCommonAncestor(a,b){var c=this.startContainer,d=this.endContainer,c=c.equals(d)?a&&c.type==CKEDITOR.NODE_ELEMENT&&this.startOffset==this.endOffset-1?c.getChild(this.startOffset):c:c.getCommonAncestor(d);return b&&!c.is?c.getParent():c;},optimize:function optimize(){var a=this.startContainer,b=this.startOffset;a.type!=CKEDITOR.NODE_ELEMENT&&(b?b>=a.getLength()&&this.setStartAfter(a):this.setStartBefore(a));a=this.endContainer;b=this.endOffset;a.type!=CKEDITOR.NODE_ELEMENT&&(b?b>=a.getLength()&&this.setEndAfter(a):this.setEndBefore(a));},optimizeBookmark:function optimizeBookmark(){var a=this.startContainer,b=this.endContainer;a.is&&a.is("span")&&a.data("cke-bookmark")&&this.setStartAt(a,CKEDITOR.POSITION_BEFORE_START);b&&b.is&&b.is("span")&&b.data("cke-bookmark")&&this.setEndAt(b,CKEDITOR.POSITION_AFTER_END);},trim:function trim(a,b){var c=this.startContainer,d=this.startOffset,f=this.collapsed;if((!a||f)&&c&&c.type==CKEDITOR.NODE_TEXT){if(d){if(d>=c.getLength())d=c.getIndex()+1,c=c.getParent();else{var k=c.split(d),d=c.getIndex()+1,c=c.getParent();this.startContainer.equals(this.endContainer)?this.setEnd(k,this.endOffset-this.startOffset):c.equals(this.endContainer)&&(this.endOffset+=1);}}else d=c.getIndex(),c=c.getParent();this.setStart(c,d);if(f){this.collapse(!0);return;}}c=this.endContainer;d=this.endOffset;b||f||!c||c.type!=CKEDITOR.NODE_TEXT||(d?(d>=c.getLength()||c.split(d),d=c.getIndex()+1):d=c.getIndex(),c=c.getParent(),this.setEnd(c,d));},enlarge:function enlarge(a,b){function c(a){return a&&a.type==CKEDITOR.NODE_ELEMENT&&a.hasAttribute("contenteditable")?null:a;}var d=new RegExp(/[^\s\ufeff]/);switch(a){case CKEDITOR.ENLARGE_INLINE:var f=1;case CKEDITOR.ENLARGE_ELEMENT:var k=function k(a,b){var c=new CKEDITOR.dom.range(e);c.setStart(a,b);c.setEndAt(e,CKEDITOR.POSITION_BEFORE_END);var c=new CKEDITOR.dom.walker(c),g;for(c.guard=function(a){return!(a.type==CKEDITOR.NODE_ELEMENT&&a.isBlockBoundary());};g=c.next();){if(g.type!=CKEDITOR.NODE_TEXT)return!1;C=g!=a?g.getText():g.substring(b);if(d.test(C))return!1;}return!0;};if(this.collapsed)break;var h=this.getCommonAncestor(),e=this.root,l,m,u,x,D,y=!1,B,C;B=this.startContainer;var F=this.startOffset;B.type==CKEDITOR.NODE_TEXT?(F&&(B=!CKEDITOR.tools.trim(B.substring(0,F)).length&&B,y=!!B),B&&((x=B.getPrevious())||(u=B.getParent()))):(F&&(x=B.getChild(F-1)||B.getLast()),x||(u=B));for(u=c(u);u||x;){if(u&&!x){!D&&u.equals(h)&&(D=!0);if(f?u.isBlockBoundary():!e.contains(u))break;y&&"inline"==u.getComputedStyle("display")||(y=!1,D?l=u:this.setStartBefore(u));x=u.getPrevious();}for(;x;){if(B=!1,x.type==CKEDITOR.NODE_COMMENT)x=x.getPrevious();else{if(x.type==CKEDITOR.NODE_TEXT)C=x.getText(),d.test(C)&&(x=null),B=/[\s\ufeff]$/.test(C);else if((x.$.offsetWidth>(CKEDITOR.env.webkit?1:0)||b&&x.is("br"))&&!x.data("cke-bookmark"))if(y&&CKEDITOR.dtd.$removeEmpty[x.getName()]){C=x.getText();if(d.test(C))x=null;else for(var F=x.$.getElementsByTagName("*"),E=0,J;J=F[E++];){if(!CKEDITOR.dtd.$removeEmpty[J.nodeName.toLowerCase()]){x=null;break;}}x&&(B=!!C.length);}else x=null;B&&(y?D?l=u:u&&this.setStartBefore(u):y=!0);if(x){B=x.getPrevious();if(!u&&!B){u=x;x=null;break;}x=B;}else u=null;}}u&&(u=c(u.getParent()));}B=this.endContainer;F=this.endOffset;u=x=null;D=y=!1;B.type==CKEDITOR.NODE_TEXT?CKEDITOR.tools.trim(B.substring(F)).length?y=!0:(y=!B.getLength(),F==B.getLength()?(x=B.getNext())||(u=B.getParent()):k(B,F)&&(u=B.getParent())):(x=B.getChild(F))||(u=B);for(;u||x;){if(u&&!x){!D&&u.equals(h)&&(D=!0);if(f?u.isBlockBoundary():!e.contains(u))break;y&&"inline"==u.getComputedStyle("display")||(y=!1,D?m=u:u&&this.setEndAfter(u));x=u.getNext();}for(;x;){B=!1;if(x.type==CKEDITOR.NODE_TEXT)C=x.getText(),k(x,0)||(x=null),B=/^[\s\ufeff]/.test(C);else if(x.type==CKEDITOR.NODE_ELEMENT){if((0<x.$.offsetWidth||b&&x.is("br"))&&!x.data("cke-bookmark"))if(y&&CKEDITOR.dtd.$removeEmpty[x.getName()]){C=x.getText();if(d.test(C))x=null;else for(F=x.$.getElementsByTagName("*"),E=0;J=F[E++];){if(!CKEDITOR.dtd.$removeEmpty[J.nodeName.toLowerCase()]){x=null;break;}}x&&(B=!!C.length);}else x=null;}else B=1;B&&y&&(D?m=u:this.setEndAfter(u));if(x){B=x.getNext();if(!u&&!B){u=x;x=null;break;}x=B;}else u=null;}u&&(u=c(u.getParent()));}l&&m&&(h=l.contains(m)?m:l,this.setStartBefore(h),this.setEndAfter(h));break;case CKEDITOR.ENLARGE_BLOCK_CONTENTS:case CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:u=new CKEDITOR.dom.range(this.root);e=this.root;u.setStartAt(e,CKEDITOR.POSITION_AFTER_START);u.setEnd(this.startContainer,this.startOffset);u=new CKEDITOR.dom.walker(u);var G,M,I=CKEDITOR.dom.walker.blockBoundary(a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS?{br:1}:null),H=null,R=function R(a){if(a.type==CKEDITOR.NODE_ELEMENT&&"false"==a.getAttribute("contenteditable")){if(H){if(H.equals(a)){H=null;return;}}else H=a;}else if(H)return;var b=I(a);b||(G=a);return b;},f=function f(a){var b=R(a);!b&&a.is&&a.is("br")&&(M=a);return b;};u.guard=R;u=u.lastBackward();G=G||e;this.setStartAt(G,!G.is("br")&&(!u&&this.checkStartOfBlock()||u&&G.contains(u))?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_AFTER_END);if(a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS){u=this.clone();u=new CKEDITOR.dom.walker(u);var P=CKEDITOR.dom.walker.whitespaces(),T=CKEDITOR.dom.walker.bookmark();u.evaluator=function(a){return!P(a)&&!T(a);};if((u=u.previous())&&u.type==CKEDITOR.NODE_ELEMENT&&u.is("br"))break;}u=this.clone();u.collapse();u.setEndAt(e,CKEDITOR.POSITION_BEFORE_END);u=new CKEDITOR.dom.walker(u);u.guard=a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS?f:R;G=H=M=null;u=u.lastForward();G=G||e;this.setEndAt(G,!u&&this.checkEndOfBlock()||u&&G.contains(u)?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_BEFORE_START);M&&this.setEndAfter(M);}},shrink:function shrink(a,b,c){if(!this.collapsed){a=a||CKEDITOR.SHRINK_TEXT;var d=this.clone(),f=this.startContainer,k=this.endContainer,h=this.startOffset,e=this.endOffset,l=1,m=1;f&&f.type==CKEDITOR.NODE_TEXT&&(h?h>=f.getLength()?d.setStartAfter(f):(d.setStartBefore(f),l=0):d.setStartBefore(f));k&&k.type==CKEDITOR.NODE_TEXT&&(e?e>=k.getLength()?d.setEndAfter(k):(d.setEndAfter(k),m=0):d.setEndBefore(k));var d=new CKEDITOR.dom.walker(d),u=CKEDITOR.dom.walker.bookmark();d.evaluator=function(b){return b.type==(a==CKEDITOR.SHRINK_ELEMENT?CKEDITOR.NODE_ELEMENT:CKEDITOR.NODE_TEXT);};var x;d.guard=function(b,d){if(u(b))return!0;if(a==CKEDITOR.SHRINK_ELEMENT&&b.type==CKEDITOR.NODE_TEXT||d&&b.equals(x)||!1===c&&b.type==CKEDITOR.NODE_ELEMENT&&b.isBlockBoundary()||b.type==CKEDITOR.NODE_ELEMENT&&b.hasAttribute("contenteditable"))return!1;d||b.type!=CKEDITOR.NODE_ELEMENT||(x=b);return!0;};l&&(f=d[a==CKEDITOR.SHRINK_ELEMENT?"lastForward":"next"]())&&this.setStartAt(f,b?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_START);m&&(d.reset(),(d=d[a==CKEDITOR.SHRINK_ELEMENT?"lastBackward":"previous"]())&&this.setEndAt(d,b?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_AFTER_END));return!(!l&&!m);}},insertNode:function insertNode(a){this.optimizeBookmark();this.trim(!1,!0);var b=this.startContainer,c=b.getChild(this.startOffset);c?a.insertBefore(c):b.append(a);a.getParent()&&a.getParent().equals(this.endContainer)&&this.endOffset++;this.setStartBefore(a);},moveToPosition:function moveToPosition(a,b){this.setStartAt(a,b);this.collapse(!0);},moveToRange:function moveToRange(a){this.setStart(a.startContainer,a.startOffset);this.setEnd(a.endContainer,a.endOffset);},selectNodeContents:function selectNodeContents(a){this.setStart(a,0);this.setEnd(a,a.type==CKEDITOR.NODE_TEXT?a.getLength():a.getChildCount());},setStart:function setStart(b,c){b.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$empty[b.getName()]&&(c=b.getIndex(),b=b.getParent());this._setStartContainer(b);this.startOffset=c;this.endContainer||(this._setEndContainer(b),this.endOffset=c);a(this);},setEnd:function setEnd(b,c){b.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$empty[b.getName()]&&(c=b.getIndex()+1,b=b.getParent());this._setEndContainer(b);this.endOffset=c;this.startContainer||(this._setStartContainer(b),this.startOffset=c);a(this);},setStartAfter:function setStartAfter(a){this.setStart(a.getParent(),a.getIndex()+1);},setStartBefore:function setStartBefore(a){this.setStart(a.getParent(),a.getIndex());},setEndAfter:function setEndAfter(a){this.setEnd(a.getParent(),a.getIndex()+1);},setEndBefore:function setEndBefore(a){this.setEnd(a.getParent(),a.getIndex());},setStartAt:function setStartAt(b,c){switch(c){case CKEDITOR.POSITION_AFTER_START:this.setStart(b,0);break;case CKEDITOR.POSITION_BEFORE_END:b.type==CKEDITOR.NODE_TEXT?this.setStart(b,b.getLength()):this.setStart(b,b.getChildCount());break;case CKEDITOR.POSITION_BEFORE_START:this.setStartBefore(b);break;case CKEDITOR.POSITION_AFTER_END:this.setStartAfter(b);}a(this);},setEndAt:function setEndAt(b,c){switch(c){case CKEDITOR.POSITION_AFTER_START:this.setEnd(b,0);break;case CKEDITOR.POSITION_BEFORE_END:b.type==CKEDITOR.NODE_TEXT?this.setEnd(b,b.getLength()):this.setEnd(b,b.getChildCount());break;case CKEDITOR.POSITION_BEFORE_START:this.setEndBefore(b);break;case CKEDITOR.POSITION_AFTER_END:this.setEndAfter(b);}a(this);},fixBlock:function fixBlock(a,b){var c=this.createBookmark(),d=this.document.createElement(b);this.collapse(a);this.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS);this.extractContents().appendTo(d);d.trim();this.insertNode(d);var f=d.getBogus();f&&f.remove();d.appendBogus();this.moveToBookmark(c);return d;},splitBlock:function splitBlock(a,b){var c=new CKEDITOR.dom.elementPath(this.startContainer,this.root),d=new CKEDITOR.dom.elementPath(this.endContainer,this.root),f=c.block,k=d.block,h=null;if(!c.blockLimit.equals(d.blockLimit))return null;"br"!=a&&(f||(f=this.fixBlock(!0,a),k=new CKEDITOR.dom.elementPath(this.endContainer,this.root).block),k||(k=this.fixBlock(!1,a)));c=f&&this.checkStartOfBlock();d=k&&this.checkEndOfBlock();this.deleteContents();f&&f.equals(k)&&(d?(h=new CKEDITOR.dom.elementPath(this.startContainer,this.root),this.moveToPosition(k,CKEDITOR.POSITION_AFTER_END),k=null):c?(h=new CKEDITOR.dom.elementPath(this.startContainer,this.root),this.moveToPosition(f,CKEDITOR.POSITION_BEFORE_START),f=null):(k=this.splitElement(f,b||!1),f.is("ul","ol")||f.appendBogus()));return{previousBlock:f,nextBlock:k,wasStartOfBlock:c,wasEndOfBlock:d,elementPath:h};},splitElement:function splitElement(a,b){if(!this.collapsed)return null;this.setEndAt(a,CKEDITOR.POSITION_BEFORE_END);var c=this.extractContents(!1,b||!1),d=a.clone(!1,b||!1);c.appendTo(d);d.insertAfter(a);this.moveToPosition(a,CKEDITOR.POSITION_AFTER_END);return d;},removeEmptyBlocksAtEnd:function(){function a(g){return function(a){return b(a)||c(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.isEmptyInlineRemoveable()||g.is("table")&&a.is("caption")?!1:!0;};}var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(!1);return function(b){for(var c=this.createBookmark(),d=this[b?"endPath":"startPath"](),f=d.block||d.blockLimit,k;f&&!f.equals(d.root)&&!f.getFirst(a(f));){k=f.getParent(),this[b?"setEndAt":"setStartAt"](f,CKEDITOR.POSITION_AFTER_END),f.remove(1),f=k;}this.moveToBookmark(c);};}(),startPath:function startPath(){return new CKEDITOR.dom.elementPath(this.startContainer,this.root);},endPath:function endPath(){return new CKEDITOR.dom.elementPath(this.endContainer,this.root);},checkBoundaryOfElement:function checkBoundaryOfElement(a,b){var d=b==CKEDITOR.START,f=this.clone();f.collapse(d);f[d?"setStartAt":"setEndAt"](a,d?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_END);f=new CKEDITOR.dom.walker(f);f.evaluator=c(d);return f[d?"checkBackward":"checkForward"]();},checkStartOfBlock:function checkStartOfBlock(){var a=this.startContainer,c=this.startOffset;CKEDITOR.env.ie&&c&&a.type==CKEDITOR.NODE_TEXT&&(a=CKEDITOR.tools.ltrim(a.substring(0,c)),f.test(a)&&this.trim(0,1));this.trim();a=new CKEDITOR.dom.elementPath(this.startContainer,this.root);c=this.clone();c.collapse(!0);c.setStartAt(a.block||a.blockLimit,CKEDITOR.POSITION_AFTER_START);a=new CKEDITOR.dom.walker(c);a.evaluator=b();return a.checkBackward();},checkEndOfBlock:function checkEndOfBlock(){var a=this.endContainer,c=this.endOffset;CKEDITOR.env.ie&&a.type==CKEDITOR.NODE_TEXT&&(a=CKEDITOR.tools.rtrim(a.substring(c)),f.test(a)&&this.trim(1,0));this.trim();a=new CKEDITOR.dom.elementPath(this.endContainer,this.root);c=this.clone();c.collapse(!1);c.setEndAt(a.block||a.blockLimit,CKEDITOR.POSITION_BEFORE_END);a=new CKEDITOR.dom.walker(c);a.evaluator=b();return a.checkForward();},getPreviousNode:function getPreviousNode(a,b,c){var d=this.clone();d.collapse(1);d.setStartAt(c||this.root,CKEDITOR.POSITION_AFTER_START);c=new CKEDITOR.dom.walker(d);c.evaluator=a;c.guard=b;return c.previous();},getNextNode:function getNextNode(a,b,c){var d=this.clone();d.collapse();d.setEndAt(c||this.root,CKEDITOR.POSITION_BEFORE_END);c=new CKEDITOR.dom.walker(d);c.evaluator=a;c.guard=b;return c.next();},checkReadOnly:function(){function a(b,c){for(;b;){if(b.type==CKEDITOR.NODE_ELEMENT){if("false"==b.getAttribute("contentEditable")&&!b.data("cke-editable"))return 0;if(b.is("html")||"true"==b.getAttribute("contentEditable")&&(b.contains(c)||b.equals(c)))break;}b=b.getParent();}return 1;}return function(){var b=this.startContainer,c=this.endContainer;return!(a(b,c)&&a(c,b));};}(),moveToElementEditablePosition:function moveToElementEditablePosition(a,b){if(a.type==CKEDITOR.NODE_ELEMENT&&!a.isEditable(!1))return this.moveToPosition(a,b?CKEDITOR.POSITION_AFTER_END:CKEDITOR.POSITION_BEFORE_START),!0;for(var c=0;a;){if(a.type==CKEDITOR.NODE_TEXT){b&&this.endContainer&&this.checkEndOfBlock()&&f.test(a.getText())?this.moveToPosition(a,CKEDITOR.POSITION_BEFORE_START):this.moveToPosition(a,b?CKEDITOR.POSITION_AFTER_END:CKEDITOR.POSITION_BEFORE_START);c=1;break;}if(a.type==CKEDITOR.NODE_ELEMENT)if(a.isEditable())this.moveToPosition(a,b?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_AFTER_START),c=1;else if(b&&a.is("br")&&this.endContainer&&this.checkEndOfBlock())this.moveToPosition(a,CKEDITOR.POSITION_BEFORE_START);else if("false"==a.getAttribute("contenteditable")&&a.is(CKEDITOR.dtd.$block))return this.setStartBefore(a),this.setEndAfter(a),!0;var d=a,h=c,e=void 0;d.type==CKEDITOR.NODE_ELEMENT&&d.isEditable(!1)&&(e=d[b?"getLast":"getFirst"](k));h||e||(e=d[b?"getPrevious":"getNext"](k));a=e;}return!!c;},moveToClosestEditablePosition:function moveToClosestEditablePosition(a,b){var c,d=0,f,k,h=[CKEDITOR.POSITION_AFTER_END,CKEDITOR.POSITION_BEFORE_START];a?(c=new CKEDITOR.dom.range(this.root),c.moveToPosition(a,h[b?0:1])):c=this.clone();if(a&&!a.is(CKEDITOR.dtd.$block))d=1;else if(f=c[b?"getNextEditableNode":"getPreviousEditableNode"]())d=1,(k=f.type==CKEDITOR.NODE_ELEMENT)&&f.is(CKEDITOR.dtd.$block)&&"false"==f.getAttribute("contenteditable")?(c.setStartAt(f,CKEDITOR.POSITION_BEFORE_START),c.setEndAt(f,CKEDITOR.POSITION_AFTER_END)):!CKEDITOR.env.needsBrFiller&&k&&f.is(CKEDITOR.dom.walker.validEmptyBlockContainers)?(c.setEnd(f,0),c.collapse()):c.moveToPosition(f,h[b?1:0]);d&&this.moveToRange(c);return!!d;},moveToElementEditStart:function moveToElementEditStart(a){return this.moveToElementEditablePosition(a);},moveToElementEditEnd:function moveToElementEditEnd(a){return this.moveToElementEditablePosition(a,!0);},getEnclosedNode:function getEnclosedNode(){var a=this.clone();a.optimize();if(a.startContainer.type!=CKEDITOR.NODE_ELEMENT||a.endContainer.type!=CKEDITOR.NODE_ELEMENT)return null;var a=new CKEDITOR.dom.walker(a),b=CKEDITOR.dom.walker.bookmark(!1,!0),c=CKEDITOR.dom.walker.whitespaces(!0);a.evaluator=function(a){return c(a)&&b(a);};var d=a.next();a.reset();return d&&d.equals(a.previous())?d:null;},getTouchedStartNode:function getTouchedStartNode(){var a=this.startContainer;return this.collapsed||a.type!=CKEDITOR.NODE_ELEMENT?a:a.getChild(this.startOffset)||a;},getTouchedEndNode:function getTouchedEndNode(){var a=this.endContainer;return this.collapsed||a.type!=CKEDITOR.NODE_ELEMENT?a:a.getChild(this.endOffset-1)||a;},getNextEditableNode:d(),getPreviousEditableNode:d(1),scrollIntoView:function scrollIntoView(){var a=new CKEDITOR.dom.element.createFromHtml("\x3cspan\x3e\x26nbsp;\x3c/span\x3e",this.document),b,c,d,f=this.clone();f.optimize();(d=f.startContainer.type==CKEDITOR.NODE_TEXT)?(c=f.startContainer.getText(),b=f.startContainer.split(f.startOffset),a.insertAfter(f.startContainer)):f.insertNode(a);a.scrollIntoView();d&&(f.startContainer.setText(c),b.remove());a.remove();},_setStartContainer:function _setStartContainer(a){this.startContainer=a;},_setEndContainer:function _setEndContainer(a){this.endContainer=a;},_find:function _find(a,b){var c=this.getCommonAncestor(),d=this.getBoundaryNodes(),f=[],k,h,e,l;if(c&&c.find)for(h=c.find(a),k=0;k<h.count();k++){if(c=h.getItem(k),b||!c.isReadOnly())e=c.getPosition(d.startNode)&CKEDITOR.POSITION_FOLLOWING||d.startNode.equals(c),l=c.getPosition(d.endNode)&CKEDITOR.POSITION_PRECEDING+CKEDITOR.POSITION_IS_CONTAINED,e&&l&&f.push(c);}return f;}};}(),CKEDITOR.POSITION_AFTER_START=1,CKEDITOR.POSITION_BEFORE_END=2,CKEDITOR.POSITION_BEFORE_START=3,CKEDITOR.POSITION_AFTER_END=4,CKEDITOR.ENLARGE_ELEMENT=1,CKEDITOR.ENLARGE_BLOCK_CONTENTS=2,CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS=3,CKEDITOR.ENLARGE_INLINE=4,CKEDITOR.START=1,CKEDITOR.END=2,CKEDITOR.SHRINK_ELEMENT=1,CKEDITOR.SHRINK_TEXT=2,"use strict",function(){function a(a){1>arguments.length||(this.range=a,this.forceBrBreak=0,this.enlargeBr=1,this.enforceRealBlocks=0,this._||(this._={}));}function e(a){var b=[];a.forEach(function(a){if("true"==a.getAttribute("contenteditable"))return b.push(a),!1;},CKEDITOR.NODE_ELEMENT,!0);return b;}function b(a,c,d,f){a:{null==f&&(f=e(d));for(var h;h=f.shift();){if(h.getDtd().p){f={element:h,remaining:f};break a;}}f=null;}if(!f)return 0;if((h=CKEDITOR.filter.instances[f.element.data("cke-filter")])&&!h.check(c))return b(a,c,d,f.remaining);c=new CKEDITOR.dom.range(f.element);c.selectNodeContents(f.element);c=c.createIterator();c.enlargeBr=a.enlargeBr;c.enforceRealBlocks=a.enforceRealBlocks;c.activeFilter=c.filter=h;a._.nestedEditable={element:f.element,container:d,remaining:f.remaining,iterator:c};return 1;}function c(a,b,c){if(!b)return!1;a=a.clone();a.collapse(!c);return a.checkBoundaryOfElement(b,c?CKEDITOR.START:CKEDITOR.END);}var d=/^[\r\n\t ]+$/,l=CKEDITOR.dom.walker.bookmark(!1,!0),m=CKEDITOR.dom.walker.whitespaces(!0),f=function f(a){return l(a)&&m(a);},h={dd:1,dt:1,li:1};a.prototype={getNextParagraph:function getNextParagraph(a){var g,e,m,r,q;a=a||"p";if(this._.nestedEditable){if(g=this._.nestedEditable.iterator.getNextParagraph(a))return this.activeFilter=this._.nestedEditable.iterator.activeFilter,g;this.activeFilter=this.filter;if(b(this,a,this._.nestedEditable.container,this._.nestedEditable.remaining))return this.activeFilter=this._.nestedEditable.iterator.activeFilter,this._.nestedEditable.iterator.getNextParagraph(a);this._.nestedEditable=null;}if(!this.range.root.getDtd()[a])return null;if(!this._.started){var t=this.range.clone();e=t.startPath();var p=t.endPath(),w=!t.collapsed&&c(t,e.block),z=!t.collapsed&&c(t,p.block,1);t.shrink(CKEDITOR.SHRINK_ELEMENT,!0);w&&t.setStartAt(e.block,CKEDITOR.POSITION_BEFORE_END);z&&t.setEndAt(p.block,CKEDITOR.POSITION_AFTER_START);e=t.endContainer.hasAscendant("pre",!0)||t.startContainer.hasAscendant("pre",!0);t.enlarge(this.forceBrBreak&&!e||!this.enlargeBr?CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:CKEDITOR.ENLARGE_BLOCK_CONTENTS);t.collapsed||(e=new CKEDITOR.dom.walker(t.clone()),p=CKEDITOR.dom.walker.bookmark(!0,!0),e.evaluator=p,this._.nextNode=e.next(),e=new CKEDITOR.dom.walker(t.clone()),e.evaluator=p,e=e.previous(),this._.lastNode=e.getNextSourceNode(!0,null,t.root),this._.lastNode&&this._.lastNode.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.trim(this._.lastNode.getText())&&this._.lastNode.getParent().isBlockBoundary()&&(p=this.range.clone(),p.moveToPosition(this._.lastNode,CKEDITOR.POSITION_AFTER_END),p.checkEndOfBlock()&&(p=new CKEDITOR.dom.elementPath(p.endContainer,p.root),this._.lastNode=(p.block||p.blockLimit).getNextSourceNode(!0))),this._.lastNode&&t.root.contains(this._.lastNode)||(this._.lastNode=this._.docEndMarker=t.document.createText(""),this._.lastNode.insertAfter(e)),t=null);this._.started=1;e=t;}p=this._.nextNode;t=this._.lastNode;for(this._.nextNode=null;p;){var w=0,z=p.hasAscendant("pre"),A=p.type!=CKEDITOR.NODE_ELEMENT,u=0;if(A)p.type==CKEDITOR.NODE_TEXT&&d.test(p.getText())&&(A=0);else{var x=p.getName();if(CKEDITOR.dtd.$block[x]&&"false"==p.getAttribute("contenteditable")){g=p;b(this,a,g);break;}else if(p.isBlockBoundary(this.forceBrBreak&&!z&&{br:1})){if("br"==x)A=1;else if(!e&&!p.getChildCount()&&"hr"!=x){g=p;m=p.equals(t);break;}e&&(e.setEndAt(p,CKEDITOR.POSITION_BEFORE_START),"br"!=x&&(this._.nextNode=p));w=1;}else{if(p.getFirst()){e||(e=this.range.clone(),e.setStartAt(p,CKEDITOR.POSITION_BEFORE_START));p=p.getFirst();continue;}A=1;}}A&&!e&&(e=this.range.clone(),e.setStartAt(p,CKEDITOR.POSITION_BEFORE_START));m=(!w||A)&&p.equals(t);if(e&&!w)for(;!p.getNext(f)&&!m;){x=p.getParent();if(x.isBlockBoundary(this.forceBrBreak&&!z&&{br:1})){w=1;A=0;m||x.equals(t);e.setEndAt(x,CKEDITOR.POSITION_BEFORE_END);break;}p=x;A=1;m=p.equals(t);u=1;}A&&e.setEndAt(p,CKEDITOR.POSITION_AFTER_END);p=this._getNextSourceNode(p,u,t);if((m=!p)||w&&e)break;}if(!g){if(!e)return this._.docEndMarker&&this._.docEndMarker.remove(),this._.nextNode=null;g=new CKEDITOR.dom.elementPath(e.startContainer,e.root);p=g.blockLimit;w={div:1,th:1,td:1};g=g.block;!g&&p&&!this.enforceRealBlocks&&w[p.getName()]&&e.checkStartOfBlock()&&e.checkEndOfBlock()&&!p.equals(e.root)?g=p:!g||this.enforceRealBlocks&&g.is(h)?(g=this.range.document.createElement(a),e.extractContents().appendTo(g),g.trim(),e.insertNode(g),r=q=!0):"li"!=g.getName()?e.checkStartOfBlock()&&e.checkEndOfBlock()||(g=g.clone(!1),e.extractContents().appendTo(g),g.trim(),q=e.splitBlock(),r=!q.wasStartOfBlock,q=!q.wasEndOfBlock,e.insertNode(g)):m||(this._.nextNode=g.equals(t)?null:this._getNextSourceNode(e.getBoundaryNodes().endNode,1,t));}r&&(r=g.getPrevious())&&r.type==CKEDITOR.NODE_ELEMENT&&("br"==r.getName()?r.remove():r.getLast()&&"br"==r.getLast().$.nodeName.toLowerCase()&&r.getLast().remove());q&&(r=g.getLast())&&r.type==CKEDITOR.NODE_ELEMENT&&"br"==r.getName()&&(!CKEDITOR.env.needsBrFiller||r.getPrevious(l)||r.getNext(l))&&r.remove();this._.nextNode||(this._.nextNode=m||g.equals(t)||!t?null:this._getNextSourceNode(g,1,t));return g;},_getNextSourceNode:function _getNextSourceNode(a,b,c){function d(a){return!(a.equals(c)||a.equals(f));}var f=this.range.root;for(a=a.getNextSourceNode(b,null,d);!l(a);){a=a.getNextSourceNode(b,null,d);}return a;}};CKEDITOR.dom.range.prototype.createIterator=function(){return new a(this);};}(),CKEDITOR.command=function(a,e){this.uiItems=[];this.exec=function(b){if(this.state==CKEDITOR.TRISTATE_DISABLED||!this.checkAllowed())return!1;this.editorFocus&&a.focus();return!1===this.fire("exec")?!0:!1!==e.exec.call(this,a,b);};this.refresh=function(a,b){if(!this.readOnly&&a.readOnly)return!0;if(this.context&&!b.isContextFor(this.context)||!this.checkAllowed(!0))return this.disable(),!0;this.startDisabled||this.enable();this.modes&&!this.modes[a.mode]&&this.disable();return!1===this.fire("refresh",{editor:a,path:b})?!0:e.refresh&&!1!==e.refresh.apply(this,arguments);};var b;this.checkAllowed=function(c){return c||"boolean"!=typeof b?b=a.activeFilter.checkFeature(this):b;};CKEDITOR.tools.extend(this,e,{modes:{wysiwyg:1},editorFocus:1,contextSensitive:!!e.context,state:CKEDITOR.TRISTATE_DISABLED});CKEDITOR.event.call(this);},CKEDITOR.command.prototype={enable:function enable(){this.state==CKEDITOR.TRISTATE_DISABLED&&this.checkAllowed()&&this.setState(this.preserveState&&"undefined"!=typeof this.previousState?this.previousState:CKEDITOR.TRISTATE_OFF);},disable:function disable(){this.setState(CKEDITOR.TRISTATE_DISABLED);},setState:function setState(a){if(this.state==a||a!=CKEDITOR.TRISTATE_DISABLED&&!this.checkAllowed())return!1;this.previousState=this.state;this.state=a;this.fire("state");return!0;},toggleState:function toggleState(){this.state==CKEDITOR.TRISTATE_OFF?this.setState(CKEDITOR.TRISTATE_ON):this.state==CKEDITOR.TRISTATE_ON&&this.setState(CKEDITOR.TRISTATE_OFF);}},CKEDITOR.event.implementOn(CKEDITOR.command.prototype),CKEDITOR.ENTER_P=1,CKEDITOR.ENTER_BR=2,CKEDITOR.ENTER_DIV=3,CKEDITOR.config={customConfig:"config.js",autoUpdateElement:!0,language:"",defaultLanguage:"en",contentsLangDirection:"",enterMode:CKEDITOR.ENTER_P,forceEnterMode:!1,shiftEnterMode:CKEDITOR.ENTER_BR,docType:"\x3c!DOCTYPE html\x3e",bodyId:"",bodyClass:"",fullPage:!1,height:200,contentsCss:CKEDITOR.getUrl("contents.css"),extraPlugins:"",removePlugins:"",protectedSource:[],tabIndex:0,width:"",baseFloatZIndex:1E4,blockedKeystrokes:[CKEDITOR.CTRL+66,CKEDITOR.CTRL+73,CKEDITOR.CTRL+85]},function(){function a(a,b,c,d,f){var g,e;a=[];for(g in b){e=b[g];e="boolean"==typeof e?{}:"function"==typeof e?{match:e}:E(e);"$"!=g.charAt(0)&&(e.elements=g);c&&(e.featureName=c.toLowerCase());var k=e;k.elements=m(k.elements,/\s+/)||null;k.propertiesOnly=k.propertiesOnly||!0===k.elements;var h=/\s*,\s*/,l=void 0;for(l in M){k[l]=m(k[l],h)||null;var u=k,t=I[l],x=m(k[I[l]],h),A=k[l],p=[],D=!0,n=void 0;x?D=!1:x={};for(n in A){"!"==n.charAt(0)&&(n=n.slice(1),p.push(n),x[n]=!0,D=!1);}for(;n=p.pop();){A[n]=A["!"+n],delete A["!"+n];}u[t]=(D?!1:x)||null;}k.match=k.match||null;d.push(e);a.push(e);}b=f.elements;f=f.generic;var H;c=0;for(d=a.length;c<d;++c){g=E(a[c]);e=!0===g.classes||!0===g.styles||!0===g.attributes;k=g;l=t=h=void 0;for(h in M){k[h]=w(k[h]);}u=!0;for(l in I){h=I[l];t=k[h];x=[];A=void 0;for(A in t){-1<A.indexOf("*")?x.push(new RegExp("^"+A.replace(/\*/g,".*")+"$")):x.push(A);}t=x;t.length&&(k[h]=t,u=!1);}k.nothingRequired=u;k.noProperties=!(k.attributes||k.classes||k.styles);if(!0===g.elements||null===g.elements)f[e?"unshift":"push"](g);else for(H in k=g.elements,delete g.elements,k){if(b[H])b[H][e?"unshift":"push"](g);else b[H]=[g];}}}function e(a,c,d,g){if(!a.match||a.match(c))if(g||f(a,c))if(a.propertiesOnly||(d.valid=!0),d.allAttributes||(d.allAttributes=b(a.attributes,c.attributes,d.validAttributes)),d.allStyles||(d.allStyles=b(a.styles,c.styles,d.validStyles)),!d.allClasses){a=a.classes;c=c.classes;g=d.validClasses;if(a){if(!0===a)a=!0;else{for(var e=0,k=c.length,h;e<k;++e){h=c[e],g[h]||(g[h]=a(h));}a=!1;}}else a=!1;d.allClasses=a;}}function b(a,b,c){if(!a)return!1;if(!0===a)return!0;for(var d in b){c[d]||(c[d]=a(d));}return!1;}function c(a,b,c){if(!a.match||a.match(b)){if(a.noProperties)return!1;c.hadInvalidAttribute=d(a.attributes,b.attributes)||c.hadInvalidAttribute;c.hadInvalidStyle=d(a.styles,b.styles)||c.hadInvalidStyle;a=a.classes;b=b.classes;if(a){for(var f=!1,g=!0===a,e=b.length;e--;){if(g||a(b[e]))b.splice(e,1),f=!0;}a=f;}else a=!1;c.hadInvalidClass=a||c.hadInvalidClass;}}function d(a,b){if(!a)return!1;var c=!1,d=!0===a,f;for(f in b){if(d||a(f))delete b[f],c=!0;}return c;}function l(a,b,c){if(a.disabled||a.customConfig&&!c||!b)return!1;a._.cachedChecks={};return!0;}function m(a,b){if(!a)return!1;if(!0===a)return a;if("string"==typeof a)return a=J(a),"*"==a?!0:CKEDITOR.tools.convertArrayToObject(a.split(b));if(CKEDITOR.tools.isArray(a))return a.length?CKEDITOR.tools.convertArrayToObject(a):!1;var c={},d=0,f;for(f in a){c[f]=a[f],d++;}return d?c:!1;}function f(a,b){if(a.nothingRequired)return!0;var c,d,f,g;if(f=a.requiredClasses)for(g=b.classes,c=0;c<f.length;++c){if(d=f[c],"string"==typeof d){if(-1==CKEDITOR.tools.indexOf(g,d))return!1;}else if(!CKEDITOR.tools.checkIfAnyArrayItemMatches(g,d))return!1;}return h(b.styles,a.requiredStyles)&&h(b.attributes,a.requiredAttributes);}function h(a,b){if(!b)return!0;for(var c=0,d;c<b.length;++c){if(d=b[c],"string"==typeof d){if(!(d in a))return!1;}else if(!CKEDITOR.tools.checkIfAnyObjectPropertyMatches(a,d))return!1;}return!0;}function k(a){if(!a)return{};a=a.split(/\s*,\s*/).sort();for(var b={};a.length;){b[a.shift()]="cke-test";}return b;}function g(a){var b,c,d,f,g={},e=1;for(a=J(a);b=a.match(H);){(c=b[2])?(d=n(c,"styles"),f=n(c,"attrs"),c=n(c,"classes")):d=f=c=null,g["$"+e++]={elements:b[1],classes:c,styles:d,attributes:f},a=a.slice(b[0].length);}return g;}function n(a,b){var c=a.match(R[b]);return c?J(c[1]):null;}function v(a){var b=a.styleBackup=a.attributes.style,c=a.classBackup=a.attributes["class"];a.styles||(a.styles=CKEDITOR.tools.parseCssText(b||"",1));a.classes||(a.classes=c?c.split(/\s+/):[]);}function r(a,b,d,f){var g=0,k;f.toHtml&&(b.name=b.name.replace(P,"$1"));if(f.doCallbacks&&a.elementCallbacks){a:{k=a.elementCallbacks;for(var h=0,l=k.length,u;h<l;++h){if(u=k[h](b)){k=u;break a;}}k=void 0;}if(k)return k;}if(f.doTransform&&(k=a._.transformations[b.name])){v(b);for(h=0;h<k.length;++h){x(a,b,k[h]);}t(b);}if(f.doFilter){a:{h=b.name;l=a._;a=l.allowedRules.elements[h];k=l.allowedRules.generic;h=l.disallowedRules.elements[h];l=l.disallowedRules.generic;u=f.skipRequired;var m={valid:!1,validAttributes:{},validClasses:{},validStyles:{},allAttributes:!1,allClasses:!1,allStyles:!1,hadInvalidAttribute:!1,hadInvalidClass:!1,hadInvalidStyle:!1},A,n;if(a||k){v(b);if(h)for(A=0,n=h.length;A<n;++A){if(!1===c(h[A],b,m)){a=null;break a;}}if(l)for(A=0,n=l.length;A<n;++A){c(l[A],b,m);}if(a)for(A=0,n=a.length;A<n;++A){e(a[A],b,m,u);}if(k)for(A=0,n=k.length;A<n;++A){e(k[A],b,m,u);}a=m;}else a=null;}if(!a||!a.valid)return d.push(b),1;n=a.validAttributes;var D=a.validStyles;k=a.validClasses;var h=b.attributes,w=b.styles,l=b.classes;u=b.classBackup;var H=b.styleBackup,I,y,q=[],m=[],z=/^data-cke-/;A=!1;delete h.style;delete h["class"];delete b.classBackup;delete b.styleBackup;if(!a.allAttributes)for(I in h){n[I]||(z.test(I)?I==(y=I.replace(/^data-cke-saved-/,""))||n[y]||(delete h[I],A=!0):(delete h[I],A=!0));}if(!a.allStyles||a.hadInvalidStyle){for(I in w){a.allStyles||D[I]?q.push(I+":"+w[I]):A=!0;}q.length&&(h.style=q.sort().join("; "));}else H&&(h.style=H);if(!a.allClasses||a.hadInvalidClass){for(I=0;I<l.length;++I){(a.allClasses||k[l[I]])&&m.push(l[I]);}m.length&&(h["class"]=m.sort().join(" "));u&&m.length<u.split(/\s+/).length&&(A=!0);}else u&&(h["class"]=u);A&&(g=1);if(!f.skipFinalValidation&&!p(b))return d.push(b),1;}f.toHtml&&(b.name=b.name.replace(T,"cke:$1"));return g;}function q(a){var b=[],c;for(c in a){-1<c.indexOf("*")&&b.push(c.replace(/\*/g,".*"));}return b.length?new RegExp("^(?:"+b.join("|")+")$"):null;}function t(a){var b=a.attributes,c;delete b.style;delete b["class"];if(c=CKEDITOR.tools.writeCssText(a.styles,!0))b.style=c;a.classes.length&&(b["class"]=a.classes.sort().join(" "));}function p(a){switch(a.name){case"a":if(!(a.children.length||a.attributes.name||a.attributes.id))return!1;break;case"img":if(!a.attributes.src)return!1;}return!0;}function w(a){if(!a)return!1;if(!0===a)return!0;var b=q(a);return function(c){return c in a||b&&c.match(b);};}function z(){return new CKEDITOR.htmlParser.element("br");}function A(a){return a.type==CKEDITOR.NODE_ELEMENT&&("br"==a.name||F.$block[a.name]);}function u(a,b,c){var d=a.name;if(F.$empty[d]||!a.children.length)"hr"==d&&"br"==b?a.replaceWith(z()):(a.parent&&c.push({check:"it",el:a.parent}),a.remove());else if(F.$block[d]||"tr"==d){if("br"==b)a.previous&&!A(a.previous)&&(b=z(),b.insertBefore(a)),a.next&&!A(a.next)&&(b=z(),b.insertAfter(a)),a.replaceWithChildren();else{var d=a.children,f;b:{f=F[b];for(var g=0,k=d.length,e;g<k;++g){if(e=d[g],e.type==CKEDITOR.NODE_ELEMENT&&!f[e.name]){f=!1;break b;}}f=!0;}if(f)a.name=b,a.attributes={},c.push({check:"parent-down",el:a});else{f=a.parent;for(var g=f.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||"body"==f.name,h,l,k=d.length;0<k;){e=d[--k],g&&(e.type==CKEDITOR.NODE_TEXT||e.type==CKEDITOR.NODE_ELEMENT&&F.$inline[e.name])?(h||(h=new CKEDITOR.htmlParser.element(b),h.insertAfter(a),c.push({check:"parent-down",el:h})),h.add(e,0)):(h=null,l=F[f.name]||F.span,e.insertAfter(a),f.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||e.type!=CKEDITOR.NODE_ELEMENT||l[e.name]||c.push({check:"el-up",el:e}));}a.remove();}}}else d in{style:1,script:1}?a.remove():(a.parent&&c.push({check:"it",el:a.parent}),a.replaceWithChildren());}function x(a,b,c){var d,f;for(d=0;d<c.length;++d){if(f=c[d],!(f.check&&!a.check(f.check,!1)||f.left&&!f.left(b))){f.right(b,O);break;}}}function D(a,b){var c=b.getDefinition(),d=c.attributes,f=c.styles,g,e,k,h;if(a.name!=c.element)return!1;for(g in d){if("class"==g)for(c=d[g].split(/\s+/),k=a.classes.join("|");h=c.pop();){if(-1==k.indexOf(h))return!1;}else if(a.attributes[g]!=d[g])return!1;}for(e in f){if(a.styles[e]!=f[e])return!1;}return!0;}function y(a,b){var c,d;"string"==typeof a?c=a:a instanceof CKEDITOR.style?d=a:(c=a[0],d=a[1]);return[{element:c,left:d,right:function right(a,c){c.transform(a,b);}}];}function B(a){return function(b){return D(b,a);};}function C(a){return function(b,c){c[a](b);};}var F=CKEDITOR.dtd,E=CKEDITOR.tools.copy,J=CKEDITOR.tools.trim,G=["","p","br","div"];CKEDITOR.FILTER_SKIP_TREE=2;CKEDITOR.filter=function(a){this.allowedContent=[];this.disallowedContent=[];this.elementCallbacks=null;this.disabled=!1;this.editor=null;this.id=CKEDITOR.tools.getNextNumber();this._={allowedRules:{elements:{},generic:[]},disallowedRules:{elements:{},generic:[]},transformations:{},cachedTests:{}};CKEDITOR.filter.instances[this.id]=this;if(a instanceof CKEDITOR.editor){a=this.editor=a;this.customConfig=!0;var b=a.config.allowedContent;!0===b?this.disabled=!0:(b||(this.customConfig=!1),this.allow(b,"config",1),this.allow(a.config.extraAllowedContent,"extra",1),this.allow(G[a.enterMode]+" "+G[a.shiftEnterMode],"default",1),this.disallow(a.config.disallowedContent));}else this.customConfig=!1,this.allow(a,"default",1);};CKEDITOR.filter.instances={};CKEDITOR.filter.prototype={allow:function allow(b,c,d){if(!l(this,b,d))return!1;var f,e;if("string"==typeof b)b=g(b);else if(b instanceof CKEDITOR.style){if(b.toAllowedContentRules)return this.allow(b.toAllowedContentRules(this.editor),c,d);f=b.getDefinition();b={};d=f.attributes;b[f.element]=f={styles:f.styles,requiredStyles:f.styles&&CKEDITOR.tools.objectKeys(f.styles)};d&&(d=E(d),f.classes=d["class"]?d["class"].split(/\s+/):null,f.requiredClasses=f.classes,delete d["class"],f.attributes=d,f.requiredAttributes=d&&CKEDITOR.tools.objectKeys(d));}else if(CKEDITOR.tools.isArray(b)){for(f=0;f<b.length;++f){e=this.allow(b[f],c,d);}return e;}a(this,b,c,this.allowedContent,this._.allowedRules);return!0;},applyTo:function applyTo(a,b,c,d){if(this.disabled)return!1;var f=this,g=[],e=this.editor&&this.editor.config.protectedSource,k,h=!1,l={doFilter:!c,doTransform:!0,doCallbacks:!0,toHtml:b};a.forEach(function(a){if(a.type==CKEDITOR.NODE_ELEMENT){if("off"==a.attributes["data-cke-filter"])return!1;if(!b||"span"!=a.name||!~CKEDITOR.tools.objectKeys(a.attributes).join("|").indexOf("data-cke-"))if(k=r(f,a,g,l),k&1)h=!0;else if(k&2)return!1;}else if(a.type==CKEDITOR.NODE_COMMENT&&a.value.match(/^\{cke_protected\}(?!\{C\})/)){var c;a:{var d=decodeURIComponent(a.value.replace(/^\{cke_protected\}/,""));c=[];var u,m,t;if(e)for(m=0;m<e.length;++m){if((t=d.match(e[m]))&&t[0].length==d.length){c=!0;break a;}}d=CKEDITOR.htmlParser.fragment.fromHtml(d);1==d.children.length&&(u=d.children[0]).type==CKEDITOR.NODE_ELEMENT&&r(f,u,c,l);c=!c.length;}c||g.push(a);}},null,!0);g.length&&(h=!0);var m;a=[];d=G[d||(this.editor?this.editor.enterMode:CKEDITOR.ENTER_P)];for(var t;c=g.pop();){c.type==CKEDITOR.NODE_ELEMENT?u(c,d,a):c.remove();}for(;m=a.pop();){if(c=m.el,c.parent)switch(t=F[c.parent.name]||F.span,m.check){case"it":F.$removeEmpty[c.name]&&!c.children.length?u(c,d,a):p(c)||u(c,d,a);break;case"el-up":c.parent.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||t[c.name]||u(c,d,a);break;case"parent-down":c.parent.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||t[c.name]||u(c.parent,d,a);}}return h;},checkFeature:function checkFeature(a){if(this.disabled||!a)return!0;a.toFeature&&(a=a.toFeature(this.editor));return!a.requiredContent||this.check(a.requiredContent);},disable:function disable(){this.disabled=!0;},disallow:function disallow(b){if(!l(this,b,!0))return!1;"string"==typeof b&&(b=g(b));a(this,b,null,this.disallowedContent,this._.disallowedRules);return!0;},addContentForms:function addContentForms(a){if(!this.disabled&&a){var b,c,d=[],f;for(b=0;b<a.length&&!f;++b){c=a[b],("string"==typeof c||c instanceof CKEDITOR.style)&&this.check(c)&&(f=c);}if(f){for(b=0;b<a.length;++b){d.push(y(a[b],f));}this.addTransformations(d);}}},addElementCallback:function addElementCallback(a){this.elementCallbacks||(this.elementCallbacks=[]);this.elementCallbacks.push(a);},addFeature:function addFeature(a){if(this.disabled||!a)return!0;a.toFeature&&(a=a.toFeature(this.editor));this.allow(a.allowedContent,a.name);this.addTransformations(a.contentTransformations);this.addContentForms(a.contentForms);return a.requiredContent&&(this.customConfig||this.disallowedContent.length)?this.check(a.requiredContent):!0;},addTransformations:function addTransformations(a){var b,c;if(!this.disabled&&a){var d=this._.transformations,f;for(f=0;f<a.length;++f){b=a[f];var g=void 0,e=void 0,k=void 0,h=void 0,l=void 0,u=void 0;c=[];for(e=0;e<b.length;++e){k=b[e],"string"==typeof k?(k=k.split(/\s*:\s*/),h=k[0],l=null,u=k[1]):(h=k.check,l=k.left,u=k.right),g||(g=k,g=g.element?g.element:h?h.match(/^([a-z0-9]+)/i)[0]:g.left.getDefinition().element),l instanceof CKEDITOR.style&&(l=B(l)),c.push({check:h==g?null:h,left:l,right:"string"==typeof u?C(u):u});}b=g;d[b]||(d[b]=[]);d[b].push(c);}}},check:function check(a,b,c){if(this.disabled)return!0;if(CKEDITOR.tools.isArray(a)){for(var d=a.length;d--;){if(this.check(a[d],b,c))return!0;}return!1;}var f,e;if("string"==typeof a){e=a+"\x3c"+(!1===b?"0":"1")+(c?"1":"0")+"\x3e";if(e in this._.cachedChecks)return this._.cachedChecks[e];d=g(a).$1;f=d.styles;var h=d.classes;d.name=d.elements;d.classes=h=h?h.split(/\s*,\s*/):[];d.styles=k(f);d.attributes=k(d.attributes);d.children=[];h.length&&(d.attributes["class"]=h.join(" "));f&&(d.attributes.style=CKEDITOR.tools.writeCssText(d.styles));f=d;}else d=a.getDefinition(),f=d.styles,h=d.attributes||{},f&&!CKEDITOR.tools.isEmpty(f)?(f=E(f),h.style=CKEDITOR.tools.writeCssText(f,!0)):f={},f={name:d.element,attributes:h,classes:h["class"]?h["class"].split(/\s+/):[],styles:f,children:[]};var h=CKEDITOR.tools.clone(f),l=[],u;if(!1!==b&&(u=this._.transformations[f.name])){for(d=0;d<u.length;++d){x(this,f,u[d]);}t(f);}r(this,h,l,{doFilter:!0,doTransform:!1!==b,skipRequired:!c,skipFinalValidation:!c});b=0<l.length?!1:CKEDITOR.tools.objectCompare(f.attributes,h.attributes,!0)?!0:!1;"string"==typeof a&&(this._.cachedChecks[e]=b);return b;},getAllowedEnterMode:function(){var a=["p","div","br"],b={p:CKEDITOR.ENTER_P,div:CKEDITOR.ENTER_DIV,br:CKEDITOR.ENTER_BR};return function(c,d){var f=a.slice(),g;if(this.check(G[c]))return c;for(d||(f=f.reverse());g=f.pop();){if(this.check(g))return b[g];}return CKEDITOR.ENTER_BR;};}(),destroy:function destroy(){delete CKEDITOR.filter.instances[this.id];delete this._;delete this.allowedContent;delete this.disallowedContent;}};var M={styles:1,attributes:1,classes:1},I={styles:"requiredStyles",attributes:"requiredAttributes",classes:"requiredClasses"},H=/^([a-z0-9\-*\s]+)((?:\s*\{[!\w\-,\s\*]+\}\s*|\s*\[[!\w\-,\s\*]+\]\s*|\s*\([!\w\-,\s\*]+\)\s*){0,3})(?:;\s*|$)/i,R={styles:/{([^}]+)}/,attrs:/\[([^\]]+)\]/,classes:/\(([^\)]+)\)/},P=/^cke:(object|embed|param)$/,T=/^(object|embed|param)$/,O;O=CKEDITOR.filter.transformationsTools={sizeToStyle:function sizeToStyle(a){this.lengthToStyle(a,"width");this.lengthToStyle(a,"height");},sizeToAttribute:function sizeToAttribute(a){this.lengthToAttribute(a,"width");this.lengthToAttribute(a,"height");},lengthToStyle:function lengthToStyle(a,b,c){c=c||b;if(!(c in a.styles)){var d=a.attributes[b];d&&(/^\d+$/.test(d)&&(d+="px"),a.styles[c]=d);}delete a.attributes[b];},lengthToAttribute:function lengthToAttribute(a,b,c){c=c||b;if(!(c in a.attributes)){var d=a.styles[b],f=d&&d.match(/^(\d+)(?:\.\d*)?px$/);f?a.attributes[c]=f[1]:"cke-test"==d&&(a.attributes[c]="cke-test");}delete a.styles[b];},alignmentToStyle:function alignmentToStyle(a){if(!("float"in a.styles)){var b=a.attributes.align;if("left"==b||"right"==b)a.styles["float"]=b;}delete a.attributes.align;},alignmentToAttribute:function alignmentToAttribute(a){if(!("align"in a.attributes)){var b=a.styles["float"];if("left"==b||"right"==b)a.attributes.align=b;}delete a.styles["float"];},matchesStyle:D,transform:function transform(a,b){if("string"==typeof b)a.name=b;else{var c=b.getDefinition(),d=c.styles,f=c.attributes,g,e,k,h;a.name=c.element;for(g in f){if("class"==g)for(c=a.classes.join("|"),k=f[g].split(/\s+/);h=k.pop();){-1==c.indexOf(h)&&a.classes.push(h);}else a.attributes[g]=f[g];}for(e in d){a.styles[e]=d[e];}}}};}(),function(){CKEDITOR.focusManager=function(a){if(a.focusManager)return a.focusManager;this.hasFocus=!1;this.currentActive=null;this._={editor:a};return this;};CKEDITOR.focusManager._={blurDelay:200};CKEDITOR.focusManager.prototype={focus:function focus(a){this._.timer&&clearTimeout(this._.timer);a&&(this.currentActive=a);this.hasFocus||this._.locked||((a=CKEDITOR.currentInstance)&&a.focusManager.blur(1),this.hasFocus=!0,(a=this._.editor.container)&&a.addClass("cke_focus"),this._.editor.fire("focus"));},lock:function lock(){this._.locked=1;},unlock:function unlock(){delete this._.locked;},blur:function blur(a){function e(){if(this.hasFocus){this.hasFocus=!1;var a=this._.editor.container;a&&a.removeClass("cke_focus");this._.editor.fire("blur");}}if(!this._.locked){this._.timer&&clearTimeout(this._.timer);var b=CKEDITOR.focusManager._.blurDelay;a||!b?e.call(this):this._.timer=CKEDITOR.tools.setTimeout(function(){delete this._.timer;e.call(this);},b,this);}},add:function add(a,e){var b=a.getCustomData("focusmanager");if(!b||b!=this){b&&b.remove(a);var b="focus",c="blur";e&&(CKEDITOR.env.ie?(b="focusin",c="focusout"):CKEDITOR.event.useCapture=1);var d={blur:function blur(){a.equals(this.currentActive)&&this.blur();},focus:function focus(){this.focus(a);}};a.on(b,d.focus,this);a.on(c,d.blur,this);e&&(CKEDITOR.event.useCapture=0);a.setCustomData("focusmanager",this);a.setCustomData("focusmanager_handlers",d);}},remove:function remove(a){a.removeCustomData("focusmanager");var e=a.removeCustomData("focusmanager_handlers");a.removeListener("blur",e.blur);a.removeListener("focus",e.focus);}};}(),CKEDITOR.keystrokeHandler=function(a){if(a.keystrokeHandler)return a.keystrokeHandler;this.keystrokes={};this.blockedKeystrokes={};this._={editor:a};return this;},function(){var a,e=function e(b){b=b.data;var d=b.getKeystroke(),e=this.keystrokes[d],m=this._.editor;a=!1===m.fire("key",{keyCode:d,domEvent:b});a||(e&&(a=!1!==m.execCommand(e,{from:"keystrokeHandler"})),a||(a=!!this.blockedKeystrokes[d]));a&&b.preventDefault(!0);return!a;},b=function b(_b){a&&(a=!1,_b.data.preventDefault(!0));};CKEDITOR.keystrokeHandler.prototype={attach:function attach(a){a.on("keydown",e,this);if(CKEDITOR.env.gecko&&CKEDITOR.env.mac)a.on("keypress",b,this);}};}(),function(){CKEDITOR.lang={languages:{af:1,ar:1,bg:1,bn:1,bs:1,ca:1,cs:1,cy:1,da:1,de:1,"de-ch":1,el:1,"en-au":1,"en-ca":1,"en-gb":1,en:1,eo:1,es:1,et:1,eu:1,fa:1,fi:1,fo:1,"fr-ca":1,fr:1,gl:1,gu:1,he:1,hi:1,hr:1,hu:1,id:1,is:1,it:1,ja:1,ka:1,km:1,ko:1,ku:1,lt:1,lv:1,mk:1,mn:1,ms:1,nb:1,nl:1,no:1,pl:1,"pt-br":1,pt:1,ro:1,ru:1,si:1,sk:1,sl:1,sq:1,"sr-latn":1,sr:1,sv:1,th:1,tr:1,tt:1,ug:1,uk:1,vi:1,"zh-cn":1,zh:1},rtl:{ar:1,fa:1,he:1,ku:1,ug:1},load:function load(a,e,b){a&&CKEDITOR.lang.languages[a]||(a=this.detect(e,a));var c=this;e=function e(){c[a].dir=c.rtl[a]?"rtl":"ltr";b(a,c[a]);};this[a]?e():CKEDITOR.scriptLoader.load(CKEDITOR.getUrl("lang/"+a+".js"),e,this);},detect:function detect(a,e){var b=this.languages;e=e||navigator.userLanguage||navigator.language||a;var c=e.toLowerCase().match(/([a-z]+)(?:-([a-z]+))?/),d=c[1],c=c[2];b[d+"-"+c]?d=d+"-"+c:b[d]||(d=null);CKEDITOR.lang.detect=d?function(){return d;}:function(a){return a;};return d||a;}};}(),CKEDITOR.scriptLoader=function(){var a={},e={};return{load:function load(b,c,d,l){var m="string"==typeof b;m&&(b=[b]);d||(d=CKEDITOR);var f=b.length,h=[],k=[],g=function g(a){c&&(m?c.call(d,a):c.call(d,h,k));};if(0===f)g(!0);else{var n=function n(a,b){(b?h:k).push(a);0>=--f&&(l&&CKEDITOR.document.getDocumentElement().removeStyle("cursor"),g(b));},v=function v(b,c){a[b]=1;var d=e[b];delete e[b];for(var f=0;f<d.length;f++){d[f](b,c);}},r=function r(b){if(a[b])n(b,!0);else{var d=e[b]||(e[b]=[]);d.push(n);if(!(1<d.length)){var f=new CKEDITOR.dom.element("script");f.setAttributes({type:"text/javascript",src:b});c&&(CKEDITOR.env.ie&&(8>=CKEDITOR.env.version||CKEDITOR.env.ie9Compat)?f.$.onreadystatechange=function(){if("loaded"==f.$.readyState||"complete"==f.$.readyState)f.$.onreadystatechange=null,v(b,!0);}:(f.$.onload=function(){setTimeout(function(){v(b,!0);},0);},f.$.onerror=function(){v(b,!1);}));f.appendTo(CKEDITOR.document.getHead());}}};l&&CKEDITOR.document.getDocumentElement().setStyle("cursor","wait");for(var q=0;q<f;q++){r(b[q]);}}},queue:function(){function a(){var b;(b=c[0])&&this.load(b.scriptUrl,b.callback,CKEDITOR,0);}var c=[];return function(d,e){var m=this;c.push({scriptUrl:d,callback:function callback(){e&&e.apply(this,arguments);c.shift();a.call(m);}});1==c.length&&a.call(this);};}()};}(),CKEDITOR.resourceManager=function(a,e){this.basePath=a;this.fileName=e;this.registered={};this.loaded={};this.externals={};this._={waitingList:{}};},CKEDITOR.resourceManager.prototype={add:function add(a,e){if(this.registered[a])throw Error('[CKEDITOR.resourceManager.add] The resource name "'+a+'" is already registered.');var b=this.registered[a]=e||{};b.name=a;b.path=this.getPath(a);CKEDITOR.fire(a+CKEDITOR.tools.capitalize(this.fileName)+"Ready",b);return this.get(a);},get:function get(a){return this.registered[a]||null;},getPath:function getPath(a){var e=this.externals[a];return CKEDITOR.getUrl(e&&e.dir||this.basePath+a+"/");},getFilePath:function getFilePath(a){var e=this.externals[a];return CKEDITOR.getUrl(this.getPath(a)+(e?e.file:this.fileName+".js"));},addExternal:function addExternal(a,e,b){a=a.split(",");for(var c=0;c<a.length;c++){var d=a[c];b||(e=e.replace(/[^\/]+$/,function(a){b=a;return"";}));this.externals[d]={dir:e,file:b||this.fileName+".js"};}},load:function load(a,e,b){CKEDITOR.tools.isArray(a)||(a=a?[a]:[]);for(var c=this.loaded,d=this.registered,l=[],m={},f={},h=0;h<a.length;h++){var k=a[h];if(k)if(c[k]||d[k])f[k]=this.get(k);else{var g=this.getFilePath(k);l.push(g);g in m||(m[g]=[]);m[g].push(k);}}CKEDITOR.scriptLoader.load(l,function(a,d){if(d.length)throw Error('[CKEDITOR.resourceManager.load] Resource name "'+m[d[0]].join(",")+'" was not found at "'+d[0]+'".');for(var g=0;g<a.length;g++){for(var k=m[a[g]],h=0;h<k.length;h++){var l=k[h];f[l]=this.get(l);c[l]=1;}}e.call(b,f);},this);}},CKEDITOR.plugins=new CKEDITOR.resourceManager("plugins/","plugin"),CKEDITOR.plugins.load=CKEDITOR.tools.override(CKEDITOR.plugins.load,function(a){var e={};return function(b,c,d){var l={},m=function m(b){a.call(this,b,function(a){CKEDITOR.tools.extend(l,a);var b=[],f;for(f in a){var n=a[f],v=n&&n.requires;if(!e[f]){if(n.icons)for(var r=n.icons.split(","),q=r.length;q--;){CKEDITOR.skin.addIcon(r[q],n.path+"icons/"+(CKEDITOR.env.hidpi&&n.hidpi?"hidpi/":"")+r[q]+".png");}e[f]=1;}if(v)for(v.split&&(v=v.split(",")),n=0;n<v.length;n++){l[v[n]]||b.push(v[n]);}}if(b.length)m.call(this,b);else{for(f in l){n=l[f],n.onLoad&&!n.onLoad._called&&(!1===n.onLoad()&&delete l[f],n.onLoad._called=1);}c&&c.call(d||window,l);}},this);};m.call(this,b);};}),CKEDITOR.plugins.setLang=function(a,e,b){var c=this.get(a);a=c.langEntries||(c.langEntries={});c=c.lang||(c.lang=[]);c.split&&(c=c.split(","));-1==CKEDITOR.tools.indexOf(c,e)&&c.push(e);a[e]=b;},CKEDITOR.ui=function(a){if(a.ui)return a.ui;this.items={};this.instances={};this.editor=a;this._={handlers:{}};return this;},CKEDITOR.ui.prototype={add:function add(a,e,b){b.name=a.toLowerCase();var c=this.items[a]={type:e,command:b.command||null,args:Array.prototype.slice.call(arguments,2)};CKEDITOR.tools.extend(c,b);},get:function get(a){return this.instances[a];},create:function create(a){var e=this.items[a],b=e&&this._.handlers[e.type],c=e&&e.command&&this.editor.getCommand(e.command),b=b&&b.create.apply(this,e.args);this.instances[a]=b;c&&c.uiItems.push(b);b&&!b.type&&(b.type=e.type);return b;},addHandler:function addHandler(a,e){this._.handlers[a]=e;},space:function space(a){return CKEDITOR.document.getById(this.spaceId(a));},spaceId:function spaceId(a){return this.editor.id+"_"+a;}},CKEDITOR.event.implementOn(CKEDITOR.ui),function(){function a(a,d,g){CKEDITOR.event.call(this);a=a&&CKEDITOR.tools.clone(a);if(void 0!==d){if(!(d instanceof CKEDITOR.dom.element))throw Error("Expect element of type CKEDITOR.dom.element.");if(!g)throw Error("One of the element modes must be specified.");if(CKEDITOR.env.ie&&CKEDITOR.env.quirks&&g==CKEDITOR.ELEMENT_MODE_INLINE)throw Error("Inline element mode is not supported on IE quirks.");if(!b(d,g))throw Error('The specified element mode is not supported on element: "'+d.getName()+'".');this.element=d;this.elementMode=g;this.name=this.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO&&(d.getId()||d.getNameAtt());}else this.elementMode=CKEDITOR.ELEMENT_MODE_NONE;this._={};this.commands={};this.templates={};this.name=this.name||e();this.id=CKEDITOR.tools.getNextId();this.status="unloaded";this.config=CKEDITOR.tools.prototypedCopy(CKEDITOR.config);this.ui=new CKEDITOR.ui(this);this.focusManager=new CKEDITOR.focusManager(this);this.keystrokeHandler=new CKEDITOR.keystrokeHandler(this);this.on("readOnly",c);this.on("selectionChange",function(a){l(this,a.data.path);});this.on("activeFilterChange",function(){l(this,this.elementPath(),!0);});this.on("mode",c);this.on("instanceReady",function(){this.config.startupFocus&&this.focus();});CKEDITOR.fire("instanceCreated",null,this);CKEDITOR.add(this);CKEDITOR.tools.setTimeout(function(){"destroyed"!==this.status?f(this,a):CKEDITOR.warn("editor-incorrect-destroy");},0,this);}function e(){do{var a="editor"+ ++r;}while(CKEDITOR.instances[a]);return a;}function b(a,b){return b==CKEDITOR.ELEMENT_MODE_INLINE?a.is(CKEDITOR.dtd.$editable)||a.is("textarea"):b==CKEDITOR.ELEMENT_MODE_REPLACE?!a.is(CKEDITOR.dtd.$nonBodyContent):1;}function c(){var a=this.commands,b;for(b in a){d(this,a[b]);}}function d(a,b){b[b.startDisabled?"disable":a.readOnly&&!b.readOnly?"disable":b.modes[a.mode]?"enable":"disable"]();}function l(a,b,c){if(b){var d,f,g=a.commands;for(f in g){d=g[f],(c||d.contextSensitive)&&d.refresh(a,b);}}}function m(a){var b=a.config.customConfig;if(!b)return!1;var b=CKEDITOR.getUrl(b),c=q[b]||(q[b]={});c.fn?(c.fn.call(a,a.config),CKEDITOR.getUrl(a.config.customConfig)!=b&&m(a)||a.fireOnce("customConfigLoaded")):CKEDITOR.scriptLoader.queue(b,function(){c.fn=CKEDITOR.editorConfig?CKEDITOR.editorConfig:function(){};m(a);});return!0;}function f(a,b){a.on("customConfigLoaded",function(){if(b){if(b.on)for(var c in b.on){a.on(c,b.on[c]);}CKEDITOR.tools.extend(a.config,b,!0);delete a.config.on;}c=a.config;a.readOnly=c.readOnly?!0:a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.element.is("textarea")?a.element.hasAttribute("disabled")||a.element.hasAttribute("readonly"):a.element.isReadOnly():a.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?a.element.hasAttribute("disabled")||a.element.hasAttribute("readonly"):!1;a.blockless=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?!(a.element.is("textarea")||CKEDITOR.dtd[a.element.getName()].p):!1;a.tabIndex=c.tabIndex||a.element&&a.element.getAttribute("tabindex")||0;a.activeEnterMode=a.enterMode=a.blockless?CKEDITOR.ENTER_BR:c.enterMode;a.activeShiftEnterMode=a.shiftEnterMode=a.blockless?CKEDITOR.ENTER_BR:c.shiftEnterMode;c.skin&&(CKEDITOR.skinName=c.skin);a.fireOnce("configLoaded");a.dataProcessor=new CKEDITOR.htmlDataProcessor(a);a.filter=a.activeFilter=new CKEDITOR.filter(a);h(a);});b&&null!=b.customConfig&&(a.config.customConfig=b.customConfig);m(a)||a.fireOnce("customConfigLoaded");}function h(a){CKEDITOR.skin.loadPart("editor",function(){k(a);});}function k(a){CKEDITOR.lang.load(a.config.language,a.config.defaultLanguage,function(b,c){var d=a.config.title;a.langCode=b;a.lang=CKEDITOR.tools.prototypedCopy(c);a.title="string"==typeof d||!1===d?d:[a.lang.editor,a.name].join(", ");a.config.contentsLangDirection||(a.config.contentsLangDirection=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.element.getDirection(1):a.lang.dir);a.fire("langLoaded");g(a);});}function g(a){a.getStylesSet(function(b){a.once("loaded",function(){a.fire("stylesSet",{styles:b});},null,null,1);n(a);});}function n(a){var b=a.config,c=b.plugins,d=b.extraPlugins,f=b.removePlugins;if(d)var g=new RegExp("(?:^|,)(?:"+d.replace(/\s*,\s*/g,"|")+")(?\x3d,|$)","g"),c=c.replace(g,""),c=c+(","+d);if(f)var e=new RegExp("(?:^|,)(?:"+f.replace(/\s*,\s*/g,"|")+")(?\x3d,|$)","g"),c=c.replace(e,"");CKEDITOR.env.air&&(c+=",adobeair");CKEDITOR.plugins.load(c.split(","),function(c){var d=[],f=[],g=[];a.plugins=c;for(var k in c){var h=c[k],l=h.lang,u=null,m=h.requires,A;CKEDITOR.tools.isArray(m)&&(m=m.join(","));if(m&&(A=m.match(e)))for(;m=A.pop();){CKEDITOR.error("editor-plugin-required",{plugin:m.replace(",",""),requiredBy:k});}l&&!a.lang[k]&&(l.split&&(l=l.split(",")),0<=CKEDITOR.tools.indexOf(l,a.langCode)?u=a.langCode:(u=a.langCode.replace(/-.*/,""),u=u!=a.langCode&&0<=CKEDITOR.tools.indexOf(l,u)?u:0<=CKEDITOR.tools.indexOf(l,"en")?"en":l[0]),h.langEntries&&h.langEntries[u]?(a.lang[k]=h.langEntries[u],u=null):g.push(CKEDITOR.getUrl(h.path+"lang/"+u+".js")));f.push(u);d.push(h);}CKEDITOR.scriptLoader.load(g,function(){for(var c=["beforeInit","init","afterInit"],g=0;g<c.length;g++){for(var e=0;e<d.length;e++){var k=d[e];0===g&&f[e]&&k.lang&&k.langEntries&&(a.lang[k.name]=k.langEntries[f[e]]);if(k[c[g]])k[c[g]](a);}}a.fireOnce("pluginsLoaded");b.keystrokes&&a.setKeystroke(a.config.keystrokes);for(e=0;e<a.config.blockedKeystrokes.length;e++){a.keystrokeHandler.blockedKeystrokes[a.config.blockedKeystrokes[e]]=1;}a.status="loaded";a.fireOnce("loaded");CKEDITOR.fire("instanceLoaded",null,a);});});}function v(){var a=this.element;if(a&&this.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO){var b=this.getData();this.config.htmlEncodeOutput&&(b=CKEDITOR.tools.htmlEncode(b));a.is("textarea")?a.setValue(b):a.setHtml(b);return!0;}return!1;}a.prototype=CKEDITOR.editor.prototype;CKEDITOR.editor=a;var r=0,q={};CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{addCommand:function addCommand(a,b){b.name=a.toLowerCase();var c=new CKEDITOR.command(this,b);this.mode&&d(this,c);return this.commands[a]=c;},_attachToForm:function _attachToForm(){function a(b){c.updateElement();c._.required&&!d.getValue()&&!1===c.fire("required")&&b.data.preventDefault();}function b(a){return!!(a&&a.call&&a.apply);}var c=this,d=c.element,f=new CKEDITOR.dom.element(d.$.form);d.is("textarea")&&f&&(f.on("submit",a),b(f.$.submit)&&(f.$.submit=CKEDITOR.tools.override(f.$.submit,function(b){return function(){a();b.apply?b.apply(this):b();};})),c.on("destroy",function(){f.removeListener("submit",a);}));},destroy:function destroy(a){this.fire("beforeDestroy");!a&&v.call(this);this.editable(null);this.filter&&(this.filter.destroy(),delete this.filter);delete this.activeFilter;this.status="destroyed";this.fire("destroy");this.removeAllListeners();CKEDITOR.remove(this);CKEDITOR.fire("instanceDestroyed",null,this);},elementPath:function elementPath(a){if(!a){a=this.getSelection();if(!a)return null;a=a.getStartElement();}return a?new CKEDITOR.dom.elementPath(a,this.editable()):null;},createRange:function createRange(){var a=this.editable();return a?new CKEDITOR.dom.range(a):null;},execCommand:function execCommand(a,b){var c=this.getCommand(a),d={name:a,commandData:b,command:c};return c&&c.state!=CKEDITOR.TRISTATE_DISABLED&&!1!==this.fire("beforeCommandExec",d)&&(d.returnValue=c.exec(d.commandData),!c.async&&!1!==this.fire("afterCommandExec",d))?d.returnValue:!1;},getCommand:function getCommand(a){return this.commands[a];},getData:function getData(a){!a&&this.fire("beforeGetData");var b=this._.data;"string"!=typeof b&&(b=(b=this.element)&&this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?b.is("textarea")?b.getValue():b.getHtml():"");b={dataValue:b};!a&&this.fire("getData",b);return b.dataValue;},getSnapshot:function getSnapshot(){var a=this.fire("getSnapshot");"string"!=typeof a&&(a=(a=this.element)&&this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?a.is("textarea")?a.getValue():a.getHtml():"");return a;},loadSnapshot:function loadSnapshot(a){this.fire("loadSnapshot",a);},setData:function setData(a,b,c){var d=!0,f=b;b&&"object"==(typeof b==="undefined"?"undefined":_typeof(b))&&(c=b.internal,f=b.callback,d=!b.noSnapshot);!c&&d&&this.fire("saveSnapshot");if(f||!c)this.once("dataReady",function(a){!c&&d&&this.fire("saveSnapshot");f&&f.call(a.editor);});a={dataValue:a};!c&&this.fire("setData",a);this._.data=a.dataValue;!c&&this.fire("afterSetData",a);},setReadOnly:function setReadOnly(a){a=null==a||a;this.readOnly!=a&&(this.readOnly=a,this.keystrokeHandler.blockedKeystrokes[8]=+a,this.editable().setReadOnly(a),this.fire("readOnly"));},insertHtml:function insertHtml(a,b,c){this.fire("insertHtml",{dataValue:a,mode:b,range:c});},insertText:function insertText(a){this.fire("insertText",a);},insertElement:function insertElement(a){this.fire("insertElement",a);},getSelectedHtml:function getSelectedHtml(a){var b=this.editable(),c=this.getSelection(),c=c&&c.getRanges();if(!b||!c||0===c.length)return null;for(var d=new CKEDITOR.dom.documentFragment(),f,g,e,k=0;k<c.length;k++){var h=c[k],l=h.startContainer;l.getName&&"tr"==l.getName()?(f||(f=l.getAscendant("table").clone(),f.append(l.getAscendant("tbody").clone()),d.append(f),f=f.findOne("tbody")),g&&g.equals(l)||(g=l,e=l.clone(),f.append(e)),e.append(h.cloneContents())):d.append(h.cloneContents());}b=f?d:b.getHtmlFromRange(c[0]);return a?b.getHtml():b;},extractSelectedHtml:function extractSelectedHtml(a,b){var c=this.editable(),d=this.getSelection().getRanges();if(!c||0===d.length)return null;d=d[0];c=c.extractHtmlFromRange(d,b);b||this.getSelection().selectRanges([d]);return a?c.getHtml():c;},focus:function focus(){this.fire("beforeFocus");},checkDirty:function checkDirty(){return"ready"==this.status&&this._.previousValue!==this.getSnapshot();},resetDirty:function resetDirty(){this._.previousValue=this.getSnapshot();},updateElement:function updateElement(){return v.call(this);},setKeystroke:function setKeystroke(){for(var a=this.keystrokeHandler.keystrokes,b=CKEDITOR.tools.isArray(arguments[0])?arguments[0]:[[].slice.call(arguments,0)],c,d,f=b.length;f--;){c=b[f],d=0,CKEDITOR.tools.isArray(c)&&(d=c[1],c=c[0]),d?a[c]=d:delete a[c];}},addFeature:function addFeature(a){return this.filter.addFeature(a);},setActiveFilter:function setActiveFilter(a){a||(a=this.filter);this.activeFilter!==a&&(this.activeFilter=a,this.fire("activeFilterChange"),a===this.filter?this.setActiveEnterMode(null,null):this.setActiveEnterMode(a.getAllowedEnterMode(this.enterMode),a.getAllowedEnterMode(this.shiftEnterMode,!0)));},setActiveEnterMode:function setActiveEnterMode(a,b){a=a?this.blockless?CKEDITOR.ENTER_BR:a:this.enterMode;b=b?this.blockless?CKEDITOR.ENTER_BR:b:this.shiftEnterMode;if(this.activeEnterMode!=a||this.activeShiftEnterMode!=b)this.activeEnterMode=a,this.activeShiftEnterMode=b,this.fire("activeEnterModeChange");},showNotification:function showNotification(a){alert(a);}});}(),CKEDITOR.ELEMENT_MODE_NONE=0,CKEDITOR.ELEMENT_MODE_REPLACE=1,CKEDITOR.ELEMENT_MODE_APPENDTO=2,CKEDITOR.ELEMENT_MODE_INLINE=3,CKEDITOR.htmlParser=function(){this._={htmlPartsRegex:/<(?:(?:\/([^>]+)>)|(?:!--([\S|\s]*?)--\x3e)|(?:([^\/\s>]+)((?:\s+[\w\-:.]+(?:\s*=\s*?(?:(?:"[^"]*")|(?:'[^']*')|[^\s"'\/>]+))?)*)[\S\s]*?(\/?)>))/g};},function(){var a=/([\w\-:.]+)(?:(?:\s*=\s*(?:(?:"([^"]*)")|(?:'([^']*)')|([^\s>]+)))|(?=\s|$))/g,e={checked:1,compact:1,declare:1,defer:1,disabled:1,ismap:1,multiple:1,nohref:1,noresize:1,noshade:1,nowrap:1,readonly:1,selected:1};CKEDITOR.htmlParser.prototype={onTagOpen:function onTagOpen(){},onTagClose:function onTagClose(){},onText:function onText(){},onCDATA:function onCDATA(){},onComment:function onComment(){},parse:function parse(b){for(var c,d,l=0,m;c=this._.htmlPartsRegex.exec(b);){d=c.index;if(d>l)if(l=b.substring(l,d),m)m.push(l);else this.onText(l);l=this._.htmlPartsRegex.lastIndex;if(d=c[1])if(d=d.toLowerCase(),m&&CKEDITOR.dtd.$cdata[d]&&(this.onCDATA(m.join("")),m=null),!m){this.onTagClose(d);continue;}if(m)m.push(c[0]);else if(d=c[3]){if(d=d.toLowerCase(),!/="/.test(d)){var f={},h,k=c[4];c=!!c[5];if(k)for(;h=a.exec(k);){var g=h[1].toLowerCase();h=h[2]||h[3]||h[4]||"";f[g]=!h&&e[g]?g:CKEDITOR.tools.htmlDecodeAttr(h);}this.onTagOpen(d,f,c);!m&&CKEDITOR.dtd.$cdata[d]&&(m=[]);}}else if(d=c[2])this.onComment(d);}if(b.length>l)this.onText(b.substring(l,b.length));}};}(),CKEDITOR.htmlParser.basicWriter=CKEDITOR.tools.createClass({$:function $(){this._={output:[]};},proto:{openTag:function openTag(a){this._.output.push("\x3c",a);},openTagClose:function openTagClose(a,e){e?this._.output.push(" /\x3e"):this._.output.push("\x3e");},attribute:function attribute(a,e){"string"==typeof e&&(e=CKEDITOR.tools.htmlEncodeAttr(e));this._.output.push(" ",a,'\x3d"',e,'"');},closeTag:function closeTag(a){this._.output.push("\x3c/",a,"\x3e");},text:function text(a){this._.output.push(a);},comment:function comment(a){this._.output.push("\x3c!--",a,"--\x3e");},write:function write(a){this._.output.push(a);},reset:function reset(){this._.output=[];this._.indent=!1;},getHtml:function getHtml(a){var e=this._.output.join("");a&&this.reset();return e;}}}),"use strict",function(){CKEDITOR.htmlParser.node=function(){};CKEDITOR.htmlParser.node.prototype={remove:function remove(){var a=this.parent.children,e=CKEDITOR.tools.indexOf(a,this),b=this.previous,c=this.next;b&&(b.next=c);c&&(c.previous=b);a.splice(e,1);this.parent=null;},replaceWith:function replaceWith(a){var e=this.parent.children,b=CKEDITOR.tools.indexOf(e,this),c=a.previous=this.previous,d=a.next=this.next;c&&(c.next=a);d&&(d.previous=a);e[b]=a;a.parent=this.parent;this.parent=null;},insertAfter:function insertAfter(a){var e=a.parent.children,b=CKEDITOR.tools.indexOf(e,a),c=a.next;e.splice(b+1,0,this);this.next=a.next;this.previous=a;a.next=this;c&&(c.previous=this);this.parent=a.parent;},insertBefore:function insertBefore(a){var e=a.parent.children,b=CKEDITOR.tools.indexOf(e,a);e.splice(b,0,this);this.next=a;(this.previous=a.previous)&&(a.previous.next=this);a.previous=this;this.parent=a.parent;},getAscendant:function getAscendant(a){var e="function"==typeof a?a:"string"==typeof a?function(b){return b.name==a;}:function(b){return b.name in a;},b=this.parent;for(;b&&b.type==CKEDITOR.NODE_ELEMENT;){if(e(b))return b;b=b.parent;}return null;},wrapWith:function wrapWith(a){this.replaceWith(a);a.add(this);return a;},getIndex:function getIndex(){return CKEDITOR.tools.indexOf(this.parent.children,this);},getFilterContext:function getFilterContext(a){return a||{};}};}(),"use strict",CKEDITOR.htmlParser.comment=function(a){this.value=a;this._={isBlockLike:!1};},CKEDITOR.htmlParser.comment.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node(),{type:CKEDITOR.NODE_COMMENT,filter:function filter(a,e){var b=this.value;if(!(b=a.onComment(e,b,this)))return this.remove(),!1;if("string"!=typeof b)return this.replaceWith(b),!1;this.value=b;return!0;},writeHtml:function writeHtml(a,e){e&&this.filter(e);a.comment(this.value);}}),"use strict",function(){CKEDITOR.htmlParser.text=function(a){this.value=a;this._={isBlockLike:!1};};CKEDITOR.htmlParser.text.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node(),{type:CKEDITOR.NODE_TEXT,filter:function filter(a,e){if(!(this.value=a.onText(e,this.value,this)))return this.remove(),!1;},writeHtml:function writeHtml(a,e){e&&this.filter(e);a.text(this.value);}});}(),"use strict",function(){CKEDITOR.htmlParser.cdata=function(a){this.value=a;};CKEDITOR.htmlParser.cdata.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node(),{type:CKEDITOR.NODE_TEXT,filter:function filter(){},writeHtml:function writeHtml(a){a.write(this.value);}});}(),"use strict",CKEDITOR.htmlParser.fragment=function(){this.children=[];this.parent=null;this._={isBlockLike:!0,hasInlineStarted:!1};},function(){function a(a){return a.attributes["data-cke-survive"]?!1:"a"==a.name&&a.attributes.href||CKEDITOR.dtd.$removeEmpty[a.name];}var e=CKEDITOR.tools.extend({table:1,ul:1,ol:1,dl:1},CKEDITOR.dtd.table,CKEDITOR.dtd.ul,CKEDITOR.dtd.ol,CKEDITOR.dtd.dl),b={ol:1,ul:1},c=CKEDITOR.tools.extend({},{html:1},CKEDITOR.dtd.html,CKEDITOR.dtd.body,CKEDITOR.dtd.head,{style:1,script:1}),d={ul:"li",ol:"li",dl:"dd",table:"tbody",tbody:"tr",thead:"tr",tfoot:"tr",tr:"td"};CKEDITOR.htmlParser.fragment.fromHtml=function(l,m,f){function h(a){var b;if(0<p.length)for(var c=0;c<p.length;c++){var d=p[c],f=d.name,g=CKEDITOR.dtd[f],e=z.name&&CKEDITOR.dtd[z.name];e&&!e[f]||a&&g&&!g[a]&&CKEDITOR.dtd[a]?f==z.name&&(n(z,z.parent,1),c--):(b||(k(),b=1),d=d.clone(),d.parent=z,z=d,p.splice(c,1),c--);}}function k(){for(;w.length;){n(w.shift(),z);}}function g(a){if(a._.isBlockLike&&"pre"!=a.name&&"textarea"!=a.name){var b=a.children.length,c=a.children[b-1],d;c&&c.type==CKEDITOR.NODE_TEXT&&((d=CKEDITOR.tools.rtrim(c.value))?c.value=d:a.children.length=b-1);}}function n(b,c,d){c=c||z||t;var e=z;void 0===b.previous&&(v(c,b)&&(z=c,q.onTagOpen(f,{}),b.returnPoint=c=z),g(b),a(b)&&!b.children.length||c.add(b),"pre"==b.name&&(u=!1),"textarea"==b.name&&(A=!1));b.returnPoint?(z=b.returnPoint,delete b.returnPoint):z=d?c:e;}function v(a,b){if((a==t||"body"==a.name)&&f&&(!a.name||CKEDITOR.dtd[a.name][f])){var c,d;return(c=b.attributes&&(d=b.attributes["data-cke-real-element-type"])?d:b.name)&&c in CKEDITOR.dtd.$inline&&!(c in CKEDITOR.dtd.head)&&!b.isOrphan||b.type==CKEDITOR.NODE_TEXT;}}function r(a,b){return a in CKEDITOR.dtd.$listItem||a in CKEDITOR.dtd.$tableContent?a==b||"dt"==a&&"dd"==b||"dd"==a&&"dt"==b:!1;}var q=new CKEDITOR.htmlParser(),t=m instanceof CKEDITOR.htmlParser.element?m:"string"==typeof m?new CKEDITOR.htmlParser.element(m):new CKEDITOR.htmlParser.fragment(),p=[],w=[],z=t,A="textarea"==t.name,u="pre"==t.name;q.onTagOpen=function(d,f,g,l){f=new CKEDITOR.htmlParser.element(d,f);f.isUnknown&&g&&(f.isEmpty=!0);f.isOptionalClose=l;if(a(f))p.push(f);else{if("pre"==d)u=!0;else{if("br"==d&&u){z.add(new CKEDITOR.htmlParser.text("\n"));return;}"textarea"==d&&(A=!0);}if("br"==d)w.push(f);else{for(;!(l=(g=z.name)?CKEDITOR.dtd[g]||(z._.isBlockLike?CKEDITOR.dtd.div:CKEDITOR.dtd.span):c,f.isUnknown||z.isUnknown||l[d]);){if(z.isOptionalClose)q.onTagClose(g);else if(d in b&&g in b)g=z.children,(g=g[g.length-1])&&"li"==g.name||n(g=new CKEDITOR.htmlParser.element("li"),z),!f.returnPoint&&(f.returnPoint=z),z=g;else if(d in CKEDITOR.dtd.$listItem&&!r(d,g))q.onTagOpen("li"==d?"ul":"dl",{},0,1);else if(g in e&&!r(d,g))!f.returnPoint&&(f.returnPoint=z),z=z.parent;else if(g in CKEDITOR.dtd.$inline&&p.unshift(z),z.parent)n(z,z.parent,1);else{f.isOrphan=1;break;}}h(d);k();f.parent=z;f.isEmpty?n(f):z=f;}}};q.onTagClose=function(a){for(var b=p.length-1;0<=b;b--){if(a==p[b].name){p.splice(b,1);return;}}for(var c=[],d=[],g=z;g!=t&&g.name!=a;){g._.isBlockLike||d.unshift(g),c.push(g),g=g.returnPoint||g.parent;}if(g!=t){for(b=0;b<c.length;b++){var e=c[b];n(e,e.parent);}z=g;g._.isBlockLike&&k();n(g,g.parent);g==z&&(z=z.parent);p=p.concat(d);}"body"==a&&(f=!1);};q.onText=function(a){if(!(z._.hasInlineStarted&&!w.length||u||A)&&(a=CKEDITOR.tools.ltrim(a),0===a.length))return;var b=z.name,g=b?CKEDITOR.dtd[b]||(z._.isBlockLike?CKEDITOR.dtd.div:CKEDITOR.dtd.span):c;if(!A&&!g["#"]&&b in e)q.onTagOpen(d[b]||""),q.onText(a);else{k();h();u||A||(a=a.replace(/[\t\r\n ]{2,}|[\t\r\n]/g," "));a=new CKEDITOR.htmlParser.text(a);if(v(z,a))this.onTagOpen(f,{},0,1);z.add(a);}};q.onCDATA=function(a){z.add(new CKEDITOR.htmlParser.cdata(a));};q.onComment=function(a){k();h();z.add(new CKEDITOR.htmlParser.comment(a));};q.parse(l);for(k();z!=t;){n(z,z.parent,1);}g(t);return t;};CKEDITOR.htmlParser.fragment.prototype={type:CKEDITOR.NODE_DOCUMENT_FRAGMENT,add:function add(a,b){isNaN(b)&&(b=this.children.length);var c=0<b?this.children[b-1]:null;if(c){if(a._.isBlockLike&&c.type==CKEDITOR.NODE_TEXT&&(c.value=CKEDITOR.tools.rtrim(c.value),0===c.value.length)){this.children.pop();this.add(a);return;}c.next=a;}a.previous=c;a.parent=this;this.children.splice(b,0,a);this._.hasInlineStarted||(this._.hasInlineStarted=a.type==CKEDITOR.NODE_TEXT||a.type==CKEDITOR.NODE_ELEMENT&&!a._.isBlockLike);},filter:function filter(a,b){b=this.getFilterContext(b);a.onRoot(b,this);this.filterChildren(a,!1,b);},filterChildren:function filterChildren(a,b,c){if(this.childrenFilteredBy!=a.id){c=this.getFilterContext(c);if(b&&!this.parent)a.onRoot(c,this);this.childrenFilteredBy=a.id;for(b=0;b<this.children.length;b++){!1===this.children[b].filter(a,c)&&b--;}}},writeHtml:function writeHtml(a,b){b&&this.filter(b);this.writeChildrenHtml(a);},writeChildrenHtml:function writeChildrenHtml(a,b,c){var d=this.getFilterContext();if(c&&!this.parent&&b)b.onRoot(d,this);b&&this.filterChildren(b,!1,d);b=0;c=this.children;for(d=c.length;b<d;b++){c[b].writeHtml(a);}},forEach:function forEach(a,b,c){if(!(c||b&&this.type!=b))var d=a(this);if(!1!==d){c=this.children;for(var e=0;e<c.length;e++){d=c[e],d.type==CKEDITOR.NODE_ELEMENT?d.forEach(a,b):b&&d.type!=b||a(d);}}},getFilterContext:function getFilterContext(a){return a||{};}};}(),"use strict",function(){function a(){this.rules=[];}function e(b,c,d,e){var m,f;for(m in c){(f=b[m])||(f=b[m]=new a()),f.add(c[m],d,e);}}CKEDITOR.htmlParser.filter=CKEDITOR.tools.createClass({$:function $(b){this.id=CKEDITOR.tools.getNextNumber();this.elementNameRules=new a();this.attributeNameRules=new a();this.elementsRules={};this.attributesRules={};this.textRules=new a();this.commentRules=new a();this.rootRules=new a();b&&this.addRules(b,10);},proto:{addRules:function addRules(a,c){var d;"number"==typeof c?d=c:c&&"priority"in c&&(d=c.priority);"number"!=typeof d&&(d=10);"object"!=(typeof c==="undefined"?"undefined":_typeof(c))&&(c={});a.elementNames&&this.elementNameRules.addMany(a.elementNames,d,c);a.attributeNames&&this.attributeNameRules.addMany(a.attributeNames,d,c);a.elements&&e(this.elementsRules,a.elements,d,c);a.attributes&&e(this.attributesRules,a.attributes,d,c);a.text&&this.textRules.add(a.text,d,c);a.comment&&this.commentRules.add(a.comment,d,c);a.root&&this.rootRules.add(a.root,d,c);},applyTo:function applyTo(a){a.filter(this);},onElementName:function onElementName(a,c){return this.elementNameRules.execOnName(a,c);},onAttributeName:function onAttributeName(a,c){return this.attributeNameRules.execOnName(a,c);},onText:function onText(a,c,d){return this.textRules.exec(a,c,d);},onComment:function onComment(a,c,d){return this.commentRules.exec(a,c,d);},onRoot:function onRoot(a,c){return this.rootRules.exec(a,c);},onElement:function onElement(a,c){for(var d=[this.elementsRules["^"],this.elementsRules[c.name],this.elementsRules.$],e,m=0;3>m;m++){if(e=d[m]){e=e.exec(a,c,this);if(!1===e)return null;if(e&&e!=c)return this.onNode(a,e);if(c.parent&&!c.name)break;}}return c;},onNode:function onNode(a,c){var d=c.type;return d==CKEDITOR.NODE_ELEMENT?this.onElement(a,c):d==CKEDITOR.NODE_TEXT?new CKEDITOR.htmlParser.text(this.onText(a,c.value)):d==CKEDITOR.NODE_COMMENT?new CKEDITOR.htmlParser.comment(this.onComment(a,c.value)):null;},onAttribute:function onAttribute(a,c,d,e){return(d=this.attributesRules[d])?d.exec(a,e,c,this):e;}}});CKEDITOR.htmlParser.filterRulesGroup=a;a.prototype={add:function add(a,c,d){this.rules.splice(this.findIndex(c),0,{value:a,priority:c,options:d});},addMany:function addMany(a,c,d){for(var e=[this.findIndex(c),0],m=0,f=a.length;m<f;m++){e.push({value:a[m],priority:c,options:d});}this.rules.splice.apply(this.rules,e);},findIndex:function findIndex(a){for(var c=this.rules,d=c.length-1;0<=d&&a<c[d].priority;){d--;}return d+1;},exec:function exec(a,c){var d=c instanceof CKEDITOR.htmlParser.node||c instanceof CKEDITOR.htmlParser.fragment,e=Array.prototype.slice.call(arguments,1),m=this.rules,f=m.length,h,k,g,n;for(n=0;n<f;n++){if(d&&(h=c.type,k=c.name),g=m[n],!(a.nonEditable&&!g.options.applyToAll||a.nestedEditable&&g.options.excludeNestedEditable)){g=g.value.apply(null,e);if(!1===g||d&&g&&(g.name!=k||g.type!=h))return g;null!=g&&(e[0]=c=g);}}return c;},execOnName:function execOnName(a,c){for(var d=0,e=this.rules,m=e.length,f;c&&d<m;d++){f=e[d],a.nonEditable&&!f.options.applyToAll||a.nestedEditable&&f.options.excludeNestedEditable||(c=c.replace(f.value[0],f.value[1]));}return c;}};}(),function(){function a(a,f){function g(a){return a||CKEDITOR.env.needsNbspFiller?new CKEDITOR.htmlParser.text(" "):new CKEDITOR.htmlParser.element("br",{"data-cke-bogus":1});}function e(a,d){return function(f){if(f.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var e=[],h=b(f),u,m;if(h)for(k(h,1)&&e.push(h);h;){l(h)&&(u=c(h))&&k(u)&&((m=c(u))&&!l(m)?e.push(u):(g(A).insertAfter(u),u.remove())),h=h.previous;}for(h=0;h<e.length;h++){e[h].remove();}if(e=!a||!1!==("function"==typeof d?d(f):d))A||CKEDITOR.env.needsBrFiller||f.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT?A||CKEDITOR.env.needsBrFiller||!(7<document.documentMode||f.name in CKEDITOR.dtd.tr||f.name in CKEDITOR.dtd.$listItem)?(e=b(f),e=!e||"form"==f.name&&"input"==e.name):e=!1:e=!1;e&&f.add(g(a));}};}function k(a,b){if((!A||CKEDITOR.env.needsBrFiller)&&a.type==CKEDITOR.NODE_ELEMENT&&"br"==a.name&&!a.attributes["data-cke-eol"])return!0;var c;return a.type==CKEDITOR.NODE_TEXT&&(c=a.value.match(p))&&(c.index&&(new CKEDITOR.htmlParser.text(a.value.substring(0,c.index)).insertBefore(a),a.value=c[0]),!CKEDITOR.env.needsBrFiller&&A&&(!b||a.parent.name in n)||!A&&((c=a.previous)&&"br"==c.name||!c||l(c)))?!0:!1;}var h={elements:{}},A="html"==f,n=CKEDITOR.tools.extend({},u),x;for(x in n){"#"in z[x]||delete n[x];}for(x in n){h.elements[x]=e(A,a.config.fillEmptyBlocks);}h.root=e(A,!1);h.elements.br=function(a){return function(b){if(b.parent.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var f=b.attributes;if("data-cke-bogus"in f||"data-cke-eol"in f)delete f["data-cke-bogus"];else{for(f=b.next;f&&d(f);){f=f.next;}var e=c(b);!f&&l(b.parent)?m(b.parent,g(a)):l(f)&&e&&!l(e)&&g(a).insertBefore(f);}}};}(A);return h;}function e(a,b){return a!=CKEDITOR.ENTER_BR&&!1!==b?a==CKEDITOR.ENTER_DIV?"div":"p":!1;}function b(a){for(a=a.children[a.children.length-1];a&&d(a);){a=a.previous;}return a;}function c(a){for(a=a.previous;a&&d(a);){a=a.previous;}return a;}function d(a){return a.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.trim(a.value)||a.type==CKEDITOR.NODE_ELEMENT&&a.attributes["data-cke-bookmark"];}function l(a){return a&&(a.type==CKEDITOR.NODE_ELEMENT&&a.name in u||a.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT);}function m(a,b){var c=a.children[a.children.length-1];a.children.push(b);b.parent=a;c&&(c.next=b,b.previous=c);}function f(a){a=a.attributes;"false"!=a.contenteditable&&(a["data-cke-editable"]=a.contenteditable?"true":1);a.contenteditable="false";}function h(a){a=a.attributes;switch(a["data-cke-editable"]){case"true":a.contenteditable="true";break;case"1":delete a.contenteditable;}}function k(a){return a.replace(C,function(a,b,c){return"\x3c"+b+c.replace(F,function(a,b){return E.test(b)&&-1==c.indexOf("data-cke-saved-"+b)?" data-cke-saved-"+a+" data-cke-"+CKEDITOR.rnd+"-"+a:a;})+"\x3e";});}function g(a,b){return a.replace(b,function(a,b,c){0===a.indexOf("\x3ctextarea")&&(a=b+r(c).replace(/</g,"\x26lt;").replace(/>/g,"\x26gt;")+"\x3c/textarea\x3e");return"\x3ccke:encoded\x3e"+encodeURIComponent(a)+"\x3c/cke:encoded\x3e";});}function n(a){return a.replace(M,function(a,b){return decodeURIComponent(b);});}function v(a){return a.replace(/\x3c!--(?!{cke_protected})[\s\S]+?--\x3e/g,function(a){return"\x3c!--"+w+"{C}"+encodeURIComponent(a).replace(/--/g,"%2D%2D")+"--\x3e";});}function r(a){return a.replace(/\x3c!--\{cke_protected\}\{C\}([\s\S]+?)--\x3e/g,function(a,b){return decodeURIComponent(b);});}function q(a,b){var c=b._.dataStore;return a.replace(/\x3c!--\{cke_protected\}([\s\S]+?)--\x3e/g,function(a,b){return decodeURIComponent(b);}).replace(/\{cke_protected_(\d+)\}/g,function(a,b){return c&&c[b]||"";});}function t(a,b){var c=[],d=b.config.protectedSource,f=b._.dataStore||(b._.dataStore={id:1}),g=/<\!--\{cke_temp(comment)?\}(\d*?)--\x3e/g,d=[/<script[\s\S]*?(<\/script>|$)/gi,/<noscript[\s\S]*?<\/noscript>/gi,/<meta[\s\S]*?\/?>/gi].concat(d);a=a.replace(/\x3c!--[\s\S]*?--\x3e/g,function(a){return"\x3c!--{cke_tempcomment}"+(c.push(a)-1)+"--\x3e";});for(var e=0;e<d.length;e++){a=a.replace(d[e],function(a){a=a.replace(g,function(a,b,d){return c[d];});return /cke_temp(comment)?/.test(a)?a:"\x3c!--{cke_temp}"+(c.push(a)-1)+"--\x3e";});}a=a.replace(g,function(a,b,d){return"\x3c!--"+w+(b?"{C}":"")+encodeURIComponent(c[d]).replace(/--/g,"%2D%2D")+"--\x3e";});a=a.replace(/<\w+(?:\s+(?:(?:[^\s=>]+\s*=\s*(?:[^'"\s>]+|'[^']*'|"[^"]*"))|[^\s=\/>]+))+\s*\/?>/g,function(a){return a.replace(/\x3c!--\{cke_protected\}([^>]*)--\x3e/g,function(a,b){f[f.id]=decodeURIComponent(b);return"{cke_protected_"+f.id++ +"}";});});return a=a.replace(/<(title|iframe|textarea)([^>]*)>([\s\S]*?)<\/\1>/g,function(a,c,d,f){return"\x3c"+c+d+"\x3e"+q(r(f),b)+"\x3c/"+c+"\x3e";});}CKEDITOR.htmlDataProcessor=function(b){var c,d,f=this;this.editor=b;this.dataFilter=c=new CKEDITOR.htmlParser.filter();this.htmlFilter=d=new CKEDITOR.htmlParser.filter();this.writer=new CKEDITOR.htmlParser.basicWriter();c.addRules(x);c.addRules(D,{applyToAll:!0});c.addRules(a(b,"data"),{applyToAll:!0});d.addRules(y);d.addRules(B,{applyToAll:!0});d.addRules(a(b,"html"),{applyToAll:!0});b.on("toHtml",function(a){a=a.data;var c=a.dataValue,d,c=t(c,b),c=g(c,G),c=k(c),c=g(c,J),c=c.replace(I,"$1cke:$2"),c=c.replace(R,"\x3ccke:$1$2\x3e\x3c/cke:$1\x3e"),c=c.replace(/(<pre\b[^>]*>)(\r\n|\n)/g,"$1$2$2"),c=c.replace(/([^a-z0-9<\-])(on\w{3,})(?!>)/gi,"$1data-cke-"+CKEDITOR.rnd+"-$2");d=a.context||b.editable().getName();var f;CKEDITOR.env.ie&&9>CKEDITOR.env.version&&"pre"==d&&(d="div",c="\x3cpre\x3e"+c+"\x3c/pre\x3e",f=1);d=b.document.createElement(d);d.setHtml("a"+c);c=d.getHtml().substr(1);c=c.replace(new RegExp("data-cke-"+CKEDITOR.rnd+"-","ig"),"");f&&(c=c.replace(/^<pre>|<\/pre>$/gi,""));c=c.replace(H,"$1$2");c=n(c);c=r(c);d=!1===a.fixForBody?!1:e(a.enterMode,b.config.autoParagraph);c=CKEDITOR.htmlParser.fragment.fromHtml(c,a.context,d);d&&(f=c,!f.children.length&&CKEDITOR.dtd[f.name][d]&&(d=new CKEDITOR.htmlParser.element(d),f.add(d)));a.dataValue=c;},null,null,5);b.on("toHtml",function(a){a.data.filter.applyTo(a.data.dataValue,!0,a.data.dontFilter,a.data.enterMode)&&b.fire("dataFiltered");},null,null,6);b.on("toHtml",function(a){a.data.dataValue.filterChildren(f.dataFilter,!0);},null,null,10);b.on("toHtml",function(a){a=a.data;var b=a.dataValue,c=new CKEDITOR.htmlParser.basicWriter();b.writeChildrenHtml(c);b=c.getHtml(!0);a.dataValue=v(b);},null,null,15);b.on("toDataFormat",function(a){var c=a.data.dataValue;a.data.enterMode!=CKEDITOR.ENTER_BR&&(c=c.replace(/^<br *\/?>/i,""));a.data.dataValue=CKEDITOR.htmlParser.fragment.fromHtml(c,a.data.context,e(a.data.enterMode,b.config.autoParagraph));},null,null,5);b.on("toDataFormat",function(a){a.data.dataValue.filterChildren(f.htmlFilter,!0);},null,null,10);b.on("toDataFormat",function(a){a.data.filter.applyTo(a.data.dataValue,!1,!0);},null,null,11);b.on("toDataFormat",function(a){var c=a.data.dataValue,d=f.writer;d.reset();c.writeChildrenHtml(d);c=d.getHtml(!0);c=r(c);c=q(c,b);a.data.dataValue=c;},null,null,15);};CKEDITOR.htmlDataProcessor.prototype={toHtml:function toHtml(a,b,c,d){var f=this.editor,g,e,k,h;b&&"object"==(typeof b==="undefined"?"undefined":_typeof(b))?(g=b.context,c=b.fixForBody,d=b.dontFilter,e=b.filter,k=b.enterMode,h=b.protectedWhitespaces):g=b;g||null===g||(g=f.editable().getName());return f.fire("toHtml",{dataValue:a,context:g,fixForBody:c,dontFilter:d,filter:e||f.filter,enterMode:k||f.enterMode,protectedWhitespaces:h}).dataValue;},toDataFormat:function toDataFormat(a,b){var c,d,f;b&&(c=b.context,d=b.filter,f=b.enterMode);c||null===c||(c=this.editor.editable().getName());return this.editor.fire("toDataFormat",{dataValue:a,filter:d||this.editor.filter,context:c,enterMode:f||this.editor.enterMode}).dataValue;}};var p=/(?:&nbsp;|\xa0)$/,w="{cke_protected}",z=CKEDITOR.dtd,A="caption colgroup col thead tfoot tbody".split(" "),u=CKEDITOR.tools.extend({},z.$blockLimit,z.$block),x={elements:{input:f,textarea:f}},D={attributeNames:[[/^on/,"data-cke-pa-on"],[/^data-cke-expando$/,""]]},y={elements:{embed:function embed(a){var b=a.parent;if(b&&"object"==b.name){var c=b.attributes.width,b=b.attributes.height;c&&(a.attributes.width=c);b&&(a.attributes.height=b);}},a:function a(_a5){var b=_a5.attributes;if(!(_a5.children.length||b.name||b.id||_a5.attributes["data-cke-saved-name"]))return!1;}}},B={elementNames:[[/^cke:/,""],[/^\?xml:namespace$/,""]],attributeNames:[[/^data-cke-(saved|pa)-/,""],[/^data-cke-.*/,""],["hidefocus",""]],elements:{$:function $(a){var b=a.attributes;if(b){if(b["data-cke-temp"])return!1;for(var c=["name","href","src"],d,f=0;f<c.length;f++){d="data-cke-saved-"+c[f],d in b&&delete b[c[f]];}}return a;},table:function table(a){a.children.slice(0).sort(function(a,b){var c,d;a.type==CKEDITOR.NODE_ELEMENT&&b.type==a.type&&(c=CKEDITOR.tools.indexOf(A,a.name),d=CKEDITOR.tools.indexOf(A,b.name));-1<c&&-1<d&&c!=d||(c=a.parent?a.getIndex():-1,d=b.parent?b.getIndex():-1);return c>d?1:-1;});},param:function param(a){a.children=[];a.isEmpty=!0;return a;},span:function span(a){"Apple-style-span"==a.attributes["class"]&&delete a.name;},html:function html(a){delete a.attributes.contenteditable;delete a.attributes["class"];},body:function body(a){delete a.attributes.spellcheck;delete a.attributes.contenteditable;},style:function style(a){var b=a.children[0];b&&b.value&&(b.value=CKEDITOR.tools.trim(b.value));a.attributes.type||(a.attributes.type="text/css");},title:function title(a){var b=a.children[0];!b&&m(a,b=new CKEDITOR.htmlParser.text());b.value=a.attributes["data-cke-title"]||"";},input:h,textarea:h},attributes:{"class":function _class(a){return CKEDITOR.tools.ltrim(a.replace(/(?:^|\s+)cke_[^\s]*/g,""))||!1;}}};CKEDITOR.env.ie&&(B.attributes.style=function(a){return a.replace(/(^|;)([^\:]+)/g,function(a){return a.toLowerCase();});});var C=/<(a|area|img|input|source)\b([^>]*)>/gi,F=/([\w-:]+)\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|(?:[^ "'>]+))/gi,E=/^(href|src|name)$/i,J=/(?:<style(?=[ >])[^>]*>[\s\S]*?<\/style>)|(?:<(:?link|meta|base)[^>]*>)/gi,G=/(<textarea(?=[ >])[^>]*>)([\s\S]*?)(?:<\/textarea>)/gi,M=/<cke:encoded>([^<]*)<\/cke:encoded>/gi,I=/(<\/?)((?:object|embed|param|html|body|head|title)[^>]*>)/gi,H=/(<\/?)cke:((?:html|body|head|title)[^>]*>)/gi,R=/<cke:(param|embed)([^>]*?)\/?>(?!\s*<\/cke:\1)/gi;}(),"use strict",CKEDITOR.htmlParser.element=function(a,e){this.name=a;this.attributes=e||{};this.children=[];var b=a||"",c=b.match(/^cke:(.*)/);c&&(b=c[1]);b=!!(CKEDITOR.dtd.$nonBodyContent[b]||CKEDITOR.dtd.$block[b]||CKEDITOR.dtd.$listItem[b]||CKEDITOR.dtd.$tableContent[b]||CKEDITOR.dtd.$nonEditable[b]||"br"==b);this.isEmpty=!!CKEDITOR.dtd.$empty[a];this.isUnknown=!CKEDITOR.dtd[a];this._={isBlockLike:b,hasInlineStarted:this.isEmpty||!b};},CKEDITOR.htmlParser.cssStyle=function(a){var e={};((a instanceof CKEDITOR.htmlParser.element?a.attributes.style:a)||"").replace(/&quot;/g,'"').replace(/\s*([^ :;]+)\s*:\s*([^;]+)\s*(?=;|$)/g,function(a,c,d){"font-family"==c&&(d=d.replace(/["']/g,""));e[c.toLowerCase()]=d;});return{rules:e,populate:function populate(a){var c=this.toString();c&&(a instanceof CKEDITOR.dom.element?a.setAttribute("style",c):a instanceof CKEDITOR.htmlParser.element?a.attributes.style=c:a.style=c);},toString:function toString(){var a=[],c;for(c in e){e[c]&&a.push(c,":",e[c],";");}return a.join("");}};},function(){function a(a){return function(b){return b.type==CKEDITOR.NODE_ELEMENT&&("string"==typeof a?b.name==a:b.name in a);};}var e=function e(a,b){a=a[0];b=b[0];return a<b?-1:a>b?1:0;},b=CKEDITOR.htmlParser.fragment.prototype;CKEDITOR.htmlParser.element.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node(),{type:CKEDITOR.NODE_ELEMENT,add:b.add,clone:function clone(){return new CKEDITOR.htmlParser.element(this.name,this.attributes);},filter:function filter(a,b){var e=this,m,f;b=e.getFilterContext(b);if(b.off)return!0;if(!e.parent)a.onRoot(b,e);for(;;){m=e.name;if(!(f=a.onElementName(b,m)))return this.remove(),!1;e.name=f;if(!(e=a.onElement(b,e)))return this.remove(),!1;if(e!==this)return this.replaceWith(e),!1;if(e.name==m)break;if(e.type!=CKEDITOR.NODE_ELEMENT)return this.replaceWith(e),!1;if(!e.name)return this.replaceWithChildren(),!1;}m=e.attributes;var h,k;for(h in m){for(f=m[h];;){if(k=a.onAttributeName(b,h)){if(k!=h)delete m[h],h=k;else break;}else{delete m[h];break;}}k&&(!1===(f=a.onAttribute(b,e,k,f))?delete m[k]:m[k]=f);}e.isEmpty||this.filterChildren(a,!1,b);return!0;},filterChildren:b.filterChildren,writeHtml:function writeHtml(a,b){b&&this.filter(b);var l=this.name,m=[],f=this.attributes,h,k;a.openTag(l,f);for(h in f){m.push([h,f[h]]);}a.sortAttributes&&m.sort(e);h=0;for(k=m.length;h<k;h++){f=m[h],a.attribute(f[0],f[1]);}a.openTagClose(l,this.isEmpty);this.writeChildrenHtml(a);this.isEmpty||a.closeTag(l);},writeChildrenHtml:b.writeChildrenHtml,replaceWithChildren:function replaceWithChildren(){for(var a=this.children,b=a.length;b;){a[--b].insertAfter(this);}this.remove();},forEach:b.forEach,getFirst:function getFirst(b){if(!b)return this.children.length?this.children[0]:null;"function"!=typeof b&&(b=a(b));for(var d=0,e=this.children.length;d<e;++d){if(b(this.children[d]))return this.children[d];}return null;},getHtml:function getHtml(){var a=new CKEDITOR.htmlParser.basicWriter();this.writeChildrenHtml(a);return a.getHtml();},setHtml:function setHtml(a){a=this.children=CKEDITOR.htmlParser.fragment.fromHtml(a).children;for(var b=0,e=a.length;b<e;++b){a[b].parent=this;}},getOuterHtml:function getOuterHtml(){var a=new CKEDITOR.htmlParser.basicWriter();this.writeHtml(a);return a.getHtml();},split:function split(a){for(var b=this.children.splice(a,this.children.length-a),e=this.clone(),m=0;m<b.length;++m){b[m].parent=e;}e.children=b;b[0]&&(b[0].previous=null);0<a&&(this.children[a-1].next=null);this.parent.add(e,this.getIndex()+1);return e;},addClass:function addClass(a){if(!this.hasClass(a)){var b=this.attributes["class"]||"";this.attributes["class"]=b+(b?" ":"")+a;}},removeClass:function removeClass(a){var b=this.attributes["class"];b&&((b=CKEDITOR.tools.trim(b.replace(new RegExp("(?:\\s+|^)"+a+"(?:\\s+|$)")," ")))?this.attributes["class"]=b:delete this.attributes["class"]);},hasClass:function hasClass(a){var b=this.attributes["class"];return b?new RegExp("(?:^|\\s)"+a+"(?\x3d\\s|$)").test(b):!1;},getFilterContext:function getFilterContext(a){var b=[];a||(a={off:!1,nonEditable:!1,nestedEditable:!1});a.off||"off"!=this.attributes["data-cke-processor"]||b.push("off",!0);a.nonEditable||"false"!=this.attributes.contenteditable?a.nonEditable&&!a.nestedEditable&&"true"==this.attributes.contenteditable&&b.push("nestedEditable",!0):b.push("nonEditable",!0);if(b.length){a=CKEDITOR.tools.copy(a);for(var e=0;e<b.length;e+=2){a[b[e]]=b[e+1];}}return a;}},!0);}(),function(){var a={},e=/{([^}]+)}/g,b=/([\\'])/g,c=/\n/g,d=/\r/g;CKEDITOR.template=function(l){if(a[l])this.output=a[l];else{var m=l.replace(b,"\\$1").replace(c,"\\n").replace(d,"\\r").replace(e,function(a,b){return"',data['"+b+"']\x3d\x3dundefined?'{"+b+"}':data['"+b+"'],'";});this.output=a[l]=Function("data","buffer","return buffer?buffer.push('"+m+"'):['"+m+"'].join('');");}};}(),delete CKEDITOR.loadFullCore,CKEDITOR.instances={},CKEDITOR.document=new CKEDITOR.dom.document(document),CKEDITOR.add=function(a){CKEDITOR.instances[a.name]=a;a.on("focus",function(){CKEDITOR.currentInstance!=a&&(CKEDITOR.currentInstance=a,CKEDITOR.fire("currentInstance"));});a.on("blur",function(){CKEDITOR.currentInstance==a&&(CKEDITOR.currentInstance=null,CKEDITOR.fire("currentInstance"));});CKEDITOR.fire("instance",null,a);},CKEDITOR.remove=function(a){delete CKEDITOR.instances[a.name];},function(){var a={};CKEDITOR.addTemplate=function(e,b){var c=a[e];if(c)return c;c={name:e,source:b};CKEDITOR.fire("template",c);return a[e]=new CKEDITOR.template(c.source);};CKEDITOR.getTemplate=function(e){return a[e];};}(),function(){var a=[];CKEDITOR.addCss=function(e){a.push(e);};CKEDITOR.getCss=function(){return a.join("\n");};}(),CKEDITOR.on("instanceDestroyed",function(){CKEDITOR.tools.isEmpty(this.instances)&&CKEDITOR.fire("reset");}),CKEDITOR.TRISTATE_ON=1,CKEDITOR.TRISTATE_OFF=2,CKEDITOR.TRISTATE_DISABLED=0,function(){CKEDITOR.inline=function(a,e){if(!CKEDITOR.env.isCompatible)return null;a=CKEDITOR.dom.element.get(a);if(a.getEditor())throw'The editor instance "'+a.getEditor().name+'" is already attached to the provided element.';var b=new CKEDITOR.editor(e,a,CKEDITOR.ELEMENT_MODE_INLINE),c=a.is("textarea")?a:null;c?(b.setData(c.getValue(),null,!0),a=CKEDITOR.dom.element.createFromHtml('\x3cdiv contenteditable\x3d"'+!!b.readOnly+'" class\x3d"cke_textarea_inline"\x3e'+c.getValue()+"\x3c/div\x3e",CKEDITOR.document),a.insertAfter(c),c.hide(),c.$.form&&b._attachToForm()):b.setData(a.getHtml(),null,!0);b.on("loaded",function(){b.fire("uiReady");b.editable(a);b.container=a;b.ui.contentsElement=a;b.setData(b.getData(1));b.resetDirty();b.fire("contentDom");b.mode="wysiwyg";b.fire("mode");b.status="ready";b.fireOnce("instanceReady");CKEDITOR.fire("instanceReady",null,b);},null,null,1E4);b.on("destroy",function(){c&&(b.container.clearCustomData(),b.container.remove(),c.show());b.element.clearCustomData();delete b.element;});return b;};CKEDITOR.inlineAll=function(){var a,e,b;for(b in CKEDITOR.dtd.$editable){for(var c=CKEDITOR.document.getElementsByTag(b),d=0,l=c.count();d<l;d++){a=c.getItem(d),"true"==a.getAttribute("contenteditable")&&(e={element:a,config:{}},!1!==CKEDITOR.fire("inline",e)&&CKEDITOR.inline(a,e.config));}}};CKEDITOR.domReady(function(){!CKEDITOR.disableAutoInline&&CKEDITOR.inlineAll();});}(),CKEDITOR.replaceClass="ckeditor",function(){function a(a,d,l,m){if(!CKEDITOR.env.isCompatible)return null;a=CKEDITOR.dom.element.get(a);if(a.getEditor())throw'The editor instance "'+a.getEditor().name+'" is already attached to the provided element.';var f=new CKEDITOR.editor(d,a,m);m==CKEDITOR.ELEMENT_MODE_REPLACE&&(a.setStyle("visibility","hidden"),f._.required=a.hasAttribute("required"),a.removeAttribute("required"));l&&f.setData(l,null,!0);f.on("loaded",function(){b(f);m==CKEDITOR.ELEMENT_MODE_REPLACE&&f.config.autoUpdateElement&&a.$.form&&f._attachToForm();f.setMode(f.config.startupMode,function(){f.resetDirty();f.status="ready";f.fireOnce("instanceReady");CKEDITOR.fire("instanceReady",null,f);});});f.on("destroy",e);return f;}function e(){var a=this.container,b=this.element;a&&(a.clearCustomData(),a.remove());b&&(b.clearCustomData(),this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE&&(b.show(),this._.required&&b.setAttribute("required","required")),delete this.element);}function b(a){var b=a.name,e=a.element,m=a.elementMode,f=a.fire("uiSpace",{space:"top",html:""}).html,h=a.fire("uiSpace",{space:"bottom",html:""}).html,k=new CKEDITOR.template('\x3c{outerEl} id\x3d"cke_{name}" class\x3d"{id} cke cke_reset cke_chrome cke_editor_{name} cke_{langDir} '+CKEDITOR.env.cssClass+'"  dir\x3d"{langDir}" lang\x3d"{langCode}" role\x3d"application"'+(a.title?' aria-labelledby\x3d"cke_{name}_arialbl"':"")+"\x3e"+(a.title?'\x3cspan id\x3d"cke_{name}_arialbl" class\x3d"cke_voice_label"\x3e{voiceLabel}\x3c/span\x3e':"")+'\x3c{outerEl} class\x3d"cke_inner cke_reset" role\x3d"presentation"\x3e{topHtml}\x3c{outerEl} id\x3d"{contentId}" class\x3d"cke_contents cke_reset" role\x3d"presentation"\x3e\x3c/{outerEl}\x3e{bottomHtml}\x3c/{outerEl}\x3e\x3c/{outerEl}\x3e'),b=CKEDITOR.dom.element.createFromHtml(k.output({id:a.id,name:b,langDir:a.lang.dir,langCode:a.langCode,voiceLabel:a.title,topHtml:f?'\x3cspan id\x3d"'+a.ui.spaceId("top")+'" class\x3d"cke_top cke_reset_all" role\x3d"presentation" style\x3d"height:auto"\x3e'+f+"\x3c/span\x3e":"",contentId:a.ui.spaceId("contents"),bottomHtml:h?'\x3cspan id\x3d"'+a.ui.spaceId("bottom")+'" class\x3d"cke_bottom cke_reset_all" role\x3d"presentation"\x3e'+h+"\x3c/span\x3e":"",outerEl:CKEDITOR.env.ie?"span":"div"}));m==CKEDITOR.ELEMENT_MODE_REPLACE?(e.hide(),b.insertAfter(e)):e.append(b);a.container=b;a.ui.contentsElement=a.ui.space("contents");f&&a.ui.space("top").unselectable();h&&a.ui.space("bottom").unselectable();e=a.config.width;m=a.config.height;e&&b.setStyle("width",CKEDITOR.tools.cssLength(e));m&&a.ui.space("contents").setStyle("height",CKEDITOR.tools.cssLength(m));b.disableContextMenu();CKEDITOR.env.webkit&&b.on("focus",function(){a.focus();});a.fireOnce("uiReady");}CKEDITOR.replace=function(b,d){return a(b,d,null,CKEDITOR.ELEMENT_MODE_REPLACE);};CKEDITOR.appendTo=function(b,d,e){return a(b,d,e,CKEDITOR.ELEMENT_MODE_APPENDTO);};CKEDITOR.replaceAll=function(){for(var a=document.getElementsByTagName("textarea"),b=0;b<a.length;b++){var e=null,m=a[b];if(m.name||m.id){if("string"==typeof arguments[0]){if(!new RegExp("(?:^|\\s)"+arguments[0]+"(?:$|\\s)").test(m.className))continue;}else if("function"==typeof arguments[0]&&(e={},!1===arguments[0](m,e)))continue;this.replace(m,e);}}};CKEDITOR.editor.prototype.addMode=function(a,b){(this._.modes||(this._.modes={}))[a]=b;};CKEDITOR.editor.prototype.setMode=function(a,b){var e=this,m=this._.modes;if(a!=e.mode&&m&&m[a]){e.fire("beforeSetMode",a);if(e.mode){var f=e.checkDirty(),m=e._.previousModeData,h,k=0;e.fire("beforeModeUnload");e.editable(0);e._.previousMode=e.mode;e._.previousModeData=h=e.getData(1);"source"==e.mode&&m==h&&(e.fire("lockSnapshot",{forceUpdate:!0}),k=1);e.ui.space("contents").setHtml("");e.mode="";}else e._.previousModeData=e.getData(1);this._.modes[a](function(){e.mode=a;void 0!==f&&!f&&e.resetDirty();k?e.fire("unlockSnapshot"):"wysiwyg"==a&&e.fire("saveSnapshot");setTimeout(function(){e.fire("mode");b&&b.call(e);},0);});}};CKEDITOR.editor.prototype.resize=function(a,b,e,m){var f=this.container,h=this.ui.space("contents"),k=CKEDITOR.env.webkit&&this.document&&this.document.getWindow().$.frameElement;m=m?this.container.getFirst(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasClass("cke_inner");}):f;m.setSize("width",a,!0);k&&(k.style.width="1%");var g=(m.$.offsetHeight||0)-(h.$.clientHeight||0),f=Math.max(b-(e?0:g),0);b=e?b+g:b;h.setStyle("height",f+"px");k&&(k.style.width="100%");this.fire("resize",{outerHeight:b,contentsHeight:f,outerWidth:a||m.getSize("width")});};CKEDITOR.editor.prototype.getResizable=function(a){return a?this.ui.space("contents"):this.container;};CKEDITOR.domReady(function(){CKEDITOR.replaceClass&&CKEDITOR.replaceAll(CKEDITOR.replaceClass);});}(),CKEDITOR.config.startupMode="wysiwyg",function(){function a(a){var b=a.editor,d=a.data.path,f=d.blockLimit,g=a.data.selection,k=g.getRanges()[0],h;if(CKEDITOR.env.gecko||CKEDITOR.env.ie&&CKEDITOR.env.needsBrFiller)if(g=e(g,d))g.appendBogus(),h=CKEDITOR.env.ie;m(b,d.block,f)&&k.collapsed&&!k.getCommonAncestor().isReadOnly()&&(d=k.clone(),d.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS),f=new CKEDITOR.dom.walker(d),f.guard=function(a){return!c(a)||a.type==CKEDITOR.NODE_COMMENT||a.isReadOnly();},!f.checkForward()||d.checkStartOfBlock()&&d.checkEndOfBlock())&&(b=k.fixBlock(!0,b.activeEnterMode==CKEDITOR.ENTER_DIV?"div":"p"),CKEDITOR.env.needsBrFiller||(b=b.getFirst(c))&&b.type==CKEDITOR.NODE_TEXT&&CKEDITOR.tools.trim(b.getText()).match(/^(?:&nbsp;|\xa0)$/)&&b.remove(),h=1,a.cancel());h&&k.select();}function e(a,b){if(a.isFake)return 0;var d=b.block||b.blockLimit,f=d&&d.getLast(c);if(!(!d||!d.isBlockBoundary()||f&&f.type==CKEDITOR.NODE_ELEMENT&&f.isBlockBoundary()||d.is("pre")||d.getBogus()))return d;}function b(a){var b=a.data.getTarget();b.is("input")&&(b=b.getAttribute("type"),"submit"!=b&&"reset"!=b||a.data.preventDefault());}function c(a){return g(a)&&n(a);}function d(a,b){return function(c){var d=c.data.$.toElement||c.data.$.fromElement||c.data.$.relatedTarget;(d=d&&d.nodeType==CKEDITOR.NODE_ELEMENT?new CKEDITOR.dom.element(d):null)&&(b.equals(d)||b.contains(d))||a.call(this,c);};}function l(a){function b(a){return function(b,f){f&&b.type==CKEDITOR.NODE_ELEMENT&&b.is(g)&&(d=b);if(!(f||!c(b)||a&&r(b)))return!1;};}var d,f=a.getRanges()[0];a=a.root;var g={table:1,ul:1,ol:1,dl:1};if(f.startPath().contains(g)){var e=f.clone();e.collapse(1);e.setStartAt(a,CKEDITOR.POSITION_AFTER_START);a=new CKEDITOR.dom.walker(e);a.guard=b();a.checkBackward();if(d)return e=f.clone(),e.collapse(),e.setEndAt(d,CKEDITOR.POSITION_AFTER_END),a=new CKEDITOR.dom.walker(e),a.guard=b(!0),d=!1,a.checkForward(),d;}return null;}function m(a,b,c){return!1!==a.config.autoParagraph&&a.activeEnterMode!=CKEDITOR.ENTER_BR&&(a.editable().equals(c)&&!b||b&&"true"==b.getAttribute("contenteditable"));}function f(a){return a.activeEnterMode!=CKEDITOR.ENTER_BR&&!1!==a.config.autoParagraph?a.activeEnterMode==CKEDITOR.ENTER_DIV?"div":"p":!1;}function h(a){var b=a.editor;b.getSelection().scrollIntoView();setTimeout(function(){b.fire("saveSnapshot");},0);}function k(a,b,c){var d=a.getCommonAncestor(b);for(b=a=c?b:a;(a=a.getParent())&&!d.equals(a)&&1==a.getChildCount();){b=a;}b.remove();}var g,n,v,r,q,t,p,w,z;CKEDITOR.editable=CKEDITOR.tools.createClass({base:CKEDITOR.dom.element,$:function $(a,b){this.base(b.$||b);this.editor=a;this.status="unloaded";this.hasFocus=!1;this.setup();},proto:{focus:function focus(){var a;if(CKEDITOR.env.webkit&&!this.hasFocus&&(a=this.editor._.previousActive||this.getDocument().getActive(),this.contains(a))){a.focus();return;}CKEDITOR.env.edge&&14<CKEDITOR.env.version&&!this.hasFocus&&this.getDocument().equals(CKEDITOR.document)&&(this.editor._.previousScrollTop=this.$.scrollTop);try{!CKEDITOR.env.ie||CKEDITOR.env.edge&&14<CKEDITOR.env.version||!this.getDocument().equals(CKEDITOR.document)?this.$.focus():this.$.setActive();}catch(b){if(!CKEDITOR.env.ie)throw b;}CKEDITOR.env.safari&&!this.isInline()&&(a=CKEDITOR.document.getActive(),a.equals(this.getWindow().getFrame())||this.getWindow().focus());},on:function on(a,b){var c=Array.prototype.slice.call(arguments,0);CKEDITOR.env.ie&&/^focus|blur$/.exec(a)&&(a="focus"==a?"focusin":"focusout",b=d(b,this),c[0]=a,c[1]=b);return CKEDITOR.dom.element.prototype.on.apply(this,c);},attachListener:function attachListener(a){!this._.listeners&&(this._.listeners=[]);var b=Array.prototype.slice.call(arguments,1),b=a.on.apply(a,b);this._.listeners.push(b);return b;},clearListeners:function clearListeners(){var a=this._.listeners;try{for(;a.length;){a.pop().removeListener();}}catch(b){}},restoreAttrs:function restoreAttrs(){var a=this._.attrChanges,b,c;for(c in a){a.hasOwnProperty(c)&&(b=a[c],null!==b?this.setAttribute(c,b):this.removeAttribute(c));}},attachClass:function attachClass(a){var b=this.getCustomData("classes");this.hasClass(a)||(!b&&(b=[]),b.push(a),this.setCustomData("classes",b),this.addClass(a));},changeAttr:function changeAttr(a,b){var c=this.getAttribute(a);b!==c&&(!this._.attrChanges&&(this._.attrChanges={}),a in this._.attrChanges||(this._.attrChanges[a]=c),this.setAttribute(a,b));},insertText:function insertText(a){this.editor.focus();this.insertHtml(this.transformPlainTextToHtml(a),"text");},transformPlainTextToHtml:function transformPlainTextToHtml(a){var b=this.editor.getSelection().getStartElement().hasAscendant("pre",!0)?CKEDITOR.ENTER_BR:this.editor.activeEnterMode;return CKEDITOR.tools.transformPlainTextToHtml(a,b);},insertHtml:function insertHtml(a,b,c){var d=this.editor;d.focus();d.fire("saveSnapshot");c||(c=d.getSelection().getRanges()[0]);t(this,b||"html",a,c);c.select();h(this);this.editor.fire("afterInsertHtml",{});},insertHtmlIntoRange:function insertHtmlIntoRange(a,b,c){t(this,c||"html",a,b);this.editor.fire("afterInsertHtml",{intoRange:b});},insertElement:function insertElement(a,b){var d=this.editor;d.focus();d.fire("saveSnapshot");var f=d.activeEnterMode,d=d.getSelection(),g=a.getName(),g=CKEDITOR.dtd.$block[g];b||(b=d.getRanges()[0]);this.insertElementIntoRange(a,b)&&(b.moveToPosition(a,CKEDITOR.POSITION_AFTER_END),g&&((g=a.getNext(function(a){return c(a)&&!r(a);}))&&g.type==CKEDITOR.NODE_ELEMENT&&g.is(CKEDITOR.dtd.$block)?g.getDtd()["#"]?b.moveToElementEditStart(g):b.moveToElementEditEnd(a):g||f==CKEDITOR.ENTER_BR||(g=b.fixBlock(!0,f==CKEDITOR.ENTER_DIV?"div":"p"),b.moveToElementEditStart(g))));d.selectRanges([b]);h(this);},insertElementIntoSelection:function insertElementIntoSelection(a){this.insertElement(a);},insertElementIntoRange:function insertElementIntoRange(a,b){var c=this.editor,d=c.config.enterMode,f=a.getName(),g=CKEDITOR.dtd.$block[f];if(b.checkReadOnly())return!1;b.deleteContents(1);b.startContainer.type==CKEDITOR.NODE_ELEMENT&&b.startContainer.is({tr:1,table:1,tbody:1,thead:1,tfoot:1})&&p(b);var e,k;if(g)for(;(e=b.getCommonAncestor(0,1))&&(k=CKEDITOR.dtd[e.getName()])&&(!k||!k[f]);){e.getName()in CKEDITOR.dtd.span?b.splitElement(e):b.checkStartOfBlock()&&b.checkEndOfBlock()?(b.setStartBefore(e),b.collapse(!0),e.remove()):b.splitBlock(d==CKEDITOR.ENTER_DIV?"div":"p",c.editable());}b.insertNode(a);return!0;},setData:function setData(a,b){b||(a=this.editor.dataProcessor.toHtml(a));this.setHtml(a);this.fixInitialSelection();"unloaded"==this.status&&(this.status="ready");this.editor.fire("dataReady");},getData:function getData(a){var b=this.getHtml();a||(b=this.editor.dataProcessor.toDataFormat(b));return b;},setReadOnly:function setReadOnly(a){this.setAttribute("contenteditable",!a);},detach:function detach(){this.removeClass("cke_editable");this.status="detached";var a=this.editor;this._.detach();delete a.document;delete a.window;},isInline:function isInline(){return this.getDocument().equals(CKEDITOR.document);},fixInitialSelection:function fixInitialSelection(){function a(){var b=c.getDocument().$,d=b.getSelection(),f;a:if(d.anchorNode&&d.anchorNode==c.$)f=!0;else{if(CKEDITOR.env.webkit&&(f=c.getDocument().getActive())&&f.equals(c)&&!d.anchorNode){f=!0;break a;}f=void 0;}f&&(f=new CKEDITOR.dom.range(c),f.moveToElementEditStart(c),b=b.createRange(),b.setStart(f.startContainer.$,f.startOffset),b.collapse(!0),d.removeAllRanges(),d.addRange(b));}function b(){var a=c.getDocument().$,d=a.selection,f=c.getDocument().getActive();"None"==d.type&&f.equals(c)&&(d=new CKEDITOR.dom.range(c),a=a.body.createTextRange(),d.moveToElementEditStart(c),d=d.startContainer,d.type!=CKEDITOR.NODE_ELEMENT&&(d=d.getParent()),a.moveToElementText(d.$),a.collapse(!0),a.select());}var c=this;if(CKEDITOR.env.ie&&(9>CKEDITOR.env.version||CKEDITOR.env.quirks))this.hasFocus&&(this.focus(),b());else if(this.hasFocus)this.focus(),a();else this.once("focus",function(){a();},null,null,-999);},getHtmlFromRange:function getHtmlFromRange(a){if(a.collapsed)return new CKEDITOR.dom.documentFragment(a.document);a={doc:this.getDocument(),range:a.clone()};w.eol.detect(a,this);w.bogus.exclude(a);w.cell.shrink(a);a.fragment=a.range.cloneContents();w.tree.rebuild(a,this);w.eol.fix(a,this);return new CKEDITOR.dom.documentFragment(a.fragment.$);},extractHtmlFromRange:function extractHtmlFromRange(a,b){var c=z,d={range:a,doc:a.document},f=this.getHtmlFromRange(a);if(a.collapsed)return a.optimize(),f;a.enlarge(CKEDITOR.ENLARGE_INLINE,1);c.table.detectPurge(d);d.bookmark=a.createBookmark();delete d.range;var g=this.editor.createRange();g.moveToPosition(d.bookmark.startNode,CKEDITOR.POSITION_BEFORE_START);d.targetBookmark=g.createBookmark();c.list.detectMerge(d,this);c.table.detectRanges(d,this);c.block.detectMerge(d,this);d.tableContentsRanges?(c.table.deleteRanges(d),a.moveToBookmark(d.bookmark),d.range=a):(a.moveToBookmark(d.bookmark),d.range=a,a.extractContents(c.detectExtractMerge(d)));a.moveToBookmark(d.targetBookmark);a.optimize();c.fixUneditableRangePosition(a);c.list.merge(d,this);c.table.purge(d,this);c.block.merge(d,this);if(b){c=a.startPath();if(d=a.checkStartOfBlock()&&a.checkEndOfBlock()&&c.block&&!a.root.equals(c.block)){a:{var d=c.block.getElementsByTag("span"),g=0,e;if(d)for(;e=d.getItem(g++);){if(!n(e)){d=!0;break a;}}d=!1;}d=!d;}d&&(a.moveToPosition(c.block,CKEDITOR.POSITION_BEFORE_START),c.block.remove());}else c.autoParagraph(this.editor,a),v(a.startContainer)&&a.startContainer.appendBogus();a.startContainer.mergeSiblings();return f;},setup:function setup(){var a=this.editor;this.attachListener(a,"beforeGetData",function(){var b=this.getData();this.is("textarea")||!1!==a.config.ignoreEmptyParagraph&&(b=b.replace(q,function(a,b){return b;}));a.setData(b,null,1);},this);this.attachListener(a,"getSnapshot",function(a){a.data=this.getData(1);},this);this.attachListener(a,"afterSetData",function(){this.setData(a.getData(1));},this);this.attachListener(a,"loadSnapshot",function(a){this.setData(a.data,1);},this);this.attachListener(a,"beforeFocus",function(){var b=a.getSelection();(b=b&&b.getNative())&&"Control"==b.type||this.focus();},this);this.attachListener(a,"insertHtml",function(a){this.insertHtml(a.data.dataValue,a.data.mode,a.data.range);},this);this.attachListener(a,"insertElement",function(a){this.insertElement(a.data);},this);this.attachListener(a,"insertText",function(a){this.insertText(a.data);},this);this.setReadOnly(a.readOnly);this.attachClass("cke_editable");a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?this.attachClass("cke_editable_inline"):a.elementMode!=CKEDITOR.ELEMENT_MODE_REPLACE&&a.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO||this.attachClass("cke_editable_themed");this.attachClass("cke_contents_"+a.config.contentsLangDirection);a.keystrokeHandler.blockedKeystrokes[8]=+a.readOnly;a.keystrokeHandler.attach(this);this.on("blur",function(){this.hasFocus=!1;},null,null,-1);this.on("focus",function(){this.hasFocus=!0;},null,null,-1);if(CKEDITOR.env.webkit)this.on("scroll",function(){a._.previousScrollTop=a.editable().$.scrollTop;},null,null,-1);if(CKEDITOR.env.edge&&14<CKEDITOR.env.version){var d=function d(){var b=a.editable();null!=a._.previousScrollTop&&b.getDocument().equals(CKEDITOR.document)&&(b.$.scrollTop=a._.previousScrollTop,a._.previousScrollTop=null,this.removeListener("scroll",d));};this.on("scroll",d);}a.focusManager.add(this);this.equals(CKEDITOR.document.getActive())&&(this.hasFocus=!0,a.once("contentDom",function(){a.focusManager.focus(this);},this));this.isInline()&&this.changeAttr("tabindex",a.tabIndex);if(!this.is("textarea")){a.document=this.getDocument();a.window=this.getWindow();var f=a.document;this.changeAttr("spellcheck",!a.config.disableNativeSpellChecker);var e=a.config.contentsLangDirection;this.getDirection(1)!=e&&this.changeAttr("dir",e);var h=CKEDITOR.getCss();if(h){var e=f.getHead(),m=e.getCustomData("stylesheet");m?h!=m.getText()&&(CKEDITOR.env.ie&&9>CKEDITOR.env.version?m.$.styleSheet.cssText=h:m.setText(h)):(h=f.appendStyleText(h),h=new CKEDITOR.dom.element(h.ownerNode||h.owningElement),e.setCustomData("stylesheet",h),h.data("cke-temp",1));}e=f.getCustomData("stylesheet_ref")||0;f.setCustomData("stylesheet_ref",e+1);this.setCustomData("cke_includeReadonly",!a.config.disableReadonlyStyling);this.attachListener(this,"click",function(a){a=a.data;var b=new CKEDITOR.dom.elementPath(a.getTarget(),this).contains("a");b&&2!=a.$.button&&b.isReadOnly()&&a.preventDefault();});var n={8:1,46:1};this.attachListener(a,"key",function(b){if(a.readOnly)return!0;var c=b.data.domEvent.getKey(),d;if(c in n){b=a.getSelection();var f,e=b.getRanges()[0],h=e.startPath(),k,m,u,c=8==c;CKEDITOR.env.ie&&11>CKEDITOR.env.version&&(f=b.getSelectedElement())||(f=l(b))?(a.fire("saveSnapshot"),e.moveToPosition(f,CKEDITOR.POSITION_BEFORE_START),f.remove(),e.select(),a.fire("saveSnapshot"),d=1):e.collapsed&&((k=h.block)&&(u=k[c?"getPrevious":"getNext"](g))&&u.type==CKEDITOR.NODE_ELEMENT&&u.is("table")&&e[c?"checkStartOfBlock":"checkEndOfBlock"]()?(a.fire("saveSnapshot"),e[c?"checkEndOfBlock":"checkStartOfBlock"]()&&k.remove(),e["moveToElementEdit"+(c?"End":"Start")](u),e.select(),a.fire("saveSnapshot"),d=1):h.blockLimit&&h.blockLimit.is("td")&&(m=h.blockLimit.getAscendant("table"))&&e.checkBoundaryOfElement(m,c?CKEDITOR.START:CKEDITOR.END)&&(u=m[c?"getPrevious":"getNext"](g))?(a.fire("saveSnapshot"),e["moveToElementEdit"+(c?"End":"Start")](u),e.checkStartOfBlock()&&e.checkEndOfBlock()?u.remove():e.select(),a.fire("saveSnapshot"),d=1):(m=h.contains(["td","th","caption"]))&&e.checkBoundaryOfElement(m,c?CKEDITOR.START:CKEDITOR.END)&&(d=1));}return!d;});a.blockless&&CKEDITOR.env.ie&&CKEDITOR.env.needsBrFiller&&this.attachListener(this,"keyup",function(b){b.data.getKeystroke()in n&&!this.getFirst(c)&&(this.appendBogus(),b=a.createRange(),b.moveToPosition(this,CKEDITOR.POSITION_AFTER_START),b.select());});this.attachListener(this,"dblclick",function(b){if(a.readOnly)return!1;b={element:b.data.getTarget()};a.fire("doubleclick",b);});CKEDITOR.env.ie&&this.attachListener(this,"click",b);CKEDITOR.env.ie&&!CKEDITOR.env.edge||this.attachListener(this,"mousedown",function(b){var c=b.data.getTarget();c.is("img","hr","input","textarea","select")&&!c.isReadOnly()&&(a.getSelection().selectElement(c),c.is("input","textarea","select")&&b.data.preventDefault());});CKEDITOR.env.edge&&this.attachListener(this,"mouseup",function(b){(b=b.data.getTarget())&&b.is("img")&&a.getSelection().selectElement(b);});CKEDITOR.env.gecko&&this.attachListener(this,"mouseup",function(b){if(2==b.data.$.button&&(b=b.data.getTarget(),!b.getOuterHtml().replace(q,""))){var c=a.createRange();c.moveToElementEditStart(b);c.select(!0);}});CKEDITOR.env.webkit&&(this.attachListener(this,"click",function(a){a.data.getTarget().is("input","select")&&a.data.preventDefault();}),this.attachListener(this,"mouseup",function(a){a.data.getTarget().is("input","textarea")&&a.data.preventDefault();}));CKEDITOR.env.webkit&&this.attachListener(a,"key",function(b){if(a.readOnly)return!0;b=b.data.domEvent.getKey();if(b in n){var c=8==b,d=a.getSelection().getRanges()[0];b=d.startPath();if(d.collapsed)a:{var f=b.block;if(f&&d[c?"checkStartOfBlock":"checkEndOfBlock"]()&&d.moveToClosestEditablePosition(f,!c)&&d.collapsed){if(d.startContainer.type==CKEDITOR.NODE_ELEMENT){var g=d.startContainer.getChild(d.startOffset-(c?1:0));if(g&&g.type==CKEDITOR.NODE_ELEMENT&&g.is("hr")){a.fire("saveSnapshot");g.remove();b=!0;break a;}}d=d.startPath().block;if(!d||d&&d.contains(f))b=void 0;else{a.fire("saveSnapshot");var e;(e=(c?d:f).getBogus())&&e.remove();e=a.getSelection();g=e.createBookmarks();(c?f:d).moveChildren(c?d:f,!1);b.lastElement.mergeSiblings();k(f,d,!c);e.selectBookmarks(g);b=!0;}}else b=!1;}else c=d,e=b.block,d=c.endPath().block,e&&d&&!e.equals(d)?(a.fire("saveSnapshot"),(f=e.getBogus())&&f.remove(),c.enlarge(CKEDITOR.ENLARGE_INLINE),c.deleteContents(),d.getParent()&&(d.moveChildren(e,!1),b.lastElement.mergeSiblings(),k(e,d,!0)),c=a.getSelection().getRanges()[0],c.collapse(1),c.optimize(),""===c.startContainer.getHtml()&&c.startContainer.appendBogus(),c.select(),b=!0):b=!1;if(!b)return;a.getSelection().scrollIntoView();a.fire("saveSnapshot");return!1;}},this,null,100);}}},_:{detach:function detach(){this.editor.setData(this.editor.getData(),0,1);this.clearListeners();this.restoreAttrs();var a;if(a=this.removeCustomData("classes"))for(;a.length;){this.removeClass(a.pop());}if(!this.is("textarea")){a=this.getDocument();var b=a.getHead();if(b.getCustomData("stylesheet")){var c=a.getCustomData("stylesheet_ref");--c?a.setCustomData("stylesheet_ref",c):(a.removeCustomData("stylesheet_ref"),b.removeCustomData("stylesheet").remove());}}this.editor.fire("contentDomUnload");delete this.editor;}}});CKEDITOR.editor.prototype.editable=function(a){var b=this._.editable;if(b&&a)return 0;arguments.length&&(b=this._.editable=a?a instanceof CKEDITOR.editable?a:new CKEDITOR.editable(this,a):(b&&b.detach(),null));return b;};CKEDITOR.on("instanceLoaded",function(b){var c=b.editor;c.on("insertElement",function(a){a=a.data;a.type==CKEDITOR.NODE_ELEMENT&&(a.is("input")||a.is("textarea"))&&("false"!=a.getAttribute("contentEditable")&&a.data("cke-editable",a.hasAttribute("contenteditable")?"true":"1"),a.setAttribute("contentEditable",!1));});c.on("selectionChange",function(b){if(!c.readOnly){var d=c.getSelection();d&&!d.isLocked&&(d=c.checkDirty(),c.fire("lockSnapshot"),a(b),c.fire("unlockSnapshot"),!d&&c.resetDirty());}});});CKEDITOR.on("instanceCreated",function(a){var b=a.editor;b.on("mode",function(){var a=b.editable();if(a&&a.isInline()){var c=b.title;a.changeAttr("role","textbox");a.changeAttr("aria-label",c);c&&a.changeAttr("title",c);var d=b.fire("ariaEditorHelpLabel",{}).label;if(d&&(c=this.ui.space(this.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?"top":"contents"))){var f=CKEDITOR.tools.getNextId(),d=CKEDITOR.dom.element.createFromHtml('\x3cspan id\x3d"'+f+'" class\x3d"cke_voice_label"\x3e'+d+"\x3c/span\x3e");c.append(d);a.changeAttr("aria-describedby",f);}}});});CKEDITOR.addCss(".cke_editable{cursor:text}.cke_editable img,.cke_editable input,.cke_editable textarea{cursor:default}");g=CKEDITOR.dom.walker.whitespaces(!0);n=CKEDITOR.dom.walker.bookmark(!1,!0);v=CKEDITOR.dom.walker.empty();r=CKEDITOR.dom.walker.bogus();q=/(^|<body\b[^>]*>)\s*<(p|div|address|h\d|center|pre)[^>]*>\s*(?:<br[^>]*>|&nbsp;|\u00A0|&#160;)?\s*(:?<\/\2>)?\s*(?=$|<\/body>)/gi;t=function(){function a(b){return b.type==CKEDITOR.NODE_ELEMENT;}function b(c,d){var f,g,e,h,k=[],m=d.range.startContainer;f=d.range.startPath();for(var m=l[m.getName()],n=0,p=c.getChildren(),w=p.count(),x=-1,q=-1,t=0,D=f.contains(l.$list);n<w;++n){f=p.getItem(n),a(f)?(e=f.getName(),D&&e in CKEDITOR.dtd.$list?k=k.concat(b(f,d)):(h=!!m[e],"br"!=e||!f.data("cke-eol")||n&&n!=w-1||(t=(g=n?k[n-1].node:p.getItem(n+1))&&(!a(g)||!g.is("br")),g=g&&a(g)&&l.$block[g.getName()]),-1!=x||h||(x=n),h||(q=n),k.push({isElement:1,isLineBreak:t,isBlock:f.isBlockBoundary(),hasBlockSibling:g,node:f,name:e,allowed:h}),g=t=0)):k.push({isElement:0,node:f,allowed:1});}-1<x&&(k[x].firstNotAllowed=1);-1<q&&(k[q].lastNotAllowed=1);return k;}function d(b,c){var f=[],g=b.getChildren(),e=g.count(),k,h=0,m=l[c],n=!b.is(l.$inline)||b.is("br");for(n&&f.push(" ");h<e;h++){k=g.getItem(h),a(k)&&!k.is(m)?f=f.concat(d(k,c)):f.push(k);}n&&f.push(" ");return f;}function g(b){return a(b.startContainer)&&b.startContainer.getChild(b.startOffset-1);}function e(b){return b&&a(b)&&(b.is(l.$removeEmpty)||b.is("a")&&!b.isBlockBoundary());}function h(b,c,d,f){var g=b.clone(),e,k;g.setEndAt(c,CKEDITOR.POSITION_BEFORE_END);(e=new CKEDITOR.dom.walker(g).next())&&a(e)&&n[e.getName()]&&(k=e.getPrevious())&&a(k)&&!k.getParent().equals(b.startContainer)&&d.contains(k)&&f.contains(e)&&e.isIdentical(k)&&(e.moveChildren(k),e.remove(),h(b,c,d,f));}function k(b,c){function d(b,c){if(c.isBlock&&c.isElement&&!c.node.is("br")&&a(b)&&b.is("br"))return b.remove(),1;}var f=c.endContainer.getChild(c.endOffset),g=c.endContainer.getChild(c.endOffset-1);f&&d(f,b[b.length-1]);g&&d(g,b[0])&&(c.setEnd(c.endContainer,c.endOffset-1),c.collapse());}var l=CKEDITOR.dtd,n={p:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,ul:1,ol:1,li:1,pre:1,dl:1,blockquote:1},w={p:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},p=CKEDITOR.tools.extend({},l.$inline);delete p.br;return function(n,q,H,t){var r=n.editor,z=!1;"unfiltered_html"==q&&(q="html",z=!0);if(!t.checkReadOnly()){var v=new CKEDITOR.dom.elementPath(t.startContainer,t.root).blockLimit||t.root;n={type:q,dontFilter:z,editable:n,editor:r,range:t,blockLimit:v,mergeCandidates:[],zombies:[]};q=n.range;t=n.mergeCandidates;var K,E;"text"==n.type&&q.shrink(CKEDITOR.SHRINK_ELEMENT,!0,!1)&&(K=CKEDITOR.dom.element.createFromHtml("\x3cspan\x3e\x26nbsp;\x3c/span\x3e",q.document),q.insertNode(K),q.setStartAfter(K));z=new CKEDITOR.dom.elementPath(q.startContainer);n.endPath=v=new CKEDITOR.dom.elementPath(q.endContainer);if(!q.collapsed){var r=v.block||v.blockLimit,W=q.getCommonAncestor();r&&!r.equals(W)&&!r.contains(W)&&q.checkEndOfBlock()&&n.zombies.push(r);q.deleteContents();}for(;(E=g(q))&&a(E)&&E.isBlockBoundary()&&z.contains(E);){q.moveToPosition(E,CKEDITOR.POSITION_BEFORE_END);}h(q,n.blockLimit,z,v);K&&(q.setEndBefore(K),q.collapse(),K.remove());K=q.startPath();if(r=K.contains(e,!1,1))q.splitElement(r),n.inlineStylesRoot=r,n.inlineStylesPeak=K.lastElement;K=q.createBookmark();(r=K.startNode.getPrevious(c))&&a(r)&&e(r)&&t.push(r);(r=K.startNode.getNext(c))&&a(r)&&e(r)&&t.push(r);for(r=K.startNode;(r=r.getParent())&&e(r);){t.push(r);}q.moveToBookmark(K);if(K=H){K=n.range;if("text"==n.type&&n.inlineStylesRoot){E=n.inlineStylesPeak;q=E.getDocument().createText("{cke-peak}");for(t=n.inlineStylesRoot.getParent();!E.equals(t);){q=q.appendTo(E.clone()),E=E.getParent();}H=q.getOuterHtml().split("{cke-peak}").join(H);}E=n.blockLimit.getName();if(/^\s+|\s+$/.test(H)&&"span"in CKEDITOR.dtd[E]){var U='\x3cspan data-cke-marker\x3d"1"\x3e\x26nbsp;\x3c/span\x3e';H=U+H+U;}H=n.editor.dataProcessor.toHtml(H,{context:null,fixForBody:!1,protectedWhitespaces:!!U,dontFilter:n.dontFilter,filter:n.editor.activeFilter,enterMode:n.editor.activeEnterMode});E=K.document.createElement("body");E.setHtml(H);U&&(E.getFirst().remove(),E.getLast().remove());if((U=K.startPath().block)&&(1!=U.getChildCount()||!U.getBogus()))a:{var L;if(1==E.getChildCount()&&a(L=E.getFirst())&&L.is(w)&&!L.hasAttribute("contenteditable")){U=L.getElementsByTag("*");K=0;for(t=U.count();K<t;K++){if(q=U.getItem(K),!q.is(p))break a;}L.moveChildren(L.getParent(1));L.remove();}}n.dataWrapper=E;K=H;}if(K){L=n.range;K=L.document;var N;E=n.blockLimit;t=0;var S,U=[],Q,Y;H=r=0;var V,da;q=L.startContainer;var z=n.endPath.elements[0],Z,v=z.getPosition(q),W=!!z.getCommonAncestor(q)&&v!=CKEDITOR.POSITION_IDENTICAL&&!(v&CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_IS_CONTAINED);q=b(n.dataWrapper,n);for(k(q,L);t<q.length;t++){v=q[t];if(N=v.isLineBreak){N=L;V=E;var X=void 0,ga=void 0;v.hasBlockSibling?N=1:(X=N.startContainer.getAscendant(l.$block,1))&&X.is({div:1,p:1})?(ga=X.getPosition(V),ga==CKEDITOR.POSITION_IDENTICAL||ga==CKEDITOR.POSITION_CONTAINS?N=0:(V=N.splitElement(X),N.moveToPosition(V,CKEDITOR.POSITION_AFTER_START),N=1)):N=0;}if(N)H=0<t;else{N=L.startPath();!v.isBlock&&m(n.editor,N.block,N.blockLimit)&&(Y=f(n.editor))&&(Y=K.createElement(Y),Y.appendBogus(),L.insertNode(Y),CKEDITOR.env.needsBrFiller&&(S=Y.getBogus())&&S.remove(),L.moveToPosition(Y,CKEDITOR.POSITION_BEFORE_END));if((N=L.startPath().block)&&!N.equals(Q)){if(S=N.getBogus())S.remove(),U.push(N);Q=N;}v.firstNotAllowed&&(r=1);if(r&&v.isElement){N=L.startContainer;for(V=null;N&&!l[N.getName()][v.name];){if(N.equals(E)){N=null;break;}V=N;N=N.getParent();}if(N)V&&(da=L.splitElement(V),n.zombies.push(da),n.zombies.push(V));else{V=E.getName();Z=!t;N=t==q.length-1;V=d(v.node,V);for(var X=[],ga=V.length,ba=0,ea=void 0,ha=0,ia=-1;ba<ga;ba++){ea=V[ba]," "==ea?(ha||Z&&!ba||(X.push(new CKEDITOR.dom.text(" ")),ia=X.length),ha=1):(X.push(ea),ha=0);}N&&ia==X.length&&X.pop();Z=X;}}if(Z){for(;N=Z.pop();){L.insertNode(N);}Z=0;}else L.insertNode(v.node);v.lastNotAllowed&&t<q.length-1&&((da=W?z:da)&&L.setEndAt(da,CKEDITOR.POSITION_AFTER_START),r=0);L.collapse();}}1!=q.length?S=!1:(S=q[0],S=S.isElement&&"false"==S.node.getAttribute("contenteditable"));S&&(H=!0,N=q[0].node,L.setStartAt(N,CKEDITOR.POSITION_BEFORE_START),L.setEndAt(N,CKEDITOR.POSITION_AFTER_END));n.dontMoveCaret=H;n.bogusNeededBlocks=U;}S=n.range;var aa;da=n.bogusNeededBlocks;for(Z=S.createBookmark();Q=n.zombies.pop();){Q.getParent()&&(Y=S.clone(),Y.moveToElementEditStart(Q),Y.removeEmptyBlocksAtEnd());}if(da)for(;Q=da.pop();){CKEDITOR.env.needsBrFiller?Q.appendBogus():Q.append(S.document.createText(" "));}for(;Q=n.mergeCandidates.pop();){Q.mergeSiblings();}S.moveToBookmark(Z);if(!n.dontMoveCaret){for(Q=g(S);Q&&a(Q)&&!Q.is(l.$empty);){if(Q.isBlockBoundary())S.moveToPosition(Q,CKEDITOR.POSITION_BEFORE_END);else{if(e(Q)&&Q.getHtml().match(/(\s|&nbsp;)$/g)){aa=null;break;}aa=S.clone();aa.moveToPosition(Q,CKEDITOR.POSITION_BEFORE_END);}Q=Q.getLast(c);}aa&&S.moveToRange(aa);}}};}();p=function(){function a(b){b=new CKEDITOR.dom.walker(b);b.guard=function(a,b){if(b)return!1;if(a.type==CKEDITOR.NODE_ELEMENT)return a.is(CKEDITOR.dtd.$tableContent);};b.evaluator=function(a){return a.type==CKEDITOR.NODE_ELEMENT;};return b;}function b(a,c,d){c=a.getDocument().createElement(c);a.append(c,d);return c;}function c(a){var b=a.count(),d;for(b;0<b--;){d=a.getItem(b),CKEDITOR.tools.trim(d.getHtml())||(d.appendBogus(),CKEDITOR.env.ie&&9>CKEDITOR.env.version&&d.getChildCount()&&d.getFirst().remove());}}return function(d){var f=d.startContainer,g=f.getAscendant("table",1),e=!1;c(g.getElementsByTag("td"));c(g.getElementsByTag("th"));g=d.clone();g.setStart(f,0);g=a(g).lastBackward();g||(g=d.clone(),g.setEndAt(f,CKEDITOR.POSITION_BEFORE_END),g=a(g).lastForward(),e=!0);g||(g=f);g.is("table")?(d.setStartAt(g,CKEDITOR.POSITION_BEFORE_START),d.collapse(!0),g.remove()):(g.is({tbody:1,thead:1,tfoot:1})&&(g=b(g,"tr",e)),g.is("tr")&&(g=b(g,g.getParent().is("thead")?"th":"td",e)),(f=g.getBogus())&&f.remove(),d.moveToPosition(g,e?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_END));};}();w={eol:{detect:function detect(a,b){var c=a.range,d=c.clone(),f=c.clone(),g=new CKEDITOR.dom.elementPath(c.startContainer,b),e=new CKEDITOR.dom.elementPath(c.endContainer,b);d.collapse(1);f.collapse();g.block&&d.checkBoundaryOfElement(g.block,CKEDITOR.END)&&(c.setStartAfter(g.block),a.prependEolBr=1);e.block&&f.checkBoundaryOfElement(e.block,CKEDITOR.START)&&(c.setEndBefore(e.block),a.appendEolBr=1);},fix:function fix(a,b){var c=b.getDocument(),d;a.appendEolBr&&(d=this.createEolBr(c),a.fragment.append(d));!a.prependEolBr||d&&!d.getPrevious()||a.fragment.append(this.createEolBr(c),1);},createEolBr:function createEolBr(a){return a.createElement("br",{attributes:{"data-cke-eol":1}});}},bogus:{exclude:function exclude(a){var b=a.range.getBoundaryNodes(),c=b.startNode,b=b.endNode;!b||!r(b)||c&&c.equals(b)||a.range.setEndBefore(b);}},tree:{rebuild:function rebuild(a,b){var c=a.range,d=c.getCommonAncestor(),f=new CKEDITOR.dom.elementPath(d,b),g=new CKEDITOR.dom.elementPath(c.startContainer,b),c=new CKEDITOR.dom.elementPath(c.endContainer,b),e;d.type==CKEDITOR.NODE_TEXT&&(d=d.getParent());if(f.blockLimit.is({tr:1,table:1})){var k=f.contains("table").getParent();e=function e(a){return!a.equals(k);};}else if(f.block&&f.block.is(CKEDITOR.dtd.$listItem)&&(g=g.contains(CKEDITOR.dtd.$list),c=c.contains(CKEDITOR.dtd.$list),!g.equals(c))){var h=f.contains(CKEDITOR.dtd.$list).getParent();e=function e(a){return!a.equals(h);};}e||(e=function e(a){return!a.equals(f.block)&&!a.equals(f.blockLimit);});this.rebuildFragment(a,b,d,e);},rebuildFragment:function rebuildFragment(a,b,c,d){for(var f;c&&!c.equals(b)&&d(c);){f=c.clone(0,1),a.fragment.appendTo(f),a.fragment=f,c=c.getParent();}}},cell:{shrink:function shrink(a){a=a.range;var b=a.startContainer,c=a.endContainer,d=a.startOffset,f=a.endOffset;b.type==CKEDITOR.NODE_ELEMENT&&b.equals(c)&&b.is("tr")&&++d==f&&a.shrink(CKEDITOR.SHRINK_TEXT);}}};z=function(){function a(b,c){var d=b.getParent();if(d.is(CKEDITOR.dtd.$inline))b[c?"insertBefore":"insertAfter"](d);}function b(c,d,f){a(d);a(f,1);for(var g;g=f.getNext();){g.insertAfter(d),d=g;}v(c)&&c.remove();}function c(a,b){var d=new CKEDITOR.dom.range(a);d.setStartAfter(b.startNode);d.setEndBefore(b.endNode);return d;}return{list:{detectMerge:function detectMerge(a,b){var d=c(b,a.bookmark),f=d.startPath(),g=d.endPath(),e=f.contains(CKEDITOR.dtd.$list),k=g.contains(CKEDITOR.dtd.$list);a.mergeList=e&&k&&e.getParent().equals(k.getParent())&&!e.equals(k);a.mergeListItems=f.block&&g.block&&f.block.is(CKEDITOR.dtd.$listItem)&&g.block.is(CKEDITOR.dtd.$listItem);if(a.mergeList||a.mergeListItems)d=d.clone(),d.setStartBefore(a.bookmark.startNode),d.setEndAfter(a.bookmark.endNode),a.mergeListBookmark=d.createBookmark();},merge:function merge(a,c){if(a.mergeListBookmark){var d=a.mergeListBookmark.startNode,f=a.mergeListBookmark.endNode,g=new CKEDITOR.dom.elementPath(d,c),e=new CKEDITOR.dom.elementPath(f,c);if(a.mergeList){var k=g.contains(CKEDITOR.dtd.$list),h=e.contains(CKEDITOR.dtd.$list);k.equals(h)||(h.moveChildren(k),h.remove());}a.mergeListItems&&(g=g.contains(CKEDITOR.dtd.$listItem),e=e.contains(CKEDITOR.dtd.$listItem),g.equals(e)||b(e,d,f));d.remove();f.remove();}}},block:{detectMerge:function detectMerge(a,b){if(!a.tableContentsRanges&&!a.mergeListBookmark){var c=new CKEDITOR.dom.range(b);c.setStartBefore(a.bookmark.startNode);c.setEndAfter(a.bookmark.endNode);a.mergeBlockBookmark=c.createBookmark();}},merge:function merge(a,c){if(a.mergeBlockBookmark&&!a.purgeTableBookmark){var d=a.mergeBlockBookmark.startNode,f=a.mergeBlockBookmark.endNode,g=new CKEDITOR.dom.elementPath(d,c),e=new CKEDITOR.dom.elementPath(f,c),g=g.block,e=e.block;g&&e&&!g.equals(e)&&b(e,d,f);d.remove();f.remove();}}},table:function(){function a(c){var f=[],g,e=new CKEDITOR.dom.walker(c),k=c.startPath().contains(d),h=c.endPath().contains(d),l={};e.guard=function(a,e){if(a.type==CKEDITOR.NODE_ELEMENT){var m="visited_"+(e?"out":"in");if(a.getCustomData(m))return;CKEDITOR.dom.element.setMarker(l,a,m,1);}if(e&&k&&a.equals(k))g=c.clone(),g.setEndAt(k,CKEDITOR.POSITION_BEFORE_END),f.push(g);else if(!e&&h&&a.equals(h))g=c.clone(),g.setStartAt(h,CKEDITOR.POSITION_AFTER_START),f.push(g);else{if(m=!e)m=a.type==CKEDITOR.NODE_ELEMENT&&a.is(d)&&(!k||b(a,k))&&(!h||b(a,h));m&&(g=c.clone(),g.selectNodeContents(a),f.push(g));}};e.lastForward();CKEDITOR.dom.element.clearAllMarkers(l);return f;}function b(a,c){var d=CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_IS_CONTAINED,f=a.getPosition(c);return f===CKEDITOR.POSITION_IDENTICAL?!1:0===(f&d);}var d={td:1,th:1,caption:1};return{detectPurge:function detectPurge(a){var b=a.range,c=b.clone();c.enlarge(CKEDITOR.ENLARGE_ELEMENT);var c=new CKEDITOR.dom.walker(c),f=0;c.evaluator=function(a){a.type==CKEDITOR.NODE_ELEMENT&&a.is(d)&&++f;};c.checkForward();if(1<f){var c=b.startPath().contains("table"),g=b.endPath().contains("table");c&&g&&b.checkBoundaryOfElement(c,CKEDITOR.START)&&b.checkBoundaryOfElement(g,CKEDITOR.END)&&(b=a.range.clone(),b.setStartBefore(c),b.setEndAfter(g),a.purgeTableBookmark=b.createBookmark());}},detectRanges:function detectRanges(f,g){var e=c(g,f.bookmark),k=e.clone(),h,l,m=e.getCommonAncestor();m.is(CKEDITOR.dtd.$tableContent)&&!m.is(d)&&(m=m.getAscendant("table",!0));l=m;m=new CKEDITOR.dom.elementPath(e.startContainer,l);l=new CKEDITOR.dom.elementPath(e.endContainer,l);m=m.contains("table");l=l.contains("table");if(m||l)m&&l&&b(m,l)?(f.tableSurroundingRange=k,k.setStartAt(m,CKEDITOR.POSITION_AFTER_END),k.setEndAt(l,CKEDITOR.POSITION_BEFORE_START),k=e.clone(),k.setEndAt(m,CKEDITOR.POSITION_AFTER_END),h=e.clone(),h.setStartAt(l,CKEDITOR.POSITION_BEFORE_START),h=a(k).concat(a(h))):m?l||(f.tableSurroundingRange=k,k.setStartAt(m,CKEDITOR.POSITION_AFTER_END),e.setEndAt(m,CKEDITOR.POSITION_AFTER_END)):(f.tableSurroundingRange=k,k.setEndAt(l,CKEDITOR.POSITION_BEFORE_START),e.setStartAt(l,CKEDITOR.POSITION_AFTER_START)),f.tableContentsRanges=h?h:a(e);},deleteRanges:function deleteRanges(a){for(var b;b=a.tableContentsRanges.pop();){b.extractContents(),v(b.startContainer)&&b.startContainer.appendBogus();}a.tableSurroundingRange&&a.tableSurroundingRange.extractContents();},purge:function purge(a){if(a.purgeTableBookmark){var b=a.doc,c=a.range.clone(),b=b.createElement("p");b.insertBefore(a.purgeTableBookmark.startNode);c.moveToBookmark(a.purgeTableBookmark);c.deleteContents();a.range.moveToPosition(b,CKEDITOR.POSITION_AFTER_START);}}};}(),detectExtractMerge:function detectExtractMerge(a){return!(a.range.startPath().contains(CKEDITOR.dtd.$listItem)&&a.range.endPath().contains(CKEDITOR.dtd.$listItem));},fixUneditableRangePosition:function fixUneditableRangePosition(a){a.startContainer.getDtd()["#"]||a.moveToClosestEditablePosition(null,!0);},autoParagraph:function autoParagraph(a,b){var c=b.startPath(),d;m(a,c.block,c.blockLimit)&&(d=f(a))&&(d=b.document.createElement(d),d.appendBogus(),b.insertNode(d),b.moveToPosition(d,CKEDITOR.POSITION_AFTER_START));}};}();}(),function(){function a(){var a=this._.fakeSelection,b;a&&(b=this.getSelection(1),b&&b.isHidden()||(a.reset(),a=0));if(!a&&(a=b||this.getSelection(1),!a||a.getType()==CKEDITOR.SELECTION_NONE))return;this.fire("selectionCheck",a);b=this.elementPath();if(!b.compare(this._.selectionPreviousPath)){var c=this._.selectionPreviousPath&&this._.selectionPreviousPath.blockLimit.equals(b.blockLimit);CKEDITOR.env.webkit&&!c&&(this._.previousActive=this.document.getActive());this._.selectionPreviousPath=b;this.fire("selectionChange",{selection:a,path:b});}}function e(){p=!0;t||(b.call(this),t=CKEDITOR.tools.setTimeout(b,200,this));}function b(){t=null;p&&(CKEDITOR.tools.setTimeout(a,0,this),p=!1);}function c(a){return w(a)||a.type==CKEDITOR.NODE_ELEMENT&&!a.is(CKEDITOR.dtd.$empty)?!0:!1;}function d(a){function b(c,d){return c&&c.type!=CKEDITOR.NODE_TEXT?a.clone()["moveToElementEdit"+(d?"End":"Start")](c):!1;}if(!(a.root instanceof CKEDITOR.editable))return!1;var d=a.startContainer,f=a.getPreviousNode(c,null,d),g=a.getNextNode(c,null,d);return b(f)||b(g,1)||!(f||g||d.type==CKEDITOR.NODE_ELEMENT&&d.isBlockBoundary()&&d.getBogus())?!0:!1;}function l(a){m(a,!1);var b=a.getDocument().createText(r);a.setCustomData("cke-fillingChar",b);return b;}function m(a,b){var c=a&&a.removeCustomData("cke-fillingChar");if(c){if(!1!==b){var d=a.getDocument().getSelection().getNative(),g=d&&"None"!=d.type&&d.getRangeAt(0),e=r.length;if(c.getLength()>e&&g&&g.intersectsNode(c.$)){var k=[{node:d.anchorNode,offset:d.anchorOffset},{node:d.focusNode,offset:d.focusOffset}];d.anchorNode==c.$&&d.anchorOffset>e&&(k[0].offset-=e);d.focusNode==c.$&&d.focusOffset>e&&(k[1].offset-=e);}}c.setText(f(c.getText(),1));k&&(c=a.getDocument().$,d=c.getSelection(),c=c.createRange(),c.setStart(k[0].node,k[0].offset),c.collapse(!0),d.removeAllRanges(),d.addRange(c),d.extend(k[1].node,k[1].offset));}}function f(a,b){return b?a.replace(q,function(a,b){return b?" ":"";}):a.replace(r,"");}function h(a,b){var c=CKEDITOR.dom.element.createFromHtml('\x3cdiv data-cke-hidden-sel\x3d"1" data-cke-temp\x3d"1" style\x3d"'+(CKEDITOR.env.ie&&14>CKEDITOR.env.version?"display:none":"position:fixed;top:0;left:-1000px")+'"\x3e'+(b||"\x26nbsp;")+"\x3c/div\x3e",a.document);a.fire("lockSnapshot");a.editable().append(c);var d=a.getSelection(1),f=a.createRange(),g=d.root.on("selectionchange",function(a){a.cancel();},null,null,0);f.setStartAt(c,CKEDITOR.POSITION_AFTER_START);f.setEndAt(c,CKEDITOR.POSITION_BEFORE_END);d.selectRanges([f]);g.removeListener();a.fire("unlockSnapshot");a._.hiddenSelectionContainer=c;}function k(a){var b={37:1,39:1,8:1,46:1};return function(c){var d=c.data.getKeystroke();if(b[d]){var f=a.getSelection().getRanges(),g=f[0];1==f.length&&g.collapsed&&(d=g[38>d?"getPreviousEditableNode":"getNextEditableNode"]())&&d.type==CKEDITOR.NODE_ELEMENT&&"false"==d.getAttribute("contenteditable")&&(a.getSelection().fake(d),c.data.preventDefault(),c.cancel());}};}function g(a){for(var b=0;b<a.length;b++){var c=a[b];c.getCommonAncestor().isReadOnly()&&a.splice(b,1);if(!c.collapsed){if(c.startContainer.isReadOnly())for(var d=c.startContainer,f;d&&!((f=d.type==CKEDITOR.NODE_ELEMENT)&&d.is("body")||!d.isReadOnly());){f&&"false"==d.getAttribute("contentEditable")&&c.setStartAfter(d),d=d.getParent();}d=c.startContainer;f=c.endContainer;var g=c.startOffset,e=c.endOffset,k=c.clone();d&&d.type==CKEDITOR.NODE_TEXT&&(g>=d.getLength()?k.setStartAfter(d):k.setStartBefore(d));f&&f.type==CKEDITOR.NODE_TEXT&&(e?k.setEndAfter(f):k.setEndBefore(f));d=new CKEDITOR.dom.walker(k);d.evaluator=function(d){if(d.type==CKEDITOR.NODE_ELEMENT&&d.isReadOnly()){var f=c.clone();c.setEndBefore(d);c.collapsed&&a.splice(b--,1);d.getPosition(k.endContainer)&CKEDITOR.POSITION_CONTAINS||(f.setStartAfter(d),f.collapsed||a.splice(b+1,0,f));return!0;}return!1;};d.next();}}return a;}var n="function"!=typeof window.getSelection,v=1,r=CKEDITOR.tools.repeat("​",7),q=new RegExp(r+"( )?","g"),t,p,w=CKEDITOR.dom.walker.invisible(1),z=function(){function a(b){return function(a){var c=a.editor.createRange();c.moveToClosestEditablePosition(a.selected,b)&&a.editor.getSelection().selectRanges([c]);return!1;};}function b(a){return function(b){var c=b.editor,d=c.createRange(),f;(f=d.moveToClosestEditablePosition(b.selected,a))||(f=d.moveToClosestEditablePosition(b.selected,!a));f&&c.getSelection().selectRanges([d]);c.fire("saveSnapshot");b.selected.remove();f||(d.moveToElementEditablePosition(c.editable()),c.getSelection().selectRanges([d]));c.fire("saveSnapshot");return!1;};}var c=a(),d=a(1);return{37:c,38:c,39:d,40:d,8:b(),46:b(1)};}();CKEDITOR.on("instanceCreated",function(b){function c(){var a=d.getSelection();a&&a.removeAllRanges();}var d=b.editor;d.on("contentDom",function(){function b(){w=new CKEDITOR.dom.selection(d.getSelection());w.lock();}function c(){g.removeListener("mouseup",c);u.removeListener("mouseup",c);var a=CKEDITOR.document.$.selection,b=a.createRange();"None"!=a.type&&b.parentElement().ownerDocument==f.$&&b.select();}var f=d.document,g=CKEDITOR.document,h=d.editable(),l=f.getBody(),u=f.getDocumentElement(),q=h.isInline(),p,w;CKEDITOR.env.gecko&&h.attachListener(h,"focus",function(a){a.removeListener();0!==p&&(a=d.getSelection().getNative())&&a.isCollapsed&&a.anchorNode==h.$&&(a=d.createRange(),a.moveToElementEditStart(h),a.select());},null,null,-2);h.attachListener(h,CKEDITOR.env.webkit?"DOMFocusIn":"focus",function(){p&&CKEDITOR.env.webkit&&(p=d._.previousActive&&d._.previousActive.equals(f.getActive()))&&null!=d._.previousScrollTop&&d._.previousScrollTop!=h.$.scrollTop&&(h.$.scrollTop=d._.previousScrollTop);d.unlockSelection(p);p=0;},null,null,-1);h.attachListener(h,"mousedown",function(){p=0;});if(CKEDITOR.env.ie||q)n?h.attachListener(h,"beforedeactivate",b,null,null,-1):h.attachListener(d,"selectionCheck",b,null,null,-1),h.attachListener(h,CKEDITOR.env.webkit?"DOMFocusOut":"blur",function(){d.lockSelection(w);p=1;},null,null,-1),h.attachListener(h,"mousedown",function(){p=0;});if(CKEDITOR.env.ie&&!q){var t;h.attachListener(h,"mousedown",function(a){2==a.data.$.button&&((a=d.document.getSelection())&&a.getType()!=CKEDITOR.SELECTION_NONE||(t=d.window.getScrollPosition()));});h.attachListener(h,"mouseup",function(a){2==a.data.$.button&&t&&(d.document.$.documentElement.scrollLeft=t.x,d.document.$.documentElement.scrollTop=t.y);t=null;});if("BackCompat"!=f.$.compatMode){if(CKEDITOR.env.ie7Compat||CKEDITOR.env.ie6Compat){var r,z;u.on("mousedown",function(a){function b(a){a=a.data.$;if(r){var c=l.$.createTextRange();try{c.moveToPoint(a.clientX,a.clientY);}catch(d){}r.setEndPoint(0>z.compareEndPoints("StartToStart",c)?"EndToEnd":"StartToStart",c);r.select();}}function c(){u.removeListener("mousemove",b);g.removeListener("mouseup",c);u.removeListener("mouseup",c);r.select();}a=a.data;if(a.getTarget().is("html")&&a.$.y<u.$.clientHeight&&a.$.x<u.$.clientWidth){r=l.$.createTextRange();try{r.moveToPoint(a.$.clientX,a.$.clientY);}catch(d){}z=r.duplicate();u.on("mousemove",b);g.on("mouseup",c);u.on("mouseup",c);}});}if(7<CKEDITOR.env.version&&11>CKEDITOR.env.version)u.on("mousedown",function(a){a.data.getTarget().is("html")&&(g.on("mouseup",c),u.on("mouseup",c));});}}h.attachListener(h,"selectionchange",a,d);h.attachListener(h,"keyup",e,d);h.attachListener(h,CKEDITOR.env.webkit?"DOMFocusIn":"focus",function(){d.forceNextSelectionCheck();d.selectionChange(1);});if(q&&(CKEDITOR.env.webkit||CKEDITOR.env.gecko)){var x;h.attachListener(h,"mousedown",function(){x=1;});h.attachListener(f.getDocumentElement(),"mouseup",function(){x&&e.call(d);x=0;});}else h.attachListener(CKEDITOR.env.ie?h:f.getDocumentElement(),"mouseup",e,d);CKEDITOR.env.webkit&&h.attachListener(f,"keydown",function(a){switch(a.data.getKey()){case 13:case 33:case 34:case 35:case 36:case 37:case 39:case 8:case 45:case 46:m(h);}},null,null,-1);h.attachListener(h,"keydown",k(d),null,null,-1);});d.on("setData",function(){d.unlockSelection();CKEDITOR.env.webkit&&c();});d.on("contentDomUnload",function(){d.unlockSelection();});if(CKEDITOR.env.ie9Compat)d.on("beforeDestroy",c,null,null,9);d.on("dataReady",function(){delete d._.fakeSelection;delete d._.hiddenSelectionContainer;d.selectionChange(1);});d.on("loadSnapshot",function(){var a=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT),b=d.editable().getLast(a);b&&b.hasAttribute("data-cke-hidden-sel")&&(b.remove(),CKEDITOR.env.gecko&&(a=d.editable().getFirst(a))&&a.is("br")&&a.getAttribute("_moz_editor_bogus_node")&&a.remove());},null,null,100);d.on("key",function(a){if("wysiwyg"==d.mode){var b=d.getSelection();if(b.isFake){var c=z[a.data.keyCode];if(c)return c({editor:d,selected:b.getSelectedElement(),selection:b,keyEvent:a});}}});});if(CKEDITOR.env.webkit)CKEDITOR.on("instanceReady",function(a){var b=a.editor;b.on("selectionChange",function(){var a=b.editable(),c=a.getCustomData("cke-fillingChar");c&&(c.getCustomData("ready")?m(a):c.setCustomData("ready",1));},null,null,-1);b.on("beforeSetMode",function(){m(b.editable());},null,null,-1);b.on("getSnapshot",function(a){a.data&&(a.data=f(a.data));},b,null,20);b.on("toDataFormat",function(a){a.data.dataValue=f(a.data.dataValue);},null,null,0);});CKEDITOR.editor.prototype.selectionChange=function(b){(b?a:e).call(this);};CKEDITOR.editor.prototype.getSelection=function(a){return!this._.savedSelection&&!this._.fakeSelection||a?(a=this.editable())&&"wysiwyg"==this.mode?new CKEDITOR.dom.selection(a):null:this._.savedSelection||this._.fakeSelection;};CKEDITOR.editor.prototype.lockSelection=function(a){a=a||this.getSelection(1);return a.getType()!=CKEDITOR.SELECTION_NONE?(!a.isLocked&&a.lock(),this._.savedSelection=a,!0):!1;};CKEDITOR.editor.prototype.unlockSelection=function(a){var b=this._.savedSelection;return b?(b.unlock(a),delete this._.savedSelection,!0):!1;};CKEDITOR.editor.prototype.forceNextSelectionCheck=function(){delete this._.selectionPreviousPath;};CKEDITOR.dom.document.prototype.getSelection=function(){return new CKEDITOR.dom.selection(this);};CKEDITOR.dom.range.prototype.select=function(){var a=this.root instanceof CKEDITOR.editable?this.root.editor.getSelection():new CKEDITOR.dom.selection(this.root);a.selectRanges([this]);return a;};CKEDITOR.SELECTION_NONE=1;CKEDITOR.SELECTION_TEXT=2;CKEDITOR.SELECTION_ELEMENT=3;CKEDITOR.dom.selection=function(a){if(a instanceof CKEDITOR.dom.selection){var b=a;a=a.root;}var c=a instanceof CKEDITOR.dom.element;this.rev=b?b.rev:v++;this.document=a instanceof CKEDITOR.dom.document?a:a.getDocument();this.root=c?a:this.document.getBody();this.isLocked=0;this._={cache:{}};if(b)return CKEDITOR.tools.extend(this._.cache,b._.cache),this.isFake=b.isFake,this.isLocked=b.isLocked,this;a=this.getNative();var d,f;if(a)if(a.getRangeAt)d=(f=a.rangeCount&&a.getRangeAt(0))&&new CKEDITOR.dom.node(f.commonAncestorContainer);else{try{f=a.createRange();}catch(g){}d=f&&CKEDITOR.dom.element.get(f.item&&f.item(0)||f.parentElement());}if(!d||d.type!=CKEDITOR.NODE_ELEMENT&&d.type!=CKEDITOR.NODE_TEXT||!this.root.equals(d)&&!this.root.contains(d))this._.cache.type=CKEDITOR.SELECTION_NONE,this._.cache.startElement=null,this._.cache.selectedElement=null,this._.cache.selectedText="",this._.cache.ranges=new CKEDITOR.dom.rangeList();return this;};var A={img:1,hr:1,li:1,table:1,tr:1,td:1,th:1,embed:1,object:1,ol:1,ul:1,a:1,input:1,form:1,select:1,textarea:1,button:1,fieldset:1,thead:1,tfoot:1};CKEDITOR.tools.extend(CKEDITOR.dom.selection,{_removeFillingCharSequenceString:f,_createFillingCharSequenceNode:l,FILLING_CHAR_SEQUENCE:r});CKEDITOR.dom.selection.prototype={getNative:function getNative(){return void 0!==this._.cache.nativeSel?this._.cache.nativeSel:this._.cache.nativeSel=n?this.document.$.selection:this.document.getWindow().$.getSelection();},getType:n?function(){var a=this._.cache;if(a.type)return a.type;var b=CKEDITOR.SELECTION_NONE;try{var c=this.getNative(),d=c.type;"Text"==d&&(b=CKEDITOR.SELECTION_TEXT);"Control"==d&&(b=CKEDITOR.SELECTION_ELEMENT);c.createRange().parentElement()&&(b=CKEDITOR.SELECTION_TEXT);}catch(f){}return a.type=b;}:function(){var a=this._.cache;if(a.type)return a.type;var b=CKEDITOR.SELECTION_TEXT,c=this.getNative();if(!c||!c.rangeCount)b=CKEDITOR.SELECTION_NONE;else if(1==c.rangeCount){var c=c.getRangeAt(0),d=c.startContainer;d==c.endContainer&&1==d.nodeType&&1==c.endOffset-c.startOffset&&A[d.childNodes[c.startOffset].nodeName.toLowerCase()]&&(b=CKEDITOR.SELECTION_ELEMENT);}return a.type=b;},getRanges:function(){var a=n?function(){function a(b){return new CKEDITOR.dom.node(b).getIndex();}var b=function b(_b2,c){_b2=_b2.duplicate();_b2.collapse(c);var d=_b2.parentElement();if(!d.hasChildNodes())return{container:d,offset:0};for(var f=d.children,g,e,h=_b2.duplicate(),k=0,l=f.length-1,m=-1,n,q;k<=l;){if(m=Math.floor((k+l)/2),g=f[m],h.moveToElementText(g),n=h.compareEndPoints("StartToStart",_b2),0<n)l=m-1;else if(0>n)k=m+1;else return{container:d,offset:a(g)};}if(-1==m||m==f.length-1&&0>n){h.moveToElementText(d);h.setEndPoint("StartToStart",_b2);h=h.text.replace(/(\r\n|\r)/g,"\n").length;f=d.childNodes;if(!h)return g=f[f.length-1],g.nodeType!=CKEDITOR.NODE_TEXT?{container:d,offset:f.length}:{container:g,offset:g.nodeValue.length};for(d=f.length;0<h&&0<d;){e=f[--d],e.nodeType==CKEDITOR.NODE_TEXT&&(q=e,h-=e.nodeValue.length);}return{container:q,offset:-h};}h.collapse(0<n?!0:!1);h.setEndPoint(0<n?"StartToStart":"EndToStart",_b2);h=h.text.replace(/(\r\n|\r)/g,"\n").length;if(!h)return{container:d,offset:a(g)+(0<n?0:1)};for(;0<h;){try{e=g[0<n?"previousSibling":"nextSibling"],e.nodeType==CKEDITOR.NODE_TEXT&&(h-=e.nodeValue.length,q=e),g=e;}catch(p){return{container:d,offset:a(g)};}}return{container:q,offset:0<n?-h:q.nodeValue.length+h};};return function(){var a=this.getNative(),c=a&&a.createRange(),d=this.getType();if(!a)return[];if(d==CKEDITOR.SELECTION_TEXT)return a=new CKEDITOR.dom.range(this.root),d=b(c,!0),a.setStart(new CKEDITOR.dom.node(d.container),d.offset),d=b(c),a.setEnd(new CKEDITOR.dom.node(d.container),d.offset),a.endContainer.getPosition(a.startContainer)&CKEDITOR.POSITION_PRECEDING&&a.endOffset<=a.startContainer.getIndex()&&a.collapse(),[a];if(d==CKEDITOR.SELECTION_ELEMENT){for(var d=[],f=0;f<c.length;f++){for(var g=c.item(f),e=g.parentNode,h=0,a=new CKEDITOR.dom.range(this.root);h<e.childNodes.length&&e.childNodes[h]!=g;h++){}a.setStart(new CKEDITOR.dom.node(e),h);a.setEnd(new CKEDITOR.dom.node(e),h+1);d.push(a);}return d;}return[];};}():function(){var a=[],b,c=this.getNative();if(!c)return a;for(var d=0;d<c.rangeCount;d++){var f=c.getRangeAt(d);b=new CKEDITOR.dom.range(this.root);b.setStart(new CKEDITOR.dom.node(f.startContainer),f.startOffset);b.setEnd(new CKEDITOR.dom.node(f.endContainer),f.endOffset);a.push(b);}return a;};return function(b){var c=this._.cache,d=c.ranges;d||(c.ranges=d=new CKEDITOR.dom.rangeList(a.call(this)));return b?g(new CKEDITOR.dom.rangeList(d.slice())):d;};}(),getStartElement:function getStartElement(){var a=this._.cache;if(void 0!==a.startElement)return a.startElement;var b;switch(this.getType()){case CKEDITOR.SELECTION_ELEMENT:return this.getSelectedElement();case CKEDITOR.SELECTION_TEXT:var c=this.getRanges()[0];if(c){if(c.collapsed)b=c.startContainer,b.type!=CKEDITOR.NODE_ELEMENT&&(b=b.getParent());else{for(c.optimize();b=c.startContainer,c.startOffset==(b.getChildCount?b.getChildCount():b.getLength())&&!b.isBlockBoundary();){c.setStartAfter(b);}b=c.startContainer;if(b.type!=CKEDITOR.NODE_ELEMENT)return b.getParent();if((b=b.getChild(c.startOffset))&&b.type==CKEDITOR.NODE_ELEMENT)for(c=b.getFirst();c&&c.type==CKEDITOR.NODE_ELEMENT;){b=c,c=c.getFirst();}else b=c.startContainer;}b=b.$;}}return a.startElement=b?new CKEDITOR.dom.element(b):null;},getSelectedElement:function getSelectedElement(){var a=this._.cache;if(void 0!==a.selectedElement)return a.selectedElement;var b=this,c=CKEDITOR.tools.tryThese(function(){return b.getNative().createRange().item(0);},function(){for(var a=b.getRanges()[0].clone(),c,d,f=2;f&&!((c=a.getEnclosedNode())&&c.type==CKEDITOR.NODE_ELEMENT&&A[c.getName()]&&(d=c));f--){a.shrink(CKEDITOR.SHRINK_ELEMENT);}return d&&d.$;});return a.selectedElement=c?new CKEDITOR.dom.element(c):null;},getSelectedText:function getSelectedText(){var a=this._.cache;if(void 0!==a.selectedText)return a.selectedText;var b=this.getNative(),b=n?"Control"==b.type?"":b.createRange().text:b.toString();return a.selectedText=b;},lock:function lock(){this.getRanges();this.getStartElement();this.getSelectedElement();this.getSelectedText();this._.cache.nativeSel=null;this.isLocked=1;},unlock:function unlock(a){if(this.isLocked){if(a)var b=this.getSelectedElement(),c=!b&&this.getRanges(),d=this.isFake;this.isLocked=0;this.reset();a&&(a=b||c[0]&&c[0].getCommonAncestor())&&a.getAscendant("body",1)&&(d?this.fake(b):b?this.selectElement(b):this.selectRanges(c));}},reset:function reset(){this._.cache={};this.isFake=0;var a=this.root.editor;if(a&&a._.fakeSelection)if(this.rev==a._.fakeSelection.rev){delete a._.fakeSelection;var b=a._.hiddenSelectionContainer;if(b){var c=a.checkDirty();a.fire("lockSnapshot");b.remove();a.fire("unlockSnapshot");!c&&a.resetDirty();}delete a._.hiddenSelectionContainer;}else CKEDITOR.warn("selection-fake-reset");this.rev=v++;},selectElement:function selectElement(a){var b=new CKEDITOR.dom.range(this.root);b.setStartBefore(a);b.setEndAfter(a);this.selectRanges([b]);},selectRanges:function selectRanges(a){var b=this.root.editor,b=b&&b._.hiddenSelectionContainer;this.reset();if(b)for(var b=this.root,c,f=0;f<a.length;++f){c=a[f],c.endContainer.equals(b)&&(c.endOffset=Math.min(c.endOffset,b.getChildCount()));}if(a.length)if(this.isLocked){var g=CKEDITOR.document.getActive();this.unlock();this.selectRanges(a);this.lock();g&&!g.equals(this.root)&&g.focus();}else{var e;a:{var h,k;if(1==a.length&&!(k=a[0]).collapsed&&(e=k.getEnclosedNode())&&e.type==CKEDITOR.NODE_ELEMENT&&(k=k.clone(),k.shrink(CKEDITOR.SHRINK_ELEMENT,!0),(h=k.getEnclosedNode())&&h.type==CKEDITOR.NODE_ELEMENT&&(e=h),"false"==e.getAttribute("contenteditable")))break a;e=void 0;}if(e)this.fake(e);else{if(n){k=CKEDITOR.dom.walker.whitespaces(!0);h=/\ufeff|\u00a0/;b={table:1,tbody:1,tr:1};1<a.length&&(e=a[a.length-1],a[0].setEnd(e.endContainer,e.endOffset));e=a[0];a=e.collapsed;var q,p,w;if((c=e.getEnclosedNode())&&c.type==CKEDITOR.NODE_ELEMENT&&c.getName()in A&&(!c.is("a")||!c.getText()))try{w=c.$.createControlRange();w.addElement(c.$);w.select();return;}catch(t){}if(e.startContainer.type==CKEDITOR.NODE_ELEMENT&&e.startContainer.getName()in b||e.endContainer.type==CKEDITOR.NODE_ELEMENT&&e.endContainer.getName()in b)e.shrink(CKEDITOR.NODE_ELEMENT,!0),a=e.collapsed;w=e.createBookmark();b=w.startNode;a||(g=w.endNode);w=e.document.$.body.createTextRange();w.moveToElementText(b.$);w.moveStart("character",1);g?(h=e.document.$.body.createTextRange(),h.moveToElementText(g.$),w.setEndPoint("EndToEnd",h),w.moveEnd("character",-1)):(q=b.getNext(k),p=b.hasAscendant("pre"),q=!(q&&q.getText&&q.getText().match(h))&&(p||!b.hasPrevious()||b.getPrevious().is&&b.getPrevious().is("br")),p=e.document.createElement("span"),p.setHtml("\x26#65279;"),p.insertBefore(b),q&&e.document.createText("﻿").insertBefore(b));e.setStartBefore(b);b.remove();a?(q?(w.moveStart("character",-1),w.select(),e.document.$.selection.clear()):w.select(),e.moveToPosition(p,CKEDITOR.POSITION_BEFORE_START),p.remove()):(e.setEndBefore(g),g.remove(),w.select());}else{g=this.getNative();if(!g)return;this.removeAllRanges();for(w=0;w<a.length;w++){if(w<a.length-1&&(q=a[w],p=a[w+1],h=q.clone(),h.setStart(q.endContainer,q.endOffset),h.setEnd(p.startContainer,p.startOffset),!h.collapsed&&(h.shrink(CKEDITOR.NODE_ELEMENT,!0),e=h.getCommonAncestor(),h=h.getEnclosedNode(),e.isReadOnly()||h&&h.isReadOnly()))){p.setStart(q.startContainer,q.startOffset);a.splice(w--,1);continue;}e=a[w];p=this.document.$.createRange();e.collapsed&&CKEDITOR.env.webkit&&d(e)&&(h=l(this.root),e.insertNode(h),(q=h.getNext())&&!h.getPrevious()&&q.type==CKEDITOR.NODE_ELEMENT&&"br"==q.getName()?(m(this.root),e.moveToPosition(q,CKEDITOR.POSITION_BEFORE_START)):e.moveToPosition(h,CKEDITOR.POSITION_AFTER_END));p.setStart(e.startContainer.$,e.startOffset);try{p.setEnd(e.endContainer.$,e.endOffset);}catch(H){if(0<=H.toString().indexOf("NS_ERROR_ILLEGAL_VALUE"))e.collapse(1),p.setEnd(e.endContainer.$,e.endOffset);else throw H;}g.addRange(p);}}this.reset();this.root.fire("selectionchange");}}},fake:function fake(a,b){var c=this.root.editor;void 0===b&&a.hasAttribute("aria-label")&&(b=a.getAttribute("aria-label"));this.reset();h(c,b);var d=this._.cache,f=new CKEDITOR.dom.range(this.root);f.setStartBefore(a);f.setEndAfter(a);d.ranges=new CKEDITOR.dom.rangeList(f);d.selectedElement=d.startElement=a;d.type=CKEDITOR.SELECTION_ELEMENT;d.selectedText=d.nativeSel=null;this.isFake=1;this.rev=v++;c._.fakeSelection=this;this.root.fire("selectionchange");},isHidden:function isHidden(){var a=this.getCommonAncestor();a&&a.type==CKEDITOR.NODE_TEXT&&(a=a.getParent());return!(!a||!a.data("cke-hidden-sel"));},createBookmarks:function createBookmarks(a){a=this.getRanges().createBookmarks(a);this.isFake&&(a.isFake=1);return a;},createBookmarks2:function createBookmarks2(a){a=this.getRanges().createBookmarks2(a);this.isFake&&(a.isFake=1);return a;},selectBookmarks:function selectBookmarks(a){for(var b=[],c,d=0;d<a.length;d++){var f=new CKEDITOR.dom.range(this.root);f.moveToBookmark(a[d]);b.push(f);}a.isFake&&(c=b[0].getEnclosedNode(),c&&c.type==CKEDITOR.NODE_ELEMENT||(CKEDITOR.warn("selection-not-fake"),a.isFake=0));a.isFake?this.fake(c):this.selectRanges(b);return this;},getCommonAncestor:function getCommonAncestor(){var a=this.getRanges();return a.length?a[0].startContainer.getCommonAncestor(a[a.length-1].endContainer):null;},scrollIntoView:function scrollIntoView(){this.type!=CKEDITOR.SELECTION_NONE&&this.getRanges()[0].scrollIntoView();},removeAllRanges:function removeAllRanges(){if(this.getType()!=CKEDITOR.SELECTION_NONE){var a=this.getNative();try{a&&a[n?"empty":"removeAllRanges"]();}catch(b){}this.reset();}}};}(),"use strict",CKEDITOR.STYLE_BLOCK=1,CKEDITOR.STYLE_INLINE=2,CKEDITOR.STYLE_OBJECT=3,function(){function a(a,b){for(var c,d;(a=a.getParent())&&!a.equals(b);){if(a.getAttribute("data-nostyle"))c=a;else if(!d){var f=a.getAttribute("contentEditable");"false"==f?c=a:"true"==f&&(d=1);}}return c;}function e(a,b,c,d){return(a.getPosition(b)|d)==d&&(!c.childRule||c.childRule(a));}function b(c){var f=c.document;if(c.collapsed)f=w(this,f),c.insertNode(f),c.moveToPosition(f,CKEDITOR.POSITION_BEFORE_END);else{var g=this.element,h=this._.definition,k,l=h.ignoreReadonly,m=l||h.includeReadonly;null==m&&(m=c.root.getCustomData("cke_includeReadonly"));var n=CKEDITOR.dtd[g];n||(k=!0,n=CKEDITOR.dtd.span);c.enlarge(CKEDITOR.ENLARGE_INLINE,1);c.trim();var p=c.createBookmark(),t=p.startNode,r=p.endNode,z=t,u;if(!l){var v=c.getCommonAncestor(),l=a(t,v),v=a(r,v);l&&(z=l.getNextSourceNode(!0));v&&(r=v);}for(z.getPosition(r)==CKEDITOR.POSITION_FOLLOWING&&(z=0);z;){l=!1;if(z.equals(r))z=null,l=!0;else{var A=z.type==CKEDITOR.NODE_ELEMENT?z.getName():null,v=A&&"false"==z.getAttribute("contentEditable"),x=A&&z.getAttribute("data-nostyle");if(A&&z.data("cke-bookmark")){z=z.getNextSourceNode(!0);continue;}if(v&&m&&CKEDITOR.dtd.$block[A])for(var D=z,y=d(D),B=void 0,C=y.length,ea=0,D=C&&new CKEDITOR.dom.range(D.getDocument());ea<C;++ea){var B=y[ea],ha=CKEDITOR.filter.instances[B.data("cke-filter")];if(ha?ha.check(this):1)D.selectNodeContents(B),b.call(this,D);}y=A?!n[A]||x?0:v&&!m?0:e(z,r,h,M):1;if(y){if(B=z.getParent(),y=h,C=g,ea=k,!B||!(B.getDtd()||CKEDITOR.dtd.span)[C]&&!ea||y.parentRule&&!y.parentRule(B))l=!0;else{if(u||A&&CKEDITOR.dtd.$removeEmpty[A]&&(z.getPosition(r)|M)!=M||(u=c.clone(),u.setStartBefore(z)),A=z.type,A==CKEDITOR.NODE_TEXT||v||A==CKEDITOR.NODE_ELEMENT&&!z.getChildCount()){for(var A=z,E;(l=!A.getNext(J))&&(E=A.getParent(),n[E.getName()])&&e(E,t,h,I);){A=E;}u.setEndAfter(A);}}}else l=!0;z=z.getNextSourceNode(x||v);}if(l&&u&&!u.collapsed){for(var l=w(this,f),v=l.hasAttributes(),x=u.getCommonAncestor(),A={},y={},B={},C={},aa,fa,F;l&&x;){if(x.getName()==g){for(aa in h.attributes){!C[aa]&&(F=x.getAttribute(fa))&&(l.getAttribute(aa)==F?y[aa]=1:C[aa]=1);}for(fa in h.styles){!B[fa]&&(F=x.getStyle(fa))&&(l.getStyle(fa)==F?A[fa]=1:B[fa]=1);}}x=x.getParent();}for(aa in y){l.removeAttribute(aa);}for(fa in A){l.removeStyle(fa);}v&&!l.hasAttributes()&&(l=null);l?(u.extractContents().appendTo(l),u.insertNode(l),q.call(this,l),l.mergeSiblings(),CKEDITOR.env.ie||l.$.normalize()):(l=new CKEDITOR.dom.element("span"),u.extractContents().appendTo(l),u.insertNode(l),q.call(this,l),l.remove(!0));u=null;}}c.moveToBookmark(p);c.shrink(CKEDITOR.SHRINK_TEXT);c.shrink(CKEDITOR.NODE_ELEMENT,!0);}}function c(a){function b(){for(var a=new CKEDITOR.dom.elementPath(d.getParent()),c=new CKEDITOR.dom.elementPath(l.getParent()),f=null,g=null,e=0;e<a.elements.length;e++){var h=a.elements[e];if(h==a.block||h==a.blockLimit)break;m.checkElementRemovable(h,!0)&&(f=h);}for(e=0;e<c.elements.length;e++){h=c.elements[e];if(h==c.block||h==c.blockLimit)break;m.checkElementRemovable(h,!0)&&(g=h);}g&&l.breakParent(g);f&&d.breakParent(f);}a.enlarge(CKEDITOR.ENLARGE_INLINE,1);var c=a.createBookmark(),d=c.startNode;if(a.collapsed){for(var f=new CKEDITOR.dom.elementPath(d.getParent(),a.root),g,e=0,h;e<f.elements.length&&(h=f.elements[e])&&h!=f.block&&h!=f.blockLimit;e++){if(this.checkElementRemovable(h)){var k;a.collapsed&&(a.checkBoundaryOfElement(h,CKEDITOR.END)||(k=a.checkBoundaryOfElement(h,CKEDITOR.START)))?(g=h,g.match=k?"start":"end"):(h.mergeSiblings(),h.is(this.element)?r.call(this,h):t(h,u(this)[h.getName()]));}}if(g){h=d;for(e=0;;e++){k=f.elements[e];if(k.equals(g))break;else if(k.match)continue;else k=k.clone();k.append(h);h=k;}h["start"==g.match?"insertBefore":"insertAfter"](g);}}else{var l=c.endNode,m=this;b();for(f=d;!f.equals(l);){g=f.getNextSourceNode(),f.type==CKEDITOR.NODE_ELEMENT&&this.checkElementRemovable(f)&&(f.getName()==this.element?r.call(this,f):t(f,u(this)[f.getName()]),g.type==CKEDITOR.NODE_ELEMENT&&g.contains(d)&&(b(),g=d.getNext())),f=g;}}a.moveToBookmark(c);a.shrink(CKEDITOR.NODE_ELEMENT,!0);}function d(a){var b=[];a.forEach(function(a){if("true"==a.getAttribute("contenteditable"))return b.push(a),!1;},CKEDITOR.NODE_ELEMENT,!0);return b;}function l(a){var b=a.getEnclosedNode()||a.getCommonAncestor(!1,!0);(a=new CKEDITOR.dom.elementPath(b,a.root).contains(this.element,1))&&!a.isReadOnly()&&z(a,this);}function m(a){var b=a.getCommonAncestor(!0,!0);if(a=new CKEDITOR.dom.elementPath(b,a.root).contains(this.element,1)){var b=this._.definition,c=b.attributes;if(c)for(var d in c){a.removeAttribute(d,c[d]);}if(b.styles)for(var f in b.styles){b.styles.hasOwnProperty(f)&&a.removeStyle(f);}}}function f(a){var b=a.createBookmark(!0),c=a.createIterator();c.enforceRealBlocks=!0;this._.enterMode&&(c.enlargeBr=this._.enterMode!=CKEDITOR.ENTER_BR);for(var d,f=a.document,g;d=c.getNextParagraph();){!d.isReadOnly()&&(c.activeFilter?c.activeFilter.check(this):1)&&(g=w(this,f,d),k(d,g));}a.moveToBookmark(b);}function h(a){var b=a.createBookmark(1),c=a.createIterator();c.enforceRealBlocks=!0;c.enlargeBr=this._.enterMode!=CKEDITOR.ENTER_BR;for(var d,f;d=c.getNextParagraph();){this.checkElementRemovable(d)&&(d.is("pre")?((f=this._.enterMode==CKEDITOR.ENTER_BR?null:a.document.createElement(this._.enterMode==CKEDITOR.ENTER_P?"p":"div"))&&d.copyAttributes(f),k(d,f)):r.call(this,d));}a.moveToBookmark(b);}function k(a,b){var c=!b;c&&(b=a.getDocument().createElement("div"),a.copyAttributes(b));var d=b&&b.is("pre"),f=a.is("pre"),e=!d&&f;if(d&&!f){f=b;(e=a.getBogus())&&e.remove();e=a.getHtml();e=n(e,/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g,"");e=e.replace(/[ \t\r\n]*(<br[^>]*>)[ \t\r\n]*/gi,"$1");e=e.replace(/([ \t\n\r]+|&nbsp;)/g," ");e=e.replace(/<br\b[^>]*>/gi,"\n");if(CKEDITOR.env.ie){var h=a.getDocument().createElement("div");h.append(f);f.$.outerHTML="\x3cpre\x3e"+e+"\x3c/pre\x3e";f.copyAttributes(h.getFirst());f=h.getFirst().remove();}else f.setHtml(e);b=f;}else e?b=v(c?[a.getHtml()]:g(a),b):a.moveChildren(b);b.replace(a);if(d){var c=b,k;(k=c.getPrevious(G))&&k.type==CKEDITOR.NODE_ELEMENT&&k.is("pre")&&(d=n(k.getHtml(),/\n$/,"")+"\n\n"+n(c.getHtml(),/^\n/,""),CKEDITOR.env.ie?c.$.outerHTML="\x3cpre\x3e"+d+"\x3c/pre\x3e":c.setHtml(d),k.remove());}else c&&p(b);}function g(a){var b=[];n(a.getOuterHtml(),/(\S\s*)\n(?:\s|(<span[^>]+data-cke-bookmark.*?\/span>))*\n(?!$)/gi,function(a,b,c){return b+"\x3c/pre\x3e"+c+"\x3cpre\x3e";}).replace(/<pre\b.*?>([\s\S]*?)<\/pre>/gi,function(a,c){b.push(c);});return b;}function n(a,b,c){var d="",f="";a=a.replace(/(^<span[^>]+data-cke-bookmark.*?\/span>)|(<span[^>]+data-cke-bookmark.*?\/span>$)/gi,function(a,b,c){b&&(d=b);c&&(f=c);return"";});return d+a.replace(b,c)+f;}function v(a,b){var c;1<a.length&&(c=new CKEDITOR.dom.documentFragment(b.getDocument()));for(var d=0;d<a.length;d++){var f=a[d],f=f.replace(/(\r\n|\r)/g,"\n"),f=n(f,/^[ \t]*\n/,""),f=n(f,/\n$/,""),f=n(f,/^[ \t]+|[ \t]+$/g,function(a,b){return 1==a.length?"\x26nbsp;":b?" "+CKEDITOR.tools.repeat("\x26nbsp;",a.length-1):CKEDITOR.tools.repeat("\x26nbsp;",a.length-1)+" ";}),f=f.replace(/\n/g,"\x3cbr\x3e"),f=f.replace(/[ \t]{2,}/g,function(a){return CKEDITOR.tools.repeat("\x26nbsp;",a.length-1)+" ";});if(c){var g=b.clone();g.setHtml(f);c.append(g);}else b.setHtml(f);}return c||b;}function r(a,b){var c=this._.definition,d=c.attributes,c=c.styles,f=u(this)[a.getName()],g=CKEDITOR.tools.isEmpty(d)&&CKEDITOR.tools.isEmpty(c),e;for(e in d){if("class"!=e&&!this._.definition.fullMatch||a.getAttribute(e)==x(e,d[e]))b&&"data-"==e.slice(0,5)||(g=a.hasAttribute(e),a.removeAttribute(e));}for(var h in c){this._.definition.fullMatch&&a.getStyle(h)!=x(h,c[h],!0)||(g=g||!!a.getStyle(h),a.removeStyle(h));}t(a,f,B[a.getName()]);g&&(this._.definition.alwaysRemoveElement?p(a,1):!CKEDITOR.dtd.$block[a.getName()]||this._.enterMode==CKEDITOR.ENTER_BR&&!a.hasAttributes()?p(a):a.renameNode(this._.enterMode==CKEDITOR.ENTER_P?"p":"div"));}function q(a){for(var b=u(this),c=a.getElementsByTag(this.element),d,f=c.count();0<=--f;){d=c.getItem(f),d.isReadOnly()||r.call(this,d,!0);}for(var g in b){if(g!=this.element)for(c=a.getElementsByTag(g),f=c.count()-1;0<=f;f--){d=c.getItem(f),d.isReadOnly()||t(d,b[g]);}}}function t(a,b,c){if(b=b&&b.attributes)for(var d=0;d<b.length;d++){var f=b[d][0],g;if(g=a.getAttribute(f)){var e=b[d][1];(null===e||e.test&&e.test(g)||"string"==typeof e&&g==e)&&a.removeAttribute(f);}}c||p(a);}function p(a,b){if(!a.hasAttributes()||b)if(CKEDITOR.dtd.$block[a.getName()]){var c=a.getPrevious(G),d=a.getNext(G);!c||c.type!=CKEDITOR.NODE_TEXT&&c.isBlockBoundary({br:1})||a.append("br",1);!d||d.type!=CKEDITOR.NODE_TEXT&&d.isBlockBoundary({br:1})||a.append("br");a.remove(!0);}else c=a.getFirst(),d=a.getLast(),a.remove(!0),c&&(c.type==CKEDITOR.NODE_ELEMENT&&c.mergeSiblings(),d&&!c.equals(d)&&d.type==CKEDITOR.NODE_ELEMENT&&d.mergeSiblings());}function w(a,b,c){var d;d=a.element;"*"==d&&(d="span");d=new CKEDITOR.dom.element(d,b);c&&c.copyAttributes(d);d=z(d,a);b.getCustomData("doc_processing_style")&&d.hasAttribute("id")?d.removeAttribute("id"):b.setCustomData("doc_processing_style",1);return d;}function z(a,b){var c=b._.definition,d=c.attributes,c=CKEDITOR.style.getStyleText(c);if(d)for(var f in d){a.setAttribute(f,d[f]);}c&&a.setAttribute("style",c);return a;}function A(a,b){for(var c in a){a[c]=a[c].replace(E,function(a,c){return b[c];});}}function u(a){if(a._.overrides)return a._.overrides;var b=a._.overrides={},c=a._.definition.overrides;if(c){CKEDITOR.tools.isArray(c)||(c=[c]);for(var d=0;d<c.length;d++){var f=c[d],g,e;"string"==typeof f?g=f.toLowerCase():(g=f.element?f.element.toLowerCase():a.element,e=f.attributes);f=b[g]||(b[g]={});if(e){var f=f.attributes=f.attributes||[],h;for(h in e){f.push([h.toLowerCase(),e[h]]);}}}}return b;}function x(a,b,c){var d=new CKEDITOR.dom.element("span");d[c?"setStyle":"setAttribute"](a,b);return d[c?"getStyle":"getAttribute"](a);}function D(a,b){function c(a,b){return"font-family"==b.toLowerCase()?a.replace(/["']/g,""):a;}"string"==typeof a&&(a=CKEDITOR.tools.parseCssText(a));"string"==typeof b&&(b=CKEDITOR.tools.parseCssText(b,!0));for(var d in a){if(!(d in b)||c(b[d],d)!=c(a[d],d)&&"inherit"!=a[d]&&"inherit"!=b[d])return!1;}return!0;}function y(a,b,c){var d=a.document,f=a.getRanges();b=b?this.removeFromRange:this.applyToRange;for(var g,e=f.createIterator();g=e.getNextRange();){b.call(this,g,c);}a.selectRanges(f);d.removeCustomData("doc_processing_style");}var B={address:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,p:1,pre:1,section:1,header:1,footer:1,nav:1,article:1,aside:1,figure:1,dialog:1,hgroup:1,time:1,meter:1,menu:1,command:1,keygen:1,output:1,progress:1,details:1,datagrid:1,datalist:1},C={a:1,blockquote:1,embed:1,hr:1,img:1,li:1,object:1,ol:1,table:1,td:1,tr:1,th:1,ul:1,dl:1,dt:1,dd:1,form:1,audio:1,video:1},F=/\s*(?:;\s*|$)/,E=/#\((.+?)\)/g,J=CKEDITOR.dom.walker.bookmark(0,1),G=CKEDITOR.dom.walker.whitespaces(1);CKEDITOR.style=function(a,b){if("string"==typeof a.type)return new CKEDITOR.style.customHandlers[a.type](a);var c=a.attributes;c&&c.style&&(a.styles=CKEDITOR.tools.extend({},a.styles,CKEDITOR.tools.parseCssText(c.style)),delete c.style);b&&(a=CKEDITOR.tools.clone(a),A(a.attributes,b),A(a.styles,b));c=this.element=a.element?"string"==typeof a.element?a.element.toLowerCase():a.element:"*";this.type=a.type||(B[c]?CKEDITOR.STYLE_BLOCK:C[c]?CKEDITOR.STYLE_OBJECT:CKEDITOR.STYLE_INLINE);"object"==_typeof(this.element)&&(this.type=CKEDITOR.STYLE_OBJECT);this._={definition:a};};CKEDITOR.style.prototype={apply:function apply(a){if(a instanceof CKEDITOR.dom.document)return y.call(this,a.getSelection());if(this.checkApplicable(a.elementPath(),a)){var b=this._.enterMode;b||(this._.enterMode=a.activeEnterMode);y.call(this,a.getSelection(),0,a);this._.enterMode=b;}},remove:function remove(a){if(a instanceof CKEDITOR.dom.document)return y.call(this,a.getSelection(),1);if(this.checkApplicable(a.elementPath(),a)){var b=this._.enterMode;b||(this._.enterMode=a.activeEnterMode);y.call(this,a.getSelection(),1,a);this._.enterMode=b;}},applyToRange:function applyToRange(a){this.applyToRange=this.type==CKEDITOR.STYLE_INLINE?b:this.type==CKEDITOR.STYLE_BLOCK?f:this.type==CKEDITOR.STYLE_OBJECT?l:null;return this.applyToRange(a);},removeFromRange:function removeFromRange(a){this.removeFromRange=this.type==CKEDITOR.STYLE_INLINE?c:this.type==CKEDITOR.STYLE_BLOCK?h:this.type==CKEDITOR.STYLE_OBJECT?m:null;return this.removeFromRange(a);},applyToObject:function applyToObject(a){z(a,this);},checkActive:function checkActive(a,b){switch(this.type){case CKEDITOR.STYLE_BLOCK:return this.checkElementRemovable(a.block||a.blockLimit,!0,b);case CKEDITOR.STYLE_OBJECT:case CKEDITOR.STYLE_INLINE:for(var c=a.elements,d=0,f;d<c.length;d++){if(f=c[d],this.type!=CKEDITOR.STYLE_INLINE||f!=a.block&&f!=a.blockLimit){if(this.type==CKEDITOR.STYLE_OBJECT){var g=f.getName();if(!("string"==typeof this.element?g==this.element:g in this.element))continue;}if(this.checkElementRemovable(f,!0,b))return!0;}}}return!1;},checkApplicable:function checkApplicable(a,b,c){b&&b instanceof CKEDITOR.filter&&(c=b);if(c&&!c.check(this))return!1;switch(this.type){case CKEDITOR.STYLE_OBJECT:return!!a.contains(this.element);case CKEDITOR.STYLE_BLOCK:return!!a.blockLimit.getDtd()[this.element];}return!0;},checkElementMatch:function checkElementMatch(a,b){var c=this._.definition;if(!a||!c.ignoreReadonly&&a.isReadOnly())return!1;var d=a.getName();if("string"==typeof this.element?d==this.element:d in this.element){if(!b&&!a.hasAttributes())return!0;if(d=c._AC)c=d;else{var d={},f=0,g=c.attributes;if(g)for(var e in g){f++,d[e]=g[e];}if(e=CKEDITOR.style.getStyleText(c))d.style||f++,d.style=e;d._length=f;c=c._AC=d;}if(c._length){for(var h in c){if("_length"!=h)if(d=a.getAttribute(h)||"","style"==h?D(c[h],d):c[h]==d){if(!b)return!0;}else if(b)return!1;}if(b)return!0;}else return!0;}return!1;},checkElementRemovable:function checkElementRemovable(a,b,c){if(this.checkElementMatch(a,b,c))return!0;if(b=u(this)[a.getName()]){var d;if(!(b=b.attributes))return!0;for(c=0;c<b.length;c++){if(d=b[c][0],d=a.getAttribute(d)){var f=b[c][1];if(null===f)return!0;if("string"==typeof f){if(d==f)return!0;}else if(f.test(d))return!0;}}}return!1;},buildPreview:function buildPreview(a){var b=this._.definition,c=[],d=b.element;"bdo"==d&&(d="span");var c=["\x3c",d],f=b.attributes;if(f)for(var g in f){c.push(" ",g,'\x3d"',f[g],'"');}(f=CKEDITOR.style.getStyleText(b))&&c.push(' style\x3d"',f,'"');c.push("\x3e",a||b.name,"\x3c/",d,"\x3e");return c.join("");},getDefinition:function getDefinition(){return this._.definition;}};CKEDITOR.style.getStyleText=function(a){var b=a._ST;if(b)return b;var b=a.styles,c=a.attributes&&a.attributes.style||"",d="";c.length&&(c=c.replace(F,";"));for(var f in b){var g=b[f],e=(f+":"+g).replace(F,";");"inherit"==g?d+=e:c+=e;}c.length&&(c=CKEDITOR.tools.normalizeCssText(c,!0));return a._ST=c+d;};CKEDITOR.style.customHandlers={};CKEDITOR.style.addCustomHandler=function(a){var b=function b(a){this._={definition:a};this.setup&&this.setup(a);};b.prototype=CKEDITOR.tools.extend(CKEDITOR.tools.prototypedCopy(CKEDITOR.style.prototype),{assignedTo:CKEDITOR.STYLE_OBJECT},a,!0);return this.customHandlers[a.type]=b;};var M=CKEDITOR.POSITION_PRECEDING|CKEDITOR.POSITION_IDENTICAL|CKEDITOR.POSITION_IS_CONTAINED,I=CKEDITOR.POSITION_FOLLOWING|CKEDITOR.POSITION_IDENTICAL|CKEDITOR.POSITION_IS_CONTAINED;}(),CKEDITOR.styleCommand=function(a,e){this.requiredContent=this.allowedContent=this.style=a;CKEDITOR.tools.extend(this,e,!0);},CKEDITOR.styleCommand.prototype.exec=function(a){a.focus();this.state==CKEDITOR.TRISTATE_OFF?a.applyStyle(this.style):this.state==CKEDITOR.TRISTATE_ON&&a.removeStyle(this.style);},CKEDITOR.stylesSet=new CKEDITOR.resourceManager("","stylesSet"),CKEDITOR.addStylesSet=CKEDITOR.tools.bind(CKEDITOR.stylesSet.add,CKEDITOR.stylesSet),CKEDITOR.loadStylesSet=function(a,e,b){CKEDITOR.stylesSet.addExternal(a,e,"");CKEDITOR.stylesSet.load(a,b);},CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{attachStyleStateChange:function attachStyleStateChange(a,e){var b=this._.styleStateChangeCallbacks;b||(b=this._.styleStateChangeCallbacks=[],this.on("selectionChange",function(a){for(var d=0;d<b.length;d++){var e=b[d],m=e.style.checkActive(a.data.path,this)?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF;e.fn.call(this,m);}}));b.push({style:a,fn:e});},applyStyle:function applyStyle(a){a.apply(this);},removeStyle:function removeStyle(a){a.remove(this);},getStylesSet:function getStylesSet(a){if(this._.stylesDefinitions)a(this._.stylesDefinitions);else{var e=this,b=e.config.stylesCombo_stylesSet||e.config.stylesSet;if(!1===b)a(null);else if(b instanceof Array)e._.stylesDefinitions=b,a(b);else{b||(b="default");var b=b.split(":"),c=b[0];CKEDITOR.stylesSet.addExternal(c,b[1]?b.slice(1).join(":"):CKEDITOR.getUrl("styles.js"),"");CKEDITOR.stylesSet.load(c,function(b){e._.stylesDefinitions=b[c];a(e._.stylesDefinitions);});}}}}),CKEDITOR.dom.comment=function(a,e){"string"==typeof a&&(a=(e?e.$:document).createComment(a));CKEDITOR.dom.domObject.call(this,a);},CKEDITOR.dom.comment.prototype=new CKEDITOR.dom.node(),CKEDITOR.tools.extend(CKEDITOR.dom.comment.prototype,{type:CKEDITOR.NODE_COMMENT,getOuterHtml:function getOuterHtml(){return"\x3c!--"+this.$.nodeValue+"--\x3e";}}),"use strict",function(){var a={},e={},b;for(b in CKEDITOR.dtd.$blockLimit){b in CKEDITOR.dtd.$list||(a[b]=1);}for(b in CKEDITOR.dtd.$block){b in CKEDITOR.dtd.$blockLimit||b in CKEDITOR.dtd.$empty||(e[b]=1);}CKEDITOR.dom.elementPath=function(b,d){var l=null,m=null,f=[],h=b,k;d=d||b.getDocument().getBody();do{if(h.type==CKEDITOR.NODE_ELEMENT){f.push(h);if(!this.lastElement&&(this.lastElement=h,h.is(CKEDITOR.dtd.$object)||"false"==h.getAttribute("contenteditable")))continue;if(h.equals(d))break;if(!m&&(k=h.getName(),"true"==h.getAttribute("contenteditable")?m=h:!l&&e[k]&&(l=h),a[k])){if(k=!l&&"div"==k){a:{k=h.getChildren();for(var g=0,n=k.count();g<n;g++){var v=k.getItem(g);if(v.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$block[v.getName()]){k=!0;break a;}}k=!1;}k=!k;}k?l=h:m=h;}}}while(h=h.getParent());m||(m=d);this.block=l;this.blockLimit=m;this.root=d;this.elements=f;};}(),CKEDITOR.dom.elementPath.prototype={compare:function compare(a){var e=this.elements;a=a&&a.elements;if(!a||e.length!=a.length)return!1;for(var b=0;b<e.length;b++){if(!e[b].equals(a[b]))return!1;}return!0;},contains:function contains(a,e,b){var c;"string"==typeof a&&(c=function c(b){return b.getName()==a;});a instanceof CKEDITOR.dom.element?c=function c(b){return b.equals(a);}:CKEDITOR.tools.isArray(a)?c=function c(b){return-1<CKEDITOR.tools.indexOf(a,b.getName());}:"function"==typeof a?c=a:"object"==(typeof a==="undefined"?"undefined":_typeof(a))&&(c=function c(b){return b.getName()in a;});var d=this.elements,l=d.length;e&&l--;b&&(d=Array.prototype.slice.call(d,0),d.reverse());for(e=0;e<l;e++){if(c(d[e]))return d[e];}return null;},isContextFor:function isContextFor(a){var e;return a in CKEDITOR.dtd.$block?(e=this.contains(CKEDITOR.dtd.$intermediate)||this.root.equals(this.block)&&this.block||this.blockLimit,!!e.getDtd()[a]):!0;},direction:function direction(){return(this.block||this.blockLimit||this.root).getDirection(1);}},CKEDITOR.dom.text=function(a,e){"string"==typeof a&&(a=(e?e.$:document).createTextNode(a));this.$=a;},CKEDITOR.dom.text.prototype=new CKEDITOR.dom.node(),CKEDITOR.tools.extend(CKEDITOR.dom.text.prototype,{type:CKEDITOR.NODE_TEXT,getLength:function getLength(){return this.$.nodeValue.length;},getText:function getText(){return this.$.nodeValue;},setText:function setText(a){this.$.nodeValue=a;},split:function split(a){var e=this.$.parentNode,b=e.childNodes.length,c=this.getLength(),d=this.getDocument(),l=new CKEDITOR.dom.text(this.$.splitText(a),d);e.childNodes.length==b&&(a>=c?(l=d.createText(""),l.insertAfter(this)):(a=d.createText(""),a.insertAfter(l),a.remove()));return l;},substring:function substring(a,e){return"number"!=typeof e?this.$.nodeValue.substr(a):this.$.nodeValue.substring(a,e);}}),function(){function a(a,c,d){var e=a.serializable,m=c[d?"endContainer":"startContainer"],f=d?"endOffset":"startOffset",h=e?c.document.getById(a.startNode):a.startNode;a=e?c.document.getById(a.endNode):a.endNode;m.equals(h.getPrevious())?(c.startOffset=c.startOffset-m.getLength()-a.getPrevious().getLength(),m=a.getNext()):m.equals(a.getPrevious())&&(c.startOffset-=m.getLength(),m=a.getNext());m.equals(h.getParent())&&c[f]++;m.equals(a.getParent())&&c[f]++;c[d?"endContainer":"startContainer"]=m;return c;}CKEDITOR.dom.rangeList=function(a){if(a instanceof CKEDITOR.dom.rangeList)return a;a?a instanceof CKEDITOR.dom.range&&(a=[a]):a=[];return CKEDITOR.tools.extend(a,e);};var e={createIterator:function createIterator(){var a=this,c=CKEDITOR.dom.walker.bookmark(),d=[],e;return{getNextRange:function getNextRange(m){e=void 0===e?0:e+1;var f=a[e];if(f&&1<a.length){if(!e)for(var h=a.length-1;0<=h;h--){d.unshift(a[h].createBookmark(!0));}if(m)for(var k=0;a[e+k+1];){var g=f.document;m=0;h=g.getById(d[k].endNode);for(g=g.getById(d[k+1].startNode);;){h=h.getNextSourceNode(!1);if(g.equals(h))m=1;else if(c(h)||h.type==CKEDITOR.NODE_ELEMENT&&h.isBlockBoundary())continue;break;}if(!m)break;k++;}for(f.moveToBookmark(d.shift());k--;){h=a[++e],h.moveToBookmark(d.shift()),f.setEnd(h.endContainer,h.endOffset);}}return f;}};},createBookmarks:function createBookmarks(b){for(var c=[],d,e=0;e<this.length;e++){c.push(d=this[e].createBookmark(b,!0));for(var m=e+1;m<this.length;m++){this[m]=a(d,this[m]),this[m]=a(d,this[m],!0);}}return c;},createBookmarks2:function createBookmarks2(a){for(var c=[],d=0;d<this.length;d++){c.push(this[d].createBookmark2(a));}return c;},moveToBookmarks:function moveToBookmarks(a){for(var c=0;c<this.length;c++){this[c].moveToBookmark(a[c]);}}};}(),function(){function a(){return CKEDITOR.getUrl(CKEDITOR.skinName.split(",")[1]||"skins/"+CKEDITOR.skinName.split(",")[0]+"/");}function e(b){var c=CKEDITOR.skin["ua_"+b],d=CKEDITOR.env;if(c)for(var c=c.split(",").sort(function(a,b){return a>b?-1:1;}),f=0,e;f<c.length;f++){if(e=c[f],d.ie&&(e.replace(/^ie/,"")==d.version||d.quirks&&"iequirks"==e)&&(e="ie"),d[e]){b+="_"+c[f];break;}}return CKEDITOR.getUrl(a()+b+".css");}function b(a,b){l[a]||(CKEDITOR.document.appendStyleSheet(e(a)),l[a]=1);b&&b();}function c(a){var b=a.getById(m);b||(b=a.getHead().append("style"),b.setAttribute("id",m),b.setAttribute("type","text/css"));return b;}function d(a,b,c){var d,f,e;if(CKEDITOR.env.webkit)for(b=b.split("}").slice(0,-1),f=0;f<b.length;f++){b[f]=b[f].split("{");}for(var h=0;h<a.length;h++){if(CKEDITOR.env.webkit)for(f=0;f<b.length;f++){e=b[f][1];for(d=0;d<c.length;d++){e=e.replace(c[d][0],c[d][1]);}a[h].$.sheet.addRule(b[f][0],e);}else{e=b;for(d=0;d<c.length;d++){e=e.replace(c[d][0],c[d][1]);}CKEDITOR.env.ie&&11>CKEDITOR.env.version?a[h].$.styleSheet.cssText+=e:a[h].$.innerHTML+=e;}}}var l={};CKEDITOR.skin={path:a,loadPart:function loadPart(c,d){CKEDITOR.skin.name!=CKEDITOR.skinName.split(",")[0]?CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(a()+"skin.js"),function(){b(c,d);}):b(c,d);},getPath:function getPath(a){return CKEDITOR.getUrl(e(a));},icons:{},addIcon:function addIcon(a,b,c,d){a=a.toLowerCase();this.icons[a]||(this.icons[a]={path:b,offset:c||0,bgsize:d||"16px"});},getIconStyle:function getIconStyle(a,b,c,d,f){var e;a&&(a=a.toLowerCase(),b&&(e=this.icons[a+"-rtl"]),e||(e=this.icons[a]));a=c||e&&e.path||"";d=d||e&&e.offset;f=f||e&&e.bgsize||"16px";a&&(a=a.replace(/'/g,"\\'"));return a&&"background-image:url('"+CKEDITOR.getUrl(a)+"');background-position:0 "+d+"px;background-size:"+f+";";}};CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{getUiColor:function getUiColor(){return this.uiColor;},setUiColor:function setUiColor(a){var b=c(CKEDITOR.document);return(this.setUiColor=function(a){this.uiColor=a;var c=CKEDITOR.skin.chameleon,e="",k="";"function"==typeof c&&(e=c(this,"editor"),k=c(this,"panel"));a=[[h,a]];d([b],e,a);d(f,k,a);}).call(this,a);}});var m="cke_ui_color",f=[],h=/\$color/g;CKEDITOR.on("instanceLoaded",function(a){if(!CKEDITOR.env.ie||!CKEDITOR.env.quirks){var b=a.editor;a=function a(_a6){_a6=(_a6.data[0]||_a6.data).element.getElementsByTag("iframe").getItem(0).getFrameDocument();if(!_a6.getById("cke_ui_color")){_a6=c(_a6);f.push(_a6);var e=b.getUiColor();e&&d([_a6],CKEDITOR.skin.chameleon(b,"panel"),[[h,e]]);}};b.on("panelShow",a);b.on("menuShow",a);b.config.uiColor&&b.setUiColor(b.config.uiColor);}});}(),function(){if(CKEDITOR.env.webkit)CKEDITOR.env.hc=!1;else{var a=CKEDITOR.dom.element.createFromHtml('\x3cdiv style\x3d"width:0;height:0;position:absolute;left:-10000px;border:1px solid;border-color:red blue"\x3e\x3c/div\x3e',CKEDITOR.document);a.appendTo(CKEDITOR.document.getHead());try{var e=a.getComputedStyle("border-top-color"),b=a.getComputedStyle("border-right-color");CKEDITOR.env.hc=!(!e||e!=b);}catch(c){CKEDITOR.env.hc=!1;}a.remove();}CKEDITOR.env.hc&&(CKEDITOR.env.cssClass+=" cke_hc");CKEDITOR.document.appendStyleText(".cke{visibility:hidden;}");CKEDITOR.status="loaded";CKEDITOR.fireOnce("loaded");if(a=CKEDITOR._.pending)for(delete CKEDITOR._.pending,e=0;e<a.length;e++){CKEDITOR.editor.prototype.constructor.apply(a[e][0],a[e][1]),CKEDITOR.add(a[e][0]);}}(),CKEDITOR.skin.name="moono",CKEDITOR.skin.ua_editor="ie,iequirks,ie7,ie8,gecko",CKEDITOR.skin.ua_dialog="ie,iequirks,ie7,ie8",CKEDITOR.skin.chameleon=function(){var a=function(){return function(a,b){for(var e=a.match(/[^#]./g),m=0;3>m;m++){var f=m,h;h=parseInt(e[m],16);h=("0"+(0>b?0|h*(1+b):0|h+(255-h)*b).toString(16)).slice(-2);e[f]=h;}return"#"+e.join("");};}(),e=function(){var a=new CKEDITOR.template("background:#{to};background-image:linear-gradient(to bottom,{from},{to});filter:progid:DXImageTransform.Microsoft.gradient(gradientType\x3d0,startColorstr\x3d'{from}',endColorstr\x3d'{to}');");return function(b,e){return a.output({from:b,to:e});};}(),b={editor:new CKEDITOR.template("{id}.cke_chrome [border-color:{defaultBorder};] {id} .cke_top [ {defaultGradient}border-bottom-color:{defaultBorder};] {id} .cke_bottom [{defaultGradient}border-top-color:{defaultBorder};] {id} .cke_resizer [border-right-color:{ckeResizer}] {id} .cke_dialog_title [{defaultGradient}border-bottom-color:{defaultBorder};] {id} .cke_dialog_footer [{defaultGradient}outline-color:{defaultBorder};border-top-color:{defaultBorder};] {id} .cke_dialog_tab [{lightGradient}border-color:{defaultBorder};] {id} .cke_dialog_tab:hover [{mediumGradient}] {id} .cke_dialog_contents [border-top-color:{defaultBorder};] {id} .cke_dialog_tab_selected, {id} .cke_dialog_tab_selected:hover [background:{dialogTabSelected};border-bottom-color:{dialogTabSelectedBorder};] {id} .cke_dialog_body [background:{dialogBody};border-color:{defaultBorder};] {id} .cke_toolgroup [{lightGradient}border-color:{defaultBorder};] {id} a.cke_button_off:hover, {id} a.cke_button_off:focus, {id} a.cke_button_off:active [{mediumGradient}] {id} .cke_button_on [{ckeButtonOn}] {id} .cke_toolbar_separator [background-color: {ckeToolbarSeparator};] {id} .cke_combo_button [border-color:{defaultBorder};{lightGradient}] {id} a.cke_combo_button:hover, {id} a.cke_combo_button:focus, {id} .cke_combo_on a.cke_combo_button [border-color:{defaultBorder};{mediumGradient}] {id} .cke_path_item [color:{elementsPathColor};] {id} a.cke_path_item:hover, {id} a.cke_path_item:focus, {id} a.cke_path_item:active [background-color:{elementsPathBg};] {id}.cke_panel [border-color:{defaultBorder};] "),panel:new CKEDITOR.template(".cke_panel_grouptitle [{lightGradient}border-color:{defaultBorder};] .cke_menubutton_icon [background-color:{menubuttonIcon};] .cke_menubutton:hover .cke_menubutton_icon, .cke_menubutton:focus .cke_menubutton_icon, .cke_menubutton:active .cke_menubutton_icon [background-color:{menubuttonIconHover};] .cke_menuseparator [background-color:{menubuttonIcon};] a:hover.cke_colorbox, a:focus.cke_colorbox, a:active.cke_colorbox [border-color:{defaultBorder};] a:hover.cke_colorauto, a:hover.cke_colormore, a:focus.cke_colorauto, a:focus.cke_colormore, a:active.cke_colorauto, a:active.cke_colormore [background-color:{ckeColorauto};border-color:{defaultBorder};] ")};return function(c,d){var l=c.uiColor,l={id:"."+c.id,defaultBorder:a(l,-.1),defaultGradient:e(a(l,.9),l),lightGradient:e(a(l,1),a(l,.7)),mediumGradient:e(a(l,.8),a(l,.5)),ckeButtonOn:e(a(l,.6),a(l,.7)),ckeResizer:a(l,-.4),ckeToolbarSeparator:a(l,.5),ckeColorauto:a(l,.8),dialogBody:a(l,.7),dialogTabSelected:e("#FFFFFF","#FFFFFF"),dialogTabSelectedBorder:"#FFF",elementsPathColor:a(l,-.6),elementsPathBg:l,menubuttonIcon:a(l,.5),menubuttonIconHover:a(l,.3)};return b[d].output(l).replace(/\[/g,"{").replace(/\]/g,"}");};}(),CKEDITOR.plugins.add("dialogui",{onLoad:function onLoad(){var a=function a(_a7){this._||(this._={});this._["default"]=this._.initValue=_a7["default"]||"";this._.required=_a7.required||!1;for(var b=[this._],c=1;c<arguments.length;c++){b.push(arguments[c]);}b.push(!0);CKEDITOR.tools.extend.apply(CKEDITOR.tools,b);return this._;},e={build:function build(a,b,c){return new CKEDITOR.ui.dialog.textInput(a,b,c);}},b={build:function build(a,b,c){return new CKEDITOR.ui.dialog[b.type](a,b,c);}},c={isChanged:function isChanged(){return this.getValue()!=this.getInitValue();},reset:function reset(a){this.setValue(this.getInitValue(),a);},setInitValue:function setInitValue(){this._.initValue=this.getValue();},resetInitValue:function resetInitValue(){this._.initValue=this._["default"];},getInitValue:function getInitValue(){return this._.initValue;}},d=CKEDITOR.tools.extend({},CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,{onChange:function onChange(a,b){this._.domOnChangeRegistered||(a.on("load",function(){this.getInputElement().on("change",function(){a.parts.dialog.isVisible()&&this.fire("change",{value:this.getValue()});},this);},this),this._.domOnChangeRegistered=!0);this.on("change",b);}},!0),l=/^on([A-Z]\w+)/,m=function m(a){for(var b in a){(l.test(b)||"title"==b||"type"==b)&&delete a[b];}return a;},f=function f(a){a=a.data.getKeystroke();a==CKEDITOR.SHIFT+CKEDITOR.ALT+36?this.setDirectionMarker("ltr"):a==CKEDITOR.SHIFT+CKEDITOR.ALT+35&&this.setDirectionMarker("rtl");};CKEDITOR.tools.extend(CKEDITOR.ui.dialog,{labeledElement:function labeledElement(b,c,d,f){if(!(4>arguments.length)){var e=a.call(this,c);e.labelId=CKEDITOR.tools.getNextId()+"_label";this._.children=[];var l={role:c.role||"presentation"};c.includeLabel&&(l["aria-labelledby"]=e.labelId);CKEDITOR.ui.dialog.uiElement.call(this,b,c,d,"div",null,l,function(){var a=[],d=c.required?" cke_required":"";"horizontal"!=c.labelLayout?a.push('\x3clabel class\x3d"cke_dialog_ui_labeled_label'+d+'" ',' id\x3d"'+e.labelId+'"',e.inputId?' for\x3d"'+e.inputId+'"':"",(c.labelStyle?' style\x3d"'+c.labelStyle+'"':"")+"\x3e",c.label,"\x3c/label\x3e",'\x3cdiv class\x3d"cke_dialog_ui_labeled_content"',c.controlStyle?' style\x3d"'+c.controlStyle+'"':"",' role\x3d"presentation"\x3e',f.call(this,b,c),"\x3c/div\x3e"):(d={type:"hbox",widths:c.widths,padding:0,children:[{type:"html",html:'\x3clabel class\x3d"cke_dialog_ui_labeled_label'+d+'" id\x3d"'+e.labelId+'" for\x3d"'+e.inputId+'"'+(c.labelStyle?' style\x3d"'+c.labelStyle+'"':"")+"\x3e"+CKEDITOR.tools.htmlEncode(c.label)+"\x3c/label\x3e"},{type:"html",html:'\x3cspan class\x3d"cke_dialog_ui_labeled_content"'+(c.controlStyle?' style\x3d"'+c.controlStyle+'"':"")+"\x3e"+f.call(this,b,c)+"\x3c/span\x3e"}]},CKEDITOR.dialog._.uiElementBuilders.hbox.build(b,d,a));return a.join("");});}},textInput:function textInput(b,c,d){if(!(3>arguments.length)){a.call(this,c);var e=this._.inputId=CKEDITOR.tools.getNextId()+"_textInput",l={"class":"cke_dialog_ui_input_"+c.type,id:e,type:c.type};c.validate&&(this.validate=c.validate);c.maxLength&&(l.maxlength=c.maxLength);c.size&&(l.size=c.size);c.inputStyle&&(l.style=c.inputStyle);var m=this,q=!1;b.on("load",function(){m.getInputElement().on("keydown",function(a){13==a.data.getKeystroke()&&(q=!0);});m.getInputElement().on("keyup",function(a){13==a.data.getKeystroke()&&q&&(b.getButton("ok")&&setTimeout(function(){b.getButton("ok").click();},0),q=!1);m.bidi&&f.call(m,a);},null,null,1E3);});CKEDITOR.ui.dialog.labeledElement.call(this,b,c,d,function(){var a=['\x3cdiv class\x3d"cke_dialog_ui_input_',c.type,'" role\x3d"presentation"'];c.width&&a.push('style\x3d"width:'+c.width+'" ');a.push("\x3e\x3cinput ");l["aria-labelledby"]=this._.labelId;this._.required&&(l["aria-required"]=this._.required);for(var b in l){a.push(b+'\x3d"'+l[b]+'" ');}a.push(" /\x3e\x3c/div\x3e");return a.join("");});}},textarea:function textarea(b,c,d){if(!(3>arguments.length)){a.call(this,c);var e=this,l=this._.inputId=CKEDITOR.tools.getNextId()+"_textarea",m={};c.validate&&(this.validate=c.validate);m.rows=c.rows||5;m.cols=c.cols||20;m["class"]="cke_dialog_ui_input_textarea "+(c["class"]||"");"undefined"!=typeof c.inputStyle&&(m.style=c.inputStyle);c.dir&&(m.dir=c.dir);if(e.bidi)b.on("load",function(){e.getInputElement().on("keyup",f);},e);CKEDITOR.ui.dialog.labeledElement.call(this,b,c,d,function(){m["aria-labelledby"]=this._.labelId;this._.required&&(m["aria-required"]=this._.required);var a=['\x3cdiv class\x3d"cke_dialog_ui_input_textarea" role\x3d"presentation"\x3e\x3ctextarea id\x3d"',l,'" '],b;for(b in m){a.push(b+'\x3d"'+CKEDITOR.tools.htmlEncode(m[b])+'" ');}a.push("\x3e",CKEDITOR.tools.htmlEncode(e._["default"]),"\x3c/textarea\x3e\x3c/div\x3e");return a.join("");});}},checkbox:function checkbox(b,c,d){if(!(3>arguments.length)){var f=a.call(this,c,{"default":!!c["default"]});c.validate&&(this.validate=c.validate);CKEDITOR.ui.dialog.uiElement.call(this,b,c,d,"span",null,null,function(){var a=CKEDITOR.tools.extend({},c,{id:c.id?c.id+"_checkbox":CKEDITOR.tools.getNextId()+"_checkbox"},!0),d=[],e=CKEDITOR.tools.getNextId()+"_label",g={"class":"cke_dialog_ui_checkbox_input",type:"checkbox","aria-labelledby":e};m(a);c["default"]&&(g.checked="checked");"undefined"!=typeof a.inputStyle&&(a.style=a.inputStyle);f.checkbox=new CKEDITOR.ui.dialog.uiElement(b,a,d,"input",null,g);d.push(' \x3clabel id\x3d"',e,'" for\x3d"',g.id,'"'+(c.labelStyle?' style\x3d"'+c.labelStyle+'"':"")+"\x3e",CKEDITOR.tools.htmlEncode(c.label),"\x3c/label\x3e");return d.join("");});}},radio:function radio(b,c,d){if(!(3>arguments.length)){a.call(this,c);this._["default"]||(this._["default"]=this._.initValue=c.items[0][1]);c.validate&&(this.validate=c.validate);var f=[],e=this;c.role="radiogroup";c.includeLabel=!0;CKEDITOR.ui.dialog.labeledElement.call(this,b,c,d,function(){for(var a=[],d=[],g=(c.id?c.id:CKEDITOR.tools.getNextId())+"_radio",l=0;l<c.items.length;l++){var w=c.items[l],z=void 0!==w[2]?w[2]:w[0],A=void 0!==w[1]?w[1]:w[0],u=CKEDITOR.tools.getNextId()+"_radio_input",x=u+"_label",u=CKEDITOR.tools.extend({},c,{id:u,title:null,type:null},!0),z=CKEDITOR.tools.extend({},u,{title:z},!0),D={type:"radio","class":"cke_dialog_ui_radio_input",name:g,value:A,"aria-labelledby":x},y=[];e._["default"]==A&&(D.checked="checked");m(u);m(z);"undefined"!=typeof u.inputStyle&&(u.style=u.inputStyle);u.keyboardFocusable=!0;f.push(new CKEDITOR.ui.dialog.uiElement(b,u,y,"input",null,D));y.push(" ");new CKEDITOR.ui.dialog.uiElement(b,z,y,"label",null,{id:x,"for":D.id},w[0]);a.push(y.join(""));}new CKEDITOR.ui.dialog.hbox(b,f,a,d);return d.join("");});this._.children=f;}},button:function button(b,c,d){if(arguments.length){"function"==typeof c&&(c=c(b.getParentEditor()));a.call(this,c,{disabled:c.disabled||!1});CKEDITOR.event.implementOn(this);var f=this;b.on("load",function(){var a=this.getElement();(function(){a.on("click",function(a){f.click();a.data.preventDefault();});a.on("keydown",function(a){a.data.getKeystroke()in{32:1}&&(f.click(),a.data.preventDefault());});})();a.unselectable();},this);var e=CKEDITOR.tools.extend({},c);delete e.style;var l=CKEDITOR.tools.getNextId()+"_label";CKEDITOR.ui.dialog.uiElement.call(this,b,e,d,"a",null,{style:c.style,href:"javascript:void(0)",title:c.label,hidefocus:"true","class":c["class"],role:"button","aria-labelledby":l},'\x3cspan id\x3d"'+l+'" class\x3d"cke_dialog_ui_button"\x3e'+CKEDITOR.tools.htmlEncode(c.label)+"\x3c/span\x3e");}},select:function select(b,c,d){if(!(3>arguments.length)){var f=a.call(this,c);c.validate&&(this.validate=c.validate);f.inputId=CKEDITOR.tools.getNextId()+"_select";CKEDITOR.ui.dialog.labeledElement.call(this,b,c,d,function(){var a=CKEDITOR.tools.extend({},c,{id:c.id?c.id+"_select":CKEDITOR.tools.getNextId()+"_select"},!0),d=[],e=[],g={id:f.inputId,"class":"cke_dialog_ui_input_select","aria-labelledby":this._.labelId};d.push('\x3cdiv class\x3d"cke_dialog_ui_input_',c.type,'" role\x3d"presentation"');c.width&&d.push('style\x3d"width:'+c.width+'" ');d.push("\x3e");void 0!==c.size&&(g.size=c.size);void 0!==c.multiple&&(g.multiple=c.multiple);m(a);for(var l=0,w;l<c.items.length&&(w=c.items[l]);l++){e.push('\x3coption value\x3d"',CKEDITOR.tools.htmlEncode(void 0!==w[1]?w[1]:w[0]).replace(/"/g,"\x26quot;"),'" /\x3e ',CKEDITOR.tools.htmlEncode(w[0]));}"undefined"!=typeof a.inputStyle&&(a.style=a.inputStyle);f.select=new CKEDITOR.ui.dialog.uiElement(b,a,d,"select",null,g,e.join(""));d.push("\x3c/div\x3e");return d.join("");});}},file:function file(b,c,d){if(!(3>arguments.length)){void 0===c["default"]&&(c["default"]="");var f=CKEDITOR.tools.extend(a.call(this,c),{definition:c,buttons:[]});c.validate&&(this.validate=c.validate);b.on("load",function(){CKEDITOR.document.getById(f.frameId).getParent().addClass("cke_dialog_ui_input_file");});CKEDITOR.ui.dialog.labeledElement.call(this,b,c,d,function(){f.frameId=CKEDITOR.tools.getNextId()+"_fileInput";var a=['\x3ciframe frameborder\x3d"0" allowtransparency\x3d"0" class\x3d"cke_dialog_ui_input_file" role\x3d"presentation" id\x3d"',f.frameId,'" title\x3d"',c.label,'" src\x3d"javascript:void('];a.push(CKEDITOR.env.ie?"(function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.close();")+"})()":"0");a.push(')"\x3e\x3c/iframe\x3e');return a.join("");});}},fileButton:function fileButton(b,c,d){var f=this;if(!(3>arguments.length)){a.call(this,c);c.validate&&(this.validate=c.validate);var e=CKEDITOR.tools.extend({},c),l=e.onClick;e.className=(e.className?e.className+" ":"")+"cke_dialog_ui_button";e.onClick=function(a){var d=c["for"];l&&!1===l.call(this,a)||(b.getContentElement(d[0],d[1]).submit(),this.disable());};b.on("load",function(){b.getContentElement(c["for"][0],c["for"][1])._.buttons.push(f);});CKEDITOR.ui.dialog.button.call(this,b,e,d);}},html:function(){var a=/^\s*<[\w:]+\s+([^>]*)?>/,b=/^(\s*<[\w:]+(?:\s+[^>]*)?)((?:.|\r|\n)+)$/,c=/\/$/;return function(d,f,e){if(!(3>arguments.length)){var l=[],m=f.html;"\x3c"!=m.charAt(0)&&(m="\x3cspan\x3e"+m+"\x3c/span\x3e");var p=f.focus;if(p){var w=this.focus;this.focus=function(){("function"==typeof p?p:w).call(this);this.fire("focus");};f.isFocusable&&(this.isFocusable=this.isFocusable);this.keyboardFocusable=!0;}CKEDITOR.ui.dialog.uiElement.call(this,d,f,l,"span",null,null,"");l=l.join("").match(a);m=m.match(b)||["","",""];c.test(m[1])&&(m[1]=m[1].slice(0,-1),m[2]="/"+m[2]);e.push([m[1]," ",l[1]||"",m[2]].join(""));}};}(),fieldset:function fieldset(a,b,c,d,f){var e=f.label;this._={children:b};CKEDITOR.ui.dialog.uiElement.call(this,a,f,d,"fieldset",null,null,function(){var a=[];e&&a.push("\x3clegend"+(f.labelStyle?' style\x3d"'+f.labelStyle+'"':"")+"\x3e"+e+"\x3c/legend\x3e");for(var b=0;b<c.length;b++){a.push(c[b]);}return a.join("");});}},!0);CKEDITOR.ui.dialog.html.prototype=new CKEDITOR.ui.dialog.uiElement();CKEDITOR.ui.dialog.labeledElement.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement(),{setLabel:function setLabel(a){var b=CKEDITOR.document.getById(this._.labelId);1>b.getChildCount()?new CKEDITOR.dom.text(a,CKEDITOR.document).appendTo(b):b.getChild(0).$.nodeValue=a;return this;},getLabel:function getLabel(){var a=CKEDITOR.document.getById(this._.labelId);return!a||1>a.getChildCount()?"":a.getChild(0).getText();},eventProcessors:d},!0);CKEDITOR.ui.dialog.button.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement(),{click:function click(){return this._.disabled?!1:this.fire("click",{dialog:this._.dialog});},enable:function enable(){this._.disabled=!1;var a=this.getElement();a&&a.removeClass("cke_disabled");},disable:function disable(){this._.disabled=!0;this.getElement().addClass("cke_disabled");},isVisible:function isVisible(){return this.getElement().getFirst().isVisible();},isEnabled:function isEnabled(){return!this._.disabled;},eventProcessors:CKEDITOR.tools.extend({},CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,{onClick:function onClick(a,b){this.on("click",function(){b.apply(this,arguments);});}},!0),accessKeyUp:function accessKeyUp(){this.click();},accessKeyDown:function accessKeyDown(){this.focus();},keyboardFocusable:!0},!0);CKEDITOR.ui.dialog.textInput.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement(),{getInputElement:function getInputElement(){return CKEDITOR.document.getById(this._.inputId);},focus:function focus(){var a=this.selectParentTab();setTimeout(function(){var b=a.getInputElement();b&&b.$.focus();},0);},select:function select(){var a=this.selectParentTab();setTimeout(function(){var b=a.getInputElement();b&&(b.$.focus(),b.$.select());},0);},accessKeyUp:function accessKeyUp(){this.select();},setValue:function setValue(a){if(this.bidi){var b=a&&a.charAt(0);(b="‪"==b?"ltr":"‫"==b?"rtl":null)&&(a=a.slice(1));this.setDirectionMarker(b);}a||(a="");return CKEDITOR.ui.dialog.uiElement.prototype.setValue.apply(this,arguments);},getValue:function getValue(){var a=CKEDITOR.ui.dialog.uiElement.prototype.getValue.call(this);if(this.bidi&&a){var b=this.getDirectionMarker();b&&(a=("ltr"==b?"‪":"‫")+a);}return a;},setDirectionMarker:function setDirectionMarker(a){var b=this.getInputElement();a?b.setAttributes({dir:a,"data-cke-dir-marker":a}):this.getDirectionMarker()&&b.removeAttributes(["dir","data-cke-dir-marker"]);},getDirectionMarker:function getDirectionMarker(){return this.getInputElement().data("cke-dir-marker");},keyboardFocusable:!0},c,!0);CKEDITOR.ui.dialog.textarea.prototype=new CKEDITOR.ui.dialog.textInput();CKEDITOR.ui.dialog.select.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement(),{getInputElement:function getInputElement(){return this._.select.getElement();},add:function add(a,b,c){var d=new CKEDITOR.dom.element("option",this.getDialog().getParentEditor().document),f=this.getInputElement().$;d.$.text=a;d.$.value=void 0===b||null===b?a:b;void 0===c||null===c?CKEDITOR.env.ie?f.add(d.$):f.add(d.$,null):f.add(d.$,c);return this;},remove:function remove(a){this.getInputElement().$.remove(a);return this;},clear:function clear(){for(var a=this.getInputElement().$;0<a.length;){a.remove(0);}return this;},keyboardFocusable:!0},c,!0);CKEDITOR.ui.dialog.checkbox.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement(),{getInputElement:function getInputElement(){return this._.checkbox.getElement();},setValue:function setValue(a,b){this.getInputElement().$.checked=a;!b&&this.fire("change",{value:a});},getValue:function getValue(){return this.getInputElement().$.checked;},accessKeyUp:function accessKeyUp(){this.setValue(!this.getValue());},eventProcessors:{onChange:function onChange(a,b){if(!CKEDITOR.env.ie||8<CKEDITOR.env.version)return d.onChange.apply(this,arguments);a.on("load",function(){var a=this._.checkbox.getElement();a.on("propertychange",function(b){b=b.data.$;"checked"==b.propertyName&&this.fire("change",{value:a.$.checked});},this);},this);this.on("change",b);return null;}},keyboardFocusable:!0},c,!0);CKEDITOR.ui.dialog.radio.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement(),{setValue:function setValue(a,b){for(var c=this._.children,d,f=0;f<c.length&&(d=c[f]);f++){d.getElement().$.checked=d.getValue()==a;}!b&&this.fire("change",{value:a});},getValue:function getValue(){for(var a=this._.children,b=0;b<a.length;b++){if(a[b].getElement().$.checked)return a[b].getValue();}return null;},accessKeyUp:function accessKeyUp(){var a=this._.children,b;for(b=0;b<a.length;b++){if(a[b].getElement().$.checked){a[b].getElement().focus();return;}}a[0].getElement().focus();},eventProcessors:{onChange:function onChange(a,b){if(!CKEDITOR.env.ie||8<CKEDITOR.env.version)return d.onChange.apply(this,arguments);a.on("load",function(){for(var a=this._.children,b=this,c=0;c<a.length;c++){a[c].getElement().on("propertychange",function(a){a=a.data.$;"checked"==a.propertyName&&this.$.checked&&b.fire("change",{value:this.getAttribute("value")});});}},this);this.on("change",b);return null;}}},c,!0);CKEDITOR.ui.dialog.file.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement(),c,{getInputElement:function getInputElement(){var a=CKEDITOR.document.getById(this._.frameId).getFrameDocument();return 0<a.$.forms.length?new CKEDITOR.dom.element(a.$.forms[0].elements[0]):this.getElement();},submit:function submit(){this.getInputElement().getParent().$.submit();return this;},getAction:function getAction(){return this.getInputElement().getParent().$.action;},registerEvents:function registerEvents(a){var b=/^on([A-Z]\w+)/,c,d=function d(a,b,c,_d){a.on("formLoaded",function(){a.getInputElement().on(c,_d,a);});},f;for(f in a){if(c=f.match(b))this.eventProcessors[f]?this.eventProcessors[f].call(this,this._.dialog,a[f]):d(this,this._.dialog,c[1].toLowerCase(),a[f]);}return this;},reset:function reset(){function a(){c.$.open();var h="";d.size&&(h=d.size-(CKEDITOR.env.ie?7:0));var z=b.frameId+"_input";c.$.write(['\x3chtml dir\x3d"'+m+'" lang\x3d"'+p+'"\x3e\x3chead\x3e\x3ctitle\x3e\x3c/title\x3e\x3c/head\x3e\x3cbody style\x3d"margin: 0; overflow: hidden; background: transparent;"\x3e','\x3cform enctype\x3d"multipart/form-data" method\x3d"POST" dir\x3d"'+m+'" lang\x3d"'+p+'" action\x3d"',CKEDITOR.tools.htmlEncode(d.action),'"\x3e\x3clabel id\x3d"',b.labelId,'" for\x3d"',z,'" style\x3d"display:none"\x3e',CKEDITOR.tools.htmlEncode(d.label),'\x3c/label\x3e\x3cinput style\x3d"width:100%" id\x3d"',z,'" aria-labelledby\x3d"',b.labelId,'" type\x3d"file" name\x3d"',CKEDITOR.tools.htmlEncode(d.id||"cke_upload"),'" size\x3d"',CKEDITOR.tools.htmlEncode(0<h?h:""),'" /\x3e\x3c/form\x3e\x3c/body\x3e\x3c/html\x3e\x3cscript\x3e',CKEDITOR.env.ie?"("+CKEDITOR.tools.fixDomain+")();":"","window.parent.CKEDITOR.tools.callFunction("+e+");","window.onbeforeunload \x3d function() {window.parent.CKEDITOR.tools.callFunction("+l+")}","\x3c/script\x3e"].join(""));c.$.close();for(h=0;h<f.length;h++){f[h].enable();}}var b=this._,c=CKEDITOR.document.getById(b.frameId).getFrameDocument(),d=b.definition,f=b.buttons,e=this.formLoadedNumber,l=this.formUnloadNumber,m=b.dialog._.editor.lang.dir,p=b.dialog._.editor.langCode;e||(e=this.formLoadedNumber=CKEDITOR.tools.addFunction(function(){this.fire("formLoaded");},this),l=this.formUnloadNumber=CKEDITOR.tools.addFunction(function(){this.getInputElement().clearCustomData();},this),this.getDialog()._.editor.on("destroy",function(){CKEDITOR.tools.removeFunction(e);CKEDITOR.tools.removeFunction(l);}));CKEDITOR.env.gecko?setTimeout(a,500):a();},getValue:function getValue(){return this.getInputElement().$.value||"";},setInitValue:function setInitValue(){this._.initValue="";},eventProcessors:{onChange:function onChange(a,b){this._.domOnChangeRegistered||(this.on("formLoaded",function(){this.getInputElement().on("change",function(){this.fire("change",{value:this.getValue()});},this);},this),this._.domOnChangeRegistered=!0);this.on("change",b);}},keyboardFocusable:!0},!0);CKEDITOR.ui.dialog.fileButton.prototype=new CKEDITOR.ui.dialog.button();CKEDITOR.ui.dialog.fieldset.prototype=CKEDITOR.tools.clone(CKEDITOR.ui.dialog.hbox.prototype);CKEDITOR.dialog.addUIElement("text",e);CKEDITOR.dialog.addUIElement("password",e);CKEDITOR.dialog.addUIElement("textarea",b);CKEDITOR.dialog.addUIElement("checkbox",b);CKEDITOR.dialog.addUIElement("radio",b);CKEDITOR.dialog.addUIElement("button",b);CKEDITOR.dialog.addUIElement("select",b);CKEDITOR.dialog.addUIElement("file",b);CKEDITOR.dialog.addUIElement("fileButton",b);CKEDITOR.dialog.addUIElement("html",b);CKEDITOR.dialog.addUIElement("fieldset",{build:function build(a,b,c){for(var d=b.children,f,e=[],l=[],m=0;m<d.length&&(f=d[m]);m++){var p=[];e.push(p);l.push(CKEDITOR.dialog._.uiElementBuilders[f.type].build(a,f,p));}return new CKEDITOR.ui.dialog[b.type](a,l,e,c,b);}});}}),CKEDITOR.DIALOG_RESIZE_NONE=0,CKEDITOR.DIALOG_RESIZE_WIDTH=1,CKEDITOR.DIALOG_RESIZE_HEIGHT=2,CKEDITOR.DIALOG_RESIZE_BOTH=3,CKEDITOR.DIALOG_STATE_IDLE=1,CKEDITOR.DIALOG_STATE_BUSY=2,function(){function a(){for(var a=this._.tabIdList.length,b=CKEDITOR.tools.indexOf(this._.tabIdList,this._.currentTabId)+a,c=b-1;c>b-a;c--){if(this._.tabs[this._.tabIdList[c%a]][0].$.offsetHeight)return this._.tabIdList[c%a];}return null;}function e(){for(var a=this._.tabIdList.length,b=CKEDITOR.tools.indexOf(this._.tabIdList,this._.currentTabId),c=b+1;c<b+a;c++){if(this._.tabs[this._.tabIdList[c%a]][0].$.offsetHeight)return this._.tabIdList[c%a];}return null;}function b(a,b){for(var c=a.$.getElementsByTagName("input"),d=0,f=c.length;d<f;d++){var e=new CKEDITOR.dom.element(c[d]);"text"==e.getAttribute("type").toLowerCase()&&(b?(e.setAttribute("value",e.getCustomData("fake_value")||""),e.removeCustomData("fake_value")):(e.setCustomData("fake_value",e.getAttribute("value")),e.setAttribute("value","")));}}function c(a,b){var c=this.getInputElement();c&&(a?c.removeAttribute("aria-invalid"):c.setAttribute("aria-invalid",!0));a||(this.select?this.select():this.focus());b&&alert(b);this.fire("validated",{valid:a,msg:b});}function d(){var a=this.getInputElement();a&&a.removeAttribute("aria-invalid");}function l(a){var b=CKEDITOR.dom.element.createFromHtml(CKEDITOR.addTemplate("dialog",t).output({id:CKEDITOR.tools.getNextNumber(),editorId:a.id,langDir:a.lang.dir,langCode:a.langCode,editorDialogClass:"cke_editor_"+a.name.replace(/\./g,"\\.")+"_dialog",closeTitle:a.lang.common.close,hidpi:CKEDITOR.env.hidpi?"cke_hidpi":""})),c=b.getChild([0,0,0,0,0]),d=c.getChild(0),f=c.getChild(1);a.plugins.clipboard&&CKEDITOR.plugins.clipboard.preventDefaultDropOnElement(c);!CKEDITOR.env.ie||CKEDITOR.env.quirks||CKEDITOR.env.edge||(a="javascript:void(function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.close();")+"}())",CKEDITOR.dom.element.createFromHtml('\x3ciframe frameBorder\x3d"0" class\x3d"cke_iframe_shim" src\x3d"'+a+'" tabIndex\x3d"-1"\x3e\x3c/iframe\x3e').appendTo(c.getParent()));d.unselectable();f.unselectable();return{element:b,parts:{dialog:b.getChild(0),title:d,close:f,tabs:c.getChild(2),contents:c.getChild([3,0,0,0]),footer:c.getChild([3,0,1,0])}};}function m(a,b,c){this.element=b;this.focusIndex=c;this.tabIndex=0;this.isFocusable=function(){return!b.getAttribute("disabled")&&b.isVisible();};this.focus=function(){a._.currentFocusIndex=this.focusIndex;this.element.focus();};b.on("keydown",function(a){a.data.getKeystroke()in{32:1,13:1}&&this.fire("click");});b.on("focus",function(){this.fire("mouseover");});b.on("blur",function(){this.fire("mouseout");});}function f(a){function b(){a.layout();}var c=CKEDITOR.document.getWindow();c.on("resize",b);a.on("hide",function(){c.removeListener("resize",b);});}function h(a,b){this._={dialog:a};CKEDITOR.tools.extend(this,b);}function k(a){function b(c){var k=a.getSize(),l=CKEDITOR.document.getWindow().getViewPaneSize(),m=c.data.$.screenX,n=c.data.$.screenY,w=m-d.x,p=n-d.y;d={x:m,y:n};f.x+=w;f.y+=p;a.move(f.x+h[3]<g?-h[3]:f.x-h[1]>l.width-k.width-g?l.width-k.width+("rtl"==e.lang.dir?0:h[1]):f.x,f.y+h[0]<g?-h[0]:f.y-h[2]>l.height-k.height-g?l.height-k.height+h[2]:f.y,1);c.data.preventDefault();}function c(){CKEDITOR.document.removeListener("mousemove",b);CKEDITOR.document.removeListener("mouseup",c);if(CKEDITOR.env.ie6Compat){var a=y.getChild(0).getFrameDocument();a.removeListener("mousemove",b);a.removeListener("mouseup",c);}}var d=null,f=null,e=a.getParentEditor(),g=e.config.dialog_magnetDistance,h=CKEDITOR.skin.margins||[0,0,0,0];"undefined"==typeof g&&(g=20);a.parts.title.on("mousedown",function(e){d={x:e.data.$.screenX,y:e.data.$.screenY};CKEDITOR.document.on("mousemove",b);CKEDITOR.document.on("mouseup",c);f=a.getPosition();if(CKEDITOR.env.ie6Compat){var g=y.getChild(0).getFrameDocument();g.on("mousemove",b);g.on("mouseup",c);}e.data.preventDefault();},a);}function g(a){function b(c){var n="rtl"==e.lang.dir,w=m.width,p=m.height,q=w+(c.data.$.screenX-l.x)*(n?-1:1)*(a._.moved?1:2),z=p+(c.data.$.screenY-l.y)*(a._.moved?1:2),u=a._.element.getFirst(),u=n&&u.getComputedStyle("right"),t=a.getPosition();t.y+z>k.height&&(z=k.height-t.y);(n?u:t.x)+q>k.width&&(q=k.width-(n?u:t.x));if(f==CKEDITOR.DIALOG_RESIZE_WIDTH||f==CKEDITOR.DIALOG_RESIZE_BOTH)w=Math.max(d.minWidth||0,q-g);if(f==CKEDITOR.DIALOG_RESIZE_HEIGHT||f==CKEDITOR.DIALOG_RESIZE_BOTH)p=Math.max(d.minHeight||0,z-h);a.resize(w,p);a._.moved||a.layout();c.data.preventDefault();}function c(){CKEDITOR.document.removeListener("mouseup",c);CKEDITOR.document.removeListener("mousemove",b);n&&(n.remove(),n=null);if(CKEDITOR.env.ie6Compat){var a=y.getChild(0).getFrameDocument();a.removeListener("mouseup",c);a.removeListener("mousemove",b);}}var d=a.definition,f=d.resizable;if(f!=CKEDITOR.DIALOG_RESIZE_NONE){var e=a.getParentEditor(),g,h,k,l,m,n,w=CKEDITOR.tools.addFunction(function(d){m=a.getSize();var f=a.parts.contents;f.$.getElementsByTagName("iframe").length&&(n=CKEDITOR.dom.element.createFromHtml('\x3cdiv class\x3d"cke_dialog_resize_cover" style\x3d"height: 100%; position: absolute; width: 100%;"\x3e\x3c/div\x3e'),f.append(n));h=m.height-a.parts.contents.getSize("height",!(CKEDITOR.env.gecko||CKEDITOR.env.ie&&CKEDITOR.env.quirks));g=m.width-a.parts.contents.getSize("width",1);l={x:d.screenX,y:d.screenY};k=CKEDITOR.document.getWindow().getViewPaneSize();CKEDITOR.document.on("mousemove",b);CKEDITOR.document.on("mouseup",c);CKEDITOR.env.ie6Compat&&(f=y.getChild(0).getFrameDocument(),f.on("mousemove",b),f.on("mouseup",c));d.preventDefault&&d.preventDefault();});a.on("load",function(){var b="";f==CKEDITOR.DIALOG_RESIZE_WIDTH?b=" cke_resizer_horizontal":f==CKEDITOR.DIALOG_RESIZE_HEIGHT&&(b=" cke_resizer_vertical");b=CKEDITOR.dom.element.createFromHtml('\x3cdiv class\x3d"cke_resizer'+b+" cke_resizer_"+e.lang.dir+'" title\x3d"'+CKEDITOR.tools.htmlEncode(e.lang.common.resize)+'" onmousedown\x3d"CKEDITOR.tools.callFunction('+w+', event )"\x3e'+("ltr"==e.lang.dir?"◢":"◣")+"\x3c/div\x3e");a.parts.footer.append(b,1);});e.on("destroy",function(){CKEDITOR.tools.removeFunction(w);});}}function n(a){a.data.preventDefault(1);}function v(a){var b=CKEDITOR.document.getWindow(),c=a.config,d=c.dialog_backgroundCoverColor||"white",f=c.dialog_backgroundCoverOpacity,e=c.baseFloatZIndex,c=CKEDITOR.tools.genKey(d,f,e),g=D[c];g?g.show():(e=['\x3cdiv tabIndex\x3d"-1" style\x3d"position: ',CKEDITOR.env.ie6Compat?"absolute":"fixed","; z-index: ",e,"; top: 0px; left: 0px; ",CKEDITOR.env.ie6Compat?"":"background-color: "+d,'" class\x3d"cke_dialog_background_cover"\x3e'],CKEDITOR.env.ie6Compat&&(d="\x3chtml\x3e\x3cbody style\x3d\\'background-color:"+d+";\\'\x3e\x3c/body\x3e\x3c/html\x3e",e.push('\x3ciframe hidefocus\x3d"true" frameborder\x3d"0" id\x3d"cke_dialog_background_iframe" src\x3d"javascript:'),e.push("void((function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.write( '"+d+"' );document.close();")+"})())"),e.push('" style\x3d"position:absolute;left:0;top:0;width:100%;height: 100%;filter: progid:DXImageTransform.Microsoft.Alpha(opacity\x3d0)"\x3e\x3c/iframe\x3e')),e.push("\x3c/div\x3e"),g=CKEDITOR.dom.element.createFromHtml(e.join("")),g.setOpacity(void 0!==f?f:.5),g.on("keydown",n),g.on("keypress",n),g.on("keyup",n),g.appendTo(CKEDITOR.document.getBody()),D[c]=g);a.focusManager.add(g);y=g;a=function a(){var a=b.getViewPaneSize();g.setStyles({width:a.width+"px",height:a.height+"px"});};var h=function h(){var a=b.getScrollPosition(),c=CKEDITOR.dialog._.currentTop;g.setStyles({left:a.x+"px",top:a.y+"px"});if(c){do{a=c.getPosition(),c.move(a.x,a.y);}while(c=c._.parentDialog);}};x=a;b.on("resize",a);a();CKEDITOR.env.mac&&CKEDITOR.env.webkit||g.focus();if(CKEDITOR.env.ie6Compat){var k=function k(){h();arguments.callee.prevScrollHandler.apply(this,arguments);};b.$.setTimeout(function(){k.prevScrollHandler=window.onscroll||function(){};window.onscroll=k;},0);h();}}function r(a){y&&(a.focusManager.remove(y),a=CKEDITOR.document.getWindow(),y.hide(),a.removeListener("resize",x),CKEDITOR.env.ie6Compat&&a.$.setTimeout(function(){window.onscroll=window.onscroll&&window.onscroll.prevScrollHandler||null;},0),x=null);}var q=CKEDITOR.tools.cssLength,t='\x3cdiv class\x3d"cke_reset_all {editorId} {editorDialogClass} {hidpi}" dir\x3d"{langDir}" lang\x3d"{langCode}" role\x3d"dialog" aria-labelledby\x3d"cke_dialog_title_{id}"\x3e\x3ctable class\x3d"cke_dialog '+CKEDITOR.env.cssClass+' cke_{langDir}" style\x3d"position:absolute" role\x3d"presentation"\x3e\x3ctr\x3e\x3ctd role\x3d"presentation"\x3e\x3cdiv class\x3d"cke_dialog_body" role\x3d"presentation"\x3e\x3cdiv id\x3d"cke_dialog_title_{id}" class\x3d"cke_dialog_title" role\x3d"presentation"\x3e\x3c/div\x3e\x3ca id\x3d"cke_dialog_close_button_{id}" class\x3d"cke_dialog_close_button" href\x3d"javascript:void(0)" title\x3d"{closeTitle}" role\x3d"button"\x3e\x3cspan class\x3d"cke_label"\x3eX\x3c/span\x3e\x3c/a\x3e\x3cdiv id\x3d"cke_dialog_tabs_{id}" class\x3d"cke_dialog_tabs" role\x3d"tablist"\x3e\x3c/div\x3e\x3ctable class\x3d"cke_dialog_contents" role\x3d"presentation"\x3e\x3ctr\x3e\x3ctd id\x3d"cke_dialog_contents_{id}" class\x3d"cke_dialog_contents_body" role\x3d"presentation"\x3e\x3c/td\x3e\x3c/tr\x3e\x3ctr\x3e\x3ctd id\x3d"cke_dialog_footer_{id}" class\x3d"cke_dialog_footer" role\x3d"presentation"\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3c/div\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3c/div\x3e';CKEDITOR.dialog=function(b,f){function h(){var a=y._.focusList;a.sort(function(a,b){return a.tabIndex!=b.tabIndex?b.tabIndex-a.tabIndex:a.focusIndex-b.focusIndex;});for(var b=a.length,c=0;c<b;c++){a[c].focusIndex=c;}}function m(a){var b=y._.focusList;a=a||0;if(!(1>b.length)){var c=y._.currentFocusIndex;y._.tabBarMode&&0>a&&(c=0);try{b[c].getInputElement().$.blur();}catch(d){}var f=c,e=1<y._.pageCount;do{f+=a;if(e&&!y._.tabBarMode&&(f==b.length||-1==f)){y._.tabBarMode=!0;y._.tabs[y._.currentTabId][0].focus();y._.currentFocusIndex=-1;return;}f=(f+b.length)%b.length;if(f==c)break;}while(a&&!b[f].isFocusable());b[f].focus();"text"==b[f].type&&b[f].select();}}function n(c){if(y==CKEDITOR.dialog._.currentTop){var d=c.data.getKeystroke(),f="rtl"==b.lang.dir,g=[37,38,39,40];x=v=0;if(9==d||d==CKEDITOR.SHIFT+9)m(d==CKEDITOR.SHIFT+9?-1:1),x=1;else if(d==CKEDITOR.ALT+121&&!y._.tabBarMode&&1<y.getPageCount())y._.tabBarMode=!0,y._.tabs[y._.currentTabId][0].focus(),y._.currentFocusIndex=-1,x=1;else if(-1!=CKEDITOR.tools.indexOf(g,d)&&y._.tabBarMode)d=-1!=CKEDITOR.tools.indexOf([f?39:37,38],d)?a.call(y):e.call(y),y.selectPage(d),y._.tabs[d][0].focus(),x=1;else if(13!=d&&32!=d||!y._.tabBarMode){if(13==d)d=c.data.getTarget(),d.is("a","button","select","textarea")||d.is("input")&&"button"==d.$.type||((d=this.getButton("ok"))&&CKEDITOR.tools.setTimeout(d.click,0,d),x=1),v=1;else if(27==d)(d=this.getButton("cancel"))?CKEDITOR.tools.setTimeout(d.click,0,d):!1!==this.fire("cancel",{hide:!0}).hide&&this.hide(),v=1;else return;}else this.selectPage(this._.currentTabId),this._.tabBarMode=!1,this._.currentFocusIndex=-1,m(1),x=1;w(c);}}function w(a){x?a.data.preventDefault(1):v&&a.data.stopPropagation();}var q=CKEDITOR.dialog._.dialogDefinitions[f],z=CKEDITOR.tools.clone(p),t=b.config.dialog_buttonsOrder||"OS",r=b.lang.dir,A={},x,v;("OS"==t&&CKEDITOR.env.mac||"rtl"==t&&"ltr"==r||"ltr"==t&&"rtl"==r)&&z.buttons.reverse();q=CKEDITOR.tools.extend(q(b),z);q=CKEDITOR.tools.clone(q);q=new u(this,q);z=l(b);this._={editor:b,element:z.element,name:f,contentSize:{width:0,height:0},size:{width:0,height:0},contents:{},buttons:{},accessKeyMap:{},tabs:{},tabIdList:[],currentTabId:null,currentTabIndex:null,pageCount:0,lastTab:null,tabBarMode:!1,focusList:[],currentFocusIndex:0,hasFocus:!1};this.parts=z.parts;CKEDITOR.tools.setTimeout(function(){b.fire("ariaWidget",this.parts.contents);},0,this);z={position:CKEDITOR.env.ie6Compat?"absolute":"fixed",top:0,visibility:"hidden"};z["rtl"==r?"right":"left"]=0;this.parts.dialog.setStyles(z);CKEDITOR.event.call(this);this.definition=q=CKEDITOR.fire("dialogDefinition",{name:f,definition:q},b).definition;if(!("removeDialogTabs"in b._)&&b.config.removeDialogTabs){z=b.config.removeDialogTabs.split(";");for(r=0;r<z.length;r++){if(t=z[r].split(":"),2==t.length){var D=t[0];A[D]||(A[D]=[]);A[D].push(t[1]);}}b._.removeDialogTabs=A;}if(b._.removeDialogTabs&&(A=b._.removeDialogTabs[f]))for(r=0;r<A.length;r++){q.removeContents(A[r]);}if(q.onLoad)this.on("load",q.onLoad);if(q.onShow)this.on("show",q.onShow);if(q.onHide)this.on("hide",q.onHide);if(q.onOk)this.on("ok",function(a){b.fire("saveSnapshot");setTimeout(function(){b.fire("saveSnapshot");},0);!1===q.onOk.call(this,a)&&(a.data.hide=!1);});this.state=CKEDITOR.DIALOG_STATE_IDLE;if(q.onCancel)this.on("cancel",function(a){!1===q.onCancel.call(this,a)&&(a.data.hide=!1);});var y=this,B=function B(a){var b=y._.contents,c=!1,d;for(d in b){for(var f in b[d]){if(c=a.call(this,b[d][f]))return;}}};this.on("ok",function(a){B(function(b){if(b.validate){var d=b.validate(this),f="string"==typeof d||!1===d;f&&(a.data.hide=!1,a.stop());c.call(b,!f,"string"==typeof d?d:void 0);return f;}});},this,null,0);this.on("cancel",function(a){B(function(c){if(c.isChanged())return b.config.dialog_noConfirmCancel||confirm(b.lang.common.confirmCancel)||(a.data.hide=!1),!0;});},this,null,0);this.parts.close.on("click",function(a){!1!==this.fire("cancel",{hide:!0}).hide&&this.hide();a.data.preventDefault();},this);this.changeFocus=m;var C=this._.element;b.focusManager.add(C,1);this.on("show",function(){C.on("keydown",n,this);if(CKEDITOR.env.gecko)C.on("keypress",w,this);});this.on("hide",function(){C.removeListener("keydown",n);CKEDITOR.env.gecko&&C.removeListener("keypress",w);B(function(a){d.apply(a);});});this.on("iframeAdded",function(a){new CKEDITOR.dom.document(a.data.iframe.$.contentWindow.document).on("keydown",n,this,null,0);});this.on("show",function(){h();var a=1<y._.pageCount;b.config.dialog_startupFocusTab&&a?(y._.tabBarMode=!0,y._.tabs[y._.currentTabId][0].focus(),y._.currentFocusIndex=-1):this._.hasFocus||(this._.currentFocusIndex=a?-1:this._.focusList.length-1,q.onFocus?(a=q.onFocus.call(this))&&a.focus():m(1));},this,null,4294967295);if(CKEDITOR.env.ie6Compat)this.on("load",function(){var a=this.getElement(),b=a.getFirst();b.remove();b.appendTo(a);},this);k(this);g(this);new CKEDITOR.dom.text(q.title,CKEDITOR.document).appendTo(this.parts.title);for(r=0;r<q.contents.length;r++){(A=q.contents[r])&&this.addPage(A);}this.parts.tabs.on("click",function(a){var b=a.data.getTarget();b.hasClass("cke_dialog_tab")&&(b=b.$.id,this.selectPage(b.substring(4,b.lastIndexOf("_"))),this._.tabBarMode&&(this._.tabBarMode=!1,this._.currentFocusIndex=-1,m(1)),a.data.preventDefault());},this);r=[];A=CKEDITOR.dialog._.uiElementBuilders.hbox.build(this,{type:"hbox",className:"cke_dialog_footer_buttons",widths:[],children:q.buttons},r).getChild();this.parts.footer.setHtml(r.join(""));for(r=0;r<A.length;r++){this._.buttons[A[r].id]=A[r];}};CKEDITOR.dialog.prototype={destroy:function destroy(){this.hide();this._.element.remove();},resize:function(){return function(a,b){this._.contentSize&&this._.contentSize.width==a&&this._.contentSize.height==b||(CKEDITOR.dialog.fire("resize",{dialog:this,width:a,height:b},this._.editor),this.fire("resize",{width:a,height:b},this._.editor),this.parts.contents.setStyles({width:a+"px",height:b+"px"}),"rtl"==this._.editor.lang.dir&&this._.position&&(this._.position.x=CKEDITOR.document.getWindow().getViewPaneSize().width-this._.contentSize.width-parseInt(this._.element.getFirst().getStyle("right"),10)),this._.contentSize={width:a,height:b});};}(),getSize:function getSize(){var a=this._.element.getFirst();return{width:a.$.offsetWidth||0,height:a.$.offsetHeight||0};},move:function move(a,b,c){var d=this._.element.getFirst(),f="rtl"==this._.editor.lang.dir,e="fixed"==d.getComputedStyle("position");CKEDITOR.env.ie&&d.setStyle("zoom","100%");e&&this._.position&&this._.position.x==a&&this._.position.y==b||(this._.position={x:a,y:b},e||(e=CKEDITOR.document.getWindow().getScrollPosition(),a+=e.x,b+=e.y),f&&(e=this.getSize(),a=CKEDITOR.document.getWindow().getViewPaneSize().width-e.width-a),b={top:(0<b?b:0)+"px"},b[f?"right":"left"]=(0<a?a:0)+"px",d.setStyles(b),c&&(this._.moved=1));},getPosition:function getPosition(){return CKEDITOR.tools.extend({},this._.position);},show:function show(){var a=this._.element,b=this.definition;a.getParent()&&a.getParent().equals(CKEDITOR.document.getBody())?a.setStyle("display","block"):a.appendTo(CKEDITOR.document.getBody());this.resize(this._.contentSize&&this._.contentSize.width||b.width||b.minWidth,this._.contentSize&&this._.contentSize.height||b.height||b.minHeight);this.reset();this.selectPage(this.definition.contents[0].id);null===CKEDITOR.dialog._.currentZIndex&&(CKEDITOR.dialog._.currentZIndex=this._.editor.config.baseFloatZIndex);this._.element.getFirst().setStyle("z-index",CKEDITOR.dialog._.currentZIndex+=10);null===CKEDITOR.dialog._.currentTop?(CKEDITOR.dialog._.currentTop=this,this._.parentDialog=null,v(this._.editor)):(this._.parentDialog=CKEDITOR.dialog._.currentTop,this._.parentDialog.getElement().getFirst().$.style.zIndex-=Math.floor(this._.editor.config.baseFloatZIndex/2),CKEDITOR.dialog._.currentTop=this);a.on("keydown",C);a.on("keyup",F);this._.hasFocus=!1;for(var c in b.contents){if(b.contents[c]){var a=b.contents[c],d=this._.tabs[a.id],e=a.requiredContent,g=0;if(d){for(var h in this._.contents[a.id]){var k=this._.contents[a.id][h];"hbox"!=k.type&&"vbox"!=k.type&&k.getInputElement()&&(k.requiredContent&&!this._.editor.activeFilter.check(k.requiredContent)?k.disable():(k.enable(),g++));}!g||e&&!this._.editor.activeFilter.check(e)?d[0].addClass("cke_dialog_tab_disabled"):d[0].removeClass("cke_dialog_tab_disabled");}}}CKEDITOR.tools.setTimeout(function(){this.layout();f(this);this.parts.dialog.setStyle("visibility","");this.fireOnce("load",{});CKEDITOR.ui.fire("ready",this);this.fire("show",{});this._.editor.fire("dialogShow",this);this._.parentDialog||this._.editor.focusManager.lock();this.foreach(function(a){a.setInitValue&&a.setInitValue();});},100,this);},layout:function layout(){var a=this.parts.dialog,b=this.getSize(),c=CKEDITOR.document.getWindow().getViewPaneSize(),d=(c.width-b.width)/2,f=(c.height-b.height)/2;CKEDITOR.env.ie6Compat||(b.height+(0<f?f:0)>c.height||b.width+(0<d?d:0)>c.width?a.setStyle("position","absolute"):a.setStyle("position","fixed"));this.move(this._.moved?this._.position.x:d,this._.moved?this._.position.y:f);},foreach:function foreach(a){for(var b in this._.contents){for(var c in this._.contents[b]){a.call(this,this._.contents[b][c]);}}return this;},reset:function(){var a=function a(_a8){_a8.reset&&_a8.reset(1);};return function(){this.foreach(a);return this;};}(),setupContent:function setupContent(){var a=arguments;this.foreach(function(b){b.setup&&b.setup.apply(b,a);});},commitContent:function commitContent(){var a=arguments;this.foreach(function(b){CKEDITOR.env.ie&&this._.currentFocusIndex==b.focusIndex&&b.getInputElement().$.blur();b.commit&&b.commit.apply(b,a);});},hide:function hide(){if(this.parts.dialog.isVisible()){this.fire("hide",{});this._.editor.fire("dialogHide",this);this.selectPage(this._.tabIdList[0]);var a=this._.element;a.setStyle("display","none");this.parts.dialog.setStyle("visibility","hidden");for(J(this);CKEDITOR.dialog._.currentTop!=this;){CKEDITOR.dialog._.currentTop.hide();}if(this._.parentDialog){var b=this._.parentDialog.getElement().getFirst();b.setStyle("z-index",parseInt(b.$.style.zIndex,10)+Math.floor(this._.editor.config.baseFloatZIndex/2));}else r(this._.editor);if(CKEDITOR.dialog._.currentTop=this._.parentDialog)CKEDITOR.dialog._.currentZIndex-=10;else{CKEDITOR.dialog._.currentZIndex=null;a.removeListener("keydown",C);a.removeListener("keyup",F);var c=this._.editor;c.focus();setTimeout(function(){c.focusManager.unlock();CKEDITOR.env.iOS&&c.window.focus();},0);}delete this._.parentDialog;this.foreach(function(a){a.resetInitValue&&a.resetInitValue();});this.setState(CKEDITOR.DIALOG_STATE_IDLE);}},addPage:function addPage(a){if(!a.requiredContent||this._.editor.filter.check(a.requiredContent)){for(var b=[],c=a.label?' title\x3d"'+CKEDITOR.tools.htmlEncode(a.label)+'"':"",d=CKEDITOR.dialog._.uiElementBuilders.vbox.build(this,{type:"vbox",className:"cke_dialog_page_contents",children:a.elements,expand:!!a.expand,padding:a.padding,style:a.style||"width: 100%;"},b),f=this._.contents[a.id]={},e=d.getChild(),g=0;d=e.shift();){d.notAllowed||"hbox"==d.type||"vbox"==d.type||g++,f[d.id]=d,"function"==typeof d.getChild&&e.push.apply(e,d.getChild());}g||(a.hidden=!0);b=CKEDITOR.dom.element.createFromHtml(b.join(""));b.setAttribute("role","tabpanel");d=CKEDITOR.env;f="cke_"+a.id+"_"+CKEDITOR.tools.getNextNumber();c=CKEDITOR.dom.element.createFromHtml(['\x3ca class\x3d"cke_dialog_tab"',0<this._.pageCount?" cke_last":"cke_first",c,a.hidden?' style\x3d"display:none"':"",' id\x3d"',f,'"',d.gecko&&!d.hc?"":' href\x3d"javascript:void(0)"',' tabIndex\x3d"-1" hidefocus\x3d"true" role\x3d"tab"\x3e',a.label,"\x3c/a\x3e"].join(""));b.setAttribute("aria-labelledby",f);this._.tabs[a.id]=[c,b];this._.tabIdList.push(a.id);!a.hidden&&this._.pageCount++;this._.lastTab=c;this.updateStyle();b.setAttribute("name",a.id);b.appendTo(this.parts.contents);c.unselectable();this.parts.tabs.append(c);a.accessKey&&(E(this,this,"CTRL+"+a.accessKey,M,G),this._.accessKeyMap["CTRL+"+a.accessKey]=a.id);}},selectPage:function selectPage(a){if(this._.currentTabId!=a&&!this._.tabs[a][0].hasClass("cke_dialog_tab_disabled")&&!1!==this.fire("selectPage",{page:a,currentPage:this._.currentTabId})){for(var c in this._.tabs){var d=this._.tabs[c][0],f=this._.tabs[c][1];c!=a&&(d.removeClass("cke_dialog_tab_selected"),f.hide());f.setAttribute("aria-hidden",c!=a);}var e=this._.tabs[a];e[0].addClass("cke_dialog_tab_selected");CKEDITOR.env.ie6Compat||CKEDITOR.env.ie7Compat?(b(e[1]),e[1].show(),setTimeout(function(){b(e[1],1);},0)):e[1].show();this._.currentTabId=a;this._.currentTabIndex=CKEDITOR.tools.indexOf(this._.tabIdList,a);}},updateStyle:function updateStyle(){this.parts.dialog[(1===this._.pageCount?"add":"remove")+"Class"]("cke_single_page");},hidePage:function hidePage(b){var c=this._.tabs[b]&&this._.tabs[b][0];c&&1!=this._.pageCount&&c.isVisible()&&(b==this._.currentTabId&&this.selectPage(a.call(this)),c.hide(),this._.pageCount--,this.updateStyle());},showPage:function showPage(a){if(a=this._.tabs[a]&&this._.tabs[a][0])a.show(),this._.pageCount++,this.updateStyle();},getElement:function getElement(){return this._.element;},getName:function getName(){return this._.name;},getContentElement:function getContentElement(a,b){var c=this._.contents[a];return c&&c[b];},getValueOf:function getValueOf(a,b){return this.getContentElement(a,b).getValue();},setValueOf:function setValueOf(a,b,c){return this.getContentElement(a,b).setValue(c);},getButton:function getButton(a){return this._.buttons[a];},click:function click(a){return this._.buttons[a].click();},disableButton:function disableButton(a){return this._.buttons[a].disable();},enableButton:function enableButton(a){return this._.buttons[a].enable();},getPageCount:function getPageCount(){return this._.pageCount;},getParentEditor:function getParentEditor(){return this._.editor;},getSelectedElement:function getSelectedElement(){return this.getParentEditor().getSelection().getSelectedElement();},addFocusable:function addFocusable(a,b){if("undefined"==typeof b)b=this._.focusList.length,this._.focusList.push(new m(this,a,b));else{this._.focusList.splice(b,0,new m(this,a,b));for(var c=b+1;c<this._.focusList.length;c++){this._.focusList[c].focusIndex++;}}},setState:function setState(a){if(this.state!=a){this.state=a;if(a==CKEDITOR.DIALOG_STATE_BUSY){if(!this.parts.spinner){var b=this.getParentEditor().lang.dir,c={attributes:{"class":"cke_dialog_spinner"},styles:{"float":"rtl"==b?"right":"left"}};c.styles["margin-"+("rtl"==b?"left":"right")]="8px";this.parts.spinner=CKEDITOR.document.createElement("div",c);this.parts.spinner.setHtml("\x26#8987;");this.parts.spinner.appendTo(this.parts.title,1);}this.parts.spinner.show();this.getButton("ok").disable();}else a==CKEDITOR.DIALOG_STATE_IDLE&&(this.parts.spinner&&this.parts.spinner.hide(),this.getButton("ok").enable());this.fire("state",a);}}};CKEDITOR.tools.extend(CKEDITOR.dialog,{add:function add(a,b){this._.dialogDefinitions[a]&&"function"!=typeof b||(this._.dialogDefinitions[a]=b);},exists:function exists(a){return!!this._.dialogDefinitions[a];},getCurrent:function getCurrent(){return CKEDITOR.dialog._.currentTop;},isTabEnabled:function isTabEnabled(a,b,c){a=a.config.removeDialogTabs;return!(a&&a.match(new RegExp("(?:^|;)"+b+":"+c+"(?:$|;)","i")));},okButton:function(){var a=function a(_a9,b){b=b||{};return CKEDITOR.tools.extend({id:"ok",type:"button",label:_a9.lang.common.ok,"class":"cke_dialog_ui_button_ok",onClick:function onClick(a){a=a.data.dialog;!1!==a.fire("ok",{hide:!0}).hide&&a.hide();}},b,!0);};a.type="button";a.override=function(b){return CKEDITOR.tools.extend(function(c){return a(c,b);},{type:"button"},!0);};return a;}(),cancelButton:function(){var a=function a(_a10,b){b=b||{};return CKEDITOR.tools.extend({id:"cancel",type:"button",label:_a10.lang.common.cancel,"class":"cke_dialog_ui_button_cancel",onClick:function onClick(a){a=a.data.dialog;!1!==a.fire("cancel",{hide:!0}).hide&&a.hide();}},b,!0);};a.type="button";a.override=function(b){return CKEDITOR.tools.extend(function(c){return a(c,b);},{type:"button"},!0);};return a;}(),addUIElement:function addUIElement(a,b){this._.uiElementBuilders[a]=b;}});CKEDITOR.dialog._={uiElementBuilders:{},dialogDefinitions:{},currentTop:null,currentZIndex:null};CKEDITOR.event.implementOn(CKEDITOR.dialog);CKEDITOR.event.implementOn(CKEDITOR.dialog.prototype);var p={resizable:CKEDITOR.DIALOG_RESIZE_BOTH,minWidth:600,minHeight:400,buttons:[CKEDITOR.dialog.okButton,CKEDITOR.dialog.cancelButton]},w=function w(a,b,c){for(var d=0,f;f=a[d];d++){if(f.id==b||c&&f[c]&&(f=w(f[c],b,c)))return f;}return null;},z=function z(a,b,c,d,f){if(c){for(var e=0,g;g=a[e];e++){if(g.id==c)return a.splice(e,0,b),b;if(d&&g[d]&&(g=z(g[d],b,c,d,!0)))return g;}if(f)return null;}a.push(b);return b;},A=function A(a,b,c){for(var d=0,f;f=a[d];d++){if(f.id==b)return a.splice(d,1);if(c&&f[c]&&(f=A(f[c],b,c)))return f;}return null;},u=function u(a,b){this.dialog=a;for(var c=b.contents,d=0,f;f=c[d];d++){c[d]=f&&new h(a,f);}CKEDITOR.tools.extend(this,b);};u.prototype={getContents:function getContents(a){return w(this.contents,a);},getButton:function getButton(a){return w(this.buttons,a);},addContents:function addContents(a,b){return z(this.contents,a,b);},addButton:function addButton(a,b){return z(this.buttons,a,b);},removeContents:function removeContents(a){A(this.contents,a);},removeButton:function removeButton(a){A(this.buttons,a);}};h.prototype={get:function get(a){return w(this.elements,a,"children");},add:function add(a,b){return z(this.elements,a,b,"children");},remove:function remove(a){A(this.elements,a,"children");}};var x,D={},y,B={},C=function C(a){var b=a.data.$.ctrlKey||a.data.$.metaKey,c=a.data.$.altKey,d=a.data.$.shiftKey,f=String.fromCharCode(a.data.$.keyCode);(b=B[(b?"CTRL+":"")+(c?"ALT+":"")+(d?"SHIFT+":"")+f])&&b.length&&(b=b[b.length-1],b.keydown&&b.keydown.call(b.uiElement,b.dialog,b.key),a.data.preventDefault());},F=function F(a){var b=a.data.$.ctrlKey||a.data.$.metaKey,c=a.data.$.altKey,d=a.data.$.shiftKey,f=String.fromCharCode(a.data.$.keyCode);(b=B[(b?"CTRL+":"")+(c?"ALT+":"")+(d?"SHIFT+":"")+f])&&b.length&&(b=b[b.length-1],b.keyup&&(b.keyup.call(b.uiElement,b.dialog,b.key),a.data.preventDefault()));},E=function E(a,b,c,d,f){(B[c]||(B[c]=[])).push({uiElement:a,dialog:b,key:c,keyup:f||a.accessKeyUp,keydown:d||a.accessKeyDown});},J=function J(a){for(var b in B){for(var c=B[b],d=c.length-1;0<=d;d--){c[d].dialog!=a&&c[d].uiElement!=a||c.splice(d,1);}0===c.length&&delete B[b];}},G=function G(a,b){a._.accessKeyMap[b]&&a.selectPage(a._.accessKeyMap[b]);},M=function M(){};(function(){CKEDITOR.ui.dialog={uiElement:function uiElement(a,b,c,d,f,e,g){if(!(4>arguments.length)){var h=(d.call?d(b):d)||"div",k=["\x3c",h," "],l=(f&&f.call?f(b):f)||{},m=(e&&e.call?e(b):e)||{},n=(g&&g.call?g.call(this,a,b):g)||"",w=this.domId=m.id||CKEDITOR.tools.getNextId()+"_uiElement";b.requiredContent&&!a.getParentEditor().filter.check(b.requiredContent)&&(l.display="none",this.notAllowed=!0);m.id=w;var p={};b.type&&(p["cke_dialog_ui_"+b.type]=1);b.className&&(p[b.className]=1);b.disabled&&(p.cke_disabled=1);for(var q=m["class"]&&m["class"].split?m["class"].split(" "):[],w=0;w<q.length;w++){q[w]&&(p[q[w]]=1);}q=[];for(w in p){q.push(w);}m["class"]=q.join(" ");b.title&&(m.title=b.title);p=(b.style||"").split(";");b.align&&(q=b.align,l["margin-left"]="left"==q?0:"auto",l["margin-right"]="right"==q?0:"auto");for(w in l){p.push(w+":"+l[w]);}b.hidden&&p.push("display:none");for(w=p.length-1;0<=w;w--){""===p[w]&&p.splice(w,1);}0<p.length&&(m.style=(m.style?m.style+"; ":"")+p.join("; "));for(w in m){k.push(w+'\x3d"'+CKEDITOR.tools.htmlEncode(m[w])+'" ');}k.push("\x3e",n,"\x3c/",h,"\x3e");c.push(k.join(""));(this._||(this._={})).dialog=a;"boolean"==typeof b.isChanged&&(this.isChanged=function(){return b.isChanged;});"function"==typeof b.isChanged&&(this.isChanged=b.isChanged);"function"==typeof b.setValue&&(this.setValue=CKEDITOR.tools.override(this.setValue,function(a){return function(c){a.call(this,b.setValue.call(this,c));};}));"function"==typeof b.getValue&&(this.getValue=CKEDITOR.tools.override(this.getValue,function(a){return function(){return b.getValue.call(this,a.call(this));};}));CKEDITOR.event.implementOn(this);this.registerEvents(b);this.accessKeyUp&&this.accessKeyDown&&b.accessKey&&E(this,a,"CTRL+"+b.accessKey);var z=this;a.on("load",function(){var b=z.getInputElement();if(b){var c=z.type in{checkbox:1,ratio:1}&&CKEDITOR.env.ie&&8>CKEDITOR.env.version?"cke_dialog_ui_focused":"";b.on("focus",function(){a._.tabBarMode=!1;a._.hasFocus=!0;z.fire("focus");c&&this.addClass(c);});b.on("blur",function(){z.fire("blur");c&&this.removeClass(c);});}});CKEDITOR.tools.extend(this,b);this.keyboardFocusable&&(this.tabIndex=b.tabIndex||0,this.focusIndex=a._.focusList.push(this)-1,this.on("focus",function(){a._.currentFocusIndex=z.focusIndex;}));}},hbox:function hbox(a,b,c,d,f){if(!(4>arguments.length)){this._||(this._={});var e=this._.children=b,g=f&&f.widths||null,h=f&&f.height||null,k,l={role:"presentation"};f&&f.align&&(l.align=f.align);CKEDITOR.ui.dialog.uiElement.call(this,a,f||{type:"hbox"},d,"table",{},l,function(){var a=['\x3ctbody\x3e\x3ctr class\x3d"cke_dialog_ui_hbox"\x3e'];for(k=0;k<c.length;k++){var b="cke_dialog_ui_hbox_child",d=[];0===k&&(b="cke_dialog_ui_hbox_first");k==c.length-1&&(b="cke_dialog_ui_hbox_last");a.push('\x3ctd class\x3d"',b,'" role\x3d"presentation" ');g?g[k]&&d.push("width:"+q(g[k])):d.push("width:"+Math.floor(100/c.length)+"%");h&&d.push("height:"+q(h));f&&void 0!==f.padding&&d.push("padding:"+q(f.padding));CKEDITOR.env.ie&&CKEDITOR.env.quirks&&e[k].align&&d.push("text-align:"+e[k].align);0<d.length&&a.push('style\x3d"'+d.join("; ")+'" ');a.push("\x3e",c[k],"\x3c/td\x3e");}a.push("\x3c/tr\x3e\x3c/tbody\x3e");return a.join("");});}},vbox:function vbox(a,b,c,d,f){if(!(3>arguments.length)){this._||(this._={});var e=this._.children=b,g=f&&f.width||null,h=f&&f.heights||null;CKEDITOR.ui.dialog.uiElement.call(this,a,f||{type:"vbox"},d,"div",null,{role:"presentation"},function(){var b=['\x3ctable role\x3d"presentation" cellspacing\x3d"0" border\x3d"0" '];b.push('style\x3d"');f&&f.expand&&b.push("height:100%;");b.push("width:"+q(g||"100%"),";");CKEDITOR.env.webkit&&b.push("float:none;");b.push('"');b.push('align\x3d"',CKEDITOR.tools.htmlEncode(f&&f.align||("ltr"==a.getParentEditor().lang.dir?"left":"right")),'" ');b.push("\x3e\x3ctbody\x3e");for(var d=0;d<c.length;d++){var k=[];b.push('\x3ctr\x3e\x3ctd role\x3d"presentation" ');g&&k.push("width:"+q(g||"100%"));h?k.push("height:"+q(h[d])):f&&f.expand&&k.push("height:"+Math.floor(100/c.length)+"%");f&&void 0!==f.padding&&k.push("padding:"+q(f.padding));CKEDITOR.env.ie&&CKEDITOR.env.quirks&&e[d].align&&k.push("text-align:"+e[d].align);0<k.length&&b.push('style\x3d"',k.join("; "),'" ');b.push(' class\x3d"cke_dialog_ui_vbox_child"\x3e',c[d],"\x3c/td\x3e\x3c/tr\x3e");}b.push("\x3c/tbody\x3e\x3c/table\x3e");return b.join("");});}}};})();CKEDITOR.ui.dialog.uiElement.prototype={getElement:function getElement(){return CKEDITOR.document.getById(this.domId);},getInputElement:function getInputElement(){return this.getElement();},getDialog:function getDialog(){return this._.dialog;},setValue:function setValue(a,b){this.getInputElement().setValue(a);!b&&this.fire("change",{value:a});return this;},getValue:function getValue(){return this.getInputElement().getValue();},isChanged:function isChanged(){return!1;},selectParentTab:function selectParentTab(){for(var a=this.getInputElement();(a=a.getParent())&&-1==a.$.className.search("cke_dialog_page_contents");){}if(!a)return this;a=a.getAttribute("name");this._.dialog._.currentTabId!=a&&this._.dialog.selectPage(a);return this;},focus:function focus(){this.selectParentTab().getInputElement().focus();return this;},registerEvents:function registerEvents(a){var b=/^on([A-Z]\w+)/,c,d=function d(a,b,c,_d2){b.on("load",function(){a.getInputElement().on(c,_d2,a);});},f;for(f in a){if(c=f.match(b))this.eventProcessors[f]?this.eventProcessors[f].call(this,this._.dialog,a[f]):d(this,this._.dialog,c[1].toLowerCase(),a[f]);}return this;},eventProcessors:{onLoad:function onLoad(a,b){a.on("load",b,this);},onShow:function onShow(a,b){a.on("show",b,this);},onHide:function onHide(a,b){a.on("hide",b,this);}},accessKeyDown:function accessKeyDown(){this.focus();},accessKeyUp:function accessKeyUp(){},disable:function disable(){var a=this.getElement();this.getInputElement().setAttribute("disabled","true");a.addClass("cke_disabled");},enable:function enable(){var a=this.getElement();this.getInputElement().removeAttribute("disabled");a.removeClass("cke_disabled");},isEnabled:function isEnabled(){return!this.getElement().hasClass("cke_disabled");},isVisible:function isVisible(){return this.getInputElement().isVisible();},isFocusable:function isFocusable(){return this.isEnabled()&&this.isVisible()?!0:!1;}};CKEDITOR.ui.dialog.hbox.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement(),{getChild:function getChild(a){if(1>arguments.length)return this._.children.concat();a.splice||(a=[a]);return 2>a.length?this._.children[a[0]]:this._.children[a[0]]&&this._.children[a[0]].getChild?this._.children[a[0]].getChild(a.slice(1,a.length)):null;}},!0);CKEDITOR.ui.dialog.vbox.prototype=new CKEDITOR.ui.dialog.hbox();(function(){var a={build:function build(a,b,c){for(var d=b.children,f,e=[],g=[],h=0;h<d.length&&(f=d[h]);h++){var k=[];e.push(k);g.push(CKEDITOR.dialog._.uiElementBuilders[f.type].build(a,f,k));}return new CKEDITOR.ui.dialog[b.type](a,g,e,c,b);}};CKEDITOR.dialog.addUIElement("hbox",a);CKEDITOR.dialog.addUIElement("vbox",a);})();CKEDITOR.dialogCommand=function(a,b){this.dialogName=a;CKEDITOR.tools.extend(this,b,!0);};CKEDITOR.dialogCommand.prototype={exec:function exec(a){a.openDialog(this.dialogName);},canUndo:!1,editorFocus:1};(function(){var a=/^([a]|[^a])+$/,b=/^\d*$/,c=/^\d*(?:\.\d+)?$/,d=/^(((\d*(\.\d+))|(\d*))(px|\%)?)?$/,f=/^(((\d*(\.\d+))|(\d*))(px|em|ex|in|cm|mm|pt|pc|\%)?)?$/i,e=/^(\s*[\w-]+\s*:\s*[^:;]+(?:;|$))*$/;CKEDITOR.VALIDATE_OR=1;CKEDITOR.VALIDATE_AND=2;CKEDITOR.dialog.validate={functions:function functions(){var a=arguments;return function(){var b=this&&this.getValue?this.getValue():a[0],c,d=CKEDITOR.VALIDATE_AND,f=[],e;for(e=0;e<a.length;e++){if("function"==typeof a[e])f.push(a[e]);else break;}e<a.length&&"string"==typeof a[e]&&(c=a[e],e++);e<a.length&&"number"==typeof a[e]&&(d=a[e]);var g=d==CKEDITOR.VALIDATE_AND?!0:!1;for(e=0;e<f.length;e++){g=d==CKEDITOR.VALIDATE_AND?g&&f[e](b):g||f[e](b);}return g?!0:c;};},regex:function regex(a,b){return function(c){c=this&&this.getValue?this.getValue():c;return a.test(c)?!0:b;};},notEmpty:function notEmpty(b){return this.regex(a,b);},integer:function integer(a){return this.regex(b,a);},number:function number(a){return this.regex(c,a);},cssLength:function cssLength(a){return this.functions(function(a){return f.test(CKEDITOR.tools.trim(a));},a);},htmlLength:function htmlLength(a){return this.functions(function(a){return d.test(CKEDITOR.tools.trim(a));},a);},inlineStyle:function inlineStyle(a){return this.functions(function(a){return e.test(CKEDITOR.tools.trim(a));},a);},equals:function equals(a,b){return this.functions(function(b){return b==a;},b);},notEqual:function notEqual(a,b){return this.functions(function(b){return b!=a;},b);}};CKEDITOR.on("instanceDestroyed",function(a){if(CKEDITOR.tools.isEmpty(CKEDITOR.instances)){for(var b;b=CKEDITOR.dialog._.currentTop;){b.hide();}for(var c in D){D[c].remove();}D={};}a=a.editor._.storedDialogs;for(var d in a){a[d].destroy();}});})();CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{openDialog:function openDialog(a,b){var c=null,d=CKEDITOR.dialog._.dialogDefinitions[a];null===CKEDITOR.dialog._.currentTop&&v(this);if("function"==typeof d)c=this._.storedDialogs||(this._.storedDialogs={}),c=c[a]||(c[a]=new CKEDITOR.dialog(this,a)),b&&b.call(c,c),c.show();else{if("failed"==d)throw r(this),Error('[CKEDITOR.dialog.openDialog] Dialog "'+a+'" failed when loading definition.');"string"==typeof d&&CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(d),function(){"function"!=typeof CKEDITOR.dialog._.dialogDefinitions[a]&&(CKEDITOR.dialog._.dialogDefinitions[a]="failed");this.openDialog(a,b);},this,0,1);}CKEDITOR.skin.loadPart("dialog");return c;}});}(),CKEDITOR.plugins.add("dialog",{requires:"dialogui",init:function init(a){a.on("doubleclick",function(e){e.data.dialog&&a.openDialog(e.data.dialog);},null,null,999);}}),function(){CKEDITOR.plugins.add("a11yhelp",{requires:"dialog",availableLangs:{af:1,ar:1,bg:1,ca:1,cs:1,cy:1,da:1,de:1,"de-ch":1,el:1,en:1,"en-gb":1,eo:1,es:1,et:1,eu:1,fa:1,fi:1,fo:1,fr:1,"fr-ca":1,gl:1,gu:1,he:1,hi:1,hr:1,hu:1,id:1,it:1,ja:1,km:1,ko:1,ku:1,lt:1,lv:1,mk:1,mn:1,nb:1,nl:1,no:1,pl:1,pt:1,"pt-br":1,ro:1,ru:1,si:1,sk:1,sl:1,sq:1,sr:1,"sr-latn":1,sv:1,th:1,tr:1,tt:1,ug:1,uk:1,vi:1,zh:1,"zh-cn":1},init:function init(a){var e=this;a.addCommand("a11yHelp",{exec:function exec(){var b=a.langCode,b=e.availableLangs[b]?b:e.availableLangs[b.replace(/-.*/,"")]?b.replace(/-.*/,""):"en";CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(e.path+"dialogs/lang/"+b+".js"),function(){a.lang.a11yhelp=e.langEntries[b];a.openDialog("a11yHelp");});},modes:{wysiwyg:1,source:1},readOnly:1,canUndo:!1});a.setKeystroke(CKEDITOR.ALT+48,"a11yHelp");CKEDITOR.dialog.add("a11yHelp",this.path+"dialogs/a11yhelp.js");a.on("ariaEditorHelpLabel",function(b){b.data.label=a.lang.common.editorHelp;});}});}(),CKEDITOR.plugins.add("about",{requires:"dialog",init:function init(a){var e=a.addCommand("about",new CKEDITOR.dialogCommand("about"));e.modes={wysiwyg:1,source:1};e.canUndo=!1;e.readOnly=1;a.ui.addButton&&a.ui.addButton("About",{label:a.lang.about.title,command:"about",toolbar:"about"});CKEDITOR.dialog.add("about",this.path+"dialogs/about.js");}}),CKEDITOR.plugins.add("basicstyles",{init:function init(a){var e=0,b=function b(_b3,d,h,k){if(k){k=new CKEDITOR.style(k);var g=c[h];g.unshift(k);a.attachStyleStateChange(k,function(b){!a.readOnly&&a.getCommand(h).setState(b);});a.addCommand(h,new CKEDITOR.styleCommand(k,{contentForms:g}));a.ui.addButton&&a.ui.addButton(_b3,{label:d,command:h,toolbar:"basicstyles,"+(e+=10)});}},c={bold:["strong","b",["span",function(a){a=a.styles["font-weight"];return"bold"==a||700<=+a;}]],italic:["em","i",["span",function(a){return"italic"==a.styles["font-style"];}]],underline:["u",["span",function(a){return"underline"==a.styles["text-decoration"];}]],strike:["s","strike",["span",function(a){return"line-through"==a.styles["text-decoration"];}]],subscript:["sub"],superscript:["sup"]},d=a.config,l=a.lang.basicstyles;b("Bold",l.bold,"bold",d.coreStyles_bold);b("Italic",l.italic,"italic",d.coreStyles_italic);b("Underline",l.underline,"underline",d.coreStyles_underline);b("Strike",l.strike,"strike",d.coreStyles_strike);b("Subscript",l.subscript,"subscript",d.coreStyles_subscript);b("Superscript",l.superscript,"superscript",d.coreStyles_superscript);a.setKeystroke([[CKEDITOR.CTRL+66,"bold"],[CKEDITOR.CTRL+73,"italic"],[CKEDITOR.CTRL+85,"underline"]]);}}),CKEDITOR.config.coreStyles_bold={element:"strong",overrides:"b"},CKEDITOR.config.coreStyles_italic={element:"em",overrides:"i"},CKEDITOR.config.coreStyles_underline={element:"u"},CKEDITOR.config.coreStyles_strike={element:"s",overrides:"strike"},CKEDITOR.config.coreStyles_subscript={element:"sub"},CKEDITOR.config.coreStyles_superscript={element:"sup"},function(){var a={exec:function exec(a){var b=a.getCommand("blockquote").state,c=a.getSelection(),d=c&&c.getRanges()[0];if(d){var l=c.createBookmarks();if(CKEDITOR.env.ie){var m=l[0].startNode,f=l[0].endNode,h;if(m&&"blockquote"==m.getParent().getName())for(h=m;h=h.getNext();){if(h.type==CKEDITOR.NODE_ELEMENT&&h.isBlockBoundary()){m.move(h,!0);break;}}if(f&&"blockquote"==f.getParent().getName())for(h=f;h=h.getPrevious();){if(h.type==CKEDITOR.NODE_ELEMENT&&h.isBlockBoundary()){f.move(h);break;}}}var k=d.createIterator();k.enlargeBr=a.config.enterMode!=CKEDITOR.ENTER_BR;if(b==CKEDITOR.TRISTATE_OFF){for(m=[];b=k.getNextParagraph();){m.push(b);}1>m.length&&(b=a.document.createElement(a.config.enterMode==CKEDITOR.ENTER_P?"p":"div"),f=l.shift(),d.insertNode(b),b.append(new CKEDITOR.dom.text("﻿",a.document)),d.moveToBookmark(f),d.selectNodeContents(b),d.collapse(!0),f=d.createBookmark(),m.push(b),l.unshift(f));h=m[0].getParent();d=[];for(f=0;f<m.length;f++){b=m[f],h=h.getCommonAncestor(b.getParent());}for(b={table:1,tbody:1,tr:1,ol:1,ul:1};b[h.getName()];){h=h.getParent();}for(f=null;0<m.length;){for(b=m.shift();!b.getParent().equals(h);){b=b.getParent();}b.equals(f)||d.push(b);f=b;}for(;0<d.length;){if(b=d.shift(),"blockquote"==b.getName()){for(f=new CKEDITOR.dom.documentFragment(a.document);b.getFirst();){f.append(b.getFirst().remove()),m.push(f.getLast());}f.replace(b);}else m.push(b);}d=a.document.createElement("blockquote");for(d.insertBefore(m[0]);0<m.length;){b=m.shift(),d.append(b);}}else if(b==CKEDITOR.TRISTATE_ON){f=[];for(h={};b=k.getNextParagraph();){for(m=d=null;b.getParent();){if("blockquote"==b.getParent().getName()){d=b.getParent();m=b;break;}b=b.getParent();}d&&m&&!m.getCustomData("blockquote_moveout")&&(f.push(m),CKEDITOR.dom.element.setMarker(h,m,"blockquote_moveout",!0));}CKEDITOR.dom.element.clearAllMarkers(h);b=[];m=[];for(h={};0<f.length;){k=f.shift(),d=k.getParent(),k.getPrevious()?k.getNext()?(k.breakParent(k.getParent()),m.push(k.getNext())):k.remove().insertAfter(d):k.remove().insertBefore(d),d.getCustomData("blockquote_processed")||(m.push(d),CKEDITOR.dom.element.setMarker(h,d,"blockquote_processed",!0)),b.push(k);}CKEDITOR.dom.element.clearAllMarkers(h);for(f=m.length-1;0<=f;f--){d=m[f];a:{h=d;for(var k=0,g=h.getChildCount(),n=void 0;k<g&&(n=h.getChild(k));k++){if(n.type==CKEDITOR.NODE_ELEMENT&&n.isBlockBoundary()){h=!1;break a;}}h=!0;}h&&d.remove();}if(a.config.enterMode==CKEDITOR.ENTER_BR)for(d=!0;b.length;){if(k=b.shift(),"div"==k.getName()){f=new CKEDITOR.dom.documentFragment(a.document);!d||!k.getPrevious()||k.getPrevious().type==CKEDITOR.NODE_ELEMENT&&k.getPrevious().isBlockBoundary()||f.append(a.document.createElement("br"));for(d=k.getNext()&&!(k.getNext().type==CKEDITOR.NODE_ELEMENT&&k.getNext().isBlockBoundary());k.getFirst();){k.getFirst().remove().appendTo(f);}d&&f.append(a.document.createElement("br"));f.replace(k);d=!1;}}}c.selectBookmarks(l);a.focus();}},refresh:function refresh(a,b){this.setState(a.elementPath(b.block||b.blockLimit).contains("blockquote",1)?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF);},context:"blockquote",allowedContent:"blockquote",requiredContent:"blockquote"};CKEDITOR.plugins.add("blockquote",{init:function init(e){e.blockless||(e.addCommand("blockquote",a),e.ui.addButton&&e.ui.addButton("Blockquote",{label:e.lang.blockquote.toolbar,command:"blockquote",toolbar:"blocks,10"}));}});}(),"use strict",function(){function a(a,b,c){b.type||(b.type="auto");if(c&&!1===a.fire("beforePaste",b)||!b.dataValue&&b.dataTransfer.isEmpty())return!1;b.dataValue||(b.dataValue="");if(CKEDITOR.env.gecko&&"drop"==b.method&&a.toolbox)a.once("afterPaste",function(){a.toolbox.focus();});return a.fire("paste",b);}function e(b){function c(){var a=b.editable();if(CKEDITOR.plugins.clipboard.isCustomCopyCutSupported){var d=function d(a){b.readOnly&&"cut"==a.name||B.initPasteDataTransfer(a,b);a.data.preventDefault();};a.on("copy",d);a.on("cut",d);a.on("cut",function(){b.readOnly||b.extractSelectedHtml();},null,null,999);}a.on(B.mainPasteEvent,function(a){"beforepaste"==B.mainPasteEvent&&C||x(a);});"beforepaste"==B.mainPasteEvent&&(a.on("paste",function(a){F||(e(),a.data.preventDefault(),x(a),k("paste")||b.openDialog("paste"));}),a.on("contextmenu",h,null,null,0),a.on("beforepaste",function(a){!a.data||a.data.$.ctrlKey||a.data.$.shiftKey||h();},null,null,0));a.on("beforecut",function(){!C&&l(b);});var f;a.attachListener(CKEDITOR.env.ie?a:b.document.getDocumentElement(),"mouseup",function(){f=setTimeout(function(){D();},0);});b.on("destroy",function(){clearTimeout(f);});a.on("keyup",D);}function d(a){return{type:a,canUndo:"cut"==a,startDisabled:!0,exec:function exec(){"cut"==this.type&&l();var a;var c=this.type;if(CKEDITOR.env.ie)a=k(c);else try{a=b.document.$.execCommand(c,!1,null);}catch(d){a=!1;}a||b.showNotification(b.lang.clipboard[this.type+"Error"]);return a;}};}function f(){return{canUndo:!1,async:!0,exec:function exec(b,c){var d=this,f=function f(c,_f){c&&a(b,c,!!_f);b.fire("afterCommandExec",{name:"paste",command:d,returnValue:!!c});};"string"==typeof c?f({dataValue:c,method:"paste",dataTransfer:B.initPasteDataTransfer()},1):b.getClipboardData(f);}};}function e(){F=1;setTimeout(function(){F=0;},100);}function h(){C=1;setTimeout(function(){C=0;},10);}function k(a){var c=b.document,d=c.getBody(),f=!1,e=function e(){f=!0;};d.on(a,e);7<CKEDITOR.env.version?c.$.execCommand(a):c.$.selection.createRange().execCommand(a);d.removeListener(a,e);return f;}function l(){if(CKEDITOR.env.ie&&!CKEDITOR.env.quirks){var a=b.getSelection(),c,d,f;a.getType()==CKEDITOR.SELECTION_ELEMENT&&(c=a.getSelectedElement())&&(d=a.getRanges()[0],f=b.document.createText(""),f.insertBefore(c),d.setStartBefore(f),d.setEndAfter(c),a.selectRanges([d]),setTimeout(function(){c.getParent()&&(f.remove(),a.selectElement(c));},0));}}function m(a,c){var d=b.document,f=b.editable(),e=function e(a){a.cancel();},h;if(!d.getById("cke_pastebin")){var k=b.getSelection(),l=k.createBookmarks();CKEDITOR.env.ie&&k.root.fire("selectionchange");var n=new CKEDITOR.dom.element(!CKEDITOR.env.webkit&&!f.is("body")||CKEDITOR.env.ie?"div":"body",d);n.setAttributes({id:"cke_pastebin","data-cke-temp":"1"});var w=0,d=d.getWindow();CKEDITOR.env.webkit?(f.append(n),n.addClass("cke_editable"),f.is("body")||(w="static"!=f.getComputedStyle("position")?f:CKEDITOR.dom.element.get(f.$.offsetParent),w=w.getDocumentPosition().y)):f.getAscendant(CKEDITOR.env.ie?"body":"html",1).append(n);n.setStyles({position:"absolute",top:d.getScrollPosition().y-w+10+"px",width:"1px",height:Math.max(1,d.getViewPaneSize().height-20)+"px",overflow:"hidden",margin:0,padding:0});CKEDITOR.env.safari&&n.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select","text"));(w=n.getParent().isReadOnly())?(n.setOpacity(0),n.setAttribute("contenteditable",!0)):n.setStyle("ltr"==b.config.contentsLangDirection?"left":"right","-10000px");b.on("selectionChange",e,null,null,0);if(CKEDITOR.env.webkit||CKEDITOR.env.gecko)h=f.once("blur",e,null,null,-100);w&&n.focus();w=new CKEDITOR.dom.range(n);w.selectNodeContents(n);var p=w.select();CKEDITOR.env.ie&&(h=f.once("blur",function(){b.lockSelection(p);}));var q=CKEDITOR.document.getWindow().getScrollPosition().y;setTimeout(function(){CKEDITOR.env.webkit&&(CKEDITOR.document.getBody().$.scrollTop=q);h&&h.removeListener();CKEDITOR.env.ie&&f.focus();k.selectBookmarks(l);n.remove();var a;CKEDITOR.env.webkit&&(a=n.getFirst())&&a.is&&a.hasClass("Apple-style-span")&&(n=a);b.removeListener("selectionChange",e);c(n.getHtml());},0);}}function A(){if("paste"==B.mainPasteEvent)return b.fire("beforePaste",{type:"auto",method:"paste"}),!1;b.focus();e();var a=b.focusManager;a.lock();if(b.editable().fire(B.mainPasteEvent)&&!k("paste"))return a.unlock(),!1;a.unlock();return!0;}function u(a){if("wysiwyg"==b.mode)switch(a.data.keyCode){case CKEDITOR.CTRL+86:case CKEDITOR.SHIFT+45:a=b.editable();e();"paste"==B.mainPasteEvent&&a.fire("beforepaste");break;case CKEDITOR.CTRL+88:case CKEDITOR.SHIFT+46:b.fire("saveSnapshot"),setTimeout(function(){b.fire("saveSnapshot");},50);}}function x(c){var d={type:"auto",method:"paste",dataTransfer:B.initPasteDataTransfer(c)};d.dataTransfer.cacheData();var f=!1!==b.fire("beforePaste",d);f&&B.canClipboardApiBeTrusted(d.dataTransfer,b)?(c.data.preventDefault(),setTimeout(function(){a(b,d);},0)):m(c,function(c){d.dataValue=c.replace(/<span[^>]+data-cke-bookmark[^<]*?<\/span>/ig,"");f&&a(b,d);});}function D(){if("wysiwyg"==b.mode){var a=y("paste");b.getCommand("cut").setState(y("cut"));b.getCommand("copy").setState(y("copy"));b.getCommand("paste").setState(a);b.fire("pasteState",a);}}function y(a){if(E&&a in{paste:1,cut:1})return CKEDITOR.TRISTATE_DISABLED;if("paste"==a)return CKEDITOR.TRISTATE_OFF;a=b.getSelection();var c=a.getRanges();return a.getType()==CKEDITOR.SELECTION_NONE||1==c.length&&c[0].collapsed?CKEDITOR.TRISTATE_DISABLED:CKEDITOR.TRISTATE_OFF;}var B=CKEDITOR.plugins.clipboard,C=0,F=0,E=0;(function(){b.on("key",u);b.on("contentDom",c);b.on("selectionChange",function(a){E=a.data.selection.getRanges()[0].checkReadOnly();D();});b.contextMenu&&b.contextMenu.addListener(function(a,b){E=b.getRanges()[0].checkReadOnly();return{cut:y("cut"),copy:y("copy"),paste:y("paste")};});})();(function(){function a(c,d,f,e,h){var k=b.lang.clipboard[d];b.addCommand(d,f);b.ui.addButton&&b.ui.addButton(c,{label:k,command:d,toolbar:"clipboard,"+e});b.addMenuItems&&b.addMenuItem(d,{label:k,command:d,group:"clipboard",order:h});}a("Cut","cut",d("cut"),10,1);a("Copy","copy",d("copy"),20,4);a("Paste","paste",f(),30,8);})();b.getClipboardData=function(a,c){function d(a){a.removeListener();a.cancel();c(a.data);}function f(a){a.removeListener();a.cancel();l=!0;c({type:k,dataValue:a.data.dataValue,dataTransfer:a.data.dataTransfer,method:"paste"});}function e(){this.customTitle=a&&a.title;}var h=!1,k="auto",l=!1;c||(c=a,a=null);b.on("paste",d,null,null,0);b.on("beforePaste",function(a){a.removeListener();h=!0;k=a.data.type;},null,null,1E3);!1===A()&&(b.removeListener("paste",d),h&&b.fire("pasteDialog",e)?(b.on("pasteDialogCommit",f),b.on("dialogHide",function(a){a.removeListener();a.data.removeListener("pasteDialogCommit",f);setTimeout(function(){l||c(null);},10);})):c(null));};}function b(a){if(CKEDITOR.env.webkit){if(!a.match(/^[^<]*$/g)&&!a.match(/^(<div><br( ?\/)?><\/div>|<div>[^<]*<\/div>)*$/gi))return"html";}else if(CKEDITOR.env.ie){if(!a.match(/^([^<]|<br( ?\/)?>)*$/gi)&&!a.match(/^(<p>([^<]|<br( ?\/)?>)*<\/p>|(\r\n))*$/gi))return"html";}else if(CKEDITOR.env.gecko){if(!a.match(/^([^<]|<br( ?\/)?>)*$/gi))return"html";}else return"html";return"htmlifiedtext";}function c(a,b){function c(a){return CKEDITOR.tools.repeat("\x3c/p\x3e\x3cp\x3e",~~(a/2))+(1==a%2?"\x3cbr\x3e":"");}b=b.replace(/\s+/g," ").replace(/> +</g,"\x3e\x3c").replace(/<br ?\/>/gi,"\x3cbr\x3e");b=b.replace(/<\/?[A-Z]+>/g,function(a){return a.toLowerCase();});if(b.match(/^[^<]$/))return b;CKEDITOR.env.webkit&&-1<b.indexOf("\x3cdiv\x3e")&&(b=b.replace(/^(<div>(<br>|)<\/div>)(?!$|(<div>(<br>|)<\/div>))/g,"\x3cbr\x3e").replace(/^(<div>(<br>|)<\/div>){2}(?!$)/g,"\x3cdiv\x3e\x3c/div\x3e"),b.match(/<div>(<br>|)<\/div>/)&&(b="\x3cp\x3e"+b.replace(/(<div>(<br>|)<\/div>)+/g,function(a){return c(a.split("\x3c/div\x3e\x3cdiv\x3e").length+1);})+"\x3c/p\x3e"),b=b.replace(/<\/div><div>/g,"\x3cbr\x3e"),b=b.replace(/<\/?div>/g,""));CKEDITOR.env.gecko&&a.enterMode!=CKEDITOR.ENTER_BR&&(CKEDITOR.env.gecko&&(b=b.replace(/^<br><br>$/,"\x3cbr\x3e")),-1<b.indexOf("\x3cbr\x3e\x3cbr\x3e")&&(b="\x3cp\x3e"+b.replace(/(<br>){2,}/g,function(a){return c(a.length/4);})+"\x3c/p\x3e"));return m(a,b);}function d(){function a(){var b={},c;for(c in CKEDITOR.dtd){"$"!=c.charAt(0)&&"div"!=c&&"span"!=c&&(b[c]=1);}return b;}var b={};return{get:function get(c){return"plain-text"==c?b.plainText||(b.plainText=new CKEDITOR.filter("br")):"semantic-content"==c?((c=b.semanticContent)||(c=new CKEDITOR.filter(),c.allow({$1:{elements:a(),attributes:!0,styles:!1,classes:!1}}),c=b.semanticContent=c),c):c?new CKEDITOR.filter(c):null;}};}function l(a,b,c){b=CKEDITOR.htmlParser.fragment.fromHtml(b);var d=new CKEDITOR.htmlParser.basicWriter();c.applyTo(b,!0,!1,a.activeEnterMode);b.writeHtml(d);return d.getHtml();}function m(a,b){a.enterMode==CKEDITOR.ENTER_BR?b=b.replace(/(<\/p><p>)+/g,function(a){return CKEDITOR.tools.repeat("\x3cbr\x3e",a.length/7*2);}).replace(/<\/?p>/g,""):a.enterMode==CKEDITOR.ENTER_DIV&&(b=b.replace(/<(\/)?p>/g,"\x3c$1div\x3e"));return b;}function f(a){a.data.preventDefault();a.data.$.dataTransfer.dropEffect="none";}function h(b){var c=CKEDITOR.plugins.clipboard;b.on("contentDom",function(){function d(c,f,e){f.select();a(b,{dataTransfer:e,method:"drop"},1);e.sourceEditor.fire("saveSnapshot");e.sourceEditor.editable().extractHtmlFromRange(c);e.sourceEditor.getSelection().selectRanges([c]);e.sourceEditor.fire("saveSnapshot");}function f(d,e){d.select();a(b,{dataTransfer:e,method:"drop"},1);c.resetDragDataTransfer();}function e(a,c,d){var f={$:a.data.$,target:a.data.getTarget()};c&&(f.dragRange=c);d&&(f.dropRange=d);!1===b.fire(a.name,f)&&a.data.preventDefault();}function h(a){a.type!=CKEDITOR.NODE_ELEMENT&&(a=a.getParent());return a.getChildCount();}var k=b.editable(),l=CKEDITOR.plugins.clipboard.getDropTarget(b),m=b.ui.space("top"),A=b.ui.space("bottom");c.preventDefaultDropOnElement(m);c.preventDefaultDropOnElement(A);k.attachListener(l,"dragstart",e);k.attachListener(b,"dragstart",c.resetDragDataTransfer,c,null,1);k.attachListener(b,"dragstart",function(a){c.initDragDataTransfer(a,b);},null,null,2);k.attachListener(b,"dragstart",function(){var a=c.dragRange=b.getSelection().getRanges()[0];CKEDITOR.env.ie&&10>CKEDITOR.env.version&&(c.dragStartContainerChildCount=a?h(a.startContainer):null,c.dragEndContainerChildCount=a?h(a.endContainer):null);},null,null,100);k.attachListener(l,"dragend",e);k.attachListener(b,"dragend",c.initDragDataTransfer,c,null,1);k.attachListener(b,"dragend",c.resetDragDataTransfer,c,null,100);k.attachListener(l,"dragover",function(a){var b=a.data.getTarget();b&&b.is&&b.is("html")?a.data.preventDefault():CKEDITOR.env.ie&&CKEDITOR.plugins.clipboard.isFileApiSupported&&a.data.$.dataTransfer.types.contains("Files")&&a.data.preventDefault();});k.attachListener(l,"drop",function(a){if(!a.data.$.defaultPrevented){a.data.preventDefault();var d=a.data.getTarget();if(!d.isReadOnly()||d.type==CKEDITOR.NODE_ELEMENT&&d.is("html")){var d=c.getRangeAtDropPosition(a,b),f=c.dragRange;d&&e(a,f,d);}}},null,null,9999);k.attachListener(b,"drop",c.initDragDataTransfer,c,null,1);k.attachListener(b,"drop",function(a){if(a=a.data){var e=a.dropRange,h=a.dragRange,k=a.dataTransfer;k.getTransferType(b)==CKEDITOR.DATA_TRANSFER_INTERNAL?setTimeout(function(){c.internalDrop(h,e,k,b);},0):k.getTransferType(b)==CKEDITOR.DATA_TRANSFER_CROSS_EDITORS?d(h,e,k):f(e,k);}},null,null,9999);});}CKEDITOR.plugins.add("clipboard",{requires:"dialog",init:function init(a){var f,k=d();a.config.forcePasteAsPlainText?f="plain-text":a.config.pasteFilter?f=a.config.pasteFilter:!CKEDITOR.env.webkit||"pasteFilter"in a.config||(f="semantic-content");a.pasteFilter=k.get(f);e(a);h(a);CKEDITOR.dialog.add("paste",CKEDITOR.getUrl(this.path+"dialogs/paste.js"));a.on("paste",function(b){b.data.dataTransfer||(b.data.dataTransfer=new CKEDITOR.plugins.clipboard.dataTransfer());if(!b.data.dataValue){var c=b.data.dataTransfer,d=c.getData("text/html");if(d)b.data.dataValue=d,b.data.type="html";else if(d=c.getData("text/plain"))b.data.dataValue=a.editable().transformPlainTextToHtml(d),b.data.type="text";}},null,null,1);a.on("paste",function(a){var b=a.data.dataValue,c=CKEDITOR.dtd.$block;-1<b.indexOf("Apple-")&&(b=b.replace(/<span class="Apple-converted-space">&nbsp;<\/span>/gi," "),"html"!=a.data.type&&(b=b.replace(/<span class="Apple-tab-span"[^>]*>([^<]*)<\/span>/gi,function(a,b){return b.replace(/\t/g,"\x26nbsp;\x26nbsp; \x26nbsp;");})),-1<b.indexOf('\x3cbr class\x3d"Apple-interchange-newline"\x3e')&&(a.data.startsWithEOL=1,a.data.preSniffing="html",b=b.replace(/<br class="Apple-interchange-newline">/,"")),b=b.replace(/(<[^>]+) class="Apple-[^"]*"/gi,"$1"));if(b.match(/^<[^<]+cke_(editable|contents)/i)){var d,f,e=new CKEDITOR.dom.element("div");for(e.setHtml(b);1==e.getChildCount()&&(d=e.getFirst())&&d.type==CKEDITOR.NODE_ELEMENT&&(d.hasClass("cke_editable")||d.hasClass("cke_contents"));){e=f=d;}f&&(b=f.getHtml().replace(/<br>$/i,""));}CKEDITOR.env.ie?b=b.replace(/^&nbsp;(?: |\r\n)?<(\w+)/g,function(b,d){return d.toLowerCase()in c?(a.data.preSniffing="html","\x3c"+d):b;}):CKEDITOR.env.webkit?b=b.replace(/<\/(\w+)><div><br><\/div>$/,function(b,d){return d in c?(a.data.endsWithEOL=1,"\x3c/"+d+"\x3e"):b;}):CKEDITOR.env.gecko&&(b=b.replace(/(\s)<br>$/,"$1"));a.data.dataValue=b;},null,null,3);a.on("paste",function(d){d=d.data;var f=d.type,e=d.dataValue,h,m=a.config.clipboard_defaultContentType||"html",n=d.dataTransfer.getTransferType(a);h="html"==f||"html"==d.preSniffing?"html":b(e);"htmlifiedtext"==h&&(e=c(a.config,e));"text"==f&&"html"==h?e=l(a,e,k.get("plain-text")):n==CKEDITOR.DATA_TRANSFER_EXTERNAL&&a.pasteFilter&&!d.dontFilter&&(e=l(a,e,a.pasteFilter));d.startsWithEOL&&(e='\x3cbr data-cke-eol\x3d"1"\x3e'+e);d.endsWithEOL&&(e+='\x3cbr data-cke-eol\x3d"1"\x3e');"auto"==f&&(f="html"==h||"html"==m?"html":"text");d.type=f;d.dataValue=e;delete d.preSniffing;delete d.startsWithEOL;delete d.endsWithEOL;},null,null,6);a.on("paste",function(b){b=b.data;b.dataValue&&(a.insertHtml(b.dataValue,b.type,b.range),setTimeout(function(){a.fire("afterPaste");},0));},null,null,1E3);a.on("pasteDialog",function(b){setTimeout(function(){a.openDialog("paste",b.data);},0);});}});CKEDITOR.plugins.clipboard={isCustomCopyCutSupported:!CKEDITOR.env.ie&&!CKEDITOR.env.iOS,isCustomDataTypesSupported:!CKEDITOR.env.ie,isFileApiSupported:!CKEDITOR.env.ie||9<CKEDITOR.env.version,mainPasteEvent:CKEDITOR.env.ie&&!CKEDITOR.env.edge?"beforepaste":"paste",canClipboardApiBeTrusted:function canClipboardApiBeTrusted(a,b){return a.getTransferType(b)!=CKEDITOR.DATA_TRANSFER_EXTERNAL||CKEDITOR.env.chrome&&!a.isEmpty()||CKEDITOR.env.gecko&&(a.getData("text/html")||a.getFilesCount())?!0:!1;},getDropTarget:function getDropTarget(a){var b=a.editable();return CKEDITOR.env.ie&&9>CKEDITOR.env.version||b.isInline()?b:a.document;},fixSplitNodesAfterDrop:function fixSplitNodesAfterDrop(a,b,c,d){function f(a,c,d){var e=a;e.type==CKEDITOR.NODE_TEXT&&(e=a.getParent());if(e.equals(c)&&d!=c.getChildCount())return a=b.startContainer.getChild(b.startOffset-1),c=b.startContainer.getChild(b.startOffset),a&&a.type==CKEDITOR.NODE_TEXT&&c&&c.type==CKEDITOR.NODE_TEXT&&(d=a.getLength(),a.setText(a.getText()+c.getText()),c.remove(),b.setStart(a,d),b.collapse(!0)),!0;}var e=b.startContainer;"number"==typeof d&&"number"==typeof c&&e.type==CKEDITOR.NODE_ELEMENT&&(f(a.startContainer,e,c)||f(a.endContainer,e,d));},isDropRangeAffectedByDragRange:function isDropRangeAffectedByDragRange(a,b){var c=b.startContainer,d=b.endOffset;return a.endContainer.equals(c)&&a.endOffset<=d||a.startContainer.getParent().equals(c)&&a.startContainer.getIndex()<d||a.endContainer.getParent().equals(c)&&a.endContainer.getIndex()<d?!0:!1;},internalDrop:function internalDrop(b,c,d,f){var e=CKEDITOR.plugins.clipboard,h=f.editable(),k,l;f.fire("saveSnapshot");f.fire("lockSnapshot",{dontUpdate:1});CKEDITOR.env.ie&&10>CKEDITOR.env.version&&this.fixSplitNodesAfterDrop(b,c,e.dragStartContainerChildCount,e.dragEndContainerChildCount);(l=this.isDropRangeAffectedByDragRange(b,c))||(k=b.createBookmark(!1));e=c.clone().createBookmark(!1);l&&(k=b.createBookmark(!1));b=k.startNode;c=k.endNode;l=e.startNode;c&&b.getPosition(l)&CKEDITOR.POSITION_PRECEDING&&c.getPosition(l)&CKEDITOR.POSITION_FOLLOWING&&l.insertBefore(b);b=f.createRange();b.moveToBookmark(k);h.extractHtmlFromRange(b,1);c=f.createRange();c.moveToBookmark(e);a(f,{dataTransfer:d,method:"drop",range:c},1);f.fire("unlockSnapshot");},getRangeAtDropPosition:function getRangeAtDropPosition(a,b){var c=a.data.$,d=c.clientX,f=c.clientY,e=b.getSelection(!0).getRanges()[0],h=b.createRange();if(a.data.testRange)return a.data.testRange;if(document.caretRangeFromPoint)c=b.document.$.caretRangeFromPoint(d,f),h.setStart(CKEDITOR.dom.node(c.startContainer),c.startOffset),h.collapse(!0);else if(c.rangeParent)h.setStart(CKEDITOR.dom.node(c.rangeParent),c.rangeOffset),h.collapse(!0);else{if(CKEDITOR.env.ie&&8<CKEDITOR.env.version&&e&&b.editable().hasFocus)return e;if(document.body.createTextRange){b.focus();c=b.document.getBody().$.createTextRange();try{for(var k=!1,l=0;20>l&&!k;l++){if(!k)try{c.moveToPoint(d,f-l),k=!0;}catch(m){}if(!k)try{c.moveToPoint(d,f+l),k=!0;}catch(u){}}if(k){var x="cke-temp-"+new Date().getTime();c.pasteHTML('\x3cspan id\x3d"'+x+'"\x3e​\x3c/span\x3e');var D=b.document.getById(x);h.moveToPosition(D,CKEDITOR.POSITION_BEFORE_START);D.remove();}else{var y=b.document.$.elementFromPoint(d,f),B=new CKEDITOR.dom.element(y),C;if(B.equals(b.editable())||"html"==B.getName())return e&&e.startContainer&&!e.startContainer.equals(b.editable())?e:null;C=B.getClientRect();d<C.left?h.setStartAt(B,CKEDITOR.POSITION_AFTER_START):h.setStartAt(B,CKEDITOR.POSITION_BEFORE_END);h.collapse(!0);}}catch(F){return null;}}else return null;}return h;},initDragDataTransfer:function initDragDataTransfer(a,b){var c=a.data.$?a.data.$.dataTransfer:null,d=new this.dataTransfer(c,b);c?this.dragData&&d.id==this.dragData.id?d=this.dragData:this.dragData=d:this.dragData?d=this.dragData:this.dragData=d;a.data.dataTransfer=d;},resetDragDataTransfer:function resetDragDataTransfer(){this.dragData=null;},initPasteDataTransfer:function initPasteDataTransfer(a,b){if(this.isCustomCopyCutSupported){if(a&&a.data&&a.data.$){var c=new this.dataTransfer(a.data.$.clipboardData,b);this.copyCutData&&c.id==this.copyCutData.id?(c=this.copyCutData,c.$=a.data.$.clipboardData):this.copyCutData=c;return c;}return new this.dataTransfer(null,b);}return new this.dataTransfer(CKEDITOR.env.edge&&a&&a.data.$&&a.data.$.clipboardData||null,b);},preventDefaultDropOnElement:function preventDefaultDropOnElement(a){a&&a.on("dragover",f);}};var k=CKEDITOR.plugins.clipboard.isCustomDataTypesSupported?"cke/id":"Text";CKEDITOR.plugins.clipboard.dataTransfer=function(a,b){a&&(this.$=a);this._={metaRegExp:/^<meta.*?>/i,bodyRegExp:/<body(?:[\s\S]*?)>([\s\S]*)<\/body>/i,fragmentRegExp:/\x3c!--(?:Start|End)Fragment--\x3e/g,data:{},files:[],normalizeType:function normalizeType(a){a=a.toLowerCase();return"text"==a||"text/plain"==a?"Text":"url"==a?"URL":a;}};this.id=this.getData(k);this.id||(this.id="Text"==k?"":"cke-"+CKEDITOR.tools.getUniqueId());if("Text"!=k)try{this.$.setData(k,this.id);}catch(c){}b&&(this.sourceEditor=b,this.setData("text/html",b.getSelectedHtml(1)),"Text"==k||this.getData("text/plain")||this.setData("text/plain",b.getSelection().getSelectedText()));};CKEDITOR.DATA_TRANSFER_INTERNAL=1;CKEDITOR.DATA_TRANSFER_CROSS_EDITORS=2;CKEDITOR.DATA_TRANSFER_EXTERNAL=3;CKEDITOR.plugins.clipboard.dataTransfer.prototype={getData:function getData(a){a=this._.normalizeType(a);var b=this._.data[a];if(void 0===b||null===b||""===b)try{b=this.$.getData(a);}catch(c){}if(void 0===b||null===b||""===b)b="";"text/html"==a?(b=b.replace(this._.metaRegExp,""),(a=this._.bodyRegExp.exec(b))&&a.length&&(b=a[1],b=b.replace(this._.fragmentRegExp,""))):"Text"==a&&CKEDITOR.env.gecko&&this.getFilesCount()&&"file://"==b.substring(0,7)&&(b="");return b;},setData:function setData(a,b){a=this._.normalizeType(a);this._.data[a]=b;if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported||"URL"==a||"Text"==a){"Text"==k&&"Text"==a&&(this.id=b);try{this.$.setData(a,b);}catch(c){}}},getTransferType:function getTransferType(a){return this.sourceEditor?this.sourceEditor==a?CKEDITOR.DATA_TRANSFER_INTERNAL:CKEDITOR.DATA_TRANSFER_CROSS_EDITORS:CKEDITOR.DATA_TRANSFER_EXTERNAL;},cacheData:function cacheData(){function a(c){c=b._.normalizeType(c);var d=b.getData(c);d&&(b._.data[c]=d);}if(this.$){var b=this,c,d;if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported){if(this.$.types)for(c=0;c<this.$.types.length;c++){a(this.$.types[c]);}}else a("Text"),a("URL");d=this._getImageFromClipboard();if(this.$&&this.$.files||d){this._.files=[];if(this.$.files&&this.$.files.length)for(c=0;c<this.$.files.length;c++){this._.files.push(this.$.files[c]);}0===this._.files.length&&d&&this._.files.push(d);}}},getFilesCount:function getFilesCount(){return this._.files.length?this._.files.length:this.$&&this.$.files&&this.$.files.length?this.$.files.length:this._getImageFromClipboard()?1:0;},getFile:function getFile(a){return this._.files.length?this._.files[a]:this.$&&this.$.files&&this.$.files.length?this.$.files[a]:0===a?this._getImageFromClipboard():void 0;},isEmpty:function isEmpty(){var a={},b;if(this.getFilesCount())return!1;for(b in this._.data){a[b]=1;}if(this.$)if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported){if(this.$.types)for(var c=0;c<this.$.types.length;c++){a[this.$.types[c]]=1;}}else a.Text=1,a.URL=1;"Text"!=k&&(a[k]=0);for(b in a){if(a[b]&&""!==this.getData(b))return!1;}return!0;},_getImageFromClipboard:function _getImageFromClipboard(){var a;if(this.$&&this.$.items&&this.$.items[0])try{if((a=this.$.items[0].getAsFile())&&a.type)return a;}catch(b){}}};}(),function(){CKEDITOR.plugins.add("panel",{beforeInit:function beforeInit(a){a.ui.addHandler(CKEDITOR.UI_PANEL,CKEDITOR.ui.panel.handler);}});CKEDITOR.UI_PANEL="panel";CKEDITOR.ui.panel=function(a,b){b&&CKEDITOR.tools.extend(this,b);CKEDITOR.tools.extend(this,{className:"",css:[]});this.id=CKEDITOR.tools.getNextId();this.document=a;this.isFramed=this.forceIFrame||this.css.length;this._={blocks:{}};};CKEDITOR.ui.panel.handler={create:function create(a){return new CKEDITOR.ui.panel(a);}};var a=CKEDITOR.addTemplate("panel",'\x3cdiv lang\x3d"{langCode}" id\x3d"{id}" dir\x3d{dir} class\x3d"cke cke_reset_all {editorId} cke_panel cke_panel {cls} cke_{dir}" style\x3d"z-index:{z-index}" role\x3d"presentation"\x3e{frame}\x3c/div\x3e'),e=CKEDITOR.addTemplate("panel-frame",'\x3ciframe id\x3d"{id}" class\x3d"cke_panel_frame" role\x3d"presentation" frameborder\x3d"0" src\x3d"{src}"\x3e\x3c/iframe\x3e'),b=CKEDITOR.addTemplate("panel-frame-inner",'\x3c!DOCTYPE html\x3e\x3chtml class\x3d"cke_panel_container {env}" dir\x3d"{dir}" lang\x3d"{langCode}"\x3e\x3chead\x3e{css}\x3c/head\x3e\x3cbody class\x3d"cke_{dir}" style\x3d"margin:0;padding:0" onload\x3d"{onload}"\x3e\x3c/body\x3e\x3c/html\x3e');CKEDITOR.ui.panel.prototype={render:function render(c,d){this.getHolderElement=function(){var a=this._.holder;if(!a){if(this.isFramed){var a=this.document.getById(this.id+"_frame"),c=a.getParent(),a=a.getFrameDocument();CKEDITOR.env.iOS&&c.setStyles({overflow:"scroll","-webkit-overflow-scrolling":"touch"});c=CKEDITOR.tools.addFunction(CKEDITOR.tools.bind(function(){this.isLoaded=!0;if(this.onLoad)this.onLoad();},this));a.write(b.output(CKEDITOR.tools.extend({css:CKEDITOR.tools.buildStyleHtml(this.css),onload:"window.parent.CKEDITOR.tools.callFunction("+c+");"},l)));a.getWindow().$.CKEDITOR=CKEDITOR;a.on("keydown",function(a){var b=a.data.getKeystroke(),c=this.document.getById(this.id).getAttribute("dir");this._.onKeyDown&&!1===this._.onKeyDown(b)?a.data.preventDefault():(27==b||b==("rtl"==c?39:37))&&this.onEscape&&!1===this.onEscape(b)&&a.data.preventDefault();},this);a=a.getBody();a.unselectable();CKEDITOR.env.air&&CKEDITOR.tools.callFunction(c);}else a=this.document.getById(this.id);this._.holder=a;}return a;};var l={editorId:c.id,id:this.id,langCode:c.langCode,dir:c.lang.dir,cls:this.className,frame:"",env:CKEDITOR.env.cssClass,"z-index":c.config.baseFloatZIndex+1};if(this.isFramed){var m=CKEDITOR.env.air?"javascript:void(0)":CKEDITOR.env.ie?"javascript:void(function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.close();")+"}())":"";l.frame=e.output({id:this.id+"_frame",src:m});}m=a.output(l);d&&d.push(m);return m;},addBlock:function addBlock(a,b){b=this._.blocks[a]=b instanceof CKEDITOR.ui.panel.block?b:new CKEDITOR.ui.panel.block(this.getHolderElement(),b);this._.currentBlock||this.showBlock(a);return b;},getBlock:function getBlock(a){return this._.blocks[a];},showBlock:function showBlock(a){a=this._.blocks[a];var b=this._.currentBlock,e=!this.forceIFrame||CKEDITOR.env.ie?this._.holder:this.document.getById(this.id+"_frame");b&&b.hide();this._.currentBlock=a;CKEDITOR.fire("ariaWidget",e);a._.focusIndex=-1;this._.onKeyDown=a.onKeyDown&&CKEDITOR.tools.bind(a.onKeyDown,a);a.show();return a;},destroy:function destroy(){this.element&&this.element.remove();}};CKEDITOR.ui.panel.block=CKEDITOR.tools.createClass({$:function $(a,b){this.element=a.append(a.getDocument().createElement("div",{attributes:{tabindex:-1,"class":"cke_panel_block"},styles:{display:"none"}}));b&&CKEDITOR.tools.extend(this,b);this.element.setAttributes({role:this.attributes.role||"presentation","aria-label":this.attributes["aria-label"],title:this.attributes.title||this.attributes["aria-label"]});this.keys={};this._.focusIndex=-1;this.element.disableContextMenu();},_:{markItem:function markItem(a){-1!=a&&(a=this.element.getElementsByTag("a").getItem(this._.focusIndex=a),CKEDITOR.env.webkit&&a.getDocument().getWindow().focus(),a.focus(),this.onMark&&this.onMark(a));}},proto:{show:function show(){this.element.setStyle("display","");},hide:function hide(){this.onHide&&!0===this.onHide.call(this)||this.element.setStyle("display","none");},onKeyDown:function onKeyDown(a,b){var e=this.keys[a];switch(e){case"next":for(var m=this._.focusIndex,e=this.element.getElementsByTag("a"),f;f=e.getItem(++m);){if(f.getAttribute("_cke_focus")&&f.$.offsetWidth){this._.focusIndex=m;f.focus();break;}}return f||b?!1:(this._.focusIndex=-1,this.onKeyDown(a,1));case"prev":m=this._.focusIndex;for(e=this.element.getElementsByTag("a");0<m&&(f=e.getItem(--m));){if(f.getAttribute("_cke_focus")&&f.$.offsetWidth){this._.focusIndex=m;f.focus();break;}f=null;}return f||b?!1:(this._.focusIndex=e.count(),this.onKeyDown(a,1));case"click":case"mouseup":return m=this._.focusIndex,(f=0<=m&&this.element.getElementsByTag("a").getItem(m))&&(f.$[e]?f.$[e]():f.$["on"+e]()),!1;}return!0;}}});}(),CKEDITOR.plugins.add("floatpanel",{requires:"panel"}),function(){function a(a,c,d,l,m){m=CKEDITOR.tools.genKey(c.getUniqueId(),d.getUniqueId(),a.lang.dir,a.uiColor||"",l.css||"",m||"");var f=e[m];f||(f=e[m]=new CKEDITOR.ui.panel(c,l),f.element=d.append(CKEDITOR.dom.element.createFromHtml(f.render(a),c)),f.element.setStyles({display:"none",position:"absolute"}));return f;}var e={};CKEDITOR.ui.floatPanel=CKEDITOR.tools.createClass({$:function $(b,c,d,e){function m(){g.hide();}d.forceIFrame=1;d.toolbarRelated&&b.elementMode==CKEDITOR.ELEMENT_MODE_INLINE&&(c=CKEDITOR.document.getById("cke_"+b.name));var f=c.getDocument();e=a(b,f,c,d,e||0);var h=e.element,k=h.getFirst(),g=this;h.disableContextMenu();this.element=h;this._={editor:b,panel:e,parentElement:c,definition:d,document:f,iframe:k,children:[],dir:b.lang.dir,showBlockParams:null};b.on("mode",m);b.on("resize",m);f.getWindow().on("resize",function(){this.reposition();},this);},proto:{addBlock:function addBlock(a,c){return this._.panel.addBlock(a,c);},addListBlock:function addListBlock(a,c){return this._.panel.addListBlock(a,c);},getBlock:function getBlock(a){return this._.panel.getBlock(a);},showBlock:function showBlock(a,c,d,e,m,f){var h=this._.panel,k=h.showBlock(a);this._.showBlockParams=[].slice.call(arguments);this.allowBlur(!1);var g=this._.editor.editable();this._.returnFocus=g.hasFocus?g:new CKEDITOR.dom.element(CKEDITOR.document.$.activeElement);this._.hideTimeout=0;var n=this.element,g=this._.iframe,g=CKEDITOR.env.ie&&!CKEDITOR.env.edge?g:new CKEDITOR.dom.window(g.$.contentWindow),v=n.getDocument(),r=this._.parentElement.getPositionedAncestor(),q=c.getDocumentPosition(v),v=r?r.getDocumentPosition(v):{x:0,y:0},t="rtl"==this._.dir,p=q.x+(e||0)-v.x,w=q.y+(m||0)-v.y;!t||1!=d&&4!=d?t||2!=d&&3!=d||(p+=c.$.offsetWidth-1):p+=c.$.offsetWidth;if(3==d||4==d)w+=c.$.offsetHeight-1;this._.panel._.offsetParentId=c.getId();n.setStyles({top:w+"px",left:0,display:""});n.setOpacity(0);n.getFirst().removeStyle("width");this._.editor.focusManager.add(g);this._.blurSet||(CKEDITOR.event.useCapture=!0,g.on("blur",function(a){function b(){delete this._.returnFocus;this.hide();}this.allowBlur()&&a.data.getPhase()==CKEDITOR.EVENT_PHASE_AT_TARGET&&this.visible&&!this._.activeChild&&(CKEDITOR.env.iOS?this._.hideTimeout||(this._.hideTimeout=CKEDITOR.tools.setTimeout(b,0,this)):b.call(this));},this),g.on("focus",function(){this._.focused=!0;this.hideChild();this.allowBlur(!0);},this),CKEDITOR.env.iOS&&(g.on("touchstart",function(){clearTimeout(this._.hideTimeout);},this),g.on("touchend",function(){this._.hideTimeout=0;this.focus();},this)),CKEDITOR.event.useCapture=!1,this._.blurSet=1);h.onEscape=CKEDITOR.tools.bind(function(a){if(this.onEscape&&!1===this.onEscape(a))return!1;},this);CKEDITOR.tools.setTimeout(function(){var a=CKEDITOR.tools.bind(function(){var a=n;a.removeStyle("width");if(k.autoSize){var b=k.element.getDocument(),b=(CKEDITOR.env.webkit||CKEDITOR.env.edge?k.element:b.getBody()).$.scrollWidth;CKEDITOR.env.ie&&CKEDITOR.env.quirks&&0<b&&(b+=(a.$.offsetWidth||0)-(a.$.clientWidth||0)+3);a.setStyle("width",b+10+"px");b=k.element.$.scrollHeight;CKEDITOR.env.ie&&CKEDITOR.env.quirks&&0<b&&(b+=(a.$.offsetHeight||0)-(a.$.clientHeight||0)+3);a.setStyle("height",b+"px");h._.currentBlock.element.setStyle("display","none").removeStyle("display");}else a.removeStyle("height");t&&(p-=n.$.offsetWidth);n.setStyle("left",p+"px");var b=h.element.getWindow(),a=n.$.getBoundingClientRect(),b=b.getViewPaneSize(),c=a.width||a.right-a.left,d=a.height||a.bottom-a.top,e=t?a.right:b.width-a.left,g=t?b.width-a.right:a.left;t?e<c&&(p=g>c?p+c:b.width>c?p-a.left:p-a.right+b.width):e<c&&(p=g>c?p-c:b.width>c?p-a.right+b.width:p-a.left);c=a.top;b.height-a.top<d&&(w=c>d?w-d:b.height>d?w-a.bottom+b.height:w-a.top);CKEDITOR.env.ie&&(b=a=new CKEDITOR.dom.element(n.$.offsetParent),"html"==b.getName()&&(b=b.getDocument().getBody()),"rtl"==b.getComputedStyle("direction")&&(p=CKEDITOR.env.ie8Compat?p-2*n.getDocument().getDocumentElement().$.scrollLeft:p-(a.$.scrollWidth-a.$.clientWidth)));var a=n.getFirst(),l;(l=a.getCustomData("activePanel"))&&l.onHide&&l.onHide.call(this,1);a.setCustomData("activePanel",this);n.setStyles({top:w+"px",left:p+"px"});n.setOpacity(1);f&&f();},this);h.isLoaded?a():h.onLoad=a;CKEDITOR.tools.setTimeout(function(){var a=CKEDITOR.env.webkit&&CKEDITOR.document.getWindow().getScrollPosition().y;this.focus();k.element.focus();CKEDITOR.env.webkit&&(CKEDITOR.document.getBody().$.scrollTop=a);this.allowBlur(!0);this._.editor.fire("panelShow",this);},0,this);},CKEDITOR.env.air?200:0,this);this.visible=1;this.onShow&&this.onShow.call(this);},reposition:function reposition(){var a=this._.showBlockParams;this.visible&&this._.showBlockParams&&(this.hide(),this.showBlock.apply(this,a));},focus:function focus(){if(CKEDITOR.env.webkit){var a=CKEDITOR.document.getActive();a&&!a.equals(this._.iframe)&&a.$.blur();}(this._.lastFocused||this._.iframe.getFrameDocument().getWindow()).focus();},blur:function blur(){var a=this._.iframe.getFrameDocument().getActive();a&&a.is("a")&&(this._.lastFocused=a);},hide:function hide(a){if(this.visible&&(!this.onHide||!0!==this.onHide.call(this))){this.hideChild();CKEDITOR.env.gecko&&this._.iframe.getFrameDocument().$.activeElement.blur();this.element.setStyle("display","none");this.visible=0;this.element.getFirst().removeCustomData("activePanel");if(a=a&&this._.returnFocus)CKEDITOR.env.webkit&&a.type&&a.getWindow().$.focus(),a.focus();delete this._.lastFocused;this._.showBlockParams=null;this._.editor.fire("panelHide",this);}},allowBlur:function allowBlur(a){var c=this._.panel;void 0!==a&&(c.allowBlur=a);return c.allowBlur;},showAsChild:function showAsChild(a,c,d,e,m,f){if(this._.activeChild!=a||a._.panel._.offsetParentId!=d.getId())this.hideChild(),a.onHide=CKEDITOR.tools.bind(function(){CKEDITOR.tools.setTimeout(function(){this._.focused||this.hide();},0,this);},this),this._.activeChild=a,this._.focused=!1,a.showBlock(c,d,e,m,f),this.blur(),(CKEDITOR.env.ie7Compat||CKEDITOR.env.ie6Compat)&&setTimeout(function(){a.element.getChild(0).$.style.cssText+="";},100);},hideChild:function hideChild(a){var c=this._.activeChild;c&&(delete c.onHide,delete this._.activeChild,c.hide(),a&&this.focus());}}});CKEDITOR.on("instanceDestroyed",function(){var a=CKEDITOR.tools.isEmpty(CKEDITOR.instances),c;for(c in e){var d=e[c];a?d.destroy():d.element.hide();}a&&(e={});});}(),CKEDITOR.plugins.add("menu",{requires:"floatpanel",beforeInit:function beforeInit(a){for(var e=a.config.menu_groups.split(","),b=a._.menuGroups={},c=a._.menuItems={},d=0;d<e.length;d++){b[e[d]]=d+1;}a.addMenuGroup=function(a,c){b[a]=c||100;};a.addMenuItem=function(a,d){b[d.group]&&(c[a]=new CKEDITOR.menuItem(this,a,d));};a.addMenuItems=function(a){for(var b in a){this.addMenuItem(b,a[b]);}};a.getMenuItem=function(a){return c[a];};a.removeMenuItem=function(a){delete c[a];};}}),function(){function a(a){a.sort(function(a,b){return a.group<b.group?-1:a.group>b.group?1:a.order<b.order?-1:a.order>b.order?1:0;});}var e='\x3cspan class\x3d"cke_menuitem"\x3e\x3ca id\x3d"{id}" class\x3d"cke_menubutton cke_menubutton__{name} cke_menubutton_{state} {cls}" href\x3d"{href}" title\x3d"{title}" tabindex\x3d"-1"_cke_focus\x3d1 hidefocus\x3d"true" role\x3d"{role}" aria-haspopup\x3d"{hasPopup}" aria-disabled\x3d"{disabled}" {ariaChecked}';CKEDITOR.env.gecko&&CKEDITOR.env.mac&&(e+=' onkeypress\x3d"return false;"');CKEDITOR.env.gecko&&(e+=' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');var e=e+(' onmouseover\x3d"CKEDITOR.tools.callFunction({hoverFn},{index});" onmouseout\x3d"CKEDITOR.tools.callFunction({moveOutFn},{index});" '+(CKEDITOR.env.ie?'onclick\x3d"return false;" onmouseup':"onclick")+'\x3d"CKEDITOR.tools.callFunction({clickFn},{index}); return false;"\x3e'),b=CKEDITOR.addTemplate("menuItem",e+'\x3cspan class\x3d"cke_menubutton_inner"\x3e\x3cspan class\x3d"cke_menubutton_icon"\x3e\x3cspan class\x3d"cke_button_icon cke_button__{iconName}_icon" style\x3d"{iconStyle}"\x3e\x3c/span\x3e\x3c/span\x3e\x3cspan class\x3d"cke_menubutton_label"\x3e{label}\x3c/span\x3e{arrowHtml}\x3c/span\x3e\x3c/a\x3e\x3c/span\x3e'),c=CKEDITOR.addTemplate("menuArrow",'\x3cspan class\x3d"cke_menuarrow"\x3e\x3cspan\x3e{label}\x3c/span\x3e\x3c/span\x3e');CKEDITOR.menu=CKEDITOR.tools.createClass({$:function $(a,b){b=this._.definition=b||{};this.id=CKEDITOR.tools.getNextId();this.editor=a;this.items=[];this._.listeners=[];this._.level=b.level||1;var c=CKEDITOR.tools.extend({},b.panel,{css:[CKEDITOR.skin.getPath("editor")],level:this._.level-1,block:{}}),f=c.block.attributes=c.attributes||{};!f.role&&(f.role="menu");this._.panelDefinition=c;},_:{onShow:function onShow(){var a=this.editor.getSelection(),b=a&&a.getStartElement(),c=this.editor.elementPath(),f=this._.listeners;this.removeAll();for(var e=0;e<f.length;e++){var k=f[e](b,a,c);if(k)for(var g in k){var n=this.editor.getMenuItem(g);!n||n.command&&!this.editor.getCommand(n.command).state||(n.state=k[g],this.add(n));}}},onClick:function onClick(a){this.hide();if(a.onClick)a.onClick();else a.command&&this.editor.execCommand(a.command);},onEscape:function onEscape(a){var b=this.parent;b?b._.panel.hideChild(1):27==a&&this.hide(1);return!1;},onHide:function onHide(){this.onHide&&this.onHide();},showSubMenu:function showSubMenu(a){var b=this._.subMenu,c=this.items[a];if(c=c.getItems&&c.getItems()){b?b.removeAll():(b=this._.subMenu=new CKEDITOR.menu(this.editor,CKEDITOR.tools.extend({},this._.definition,{level:this._.level+1},!0)),b.parent=this,b._.onClick=CKEDITOR.tools.bind(this._.onClick,this));for(var f in c){var e=this.editor.getMenuItem(f);e&&(e.state=c[f],b.add(e));}var k=this._.panel.getBlock(this.id).element.getDocument().getById(this.id+String(a));setTimeout(function(){b.show(k,2);},0);}else this._.panel.hideChild(1);}},proto:{add:function add(a){a.order||(a.order=this.items.length);this.items.push(a);},removeAll:function removeAll(){this.items=[];},show:function show(b,c,e,f){if(!this.parent&&(this._.onShow(),!this.items.length))return;c=c||("rtl"==this.editor.lang.dir?2:1);var h=this.items,k=this.editor,g=this._.panel,n=this._.element;if(!g){g=this._.panel=new CKEDITOR.ui.floatPanel(this.editor,CKEDITOR.document.getBody(),this._.panelDefinition,this._.level);g.onEscape=CKEDITOR.tools.bind(function(a){if(!1===this._.onEscape(a))return!1;},this);g.onShow=function(){g._.panel.getHolderElement().getParent().addClass("cke").addClass("cke_reset_all");};g.onHide=CKEDITOR.tools.bind(function(){this._.onHide&&this._.onHide();},this);n=g.addBlock(this.id,this._.panelDefinition.block);n.autoSize=!0;var v=n.keys;v[40]="next";v[9]="next";v[38]="prev";v[CKEDITOR.SHIFT+9]="prev";v["rtl"==k.lang.dir?37:39]=CKEDITOR.env.ie?"mouseup":"click";v[32]=CKEDITOR.env.ie?"mouseup":"click";CKEDITOR.env.ie&&(v[13]="mouseup");n=this._.element=n.element;v=n.getDocument();v.getBody().setStyle("overflow","hidden");v.getElementsByTag("html").getItem(0).setStyle("overflow","hidden");this._.itemOverFn=CKEDITOR.tools.addFunction(function(a){clearTimeout(this._.showSubTimeout);this._.showSubTimeout=CKEDITOR.tools.setTimeout(this._.showSubMenu,k.config.menu_subMenuDelay||400,this,[a]);},this);this._.itemOutFn=CKEDITOR.tools.addFunction(function(){clearTimeout(this._.showSubTimeout);},this);this._.itemClickFn=CKEDITOR.tools.addFunction(function(a){var b=this.items[a];if(b.state==CKEDITOR.TRISTATE_DISABLED)this.hide(1);else if(b.getItems)this._.showSubMenu(a);else this._.onClick(b);},this);}a(h);for(var v=k.elementPath(),v=['\x3cdiv class\x3d"cke_menu'+(v&&v.direction()!=k.lang.dir?" cke_mixed_dir_content":"")+'" role\x3d"presentation"\x3e'],r=h.length,q=r&&h[0].group,t=0;t<r;t++){var p=h[t];q!=p.group&&(v.push('\x3cdiv class\x3d"cke_menuseparator" role\x3d"separator"\x3e\x3c/div\x3e'),q=p.group);p.render(this,t,v);}v.push("\x3c/div\x3e");n.setHtml(v.join(""));CKEDITOR.ui.fire("ready",this);this.parent?this.parent._.panel.showAsChild(g,this.id,b,c,e,f):g.showBlock(this.id,b,c,e,f);k.fire("menuShow",[g]);},addListener:function addListener(a){this._.listeners.push(a);},hide:function hide(a){this._.onHide&&this._.onHide();this._.panel&&this._.panel.hide(a);}}});CKEDITOR.menuItem=CKEDITOR.tools.createClass({$:function $(a,b,c){CKEDITOR.tools.extend(this,c,{order:0,className:"cke_menubutton__"+b});this.group=a._.menuGroups[this.group];this.editor=a;this.name=b;},proto:{render:function render(a,e,m){var f=a.id+String(e),h="undefined"==typeof this.state?CKEDITOR.TRISTATE_OFF:this.state,k="",g=h==CKEDITOR.TRISTATE_ON?"on":h==CKEDITOR.TRISTATE_DISABLED?"disabled":"off";this.role in{menuitemcheckbox:1,menuitemradio:1}&&(k=' aria-checked\x3d"'+(h==CKEDITOR.TRISTATE_ON?"true":"false")+'"');var n=this.getItems,v="\x26#"+("rtl"==this.editor.lang.dir?"9668":"9658")+";",r=this.name;this.icon&&!/\./.test(this.icon)&&(r=this.icon);a={id:f,name:this.name,iconName:r,label:this.label,cls:this.className||"",state:g,hasPopup:n?"true":"false",disabled:h==CKEDITOR.TRISTATE_DISABLED,title:this.label,href:"javascript:void('"+(this.label||"").replace("'")+"')",hoverFn:a._.itemOverFn,moveOutFn:a._.itemOutFn,clickFn:a._.itemClickFn,index:e,iconStyle:CKEDITOR.skin.getIconStyle(r,"rtl"==this.editor.lang.dir,r==this.icon?null:this.icon,this.iconOffset),arrowHtml:n?c.output({label:v}):"",role:this.role?this.role:"menuitem",ariaChecked:k};b.output(a,m);}}});}(),CKEDITOR.config.menu_groups="clipboard,form,tablecell,tablecellproperties,tablerow,tablecolumn,table,anchor,link,image,flash,checkbox,radio,textfield,hiddenfield,imagebutton,button,select,textarea,div",CKEDITOR.plugins.add("contextmenu",{requires:"menu",onLoad:function onLoad(){CKEDITOR.plugins.contextMenu=CKEDITOR.tools.createClass({base:CKEDITOR.menu,$:function $(a){this.base.call(this,a,{panel:{className:"cke_menu_panel",attributes:{"aria-label":a.lang.contextmenu.options}}});},proto:{addTarget:function addTarget(a,e){a.on("contextmenu",function(a){a=a.data;var c=CKEDITOR.env.webkit?b:CKEDITOR.env.mac?a.$.metaKey:a.$.ctrlKey;if(!e||!c){a.preventDefault();if(CKEDITOR.env.mac&&CKEDITOR.env.webkit){var c=this.editor,m=new CKEDITOR.dom.elementPath(a.getTarget(),c.editable()).contains(function(a){return a.hasAttribute("contenteditable");},!0);m&&"false"==m.getAttribute("contenteditable")&&c.getSelection().fake(m);}var m=a.getTarget().getDocument(),f=a.getTarget().getDocument().getDocumentElement(),c=!m.equals(CKEDITOR.document),m=m.getWindow().getScrollPosition(),h=c?a.$.clientX:a.$.pageX||m.x+a.$.clientX,k=c?a.$.clientY:a.$.pageY||m.y+a.$.clientY;CKEDITOR.tools.setTimeout(function(){this.open(f,null,h,k);},CKEDITOR.env.ie?200:0,this);}},this);if(CKEDITOR.env.webkit){var b,c=function c(){b=0;};a.on("keydown",function(a){b=CKEDITOR.env.mac?a.data.$.metaKey:a.data.$.ctrlKey;});a.on("keyup",c);a.on("contextmenu",c);}},open:function open(a,e,b,c){this.editor.focus();a=a||CKEDITOR.document.getDocumentElement();this.editor.selectionChange(1);this.show(a,e,b,c);}}});},beforeInit:function beforeInit(a){var e=a.contextMenu=new CKEDITOR.plugins.contextMenu(a);a.on("contentDom",function(){e.addTarget(a.editable(),!1!==a.config.browserContextMenuOnCtrl);});a.addCommand("contextMenu",{exec:function exec(){a.contextMenu.open(a.document.getBody());}});a.setKeystroke(CKEDITOR.SHIFT+121,"contextMenu");a.setKeystroke(CKEDITOR.CTRL+CKEDITOR.SHIFT+121,"contextMenu");}}),function(){function a(a,b){function m(b){b=g.list[b];var c;b.equals(a.editable())||"true"==b.getAttribute("contenteditable")?(c=a.createRange(),c.selectNodeContents(b),c=c.select()):(c=a.getSelection(),c.selectElement(b));CKEDITOR.env.ie&&a.fire("selectionChange",{selection:c,path:new CKEDITOR.dom.elementPath(b)});a.focus();}function f(){k&&k.setHtml('\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e');delete g.list;}var h=a.ui.spaceId("path"),k,g=a._.elementsPath,n=g.idBase;b.html+='\x3cspan id\x3d"'+h+'_label" class\x3d"cke_voice_label"\x3e'+a.lang.elementspath.eleLabel+'\x3c/span\x3e\x3cspan id\x3d"'+h+'" class\x3d"cke_path" role\x3d"group" aria-labelledby\x3d"'+h+'_label"\x3e\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e\x3c/span\x3e';a.on("uiReady",function(){var b=a.ui.space("path");b&&a.focusManager.add(b,1);});g.onClick=m;var v=CKEDITOR.tools.addFunction(m),r=CKEDITOR.tools.addFunction(function(b,c){var f=g.idBase,e;c=new CKEDITOR.dom.event(c);e="rtl"==a.lang.dir;switch(c.getKeystroke()){case e?39:37:case 9:return(e=CKEDITOR.document.getById(f+(b+1)))||(e=CKEDITOR.document.getById(f+"0")),e.focus(),!1;case e?37:39:case CKEDITOR.SHIFT+9:return(e=CKEDITOR.document.getById(f+(b-1)))||(e=CKEDITOR.document.getById(f+(g.list.length-1))),e.focus(),!1;case 27:return a.focus(),!1;case 13:case 32:return m(b),!1;}return!0;});a.on("selectionChange",function(){for(var b=[],f=g.list=[],e=[],m=g.filters,l=!0,A=a.elementPath().elements,u,x=A.length;x--;){var D=A[x],y=0;u=D.data("cke-display-name")?D.data("cke-display-name"):D.data("cke-real-element-type")?D.data("cke-real-element-type"):D.getName();(l=D.hasAttribute("contenteditable")?"true"==D.getAttribute("contenteditable"):l)||D.hasAttribute("contenteditable")||(y=1);for(var B=0;B<m.length;B++){var C=m[B](D,u);if(!1===C){y=1;break;}u=C||u;}y||(f.unshift(D),e.unshift(u));}f=f.length;for(m=0;m<f;m++){u=e[m],l=a.lang.elementspath.eleTitle.replace(/%1/,u),u=c.output({id:n+m,label:l,text:u,jsTitle:"javascript:void('"+u+"')",index:m,keyDownFn:r,clickFn:v}),b.unshift(u);}k||(k=CKEDITOR.document.getById(h));e=k;e.setHtml(b.join("")+'\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e');a.fire("elementsPathUpdate",{space:e});});a.on("readOnly",f);a.on("contentDomUnload",f);a.addCommand("elementsPathFocus",e.toolbarFocus);a.setKeystroke(CKEDITOR.ALT+122,"elementsPathFocus");}var e={toolbarFocus:{editorFocus:!1,readOnly:1,exec:function exec(a){(a=CKEDITOR.document.getById(a._.elementsPath.idBase+"0"))&&a.focus(CKEDITOR.env.ie||CKEDITOR.env.air);}}},b="";CKEDITOR.env.gecko&&CKEDITOR.env.mac&&(b+=' onkeypress\x3d"return false;"');CKEDITOR.env.gecko&&(b+=' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');var c=CKEDITOR.addTemplate("pathItem",'\x3ca id\x3d"{id}" href\x3d"{jsTitle}" tabindex\x3d"-1" class\x3d"cke_path_item" title\x3d"{label}"'+b+' hidefocus\x3d"true"  onkeydown\x3d"return CKEDITOR.tools.callFunction({keyDownFn},{index}, event );" onclick\x3d"CKEDITOR.tools.callFunction({clickFn},{index}); return false;" role\x3d"button" aria-label\x3d"{label}"\x3e{text}\x3c/a\x3e');CKEDITOR.plugins.add("elementspath",{init:function init(b){b._.elementsPath={idBase:"cke_elementspath_"+CKEDITOR.tools.getNextNumber()+"_",filters:[]};b.on("uiSpace",function(c){"bottom"==c.data.space&&a(b,c.data);});}});}(),function(){function a(a,d){var l,m;d.on("refresh",function(a){var c=[e],d;for(d in a.data.states){c.push(a.data.states[d]);}this.setState(CKEDITOR.tools.search(c,b)?b:e);},d,null,100);d.on("exec",function(b){l=a.getSelection();m=l.createBookmarks(1);b.data||(b.data={});b.data.done=!1;},d,null,0);d.on("exec",function(){a.forceNextSelectionCheck();l.selectBookmarks(m);},d,null,100);}var e=CKEDITOR.TRISTATE_DISABLED,b=CKEDITOR.TRISTATE_OFF;CKEDITOR.plugins.add("indent",{init:function init(b){var d=CKEDITOR.plugins.indent.genericDefinition;a(b,b.addCommand("indent",new d(!0)));a(b,b.addCommand("outdent",new d()));b.ui.addButton&&(b.ui.addButton("Indent",{label:b.lang.indent.indent,command:"indent",directional:!0,toolbar:"indent,20"}),b.ui.addButton("Outdent",{label:b.lang.indent.outdent,command:"outdent",directional:!0,toolbar:"indent,10"}));b.on("dirChanged",function(a){var d=b.createRange(),f=a.data.node;d.setStartBefore(f);d.setEndAfter(f);for(var e=new CKEDITOR.dom.walker(d),k;k=e.next();){if(k.type==CKEDITOR.NODE_ELEMENT)if(!k.equals(f)&&k.getDirection())d.setStartAfter(k),e=new CKEDITOR.dom.walker(d);else{var g=b.config.indentClasses;if(g)for(var n="ltr"==a.data.dir?["_rtl",""]:["","_rtl"],v=0;v<g.length;v++){k.hasClass(g[v]+n[0])&&(k.removeClass(g[v]+n[0]),k.addClass(g[v]+n[1]));}g=k.getStyle("margin-right");n=k.getStyle("margin-left");g?k.setStyle("margin-left",g):k.removeStyle("margin-left");n?k.setStyle("margin-right",n):k.removeStyle("margin-right");}}});}});CKEDITOR.plugins.indent={genericDefinition:function genericDefinition(a){this.isIndent=!!a;this.startDisabled=!this.isIndent;},specificDefinition:function specificDefinition(a,b,e){this.name=b;this.editor=a;this.jobs={};this.enterBr=a.config.enterMode==CKEDITOR.ENTER_BR;this.isIndent=!!e;this.relatedGlobal=e?"indent":"outdent";this.indentKey=e?9:CKEDITOR.SHIFT+9;this.database={};},registerCommands:function registerCommands(a,b){a.on("pluginsLoaded",function(){for(var a in b){(function(a,b){var c=a.getCommand(b.relatedGlobal),d;for(d in b.jobs){c.on("exec",function(c){c.data.done||(a.fire("lockSnapshot"),b.execJob(a,d)&&(c.data.done=!0),a.fire("unlockSnapshot"),CKEDITOR.dom.element.clearAllMarkers(b.database));},this,null,d),c.on("refresh",function(c){c.data.states||(c.data.states={});c.data.states[b.name+"@"+d]=b.refreshJob(a,d,c.data.path);},this,null,d);}a.addFeature(b);})(this,b[a]);}});}};CKEDITOR.plugins.indent.genericDefinition.prototype={context:"p",exec:function exec(){}};CKEDITOR.plugins.indent.specificDefinition.prototype={execJob:function execJob(a,b){var l=this.jobs[b];if(l.state!=e)return l.exec.call(this,a);},refreshJob:function refreshJob(a,b,l){b=this.jobs[b];a.activeFilter.checkFeature(this)?b.state=b.refresh.call(this,a,l):b.state=e;return b.state;},getContext:function getContext(a){return a.contains(this.context);}};}(),function(){function a(a){function c(e){for(var h=r.startContainer,l=r.endContainer;h&&!h.getParent().equals(e);){h=h.getParent();}for(;l&&!l.getParent().equals(e);){l=l.getParent();}if(!h||!l)return!1;for(var q=h,h=[],t=!1;!t;){q.equals(l)&&(t=!0),h.push(q),q=q.getNext();}if(1>h.length)return!1;q=e.getParents(!0);for(l=0;l<q.length;l++){if(q[l].getName&&m[q[l].getName()]){e=q[l];break;}}for(var q=d.isIndent?1:-1,l=h[0],h=h[h.length-1],t=CKEDITOR.plugins.list.listToArray(e,g),x=t[h.getCustomData("listarray_index")].indent,l=l.getCustomData("listarray_index");l<=h.getCustomData("listarray_index");l++){if(t[l].indent+=q,0<q){var v=t[l].parent;t[l].parent=new CKEDITOR.dom.element(v.getName(),v.getDocument());}}for(l=h.getCustomData("listarray_index")+1;l<t.length&&t[l].indent>x;l++){t[l].indent+=q;}h=CKEDITOR.plugins.list.arrayToList(t,g,null,a.config.enterMode,e.getDirection());if(!d.isIndent){var y;if((y=e.getParent())&&y.is("li"))for(var q=h.listNode.getChildren(),B=[],C,l=q.count()-1;0<=l;l--){(C=q.getItem(l))&&C.is&&C.is("li")&&B.push(C);}}h&&h.listNode.replace(e);if(B&&B.length)for(l=0;l<B.length;l++){for(C=e=B[l];(C=C.getNext())&&C.is&&C.getName()in m;){CKEDITOR.env.needsNbspFiller&&!e.getFirst(b)&&e.append(r.document.createText(" ")),e.append(C);}e.insertAfter(y);}h&&a.fire("contentDomInvalidated");return!0;}for(var d=this,g=this.database,m=this.context,l=a.getSelection(),l=(l&&l.getRanges()).createIterator(),r;r=l.getNextRange();){for(var q=r.getCommonAncestor();q&&(q.type!=CKEDITOR.NODE_ELEMENT||!m[q.getName()]);){if(a.editable().equals(q)){q=!1;break;}q=q.getParent();}q||(q=r.startPath().contains(m))&&r.setEndAt(q,CKEDITOR.POSITION_BEFORE_END);if(!q){var t=r.getEnclosedNode();t&&t.type==CKEDITOR.NODE_ELEMENT&&t.getName()in m&&(r.setStartAt(t,CKEDITOR.POSITION_AFTER_START),r.setEndAt(t,CKEDITOR.POSITION_BEFORE_END),q=t);}q&&r.startContainer.type==CKEDITOR.NODE_ELEMENT&&r.startContainer.getName()in m&&(t=new CKEDITOR.dom.walker(r),t.evaluator=e,r.startContainer=t.next());q&&r.endContainer.type==CKEDITOR.NODE_ELEMENT&&r.endContainer.getName()in m&&(t=new CKEDITOR.dom.walker(r),t.evaluator=e,r.endContainer=t.previous());if(q)return c(q);}return 0;}function e(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.is("li");}function b(a){return c(a)&&d(a);}var c=CKEDITOR.dom.walker.whitespaces(!0),d=CKEDITOR.dom.walker.bookmark(!1,!0),l=CKEDITOR.TRISTATE_DISABLED,m=CKEDITOR.TRISTATE_OFF;CKEDITOR.plugins.add("indentlist",{requires:"indent",init:function init(b){function c(b){d.specificDefinition.apply(this,arguments);this.requiredContent=["ul","ol"];b.on("key",function(a){if("wysiwyg"==b.mode&&a.data.keyCode==this.indentKey){var c=this.getContext(b.elementPath());!c||this.isIndent&&CKEDITOR.plugins.indentList.firstItemInPath(this.context,b.elementPath(),c)||(b.execCommand(this.relatedGlobal),a.cancel());}},this);this.jobs[this.isIndent?10:30]={refresh:this.isIndent?function(a,b){var c=this.getContext(b),d=CKEDITOR.plugins.indentList.firstItemInPath(this.context,b,c);return c&&this.isIndent&&!d?m:l;}:function(a,b){return!this.getContext(b)||this.isIndent?l:m;},exec:CKEDITOR.tools.bind(a,this)};}var d=CKEDITOR.plugins.indent;d.registerCommands(b,{indentlist:new c(b,"indentlist",!0),outdentlist:new c(b,"outdentlist")});CKEDITOR.tools.extend(c.prototype,d.specificDefinition.prototype,{context:{ol:1,ul:1}});}});CKEDITOR.plugins.indentList={};CKEDITOR.plugins.indentList.firstItemInPath=function(a,b,c){var d=b.contains(e);c||(c=b.contains(a));return c&&d&&d.equals(c.getFirst(e));};}(),function(){function a(a,b,c){function d(c){if(!(!(l=k[c?"getFirst":"getLast"]())||l.is&&l.isBlockBoundary()||!(m=b.root[c?"getPrevious":"getNext"](CKEDITOR.dom.walker.invisible(!0)))||m.is&&m.isBlockBoundary({br:1})))a.document.createElement("br")[c?"insertBefore":"insertAfter"](l);}for(var f=CKEDITOR.plugins.list.listToArray(b.root,c),e=[],g=0;g<b.contents.length;g++){var h=b.contents[g];(h=h.getAscendant("li",!0))&&!h.getCustomData("list_item_processed")&&(e.push(h),CKEDITOR.dom.element.setMarker(c,h,"list_item_processed",!0));}h=null;for(g=0;g<e.length;g++){h=e[g].getCustomData("listarray_index"),f[h].indent=-1;}for(g=h+1;g<f.length;g++){if(f[g].indent>f[g-1].indent+1){e=f[g-1].indent+1-f[g].indent;for(h=f[g].indent;f[g]&&f[g].indent>=h;){f[g].indent+=e,g++;}g--;}}var k=CKEDITOR.plugins.list.arrayToList(f,c,null,a.config.enterMode,b.root.getAttribute("dir")).listNode,l,m;d(!0);d();k.replace(b.root);a.fire("contentDomInvalidated");}function e(a,b){this.name=a;this.context=this.type=b;this.allowedContent=b+" li";this.requiredContent=b;}function b(a,b,c,d){for(var f,e;f=a[d?"getLast":"getFirst"](r);){(e=f.getDirection(1))!==b.getDirection(1)&&f.setAttribute("dir",e),f.remove(),c?f[d?"insertBefore":"insertAfter"](c):b.append(f,d);}}function c(a){function c(d){var f=a[d?"getPrevious":"getNext"](g);f&&f.type==CKEDITOR.NODE_ELEMENT&&f.is(a.getName())&&(b(a,f,null,!d),a.remove(),a=f);}c();c(1);}function d(a){return a.type==CKEDITOR.NODE_ELEMENT&&(a.getName()in CKEDITOR.dtd.$block||a.getName()in CKEDITOR.dtd.$listItem)&&CKEDITOR.dtd[a.getName()]["#"];}function l(a,d,f){a.fire("saveSnapshot");f.enlarge(CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS);var e=f.extractContents();d.trim(!1,!0);var h=d.createBookmark(),k=new CKEDITOR.dom.elementPath(d.startContainer),l=k.block,k=k.lastElement.getAscendant("li",1)||l,r=new CKEDITOR.dom.elementPath(f.startContainer),v=r.contains(CKEDITOR.dtd.$listItem),r=r.contains(CKEDITOR.dtd.$list);l?(l=l.getBogus())&&l.remove():r&&(l=r.getPrevious(g))&&n(l)&&l.remove();(l=e.getLast())&&l.type==CKEDITOR.NODE_ELEMENT&&l.is("br")&&l.remove();(l=d.startContainer.getChild(d.startOffset))?e.insertBefore(l):d.startContainer.append(e);v&&(e=m(v))&&(k.contains(v)?(b(e,v.getParent(),v),e.remove()):k.append(e));for(;f.checkStartOfBlock()&&f.checkEndOfBlock();){r=f.startPath();e=r.block;if(!e)break;e.is("li")&&(k=e.getParent(),e.equals(k.getLast(g))&&e.equals(k.getFirst(g))&&(e=k));f.moveToPosition(e,CKEDITOR.POSITION_BEFORE_START);e.remove();}f=f.clone();e=a.editable();f.setEndAt(e,CKEDITOR.POSITION_BEFORE_END);f=new CKEDITOR.dom.walker(f);f.evaluator=function(a){return g(a)&&!n(a);};(f=f.next())&&f.type==CKEDITOR.NODE_ELEMENT&&f.getName()in CKEDITOR.dtd.$list&&c(f);d.moveToBookmark(h);d.select();a.fire("saveSnapshot");}function m(a){return(a=a.getLast(g))&&a.type==CKEDITOR.NODE_ELEMENT&&a.getName()in f?a:null;}var f={ol:1,ul:1},h=CKEDITOR.dom.walker.whitespaces(),k=CKEDITOR.dom.walker.bookmark(),g=function g(a){return!(h(a)||k(a));},n=CKEDITOR.dom.walker.bogus();CKEDITOR.plugins.list={listToArray:function listToArray(a,b,c,d,e){if(!f[a.getName()])return[];d||(d=0);c||(c=[]);for(var g=0,h=a.getChildCount();g<h;g++){var k=a.getChild(g);k.type==CKEDITOR.NODE_ELEMENT&&k.getName()in CKEDITOR.dtd.$list&&CKEDITOR.plugins.list.listToArray(k,b,c,d+1);if("li"==k.$.nodeName.toLowerCase()){var l={parent:a,indent:d,element:k,contents:[]};e?l.grandparent=e:(l.grandparent=a.getParent(),l.grandparent&&"li"==l.grandparent.$.nodeName.toLowerCase()&&(l.grandparent=l.grandparent.getParent()));b&&CKEDITOR.dom.element.setMarker(b,k,"listarray_index",c.length);c.push(l);for(var m=0,n=k.getChildCount(),r;m<n;m++){r=k.getChild(m),r.type==CKEDITOR.NODE_ELEMENT&&f[r.getName()]?CKEDITOR.plugins.list.listToArray(r,b,c,d+1,l.grandparent):l.contents.push(r);}}}return c;},arrayToList:function arrayToList(a,b,c,d,e){c||(c=0);if(!a||a.length<c+1)return null;for(var h,l=a[c].parent.getDocument(),m=new CKEDITOR.dom.documentFragment(l),n=null,r=c,v=Math.max(a[c].indent,0),C=null,F,E,J=d==CKEDITOR.ENTER_P?"p":"div";;){var G=a[r];h=G.grandparent;F=G.element.getDirection(1);if(G.indent==v){n&&a[r].parent.getName()==n.getName()||(n=a[r].parent.clone(!1,1),e&&n.setAttribute("dir",e),m.append(n));C=n.append(G.element.clone(0,1));F!=n.getDirection(1)&&C.setAttribute("dir",F);for(h=0;h<G.contents.length;h++){C.append(G.contents[h].clone(1,1));}r++;}else if(G.indent==Math.max(v,0)+1)G=a[r-1].element.getDirection(1),r=CKEDITOR.plugins.list.arrayToList(a,null,r,d,G!=F?F:null),!C.getChildCount()&&CKEDITOR.env.needsNbspFiller&&7>=l.$.documentMode&&C.append(l.createText(" ")),C.append(r.listNode),r=r.nextIndex;else if(-1==G.indent&&!c&&h){f[h.getName()]?(C=G.element.clone(!1,!0),F!=h.getDirection(1)&&C.setAttribute("dir",F)):C=new CKEDITOR.dom.documentFragment(l);var n=h.getDirection(1)!=F,M=G.element,I=M.getAttribute("class"),H=M.getAttribute("style"),R=C.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT&&(d!=CKEDITOR.ENTER_BR||n||H||I),P,T=G.contents.length,O;for(h=0;h<T;h++){if(P=G.contents[h],k(P)&&1<T)R?O=P.clone(1,1):C.append(P.clone(1,1));else if(P.type==CKEDITOR.NODE_ELEMENT&&P.isBlockBoundary()){n&&!P.getDirection()&&P.setAttribute("dir",F);E=P;var K=M.getAttribute("style");K&&E.setAttribute("style",K.replace(/([^;])$/,"$1;")+(E.getAttribute("style")||""));I&&P.addClass(I);E=null;O&&(C.append(O),O=null);C.append(P.clone(1,1));}else R?(E||(E=l.createElement(J),C.append(E),n&&E.setAttribute("dir",F)),H&&E.setAttribute("style",H),I&&E.setAttribute("class",I),O&&(E.append(O),O=null),E.append(P.clone(1,1))):C.append(P.clone(1,1));}O&&((E||C).append(O),O=null);C.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT&&r!=a.length-1&&(CKEDITOR.env.needsBrFiller&&(F=C.getLast())&&F.type==CKEDITOR.NODE_ELEMENT&&F.is("br")&&F.remove(),(F=C.getLast(g))&&F.type==CKEDITOR.NODE_ELEMENT&&F.is(CKEDITOR.dtd.$block)||C.append(l.createElement("br")));F=C.$.nodeName.toLowerCase();"div"!=F&&"p"!=F||C.appendBogus();m.append(C);n=null;r++;}else return null;E=null;if(a.length<=r||Math.max(a[r].indent,0)<v)break;}if(b)for(a=m.getFirst();a;){if(a.type==CKEDITOR.NODE_ELEMENT&&(CKEDITOR.dom.element.clearMarkers(b,a),a.getName()in CKEDITOR.dtd.$listItem&&(c=a,l=e=d=void 0,d=c.getDirection()))){for(e=c.getParent();e&&!(l=e.getDirection());){e=e.getParent();}d==l&&c.removeAttribute("dir");}a=a.getNextSourceNode();}return{listNode:m,nextIndex:r};}};var v=/^h[1-6]$/,r=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT);e.prototype={exec:function exec(b){this.refresh(b,b.elementPath());var d=b.config,e=b.getSelection(),h=e&&e.getRanges();if(this.state==CKEDITOR.TRISTATE_OFF){var k=b.editable();if(k.getFirst(g)){var l=1==h.length&&h[0];(d=l&&l.getEnclosedNode())&&d.is&&this.type==d.getName()&&this.setState(CKEDITOR.TRISTATE_ON);}else d.enterMode==CKEDITOR.ENTER_BR?k.appendBogus():h[0].fixBlock(1,d.enterMode==CKEDITOR.ENTER_P?"p":"div"),e.selectRanges(h);}for(var d=e.createBookmarks(!0),k=[],m={},h=h.createIterator(),n=0;(l=h.getNextRange())&&++n;){var r=l.getBoundaryNodes(),y=r.startNode,B=r.endNode;y.type==CKEDITOR.NODE_ELEMENT&&"td"==y.getName()&&l.setStartAt(r.startNode,CKEDITOR.POSITION_AFTER_START);B.type==CKEDITOR.NODE_ELEMENT&&"td"==B.getName()&&l.setEndAt(r.endNode,CKEDITOR.POSITION_BEFORE_END);l=l.createIterator();for(l.forceBrBreak=this.state==CKEDITOR.TRISTATE_OFF;r=l.getNextParagraph();){if(!r.getCustomData("list_block")){CKEDITOR.dom.element.setMarker(m,r,"list_block",1);for(var C=b.elementPath(r),y=C.elements,B=0,C=C.blockLimit,F,E=y.length-1;0<=E&&(F=y[E]);E--){if(f[F.getName()]&&C.contains(F)){C.removeCustomData("list_group_object_"+n);(y=F.getCustomData("list_group_object"))?y.contents.push(r):(y={root:F,contents:[r]},k.push(y),CKEDITOR.dom.element.setMarker(m,F,"list_group_object",y));B=1;break;}}B||(B=C,B.getCustomData("list_group_object_"+n)?B.getCustomData("list_group_object_"+n).contents.push(r):(y={root:B,contents:[r]},CKEDITOR.dom.element.setMarker(m,B,"list_group_object_"+n,y),k.push(y)));}}}for(F=[];0<k.length;){if(y=k.shift(),this.state==CKEDITOR.TRISTATE_OFF){if(f[y.root.getName()]){h=b;n=y;y=m;l=F;B=CKEDITOR.plugins.list.listToArray(n.root,y);C=[];for(r=0;r<n.contents.length;r++){E=n.contents[r],(E=E.getAscendant("li",!0))&&!E.getCustomData("list_item_processed")&&(C.push(E),CKEDITOR.dom.element.setMarker(y,E,"list_item_processed",!0));}for(var E=n.root.getDocument(),J=void 0,G=void 0,r=0;r<C.length;r++){var M=C[r].getCustomData("listarray_index"),J=B[M].parent;J.is(this.type)||(G=E.createElement(this.type),J.copyAttributes(G,{start:1,type:1}),G.removeStyle("list-style-type"),B[M].parent=G);}y=CKEDITOR.plugins.list.arrayToList(B,y,null,h.config.enterMode);B=void 0;C=y.listNode.getChildCount();for(r=0;r<C&&(B=y.listNode.getChild(r));r++){B.getName()==this.type&&l.push(B);}y.listNode.replace(n.root);h.fire("contentDomInvalidated");}else{B=b;l=y;r=F;C=l.contents;h=l.root.getDocument();n=[];1==C.length&&C[0].equals(l.root)&&(y=h.createElement("div"),C[0].moveChildren&&C[0].moveChildren(y),C[0].append(y),C[0]=y);l=l.contents[0].getParent();for(E=0;E<C.length;E++){l=l.getCommonAncestor(C[E].getParent());}J=B.config.useComputedState;B=y=void 0;J=void 0===J||J;for(E=0;E<C.length;E++){for(G=C[E];M=G.getParent();){if(M.equals(l)){n.push(G);!B&&G.getDirection()&&(B=1);G=G.getDirection(J);null!==y&&(y=y&&y!=G?null:G);break;}G=M;}}if(!(1>n.length)){C=n[n.length-1].getNext();E=h.createElement(this.type);r.push(E);for(J=r=void 0;n.length;){r=n.shift(),J=h.createElement("li"),G=r,G.is("pre")||v.test(G.getName())||"false"==G.getAttribute("contenteditable")?r.appendTo(J):(r.copyAttributes(J),y&&r.getDirection()&&(J.removeStyle("direction"),J.removeAttribute("dir")),r.moveChildren(J),r.remove()),J.appendTo(E);}y&&B&&E.setAttribute("dir",y);C?E.insertBefore(C):E.appendTo(l);}}}else this.state==CKEDITOR.TRISTATE_ON&&f[y.root.getName()]&&a.call(this,b,y,m);}for(E=0;E<F.length;E++){c(F[E]);}CKEDITOR.dom.element.clearAllMarkers(m);e.selectBookmarks(d);b.focus();},refresh:function refresh(a,b){var c=b.contains(f,1),d=b.blockLimit||b.root;c&&d.contains(c)?this.setState(c.is(this.type)?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF):this.setState(CKEDITOR.TRISTATE_OFF);}};CKEDITOR.plugins.add("list",{requires:"indentlist",init:function init(a){a.blockless||(a.addCommand("numberedlist",new e("numberedlist","ol")),a.addCommand("bulletedlist",new e("bulletedlist","ul")),a.ui.addButton&&(a.ui.addButton("NumberedList",{label:a.lang.list.numberedlist,command:"numberedlist",directional:!0,toolbar:"list,10"}),a.ui.addButton("BulletedList",{label:a.lang.list.bulletedlist,command:"bulletedlist",directional:!0,toolbar:"list,20"})),a.on("key",function(b){var c=b.data.domEvent.getKey(),e;if("wysiwyg"==a.mode&&c in{8:1,46:1}){var h=a.getSelection().getRanges()[0],k=h&&h.startPath();if(h&&h.collapsed){var r=8==c,v=a.editable(),D=new CKEDITOR.dom.walker(h.clone());D.evaluator=function(a){return g(a)&&!n(a);};D.guard=function(a,b){return!(b&&a.type==CKEDITOR.NODE_ELEMENT&&a.is("table"));};c=h.clone();if(r){var y;(y=k.contains(f))&&h.checkBoundaryOfElement(y,CKEDITOR.START)&&(y=y.getParent())&&y.is("li")&&(y=m(y))?(e=y,y=y.getPrevious(g),c.moveToPosition(y&&n(y)?y:e,CKEDITOR.POSITION_BEFORE_START)):(D.range.setStartAt(v,CKEDITOR.POSITION_AFTER_START),D.range.setEnd(h.startContainer,h.startOffset),(y=D.previous())&&y.type==CKEDITOR.NODE_ELEMENT&&(y.getName()in f||y.is("li"))&&(y.is("li")||(D.range.selectNodeContents(y),D.reset(),D.evaluator=d,y=D.previous()),e=y,c.moveToElementEditEnd(e),c.moveToPosition(c.endPath().block,CKEDITOR.POSITION_BEFORE_END)));if(e)l(a,c,h),b.cancel();else{var B=k.contains(f);B&&h.checkBoundaryOfElement(B,CKEDITOR.START)&&(e=B.getFirst(g),h.checkBoundaryOfElement(e,CKEDITOR.START)&&(y=B.getPrevious(g),m(e)?y&&(h.moveToElementEditEnd(y),h.select()):a.execCommand("outdent"),b.cancel()));}}else if(e=k.contains("li")){if(D.range.setEndAt(v,CKEDITOR.POSITION_BEFORE_END),r=(v=e.getLast(g))&&d(v)?v:e,k=0,(y=D.next())&&y.type==CKEDITOR.NODE_ELEMENT&&y.getName()in f&&y.equals(v)?(k=1,y=D.next()):h.checkBoundaryOfElement(r,CKEDITOR.END)&&(k=2),k&&y){h=h.clone();h.moveToElementEditStart(y);if(1==k&&(c.optimize(),!c.startContainer.equals(e))){for(e=c.startContainer;e.is(CKEDITOR.dtd.$inline);){B=e,e=e.getParent();}B&&c.moveToPosition(B,CKEDITOR.POSITION_AFTER_END);}2==k&&(c.moveToPosition(c.endPath().block,CKEDITOR.POSITION_BEFORE_END),h.endPath().block&&h.moveToPosition(h.endPath().block,CKEDITOR.POSITION_AFTER_START));l(a,c,h);b.cancel();}}else D.range.setEndAt(v,CKEDITOR.POSITION_BEFORE_END),(y=D.next())&&y.type==CKEDITOR.NODE_ELEMENT&&y.is(f)&&(y=y.getFirst(g),k.block&&h.checkStartOfBlock()&&h.checkEndOfBlock()?(k.block.remove(),h.moveToElementEditStart(y),h.select()):m(y)?(h.moveToElementEditStart(y),h.select()):(h=h.clone(),h.moveToElementEditStart(y),l(a,c,h)),b.cancel());setTimeout(function(){a.selectionChange(1);});}}}));}});}(),function(){function a(a,b,c){c=a.config.forceEnterMode||c;"wysiwyg"==a.mode&&(b||(b=a.activeEnterMode),a.elementPath().isContextFor("p")||(b=CKEDITOR.ENTER_BR,c=1),a.fire("saveSnapshot"),b==CKEDITOR.ENTER_BR?m(a,b,null,c):f(a,b,null,c),a.fire("saveSnapshot"));}function e(a){a=a.getSelection().getRanges(!0);for(var b=a.length-1;0<b;b--){a[b].deleteContents();}return a[0];}function b(a){var b=a.startContainer.getAscendant(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&"true"==a.getAttribute("contenteditable");},!0);if(a.root.equals(b))return a;b=new CKEDITOR.dom.range(b);b.moveToRange(a);return b;}CKEDITOR.plugins.add("enterkey",{init:function init(b){b.addCommand("enter",{modes:{wysiwyg:1},editorFocus:!1,exec:function exec(b){a(b);}});b.addCommand("shiftEnter",{modes:{wysiwyg:1},editorFocus:!1,exec:function exec(b){a(b,b.activeShiftEnterMode,1);}});b.setKeystroke([[13,"enter"],[CKEDITOR.SHIFT+13,"shiftEnter"]]);}});var c=CKEDITOR.dom.walker.whitespaces(),d=CKEDITOR.dom.walker.bookmark();CKEDITOR.plugins.enterkey={enterBlock:function enterBlock(a,f,l,v){if(l=l||e(a)){l=b(l);var r=l.document,q=l.checkStartOfBlock(),t=l.checkEndOfBlock(),p=a.elementPath(l.startContainer),w=p.block,z=f==CKEDITOR.ENTER_DIV?"div":"p",A;if(q&&t){if(w&&(w.is("li")||w.getParent().is("li"))){w.is("li")||(w=w.getParent());l=w.getParent();A=l.getParent();v=!w.hasPrevious();var u=!w.hasNext(),z=a.getSelection(),x=z.createBookmarks(),q=w.getDirection(1),t=w.getAttribute("class"),D=w.getAttribute("style"),y=A.getDirection(1)!=q;a=a.enterMode!=CKEDITOR.ENTER_BR||y||D||t;if(A.is("li"))v||u?(v&&u&&l.remove(),w[u?"insertAfter":"insertBefore"](A)):w.breakParent(A);else{if(a){if(p.block.is("li")?(A=r.createElement(f==CKEDITOR.ENTER_P?"p":"div"),y&&A.setAttribute("dir",q),D&&A.setAttribute("style",D),t&&A.setAttribute("class",t),w.moveChildren(A)):A=p.block,v||u)A[v?"insertBefore":"insertAfter"](l);else w.breakParent(l),A.insertAfter(l);}else if(w.appendBogus(!0),v||u)for(;r=w[v?"getFirst":"getLast"]();){r[v?"insertBefore":"insertAfter"](l);}else for(w.breakParent(l);r=w.getLast();){r.insertAfter(l);}w.remove();}z.selectBookmarks(x);return;}if(w&&w.getParent().is("blockquote")){w.breakParent(w.getParent());w.getPrevious().getFirst(CKEDITOR.dom.walker.invisible(1))||w.getPrevious().remove();w.getNext().getFirst(CKEDITOR.dom.walker.invisible(1))||w.getNext().remove();l.moveToElementEditStart(w);l.select();return;}}else if(w&&w.is("pre")&&!t){m(a,f,l,v);return;}if(q=l.splitBlock(z)){f=q.previousBlock;w=q.nextBlock;p=q.wasStartOfBlock;a=q.wasEndOfBlock;w?(x=w.getParent(),x.is("li")&&(w.breakParent(x),w.move(w.getNext(),1))):f&&(x=f.getParent())&&x.is("li")&&(f.breakParent(x),x=f.getNext(),l.moveToElementEditStart(x),f.move(f.getPrevious()));if(p||a){if(f){if(f.is("li")||!h.test(f.getName())&&!f.is("pre"))A=f.clone();}else w&&(A=w.clone());A?v&&!A.is("li")&&A.renameNode(z):x&&x.is("li")?A=x:(A=r.createElement(z),f&&(u=f.getDirection())&&A.setAttribute("dir",u));if(r=q.elementPath)for(v=0,z=r.elements.length;v<z;v++){x=r.elements[v];if(x.equals(r.block)||x.equals(r.blockLimit))break;CKEDITOR.dtd.$removeEmpty[x.getName()]&&(x=x.clone(),A.moveChildren(x),A.append(x));}A.appendBogus();A.getParent()||l.insertNode(A);A.is("li")&&A.removeAttribute("value");!CKEDITOR.env.ie||!p||a&&f.getChildCount()||(l.moveToElementEditStart(a?f:A),l.select());l.moveToElementEditStart(p&&!a?w:A);}else w.is("li")&&(A=l.clone(),A.selectNodeContents(w),A=new CKEDITOR.dom.walker(A),A.evaluator=function(a){return!(d(a)||c(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.getName()in CKEDITOR.dtd.$inline&&!(a.getName()in CKEDITOR.dtd.$empty));},(x=A.next())&&x.type==CKEDITOR.NODE_ELEMENT&&x.is("ul","ol")&&(CKEDITOR.env.needsBrFiller?r.createElement("br"):r.createText(" ")).insertBefore(x)),w&&l.moveToElementEditStart(w);l.select();l.scrollIntoView();}}},enterBr:function enterBr(a,b,c,d){if(c=c||e(a)){var l=c.document,m=c.checkEndOfBlock(),t=new CKEDITOR.dom.elementPath(a.getSelection().getStartElement()),p=t.block,w=p&&t.block.getName();d||"li"!=w?(!d&&m&&h.test(w)?(m=p.getDirection())?(l=l.createElement("div"),l.setAttribute("dir",m),l.insertAfter(p),c.setStart(l,0)):(l.createElement("br").insertAfter(p),CKEDITOR.env.gecko&&l.createText("").insertAfter(p),c.setStartAt(p.getNext(),CKEDITOR.env.ie?CKEDITOR.POSITION_BEFORE_START:CKEDITOR.POSITION_AFTER_START)):(a="pre"==w&&CKEDITOR.env.ie&&8>CKEDITOR.env.version?l.createText("\r"):l.createElement("br"),c.deleteContents(),c.insertNode(a),CKEDITOR.env.needsBrFiller?(l.createText("﻿").insertAfter(a),m&&(p||t.blockLimit).appendBogus(),a.getNext().$.nodeValue="",c.setStartAt(a.getNext(),CKEDITOR.POSITION_AFTER_START)):c.setStartAt(a,CKEDITOR.POSITION_AFTER_END)),c.collapse(!0),c.select(),c.scrollIntoView()):f(a,b,c,d);}}};var l=CKEDITOR.plugins.enterkey,m=l.enterBr,f=l.enterBlock,h=/^h[1-6]$/;}(),function(){function a(a,b){var c={},d=[],l={nbsp:" ",shy:"­",gt:"\x3e",lt:"\x3c",amp:"\x26",apos:"'",quot:'"'};a=a.replace(/\b(nbsp|shy|gt|lt|amp|apos|quot)(?:,|$)/g,function(a,f){var e=b?"\x26"+f+";":l[f];c[e]=b?l[f]:"\x26"+f+";";d.push(e);return"";});if(!b&&a){a=a.split(",");var m=document.createElement("div"),f;m.innerHTML="\x26"+a.join(";\x26")+";";f=m.innerHTML;m=null;for(m=0;m<f.length;m++){var h=f.charAt(m);c[h]="\x26"+a[m]+";";d.push(h);}}c.regex=d.join(b?"|":"");return c;}CKEDITOR.plugins.add("entities",{afterInit:function afterInit(e){function b(a){return h[a];}function c(a){return"force"!=d.entities_processNumerical&&m[a]?m[a]:"\x26#"+a.charCodeAt(0)+";";}var d=e.config;if(e=(e=e.dataProcessor)&&e.htmlFilter){var l=[];!1!==d.basicEntities&&l.push("nbsp,gt,lt,amp");d.entities&&(l.length&&l.push("quot,iexcl,cent,pound,curren,yen,brvbar,sect,uml,copy,ordf,laquo,not,shy,reg,macr,deg,plusmn,sup2,sup3,acute,micro,para,middot,cedil,sup1,ordm,raquo,frac14,frac12,frac34,iquest,times,divide,fnof,bull,hellip,prime,Prime,oline,frasl,weierp,image,real,trade,alefsym,larr,uarr,rarr,darr,harr,crarr,lArr,uArr,rArr,dArr,hArr,forall,part,exist,empty,nabla,isin,notin,ni,prod,sum,minus,lowast,radic,prop,infin,ang,and,or,cap,cup,int,there4,sim,cong,asymp,ne,equiv,le,ge,sub,sup,nsub,sube,supe,oplus,otimes,perp,sdot,lceil,rceil,lfloor,rfloor,lang,rang,loz,spades,clubs,hearts,diams,circ,tilde,ensp,emsp,thinsp,zwnj,zwj,lrm,rlm,ndash,mdash,lsquo,rsquo,sbquo,ldquo,rdquo,bdquo,dagger,Dagger,permil,lsaquo,rsaquo,euro"),d.entities_latin&&l.push("Agrave,Aacute,Acirc,Atilde,Auml,Aring,AElig,Ccedil,Egrave,Eacute,Ecirc,Euml,Igrave,Iacute,Icirc,Iuml,ETH,Ntilde,Ograve,Oacute,Ocirc,Otilde,Ouml,Oslash,Ugrave,Uacute,Ucirc,Uuml,Yacute,THORN,szlig,agrave,aacute,acirc,atilde,auml,aring,aelig,ccedil,egrave,eacute,ecirc,euml,igrave,iacute,icirc,iuml,eth,ntilde,ograve,oacute,ocirc,otilde,ouml,oslash,ugrave,uacute,ucirc,uuml,yacute,thorn,yuml,OElig,oelig,Scaron,scaron,Yuml"),d.entities_greek&&l.push("Alpha,Beta,Gamma,Delta,Epsilon,Zeta,Eta,Theta,Iota,Kappa,Lambda,Mu,Nu,Xi,Omicron,Pi,Rho,Sigma,Tau,Upsilon,Phi,Chi,Psi,Omega,alpha,beta,gamma,delta,epsilon,zeta,eta,theta,iota,kappa,lambda,mu,nu,xi,omicron,pi,rho,sigmaf,sigma,tau,upsilon,phi,chi,psi,omega,thetasym,upsih,piv"),d.entities_additional&&l.push(d.entities_additional));var m=a(l.join(",")),f=m.regex?"["+m.regex+"]":"a^";delete m.regex;d.entities&&d.entities_processNumerical&&(f="[^ -~]|"+f);var f=new RegExp(f,"g"),h=a("nbsp,gt,lt,amp,shy",!0),k=new RegExp(h.regex,"g");e.addRules({text:function text(a){return a.replace(k,b).replace(f,c);}},{applyToAll:!0,excludeNestedEditable:!0});}}});}(),CKEDITOR.config.basicEntities=!0,CKEDITOR.config.entities=!0,CKEDITOR.config.entities_latin=!0,CKEDITOR.config.entities_greek=!0,CKEDITOR.config.entities_additional="#39",CKEDITOR.plugins.add("popup"),CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{popup:function popup(a,e,b,c){e=e||"80%";b=b||"70%";"string"==typeof e&&1<e.length&&"%"==e.substr(e.length-1,1)&&(e=parseInt(window.screen.width*parseInt(e,10)/100,10));"string"==typeof b&&1<b.length&&"%"==b.substr(b.length-1,1)&&(b=parseInt(window.screen.height*parseInt(b,10)/100,10));640>e&&(e=640);420>b&&(b=420);var d=parseInt((window.screen.height-b)/2,10),l=parseInt((window.screen.width-e)/2,10);c=(c||"location\x3dno,menubar\x3dno,toolbar\x3dno,dependent\x3dyes,minimizable\x3dno,modal\x3dyes,alwaysRaised\x3dyes,resizable\x3dyes,scrollbars\x3dyes")+",width\x3d"+e+",height\x3d"+b+",top\x3d"+d+",left\x3d"+l;var m=window.open("",null,c,!0);if(!m)return!1;try{-1==navigator.userAgent.toLowerCase().indexOf(" chrome/")&&(m.moveTo(l,d),m.resizeTo(e,b)),m.focus(),m.location.href=a;}catch(f){window.open(a,null,c,!0);}return!0;}}),function(){function a(a,b){var c=[];if(b)for(var d in b){c.push(d+"\x3d"+encodeURIComponent(b[d]));}else return a;return a+(-1!=a.indexOf("?")?"\x26":"?")+c.join("\x26");}function e(a){a+="";return a.charAt(0).toUpperCase()+a.substr(1);}function b(){var b=this.getDialog(),c=b.getParentEditor();c._.filebrowserSe=this;var d=c.config["filebrowser"+e(b.getName())+"WindowWidth"]||c.config.filebrowserWindowWidth||"80%",b=c.config["filebrowser"+e(b.getName())+"WindowHeight"]||c.config.filebrowserWindowHeight||"70%",f=this.filebrowser.params||{};f.CKEditor=c.name;f.CKEditorFuncNum=c._.filebrowserFn;f.langCode||(f.langCode=c.langCode);f=a(this.filebrowser.url,f);c.popup(f,d,b,c.config.filebrowserWindowFeatures||c.config.fileBrowserWindowFeatures);}function c(){var a=this.getDialog();a.getParentEditor()._.filebrowserSe=this;return a.getContentElement(this["for"][0],this["for"][1]).getInputElement().$.value&&a.getContentElement(this["for"][0],this["for"][1]).getAction()?!0:!1;}function d(b,c,d){var f=d.params||{};f.CKEditor=b.name;f.CKEditorFuncNum=b._.filebrowserFn;f.langCode||(f.langCode=b.langCode);c.action=a(d.url,f);c.filebrowser=d;}function l(a,f,g,m){if(m&&m.length)for(var v,r=m.length;r--;){if(v=m[r],"hbox"!=v.type&&"vbox"!=v.type&&"fieldset"!=v.type||l(a,f,g,v.children),v.filebrowser)if("string"==typeof v.filebrowser&&(v.filebrowser={action:"fileButton"==v.type?"QuickUpload":"Browse",target:v.filebrowser}),"Browse"==v.filebrowser.action){var q=v.filebrowser.url;void 0===q&&(q=a.config["filebrowser"+e(f)+"BrowseUrl"],void 0===q&&(q=a.config.filebrowserBrowseUrl));q&&(v.onClick=b,v.filebrowser.url=q,v.hidden=!1);}else if("QuickUpload"==v.filebrowser.action&&v["for"]&&(q=v.filebrowser.url,void 0===q&&(q=a.config["filebrowser"+e(f)+"UploadUrl"],void 0===q&&(q=a.config.filebrowserUploadUrl)),q)){var t=v.onClick;v.onClick=function(a){var b=a.sender;if(t&&!1===t.call(b,a))return!1;if(c.call(b,a)){a=b.getDialog().getContentElement(this["for"][0],this["for"][1]).getInputElement();if(b=new CKEDITOR.dom.element(a.$.form))(a=b.$.elements.ckCsrfToken)?a=new CKEDITOR.dom.element(a):(a=new CKEDITOR.dom.element("input"),a.setAttributes({name:"ckCsrfToken",type:"hidden"}),b.append(a)),a.setAttribute("value",CKEDITOR.tools.getCsrfToken());return!0;}return!1;};v.filebrowser.url=q;v.hidden=!1;d(a,g.getContents(v["for"][0]).get(v["for"][1]),v.filebrowser);}}}function m(a,b,c){if(-1!==c.indexOf(";")){c=c.split(";");for(var d=0;d<c.length;d++){if(m(a,b,c[d]))return!0;}return!1;}return(a=a.getContents(b).get(c).filebrowser)&&a.url;}function f(a,b){var c=this._.filebrowserSe.getDialog(),d=this._.filebrowserSe["for"],f=this._.filebrowserSe.filebrowser.onSelect;d&&c.getContentElement(d[0],d[1]).reset();if("function"!=typeof b||!1!==b.call(this._.filebrowserSe))if(!f||!1!==f.call(this._.filebrowserSe,a,b))if("string"==typeof b&&b&&alert(b),a&&(d=this._.filebrowserSe,c=d.getDialog(),d=d.filebrowser.target||null))if(d=d.split(":"),f=c.getContentElement(d[0],d[1]))f.setValue(a),c.selectPage(d[0]);}CKEDITOR.plugins.add("filebrowser",{requires:"popup",init:function init(a){a._.filebrowserFn=CKEDITOR.tools.addFunction(f,a);a.on("destroy",function(){CKEDITOR.tools.removeFunction(this._.filebrowserFn);});}});CKEDITOR.on("dialogDefinition",function(a){if(a.editor.plugins.filebrowser)for(var b=a.data.definition,c,d=0;d<b.contents.length;++d){if(c=b.contents[d])l(a.editor,a.data.name,b,c.elements),c.hidden&&c.filebrowser&&(c.hidden=!m(b,c.id,c.filebrowser));}});}(),function(){function a(a){var d=a.config,l=a.fire("uiSpace",{space:"top",html:""}).html,m=function(){function f(a,c,d){h.setStyle(c,b(d));h.setStyle("position",a);}function g(a){var b=k.getDocumentPosition();switch(a){case"top":f("absolute","top",b.y-z-x);break;case"pin":f("fixed","top",y);break;case"bottom":f("absolute","top",b.y+(p.height||p.bottom-p.top)+x);}l=a;}var l,k,t,p,w,z,A,u=d.floatSpaceDockedOffsetX||0,x=d.floatSpaceDockedOffsetY||0,D=d.floatSpacePinnedOffsetX||0,y=d.floatSpacePinnedOffsetY||0;return function(f){if(k=a.editable()){var n=f&&"focus"==f.name;n&&h.show();a.fire("floatingSpaceLayout",{show:n});h.removeStyle("left");h.removeStyle("right");t=h.getClientRect();p=k.getClientRect();w=e.getViewPaneSize();z=t.height;A="pageXOffset"in e.$?e.$.pageXOffset:CKEDITOR.document.$.documentElement.scrollLeft;l?(z+x<=p.top?g("top"):z+x>w.height-p.bottom?g("pin"):g("bottom"),f=w.width/2,f=d.floatSpacePreferRight?"right":0<p.left&&p.right<w.width&&p.width>t.width?"rtl"==d.contentsLangDirection?"right":"left":f-p.left>p.right-f?"left":"right",t.width>w.width?(f="left",n=0):(n="left"==f?0<p.left?p.left:0:p.right<w.width?w.width-p.right:0,n+t.width>w.width&&(f="left"==f?"right":"left",n=0)),h.setStyle(f,b(("pin"==l?D:u)+n+("pin"==l?0:"left"==f?A:-A)))):(l="pin",g("pin"),m(f));}};}();if(l){var f=new CKEDITOR.template('\x3cdiv id\x3d"cke_{name}" class\x3d"cke {id} cke_reset_all cke_chrome cke_editor_{name} cke_float cke_{langDir} '+CKEDITOR.env.cssClass+'" dir\x3d"{langDir}" title\x3d"'+(CKEDITOR.env.gecko?" ":"")+'" lang\x3d"{langCode}" role\x3d"application" style\x3d"{style}"'+(a.title?' aria-labelledby\x3d"cke_{name}_arialbl"':" ")+"\x3e"+(a.title?'\x3cspan id\x3d"cke_{name}_arialbl" class\x3d"cke_voice_label"\x3e{voiceLabel}\x3c/span\x3e':" ")+'\x3cdiv class\x3d"cke_inner"\x3e\x3cdiv id\x3d"{topId}" class\x3d"cke_top" role\x3d"presentation"\x3e{content}\x3c/div\x3e\x3c/div\x3e\x3c/div\x3e'),h=CKEDITOR.document.getBody().append(CKEDITOR.dom.element.createFromHtml(f.output({content:l,id:a.id,langDir:a.lang.dir,langCode:a.langCode,name:a.name,style:"display:none;z-index:"+(d.baseFloatZIndex-1),topId:a.ui.spaceId("top"),voiceLabel:a.title}))),k=CKEDITOR.tools.eventsBuffer(500,m),g=CKEDITOR.tools.eventsBuffer(100,m);h.unselectable();h.on("mousedown",function(a){a=a.data;a.getTarget().hasAscendant("a",1)||a.preventDefault();});a.on("focus",function(b){m(b);a.on("change",k.input);e.on("scroll",g.input);e.on("resize",g.input);});a.on("blur",function(){h.hide();a.removeListener("change",k.input);e.removeListener("scroll",g.input);e.removeListener("resize",g.input);});a.on("destroy",function(){e.removeListener("scroll",g.input);e.removeListener("resize",g.input);h.clearCustomData();h.remove();});a.focusManager.hasFocus&&h.show();a.focusManager.add(h,1);}}var e=CKEDITOR.document.getWindow(),b=CKEDITOR.tools.cssLength;CKEDITOR.plugins.add("floatingspace",{init:function init(b){b.on("loaded",function(){a(this);},null,null,20);}});}(),CKEDITOR.plugins.add("listblock",{requires:"panel",onLoad:function onLoad(){var a=CKEDITOR.addTemplate("panel-list",'\x3cul role\x3d"presentation" class\x3d"cke_panel_list"\x3e{items}\x3c/ul\x3e'),e=CKEDITOR.addTemplate("panel-list-item",'\x3cli id\x3d"{id}" class\x3d"cke_panel_listItem" role\x3dpresentation\x3e\x3ca id\x3d"{id}_option" _cke_focus\x3d1 hidefocus\x3dtrue title\x3d"{title}" href\x3d"javascript:void(\'{val}\')"  {onclick}\x3d"CKEDITOR.tools.callFunction({clickFn},\'{val}\'); return false;" role\x3d"option"\x3e{text}\x3c/a\x3e\x3c/li\x3e'),b=CKEDITOR.addTemplate("panel-list-group",'\x3ch1 id\x3d"{id}" class\x3d"cke_panel_grouptitle" role\x3d"presentation" \x3e{label}\x3c/h1\x3e'),c=/\'/g;CKEDITOR.ui.panel.prototype.addListBlock=function(a,b){return this.addBlock(a,new CKEDITOR.ui.listBlock(this.getHolderElement(),b));};CKEDITOR.ui.listBlock=CKEDITOR.tools.createClass({base:CKEDITOR.ui.panel.block,$:function $(a,b){b=b||{};var c=b.attributes||(b.attributes={});(this.multiSelect=!!b.multiSelect)&&(c["aria-multiselectable"]=!0);!c.role&&(c.role="listbox");this.base.apply(this,arguments);this.element.setAttribute("role",c.role);c=this.keys;c[40]="next";c[9]="next";c[38]="prev";c[CKEDITOR.SHIFT+9]="prev";c[32]=CKEDITOR.env.ie?"mouseup":"click";CKEDITOR.env.ie&&(c[13]="mouseup");this._.pendingHtml=[];this._.pendingList=[];this._.items={};this._.groups={};},_:{close:function close(){if(this._.started){var b=a.output({items:this._.pendingList.join("")});this._.pendingList=[];this._.pendingHtml.push(b);delete this._.started;}},getClick:function getClick(){this._.click||(this._.click=CKEDITOR.tools.addFunction(function(a){var b=this.toggle(a);if(this.onClick)this.onClick(a,b);},this));return this._.click;}},proto:{add:function add(a,b,m){var f=CKEDITOR.tools.getNextId();this._.started||(this._.started=1,this._.size=this._.size||0);this._.items[a]=f;var h;h=CKEDITOR.tools.htmlEncodeAttr(a).replace(c,"\\'");a={id:f,val:h,onclick:CKEDITOR.env.ie?'onclick\x3d"return false;" onmouseup':"onclick",clickFn:this._.getClick(),title:CKEDITOR.tools.htmlEncodeAttr(m||a),text:b||a};this._.pendingList.push(e.output(a));},startGroup:function startGroup(a){this._.close();var c=CKEDITOR.tools.getNextId();this._.groups[a]=c;this._.pendingHtml.push(b.output({id:c,label:a}));},commit:function commit(){this._.close();this.element.appendHtml(this._.pendingHtml.join(""));delete this._.size;this._.pendingHtml=[];},toggle:function toggle(a){var b=this.isMarked(a);b?this.unmark(a):this.mark(a);return!b;},hideGroup:function hideGroup(a){var b=(a=this.element.getDocument().getById(this._.groups[a]))&&a.getNext();a&&(a.setStyle("display","none"),b&&"ul"==b.getName()&&b.setStyle("display","none"));},hideItem:function hideItem(a){this.element.getDocument().getById(this._.items[a]).setStyle("display","none");},showAll:function showAll(){var a=this._.items,b=this._.groups,c=this.element.getDocument(),f;for(f in a){c.getById(a[f]).setStyle("display","");}for(var e in b){a=c.getById(b[e]),f=a.getNext(),a.setStyle("display",""),f&&"ul"==f.getName()&&f.setStyle("display","");}},mark:function mark(a){this.multiSelect||this.unmarkAll();a=this._.items[a];var b=this.element.getDocument().getById(a);b.addClass("cke_selected");this.element.getDocument().getById(a+"_option").setAttribute("aria-selected",!0);this.onMark&&this.onMark(b);},unmark:function unmark(a){var b=this.element.getDocument();a=this._.items[a];var c=b.getById(a);c.removeClass("cke_selected");b.getById(a+"_option").removeAttribute("aria-selected");this.onUnmark&&this.onUnmark(c);},unmarkAll:function unmarkAll(){var a=this._.items,b=this.element.getDocument(),c;for(c in a){var f=a[c];b.getById(f).removeClass("cke_selected");b.getById(f+"_option").removeAttribute("aria-selected");}this.onUnmark&&this.onUnmark();},isMarked:function isMarked(a){return this.element.getDocument().getById(this._.items[a]).hasClass("cke_selected");},focus:function focus(a){this._.focusIndex=-1;var b=this.element.getElementsByTag("a"),c,f=-1;if(a)for(c=this.element.getDocument().getById(this._.items[a]).getFirst();a=b.getItem(++f);){if(a.equals(c)){this._.focusIndex=f;break;}}else this.element.focus();c&&setTimeout(function(){c.focus();},0);}}});}}),function(){var a='\x3ca id\x3d"{id}" class\x3d"cke_button cke_button__{name} cke_button_{state} {cls}"'+(CKEDITOR.env.gecko&&!CKEDITOR.env.hc?"":" href\x3d\"javascript:void('{titleJs}')\"")+' title\x3d"{title}" tabindex\x3d"-1" hidefocus\x3d"true" role\x3d"button" aria-labelledby\x3d"{id}_label" aria-haspopup\x3d"{hasArrow}" aria-disabled\x3d"{ariaDisabled}"';CKEDITOR.env.gecko&&CKEDITOR.env.mac&&(a+=' onkeypress\x3d"return false;"');CKEDITOR.env.gecko&&(a+=' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');var a=a+(' onkeydown\x3d"return CKEDITOR.tools.callFunction({keydownFn},event);" onfocus\x3d"return CKEDITOR.tools.callFunction({focusFn},event);" '+(CKEDITOR.env.ie?'onclick\x3d"return false;" onmouseup':"onclick")+'\x3d"CKEDITOR.tools.callFunction({clickFn},this);return false;"\x3e\x3cspan class\x3d"cke_button_icon cke_button__{iconName}_icon" style\x3d"{style}"'),a=a+'\x3e\x26nbsp;\x3c/span\x3e\x3cspan id\x3d"{id}_label" class\x3d"cke_button_label cke_button__{name}_label" aria-hidden\x3d"false"\x3e{label}\x3c/span\x3e{arrowHtml}\x3c/a\x3e',e=CKEDITOR.addTemplate("buttonArrow",'\x3cspan class\x3d"cke_button_arrow"\x3e'+(CKEDITOR.env.hc?"\x26#9660;":"")+"\x3c/span\x3e"),b=CKEDITOR.addTemplate("button",a);CKEDITOR.plugins.add("button",{beforeInit:function beforeInit(a){a.ui.addHandler(CKEDITOR.UI_BUTTON,CKEDITOR.ui.button.handler);}});CKEDITOR.UI_BUTTON="button";CKEDITOR.ui.button=function(a){CKEDITOR.tools.extend(this,a,{title:a.label,click:a.click||function(b){b.execCommand(a.command);}});this._={};};CKEDITOR.ui.button.handler={create:function create(a){return new CKEDITOR.ui.button(a);}};CKEDITOR.ui.button.prototype={render:function render(a,d){function l(){var b=a.mode;b&&(b=this.modes[b]?void 0!==t[b]?t[b]:CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,b=a.readOnly&&!this.readOnly?CKEDITOR.TRISTATE_DISABLED:b,this.setState(b),this.refresh&&this.refresh());}var m=CKEDITOR.env,f=this._.id=CKEDITOR.tools.getNextId(),h="",k=this.command,g;this._.editor=a;var n={id:f,button:this,editor:a,focus:function focus(){CKEDITOR.document.getById(f).focus();},execute:function execute(){this.button.click(a);},attach:function attach(a){this.button.attach(a);}},v=CKEDITOR.tools.addFunction(function(a){if(n.onkey)return a=new CKEDITOR.dom.event(a),!1!==n.onkey(n,a.getKeystroke());}),r=CKEDITOR.tools.addFunction(function(a){var b;n.onfocus&&(b=!1!==n.onfocus(n,new CKEDITOR.dom.event(a)));return b;}),q=0;n.clickFn=g=CKEDITOR.tools.addFunction(function(){q&&(a.unlockSelection(1),q=0);n.execute();m.iOS&&a.focus();});if(this.modes){var t={};a.on("beforeModeUnload",function(){a.mode&&this._.state!=CKEDITOR.TRISTATE_DISABLED&&(t[a.mode]=this._.state);},this);a.on("activeFilterChange",l,this);a.on("mode",l,this);!this.readOnly&&a.on("readOnly",l,this);}else k&&(k=a.getCommand(k))&&(k.on("state",function(){this.setState(k.state);},this),h+=k.state==CKEDITOR.TRISTATE_ON?"on":k.state==CKEDITOR.TRISTATE_DISABLED?"disabled":"off");if(this.directional)a.on("contentDirChanged",function(b){var d=CKEDITOR.document.getById(this._.id),f=d.getFirst();b=b.data;b!=a.lang.dir?d.addClass("cke_"+b):d.removeClass("cke_ltr").removeClass("cke_rtl");f.setAttribute("style",CKEDITOR.skin.getIconStyle(w,"rtl"==b,this.icon,this.iconOffset));},this);k||(h+="off");var p=this.name||this.command,w=p;this.icon&&!/\./.test(this.icon)&&(w=this.icon,this.icon=null);h={id:f,name:p,iconName:w,label:this.label,cls:this.className||"",state:h,ariaDisabled:"disabled"==h?"true":"false",title:this.title,titleJs:m.gecko&&!m.hc?"":(this.title||"").replace("'",""),hasArrow:this.hasArrow?"true":"false",keydownFn:v,focusFn:r,clickFn:g,style:CKEDITOR.skin.getIconStyle(w,"rtl"==a.lang.dir,this.icon,this.iconOffset),arrowHtml:this.hasArrow?e.output():""};b.output(h,d);if(this.onRender)this.onRender();return n;},setState:function setState(a){if(this._.state==a)return!1;this._.state=a;var b=CKEDITOR.document.getById(this._.id);return b?(b.setState(a,"cke_button"),a==CKEDITOR.TRISTATE_DISABLED?b.setAttribute("aria-disabled",!0):b.removeAttribute("aria-disabled"),this.hasArrow?(a=a==CKEDITOR.TRISTATE_ON?this._.editor.lang.button.selectedLabel.replace(/%1/g,this.label):this.label,CKEDITOR.document.getById(this._.id+"_label").setText(a)):a==CKEDITOR.TRISTATE_ON?b.setAttribute("aria-pressed",!0):b.removeAttribute("aria-pressed"),!0):!1;},getState:function getState(){return this._.state;},toFeature:function toFeature(a){if(this._.feature)return this._.feature;var b=this;this.allowedContent||this.requiredContent||!this.command||(b=a.getCommand(this.command)||b);return this._.feature=b;}};CKEDITOR.ui.prototype.addButton=function(a,b){this.add(a,CKEDITOR.UI_BUTTON,b);};}(),CKEDITOR.plugins.add("richcombo",{requires:"floatpanel,listblock,button",beforeInit:function beforeInit(a){a.ui.addHandler(CKEDITOR.UI_RICHCOMBO,CKEDITOR.ui.richCombo.handler);}}),function(){var a='\x3cspan id\x3d"{id}" class\x3d"cke_combo cke_combo__{name} {cls}" role\x3d"presentation"\x3e\x3cspan id\x3d"{id}_label" class\x3d"cke_combo_label"\x3e{label}\x3c/span\x3e\x3ca class\x3d"cke_combo_button" title\x3d"{title}" tabindex\x3d"-1"'+(CKEDITOR.env.gecko&&!CKEDITOR.env.hc?"":" href\x3d\"javascript:void('{titleJs}')\"")+' hidefocus\x3d"true" role\x3d"button" aria-labelledby\x3d"{id}_label" aria-haspopup\x3d"true"';CKEDITOR.env.gecko&&CKEDITOR.env.mac&&(a+=' onkeypress\x3d"return false;"');CKEDITOR.env.gecko&&(a+=' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');var a=a+(' onkeydown\x3d"return CKEDITOR.tools.callFunction({keydownFn},event,this);" onfocus\x3d"return CKEDITOR.tools.callFunction({focusFn},event);" '+(CKEDITOR.env.ie?'onclick\x3d"return false;" onmouseup':"onclick")+'\x3d"CKEDITOR.tools.callFunction({clickFn},this);return false;"\x3e\x3cspan id\x3d"{id}_text" class\x3d"cke_combo_text cke_combo_inlinelabel"\x3e{label}\x3c/span\x3e\x3cspan class\x3d"cke_combo_open"\x3e\x3cspan class\x3d"cke_combo_arrow"\x3e'+(CKEDITOR.env.hc?"\x26#9660;":CKEDITOR.env.air?"\x26nbsp;":"")+"\x3c/span\x3e\x3c/span\x3e\x3c/a\x3e\x3c/span\x3e"),e=CKEDITOR.addTemplate("combo",a);CKEDITOR.UI_RICHCOMBO="richcombo";CKEDITOR.ui.richCombo=CKEDITOR.tools.createClass({$:function $(a){CKEDITOR.tools.extend(this,a,{canGroup:!1,title:a.label,modes:{wysiwyg:1},editorFocus:1});a=this.panel||{};delete this.panel;this.id=CKEDITOR.tools.getNextNumber();this.document=a.parent&&a.parent.getDocument()||CKEDITOR.document;a.className="cke_combopanel";a.block={multiSelect:a.multiSelect,attributes:a.attributes};a.toolbarRelated=!0;this._={panelDefinition:a,items:{}};},proto:{renderHtml:function renderHtml(a){var c=[];this.render(a,c);return c.join("");},render:function render(a,c){function d(){if(this.getState()!=CKEDITOR.TRISTATE_ON){var c=this.modes[a.mode]?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED;a.readOnly&&!this.readOnly&&(c=CKEDITOR.TRISTATE_DISABLED);this.setState(c);this.setValue("");c!=CKEDITOR.TRISTATE_DISABLED&&this.refresh&&this.refresh();}}var l=CKEDITOR.env,m="cke_"+this.id,f=CKEDITOR.tools.addFunction(function(c){v&&(a.unlockSelection(1),v=0);k.execute(c);},this),h=this,k={id:m,combo:this,focus:function focus(){CKEDITOR.document.getById(m).getChild(1).focus();},execute:function execute(c){var d=h._;if(d.state!=CKEDITOR.TRISTATE_DISABLED)if(h.createPanel(a),d.on)d.panel.hide();else{h.commit();var f=h.getValue();f?d.list.mark(f):d.list.unmarkAll();d.panel.showBlock(h.id,new CKEDITOR.dom.element(c),4);}},clickFn:f};a.on("activeFilterChange",d,this);a.on("mode",d,this);a.on("selectionChange",d,this);!this.readOnly&&a.on("readOnly",d,this);var g=CKEDITOR.tools.addFunction(function(c,d){c=new CKEDITOR.dom.event(c);var e=c.getKeystroke();if(40==e)a.once("panelShow",function(a){a.data._.panel._.currentBlock.onKeyDown(40);});switch(e){case 13:case 32:case 40:CKEDITOR.tools.callFunction(f,d);break;default:k.onkey(k,e);}c.preventDefault();}),n=CKEDITOR.tools.addFunction(function(){k.onfocus&&k.onfocus();}),v=0;k.keyDownFn=g;l={id:m,name:this.name||this.command,label:this.label,title:this.title,cls:this.className||"",titleJs:l.gecko&&!l.hc?"":(this.title||"").replace("'",""),keydownFn:g,focusFn:n,clickFn:f};e.output(l,c);if(this.onRender)this.onRender();return k;},createPanel:function createPanel(a){if(!this._.panel){var c=this._.panelDefinition,d=this._.panelDefinition.block,e=c.parent||CKEDITOR.document.getBody(),m="cke_combopanel__"+this.name,f=new CKEDITOR.ui.floatPanel(a,e,c),h=f.addListBlock(this.id,d),k=this;f.onShow=function(){this.element.addClass(m);k.setState(CKEDITOR.TRISTATE_ON);k._.on=1;k.editorFocus&&!a.focusManager.hasFocus&&a.focus();if(k.onOpen)k.onOpen();a.once("panelShow",function(){h.focus(!h.multiSelect&&k.getValue());});};f.onHide=function(c){this.element.removeClass(m);k.setState(k.modes&&k.modes[a.mode]?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);k._.on=0;if(!c&&k.onClose)k.onClose();};f.onEscape=function(){f.hide(1);};h.onClick=function(a,b){k.onClick&&k.onClick.call(k,a,b);f.hide();};this._.panel=f;this._.list=h;f.getBlock(this.id).onHide=function(){k._.on=0;k.setState(CKEDITOR.TRISTATE_OFF);};this.init&&this.init();}},setValue:function setValue(a,c){this._.value=a;var d=this.document.getById("cke_"+this.id+"_text");d&&(a||c?d.removeClass("cke_combo_inlinelabel"):(c=this.label,d.addClass("cke_combo_inlinelabel")),d.setText("undefined"!=typeof c?c:a));},getValue:function getValue(){return this._.value||"";},unmarkAll:function unmarkAll(){this._.list.unmarkAll();},mark:function mark(a){this._.list.mark(a);},hideItem:function hideItem(a){this._.list.hideItem(a);},hideGroup:function hideGroup(a){this._.list.hideGroup(a);},showAll:function showAll(){this._.list.showAll();},add:function add(a,c,d){this._.items[a]=d||a;this._.list.add(a,c,d);},startGroup:function startGroup(a){this._.list.startGroup(a);},commit:function commit(){this._.committed||(this._.list.commit(),this._.committed=1,CKEDITOR.ui.fire("ready",this));this._.committed=1;},setState:function setState(a){if(this._.state!=a){var c=this.document.getById("cke_"+this.id);c.setState(a,"cke_combo");a==CKEDITOR.TRISTATE_DISABLED?c.setAttribute("aria-disabled",!0):c.removeAttribute("aria-disabled");this._.state=a;}},getState:function getState(){return this._.state;},enable:function enable(){this._.state==CKEDITOR.TRISTATE_DISABLED&&this.setState(this._.lastState);},disable:function disable(){this._.state!=CKEDITOR.TRISTATE_DISABLED&&(this._.lastState=this._.state,this.setState(CKEDITOR.TRISTATE_DISABLED));}},statics:{handler:{create:function create(a){return new CKEDITOR.ui.richCombo(a);}}}});CKEDITOR.ui.prototype.addRichCombo=function(a,c){this.add(a,CKEDITOR.UI_RICHCOMBO,c);};}(),CKEDITOR.plugins.add("format",{requires:"richcombo",init:function init(a){if(!a.blockless){for(var e=a.config,b=a.lang.format,c=e.format_tags.split(";"),d={},l=0,m=[],f=0;f<c.length;f++){var h=c[f],k=new CKEDITOR.style(e["format_"+h]);if(!a.filter.customConfig||a.filter.check(k))l++,d[h]=k,d[h]._.enterMode=a.config.enterMode,m.push(k);}0!==l&&a.ui.addRichCombo("Format",{label:b.label,title:b.panelTitle,toolbar:"styles,20",allowedContent:m,panel:{css:[CKEDITOR.skin.getPath("editor")].concat(e.contentsCss),multiSelect:!1,attributes:{"aria-label":b.panelTitle}},init:function init(){this.startGroup(b.panelTitle);for(var a in d){var c=b["tag_"+a];this.add(a,d[a].buildPreview(c),c);}},onClick:function onClick(b){a.focus();a.fire("saveSnapshot");b=d[b];var c=a.elementPath();a[b.checkActive(c,a)?"removeStyle":"applyStyle"](b);setTimeout(function(){a.fire("saveSnapshot");},0);},onRender:function onRender(){a.on("selectionChange",function(b){var c=this.getValue();b=b.data.path;this.refresh();for(var f in d){if(d[f].checkActive(b,a)){f!=c&&this.setValue(f,a.lang.format["tag_"+f]);return;}}this.setValue("");},this);},onOpen:function onOpen(){this.showAll();for(var b in d){a.activeFilter.check(d[b])||this.hideItem(b);}},refresh:function refresh(){var b=a.elementPath();if(b){if(b.isContextFor("p"))for(var c in d){if(a.activeFilter.check(d[c]))return;}this.setState(CKEDITOR.TRISTATE_DISABLED);}}});}}}),CKEDITOR.config.format_tags="p;h1;h2;h3;h4;h5;h6;pre;address;div",CKEDITOR.config.format_p={element:"p"},CKEDITOR.config.format_div={element:"div"},CKEDITOR.config.format_pre={element:"pre"},CKEDITOR.config.format_address={element:"address"},CKEDITOR.config.format_h1={element:"h1"},CKEDITOR.config.format_h2={element:"h2"},CKEDITOR.config.format_h3={element:"h3"},CKEDITOR.config.format_h4={element:"h4"},CKEDITOR.config.format_h5={element:"h5"},CKEDITOR.config.format_h6={element:"h6"},function(){var a={canUndo:!1,exec:function exec(a){var b=a.document.createElement("hr");a.insertElement(b);},allowedContent:"hr",requiredContent:"hr"};CKEDITOR.plugins.add("horizontalrule",{init:function init(e){e.blockless||(e.addCommand("horizontalrule",a),e.ui.addButton&&e.ui.addButton("HorizontalRule",{label:e.lang.horizontalrule.toolbar,command:"horizontalrule",toolbar:"insert,40"}));}});}(),CKEDITOR.plugins.add("htmlwriter",{init:function init(a){var e=new CKEDITOR.htmlWriter();e.forceSimpleAmpersand=a.config.forceSimpleAmpersand;e.indentationChars=a.config.dataIndentationChars||"\t";a.dataProcessor.writer=e;}}),CKEDITOR.htmlWriter=CKEDITOR.tools.createClass({base:CKEDITOR.htmlParser.basicWriter,$:function $(){this.base();this.indentationChars="\t";this.selfClosingEnd=" /\x3e";this.lineBreakChars="\n";this.sortAttributes=1;this._.indent=0;this._.indentation="";this._.inPre=0;this._.rules={};var a=CKEDITOR.dtd,e;for(e in CKEDITOR.tools.extend({},a.$nonBodyContent,a.$block,a.$listItem,a.$tableContent)){this.setRules(e,{indent:!a[e]["#"],breakBeforeOpen:1,breakBeforeClose:!a[e]["#"],breakAfterClose:1,needsSpace:e in a.$block&&!(e in{li:1,dt:1,dd:1})});}this.setRules("br",{breakAfterOpen:1});this.setRules("title",{indent:0,breakAfterOpen:0});this.setRules("style",{indent:0,breakBeforeClose:1});this.setRules("pre",{breakAfterOpen:1,indent:0});},proto:{openTag:function openTag(a){var e=this._.rules[a];this._.afterCloser&&e&&e.needsSpace&&this._.needsSpace&&this._.output.push("\n");this._.indent?this.indentation():e&&e.breakBeforeOpen&&(this.lineBreak(),this.indentation());this._.output.push("\x3c",a);this._.afterCloser=0;},openTagClose:function openTagClose(a,e){var b=this._.rules[a];e?(this._.output.push(this.selfClosingEnd),b&&b.breakAfterClose&&(this._.needsSpace=b.needsSpace)):(this._.output.push("\x3e"),b&&b.indent&&(this._.indentation+=this.indentationChars));b&&b.breakAfterOpen&&this.lineBreak();"pre"==a&&(this._.inPre=1);},attribute:function attribute(a,e){"string"==typeof e&&(this.forceSimpleAmpersand&&(e=e.replace(/&amp;/g,"\x26")),e=CKEDITOR.tools.htmlEncodeAttr(e));this._.output.push(" ",a,'\x3d"',e,'"');},closeTag:function closeTag(a){var e=this._.rules[a];e&&e.indent&&(this._.indentation=this._.indentation.substr(this.indentationChars.length));this._.indent?this.indentation():e&&e.breakBeforeClose&&(this.lineBreak(),this.indentation());this._.output.push("\x3c/",a,"\x3e");"pre"==a&&(this._.inPre=0);e&&e.breakAfterClose&&(this.lineBreak(),this._.needsSpace=e.needsSpace);this._.afterCloser=1;},text:function text(a){this._.indent&&(this.indentation(),!this._.inPre&&(a=CKEDITOR.tools.ltrim(a)));this._.output.push(a);},comment:function comment(a){this._.indent&&this.indentation();this._.output.push("\x3c!--",a,"--\x3e");},lineBreak:function lineBreak(){!this._.inPre&&0<this._.output.length&&this._.output.push(this.lineBreakChars);this._.indent=1;},indentation:function indentation(){!this._.inPre&&this._.indentation&&this._.output.push(this._.indentation);this._.indent=0;},reset:function reset(){this._.output=[];this._.indent=0;this._.indentation="";this._.afterCloser=0;this._.inPre=0;this._.needsSpace=0;},setRules:function setRules(a,e){var b=this._.rules[a];b?CKEDITOR.tools.extend(b,e,!0):this._.rules[a]=e;}}}),function(){function a(a,c){c||(c=a.getSelection().getSelectedElement());if(c&&c.is("img")&&!c.data("cke-realelement")&&!c.isReadOnly())return c;}function e(a){var c=a.getStyle("float");if("inherit"==c||"none"==c)c=0;c||(c=a.getAttribute("align"));return c;}CKEDITOR.plugins.add("image",{requires:"dialog",init:function init(b){if(!b.plugins.image2){CKEDITOR.dialog.add("image",this.path+"dialogs/image.js");var c="img[alt,!src]{border-style,border-width,float,height,margin,margin-bottom,margin-left,margin-right,margin-top,width}";CKEDITOR.dialog.isTabEnabled(b,"image","advanced")&&(c="img[alt,dir,id,lang,longdesc,!src,title]{*}(*)");b.addCommand("image",new CKEDITOR.dialogCommand("image",{allowedContent:c,requiredContent:"img[alt,src]",contentTransformations:[["img{width}: sizeToStyle","img[width]: sizeToAttribute"],["img{float}: alignmentToStyle","img[align]: alignmentToAttribute"]]}));b.ui.addButton&&b.ui.addButton("Image",{label:b.lang.common.image,command:"image",toolbar:"insert,10"});b.on("doubleclick",function(a){var b=a.data.element;!b.is("img")||b.data("cke-realelement")||b.isReadOnly()||(a.data.dialog="image");});b.addMenuItems&&b.addMenuItems({image:{label:b.lang.image.menu,command:"image",group:"image"}});b.contextMenu&&b.contextMenu.addListener(function(c){if(a(b,c))return{image:CKEDITOR.TRISTATE_OFF};});}},afterInit:function afterInit(b){function c(c){var l=b.getCommand("justify"+c);if(l){if("left"==c||"right"==c)l.on("exec",function(l){var f=a(b),h;f&&(h=e(f),h==c?(f.removeStyle("float"),c==e(f)&&f.removeAttribute("align")):f.setStyle("float",c),l.cancel());});l.on("refresh",function(l){var f=a(b);f&&(f=e(f),this.setState(f==c?CKEDITOR.TRISTATE_ON:"right"==c||"left"==c?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED),l.cancel());});}}b.plugins.image2||(c("left"),c("right"),c("center"),c("block"));}});}(),CKEDITOR.config.image_removeLinkByEmptyURL=!0,function(){function a(a,b){var d=c.exec(a),e=c.exec(b);if(d){if(!d[2]&&"px"==e[2])return e[1];if("px"==d[2]&&!e[2])return e[1]+"px";}return b;}var e=CKEDITOR.htmlParser.cssStyle,b=CKEDITOR.tools.cssLength,c=/^((?:\d*(?:\.\d+))|(?:\d+))(.*)?$/i,d={elements:{$:function $(b){var c=b.attributes;if((c=(c=(c=c&&c["data-cke-realelement"])&&new CKEDITOR.htmlParser.fragment.fromHtml(decodeURIComponent(c)))&&c.children[0])&&b.attributes["data-cke-resizable"]){var d=new e(b).rules;b=c.attributes;var h=d.width,d=d.height;h&&(b.width=a(b.width,h));d&&(b.height=a(b.height,d));}return c;}}};CKEDITOR.plugins.add("fakeobjects",{init:function init(a){a.filter.allow("img[!data-cke-realelement,src,alt,title](*){*}","fakeobjects");},afterInit:function afterInit(a){(a=(a=a.dataProcessor)&&a.htmlFilter)&&a.addRules(d,{applyToAll:!0});}});CKEDITOR.editor.prototype.createFakeElement=function(a,c,d,h){var k=this.lang.fakeobjects,k=k[d]||k.unknown;c={"class":c,"data-cke-realelement":encodeURIComponent(a.getOuterHtml()),"data-cke-real-node-type":a.type,alt:k,title:k,align:a.getAttribute("align")||""};CKEDITOR.env.hc||(c.src=CKEDITOR.tools.transparentImageData);d&&(c["data-cke-real-element-type"]=d);h&&(c["data-cke-resizable"]=h,d=new e(),h=a.getAttribute("width"),a=a.getAttribute("height"),h&&(d.rules.width=b(h)),a&&(d.rules.height=b(a)),d.populate(c));return this.document.createElement("img",{attributes:c});};CKEDITOR.editor.prototype.createFakeParserElement=function(a,c,d,h){var k=this.lang.fakeobjects,k=k[d]||k.unknown,g;g=new CKEDITOR.htmlParser.basicWriter();a.writeHtml(g);g=g.getHtml();c={"class":c,"data-cke-realelement":encodeURIComponent(g),"data-cke-real-node-type":a.type,alt:k,title:k,align:a.attributes.align||""};CKEDITOR.env.hc||(c.src=CKEDITOR.tools.transparentImageData);d&&(c["data-cke-real-element-type"]=d);h&&(c["data-cke-resizable"]=h,h=a.attributes,a=new e(),d=h.width,h=h.height,void 0!==d&&(a.rules.width=b(d)),void 0!==h&&(a.rules.height=b(h)),a.populate(c));return new CKEDITOR.htmlParser.element("img",c);};CKEDITOR.editor.prototype.restoreRealElement=function(b){if(b.data("cke-real-node-type")!=CKEDITOR.NODE_ELEMENT)return null;var c=CKEDITOR.dom.element.createFromHtml(decodeURIComponent(b.data("cke-realelement")),this.document);if(b.data("cke-resizable")){var d=b.getStyle("width");b=b.getStyle("height");d&&c.setAttribute("width",a(c.getAttribute("width"),d));b&&c.setAttribute("height",a(c.getAttribute("height"),b));}return c;};}(),"use strict",function(){function a(a){return a.replace(/'/g,"\\$\x26");}function e(a){for(var b,c=a.length,d=[],f=0;f<c;f++){b=a.charCodeAt(f),d.push(b);}return"String.fromCharCode("+d.join(",")+")";}function b(b,c){var d=b.plugins.link,f=d.compiledProtectionFunction.params,e,h;h=[d.compiledProtectionFunction.name,"("];for(var g=0;g<f.length;g++){d=f[g].toLowerCase(),e=c[d],0<g&&h.push(","),h.push("'",e?a(encodeURIComponent(c[d])):"","'");}h.push(")");return h.join("");}function c(a){a=a.config.emailProtection||"";var b;a&&"encode"!=a&&(b={},a.replace(/^([^(]+)\(([^)]+)\)$/,function(a,c,d){b.name=c;b.params=[];d.replace(/[^,\s]+/g,function(a){b.params.push(a);});}));return b;}CKEDITOR.plugins.add("link",{requires:"dialog,fakeobjects",onLoad:function onLoad(){function a(b){return c.replace(/%1/g,"rtl"==b?"right":"left").replace(/%2/g,"cke_contents_"+b);}var b="background:url("+CKEDITOR.getUrl(this.path+"images"+(CKEDITOR.env.hidpi?"/hidpi":"")+"/anchor.png")+") no-repeat %1 center;border:1px dotted #00f;background-size:16px;",c=".%2 a.cke_anchor,.%2 a.cke_anchor_empty,.cke_editable.%2 a[name],.cke_editable.%2 a[data-cke-saved-name]{"+b+"padding-%1:18px;cursor:auto;}.%2 img.cke_anchor{"+b+"width:16px;min-height:15px;height:1.15em;vertical-align:text-bottom;}";CKEDITOR.addCss(a("ltr")+a("rtl"));},init:function init(a){var b="a[!href]";CKEDITOR.dialog.isTabEnabled(a,"link","advanced")&&(b=b.replace("]",",accesskey,charset,dir,id,lang,name,rel,tabindex,title,type]{*}(*)"));CKEDITOR.dialog.isTabEnabled(a,"link","target")&&(b=b.replace("]",",target,onclick]"));a.addCommand("link",new CKEDITOR.dialogCommand("link",{allowedContent:b,requiredContent:"a[href]"}));a.addCommand("anchor",new CKEDITOR.dialogCommand("anchor",{allowedContent:"a[!name,id]",requiredContent:"a[name]"}));a.addCommand("unlink",new CKEDITOR.unlinkCommand());a.addCommand("removeAnchor",new CKEDITOR.removeAnchorCommand());a.setKeystroke(CKEDITOR.CTRL+76,"link");a.ui.addButton&&(a.ui.addButton("Link",{label:a.lang.link.toolbar,command:"link",toolbar:"links,10"}),a.ui.addButton("Unlink",{label:a.lang.link.unlink,command:"unlink",toolbar:"links,20"}),a.ui.addButton("Anchor",{label:a.lang.link.anchor.toolbar,command:"anchor",toolbar:"links,30"}));CKEDITOR.dialog.add("link",this.path+"dialogs/link.js");CKEDITOR.dialog.add("anchor",this.path+"dialogs/anchor.js");a.on("doubleclick",function(b){var c=CKEDITOR.plugins.link.getSelectedLink(a)||b.data.element;c.isReadOnly()||(c.is("a")?(b.data.dialog=!c.getAttribute("name")||c.getAttribute("href")&&c.getChildCount()?"link":"anchor",b.data.link=c):CKEDITOR.plugins.link.tryRestoreFakeAnchor(a,c)&&(b.data.dialog="anchor"));},null,null,0);a.on("doubleclick",function(b){b.data.dialog in{link:1,anchor:1}&&b.data.link&&a.getSelection().selectElement(b.data.link);},null,null,20);a.addMenuItems&&a.addMenuItems({anchor:{label:a.lang.link.anchor.menu,command:"anchor",group:"anchor",order:1},removeAnchor:{label:a.lang.link.anchor.remove,command:"removeAnchor",group:"anchor",order:5},link:{label:a.lang.link.menu,command:"link",group:"link",order:1},unlink:{label:a.lang.link.unlink,command:"unlink",group:"link",order:5}});a.contextMenu&&a.contextMenu.addListener(function(b){if(!b||b.isReadOnly())return null;b=CKEDITOR.plugins.link.tryRestoreFakeAnchor(a,b);if(!b&&!(b=CKEDITOR.plugins.link.getSelectedLink(a)))return null;var c={};b.getAttribute("href")&&b.getChildCount()&&(c={link:CKEDITOR.TRISTATE_OFF,unlink:CKEDITOR.TRISTATE_OFF});b&&b.hasAttribute("name")&&(c.anchor=c.removeAnchor=CKEDITOR.TRISTATE_OFF);return c;});this.compiledProtectionFunction=c(a);},afterInit:function afterInit(_a11){_a11.dataProcessor.dataFilter.addRules({elements:{a:function a(b){return b.attributes.name?b.children.length?null:_a11.createFakeParserElement(b,"cke_anchor","anchor"):null;}}});var b=_a11._.elementsPath&&_a11._.elementsPath.filters;b&&b.push(function(b,c){if("a"==c&&(CKEDITOR.plugins.link.tryRestoreFakeAnchor(_a11,b)||b.getAttribute("name")&&(!b.getAttribute("href")||!b.getChildCount())))return"anchor";});}});var d=/^javascript:/,l=/^mailto:([^?]+)(?:\?(.+))?$/,m=/subject=([^;?:@&=$,\/]*)/i,f=/body=([^;?:@&=$,\/]*)/i,h=/^#(.*)$/,k=/^((?:http|https|ftp|news):\/\/)?(.*)$/,g=/^(_(?:self|top|parent|blank))$/,n=/^javascript:void\(location\.href='mailto:'\+String\.fromCharCode\(([^)]+)\)(?:\+'(.*)')?\)$/,v=/^javascript:([^(]+)\(([^)]+)\)$/,r=/\s*window.open\(\s*this\.href\s*,\s*(?:'([^']*)'|null)\s*,\s*'([^']*)'\s*\)\s*;\s*return\s*false;*\s*/,q=/(?:^|,)([^=]+)=(\d+|yes|no)/gi,t={id:"advId",dir:"advLangDir",accessKey:"advAccessKey",name:"advName",lang:"advLangCode",tabindex:"advTabIndex",title:"advTitle",type:"advContentType","class":"advCSSClasses",charset:"advCharset",style:"advStyles",rel:"advRel"};CKEDITOR.plugins.link={getSelectedLink:function getSelectedLink(a){var b=a.getSelection(),c=b.getSelectedElement();return c&&c.is("a")?c:(b=b.getRanges()[0])?(b.shrink(CKEDITOR.SHRINK_TEXT),a.elementPath(b.getCommonAncestor()).contains("a",1)):null;},getEditorAnchors:function getEditorAnchors(a){for(var b=a.editable(),c=b.isInline()&&!a.plugins.divarea?a.document:b,b=c.getElementsByTag("a"),c=c.getElementsByTag("img"),d=[],f=0,e;e=b.getItem(f++);){(e.data("cke-saved-name")||e.hasAttribute("name"))&&d.push({name:e.data("cke-saved-name")||e.getAttribute("name"),id:e.getAttribute("id")});}for(f=0;e=c.getItem(f++);){(e=this.tryRestoreFakeAnchor(a,e))&&d.push({name:e.getAttribute("name"),id:e.getAttribute("id")});}return d;},fakeAnchor:!0,tryRestoreFakeAnchor:function tryRestoreFakeAnchor(a,b){if(b&&b.data("cke-real-element-type")&&"anchor"==b.data("cke-real-element-type")){var c=a.restoreRealElement(b);if(c.data("cke-saved-name"))return c;}},parseLinkAttributes:function parseLinkAttributes(a,b){var c=b&&(b.data("cke-saved-href")||b.getAttribute("href"))||"",e=a.plugins.link.compiledProtectionFunction,u=a.config.emailProtection,x,D={};c.match(d)&&("encode"==u?c=c.replace(n,function(a,b,c){c=c||"";return"mailto:"+String.fromCharCode.apply(String,b.split(","))+c.replace(/\\'/g,"'");}):u&&c.replace(v,function(a,b,c){if(b==e.name){D.type="email";a=D.email={};b=/(^')|('$)/g;c=c.match(/[^,\s]+/g);for(var d=c.length,f,h,g=0;g<d;g++){f=decodeURIComponent,h=c[g].replace(b,"").replace(/\\'/g,"'"),h=f(h),f=e.params[g].toLowerCase(),a[f]=h;}a.address=[a.name,a.domain].join("@");}}));if(!D.type)if(u=c.match(h))D.type="anchor",D.anchor={},D.anchor.name=D.anchor.id=u[1];else if(u=c.match(l)){x=c.match(m);c=c.match(f);D.type="email";var y=D.email={};y.address=u[1];x&&(y.subject=decodeURIComponent(x[1]));c&&(y.body=decodeURIComponent(c[1]));}else c&&(x=c.match(k))&&(D.type="url",D.url={},D.url.protocol=x[1],D.url.url=x[2]);if(b){if(c=b.getAttribute("target"))D.target={type:c.match(g)?c:"frame",name:c};else if(c=(c=b.data("cke-pa-onclick")||b.getAttribute("onclick"))&&c.match(r))for(D.target={type:"popup",name:c[1]};u=q.exec(c[2]);){"yes"!=u[2]&&"1"!=u[2]||u[1]in{height:1,width:1,top:1,left:1}?isFinite(u[2])&&(D.target[u[1]]=u[2]):D.target[u[1]]=!0;}var c={},B;for(B in t){(u=b.getAttribute(B))&&(c[t[B]]=u);}if(B=b.data("cke-saved-name")||c.advName)c.advName=B;CKEDITOR.tools.isEmpty(c)||(D.advanced=c);}return D;},getLinkAttributes:function getLinkAttributes(c,d){var f=c.config.emailProtection||"",h={};switch(d.type){case"url":var f=d.url&&void 0!==d.url.protocol?d.url.protocol:"http://",g=d.url&&CKEDITOR.tools.trim(d.url.url)||"";h["data-cke-saved-href"]=0===g.indexOf("/")?g:f+g;break;case"anchor":f=d.anchor&&d.anchor.id;h["data-cke-saved-href"]="#"+(d.anchor&&d.anchor.name||f||"");break;case"email":var k=d.email,g=k.address;switch(f){case"":case"encode":var l=encodeURIComponent(k.subject||""),m=encodeURIComponent(k.body||""),k=[];l&&k.push("subject\x3d"+l);m&&k.push("body\x3d"+m);k=k.length?"?"+k.join("\x26"):"";"encode"==f?(f=["javascript:void(location.href\x3d'mailto:'+",e(g)],k&&f.push("+'",a(k),"'"),f.push(")")):f=["mailto:",g,k];break;default:f=g.split("@",2),k.name=f[0],k.domain=f[1],f=["javascript:",b(c,k)];}h["data-cke-saved-href"]=f.join("");}if(d.target)if("popup"==d.target.type){for(var f=["window.open(this.href, '",d.target.name||"","', '"],n="resizable status location toolbar menubar fullscreen scrollbars dependent".split(" "),g=n.length,l=function l(a){d.target[a]&&n.push(a+"\x3d"+d.target[a]);},k=0;k<g;k++){n[k]+=d.target[n[k]]?"\x3dyes":"\x3dno";}l("width");l("left");l("height");l("top");f.push(n.join(","),"'); return false;");h["data-cke-pa-onclick"]=f.join("");}else"notSet"!=d.target.type&&d.target.name&&(h.target=d.target.name);if(d.advanced){for(var q in t){(f=d.advanced[t[q]])&&(h[q]=f);}h.name&&(h["data-cke-saved-name"]=h.name);}h["data-cke-saved-href"]&&(h.href=h["data-cke-saved-href"]);q={target:1,onclick:1,"data-cke-pa-onclick":1,"data-cke-saved-name":1};d.advanced&&CKEDITOR.tools.extend(q,t);for(var r in h){delete q[r];}return{set:h,removed:CKEDITOR.tools.objectKeys(q)};},showDisplayTextForElement:function showDisplayTextForElement(a,b){var c={img:1,table:1,tbody:1,thead:1,tfoot:1,input:1,select:1,textarea:1};return b.widgets&&b.widgets.focused?!1:!a||!a.getName||!a.is(c);}};CKEDITOR.unlinkCommand=function(){};CKEDITOR.unlinkCommand.prototype={exec:function exec(a){var b=new CKEDITOR.style({element:"a",type:CKEDITOR.STYLE_INLINE,alwaysRemoveElement:1});a.removeStyle(b);},refresh:function refresh(a,b){var c=b.lastElement&&b.lastElement.getAscendant("a",!0);c&&"a"==c.getName()&&c.getAttribute("href")&&c.getChildCount()?this.setState(CKEDITOR.TRISTATE_OFF):this.setState(CKEDITOR.TRISTATE_DISABLED);},contextSensitive:1,startDisabled:1,requiredContent:"a[href]"};CKEDITOR.removeAnchorCommand=function(){};CKEDITOR.removeAnchorCommand.prototype={exec:function exec(a){var b=a.getSelection(),c=b.createBookmarks(),d;if(b&&(d=b.getSelectedElement())&&(d.getChildCount()?d.is("a"):CKEDITOR.plugins.link.tryRestoreFakeAnchor(a,d)))d.remove(1);else if(d=CKEDITOR.plugins.link.getSelectedLink(a))d.hasAttribute("href")?(d.removeAttributes({name:1,"data-cke-saved-name":1}),d.removeClass("cke_anchor")):d.remove(1);b.selectBookmarks(c);},requiredContent:"a[name]"};CKEDITOR.tools.extend(CKEDITOR.config,{linkShowAdvancedTab:!0,linkShowTargetTab:!0});}(),"use strict",function(){function a(a,b,c){return n(b)&&n(c)&&c.equals(b.getNext(function(a){return!(Z(a)||X(a)||v(a));}));}function e(a){this.upper=a[0];this.lower=a[1];this.set.apply(this,a.slice(2));}function b(a){var b=a.element;if(b&&n(b)&&(b=b.getAscendant(a.triggers,!0))&&a.editable.contains(b)){var c=m(b);if("true"==c.getAttribute("contenteditable"))return b;if(c.is(a.triggers))return c;}return null;}function c(a,b,c){u(a,b);u(a,c);a=b.size.bottom;c=c.size.top;return a&&c?0|(a+c)/2:a||c;}function d(a,b,c){return b=b[c?"getPrevious":"getNext"](function(b){return b&&b.type==CKEDITOR.NODE_TEXT&&!Z(b)||n(b)&&!v(b)&&!g(a,b);});}function l(a,b,c){return a>b&&a<c;}function m(a,b){if(a.data("cke-editable"))return null;for(b||(a=a.getParent());a&&!a.data("cke-editable");){if(a.hasAttribute("contenteditable"))return a;a=a.getParent();}return null;}function f(a){var b=a.doc,c=F('\x3cspan contenteditable\x3d"false" style\x3d"'+Q+"position:absolute;border-top:1px dashed "+a.boxColor+'"\x3e\x3c/span\x3e',b),d=CKEDITOR.getUrl(this.path+"images/"+(E.hidpi?"hidpi/":"")+"icon"+(a.rtl?"-rtl":"")+".png");B(c,{attach:function attach(){this.wrap.getParent()||this.wrap.appendTo(a.editable,!0);return this;},lineChildren:[B(F('\x3cspan title\x3d"'+a.editor.lang.magicline.title+'" contenteditable\x3d"false"\x3e\x26#8629;\x3c/span\x3e',b),{base:Q+"height:17px;width:17px;"+(a.rtl?"left":"right")+":17px;background:url("+d+") center no-repeat "+a.boxColor+";cursor:pointer;"+(E.hc?"font-size: 15px;line-height:14px;border:1px solid #fff;text-align:center;":"")+(E.hidpi?"background-size: 9px 10px;":""),looks:["top:-8px; border-radius: 2px;","top:-17px; border-radius: 2px 2px 0px 0px;","top:-1px; border-radius: 0px 0px 2px 2px;"]}),B(F(V,b),{base:Y+"left:0px;border-left-color:"+a.boxColor+";",looks:["border-width:8px 0 8px 8px;top:-8px","border-width:8px 0 0 8px;top:-8px","border-width:0 0 8px 8px;top:0px"]}),B(F(V,b),{base:Y+"right:0px;border-right-color:"+a.boxColor+";",looks:["border-width:8px 8px 8px 0;top:-8px","border-width:8px 8px 0 0;top:-8px","border-width:0 8px 8px 0;top:0px"]})],detach:function detach(){this.wrap.getParent()&&this.wrap.remove();return this;},mouseNear:function mouseNear(){u(a,this);var b=a.holdDistance,c=this.size;return c&&l(a.mouse.y,c.top-b,c.bottom+b)&&l(a.mouse.x,c.left-b,c.right+b)?!0:!1;},place:function place(){var b=a.view,c=a.editable,d=a.trigger,f=d.upper,e=d.lower,h=f||e,g=h.getParent(),k={};this.trigger=d;f&&u(a,f,!0);e&&u(a,e,!0);u(a,g,!0);a.inInlineMode&&x(a,!0);g.equals(c)?(k.left=b.scroll.x,k.right=-b.scroll.x,k.width=""):(k.left=h.size.left-h.size.margin.left+b.scroll.x-(a.inInlineMode?b.editable.left+b.editable.border.left:0),k.width=h.size.outerWidth+h.size.margin.left+h.size.margin.right+b.scroll.x,k.right="");f&&e?k.top=f.size.margin.bottom===e.size.margin.top?0|f.size.bottom+f.size.margin.bottom/2:f.size.margin.bottom<e.size.margin.top?f.size.bottom+f.size.margin.bottom:f.size.bottom+f.size.margin.bottom-e.size.margin.top:f?e||(k.top=f.size.bottom+f.size.margin.bottom):k.top=e.size.top-e.size.margin.top;d.is(T)||l(k.top,b.scroll.y-15,b.scroll.y+5)?(k.top=a.inInlineMode?0:b.scroll.y,this.look(T)):d.is(O)||l(k.top,b.pane.bottom-5,b.pane.bottom+15)?(k.top=a.inInlineMode?b.editable.height+b.editable.padding.top+b.editable.padding.bottom:b.pane.bottom-1,this.look(O)):(a.inInlineMode&&(k.top-=b.editable.top+b.editable.border.top),this.look(K));a.inInlineMode&&(k.top--,k.top+=b.editable.scroll.top,k.left+=b.editable.scroll.left);for(var m in k){k[m]=CKEDITOR.tools.cssLength(k[m]);}this.setStyles(k);},look:function look(a){if(this.oldLook!=a){for(var b=this.lineChildren.length,c;b--;){(c=this.lineChildren[b]).setAttribute("style",c.base+c.looks[0|a/2]);}this.oldLook=a;}},wrap:new C("span",a.doc)});for(b=c.lineChildren.length;b--;){c.lineChildren[b].appendTo(c);}c.look(K);c.appendTo(c.wrap);c.unselectable();c.lineChildren[0].on("mouseup",function(b){c.detach();h(a,function(b){var c=a.line.trigger;b[c.is(I)?"insertBefore":"insertAfter"](c.is(I)?c.lower:c.upper);},!0);a.editor.focus();E.ie||a.enterMode==CKEDITOR.ENTER_BR||a.hotNode.scrollIntoView();b.data.preventDefault(!0);});c.on("mousedown",function(a){a.data.preventDefault(!0);});a.line=c;}function h(a,b,c){var d=new CKEDITOR.dom.range(a.doc),f=a.editor,e;E.ie&&a.enterMode==CKEDITOR.ENTER_BR?e=a.doc.createText(ca):(e=(e=m(a.element,!0))&&e.data("cke-enter-mode")||a.enterMode,e=new C(M[e],a.doc),e.is("br")||a.doc.createText(ca).appendTo(e));c&&f.fire("saveSnapshot");b(e);d.moveToPosition(e,CKEDITOR.POSITION_AFTER_START);f.getSelection().selectRanges([d]);a.hotNode=e;c&&f.fire("saveSnapshot");}function k(a,c){return{canUndo:!0,modes:{wysiwyg:1},exec:function(){function f(b){var d=E.ie&&9>E.version?" ":ca,e=a.hotNode&&a.hotNode.getText()==d&&a.element.equals(a.hotNode)&&a.lastCmdDirection===!!c;h(a,function(d){e&&a.hotNode&&a.hotNode.remove();d[c?"insertAfter":"insertBefore"](b);d.setAttributes({"data-cke-magicline-hot":1,"data-cke-magicline-dir":!!c});a.lastCmdDirection=!!c;});E.ie||a.enterMode==CKEDITOR.ENTER_BR||a.hotNode.scrollIntoView();a.line.detach();}return function(e){e=e.getSelection().getStartElement();var h;e=e.getAscendant(N,1);if(!t(a,e)&&e&&!e.equals(a.editable)&&!e.contains(a.editable)){(h=m(e))&&"false"==h.getAttribute("contenteditable")&&(e=h);a.element=e;h=d(a,e,!c);var g;n(h)&&h.is(a.triggers)&&h.is(L)&&(!d(a,h,!c)||(g=d(a,h,!c))&&n(g)&&g.is(a.triggers))?f(h):(g=b(a,e),n(g)&&(d(a,g,!c)?(e=d(a,g,!c))&&n(e)&&e.is(a.triggers)&&f(g):f(g)));}};}()};}function g(a,b){if(!b||b.type!=CKEDITOR.NODE_ELEMENT||!b.$)return!1;var c=a.line;return c.wrap.equals(b)||c.wrap.contains(b);}function n(a){return a&&a.type==CKEDITOR.NODE_ELEMENT&&a.$;}function v(a){if(!n(a))return!1;var b;(b=r(a))||(n(a)?(b={left:1,right:1,center:1},b=!(!b[a.getComputedStyle("float")]&&!b[a.getAttribute("align")])):b=!1);return b;}function r(a){return!!{absolute:1,fixed:1}[a.getComputedStyle("position")];}function q(a,b){return n(b)?b.is(a.triggers):null;}function t(a,b){if(!b)return!1;for(var c=b.getParents(1),d=c.length;d--;){for(var f=a.tabuList.length;f--;){if(c[d].hasAttribute(a.tabuList[f]))return!0;}}return!1;}function p(a,b,c){b=b[c?"getLast":"getFirst"](function(b){return a.isRelevant(b)&&!b.is(U);});if(!b)return!1;u(a,b);return c?b.size.top>a.mouse.y:b.size.bottom<a.mouse.y;}function w(a){var b=a.editable,c=a.mouse,d=a.view,f=a.triggerOffset;x(a);var h=c.y>(a.inInlineMode?d.editable.top+d.editable.height/2:Math.min(d.editable.height,d.pane.height)/2),b=b[h?"getLast":"getFirst"](function(a){return!(Z(a)||X(a));});if(!b)return null;g(a,b)&&(b=a.line.wrap[h?"getPrevious":"getNext"](function(a){return!(Z(a)||X(a));}));if(!n(b)||v(b)||!q(a,b))return null;u(a,b);return!h&&0<=b.size.top&&l(c.y,0,b.size.top+f)?(a=a.inInlineMode||0===d.scroll.y?T:K,new e([null,b,I,P,a])):h&&b.size.bottom<=d.pane.height&&l(c.y,b.size.bottom-f,d.pane.height)?(a=a.inInlineMode||l(b.size.bottom,d.pane.height-f,d.pane.height)?O:K,new e([b,null,H,P,a])):null;}function z(a){var c=a.mouse,f=a.view,h=a.triggerOffset,g=b(a);if(!g)return null;u(a,g);var h=Math.min(h,0|g.size.outerHeight/2),k=[],m,r;if(l(c.y,g.size.top-1,g.size.top+h))r=!1;else if(l(c.y,g.size.bottom-h,g.size.bottom+1))r=!0;else return null;if(v(g)||p(a,g,r)||g.getParent().is(W))return null;var t=d(a,g,!r);if(t){if(t&&t.type==CKEDITOR.NODE_TEXT)return null;if(n(t)){if(v(t)||!q(a,t)||t.getParent().is(W))return null;k=[t,g][r?"reverse":"concat"]().concat([R,P]);}}else g.equals(a.editable[r?"getLast":"getFirst"](a.isRelevant))?(x(a),r&&l(c.y,g.size.bottom-h,f.pane.height)&&l(g.size.bottom,f.pane.height-h,f.pane.height)?m=O:l(c.y,0,g.size.top+h)&&(m=T)):m=K,k=[null,g][r?"reverse":"concat"]().concat([r?H:I,P,m,g.equals(a.editable[r?"getLast":"getFirst"](a.isRelevant))?r?O:T:K]);return 0 in k?new e(k):null;}function A(a,b,c,d){for(var f=b.getDocumentPosition(),e={},h={},g={},k={},l=ba.length;l--;){e[ba[l]]=parseInt(b.getComputedStyle.call(b,"border-"+ba[l]+"-width"),10)||0,g[ba[l]]=parseInt(b.getComputedStyle.call(b,"padding-"+ba[l]),10)||0,h[ba[l]]=parseInt(b.getComputedStyle.call(b,"margin-"+ba[l]),10)||0;}c&&!d||D(a,d);k.top=f.y-(c?0:a.view.scroll.y);k.left=f.x-(c?0:a.view.scroll.x);k.outerWidth=b.$.offsetWidth;k.outerHeight=b.$.offsetHeight;k.height=k.outerHeight-(g.top+g.bottom+e.top+e.bottom);k.width=k.outerWidth-(g.left+g.right+e.left+e.right);k.bottom=k.top+k.outerHeight;k.right=k.left+k.outerWidth;a.inInlineMode&&(k.scroll={top:b.$.scrollTop,left:b.$.scrollLeft});return B({border:e,padding:g,margin:h,ignoreScroll:c},k,!0);}function u(a,b,c){if(!n(b))return b.size=null;if(!b.size)b.size={};else if(b.size.ignoreScroll==c&&b.size.date>new Date()-S)return null;return B(b.size,A(a,b,c),{date:+new Date()},!0);}function x(a,b){a.view.editable=A(a,a.editable,b,!0);}function D(a,b){a.view||(a.view={});var c=a.view;if(!(!b&&c&&c.date>new Date()-S)){var d=a.win,c=d.getScrollPosition(),d=d.getViewPaneSize();B(a.view,{scroll:{x:c.x,y:c.y,width:a.doc.$.documentElement.scrollWidth-d.width,height:a.doc.$.documentElement.scrollHeight-d.height},pane:{width:d.width,height:d.height,bottom:d.height+c.y},date:+new Date()},!0);}}function y(a,b,c,d){for(var f=d,h=d,g=0,k=!1,l=!1,m=a.view.pane.height,n=a.mouse;n.y+g<m&&0<n.y-g;){k||(k=b(f,d));l||(l=b(h,d));!k&&0<n.y-g&&(f=c(a,{x:n.x,y:n.y-g}));!l&&n.y+g<m&&(h=c(a,{x:n.x,y:n.y+g}));if(k&&l)break;g+=2;}return new e([f,h,null,null]);}CKEDITOR.plugins.add("magicline",{init:function init(a){var c=a.config,l=c.magicline_triggerOffset||30,m={editor:a,enterMode:c.enterMode,triggerOffset:l,holdDistance:0|l*(c.magicline_holdDistance||.5),boxColor:c.magicline_color||"#ff0000",rtl:"rtl"==c.contentsLangDirection,tabuList:["data-cke-hidden-sel"].concat(c.magicline_tabuList||[]),triggers:c.magicline_everywhere?N:{table:1,hr:1,div:1,ul:1,ol:1,dl:1,form:1,blockquote:1}},q,p,u;m.isRelevant=function(a){return n(a)&&!g(m,a)&&!v(a);};a.on("contentDom",function(){var l=a.editable(),n=a.document,v=a.window;B(m,{editable:l,inInlineMode:l.isInline(),doc:n,win:v,hotNode:null},!0);m.boundary=m.inInlineMode?m.editable:m.doc.getDocumentElement();l.is(G.$inline)||(m.inInlineMode&&!r(l)&&l.setStyles({position:"relative",top:null,left:null}),f.call(this,m),D(m),l.attachListener(a,"beforeUndoImage",function(){m.line.detach();}),l.attachListener(a,"beforeGetData",function(){m.line.wrap.getParent()&&(m.line.detach(),a.once("getData",function(){m.line.attach();},null,null,1E3));},null,null,0),l.attachListener(m.inInlineMode?n:n.getWindow().getFrame(),"mouseout",function(b){if("wysiwyg"==a.mode)if(m.inInlineMode){var c=b.data.$.clientX;b=b.data.$.clientY;D(m);x(m,!0);var d=m.view.editable,f=m.view.scroll;c>d.left-f.x&&c<d.right-f.x&&b>d.top-f.y&&b<d.bottom-f.y||(clearTimeout(u),u=null,m.line.detach());}else clearTimeout(u),u=null,m.line.detach();}),l.attachListener(l,"keyup",function(){m.hiddenMode=0;}),l.attachListener(l,"keydown",function(b){if("wysiwyg"==a.mode)switch(b.data.getKeystroke()){case 2228240:case 16:m.hiddenMode=1,m.line.detach();}}),l.attachListener(m.inInlineMode?l:n,"mousemove",function(b){p=!0;if("wysiwyg"==a.mode&&!a.readOnly&&!u){var c={x:b.data.$.clientX,y:b.data.$.clientY};u=setTimeout(function(){m.mouse=c;u=m.trigger=null;D(m);p&&!m.hiddenMode&&a.focusManager.hasFocus&&!m.line.mouseNear()&&(m.element=da(m,!0))&&((m.trigger=w(m)||z(m)||ga(m))&&!t(m,m.trigger.upper||m.trigger.lower)?m.line.attach().place():(m.trigger=null,m.line.detach()),p=!1);},30);}}),l.attachListener(v,"scroll",function(){"wysiwyg"==a.mode&&(m.line.detach(),E.webkit&&(m.hiddenMode=1,clearTimeout(q),q=setTimeout(function(){m.mouseDown||(m.hiddenMode=0);},50)));}),l.attachListener(J?n:v,"mousedown",function(){"wysiwyg"==a.mode&&(m.line.detach(),m.hiddenMode=1,m.mouseDown=1);}),l.attachListener(J?n:v,"mouseup",function(){m.hiddenMode=0;m.mouseDown=0;}),a.addCommand("accessPreviousSpace",k(m)),a.addCommand("accessNextSpace",k(m,!0)),a.setKeystroke([[c.magicline_keystrokePrevious,"accessPreviousSpace"],[c.magicline_keystrokeNext,"accessNextSpace"]]),a.on("loadSnapshot",function(){var b,c,d,f;for(f in{p:1,br:1,div:1}){for(b=a.document.getElementsByTag(f),d=b.count();d--;){if((c=b.getItem(d)).data("cke-magicline-hot")){m.hotNode=c;m.lastCmdDirection="true"===c.data("cke-magicline-dir")?!0:!1;return;}}}}),this.backdoor={accessFocusSpace:h,boxTrigger:e,isLine:g,getAscendantTrigger:b,getNonEmptyNeighbour:d,getSize:A,that:m,triggerEdge:z,triggerEditable:w,triggerExpand:ga});},this);}});var B=CKEDITOR.tools.extend,C=CKEDITOR.dom.element,F=C.createFromHtml,E=CKEDITOR.env,J=CKEDITOR.env.ie&&9>CKEDITOR.env.version,G=CKEDITOR.dtd,M={},I=128,H=64,R=32,P=16,T=4,O=2,K=1,ca=" ",W=G.$listItem,U=G.$tableContent,L=B({},G.$nonEditable,G.$empty),N=G.$block,S=100,Q="width:0px;height:0px;padding:0px;margin:0px;display:block;z-index:9999;color:#fff;position:absolute;font-size: 0px;line-height:0px;",Y=Q+"border-color:transparent;display:block;border-style:solid;",V="\x3cspan\x3e"+ca+"\x3c/span\x3e";M[CKEDITOR.ENTER_BR]="br";M[CKEDITOR.ENTER_P]="p";M[CKEDITOR.ENTER_DIV]="div";e.prototype={set:function set(a,b,c){this.properties=a+b+(c||K);return this;},is:function is(a){return(this.properties&a)==a;}};var da=function(){function a(b,c){var d=b.$.elementFromPoint(c.x,c.y);return d&&d.nodeType?new CKEDITOR.dom.element(d):null;}return function(b,c,d){if(!b.mouse)return null;var f=b.doc,e=b.line.wrap;d=d||b.mouse;var h=a(f,d);c&&g(b,h)&&(e.hide(),h=a(f,d),e.show());return!h||h.type!=CKEDITOR.NODE_ELEMENT||!h.$||E.ie&&9>E.version&&!b.boundary.equals(h)&&!b.boundary.contains(h)?null:h;};}(),Z=CKEDITOR.dom.walker.whitespaces(),X=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_COMMENT),ga=function(){function b(f){var e=f.element,h,g,k;if(!n(e)||e.contains(f.editable)||e.isReadOnly())return null;k=y(f,function(a,b){return!b.equals(a);},function(a,b){return da(a,!0,b);},e);h=k.upper;g=k.lower;if(a(f,h,g))return k.set(R,8);if(h&&e.contains(h))for(;!h.getParent().equals(e);){h=h.getParent();}else h=e.getFirst(function(a){return d(f,a);});if(g&&e.contains(g))for(;!g.getParent().equals(e);){g=g.getParent();}else g=e.getLast(function(a){return d(f,a);});if(!h||!g)return null;u(f,h);u(f,g);if(!l(f.mouse.y,h.size.top,g.size.bottom))return null;for(var e=Number.MAX_VALUE,m,q,r,t;g&&!g.equals(h)&&(q=h.getNext(f.isRelevant));){m=Math.abs(c(f,h,q)-f.mouse.y),m<e&&(e=m,r=h,t=q),h=q,u(f,h);}if(!r||!t||!l(f.mouse.y,r.size.top,t.size.bottom))return null;k.upper=r;k.lower=t;return k.set(R,8);}function d(a,b){return!(b&&b.type==CKEDITOR.NODE_TEXT||X(b)||v(b)||g(a,b)||b.type==CKEDITOR.NODE_ELEMENT&&b.$&&b.is("br"));}return function(c){var d=b(c),f;if(f=d){f=d.upper;var e=d.lower;f=!f||!e||v(e)||v(f)||e.equals(f)||f.equals(e)||e.contains(f)||f.contains(e)?!1:q(c,f)&&q(c,e)&&a(c,f,e)?!0:!1;}return f?d:null;};}(),ba=["top","left","right","bottom"];}(),CKEDITOR.config.magicline_keystrokePrevious=CKEDITOR.CTRL+CKEDITOR.SHIFT+51,CKEDITOR.config.magicline_keystrokeNext=CKEDITOR.CTRL+CKEDITOR.SHIFT+52,function(){function a(a){if(!a||a.type!=CKEDITOR.NODE_ELEMENT||"form"!=a.getName())return[];for(var b=[],c=["style","className"],d=0;d<c.length;d++){var e=a.$.elements.namedItem(c[d]);e&&(e=new CKEDITOR.dom.element(e),b.push([e,e.nextSibling]),e.remove());}return b;}function e(a,b){if(a&&a.type==CKEDITOR.NODE_ELEMENT&&"form"==a.getName()&&0<b.length)for(var c=b.length-1;0<=c;c--){var d=b[c][0],e=b[c][1];e?d.insertBefore(e):d.appendTo(a);}}function b(b,c){var d=a(b),h={},k=b.$;c||(h["class"]=k.className||"",k.className="");h.inline=k.style.cssText||"";c||(k.style.cssText="position: static; overflow: visible");e(d);return h;}function c(b,c){var d=a(b),h=b.$;"class"in c&&(h.className=c["class"]);"inline"in c&&(h.style.cssText=c.inline);e(d);}function d(a){if(!a.editable().isInline()){var b=CKEDITOR.instances,c;for(c in b){var d=b[c];"wysiwyg"!=d.mode||d.readOnly||(d=d.document.getBody(),d.setAttribute("contentEditable",!1),d.setAttribute("contentEditable",!0));}a.editable().hasFocus&&(a.toolbox.focus(),a.focus());}}CKEDITOR.plugins.add("maximize",{init:function init(a){function e(){var b=k.getViewPaneSize();a.resize(b.width,b.height,null,!0);}if(a.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE){var f=a.lang,h=CKEDITOR.document,k=h.getWindow(),g,n,v,r=CKEDITOR.TRISTATE_OFF;a.addCommand("maximize",{modes:{wysiwyg:!CKEDITOR.env.iOS,source:!CKEDITOR.env.iOS},readOnly:1,editorFocus:!1,exec:function exec(){var q=a.container.getFirst(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasClass("cke_inner");}),t=a.ui.space("contents");if("wysiwyg"==a.mode){var p=a.getSelection();g=p&&p.getRanges();n=k.getScrollPosition();}else{var w=a.editable().$;g=!CKEDITOR.env.ie&&[w.selectionStart,w.selectionEnd];n=[w.scrollLeft,w.scrollTop];}if(this.state==CKEDITOR.TRISTATE_OFF){k.on("resize",e);v=k.getScrollPosition();for(p=a.container;p=p.getParent();){p.setCustomData("maximize_saved_styles",b(p)),p.setStyle("z-index",a.config.baseFloatZIndex-5);}t.setCustomData("maximize_saved_styles",b(t,!0));q.setCustomData("maximize_saved_styles",b(q,!0));t={overflow:CKEDITOR.env.webkit?"":"hidden",width:0,height:0};h.getDocumentElement().setStyles(t);!CKEDITOR.env.gecko&&h.getDocumentElement().setStyle("position","fixed");CKEDITOR.env.gecko&&CKEDITOR.env.quirks||h.getBody().setStyles(t);CKEDITOR.env.ie?setTimeout(function(){k.$.scrollTo(0,0);},0):k.$.scrollTo(0,0);q.setStyle("position",CKEDITOR.env.gecko&&CKEDITOR.env.quirks?"fixed":"absolute");q.$.offsetLeft;q.setStyles({"z-index":a.config.baseFloatZIndex-5,left:"0px",top:"0px"});q.addClass("cke_maximized");e();t=q.getDocumentPosition();q.setStyles({left:-1*t.x+"px",top:-1*t.y+"px"});CKEDITOR.env.gecko&&d(a);}else if(this.state==CKEDITOR.TRISTATE_ON){k.removeListener("resize",e);for(var p=[t,q],z=0;z<p.length;z++){c(p[z],p[z].getCustomData("maximize_saved_styles")),p[z].removeCustomData("maximize_saved_styles");}for(p=a.container;p=p.getParent();){c(p,p.getCustomData("maximize_saved_styles")),p.removeCustomData("maximize_saved_styles");}CKEDITOR.env.ie?setTimeout(function(){k.$.scrollTo(v.x,v.y);},0):k.$.scrollTo(v.x,v.y);q.removeClass("cke_maximized");CKEDITOR.env.webkit&&(q.setStyle("display","inline"),setTimeout(function(){q.setStyle("display","block");},0));a.fire("resize",{outerHeight:a.container.$.offsetHeight,contentsHeight:t.$.offsetHeight,outerWidth:a.container.$.offsetWidth});}this.toggleState();if(p=this.uiItems[0])t=this.state==CKEDITOR.TRISTATE_OFF?f.maximize.maximize:f.maximize.minimize,p=CKEDITOR.document.getById(p._.id),p.getChild(1).setHtml(t),p.setAttribute("title",t),p.setAttribute("href",'javascript:void("'+t+'");');"wysiwyg"==a.mode?g?(CKEDITOR.env.gecko&&d(a),a.getSelection().selectRanges(g),(w=a.getSelection().getStartElement())&&w.scrollIntoView(!0)):k.$.scrollTo(n.x,n.y):(g&&(w.selectionStart=g[0],w.selectionEnd=g[1]),w.scrollLeft=n[0],w.scrollTop=n[1]);g=n=null;r=this.state;a.fire("maximize",this.state);},canUndo:!1});a.ui.addButton&&a.ui.addButton("Maximize",{label:f.maximize.maximize,command:"maximize",toolbar:"tools,10"});a.on("mode",function(){var b=a.getCommand("maximize");b.setState(b.state==CKEDITOR.TRISTATE_DISABLED?CKEDITOR.TRISTATE_DISABLED:r);},null,null,100);}}});}(),function(){function a(a,c,d){var e=CKEDITOR.cleanWord;e?d():(a=CKEDITOR.getUrl(a.config.pasteFromWordCleanupFile||c+"filter/default.js"),CKEDITOR.scriptLoader.load(a,d,null,!0));return!e;}function e(a){a.data.type="html";}CKEDITOR.plugins.add("pastefromword",{requires:"clipboard",init:function init(b){var c=0,d=this.path;b.addCommand("pastefromword",{canUndo:!1,async:!0,exec:function exec(a){var b=this;c=1;a.once("beforePaste",e);a.getClipboardData({title:a.lang.pastefromword.title},function(c){c&&a.fire("paste",{type:"html",dataValue:c.dataValue,method:"paste",dataTransfer:CKEDITOR.plugins.clipboard.initPasteDataTransfer()});a.fire("afterCommandExec",{name:"pastefromword",command:b,returnValue:!!c});});}});b.ui.addButton&&b.ui.addButton("PasteFromWord",{label:b.lang.pastefromword.toolbar,command:"pastefromword",toolbar:"clipboard,50"});b.on("pasteState",function(a){b.getCommand("pastefromword").setState(a.data);});b.on("paste",function(e){var m=e.data,f=m.dataValue;if(f&&(c||/(class=\"?Mso|style=\"[^\"]*\bmso\-|w:WordDocument)/.test(f))){m.dontFilter=!0;var h=a(b,d,function(){if(h)b.fire("paste",m);else if(!b.config.pasteFromWordPromptCleanup||c||confirm(b.lang.pastefromword.confirmCleanup))m.dataValue=CKEDITOR.cleanWord(f,b);c=0;});h&&e.cancel();}},null,null,3);}});}(),function(){var a={canUndo:!1,async:!0,exec:function exec(e){e.getClipboardData({title:e.lang.pastetext.title},function(b){b&&e.fire("paste",{type:"text",dataValue:b.dataValue,method:"paste",dataTransfer:CKEDITOR.plugins.clipboard.initPasteDataTransfer()});e.fire("afterCommandExec",{name:"pastetext",command:a,returnValue:!!b});});}};CKEDITOR.plugins.add("pastetext",{requires:"clipboard",init:function init(e){e.addCommand("pastetext",a);e.ui.addButton&&e.ui.addButton("PasteText",{label:e.lang.pastetext.button,command:"pastetext",toolbar:"clipboard,40"});if(e.config.forcePasteAsPlainText)e.on("beforePaste",function(a){"html"!=a.data.type&&(a.data.type="text");});e.on("pasteState",function(a){e.getCommand("pastetext").setState(a.data);});}});}(),CKEDITOR.plugins.add("removeformat",{init:function init(a){a.addCommand("removeFormat",CKEDITOR.plugins.removeformat.commands.removeformat);a.ui.addButton&&a.ui.addButton("RemoveFormat",{label:a.lang.removeformat.toolbar,command:"removeFormat",toolbar:"cleanup,10"});}}),CKEDITOR.plugins.removeformat={commands:{removeformat:{exec:function exec(a){for(var e=a._.removeFormatRegex||(a._.removeFormatRegex=new RegExp("^(?:"+a.config.removeFormatTags.replace(/,/g,"|")+")$","i")),b=a._.removeAttributes||(a._.removeAttributes=a.config.removeFormatAttributes.split(",")),c=CKEDITOR.plugins.removeformat.filter,d=a.getSelection().getRanges(),l=d.createIterator(),m=function m(a){return a.type==CKEDITOR.NODE_ELEMENT;},f;f=l.getNextRange();){f.collapsed||f.enlarge(CKEDITOR.ENLARGE_ELEMENT);var h=f.createBookmark(),k=h.startNode,g=h.endNode,n=function n(b){for(var d=a.elementPath(b),f=d.elements,h=1,g;(g=f[h])&&!g.equals(d.block)&&!g.equals(d.blockLimit);h++){e.test(g.getName())&&c(a,g)&&b.breakParent(g);}};n(k);if(g)for(n(g),k=k.getNextSourceNode(!0,CKEDITOR.NODE_ELEMENT);k&&!k.equals(g);){if(k.isReadOnly()){if(k.getPosition(g)&CKEDITOR.POSITION_CONTAINS)break;k=k.getNext(m);}else n=k.getNextSourceNode(!1,CKEDITOR.NODE_ELEMENT),"img"==k.getName()&&k.data("cke-realelement")||!c(a,k)||(e.test(k.getName())?k.remove(1):(k.removeAttributes(b),a.fire("removeFormatCleanup",k))),k=n;}f.moveToBookmark(h);}a.forceNextSelectionCheck();a.getSelection().selectRanges(d);}}},filter:function filter(a,e){for(var b=a._.removeFormatFilters||[],c=0;c<b.length;c++){if(!1===b[c](e))return!1;}return!0;}},CKEDITOR.editor.prototype.addRemoveFormatFilter=function(a){this._.removeFormatFilters||(this._.removeFormatFilters=[]);this._.removeFormatFilters.push(a);},CKEDITOR.config.removeFormatTags="b,big,cite,code,del,dfn,em,font,i,ins,kbd,q,s,samp,small,span,strike,strong,sub,sup,tt,u,var",CKEDITOR.config.removeFormatAttributes="class,style,lang,width,height,align,hspace,valign",CKEDITOR.plugins.add("resize",{init:function init(a){function e(b){var d=h.width,e=h.height,m=d+(b.data.$.screenX-f.x)*("rtl"==l?-1:1);b=e+(b.data.$.screenY-f.y);k&&(d=Math.max(c.resize_minWidth,Math.min(m,c.resize_maxWidth)));g&&(e=Math.max(c.resize_minHeight,Math.min(b,c.resize_maxHeight)));a.resize(k?d:null,e);}function b(){CKEDITOR.document.removeListener("mousemove",e);CKEDITOR.document.removeListener("mouseup",b);a.document&&(a.document.removeListener("mousemove",e),a.document.removeListener("mouseup",b));}var c=a.config,d=a.ui.spaceId("resizer"),l=a.element?a.element.getDirection(1):"ltr";!c.resize_dir&&(c.resize_dir="vertical");void 0===c.resize_maxWidth&&(c.resize_maxWidth=3E3);void 0===c.resize_maxHeight&&(c.resize_maxHeight=3E3);void 0===c.resize_minWidth&&(c.resize_minWidth=750);void 0===c.resize_minHeight&&(c.resize_minHeight=250);if(!1!==c.resize_enabled){var m=null,f,h,k=("both"==c.resize_dir||"horizontal"==c.resize_dir)&&c.resize_minWidth!=c.resize_maxWidth,g=("both"==c.resize_dir||"vertical"==c.resize_dir)&&c.resize_minHeight!=c.resize_maxHeight,n=CKEDITOR.tools.addFunction(function(d){m||(m=a.getResizable());h={width:m.$.offsetWidth||0,height:m.$.offsetHeight||0};f={x:d.screenX,y:d.screenY};c.resize_minWidth>h.width&&(c.resize_minWidth=h.width);c.resize_minHeight>h.height&&(c.resize_minHeight=h.height);CKEDITOR.document.on("mousemove",e);CKEDITOR.document.on("mouseup",b);a.document&&(a.document.on("mousemove",e),a.document.on("mouseup",b));d.preventDefault&&d.preventDefault();});a.on("destroy",function(){CKEDITOR.tools.removeFunction(n);});a.on("uiSpace",function(b){if("bottom"==b.data.space){var c="";k&&!g&&(c=" cke_resizer_horizontal");!k&&g&&(c=" cke_resizer_vertical");var f='\x3cspan id\x3d"'+d+'" class\x3d"cke_resizer'+c+" cke_resizer_"+l+'" title\x3d"'+CKEDITOR.tools.htmlEncode(a.lang.common.resize)+'" onmousedown\x3d"CKEDITOR.tools.callFunction('+n+', event)"\x3e'+("ltr"==l?"◢":"◣")+"\x3c/span\x3e";"ltr"==l&&"ltr"==c?b.data.html+=f:b.data.html=f+b.data.html;}},a,null,100);a.on("maximize",function(b){a.ui.space("resizer")[b.data==CKEDITOR.TRISTATE_ON?"hide":"show"]();});}}}),CKEDITOR.plugins.add("menubutton",{requires:"button,menu",onLoad:function onLoad(){var a=function a(_a12){var b=this._,c=b.menu;b.state!==CKEDITOR.TRISTATE_DISABLED&&(b.on&&c?c.hide():(b.previousState=b.state,c||(c=b.menu=new CKEDITOR.menu(_a12,{panel:{className:"cke_menu_panel",attributes:{"aria-label":_a12.lang.common.options}}}),c.onHide=CKEDITOR.tools.bind(function(){var c=this.command?_a12.getCommand(this.command).modes:this.modes;this.setState(!c||c[_a12.mode]?b.previousState:CKEDITOR.TRISTATE_DISABLED);b.on=0;},this),this.onMenu&&c.addListener(this.onMenu)),this.setState(CKEDITOR.TRISTATE_ON),b.on=1,setTimeout(function(){c.show(CKEDITOR.document.getById(b.id),4);},0)));};CKEDITOR.ui.menuButton=CKEDITOR.tools.createClass({base:CKEDITOR.ui.button,$:function $(e){delete e.panel;this.base(e);this.hasArrow=!0;this.click=a;},statics:{handler:{create:function create(a){return new CKEDITOR.ui.menuButton(a);}}}});},beforeInit:function beforeInit(a){a.ui.addHandler(CKEDITOR.UI_MENUBUTTON,CKEDITOR.ui.menuButton.handler);}}),CKEDITOR.UI_MENUBUTTON="menubutton","use strict",CKEDITOR.plugins.add("scayt",{requires:"menubutton,dialog",tabToOpen:null,dialogName:"scaytDialog",init:function init(a){var e=this,b=CKEDITOR.plugins.scayt;this.bindEvents(a);this.parseConfig(a);this.addRule(a);CKEDITOR.dialog.add(this.dialogName,CKEDITOR.getUrl(this.path+"dialogs/options.js"));this.addMenuItems(a);var c=a.lang.scayt,d=CKEDITOR.env;a.ui.add("Scayt",CKEDITOR.UI_MENUBUTTON,{label:c.text_title,title:a.plugins.wsc?a.lang.wsc.title:c.text_title,modes:{wysiwyg:!(d.ie&&(8>d.version||d.quirks))},toolbar:"spellchecker,20",refresh:function refresh(){var c=a.ui.instances.Scayt.getState();a.scayt&&(c=b.state.scayt[a.name]?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF);a.fire("scaytButtonState",c);},onRender:function onRender(){var b=this;a.on("scaytButtonState",function(a){void 0!==_typeof(a.data)&&b.setState(a.data);});},onMenu:function onMenu(){var c=a.scayt;a.getMenuItem("scaytToggle").label=a.lang.scayt[c&&b.state.scayt[a.name]?"btn_disable":"btn_enable"];c={scaytToggle:CKEDITOR.TRISTATE_OFF,scaytOptions:c?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,scaytLangs:c?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,scaytDict:c?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,scaytAbout:c?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,WSC:a.plugins.wsc?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED};a.config.scayt_uiTabs[0]||delete c.scaytOptions;a.config.scayt_uiTabs[1]||delete c.scaytLangs;a.config.scayt_uiTabs[2]||delete c.scaytDict;return c;}});a.contextMenu&&a.addMenuItems&&(a.contextMenu.addListener(function(b,c){var d=a.scayt,h,k;d&&(k=d.getSelectionNode())&&(h=e.menuGenerator(a,k),d.showBanner("."+a.contextMenu._.definition.panel.className.split(" ").join(" .")));return h;}),a.contextMenu._.onHide=CKEDITOR.tools.override(a.contextMenu._.onHide,function(b){return function(){var c=a.scayt;c&&c.hideBanner();return b.apply(this);};}));},addMenuItems:function addMenuItems(a){var e=this,b=CKEDITOR.plugins.scayt;a.addMenuGroup("scaytButton");for(var c=a.config.scayt_contextMenuItemsOrder.split("|"),d=0;d<c.length;d++){c[d]="scayt_"+c[d];}if((c=["grayt_description","grayt_suggest","grayt_control"].concat(c))&&c.length)for(d=0;d<c.length;d++){a.addMenuGroup(c[d],d-10);}a.addCommand("scaytToggle",{exec:function exec(a){var c=a.scayt;b.state.scayt[a.name]=!b.state.scayt[a.name];!0===b.state.scayt[a.name]?c||b.createScayt(a):c&&b.destroy(a);}});a.addCommand("scaytAbout",{exec:function exec(a){a.scayt.tabToOpen="about";a.lockSelection();a.openDialog(e.dialogName);}});a.addCommand("scaytOptions",{exec:function exec(a){a.scayt.tabToOpen="options";a.lockSelection();a.openDialog(e.dialogName);}});a.addCommand("scaytLangs",{exec:function exec(a){a.scayt.tabToOpen="langs";a.lockSelection();a.openDialog(e.dialogName);}});a.addCommand("scaytDict",{exec:function exec(a){a.scayt.tabToOpen="dictionaries";a.lockSelection();a.openDialog(e.dialogName);}});c={scaytToggle:{label:a.lang.scayt.btn_enable,group:"scaytButton",command:"scaytToggle"},scaytAbout:{label:a.lang.scayt.btn_about,group:"scaytButton",command:"scaytAbout"},scaytOptions:{label:a.lang.scayt.btn_options,group:"scaytButton",command:"scaytOptions"},scaytLangs:{label:a.lang.scayt.btn_langs,group:"scaytButton",command:"scaytLangs"},scaytDict:{label:a.lang.scayt.btn_dictionaries,group:"scaytButton",command:"scaytDict"}};a.plugins.wsc&&(c.WSC={label:a.lang.wsc.toolbar,group:"scaytButton",onClick:function onClick(){var b=CKEDITOR.plugins.scayt,c=a.scayt,d=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.container.getText():a.document.getBody().getText();(d=d.replace(/\s/g,""))?(c&&b.state.scayt[a.name]&&c.setMarkupPaused&&c.setMarkupPaused(!0),a.lockSelection(),a.execCommand("checkspell")):alert("Nothing to check!");}});a.addMenuItems(c);},bindEvents:function bindEvents(a){var e=CKEDITOR.plugins.scayt,b=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE,c=function c(){e.destroy(a);},d=function d(){!e.state.scayt[a.name]||a.readOnly||a.scayt||e.createScayt(a);},l=function l(){var c=a.editable();c.attachListener(c,"focus",function(c){CKEDITOR.plugins.scayt&&!a.scayt&&setTimeout(d,0);c=CKEDITOR.plugins.scayt&&CKEDITOR.plugins.scayt.state.scayt[a.name]&&a.scayt;var f,e;if((b||c)&&a._.savedSelection){c=a._.savedSelection.getSelectedElement();c=!c&&a._.savedSelection.getRanges();for(var m=0;m<c.length;m++){e=c[m],"string"===typeof e.startContainer.$.nodeValue&&(f=e.startContainer.getText().length,(f<e.startOffset||f<e.endOffset)&&a.unlockSelection(!1));}}},this,null,-10);},m=function m(){b?a.config.scayt_inlineModeImmediateMarkup?d():(a.on("blur",function(){setTimeout(c,0);}),a.on("focus",d),a.focusManager.hasFocus&&d()):d();l();var f=a.editable();f.attachListener(f,"mousedown",function(b){b=b.data.getTarget();var c=a.widgets&&a.widgets.getByElement(b);c&&(c.wrapper=b.getAscendant(function(a){return a.hasAttribute("data-cke-widget-wrapper");},!0));},this,null,-10);};a.on("contentDom",m);a.on("beforeCommandExec",function(b){var c=a.scayt,d=null,g=!1,m=!0;b.data.name in e.options.disablingCommandExec&&"wysiwyg"==a.mode?c&&(e.destroy(a),a.fire("scaytButtonState",CKEDITOR.TRISTATE_DISABLED)):"bold"!==b.data.name&&"italic"!==b.data.name&&"underline"!==b.data.name&&"strike"!==b.data.name&&"subscript"!==b.data.name&&"superscript"!==b.data.name&&"enter"!==b.data.name&&"cut"!==b.data.name&&"language"!==b.data.name||!c||("cut"===b.data.name&&(m=!1,g=!0),"language"===b.data.name&&(d=(d=a.plugins.language.getCurrentLangElement(a))&&d.$,g=!0),a.fire("reloadMarkupScayt",{removeOptions:{removeInside:m,forceBookmark:g,selectionNode:d},timeout:0}));});a.on("beforeSetMode",function(b){if("source"==b.data){if(b=a.scayt)e.destroy(a),a.fire("scaytButtonState",CKEDITOR.TRISTATE_DISABLED);a.document&&a.document.getBody().removeAttribute("_jquid");}});a.on("afterCommandExec",function(b){"wysiwyg"!=a.mode||"undo"!=b.data.name&&"redo"!=b.data.name||setTimeout(function(){var b=a.scayt,c=b&&b.getScaytLangList();c&&c.ltr&&c.rtl&&b.fire("startSpellCheck, startGrammarCheck");},250);});a.on("readOnly",function(b){var c;b&&(c=a.scayt,!0===b.editor.readOnly?c&&c.fire("removeMarkupInDocument",{}):c?c.fire("startSpellCheck, startGrammarCheck"):"wysiwyg"==b.editor.mode&&!0===e.state.scayt[b.editor.name]&&(e.createScayt(a),b.editor.fire("scaytButtonState",CKEDITOR.TRISTATE_ON)));});a.on("beforeDestroy",c);a.on("setData",function(){c();(a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE||a.plugins.divarea)&&m();},this,null,50);a.on("reloadMarkupScayt",function(b){var c=b.data&&b.data.removeOptions;setTimeout(function(){var b=a.scayt,d=b&&b.getScaytLangList();d&&d.ltr&&d.rtl&&(a.document.fire("keydown",new CKEDITOR.dom.event({keyCode:37})),b.removeMarkupInSelectionNode(c),b.fire("startSpellCheck, startGrammarCheck"));},b.data&&b.data.timeout||0);});a.on("insertElement",function(){a.fire("reloadMarkupScayt",{removeOptions:{forceBookmark:!0}});},this,null,50);a.on("insertHtml",function(){a.fire("reloadMarkupScayt");},this,null,50);a.on("insertText",function(){a.fire("reloadMarkupScayt");},this,null,50);a.on("scaytDialogShown",function(b){b.data.selectPage(a.scayt.tabToOpen);});},parseConfig:function parseConfig(a){var e=CKEDITOR.plugins.scayt;e.replaceOldOptionsNames(a.config);"boolean"!==typeof a.config.scayt_autoStartup&&(a.config.scayt_autoStartup=!1);e.state.scayt[a.name]=a.config.scayt_autoStartup;"boolean"!==typeof a.config.grayt_autoStartup&&(a.config.grayt_autoStartup=!1);"boolean"!==typeof a.config.scayt_inlineModeImmediateMarkup&&(a.config.scayt_inlineModeImmediateMarkup=!1);e.state.grayt[a.name]=a.config.grayt_autoStartup;a.config.scayt_contextCommands||(a.config.scayt_contextCommands="ignore|ignoreall|add");a.config.scayt_contextMenuItemsOrder||(a.config.scayt_contextMenuItemsOrder="suggest|moresuggest|control");a.config.scayt_sLang||(a.config.scayt_sLang="en_US");if(void 0===a.config.scayt_maxSuggestions||"number"!=typeof a.config.scayt_maxSuggestions||0>a.config.scayt_maxSuggestions)a.config.scayt_maxSuggestions=5;if(void 0===a.config.scayt_minWordLength||"number"!=typeof a.config.scayt_minWordLength||1>a.config.scayt_minWordLength)a.config.scayt_minWordLength=4;if(void 0===a.config.scayt_customDictionaryIds||"string"!==typeof a.config.scayt_customDictionaryIds)a.config.scayt_customDictionaryIds="";if(void 0===a.config.scayt_userDictionaryName||"string"!==typeof a.config.scayt_userDictionaryName)a.config.scayt_userDictionaryName=null;if("string"===typeof a.config.scayt_uiTabs&&3===a.config.scayt_uiTabs.split(",").length){var b=[],c=[];a.config.scayt_uiTabs=a.config.scayt_uiTabs.split(",");CKEDITOR.tools.search(a.config.scayt_uiTabs,function(a){1===Number(a)||0===Number(a)?(c.push(!0),b.push(Number(a))):c.push(!1);});null===CKEDITOR.tools.search(c,!1)?a.config.scayt_uiTabs=b:a.config.scayt_uiTabs=[1,1,1];}else a.config.scayt_uiTabs=[1,1,1];"string"!=typeof a.config.scayt_serviceProtocol&&(a.config.scayt_serviceProtocol=null);"string"!=typeof a.config.scayt_serviceHost&&(a.config.scayt_serviceHost=null);"string"!=typeof a.config.scayt_servicePort&&(a.config.scayt_servicePort=null);"string"!=typeof a.config.scayt_servicePath&&(a.config.scayt_servicePath=null);a.config.scayt_moreSuggestions||(a.config.scayt_moreSuggestions="on");"string"!==typeof a.config.scayt_customerId&&(a.config.scayt_customerId="1:WvF0D4-UtPqN1-43nkD4-NKvUm2-daQqk3-LmNiI-z7Ysb4-mwry24-T8YrS3-Q2tpq2");"string"!==typeof a.config.scayt_srcUrl&&(e=document.location.protocol,e=-1!=e.search(/https?:/)?e:"http:",a.config.scayt_srcUrl=e+"//svc.webspellchecker.net/spellcheck31/lf/scayt3/ckscayt/ckscayt.js");"boolean"!==typeof CKEDITOR.config.scayt_handleCheckDirty&&(CKEDITOR.config.scayt_handleCheckDirty=!0);"boolean"!==typeof CKEDITOR.config.scayt_handleUndoRedo&&(CKEDITOR.config.scayt_handleUndoRedo=!0);CKEDITOR.config.scayt_handleUndoRedo=CKEDITOR.plugins.undo?CKEDITOR.config.scayt_handleUndoRedo:!1;"boolean"!==typeof a.config.scayt_multiLanguageMode&&(a.config.scayt_multiLanguageMode=!1);"object"!==_typeof(a.config.scayt_multiLanguageStyles)&&(a.config.scayt_multiLanguageStyles={});a.config.scayt_ignoreAllCapsWords&&"boolean"!==typeof a.config.scayt_ignoreAllCapsWords&&(a.config.scayt_ignoreAllCapsWords=!1);a.config.scayt_ignoreDomainNames&&"boolean"!==typeof a.config.scayt_ignoreDomainNames&&(a.config.scayt_ignoreDomainNames=!1);a.config.scayt_ignoreWordsWithMixedCases&&"boolean"!==typeof a.config.scayt_ignoreWordsWithMixedCases&&(a.config.scayt_ignoreWordsWithMixedCases=!1);a.config.scayt_ignoreWordsWithNumbers&&"boolean"!==typeof a.config.scayt_ignoreWordsWithNumbers&&(a.config.scayt_ignoreWordsWithNumbers=!1);if(a.config.scayt_disableOptionsStorage){var e=CKEDITOR.tools.isArray(a.config.scayt_disableOptionsStorage)?a.config.scayt_disableOptionsStorage:"string"===typeof a.config.scayt_disableOptionsStorage?[a.config.scayt_disableOptionsStorage]:void 0,d="all options lang ignore-all-caps-words ignore-domain-names ignore-words-with-mixed-cases ignore-words-with-numbers".split(" "),l=["lang","ignore-all-caps-words","ignore-domain-names","ignore-words-with-mixed-cases","ignore-words-with-numbers"],m=CKEDITOR.tools.search,f=CKEDITOR.tools.indexOf;a.config.scayt_disableOptionsStorage=function(a){for(var b=[],c=0;c<a.length;c++){var e=a[c],v=!!m(a,"options");if(!m(d,e)||v&&m(l,function(a){if("lang"===a)return!1;}))return;m(l,e)&&l.splice(f(l,e),1);if("all"===e||v&&m(a,"lang"))return[];"options"===e&&(l=["lang"]);}return b=b.concat(l);}(e);}},addRule:function addRule(a){var e=CKEDITOR.plugins.scayt,b=a.dataProcessor,c=b&&b.htmlFilter,d=a._.elementsPath&&a._.elementsPath.filters,b=b&&b.dataFilter,l=a.addRemoveFormatFilter,m=function m(b){if(a.scayt&&(b.hasAttribute(e.options.data_attribute_name)||b.hasAttribute(e.options.problem_grammar_data_attribute)))return!1;},f=function f(b){var c=!0;a.scayt&&(b.hasAttribute(e.options.data_attribute_name)||b.hasAttribute(e.options.problem_grammar_data_attribute))&&(c=!1);return c;};d&&d.push(m);b&&b.addRules({elements:{span:function span(a){var b=a.hasClass(e.options.misspelled_word_class)&&a.attributes[e.options.data_attribute_name],c=a.hasClass(e.options.problem_grammar_class)&&a.attributes[e.options.problem_grammar_data_attribute];e&&(b||c)&&delete a.name;return a;}}});c&&c.addRules({elements:{span:function span(a){var b=a.hasClass(e.options.misspelled_word_class)&&a.attributes[e.options.data_attribute_name],c=a.hasClass(e.options.problem_grammar_class)&&a.attributes[e.options.problem_grammar_data_attribute];e&&(b||c)&&delete a.name;return a;}}});l&&l.call(a,f);},scaytMenuDefinition:function scaytMenuDefinition(a){var e=this;a=a.scayt;return{scayt:{scayt_ignore:{label:a.getLocal("btn_ignore"),group:"scayt_control",order:1,exec:function exec(a){a.scayt.ignoreWord();}},scayt_ignoreall:{label:a.getLocal("btn_ignoreAll"),group:"scayt_control",order:2,exec:function exec(a){a.scayt.ignoreAllWords();}},scayt_add:{label:a.getLocal("btn_addWord"),group:"scayt_control",order:3,exec:function exec(a){var c=a.scayt;setTimeout(function(){c.addWordToUserDictionary();},10);}},scayt_option:{label:a.getLocal("btn_options"),group:"scayt_control",order:4,exec:function exec(a){a.scayt.tabToOpen="options";a.lockSelection();a.openDialog(e.dialogName);},verification:function verification(a){return 1==a.config.scayt_uiTabs[0]?!0:!1;}},scayt_language:{label:a.getLocal("btn_langs"),group:"scayt_control",order:5,exec:function exec(a){a.scayt.tabToOpen="langs";a.lockSelection();a.openDialog(e.dialogName);},verification:function verification(a){return 1==a.config.scayt_uiTabs[1]?!0:!1;}},scayt_dictionary:{label:a.getLocal("btn_dictionaries"),group:"scayt_control",order:6,exec:function exec(a){a.scayt.tabToOpen="dictionaries";a.lockSelection();a.openDialog(e.dialogName);},verification:function verification(a){return 1==a.config.scayt_uiTabs[2]?!0:!1;}},scayt_about:{label:a.getLocal("btn_about"),group:"scayt_control",order:7,exec:function exec(a){a.scayt.tabToOpen="about";a.lockSelection();a.openDialog(e.dialogName);}}},grayt:{grayt_problemdescription:{label:"Grammar problem description",group:"grayt_description",order:1,state:CKEDITOR.TRISTATE_DISABLED,exec:function exec(a){}},grayt_ignore:{label:a.getLocal("btn_ignore"),group:"grayt_control",order:2,exec:function exec(a){a.scayt.ignorePhrase();}}}};},buildSuggestionMenuItems:function buildSuggestionMenuItems(a,e,b){var c={},d={},l=b?"word":"phrase",m=b?"startGrammarCheck":"startSpellCheck",f=a.scayt;if(0<e.length&&"no_any_suggestions"!==e[0]){if(b)for(b=0;b<e.length;b++){var h="scayt_suggest_"+CKEDITOR.plugins.scayt.suggestions[b].replace(" ","_");a.addCommand(h,this.createCommand(CKEDITOR.plugins.scayt.suggestions[b],l,m));b<a.config.scayt_maxSuggestions?(a.addMenuItem(h,{label:e[b],command:h,group:"scayt_suggest",order:b+1}),c[h]=CKEDITOR.TRISTATE_OFF):(a.addMenuItem(h,{label:e[b],command:h,group:"scayt_moresuggest",order:b+1}),d[h]=CKEDITOR.TRISTATE_OFF,"on"===a.config.scayt_moreSuggestions&&(a.addMenuItem("scayt_moresuggest",{label:f.getLocal("btn_moreSuggestions"),group:"scayt_moresuggest",order:10,getItems:function getItems(){return d;}}),c.scayt_moresuggest=CKEDITOR.TRISTATE_OFF));}else for(b=0;b<e.length;b++){h="grayt_suggest_"+CKEDITOR.plugins.scayt.suggestions[b].replace(" ","_"),a.addCommand(h,this.createCommand(CKEDITOR.plugins.scayt.suggestions[b],l,m)),a.addMenuItem(h,{label:e[b],command:h,group:"grayt_suggest",order:b+1}),c[h]=CKEDITOR.TRISTATE_OFF;}}else c.no_scayt_suggest=CKEDITOR.TRISTATE_DISABLED,a.addCommand("no_scayt_suggest",{exec:function exec(){}}),a.addMenuItem("no_scayt_suggest",{label:f.getLocal("btn_noSuggestions")||"no_scayt_suggest",command:"no_scayt_suggest",group:"scayt_suggest",order:0});return c;},menuGenerator:function menuGenerator(a,e){var b=a.scayt,c=this.scaytMenuDefinition(a),d={},l=a.config.scayt_contextCommands.split("|"),m=e.getAttribute(b.getLangAttribute())||b.getLang(),f,h;f=b.isScaytNode(e);h=b.isGraytNode(e);f?(c=c.scayt,d=e.getAttribute(b.getScaytNodeAttributeName()),b.fire("getSuggestionsList",{lang:m,word:d}),d=this.buildSuggestionMenuItems(a,CKEDITOR.plugins.scayt.suggestions,f)):h&&(c=c.grayt,d=e.getAttribute(b.getGraytNodeAttributeName()),h=b.getProblemDescriptionText(d,m),c.grayt_problemdescription&&h&&(c.grayt_problemdescription.label=h),b.fire("getGrammarSuggestionsList",{lang:m,phrase:d}),d=this.buildSuggestionMenuItems(a,CKEDITOR.plugins.scayt.suggestions,f));if(f&&"off"==a.config.scayt_contextCommands)return d;for(var k in c){f&&-1==CKEDITOR.tools.indexOf(l,k.replace("scayt_",""))&&"all"!=a.config.scayt_contextCommands||(d[k]="undefined"!=typeof c[k].state?c[k].state:CKEDITOR.TRISTATE_OFF,"function"!==typeof c[k].verification||c[k].verification(a)||delete d[k],a.addCommand(k,{exec:c[k].exec}),a.addMenuItem(k,{label:a.lang.scayt[c[k].label]||c[k].label,command:k,group:c[k].group,order:c[k].order}));}return d;},createCommand:function createCommand(a,e,b){return{exec:function exec(c){c=c.scayt;var d={};d[e]=a;c.replaceSelectionNode(d);"startGrammarCheck"===b&&c.removeMarkupInSelectionNode({grammarOnly:!0});c.fire(b);}};}}),CKEDITOR.plugins.scayt={state:{scayt:{},grayt:{}},suggestions:[],loadingHelper:{loadOrder:[]},isLoading:!1,options:{disablingCommandExec:{source:!0,newpage:!0,templates:!0},data_attribute_name:"data-scayt-word",misspelled_word_class:"scayt-misspell-word",problem_grammar_data_attribute:"data-grayt-phrase",problem_grammar_class:"gramm-problem"},backCompatibilityMap:{scayt_service_protocol:"scayt_serviceProtocol",scayt_service_host:"scayt_serviceHost",scayt_service_port:"scayt_servicePort",scayt_service_path:"scayt_servicePath",scayt_customerid:"scayt_customerId"},replaceOldOptionsNames:function replaceOldOptionsNames(a){for(var e in a){e in this.backCompatibilityMap&&(a[this.backCompatibilityMap[e]]=a[e],delete a[e]);}},createScayt:function createScayt(a){var e=this,b=CKEDITOR.plugins.scayt;this.loadScaytLibrary(a,function(a){var d=a.window&&a.window.getFrame()||a.editable();d?(d={lang:a.config.scayt_sLang,container:d.$,customDictionary:a.config.scayt_customDictionaryIds,userDictionaryName:a.config.scayt_userDictionaryName,localization:a.langCode,customer_id:a.config.scayt_customerId,debug:a.config.scayt_debug,data_attribute_name:e.options.data_attribute_name,misspelled_word_class:e.options.misspelled_word_class,problem_grammar_data_attribute:e.options.problem_grammar_data_attribute,problem_grammar_class:e.options.problem_grammar_class,"options-to-restore":a.config.scayt_disableOptionsStorage,focused:a.editable().hasFocus,ignoreElementsRegex:a.config.scayt_elementsToIgnore,minWordLength:a.config.scayt_minWordLength,multiLanguageMode:a.config.scayt_multiLanguageMode,multiLanguageStyles:a.config.scayt_multiLanguageStyles,graytAutoStartup:b.state.grayt[a.name]},a.config.scayt_serviceProtocol&&(d.service_protocol=a.config.scayt_serviceProtocol),a.config.scayt_serviceHost&&(d.service_host=a.config.scayt_serviceHost),a.config.scayt_servicePort&&(d.service_port=a.config.scayt_servicePort),a.config.scayt_servicePath&&(d.service_path=a.config.scayt_servicePath),"boolean"===typeof a.config.scayt_ignoreAllCapsWords&&(d["ignore-all-caps-words"]=a.config.scayt_ignoreAllCapsWords),"boolean"===typeof a.config.scayt_ignoreDomainNames&&(d["ignore-domain-names"]=a.config.scayt_ignoreDomainNames),"boolean"===typeof a.config.scayt_ignoreWordsWithMixedCases&&(d["ignore-words-with-mixed-cases"]=a.config.scayt_ignoreWordsWithMixedCases),"boolean"===typeof a.config.scayt_ignoreWordsWithNumbers&&(d["ignore-words-with-numbers"]=a.config.scayt_ignoreWordsWithNumbers),d=new SCAYT.CKSCAYT(d,function(){},function(){}),d.subscribe("suggestionListSend",function(a){for(var b={},c=[],d=0;d<a.suggestionList.length;d++){b["word_"+a.suggestionList[d]]||(b["word_"+a.suggestionList[d]]=a.suggestionList[d],c.push(a.suggestionList[d]));}CKEDITOR.plugins.scayt.suggestions=c;}),d.subscribe("selectionIsChanged",function(b){a.getSelection().isLocked&&a.lockSelection();}),d.subscribe("graytStateChanged",function(d){b.state.grayt[a.name]=d.state;}),a.scayt=d,a.fire("scaytButtonState",a.readOnly?CKEDITOR.TRISTATE_DISABLED:CKEDITOR.TRISTATE_ON)):b.state.scayt[a.name]=!1;});},destroy:function destroy(a){a.scayt&&a.scayt.destroy();delete a.scayt;a.fire("scaytButtonState",CKEDITOR.TRISTATE_OFF);},loadScaytLibrary:function loadScaytLibrary(a,e){var b=this,c,d;this.loadingHelper[a.name]||("undefined"===typeof window.SCAYT||"function"!==typeof window.SCAYT.CKSCAYT?(this.loadingHelper[a.name]=e,this.loadingHelper.loadOrder.push(a.name),c=new Date(),c=c.getTime(),d=a.config.scayt_srcUrl,d+=0<=d.indexOf("?")?"":"?"+c,this.loadingHelper.ckscaytLoading||(CKEDITOR.scriptLoader.load(d,function(a){if(a){CKEDITOR.fireOnce("scaytReady");for(var c=0;c<b.loadingHelper.loadOrder.length;c++){a=b.loadingHelper.loadOrder[c];if("function"===typeof b.loadingHelper[a])b.loadingHelper[a](CKEDITOR.instances[a]);delete b.loadingHelper[a];}b.loadingHelper.loadOrder=[];}}),this.loadingHelper.ckscaytLoading=!0)):window.SCAYT&&"function"===typeof window.SCAYT.CKSCAYT&&(CKEDITOR.fireOnce("scaytReady"),a.scayt||"function"===typeof e&&e(a)));}},CKEDITOR.on("dialogDefinition",function(a){var e=a.data.name;a=a.data.definition.dialog;if("scaytDialog"===e)a.on("cancel",function(a){return!1;},this,null,-1);if("checkspell"===e)a.on("cancel",function(a){a=a.sender&&a.sender.getParentEditor();var c=CKEDITOR.plugins.scayt,d=a.scayt;d&&c.state.scayt[a.name]&&d.setMarkupPaused&&d.setMarkupPaused(!1);a.unlockSelection();},this,null,-2);if("link"===e)a.on("ok",function(a){var c=a.sender&&a.sender.getParentEditor();c&&setTimeout(function(){c.fire("reloadMarkupScayt",{removeOptions:{removeInside:!0,forceBookmark:!0},timeout:0});},0);});}),CKEDITOR.on("scaytReady",function(){if(!0===CKEDITOR.config.scayt_handleCheckDirty){var a=CKEDITOR.editor.prototype;a.checkDirty=CKEDITOR.tools.override(a.checkDirty,function(a){return function(){var c=null,d=this.scayt;if(CKEDITOR.plugins.scayt&&CKEDITOR.plugins.scayt.state.scayt[this.name]&&this.scayt){if(c="ready"==this.status)var e=d.removeMarkupFromString(this.getSnapshot()),d=d.removeMarkupFromString(this._.previousValue),c=c&&d!==e;}else c=a.call(this);return c;};});a.resetDirty=CKEDITOR.tools.override(a.resetDirty,function(a){return function(){var c=this.scayt;CKEDITOR.plugins.scayt&&CKEDITOR.plugins.scayt.state.scayt[this.name]&&this.scayt?this._.previousValue=c.removeMarkupFromString(this.getSnapshot()):a.call(this);};});}if(!0===CKEDITOR.config.scayt_handleUndoRedo){var a=CKEDITOR.plugins.undo.Image.prototype,e="function"==typeof a.equalsContent?"equalsContent":"equals";a[e]=CKEDITOR.tools.override(a[e],function(a){return function(c){var d=c.editor.scayt,e=this.contents,m=c.contents,f=null;CKEDITOR.plugins.scayt&&CKEDITOR.plugins.scayt.state.scayt[c.editor.name]&&c.editor.scayt&&(this.contents=d.removeMarkupFromString(e)||"",c.contents=d.removeMarkupFromString(m)||"");f=a.apply(this,arguments);this.contents=e;c.contents=m;return f;};});}}),function(){var a={preserveState:!0,editorFocus:!1,readOnly:1,exec:function exec(a){this.toggleState();this.refresh(a);},refresh:function refresh(a){if(a.document){var b=this.state==CKEDITOR.TRISTATE_ON?"attachClass":"removeClass";a.editable()[b]("cke_show_borders");}}};CKEDITOR.plugins.add("showborders",{modes:{wysiwyg:1},onLoad:function onLoad(){var a;a=(CKEDITOR.env.ie6Compat?[".%1 table.%2,",".%1 table.%2 td, .%1 table.%2 th","{","border : #d3d3d3 1px dotted","}"]:".%1 table.%2,;.%1 table.%2 \x3e tr \x3e td, .%1 table.%2 \x3e tr \x3e th,;.%1 table.%2 \x3e tbody \x3e tr \x3e td, .%1 table.%2 \x3e tbody \x3e tr \x3e th,;.%1 table.%2 \x3e thead \x3e tr \x3e td, .%1 table.%2 \x3e thead \x3e tr \x3e th,;.%1 table.%2 \x3e tfoot \x3e tr \x3e td, .%1 table.%2 \x3e tfoot \x3e tr \x3e th;{;border : #d3d3d3 1px dotted;}".split(";")).join("").replace(/%2/g,"cke_show_border").replace(/%1/g,"cke_show_borders ");CKEDITOR.addCss(a);},init:function init(e){var b=e.addCommand("showborders",a);b.canUndo=!1;!1!==e.config.startupShowBorders&&b.setState(CKEDITOR.TRISTATE_ON);e.on("mode",function(){b.state!=CKEDITOR.TRISTATE_DISABLED&&b.refresh(e);},null,null,100);e.on("contentDom",function(){b.state!=CKEDITOR.TRISTATE_DISABLED&&b.refresh(e);});e.on("removeFormatCleanup",function(a){a=a.data;e.getCommand("showborders").state==CKEDITOR.TRISTATE_ON&&a.is("table")&&(!a.hasAttribute("border")||0>=parseInt(a.getAttribute("border"),10))&&a.addClass("cke_show_border");});},afterInit:function afterInit(a){var b=a.dataProcessor;a=b&&b.dataFilter;b=b&&b.htmlFilter;a&&a.addRules({elements:{table:function table(a){a=a.attributes;var b=a["class"],e=parseInt(a.border,10);e&&!(0>=e)||b&&-1!=b.indexOf("cke_show_border")||(a["class"]=(b||"")+" cke_show_border");}}});b&&b.addRules({elements:{table:function table(a){a=a.attributes;var b=a["class"];b&&(a["class"]=b.replace("cke_show_border","").replace(/\s{2}/," ").replace(/^\s+|\s+$/,""));}}});}});CKEDITOR.on("dialogDefinition",function(a){var b=a.data.name;if("table"==b||"tableProperties"==b)if(a=a.data.definition,b=a.getContents("info").get("txtBorder"),b.commit=CKEDITOR.tools.override(b.commit,function(a){return function(b,e){a.apply(this,arguments);var m=parseInt(this.getValue(),10);e[!m||0>=m?"addClass":"removeClass"]("cke_show_border");};}),a=(a=a.getContents("advanced"))&&a.get("advCSSClasses"))a.setup=CKEDITOR.tools.override(a.setup,function(a){return function(){a.apply(this,arguments);this.setValue(this.getValue().replace(/cke_show_border/,""));};}),a.commit=CKEDITOR.tools.override(a.commit,function(a){return function(b,e){a.apply(this,arguments);parseInt(e.getAttribute("border"),10)||e.addClass("cke_show_border");};});});}(),function(){CKEDITOR.plugins.add("sourcearea",{init:function init(e){function b(){var a=d&&this.equals(CKEDITOR.document.getActive());this.hide();this.setStyle("height",this.getParent().$.clientHeight+"px");this.setStyle("width",this.getParent().$.clientWidth+"px");this.show();a&&this.focus();}if(e.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE){var c=CKEDITOR.plugins.sourcearea;e.addMode("source",function(c){var d=e.ui.space("contents").getDocument().createElement("textarea");d.setStyles(CKEDITOR.tools.extend({width:CKEDITOR.env.ie7Compat?"99%":"100%",height:"100%",resize:"none",outline:"none","text-align":"left"},CKEDITOR.tools.cssVendorPrefix("tab-size",e.config.sourceAreaTabSize||4)));d.setAttribute("dir","ltr");d.addClass("cke_source").addClass("cke_reset").addClass("cke_enable_context_menu");e.ui.space("contents").append(d);d=e.editable(new a(e,d));d.setData(e.getData(1));CKEDITOR.env.ie&&(d.attachListener(e,"resize",b,d),d.attachListener(CKEDITOR.document.getWindow(),"resize",b,d),CKEDITOR.tools.setTimeout(b,0,d));e.fire("ariaWidget",this);c();});e.addCommand("source",c.commands.source);e.ui.addButton&&e.ui.addButton("Source",{label:e.lang.sourcearea.toolbar,command:"source",toolbar:"mode,10"});e.on("mode",function(){e.getCommand("source").setState("source"==e.mode?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF);});var d=CKEDITOR.env.ie&&9==CKEDITOR.env.version;}}});var a=CKEDITOR.tools.createClass({base:CKEDITOR.editable,proto:{setData:function setData(a){this.setValue(a);this.status="ready";this.editor.fire("dataReady");},getData:function getData(){return this.getValue();},insertHtml:function insertHtml(){},insertElement:function insertElement(){},insertText:function insertText(){},setReadOnly:function setReadOnly(a){this[(a?"set":"remove")+"Attribute"]("readOnly","readonly");},detach:function detach(){a.baseProto.detach.call(this);this.clearCustomData();this.remove();}}});}(),CKEDITOR.plugins.sourcearea={commands:{source:{modes:{wysiwyg:1,source:1},editorFocus:!1,readOnly:1,exec:function exec(a){"wysiwyg"==a.mode&&a.fire("saveSnapshot");a.getCommand("source").setState(CKEDITOR.TRISTATE_DISABLED);a.setMode("source"==a.mode?"wysiwyg":"source");},canUndo:!1}}},CKEDITOR.plugins.add("specialchar",{availableLangs:{af:1,ar:1,bg:1,ca:1,cs:1,cy:1,da:1,de:1,"de-ch":1,el:1,en:1,"en-gb":1,eo:1,es:1,et:1,eu:1,fa:1,fi:1,fr:1,"fr-ca":1,gl:1,he:1,hr:1,hu:1,id:1,it:1,ja:1,km:1,ko:1,ku:1,lt:1,lv:1,nb:1,nl:1,no:1,pl:1,pt:1,"pt-br":1,ru:1,si:1,sk:1,sl:1,sq:1,sv:1,th:1,tr:1,tt:1,ug:1,uk:1,vi:1,zh:1,"zh-cn":1},requires:"dialog",init:function init(a){var e=this;CKEDITOR.dialog.add("specialchar",this.path+"dialogs/specialchar.js");a.addCommand("specialchar",{exec:function exec(){var b=a.langCode,b=e.availableLangs[b]?b:e.availableLangs[b.replace(/-.*/,"")]?b.replace(/-.*/,""):"en";CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(e.path+"dialogs/lang/"+b+".js"),function(){CKEDITOR.tools.extend(a.lang.specialchar,e.langEntries[b]);a.openDialog("specialchar");});},modes:{wysiwyg:1},canUndo:!1});a.ui.addButton&&a.ui.addButton("SpecialChar",{label:a.lang.specialchar.toolbar,command:"specialchar",toolbar:"insert,50"});}}),CKEDITOR.config.specialChars="! \x26quot; # $ % \x26amp; ' ( ) * + - . / 0 1 2 3 4 5 6 7 8 9 : ; \x26lt; \x3d \x26gt; ? @ A B C D E F G H I J K L M N O P Q R S T U V W X Y Z [ ] ^ _ ` a b c d e f g h i j k l m n o p q r s t u v w x y z { | } ~ \x26euro; \x26lsquo; \x26rsquo; \x26ldquo; \x26rdquo; \x26ndash; \x26mdash; \x26iexcl; \x26cent; \x26pound; \x26curren; \x26yen; \x26brvbar; \x26sect; \x26uml; \x26copy; \x26ordf; \x26laquo; \x26not; \x26reg; \x26macr; \x26deg; \x26sup2; \x26sup3; \x26acute; \x26micro; \x26para; \x26middot; \x26cedil; \x26sup1; \x26ordm; \x26raquo; \x26frac14; \x26frac12; \x26frac34; \x26iquest; \x26Agrave; \x26Aacute; \x26Acirc; \x26Atilde; \x26Auml; \x26Aring; \x26AElig; \x26Ccedil; \x26Egrave; \x26Eacute; \x26Ecirc; \x26Euml; \x26Igrave; \x26Iacute; \x26Icirc; \x26Iuml; \x26ETH; \x26Ntilde; \x26Ograve; \x26Oacute; \x26Ocirc; \x26Otilde; \x26Ouml; \x26times; \x26Oslash; \x26Ugrave; \x26Uacute; \x26Ucirc; \x26Uuml; \x26Yacute; \x26THORN; \x26szlig; \x26agrave; \x26aacute; \x26acirc; \x26atilde; \x26auml; \x26aring; \x26aelig; \x26ccedil; \x26egrave; \x26eacute; \x26ecirc; \x26euml; \x26igrave; \x26iacute; \x26icirc; \x26iuml; \x26eth; \x26ntilde; \x26ograve; \x26oacute; \x26ocirc; \x26otilde; \x26ouml; \x26divide; \x26oslash; \x26ugrave; \x26uacute; \x26ucirc; \x26uuml; \x26yacute; \x26thorn; \x26yuml; \x26OElig; \x26oelig; \x26#372; \x26#374 \x26#373 \x26#375; \x26sbquo; \x26#8219; \x26bdquo; \x26hellip; \x26trade; \x26#9658; \x26bull; \x26rarr; \x26rArr; \x26hArr; \x26diams; \x26asymp;".split(" "),function(){CKEDITOR.plugins.add("stylescombo",{requires:"richcombo",init:function init(a){var e=a.config,b=a.lang.stylescombo,c={},d=[],l=[];a.on("stylesSet",function(b){if(b=b.data.styles){for(var f,h,k,g=0,n=b.length;g<n;g++){(f=b[g],a.blockless&&f.element in CKEDITOR.dtd.$block||(h=f.name,f=new CKEDITOR.style(f),a.filter.customConfig&&!a.filter.check(f)))||(f._name=h,f._.enterMode=e.enterMode,f._.type=k=f.assignedTo||f.type,f._.weight=g+1E3*(k==CKEDITOR.STYLE_OBJECT?1:k==CKEDITOR.STYLE_BLOCK?2:3),c[h]=f,d.push(f),l.push(f));}d.sort(function(a,b){return a._.weight-b._.weight;});}});a.ui.addRichCombo("Styles",{label:b.label,title:b.panelTitle,toolbar:"styles,10",allowedContent:l,panel:{css:[CKEDITOR.skin.getPath("editor")].concat(e.contentsCss),multiSelect:!0,attributes:{"aria-label":b.panelTitle}},init:function init(){var a,c,e,k,g,l;g=0;for(l=d.length;g<l;g++){a=d[g],c=a._name,k=a._.type,k!=e&&(this.startGroup(b["panelTitle"+String(k)]),e=k),this.add(c,a.type==CKEDITOR.STYLE_OBJECT?c:a.buildPreview(),c);}this.commit();},onClick:function onClick(b){a.focus();a.fire("saveSnapshot");b=c[b];var d=a.elementPath();a[b.checkActive(d,a)?"removeStyle":"applyStyle"](b);a.fire("saveSnapshot");},onRender:function onRender(){a.on("selectionChange",function(b){var d=this.getValue();b=b.data.path.elements;for(var e=0,k=b.length,g;e<k;e++){g=b[e];for(var l in c){if(c[l].checkElementRemovable(g,!0,a)){l!=d&&this.setValue(l);return;}}}this.setValue("");},this);},onOpen:function onOpen(){var d=a.getSelection().getSelectedElement(),d=a.elementPath(d),f=[0,0,0,0];this.showAll();this.unmarkAll();for(var e in c){var k=c[e],g=k._.type;k.checkApplicable(d,a,a.activeFilter)?f[g]++:this.hideItem(e);k.checkActive(d,a)&&this.mark(e);}f[CKEDITOR.STYLE_BLOCK]||this.hideGroup(b["panelTitle"+String(CKEDITOR.STYLE_BLOCK)]);f[CKEDITOR.STYLE_INLINE]||this.hideGroup(b["panelTitle"+String(CKEDITOR.STYLE_INLINE)]);f[CKEDITOR.STYLE_OBJECT]||this.hideGroup(b["panelTitle"+String(CKEDITOR.STYLE_OBJECT)]);},refresh:function refresh(){var b=a.elementPath();if(b){for(var d in c){if(c[d].checkApplicable(b,a,a.activeFilter))return;}this.setState(CKEDITOR.TRISTATE_DISABLED);}},reset:function reset(){c={};d=[];}});}});}(),function(){function a(a){return{editorFocus:!1,canUndo:!1,modes:{wysiwyg:1},exec:function exec(b){if(b.editable().hasFocus){var c=b.getSelection(),f;if(f=new CKEDITOR.dom.elementPath(c.getCommonAncestor(),c.root).contains({td:1,th:1},1)){var c=b.createRange(),e=CKEDITOR.tools.tryThese(function(){var b=f.getParent().$.cells[f.$.cellIndex+(a?-1:1)];b.parentNode.parentNode;return b;},function(){var b=f.getParent(),b=b.getAscendant("table").$.rows[b.$.rowIndex+(a?-1:1)];return b.cells[a?b.cells.length-1:0];});if(e||a){if(e)e=new CKEDITOR.dom.element(e),c.moveToElementEditStart(e),c.checkStartOfBlock()&&c.checkEndOfBlock()||c.selectNodeContents(e);else return!0;}else{for(var k=f.getAscendant("table").$,e=f.getParent().$.cells,k=new CKEDITOR.dom.element(k.insertRow(-1),b.document),g=0,n=e.length;g<n;g++){k.append(new CKEDITOR.dom.element(e[g],b.document).clone(!1,!1)).appendBogus();}c.moveToElementEditStart(k);}c.select(!0);return!0;}}return!1;}};}var e={editorFocus:!1,modes:{wysiwyg:1,source:1}},b={exec:function exec(a){a.container.focusNext(!0,a.tabIndex);}},c={exec:function exec(a){a.container.focusPrevious(!0,a.tabIndex);}};CKEDITOR.plugins.add("tab",{init:function init(d){for(var l=!1!==d.config.enableTabKeyTools,m=d.config.tabSpaces||0,f="";m--;){f+=" ";}if(f)d.on("key",function(a){9==a.data.keyCode&&(d.insertText(f),a.cancel());});if(l)d.on("key",function(a){(9==a.data.keyCode&&d.execCommand("selectNextCell")||a.data.keyCode==CKEDITOR.SHIFT+9&&d.execCommand("selectPreviousCell"))&&a.cancel();});d.addCommand("blur",CKEDITOR.tools.extend(b,e));d.addCommand("blurBack",CKEDITOR.tools.extend(c,e));d.addCommand("selectNextCell",a());d.addCommand("selectPreviousCell",a(!0));}});}(),CKEDITOR.dom.element.prototype.focusNext=function(a,e){var b=void 0===e?this.getTabIndex():e,c,d,l,m,f,h;if(0>=b)for(f=this.getNextSourceNode(a,CKEDITOR.NODE_ELEMENT);f;){if(f.isVisible()&&0===f.getTabIndex()){l=f;break;}f=f.getNextSourceNode(!1,CKEDITOR.NODE_ELEMENT);}else for(f=this.getDocument().getBody().getFirst();f=f.getNextSourceNode(!1,CKEDITOR.NODE_ELEMENT);){if(!c)if(!d&&f.equals(this)){if(d=!0,a){if(!(f=f.getNextSourceNode(!0,CKEDITOR.NODE_ELEMENT)))break;c=1;}}else d&&!this.contains(f)&&(c=1);if(f.isVisible()&&!(0>(h=f.getTabIndex()))){if(c&&h==b){l=f;break;}h>b&&(!l||!m||h<m)?(l=f,m=h):l||0!==h||(l=f,m=h);}}l&&l.focus();},CKEDITOR.dom.element.prototype.focusPrevious=function(a,e){for(var b=void 0===e?this.getTabIndex():e,c,d,l,m=0,f,h=this.getDocument().getBody().getLast();h=h.getPreviousSourceNode(!1,CKEDITOR.NODE_ELEMENT);){if(!c)if(!d&&h.equals(this)){if(d=!0,a){if(!(h=h.getPreviousSourceNode(!0,CKEDITOR.NODE_ELEMENT)))break;c=1;}}else d&&!this.contains(h)&&(c=1);if(h.isVisible()&&!(0>(f=h.getTabIndex())))if(0>=b){if(c&&0===f){l=h;break;}f>m&&(l=h,m=f);}else{if(c&&f==b){l=h;break;}f<b&&(!l||f>m)&&(l=h,m=f);}}l&&l.focus();},CKEDITOR.plugins.add("table",{requires:"dialog",init:function init(a){function e(a){return CKEDITOR.tools.extend(a||{},{contextSensitive:1,refresh:function refresh(a,b){this.setState(b.contains("table",1)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);}});}if(!a.blockless){var b=a.lang.table;a.addCommand("table",new CKEDITOR.dialogCommand("table",{context:"table",allowedContent:"table{width,height}[align,border,cellpadding,cellspacing,summary];caption tbody thead tfoot;th td tr[scope];"+(a.plugins.dialogadvtab?"table"+a.plugins.dialogadvtab.allowedContent():""),requiredContent:"table",contentTransformations:[["table{width}: sizeToStyle","table[width]: sizeToAttribute"]]}));a.addCommand("tableProperties",new CKEDITOR.dialogCommand("tableProperties",e()));a.addCommand("tableDelete",e({exec:function exec(a){var b=a.elementPath().contains("table",1);if(b){var e=b.getParent(),m=a.editable();1!=e.getChildCount()||e.is("td","th")||e.equals(m)||(b=e);a=a.createRange();a.moveToPosition(b,CKEDITOR.POSITION_BEFORE_START);b.remove();a.select();}}}));a.ui.addButton&&a.ui.addButton("Table",{label:b.toolbar,command:"table",toolbar:"insert,30"});CKEDITOR.dialog.add("table",this.path+"dialogs/table.js");CKEDITOR.dialog.add("tableProperties",this.path+"dialogs/table.js");a.addMenuItems&&a.addMenuItems({table:{label:b.menu,command:"tableProperties",group:"table",order:5},tabledelete:{label:b.deleteTable,command:"tableDelete",group:"table",order:1}});a.on("doubleclick",function(a){a.data.element.is("table")&&(a.data.dialog="tableProperties");});a.contextMenu&&a.contextMenu.addListener(function(){return{tabledelete:CKEDITOR.TRISTATE_OFF,table:CKEDITOR.TRISTATE_OFF};});}}}),function(){function a(a){function b(a){0<c.length||a.type!=CKEDITOR.NODE_ELEMENT||!v.test(a.getName())||a.getCustomData("selected_cell")||(CKEDITOR.dom.element.setMarker(d,a,"selected_cell",!0),c.push(a));}a=a.getRanges();for(var c=[],d={},f=0;f<a.length;f++){var e=a[f];if(e.collapsed)e=e.getCommonAncestor(),(e=e.getAscendant("td",!0)||e.getAscendant("th",!0))&&c.push(e);else{var e=new CKEDITOR.dom.walker(e),g;for(e.guard=b;g=e.next();){g.type==CKEDITOR.NODE_ELEMENT&&g.is(CKEDITOR.dtd.table)||(g=g.getAscendant("td",!0)||g.getAscendant("th",!0))&&!g.getCustomData("selected_cell")&&(CKEDITOR.dom.element.setMarker(d,g,"selected_cell",!0),c.push(g));}}}CKEDITOR.dom.element.clearAllMarkers(d);return c;}function e(b,c){for(var d=a(b),f=d[0],e=f.getAscendant("table"),f=f.getDocument(),g=d[0].getParent(),h=g.$.rowIndex,d=d[d.length-1],k=d.getParent().$.rowIndex+d.$.rowSpan-1,d=new CKEDITOR.dom.element(e.$.rows[k]),h=c?h:k,g=c?g:d,d=CKEDITOR.tools.buildTableMap(e),e=d[h],h=c?d[h-1]:d[h+1],d=d[0].length,f=f.createElement("tr"),k=0;e[k]&&k<d;k++){var m;1<e[k].rowSpan&&h&&e[k]==h[k]?(m=e[k],m.rowSpan+=1):(m=new CKEDITOR.dom.element(e[k]).clone(),m.removeAttribute("rowSpan"),m.appendBogus(),f.append(m),m=m.$);k+=m.colSpan-1;}c?f.insertBefore(g):f.insertAfter(g);}function b(c){if(c instanceof CKEDITOR.dom.selection){var d=a(c),f=d[0].getAscendant("table"),e=CKEDITOR.tools.buildTableMap(f);c=d[0].getParent().$.rowIndex;for(var d=d[d.length-1],g=d.getParent().$.rowIndex+d.$.rowSpan-1,d=[],h=c;h<=g;h++){for(var k=e[h],m=new CKEDITOR.dom.element(f.$.rows[h]),l=0;l<k.length;l++){var n=new CKEDITOR.dom.element(k[l]),v=n.getParent().$.rowIndex;1==n.$.rowSpan?n.remove():(--n.$.rowSpan,v==h&&(v=e[h+1],v[l-1]?n.insertAfter(new CKEDITOR.dom.element(v[l-1])):new CKEDITOR.dom.element(f.$.rows[h+1]).append(n,1)));l+=n.$.colSpan-1;}d.push(m);}e=f.$.rows;f=new CKEDITOR.dom.element(e[g+1]||(0<c?e[c-1]:null)||f.$.parentNode);for(h=d.length;0<=h;h--){b(d[h]);}return f;}c instanceof CKEDITOR.dom.element&&(f=c.getAscendant("table"),1==f.$.rows.length?f.remove():c.remove());return null;}function c(a,b){for(var c=b?Infinity:0,d=0;d<a.length;d++){var f;f=a[d];for(var e=b,g=f.getParent().$.cells,h=0,k=0;k<g.length;k++){var m=g[k],h=h+(e?1:m.colSpan);if(m==f.$)break;}f=h-1;if(b?f<c:f>c)c=f;}return c;}function d(b,d){for(var f=a(b),e=f[0].getAscendant("table"),g=c(f,1),f=c(f),g=d?g:f,h=CKEDITOR.tools.buildTableMap(e),e=[],f=[],k=h.length,m=0;m<k;m++){e.push(h[m][g]),f.push(d?h[m][g-1]:h[m][g+1]);}for(m=0;m<k;m++){e[m]&&(1<e[m].colSpan&&f[m]==e[m]?(g=e[m],g.colSpan+=1):(g=new CKEDITOR.dom.element(e[m]).clone(),g.removeAttribute("colSpan"),g.appendBogus(),g[d?"insertBefore":"insertAfter"].call(g,new CKEDITOR.dom.element(e[m])),g=g.$),m+=g.rowSpan-1);}}function l(a,b){var c=a.getStartElement();if(c=c.getAscendant("td",1)||c.getAscendant("th",1)){var d=c.clone();d.appendBogus();b?d.insertBefore(c):d.insertAfter(c);}}function m(b){if(b instanceof CKEDITOR.dom.selection){b=a(b);var c=b[0]&&b[0].getAscendant("table"),d;a:{var e=0;d=b.length-1;for(var g={},h,k;h=b[e++];){CKEDITOR.dom.element.setMarker(g,h,"delete_cell",!0);}for(e=0;h=b[e++];){if((k=h.getPrevious())&&!k.getCustomData("delete_cell")||(k=h.getNext())&&!k.getCustomData("delete_cell")){CKEDITOR.dom.element.clearAllMarkers(g);d=k;break a;}}CKEDITOR.dom.element.clearAllMarkers(g);k=b[0].getParent();(k=k.getPrevious())?d=k.getLast():(k=b[d].getParent(),d=(k=k.getNext())?k.getChild(0):null);}for(k=b.length-1;0<=k;k--){m(b[k]);}d?f(d,!0):c&&c.remove();}else b instanceof CKEDITOR.dom.element&&(c=b.getParent(),1==c.getChildCount()?c.remove():b.remove());}function f(a,b){var c=a.getDocument(),d=CKEDITOR.document;CKEDITOR.env.ie&&10==CKEDITOR.env.version&&(d.focus(),c.focus());c=new CKEDITOR.dom.range(c);c["moveToElementEdit"+(b?"End":"Start")](a)||(c.selectNodeContents(a),c.collapse(b?!1:!0));c.select(!0);}function h(a,b,c){a=a[b];if("undefined"==typeof c)return a;for(b=0;a&&b<a.length;b++){if(c.is&&a[b]==c.$)return b;if(b==c)return new CKEDITOR.dom.element(a[b]);}return c.is?-1:null;}function k(b,c,d){var f=a(b),e;if((c?1!=f.length:2>f.length)||(e=b.getCommonAncestor())&&e.type==CKEDITOR.NODE_ELEMENT&&e.is("table"))return!1;var g;b=f[0];e=b.getAscendant("table");var k=CKEDITOR.tools.buildTableMap(e),m=k.length,l=k[0].length,n=b.getParent().$.rowIndex,v=h(k,n,b);if(c){var B;try{var C=parseInt(b.getAttribute("rowspan"),10)||1;g=parseInt(b.getAttribute("colspan"),10)||1;B=k["up"==c?n-C:"down"==c?n+C:n]["left"==c?v-g:"right"==c?v+g:v];}catch(F){return!1;}if(!B||b.$==B)return!1;f["up"==c||"left"==c?"unshift":"push"](new CKEDITOR.dom.element(B));}c=b.getDocument();var E=n,C=B=0,J=!d&&new CKEDITOR.dom.documentFragment(c),G=0;for(c=0;c<f.length;c++){g=f[c];var M=g.getParent(),I=g.getFirst(),H=g.$.colSpan,R=g.$.rowSpan,M=M.$.rowIndex,P=h(k,M,g),G=G+H*R,C=Math.max(C,P-v+H);B=Math.max(B,M-n+R);d||(H=g,(R=H.getBogus())&&R.remove(),H.trim(),g.getChildren().count()&&(M==E||!I||I.isBlockBoundary&&I.isBlockBoundary({br:1})||(E=J.getLast(CKEDITOR.dom.walker.whitespaces(!0)),!E||E.is&&E.is("br")||J.append("br")),g.moveChildren(J)),c?g.remove():g.setHtml(""));E=M;}if(d)return B*C==G;J.moveChildren(b);b.appendBogus();C>=l?b.removeAttribute("rowSpan"):b.$.rowSpan=B;B>=m?b.removeAttribute("colSpan"):b.$.colSpan=C;d=new CKEDITOR.dom.nodeList(e.$.rows);f=d.count();for(c=f-1;0<=c;c--){e=d.getItem(c),e.$.cells.length||(e.remove(),f++);}return b;}function g(b,c){var d=a(b);if(1<d.length)return!1;if(c)return!0;var d=d[0],f=d.getParent(),e=f.getAscendant("table"),g=CKEDITOR.tools.buildTableMap(e),k=f.$.rowIndex,m=h(g,k,d),l=d.$.rowSpan,n;if(1<l){n=Math.ceil(l/2);for(var l=Math.floor(l/2),f=k+n,e=new CKEDITOR.dom.element(e.$.rows[f]),g=h(g,f),v,f=d.clone(),k=0;k<g.length;k++){if(v=g[k],v.parentNode==e.$&&k>m){f.insertBefore(new CKEDITOR.dom.element(v));break;}else v=null;}v||e.append(f);}else for(l=n=1,e=f.clone(),e.insertAfter(f),e.append(f=d.clone()),v=h(g,k),m=0;m<v.length;m++){v[m].rowSpan++;}f.appendBogus();d.$.rowSpan=n;f.$.rowSpan=l;1==n&&d.removeAttribute("rowSpan");1==l&&f.removeAttribute("rowSpan");return f;}function n(b,c){var d=a(b);if(1<d.length)return!1;if(c)return!0;var d=d[0],f=d.getParent(),e=f.getAscendant("table"),e=CKEDITOR.tools.buildTableMap(e),g=h(e,f.$.rowIndex,d),k=d.$.colSpan;if(1<k)f=Math.ceil(k/2),k=Math.floor(k/2);else{for(var k=f=1,m=[],l=0;l<e.length;l++){var n=e[l];m.push(n[g]);1<n[g].rowSpan&&(l+=n[g].rowSpan-1);}for(e=0;e<m.length;e++){m[e].colSpan++;}}e=d.clone();e.insertAfter(d);e.appendBogus();d.$.colSpan=f;e.$.colSpan=k;1==f&&d.removeAttribute("colSpan");1==k&&e.removeAttribute("colSpan");return e;}var v=/^(?:td|th)$/;CKEDITOR.plugins.tabletools={requires:"table,dialog,contextmenu",init:function init(c){function h(a){return CKEDITOR.tools.extend(a||{},{contextSensitive:1,refresh:function refresh(a,b){this.setState(b.contains({td:1,th:1},1)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);}});}function t(a,b){var d=c.addCommand(a,b);c.addFeature(d);}var p=c.lang.table;t("cellProperties",new CKEDITOR.dialogCommand("cellProperties",h({allowedContent:"td th{width,height,border-color,background-color,white-space,vertical-align,text-align}[colspan,rowspan]",requiredContent:"table"})));CKEDITOR.dialog.add("cellProperties",this.path+"dialogs/tableCell.js");t("rowDelete",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();f(b(a));}}));t("rowInsertBefore",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();e(a,!0);}}));t("rowInsertAfter",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();e(a);}}));t("columnDelete",h({requiredContent:"table",exec:function exec(b){b=b.getSelection();b=a(b);var c=b[0],d=b[b.length-1];b=c.getAscendant("table");for(var e=CKEDITOR.tools.buildTableMap(b),g,h,k=[],m=0,l=e.length;m<l;m++){for(var n=0,q=e[m].length;n<q;n++){e[m][n]==c.$&&(g=n),e[m][n]==d.$&&(h=n);}}for(m=g;m<=h;m++){for(n=0;n<e.length;n++){d=e[n],c=new CKEDITOR.dom.element(b.$.rows[n]),d=new CKEDITOR.dom.element(d[m]),d.$&&(1==d.$.colSpan?d.remove():--d.$.colSpan,n+=d.$.rowSpan-1,c.$.cells.length||k.push(c));}}h=b.$.rows[0]&&b.$.rows[0].cells;g=new CKEDITOR.dom.element(h[g]||(g?h[g-1]:b.$.parentNode));k.length==l&&b.remove();g&&f(g,!0);}}));t("columnInsertBefore",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();d(a,!0);}}));t("columnInsertAfter",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();d(a);}}));t("cellDelete",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();m(a);}}));t("cellMerge",h({allowedContent:"td[colspan,rowspan]",requiredContent:"td[colspan,rowspan]",exec:function exec(a){f(k(a.getSelection()),!0);}}));t("cellMergeRight",h({allowedContent:"td[colspan]",requiredContent:"td[colspan]",exec:function exec(a){f(k(a.getSelection(),"right"),!0);}}));t("cellMergeDown",h({allowedContent:"td[rowspan]",requiredContent:"td[rowspan]",exec:function exec(a){f(k(a.getSelection(),"down"),!0);}}));t("cellVerticalSplit",h({allowedContent:"td[rowspan]",requiredContent:"td[rowspan]",exec:function exec(a){f(n(a.getSelection()));}}));t("cellHorizontalSplit",h({allowedContent:"td[colspan]",requiredContent:"td[colspan]",exec:function exec(a){f(g(a.getSelection()));}}));t("cellInsertBefore",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();l(a,!0);}}));t("cellInsertAfter",h({requiredContent:"table",exec:function exec(a){a=a.getSelection();l(a);}}));c.addMenuItems&&c.addMenuItems({tablecell:{label:p.cell.menu,group:"tablecell",order:1,getItems:function getItems(){var b=c.getSelection(),d=a(b);return{tablecell_insertBefore:CKEDITOR.TRISTATE_OFF,tablecell_insertAfter:CKEDITOR.TRISTATE_OFF,tablecell_delete:CKEDITOR.TRISTATE_OFF,tablecell_merge:k(b,null,!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_merge_right:k(b,"right",!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_merge_down:k(b,"down",!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_split_vertical:n(b,!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_split_horizontal:g(b,!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_properties:0<d.length?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED};}},tablecell_insertBefore:{label:p.cell.insertBefore,group:"tablecell",command:"cellInsertBefore",order:5},tablecell_insertAfter:{label:p.cell.insertAfter,group:"tablecell",command:"cellInsertAfter",order:10},tablecell_delete:{label:p.cell.deleteCell,group:"tablecell",command:"cellDelete",order:15},tablecell_merge:{label:p.cell.merge,group:"tablecell",command:"cellMerge",order:16},tablecell_merge_right:{label:p.cell.mergeRight,group:"tablecell",command:"cellMergeRight",order:17},tablecell_merge_down:{label:p.cell.mergeDown,group:"tablecell",command:"cellMergeDown",order:18},tablecell_split_horizontal:{label:p.cell.splitHorizontal,group:"tablecell",command:"cellHorizontalSplit",order:19},tablecell_split_vertical:{label:p.cell.splitVertical,group:"tablecell",command:"cellVerticalSplit",order:20},tablecell_properties:{label:p.cell.title,group:"tablecellproperties",command:"cellProperties",order:21},tablerow:{label:p.row.menu,group:"tablerow",order:1,getItems:function getItems(){return{tablerow_insertBefore:CKEDITOR.TRISTATE_OFF,tablerow_insertAfter:CKEDITOR.TRISTATE_OFF,tablerow_delete:CKEDITOR.TRISTATE_OFF};}},tablerow_insertBefore:{label:p.row.insertBefore,group:"tablerow",command:"rowInsertBefore",order:5},tablerow_insertAfter:{label:p.row.insertAfter,group:"tablerow",command:"rowInsertAfter",order:10},tablerow_delete:{label:p.row.deleteRow,group:"tablerow",command:"rowDelete",order:15},tablecolumn:{label:p.column.menu,group:"tablecolumn",order:1,getItems:function getItems(){return{tablecolumn_insertBefore:CKEDITOR.TRISTATE_OFF,tablecolumn_insertAfter:CKEDITOR.TRISTATE_OFF,tablecolumn_delete:CKEDITOR.TRISTATE_OFF};}},tablecolumn_insertBefore:{label:p.column.insertBefore,group:"tablecolumn",command:"columnInsertBefore",order:5},tablecolumn_insertAfter:{label:p.column.insertAfter,group:"tablecolumn",command:"columnInsertAfter",order:10},tablecolumn_delete:{label:p.column.deleteColumn,group:"tablecolumn",command:"columnDelete",order:15}});c.contextMenu&&c.contextMenu.addListener(function(a,b,c){return(a=c.contains({td:1,th:1},1))&&!a.isReadOnly()?{tablecell:CKEDITOR.TRISTATE_OFF,tablerow:CKEDITOR.TRISTATE_OFF,tablecolumn:CKEDITOR.TRISTATE_OFF}:null;});},getSelectedCells:a};CKEDITOR.plugins.add("tabletools",CKEDITOR.plugins.tabletools);}(),CKEDITOR.tools.buildTableMap=function(a){a=a.$.rows;for(var e=-1,b=[],c=0;c<a.length;c++){e++;!b[e]&&(b[e]=[]);for(var d=-1,l=0;l<a[c].cells.length;l++){var m=a[c].cells[l];for(d++;b[e][d];){d++;}for(var f=isNaN(m.colSpan)?1:m.colSpan,m=isNaN(m.rowSpan)?1:m.rowSpan,h=0;h<m;h++){b[e+h]||(b[e+h]=[]);for(var k=0;k<f;k++){b[e+h][d+k]=a[c].cells[l];}}d+=f-1;}}return b;},function(){function a(a){function b(){for(var g=c(),h=CKEDITOR.tools.clone(a.config.toolbarGroups)||e(a),k=0;k<h.length;k++){var l=h[k];if("/"!=l){"string"==typeof l&&(l=h[k]={name:l});var t,p=l.groups;if(p)for(var w=0;w<p.length;w++){t=p[w],(t=g[t])&&f(l,t);}(t=g[l.name])&&f(l,t);}}return h;}function c(){var b={},f,e,g;for(f in a.ui.items){e=a.ui.items[f],g=e.toolbar||"others",g=g.split(","),e=g[0],g=parseInt(g[1]||-1,10),b[e]||(b[e]=[]),b[e].push({name:f,order:g});}for(e in b){b[e]=b[e].sort(function(a,b){return a.order==b.order?0:0>b.order?-1:0>a.order?1:a.order<b.order?-1:1;});}return b;}function f(b,c){if(c.length){b.items?b.items.push(a.ui.create("-")):b.items=[];for(var f;f=c.shift();){f="string"==typeof f?f:f.name,k&&-1!=CKEDITOR.tools.indexOf(k,f)||(f=a.ui.create(f))&&a.addFeature(f)&&b.items.push(f);}}}function h(a){var b=[],c,d,e;for(c=0;c<a.length;++c){d=a[c],e={},"/"==d?b.push(d):CKEDITOR.tools.isArray(d)?(f(e,CKEDITOR.tools.clone(d)),b.push(e)):d.items&&(f(e,CKEDITOR.tools.clone(d.items)),e.name=d.name,b.push(e));}return b;}var k=a.config.removeButtons,k=k&&k.split(","),g=a.config.toolbar;"string"==typeof g&&(g=a.config["toolbar_"+g]);return a.toolbar=g?h(g):b();}function e(a){return a._.toolbarGroups||(a._.toolbarGroups=[{name:"document",groups:["mode","document","doctools"]},{name:"clipboard",groups:["clipboard","undo"]},{name:"editing",groups:["find","selection","spellchecker"]},{name:"forms"},"/",{name:"basicstyles",groups:["basicstyles","cleanup"]},{name:"paragraph",groups:["list","indent","blocks","align","bidi"]},{name:"links"},{name:"insert"},"/",{name:"styles"},{name:"colors"},{name:"tools"},{name:"others"},{name:"about"}]);}var b=function b(){this.toolbars=[];this.focusCommandExecuted=!1;};b.prototype.focus=function(){for(var a=0,b;b=this.toolbars[a++];){for(var c=0,f;f=b.items[c++];){if(f.focus){f.focus();return;}}}};var c={modes:{wysiwyg:1,source:1},readOnly:1,exec:function exec(a){a.toolbox&&(a.toolbox.focusCommandExecuted=!0,CKEDITOR.env.ie||CKEDITOR.env.air?setTimeout(function(){a.toolbox.focus();},100):a.toolbox.focus());}};CKEDITOR.plugins.add("toolbar",{requires:"button",init:function init(d){var e,m=function m(a,b){var c,g="rtl"==d.lang.dir,n=d.config.toolbarGroupCycling,v=g?37:39,g=g?39:37,n=void 0===n||n;switch(b){case 9:case CKEDITOR.SHIFT+9:for(;!c||!c.items.length;){if(c=9==b?(c?c.next:a.toolbar.next)||d.toolbox.toolbars[0]:(c?c.previous:a.toolbar.previous)||d.toolbox.toolbars[d.toolbox.toolbars.length-1],c.items.length)for(a=c.items[e?c.items.length-1:0];a&&!a.focus;){(a=e?a.previous:a.next)||(c=0);}}a&&a.focus();return!1;case v:c=a;do{c=c.next,!c&&n&&(c=a.toolbar.items[0]);}while(c&&!c.focus);c?c.focus():m(a,9);return!1;case 40:return a.button&&a.button.hasArrow?(d.once("panelShow",function(a){a.data._.panel._.currentBlock.onKeyDown(40);}),a.execute()):m(a,40==b?v:g),!1;case g:case 38:c=a;do{c=c.previous,!c&&n&&(c=a.toolbar.items[a.toolbar.items.length-1]);}while(c&&!c.focus);c?c.focus():(e=1,m(a,CKEDITOR.SHIFT+9),e=0);return!1;case 27:return d.focus(),!1;case 13:case 32:return a.execute(),!1;}return!0;};d.on("uiSpace",function(c){if(c.data.space==d.config.toolbarLocation){c.removeListener();d.toolbox=new b();var e=CKEDITOR.tools.getNextId(),k=['\x3cspan id\x3d"',e,'" class\x3d"cke_voice_label"\x3e',d.lang.toolbar.toolbars,"\x3c/span\x3e",'\x3cspan id\x3d"'+d.ui.spaceId("toolbox")+'" class\x3d"cke_toolbox" role\x3d"group" aria-labelledby\x3d"',e,'" onmousedown\x3d"return false;"\x3e'],e=!1!==d.config.toolbarStartupExpanded,g,l;d.config.toolbarCanCollapse&&d.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE&&k.push('\x3cspan class\x3d"cke_toolbox_main"'+(e?"\x3e":' style\x3d"display:none"\x3e'));for(var v=d.toolbox.toolbars,r=a(d),q=0;q<r.length;q++){var t,p=0,w,z=r[q],A;if(z)if(g&&(k.push("\x3c/span\x3e"),l=g=0),"/"===z)k.push('\x3cspan class\x3d"cke_toolbar_break"\x3e\x3c/span\x3e');else{A=z.items||z;for(var u=0;u<A.length;u++){var x=A[u],D;if(x){var y=function y(a){a=a.render(d,k);B=p.items.push(a)-1;0<B&&(a.previous=p.items[B-1],a.previous.next=a);a.toolbar=p;a.onkey=m;a.onfocus=function(){d.toolbox.focusCommandExecuted||d.focus();};};if(x.type==CKEDITOR.UI_SEPARATOR)l=g&&x;else{D=!1!==x.canGroup;if(!p){t=CKEDITOR.tools.getNextId();p={id:t,items:[]};w=z.name&&(d.lang.toolbar.toolbarGroups[z.name]||z.name);k.push('\x3cspan id\x3d"',t,'" class\x3d"cke_toolbar"',w?' aria-labelledby\x3d"'+t+'_label"':"",' role\x3d"toolbar"\x3e');w&&k.push('\x3cspan id\x3d"',t,'_label" class\x3d"cke_voice_label"\x3e',w,"\x3c/span\x3e");k.push('\x3cspan class\x3d"cke_toolbar_start"\x3e\x3c/span\x3e');var B=v.push(p)-1;0<B&&(p.previous=v[B-1],p.previous.next=p);}D?g||(k.push('\x3cspan class\x3d"cke_toolgroup" role\x3d"presentation"\x3e'),g=1):g&&(k.push("\x3c/span\x3e"),g=0);l&&(y(l),l=0);y(x);}}}g&&(k.push("\x3c/span\x3e"),l=g=0);p&&k.push('\x3cspan class\x3d"cke_toolbar_end"\x3e\x3c/span\x3e\x3c/span\x3e');}}d.config.toolbarCanCollapse&&k.push("\x3c/span\x3e");if(d.config.toolbarCanCollapse&&d.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE){var C=CKEDITOR.tools.addFunction(function(){d.execCommand("toolbarCollapse");});d.on("destroy",function(){CKEDITOR.tools.removeFunction(C);});d.addCommand("toolbarCollapse",{readOnly:1,exec:function exec(a){var b=a.ui.space("toolbar_collapser"),c=b.getPrevious(),d=a.ui.space("contents"),f=c.getParent(),e=parseInt(d.$.style.height,10),g=f.$.offsetHeight,h=b.hasClass("cke_toolbox_collapser_min");h?(c.show(),b.removeClass("cke_toolbox_collapser_min"),b.setAttribute("title",a.lang.toolbar.toolbarCollapse)):(c.hide(),b.addClass("cke_toolbox_collapser_min"),b.setAttribute("title",a.lang.toolbar.toolbarExpand));b.getFirst().setText(h?"▲":"◀");d.setStyle("height",e-(f.$.offsetHeight-g)+"px");a.fire("resize",{outerHeight:a.container.$.offsetHeight,contentsHeight:d.$.offsetHeight,outerWidth:a.container.$.offsetWidth});},modes:{wysiwyg:1,source:1}});d.setKeystroke(CKEDITOR.ALT+(CKEDITOR.env.ie||CKEDITOR.env.webkit?189:109),"toolbarCollapse");k.push('\x3ca title\x3d"'+(e?d.lang.toolbar.toolbarCollapse:d.lang.toolbar.toolbarExpand)+'" id\x3d"'+d.ui.spaceId("toolbar_collapser")+'" tabIndex\x3d"-1" class\x3d"cke_toolbox_collapser');e||k.push(" cke_toolbox_collapser_min");k.push('" onclick\x3d"CKEDITOR.tools.callFunction('+C+')"\x3e','\x3cspan class\x3d"cke_arrow"\x3e\x26#9650;\x3c/span\x3e',"\x3c/a\x3e");}k.push("\x3c/span\x3e");c.data.html+=k.join("");}});d.on("destroy",function(){if(this.toolbox){var a,b=0,c,d,e;for(a=this.toolbox.toolbars;b<a.length;b++){for(d=a[b].items,c=0;c<d.length;c++){e=d[c],e.clickFn&&CKEDITOR.tools.removeFunction(e.clickFn),e.keyDownFn&&CKEDITOR.tools.removeFunction(e.keyDownFn);}}}});d.on("uiReady",function(){var a=d.ui.space("toolbox");a&&d.focusManager.add(a,1);});d.addCommand("toolbarFocus",c);d.setKeystroke(CKEDITOR.ALT+121,"toolbarFocus");d.ui.add("-",CKEDITOR.UI_SEPARATOR,{});d.ui.addHandler(CKEDITOR.UI_SEPARATOR,{create:function create(){return{render:function render(a,b){b.push('\x3cspan class\x3d"cke_toolbar_separator" role\x3d"separator"\x3e\x3c/span\x3e');return{};}};}});}});CKEDITOR.ui.prototype.addToolbarGroup=function(a,b,c){var f=e(this.editor),h=0===b,k={name:a};if(c){if(c=CKEDITOR.tools.search(f,function(a){return a.name==c;})){!c.groups&&(c.groups=[]);if(b&&(b=CKEDITOR.tools.indexOf(c.groups,b),0<=b)){c.groups.splice(b+1,0,a);return;}h?c.groups.splice(0,0,a):c.groups.push(a);return;}b=null;}b&&(b=CKEDITOR.tools.indexOf(f,function(a){return a.name==b;}));h?f.splice(0,0,a):"number"==typeof b?f.splice(b+1,0,k):f.push(a);};}(),CKEDITOR.UI_SEPARATOR="separator",CKEDITOR.config.toolbarLocation="top","use strict",function(){var a=[CKEDITOR.CTRL+90,CKEDITOR.CTRL+89,CKEDITOR.CTRL+CKEDITOR.SHIFT+90],e={8:1,46:1};CKEDITOR.plugins.add("undo",{init:function init(c){function d(a){g.enabled&&!1!==a.data.command.canUndo&&g.save();}function e(){g.enabled=c.readOnly?!1:"wysiwyg"==c.mode;g.onChange();}var g=c.undoManager=new b(c),m=g.editingHandler=new l(g),v=c.addCommand("undo",{exec:function exec(){g.undo()&&(c.selectionChange(),this.fire("afterUndo"));},startDisabled:!0,canUndo:!1}),r=c.addCommand("redo",{exec:function exec(){g.redo()&&(c.selectionChange(),this.fire("afterRedo"));},startDisabled:!0,canUndo:!1});c.setKeystroke([[a[0],"undo"],[a[1],"redo"],[a[2],"redo"]]);g.onChange=function(){v.setState(g.undoable()?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);r.setState(g.redoable()?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);};c.on("beforeCommandExec",d);c.on("afterCommandExec",d);c.on("saveSnapshot",function(a){g.save(a.data&&a.data.contentOnly);});c.on("contentDom",m.attachListeners,m);c.on("instanceReady",function(){c.fire("saveSnapshot");});c.on("beforeModeUnload",function(){"wysiwyg"==c.mode&&g.save(!0);});c.on("mode",e);c.on("readOnly",e);c.ui.addButton&&(c.ui.addButton("Undo",{label:c.lang.undo.undo,command:"undo",toolbar:"undo,10"}),c.ui.addButton("Redo",{label:c.lang.undo.redo,command:"redo",toolbar:"undo,20"}));c.resetUndo=function(){g.reset();c.fire("saveSnapshot");};c.on("updateSnapshot",function(){g.currentImage&&g.update();});c.on("lockSnapshot",function(a){a=a.data;g.lock(a&&a.dontUpdate,a&&a.forceUpdate);});c.on("unlockSnapshot",g.unlock,g);}});CKEDITOR.plugins.undo={};var b=CKEDITOR.plugins.undo.UndoManager=function(a){this.strokesRecorded=[0,0];this.locked=null;this.previousKeyGroup=-1;this.limit=a.config.undoStackSize||20;this.strokesLimit=25;this.editor=a;this.reset();};b.prototype={type:function type(a,c){var d=b.getKeyGroup(a),e=this.strokesRecorded[d]+1;c=c||e>=this.strokesLimit;this.typing||(this.hasUndo=this.typing=!0,this.hasRedo=!1,this.onChange());c?(e=0,this.editor.fire("saveSnapshot")):this.editor.fire("change");this.strokesRecorded[d]=e;this.previousKeyGroup=d;},keyGroupChanged:function keyGroupChanged(a){return b.getKeyGroup(a)!=this.previousKeyGroup;},reset:function reset(){this.snapshots=[];this.index=-1;this.currentImage=null;this.hasRedo=this.hasUndo=!1;this.locked=null;this.resetType();},resetType:function resetType(){this.strokesRecorded=[0,0];this.typing=!1;this.previousKeyGroup=-1;},refreshState:function refreshState(){this.hasUndo=!!this.getNextImage(!0);this.hasRedo=!!this.getNextImage(!1);this.resetType();this.onChange();},save:function save(a,b,d){var e=this.editor;if(this.locked||"ready"!=e.status||"wysiwyg"!=e.mode)return!1;var m=e.editable();if(!m||"ready"!=m.status)return!1;m=this.snapshots;b||(b=new c(e));if(!1===b.contents)return!1;if(this.currentImage)if(b.equalsContent(this.currentImage)){if(a||b.equalsSelection(this.currentImage))return!1;}else!1!==d&&e.fire("change");m.splice(this.index+1,m.length-this.index-1);m.length==this.limit&&m.shift();this.index=m.push(b)-1;this.currentImage=b;!1!==d&&this.refreshState();return!0;},restoreImage:function restoreImage(a){var b=this.editor,c;a.bookmarks&&(b.focus(),c=b.getSelection());this.locked={level:999};this.editor.loadSnapshot(a.contents);a.bookmarks?c.selectBookmarks(a.bookmarks):CKEDITOR.env.ie&&(c=this.editor.document.getBody().$.createTextRange(),c.collapse(!0),c.select());this.locked=null;this.index=a.index;this.currentImage=this.snapshots[this.index];this.update();this.refreshState();b.fire("change");},getNextImage:function getNextImage(a){var b=this.snapshots,c=this.currentImage,d;if(c)if(a)for(d=this.index-1;0<=d;d--){if(a=b[d],!c.equalsContent(a))return a.index=d,a;}else for(d=this.index+1;d<b.length;d++){if(a=b[d],!c.equalsContent(a))return a.index=d,a;}return null;},redoable:function redoable(){return this.enabled&&this.hasRedo;},undoable:function undoable(){return this.enabled&&this.hasUndo;},undo:function undo(){if(this.undoable()){this.save(!0);var a=this.getNextImage(!0);if(a)return this.restoreImage(a),!0;}return!1;},redo:function redo(){if(this.redoable()&&(this.save(!0),this.redoable())){var a=this.getNextImage(!1);if(a)return this.restoreImage(a),!0;}return!1;},update:function update(a){if(!this.locked){a||(a=new c(this.editor));for(var b=this.index,d=this.snapshots;0<b&&this.currentImage.equalsContent(d[b-1]);){--b;}d.splice(b,this.index-b+1,a);this.index=b;this.currentImage=a;}},updateSelection:function updateSelection(a){if(!this.snapshots.length)return!1;var b=this.snapshots,c=b[b.length-1];return c.equalsContent(a)&&!c.equalsSelection(a)?(this.currentImage=b[b.length-1]=a,!0):!1;},lock:function lock(a,b){if(this.locked)this.locked.level++;else if(a)this.locked={level:1};else{var d=null;if(b)d=!0;else{var e=new c(this.editor,!0);this.currentImage&&this.currentImage.equalsContent(e)&&(d=e);}this.locked={update:d,level:1};}},unlock:function unlock(){if(this.locked&&! --this.locked.level){var a=this.locked.update;this.locked=null;if(!0===a)this.update();else if(a){var b=new c(this.editor,!0);a.equalsContent(b)||this.update();}}}};b.navigationKeyCodes={37:1,38:1,39:1,40:1,36:1,35:1,33:1,34:1};b.keyGroups={PRINTABLE:0,FUNCTIONAL:1};b.isNavigationKey=function(a){return!!b.navigationKeyCodes[a];};b.getKeyGroup=function(a){var c=b.keyGroups;return e[a]?c.FUNCTIONAL:c.PRINTABLE;};b.getOppositeKeyGroup=function(a){var c=b.keyGroups;return a==c.FUNCTIONAL?c.PRINTABLE:c.FUNCTIONAL;};b.ieFunctionalKeysBug=function(a){return CKEDITOR.env.ie&&b.getKeyGroup(a)==b.keyGroups.FUNCTIONAL;};var c=CKEDITOR.plugins.undo.Image=function(a,b){this.editor=a;a.fire("beforeUndoImage");var c=a.getSnapshot();CKEDITOR.env.ie&&c&&(c=c.replace(/\s+data-cke-expando=".*?"/g,""));this.contents=c;b||(this.bookmarks=(c=c&&a.getSelection())&&c.createBookmarks2(!0));a.fire("afterUndoImage");},d=/\b(?:href|src|name)="[^"]*?"/gi;c.prototype={equalsContent:function equalsContent(a){var b=this.contents;a=a.contents;CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)&&(b=b.replace(d,""),a=a.replace(d,""));return b!=a?!1:!0;},equalsSelection:function equalsSelection(a){var b=this.bookmarks;a=a.bookmarks;if(b||a){if(!b||!a||b.length!=a.length)return!1;for(var c=0;c<b.length;c++){var d=b[c],e=a[c];if(d.startOffset!=e.startOffset||d.endOffset!=e.endOffset||!CKEDITOR.tools.arrayCompare(d.start,e.start)||!CKEDITOR.tools.arrayCompare(d.end,e.end))return!1;}}return!0;}};var l=CKEDITOR.plugins.undo.NativeEditingHandler=function(a){this.undoManager=a;this.ignoreInputEvent=!1;this.keyEventsStack=new m();this.lastKeydownImage=null;};l.prototype={onKeydown:function onKeydown(d){var e=d.data.getKey();if(229!==e)if(-1<CKEDITOR.tools.indexOf(a,d.data.getKeystroke()))d.data.preventDefault();else if(this.keyEventsStack.cleanUp(d),d=this.undoManager,this.keyEventsStack.getLast(e)||this.keyEventsStack.push(e),this.lastKeydownImage=new c(d.editor),b.isNavigationKey(e)||this.undoManager.keyGroupChanged(e))if(d.strokesRecorded[0]||d.strokesRecorded[1])d.save(!1,this.lastKeydownImage,!1),d.resetType();},onInput:function onInput(){if(this.ignoreInputEvent)this.ignoreInputEvent=!1;else{var a=this.keyEventsStack.getLast();a||(a=this.keyEventsStack.push(0));this.keyEventsStack.increment(a.keyCode);this.keyEventsStack.getTotalInputs()>=this.undoManager.strokesLimit&&(this.undoManager.type(a.keyCode,!0),this.keyEventsStack.resetInputs());}},onKeyup:function onKeyup(a){var d=this.undoManager;a=a.data.getKey();var e=this.keyEventsStack.getTotalInputs();this.keyEventsStack.remove(a);if(!(b.ieFunctionalKeysBug(a)&&this.lastKeydownImage&&this.lastKeydownImage.equalsContent(new c(d.editor,!0))))if(0<e)d.type(a);else if(b.isNavigationKey(a))this.onNavigationKey(!0);},onNavigationKey:function onNavigationKey(a){var b=this.undoManager;!a&&b.save(!0,null,!1)||b.updateSelection(new c(b.editor));b.resetType();},ignoreInputEventListener:function ignoreInputEventListener(){this.ignoreInputEvent=!0;},attachListeners:function attachListeners(){var a=this.undoManager.editor,c=a.editable(),d=this;c.attachListener(c,"keydown",function(a){d.onKeydown(a);if(b.ieFunctionalKeysBug(a.data.getKey()))d.onInput();},null,null,999);c.attachListener(c,CKEDITOR.env.ie?"keypress":"input",d.onInput,d,null,999);c.attachListener(c,"keyup",d.onKeyup,d,null,999);c.attachListener(c,"paste",d.ignoreInputEventListener,d,null,999);c.attachListener(c,"drop",d.ignoreInputEventListener,d,null,999);c.attachListener(c.isInline()?c:a.document.getDocumentElement(),"click",function(){d.onNavigationKey();},null,null,999);c.attachListener(this.undoManager.editor,"blur",function(){d.keyEventsStack.remove(9);},null,null,999);}};var m=CKEDITOR.plugins.undo.KeyEventsStack=function(){this.stack=[];};m.prototype={push:function push(a){a=this.stack.push({keyCode:a,inputs:0});return this.stack[a-1];},getLastIndex:function getLastIndex(a){if("number"!=typeof a)return this.stack.length-1;for(var b=this.stack.length;b--;){if(this.stack[b].keyCode==a)return b;}return-1;},getLast:function getLast(a){a=this.getLastIndex(a);return-1!=a?this.stack[a]:null;},increment:function increment(a){this.getLast(a).inputs++;},remove:function remove(a){a=this.getLastIndex(a);-1!=a&&this.stack.splice(a,1);},resetInputs:function resetInputs(a){if("number"==typeof a)this.getLast(a).inputs=0;else for(a=this.stack.length;a--;){this.stack[a].inputs=0;}},getTotalInputs:function getTotalInputs(){for(var a=this.stack.length,b=0;a--;){b+=this.stack[a].inputs;}return b;},cleanUp:function cleanUp(a){a=a.data.$;a.ctrlKey||a.metaKey||this.remove(17);a.shiftKey||this.remove(16);a.altKey||this.remove(18);}};}(),CKEDITOR.plugins.add("wsc",{requires:"dialog",parseApi:function parseApi(a){a.config.wsc_onFinish="function"===typeof a.config.wsc_onFinish?a.config.wsc_onFinish:function(){};a.config.wsc_onClose="function"===typeof a.config.wsc_onClose?a.config.wsc_onClose:function(){};},parseConfig:function parseConfig(a){a.config.wsc_customerId=a.config.wsc_customerId||CKEDITOR.config.wsc_customerId||"1:ua3xw1-2XyGJ3-GWruD3-6OFNT1-oXcuB1-nR6Bp4-hgQHc-EcYng3-sdRXG3-NOfFk";a.config.wsc_customDictionaryIds=a.config.wsc_customDictionaryIds||CKEDITOR.config.wsc_customDictionaryIds||"";a.config.wsc_userDictionaryName=a.config.wsc_userDictionaryName||CKEDITOR.config.wsc_userDictionaryName||"";a.config.wsc_customLoaderScript=a.config.wsc_customLoaderScript||CKEDITOR.config.wsc_customLoaderScript;CKEDITOR.config.wsc_cmd=a.config.wsc_cmd||CKEDITOR.config.wsc_cmd||"spell";CKEDITOR.config.wsc_version="v4.3.0-master-d769233";CKEDITOR.config.wsc_removeGlobalVariable=!0;},init:function init(a){var e=CKEDITOR.env;this.parseConfig(a);this.parseApi(a);a.addCommand("checkspell",new CKEDITOR.dialogCommand("checkspell")).modes={wysiwyg:!CKEDITOR.env.opera&&!CKEDITOR.env.air&&document.domain==window.location.hostname&&!(e.ie&&(8>e.version||e.quirks))};"undefined"==typeof a.plugins.scayt&&a.ui.addButton&&a.ui.addButton("SpellChecker",{label:a.lang.wsc.toolbar,click:function click(a){var c=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.container.getText():a.document.getBody().getText();(c=c.replace(/\s/g,""))?a.execCommand("checkspell"):alert("Nothing to check!");},toolbar:"spellchecker,10"});CKEDITOR.dialog.add("checkspell",this.path+(CKEDITOR.env.ie&&7>=CKEDITOR.env.version?"dialogs/wsc_ie.js":window.postMessage?"dialogs/wsc.js":"dialogs/wsc_ie.js"));}}),function(){function a(a){function b(a){var c=!1;g.attachListener(g,"keydown",function(){var b=f.getBody().getElementsByTag(a);if(!c){for(var d=0;d<b.count();d++){b.getItem(d).setCustomData("retain",!0);}c=!0;}},null,null,1);g.attachListener(g,"keyup",function(){var b=f.getElementsByTag(a);c&&(1!=b.count()||b.getItem(0).getCustomData("retain")||b.getItem(0).hasAttribute("data-cke-temp")||b.getItem(0).remove(1),c=!1);});}var c=this.editor,f=a.document,h=f.body,k=f.getElementById("cke_actscrpt");k&&k.parentNode.removeChild(k);(k=f.getElementById("cke_shimscrpt"))&&k.parentNode.removeChild(k);(k=f.getElementById("cke_basetagscrpt"))&&k.parentNode.removeChild(k);h.contentEditable=!0;CKEDITOR.env.ie&&(h.hideFocus=!0,h.disabled=!0,h.removeAttribute("disabled"));delete this._.isLoadingData;this.$=h;f=new CKEDITOR.dom.document(f);this.setup();this.fixInitialSelection();var g=this;CKEDITOR.env.ie&&!CKEDITOR.env.edge&&f.getDocumentElement().addClass(f.$.compatMode);CKEDITOR.env.ie&&!CKEDITOR.env.edge&&c.enterMode!=CKEDITOR.ENTER_P?b("p"):CKEDITOR.env.edge&&c.enterMode!=CKEDITOR.ENTER_DIV&&b("div");if(CKEDITOR.env.webkit||CKEDITOR.env.ie&&10<CKEDITOR.env.version)f.getDocumentElement().on("mousedown",function(a){a.data.getTarget().is("html")&&setTimeout(function(){c.editable().focus();});});e(c);try{c.document.$.execCommand("2D-position",!1,!0);}catch(n){}(CKEDITOR.env.gecko||CKEDITOR.env.ie&&"CSS1Compat"==c.document.$.compatMode)&&this.attachListener(this,"keydown",function(a){var b=a.data.getKeystroke();if(33==b||34==b)if(CKEDITOR.env.ie)setTimeout(function(){c.getSelection().scrollIntoView();},0);else if(c.window.$.innerHeight>this.$.offsetHeight){var d=c.createRange();d[33==b?"moveToElementEditStart":"moveToElementEditEnd"](this);d.select();a.data.preventDefault();}});CKEDITOR.env.ie&&this.attachListener(f,"blur",function(){try{f.$.selection.empty();}catch(a){}});CKEDITOR.env.iOS&&this.attachListener(f,"touchend",function(){a.focus();});h=c.document.getElementsByTag("title").getItem(0);h.data("cke-title",h.getText());CKEDITOR.env.ie&&(c.document.$.title=this._.docTitle);CKEDITOR.tools.setTimeout(function(){"unloaded"==this.status&&(this.status="ready");c.fire("contentDom");this._.isPendingFocus&&(c.focus(),this._.isPendingFocus=!1);setTimeout(function(){c.fire("dataReady");},0);},0,this);}function e(a){function b(){var e;a.editable().attachListener(a,"selectionChange",function(){var b=a.getSelection().getSelectedElement();b&&(e&&(e.detachEvent("onresizestart",c),e=null),b.$.attachEvent("onresizestart",c),e=b.$);});}function c(a){a.returnValue=!1;}if(CKEDITOR.env.gecko)try{var e=a.document.$;e.execCommand("enableObjectResizing",!1,!a.config.disableObjectResizing);e.execCommand("enableInlineTableEditing",!1,!a.config.disableNativeTableHandles);}catch(h){}else CKEDITOR.env.ie&&11>CKEDITOR.env.version&&a.config.disableObjectResizing&&b(a);}function b(){var a=[];if(8<=CKEDITOR.document.$.documentMode){a.push("html.CSS1Compat [contenteditable\x3dfalse]{min-height:0 !important}");var b=[],c;for(c in CKEDITOR.dtd.$removeEmpty){b.push("html.CSS1Compat "+c+"[contenteditable\x3dfalse]");}a.push(b.join(",")+"{display:inline-block}");}else CKEDITOR.env.gecko&&(a.push("html{height:100% !important}"),a.push("img:-moz-broken{-moz-force-broken-image-icon:1;min-width:24px;min-height:24px}"));a.push("html{cursor:text;*cursor:auto}");a.push("img,input,textarea{cursor:default}");return a.join("\n");}var c;CKEDITOR.plugins.add("wysiwygarea",{init:function init(a){a.config.fullPage&&a.addFeature({allowedContent:"html head title; style [media,type]; body (*)[id]; meta link [*]",requiredContent:"body"});a.addMode("wysiwyg",function(b){function e(f){f&&f.removeListener();a.editable(new c(a,h.$.contentWindow.document.body));a.setData(a.getData(1),b);}var f="document.open();"+(CKEDITOR.env.ie?"("+CKEDITOR.tools.fixDomain+")();":"")+"document.close();",f=CKEDITOR.env.air?"javascript:void(0)":CKEDITOR.env.ie&&!CKEDITOR.env.edge?"javascript:void(function(){"+encodeURIComponent(f)+"}())":"",h=CKEDITOR.dom.element.createFromHtml('\x3ciframe src\x3d"'+f+'" frameBorder\x3d"0"\x3e\x3c/iframe\x3e');h.setStyles({width:"100%",height:"100%"});h.addClass("cke_wysiwyg_frame").addClass("cke_reset");f=a.ui.space("contents");f.append(h);var k=CKEDITOR.env.ie&&!CKEDITOR.env.edge||CKEDITOR.env.gecko;if(k)h.on("load",e);var g=a.title,n=a.fire("ariaEditorHelpLabel",{}).label;g&&(CKEDITOR.env.ie&&n&&(g+=", "+n),h.setAttribute("title",g));if(n){var g=CKEDITOR.tools.getNextId(),v=CKEDITOR.dom.element.createFromHtml('\x3cspan id\x3d"'+g+'" class\x3d"cke_voice_label"\x3e'+n+"\x3c/span\x3e");f.append(v,1);h.setAttribute("aria-describedby",g);}a.on("beforeModeUnload",function(a){a.removeListener();v&&v.remove();});h.setAttributes({tabIndex:a.tabIndex,allowTransparency:"true"});!k&&e();a.fire("ariaWidget",h);});}});CKEDITOR.editor.prototype.addContentsCss=function(a){var b=this.config,c=b.contentsCss;CKEDITOR.tools.isArray(c)||(b.contentsCss=c?[c]:[]);b.contentsCss.push(a);};c=CKEDITOR.tools.createClass({$:function $(){this.base.apply(this,arguments);this._.frameLoadedHandler=CKEDITOR.tools.addFunction(function(b){CKEDITOR.tools.setTimeout(a,0,this,b);},this);this._.docTitle=this.getWindow().getFrame().getAttribute("title");},base:CKEDITOR.editable,proto:{setData:function setData(a,c){var e=this.editor;if(c)this.setHtml(a),this.fixInitialSelection(),e.fire("dataReady");else{this._.isLoadingData=!0;e._.dataStore={id:1};var f=e.config,h=f.fullPage,k=f.docType,g=CKEDITOR.tools.buildStyleHtml(b()).replace(/<style>/,'\x3cstyle data-cke-temp\x3d"1"\x3e');h||(g+=CKEDITOR.tools.buildStyleHtml(e.config.contentsCss));var n=f.baseHref?'\x3cbase href\x3d"'+f.baseHref+'" data-cke-temp\x3d"1" /\x3e':"";h&&(a=a.replace(/<!DOCTYPE[^>]*>/i,function(a){e.docType=k=a;return"";}).replace(/<\?xml\s[^\?]*\?>/i,function(a){e.xmlDeclaration=a;return"";}));a=e.dataProcessor.toHtml(a);h?(/<body[\s|>]/.test(a)||(a="\x3cbody\x3e"+a),/<html[\s|>]/.test(a)||(a="\x3chtml\x3e"+a+"\x3c/html\x3e"),/<head[\s|>]/.test(a)?/<title[\s|>]/.test(a)||(a=a.replace(/<head[^>]*>/,"$\x26\x3ctitle\x3e\x3c/title\x3e")):a=a.replace(/<html[^>]*>/,"$\x26\x3chead\x3e\x3ctitle\x3e\x3c/title\x3e\x3c/head\x3e"),n&&(a=a.replace(/<head[^>]*?>/,"$\x26"+n)),a=a.replace(/<\/head\s*>/,g+"$\x26"),a=k+a):a=f.docType+'\x3chtml dir\x3d"'+f.contentsLangDirection+'" lang\x3d"'+(f.contentsLanguage||e.langCode)+'"\x3e\x3chead\x3e\x3ctitle\x3e'+this._.docTitle+"\x3c/title\x3e"+n+g+"\x3c/head\x3e\x3cbody"+(f.bodyId?' id\x3d"'+f.bodyId+'"':"")+(f.bodyClass?' class\x3d"'+f.bodyClass+'"':"")+"\x3e"+a+"\x3c/body\x3e\x3c/html\x3e";CKEDITOR.env.gecko&&(a=a.replace(/<body/,'\x3cbody contenteditable\x3d"true" '),2E4>CKEDITOR.env.version&&(a=a.replace(/<body[^>]*>/,"$\x26\x3c!-- cke-content-start --\x3e")));f='\x3cscript id\x3d"cke_actscrpt" type\x3d"text/javascript"'+(CKEDITOR.env.ie?' defer\x3d"defer" ':"")+"\x3evar wasLoaded\x3d0;function onload(){if(!wasLoaded)window.parent.CKEDITOR.tools.callFunction("+this._.frameLoadedHandler+",window);wasLoaded\x3d1;}"+(CKEDITOR.env.ie?"onload();":'document.addEventListener("DOMContentLoaded", onload, false );')+"\x3c/script\x3e";CKEDITOR.env.ie&&9>CKEDITOR.env.version&&(f+='\x3cscript id\x3d"cke_shimscrpt"\x3ewindow.parent.CKEDITOR.tools.enableHtml5Elements(document)\x3c/script\x3e');n&&CKEDITOR.env.ie&&10>CKEDITOR.env.version&&(f+='\x3cscript id\x3d"cke_basetagscrpt"\x3evar baseTag \x3d document.querySelector( "base" );baseTag.href \x3d baseTag.href;\x3c/script\x3e');a=a.replace(/(?=\s*<\/(:?head)>)/,f);this.clearCustomData();this.clearListeners();e.fire("contentDomUnload");var v=this.getDocument();try{v.write(a);}catch(r){setTimeout(function(){v.write(a);},0);}}},getData:function getData(a){if(a)return this.getHtml();a=this.editor;var b=a.config,c=b.fullPage,e=c&&a.docType,h=c&&a.xmlDeclaration,k=this.getDocument(),c=c?k.getDocumentElement().getOuterHtml():k.getBody().getHtml();CKEDITOR.env.gecko&&b.enterMode!=CKEDITOR.ENTER_BR&&(c=c.replace(/<br>(?=\s*(:?$|<\/body>))/,""));c=a.dataProcessor.toDataFormat(c);h&&(c=h+"\n"+c);e&&(c=e+"\n"+c);return c;},focus:function focus(){this._.isLoadingData?this._.isPendingFocus=!0:c.baseProto.focus.call(this);},detach:function detach(){var a=this.editor,b=a.document,e;try{e=a.window.getFrame();}catch(f){}c.baseProto.detach.call(this);this.clearCustomData();b.getDocumentElement().clearCustomData();CKEDITOR.tools.removeFunction(this._.frameLoadedHandler);e&&e.getParent()?(e.clearCustomData(),(a=e.removeCustomData("onResize"))&&a.removeListener(),e.remove()):CKEDITOR.warn("editor-destroy-iframe");}}});}(),CKEDITOR.config.disableObjectResizing=!1,CKEDITOR.config.disableNativeTableHandles=!0,CKEDITOR.config.disableNativeSpellChecker=!0,CKEDITOR.config.plugins="dialogui,dialog,a11yhelp,about,basicstyles,blockquote,clipboard,panel,floatpanel,menu,contextmenu,elementspath,indent,indentlist,list,enterkey,entities,popup,filebrowser,floatingspace,listblock,button,richcombo,format,horizontalrule,htmlwriter,image,fakeobjects,link,magicline,maximize,pastefromword,pastetext,removeformat,resize,menubutton,scayt,showborders,sourcearea,specialchar,stylescombo,tab,table,tabletools,toolbar,undo,wsc,wysiwygarea",CKEDITOR.config.skin="moono",function(){var a=function a(_a13,b){var c=CKEDITOR.getUrl("plugins/"+b);_a13=_a13.split(",");for(var d=0;d<_a13.length;d++){CKEDITOR.skin.icons[_a13[d]]={path:c,offset:-_a13[++d],bgsize:_a13[++d]};}};CKEDITOR.env.hidpi?a("about,0,,bold,24,,italic,48,,strike,72,,subscript,96,,superscript,120,,underline,144,,bidiltr,168,,bidirtl,192,,blockquote,216,,copy-rtl,240,,copy,264,,cut-rtl,288,,cut,312,,paste-rtl,336,,paste,360,,codesnippet,384,,bgcolor,408,,textcolor,432,,creatediv,456,,docprops-rtl,480,,docprops,504,,embed,528,,embedsemantic,552,,find-rtl,576,,find,600,,replace,624,,flash,648,,button,672,,checkbox,696,,form,720,,hiddenfield,744,,imagebutton,768,,radio,792,,select-rtl,816,,select,840,,textarea-rtl,864,,textarea,888,,textfield-rtl,912,,textfield,936,,horizontalrule,960,,iframe,984,,image,1008,,indent-rtl,1032,,indent,1056,,outdent-rtl,1080,,outdent,1104,,justifyblock,1128,,justifycenter,1152,,justifyleft,1176,,justifyright,1200,,language,1224,,anchor-rtl,1248,,anchor,1272,,link,1296,,unlink,1320,,bulletedlist-rtl,1344,,bulletedlist,1368,,numberedlist-rtl,1392,,numberedlist,1416,,mathjax,1440,,maximize,1464,,newpage-rtl,1488,,newpage,1512,,pagebreak-rtl,1536,,pagebreak,1560,,pastefromword-rtl,1584,,pastefromword,1608,,pastetext-rtl,1632,,pastetext,1656,,placeholder,1680,,preview-rtl,1704,,preview,1728,,print,1752,,removeformat,1776,,save,1800,,scayt,1824,,selectall,1848,,showblocks-rtl,1872,,showblocks,1896,,smiley,1920,,source-rtl,1944,,source,1968,,sourcedialog-rtl,1992,,sourcedialog,2016,,specialchar,2040,,table,2064,,templates-rtl,2088,,templates,2112,,uicolor,2136,,redo-rtl,2160,,redo,2184,,undo-rtl,2208,,undo,2232,,simplebox,4512,auto,spellchecker,2280,","icons_hidpi.png"):a("about,0,auto,bold,24,auto,italic,48,auto,strike,72,auto,subscript,96,auto,superscript,120,auto,underline,144,auto,bidiltr,168,auto,bidirtl,192,auto,blockquote,216,auto,copy-rtl,240,auto,copy,264,auto,cut-rtl,288,auto,cut,312,auto,paste-rtl,336,auto,paste,360,auto,codesnippet,384,auto,bgcolor,408,auto,textcolor,432,auto,creatediv,456,auto,docprops-rtl,480,auto,docprops,504,auto,embed,528,auto,embedsemantic,552,auto,find-rtl,576,auto,find,600,auto,replace,624,auto,flash,648,auto,button,672,auto,checkbox,696,auto,form,720,auto,hiddenfield,744,auto,imagebutton,768,auto,radio,792,auto,select-rtl,816,auto,select,840,auto,textarea-rtl,864,auto,textarea,888,auto,textfield-rtl,912,auto,textfield,936,auto,horizontalrule,960,auto,iframe,984,auto,image,1008,auto,indent-rtl,1032,auto,indent,1056,auto,outdent-rtl,1080,auto,outdent,1104,auto,justifyblock,1128,auto,justifycenter,1152,auto,justifyleft,1176,auto,justifyright,1200,auto,language,1224,auto,anchor-rtl,1248,auto,anchor,1272,auto,link,1296,auto,unlink,1320,auto,bulletedlist-rtl,1344,auto,bulletedlist,1368,auto,numberedlist-rtl,1392,auto,numberedlist,1416,auto,mathjax,1440,auto,maximize,1464,auto,newpage-rtl,1488,auto,newpage,1512,auto,pagebreak-rtl,1536,auto,pagebreak,1560,auto,pastefromword-rtl,1584,auto,pastefromword,1608,auto,pastetext-rtl,1632,auto,pastetext,1656,auto,placeholder,1680,auto,preview-rtl,1704,auto,preview,1728,auto,print,1752,auto,removeformat,1776,auto,save,1800,auto,scayt,1824,auto,selectall,1848,auto,showblocks-rtl,1872,auto,showblocks,1896,auto,smiley,1920,auto,source-rtl,1944,auto,source,1968,auto,sourcedialog-rtl,1992,auto,sourcedialog,2016,auto,specialchar,2040,auto,table,2064,auto,templates-rtl,2088,auto,templates,2112,auto,uicolor,2136,auto,redo-rtl,2160,auto,redo,2184,auto,undo-rtl,2208,auto,undo,2232,auto,simplebox,2256,auto,spellchecker,2280,auto","icons.png");}());})();

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;var require;/* WEBPACK VAR INJECTION */(function(module, global, process) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
	 For licensing, see LICENSE.html or http://cksource.com/ckfinder/license
	 */
	var CKFinder = function () {
	  function __internalInit(e) {
	    return e = e || {}, e[S('A&&)*";:+,)')] = S('"wLLUAZ\nJ\fIKB_DVFF_XVU]~uy)/&&6eu'), e[S(" IGOHJ")] = S("'`LFGC\rHJ\\]]DVDV[R_IiZ` 0&d7#&$%3k?,*o$93't,9\"x8(>|),&	C\nF\b	\x00LP\f\\P^\bå¡òöð¥êèüúªäê­ëéöþàç´áù·ûëÿúèø¾öÔ") + S("8nUNPYF/4b/-.#g<&j,)9n.p7 61u04?9/~3	\r\x00YG.\fL\nQT[\r õðâêöêæüàåå­­æûäá¨¼»ñùôë·ùðïòëíÃÄÀËÈÄÃÏÃÅÈÈÜÓÀßÓÝÞÞÊâÊÍ¡¯±¯¥±¯¨¦º"), e[S("e~Jj}~")] = !0, e;
	  }function internalCKFinderInit(e, t, n) {
	    var i = t.getElementsByTagName(S("(AOJH"))[0],
	        r = t.createElement(S("bqa}eb"));r[S(r.innerText ? "rrs{mtDZW" : "IOLFVmrjd")] = n + S("7YPZtp{ES\f|W@RRX\n\\ECJ@GW[VCZ]WN}t(,'!7h4<(8?d") + JSON.stringify(e) + S("5\f"), i.appendChild(r);
	  }function configOrDefault(e, t) {
	    return e ? e : t;
	  }function createUrlParams(e) {
	    var t = [];for (var n in e) {
	      t.push(encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
	    }return "?" + t.join("&");
	  }function extendObject(e, t) {
	    for (var n in t) {
	      t.hasOwnProperty(n) && (e[n] = t[n]);
	    }return e;
	  }function updateIOSConfig(e, t) {
	    e._iosWidgetHeight = parseInt(getComputedStyle(t).height), e._iosWidgetWidth = parseInt(getComputedStyle(t).width);
	  }function checkOnInit(e, t) {
	    if (e && !e._omitCheckOnInit && "function" == typeof e.onInit) {
	      var n = e.onInit;delete e.onInit, t.addEventListener(S('A!(",(#-;.-)7'), function (t) {
	        e._initCalled || (e._initCalled = !0, n(t.detail.ckfinder));
	      });
	    }
	  }function S(e) {
	    for (var t = "", n = e.charCodeAt(0), i = 1; i < e.length; ++i) {
	      t += String.fromCharCode(e.charCodeAt(i) ^ i + n & 255);
	    }return t;
	  }function isIE9() {
	    var e,
	        t,
	        n = -1;return navigator.appName == S("mHAQKVIA\\	cEXH\\AUEvLEZXJ\\H") && (e = navigator.userAgent, t = new RegExp(S("-c|ytoeBAfmx8ti;n")), null !== t.exec(e) && (n = parseFloat(RegExp.$1))), 9 === n;
	  }var basePath = function () {
	    if (parent && parent.CKFinder && parent.CKFinder.basePath) return parent.CKFinder.basePath;var e,
	        t,
	        n,
	        i = document.getElementsByTagName(S("cr`zda"));for (e = 0; e < i.length && (t = i[e], n = void 0 !== t.getAttribute.length ? t.src : t.getAttribute(S('"PVF')), !n || n.split("/").slice(-1)[0] !== S("ofhf~uwa:e")); e++) {}return n.split("/").slice(0, -1).join("/") + "/";
	  }(),
	      Modal = { open: function open(e) {
	      function t(e, t, n) {
	        t.forEach(function (t) {
	          e.addEventListener(t, n);
	        });
	      }function n(e, t, n) {
	        t.forEach(function (t) {
	          e.removeEventListener(t, n);
	        });
	      }function i(e) {
	        return 0 === e.type.indexOf(S("C0*3$ ")) ? { x: e.touches[0].pageX, y: e.touches[0].pageY } : { x: document.all ? window.event.clientX : e.pageX, y: document.all ? window.event.clientX : e.pageY };
	      }function r(e) {
	        var t = i(e);p = t.x, m = t.y;var n = m - E;y.style.left = p - b + S(":KD"), y.style.top = (0 > n ? 0 : n) + S("cl");
	      }function o(e) {
	        var t,
	            n,
	            r = i(e);f ? (t = u - (T - r.x), n = l - (R - r.y), t > 200 && (M.style.width = t + S("A2;")), n > 200 && (M.style.height = n + S("aj"))) : h && (t = u + (T - r.x), n = l - (R - r.y), t > 200 && (M.style.width = t + S("C4="), y.style.left = b - (T - r.x) + S("|u")), n > 200 && (M.style.height = n + S("._H")));
	      }function s() {
	        I.parentNode === M && M.removeChild(I), f = !1, h = !1, n(document, [S("&JG\\YNABXJ"), S("/D^GP\\XYA]")], o), n(document, [S("/]^G@Q@F"), S("munu{qD")], s);
	      }function a(e) {
	        e.preventDefault();var n = i(e);T = n.x, R = n.y, u = M.clientWidth, l = M.clientHeight, M.appendChild(I), t(document, [S(":VSHMZ-.4&"), S("xb{lx|}eq")], o), t(document, [S("<PQJ3$73"), S("f|av~rv}")], s);
	      }if (e = e || {}, !Modal.div) {
	        Modal.heightAdded = 48, Modal.widthAdded = 2;var u,
	            l,
	            c = Math.min(configOrDefault(e.width, 1e3), window.innerWidth - Modal.widthAdded),
	            d = Math.min(configOrDefault(e.height, 700), window.innerHeight - Modal.heightAdded),
	            f = !1,
	            h = !1,
	            g = !1,
	            p = 0,
	            m = 0,
	            v = e.width,
	            w = e.height;e.width = e.height = S("''(<");var y = Modal.div = document.createElement(S("+HDX"));y.id = S(';_VX-.&"('), y.style.position = S("jdvjt"), y.style.top = (document.documentElement.clientHeight - Modal.heightAdded) / 2 - d / 2 + S("ha"), y.style.left = (document.documentElement.clientWidth - Modal.widthAdded) / 2 - c / 2 + S("5FO"), y.style.background = S(":Z[X"), y.style.border = S("$V_\bZEGEI\fQPS"), y.style.boxShadow = S("Aq3<eu70i;4m<(20zcxezgtitiu"), y.style.borderTopLeftRadius = y.style.borderTopRightRadius = S("6HA"), y.style.zIndex = 8999, y.innerHTML = S('&L@\\EI\rSZTYZRVTR^]Y[Mba17=)#zj*?9?"<up<=%1nv57+>>.p*0LK	\rW[\bJR\nT\fP\fçéö®öäâîýú°¾üõµ¯òðñøóçùâöý »éïò·ÄÀÖÂÌËÆÏÌØÚÊ×ÝÝÑÕÆÓêÿÜè·¦¦®¼¥õ¤¿¨¡ü¤ä¦ºú°·á¹è³¤Ñ¶´¢£¾¡ÈÀÆº¶Å¤8xOGErJ4F;PrEjj=|zvTs,_}]nWXItWXHMCt@JBc@gmZd|yVV^XYRrO_\fTs|6".)!-}(6>5d5h2\x00T\f\nQ08%F-1"4\f.\'(ÒñØÔ±µÏÀäâÚØÆãíâÖúÞËÂÿÌ¥ûíÀ©ÊèÄÇêÉÆäòÎïÎêÇÉÆêÆÏøæÄÖõâÀ×ïêÃêèöÝ¸ð­õ¨§·¶·ì½µ²èÐ¯ ±¯¯º¸¥¤¼¹§½Ì¿½·¸©®ofK@EbVOF9h8Mjl=J|q!B%FDQnPHUz},rWA`ODP_IADgihYPXxNq^Y\bnK]|q7!/\'|5&hz:2a9h+="8><?9P#)#,%;;:ED9\r#IELÉ¸ËêÊíÜÀÎâÓÜÝäÇÇÞ¡ð Õáô¤ÚñÃ©ð­ûËÈïðíÓöÀÇÎãïÛÛÌèÜÄèäòÌäòÑàüÐÑÜÑêª¢¥øª«à¸²³è°ººí¤Ü¯­£¬¸·Ä»¤± »0hf[NvMDFgifJfBWF{H!waL%Nl@CVuzXvJipmBj]bzhWJBS\bVZDS]KYSIJP-{s3<e5($ .ko.w,i2kh<0?00-`hi-&A\bQIR') + S('9ZNJF,$a"))&<sj9%*&;kq"201?9?czl,%~nPCTEG\f\x00KQBYJ[]ïóöâêñ½§îæäÿ¡ëïâùýë©´Ôäþùõ¶»ïüðìÒÇÑÍÃÁÄÚÄÞÙÏÁÄÕÛÛÂÏÜÓÜÔÉÝ¯­¦øä£©©¼ä¹¢¶¨ôïâá¢«ôô¿º¨¶¨¯½³ªäÀÈÖÍÜßÒÒÆÞeyv.``ehzh~bcc4/~~|v44zhvho}sj$\x00BMOKW\f\fGB@^@GU[B\fS_]T&l/, $*j+%%8)on\'"44nvvtieu:b') + S(")9sqo$") + S("5\nSQORX\x00\\+'o.+!'+e+%/5on<$(>6iw&8+0.233d\fSTO") + c + S("6G@SYTYW4{b") + d + S(">O8c|k!/1v") + S('%CA_\nBH\fL[W^[QW[_UTHXL`26:( {e ,#,$9toaa"+tt?:(6(/=3*d@\x00\bQLN\b\\B@VK') + S("9HL\\P)%a'. j%&.* `<*#8(6y=79<5?v/*|XDWN\\\x00\fCY\r	E ¶òû¿¥îâáîâÿ¶­¹ÿèª²÷ýææûùà »þññüËÅÈÊÇÓÆÎÊÙÒÞÀ×ÑÇÛÝßÎÎÇà²­¯­¡æä¬­®ðì¯¡½´´ þ¶º¢£·´àûï­¦ÿÅÅÑÉÒÑÁÍ") + S("Ez48($k%)sm3:4~9:264t(>/4$:M	\r\x00	J\fHKLP\nCZ\bP\fóèøæ¿¥ñîìýâ±¬ºþ÷«±úöýòþã¢¹­ëä¦¾ûÉÒÒÏÅÜÊÅÅÈÇÉÜÞÓÇÄÞßÑÎßÑÍ¤¤°î¶¬¡¯¼óêø¼µî¼¿½»·ôö²³¼âú¹³¯ººÌÒÉÙÍÓ×ÃÛÄÇÓn?") + S("FJR"), document.body.appendChild(y), CKFinder.widget(S("%ELNGDHLBR^VJ"), e), Modal.footer = document.getElementById(S('"@OCJGMKGKA@DT@')), window.addEventListener(S("9UIUXPK!5+,*&.&&./"), function () {
	          Modal.maximized || setTimeout(function () {
	            c = Math.min(configOrDefault(v, 1e3), document.documentElement.clientWidth - Modal.widthAdded), d = Math.min(configOrDefault(w, 700), document.documentElement.clientHeight - Modal.heightAdded);var e = document.getElementById(S("CJDIJBFDHDHT"));e.style.width = c + S("6G@"), e.style.height = d + S("kd"), y.style.top = (document.documentElement.clientHeight - Modal.heightAdded) / 2 - d / 2 + S("E6?"), y.style.left = (document.documentElement.clientWidth - Modal.widthAdded) / 2 - c / 2 + S("#T]");
	          }, 100);
	        });var C = document.getElementById(S("\nhgk#bus9vzxk|"));t(C, [S(" BNJGN"), S("8MUN_U[Q$")], function (e) {
	          e.stopPropagation(), e.preventDefault(), Modal.close();
	        });var x = Modal.header = document.getElementById(S("\fnei=|}wuy;}x~~n")),
	            b = y.offsetLeft,
	            E = y.offsetTop;t(x, [S("bdavpzay"), S("+XB[LXBFRFA")], function (e) {
	          e.preventDefault(), g = !0;var n = i(e);p = n.x, m = n.y, b = p - y.offsetLeft, E = m - y.offsetTop, M.appendChild(I), t(document, [S("\nfcx}j}~dv"), S("kOTAKIJPB")], r);
	        }), t(x, [S("'EF_XIX^"), S("'\\F_HDH@K")], function () {
	          g = !1, I.parentNode === M && M.removeChild(I), n(document, [S(".B_DAVYZ@R"), S("?4.7 ,()1-")], r);
	        });var _ = document.getElementById(S("4V]QTU_]QM%2+9!h.&&-&.a>+")),
	            F = document.getElementById(S("(JAM@AKQ]AQF_M]RZRYRZm25")),
	            M = Modal.body = document.getElementById(S("-MDV_\\PTZZV^B")),
	            I = document.createElement(S("$AOQ"));I.style.position = S("0PP@[YCC]"), I.style.top = I.style.right = I.style.bottom = I.style.left = 0, I.style.zIndex = 1e5, t(_, [S("qrklEEMTJ"), S("&SG\\IC_YO]D")], function (e) {
	          f = !0, a(e);
	        }), t(F, [S("{xmjsjp"), S("iqjCIQWEWR")], function (e) {
	          b = y.offsetLeft, h = !0, a(e);
	        });var T, R;
	      }
	    }, close: function close() {
	      Modal.div && (document.body.removeChild(Modal.div), Modal.div = null, Modal.maximized && (document.documentElement.style.overflow = Modal.preDocumentOverflow, document.documentElement.style.width = Modal.preDocumentWidth, document.documentElement.style.height = Modal.preDocumentHeight));
	    }, maximize: function maximize(e) {
	      e ? (Modal.preDocumentOverflow = document.documentElement.style.overflow, Modal.preDocumentWidth = document.documentElement.style.width, Modal.preDocumentHeight = document.documentElement.style.height, document.documentElement.style.overflow = S("zzpqsy"), document.documentElement.style.width = 0, document.documentElement.style.height = 0, Modal.preLeft = Modal.div.style.left, Modal.preTop = Modal.div.style.top, Modal.preWidth = Modal.body.style.width, Modal.preHeight = Modal.body.style.height, Modal.preBorder = Modal.div.style.border, Modal.div.style.left = Modal.div.style.top = Modal.div.style.right = Modal.div.style.bottom = 0, Modal.body.style.width = S("$\r"), Modal.body.style.height = S("Ewwxl"), Modal.div.style.border = "", Modal.header.style.display = S("NNLF"), Modal.footer.style.display = S("zzxr"), Modal.maximized = !0) : (document.documentElement.style.overflow = Modal.preDocumentOverflow, document.documentElement.style.width = Modal.preDocumentWidth, document.documentElement.style.height = Modal.preDocumentHeight, Modal.div.style.right = Modal.div.style.bottom = "", Modal.div.style.left = Modal.preLeft, Modal.div.style.top = Modal.preTop, Modal.div.style.border = Modal.preBorder, Modal.body.style.width = Modal.preWidth, Modal.body.style.height = Modal.preHeight, Modal.header.style.display = S("'JEEHG"), Modal.footer.style.display = S("\ni`bmd"), Modal.maximized = !1);
	    } },
	      _r = /(window|S("A0&5j4"))/,
	      ckfPopupWindow;return { basePath: basePath, modal: function modal(e) {
	      return e === S("r~|gp") ? Modal.close() : e === S("-XFCXP_Q") ? !!Modal.div : e === S("pgILKYA") ? Modal.maximize(!0) : e === S("rIOKNM_C") ? Modal.maximize(!1) : void Modal.open(e);
	    }, config: function config(e) {
	      CKFinder._config = e;
	    }, widget: function widget(e, t) {
	      function n(e) {
	        return e + (/^[0-9]+$/.test(e) ? S("h") : "");
	      }if (t = t || {}, !e) throw S("Us=<vDLTQOHF	NNJD@JT[]v}qQW^^NIV$&'7llf$)%&e");var i = S("E$(:-/9v#!!5j");i += S("2D]QB_") + n(configOrDefault(t.width, S("1"))) + ";", i += S("xt{t|a,") + n(configOrDefault(t.height, S("; !"))) + ";";var r = document.createElement(S('"JBWGJM'));r.src = "", r.setAttribute(S("A17=)#"), i), r.setAttribute(S("-]JQ\\^VGF"), S(" RGBIICT[")), r.setAttribute(S("o~lpLMKMC"), S('"BQQI')), r.setAttribute(S("nz~tp{EY"), configOrDefault(t.tabindex, 0)), r.attachEvent ? r.attachEvent(S("E))$&+/"), function () {
	        internalCKFinderInit(t, r.contentDocument, S("/@P@VZA"));
	      }) : r.onload = function () {
	        /iPad|iPhone|iPod/.test(navigator.platform) && (updateIOSConfig(t, r), r.contentWindow.addEventListener(S("3W^P^V]_InX_[9"), function (e) {
	          e.detail.ckfinder.on(S("?5(x1!6/=-"), function (e) {
	            updateIOSConfig(e.finder.config, r);
	          }, null, null, 1);
	        })), internalCKFinderInit(t, r.contentDocument, S("(YKYICZ"));
	      };var o = document.getElementById(e);if (!o) throw S(')i`jD@KUCD]QQRL^QJ,%b-+1f!!\'.k)!+"5?&s#<"?x0>{~') + e + S("2");o.innerHTML = "", o.appendChild(r), checkOnInit(t, r.contentWindow);
	    }, popup: function popup(e) {
	      e = e || {}, window.CKFinder._popupOptions = e;var t = isIE9() ? window.CKFinder.basePath + S("psy||h5tiss") : S("4TTXMM\x00YP\\PT"),
	          n = S("ws~kINLJJ\nJMG_IM_A_F\\[YTVJTTY[O%/&&*1{>-:f&%#'\"9+3180k97u748<2bO	8\nM\b\x00XCåò®ðç÷éëäëëùÿ°÷êã");n += S("%\nPAM^C") + configOrDefault(e.width, 1e3), n += S("$	NBANB_") + configOrDefault(e.height, 700), n += S("-[_A"), n += S("0^VRA\b	"), "undefined" == typeof ckfPopupWindow || ckfPopupWindow.closed || ckfPopupWindow.close();var i;try {
	        var r = S("(jam|B^Z@") + Date.now();ckfPopupWindow = window.open(t, r, n, !0);
	      } catch (o) {
	        return;
	      }return setTimeout(function () {
	        ckfPopupWindow && (i = ckfPopupWindow.document, i.open(), i.write(S("*6\\VYOEM[?HUOO") + S(":TISS~") + S("=W% &}") + S("0\r_V@TTPXHHYI55$n|gx") + S("/ypbv8w{vy <iIDUSKWR\bJEEXH@[\rEZPA^\n\\\\LR_XH)%6+h,(.< +'a>-.<4obx %2*t)8=1?=\f_\rGX") + S('"PLRKMi`jD@KUC\x00qQU_~OQH3$0k1/3$,t') + S(">o)'\" {") + S('"FJB^') + S("0\rAPF\\FCJHX") + window.CKFinder.basePath + S("<^UY)/&&6k,4ji)#-?=*$lp& 3{ozgft/>,6\\") + S("Cx6%5!9>u") + S("?7(,'+2h.;\n\r%#**\"=#!%k#*,?`") + S("mrryqhNLOKDBN\\DHXDAAH") + S("=`a\b,(#-;d88,<;xq%::19 v6*>28,q#*$\n\nF6 \x00V^C") + "}" + S(" \rPGWOW\\") + S(";\x00\\P$8|") + S('*8pmww"')), i.close(), ckfPopupWindow.focus());
	      }, 100), ckfPopupWindow;
	    }, start: function start(e) {
	      if (!e) {
	        var t = window.opener,
	            n = {};e = {};var i = window.location.search.substring(1);if (i) for (var r = i.split("&"), o = 0; o < r.length; ++o) {
	          var s = r[o].split("=");n[s[0]] = s[1] || null;
	        }if (n.popup && (window.isCKFinderPopup = !0), t && n.configId && t.CKFinder && t.CKFinder._popupOptions) {
	          var a = decodeURIComponent(n.configId);e = t.CKFinder._popupOptions[a] || {}, e._omitCheckOnInit = !0;
	        }
	      }CKFinder._setup(window, document), checkOnInit(e, window), CKFinder.start(e);
	    }, setupCKEditor: function setupCKEditor(e, t, n) {
	      function i(e) {
	        if (/^(http(s)?:)?\/\/.+/i.test(e)) return e;0 !== e.indexOf("/") && (e = "/" + e);var t = window.parent ? window.parent.location : window.location,
	            n = t.protocol + S("43") + t.host;return n + e;
	      }if (!e) {
	        for (var r in CKEDITOR.instances) {
	          CKFinder.setupCKEditor(CKEDITOR.instances[r]);
	        }return void CKEDITOR.on(S("%OI[]KEOHm]UPFVP"), function (e) {
	          CKFinder.setupCKEditor(e.editor);
	        });
	      }e.config.filebrowserBrowseUrl = window.CKFinder.basePath + S('@")%-+"":g"?!!'), n = extendObject({ command: S("B1,%,9&$-)"), type: S(".iY]W@") }, n);var o = window.CKFinder.basePath + S('D&)5-f)$"#+,$> |$=&x;6459>*0O');t = extendObject(window.CKFinder._config || {}, t), Object.keys(t).length && (window.CKFinder._popupOptions || (window.CKFinder._popupOptions = {}), t._omitCheckOnInit = !0, window.CKFinder._popupOptions[e.name] = t, e.config.filebrowserBrowseUrl += S("<NP042~uc%(&/#,)s") + encodeURIComponent(e.name), t.connectorPath ? o = i(t.connectorPath) : t.connectorLanguage && (o = window.CKFinder.basePath + S("CNPFFIIFLI_C_") + t.connectorLanguage + S("@n!,*+#$<&8e") + t.connectorLanguage)), e.config.filebrowserUploadUrl = o + createUrlParams(n);
	    }, _setup: function _setup(window, document) {
	      window.CKFinder = window.CKFinder || {}, window.CKFinder.basePath = function () {
	        if (window.parent && window.parent.CKFinder && window.parent.CKFinder.basePath) return window.parent.CKFinder.basePath;for (var e, t, n = document.getElementsByTagName(S("0BQA]EB")), i = 0; i < n.length && (e = n[i], t = void 0 !== e.getAttribute.length ? e.src : e.getAttribute(S("<NL\\")), !t || t.split("/").slice(-1)[0] !== S("ofhf~uwa:e")); i++) {}return t.split("/").slice(0, -1).join("/") + "/";
	      }();var CKFinder;!function () {
	        if (!CKFinder || !CKFinder.requirejs) {
	          CKFinder ? require = CKFinder : CKFinder = {};var requirejs, require, define;!function (global) {
	            function isFunction(e) {
	              return "[object Function]" === ostring.call(e);
	            }function isArray(e) {
	              return "[object Array]" === ostring.call(e);
	            }function each(e, t) {
	              if (e) {
	                var n;for (n = 0; n < e.length && (!e[n] || !t(e[n], n, e)); n += 1) {}
	              }
	            }function eachReverse(e, t) {
	              if (e) {
	                var n;for (n = e.length - 1; n > -1 && (!e[n] || !t(e[n], n, e)); n -= 1) {}
	              }
	            }function hasProp(e, t) {
	              return hasOwn.call(e, t);
	            }function getOwn(e, t) {
	              return hasProp(e, t) && e[t];
	            }function eachProp(e, t) {
	              var n;for (n in e) {
	                if (hasProp(e, n) && t(e[n], n)) break;
	              }
	            }function mixin(e, t, n, i) {
	              return t && eachProp(t, function (t, r) {
	                (n || !hasProp(e, r)) && (!i || "object" != (typeof t === 'undefined' ? 'undefined' : _typeof(t)) || !t || isArray(t) || isFunction(t) || t instanceof RegExp ? e[r] = t : (e[r] || (e[r] = {}), mixin(e[r], t, n, i)));
	              }), e;
	            }function bind(e, t) {
	              return function () {
	                return t.apply(e, arguments);
	              };
	            }function scripts() {
	              return document.getElementsByTagName(S("\r}lbxbg"));
	            }function defaultOnError(e) {
	              throw e;
	            }function getGlobal(e) {
	              if (!e) return e;var t = global;return each(e.split("."), function (e) {
	                t = t[e];
	              }), t;
	            }function makeError(e, t, n, i) {
	              var r = new Error(t + S("18[@AF\rH^MHWM%+1m+7!h,&)8c(<=?#!}<!;;{") + e);return r.requireType = e, r.requireModules = i, n && (r.originalError = n), r;
	            }function newContext(e) {
	              function t(e) {
	                var t, n;for (t = 0; t < e.length; t++) {
	                  if (n = e[t], "." === n) e.splice(t, 1), t -= 1;else if (".." === n) {
	                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;t > 0 && (e.splice(t - 1, 2), t -= 2);
	                  }
	                }
	              }function n(e, n, i) {
	                var r,
	                    o,
	                    s,
	                    a,
	                    u,
	                    l,
	                    c,
	                    d,
	                    f,
	                    S,
	                    h,
	                    g,
	                    p = n && n.split("/"),
	                    m = E.map,
	                    v = m && m["*"];if (e && (e = e.split("/"), c = e.length - 1, E.nodeIdCompat && jsSuffixRegExp.test(e[c]) && (e[c] = e[c].replace(jsSuffixRegExp, "")), "." === e[0].charAt(0) && p && (g = p.slice(0, p.length - 1), e = g.concat(e)), t(e), e = e.join("/")), i && m && (p || v)) {
	                  s = e.split("/");e: for (a = s.length; a > 0; a -= 1) {
	                    if (l = s.slice(0, a).join("/"), p) for (u = p.length; u > 0; u -= 1) {
	                      if (o = getOwn(m, p.slice(0, u).join("/")), o && (o = getOwn(o, l))) {
	                        d = o, f = a;break e;
	                      }
	                    }!S && v && getOwn(v, l) && (S = getOwn(v, l), h = a);
	                  }!d && S && (d = S, f = h), d && (s.splice(0, f, d), e = s.join("/"));
	                }return r = getOwn(E.pkgs, e), r ? r : e;
	              }function i(e) {
	                isBrowser && each(scripts(), function (t) {
	                  return t.getAttribute(S("B'%1'j:,;>%?+\"?5'?1")) === e && t.getAttribute(S("%BF\\HYI\\[FBTQ\\ZASOL")) === C.contextName ? (t.parentNode.removeChild(t), !0) : void 0;
	                });
	              }function r(e) {
	                var t = getOwn(E.paths, e);return t && isArray(t) && t.length > 1 ? (t.shift(), C.require.undef(e), C.makeRequire(null, { skipMap: !0 })([e]), !0) : void 0;
	              }function o(e) {
	                var t,
	                    n = e ? e.indexOf("!") : -1;return n > -1 && (t = e.substring(0, n), e = e.substring(n + 1, e.length)), [t, e];
	              }function s(e, t, i, r) {
	                var s,
	                    a,
	                    u,
	                    l,
	                    c = null,
	                    d = t ? t.name : null,
	                    f = e,
	                    h = !0,
	                    g = "";return e || (h = !1, e = "_@r" + (B += 1)), l = o(e), c = l[0], e = l[1], c && (c = n(c, d, r), a = getOwn(T, c)), e && (c ? g = a && a.normalize ? a.normalize(e, function (e) {
	                  return n(e, d, r);
	                }) : -1 === e.indexOf("!") ? n(e, d, r) : e : (g = n(e, d, r), l = o(g), c = l[0], g = l[1], i = !0, s = C.nameToUrl(g))), u = !c || a || i ? "" : S('A6*+)5%(&"6(*') + (D += 1), { prefix: c, name: g, parentMap: t, unnormalized: !!u, url: s, originalName: f, isDefine: h, id: (c ? c + "!" + g : g) + u };
	              }function a(e) {
	                var t = e.id,
	                    n = getOwn(_, t);return n || (n = _[t] = new C.Module(e)), n;
	              }function u(e, t, n) {
	                var i = e.id,
	                    r = getOwn(_, i);!hasProp(T, i) || r && !r.defineEmitComplete ? (r = a(e), r.error && t === S("vfgye") ? n(r.error) : r.on(t, n)) : "defined" === t && n(T[i]);
	              }function l(e, t) {
	                var n = e.requireModules,
	                    i = !1;t ? t(e) : (each(n, function (t) {
	                  var n = getOwn(_, t);n && (n.error = e, n.events.error && (i = !0, n.emit(S(";YOLP2"), e)));
	                }), i || req.onError(e));
	              }function c() {
	                globalDefQueue.length && (each(globalDefQueue, function (e) {
	                  var t = e[0];"string" == typeof t && (C.defQueueMap[t] = !0), I.push(e);
	                }), globalDefQueue = []);
	              }function d(e) {
	                delete _[e], delete F[e];
	              }function f(e, t, n) {
	                var i = e.map.id;e.error ? e.emit(S("wafzd"), e.error) : (t[i] = !0, each(e.depMaps, function (i, r) {
	                  var o = i.id,
	                      s = getOwn(_, o);!s || e.depMatched[r] || n[o] || (getOwn(t, o) ? (e.defineDep(r, T[o]), e.check()) : f(s, t, n));
	                }), n[i] = !0);
	              }function h() {
	                var e,
	                    t,
	                    n = 1e3 * E.waitSeconds,
	                    o = n && C.startTime + n < new Date().getTime(),
	                    s = [],
	                    a = [],
	                    u = !1,
	                    c = !0;if (!w) {
	                  if (w = !0, eachProp(F, function (e) {
	                    var n = e.map,
	                        l = n.id;if (e.enabled && (n.isDefine || a.push(e), !e.error)) if (!e.inited && o) r(l) ? (t = !0, u = !0) : (s.push(l), i(l));else if (!e.inited && e.fetched && n.isDefine && (u = !0, !n.prefix)) return c = !1;
	                  }), o && s.length) return e = makeError(S("<IWR%.77"), S("'dFKO\fYGBU^GGSYETU_IQ[Lza") + s, null, s), e.contextName = C.contextName, l(e);c && each(a, function (e) {
	                    f(e, {}, {});
	                  }), o && !t || !u || !isBrowser && !isWebWorker || b || (b = setTimeout(function () {
	                    b = 0, h();
	                  }, 50)), w = !1;
	                }
	              }function g(e) {
	                hasProp(T, e[0]) || a(s(e[0], null, !0)).init(e[1], e[2]);
	              }function p(e, t, n, i) {
	                e.detachEvent && !isOpera ? i && e.detachEvent(i, t) : e.removeEventListener(n, t, !1);
	              }function m(e) {
	                var t = e.currentTarget || e.srcElement;return p(t, C.onScriptLoad, S("!NLEA"), S('\x1EpNSGB@\\USI]OHDL@HU')), p(t, C.onScriptError, S("@$01+7")), { node: t, id: t && t.getAttribute(S("usgu8drilsiypq{UMG")) };
	              }function v() {
	                var e;for (c(); I.length;) {
	                  if (e = I.shift(), null === e[0]) return l(makeError(S("=SV3,#7'-"), S("\f@g|}pfp|pr7ywuuepqjSFFBLHB\x00\x00\nFCI[CU") + e[e.length - 1]));g(e);
	                }C.defQueueMap = {};
	              }var w,
	                  y,
	                  C,
	                  x,
	                  b,
	                  E = { waitSeconds: 7, baseUrl: S("@om"), paths: {}, bundles: {}, pkgs: {}, shim: {}, config: {} },
	                  _ = {},
	                  F = {},
	                  M = {},
	                  I = [],
	                  T = {},
	                  R = {},
	                  P = {},
	                  B = 1,
	                  D = 1;return x = { require: function require(e) {
	                  return e.require ? e.require : e.require = C.makeRequire(e.map);
	                }, exports: function exports(e) {
	                  return e.usingExports = !0, e.map.isDefine ? e.exports ? T[e.map.id] = e.exports : e.exports = T[e.map.id] = {} : void 0;
	                }, module: function module(e) {
	                  return e.module ? e.module : e.module = { id: e.map.id, uri: e.map.url, config: function config() {
	                      return getOwn(E.config, e.map.id) || {};
	                    }, exports: e.exports || (e.exports = {}) };
	                } }, y = function y(e) {
	                this.events = getOwn(M, e.id) || {}, this.map = e, this.shim = getOwn(E.shim, e.id), this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, this.depCount = 0;
	              }, y.prototype = { init: function init(e, t, n, i) {
	                  i = i || {}, this.inited || (this.factory = t, n ? this.on(S(")OY^B\\"), n) : this.events.error && (n = bind(this, function (e) {
	                    this.emit(S("7]KHTN"), e);
	                  })), this.depMaps = e && e.slice(0), this.errback = n, this.inited = !0, this.ignore = i.ignore, i.enabled || this.enabled ? this.enable() : this.check());
	                }, defineDep: function defineDep(e, t) {
	                  this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, this.depExports[e] = t);
	                }, fetch: function fetch() {
	                  if (!this.fetched) {
	                    this.fetched = !0, C.startTime = new Date().getTime();var e = this.map;return this.shim ? void C.makeRequire(this.map, { enableBuildCallback: !0 })(this.shim.deps || [], bind(this, function () {
	                      return e.prefix ? this.callPlugin() : this.load();
	                    })) : e.prefix ? this.callPlugin() : this.load();
	                  }
	                }, load: function load() {
	                  var e = this.map.url;R[e] || (R[e] = !0, C.load(this.map.id, e));
	                }, check: function check() {
	                  if (this.enabled && !this.enabling) {
	                    var e,
	                        t,
	                        n = this.map.id,
	                        i = this.depExports,
	                        r = this.exports,
	                        o = this.factory;if (this.inited) {
	                      if (this.error) this.emit(S("pdewk"), this.error);else if (!this.defining) {
	                        if (this.defining = !0, this.depCount < 1 && !this.defined) {
	                          if (isFunction(o)) {
	                            if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
	                              r = C.execCb(n, o, i, r);
	                            } catch (s) {
	                              e = s;
	                            } else r = C.execCb(n, o, i, r);if (this.map.isDefine && void 0 === r && (t = this.module, t ? r = t.exports : this.usingExports && (r = this.exports)), e) return e.requireMap = this.map, e.requireModules = this.map.isDefine ? [this.map.id] : null, e.requireType = S(this.map.isDefine ? "0UWU][S" : "<O[N5(0&"), l(this.error = e);
	                          } else r = o;this.exports = r, this.map.isDefine && !this.ignore && (T[n] = r, req.onResourceLoad && req.onResourceLoad(C, this.map, this.depMaps)), d(n), this.defined = !0;
	                        }this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, this.emit("defined", this.exports), this.defineEmitComplete = !0);
	                      }
	                    } else hasProp(C.defQueueMap, n) || this.fetch();
	                  }
	                }, callPlugin: function callPlugin() {
	                  var e = this.map,
	                      t = e.id,
	                      i = s(e.prefix);this.depMaps.push(i), u(i, "defined", bind(this, function (i) {
	                    var r,
	                        o,
	                        c,
	                        f = getOwn(P, this.map.id),
	                        h = this.map.name,
	                        g = this.map.parentMap ? this.map.parentMap.name : null,
	                        p = C.makeRequire(e.parentMap, { enableBuildCallback: !0 });return this.map.unnormalized ? (i.normalize && (h = i.normalize(h, function (e) {
	                      return n(e, g, !0);
	                    }) || ""), o = s(e.prefix + "!" + h, this.map.parentMap), u(o, "defined", bind(this, function (e) {
	                      this.init([], function () {
	                        return e;
	                      }, null, { enabled: !0, ignore: !0 });
	                    })), c = getOwn(_, o.id), void (c && (this.depMaps.push(o), this.events.error && c.on(S("'M[XD^"), bind(this, function (e) {
	                      this.emit(S("ESPLV"), e);
	                    })), c.enable()))) : f ? (this.map.url = C.nameToUrl(f), void this.load()) : (r = bind(this, function (e) {
	                      this.init([], function () {
	                        return e;
	                      }, null, { enabled: !0 });
	                    }), r.error = bind(this, function (e) {
	                      this.inited = !0, this.error = e, e.requireModules = [t], eachProp(_, function (e) {
	                        0 === e.map.id.indexOf(t + S("4jCYVVHV]QWE%%")) && d(e.map.id);
	                      }), l(e);
	                    }), r.fromText = bind(this, function (n, i) {
	                      var o = e.name,
	                          u = s(o),
	                          c = useInteractive;i && (n = i), c && (useInteractive = !1), a(u), hasProp(E.config, t) && (E.config[o] = E.config[t]);try {
	                        req.exec(n);
	                      } catch (d) {
	                        return l(makeError(S("htqi{gTDTBH"), S(",K\\@]eWK@SAYU]SO") + t + S(")\nMMDBJT") + d, d, [t]));
	                      }c && (useInteractive = !0), this.depMaps.push(u), C.completeLoad(o), p([o], r);
	                    }), void i.load(e.name, p, r, E));
	                  })), C.enable(i, this), this.pluginMaps[i.id] = i;
	                }, enable: function enable() {
	                  F[this.map.id] = this, this.enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function (e, t) {
	                    var n, i, r;if ("string" == typeof e) {
	                      if (e = s(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), this.depMaps[t] = e, r = getOwn(x, e.id)) return void (this.depExports[t] = r(this));this.depCount += 1, u(e, "defined", bind(this, function (e) {
	                        this.undefed || (this.defineDep(t, e), this.check());
	                      })), this.errback ? u(e, S("$@TUG["), bind(this, this.errback)) : this.events.error && u(e, S("pdewk"), bind(this, function (e) {
	                        this.emit(S("zRSMQ"), e);
	                      }));
	                    }n = e.id, i = _[n], hasProp(x, n) || !i || i.enabled || C.enable(e, this);
	                  })), eachProp(this.pluginMaps, bind(this, function (e) {
	                    var t = getOwn(_, e.id);t && !t.enabled && C.enable(e, this);
	                  })), this.enabling = !1, this.check();
	                }, on: function on(e, t) {
	                  var n = this.events[e];n || (n = this.events[e] = []), n.push(t);
	                }, emit: function emit(e, t) {
	                  each(this.events[e], function (e) {
	                    e(t);
	                  }), e === S("ESPLV") && delete this.events[e];
	                } }, C = { config: E, contextName: e, registry: _, defined: T, urlFetched: R, defQueue: I, defQueueMap: {}, Module: y, makeModuleMap: s, nextTick: req.nextTick, onError: l, configure: function configure(e) {
	                  e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/");var t = E.shim,
	                      n = { paths: !0, bundles: !0, config: !0, map: !0 };eachProp(e, function (e, t) {
	                    n[t] ? (E[t] || (E[t] = {}), mixin(E[t], e, !0, !0)) : E[t] = e;
	                  }), e.bundles && eachProp(e.bundles, function (e, t) {
	                    each(e, function (e) {
	                      e !== t && (P[e] = t);
	                    });
	                  }), e.shim && (eachProp(e.shim, function (e, n) {
	                    isArray(e) && (e = { deps: e }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = C.makeShimExports(e)), t[n] = e;
	                  }), E.shim = t), e.packages && each(e.packages, function (e) {
	                    var t, n;e = "string" == typeof e ? { name: e } : e, n = e.name, t = e.location, t && (E.paths[n] = e.location), E.pkgs[n] = e.name + "/" + (e.main || S("9WZUS")).replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
	                  }), eachProp(_, function (e, t) {
	                    e.inited || e.map.unnormalized || (e.map = s(t, null, !0));
	                  }), (e.deps || e.callback) && C.require(e.deps || [], e.callback);
	                }, makeShimExports: function makeShimExports(e) {
	                  function t() {
	                    var t;return e.init && (t = e.init.apply(global, arguments)), t || e.exports && getGlobal(e.exports);
	                  }return t;
	                }, makeRequire: function makeRequire(t, r) {
	                  function o(n, i, u) {
	                    var c, d, f;return r.enableBuildCallback && i && isFunction(i) && (i.__requireJsBuild = !0), "string" == typeof n ? isFunction(i) ? l(makeError(S("'ZL[^E_KNBVA"), S("\nBb{ocyu2aqdc~j|:x}qr")), u) : t && hasProp(x, n) ? x[n](_[t.id]) : req.get ? req.get(C, n, t, o) : (d = s(n, t, !1, !0), c = d.id, hasProp(T, c) ? T[c] : l(makeError(S("!LLPIIFLLN"), S("6zW]OWYP^-$ba") + c + S("?>wARMKQEMLD@BOKUUJQAQWKXSSJZ85xc") + e + (t ? "" : S("&	\b|YN\f_K^EX@Vnk"))))) : (v(), C.nextTick(function () {
	                      v(), f = a(s(null, t)), f.skipMap = r.skipMap, f.init(n, i, u, { enabled: !0 }), h();
	                    }), o);
	                  }return r = r || {}, mixin(o, { isBrowser: isBrowser, toUrl: function toUrl(e) {
	                      var i,
	                          r = e.lastIndexOf("."),
	                          o = e.split("/")[0],
	                          s = "." === o || ".." === o;return -1 !== r && (!s || r > 1) && (i = e.substring(r, e.length), e = e.substring(0, r)), C.nameToUrl(n(e, t && t.id, !0), i, !0);
	                    }, defined: function defined(e) {
	                      return hasProp(T, s(e, t, !1, !0).id);
	                    }, specified: function specified(e) {
	                      return e = s(e, t, !1, !0).id, hasProp(T, e) || hasProp(_, e);
	                    } }), t || (o.undef = function (e) {
	                    c();var n = s(e, t, !0),
	                        r = getOwn(_, e);r.undefed = !0, i(e), delete T[e], delete R[n.url], delete M[e], eachReverse(I, function (t, n) {
	                      t[0] === e && I.splice(n, 1);
	                    }), delete C.defQueueMap[e], r && (r.events.defined && (M[e] = r.events), d(e));
	                  }), o;
	                }, enable: function enable(e) {
	                  var t = getOwn(_, e.id);t && a(e).enable();
	                }, completeLoad: function completeLoad(e) {
	                  var t,
	                      n,
	                      i,
	                      o = getOwn(E.shim, e) || {},
	                      s = o.exports;for (c(); I.length;) {
	                    if (n = I.shift(), null === n[0]) {
	                      if (n[0] = e, t) break;t = !0;
	                    } else n[0] === e && (t = !0);g(n);
	                  }if (C.defQueueMap = {}, i = getOwn(_, e), !t && !hasProp(T, e) && i && !i.inited) {
	                    if (!(!E.enforceDefine || s && getGlobal(s))) return r(e) ? void 0 : l(makeError(S("}wqsy}"), S("(gEHHHF^TPUYZ^VH") + e, null, [e]));g([e, o.deps || [], o.exportsFn]);
	                  }h();
	                }, nameToUrl: function nameToUrl(e, t, n) {
	                  var i,
	                      r,
	                      o,
	                      s,
	                      a,
	                      u,
	                      l,
	                      c = getOwn(E.pkgs, e);if (c && (e = c), l = getOwn(P, e)) return C.nameToUrl(l, t, n);if (req.jsExtRegExp.test(e)) a = e + (t || "");else {
	                    for (i = E.paths, r = e.split("/"), o = r.length; o > 0; o -= 1) {
	                      if (s = r.slice(0, o).join("/"), u = getOwn(i, s)) {
	                        isArray(u) && (u = u[0]), r.splice(0, o, u);break;
	                      }
	                    }a = r.join("/"), a += t || (/^data\:|\?/.test(a) || n ? "" : ".js"), a = ("/" === a.charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : E.baseUrl) + a;
	                  }return E.urlArgs ? a + ((-1 === a.indexOf("?") ? "?" : "&") + E.urlArgs) : a;
	                }, load: function load(e, t) {
	                  req.load(C, e, t);
	                }, execCb: function execCb(e, t, n, i) {
	                  return t.apply(i, n);
	                }, onScriptLoad: function onScriptLoad(e) {
	                  if (e.type === S("/\\^SW") || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
	                    interactiveScript = null;var t = m(e);C.completeLoad(t.id);
	                  }
	                }, onScriptError: function onScriptError(e) {
	                  var t = m(e);return r(t.id) ? void 0 : l(makeError(S("%UDZ@Z_I_\\@B"), S("M|RHRW@TUG[\nMC_") + t.id, e, [t.id]));
	                } }, C.require = C.makeRequire(), C;
	            }function getInteractiveScript() {
	              return interactiveScript && interactiveScript.readyState === S("(@D_I_OLDXDV") ? interactiveScript : (eachReverse(scripts(), function (e) {
	                return e.readyState === S("qwn~n|}kIWG") ? interactiveScript = e : void 0;
	              }), interactiveScript);
	            }var req,
	                s,
	                head,
	                baseElement,
	                dataMain,
	                src,
	                interactiveScript,
	                currentlyAddingScript,
	                mainScript,
	                subPath,
	                version = S("&"),
	                commentRegExp = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/gm,
	                cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
	                jsSuffixRegExp = /\.js$/,
	                currDirRegExp = /^\.\//,
	                op = Object.prototype,
	                ostring = op.toString,
	                hasOwn = op.hasOwnProperty,
	                ap = Array.prototype,
	                isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document),
	                isWebWorker = !isBrowser && "undefined" != typeof importScripts,
	                readyRegExp = isBrowser && navigator.platform === S("+|aovcesg}zx") ? /^complete$/ : /^(complete|loaded)$/,
	                defContextName = "_",
	                isOpera = "undefined" != typeof opera && opera.toString() === S("Mxzsxh=QoESC~"),
	                contexts = {},
	                cfg = {},
	                globalDefQueue = [],
	                useInteractive = !1;if ("undefined" == typeof define) {
	              if ("undefined" != typeof requirejs) {
	                if (isFunction(requirejs)) return;cfg = requirejs, requirejs = void 0;
	              }"undefined" == typeof require || isFunction(require) || (cfg = require, require = void 0), req = requirejs = function requirejs(e, t, n, i) {
	                var r,
	                    o,
	                    s = defContextName;return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, t = n, n = i) : e = []), o && o.context && (s = o.context), r = getOwn(contexts, s), r || (r = contexts[s] = req.s.newContext(s)), o && r.configure(o), r.require(e, t, n);
	              }, req.config = function (e) {
	                return req(e);
	              }, req.nextTick = "undefined" != typeof setTimeout ? function (e) {
	                setTimeout(e, 4);
	              } : function (e) {
	                e();
	              }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, req.isBrowser = isBrowser, s = req.s = { contexts: contexts, newContext: newContext }, req({}), each([S("6CWlHW"), S(">J.%'%"), "defined", S("ffr{p|ryy")], function (e) {
	                req[e] = function () {
	                  var t = contexts[defContextName];return t.require[e].apply(t, arguments);
	                };
	              }), isBrowser && (head = s.head = document.getElementsByTagName(S("3\\PWS"))[0], baseElement = document.getElementsByTagName(S(":Y]N["))[0], baseElement && (head = s.head = baseElement.parentNode)), req.onError = defaultOnError, req.createNode = function (e, t, n) {
	                var i = e.xhtml ? document.createElementNS(S('B+016}gf=<;c9|~> 4{donav"3(02'), S("<UJR,{1 6,63")) : document.createElement(S(",^M]YAF"));return i.type = e.scriptType || S("1FVLA]YO[H_OWO4"), i.charset = S("f`s;/"), i.async = !0, i;
	              }, req.load = function (e, t, n) {
	                var i,
	                    r = e && e.config || {};if (isBrowser) return i = req.createNode(r, t, n), r.onNodeCreated && r.onNodeCreated(i, r, t, n), i.setAttribute(S('?$ 6"i7#6= 8./" ;5)&'), e.contextName), i.setAttribute(S("}i2RDSVMWCJGM_GI"), t), !i.attachEvent || i.attachEvent.toString && i.attachEvent.toString().indexOf(S("<fP^4(4&d&)#-")) < 0 || isOpera ? (i.addEventListener(S("3XZWS"), e.onScriptLoad, !1), i.addEventListener(S("yolpR"), e.onScriptError, !1)) : (useInteractive = !0, i.attachEvent(S("vtiy|zfSUCWAFNFFNO"), e.onScriptLoad)), i.src = n, currentlyAddingScript = i, baseElement ? head.insertBefore(i, baseElement) : head.appendChild(i), currentlyAddingScript = null, i;if (isWebWorker) try {
	                  importScripts(n), e.completeLoad(t);
	                } catch (o) {
	                  e.onError(makeError(S("(@G[C_Z\\SC[C@F"), S("pwksojLCSKSPVAI@FNH\rH@B") + t + S("Cd$2g") + n, o, [t]));
	                }
	              }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function (e) {
	                return head || (head = e.parentNode), dataMain = e.getAttribute(S(" ECWE\bKFAG")), dataMain ? (mainScript = dataMain, cfg.baseUrl || (src = mainScript.split("/"), mainScript = src.pop(), subPath = src.length ? src.join("/") + "/" : S("!\f\f"), cfg.baseUrl = subPath), mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [mainScript], !0) : void 0;
	              }), define = function define(e, t, n) {
	                var i, r;"string" != typeof e && (n = t, t = e, e = null), isArray(t) || (n = t, t = null), !t && isFunction(n) && (t = [], n.length && (n.toString().replace(commentRegExp, "").replace(cjsRequireRegExp, function (e, n) {
	                  t.push(n);
	                }), t = (1 === n.length ? [S("kjitlz")] : [S("\r|jad{aq"), S("$@^WG[^X"), S("5[X\\LV^")]).concat(t))), useInteractive && (i = currentlyAddingScript || getInteractiveScript(), i && (e || (e = i.getAttribute(S("B'%1'j:,;>%?+\"?5'?1"))), r = contexts[i.getAttribute(S("7\\XNZO[N5(0&'*(3-1>"))])), r ? (r.defQueue.push([e, t, n]), r.defQueueMap[e] = !0) : globalDefQueue.push([e, t, n]);
	              }, define.amd = { jQuery: !0 }, req.exec = function (text) {
	                return eval(text);
	              }, req(cfg);
	            }
	          }(this), CKFinder.requirejs = requirejs, CKFinder.require = require, CKFinder.define = define;
	        }
	      }(), CKFinder.define(S("A0&50/5-#)"), function () {}), function () {
	        function e(e, t, n) {
	          for (var i = (n || 0) - 1, r = e ? e.length : 0; ++i < r;) {
	            if (e[i] === t) return i;
	          }return -1;
	        }function t(t, n) {
	          var i = typeof n === 'undefined' ? 'undefined' : _typeof(n);if (t = t.cache, "boolean" == i || null == n) return t[n] ? 0 : -1;"number" != i && "string" != i && (i = "object");var r = "number" == i ? n : v + n;return t = (t = t[i]) && t[r], "object" == i ? t && e(t, n) > -1 ? 0 : -1 : t ? 0 : -1;
	        }function n(e) {
	          var t = this.cache,
	              n = typeof e === 'undefined' ? 'undefined' : _typeof(e);if ("boolean" == n || null == e) t[e] = !0;else {
	            "number" != n && "string" != n && (n = "object");var i = "number" == n ? e : v + e,
	                r = t[n] || (t[n] = {});"object" == n ? (r[i] || (r[i] = [])).push(e) : r[i] = !0;
	          }
	        }function i(e) {
	          return e.charCodeAt(0);
	        }function r(e, t) {
	          for (var n = e.criteria, i = t.criteria, r = -1, o = n.length; ++r < o;) {
	            var s = n[r],
	                a = i[r];if (s !== a) {
	              if (s > a || "undefined" == typeof s) return 1;if (a > s || "undefined" == typeof a) return -1;
	            }
	          }return e.index - t.index;
	        }function o(e) {
	          var t = -1,
	              i = e.length,
	              r = e[0],
	              o = e[i / 2 | 0],
	              s = e[i - 1];if (r && "object" == (typeof r === 'undefined' ? 'undefined' : _typeof(r)) && o && "object" == (typeof o === 'undefined' ? 'undefined' : _typeof(o)) && s && "object" == (typeof s === 'undefined' ? 'undefined' : _typeof(s))) return !1;var a = u();a[S("\rhn|bw")] = a[S("bxbc")] = a[S(";HOKZ")] = a.undefined = !1;var l = u();for (l.array = e, l.cache = a, l.push = n; ++t < i;) {
	            l.push(e[t]);
	          }return l;
	        }function s(e) {
	          return "\\" + J[e];
	        }function a() {
	          return g.pop() || [];
	        }function u() {
	          return p.pop() || { array: null, cache: null, criteria: null, "false": !1, index: 0, "null": !1, number: null, object: null, push: null, string: null, "true": !1, undefined: !1, value: null };
	        }function l(e) {
	          e.length = 0, g.length < y && g.push(e);
	        }function c(e) {
	          var t = e.cache;t && c(t), e.array = e.cache = e.criteria = e.object = e.number = e.string = e.value = null, p.length < y && p.push(e);
	        }function d(e, t, n) {
	          t || (t = 0), "undefined" == typeof n && (n = e ? e.length : 0);for (var i = -1, r = n - t || 0, o = Array(0 > r ? 0 : r); ++i < r;) {
	            o[i] = e[t + i];
	          }return o;
	        }function f(n) {
	          function g(e) {
	            return e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && !jn(e) && An.call(e, S("(vu\\^L^_UUml")) ? e : new p(e);
	          }function p(e, t) {
	            this.__chain__ = !!t, this.__wrapped__ = e;
	          }function y(e) {
	            function t() {
	              if (i) {
	                var e = d(i);Kn.apply(e, arguments);
	              }if (this instanceof t) {
	                var o = Q(n.prototype),
	                    s = n.apply(o, e || arguments);return Pe(s) ? s : o;
	              }return n.apply(r, e || arguments);
	            }var n = e[0],
	                i = e[2],
	                r = e[4];return Gn(t, e), t;
	          }function J(e, t, n, i, r) {
	            if (n) {
	              var o = n(e);if ("undefined" != typeof o) return o;
	            }var s = Pe(e);if (!s) return e;var u = In.call(e);if (!L[u]) return e;var c = Qn[u];switch (u) {case V:case N:
	                return new c(+e);case U:case $:
	                return new c(e);case W:
	                return o = c(e.source, F.exec(e)), o.lastIndex = e.lastIndex, o;}var f = jn(e);if (t) {
	              var h = !i;i || (i = a()), r || (r = a());for (var g = i.length; g--;) {
	                if (i[g] == e) return r[g];
	              }o = f ? c(e.length) : {};
	            } else o = f ? d(e) : si({}, e);return f && (An.call(e, S("#MKBBP")) && (o.index = e.index), An.call(e, S("7QWJNH")) && (o.input = e.input)), t ? (i.push(e), r.push(o), (f ? Xe : li)(e, function (e, s) {
	              o[s] = J(e, t, n, i, r);
	            }), h && (l(i), l(r)), o) : o;
	          }function Q(e, t) {
	            return Pe(e) ? qn(e) : {};
	          }function X(e, t, n) {
	            if ("function" != typeof e) return Gt;if ("undefined" == typeof t || !(S("'X[E_CYW_U") in e)) return e;var i = e.__bindData__;if ("undefined" == typeof i && (Xn.funcNames && (i = !e.name), i = i || !Xn.funcDecomp, !i)) {
	              var r = Dn.call(e);Xn.funcNames || (i = !M.test(r)), i || (i = P.test(r), Gn(e, i));
	            }if (i === !1 || i !== !0 && 1 & i[1]) return e;switch (n) {case 1:
	                return function (n) {
	                  return e.call(t, n);
	                };case 2:
	                return function (n, i) {
	                  return e.call(t, n, i);
	                };case 3:
	                return function (n, i, r) {
	                  return e.call(t, n, i, r);
	                };case 4:
	                return function (n, i, r, o) {
	                  return e.call(t, n, i, r, o);
	                };}return At(e, t);
	          }function G(e) {
	            function t() {
	              var e = u ? s : this;if (r) {
	                var h = d(r);Kn.apply(h, arguments);
	              }if ((o || c) && (h || (h = d(arguments)), o && Kn.apply(h, o), c && h.length < a)) return i |= 16, G([n, f ? i : -4 & i, h, null, s, a]);if (h || (h = arguments), l && (n = e[S]), this instanceof t) {
	                e = Q(n.prototype);var g = n.apply(e, h);return Pe(g) ? g : e;
	              }return n.apply(e, h);
	            }var n = e[0],
	                i = e[1],
	                r = e[2],
	                o = e[3],
	                s = e[4],
	                a = e[5],
	                u = 1 & i,
	                l = 2 & i,
	                c = 4 & i,
	                f = 8 & i,
	                S = n;return Gn(t, e), t;
	          }function j(n, i) {
	            var r = -1,
	                s = le(),
	                a = n ? n.length : 0,
	                u = a >= w && s === e,
	                l = [];if (u) {
	              var d = o(i);d ? (s = t, i = d) : u = !1;
	            }for (; ++r < a;) {
	              var f = n[r];s(i, f) < 0 && l.push(f);
	            }return u && c(i), l;
	          }function te(e, t, n, i) {
	            for (var r = (i || 0) - 1, o = e ? e.length : 0, s = []; ++r < o;) {
	              var a = e[r];if (a && "object" == (typeof a === 'undefined' ? 'undefined' : _typeof(a)) && "number" == typeof a.length && (jn(a) || Se(a))) {
	                t || (a = te(a, t, n));var u = -1,
	                    l = a.length,
	                    c = s.length;for (s.length += l; ++u < l;) {
	                  s[c++] = a[u];
	                }
	              } else n || s.push(a);
	            }return s;
	          }function ne(e, t, n, i, r, o) {
	            if (n) {
	              var s = n(e, t);if ("undefined" != typeof s) return !!s;
	            }if (e === t) return 0 !== e || 1 / e == 1 / t;var u = typeof e === 'undefined' ? 'undefined' : _typeof(e),
	                c = typeof t === 'undefined' ? 'undefined' : _typeof(t);if (!(e !== e || e && Z[u] || t && Z[c])) return !1;if (null == e || null == t) return e === t;var d = In.call(e),
	                f = In.call(t);if (d == A && (d = q), f == A && (f = q), d != f) return !1;switch (d) {case V:case N:
	                return +e == +t;case U:
	                return e != +e ? t != +t : 0 == e ? 1 / e == 1 / t : e == +t;case W:case $:
	                return e == bn(t);}var h = d == K;if (!h) {
	              var g = An.call(e, S("SRy}qabvpJI")),
	                  p = An.call(t, S("FEln|noEE}|"));if (g || p) return ne(g ? e.__wrapped__ : e, p ? t.__wrapped__ : t, n, i, r, o);if (d != q) return !1;var m = e.constructor,
	                  v = t.constructor;if (m != v && !(Re(m) && m instanceof m && Re(v) && v instanceof v) && S("vyykmhniqm") in e && S("0R]]GADB[MUI") in t) return !1;
	            }var w = !r;r || (r = a()), o || (o = a());for (var y = r.length; y--;) {
	              if (r[y] == e) return o[y] == t;
	            }var C = 0;if (s = !0, r.push(e), o.push(t), h) {
	              if (y = e.length, C = t.length, s = C == y, s || i) for (; C--;) {
	                var x = y,
	                    b = t[C];if (i) for (; x-- && !(s = ne(e[x], b, n, i, r, o));) {} else if (!(s = ne(e[C], b, n, i, r, o))) break;
	              }
	            } else ui(t, function (t, a, u) {
	              return An.call(u, a) ? (C++, s = An.call(e, a) && ne(e[a], t, n, i, r, o)) : void 0;
	            }), s && !i && ui(e, function (e, t, n) {
	              return An.call(n, t) ? s = --C > -1 : void 0;
	            });return r.pop(), o.pop(), w && (l(r), l(o)), s;
	          }function ie(e, t, n, i, r) {
	            (jn(t) ? Xe : li)(t, function (t, o) {
	              var s,
	                  a,
	                  u = t,
	                  l = e[o];if (t && ((a = jn(t)) || ci(t))) {
	                for (var c = i.length; c--;) {
	                  if (s = i[c] == t) {
	                    l = r[c];break;
	                  }
	                }if (!s) {
	                  var d;n && (u = n(l, t), (d = "undefined" != typeof u) && (l = u)), d || (l = a ? jn(l) ? l : [] : ci(l) ? l : {}), i.push(t), r.push(l), d || ie(l, t, n, i, r);
	                }
	              } else n && (u = n(l, t), "undefined" == typeof u && (u = t)), "undefined" != typeof u && (l = u);e[o] = l;
	            });
	          }function re(e, t) {
	            return e + Bn(zn() * (t - e + 1));
	          }function oe(n, i, r) {
	            var s = -1,
	                u = le(),
	                d = n ? n.length : 0,
	                f = [],
	                S = !i && d >= w && u === e,
	                h = r || S ? a() : f;if (S) {
	              var g = o(h);u = t, h = g;
	            }for (; ++s < d;) {
	              var p = n[s],
	                  m = r ? r(p, s, n) : p;(i ? !s || h[h.length - 1] !== m : u(h, m) < 0) && ((r || S) && h.push(m), f.push(p));
	            }return S ? (l(h.array), c(h)) : r && l(h), f;
	          }function se(e) {
	            return function (t, n, i) {
	              var r = {};n = g.createCallback(n, i, 3);var o = -1,
	                  s = t ? t.length : 0;if ("number" == typeof s) for (; ++o < s;) {
	                var a = t[o];e(r, a, n(a, o, t), t);
	              } else li(t, function (t, i, o) {
	                e(r, t, n(t, i, o), o);
	              });return r;
	            };
	          }function ae(e, t, n, i, r, o) {
	            var s = 1 & t,
	                a = 2 & t,
	                u = 4 & t,
	                l = 16 & t,
	                c = 32 & t;if (!a && !Re(e)) throw new En();l && !n.length && (t &= -17, l = n = !1), c && !i.length && (t &= -33, c = i = !1);var f = e && e.__bindData__;if (f && f !== !0) return f = d(f), f[2] && (f[2] = d(f[2])), f[3] && (f[3] = d(f[3])), !s || 1 & f[1] || (f[4] = r), !s && 1 & f[1] && (t |= 8), !u || 4 & f[1] || (f[5] = o), l && Kn.apply(f[2] || (f[2] = []), n), c && Hn.apply(f[3] || (f[3] = []), i), f[1] |= t, ae.apply(null, f);var S = 1 == t || 17 === t ? y : G;return S([e, t, n, i, r, o]);
	          }function ue(e) {
	            return ni[e];
	          }function le() {
	            var t = (t = g.indexOf) === vt ? e : t;return t;
	          }function ce(e) {
	            return "function" == typeof e && Tn.test(e);
	          }function de(e) {
	            var t, n;return e && In.call(e) == q && (t = e.constructor, !Re(t) || t instanceof t) ? (ui(e, function (e, t) {
	              n = t;
	            }), "undefined" == typeof n || An.call(e, n)) : !1;
	          }function fe(e) {
	            return ii[e];
	          }function Se(e) {
	            return e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && "number" == typeof e.length && In.call(e) == A || !1;
	          }function he(e, t, n, i) {
	            return "boolean" != typeof t && null != t && (i = n, n = t, t = !1), J(e, t, "function" == typeof n && X(n, i, 1));
	          }function ge(e, t, n) {
	            return J(e, !0, "function" == typeof t && X(t, n, 1));
	          }function pe(e, t) {
	            var n = Q(e);return t ? si(n, t) : n;
	          }function me(e, t, n) {
	            var i;return t = g.createCallback(t, n, 3), li(e, function (e, n, r) {
	              return t(e, n, r) ? (i = n, !1) : void 0;
	            }), i;
	          }function ve(e, t, n) {
	            var i;return t = g.createCallback(t, n, 3), ye(e, function (e, n, r) {
	              return t(e, n, r) ? (i = n, !1) : void 0;
	            }), i;
	          }function we(e, t, n) {
	            var i = [];ui(e, function (e, t) {
	              i.push(t, e);
	            });var r = i.length;for (t = X(t, n, 3); r-- && t(i[r--], i[r], e) !== !1;) {}return e;
	          }function ye(e, t, n) {
	            var i = ti(e),
	                r = i.length;for (t = X(t, n, 3); r--;) {
	              var o = i[r];if (t(e[o], o, e) === !1) break;
	            }return e;
	          }function Ce(e) {
	            var t = [];return ui(e, function (e, n) {
	              Re(e) && t.push(n);
	            }), t.sort();
	          }function xe(e, t) {
	            return e ? An.call(e, t) : !1;
	          }function be(e) {
	            for (var t = -1, n = ti(e), i = n.length, r = {}; ++t < i;) {
	              var o = n[t];r[e[o]] = o;
	            }return r;
	          }function Ee(e) {
	            return e === !0 || e === !1 || e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && In.call(e) == V || !1;
	          }function _e(e) {
	            return e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && In.call(e) == N || !1;
	          }function Fe(e) {
	            return e && 1 === e.nodeType || !1;
	          }function Me(e) {
	            var t = !0;if (!e) return t;var n = In.call(e),
	                i = e.length;return n == K || n == $ || n == A || n == q && "number" == typeof i && Re(e.splice) ? !i : (li(e, function () {
	              return t = !1;
	            }), t);
	          }function Ie(e, t, n, i) {
	            return ne(e, t, "function" == typeof n && X(n, i, 2));
	          }function Te(e) {
	            return $n(e) && !Ln(parseFloat(e));
	          }function Re(e) {
	            return "function" == typeof e;
	          }function Pe(e) {
	            return !(!e || !Z[typeof e === 'undefined' ? 'undefined' : _typeof(e)]);
	          }function Be(e) {
	            return Oe(e) && e != +e;
	          }function De(e) {
	            return null === e;
	          }function Oe(e) {
	            return "number" == typeof e || e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && In.call(e) == U || !1;
	          }function Ae(e) {
	            return e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && In.call(e) == W || !1;
	          }function Ke(e) {
	            return "string" == typeof e || e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && In.call(e) == $ || !1;
	          }function Ve(e) {
	            return "undefined" == typeof e;
	          }function Ne(e, t, n) {
	            var i = {};return t = g.createCallback(t, n, 3), li(e, function (e, n, r) {
	              i[n] = t(e, n, r);
	            }), i;
	          }function He(e) {
	            var t = arguments,
	                n = 2;if (!Pe(e)) return e;if ("number" != typeof t[2] && (n = t.length), n > 3 && "function" == typeof t[n - 2]) var i = X(t[--n - 1], t[n--], 2);else n > 2 && "function" == typeof t[n - 1] && (i = t[--n]);for (var r = d(arguments, 1, n), o = -1, s = a(), u = a(); ++o < n;) {
	              ie(e, r[o], i, s, u);
	            }return l(s), l(u), e;
	          }function Ue(e, t, n) {
	            var i = {};if ("function" != typeof t) {
	              var r = [];ui(e, function (e, t) {
	                r.push(t);
	              }), r = j(r, te(arguments, !0, !1, 1));for (var o = -1, s = r.length; ++o < s;) {
	                var a = r[o];i[a] = e[a];
	              }
	            } else t = g.createCallback(t, n, 3), ui(e, function (e, n, r) {
	              t(e, n, r) || (i[n] = e);
	            });return i;
	          }function qe(e) {
	            for (var t = -1, n = ti(e), i = n.length, r = gn(i); ++t < i;) {
	              var o = n[t];r[t] = [o, e[o]];
	            }return r;
	          }function We(e, t, n) {
	            var i = {};if ("function" != typeof t) for (var r = -1, o = te(arguments, !0, !1, 1), s = Pe(e) ? o.length : 0; ++r < s;) {
	              var a = o[r];a in e && (i[a] = e[a]);
	            } else t = g.createCallback(t, n, 3), ui(e, function (e, n, r) {
	              t(e, n, r) && (i[n] = e);
	            });return i;
	          }function $e(e, t, n, i) {
	            var r = jn(e);if (null == n) if (r) n = [];else {
	              var o = e && e.constructor,
	                  s = o && o.prototype;n = Q(s);
	            }return t && (t = g.createCallback(t, i, 4), (r ? Xe : li)(e, function (e, i, r) {
	              return t(n, e, i, r);
	            })), n;
	          }function Le(e) {
	            for (var t = -1, n = ti(e), i = n.length, r = gn(i); ++t < i;) {
	              r[t] = e[n[t]];
	            }return r;
	          }function Ye(e) {
	            for (var t = arguments, n = -1, i = te(t, !0, !1, 1), r = t[2] && t[2][t[1]] === e ? 1 : i.length, o = gn(r); ++n < r;) {
	              o[n] = e[i[n]];
	            }return o;
	          }function ke(e, t, n) {
	            var i = -1,
	                r = le(),
	                o = e ? e.length : 0,
	                s = !1;return n = (0 > n ? kn(0, o + n) : n) || 0, jn(e) ? s = r(e, t, n) > -1 : "number" == typeof o ? s = (Ke(e) ? e.indexOf(t, n) : r(e, t, n)) > -1 : li(e, function (e) {
	              return ++i >= n ? !(s = e === t) : void 0;
	            }), s;
	          }function Ze(e, t, n) {
	            var i = !0;t = g.createCallback(t, n, 3);var r = -1,
	                o = e ? e.length : 0;if ("number" == typeof o) for (; ++r < o && (i = !!t(e[r], r, e));) {} else li(e, function (e, n, r) {
	              return i = !!t(e, n, r);
	            });return i;
	          }function Je(e, t, n) {
	            var i = [];t = g.createCallback(t, n, 3);var r = -1,
	                o = e ? e.length : 0;if ("number" == typeof o) for (; ++r < o;) {
	              var s = e[r];t(s, r, e) && i.push(s);
	            } else li(e, function (e, n, r) {
	              t(e, n, r) && i.push(e);
	            });return i;
	          }function ze(e, t, n) {
	            t = g.createCallback(t, n, 3);var i = -1,
	                r = e ? e.length : 0;if ("number" != typeof r) {
	              var o;return li(e, function (e, n, i) {
	                return t(e, n, i) ? (o = e, !1) : void 0;
	              }), o;
	            }for (; ++i < r;) {
	              var s = e[i];if (t(s, i, e)) return s;
	            }
	          }function Qe(e, t, n) {
	            var i;return t = g.createCallback(t, n, 3), Ge(e, function (e, n, r) {
	              return t(e, n, r) ? (i = e, !1) : void 0;
	            }), i;
	          }function Xe(e, t, n) {
	            var i = -1,
	                r = e ? e.length : 0;if (t = t && "undefined" == typeof n ? t : X(t, n, 3), "number" == typeof r) for (; ++i < r && t(e[i], i, e) !== !1;) {} else li(e, t);return e;
	          }function Ge(e, t, n) {
	            var i = e ? e.length : 0;if (t = t && "undefined" == typeof n ? t : X(t, n, 3), "number" == typeof i) for (; i-- && t(e[i], i, e) !== !1;) {} else {
	              var r = ti(e);i = r.length, li(e, function (e, n, o) {
	                return n = r ? r[--i] : --i, t(o[n], n, o);
	              });
	            }return e;
	          }function je(e, t) {
	            var n = d(arguments, 2),
	                i = -1,
	                r = "function" == typeof t,
	                o = e ? e.length : 0,
	                s = gn("number" == typeof o ? o : 0);return Xe(e, function (e) {
	              s[++i] = (r ? t : e[t]).apply(e, n);
	            }), s;
	          }function et(e, t, n) {
	            var i = -1,
	                r = e ? e.length : 0;if (t = g.createCallback(t, n, 3), "number" == typeof r) for (var o = gn(r); ++i < r;) {
	              o[i] = t(e[i], i, e);
	            } else o = [], li(e, function (e, n, r) {
	              o[++i] = t(e, n, r);
	            });return o;
	          }function tt(e, t, n) {
	            var r = -(1 / 0),
	                o = r;if ("function" != typeof t && n && n[t] === e && (t = null), null == t && jn(e)) for (var s = -1, a = e.length; ++s < a;) {
	              var u = e[s];u > o && (o = u);
	            } else t = null == t && Ke(e) ? i : g.createCallback(t, n, 3), Xe(e, function (e, n, i) {
	              var s = t(e, n, i);s > r && (r = s, o = e);
	            });return o;
	          }function nt(e, t, n) {
	            var r = 1 / 0,
	                o = r;if ("function" != typeof t && n && n[t] === e && (t = null), null == t && jn(e)) for (var s = -1, a = e.length; ++s < a;) {
	              var u = e[s];o > u && (o = u);
	            } else t = null == t && Ke(e) ? i : g.createCallback(t, n, 3), Xe(e, function (e, n, i) {
	              var s = t(e, n, i);r > s && (r = s, o = e);
	            });return o;
	          }function it(e, t, n, i) {
	            if (!e) return n;var r = arguments.length < 3;t = g.createCallback(t, i, 4);var o = -1,
	                s = e.length;if ("number" == typeof s) for (r && (n = e[++o]); ++o < s;) {
	              n = t(n, e[o], o, e);
	            } else li(e, function (e, i, o) {
	              n = r ? (r = !1, e) : t(n, e, i, o);
	            });return n;
	          }function rt(e, t, n, i) {
	            var r = arguments.length < 3;return t = g.createCallback(t, i, 4), Ge(e, function (e, i, o) {
	              n = r ? (r = !1, e) : t(n, e, i, o);
	            }), n;
	          }function ot(e, t, n) {
	            return t = g.createCallback(t, n, 3), Je(e, function (e, n, i) {
	              return !t(e, n, i);
	            });
	          }function st(e, t, n) {
	            if (e && "number" != typeof e.length && (e = Le(e)), null == t || n) return e ? e[re(0, e.length - 1)] : h;var i = at(e);return i.length = Zn(kn(0, t), i.length), i;
	          }function at(e) {
	            var t = -1,
	                n = e ? e.length : 0,
	                i = gn("number" == typeof n ? n : 0);return Xe(e, function (e) {
	              var n = re(0, ++t);i[t] = i[n], i[n] = e;
	            }), i;
	          }function ut(e) {
	            var t = e ? e.length : 0;return "number" == typeof t ? t : ti(e).length;
	          }function lt(e, t, n) {
	            var i;t = g.createCallback(t, n, 3);var r = -1,
	                o = e ? e.length : 0;if ("number" == typeof o) for (; ++r < o && !(i = t(e[r], r, e));) {} else li(e, function (e, n, r) {
	              return !(i = t(e, n, r));
	            });return !!i;
	          }function ct(e, t, n) {
	            var i = -1,
	                o = jn(t),
	                s = e ? e.length : 0,
	                d = gn("number" == typeof s ? s : 0);for (o || (t = g.createCallback(t, n, 3)), Xe(e, function (e, n, r) {
	              var s = d[++i] = u();o ? s.criteria = et(t, function (t) {
	                return e[t];
	              }) : (s.criteria = a())[0] = t(e, n, r), s.index = i, s.value = e;
	            }), s = d.length, d.sort(r); s--;) {
	              var f = d[s];d[s] = f.value, o || l(f.criteria), c(f);
	            }return d;
	          }function dt(e) {
	            return e && "number" == typeof e.length ? d(e) : Le(e);
	          }function ft(e) {
	            for (var t = -1, n = e ? e.length : 0, i = []; ++t < n;) {
	              var r = e[t];r && i.push(r);
	            }return i;
	          }function St(e) {
	            return j(e, te(arguments, !0, !0, 1));
	          }function ht(e, t, n) {
	            var i = -1,
	                r = e ? e.length : 0;for (t = g.createCallback(t, n, 3); ++i < r;) {
	              if (t(e[i], i, e)) return i;
	            }return -1;
	          }function gt(e, t, n) {
	            var i = e ? e.length : 0;for (t = g.createCallback(t, n, 3); i--;) {
	              if (t(e[i], i, e)) return i;
	            }return -1;
	          }function pt(e, t, n) {
	            var i = 0,
	                r = e ? e.length : 0;if ("number" != typeof t && null != t) {
	              var o = -1;for (t = g.createCallback(t, n, 3); ++o < r && t(e[o], o, e);) {
	                i++;
	              }
	            } else if (i = t, null == i || n) return e ? e[0] : h;return d(e, 0, Zn(kn(0, i), r));
	          }function mt(e, t, n, i) {
	            return "boolean" != typeof t && null != t && (i = n, n = "function" != typeof t && i && i[t] === e ? null : t, t = !1), null != n && (e = et(e, n, i)), te(e, t);
	          }function vt(t, n, i) {
	            if ("number" == typeof i) {
	              var r = t ? t.length : 0;i = 0 > i ? kn(0, r + i) : i || 0;
	            } else if (i) {
	              var o = Mt(t, n);return t[o] === n ? o : -1;
	            }return e(t, n, i);
	          }function wt(e, t, n) {
	            var i = 0,
	                r = e ? e.length : 0;if ("number" != typeof t && null != t) {
	              var o = r;for (t = g.createCallback(t, n, 3); o-- && t(e[o], o, e);) {
	                i++;
	              }
	            } else i = null == t || n ? 1 : t || i;return d(e, 0, Zn(kn(0, r - i), r));
	          }function yt() {
	            for (var n = [], i = -1, r = arguments.length, s = a(), u = le(), d = u === e, f = a(); ++i < r;) {
	              var S = arguments[i];(jn(S) || Se(S)) && (n.push(S), s.push(d && S.length >= w && o(i ? n[i] : f)));
	            }var h = n[0],
	                g = -1,
	                p = h ? h.length : 0,
	                m = [];e: for (; ++g < p;) {
	              var v = s[0];if (S = h[g], (v ? t(v, S) : u(f, S)) < 0) {
	                for (i = r, (v || f).push(S); --i;) {
	                  if (v = s[i], (v ? t(v, S) : u(n[i], S)) < 0) continue e;
	                }m.push(S);
	              }
	            }for (; r--;) {
	              v = s[r], v && c(v);
	            }return l(s), l(f), m;
	          }function Ct(e, t, n) {
	            var i = 0,
	                r = e ? e.length : 0;if ("number" != typeof t && null != t) {
	              var o = r;for (t = g.createCallback(t, n, 3); o-- && t(e[o], o, e);) {
	                i++;
	              }
	            } else if (i = t, null == i || n) return e ? e[r - 1] : h;return d(e, kn(0, r - i));
	          }function xt(e, t, n) {
	            var i = e ? e.length : 0;for ("number" == typeof n && (i = (0 > n ? kn(0, i + n) : Zn(n, i - 1)) + 1); i--;) {
	              if (e[i] === t) return i;
	            }return -1;
	          }function bt(e) {
	            for (var t = arguments, n = 0, i = t.length, r = e ? e.length : 0; ++n < i;) {
	              for (var o = -1, s = t[n]; ++o < r;) {
	                e[o] === s && (Nn.call(e, o--, 1), r--);
	              }
	            }return e;
	          }function Et(e, t, n) {
	            e = +e || 0, n = "number" == typeof n ? n : +n || 1, null == t && (t = e, e = 0);for (var i = -1, r = kn(0, Rn((t - e) / (n || 1))), o = gn(r); ++i < r;) {
	              o[i] = e, e += n;
	            }return o;
	          }function _t(e, t, n) {
	            var i = -1,
	                r = e ? e.length : 0,
	                o = [];for (t = g.createCallback(t, n, 3); ++i < r;) {
	              var s = e[i];t(s, i, e) && (o.push(s), Nn.call(e, i--, 1), r--);
	            }return o;
	          }function Ft(e, t, n) {
	            if ("number" != typeof t && null != t) {
	              var i = 0,
	                  r = -1,
	                  o = e ? e.length : 0;for (t = g.createCallback(t, n, 3); ++r < o && t(e[r], r, e);) {
	                i++;
	              }
	            } else i = null == t || n ? 1 : kn(0, t);return d(e, i);
	          }function Mt(e, t, n, i) {
	            var r = 0,
	                o = e ? e.length : r;for (n = n ? g.createCallback(n, i, 1) : Gt, t = n(t); o > r;) {
	              var s = r + o >>> 1;n(e[s]) < t ? r = s + 1 : o = s;
	            }return r;
	          }function It() {
	            return oe(te(arguments, !0, !0));
	          }function Tt(e, t, n, i) {
	            return "boolean" != typeof t && null != t && (i = n, n = "function" != typeof t && i && i[t] === e ? null : t, t = !1), null != n && (n = g.createCallback(n, i, 3)), oe(e, t, n);
	          }function Rt(e) {
	            return j(e, d(arguments, 1));
	          }function Pt() {
	            for (var e = -1, t = arguments.length; ++e < t;) {
	              var n = arguments[e];if (jn(n) || Se(n)) var i = i ? oe(j(i, n).concat(j(n, i))) : n;
	            }return i || [];
	          }function Bt() {
	            for (var e = arguments.length > 1 ? arguments : arguments[0], t = -1, n = e ? tt(hi(e, S("8U_U[IV"))) : 0, i = gn(0 > n ? 0 : n); ++t < n;) {
	              i[t] = hi(e, t);
	            }return i;
	          }function Dt(e, t) {
	            var n = -1,
	                i = e ? e.length : 0,
	                r = {};for (t || !i || jn(e[0]) || (t = []); ++n < i;) {
	              var o = e[n];t ? r[o] = t[n] : o && (r[o[0]] = o[1]);
	            }return r;
	          }function Ot(e, t) {
	            if (!Re(t)) throw new En();return function () {
	              return --e < 1 ? t.apply(this, arguments) : void 0;
	            };
	          }function At(e, t) {
	            return arguments.length > 2 ? ae(e, 17, d(arguments, 2), null, t) : ae(e, 1, null, null, t);
	          }function Kt(e) {
	            for (var t = arguments.length > 1 ? te(arguments, !0, !1, 1) : Ce(e), n = -1, i = t.length; ++n < i;) {
	              var r = t[n];e[r] = ae(e[r], 1, null, null, e);
	            }return e;
	          }function Vt(e, t) {
	            return arguments.length > 2 ? ae(t, 19, d(arguments, 2), null, e) : ae(t, 3, null, null, e);
	          }function Nt() {
	            for (var e = arguments, t = e.length; t--;) {
	              if (!Re(e[t])) throw new En();
	            }return function () {
	              for (var t = arguments, n = e.length; n--;) {
	                t = [e[n].apply(this, t)];
	              }return t[0];
	            };
	          }function Ht(e, t) {
	            return t = "number" == typeof t ? t : +t || e.length, ae(e, 4, null, null, null, t);
	          }function Ut(e, t, n) {
	            var i,
	                r,
	                o,
	                s,
	                a,
	                u,
	                l,
	                c = 0,
	                d = !1,
	                f = !0;if (!Re(e)) throw new En();if (t = kn(0, t) || 0, n === !0) {
	              var g = !0;f = !1;
	            } else Pe(n) && (g = n.leading, d = S(".BQIeR]A") in n && (kn(t, n.maxWait) || 0), f = S("beypvrrz") in n ? n.trailing : f);var p = function p() {
	              var n = t - (pi() - s);if (0 >= n) {
	                r && Pn(r);var d = l;r = u = l = h, d && (c = pi(), o = e.apply(a, i), u || r || (i = a = null));
	              } else u = Vn(p, n);
	            },
	                m = function m() {
	              u && Pn(u), r = u = l = h, (f || d !== t) && (c = pi(), o = e.apply(a, i), u || r || (i = a = null));
	            };return function () {
	              if (i = arguments, s = pi(), a = this, l = f && (u || !g), d === !1) var n = g && !u;else {
	                r || g || (c = s);var S = d - (s - c),
	                    h = 0 >= S;h ? (r && (r = Pn(r)), c = s, o = e.apply(a, i)) : r || (r = Vn(m, S));
	              }return h && u ? u = Pn(u) : u || t === d || (u = Vn(p, t)), n && (h = !0, o = e.apply(a, i)), !h || u || r || (i = a = null), o;
	            };
	          }function qt(e) {
	            if (!Re(e)) throw new En();var t = d(arguments, 1);return Vn(function () {
	              e.apply(h, t);
	            }, 1);
	          }function Wt(e, t) {
	            if (!Re(e)) throw new En();var n = d(arguments, 2);return Vn(function () {
	              e.apply(h, n);
	            }, t);
	          }function $t(e, t) {
	            if (!Re(e)) throw new En();var n = function n() {
	              var i = n.cache,
	                  r = t ? t.apply(this, arguments) : v + arguments[0];return An.call(i, r) ? i[r] : i[r] = e.apply(this, arguments);
	            };return n.cache = {}, n;
	          }function Lt(e) {
	            var t, n;if (!Re(e)) throw new En();return function () {
	              return t ? n : (t = !0, n = e.apply(this, arguments), e = null, n);
	            };
	          }function Yt(e) {
	            return ae(e, 16, d(arguments, 1));
	          }function kt(e) {
	            return ae(e, 32, null, d(arguments, 1));
	          }function Zt(e, t, n) {
	            var i = !0,
	                r = !0;if (!Re(e)) throw new En();return n === !1 ? i = !1 : Pe(n) && (i = S("A.&%!/)/") in n ? n.leading : i, r = S("(]XJEAGAW") in n ? n.trailing : r), Y.leading = i, Y.maxWait = t, Y.trailing = r, Ut(e, t, Y);
	          }function Jt(e, t) {
	            return ae(t, 16, [e]);
	          }function zt(e) {
	            return function () {
	              return e;
	            };
	          }function Qt(e, t, n) {
	            var i = typeof e === 'undefined' ? 'undefined' : _typeof(e);if (null == e || "function" == i) return X(e, t, n);if ("object" != i) return nn(e);var r = ti(e),
	                o = r[0],
	                s = e[o];return 1 != r.length || s !== s || Pe(s) ? function (t) {
	              for (var n = r.length, i = !1; n-- && (i = ne(t[r[n]], e[r[n]], null, !0));) {}return i;
	            } : function (e) {
	              var t = e[o];return s === t && (0 !== s || 1 / s == 1 / t);
	            };
	          }function Xt(e) {
	            return null == e ? "" : bn(e).replace(oi, ue);
	          }function Gt(e) {
	            return e;
	          }function jt(e, t, n) {
	            var i = !0,
	                r = t && Ce(t);t && (n || r.length) || (null == n && (n = t), o = p, t = e, e = g, r = Ce(t)), n === !1 ? i = !1 : Pe(n) && S("=]W!(,") in n && (i = n.chain);var o = e,
	                s = Re(o);Xe(r, function (n) {
	              var r = e[n] = t[n];s && (o.prototype[n] = function () {
	                var t = this.__chain__,
	                    n = this.__wrapped__,
	                    s = [n];Kn.apply(s, arguments);var a = r.apply(e, s);if (i || t) {
	                  if (n === a && Pe(a)) return this;a = new o(a), a.__chain__ = t;
	                }return a;
	              });
	            });
	          }function en() {
	            return n._ = Mn, this;
	          }function tn() {}function nn(e) {
	            return function (t) {
	              return t[e];
	            };
	          }function rn(e, t, n) {
	            var i = null == e,
	                r = null == t;if (null == n && ("boolean" == typeof e && r ? (n = e, e = 1) : r || "boolean" != typeof t || (n = t, r = !0)), i && r && (t = 1), e = +e || 0, r ? (t = e, e = 0) : t = +t || 0, n || e % 1 || t % 1) {
	              var o = zn();return Zn(e + o * (t - e + parseFloat(S("$C\n") + ((o + "").length - 1))), t);
	            }return re(e, t);
	          }function on(e, t) {
	            if (e) {
	              var n = e[t];return Re(n) ? e[t]() : n;
	            }
	          }function sn(e, t, n) {
	            var i = g.templateSettings;e = bn(e || ""), n = ai({}, n, i);var r,
	                o = ai({}, n.imports, i.imports),
	                a = ti(o),
	                u = Le(o),
	                l = 0,
	                c = n.interpolate || R,
	                d = S('EDl=5"\x00'),
	                f = xn((n.escape || R).source + "|" + c.source + "|" + (c === I ? _ : R).source + "|" + (n.evaluate || R).source + S("<A"), "g");e.replace(f, function (t, n, i, o, a, u) {
	              return i || (i = o), d += e.slice(l, u).replace(B, s), n && (d += S(";=5~G") + n + S(";3?1")), a && (r = !0, d += S("/\n8") + a + S("$,xwY\n\x00\r	")), i && (d += S("3=edHh") + i + S("7PJ,-b|dbagri8dndZv")), l = u + t.length, t;
	            }), d += S(".\b;");var p = n.variable,
	                m = p;m || (p = S("zt}"), d = S("#SLRO\b") + p + S("*\fV$") + d + S("p")), d = (r ? d.replace(x, "") : d).replace(b, S(":.")).replace(E, S("8\x00")), d = S("1TFZVB^WW") + p + S("7?[+") + (m ? "" : p + S("Cd9:g`") + p + S("\n+1-ur9*")) + S("D3'5h?`m qossrzw?{a}q\x00") + (r ? S('Che"iwk\r?<.)"!;!9#!)?u6271[k') + S('?&4, 0,))h98""9ffp*r\f%v|ey6s=>\f\rJ\n\r@MIHYQy') : S("73")) + d + S("6E]MOIRa`0K?");var v = S("\n#' ?22`{`dt}LHW!") + (n.sourceURL || S("#aakqbz<`p{gtxn~3nqjRBGx") + O++ + "]") + S("6=");try {
	              var w = vn(a, S(":IYIKM.a") + d + v).apply(h, u);
	            } catch (y) {
	              throw y.source = d, y;
	            }return t ? w(t) : (w.source = d, w);
	          }function an(e, t, n) {
	            e = (e = +e) > -1 ? e : 0;var i = -1,
	                r = gn(e);for (t = X(t, n, 1); ++i < e;) {
	              r[i] = t(i);
	            }return r;
	          }function un(e) {
	            return null == e ? "" : bn(e).replace(ri, fe);
	          }function ln(e) {
	            var t = ++m;return bn(null == e ? "" : e) + t;
	          }function cn(e) {
	            return e = new p(e), e.__chain__ = !0, e;
	          }function dn(e, t) {
	            return t(e), e;
	          }function fn() {
	            return this.__chain__ = !0, this;
	          }function Sn() {
	            return bn(this.__wrapped__);
	          }function hn() {
	            return this.__wrapped__;
	          }n = n ? ee.defaults(z.Object(), n, ee.pick(z, D)) : z;var gn = n.Array,
	              pn = n.Boolean,
	              mn = n.Date,
	              vn = n.Function,
	              wn = n.Math,
	              yn = n.Number,
	              Cn = n.Object,
	              xn = n.RegExp,
	              bn = n.String,
	              En = n.TypeError,
	              _n = [],
	              Fn = Cn.prototype,
	              Mn = n._,
	              In = Fn.toString,
	              Tn = xn("^" + bn(In).replace(/[.*+?^${}()|[\]\\]/g, S("9f")).replace(/toString| for [^\]]+/g, S("\f#$0")) + "$"),
	              Rn = wn.ceil,
	              Pn = n.clearTimeout,
	              Bn = wn.floor,
	              Dn = vn.prototype.toString,
	              On = ce(On = Cn.getPrototypeOf) && On,
	              An = Fn.hasOwnProperty,
	              Kn = _n.push,
	              Vn = n.setTimeout,
	              Nn = _n.splice,
	              Hn = _n.unshift,
	              Un = function () {
	            try {
	              var e = {},
	                  t = ce(t = Cn.defineProperty) && t,
	                  n = t(e, e, e) && t;
	            } catch (i) {}return n;
	          }(),
	              qn = ce(qn = Cn.create) && qn,
	              Wn = ce(Wn = gn.isArray) && Wn,
	              $n = n.isFinite,
	              Ln = n.isNaN,
	              Yn = ce(Yn = Cn.keys) && Yn,
	              kn = wn.max,
	              Zn = wn.min,
	              Jn = n.parseInt,
	              zn = wn.random,
	              Qn = {};Qn[K] = gn, Qn[V] = pn, Qn[N] = mn, Qn[H] = vn, Qn[q] = Cn, Qn[U] = yn, Qn[W] = xn, Qn[$] = bn, p.prototype = g.prototype;var Xn = g.support = {};Xn.funcDecomp = !ce(n.WinRTError) && P.test(f), Xn.funcNames = "string" == typeof vn.name, g.templateSettings = { escape: /<%-([\s\S]+?)%>/g, evaluate: /<%([\s\S]+?)%>/g, interpolate: I, variable: "", imports: { _: g } }, qn || (Q = function () {
	            function e() {}return function (t) {
	              if (Pe(t)) {
	                e.prototype = t;var i = new e();e.prototype = null;
	              }return i || n.Object();
	            };
	          }());var Gn = Un ? function (e, t) {
	            k.value = t, Un(e, S("6hg[SUXy_K!"), k), k.value = null;
	          } : tn,
	              jn = Wn || function (e) {
	            return e && "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) && "number" == typeof e.length && In.call(e) == K || !1;
	          },
	              ei = function ei(e) {
	            var t,
	                n = e,
	                i = [];if (!n) return i;if (!Z[typeof e === 'undefined' ? 'undefined' : _typeof(e)]) return i;for (t in n) {
	              An.call(n, t) && i.push(t);
	            }return i;
	          },
	              ti = Yn ? function (e) {
	            return Pe(e) ? Yn(e) : [];
	          } : ei,
	              ni = { "&": S("\r(n}a)"), "<": S("-\bCD\n"), ">": S(">~n "), '"': S("&Y\\E_"), "'": S("26%.#") },
	              ii = be(ni),
	              ri = xn("(" + ti(ii).join("|") + ")", "g"),
	              oi = xn("[" + ti(ni).join("") + "]", "g"),
	              si = function si(e, t, n) {
	            var i,
	                r = e,
	                o = r;if (!r) return o;var s = arguments,
	                a = 0,
	                u = "number" == typeof n ? 2 : s.length;if (u > 3 && "function" == typeof s[u - 2]) var l = X(s[--u - 1], s[u--], 2);else u > 2 && "function" == typeof s[u - 1] && (l = s[--u]);for (; ++a < u;) {
	              if (r = s[a], r && Z[typeof r === 'undefined' ? 'undefined' : _typeof(r)]) for (var c = -1, d = Z[typeof r === 'undefined' ? 'undefined' : _typeof(r)] && ti(r), f = d ? d.length : 0; ++c < f;) {
	                i = d[c], o[i] = l ? l(o[i], r[i]) : r[i];
	              }
	            }return o;
	          },
	              ai = function ai(e, t, n) {
	            var i,
	                r = e,
	                o = r;if (!r) return o;for (var s = arguments, a = 0, u = "number" == typeof n ? 2 : s.length; ++a < u;) {
	              if (r = s[a], r && Z[typeof r === 'undefined' ? 'undefined' : _typeof(r)]) for (var l = -1, c = Z[typeof r === 'undefined' ? 'undefined' : _typeof(r)] && ti(r), d = c ? c.length : 0; ++l < d;) {
	                i = c[l], "undefined" == typeof o[i] && (o[i] = r[i]);
	              }
	            }return o;
	          },
	              ui = function ui(e, t, n) {
	            var i,
	                r = e,
	                o = r;if (!r) return o;if (!Z[typeof r === 'undefined' ? 'undefined' : _typeof(r)]) return o;t = t && "undefined" == typeof n ? t : X(t, n, 3);for (i in r) {
	              if (t(r[i], i, e) === !1) return o;
	            }return o;
	          },
	              li = function li(e, t, n) {
	            var i,
	                r = e,
	                o = r;if (!r) return o;if (!Z[typeof r === 'undefined' ? 'undefined' : _typeof(r)]) return o;t = t && "undefined" == typeof n ? t : X(t, n, 3);for (var s = -1, a = Z[typeof r === 'undefined' ? 'undefined' : _typeof(r)] && ti(r), u = a ? a.length : 0; ++s < u;) {
	              if (i = a[s], t(r[i], i, e) === !1) return o;
	            }return o;
	          },
	              ci = On ? function (e) {
	            if (!e || In.call(e) != q) return !1;var t = e.valueOf,
	                n = ce(t) && (n = On(t)) && On(n);return n ? e == n || On(e) == n : de(e);
	          } : de,
	              di = se(function (e, t, n) {
	            An.call(e, n) ? e[n]++ : e[n] = 1;
	          }),
	              fi = se(function (e, t, n) {
	            (An.call(e, n) ? e[n] : e[n] = []).push(t);
	          }),
	              Si = se(function (e, t, n) {
	            e[n] = t;
	          }),
	              hi = et,
	              gi = Je,
	              pi = ce(pi = mn.now) && pi || function () {
	            return new mn().getTime();
	          },
	              mi = 8 == Jn(C + S(")")) ? Jn : function (e, t) {
	            return Jn(Ke(e) ? e.replace(T, "") : e, t || 0);
	          };return g.after = Ot, g.assign = si, g.at = Ye, g.bind = At, g.bindAll = Kt, g.bindKey = Vt, g.chain = cn, g.compact = ft, g.compose = Nt, g.constant = zt, g.countBy = di, g.create = pe, g.createCallback = Qt, g.curry = Ht, g.debounce = Ut, g.defaults = ai, g.defer = qt, g.delay = Wt, g.difference = St, g.filter = Je, g.flatten = mt, g.forEach = Xe, g.forEachRight = Ge, g.forIn = ui, g.forInRight = we, g.forOwn = li, g.forOwnRight = ye, g.functions = Ce, g.groupBy = fi, g.indexBy = Si, g.initial = wt, g.intersection = yt, g.invert = be, g.invoke = je, g.keys = ti, g.map = et, g.mapValues = Ne, g.max = tt, g.memoize = $t, g.merge = He, g.min = nt, g.omit = Ue, g.once = Lt, g.pairs = qe, g.partial = Yt, g.partialRight = kt, g.pick = We, g.pluck = hi, g.property = nn, g.pull = bt, g.range = Et, g.reject = ot, g.remove = _t, g.rest = Ft, g.shuffle = at, g.sortBy = ct, g.tap = dn, g.throttle = Zt, g.times = an, g.toArray = dt, g.transform = $e, g.union = It, g.uniq = Tt, g.values = Le, g.where = gi, g.without = Rt, g.wrap = Jt, g.xor = Pt, g.zip = Bt, g.zipObject = Dt, g.collect = et, g.drop = Ft, g.each = Xe, g.eachRight = Ge, g.extend = si, g.methods = Ce, g.object = Dt, g.select = Je, g.tail = Ft, g.unique = Tt, g.unzip = Bt, jt(g), g.clone = he, g.cloneDeep = ge, g.contains = ke, g.escape = Xt, g.every = Ze, g.find = ze, g.findIndex = ht, g.findKey = me, g.findLast = Qe, g.findLastIndex = gt, g.findLastKey = ve, g.has = xe, g.identity = Gt, g.indexOf = vt, g.isArguments = Se, g.isArray = jn, g.isBoolean = Ee, g.isDate = _e, g.isElement = Fe, g.isEmpty = Me, g.isEqual = Ie, g.isFinite = Te, g.isFunction = Re, g.isNaN = Be, g.isNull = De, g.isNumber = Oe, g.isObject = Pe, g.isPlainObject = ci, g.isRegExp = Ae, g.isString = Ke, g.isUndefined = Ve, g.lastIndexOf = xt, g.mixin = jt, g.noConflict = en, g.noop = tn, g.now = pi, g.parseInt = mi, g.random = rn, g.reduce = it, g.reduceRight = rt, g.result = on, g.runInContext = f, g.size = ut, g.some = lt, g.sortedIndex = Mt, g.template = sn, g.unescape = un, g.uniqueId = ln, g.all = Ze, g.any = lt, g.detect = ze, g.findWhere = ze, g.foldl = it, g.foldr = rt, g.include = ke, g.inject = it, jt(function () {
	            var e = {};return li(g, function (t, n) {
	              g.prototype[n] || (e[n] = t);
	            }), e;
	          }(), !1), g.first = pt, g.last = Ct, g.sample = st, g.take = pt, g.head = pt, li(g, function (e, t) {
	            var n = t !== S("|q|bq");g.prototype[t] || (g.prototype[t] = function (t, i) {
	              var r = this.__chain__,
	                  o = e(this.__wrapped__, t, i);return r || null != t && (!i || n && "function" == typeof t) ? new p(o, r) : o;
	            });
	          }), g.VERSION = S("*\x00"), g.prototype.chain = fn, g.prototype.toString = Sn, g.prototype.value = hn, g.prototype.valueOf = hn, Xe([S("@+-**"), S("1B\\D"), S("?3)+%0")], function (e) {
	            var t = _n[e];g.prototype[e] = function () {
	              var e = this.__chain__,
	                  n = t.apply(this.__wrapped__, arguments);return e ? new p(n, e) : n;
	            };
	          }), Xe([S("oURJ"), S(" SGUAWUB"), S("orlk"), S("$PHT@@L_")], function (e) {
	            var t = _n[e];g.prototype[e] = function () {
	              return t.apply(this.__wrapped__, arguments), this;
	            };
	          }), Xe([S("'KFDHMY"), S(",^BFST"), S("acx|ur")], function (e) {
	            var t = _n[e];g.prototype[e] = function () {
	              return new p(t.apply(this.__wrapped__, arguments), this.__chain__);
	            };
	          }), g;
	        }var h,
	            g = [],
	            p = [],
	            m = 0,
	            v = +new Date() + "",
	            w = 75,
	            y = 40,
	            C = S("4¸ﻦ") + S(".%=’‛") + S("7ᚸᠷ››‾‾››⁆⁆⁊⁊⁎⁪’ぇ"),
	            x = /\b__p \+= '';/g,
	            b = /\b(__p \+=) '' \+/g,
	            E = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
	            _ = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
	            F = /\w*$/,
	            M = /^\s*function[ \n\r\t]+\w/,
	            I = /<%=([\s\S]+?)%>/g,
	            T = RegExp(S("${}") + C + S("R:!9;+(831")),
	            R = /($^)/,
	            P = /\bthis\b/,
	            B = /['\n\r\t\u2028\u2029\\]/g,
	            D = [S("!cQVD_"), S("C*)+-($"), S("\rJndt"), S("+jX@LDX]]"), S("(dK_D"), S("Bxcmuc"), S("&hJCOHX"), S("AqrSoh"), S("9iONTPX"), "_", S("~TUC@L`PBF]"), S("\nh`ho}Dxv{`b"), S("fcW{}}as"), S(">V3#\r"), S(":K]OMZ	/6"), S("3GPBcQT_TII")],
	            O = 0,
	            A = S("At~w{|TcQCPKBF]Yv"),
	            K = "[object Array]",
	            V = S(" zMAN@ES\bkED@HOAm"),
	            N = S("(rEIFHM[uSGQh"),
	            H = "[object Function]",
	            U = S(';gR\\U%"6c\n0+%-;\x17'),
	            q = S("<fQ]*$!7d\n$--*>"),
	            W = S("B+',\"+=j)*7 \f"),
	            $ = S("6lW[P^_Il43+-#"),
	            L = {};L[H] = !1, L[A] = L[K] = L[V] = L[N] = L[U] = L[q] = L[W] = L[$] = !0;var Y = { leading: !1, maxWait: 0, trailing: !1 },
	            k = { configurable: !1, enumerable: !1, value: null, writable: !1 },
	            Z = { "boolean": !1, "function": !0, object: !0, number: !1, string: !1, undefined: !1 },
	            J = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "	": "t", '\u2028': S('"V'), '\u2029': S("6B\n	\b") },
	            z = Z[typeof window === 'undefined' ? 'undefined' : _typeof(window)] && window || this,
	            Q = Z[ false ? 'undefined' : _typeof(exports)] && exports && !exports.nodeType && exports,
	            X = Z[ false ? 'undefined' : _typeof(module)] && module && !module.nodeType && module,
	            G = X && X.exports === Q && Q,
	            j = Z[typeof global === 'undefined' ? 'undefined' : _typeof(global)] && global;!j || j.global !== j && j.window !== j || (z = j);var ee = f();"function" == typeof CKFinder.define && "object" == _typeof(CKFinder.define.amd) && CKFinder.define.amd ? (z._ = ee, CKFinder.define(S("g}ppdd{vh~"), [], function () {
	          return ee;
	        })) : Q && X ? G ? (X.exports = ee)._ = ee : Q._ = ee : z._ = ee;
	      }.call(this), function () {
	        function e(t, n, i) {
	          return ("string" == typeof n ? n : n.toString()).replace(t.define || s, function (e, n, r, o) {
	            return 0 === n.indexOf(S("qsq6")) && (n = n.substring(4)), n in i || (":" === r ? (t.defineParams && o.replace(t.defineParams, function (e, t, r) {
	              i[n] = { arg: t, text: r };
	            }), n in i || (i[n] = o)) : new Function(S("\rjjv"), S("0UWUo") + n + S("2i\b") + o)(i)), "";
	          }).replace(t.use || s, function (n, r) {
	            t.useParams && (r = r.replace(t.useParams, function (e, t, n, r) {
	              return i[n] && i[n].arg && r ? (e = (n + ":" + r).replace(/'|\\/g, "_"), i.__exp = i.__exp || {}, i.__exp[e] = i[n].text.replace(new RegExp(S("0Gf@BAi;}\b") + i[n].arg + S("Aj1c`"), "g"), S("0$") + r + S(":")), t + S("-JJVmlQMFl") + e + S("5j")) : void 0;
	            }));var o = new Function(S("0UWU"), S("-\\JDD@]") + r)(i);return o ? e(t, o, i) : o;
	          });
	        }function t(e) {
	          return e.replace(/\\('|\\)/g, S("(<")).replace(/[\r\t\n]/g, " ");
	        }var n,
	            i = { version: S("?qormw"), templateSettings: { evaluate: /\{\{([\s\S]+?(\}?)+)\}\}/g, interpolate: /\{\{=([\s\S]+?)\}\}/g, encode: /\{\{!([\s\S]+?)\}\}/g, use: /\{\{#([\s\S]+?)\}\}/g, useParams: /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g, define: /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g, defineParams: /^\s*([\w$]+):([\s\S]+)/, conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g, iterate: /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g, varname: S("5_C"), strip: !0, append: !0, selfcontained: !1, doNotSkipEncoded: !1 }, template: void 0, compile: void 0 };i.encodeHTMLSource = function (e) {
	          var t = { "&": S("5"), "<": S('"'), ">": S("71%&."), '"': S("<8/)%"), "'": S("%\x00"), "/": S("%\x00") },
	              n = e ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;return function (e) {
	            return e ? e.toString().replace(n, function (e) {
	              return t[e] || e;
	            }) : "";
	          };
	        }, n = function () {
	          return this || (0, eval)(S("5B_QJ"));
	        }(), "undefined" != typeof module && module.exports ? module.exports = i : "function" == typeof CKFinder.define && CKFinder.define.amd ? CKFinder.define(S("u}G"), [], function () {
	          return i;
	        }) : n.doT = i;var r = { start: S("=h"), end: S(">kf"), startencode: S("\n,'h`luw[@XZ?") },
	            o = { start: S("1\b[@B"), end: S(">#voo7 9"), startencode: S(" LQQ\rMGIDHHf{}}") },
	            s = /$^/;i.template = function (a, u, l) {
	          u = u || i.templateSettings;var c,
	              d,
	              f = u.append ? r : o,
	              h = 0;a = u.use || u.define ? e(u, a, l || {}) : a, a = (S("9LZNQJ4|e") + (u.strip ? a.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g, " ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") : a).replace(/'|\\/g, S("&{\f")).replace(u.interpolate || s, function (e, n) {
	            return f.start + t(n) + f.end;
	          }).replace(u.encode || s, function (e, n) {
	            return c = !0, f.startencode + t(n) + f.end;
	          }).replace(u.conditional || s, function (e, n, i) {
	            return n ? i ? S("0#dwox>vF	") + t(i) + S("9j}f`>+0") : S('?"g~pn{dOTV\b') : i ? S("1\b]S") + t(i) + S(">cvoo7 9") : S("+S@EE");
	          }).replace(u.iterate || s, function (e, n, i, r) {
	            return n ? (h += 1, d = r || "i" + h, n = t(n), S("Bd3'5h(89") + h + "=" + n + S(" u{6~RS") + h + S("*W[O]") + i + "," + d + S("=qm.") + h + S(",saf") + h + S("9t|t|hu3.VJJH@") + d + S("7U") + h + S("=D") + i + S("-NBC") + h + "[" + d + S("(qAZD")) : S("9\x00AC/46hyb");
	          }).replace(u.evaluate || s, function (e, n) {
	            return S("/\n") + t(n) + S("{`b<%>");
	          }) + S("6)aqacev9unh&")).replace(/\n/g, S("Jy")).replace(/\t/g, S("3hA")).replace(/\r/g, S("Al")).replace(/(\s|;|\}|^|\{)out\+='';/g, S("'\f")).replace(/\+''/g, ""), c && (u.selfcontained || !n || n._encodeHTML || (n._encodeHTML = i.encodeHTMLSource(u.doNotSkipEncoded)), a = S("lzn={qCNFFlqkk\b\n_U]K@VmVZVYS]qnvp}ae6*!#!!'//kmqo4<0;13\f{f}v") + i.encodeHTMLSource.toString() + "(" + (u.doNotSkipEncoded || "") + S("&") + a);try {
	            return new Function(u.varname, a);
	          } catch (g) {
	            throw "undefined" != typeof console && console.log(S("-m@E]VZZB[K_ZHX^`5'.4)'3-i,>\".:&??hs") + a), g;
	          }
	        }, i.compile = function (e, t) {
	          return i.template(e, null, t);
	        };
	      }(), function (e, t) {
	        if ("function" == typeof CKFinder.define && CKFinder.define.amd) CKFinder.define(S("/RPQXVZXR"), [S("+YCJJBBQ\\FP"), S("wojES["), S("'MQZD^Y]")], function (n, i, r) {
	          e.Backbone = t(e, r, n, i);
	        });else if (true) {
	          var n = __webpack_require__(320)(S("nry{mSBMQA"));t(e, exports, n);
	        } else e.Backbone = t(e, {}, e._, e.jQuery || e.Zepto || e.ender || e.$);
	      }(this, function (e, t, n, i) {
	        var r = e.Backbone,
	            o = [],
	            s = (o.push, o.slice);o.splice;t.VERSION = S("&"), t.$ = i, t.noConflict = function () {
	          return e.Backbone = r, this;
	        }, t.emulateHTTP = !1, t.emulateJSON = !1;var a = t.Events = { on: function on(e, t, n) {
	            if (!l(this, "on", e, [t, n]) || !t) return this;this._events || (this._events = {});var i = this._events[e] || (this._events[e] = []);return i.push({ callback: t, context: n, ctx: n || this }), this;
	          }, once: function once(e, t, i) {
	            if (!l(this, S("ss}z"), e, [t, i]) || !t) return this;var r = this,
	                o = n.once(function () {
	              r.off(e, o), t.apply(this, arguments);
	            });return o._callback = t, this.on(e, o, i);
	          }, off: function off(e, t, i) {
	            var r, o, s, a, u, c, d, f;if (!this._events || !l(this, S("E)!."), e, [t, i])) return this;if (!e && !t && !i) return this._events = void 0, this;for (a = e ? [e] : n.keys(this._events), u = 0, c = a.length; c > u; u++) {
	              if (e = a[u], s = this._events[e]) {
	                if (this._events[e] = r = [], t || i) for (d = 0, f = s.length; f > d; d++) {
	                  o = s[d], (t && t !== o.callback && t !== o.callback._callback || i && i !== o.context) && r.push(o);
	                }r.length || delete this._events[e];
	              }
	            }return this;
	          }, trigger: function trigger(e) {
	            if (!this._events) return this;var t = s.call(arguments, 1);if (!l(this, S("xghwt`"), e, t)) return this;var n = this._events[e],
	                i = this._events.all;return n && c(n, t), i && c(i, arguments), this;
	          }, stopListening: function stopListening(e, t, i) {
	            var r = this._listeningTo;if (!r) return this;var o = !t && !i;i || "object" != (typeof t === 'undefined' ? 'undefined' : _typeof(t)) || (i = this), e && ((r = {})[e._listenId] = e);for (var s in r) {
	              e = r[s], e.off(t, i, this), (o || n.isEmpty(e._events)) && delete this._listeningTo[s];
	            }return this;
	          } },
	            u = /\s+/,
	            l = function l(e, t, n, i) {
	          if (!n) return !0;if ("object" == (typeof n === 'undefined' ? 'undefined' : _typeof(n))) {
	            for (var r in n) {
	              e[t].apply(e, [r, n[r]].concat(i));
	            }return !1;
	          }if (u.test(n)) {
	            for (var o = n.split(u), s = 0, a = o.length; a > s; s++) {
	              e[t].apply(e, [o[s]].concat(i));
	            }return !1;
	          }return !0;
	        },
	            c = function c(e, t) {
	          var n,
	              i = -1,
	              r = e.length,
	              o = t[0],
	              s = t[1],
	              a = t[2];switch (t.length) {case 0:
	              for (; ++i < r;) {
	                (n = e[i]).callback.call(n.ctx);
	              }return;case 1:
	              for (; ++i < r;) {
	                (n = e[i]).callback.call(n.ctx, o);
	              }return;case 2:
	              for (; ++i < r;) {
	                (n = e[i]).callback.call(n.ctx, o, s);
	              }return;case 3:
	              for (; ++i < r;) {
	                (n = e[i]).callback.call(n.ctx, o, s, a);
	              }return;default:
	              for (; ++i < r;) {
	                (n = e[i]).callback.apply(n.ctx, t);
	              }return;}
	        },
	            d = { listenTo: "on", listenToOnce: S("0^\\PQ") };n.each(d, function (e, t) {
	          a[t] = function (t, i, r) {
	            var o = this._listeningTo || (this._listeningTo = {}),
	                s = t._listenId || (t._listenId = n.uniqueId("l"));return o[s] = t, r || "object" != (typeof i === 'undefined' ? 'undefined' : _typeof(i)) || (r = this), t[e](i, r, this), this;
	          };
	        }), a.bind = a.on, a.unbind = a.off, n.extend(t, a);var f = t.Model = function (e, t) {
	          var i = e || {};t || (t = {}), this.cid = n.uniqueId("c"), this.attributes = {}, t.collection && (this.collection = t.collection), t.parse && (i = this.parse(i, t) || {}), i = n.defaults({}, i, n.result(this, S("8]_]]HRK3"))), this.set(i, t), this.changed = {}, this.initialize.apply(this, arguments);
	        };n.extend(f.prototype, a, { changed: null, validationError: null, idAttribute: S("\rgk"), initialize: function initialize() {}, toJSON: function toJSON(e) {
	            return n.clone(this.attributes);
	          }, sync: function sync() {
	            return t.sync.apply(this, arguments);
	          }, get: function get(e) {
	            return this.attributes[e];
	          }, escape: function escape(e) {
	            return n.escape(this.get(e));
	          }, has: function has(e) {
	            return null != this.get(e);
	          }, set: function set(e, t, i) {
	            var r, o, s, a, u, l, c, d;if (null == e) return this;if ("object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) ? (o = e, i = t) : (o = {})[e] = t, i || (i = {}), !this._validate(o, i)) return !1;s = i.unset, u = i.silent, a = [], l = this._changing, this._changing = !0, l || (this._previousAttributes = n.clone(this.attributes), this.changed = {}), d = this.attributes, c = this._previousAttributes, this.idAttribute in o && (this.id = o[this.idAttribute]);for (r in o) {
	              t = o[r], n.isEqual(d[r], t) || a.push(r), n.isEqual(c[r], t) ? delete this.changed[r] : this.changed[r] = t, s ? delete d[r] : d[r] = t;
	            }if (!u) {
	              a.length && (this._pending = i);for (var f = 0, h = a.length; h > f; f++) {
	                this.trigger(S("}wAOEF") + a[f], this, d[a[f]], i);
	              }
	            }if (l) return this;if (!u) for (; this._pending;) {
	              i = this._pending, this._pending = !1, this.trigger(S("8ZRZRZ["), this, i);
	            }return this._pending = !1, this._changing = !1, this;
	          }, unset: function unset(e, t) {
	            return this.set(e, void 0, n.extend({}, t, { unset: !0 }));
	          }, clear: function clear(e) {
	            var t = {};for (var i in this.attributes) {
	              t[i] = void 0;
	            }return this.set(t, n.extend({}, e, { unset: !0 }));
	          }, hasChanged: function hasChanged(e) {
	            return null == e ? !n.isEmpty(this.changed) : n.has(this.changed, e);
	          }, changedAttributes: function changedAttributes(e) {
	            if (!e) return this.hasChanged() ? n.clone(this.changed) : !1;var t,
	                i = !1,
	                r = this._changing ? this._previousAttributes : this.attributes;for (var o in e) {
	              n.isEqual(r[o], t = e[o]) || ((i || (i = {}))[o] = t);
	            }return i;
	          }, previous: function previous(e) {
	            return null != e && this._previousAttributes ? this._previousAttributes[e] : null;
	          }, previousAttributes: function previousAttributes() {
	            return n.clone(this._previousAttributes);
	          }, fetch: function fetch(e) {
	            e = e ? n.clone(e) : {}, void 0 === e.parse && (e.parse = !0);var t = this,
	                i = e.success;return e.success = function (n) {
	              return t.set(t.parse(n, e), e) ? (i && i(t, n, e), void t.trigger(S("envz"), t, n, e)) : !1;
	            }, N(this, e), this.sync(S('"QADB'), this, e);
	          }, save: function save(e, t, i) {
	            var r,
	                o,
	                s,
	                a = this.attributes;if (null == e || "object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e)) ? (r = e, i = t) : (r = {})[e] = t, i = n.extend({ validate: !0 }, i), r && !i.wait) {
	              if (!this.set(r, i)) return !1;
	            } else if (!this._validate(r, i)) return !1;r && i.wait && (this.attributes = n.extend({}, a, r)), void 0 === i.parse && (i.parse = !0);var u = this,
	                l = i.success;return i.success = function (e) {
	              u.attributes = a;var t = u.parse(e, i);return i.wait && (t = n.extend(r || {}, t)), n.isObject(t) && !u.set(t, i) ? !1 : (l && l(u, e, i), void u.trigger(S("D6?)+"), u, e, i));
	            }, N(this, i), o = S(this.isNew() ? "tj|{oy" : i.patch ? "k}i}w" : "jPECWA"), o === S("C4$2$ ") && (i.attrs = r), s = this.sync(o, this, i), r && i.wait && (this.attributes = a), s;
	          }, destroy: function destroy(e) {
	            e = e ? n.clone(e) : {};var t = this,
	                i = e.success,
	                r = function r() {
	              t.trigger(S("+HH][B^K"), t, t.collection, e);
	            };if (e.success = function (n) {
	              (e.wait || t.isNew()) && r(), i && i(t, n, e), t.isNew() || t.trigger(S("ajzv"), t, n, e);
	            }, this.isNew()) return e.success(), !1;N(this, e);var o = this.sync(S("!FFH@RB"), this, e);return e.wait || r(), o;
	          }, url: function url() {
	            var e = n.result(this, S(" TPOvJIS")) || n.result(this.collection, S("ior")) || V();return this.isNew() ? e : e.replace(/([^\/])$/, S("@esl")) + encodeURIComponent(this.id);
	          }, parse: function parse(e, t) {
	            return e;
	          }, clone: function clone() {
	            return new this.constructor(this.attributes);
	          }, isNew: function isNew() {
	            return !this.has(this.idAttribute);
	          }, isValid: function isValid(e) {
	            return this._validate({}, n.extend(e || {}, { validate: !0 }));
	          }, _validate: function _validate(e, t) {
	            if (!t.validate || !this.validate) return !0;e = n.extend({}, this.attributes, e);var i = this.validationError = this.validate(e, t) || null;return i ? (this.trigger(S("=WQ6 .* "), this, i, n.extend(t, { validationError: i })), !1) : !0;
	          } });var h = [S("/[TK@"), S("\rxn|dw`"), S("mvRR"), S(")CEZH\\["), S("nvCJ"), S("\rabye")];n.each(h, function (e) {
	          f.prototype[e] = function () {
	            var t = s.call(arguments);return t.unshift(this.attributes), n[e].apply(n, t);
	          };
	        });var g = t.Collection = function (e, t) {
	          t || (t = {}), t.model && (this.model = t.model), void 0 !== t.comparator && (this.comparator = t.comparator), this._reset(), this.initialize.apply(this, arguments), e && this.reset(e, n.extend({ silent: !0 }, t));
	        },
	            p = { add: !0, remove: !0, merge: !0 },
	            m = { add: !0, remove: !1 };n.extend(g.prototype, a, { model: f, initialize: function initialize() {}, toJSON: function toJSON(e) {
	            return this.map(function (t) {
	              return t.toJSON(e);
	            });
	          }, sync: function sync() {
	            return t.sync.apply(this, arguments);
	          }, add: function add(e, t) {
	            return this.set(e, n.extend({ merge: !1 }, t, m));
	          }, remove: function remove(e, t) {
	            var i = !n.isArray(e);e = i ? [e] : n.clone(e), t || (t = {});var r, o, s, a;for (r = 0, o = e.length; o > r; r++) {
	              a = e[r] = this.get(e[r]), a && (delete this._byId[a.id], delete this._byId[a.cid], s = this.indexOf(a), this.models.splice(s, 1), this.length--, t.silent || (t.index = s, a.trigger(S("$WCJG_O"), a, this, t)), this._removeReference(a, t));
	            }return i ? e[0] : e;
	          }, set: function set(e, t) {
	            t = n.defaults({}, t, p), t.parse && (e = this.parse(e, t));var i = !n.isArray(e);e = i ? e ? [e] : [] : n.clone(e);var r,
	                o,
	                s,
	                a,
	                u,
	                l,
	                c,
	                d = t.at,
	                h = this.model,
	                g = this.comparator && null == d && t.sort !== !1,
	                m = n.isString(this.comparator) ? this.comparator : null,
	                v = [],
	                w = [],
	                y = {},
	                C = t.add,
	                x = t.merge,
	                b = t.remove,
	                E = !g && C && b ? [] : !1;for (r = 0, o = e.length; o > r; r++) {
	              if (u = e[r] || {}, s = u instanceof f ? a = u : u[h.prototype.idAttribute || S("ft")], l = this.get(s)) b && (y[l.cid] = !0), x && (u = u === a ? a.attributes : u, t.parse && (u = l.parse(u, t)), l.set(u, t), g && !c && l.hasChanged(m) && (c = !0)), e[r] = l;else if (C) {
	                if (a = e[r] = this._prepareModel(u, t), !a) continue;v.push(a), this._addReference(a, t);
	              }a = l || a, !E || !a.isNew() && y[a.id] || E.push(a), y[a.id] = !0;
	            }if (b) {
	              for (r = 0, o = this.length; o > r; ++r) {
	                y[(a = this.models[r]).cid] || w.push(a);
	              }w.length && this.remove(w, t);
	            }if (v.length || E && E.length) if (g && (c = !0), this.length += v.length, null != d) for (r = 0, o = v.length; o > r; r++) {
	              this.models.splice(d + r, 0, v[r]);
	            } else {
	              E && (this.models.length = 0);var _ = E || v;for (r = 0, o = _.length; o > r; r++) {
	                this.models.push(_[r]);
	              }
	            }if (c && this.sort({ silent: !0 }), !t.silent) {
	              for (r = 0, o = v.length; o > r; r++) {
	                (a = v[r]).trigger(S("{D"), a, this, t);
	              }(c || E && E.length) && this.trigger(S(":HSOJ"), this, t);
	            }return i ? e[0] : e;
	          }, reset: function reset(e, t) {
	            t || (t = {});for (var i = 0, r = this.models.length; r > i; i++) {
	              this._removeReference(this.models[i], t);
	            }return t.previousModels = this.models, this._reset(), e = this.add(e, n.extend({ silent: !0 }, t)), t.silent || this.trigger(S("}ubwg"), this, t), e;
	          }, push: function push(e, t) {
	            return this.add(e, n.extend({ at: this.length }, t));
	          }, pop: function pop(e) {
	            var t = this.at(this.length - 1);return this.remove(t, e), t;
	          }, unshift: function unshift(e, t) {
	            return this.add(e, n.extend({ at: 0 }, t));
	          }, shift: function shift(e) {
	            var t = this.at(0);return this.remove(t, e), t;
	          }, slice: function slice() {
	            return s.apply(this.models, arguments);
	          }, get: function get(e) {
	            return null == e ? void 0 : this._byId[e] || this._byId[e.id] || this._byId[e.cid];
	          }, at: function at(e) {
	            return this.models[e];
	          }, where: function where(e, t) {
	            return n.isEmpty(e) ? t ? void 0 : [] : this[S(t ? "+JD@K" : "iy}fvf")](function (t) {
	              for (var n in e) {
	                if (e[n] !== t.get(n)) return !1;
	              }return !0;
	            });
	          }, findWhere: function findWhere(e) {
	            return this.where(e, !0);
	          }, sort: function sort(e) {
	            if (!this.comparator) throw new Error(S("#gDHIG]\nXC_ZQAV@A^LQUNH_#./3%7'3';"));return e || (e = {}), n.isString(this.comparator) || 1 === this.comparator.length ? this.models = this.sortBy(this.comparator, this) : this.models.sort(n.bind(this.comparator, this)), e.silent || this.trigger(S("4FYEL"), this, e), this;
	          }, pluck: function pluck(e) {
	            return n.invoke(this.models, S(";[XJ"), e);
	          }, fetch: function fetch(e) {
	            e = e ? n.clone(e) : {}, void 0 === e.parse && (e.parse = !0);var t = e.success,
	                i = this;return e.success = function (n) {
	              var r = S(e.reset ? "B1!6#3" : "@2'7");i[r](n, e), t && t(i, n, e), i.trigger(S("8JCU_"), i, n, e);
	            }, N(this, e), this.sync(S(":IY\\Z"), this, e);
	          }, create: function create(e, t) {
	            if (t = t ? n.clone(t) : {}, !(e = this._prepareModel(e, t))) return !1;t.wait || this.add(e, t);var i = this,
	                r = t.success;return t.success = function (e, n) {
	              t.wait && i.add(e, t), r && r(e, n, t);
	            }, e.save(null, t), e;
	          }, parse: function parse(e, t) {
	            return e;
	          }, clone: function clone() {
	            return new this.constructor(this.models);
	          }, _reset: function _reset() {
	            this.length = 0, this.models = [], this._byId = {};
	          }, _prepareModel: function _prepareModel(e, t) {
	            if (e instanceof f) return e;t = t ? n.clone(t) : {}, t.collection = this;var i = new this.model(e, t);return i.validationError ? (this.trigger(S("f~gs}q"), this, i.validationError, t), !1) : i;
	          }, _addReference: function _addReference(e, t) {
	            this._byId[e.cid] = e, null != e.id && (this._byId[e.id] = e), e.collection || (e.collection = this), e.on(S("7YUV"), this._onModelEvent, this);
	          }, _removeReference: function _removeReference(e, t) {
	            this === e.collection && delete e.collection, e.off(S(";]QR"), this._onModelEvent, this);
	          }, _onModelEvent: function _onModelEvent(e, t, n, i) {
	            (e !== S("1SWP") && e !== S("D7#*'?/") || n === this) && (e === S("zzSUPL]") && this.remove(t, i), t && e === S(" BJBJBC") + t.idAttribute && (delete this._byId[t.previous(t.idAttribute)], null != t.id && (this._byId[t.id] = t)), this.trigger.apply(this, arguments));
	          } });var v = [S("\nmcKnsy"), S("|{xt"), S("rAQ"), S("8ZUWPX]K"), S("%TBL\\IN"), S("}sqzs"), S('E/)",)?'), S("B1!!3$-#,$9"), S("rzzsj"), S("{wqD"), S("wqastl"), S("$COK\\LX"), S("@2'/!&2"), S("0CWYQVB"), S("!GUAW_"), S("}qr"), S("||w"), S(")KEU"), S("%OIKE_OI"), S("s~|gu|xd"), S("'AG\\DGH"), S("@,#;"), S(".BY_"), S("D1):;+2"), S("B0-?#"), S("?&(000"), S("#L@GC"), S("4AW\\]"), S("*BBDZFQ]"), S("o{lT"), S("?4 +/"), S("nrn"), S("@-#00"), S("E1.<!%>8"), S('D!/!.,8.".+'), S("~v}cS{"), S("#WMSANEO"), S("}s``\\xs}aU}"), S("{`Qxfca"), S(" BJBMK"), S(">L!,2/!")];n.each(v, function (e) {
	          g.prototype[e] = function () {
	            var t = s.call(arguments);return t.unshift(this.models), n[e].apply(n, t);
	          };
	        });var w = [S("$BTH]YhR"), S(";_RKQ4;"), S("|cfQm"), S("E/),,2	5")];n.each(w, function (e) {
	          g.prototype[e] = function (t, i) {
	            var r = n.isFunction(t) ? t : function (e) {
	              return e.get(t);
	            };return n[e](this.models, r, i);
	          };
	        });var y = t.View = function (e) {
	          this.cid = n.uniqueId(S("2E]PA")), e || (e = {}), n.extend(this, n.pick(e, x)), this._ensureElement(), this.initialize.apply(this, arguments), this.delegateEvents();
	        },
	            C = /^(\S+)\s*(.*)$/,
	            x = [S("\f`aku}"), S("|OMNFGQOHF"), S("C!)"), S("#MA"), S("4TBCJPXNHXM"), S("l|pa`Zt{r"), S("-ZNWS^Q"), S("2VBPXCK")];n.extend(y.prototype, a, { tagName: S("B'-3"), $: function $(e) {
	            return this.$el.find(e);
	          }, initialize: function initialize() {}, render: function render() {
	            return this;
	          }, remove: function remove() {
	            return this.$el.remove(), this.stopListening(), this;
	          }, setElement: function setElement(e, n) {
	            return this.$el && this.undelegateEvents(), this.$el = e instanceof t.$ ? e : t.$(e), this.el = this.$el[0], n !== !1 && this.delegateEvents(), this;
	          }, delegateEvents: function delegateEvents(e) {
	            if (!e && !(e = n.result(this, S("%CQMG^X")))) return this;this.undelegateEvents();for (var t in e) {
	              var i = e[t];if (n.isFunction(i) || (i = this[e[t]]), i) {
	                var r = t.match(C),
	                    o = r[1],
	                    s = r[2];i = n.bind(i, this), o += S("2PPZR_XN^yK[Q42") + this.cid, "" === s ? this.$el.on(o, i) : this.$el.on(o, s, i);
	              }
	            }return this;
	          }, undelegateEvents: function undelegateEvents() {
	            return this.$el.off(S("Al'!)# )=/:( ;#") + this.cid), this;
	          }, _ensureElement: function _ensureElement() {
	            if (this.el) this.setElement(n.result(this, S("\nn`")), !1);else {
	              var e = n.extend({}, n.result(this, S("0PFGF\\TBL\\I")));this.id && (e.id = n.result(this, S("+EI"))), this.className && (e[S("s}s`g")] = n.result(this, S("\rmcqba]uxs")));var i = t.$("<" + n.result(this, S("&SINdJAH")) + ">").attr(e);this.setElement(i, !1);
	            }
	          } }), t.sync = function (e, i, r) {
	          var o = E[e];n.defaults(r || (r = {}), { emulateHTTP: t.emulateHTTP, emulateJSON: t.emulateJSON });var s = { type: o, dataType: S("|dww") };if (r.url || (s.url = n.result(i, S("/EC^")) || V()), null != r.data || !i || e !== S("<^LZ!5'") && e !== S("4@FSYM_") && e !== S("@1#7'-") || (s.contentType = S("?!12/-&'3!&$d&>!!"), s.data = JSON.stringify(r.attrs || i.toJSON(r))), r.emulateJSON && (s.contentType = S("6VHIVR_\\JV//m;i210e/%9!`;=<4<0;133"), s.data = s.data ? { model: s.data } : {}), r.emulateHTTP && (o === S("\r^ZD") || o === S("0uwqas") || o === S("B"))) {
	            s.type = S("0a}``"), r.emulateJSON && (s.data._method = o);var a = r.beforeSend;r.beforeSend = function (e) {
	              return e.setRequestHeader(S("0i{`afu\\NSSYp6$01-!#"), o), a ? a.apply(this, arguments) : void 0;
	            };
	          }s.type === S("(no") || r.emulateJSON || (s.processData = !1), s.type === S("7hxnxt") && b && (s.xhr = function () {
	            return new ActiveXObject(S("&jAJXD_BH[i|abg"));
	          });var u = r.xhr = t.ajax(n.extend(s, r));return i.trigger(S("'ZL[^I^Z"), i, u, r), u;
	        };var b = !("undefined" == typeof window || !window.ActiveXObject || window.XMLHttpRequest && new XMLHttpRequest().dispatchEvent),
	            E = { create: S("5fxkm"), update: S("$uss"), patch: S("8i{ou"), "delete": S("\rJJ\\TFV"), read: S("/wtf") };t.ajax = function () {
	          return t.$.ajax.apply(t.$, arguments);
	        };var _ = t.Router = function (e) {
	          e || (e = {}), e.routes && (this.routes = e.routes), this._bindRoutes(), this.initialize.apply(this, arguments);
	        },
	            F = /\((.*?)\)/g,
	            M = /(\(\?)?:\w+/g,
	            I = /\*\w+/g,
	            T = /[\-{}\[\]+?.,\\\^$|#\s]/g;n.extend(_.prototype, a, { initialize: function initialize() {}, route: function route(e, i, r) {
	            n.isRegExp(e) || (e = this._routeToRegExp(e)), n.isFunction(i) && (r = i, i = ""), r || (r = this[i]);var o = this;return t.history.route(e, function (n) {
	              var s = o._extractParameters(e, n);o.execute(r, s), o.trigger.apply(o, [S("&UG\\^N") + i].concat(s)), o.trigger(S("ishjz"), i, s), t.history.trigger(S("c}f`p"), o, i, s);
	            }), this;
	          }, execute: function execute(e, t) {
	            e && e.apply(this, t);
	          }, navigate: function navigate(e, n) {
	            return t.history.navigate(e, n), this;
	          }, _bindRoutes: function _bindRoutes() {
	            if (this.routes) {
	              this.routes = n.result(this, S("3FZCC]J"));for (var e, t = n.keys(this.routes); null != (e = t.pop());) {
	                this.route(e, this.routes[e]);
	              }
	            }
	          }, _routeToRegExp: function _routeToRegExp(e) {
	            return e = e.replace(T, S("H10")).replace(F, S(":i~")).replace(M, function (e, t) {
	              return t ? e : S("-tn\rn");
	            }).replace(I, S("/jl\fi	")), new RegExp("^" + e + S("'/+N,<NJdDJG154!;"));
	          }, _extractParameters: function _extractParameters(e, t) {
	            var i = e.exec(t).slice(1);return n.map(i, function (e, t) {
	              return t === i.length - 1 ? e || null : e ? decodeURIComponent(e) : null;
	            });
	          } });var R = t.History = function () {
	          this.handlers = [], n.bindAll(this, S("*HDHMDeC^")), "undefined" != typeof window && (this.location = window.location, this.history = window.history);
	        },
	            P = /^[#\/]|\s+$/g,
	            B = /^\/+|\/+$/g,
	            D = /msie [\w.]+/,
	            O = /\/$/,
	            A = /#.*$/;R.started = !1, n.extend(R.prototype, a, { interval: 50, atRoot: function atRoot() {
	            return this.location.pathname.replace(/[^\/]$/, S("108")) === this.root;
	          }, getHash: function getHash(e) {
	            var t = (e || this).location.href.match(/#(.*)$/);return t ? t[1] : "";
	          }, getFragment: function getFragment(e, t) {
	            if (null == e) if (this._hasPushState || !this._wantsHashChange || t) {
	              e = decodeURI(this.location.pathname + this.location.search);var n = this.root.replace(O, "");e.indexOf(n) || (e = e.slice(n.length));
	            } else e = this.getHash();return e.replace(P, "");
	          }, start: function start(e) {
	            if (R.started) throw new Error(S("Quv}uww5ttmkOS[LDUIEXNMIWRTW]FBVJM__"));R.started = !0, this.options = n.extend({ root: "/" }, this.options, e), this.root = this.options.root, this._wantsHashChange = this.options.hashChange !== !1, this._wantsPushState = !!this.options.pushState, this._hasPushState = !!(this.options.pushState && this.history && this.history.pushState);var i = this.getFragment(),
	                r = document.documentMode,
	                o = D.exec(navigator.userAgent.toLowerCase()) && (!r || 7 >= r);if (this.root = ("/" + this.root + "/").replace(B, "/"), o && this._wantsHashChange) {
	              var s = t.$(S("&rzorEQQGMI_KXO_G_DAWUQW^^D\x00qc|"));this.iframe = s.hide().appendTo(S("\foaki"))[0].contentWindow, this.navigate(i);
	            }this._hasPushState ? t.$(window).on(S("gwiio}i{"), this.checkUrl) : this._wantsHashChange && S("1]]\\TE_[Q[U[X") in window && !o ? t.$(window).on(S("7PXIS_U_Q'$"), this.checkUrl) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), this.fragment = i;var a = this.location;if (this._wantsHashChange && this._wantsPushState) {
	              if (!this._hasPushState && !this.atRoot()) return this.fragment = this.getFragment(null, !0), this.location.replace(this.root + "#" + this.fragment), !0;this._hasPushState && this.atRoot() && a.hash && (this.fragment = this.getHash().replace(P, ""), this.history.replaceState({}, document.title, this.root + this.fragment));
	            }return this.options.silent ? void 0 : this.loadUrl();
	          }, stop: function stop() {
	            t.$(window).off(S("\n{c}}{qew"), this.checkUrl).off(S("{uf~tpxt|y"), this.checkUrl), this._checkUrlInterval && clearInterval(this._checkUrlInterval), R.started = !1;
	          }, route: function route(e, t) {
	            this.handlers.unshift({ route: e, callback: t });
	          }, checkUrl: function checkUrl(e) {
	            var t = this.getFragment();return t === this.fragment && this.iframe && (t = this.getFragment(this.getHash(this.iframe))), t === this.fragment ? !1 : (this.iframe && this.navigate(t), void this.loadUrl());
	          }, loadUrl: function loadUrl(e) {
	            return e = this.fragment = this.getFragment(e), n.any(this.handlers, function (t) {
	              return t.route.test(e) ? (t.callback(e), !0) : void 0;
	            });
	          }, navigate: function navigate(e, t) {
	            if (!R.started) return !1;t && t !== !0 || (t = { trigger: !!t });var n = this.root + (e = this.getFragment(e || ""));if (e = e.replace(A, ""), this.fragment !== e) {
	              if (this.fragment = e, "" === e && "/" !== n && (n = n.slice(0, -1)), this._hasPushState) this.history[S(t.replace ? "0CWCXTURkM[OY" : "._EBZ`@TBR")]({}, document.title, n);else {
	                if (!this._wantsHashChange) return this.location.assign(n);this._updateHash(this.location, e, t.replace), this.iframe && e !== this.getFragment(this.getHash(this.iframe)) && (t.replace || this.iframe.document.open().close(), this._updateHash(this.iframe.location, e, t.replace));
	              }return t.trigger ? this.loadUrl(e) : void 0;
	            }
	          }, _updateHash: function _updateHash(e, t, n) {
	            if (n) {
	              var i = e.href.replace(/(javascript:|#).*$/, "");e.replace(i + "#" + t);
	            } else e.hash = "#" + t;
	          } }), t.history = new R();var K = function K(e, t) {
	          var i,
	              r = this;i = e && n.has(e, S("6TWWIONH]K/3")) ? e.constructor : function () {
	            return r.apply(this, arguments);
	          }, n.extend(i, r, t);var o = function o() {
	            this.constructor = i;
	          };return o.prototype = r.prototype, i.prototype = new o(), e && n.extend(i.prototype, e), i.__super__ = r.prototype, i;
	        };f.extend = g.extend = _.extend = y.extend = R.extend = K;var V = function V() {
	          throw new Error(S("\rO/2d`65fewiihd>pRDVJFRNGG\nFY^ZRT@DPU^^P__"));
	        },
	            N = function N(e, t) {
	          var n = t.error;t.error = function (i) {
	            n && n(e, i, t), e.trigger(S("=[M2.0"), e, i, t);
	          };
	        };return t;
	      }), function (e, t) {
	        if ("function" == typeof CKFinder.define && CKFinder.define.amd) CKFinder.define(S("rASKLJ@RSM"), [S("0SSP_WYY]"), S("<HP[%31 +7#")], function (n, i) {
	          return e.Marionette = e.Mn = t(e, n, i);
	        });else if (true) {
	          var n = __webpack_require__(320)(S("|~CJ@LJ@")),
	              i = __webpack_require__(320)(S("*^BIK]CR]AQ"));module.exports = t(e, n, i);
	        } else e.Marionette = e.Mn = t(e, e.Backbone, e._);
	      }(this, function (e, t, n) {
	        "use strict";
	        !function (e, t) {
	          var n = e.ChildViewContainer;return e.ChildViewContainer = function (e, t) {
	            var n = function n(e) {
	              this._views = {}, this._indexByModel = {}, this._indexByCustom = {}, this._updateLength(), t.each(e, this.add, this);
	            };t.extend(n.prototype, { add: function add(e, t) {
	                var n = e.cid;return this._views[n] = e, e.model && (this._indexByModel[e.model.cid] = n), t && (this._indexByCustom[t] = n), this._updateLength(), this;
	              }, findByModel: function findByModel(e) {
	                return this.findByModelCid(e.cid);
	              }, findByModelCid: function findByModelCid(e) {
	                var t = this._indexByModel[e];return this.findByCid(t);
	              }, findByCustom: function findByCustom(e) {
	                var t = this._indexByCustom[e];return this.findByCid(t);
	              }, findByIndex: function findByIndex(e) {
	                return t.values(this._views)[e];
	              }, findByCid: function findByCid(e) {
	                return this._views[e];
	              }, remove: function remove(e) {
	                var n = e.cid;return e.model && delete this._indexByModel[e.model.cid], t.any(this._indexByCustom, function (e, t) {
	                  return e === n ? (delete this._indexByCustom[t], !0) : void 0;
	                }, this), delete this._views[n], this._updateLength(), this;
	              }, call: function call(e) {
	                this.apply(e, t.tail(arguments));
	              }, apply: function apply(e, n) {
	                t.each(this._views, function (i) {
	                  t.isFunction(i[e]) && i[e].apply(i, n || []);
	                });
	              }, _updateLength: function _updateLength() {
	                this.length = t.size(this._views);
	              } });var i = [S('"EKWcFKA'), S("1WRW]"), S("zyi"), S("\rhf~u"), S("/TTFVWA"), S("0W[_@PD"), S('.\\U]WP@'), S("\fkeurf"), S("~jxlf"), S("vtu"), S(",^ABU"), S("&FFP"), S("D,($$<.."), S("uxvm{rrn"), S("(@D]CFK"), S("muZnof"), S(">Y)317"), S("(@DBXDOC"), S("!PFWQ"), S("|pag"), S("d}a~xmm"), S('"JW`KW\\P'), S("(YF^OF"), S("@3''1&#")];return t.each(i, function (e) {
	              n.prototype[e] = function () {
	                var n = t.values(this._views),
	                    i = [n].concat(t.toArray(arguments));return t[e].apply(t, i);
	              };
	            }), n;
	          }(e, t), e.ChildViewContainer.VERSION = S("'"), e.ChildViewContainer.noConflict = function () {
	            return e.ChildViewContainer = n, this;
	          }, e.ChildViewContainer;
	        }(t, n), function (e, t) {
	          var n = e.Wreqr,
	              i = e.Wreqr = {};return e.Wreqr.VERSION = S(">nrlv"), e.Wreqr.noConflict = function () {
	            return e.Wreqr = n, this;
	          }, i.Handlers = function (e, t) {
	            var n = function n(e) {
	              this.options = e, this._wreqrHandlers = {}, t.isFunction(this.initialize) && this.initialize(e);
	            };return n.extend = e.Model.extend, t.extend(n.prototype, e.Events, { setHandlers: function setHandlers(e) {
	                t.each(e, function (e, n) {
	                  var i = null;t.isObject(e) && !t.isFunction(e) && (i = e.context, e = e.callback), this.setHandler(n, e, i);
	                }, this);
	              }, setHandler: function setHandler(e, t, n) {
	                var i = { callback: t, context: n };this._wreqrHandlers[e] = i, this.trigger(S(",EOAT]WATRS"), e, t, n);
	              }, hasHandler: function hasHandler(e) {
	                return !!this._wreqrHandlers[e];
	              }, getHandler: function getHandler(e) {
	                var t = this._wreqrHandlers[e];if (t) return function () {
	                  return t.callback.apply(t.context, arguments);
	                };
	              }, removeHandler: function removeHandler(e) {
	                delete this._wreqrHandlers[e];
	              }, removeAllHandlers: function removeAllHandlers() {
	                this._wreqrHandlers = {};
	              } }), n;
	          }(e, t), i.CommandStorage = function () {
	            var n = function n(e) {
	              this.options = e, this._commands = {}, t.isFunction(this.initialize) && this.initialize(e);
	            };return t.extend(n.prototype, e.Events, { getCommands: function getCommands(e) {
	                var t = this._commands[e];return t || (t = { command: e, instances: [] }, this._commands[e] = t), t;
	              }, addCommand: function addCommand(e, t) {
	                var n = this.getCommands(e);n.instances.push(t);
	              }, clearCommands: function clearCommands(e) {
	                var t = this.getCommands(e);t.instances = [];
	              } }), n;
	          }(), i.Commands = function (e, t) {
	            return e.Handlers.extend({ storageType: e.CommandStorage, constructor: function constructor(t) {
	                this.options = t || {}, this._initializeStorage(this.options), this.on(S("*CMCJCUC\bRPQ"), this._executeCommands, this), e.Handlers.prototype.constructor.apply(this, arguments);
	              }, execute: function execute(e) {
	                e = arguments[0];var n = t.rest(arguments);this.hasHandler(e) ? this.getHandler(e).apply(this, n) : this.storage.addCommand(e, n);
	              }, _executeCommands: function _executeCommands(e, n, i) {
	                var r = this.storage.getCommands(e);t.each(r.instances, function (e) {
	                  n.apply(i, e);
	                }), this.storage.clearCommands(e);
	              }, _initializeStorage: function _initializeStorage(e) {
	                var n,
	                    i = e.storageType || this.storageType;n = t.isFunction(i) ? new i() : i, this.storage = n;
	              } });
	          }(i, t), i.RequestResponse = function (e, t) {
	            return e.Handlers.extend({ request: function request(e) {
	                return this.hasHandler(e) ? this.getHandler(e).apply(this, t.rest(arguments)) : void 0;
	              } });
	          }(i, t), i.EventAggregator = function (e, t) {
	            var n = function n() {};return n.extend = e.Model.extend, t.extend(n.prototype, e.Events), n;
	          }(e, t), i.Channel = function (n) {
	            var i = function i(t) {
	              this.vent = new e.Wreqr.EventAggregator(), this.reqres = new e.Wreqr.RequestResponse(), this.commands = new e.Wreqr.Commands(), this.channelName = t;
	            };return t.extend(i.prototype, { reset: function reset() {
	                return this.vent.off(), this.vent.stopListening(), this.reqres.removeAllHandlers(), this.commands.removeAllHandlers(), this;
	              }, connectEvents: function connectEvents(e, t) {
	                return this._connect(S('"UAKR'), e, t), this;
	              }, connectCommands: function connectCommands(e, t) {
	                return this._connect(S('>\\/,/"*!5'), e, t), this;
	              }, connectRequests: function connectRequests(e, t) {
	                return this._connect(S("A0&57#4"), e, t), this;
	              }, _connect: function _connect(e, n, i) {
	                if (n) {
	                  i = i || this;var r = e === S("\rxj~e") ? "on" : S("gpb_yw~wyo");t.each(n, function (n, o) {
	                    this[e][r](o, t.bind(n, i));
	                  }, this);
	                }
	              } }), i;
	          }(i), i.radio = function (e, t) {
	            var n = function n() {
	              this._channels = {}, this.vent = {}, this.commands = {}, this.reqres = {}, this._proxyMethods();
	            };t.extend(n.prototype, { channel: function channel(e) {
	                if (!e) throw new Error(S("&d@HDEIABEBFFPURQO_]P^-$"));return this._getChannel(e);
	              }, _getChannel: function _getChannel(t) {
	                var n = this._channels[t];return n || (n = new e.Channel(t), this._channels[t] = n), n;
	              }, _proxyMethods: function _proxyMethods() {
	                t.each([S("iEOV"), S(" BMNIDHC["), S("7J\\KIYN")], function (e) {
	                  t.each(i[e], function (t) {
	                    this[e][t] = r(this, e, t);
	                  }, this);
	                }, this);
	              } });var i = { vent: ["on", S("&HNO"), S("*_^DIHUC"), S("5YY[\\"), S("|d~b_}fbrvpt|"), S("rvSUGMpJ"), S("+@D][U_f\\{[UR")], commands: [S(" DZFGPRB"), S("'[L^cMCJCUC"), S(";OXJw!/&/!75"), S("$WCJG_OcMCJCUC"), S('9H^QRHZ-.%+"+-;9')], reqres: [S("?2$36!62"), S("=MZ4	#- )#5"), S("erlQ{uxq{mS"), S("$WCJG_OcMCJCUC"), S("2AQXYA]xVWt\\P[,$00")] },
	                r = function r(e, n, i) {
	              return function (r) {
	                var o = e._getChannel(r)[n];return o[i].apply(o, t.rest(arguments));
	              };
	            };return new n();
	          }(i, t), e.Wreqr;
	        }(t, n);var i = e.Marionette,
	            r = e.Mn,
	            o = t.Marionette = {};o.VERSION = S('"\n\b'), o.noConflict = function () {
	          return e.Marionette = i, e.Mn = r, this;
	        }, t.Marionette = o, o.Deferred = t.$.Deferred, o.extend = t.Model.extend, o.isNodeAttached = function (e) {
	          return t.$.contains(document.documentElement, e);
	        }, o.mergeOptions = function (e, t) {
	          e && n.extend(this, n.pick(e, t));
	        }, o.getOption = function (e, t) {
	          return e && t ? e.options && void 0 !== e.options[t] ? e.options[t] : e[t] : void 0;
	        }, o.proxyGetOption = function (e) {
	          return o.getOption(this, e);
	        }, o._getValue = function (e, t, i) {
	          return n.isFunction(e) && (e = i ? e.apply(t, i) : e.call(t)), e;
	        }, o.normalizeMethods = function (e) {
	          return n.reduce(e, function (e, t, i) {
	            return n.isFunction(t) || (t = this[t]), t && (e[i] = t), e;
	          }, {}, this);
	        }, o.normalizeUIString = function (e, t) {
	          return e.replace(/@ui\.[a-zA-Z_$0-9]*/g, function (e) {
	            return t[e.slice(4)];
	          });
	        }, o.normalizeUIKeys = function (e, t) {
	          return n.reduce(e, function (e, n, i) {
	            var r = o.normalizeUIString(i, t);return e[r] = n, e;
	          }, {});
	        }, o.normalizeUIValues = function (e, t, i) {
	          return n.each(e, function (r, s) {
	            n.isString(r) ? e[s] = o.normalizeUIString(r, t) : n.isObject(r) && n.isArray(i) && (n.extend(r, o.normalizeUIValues(n.pick(r, i), t)), n.each(i, function (e) {
	              var i = r[e];n.isString(i) && (r[e] = o.normalizeUIString(i, t));
	            }));
	          }), e;
	        }, o.actAsCollection = function (e, t) {
	          var i = [S("~vh^}~v"), S("(LKHD"), S("<P_O"), S("\fkgat"), S("!FFP@ES"), S("3R\\ZC]K"), S('"PAICD\\'), S("/BTXVWA"), S(")O]I_W"), S("%GKD"), S("B0+(#"), S("1S]M"), S("8PTXPHZZ"), S("*HCCZNY_A"), S(">V.7-(!"), S("@5-67'>"), S("E .::>"), S("ptrhts"), S("#V@US"), S(".CQBF"), S("&PA]BDYY"), S(" HQfIUR^"), S("A2/1&-")];n.each(i, function (i) {
	            e[i] = function () {
	              var e = n.values(n.result(this, t)),
	                  r = [e].concat(n.toArray(arguments));return n[i].apply(n, r);
	            };
	          });
	        };var s = o.deprecate = function (e, t) {
	          n.isObject(e) && (e = e.prev + S("5d8~urrz>kO@FWCJG_OO\fD@DYWR@BBJ\\") + S("A~vufs7mj;") + e.next + S("<WQ35'\" k") + (e.url ? S("Ef-,pk") + e.url : "")), void 0 !== t && t || s._cache[e] || (s._warn(S(",iK_BTQR@\\YYN[IRTPXza") + e), s._cache[e] = !0);
	        };s._warn = "undefined" != typeof console && (console.warn || console.log) || function () {}, s._cache = {}, o._triggerMethod = function () {
	          function e(e, t, n) {
	            return n.toUpperCase();
	          }var t = /(^|:)(\w)/gi;return function (i, r, o) {
	            var s = arguments.length < 3;s && (o = r, r = o[0]);var a,
	                u = "on" + r.replace(t, e),
	                l = i[u];return n.isFunction(l) && (a = l.apply(i, s ? n.rest(o) : o)), n.isFunction(i.trigger) && (s + o.length > 1 ? i.trigger.apply(i, s ? o : [r].concat(n.drop(o, 0))) : i.trigger(r)), a;
	          };
	        }(), o.triggerMethod = function (e) {
	          return o._triggerMethod(this, arguments);
	        }, o.triggerMethodOn = function (e) {
	          var t = n.isFunction(e.triggerMethod) ? e.triggerMethod : o.triggerMethod;return t.apply(e, n.rest(arguments));
	        }, o.MonitorDOMRefresh = function (e) {
	          function t() {
	            e._isShown = !0, i();
	          }function n() {
	            e._isRendered = !0, i();
	          }function i() {
	            e._isShown && e._isRendered && o.isNodeAttached(e.el) && o.triggerMethodOn(e, S("\fiab*cwufpe"), e);
	          }e._isDomRefreshMonitored || (e._isDomRefreshMonitored = !0, e.on({ show: t, render: n }));
	        }, function (e) {
	          function t(t, i, r, o) {
	            var s = o.split(/\s+/);n.each(s, function (n) {
	              var o = t[n];if (!o) throw new e.Error(S("]tf{{q65") + n + S("2BWDZUUZTYJ2$&c%6f&&i/=)#:o80<780${x;//|91:A\f\fEE"));t.listenTo(i, r, o);
	            });
	          }function i(e, t, n, i) {
	            e.listenTo(t, n, i);
	          }function r(e, t, i, r) {
	            var o = r.split(/\s+/);n.each(o, function (n) {
	              var r = e[n];e.stopListening(t, i, r);
	            });
	          }function o(e, t, n, i) {
	            e.stopListening(t, n, i);
	          }function s(t, i, r, o, s) {
	            if (i && r) {
	              if (!n.isObject(r)) throw new e.Error({ message: S("Myvzzre7ulio<{?AOLFOCD\\	EY\fK[ASE[\\Z"), url: S("wzntqqEUVF\nCSIK]CDB^\x00GD\\^YTD^WW_OHX\\V.%'-0,2>-?/%8>") });r = e._getValue(r, t), n.each(r, function (e, r) {
	                n.isFunction(e) ? o(t, i, r, e) : s(t, i, r, e);
	              });
	            }
	          }e.bindEntityEvents = function (e, n, r) {
	            s(e, n, r, i, t);
	          }, e.unbindEntityEvents = function (e, t, n) {
	            s(e, t, n, o, r);
	          }, e.proxyBindEntityEvents = function (t, n) {
	            return e.bindEntityEvents(this, t, n);
	          }, e.proxyUnbindEntityEvents = function (t, n) {
	            return e.unbindEntityEvents(this, t, n);
	          };
	        }(o);var a = [S(":_YN]M)16*++"), S("$COKMgKFI"), S("-BF^T|FYWSE"), S("w{vy"), S("$HCT[HMN"), "number"];return o.Error = o.extend.call(Error, { urlRoot: S('-F[DA\bXWEQVT^HI[U3o!,)j"(+:e=') + o.VERSION + "/", constructor: function constructor(e, t) {
	            n.isObject(e) ? (t = e, e = t.message) : t || (t = {});var i = Error.call(this, e);n.extend(this, n.pick(i, a), n.pick(t, a)), this.captureStackTrace(), t.url && (this.url = this.urlRoot + t.url);
	          }, captureStackTrace: function captureStackTrace() {
	            Error.captureStackTrace && Error.captureStackTrace(this, o.Error);
	          }, toString: function toString() {
	            return this.name + S("&\b") + this.message + (this.url ? S(")\nxIH") + this.url : "");
	          } }), o.Error.extend = o.extend, o.Callbacks = function () {
	          this._deferred = o.Deferred(), this._callbacks = [];
	        }, n.extend(o.Callbacks.prototype, { add: function add(e, t) {
	            var i = n.result(this._deferred, S("ihtqtmz"));this._callbacks.push({ cb: e, ctx: t }), i.then(function (n) {
	              t && (n.context = t), e.call(n.context, n.options);
	            });
	          }, run: function run(e, t) {
	            this._deferred.resolve({ options: e, context: t });
	          }, reset: function reset() {
	            var e = this._callbacks;this._deferred = o.Deferred(), this._callbacks = [], n.each(e, function (e) {
	              this.add(e.cb, e.ctx);
	            }, this);
	          } }), o.Controller = function (e) {
	          this.options = e || {}, n.isFunction(this.initialize) && this.initialize(this.options);
	        }, o.Controller.extend = o.extend, n.extend(o.Controller.prototype, t.Events, { destroy: function destroy() {
	            return o._triggerMethod(this, S("@#'%+7#},,9?>\"7"), arguments), o._triggerMethod(this, S('E"";=8$5'), arguments), this.stopListening(), this.off(), this;
	          }, triggerMethod: o.triggerMethod, mergeOptions: o.mergeOptions, getOption: o.proxyGetOption }), o.Object = function (e) {
	          this.options = n.extend({}, n.result(this, S("vjourpl")), e), this.initialize.apply(this, arguments);
	        }, o.Object.extend = o.extend, n.extend(o.Object.prototype, t.Events, { initialize: function initialize() {}, destroy: function destroy() {
	            return this.triggerMethod(S("'JLLD^HKUBFA[L")), this.triggerMethod(S("6S]JNISD")), this.stopListening(), this;
	          }, triggerMethod: o.triggerMethod, mergeOptions: o.mergeOptions, getOption: o.proxyGetOption, bindEntityEvents: o.proxyBindEntityEvents, unbindEntityEvents: o.proxyUnbindEntityEvents }), o.Region = o.Object.extend({ constructor: function constructor(e) {
	            if (this.options = e || {}, this.el = this.getOption(S("9_W")), this.el = this.el instanceof t.$ ? this.el[0] : this.el, !this.el) throw new o.Error({ name: S("9tTyQ{M2.0"), message: S('"bJBD\nFY^ZRT@DPU^^P__[QM` b1!"/(&g') });this.$el = this.getEl(this.el), o.Object.call(this, e);
	          }, show: function show(e, t) {
	            if (this._ensureElement()) {
	              this._ensureViewIsIntact(e), o.MonitorDOMRefresh(e);var i = t || {},
	                  r = e !== this.currentView,
	                  s = !!i.preventDestroy,
	                  a = !!i.forceShow,
	                  u = !!this.currentView,
	                  l = r && !s,
	                  c = r || a;if (u && this.triggerMethod(S('A &"*4"r:=*<;;'), this.currentView, this, t), this.currentView && delete this.currentView._parent, l ? this.empty() : u && c && this.currentView.off(S("?$$176*?"), this.empty, this), c) {
	                e.once(S("=ZZ350,="), this.empty, this), this._renderView(e), e._parent = this, u && this.triggerMethod(S("(KOMC_KCFSC"), e, this, t), this.triggerMethod(S('pvrzdr"jrtk'), e, this, t), o.triggerMethodOn(e, S("1PVRZDRJRTK"), e, this, t), u && this.triggerMethod(S("/CFSC{@B"), this.currentView, this, t);var d = o.isNodeAttached(this.el),
	                    f = [],
	                    h = n.extend({ triggerBeforeAttach: this.triggerBeforeAttach, triggerAttach: this.triggerAttach }, i);return d && h.triggerBeforeAttach && (f = this._displayedViews(e), this._triggerAttach(f, S("wsqwk!"))), this.attachHtml(e), this.currentView = e, d && h.triggerAttach && (f = this._displayedViews(e), this._triggerAttach(f)), u && this.triggerMethod(S("/CFSC"), e, this, t), this.triggerMethod(S("2@\\ZA"), e, this, t), o.triggerMethodOn(e, S("dpvm"), e, this, t), this;
	              }return this;
	            }
	          }, triggerBeforeAttach: !0, triggerAttach: !0, _triggerAttach: function _triggerAttach(e, t) {
	            var i = (t || "") + S("8XNO]^V");n.each(e, function (e) {
	              o.triggerMethodOn(e, i, e, this);
	            }, this);
	          }, _displayedViews: function _displayedViews(e) {
	            return n.union([e], n.result(e, S("=aX%5\f&71## /<?")) || []);
	          }, _renderView: function _renderView(e) {
	            e.supportsRenderLifecycle || o.triggerMethodOn(e, S("~xxpRDQAKBBZ"), e), e.render(), e.supportsRenderLifecycle || o.triggerMethodOn(e, S("C6 (#-;"), e);
	          }, _ensureElement: function _ensureElement() {
	            if (n.isObject(this.el) || (this.$el = this.getEl(this.el), this.el = this.$el[0]), !this.$el || 0 === this.$el.length) {
	              if (this.getOption(S("-OC\\^E~]FE^V^W"))) return !1;throw new o.Error(S("7yWYQ") + this.$el.selector + S(";qhmk\x00DZJWQNF	nda"));
	            }return !0;
	          }, _ensureViewIsIntact: function _ensureViewIsIntact(e) {
	            if (!e) throw new o.Error({ name: S("?('4\n*2)%#/"), message: S("#pMC^@O\\\f]O\\CTV]FBV]_]US[[` ,'d1.\":,,$>(n&>'3?=1xw6/{1(-+@EG\x00L\x00UX\nS") });if (e.isDestroyed) throw new o.Error({ name: S("#rLCPlLY_^BWJTt@A[G"), message: S("!tJARK@N\f") + e.cid + S("?bhb+%6f&$;/*(4n-54<s00%#*6#>8}?1A\n	HK^") });
	          }, getEl: function getEl(e) {
	            return t.$(e, o._getValue(this.options.parentEl, this));
	          }, attachHtml: function attachHtml(e) {
	            this.$el.contents().detach(), this.el.appendChild(e.el);
	          }, empty: function empty(e) {
	            var t = this.currentView,
	                n = e || {},
	                i = !!n.preventDestroy;return t ? (t.off(S(":_YNJM/8"), this.empty, this), this.triggerMethod(S("9X^ZRLZz$/30<"), t), i || this._destroyView(), this.triggerMethod(S("vlig"), t), delete this.currentView, i && this.$el.contents().detach(), this) : void 0;
	          }, _destroyView: function _destroyView() {
	            var e = this.currentView;e.isDestroyed || (e.supportsDestroyLifecycle || o.triggerMethodOn(e, S("z||tnx${ERVQK\\"), e), e.destroy ? e.destroy() : (e.remove(), e.isDestroyed = !0), e.supportsDestroyLifecycle || o.triggerMethodOn(e, S("DDQWVJ_"), e));
	          }, attachView: function attachView(e) {
	            return this.currentView && delete this.currentView._parent, e._parent = this, this.currentView = e, this;
	          }, hasView: function hasView() {
	            return !!this.currentView;
	          }, reset: function reset() {
	            return this.empty(), this.$el && (this.el = this.$el.selector), delete this.$el, this;
	          } }, { buildRegion: function buildRegion(e, t) {
	            if (n.isString(e)) return this._buildRegionFromSelector(e, t);if (e.selector || e.el || e.regionClass) return this._buildRegionFromObject(e, t);if (n.isFunction(e)) return this._buildRegionFromRegionClass(e);throw new o.Error({ message: S('0x_CFZFRJH^[TQQ`"--",!2:(>"##n;)!7}'), url: S("+AL\\F__WG@PE]^STRVK--a1!\"/(&d)$\"+'(%#3'=:8z, *>/") });
	          }, _buildRegionFromSelector: function _buildRegionFromSelector(e, t) {
	            return new t({ el: e });
	          }, _buildRegionFromObject: function _buildRegionFromObject(e, t) {
	            var i = e.regionClass || t,
	                r = n.omit(e, S("#W@JBK]EY"), S("C6 !.''	'->="));return e.selector && !r.el && (r.el = e.selector), new i(r);
	          }, _buildRegionFromRegionClass: function _buildRegionFromRegionClass(e) {
	            return new e();
	          } }), o.RegionManager = o.Controller.extend({ constructor: function constructor(e) {
	            this._regions = {}, this.length = 0, o.Controller.call(this, e), this.addRegions(this.getOption(S("\fkhy~|`")));
	          }, addRegions: function addRegions(e, t) {
	            return e = o._getValue(e, this, arguments), n.reduce(e, function (e, i, r) {
	              return n.isString(i) && (i = { selector: i }), i.selector && (i = n.defaults({}, i, t)), e[r] = this.addRegion(r, i), e;
	            }, {}, this);
	          }, addRegion: function addRegion(e, t) {
	            var n;return n = t instanceof o.Region ? t : o.Region.buildRegion(t, o.Region), this.triggerMethod(S("qqsye}#{x'lzGHMM"), e, n), n._parent = this, this._store(e, n), this.triggerMethod(S('"B@AUMNCDB'), e, n), n;
	          }, get: function get(e) {
	            return this._regions[e];
	          }, getRegions: function getRegions() {
	            return n.clone(this._regions);
	          }, removeRegion: function removeRegion(e) {
	            var t = this._regions[e];return this._remove(e, t), t;
	          }, removeRegions: function removeRegions() {
	            var e = this.getRegions();return n.each(this._regions, function (e, t) {
	              this._remove(t, e);
	            }, this), e;
	          }, emptyRegions: function emptyRegions() {
	            var e = this.getRegions();return n.invoke(e, S("?%,27=")), e;
	          }, destroy: function destroy() {
	            return this.removeRegions(), o.Controller.prototype.destroy.apply(this, arguments);
	          }, _store: function _store(e, t) {
	            this._regions[e] || this.length++, this._regions[e] = t;
	          }, _remove: function _remove(e, t) {
	            this.triggerMethod(S('*IIKA]U\x0B@VYZ@R\x02K_\\URP'), e, t), t.empty(), t.stopListening(), delete t._parent, delete this._regions[e], this.length--, this.triggerMethod(S("gszwo!nxyvOO"), e, t);
	          } }), o.actAsCollection(o.RegionManager.prototype, S("Gk|urpl")), o.TemplateCache = function (e) {
	          this.templateId = e;
	        }, n.extend(o.TemplateCache, { templateCaches: {}, get: function get(e, t) {
	            var n = this.templateCaches[e];return n || (n = new o.TemplateCache(e), this.templateCaches[e] = n), n.load(t);
	          }, clear: function clear() {
	            var e,
	                t = n.toArray(arguments),
	                i = t.length;if (i > 0) for (e = 0; i > e; e++) {
	              delete this.templateCaches[t[e]];
	            } else this.templateCaches = {};
	          } }), n.extend(o.TemplateCache.prototype, { load: function load(e) {
	            if (this.compiledTemplate) return this.compiledTemplate;var t = this.loadTemplate(this.templateId, e);return this.compiledTemplate = this.compileTemplate(t, e), this.compiledTemplate;
	          }, loadTemplate: function loadTemplate(e, n) {
	            var i = t.$(e);if (!i.length) throw new o.Error({ name: S("0]gQXF[YM_~NOQM"), message: S("S~gp5xxl9|rry>kELROEQC\b") + e + '"' });return i.html();
	          }, compileTemplate: function compileTemplate(e, t) {
	            return n.template(e, t);
	          } }), o.Renderer = { render: function render(e, t) {
	            if (!e) throw new o.Error({ name: S("4aSZHU[OYsQK.7- \x0045';"), message: S("8z[URRJ2$,'!7f3 ,j?) >#1%7s'<84=y3//}8>\fODIL\x00X") });var i = n.isFunction(e) ? e : o.TemplateCache.get(e);return i(t);
	          } }, o.View = t.View.extend({ isDestroyed: !1, supportsRenderLifecycle: !0, supportsDestroyLifecycle: !0, constructor: function constructor(e) {
	            this.render = n.bind(this.render, this), e = o._getValue(e, this), this.options = n.extend({}, n.result(this, S(";SMJV//1")), e), this._behaviors = o.Behaviors(this), t.View.call(this, this.options), o.MonitorDOMRefresh(this);
	          }, getTemplate: function getTemplate() {
	            return this.getOption(S("\fykb`}sgq"));
	          }, serializeModel: function serializeModel(e) {
	            return e.toJSON.apply(e, n.rest(arguments));
	          }, mixinTemplateHelpers: function mixinTemplateHelpers(e) {
	            e = e || {};var t = this.getOption(S("ew~dywc}Qwlxll"));return t = o._getValue(t, this), n.extend(e, t);
	          }, normalizeUIKeys: function normalizeUIKeys(e) {
	            var t = n.result(this, S("(v_BnD@KY_U@"));return o.normalizeUIKeys(e, t || n.result(this, S("D0/")));
	          }, normalizeUIValues: function normalizeUIValues(e, t) {
	            var i = n.result(this, S(")_B")),
	                r = n.result(this, S("7gLSyUSZV.&1"));return o.normalizeUIValues(e, r || i, t);
	          }, configureTriggers: function configureTriggers() {
	            if (this.triggers) {
	              var e = this.normalizeUIKeys(n.result(this, S("0E@ZSRSEK")));return n.reduce(e, function (e, t, n) {
	                return e[n] = this._buildViewTrigger(t), e;
	              }, {}, this);
	            }
	          }, delegateEvents: function delegateEvents(e) {
	            return this._delegateDOMEvents(e), this.bindEntityEvents(this.model, this.getOption(S(")GDHHBjFT\\GG"))), this.bindEntityEvents(this.collection, this.getOption(S("8ZUWPX]K).,2 (3;"))), n.each(this._behaviors, function (e) {
	              e.bindEntityEvents(this.model, e.getOption(S("spDDNfR@HS["))), e.bindEntityEvents(this.collection, e.getOption(S("1Q\\XYSTLPUUyK[Q42")));
	            }, this), this;
	          }, _delegateDOMEvents: function _delegateDOMEvents(e) {
	            var i = o._getValue(e || this.events, this);i = this.normalizeUIKeys(i), n.isUndefined(e) && (this.events = i);var r = {},
	                s = n.result(this, S("(KOCM[G@BtDVZAE")) || {},
	                a = this.configureTriggers(),
	                u = n.result(this, S("$GCOI_CD^y\\FWVWAG")) || {};n.extend(r, s, i, a, u), t.View.prototype.delegateEvents.call(this, r);
	          }, undelegateEvents: function undelegateEvents() {
	            return t.View.prototype.undelegateEvents.apply(this, arguments), this.unbindEntityEvents(this.model, this.getOption(S("uv~~pXhzNUQ"))), this.unbindEntityEvents(this.collection, this.getOption(S("2P[YZR[MSTRxHZ.51"))), n.each(this._behaviors, function (e) {
	              e.unbindEntityEvents(this.model, e.getOption(S(".B_UW_qCSYLJ"))), e.unbindEntityEvents(this.collection, e.getOption(S(".L_]^VWA_XV|L^RIM")));
	            }, this), this;
	          }, _ensureViewIsIntact: function _ensureViewIsIntact() {
	            if (this.isDestroyed) throw new o.Error({ name: S("G{vcQsdlkubyy[mRNP"), message: S("*}EHYR[W") + this.cid + S("1=5~vk9{wnx{Y@FAKCMZ^YCTKKP\\WVWYVVN^XJ3$&m") });
	          }, destroy: function destroy() {
	            if (this.isDestroyed) return this;var e = n.toArray(arguments);return this.triggerMethod.apply(this, [S("!@FBJTBMOXX_AV")].concat(e)), this.isDestroyed = !0, this.triggerMethod.apply(this, [S("C  53:&3")].concat(e)), this.unbindUIElements(), this.isRendered = !1, this.remove(), n.invoke(this._behaviors, S("*OI^Z]_H"), e), this;
	          }, bindUIElements: function bindUIElements() {
	            this._bindUIElements(), n.invoke(this._behaviors, this._bindUIElements);
	          }, _bindUIElements: function _bindUIElements() {
	            if (this.ui) {
	              this._uiBindings || (this._uiBindings = this.ui);var e = n.result(this, S("7gLSyUSZV.&1"));this.ui = {}, n.each(e, function (e, t) {
	                this.ui[t] = this.$(e);
	              }, this);
	            }
	          }, unbindUIElements: function unbindUIElements() {
	            this._unbindUIElements(), n.invoke(this._behaviors, this._unbindUIElements);
	          }, _unbindUIElements: function _unbindUIElements() {
	            this.ui && this._uiBindings && (n.each(this.ui, function (e, t) {
	              delete this.ui[t];
	            }, this), this.ui = this._uiBindings, delete this._uiBindings);
	          }, _buildViewTrigger: function _buildViewTrigger(e) {
	            var t = n.defaults({}, e, { preventDefault: !0, stopPropagation: !0 }),
	                i = n.isObject(e) ? t.event : e;return function (e) {
	              e && (e.preventDefault && t.preventDefault && e.preventDefault(), e.stopPropagation && t.stopPropagation && e.stopPropagation());var n = { view: this, model: this.model, collection: this.collection };this.triggerMethod(i, n);
	            };
	          }, setElement: function setElement() {
	            var e = t.View.prototype.setElement.apply(this, arguments);return n.invoke(this._behaviors, S("%VUGQS}EHYB^BVFA_RK"), this), e;
	          }, triggerMethod: function triggerMethod() {
	            var e = o._triggerMethod(this, arguments);return this._triggerEventOnBehaviors(arguments), this._triggerEventOnParentLayout(arguments[0], n.rest(arguments)), e;
	          }, _triggerEventOnBehaviors: function _triggerEventOnBehaviors(e) {
	            for (var t = o._triggerMethod, n = this._behaviors, i = 0, r = n && n.length; r > i; i++) {
	              t(n[i], e);
	            }
	          }, _triggerEventOnParentLayout: function _triggerEventOnParentLayout(e, t) {
	            var i = this._parentLayoutView();if (i) {
	              var r = o.getOption(i, S("9YSUQZi)$52 (3;/-%5")),
	                  s = r + ":" + e,
	                  a = [this].concat(t);o._triggerMethod(i, s, a);var u = o.getOption(i, S("\fnff|uWeq{bd")),
	                  l = i.normalizeMethods(u);l && n.isFunction(l[e]) && l[e].apply(i, a);
	            }
	          }, _getImmediateChildren: function _getImmediateChildren() {
	            return [];
	          }, _getNestedViews: function _getNestedViews() {
	            var e = this._getImmediateChildren();return e.length ? n.reduce(e, function (e, t) {
	              return t._getNestedViews ? e.concat(t._getNestedViews()) : e;
	            }, e) : e;
	          }, _getAncestors: function _getAncestors() {
	            for (var e = [], t = this._parent; t;) {
	              e.push(t), t = t._parent;
	            }return e;
	          }, _parentLayoutView: function _parentLayoutView() {
	            var e = this._getAncestors();return n.find(e, function (e) {
	              return e instanceof o.LayoutView;
	            });
	          }, normalizeMethods: o.normalizeMethods, mergeOptions: o.mergeOptions, getOption: o.proxyGetOption, bindEntityEvents: o.proxyBindEntityEvents, unbindEntityEvents: o.proxyUnbindEntityEvents }), o.ItemView = o.View.extend({ constructor: function constructor() {
	            o.View.apply(this, arguments);
	          }, serializeData: function serializeData() {
	            if (!this.model && !this.collection) return {};var e = [this.model || this.collection];return arguments.length && e.push.apply(e, arguments), this.model ? this.serializeModel.apply(this, e) : { items: this.serializeCollection.apply(this, e) };
	          }, serializeCollection: function serializeCollection(e) {
	            return e.toJSON.apply(e, n.rest(arguments));
	          }, render: function render() {
	            return this._ensureViewIsIntact(), this.triggerMethod(S("vppxj| iyszzR"), this), this._renderTemplate(), this.isRendered = !0, this.bindUIElements(), this.triggerMethod(S("}uvvf"), this), this;
	          }, _renderTemplate: function _renderTemplate() {
	            var e = this.getTemplate();if (e !== !1) {
	              if (!e) throw new o.Error({ name: S("7mW^^ZTPZ$'.4)'3-\f89#?"), message: S("Wtxywm:iyszzRVKARBEYFJXH\\Y_QV\\BQJUIQR/3b6*!#!!'//b") });var t = this.mixinTemplateHelpers(this.serializeData()),
	                  n = o.Renderer.render(e, t, this);return this.attachElContent(n), this;
	            }
	          }, attachElContent: function attachElContent(e) {
	            return this.$el.html(e), this;
	          } }), o.CollectionView = o.View.extend({ childViewEventPrefix: S("5U_QU^MUXI"), sort: !0, constructor: function constructor(e) {
	            this.once(S("bt|wqg"), this._initialEvents), this._initChildViewStorage(), o.View.apply(this, arguments), this.on({ "before:show": this._onBeforeShowCalled, show: this._onShowCalled, "before:attach": this._onBeforeAttachCalled, attach: this._onAttachCalled }), this.initRenderBuffer();
	          }, initRenderBuffer: function initRenderBuffer() {
	            this._bufferedChildren = [];
	          }, startBuffering: function startBuffering() {
	            this.initRenderBuffer(), this.isBuffering = !0;
	          }, endBuffering: function endBuffering() {
	            var e,
	                t = this._isShown && o.isNodeAttached(this.el);this.isBuffering = !1, this._isShown && this._triggerMethodMany(this._bufferedChildren, this, S("#F@@HZLXDBY")), t && this._triggerBeforeAttach && (e = this._getNestedViews(), this._triggerMethodMany(e, this, S("'JLLD^HNDESP\\"))), this.attachBuffer(this, this._createBuffer()), t && this._triggerAttach && (e = this._getNestedViews(), this._triggerMethodMany(e, this, S(">^45# ,"))), this._isShown && this._triggerMethodMany(this._bufferedChildren, this, S("C7-)0")), this.initRenderBuffer();
	          }, _triggerMethodMany: function _triggerMethodMany(e, t, i) {
	            var r = n.drop(arguments, 3);n.each(e, function (e) {
	              o.triggerMethodOn.apply(e, [e, i, e, t].concat(r));
	            });
	          }, _initialEvents: function _initialEvents() {
	            this.collection && (this.listenTo(this.collection, S("|z{"), this._onCollectionAdd), this.listenTo(this.collection, S("bt|bp"), this._onCollectionRemove), this.listenTo(this.collection, S("6E]J_O"), this.render), this.getOption(S("(ZEYX")) && this.listenTo(this.collection, S("nqmT"), this._sortViews));
	          }, _onCollectionAdd: function _onCollectionAdd(e, t, i) {
	            var r = void 0 !== i.at && (i.index || t.indexOf(e));if ((this.getOption(S("2U]YBRJ")) || r === !1) && (r = n.indexOf(this._filteredSortedModels(r), e)), this._shouldAddChild(e, r)) {
	              this.destroyEmptyView();var o = this.getChildView(e);this.addChild(e, o, r);
	            }
	          }, _onCollectionRemove: function _onCollectionRemove(e) {
	            var t = this.children.findByModel(e);this.removeChildView(t), this.checkEmpty();
	          }, _onBeforeShowCalled: function _onBeforeShowCalled() {
	            this._triggerBeforeAttach = this._triggerAttach = !1, this.children.each(function (e) {
	              o.triggerMethodOn(e, S("BDDLV@T@F]"), e);
	            });
	          }, _onShowCalled: function _onShowCalled() {
	            this.children.each(function (e) {
	              o.triggerMethodOn(e, S("+_EAX"), e);
	            });
	          }, _onBeforeAttachCalled: function _onBeforeAttachCalled() {
	            this._triggerBeforeAttach = !0;
	          }, _onAttachCalled: function _onAttachCalled() {
	            this._triggerAttach = !0;
	          }, render: function render() {
	            return this._ensureViewIsIntact(), this.triggerMethod(S("tr~vh~&o{qDDP"), this), this._renderChildren(), this.isRendered = !0, this.triggerMethod(S("9H^RY[M"), this), this;
	          }, reorder: function reorder() {
	            var e = this.children,
	                t = this._filteredSortedModels(),
	                i = n.find(t, function (t) {
	              return !e.findByModel(t);
	            });if (i) this.render();else {
	              var r = n.map(t, function (t, n) {
	                var i = e.findByModel(t);return i._index = n, i.el;
	              });this.triggerMethod(S('C&  (:,p9)"<+5#')), this._appendReorderedChildren(r), this.triggerMethod(S('7J\\UIXXL'));
	            }
	          }, resortView: function resortView() {
	            o.getOption(this, S("<O[P2%'1+(:=")) ? this.reorder() : this.render();
	          }, _sortViews: function _sortViews() {
	            var e = this._filteredSortedModels(),
	                t = n.find(e, function (e, t) {
	              var n = this.children.findByModel(e);return !n || n._index !== t;
	            }, this);t && this.resortView();
	          }, _emptyViewIndex: -1, _appendReorderedChildren: function _appendReorderedChildren(e) {
	            this.$el.append(e);
	          }, _renderChildren: function _renderChildren() {
	            this.destroyEmptyView(), this.destroyChildren({ checkEmpty: !1 }), this.isEmpty(this.collection) ? this.showEmptyView() : (this.triggerMethod(S("u}uiy'lzNEGQFIKDLI_EB@"), this), this.startBuffering(), this.showCollection(), this.endBuffering(), this.triggerMethod(S("kuxxl%CNNOAFRNGG"), this), this.children.isEmpty() && this.getOption(S("*MEAZJB")) && this.showEmptyView());
	          }, showCollection: function showCollection() {
	            var e,
	                t = this._filteredSortedModels();n.each(t, function (t, n) {
	              e = this.getChildView(t), this.addChild(t, e, n);
	            }, this);
	          }, _filteredSortedModels: function _filteredSortedModels(e) {
	            var t = this.getViewComparator(),
	                i = this.collection.models;if (e = Math.min(Math.max(e, 0), i.length - 1), t) {
	              var r;e && (r = i[e], i = i.slice(0, e).concat(i.slice(e + 1))), i = this._sortModelsBy(i, t), r && i.splice(e, 0, r);
	            }return this.getOption(S("A$*(1#5")) && (i = n.filter(i, function (e, t) {
	              return this._shouldAddChild(e, t);
	            }, this)), i;
	          }, _sortModelsBy: function _sortModelsBy(e, t) {
	            return "string" == typeof t ? n.sortBy(e, function (e) {
	              return e.get(t);
	            }, this) : 1 === t.length ? n.sortBy(e, t, this) : e.sort(n.bind(t, this));
	          }, showEmptyView: function showEmptyView() {
	            var e = this.getEmptyView();if (e && !this._showingEmptyView) {
	              this.triggerMethod(S("\fokicw)fpxs}k ~qmjf")), this._showingEmptyView = !0;var n = new t.Model();this.addEmptyView(n, e), this.triggerMethod(S("kuxxl%ELRW]"));
	            }
	          }, destroyEmptyView: function destroyEmptyView() {
	            this._showingEmptyView && (this.triggerMethod(S("9X^ZRLZz3'.+3#}-$:?5")), this.destroyChildren(), delete this._showingEmptyView, this.triggerMethod(S("@3'.+3#}-$:?5")));
	          }, getEmptyView: function getEmptyView() {
	            return this.getOption(S("\fhcdhDzqb"));
	          }, addEmptyView: function addEmptyView(e, t) {
	            var i,
	                r = this._isShown && !this.isBuffering && o.isNodeAttached(this.el),
	                s = this.getOption(S("6RUINBjT[H16*++5")) || this.getOption(S(">\\((.',#09>\"##="));n.isFunction(s) && (s = s.call(this, e, this._emptyViewIndex));var a = this.buildChildView(e, t, s);a._parent = this, this.proxyChildEvents(a), a.once(S('"QAKBBZ'), function () {
	              this._isShown && o.triggerMethodOn(a, S("2QQSYE]ISSJ"), a), r && this._triggerBeforeAttach && (i = this._getViewAndNested(a), this._triggerMethodMany(i, this, S('5TR^VH^\\JK!"*')));
	            }, this), this.children.add(a), this.renderChildView(a, this._emptyViewIndex), r && this._triggerAttach && (i = this._getViewAndNested(a), this._triggerMethodMany(i, this, S("pfguv~"))), this._isShown && o.triggerMethodOn(a, S("=MW/6"), a);
	          }, getChildView: function getChildView(e) {
	            var t = this.getOption(S("rzzxq@~}n"));if (!t) throw new o.Error({ name: S("nNaKMIBqAL]n^_A]"), message: S("*j\fMGY]Ve]PATOHH\\Z`22&', .--") });return t;
	          }, addChild: function addChild(e, t, n) {
	            var i = this.getOption(S("p||zsNplSmjvOOQ"));i = o._getValue(i, this, [e, n]);var r = this.buildChildView(e, t, i);return this._updateIndices(r, !0, n), this.triggerMethod(S("8[_]SO[!%&y'-/+,"), r), this._addChildView(r, n), this.triggerMethod(S("7Y]^_UWS$"), r), r._parent = this, r;
	          }, _updateIndices: function _updateIndices(e, t, n) {
	            this.getOption(S("orlk")) && (t && (e._index = n), this.children.each(function (n) {
	              n._index >= e._index && (n._index += t ? 1 : -1);
	            }));
	          }, _addChildView: function _addChildView(e, t) {
	            var n,
	                i = this._isShown && !this.isBuffering && o.isNodeAttached(this.el);this.proxyChildEvents(e), e.once(S("!PFJACU"), function () {
	              this._isShown && !this.isBuffering && o.triggerMethodOn(e, S("x~zrlzRJLS"), e), i && this._triggerBeforeAttach && (n = this._getViewAndNested(e), this._triggerMethodMany(n, this, S("&EMOEYIO[DPQ[")));
	            }, this), this.children.add(e), this.renderChildView(e, t), i && this._triggerAttach && (n = this._getViewAndNested(e), this._triggerMethodMany(n, this, S("xno}~v"))), this._isShown && !this.isBuffering && o.triggerMethodOn(e, S("lHNU"), e);
	          }, renderChildView: function renderChildView(e, t) {
	            return e.supportsRenderLifecycle || o.triggerMethodOn(e, S("wsqwk!nxp{ES"), e), e.render(), e.supportsRenderLifecycle || o.triggerMethodOn(e, S("0CW]PPD"), e), this.attachHtml(this, e, t), e;
	          }, buildChildView: function buildChildView(e, t, i) {
	            var r = n.extend({ model: e }, i),
	                s = new t(r);return o.MonitorDOMRefresh(s), s;
	          }, removeChildView: function removeChildView(e) {
	            return e ? (this.triggerMethod(S('3VPPXJ\\\x00IYPQI%{!+-)"'), e), e.supportsDestroyLifecycle || o.triggerMethodOn(e, S(";^XXP2$x'!625'0"), e), e.destroy ? e.destroy() : e.remove(), e.supportsDestroyLifecycle || o.triggerMethodOn(e, S(")NN_Y\\@I"), e), delete e._parent, this.stopListening(e), this.children.remove(e), this.triggerMethod(S("7J\\WTJX\\((.'"), e), this._updateIndices(e, !1), e) : e;
	          }, isEmpty: function isEmpty() {
	            return !this.collection || 0 === this.collection.length;
	          }, checkEmpty: function checkEmpty() {
	            this.isEmpty(this.collection) && this.showEmptyView();
	          }, attachBuffer: function attachBuffer(e, t) {
	            e.$el.append(t);
	          }, _createBuffer: function _createBuffer() {
	            var e = document.createDocumentFragment();return n.each(this._bufferedChildren, function (t) {
	              e.appendChild(t.el);
	            }), e;
	          }, attachHtml: function attachHtml(e, t, n) {
	            e.isBuffering ? e._bufferedChildren.splice(n, 0, t) : e._insertBefore(t, n) || e._insertAfter(t);
	          }, _insertBefore: function _insertBefore(e, t) {
	            var n,
	                i = this.getOption(S("b|{")) && t < this.children.length - 1;return i && (n = this.children.find(function (e) {
	              return e._index === t + 1;
	            })), n ? (n.$el.before(e.el), !0) : !1;
	          }, _insertAfter: function _insertAfter(e) {
	            this.$el.append(e.el);
	          }, _initChildViewStorage: function _initChildViewStorage() {
	            this.children = new t.ChildViewContainer();
	          }, destroy: function destroy() {
	            return this.isDestroyed ? this : (this.triggerMethod(S("&EMOEYIJJCE@\\MUXTU_XHTQQ")), this.destroyChildren({ checkEmpty: !1 }), this.triggerMethod(S(':_YNJM/8x +)*"+=#$"')), o.View.prototype.destroy.apply(this, arguments));
	          }, destroyChildren: function destroyChildren(e) {
	            var t = e || {},
	                i = !0,
	                r = this.children.map(n.identity);return n.isUndefined(t.checkEmpty) || (i = t.checkEmpty), this.children.each(this.removeChildView, this), i && this.checkEmpty(), r;
	          }, _shouldAddChild: function _shouldAddChild(e, t) {
	            var i = this.getOption(S("9\\RPI[M"));return !n.isFunction(i) || i.call(this, e, t, this.collection);
	          }, proxyChildEvents: function proxyChildEvents(e) {
	            var t = this.getOption(S(">\\((.',#0\r?/%8<*68*"));this.listenTo(e, S("C%)*"), function () {
	              var i = n.toArray(arguments),
	                  r = i[0],
	                  o = this.normalizeMethods(n.result(this, S(")ICEAJjFT\\GG")));i[0] = t + ":" + r, i.splice(1, 0, e), "undefined" != typeof o && n.isFunction(o[r]) && o[r].apply(this, i.slice(1)), this.triggerMethod.apply(this, i);
	            });
	          }, _getImmediateChildren: function _getImmediateChildren() {
	            return n.values(this.children._views);
	          }, _getViewAndNested: function _getViewAndNested(e) {
	            return [e].concat(n.result(e, S("-qHUE|VGASSnP_LO")) || []);
	          }, getViewComparator: function getViewComparator() {
	            return this.getOption(S(",[GJGr]^DTDVLVH"));
	          } }), o.CompositeView = o.CollectionView.extend({ constructor: function constructor() {
	            o.CollectionView.apply(this, arguments);
	          }, _initialEvents: function _initialEvents() {
	            this.collection && (this.listenTo(this.collection, S("(HNO"), this._onCollectionAdd), this.listenTo(this.collection, S("%TBEF\\N"), this._onCollectionRemove), this.listenTo(this.collection, S(" SGPAQ"), this._renderChildren), this.getOption(S("#WJTS")) && this.listenTo(this.collection, S("B0+72"), this._sortViews));
	          }, getChildView: function getChildView(e) {
	            var t = this.getOption(S("/SY[_Pc_RO")) || this.constructor;return t;
	          }, serializeData: function serializeData() {
	            var e = {};return this.model && (e = n.partial(this.serializeModel, this.model).apply(this, arguments)), e;
	          }, render: function render() {
	            return this._ensureViewIsIntact(), this._isRendering = !0, this.resetChildViewContainer(), this.triggerMethod(S("vppxj| iyszzR"), this), this._renderTemplate(), this._renderChildren(), this._isRendering = !1, this.isRendered = !0, this.triggerMethod(S("/BT\\WQG"), this), this;
	          }, _renderChildren: function _renderChildren() {
	            (this.isRendered || this._isRendering) && o.CollectionView.prototype._renderChildren.call(this);
	          }, _renderTemplate: function _renderTemplate() {
	            var e = {};e = this.serializeData(), e = this.mixinTemplateHelpers(e), this.triggerMethod(S("9X^ZRLZz3'-  4}<,'; ,:*"));var t = this.getTemplate(),
	                n = o.Renderer.render(t, e, this);this.attachElContent(n), this.bindUIElements(), this.triggerMethod(S('6E]W^^NJZ-1."0 '));
	          }, attachElContent: function attachElContent(e) {
	            return this.$el.html(e), this;
	          }, attachBuffer: function attachBuffer(e, t) {
	            var n = this.getChildViewContainer(e);n.append(t);
	          }, _insertAfter: function _insertAfter(e) {
	            var t = this.getChildViewContainer(this, e);t.append(e.el);
	          }, _appendReorderedChildren: function _appendReorderedChildren(e) {
	            var t = this.getChildViewContainer(this);t.append(e);
	          }, getChildViewContainer: function getChildViewContainer(e, t) {
	            if (e.$childViewContainer) return e.$childViewContainer;var n,
	                i = o.getOption(e, S("/SY[_Pc_ROzUUH\\WQ%3"));if (i) {
	              var r = o._getValue(i, e);if (n = "@" === r.charAt(0) && e.ui ? e.ui[r.substr(4)] : e.$(r), n.length <= 0) throw new o.Error({ name: S('6tPPV_jT[H.,7%,(":#8?$ (# <&'), message: S("%rOM	Y[INGIYTVV^^T]lRYJ}P.5#** 4eh>+8l#!;p7=&:1lw") + e.childViewContainer });
	            } else n = e.$el;return e.$childViewContainer = n, n;
	          }, resetChildViewContainer: function resetChildViewContainer() {
	            this.$childViewContainer && (this.$childViewContainer = void 0);
	          } }), o.LayoutView = o.ItemView.extend({ regionClass: o.Region, options: { destroyImmediate: !1 }, childViewEventPrefix: S("\fnff|udzqb"), constructor: function constructor(e) {
	            e = e || {}, this._firstRender = !0, this._initializeRegions(e), o.ItemView.call(this, e);
	          }, render: function render() {
	            return this._ensureViewIsIntact(), this._firstRender ? this._firstRender = !1 : this._reInitializeRegions(), o.ItemView.prototype.render.apply(this, arguments);
	          }, destroy: function destroy() {
	            return this.isDestroyed ? this : (this.getOption(S("'LLY_^BWf]\\WW]TBR")) === !0 && this.$el.remove(), this.regionManager.destroy(), o.ItemView.prototype.destroy.apply(this, arguments));
	          }, showChildView: function showChildView(e, t) {
	            return this.getRegion(e).show(t);
	          }, getChildView: function getChildView(e) {
	            return this.getRegion(e).currentView;
	          }, addRegion: function addRegion(e, t) {
	            var n = {};return n[e] = t, this._buildRegions(n)[e];
	          }, addRegions: function addRegions(e) {
	            return this.regions = n.extend({}, this.regions, e), this._buildRegions(e);
	          }, removeRegion: function removeRegion(e) {
	            return delete this.regions[e], this.regionManager.removeRegion(e);
	          }, getRegion: function getRegion(e) {
	            return this.regionManager.get(e);
	          }, getRegions: function getRegions() {
	            return this.regionManager.getRegions();
	          }, _buildRegions: function _buildRegions(e) {
	            var t = { regionClass: this.getOption(S("<O[X).,\x00($54")), parentEl: n.partial(n.result, this, S("&BD")) };return this.regionManager.addRegions(e, t);
	          }, _initializeRegions: function _initializeRegions(e) {
	            var t;this._initRegionManager(), t = o._getValue(this.regions, this, [e]) || {};var i = this.getOption.call(e, S('B1!"/(&:'));i = o._getValue(i, this, [e]), n.extend(t, i), t = this.normalizeUIValues(t, [S("4FS[]ZNTN"), S("1W_")]), this.addRegions(t);
	          }, _reInitializeRegions: function _reInitializeRegions() {
	            this.regionManager.invoke(S("e}jo"));
	          }, getRegionManager: function getRegionManager() {
	            return new o.RegionManager();
	          }, _initRegionManager: function _initRegionManager() {
	            this.regionManager = this.getRegionManager(), this.regionManager._parent = this, this.listenTo(this.regionManager, S("D'#!';/q-)*u\"45:;;"), function (e) {
	              this.triggerMethod(S(">]%'-1!'#,s8.+$!!"), e);
	            }), this.listenTo(this.regionManager, S("x~&o{xINL"), function (e, t) {
	              this[e] = t, this.triggerMethod(S("E'#,s8.+$!!"), e, t);
	            }), this.listenTo(this.regionManager, S('?"$$,6 |5-$%=)w<*78=='), function (e) {
	              this.triggerMethod(S('A &"*4"r;/&#;+u"45:;;'), e);
	            }), this.listenTo(this.regionManager, S("5DRUVL^O[X).,"), function (e, t) {
	              delete this[e], this.triggerMethod(S("\nyi`ayu+`vs|yy"), e, t);
	            });
	          }, _getImmediateChildren: function _getImmediateChildren() {
	            return n.chain(this.regionManager.getRegions()).pluck(S("lec`vza@~}n")).compact().value();
	          } }), o.Behavior = o.Object.extend({ constructor: function constructor(e, t) {
	            this.view = t, this.defaults = n.result(this, S("D!#!)<&??")) || {}, this.options = n.extend({}, this.defaults, e), this.ui = n.extend({}, n.result(t, S("\r{f")), n.result(this, S(")_B"))), o.Object.apply(this, arguments);
	          }, $: function $() {
	            return this.view.$.apply(this.view, arguments);
	          }, destroy: function destroy() {
	            return this.stopListening(), this;
	          }, proxyViewProperties: function proxyViewProperties(e) {
	            this.$el = e.$el, this.el = e.el;
	          } }), o.Behaviors = function (e, t) {
	          function n(e, i) {
	            return t.isObject(e.behaviors) ? (i = n.parseBehaviors(e, i || t.result(e, S("%DB@H\\BC_]"))), n.wrap(e, i, t.keys(s)), i) : {};
	          }function i(e, t) {
	            this._view = e, this._behaviors = t, this._triggers = {};
	          }function r(e) {
	            return e._uiBindings || e.ui;
	          }var o = /^(\S+)\s*(.*)$/,
	              s = { behaviorTriggers: function behaviorTriggers(e, t) {
	              var n = new i(this, t);return n.buildBehaviorTriggers();
	            }, behaviorEvents: function behaviorEvents(n, i) {
	              var s = {};return t.each(i, function (n, i) {
	                var a = {},
	                    u = t.clone(t.result(n, S('D 0"&=9'))) || {};u = e.normalizeUIKeys(u, r(n));var l = 0;t.each(u, function (e, r) {
	                  var s = r.match(o),
	                      u = s[1] + "." + [this.cid, i, l++, " "].join(""),
	                      c = s[2],
	                      d = u + c,
	                      f = t.isFunction(e) ? e : n[e];a[d] = t.bind(f, n);
	                }, this), s = t.extend(s, a);
	              }, this), s;
	            } };return t.extend(n, { behaviorsLookup: function behaviorsLookup() {
	              throw new e.Error({ message: S("J{`6zmjn;xxxvNDTL@TB\bPE^^\rLJXPDZ[GEYK_OIQM%%l"), url: S("bqc{|zpbc}7x~t|hvOSQ\rLQKKKOCM[G@BB^\\[^CG") });
	            }, getBehaviorClass: function getBehaviorClass(t, i) {
	              return t.behaviorClass ? t.behaviorClass : e._getValue(n.behaviorsLookup, this, [t, i])[i];
	            }, parseBehaviors: function parseBehaviors(e, i) {
	              return t.chain(i).map(function (i, r) {
	                var o = n.getBehaviorClass(i, r),
	                    s = new o(i, e),
	                    a = n.parseBehaviors(e, t.result(s, S("6U]Q[MURLL")));return [s].concat(a);
	              }).flatten().value();
	            }, wrap: function wrap(e, n, i) {
	              t.each(i, function (i) {
	                e[i] = t.partial(s[i], e[i], n);
	              });
	            } }), t.extend(i.prototype, { buildBehaviorTriggers: function buildBehaviorTriggers() {
	              return t.each(this._behaviors, this._buildTriggerHandlersForBehavior, this), this._triggers;
	            }, _buildTriggerHandlersForBehavior: function _buildTriggerHandlersForBehavior(n, i) {
	              var o = t.clone(t.result(n, S("2GF\\QP]KI"))) || {};o = e.normalizeUIKeys(o, r(n)), t.each(o, t.bind(this._setHandlerForBehavior, this, n, i));
	            }, _setHandlerForBehavior: function _setHandlerForBehavior(e, t, n, i) {
	              var r = i.replace(/^\S+/, function (e) {
	                return e + "." + S("3VP^VNPUIHOWX'$00") + t;
	              });this._triggers[r] = this._view._buildViewTrigger(n);
	            } }), n;
	        }(o, n), o.AppRouter = t.Router.extend({ constructor: function constructor(e) {
	            this.options = e || {}, t.Router.apply(this, arguments);var n = this.getOption(S("+M]^}_DFVG")),
	                i = this._getController();this.processAppRoutes(i, n), this.on(S("-\\@EEW"), this._processOnRoute, this);
	          }, appRoute: function appRoute(e, t) {
	            var n = this._getController();this._addAppRoute(n, e, t);
	          }, _processOnRoute: function _processOnRoute(e, t) {
	            if (n.isFunction(this.onRoute)) {
	              var i = n.invert(this.getOption(S("2RDEdXMM_H")))[e];this.onRoute(e, i, t);
	            }
	          }, processAppRoutes: function processAppRoutes(e, t) {
	            if (t) {
	              var i = n.keys(t).reverse();n.each(i, function (n) {
	                this._addAppRoute(e, n, t[n]);
	              }, this);
	            }
	          }, _getController: function _getController() {
	            return this.getOption(S('>\\//61+)*":'));
	          }, _addAppRoute: function _addAppRoute(e, t, i) {
	            var r = e[i];if (!r) throw new o.Error(S("3yPB_W]") + i + S("=7 1c**2g.&?%(m!!p%:6t699,+5708,"));this.route(t, i, n.bind(r, e));
	          }, mergeOptions: o.mergeOptions, getOption: o.proxyGetOption, triggerMethod: o.triggerMethod, bindEntityEvents: o.proxyBindEntityEvents, unbindEntityEvents: o.proxyUnbindEntityEvents }), o.Application = o.Object.extend({ constructor: function constructor(e) {
	            this._initializeRegions(e), this._initCallbacks = new o.Callbacks(), this.submodules = {}, n.extend(this, e), this._initChannel(), o.Object.apply(this, arguments);
	          }, execute: function execute() {
	            this.commands.execute.apply(this.commands, arguments);
	          }, request: function request() {
	            return this.reqres.request.apply(this.reqres, arguments);
	          }, addInitializer: function addInitializer(e) {
	            this._initCallbacks.add(e);
	          }, start: function start(e) {
	            this.triggerMethod(S("B!!#)5-s9?-?:"), e), this._initCallbacks.run(e, this), this.triggerMethod(S("B00$43"), e);
	          }, addRegions: function addRegions(e) {
	            return this._regionManager.addRegions(e);
	          }, emptyRegions: function emptyRegions() {
	            return this._regionManager.emptyRegions();
	          }, removeRegion: function removeRegion(e) {
	            return this._regionManager.removeRegion(e);
	          }, getRegion: function getRegion(e) {
	            return this._regionManager.get(e);
	          }, getRegions: function getRegions() {
	            return this._regionManager.getRegions();
	          }, module: function module(e, t) {
	            var i = o.Module.getClass(t),
	                r = n.toArray(arguments);return r.unshift(this), i.create.apply(i, r);
	          }, getRegionManager: function getRegionManager() {
	            return new o.RegionManager();
	          }, _initializeRegions: function _initializeRegions(e) {
	            var t = n.isFunction(this.regions) ? this.regions(e) : this.regions || {};this._initRegionManager();var i = o.getOption(e, S("D7# !&$8"));return n.isFunction(i) && (i = i.call(this, e)), n.extend(t, i), this.addRegions(t), this;
	          }, _initRegionManager: function _initRegionManager() {
	            this._regionManager = this.getRegionManager(), this._regionManager._parent = this, this.listenTo(this._regionManager, S("vppxj| zxy$mEFKLJ"), function () {
	              o._triggerMethod(this, S("qqsye}#{x'lzGHMM"), arguments);
	            }), this.listenTo(this._regionManager, S("0PVWGSPQVT"), function (e, t) {
	              this[e] = t, o._triggerMethod(this, S("<\\Z[z3'$-*("), arguments);
	            }), this.listenTo(this._regionManager, S(".MUW]AQDRUVL^O[X).,"), function () {
	              o._triggerMethod(this, S("swu{gs-j|wtjx$mEFKLJ"), arguments);
	            }), this.listenTo(this._regionManager, S("gszwo!nxyvOO"), function (e) {
	              delete this[e], o._triggerMethod(this, S("'ZLGDZH]UV[\\Z"), arguments);
	            });
	          }, _initChannel: function _initChannel() {
	            this.channelName = n.result(this, S("7[Q[URXRq!,'")) || S(" FNLFDJ"), this.channel = n.result(this, S("E%/)'$. ")) || t.Wreqr.radio.channel(this.channelName), this.vent = n.result(this, S("3BPXC")) || this.channel.vent, this.commands = n.result(this, S("%EHEDKEH^")) || this.channel.commands, this.reqres = n.result(this, S(" SGRV@U")) || this.channel.reqres;
	          } }), o.Module = function (e, t, i) {
	          this.moduleName = e, this.options = n.extend({}, this.options, i), this.initialize = i.initialize || this.initialize, this.submodules = {}, this._setupInitializersAndFinalizers(), this.app = t, n.isFunction(this.initialize) && this.initialize(e, t, this.options);
	        }, o.Module.extend = o.extend, n.extend(o.Module.prototype, t.Events, { startWithParent: !0, initialize: function initialize() {}, addInitializer: function addInitializer(e) {
	            this._initializerCallbacks.add(e);
	          }, addFinalizer: function addFinalizer(e) {
	            this._finalizerCallbacks.add(e);
	          }, start: function start(e) {
	            this._isInitialized || (n.each(this.submodules, function (t) {
	              t.startWithParent && t.start(e);
	            }), this.triggerMethod(S("1PVRZDRJNZNI"), e), this._initializerCallbacks.run(e, this), this._isInitialized = !0, this.triggerMethod(S("8JNZNI"), e));
	          }, stop: function stop() {
	            this._isInitialized && (this._isInitialized = !1, this.triggerMethod(S("6U]_UIYMK/1")), n.invoke(this.submodules, S(" RVLT")), this._finalizerCallbacks.run(void 0, this), this._initializerCallbacks.reset(), this._finalizerCallbacks.reset(), this.triggerMethod(S(",^Z@@")));
	          }, addDefinition: function addDefinition(e, t) {
	            this._runModuleDefinition(e, t);
	          }, _runModuleDefinition: function _runModuleDefinition(e, i) {
	            if (e) {
	              var r = n.flatten([this, this.app, t, o, t.$, n, i]);e.apply(this, r);
	            }
	          }, _setupInitializersAndFinalizers: function _setupInitializersAndFinalizers() {
	            this._initializerCallbacks = new o.Callbacks(), this._finalizerCallbacks = new o.Callbacks();
	          }, triggerMethod: o.triggerMethod }), n.extend(o.Module, { create: function create(e, t, i) {
	            var r = e,
	                o = n.drop(arguments, 3);t = t.split(".");var s = t.length,
	                a = [];return a[s - 1] = i, n.each(t, function (t, n) {
	              var s = r;r = this._getModule(s, t, e, i), this._addModuleDefinition(s, r, a[n], o);
	            }, this), r;
	          }, _getModule: function _getModule(e, t, i, r, o) {
	            var s = n.extend({}, r),
	                a = this.getClass(r),
	                u = e[t];return u || (u = new a(t, i, s), e[t] = u, e.submodules[t] = u), u;
	          }, getClass: function getClass(e) {
	            var t = o.Module;return e ? e.prototype instanceof t ? e : e.moduleClass || t : t;
	          }, _addModuleDefinition: function _addModuleDefinition(e, t, n, i) {
	            var r = this._getDefine(n),
	                o = this._getStartWithParent(n, t);r && t.addDefinition(r, i), this._addStartWithParent(e, t, o);
	          }, _getStartWithParent: function _getStartWithParent(e, t) {
	            var i;return n.isFunction(e) && e.prototype instanceof o.Module ? (i = t.constructor.prototype.startWithParent, n.isUndefined(i) ? !0 : i) : n.isObject(e) ? (i = e.startWithParent, n.isUndefined(i) ? !0 : i) : !0;
	          }, _getDefine: function _getDefine(e) {
	            return !n.isFunction(e) || e.prototype instanceof o.Module ? n.isObject(e) ? e.define : null : e;
	          }, _addStartWithParent: function _addStartWithParent(e, t, n) {
	            t.startWithParent = t.startWithParent && n, t.startWithParent && !t.startWithParentIsConfigured && (t.startWithParentIsConfigured = !0, e.addInitializer(function (e) {
	              t.startWithParent && t.start(e);
	            }));
	          } }), o;
	      }), CKFinder.define(S("'kblBBIK]r]]R\\Q"), [], function () {
	        "use strict";
	        var e = { id: "", configPath: S(">\\//$*#k,4"), language: "", languages: { bg: 1, ca: 1, cs: 1, cy: 1, da: 1, de: 1, el: 1, en: 1, eo: 1, es: 1, "es-mx": 1, et: 1, eu: 1, fa: 1, fi: 1, fr: 1, gu: 1, he: 1, hi: 1, hr: 1, hu: 1, it: 1, ja: 1, ko: 1, ku: 1, lt: 1, lv: 1, nb: 1, nl: 1, no: 1, nn: 1, pl: 1, "pt-br": 1, ro: 1, ru: 1, sk: 1, sl: 1, sr: 1, sv: 1, tr: 1, vi: 1, "zh-cn": 1, "zh-tw": 1 }, defaultLanguage: S("j~"), removeModules: "", plugins: "", tabIndex: 0, resourceType: null, type: null, startupPath: "", startupFolderExpanded: !0, readOnly: !1, readOnlyExclude: "", connectorPath: "", connectorLanguage: S("._XA"), pass: "", connectorInfo: "", dialogMinWidth: S("+#yp"), dialogMinHeight: S("\n?i`"), dialogFocusItem: !0, dialogOverlaySwatch: !1, loaderOverlaySwatch: !1, width: S("\r?? 4"), height: 400, fileIcons: { "default": S(".Z^Z\\\\C[GV^"), folder: S(".KYCWP@ZDNIT\\"), "7z": S("%]YDL"), accdb: S("5WT[\\IHMPX"), avi: S("kw{EN\fSJB"), bmp: S("?),#$!k6)/"), css: S("(JYX]@H"), csv: S("#GVP	XGM"), doc: S("{dovh2mpx"), docx: S(":VOJQM$o2-#"), flac: S("*JYIG@A\\T"), gif: S("{~urs9hw}"), gz: S("(]KY]@H"), htm: S("@)6.(k6)/"), html: S("@)6.(k6)/"), jpeg: S('D,+&/,d;"*'), jpg: S("\nbalij>a|t"), js: S('A("2$5$: :?b= ('), log: S("/\\^UD[Q"), mp3: S("E'2, %e<#)"), mp4: S("@7+'!*h7&."), odg: S("B'6$1i8'-"), odp: S("!KNTWCT[ZEK"), ods: S("C'$*$f9$,"), odt: S("kowkES\fSJB"), ogg: S("ATFJKVIO"), opus: S("vm}st2mpx"), pdf: S("._TWCZR"), php: S("C4-6i8'-"), png: S("7QT[\\YNQ'"), ppt: S("ksj{mPNKMPVIO"), pptx: S("5FXO\\HKSTPKn1,$"), rar: S("bp`=d{q"), README: S("@3'\" (#i8'-"), rtf: S("bet=d{q"), sql: S("@23/j5( "), tar: S("8M[IMPX"), tiff: S("{~urs9hw}"), txt: S("\r~cqx|=d{q"), wav: S("tcsqv4krz"), weba: S("\roztx}=d{q"), webm: S('<KW[%.l3*"'), xls: S("6R@Z_WMPX"), xlsx: S("pnt}u4krz"), zip: S("k{c:exp") }, fileIconsPath: S("C7./);f)$>(a)9=7~=699+v"), fileIconsSizes: S("\"$$?%'.;.-6/$1--\f"), defaultDisplayFileName: !0, defaultDisplayDate: !0, defaultDisplayFileSize: !0, thumbnailDelay: 50, thumbnailDefaultSize: 150, thumbnailMinSize: null, thumbnailMaxSize: null, thumbnailSizeStep: 2, thumbnailClasses: { 120: S("|}p~"), 180: S("8T__UHS") }, chooseFiles: !1, chooseFilesOnDblClick: !0, chooseFilesClosePopup: !0, resizeImages: !0, rememberLastFolder: !0, skin: S("vsrpp"), swatch: "a", displayFoldersPanel: !0, jquery: S("cysa<~dcrj`4qo"), jqueryMobile: S("}we8rho~nd0rOCKOALT"), jqueryMobileStructureCSS: S("qw}SHRQ@T^DEIEAKCE@FWACE]YHO"), jqueryMobileIconsCSS: "", iconsCSS: "", themeCSS: "", coreCSS: S("D6-.&:e(#?+`3:4::13%v:)("), primaryPanelWidth: "", secondaryPanelWidth: "", cors: !1, corsSelect: !1, editImageMode: "", editImageAdjustments: [S("xiuzvkNDQP"), S("2P[[BEYJN"), S(":^DMQL53'"), S(")YJXX\\NDX]]"), S("i~lt"), S(":HT\\LO%/")], editImagePresets: [S("r~rf|bn"), S("ywaYt|rkmc"), S("/^^AGUYQ^Y"), S("2C][^XT\\"), S("|e`zgp"), S("osuh|yz")], autoCloseHTML5Upload: 5, uiModeThreshold: 48 };return e;
	      }), CKFinder.define(S("YPZtp{ES\rfR@HS"), [], function () {
	        "use strict";
	        function e() {}function t(e) {
	          var t = e.getPrivate && e.getPrivate() || e._ev || (e._ev = {});return t.events || (t.events = {});
	        }function n(e) {
	          this.name = e, this.listeners = [];
	        }function i(e) {
	          var i = t(this);return i[e] || (i[e] = new n(e));
	        }return n.prototype = { getListenerIndex: function getListenerIndex(e) {
	            for (var t = 0, n = this.listeners; t < n.length; t++) {
	              if (n[t].fn === e) return t;
	            }return -1;
	          } }, e.prototype = { on: function on(e, t, n, r, o) {
	            function s(i, o, s, u) {
	              var l = { name: e, sender: this, finder: i, data: o, listenerData: r, stop: s, cancel: u, removeListener: a },
	                  c = t.call(n, l);return c === !1 ? !1 : l.data;
	            }function a() {
	              d.removeListener(e, t);
	            }var u,
	                l,
	                c = i.call(this, e),
	                d = this;if (c.getListenerIndex(t) < 0) {
	              for (u = c.listeners, n || (n = this), isNaN(o) && (o = 10), s.fn = t, s.priority = o, l = u.length - 1; l >= 0; l--) {
	                if (u[l].priority <= o) return u.splice(l + 1, 0, s), { removeListener: a };
	              }u.unshift(s);
	            }return { removeListener: a };
	          }, once: function once() {
	            var e = arguments[1];return arguments[1] = function (t) {
	              return t.removeListener(), e.apply(this, arguments);
	            }, this.on.apply(this, arguments);
	          }, fire: function () {
	            var e = 0,
	                n = function n() {
	              e = 1;
	            },
	                i = 0,
	                r = function r() {
	              i = 1;
	            };return function (o, s, a) {
	              var u,
	                  l,
	                  c,
	                  d,
	                  f = t(this)[o],
	                  S = e,
	                  h = i;if (e = 0, i = 0, f && (c = f.listeners, c.length)) for (c = c.slice(0), u = 0; u < c.length; u++) {
	                if (f.errorProof) try {
	                  d = c[u].call(this, a, s, n, r);
	                } catch (g) {} else d = c[u].call(this, a, s, n, r);if (d === !1 ? i = 1 : "undefined" != typeof d && (s = d), e || i) break;
	              }return l = i ? !1 : "undefined" == typeof s ? !0 : s, e = S, i = h, l;
	            };
	          }(), fireOnce: function fireOnce(e, n, i) {
	            var r = this.fire(e, n, i);return delete t(this)[e], r;
	          }, removeListener: function removeListener(e, n) {
	            var i,
	                r = t(this)[e];r && (i = r.getListenerIndex(n), i >= 0 && r.listeners.splice(i, 1));
	          }, removeAllListeners: function removeAllListeners() {
	            var e,
	                n = t(this);for (e in n) {
	              delete n[e];
	            }
	          }, hasListeners: function hasListeners(e) {
	            var n = t(this)[e];return n && n.listeners.length > 0;
	          } }, e;
	      }), CKFinder.define(S("RYU}{rrj6Oouq1JTHN"), [S("B6*!#5;*%9)")], function (e) {
	        "use strict";
	        var t = { url: function url(e) {
	            return (/^(http(s)?:)?\/\/.+/i.test(e) ? e : CKFinder.require.toUrl(e)
	            );
	          }, asyncArrayTraverse: function asyncArrayTraverse(e, t, n) {
	            var _i,
	                r = 50,
	                o = 10,
	                s = 0;n || (n = null), t = t.bind(n), (_i = function i() {
	              for (var n, a = 0, u = new Date().getTime();;) {
	                if (n = e.item ? e.item(s) : e[s], !n || t(n, s, e) === !1) return;if (s += 1, a += 1, a >= o && new Date().getTime() - u > r) return setTimeout(_i, r);
	              }
	            }).call();
	          }, isPopup: function isPopup() {
	            return window !== window.parent && !!window.opener || window.isCKFinderPopup;
	          }, isModal: function isModal() {
	            return window.parent.CKFinder && window.parent.CKFinder.modal && window.parent.CKFinder.modal(S("jtmvBMG"));
	          }, isWidget: function isWidget() {
	            return window !== window.parent && !window.opener;
	          }, toGet: function toGet(t) {
	            var n = "";return e.forOwn(t, function (e, i) {
	              n += "&" + encodeURIComponent(i) + "=" + encodeURIComponent(t[i]);
	            }), n.substring(1);
	          }, cssEntities: function cssEntities(e) {
	            return e.replace(/\(/g, S("1\r\r\r\n\x00")).replace(/\)/g, S(')3( (26"&#'));
	          }, jsCssEntities: function jsCssEntities(e) {
	            return e.replace(/\(/g, S("!")).replace(/\)/g, S("7!-"));
	          }, getUrlParams: function getUrlParams() {
	            var e = {};return window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (t, n, i) {
	              e[n] = i;
	            }), e;
	          }, parentFolder: function parentFolder(e) {
	            return e.split("/").slice(0, -1).join("/");
	          }, isShortcut: function isShortcut(t, n) {
	            var i = n.split("+"),
	                r = !!t.ctrlKey || !!t.metaKey,
	                o = !!t.altKey,
	                s = !!t.shiftKey,
	                a = r === (e.contains(i, S("}kRM")) ? !0 : !1),
	                u = o === (e.contains(i, S("\rocd")) ? !0 : !1),
	                l = s === (e.contains(i, S("9ISU[J")) ? !0 : !1);return a && u && l;
	          }, randomString: function randomString(e, t) {
	            t || (t = S(".NRRVVRR^^RRVVRRNN226622>>2y{yy{ygik"));for (var n = "", i = 0; e > i; i++) {
	              n += t.charAt(Math.floor(Math.random() * t.length));
	            }return n;
	          } };return t;
	      }), CKFinder.define(S("P_Sy||h4IiwsmCMC"), [S(".Z^UWAGVYE]"), S("!HRQ@T^"), S("{r|D{qq}AM")], function (e, t, n) {
	        "use strict";
	        function i(e, t, i, o) {
	          function s(t) {
	            o(e, JSON.parse(t));
	          }function a() {
	            o(e);
	          }e || (e = r.getSupportedLanguage(navigator.userLanguage || navigator.language, i)), i[t] || (t = S("\fh`"));var u,
	              l = S("=R^.&m") + t + S("!zb}}");i[e] && (u = S("0]S]S") + e + S("=~fyy")), u || (u = l), n.require([S("6C]AN") + n.require.toUrl(u) + S("2\fBPD\nPI@OWX")], s, a);
	        }var r = { loadPluginLang: function loadPluginLang(t, i, r, o) {
	            var s,
	                a = r.lang.split(",");if (e.indexOf(a, t) >= 0) s = t;else {
	              if (!(e.indexOf(a, i) >= 0)) return void o({});s = i;
	            }n.require([S("xhv{1") + n.require.toUrl(r.path) + S("7TXT\\") + s + S("<TL//")], function (e) {
	              var t;try {
	                t = JSON.parse(e);
	              } catch (n) {
	                t = {};
	              }o(t);
	            }, function () {
	              o({});
	            });
	          }, init: function init(n) {
	            var r = new t.Deferred();return i(n.language, n.defaultLanguage, n.languages, function (t, n) {
	              if (!n) return void r.reject();var i = n;i.formatDate = function () {
	                var e = S(" z") + i.DateAmPm.join(S("*\f\x00\n")) + S("2i"),
	                    t = i.DateTime.replace(/dd|mm|yyyy|hh|HH|MM|aa|d|m|yy|h|H|M|a/g, function (t) {
	                  var n = { d: S("vrm;drhu{xy51A\f"), dd: S("#@D_"), m: S("uvtot3lzPMC@A\r	y\f"), mm: S("tuuhu"), yy: S("\ftknb?afvfbe0+3"), yyyy: S("'QLKY"), H: S("#LJSU[O[@LMJl"), HH: S(",EAZB"), h: S('5\x1E\x17PVOI\x1C\x01\x1E\x0Era}c,*35hsjclen\'?$ syugexpzp|lno@HL\x17\x0B6\x12\x15\x01\x07\rCEC\x1D\x1A\x12\x02\x06\x01\\UGWQYSU\x0E\x18\x0E\x13\xE1\xE2\xE7\xAB\xAB\xDB\xB6\xA8\xA4\xAE\xAD\xA2'), hh: S("3<uqjR\bAE^^\r\\ZCE\nkassteoi<&?>$ (xx| !7%#*qzj|t~v"), M: S(",@GAEEWFPF[YZ_clfej"), MM: S(".BY_GGQ"), a: e + S("{JLQW\b\r\niU_YK{O\r"), aa: e + S("Eg &?9lqn~bqmsdulwiy") };return S("Bdh") + n[t] + S("&");
	                });return t = "'" + t + "'", t = t.replace(/('',)|,''$/g, ""), new Function(S(" XGBV"), S(",@AADY"), S("\nomt"), S("rtio"), S("}x|f`p"), S("!PFPPTI\br") + t + S("E7ptus6=\b"));
	              }(), i.formatDateString = function (t) {
	                return t = t || "", e.isNumber(t) && (t = t.toString()), t.length < 12 ? "" : i.formatDate(t.substr(0, 4), t.substr(4, 2), t.substr(6, 2), t.substr(8, 2), t.substr(10, 2));
	              }, i.formatFileSize = function (e) {
	                var t = 1024,
	                    n = t * t,
	                    r = n * t;return e >= r ? i.Gb.replace(S(">-"), (e / r).toFixed(1)) : e >= n ? i.Mb.replace(S("3&"), (e / n).toFixed(1)) : e >= t ? i.Kb.replace(S("0"), (e / t).toFixed(1)) : S("7\by").replace(S(")"), e);
	              }, i.formatTransfer = function (e) {
	                return i.SizePerSecond.replace(S(" "), i.formatFileSize(parseInt(e)));
	              }, i.formatFilesCount = function (e) {
	                return i[S(1 === e ? "7~PV^O~QJ.5\r-!" : "5p^T\\IxSHPK\r ,:")].replace(S("!"), e);
	              }, r.resolve(i);
	            }), r.promise();
	          }, getSupportedLanguage: function getSupportedLanguage(e, t) {
	            if (!e) return !1;var n = e.toLowerCase().match(/([a-z]+)(?:-([a-z]+))?/),
	                i = n[1],
	                r = n[2];return t[i + "-" + r] ? i = i + "-" + r : t[i] || (i = !1), i;
	          } };return r;
	      }), CKFinder.define(S("%eln@DOI_zDX^POtW]_"), { up: 38, down: 40, left: 37, right: 39, backspace: 8, tab: 9, enter: 13, space: 32, escape: 27, end: 35, home: 36, "delete": 46, menu: 93, slash: 191, a: 65, r: 82, u: 85, f2: 113, f5: 116, f7: 118, f8: 119, f9: 120, f10: 121 }), CKFinder.define(S("4v}qQW^^Nkvo%&-4"), [S("=KQ$$00'*4\""), S("z`gvfl"), S('A\b,(#-;e8$"`4+;13')], function (e, t, n) {
	        "use strict";
	        function i() {
	          var n = [S("$QTFFZC_EB@")];e.forEach(n, function (e) {
	            o(e) && t(S("1P\\PL")).addClass(S("!AHB\b@BI]_YI\x00M\\C") + e);
	          });
	        }function r(e) {
	          var n = void 0 === document.documentMode,
	              i = window.chrome;n && !i ? t(window).on(S(".I_RG@]["), function (t) {
	            t.target === window && setTimeout(function () {
	              e.fire(S("<HW&.!67"), null, e);
	            }, a);
	          }).on(S("FNAVWJSS"), function (t) {
	            t.target === window && e.fire(S("!WJGJRZ"), null, e);
	          }) : window.addEventListener ? (window.addEventListener(S("4SYTMJ"), function () {
	            setTimeout(function () {
	              e.fire(S(")_BKALEB"), null, e);
	            }, a);
	          }, !1), window.addEventListener(S("t{mk"), function () {
	            e.fire(S("8LS^QKM"), null, e);
	          }, !1)) : (window.attachEvent(S("6QWZOH"), function () {
	            setTimeout(function () {
	              e.fire(S("8LSZR]J3"), null, e);
	            }, a);
	          }), window.attachEvent(S("'JE_Y"), function () {
	            e.fire(S("(\\CNA[]"), null, e);
	          }));
	        }function o(e) {
	          var t = document.body || document.documentElement,
	              n = t.style;if ("string" == typeof n[e]) return !0;var i = [S("Abt"), S(">H%#)*0"), S("wD@HMQ"), S(">t(5//"), "O", S("@,1")];e = e.charAt(0).toUpperCase() + e.substr(1);for (var r = 0; r < i.length; r++) {
	            if ("string" == typeof n[i[r] + e]) return !0;
	          }return !1;
	        }function s(e, t, n) {
	          t && e.removeClass(S("6TS_NUSP$$o") + t), e.addClass(S("'KBLYDB_UW") + n);
	        }var a = 300;return { init: function init(e) {
	            i(), r(e);var o = t(S("5TX\\@"));o.attr({ "data-theme": e.config.swatch, role: S("scdytymstr") }), navigator.userAgent.toLowerCase().indexOf(S("D14.,,$?c")) > -1 && o.addClass(S("=]T&l+&")), t(S("*CX@B")).attr({ dir: e.lang.dir, lang: e.lang.LangCode }), e.lang.dir !== S("`y|") && o.addClass(S("\nhgk#}d}")), e.setHandler(S("3A\\\fP]MwTXX"), function () {
	              var n,
	                  i,
	                  r = window.matchMedia ? function () {
	                return void 0 === i && (i = S("$\rKFP]BHYF") + e.config.uiModeThreshold + S("\rkb9")), window.matchMedia(i).matches;
	              } : function () {
	                return void 0 === n && (n = parseFloat(t(S("B!+!?")).css(S(":]SSJ3(8&"))) * e.config.uiModeThreshold), window.innerWidth <= n;
	              };return function () {
	                return S(r.call(this) ? "pq}IMG" : "$ACTC]E[");
	              };
	            }());var a = e.request(S("(\\CKHZb_UW"));s(o, null, a), t(window).bind(S('8MRISIJS%%0&7,<"'), function () {
	              var t = e.request(S(":NUYZ4\f-'!")),
	                  n = a !== t;n && (s(o, a, t), a = t), e.fire(S('c~"khug{'), { modeChanged: n, mode: a }, e);
	            });var u = t.event.special.swipe.start;t.event.special.swipe.start = function (e) {
	              var t = u(e);return t.ckfOrigin = e.originalEvent.type, t;
	            }, t(window).bind(S("lWHRFH@@S"), function (t) {
	              0 !== t.swipestart.ckfOrigin.indexOf(S("ab{|u")) && e.fire(S("@4+y72/7-%/-8"), { evt: t }, e);
	            }), t(window).bind(S("4FA^H\\HR[UJ"), function (t) {
	              0 !== t.swipestart.ckfOrigin.indexOf(S(".B_DAV")) && e.fire(S("or&nivPDPJCMR"), { evt: t }, e);
	            }), e.setHandler(S("\nh`b}j@~bfd"), function () {
	              e.util.isPopup() ? window.close() : window.top && window.top.CKFinder && window.top.CKFinder.modal && window.top.CKFinder.modal(S(",NB@CT"));
	            }), t(document).on(S("hbjseagugb"), S("Nrey~}z~q{B"), function (e) {
	              e.preventDefault(), e.dragDrop && e.dragDrop();
	            }), e.once(S("C%56}:,+/5"), function (e) {
	              e.finder.request(S("A)&=*.;=/%"), { key: n.space }), e.finder.on(S("D.#>,&=%v") + n.space, function (e) {
	                e.data.evt.preventDefault();
	              });
	            });
	          } };
	      }), CKFinder.define(S('C\x00.&-/9c":78< {:"?04'), [S("evvffuxj|"), S("'BX_N^T"), S("C&$%,*&$.")], function (e, t, n) {
	        "use strict";
	        function i() {}return i.extend = n.Model.extend, e.extend(i.prototype, { addCss: function addCss(e) {
	            t(S("Cx62>$,t")).text(e).appendTo(S("u{~D"));
	          }, init: function init() {} }), i;
	      }), CKFinder.define(S("(jamECJJBb_AR_YKjWIZWQ3"), [S(" TLGAWUDG[O"), S("f|{jbh"), S("8[[XW_QQ%"), S('A\b,(#-;e 8)&>"}8 1>6'), S("_VXvNEGQpRNDfJBJ")], function (e, t, n, i, r) {
	        "use strict";
	        function o(e, t, n) {
	          function i() {
	            t.init(e), e._plugins.add(t), n.loaded = !0, e.fire(S('bary"kzxd'), { plugin: t }, e);
	          }return t.path = e.util.parentFolder(n.url) + "/", t.lang ? void r.loadPluginLang(e.lang.LangCode, e.config.defaultLanguage, t, function (t) {
	            t.name && t.values && (e.lang[t.name] = t.values), i();
	          }) : void i();
	        }var s = n.Collection.extend({ load: function load(t) {
	            function n() {
	              var n = e.countBy(r, S("yyv||~"));n.undefined || (t.fire(S("ezbpt!}qrME@FZ"), null, t), n["false"] && e.forEach(e.where(r, { loaded: !1 }), function (e) {
	                t.fire(S("\f}bzwx|)xzws]khtn"), { configKey: e.config, url: e.url });
	              }));
	            }var r = [],
	                s = t.config.plugins;return s.length < 1 ? void t.fire(S("=NS5&+-~$*+,+/5"), null, t) : (e.isString(s) && (s = s.split(",")), e.forEach(s, function (e) {
	              var t = e;-1 === e.search("/") && (t = CKFinder.require.toUrl(S("(YF^KD@\\") + e + "/" + e + ".js")), r.push({ config: e, url: t, loaded: void 0 });
	            }), t.on(S("1B_AR_YK_ZXD"), function () {
	              n();
	            }), void e.forEach(r, function (e) {
	              CKFinder.require([e.url], function (n) {
	                var r = i.extend(n);o(t, new r(), e);
	              }, function () {
	                e.loaded = !1, n();
	              });
	            }));
	          } });return s;
	      }), CKFinder.define(S("(jamECJJB\\P@ZRKyTRS[\\4.0l7');9%98"), [S("qmh{mY"), S("a{rrjjytnx")], function (e, t) {
	        "use strict";
	        function n(e, t) {
	          this.url = e, this.config = t, this.onDone = o, this.onFail = o, this.request = null;
	        }function i(t) {
	          var n, i;n = new XDomainRequest(), i = null, t.config.type === S("$UIT\\") && (i = e.param(t.config.post)), n.open(t.config.type, t.url), n.onload = function () {
	            t.onDone(this.responseText);
	          }, n.onprogress = o, n.ontimeout = o, n.onerror = function () {
	            t.onFail();
	          }, t.request = n, setTimeout(function () {
	            n.send(i);
	          }, 0);
	        }function r(n) {
	          var i, r;i = new XMLHttpRequest(), r = null, i.open(n.config.type, n.url, !0), i.onreadystatechange = function () {
	            4 === this.readyState && n.onDone(this.responseText);
	          }, i.onerror = function () {
	            n.onFail();
	          }, t.isFunction(n.config.uploadProgress) && i.upload && (i.upload.onprogress = n.config.uploadProgress), t.isFunction(n.config.uploadEnd) && i.upload && (i.upload.onload = n.config.uploadEnd), n.config.type === S("8IUHH") && (r = e.param(t.extend(n.config.post)), i.setRequestHeader(S("/s^\\GQ[Bl@J^"), S("E'78%#(-9' >~*~#\"!z>6(6q(,3\f\x00\x00"))), i.send(r), n.request = i;
	        }var o = function o() {};return n.prototype.done = function (e) {
	          this.onDone = e;
	        }, n.prototype.fail = function (e) {
	          this.onFail = e;
	        }, n.prototype.send = function () {
	          window.XMLHttpRequest ? r(this) : i(this);
	        }, n.prototype.abort = function () {
	          this.request && this.request.abort();
	        }, n;
	      }), CKFinder.define(S("<~uy)/&&6j(,<&.?b\r >?70 :$x6459>*0"), [S("/E_VVFFUXJ\\"), S("xbapdn"), S("u|~F}wss"), S("XW[wqDDP\fiJBRDLYoB@AURF\\FbEYWIKSOJ")], function (e, t, n, i) {
	        "use strict";
	        function r(e) {
	          function t(e) {
	            if (/^(http(s)?:)?\/\/.+/i.test(e)) return e;0 !== e.indexOf("/") && (e = "/" + e);var t = window.parent ? window.parent.location : window.location,
	                n = t.protocol + S("%	\b") + t.host;return n + e;
	          }var i = e.config,
	              r = i.connectorLanguage;this.finder = e, this.config = i, i.connectorPath ? this.baseUrl = t(i.connectorPath) : this.baseUrl = n.require.toUrl(S(")OB\\JR]]ZPUCWK") + r + S("&\bKFDEINZ@B") + r), e.setHandlers({ "command:send": { callback: s, context: this }, "command:url": { callback: function callback(e) {
	                return o.call(this, e.command, e.params, e.folder);
	              }, context: this } });
	        }function o(t, n, i) {
	          var r = this.finder,
	              o = r.config,
	              s = { command: t, lang: r.lang.LangCode },
	              a = o.connectorInfo;if (i && (s.type = i.get(S("aqfybjzOem{")), s.currentFolder = i.getPath(), s.hash = i.getHash()), o.pass.length) {
	            var u = o.pass.split(",");e.forEach(u, function (e) {
	              s[e] = r.config[e];
	            });
	          }o.id && (s.id = o.id);var l = this.baseUrl + "?" + r.util.toGet(e.extend(s, n));return a.length > 0 && (l += "&" + a), l;
	        }function s(n) {
	          var r = this.finder,
	              s = n.name,
	              u = t.Deferred(),
	              l = { name: s, response: { error: { number: 109 } } };if (e.has(n, S("1Q\\ZASOL")) && (l.context = n.context), r.fire(S(":XSPS^.%x!!#)5-"), n, r) && r.fire(S("q|yxwy|#x~zrlz") + s, n, r)) {
	            var c = e.extend({ type: S("6P]M"), post: {} }, n),
	                d = {};d.type = c.type, c.type === S("#TJUS") && (d.post = c.post), c.uploadProgress && (d.uploadProgress = c.uploadProgress), c.uploadEnd && (d.uploadEnd = c.uploadEnd);var f = o.call(this, s, n.params, n.folder),
	                h = new i(f, d);return h.done(function (t) {
	              var i,
	                  o,
	                  c = !1;try {
	                o = JSON.parse(t), i = { name: s, response: o, rawResponse: t }, c = !0;
	              } catch (d) {
	                var f = l;return f.response.error.message = t, a(s, f, r), void u.reject(f);
	              }c && u.resolve(o), e.has(n, S("\rm`~ewk`")) && (i.context = n.context), !o || o.error ? r.fire(S("9YTQP_Q${'16*4}") + s, i, r) && (n.context && n.context.silentConnectorErrors || r.fire(S("uxut{ux'{mRNP"), i, r)) : r.fire(S('>\\/,/"*!|(#s') + s, i, r), r.fire(S("7[VWV]SZ!'6&6"), i, r), r.fire(S("rsrAOFECRBZ") + s, i, r);
	            }), h.fail(function () {
	              a(s, l, r), u.reject(l);
	            }), h.send(), n.returnTransport ? h : u.promise();
	          }
	        }function a(e, t, n) {
	          n.fire(S("vyzuxt&xlmOS") + e, t, n) && n.fire(S('r}~ytxs"|hiso'), t, n), n.fire(S("}pMLCM@GA\\LX"), t, n), n.fire(S("A!,)('),s+-8(<u") + e, t, n);
	        }return r;
	      }), CKFinder.define(S('8zq}USZZ2n*!25h\n(9.c!"=><'), [S("?5/&&66%(:,"), S("\fia["), S("#IDTNGGO_XH")], function (e, t, n) {
	        "use strict";
	        var i = { proto: { getTemplate: function getTemplate() {
	              var i = this,
	                  r = n.getOption(i, S("kELROEQC")),
	                  o = n.getOption(i, S(" HOSKWRT"));e.isFunction(o) && (o = o.call(this));var s = { imports: o, name: i.name, template: r };return i.finder.fire(S("5BRUIVZHX"), s, i.finder), i.finder.fire(S("{u|buas-") + i.name, s, i.finder), t.template(s.template, null, s.imports);
	            }, mixinTemplateHelpers: function mixinTemplateHelpers(t) {
	              t = t || {};var i = this.getOption(S("oypnsAUGkAIVBZZ"));return i = n._getValue(i, this), e.extend(t, { lang: this.finder.lang, config: this.finder.config }, i);
	            } }, util: { construct: function construct(e) {
	              if (!this.name) {
	                if (!e.name) throw S('9TZQXO!3#.!1#5h$?88m,*p""67<0>==');this.name = e.name;
	              }if (!this.finder) {
	                if (!e.finder) throw S("\nMecjjb1brft{rl|h;qhmk\x00CGWUCDAOCNH\rH@BDZQB\f") + this.name;this.finder = e.finder;
	              }this.finder.fire(S(")\\BIZ") + this.name, { view: this }, this.finder);
	            } } };return i;
	      }), CKFinder.define(S("RYU}{rrj6Lryjm0b@QFfIJXFYBXHxFUF"), [S("@4,'!75$';/"), S("uxhrss{kTD"), S("QXR|xs}k5MuxilcCPA\neHEDEE")], function (e, t, n) {
	        "use strict";
	        var i = t.CompositeView,
	            r = i.extend(n.proto),
	            o = r.extend({ constructor: function constructor(e) {
	            n.util.construct.call(this, e), i.prototype.constructor.apply(this, Array.prototype.slice.call(arguments));
	          }, buildChildView: function buildChildView(t, n, i) {
	            var r = e.extend({ model: t, finder: this.finder }, i);return new n(r);
	          }, attachBuffer: function attachBuffer(e, t) {
	            var n = this.getChildViewContainer(e);n.append(t), this.triggerMethod(S("=_K4 !+0 !-;"));
	          } });return o;
	      }), CKFinder.define(S("8zq}USZZ2n*!25h\n(9.c:*=;6#"), [S("\f`o}y~|v`as"), S("&dcoCEHH\\\x00fXWDGtVK\\xSPSP.")], function (e, t) {
	        "use strict";
	        var n = e.ItemView,
	            i = n.extend(t.proto),
	            r = i.extend({ constructor: function constructor(e) {
	            t.util.construct.call(this, e), n.prototype.constructor.apply(this, Array.prototype.slice.call(arguments));
	          } });return r;
	      }), CKFinder.define(S("?4$:7"), [S(" LMGQIC")], function (e) {
	        "use strict";
	        var t,
	            n,
	            i,
	            r,
	            o,
	            s = [S(">r39//vk\n"), S("Pw|RNQLBQ\beebx}"), S("Yfnzt+4CQQVKtq\f\n")],
	            a = /^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im,
	            u = /<body[^>]*>\s*([\s\S]+)\s*<\/body>/im,
	            l = "undefined" != typeof location && location.href,
	            c = l && location.protocol && location.protocol.replace(/\:/, ""),
	            d = l && location.hostname,
	            f = l && (location.port || void 0),
	            h = {},
	            g = e.config && e.config() || {};return t = { version: S(":	\rt"), strip: function strip(e) {
	            if (e) {
	              e = e.replace(a, "");var t = e.match(u);t && (e = t[1]);
	            } else e = "";return e;
	          }, jsEscape: function jsEscape(e) {
	            return e.replace(/(['\\])/g, S(".s\x00")).replace(/[\f]/g, S("Pk")).replace(/[\b]/g, S("9fY")).replace(/[\n]/g, S("B*")).replace(/[\t]/g, S("O`")).replace(/[\r]/g, S("1nA")).replace(/[\u2028]/g, S("8eO	\f")).replace(/[\u2029]/g, S("/lD\x00\f"));
	          }, createXhr: g.createXhr || function () {
	            var e, t, n;if ("undefined" != typeof XMLHttpRequest) return new XMLHttpRequest();if ("undefined" != typeof ActiveXObject) for (t = 0; 3 > t; t += 1) {
	              n = s[t];try {
	                e = new ActiveXObject(n);
	              } catch (i) {}if (e) {
	                s = [n];break;
	              }
	            }return e;
	          }, parseName: function parseName(e) {
	            var t,
	                n,
	                i,
	                r = !1,
	                o = e.lastIndexOf("."),
	                s = 0 === e.indexOf(S("22")) || 0 === e.indexOf(S("4"));return -1 !== o && (!s || o > 1) ? (t = e.substring(0, o), n = e.substring(o + 1)) : t = e, i = n || t, o = i.indexOf("!"), -1 !== o && (r = i.substring(o + 1) === S("(Z^YE]"), i = i.substring(0, o), n ? n = i : t = i), { moduleName: t, ext: n, strip: r };
	          }, xdRegExp: /^((\w+)\:)?\/\/([^\/\\]+)/, useXhr: function useXhr(e, n, i, r) {
	            var o,
	                s,
	                a,
	                u = t.xdRegExp.exec(e);return u ? (o = u[2], s = u[3], s = s.split(":"), a = s[1], s = s[0], !(o && o !== n || s && s.toLowerCase() !== i.toLowerCase() || (a || s) && a !== r)) : !0;
	          }, finishLoad: function finishLoad(e, n, i, r) {
	            i = n ? t.strip(i) : i, g.isBuild && (h[e] = i), r(i);
	          }, load: function load(e, n, i, r) {
	            if (r && r.isBuild && !r.inlineText) return void i();g.isBuild = r && r.isBuild;var o = t.parseName(e),
	                s = o.moduleName + (o.ext ? "." + o.ext : ""),
	                a = n.toUrl(s),
	                u = g.useXhr || t.useXhr;return 0 === a.indexOf(S("p{gl` ")) ? void i() : void (!l || u(a, c, d, f) ? t.get(a, function (n) {
	              t.finishLoad(e, o.strip, n, i);
	            }, function (e) {
	              i.error && i.error(e);
	            }) : n([s], function (e) {
	              t.finishLoad(o.moduleName + "." + o.ext, o.strip, e, i);
	            }));
	          }, write: function write(e, n, i, r) {
	            if (h.hasOwnProperty(n)) {
	              var o = t.jsEscape(h[n]);i.asModule(e + "!" + n, S("y{wqE	DVJFRNGG\n\rUBTFFF[") + o + S("6)n=."));
	            }
	          }, writeFile: function writeFile(e, n, i, r, o) {
	            var s = t.parseName(n),
	                a = s.ext ? "." + s.ext : "",
	                u = s.moduleName + a,
	                l = i.toUrl(s.moduleName + a) + ".js";t.load(u, i, function (n) {
	              var i = function i(e) {
	                return r(l, e);
	              };i.asModule = function (e, t) {
	                return r.asModule(e, l, t);
	              }, t.write(e, u, i, o);
	            }, o);
	          } }, g.env === S("\necik") || !g.env && "undefined" != typeof process && process.versions && process.versions.node && !process.versions[S("<SQ[%l5&&./3")] && !process.versions[S("sg{x;dp|vw")] ? (n = __webpack_require__(320).nodeRequire(S("@'1")), t.get = function (e, t, i) {
	          try {
	            var r = n.readFileSync(e, S("D02!p"));'\uFEFF' === r[0] && (r = r.substring(1)), t(r);
	          } catch (o) {
	            i && i(o);
	          }
	        }) : g.env === S("evm") || !g.env && t.createXhr() ? t.get = function (e, n, i, r) {
	          var o,
	              s = t.createXhr();if (s.open(S("1uv`"), e, !0), r) for (o in r) {
	            r.hasOwnProperty(o) && s.setRequestHeader(o.toLowerCase(), r[o]);
	          }g.onXhr && g.onXhr(s, e), s.onreadystatechange = function (t) {
	            var r, o;4 === s.readyState && (r = s.status || 0, r > 399 && 600 > r ? (o = new Error(e + S("1ZG@E6dlxnno'>") + r), o.xhr = s, i && i(o)) : n(s.responseText), g.onXhrComplete && g.onXhrComplete(s, e));
	          }, s.send(null);
	        } : g.env === S("`{}{y") || !g.env && "undefined" != typeof Packages && "undefined" != typeof java ? t.get = function (e, t) {
	          var n,
	              i,
	              r = S("\r{{v<*"),
	              o = new java.io.File(e),
	              s = java.lang.System.getProperty(S("&KAGO_H^NBPF\\F")),
	              a = new java.io.BufferedReader(new java.io.InputStreamReader(new java.io.FileInputStream(o), r)),
	              u = "";try {
	            for (n = new java.lang.StringBuffer(), i = a.readLine(), i && i.length() && 65279 === i.charAt(0) && (i = i.substring(1)), null !== i && n.append(i); null !== (i = a.readLine());) {
	              n.append(s), n.append(i);
	            }u = String(n.toString());
	          } finally {
	            a.close();
	          }t(u);
	        } : (g.env === S("dm}pNOG@P") || !g.env && "undefined" != typeof Components && Components.classes && Components.interfaces) && (i = Components.classes, r = Components.interfaces, Components.utils[S("svlrlk")](S(":IYNQJ2\"'ykj!5-f'$(8\"*#~:80#15)u6.3")), o = S("-nB_K[_XTXJ^LUSZP72o1!\"/4<;3f'(7ta") in i, t.get = function (e, t) {
	          var n,
	              s,
	              a,
	              u = {};o && (e = e.replace(/\//g, "\\")), a = new FileUtils.File(e);try {
	            n = i[S("*kABTF\\]S[GQV\\NLSOU&(.&i,(7==g88?+.=jc")].createInstance(r.nsIFileInputStream), n.init(a, 1, 0, !1), s = i[S(")jFCWGC\\P\\FR^VMV_RPI%36&6h/)8<>f?9<*1<ib")].createInstance(r.nsIConverterInputStream), s.init(n, S("kkF\f"), n.available(), r.nsIConverterInputStream.DEFAULT_REPLACEMENT_CHARACTER), s.readString(n.available(), u), s.close(), n.close(), t(u.value);
	          } catch (l) {
	            throw new Error((a && a.path || "") + S("$") + l);
	          }
	        }), t;
	      }), CKFinder.define(S("ewk`4U\\^ptyo1KELROEQCTjEEXHV[}T\\FvYYL\\BOqXPJ	5'.j!)3"), [], function () {
	        return S(')QP\rG[U[E]QSEDG@GB=KK%e2&* $/)5sm}`ps797$+dx.5p<+A[EGG-R	\x00Z\rPóààïáá¦üó¶÷ö÷ö±¯ùå¼ú÷úø·åäïò±ÿêñÈÁÌÊÊÂÎÝÞÅÇÌßßÈÏÞÌÓØÓÓÂ½º¹ü¹¸äç³²õëí¤ºá¹¢° ¼ ²ø¤§º®´¿òÕËÌÎÔÔÐmd?!~;\'a}$em`k/ml03on)7qm4wusu^TUPJFPRB[	WVWVPYE_][]vLMHR^HJZ3ax"014.*<>.1054m0&\'&<4",<t5=0;"\\@X	A\bU@ýü¼ýüµ©ãÿ¢áïíõý²îé«·ø¤çæ¡âÝ«');
	      }), CKFinder.define(S("$fmaAGNN^c@TD^VGuXVM_CHp[Q5n*!25h&$?)5:5?'=0!"), [S("\r{att``wzdr"), S("E,6=,82"), S("TS_suxxl0vHGTW\ndF[LhC@^@CXFVb\\S@"), S("!ahbLHCM[}EHY\\sS@QC]TlRYJ"), S("+XHV[ryu][RRJn^QMR^4$1l*(3-1>)#;`><'1-\"=7/(83q"), S("V]Qqw~~n2KkIM\rhA\\eHLL")], function (e, t, n, i, r, o) {
	        "use strict";
	        function s(e, t) {
	          var n = e.x,
	              i = e.y,
	              r = t.height(),
	              o = t.width();return { x: parseInt(n + (window.innerWidth < n + o ? -1 : 1) * o / 2, 10), y: parseInt(i + (window.innerHeight < i + r ? -1 : 1) * r / 2 + document.body.scrollTop, 10) };
	        }var a = n.extend({ name: S("P{{br`mW~rh"), template: S(";\x00HR|n7/z"), childViewContainer: S("bt"), emptyView: i.extend({ name: S("%eHF]OSX`KAEt_C@L"), template: S("+|pl;qlS\x00@OCJMZYJKH\f\fVZB") }), initialize: function initialize(n) {
	            function i(t) {
	              var i = t.model.get(S("xyourp")),
	                  r = t.evt;e.isFunction(i) && (r.stopPropagation(), r.preventDefault(), i(n.forView)), setTimeout(function () {
	                a.destroy();
	              }, 10);
	            }function r(e) {
	              !a || a.$el.find(e.target).length || a.isDestroyed || a.destroy();
	            }var a = this,
	                u = t(document),
	                l = S("}~g`qqy`v9ytri{gTLGMQ"),
	                c = n.position,
	                d = n.positionToEl;if (!c && d) {
	              var f = d.get(0).getBoundingClientRect();c = { x: f.left + d.width() / 2, y: f.top + d.height() / 2 };
	            }a.$el.attr(S("wuaw:lqvy"), a.finder.config.swatch), a.on(S(" EGPPWI^"), function () {
	              u.off(l, r), a.$el.length && a.$el.remove();
	            }), a.on(S("5DRV]_I"), function () {
	              a.$el.find(S("<HR")).listview(), t(S("\r zy<b|d`f:{vto}tpzR")).remove(), a.$el.popup().popup(S("%IWMG")), a.$el.find(S("!\fVM\bDSFLB^^Z")).focus(), c && c.x && c.y && a.$el.popup(S("A0&4*5.< %%"), s(c, a.$el)), setTimeout(function () {
	                u.one(l, r);
	              }, 0);
	            }), a.on(S("\nhddbkfxwd.|bruzvrv{{"), function (e, t) {
	              i(t);
	            }), a.on(S("0RZZXQ@^]N\x00RHXST%8&,3+"), function (t, n) {
	              var r,
	                  s,
	                  u,
	                  l = n.evt;l.keyCode === o.up && (l.stopPropagation(), l.preventDefault(), r = a.$el.find("a"), s = e.indexOf(r, t.$el.find("a")[0]), u = s - 1, r[u >= 0 ? u : r.length - 1].focus()), l.keyCode === o.down && (l.stopPropagation(), l.preventDefault(), r = a.$el.find("a"), s = e.indexOf(r, t.$el.find("a")[0]), u = s + 1, r[u <= r.length - 1 ? u : 0].focus()), (l.keyCode === o.enter || l.keyCode === o.space) && (a.destroy(), i(n)), l.keyCode === o.escape && (l.stopPropagation(), l.preventDefault(), a.destroy());
	            });
	          }, getChildView: function getChildView(e) {
	            var t = { contextmenu: function contextmenu(e) {
	                e.preventDefault(), e.stopPropagation();
	              } };e.get(S("D!/1!-/9")) || (t[S("xpt}t\x00@")] = function (e) {
	              this.trigger(S("0XFVYVZ^[R__"), { evt: e, view: this, model: this.model });
	            }, t[S("tEXFLSKF")] = function (e) {
	              this.trigger(S("qmvwxg{OVL"), { evt: e, view: this, model: this.model });
	            });var n = { name: S("Ytri{gTlGMQlRBE"), finder: this.finder, template: r, events: t, tagName: S("<QW"), modelEvents: { "change:active": S("6E]W^^N") } };return e.get(S("kyg{wqg")) && (n.attributes = { "data-role": S("~zga;sqosyo") }), i.extend(n);
	          } });return a;
	      }), CKFinder.define(S("+ofhF^UWAxYSMU_H~QQ4$:7	 (2g\n%%8(6;4<&"), [S("0D\\WQGETWK_"), S("zxyp~rpz"), S("/sztZZQSEtU_IQ[Lo--0 >3,$>c'*'\"};;\"2 ->2(\b6")], function (e, t, n) {
	        "use strict";
	        function i(e) {
	          function t() {
	            n.lastView && n.lastView.destroy();
	          }this.finder = e, e.setHandler(S("7[VTOYEJr%/7"), r, this);var n = this;e.on(S('"VMDK]['), t), e.on(S(":NULZ3(8&"), t), e.on(S("&T@FX_OXZ\\\n][@@QRV\\HZP"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.showContextMenu, shortcuts: S("E=4  ,?1f5)aa/") });
	          }, null, null, 50);
	        }function r(e) {
	          var i = this,
	              r = i.finder,
	              o = new t.Collection(),
	              s = { groups: o, context: e.context };if (r.fire(S(")IDBYKWD|W]A"), s, r) && r.fire(S("4VYYL\\BOqXPJz") + e.name, s, r)) {
	            o.forEach(function (n) {
	              var i = new t.Collection();r.fire(S("-M@^EWK@xSYM") + e.name + ":" + n.get(S("B-%(#")), { items: i, context: e.context }, r), n.set(S("ui{rS"), i);
	            });var a = new t.Collection();o.forEach(function (e) {
	              var t = e.get(S("2Z@P[D"));t.length && (a.length && a.add({ divider: !0 }), a.add(t.models));
	            }), i.lastView && i.lastView.destroy();var u = e.evt && e.evt.clientX ? { x: e.evt.clientX, y: e.evt.clientY } : !1,
	                l = e.positionToEl ? e.positionToEl : null;r.request(S("zr}jSPFI@KEM[")), i.lastView = new n({ finder: r, className: S(">\\+'o ++2\"0='.\"8"), collection: a, position: u, positionToEl: l, forView: e.view }), i.lastView.on(S("hh}{b~k"), function () {
	              r.request(S("-H@SDA	FPECWK_"));
	            }), i.lastView.render();
	          }
	        }return i;
	      }), CKFinder.define(S("1qxr\\XS]KvSY[S3n,(!#5;\n%' (-;9><"), [S("2QUV]UWW_"), S("$fmaAGNN^c@TT^@sY[\\\\H")], function (e, t) {
	        "use strict";
	        var n = e.Collection.extend({ model: t, initialize: function initialize() {
	            this.on(S("uqGDMEHC"), this.sort);
	          }, comparator: function comparator(e, t) {
	            return e.get(S(")DJAH")).localeCompare(t.get(S(";R\\SZ")));
	          } });return n;
	      }), CKFinder.define(S('@	-+"":f$(("<=?00$'), [S('?" !(&*("'), S("<~uy)/&&6j(,,&8c!#44  ::;=:.233")], function (e, t) {
	        "use strict";
	        var n = e.Model.extend({ defaults: { name: "", hasChildren: !1, resourceType: "", isRoot: !1, parent: null, isPending: !1, "view:isFolder": !0 }, initialize: function initialize() {
	            function e() {
	              o.set(S("4]WD{QSWXO[Q"), !!o.get(S(";_UWS$3'-")).length);
	            }this.set(S("*EM@K"), this.get(S("8W[VY")).toString(), { silent: !0 }), this.set(S(".LXX^WFPX"), new t(), { silent: !0 });var n = this.get(S("tppvnxp"));n.on(S("p|txp}"), e), n.on(S("RDOLR@"), e), this.on(S("5U_YW]^^VV,%0&*"), function (t, n) {
	              n && (n.on(S('A!+%+!"'), e), n.on(S("B1!()1-"), e));
	            });var i = this.get(S(")KG@BYJTtJGQ[E^WWI"));i && "string" == typeof i && this.set(S("6VTUULYY{G4$,0-*(4"), i.split(","), { silent: !0 });var r = this.get(S("C%)*(?,.49+!#8=='"));r && "string" == typeof r && this.set(S("mab`gtvVlasykpuuo"), i.split(","), { silent: !0 });var o = this;
	          }, getPath: function getPath(e) {
	            var t, n;return t = this.get(S("cugsyl")), n = t ? t.getPath(e).toString() + this.get(S("w{vy")) + "/" : "/", this.get(S("/YB`\\[A")) && e && e.full && (n = this.get(S("'ZLYDY_MJdHBV")) + ":" + n), n;
	          }, getHash: function getHash() {
	            if (this.has(S("!JBWM"))) return this.get(S("yjr"));var e = this.get(S('"SEWCI\\'));return e.getHash();
	          }, getUrl: function getUrl() {
	            if (this.has(S("+Y_B"))) return this.get(S("jRM"));var e = this.get(S("asaq{b"));if (!e) return !1;var t = e.getUrl();return t && t + this.get(S("6YYT_")) + "/";
	          }, isPath: function isPath(e, t) {
	            return e === this.getPath() && t === this.get(S("&UMZE^^NK{IAW"));
	          }, getResourceType: function getResourceType() {
	            for (var e = this; !e.get(S("qjHtsi"));) {
	              e = e.get(S("gykuh"));
	            }return e;
	          } }, { isValidName: function isValidName(e) {
	            var t = /[\\\/:\*\?"<>\|]/;return !t.test(e);
	          } });return n;
	      }), CKFinder.define(S("8M_CH}t(,'!7i-$:'-9+<=?00$$w5788,\f'\r\n\b=_\x00"), [], function () {
	        return S('/\fW]AYWTLPUU~KK($$"$w@BE65np8&}0<7;7>>/.?8Anlo[M\x00OQ13å£¢õåéóâµ«ñð­­çû¾÷ýÿððäÙùôÿ»áà¼¿ÔÀÀÊÊÁÃßÌÜÆÑÀÖÅÀßÅÝÝÈÏËÚâÿÈÊøêª¦ª¬¦õÆñá©¿£¿íÞé¦÷»µ»¨¯àüºÉÎÓÒÀÏø');
	      }), CKFinder.define(S('@	-+"":f$(8"*#~<813%+v\f29*-p&(\f.\r\b&'), [S('\x1D]TfHLGAW\tqAL]X\x03oO\\U\x1E{GQX`^]N'), S("*hgkGATT@yZRRTJ}SQZZ2"), S('TDZWfmaAGNN^zJ]A^R@PE~VV_YOM..\'!7\b&%,"-!!(4?#84"2v=5/')], function (e, t, n) {
	        "use strict";
	        return e.extend({ name: S("'nFFOI_`N]TvZUYYPnP_L"), template: n, ui: { error: S("6]KHTNSZ32#$!"), folderName: S(".F^AGGo[WZ]UYJxP,%'1\n$+\"j") }, events: { "input @ui.folderName": function inputUiFolderName() {
	              var e = this.ui.folderName.val().toString();t.isValidName(e) ? this.model.unset(S("?%30,6")) : this.model.set(S("7]KHTN"), this.finder.lang.ErrorMsg.FolderInvChar), this.model.set(S("(OEGHH\\aQ\\W"), e);
	            }, submit: function submit(e) {
	              this.trigger(S("dm{wrh'xpRL")), e.preventDefault();
	            } }, modelEvents: { "change:error": function changeError(e, t) {
	              t ? (this.ui.error.show(), this.ui.error.html(t)) : this.ui.error.hide();
	            } } });
	      }), CKFinder.define(S("8zq}USZZ2n, 0*\";f	9),:*>>71'y*<;/913"), [S("!@BGNDHFL"), S("$fmaAGNN^c@TD^VGpXT]_IOhV%61l**#-;*!(\n&1==4<3 ")], function (e, t) {
	        "use strict";
	        function n(n) {
	          n.setHandler(S("$CIKLLXO_KNDT"), function (i) {
	            var r = i.parent,
	                o = i.newFolderName;if (o) n.request(S("\faantt`)g}y`"), { text: n.lang.PleaseWait }), n.request(S("uxut{ux'mzNE"), { name: S("Tj|{oy[qsDDP"), type: S(")ZD_Y"), folder: r, params: { newFolderName: o }, context: { folder: r } });else {
	              var s = new e.Model({ dialogMessage: n.lang.FolderNew, folderName: i.newFolderName, error: !1 }),
	                  a = n.request(S(" EKBHJA"), { view: new t({ finder: n, model: s }), name: S("@0&%1#'%..>"), title: n.lang.NewNameDlgTitle, context: { parent: r } });s.on(S("+OEOAWT\bVFGYE"), function (e, t) {
	                t ? a.disableButton(S("pK")) : a.enableButton(S(">P+"));
	              });
	            }
	          }), n.on(S("xtsOF`V@GSMoEGHH\\_Z"), function (e) {
	            var t = e.data.view.model;if (!t.get(S("7]KHTN"))) {
	              var i = t.get(S("\nmcajjb_s~q"));e.finder.request(S("1VZUYYP]_HHOQF")), n.request(S("0W]_PPD\r[K_ZHX"), { parent: e.data.context.parent, newFolderName: i });
	            }
	          }), n.on(S("}pNUG[PhCI]LD@IK]\nTVZ@"), function (e) {
	            var t = e.finder,
	                n = e.data.context.folder;e.data.items.add({ name: S("5uE]XN^zRR[%3"), label: t.lang.NewSubFolder, isActive: n.get(S("\flmc")).folderCreate, icon: S("6TS_]SQZZ2l#' "), action: function action() {
	                t.request(S('-H@\\UWA\x0EVDRYM_'), { parent: n });
	              } });
	          }), n.on(S("kONNAEWUMZO_`OF^T\\XQSE"), function (e) {
	            var t = e.data.folder;t.get(S("\njoa")).folderCreate && e.data.toolbar.push({ type: S(")H^XYAA"), name: S("]mE@VFbJJCM["), priority: 70, icon: S("\fnei=w}ppd:y}~"), label: e.finder.lang.NewSubFolder, action: function action() {
	                n.request(S("w}ppd-{kzhx"), { parent: t });
	              } });
	          }), n.on(S("rsrAOFECRBZiYILZJv^^WQG"), i);
	        }function i(e) {
	          function t(e) {
	            e.data.context.parent.cid === n.cid && (e.data.response.error || n.trigger(S("6BQ_CL\\P[")), e.finder.removeListener(S("4VYZUXT_\\XK%3x!1\x00($-/9?"), t));
	          }var n = e.data.context.folder;e.finder.request(S("'DFKOI_GYUW")), e.data.response.error || (n.set(S("*CM^mGY]VAQ["), !0), e.finder.once(S(".L_\\_RZQ\fV^M_Iz[K..'!75"), t), e.finder.request(S("obcbqv)gpxs"), { name: S("\fJk{V~~wqge"), folder: n, context: { parent: n } }, null, null, 30));
	        }return n;
	      }), CKFinder.define(S('kEYVgn`NFMOYyKB@]SGQFs]U_OY{WS%n&( 2" &.	?< "6< '), [], function () {
	        return S(")QP\rG[\\ATHKHA@WKn,1$d8;{g9t07r32Zm'?j_-,&y3/r8,-C^\x00JQN\n	NTZAQé¿ùøúøû´¦ÿç²");
	      }), CKFinder.define(S("?\n**!#5g%/9!+<7?1!315?t82:$\n\b\x00"), [S("5CY\\\\HH_RLZ"), S("|KCMMA"), S(">K%96b\x00.&-/9c+\" =3'1&y=5?/973N&\b\x00.\x00)\x00_\x00"), S("C\x00.&-/9c:&<~6-93=")], function (e, t, n, i) {
	        "use strict";
	        function r(e) {
	          this.finder = e, e.setHandler(S(" GKOAVCMEO_I"), o, this), e.on(S(".KYP^\\SrRT\\N^zTRZ.,%-7+}'\""), u), e.on(S(";_RSR!/&y%#2\":s. (:*8>6'"), l), e.on(S("+OBCBQ_V	QGDXJ~^PXJZ(.&7"), c), e.on(S("!ALJQC_\\dOEYHF\\T"), function (e) {
	            e.data.groups.add({ name: S('E""$,>.') });
	          }, null, null, 40), e.on(S("ytri{gTlGMQ@NDLOIAK[U"), a, this), e.on(S("bxwuxzn'lzSDViDOIOCGI"), function (t) {
	            s(t, e.lang.Delete);
	          }), e.on(S("7LVUW^\\L2$1&0&!'p-%!+<"), function (t) {
	            s(t, e.lang.DeleteFiles);
	          }), d(e);
	        }function o(e) {
	          var t,
	              n = this.finder,
	              i = e.files;t = i.length > 1 ? n.lang.FilesDelete.replace(S("Bfu"), i.length) : n.lang.FileDelete.replace(S("Ecv"), i[0].get(S("xvu|"))), n.request(S("xtsOF@KK@NZD"), { name: S("5rRT\\N^zTRZ.,%-7+"), msg: t, context: { files: i } });
	        }function s(e, t) {
	          var n = e.finder.request(S("$CIKLLXKHZnSE[EQ"));n.get(S("0PQ_")).fileDelete && e.data.toolbar.push({ type: S('"AQQRHF'), name: S("5rRT\\N^zTRZ3"), priority: 10, icon: S("4V]Q_SWYZZ,$6&"), label: t, action: function action() {
	              e.finder.request(S("xvLDQ@@JB\\L"), { files: e.finder.request(S("p~t|i!{xjLEMG@P@B")).toArray() });
	            } });
	        }function a(e) {
	          var t = this,
	              n = t.finder,
	              i = n.request(S("jdbjc+uv`Fs{}zn~x")),
	              r = i.length > 1;e.data.items.add({ name: S("UwqasQquh"), label: r ? n.lang.DeleteFiles : n.lang.Delete, isActive: e.data.context.file.get(S("3RZZS]K")).get(S(":Z_Q")).fileDelete, icon: S(">\\+'o%-)#j,,&.8("), action: function action() {
	              n.request(S("tzxpe-||v~hx"), { files: r ? i : [e.data.context.file] });
	            } });
	        }function u(n) {
	          var i = n.data.context.files,
	              r = [],
	              o = n.finder;i instanceof t.Collection && (i = i.toArray()), e.forEach(i, function (e) {
	            var t = e.get(S("i}vvf"));r.push({ name: e.get(S("qALG")), type: t.get(S("lzSNWQG@r^XL")), folder: t.getPath() });
	          });var s = o.request(S("\rh`|uwa.rscYznrjx"));o.request(S("LNCGAWT@F]"), { text: o.lang.PleaseWait }), o.request(S("D&)*%($/v>+!4"), { name: S("]wyi{YIMGP"), type: S("B3+62"), post: { files: r }, folder: s, context: { files: i } });
	        }function l(t) {
	          var n = t.data.response;t.finder.request(S("D))&,,8q$$**")), n.error || (e.forEach(t.data.context.files, function (e) {
	            var t = e.get(S('"EKIBBZ'));t.get(S("1Q[]YRE]W")).remove(e);
	          }), t.finder.fire(S("tzxpe-||v~hxz"), { files: t.data.context.files }, t.finder));
	        }function c(i) {
	          var r = i.data.response;if (r.error.number === f) {
	            i.cancel();var o = !!r.deleted,
	                s = i.finder.lang.Errors[f],
	                a = [];e.forEach(r.error.errors, function (e) {
	              a.push(e.name + S(".5") + i.finder.lang.Errors[e.number]), 117 === e.number && (o = !0);
	            }), i.finder.request(S("=ZV!--$"), { name: S("B!)#3-#')>=\">  "), title: i.finder.lang.OperationCompletedErrors, template: n, templateModel: new t.Model({ deleted: r.deleted, errors: a, msg: s }), buttons: [S("%ILkEEXI")] }), o && i.finder.request(S('t|xqse"k}nxmwfHNFW'));
	          }
	        }function d(e) {
	          e.on(S("=XV,$x(!<\"(?'"), function (t) {
	            if (t.data.evt.keyCode === i["delete"] && e.util.isShortcut(t.data.evt, "")) {
	              var n = e.request(S("%@NDLYKHZ|U]WP@PR"));e.request(S('"EMICTMOGIYK'), { files: n.length > 1 ? n : [t.data.file] });
	            }
	          }), e.on(S(".\\X^@GW@BDUSHHXV,$1"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files["delete"], shortcuts: S("E=#-%7") });
	          }, null, null, 30);
	        }var f = 302;return r;
	      }), CKFinder.define(S("<~uy)/&&6j(,<&.?b\n*<4&6::3=+u91;+'\r\x00\x00"), [S("[R\\rry{mtVJH\nmBQjEOI")], function (e) {
	        "use strict";
	        function t(e) {
	          e.on(S("|p{wsz$[EMGWAcIKLLXhCCHFB\\\b\\_"), function (t) {
	            var n = t.data.context.folder;e.request(S("7TV[_YOL(.5"), { text: e.lang.PleaseWait }), e.request(S("$FIJEHDO^KAT"), { name: S('C\x00 *"<,\f$ )+='), type: S("3DZEC"), folder: n, context: { folder: n } }, e);
	          }), e.on(S("s~~u{r-yn~n'ZzLDVFbJJCM["), function (t) {
	            var n = t.data.response,
	                i = t.data.context.folder;if (e.request(S('"OKDBBZBBHH')), !n.error) {
	              var r = i.get(S("oASGMP"));i.unset(S(">O!3'-0")), r.get(S('D&..$-8."')).remove(i);var o = e.request(S(" GMO@@TOL^jOYGYU"));o.cid === i.cid && e.request(S("6QWU^^NMZ,$!7"), { folder: r }), e.fire(S("'NFFOI_KU]WGQQ"), { folder: i });
	            }
	          }), e.on(S(",YA@\\SSAGSD]M\x00v]TP&..'!7"), function (t) {
	            var n = t.data.folder;!n.get(S("?)2,+1")) && n.get(S("4TU[")).folderDelete && t.data.toolbar.push({ type: S("+NXZ[__"), name: S("Wqysc}_uwxxl"), priority: 20, icon: S(".L[WU[YRRJ^^PXJZ"), label: t.finder.lang.Delete, action: function action() {
	                e.request(S(" GMO@@TLLFNXH"), { folder: n });
	              } });
	          }), e.on(S("4VYYL\\BOqXPJz'-/  4"), function (e) {
	            e.data.groups.add({ name: S("?$$.&0 ") });
	          }, null, null, 20), e.on(S("=]P.5';0\b#)=s,$ )+=j57?1!3"), function (e) {
	            var t = e.finder,
	                n = e.data.context.folder,
	                i = n.get(S(")CX~BA[")),
	                r = n.get(S("B\"')"));e.data.items.add({ name: S("6s]U_OY{QS$$0"), label: t.lang.Delete, isActive: !i && r.folderDelete, icon: S('ofh"v~~wqg;s}uoy'), action: function action() {
	                t.request(S("&AGENN^JJ\\TFV"), { folder: n });
	              } });
	          }), e.setHandler(S("+JBBKUC\bWQYSC]"), function (t) {
	            var n = t.folder;e.request(S(":_U\\RP'{!,*#/5%"), { name: S("ZzLDVFbJJCM[iDBKG]]"), context: { folder: n }, msg: e.lang.FolderDelete.replace(S("6%"), n.get(S("1\\RYP"))) });
	          }), n(e);
	        }function n(t) {
	          t.on(S("=XP,%'1~.#>,&=%"), function (n) {
	            n.data.folder.get(S("D,5'&>")) || n.data.evt.keyCode === e["delete"] && n.finder.util.isShortcut(n.data.evt, "") && (n.data.evt.preventDefault(), n.data.evt.stopPropagation(), t.request(S("v~~wqg,s}uoy"), { folder: n.data.folder }));
	          }), t.on(S("&T@FX_OXZ\\\n][@@PXT]_IO"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.folders["delete"], shortcuts: S("$^BBDT") });
	          }, null, null, 30);
	        }return t;
	      }), CKFinder.define(S("%eln@DOI_yYTE@wWD]vZERKK('4"), [S("+AL\\F__WG@P"), S("B\x00/),,8d$+8#~2'0y74742")], function (e, t) {
	        "use strict";
	        var n = e.LayoutView,
	            i = n.extend(t.proto),
	            r = i.extend({ constructor: function constructor(n) {
	            t.util.construct.call(this, n), e.LayoutView.prototype.constructor.apply(this, Array.prototype.slice.call(arguments));
	          } });return r;
	      }), CKFinder.define(S("_VXvNEGQsOB_ZiM^K\x00s^^_QVB^WWlRYJ"), [S("nry{mSBMQA"), S("rASKLJ@RSM"), S("cjdJJACUCN[^mQBWwZ[ZWW")], function (e, t, n) {
	        "use strict";
	        var i = t.CollectionView,
	            r = i.extend(n.proto),
	            o = r.extend({ constructor: function constructor(e) {
	            n.util.construct.call(this, e), i.prototype.constructor.apply(this, Array.prototype.slice.call(arguments));
	          }, buildChildView: function buildChildView(t, n, i) {
	            var r = e.extend({ model: t, finder: this.finder }, i);return new n(r);
	          } });return o;
	      }), CKFinder.define(S("'kblBBIK]|]WAYSD}SZPRYLo+&36i!(&$+;;$><=0!"), [S("V]Qqw~~n2KkIM\rhA\\eHLL"), S("5u|~PT_YOi)$50k'4-f?) &5&")], function (e, t) {
	        "use strict";
	        return t.extend({ name: S("XtsOF`VPQII"), tagName: S("yiijpN"), template: S("nm*8pn5p||zL_^"), attributes: { tabindex: 1 }, events: { click: function click() {
	              this.trigger(S("8[OOHRP"));
	            }, keydown: function keydown(t) {
	              (t.keyCode === e.enter || t.keyCode === e.space) && (t.preventDefault(), this.trigger(S("A 601))")));
	            } }, onRender: function onRender() {
	            this.$el.attr(S("D!'3)d#% $ *"), !0).attr(S("/TPFRV]Q[OOHRP"), this.model.get(S("4[WZ]")));
	          } });
	      }), CKFinder.define(S("\nHGKgatt`<Yzrbt|i4XtsOFQ\frLCP[nBMAAHrDFG[[EaQ\\M"), [S("kqDDPPGJTB"), S("rpqxvzxr"), S('?\n**!#5g#.;>a\r1"7|::;=:.233\b6'), S("V]Qqw~~n2SpDTNFW\nbNIEEL_xFUFAp\\W[W^xNHIQQ('4")], function (e, t, n, i) {
	        "use strict";
	        function r(n, i) {
	          var r = new t.Collection();return e.forEach(n, function (t) {
	            var n = e.isString(t) ? t : t.name;r.push(e.extend({ icons: {}, label: n, name: n, event: n.toLocaleLowerCase() }, e.isString(t) ? i[n] : t));
	          }), r;
	        }return n.extend({ name: S("Sqxvt{_kkTNLP"), childView: i, initialize: function initialize(e) {
	            this.collection = r(e.buttons, { ok: { label: this.finder.lang.OkBtn, icons: { primary: S("$PO\nAJEENFJSZ") } }, okClose: { label: this.finder.lang.OkBtn, icons: { primary: S("!WJ	LEHFICINE") }, event: S("<RU") }, cancel: { label: this.finder.lang.CancelBtn, icons: { primary: S("c~5pytr0}sORG") } } });
	          } });
	      }), CKFinder.define(S('hxfkbieMKBBZ~NA]BNDTAp\\W[W^IxT_S/&"=*33f-%?'), [], function () {
	        return S('a`#=wkUKWH@ZUNBZ\rJNDPA[YS\nQ_ZXXL`"."76{e= g?%9"*ron;ek-,ey3/r)7+\fBYIYWVD\bQ\nM	JZ@\\ëç¯çíäêèï¤éäâùëáäâ¿èï¨¶þì·óÿ¼àã½ÂÎÂ×ÖËÂÌÈÄÏÃßÖÐÛÛÂÒÖÍÉÇÆ©µì ««²¢¦½§­¾½±¼·ó©¨ôéäö¾²ªãÔ¤ÞÂË«ÐÏ×ÀÜi,aljqci|)i`j jfq}}t9wcclvth>=w{AHB\bBNIEELO[[D^\\@NM\nPNUYB=c|k!/1v21t10D');
	      }), CKFinder.define(S(',neiY_VVF{X\\LV^OzV!--$7j.->9d\b$/#?6:1"'), [S("2FZQSEKZUIY"), S("vlkzRX"), S("SZTzzqse7Lnrp2UzYbMGA"), S("OFHf~uwa;Croj5Y}n{0l@[LQQpNM^"), S("\rMDVx|wqg9Zw}owyn1[I@NLCV	qAL]XiGN\\^UqAABXVJlRYJ"), S("?4$:7e\r!'..>b*=!>2 0%x0;73:-p$\b*B	")], function (e, t, n, i, r, o) {
	        "use strict";
	        var s = 20,
	            a = i.extend({ template: o, className: S("3W^P\\P[WSZ"), ui: { title: S("%\bRA^BXAKVX@@@") }, attributes: { role: S("kyp~|s") }, regions: function regions(e) {
	            return { contents: S(":_VX$(#/+\"k$''>.\"9=b") + e.id, buttons: S("Cg&-!e-#* \")b2$&';;%z") + e.id };
	          }, initialize: function initialize() {
	            this.listenTo(this.contents, S("%UOG^"), function () {
	              this.$el.trigger(S("(JXNMYK"));
	            }, this), t(S('6MPKSMKOm"--0$/)-;')).remove();
	          }, onRender: function onRender() {
	            var t = e.uniqueId(),
	                i = S('ofh"txs{r;{y{w1') + t;this.$el.attr(S("A&\"0$k3 ,'."), this.finder.config.swatch).attr(S("?!3+\"i)'%-%&.(/7"), i).attr(S("6VJP[XXM\\2( & '?"), this.regions.contents.replace("#", "")).appendTo(S("q{qo")), this.options.ariaLabelId && this.$el.attr(S("'I[CJAOMU]^VPWO"), this.$el.attr(S("~RHCHDDBDEOONT")) + " " + this.regions.contents.replace("#", "")), this.ui.title.attr({ id: i, "aria-live": S("8IUWUI[") }), this.contents.show(this.getOption(S("ptuyoHvEV"))), this._addButtons(), this.$el.trigger(S("/SCWR@P")), this.$el.popup(this._getUiConfig()), this.$el.parent().addClass(S("9ORYW^,.%n4*628"));try {
	              this.$el.popup(S("'GYOE"), this.options.uiOpen || {});
	            } catch (r) {}this.$el.find(S('"\rGN@\nL@KGCJMEEF\\ZFUMMNTRfZ^4 o /#k%==>$"pl ;><\'0t\ntw90:p:6\r\rIL(UQôîì¾¦êí¥Õ')).first().focus();var o = this.getOption(S("3RZUBKpN^Q"));if (o) {
	              var s = e.isString(o) ? o : S('>V.177he2"0=+9),bo#4>67!'),
	                  a = this.$el.find(s).first();a.length && a.focus();
	            }return this.options.restrictHeight && this.restrictHeight(), this.$el.on(S("3_POSWNT"), function (e) {
	              e.keyCode !== n.tab && e.stopPropagation();
	            }), this;
	          }, onDestroy: function onDestroy() {
	            try {
	              this.$el.popup(S("#GIITM")), this.$el.off(S("(BORHBYA")), this.$el.remove();
	            } catch (e) {}
	          }, getButton: function getButton(e) {
	            return this.$el.popup(S("6@Q]]^H")).find(S("zlnossE{AUCGN@\nJ\\^_CC\r") + e + S(";`"));
	          }, enableButton: function enableButton(e) {
	            this.getButton(e).removeClass(S('?5(o00$2"e-#8-/"*4')).attr(S("5WEQX_UN_],$&"), S("%@FDZO"));
	          }, disableButton: function disableButton(e) {
	            this.getButton(e).addClass(S("\n~e }{qew>p|evzu")).attr(S('C%7/&e-#8-/"*4'), S("faap"));
	          }, restrictHeight: function restrictHeight() {
	            if (!this.isDestroyed) {
	              var e = t(window).height() - this.ui.title.outerHeight() - this.buttons.$el.outerHeight() - this.$el.parent().position().top - s;this.contents.$el.css(S("xwo5qr{uj"), parseInt(e, 10) + S("4EN"));
	            }
	          }, _fixTopOffset: function _fixTopOffset() {
	            var e = this.$el.parent().css(S("jpP")),
	                t = parseInt(e) - (window.scrollY || window.pageYOffset);this.$el.parent().css(S("D1)7"), t);
	          }, _addButtons: function _addButtons() {
	            var e = this.getOption(S("qaabxvj"));if (e) {
	              var t = this,
	                  n = new r({ finder: this.finder, buttons: e });this.listenTo(n, S('"@LLJC^@O\\O[[D^\\'), function (e) {
	                var n = e.model.get(S("C!3#)<")),
	                    i = e.model.get(S("'FHGN"));(i === S("sp|pqy") || i === S("vqXprmz")) && t.destroy(), t.finder.fire(S("sqxvt{'") + t.getOption(S("'FHGN")) + ":" + n, t.getOption(S("=]S)\")%1'")), t.finder);
	              }), this.buttons.show(n);
	            }
	          }, _getUiConfig: function _getUiConfig() {
	            function t(e, t, n) {
	              i[e] && i[e].apply(t, n);
	            }var n = this,
	                i = {},
	                r = this.getOption(S("itQoTHMMW"));r && e.forEach([S("\nh~ho{u"), S("#ECRBZJFD_H"), S("0SWU[GSGWJSOURP")], function (e) {
	              i[e] = r[e], delete r[e];
	            });var o = { create: function create() {
	                n.contents.$el.css({ minWidth: n.getOption(S("'E@D|EIZG")), minHeight: n.getOption(S("9WRRu[V')6")), maxHeight: window.innerHeight }), t(S("\fn|jqew"), this, arguments);
	              }, afterclose: function afterclose() {
	                n.destroy(), t(S('"BBQCUKEEXI'), this, arguments);
	              }, afteropen: function afteropen() {
	                n._fixTopOffset(), t(S("rrasewiu"), this, arguments);
	              }, beforeposition: function beforeposition(e, i) {
	                r && r.positionTo && (delete i.x, delete i.y, i.positionTo = r.positionTo), setTimeout(function () {
	                  n.options.restrictHeight && n.restrictHeight();
	                }, 0), t(S("BDDLV@VH[@^BCC"), this, arguments);
	              } },
	                s = n.finder.config.dialogOverlaySwatch;return s && (o.overlayTheme = e.isBoolean(s) ? n.finder.config.swatch : s), e.extend(o, r);
	          } });return a;
	      }), CKFinder.define(S("(jamECJJBdZQBEu\\IH]Z[i)$5"), [S("1G]PPDD[VH^"), S("4WWTS[UUY"), S("TS_suxxl0vHGTW\ndF[LbXHCyYTE")], function (e, t, n) {
	        "use strict";
	        var i = n.extend({ name: S("%kB[ZKLI{GJG"), className: S("\fnei=|w`gtqr"), template: S("B75')h .vn65rp8&}=1v*%{d '`~6OETF\rP"), initialize: function initialize(n) {
	            this.model = new t.Model({ msg: n.msg, id: n.id ? n.id : e.uniqueId() });
	          } });return i;
	      }), CKFinder.define(S("SZTzzqse7Tuiq{leKBHJATmCJ@BI\\"), [S("cy||hhrlz"), S("JPWFV\\"), S("1PRW^TXV\\"), S('7{r|RRY[Mo6*(j\r"1\n%/)'), S("C\x00.&-/9c\x00!+%=7 {?646=(s7:M'\r\n\b?"), S("D\r!'..>b&5&!|4%2w.>17:"), S('?\n**!#5g#.;>a5"!230\x00>=.')], function (e, t, n, i, r, o, s) {
	        "use strict";
	        function a(e) {
	          this.finder = e, e.setHandlers({ dialog: { callback: u, context: this }, "dialog:info": { callback: l, context: this }, "dialog:confirm": { callback: c, context: this }, "dialog:destroy": h }), e.request(S("*@ITCYBFVZ"), { key: i.escape }), e.on(S("+GHWZ@\x00"), function (e) {
	            var n, i;i = t(S("$ELNNBMAAH")), i.length && (n = e.data.evt, n.preventDefault(), n.stopPropagation(), h());
	          }, null, null, 20);
	        }function u(t) {
	          var n = this.finder;if (h(), !t.name) throw S("n@OFUGUIDO_I_BEBFVPDH\\YRZT[[`'-1d!/&$&-");var i = e.isUndefined(t.captureFormSubmit) ? !0 : t.captureFormSubmit,
	              o = d(t, n, i),
	              s = f(n, t, o),
	              a = new r(s);return n.request(S("w}paf,e}tv~xl")), a.on(S("3PPECJVC"), function () {
	            n.request(S("%@HK\\Y^H][_CW"));
	          }), i && a.listenTo(o, S('D63%% >q*"<"'), function () {
	            return n.fire(S("\fign|~u)") + t.name + S("/y|"), s.clickData, n), !1;
	          }), a.render(), n.request(S("E (+<9q8?/?"), { node: a.$el }), a;
	        }function l(t) {
	          var n = e.uniqueId(S("C'. j%,98-*+b")),
	              i = e.extend({ name: S('0x\\U['), buttons: !1, view: new s({ msg: t.msg, finder: this.finder, id: n }), transition: S("?&-+3"), ariaLabelId: n }, t);return u.call(this, i);
	        }function c(t) {
	          var n = e.uniqueId(S("qxr8{rkj{|y0")),
	              i = e.extend({ name: S("4vYY^PHV"), buttons: [S("cfMcbw"), S("*HMCMJ\\")], title: this.finder.lang.common.messageTitle, view: new s({ msg: t.msg, finder: this.finder, id: n }), ariaLabelId: n }, t);return u.call(this, i);
	        }function d(e, t, n) {
	          var i;if (e.view) i = e.view;else {
	            var r = { name: e.name, finder: t, template: e.template };n && (r.triggers = { "submit form": { event: S("oh|rIUEKWK"), preventDefault: !0, stopPropagation: !1 } }), i = new (o.extend(r))({ model: e.templateModel });
	          }return i;
	        }function f(t, i, r) {
	          var o = { finder: t, name: i.name, id: e.uniqueId(S("<^UY")), minWidth: i.minWidth ? i.minWidth : t.config.dialogMinWidth, minHeight: i.minHeight ? i.minHeight : t.config.dialogMinHeight, focusItem: e.isUndefined(i.focusItem) ? t.config.dialogFocusItem : i.focusItem, buttons: e.isUndefined(i.buttons) ? [S("~y"), S("3WTXT]U")] : i.buttons, captureFormSubmit: e.isUndefined(i.captureFormSubmit) ? !0 : i.captureFormSubmit, restrictHeight: e.isUndefined(i.restrictHeight) ? !1 : i.restrictHeight, uiOptions: i.uiOptions };return i.ariaLabelId && (o.ariaLabelId = i.ariaLabelId), o.model = new n.Model({ id: o.id, title: i.title, hasButtons: !e.isUndefined(o.buttons), contentClassName: e.isUndefined(i.contentClassName) ? S('>5(o ++2"&=') : i.contentClassName === !1 ? "" : " " + i.contentClassName }), o.clickData = { model: i.templateModel, view: r, context: i.context }, o.innerView = r, o;
	        }function h() {
	          t(S("#\nFMAMCJ@BI")).popup(S("=]S/2'")), t(S("<KVm1-315k$''>*%#+=")).remove();
	        }return a;
	      }), CKFinder.define(S('hxfkbieMKBBZ~NA]BNDTAqQ_CqT[\\Y{[)5.%"#)0%>8c* $'), [], function () {
	        return S("7]SM^R^32a'. j- g<>,>?5#pm^\\j31/z28`|<O\rH\rON\f\x00IWTQ\r\föèçô¦»º¨ìàüµ²ëùç²úð¨´ôóÿ·þõ°ÿüÔÈÍÍ×ÄÄÈÙØÍÄÖ×ÚÖÙÙÌËÕ×ÏËÖí£­§½è½¼õé£¿â¾¹®¤²ºó©¨ôéäö¾²ªãÔãÏÚï");
	      }), CKFinder.define(S("\\kgKM@@T\beFN^@H]\x00uU[G}XWP]lRYJM%+7\r(' -+2#8:"), [S(",neiY_VVF`^]NI~\\MZo\r#:+02!,="), S('&SMQ^\nofhF^UWAaSZHU[OYNz$(6\n)$!"g\f."8#.742-:##v=5/')], function (e, t) {
	        "use strict";
	        return e.extend({ name: S("ZDHVjIDABdHSDYY"), template: t, regions: { preview: S("Cg&-!e,#f<?+994%"), actions: S("Ee$#/g.%`/,$8=='") }, templateHelpers: function templateHelpers() {
	            return { swatch: this.finder.config.swatch };
	          }, onActionsExpand: function onActionsExpand() {
	            this.preview.$el.addClass(S("xw{3zI\fRQASOB_XNHXMJT"));
	          }, onActionsCollapse: function onActionsCollapse() {
	            this.preview.$el.removeClass(S('ofh"ux?cfp`~}n7iyyk|EE'));
	          } });
	      }), CKFinder.define(S("2GQMB{r|RRY[Mo'.4)'3-:e($:=056{;6?<\n)9+7:O\f"), [], function () {
	        return S('5\nTYWLZO]S!21~f&-!e,#f/, 91"pmhz566/;(bW');
	      }), CKFinder.define(S('6tsSUXXL\r.&6( 5h\r-#? /(5~:1"%x4;<9\r,:\b2\f'), [S('@	-+"":f"):=`0!6{"253>+'), S('c}an:_VXvNEGQqCJXEK_I^jTXFzYTQRpWZ[XnM%7+&3k"(<')], function (e, t) {
	        "use strict";
	        return e.extend({ name: S("E*)./>(8&5&"), template: t, ui: { canvas: S("0|KGFM\bEFF_KX") } });
	      }), CKFinder.define(S("?4$:7e\r!'..>b*=!>2 0%x=3/0?8N#\x00\f		F\r"), [], function () {
	        return S(" ywi\x00ECWE\bTHDL	OBBCQAAZVYS][O]]P,-#37 \"j!*%%qo54mq;'z<586$'y|9?+L\b\r\rG\x00RR\n	NTY\x00\\_äàöâ©ìåèæùåø±¯üæ÷ùæ±´ñ÷ãù´óõïøê¢ÇÃÏ×ÀÜÈÈÂÂÉË×¼ÔÖ¤üà¸¿øæ®¼ç£¯ì°³â¤°°ñô¶º¶«ªçù¿¶¸òÏÄÍÐÈÔØÛ-bmmpwik{4(pw0.fd?{w4hk:lxxk}s{sYXOS]C_@HRM\r[\x00<XTH#-#07xd$#/g.%`/,$8==y699,+57/`cOZoZH\f\x00Uf");
	      }), CKFinder.define(S("0ryu][RRJwTXHRZ3n'-1*)./d$+8#~0 <990?,"), [S("A7-  44+&8."), S("wojES["), S("4v}qQW^^NkK)-m\b!<(,,"), S("\nHGKgatt`<B|s`k6Xzox1SAXMVPsOB_"), S("6C]ANvxV.%'1k#*8%+?)>a\n48&9412w9/520q")], function (e, t, n, i, r) {
	        "use strict";
	        return i.extend({ name: S(";}^JV//*!2"), template: r, className: S("-MDVWZTUCQVT"), ui: { heading: S("<ps;rq4{xhtqq\rUKWH@"), controls: S(" AHB\bCNHI_EB@S^\\GFZZD") }, regions: { action: S("(I@J\x00KFPQG]ZX[VTONRRL") }, events: { collapsiblecollapse: function collapsiblecollapse() {
	              this.model.get(S("9NTSQ")).trigger(S("D&)+$(:8)")), this.ui.heading.attr(S("0P@ZUSOHXT_YY"), S(":]]QMZ")).find(S(" WJ	GRI")).removeClass(S("+YDMD_RWA_A]")), this.trigger(S("}pLMCSW@")), this.isExpanded = !1, this.ui.controls.find(S("5mCY[SUXXFb")).attr(S("1FRV\\XS]A"), S("Ekv"));
	            }, collapsibleexpand: function collapsibleexpand() {
	              this.model.get(S("/D^]_")).trigger(S(">Z81#- ")), this.ui.heading.attr(S("2RF\\W]AJZRY[["), S("niix")).find(S("<KVm#6-")).addClass(S("&RAH_B\x00OLDXDV")), this.trigger(S(">Z81#- ")), this.isExpanded = !0, this.ui.controls.find(S("&|\\HHBBIKWm")).attr(S("i}IOFF\\"), this.model.get(S("*_MOGATTJ")));
	            }, collapsiblecreate: function collapsiblecreate() {
	              this.$el.find(S("4C^ZUWP\\NL)#.&i-#&, $,a9!(7=7")).attr(S("8M[YUSZZ8"), this.model.get(S("\nmogattj"))), this.ui.heading.attr(S("0P@ZUSOHXT_YY"), S("qyui~")), this.isExpanded = !1;var e = this.model.get(S("8P^"));this.$el.find(S(" WJ	FIKDHZXEOBJR]]@PXC")).attr({ id: e + S('=K!#2"* *'), role: S("\nmo~n~t~"), "aria-labelledby": e + S("!WEG") });
	            }, "keydown .ui-collapsible-heading-toggle": function keydownUiCollapsibleHeadingToggle(e) {
	              if (e.keyCode === n.space || e.keyCode === n.enter) {
	                e.stopPropagation(), e.preventDefault();var t = S(this.$el.find(S("6MPXSQR^02+!( ")).collapsible(S("vjourp"), S("\nhcabn`bww")) ? "{gP@LG" : ".L_]^RDFS");this.$el.find(S("8OR^QS, 20-'*\"")).collapsible(t);
	              }
	            }, "keydown [tabindex]": function keydownTabindex(e) {
	              e.keyCode === n.tab && (!this.isExpanded && e.target === this.ui.heading.find(S("TKGJJKIYYBNAKXTSW][QLV]\\PX")).get(0) || this.ui.controls.find(S("$~RFJ@DOIUs")).last().get(0) === e.target) && this.trigger(S("cy{H~mh{lT"), e);
	            } }, initialize: function initialize() {
	            this.model.set(S("zp"), e.uniqueId());
	          }, collapse: function collapse() {
	            this.$el.find(S("2A\\TWUVZLNW],$")).collapsible(S("{vvw}mmz"));
	          }, onRender: function onRender() {
	            this.action.show(this.model.get(S("A6,+)")).getView(this.finder)), this.$el.attr(S("{AUCGN@\nM@_CBB"), this.model.get(S('"WKJJ')).get(S("7VXW^")));
	          } });
	      }), CKFinder.define(S("U\\^ptyo1ROEWOAV	bL@^bALIJg[VCFv[MSTRNhV%6"), [S("~dcrj`"), S("W^P~v}i3KwzWR\raEVC\bkFFGINZF__dZQB"), S('B\x00/),,8d"*:<4!|1?#4;<9r\b6L%<	')], function (e, t, n) {
	        "use strict";
	        function i(t, n) {
	          var i = t === S('"GAVMSGY');e(S("<ps;rq4ytrilpLR\rQLDGEFJ\\^GM\\T[QTR^V^OSZYS%")).toggleClass(S("&RAID^CK]P^_@_ZMTU^QQm/-7!=2"), !i).toggleClass(S(n.lang.dir === S("<QJM") ? ">J)l 7*h/$''g')+:" : "([CLDY"), i);
	        }function r(e) {
	          e.data.modeChanged && i(e.data.mode, e.finder);
	        }return t.extend({ name: S("0pQG]ZXDnP_L"), attributes: { "data-role": S("*HCABN@B[QXPERL"), role: S("cy{vroi") }, childView: n, childViewContainer: S("\f.mdv<ww}a;~ux}~1|}kINLP"), childEvents: { expand: function expand(e) {
	              this.children.forEach(function (t) {
	                t.cid === e.cid || t.ui.heading.hasClass(S("hw2CNNOEUUNJEODHOKY_UWZZ[YII^X")) || t.collapse();
	              });
	            }, tabRequest: function tabRequest(e, t) {
	              this.finder.util.isShortcut(t, "") && this.children.last() !== e && this.finder.request(S("zr}jSLF\\Q"), { node: e.$el.find(S("#QGEAGNNTp")).not(S("Nbvzptye#=\r\x00~")).last(), event: t });
	            } }, initialize: function initialize() {
	            var t = this.finder;this.collection.on(S("(@GJKHjNDP\bAQTRN"), function () {
	              i(t.request(S("']@LIYc@TT")), t), e.mobile.resetActivePageHeight();
	            }), t.on(S("/EX\bAQF_M]"), r);
	          }, onDestroy: function onDestroy() {
	            this.finder.removeListener(S("-[F\nCW@]OS"), r);
	          }, focusFirst: function focusFirst() {
	            this.$el.find(S("2hw2CNNOEUUNJEODHOKY_U@ZQPT\\")).first().focus();
	          } });
	      }), CKFinder.define(S("5u|~PT_YOr/%7/!6i, >!,)*=719%x=3/0?8%"), [S('E$&+"($"(')], function (e) {
	        "use strict";
	        var t = e.Model.extend({ defaults: { file: null, caman: null, imagePreview: "", fullImagePreview: "", actions: null }, initialize: function initialize() {
	            this.set(S("B\"'1/(&:"), new e.Collection());
	          } });return t;
	      }), CKFinder.define(S("cjdJJACUdEOYAK\\tVZ@|[V_\\oSRRLo-,("), [S("6UYZQYSS[")], function (e) {
	        "use strict";
	        return e.Model.extend({ getActionData: function getActionData() {
	            return new e.Model({});
	          }, saveDeferred: function saveDeferred(e, t) {
	            return t;
	          }, getView: function getView(e) {
	            var t = this.get(S("A4*!2+):9")),
	                n = new t({ finder: e, model: this.getActionData() });return this.set(S(")\\BIZ"), n), n;
	          } });
	      }), CKFinder.define(S("6C]ANvxV.%'1k#*8%+?)>a\n48&9412w(4,s:0"), [], function () {
	        return S("3\bQ_AZVZON#*$n!,k$:&:f/\" ;\">> y<8'--)ybWWc\f\x00\x00\b[lnaVLAZ0\f0PåäòÂ÷õãäüÛëÿåâ®òí¨üøçííºõýðû¢ÂÉÅç×É×ãÌÏÛíÞÞÊÓÅàÒÀÜÙÍÛÙÕÓÚÚ¸üà¸¿øæ®¼ç¾ª®¤ «µ©ò®©÷ö£¡©¿æþ¾¶ºÇ×ÉÂ°¥Üßcig`o`b:*jbnofkk2ji,ih6sym{6u~qqPNQ^]\b@^@L@HU[A\bUNI@CS%'68?zy:5;#,$954o,/qj__kw5;991`Ui]\x00		H\x00VN	]^U\n\\_ôààêêáãÿµ«ñð±­çû¾åóñýûòòà¹çæ¾½úþÔÀÊÇÊÈÊÁÍÙÇÌÛ×ÕÁ×ÑÚÕÕÌÒÍâº¹üä¬²é¤¨¤¬â©§½ðìïóó¹¢¥ÿ¤§·¹»ª¤ÞÝÓÍÎÎÔÙÒ¸tHobc`(fxyfr,ps3?sgg`zx)%5uk ");
	      }), CKFinder.define(S('6tsSUXXL\r.&6( 5h\r-#? /(5~:1"%x+5+\n4;('), [S("4v}qQW^^NkK)-m\b!<(,,"), S("ZQ]uszzRtJARU\bjHYNdZJ]g[VC"), S("1FVLAtsSUXXL$/3($2\";f/%9\"167|'9'v=5/")], function (e, t, n) {
	        "use strict";
	        return t.extend({ name: S("E5'9\"):"), template: n, className: S("{r|6yt3|RNRGJHSZFFX"), ui: { keepAspectRatio: S(">V.177+'*-th('+\r=?!61%$(<9/<*6C?"), apply: S("3V]Q\\S_OQOm 23(<") }, triggers: { "click @ui.apply": S(",L^_\\H") }, events: { "change @ui.keepAspectRatio": function changeUiKeepAspectRatio(e) {
	              e.stopPropagation(), e.preventDefault(), this.model.set(S(")ANI]o\\@TQGfTB^W"), this.ui.keepAspectRatio.is(S(":_U[\\+$&")));
	            }, "keyup @ui.keepAspectRatio": function keyupUiKeepAspectRatio(t) {
	              (t.keyCode === e.space || t.keyCode === e.enter) && (t.preventDefault(), t.stopPropagation(), this.ui.keepAspectRatio.prop(S("1Q[QV]R\\"), !this.ui.keepAspectRatio.is(S("(ICINEJT"))).checkboxradio(S('A0&"7#4 ')).trigger(S("'KAKEKH")));
	            }, "keydown @ui.apply": function keydownUiApply(t) {
	              (t.keyCode === e.space || t.keyCode === e.enter) && this.trigger(S("E'78%3"));
	            } } });
	      }), CKFinder.define(S('"WA]RkblBBIK]eW^DYWC]J~XTJv- %&k4(8%3b)!;'), [], function () {
	        return S("%CA_\nH@L]\\\rQXRS^ZHTL\x005I}&*2e%+):9vn.%)}4;~7'9'u+?(5';}@\rTHPN_ZP\\L^ý£¼¿«áïñ¶·èäø¯óýóàç¨´ôóÿ·þõ°ýíÏÑÊÊÃÉÏÅÛ¥ÖÚÂ");
	      }), CKFinder.define(S("TS_suxxl0mNFVH@U\bmMC_e@OHUdZQBE{KUK~RFi)$5"), [S("A(21 4>"), S(">|+-  4h /<?b\f.#4} 0;1<-"), S('hxfkbieMKBBZ~NA]BNDTAqQ_CqT[\\Y}M/1\x00,<k"(<')], function (e, t, n) {
	        "use strict";
	        var i = t.extend({ name: S("VdxhOs~k"), className: S("<^UYm$+n'7)7e>8*<"), template: n, ui: { cropBox: S("/RYUP_[KUK"), cropResize: S("/RYUP_[KUKO[L);'"), cropInfo: S("5TS_^U]M/1o**#)") }, events: { "vmousedown @ui.cropBox": S('@.,+05"\f&=%'), "vmouseup @ui.cropBox": S("OOoLQVCrX"), "vmousedown @ui.cropResize": S("{{[xmj_sjpPNsGPM_C"), "vmouseup @ui.cropResize": S("=QQ\r.70!6\b&/8%7+") }, modelEvents: { change: S("=KO$ 6&*5.< %%"), "change:keepAspectRatio": function changeKeepAspectRatio() {
	              if (this.model.get(S("B(! 6;9/(8/;9>"))) {
	                var e = this.model.get(S("E4\"&-/9('(8%")),
	                    t = this.model.get(S('?- :!+"":/"+%:')),
	                    n = this.model.get(S("1_RLgSY\\\\HlUYJW")),
	                    i = t - this.model.get(S("0CW]PPDn")),
	                    r = n - this.model.get(S("\fkatt`K"));e > i && (e = i);var o = parseInt(e * n / t, 10);o > r && (o = r, e = parseInt(o * t / n, 10)), this.model.set({ renderWidth: o, renderHeight: e });
	              }
	            } }, onRender: function onRender() {
	            var e;e = this.model.get(S("z{uj|m")), this.$el.css({ width: this.model.get(S("1_RLgSY\\\\HlUYJW")), height: this.model.get(S(",@OWbT\\WQG~RQ^RO")) }), this.ui.cropBox.css({ backgroundImage: S(":NNQ") + e.toDataURL() + ")", backgroundSize: this.model.get(S("xwoJ|tyoIvDUJ")) + S("8IB") + this.model.get(S("alv]uvvf]s~qn")) + S("bk") }), this.updatePosition();
	          }, onMouseDown: function onMouseDown(t) {
	            var n = this;t.stopPropagation(), e(window).on(S("!TNKPUBEF\\N"), { model: n.model, view: n, moveStart: { x: t.clientX - n.model.get(S("7J\\T_YOf")), y: t.clientY - n.model.get(S("&UMGNN^t")) } }, n.mouseMove), e(window).one(S("ntunoxko"), function () {
	              n.onMouseUp();
	            });
	          }, onMouseUp: function onMouseUp(t) {
	            t && t.stopPropagation(), e(window).off(S("'^DE^_HC@FT"), this.mouseMove);
	          }, mouseMove: function mouseMove(e) {
	            var t, n, i, r, o, s, a, u;t = e.data.model, n = e.data.view.ui.cropBox, i = e.clientX - e.data.moveStart.x, r = e.clientY - e.data.moveStart.y, o = n.outerWidth(), s = n.outerHeight(), a = t.get(S("ytnE}w~~nJw{TI")) - o, u = t.get(S('8T[CnXP[%3\n&-".3')) - s, i = 0 > i ? 0 : i, r = 0 > r ? 0 : r, i = i > a ? a : i, r = r > u ? u : r, t.set({ renderX: i, renderY: r });
	          }, onMouseDownOnResize: function onMouseDownOnResize(t) {
	            var n = this;t.stopPropagation(), e(window).on(S("C2()2;,'$:("), { model: n.model, view: n, moveStart: { x: t.clientX - n.model.get(S('B1!+"":#/8%')), y: t.clientY - n.model.get(S("nxp{ESjFMBNS")) } }, n.mouseResize), e(window).one(S("f|}fgpcg"), function () {
	              n.onMouseUpOnResize();
	            });
	          }, onMouseUpOnResize: function onMouseUpOnResize() {
	            e(window).off(S("!TNKPUBEF\\N"), this.mouseResize);
	          }, mouseResize: function mouseResize(e) {
	            var t, n, i, r, o, s;t = e.data.model, n = t.get(S("@,+-7)7")), i = e.clientX - e.data.moveStart.x, r = e.clientY - e.data.moveStart.y, o = t.get(S("\nfmu\\j~uwaC|rcp")) - t.get(S("2AQ[RRJa")), s = t.get(S("s~XsGM@@ToM@MCX")) - t.get(S('B1!+"":')), r = n > r ? n : r, i = n > i ? n : i, t.get(S(")ANI]o\\@TQGfTB^W")) && (i = parseInt(r * t.get(S("+ALV}U_VVFb_SLQ")) / t.get(S("s~XsGM@@ToM@MCX")), 10)), i = i > o ? o : i, r = r > s ? s : r, t.set({ renderWidth: i, renderHeight: r });
	          }, updatePosition: function updatePosition() {
	            var e = this.model.get(S("+^H@KUCj")),
	                t = this.model.get(S("\r|j~uwaM")),
	                n = (this.ui.cropBox.outerWidth() - this.ui.cropBox.width()) / 2;this.ui.cropBox.css({ top: t + S("en"), left: e + S("`i"), width: this.model.get(S("\fkatt`D}qb")) - 2 * n + S('"S\\'), height: this.model.get(S("lzNEGQl@O@@]")) - 2 * n + S("fo"), backgroundPosition: -e - n + S(":KD") + (-t - n) + S("-^W") }), this.ui.cropInfo.text(this.model.get(S("A5* 1.")) + "x" + this.model.get(S("}s~qn"))), this.ui.cropInfo.attr(S("hlzn=ryu9eydqmstr"), this.model.get("x") + "," + this.model.get("y"));
	          } });return i;
	      }), CKFinder.define(S("RYU}{rrj6WtxhrzSgGMQoJINOxBACCqA[EbXWU"), [S('?" !(&*("'), S("\fgzuck"), S("RYU}{rrj6WtxhrzSgGMQoJINOxBACCf\\[Y"), S("#gn`NFMOY`AKE]W@pR^LpWZ[Xi)$50k4(8#.;"), S('6tsSUXXL\r.&6( 5h\r-#? /(5~:1"%x+5+2&		')], function (e, t, n, i, r) {
	        "use strict";
	        return n.extend({ defaults: { name: S(",n\\@@"), viewClass: i, view: null, isVisible: !1 }, initialize: function initialize() {
	            function n(e) {
	              var t, n, i;i = e.get(S("/BT\\WQGa^\\MR")), n = e.get(S("D7#),,8)$)'$")), t = e.get(S("\nbalijGxvg|")) / e.get(S("M@ZqAKBBZ~COXE")), e.set(S("gxvg|"), parseInt(i * t, 10)), e.set(S(":SYTYW4"), parseInt(n * t, 10)), e.set("x", parseInt(e.get(S("h~ry{mx")) * t, 10)), e.set("y", parseInt(e.get(S("gsy||hB")) * t, 10));
	            }function i() {
	              r.get(S(";UNhV3( /!")) && (r.closeCropBox(), r.openCropBox());
	            }this.viewModel = new e.Model({ x: 0, y: 0, width: 0, height: 0, renderWidth: 0, renderHeight: 0, maxWidth: 0, maxHeight: 0, imageWidth: 0, imageHeight: 0, keepAspectRatio: !1, tabindex: this.get(S("E2&* $/)5")) }), this.viewModel.on(S("&D@HDLI\\J^UWAc\\RCP"), n), this.viewModel.on(S("\fnfn~vw)fpxs}kR~uzvk"), n), this.viewModel.on(S("1Q[U[QRK_UXXLg"), n), this.viewModel.on(S("'KAKEKH]U_VVFl"), n), this.collection.on(S("\fdcnwtVr`t,e}x~b"), function () {
	              var e, n, i, r, o, s;e = this.get(S("\rkkye[~ursSym{")), s = e.get(S("&DIDKE")).renderingCanvas, n = t(s).width(), i = t(s).height(), r = parseInt(n / 2, 10), o = parseInt(i / 2, 10), this.viewModel.set({ canvas: e.get(S('?# /"*')).renderingCanvas, minCrop: 10, x: e.get(S("0X_RSPa^\\MR")), y: e.get(S("%OJINOcIDIGD")), renderX: parseInt((n - r) / 2, 10), renderY: parseInt((i - o) / 2, 10), width: e.get(S("!KNEBCpAM^C")), height: e.get(S("!KNEBCoM@MCX")), renderWidth: r, renderHeight: o, maxRenderWidth: n, maxRenderHeight: i, imageWidth: e.get(S("\nbalijYt|")).width, imageHeight: e.get(S("upxEhLEK")).height }), this.get(S('"UM@Q')).on(S("!CSTI_"), function () {
	                this.cropView();
	              }, this);
	            }, this), this.on(S("wkdtxs"), this.openCropBox, this), this.on(S("~qsL@RPA"), this.closeCropBox, this);var r = this;this.collection.on(S("lvuw&o{lEUBBQCU"), i), this.collection.on(S(" TKV@UNRL"), i);
	          }, cropView: function cropView() {
	            var e = this.get(S("@$&*0\f+&/,*8,")),
	                t = e.get(S("\fnobq")).renderingCanvas,
	                n = t.width / this.viewModel.get(S("s~XsGM@@TpAM^C"));e.get(S("+OLCN^")).crop(parseInt(n * this.viewModel.get(S("3FPXS]KmRXIV")), 10), parseInt(n * this.viewModel.get(S("7J\\T_YOvZ)&*7")), 10), parseInt(n * this.viewModel.get(S("C6 (#-;")), 10), parseInt(n * this.viewModel.get(S('B1!+"":')), 10)), this.collection.requestThrottler();var i = !1;e.get(S("E'$< %%?")).forEach(function (e) {
	              e.get(S("4AYXT")) === S("=lP4 6&") && (i = !i);
	            }), n = (i ? e.get(S("\fdcnwtZv}r~c")) : e.get(S("6^UX]^kTZK("))) / this.viewModel.get(S("\nfmu\\j~uwaC|rcp")), e.get(S("%GD\\@EE_")).push({ tool: this.get(S("'FHGN")), data: { width: parseInt(n * this.viewModel.get(S(".]U_VVFb_SLQ")), 10), height: parseInt(n * this.viewModel.get(S("6E]W^^Nu[V')6")), 10), x: parseInt(n * this.viewModel.get(S("j|tyoF")), 10), y: parseInt(n * this.viewModel.get(S(".]U_VVFl")), 10) } }), this.closeCropBox();
	          }, openCropBox: function openCropBox() {
	            var e = this.get(S("\nnhdzF}puvPtbv")).get(S("E%&%($")).renderingCanvas,
	                n = t(e).width(),
	                i = t(e).height(),
	                o = parseInt(n / 2, 10),
	                s = parseInt(i / 2, 10);this.viewModel.set({ maxRenderWidth: n, maxRenderHeight: i, renderWidth: o, renderHeight: s, renderX: parseInt((n - o) / 2, 10), renderY: parseInt((i - s) / 2, 10) }), this.cropBox = new r({ finder: this.collection.finder, model: this.viewModel }), this.cropBox.render().$el.appendTo(t(this.get(S('"F@LRnEHMNhLZN')).get(S("<^_R!/")).renderingCanvas).parent()), this.set(S("9SHjTMV\"-'"), !0);
	          }, closeCropBox: function closeCropBox() {
	            this.cropBox && this.cropBox.destroy(), this.set(S("?)2*7,$+-"), !1);
	          }, saveDeferred: function saveDeferred(e, n) {
	            var i, r;return i = new t.Deferred(), r = i.promise(), n.then(function (t) {
	              t.crop(e.width, e.height, e.x, e.y).render(function () {
	                i.resolve(this);
	              });
	            }), r;
	          }, getActionData: function getActionData() {
	            return this.viewModel;
	          } });
	      }), CKFinder.define(S("$QC_\\\bi`jD@KUCgQXF[YM_HxZV4\b/\"# i'=+?)c* $"), [], function () {
	        return S("(NBZ\rMCQBAV]Q\\SNRJ^4$o ++25'%9f%#>:$\"pm^\\j5--.42}7;]C\bHE\rB\b_^áãëíààþºªòñ¶¬äú¡äððúúñóï¸äç¹¼ùÿëÁËÀËËËÂÌÞÂÚÎÄÔßÑÓÂÝÛÏÝ×Ü¯¯²¬·øä¼³öê¢¸ã¢®¾¶ü·½§öêåùý·¨¯ù¢Ø×Í×ÈÄÚÓnf,F`lrNehmn\"a{qewRzaTtvypktmz\x00\\_GSS\\FD&$MEEF\\Z_SYPZ[Vm3-7%1#j+%%(':'<5sr'57?9<<\"f~&%b@\bM\rLMPXGYRòîöâðà«õáîâÿ®­êîäð¿ú÷úøç÷ê§¹çæ¡¿ÉÕÏÅËÁÌÀØÜÅÀÉÈÚÒÞÍÁÀÃÂ²¨¥«°¾½øµ´èõ·¶óï¹¥ü¿µ»±ù½³¯°¿¸Ï«ÑÈÚÂ÷ÂÐdht=");
	      }), CKFinder.define(S('*hgkGATT@yZRBT\\IyYWK	,#$!j.->9d":.$4:1"'), [S("L[W{}ppd8Mmsw3V{fcNFF"), S("6tsSUXXL('47j&;,e8(#94%"), S("\fykwd0QXR|xs}k5OypnsAUGP`BN\\`GJKH}_ESGQRXL")], function (e, t, n) {
	        "use strict";
	        return t.extend({ name: S("@|`tbrNpl"), template: n, ui: { clockwise: S("BIE	@O\nZF^JXHL\\^QXC\\ER"), antiClockwise: S(" AHB\bCN[E_MYKQ_FZWYYTSNSHY") }, events: { "click @ui.clockwise": S("xvZvtvivSD"), "click @ui.antiClockwise": S('8VTzRIW|,.!(3,5"'), "keydown @ui.clockwise": function keydownUiClockwise(t) {
	              (t.keyCode === e.space || t.keyCode === e.enter) && this.onClockwise();
	            }, "keydown @ui.antiClockwise": function keydownUiAntiClockwise(t) {
	              (t.keyCode === e.space || t.keyCode === e.enter) && this.onAntiClockwise();
	            } }, onClockwise: function onClockwise() {
	            this.model.unset(S("=R^35,0$2.''%+!+"), { silent: !0 }), this.model.set(S("+@L][b^FR@\\YYyW]WY"), 90);
	          }, onAntiClockwise: function onAntiClockwise() {
	            this.model.unset(S("4YWDLkUO]IWP.\x00,$( "), { silent: !0 }), this.model.set(S(")FJ_Y|@DPFZ[[wY_U_"), -90);
	          } });
	      }), CKFinder.define(S(" bieMKBBZgDHXBJCwW]AZY^_hRQS3n,0$2\"&%'"), [S("*A]XK]I"), S("B!%&-%''/"), S("5u|~PT_YOr/%7/!6i, >!,)*=<8&y766"), S('2ps_Y\\\\HqRZJ,$1l!/3$+,)b&5&!|:"6,<\f29*')], function (e, t, n, i) {
	        "use strict";
	        return n.extend({ defaults: { name: S('"qKQGSM'), viewClass: i, view: null, rotationApplied: !1 }, initialize: function initialize() {
	            function e() {
	              var e = n.get(S('6R\\PNrQ\\YZ 6"')).get(S("\flm{y~|`"));e.remove(e.where({ tool: n.get(S(":U]P[")) })), n.viewModel.set(S("%GIOEO"), 0), n.viewModel.set(S("\fao|dC}guaxvXt|px"), 0);
	            }var n = this;this.viewModel = new t.Model({ angle: 0, lastRotationAngle: 0, tabindex: this.get(S("#PDDNFMOS")) }), this.viewModel.on(S(">\\( ,$!*&;=$8,:&??=393"), function (e, t) {
	              this.get(S("\nnhdzF}puvPtbv")).get(S("B\"'1/(&:")).push({ tool: this.get(S("zt{r")), data: t }), this.set(S("8KUO]IWP.\x0023(,##"), !1), this.collection.requestThrottler();
	            }, this), this.collection.on(S("A6+6*23$,"), function (e) {
	              this.get(S("kuo}iwpN`RSHLCC")) || (e.rotate(this.viewModel.get(S("}s``Gycymstr\\pxLD"))), e.render(), this.set(S('E4(<(>"##? =;60'), !0));
	            }, this), this.collection.on(S("C0*)+r;/8)9t") + this.get(S("2]UXS")), e), this.collection.on(S("\fya`|+`vgpb-yuv"), e);
	          }, saveDeferred: function saveDeferred(t, n) {
	            var i, r;return i = new e.Deferred(), r = i.promise(), n.then(function (e) {
	              e.rotate(t).render(function () {
	                i.resolve(this);
	              });
	            }), r;
	          }, getActionData: function getActionData() {
	            return this.viewModel;
	          } });
	      }), CKFinder.define(S("7L\\BO~uy)/&&6j\"%9&*8(=`5;'870=v?6(-+N\r"), [], function () {
	        return S('`gc>vTDJHQCU[\nMEAZJBON>	R^NYW]NMb")%i /j. &?)?lqZXn?573;x:6:/.c}\nN\fK@\fRXYQ\n­èáìê¨êâîýªþå çìÿÿ¿èï¨¶ññõîþî³÷üÏÏÞÙÁÇÛ×ÖÖØÞÇÑÇÙÙÔßÁÀ»ºÿã¢¬ª³­»ä§­¯«£ð¬¯ïû¹·µ½µäÑÕá·±ÃÔÈÃÜÕÝ ocna8$|s4*meazjb?|ryp6je;:rx <d[EMIRBZDJAHRM^][CBZTRK%3l ++ ./g\'""m32r[[Ztuv:9!gy\'&c\bH\fC\bQVU	GYC_æèî÷á÷¨äççìâë£ýûõá²îé·¶áùõïþ¡¿åäÄÊÈÑÃÕÊÅÅÊÄÉÙßÛÇÈËÍÃËÙÍ¡¯¥¦æÏÏÎèéê¯­¹¯â¶¸¾§±§ëõ£¢çûº´²«ÌÇÈËÝÅÛÁÝlugq*fiin`m%ecg{0lo14awuqw~~d <d[JPRFJ@DOIURM\f9\bR^N0@GCCBJ');
	      }), CKFinder.define(S("3w~p^V]_IpQ[5-'0k\x00\".<\x00'*+(a94% {2=-*.\r58)"), [S("#NTSBZP"), S("@## /'))-"), S("P_Sy||h4Jt{hS`BW@	n\\LG}EHY"), S('*_IUZsztZZQSEm_VLQ_K%2m ,2%(-.c\f*%%"&}0:"')], function (e, t, n, i) {
	        "use strict";
	        var r = 100;return n.extend({ isSliding: !1, applyFilterInterval: null, lastFilterEvent: null, name: S("5wSRLIOjT[H"), template: i, events: { "slidestart .ckf-ei-filter-slider": S('E))%#/):."%'), "slidestop .ckf-ei-filter-slider": S("\fb`\\|xvvGayg"), "change .ckf-ei-filter-slider": S("Tzxase"), "keyup .ckf-ei-filter-slider": S("uuZtrkES") }, initialize: function initialize() {
	            this.model.get(S(".NSE[EQs_[L\\HH")).on(S("B1!6#3"), function () {
	              this.render();
	            }, this);
	          }, onSlideStart: function onSlideStart() {
	            this.isSliding = !0;
	          }, onSlideStop: function onSlideStop(e) {
	            this.isSliding = !1, this.applyFilters(e);
	          }, onRender: function onRender() {
	            this.$el.trigger(S("$FTBI]O"));
	          }, onFilter: function onFilter(e) {
	            var t = this;t.isSliding || (this.lastFilterEvent = e, this.applyFilterInterval || (this.applyFilterInterval = setInterval(function () {
	              Date.now() - t.lastFilterEvent.timeStamp > 100 && (t.applyFilters(t.lastFilterEvent), clearInterval(t.applyFilterInterval), t.applyFilterInterval = null);
	            }, r)));
	          }, applyFilters: function applyFilters(n) {
	            var i, r, o;o = this.model.get(S("yznrjxXvLUGQW")), r = e(n.currentTarget).data(S("A$*(1#5")), i = o.where({ filter: r })[0], i || (i = new t.Model({ filter: r }), o.push(i)), i.set(S(",[OCET"), e(n.currentTarget).val());
	          } });
	      }), CKFinder.define(S('8zq}USZZ2n, 0*";f/%9"167|\x00:9;+v?6(-+4\r'), [S("9PJIXLF"), S("rpqxvzxr"), S("nry{mSBMQA"), S("RYU}{rrj6WtxhrzSgGMQoJINOxBACCf\\[Y"), S('"`ocOILLXaBJZ\\TAqQ_CqT[\\YhV%61l!,2;="):')], function (e, t, n, i, r) {
	        "use strict";
	        return i.extend({ defaults: function defaults() {
	            var e = this.collection.finder.config,
	                t = [{ name: S('"AVLAO\\GOX_'), icon: S("w~p:zks|tipzSR"), config: { min: -100, max: 100, step: 1, init: 0 } }, { name: S("0R]]@GWDL"), icon: S('ofh"s~|gftec'), config: { min: -100, max: 100, step: 1, init: 0 } }, { name: S("kxnnn|jvOO"), icon: S("}tF\fQBPPTF\\@EE"), config: { min: -100, max: 100, step: 1, init: 0 } }, { name: S("`~zk{ux"), icon: S("0RYUC_UJXTXY"), config: { min: -100, max: 100, step: 1, init: 0 } }, { name: S("(LR[C^[]U"), icon: S("@\")%i >7':?9)"), config: { min: -100, max: 100, step: 1, init: 0 } }, { name: S(")B^I"), icon: S("{r|6th{"), config: { min: 0, max: 100, step: 1, init: 0 } }, { name: S("=MZ0(#"), icon: S("\nhgk#|ua{r"), config: { min: 0, max: 100, step: 1, init: 0 } }, { name: S("@&#.)$"), icon: S("ts7|}ps~"), config: { min: 0, max: 10, step: .1, init: 1 } }, { name: S("7VVSHY"), icon: S(";_VX..+0!"), config: { min: 0, max: 100, step: 1, init: 0 } }, { name: S("6TTPJ"), icon: S("v}q5zvrl"), config: { min: 0, max: 100, step: 1, init: 0 } }, { name: S("\nxdl|u"), icon: S("5U\\^IS]ONZ."), config: { min: 0, max: 100, step: 1, init: 0 } }, { name: S("/CESP_wZBJ"), icon: S("qxr8t{mk"), config: { min: 0, max: 20, step: 1, init: 0 } }],
	                i = n.filter(t, function (t) {
	              return n.contains(e.editImageAdjustments, t.name);
	            });return { name: S("8x^QINJ"), viewClass: r, view: null, filters: i };
	          }, initialize: function initialize() {
	            function e() {
	              var e = n.get(S("1WW]AZY^_]I_")).get(S("}~jvOOQ"));e.remove(e.where({ tool: n.get(S("*EM@K")) })), i.reset();
	            }var n = this,
	                i = new t.Collection();i.on(S("4TRS"), function () {
	              n.collection.resetTool(S("(yXN_HZ\\"));
	            }), n.collection.on(S("$QIHDXN_HZ") + n.get(S("aq|w")), e), n.collection.on(S(">K/..y6 5\"<s+' "), e), i.on(S("B ,$( -"), function () {
	              var e, i, r, o;o = n.get(S("|~rhTs~GDfBPD")), r = o.get(S("3UVB^WWI")), i = r.where({ tool: n.get(S("&IIDO")) })[0], e = this.toJSON(), i || (i = new t.Model({ tool: n.get(S("tzqx")) }), r.push(i)), i.set(S("wuaw"), e), n.collection.requestThrottler();
	            });var r = new t.Model({ filters: this.get(S("qqun~nn")), activeFilters: i, tabindex: this.get(S("5BVZPT_YE")) });this.on(S("zrzrz{%EEKWmHG@MmK_M"), function (e, t) {
	              r.set(S("5P^T\\"), t.get(S("6QQU_")));
	            }), this.collection.on(S(">K(3-70)#"), function (e) {
	              i.length && i.clone().forEach(function (t) {
	                e[t.get(S("(OCGXH\\"))](parseFloat(t.get(S("V@NVA"))));
	              });
	            }), this.viewModel = r, this.activeFilters = i;
	          }, getActionData: function getActionData() {
	            return this.viewModel;
	          }, saveDeferred: function saveDeferred(t, n) {
	            var i = new e.Deferred(),
	                r = i.promise();return n.then(function (n) {
	              e.each(t, function (e, t) {
	                n[t.filter](parseFloat(t.value));
	              }), n.render(function () {
	                i.resolve(this);
	              });
	            }), r;
	          } });
	      }), CKFinder.define(S("+XHV[ryu][RRJn^QMR^4$1l!/3$+,)b=5\"7''{28,"), [], function () {
	        return S("kjl3}a8gj|i~hn$?PSGPAQZU#IYYZ@^Q_UFE\nZQ]XW03'0!1dg,(>*a=<*#4&nv.-jx)(>/8*q\x00DEH	\n\n\bLP\bHV\fWåù¢þù§¸µãæë­íãñâá®¶öýñµüó¶ìïûìÅÕÓÖÀÐÎÍÞÍÁÚÊÉÅÄÒËÜÎÐÜÜÚ¬á¿¾æåéùè²±öì½¼ª£´¦ý¸´´²´ù§¦Öáñ½Ûìæ");
	      }), CKFinder.define(S("<~uy)/&&6j(,<&.?b+9%>523x0?,/r-3"), [S(";ISZZ22!,6 "), S("eadwam"), S("#gn`NFMOYxZF\\yVMvYS]"), S(".l{w[]PPDnP_LO|^3$m\n0 +!,="), S("9N^DI|+-  4h,'; ,:*#~7=!:9>?t\f/;,M\x00\n")], function (e, t, n, i, r) {
	        "use strict";
	        var o = 240,
	            s = 80;return i.extend({ name: S("<mLZ3$60,#0"), template: r, events: { "click .ckf-ei-preset": S("=QQ3'0!1"), "keydown .ckf-ei-preset": function keydownCkfEiPreset(e) {
	              (e.keyCode === n.space || e.keyCode === n.enter) && this.onPreset(e);
	            } }, onRender: function onRender() {
	            function n() {
	              if (d.length) {
	                var e, r;e = t(d.shift()), r = e.data(S("a`vgpb")), u("#" + l, i, function () {
	                  this.revert(!1), this[r]().render(function () {
	                    e.find(S("ILE")).attr(S("A11'"), this.toBase64()), n();
	                  });
	                });
	              } else c.remove();
	            }var i,
	                r = this.model.get(S("w{q"));if (this.finder.config.initConfigInfo.thumbs) {
	              var a;e.forEach(this.finder.config.initConfigInfo.thumbs, function (e) {
	                var t = parseInt(e.split("x")[0]);!a && t >= o && (a = t);
	              }), a && (i = this.finder.request(S("#BLJBNO_xE[BR"), { file: r }));
	            }i && this.finder.config.initConfigInfo.thumbs || (i = this.finder.request(S("%OJINO\\_KYYTEfFY"), { file: r, maxWidth: o, maxHeight: s, noCache: !0 }));var u = this.model.get(S("Yzq|p")),
	                l = e.uniqueId(S("|KG")),
	                c = t(S("3\bVWYNXI")).attr(S("0XV"), l).attr(S("*\\EIZG"), o).attr(S("txwxHU"), o).css(S("9^ROMR^9"), S("?..,&")).appendTo(S("{ue")),
	                d = this.$el.find(S(".SZTQ\\GJ\\I^H")).toArray();n();
	          }, onPreset: function onPreset(e) {
	            this.model.set(S("1SP@\\@R"), t(e.currentTarget).data(S("gj|i~h")));
	          } });
	      }), CKFinder.define(S("(jamECJJB\\P@ZRK_UIwR!&'l*)+;f9)>+;#=<8"), [S("8SKNYOG"), S("8LT_YOM\\/3'"), S("quv}uww"), S('B\x00/),,8d"*:<4!|1?#4;<9r\n0\rL0\n	'), S('8zq}USZZ2n, 0*";f/%9"167|<3 +v\n)9.;+7')], function (e, t, n, i, r) {
	        "use strict";
	        return i.extend({ defaults: function defaults() {
	            var e, n, i;return e = this.collection.finder.config, n = [{ name: S("pxtd~l`") }, { name: S("D&))+,$?>,:*") }, { name: S("@\"0,765'*/8?") }, { name: S("zrpWHLDwPH") }, { name: S(";[OKQ'8") }, { name: S("#LD\\^lHSX") }, { name: S("8Q_VUSYH!8") }, { name: S("}kWzvxmkY") }, { name: S("#NDTV]LY") }, { name: S("0]]^[") }, { name: S("$IIQM") }, { name: S("ttoisGHC") }, { name: S("\ractS}|`") }, { name: S("\fb|n~vwCqpz") }, { name: S("'X@DCCAK") }, { name: S(" RKMgLR^") }, { name: S("7KLTIUN[") }, { name: S("D3/)<(-.") }], i = t.filter(n, function (n) {
	              return t.contains(e.editImagePresets, n.name);
	            }), { name: S(" qPFW@RT"), viewClass: r, view: null, presets: i };
	          }, initialize: function initialize() {
	            function e() {
	              var e = t.get(S("tvz`\\{v|^zh|")).get(S("$DESAFDX"));i.set(S("@ !7-3#"), null), e.remove(e.where({ tool: t.get(S(";R\\SZ")) }));
	            }var t = this,
	                i = new n.Model({ Caman: this.get(S("&dIDKE")), active: null, presets: this.get(S("8IH^OXJL")), tabindex: this.get(S("2GUW_Y\\\\B")) });i.on(S("D&.&&./q-.:&&4"), function (e, n) {
	              var i, r;n && (t.collection.resetTool(S("%gCB\\Y_")), i = t.get(S("*NHDZf]PUVpTBV")), r = i.get(S(".NSE[\\ZF")), r.remove(r.where({ tool: t.get(S("\nem`k")) })), r.push({ tool: t.get(S(";R\\SZ")), data: n }), t.collection.requestThrottler());
	            }), t.collection.on(S("nsnrjkLD"), function (e) {
	              var n = t.viewModel.get(S("D$%3!?/"));n && e[n]();
	            }), t.collection.on(S("g{zz-j|i~h'") + t.get(S("~pv")), e), t.collection.on(S("hrqsSGPAQFDE"), e), this.on(S('"@LDH@MOOEYgBQVWwUAW'), function (e, t) {
	              i.set(S("ztrz"), t.get(S("'N@FN")));
	            }), this.viewModel = i;
	          }, saveDeferred: function saveDeferred(t, n) {
	            var i, r;return i = new e.Deferred(), r = i.promise(), n.then(function (e) {
	              e[t]().render(function () {
	                i.resolve(this);
	              });
	            }), r;
	          }, getActionData: function getActionData() {
	            return this.viewModel;
	          } });
	      }), CKFinder.define(S('&SMQ^\nofhF^UWAaSZHU[OYNz$(6\n)$!"g/8%7+a4>&'), [], function () {
	        return S("!zvVAOEVU\n\\CK_GKP\r><\nSQOXP\\ML}c!(\"h#.e;/8%7+b3><'&::$u04+))-}^kkjX\f\bJ\r\x00RR&-	] ÷ãïñà»¥óò·«åù ëùââÿõìÁþüíò»áà¼¿ÔÀÀÊÊÁÃßÑÐÇÛÅÓÑÝÛÒÒÀÇÆ´¶Éý²ã§©§´»ôè¨§«ãª¹ü ¶§¼¬²õºµµ¨¯±³ÌÄÙÕÅÒççæÌÖÆÞRdqj~`Nbanb.-xn|dw.6nm*8pn5xtmoL@[kALAO\\	WV\rZNRX\\WQMCBUIK!#+-  >g54huFDGs q1?5&%jz:1=q87r\n\x00KB\nVK\r\fEYRç¯ÒêüàêÔàæøÿñð² à¯¨ºòþî§§³ù÷é«ÏÅÇÃË££Ð×ÆÄÞÒÚÒòÜÐÎòÑÜÙÚîª§¦´µ·­ª¾­¹§ ð¬¯ÙÝé¿¹¨¬®û¨¤®ºÝÃÈËÉ×ÅÙÒioff|%{z*)djah3-sztAqfm}R~l\\moEBVqEQOH\n	QP\rG[ZWVDtEG]ZNi]IWP`<? , %,--wi/%+,;46q/.i*%y>:(<s6\f[EUK@]WEDZ\\	\fXýüîæâñýü·¶÷öþäéçäêé¬éè´©¥µ÷ýÿûó«ÁÑÑÒÈÆÃÏÍÄÖ×ÚÇÓÄÑÃßÝÍÎÓ¹ãâ·¥§¯©¬¬²öî¶µòð¸¦ý ´´¾¶½¿£ü £ýÀÈ×ÉÂÖÕ×or?!~9'a}$gmci!tx`3)(60tmh<a`rzFUYX[ZZ@MCXVUML\rONQMW]SY%+7\r(' -g+;<!7o-,n|6 \"#77dQ");
	      }), CKFinder.define(S("[R\\rry{mlMGQICTlNBXdCNWTe]PADk_HUG[i)$5"), [S("6tsSUXXL5+/k#>&.."), S("P_Sy||h4Jt{hS`BW@	n\\LG}EHY"), S('1FVLAtsSUXXL$/3($2";f/%9"167|0%>"<t?3)')], function (e, t, n) {
	        "use strict";
	        return t.extend({ name: S("@'0-?#!,="), template: n, className: S("CJDALUMZCQI\x00M@^E@\\XF"), ui: { width: S("ptkiiEqALGFMAzLYBVHyFTEZi"), height: S("usnjTzLBI@KBLyI^GUUyWZS]Be"), keepAspectRatio: S('6^VIOOgS_R%|` /#"; 0.(+?""67!6,05y'), apply: S("Cg&-!e,#f>(=&*42$%:.") }, triggers: { "click @ui.apply": S("D$67$0") }, events: { "change @ui.width": S("4ZX`Q]NS"), "change @ui.height": S("(FDcIDIGD"), "change @ui.keepAspectRatio": S("(FDj_]KLDcSG]Z"), "keyup @ui.keepAspectRatio": function keyupUiKeepAspectRatio(t) {
	              (t.keyCode === e.space || t.keyCode === e.enter) && (t.preventDefault(), t.stopPropagation(), this.ui.keepAspectRatio.prop(S("1Q[QV]R\\"), !this.ui.keepAspectRatio.is(S(";^VZ#*''"))).checkboxradio(S(",_KIBTA[")).trigger(S("v~vv~")));
	            }, "keydown @ui.apply": function keydownUiApply(t) {
	              (t.keyCode === e.space || t.keyCode === e.enter) && this.trigger(S("!CSTI_"));
	            } }, modelEvents: { "change:realWidth": S("mEOFFV"), "change:displayWidth": S("@2'7,\"3 "), "change:displayHeight": S("oxjWEHEKP") }, onRender: function onRender() {
	            this.$el.trigger(S("o{~TD"));
	          }, onAspectRatio: function onAspectRatio() {
	            var e = this.ui.keepAspectRatio.is(S("6nfjszww"));this.model.set(S("'CLO[m^^JSE`R@\\Y"), e), e && this.onWidth();
	          }, onWidth: function onWidth() {
	            if (!this.dontRender) {
	              var e = this.model.get(S("(MCX\\AOVgXVG\\"));if (!(0 > e)) {
	                var t = parseInt(this.ui.width.val(), 10);(isNaN(t) || 0 >= t) && (t = 1);var n = this.model.get(S("/BTS_c\\RCP"));t > n && (t = n);var i = this.model.get(S("3P\\EGTXCsYTYW4"));if (this.model.get(S("xqpfVkixhOkIN"))) {
	                  var r = n / this.model.get(S("1@VUY~RQ^RO"));i = parseInt(t / r, 10);
	                }0 >= i && (i = 1), this.updateSizes(t, i);
	              }
	            }
	          }, onHeight: function onHeight() {
	            if (!this.dontRender) {
	              var e = this.model.get(S("3P\\EGTXCsYTYW4"));if (!(0 > e)) {
	                var t = parseInt(this.ui.height.val(), 10),
	                    n = this.model.get(S("/BTS_|P_PPM"));(isNaN(t) || 0 >= t) && (t = 1), t > n && (t = n);var i = this.model.get(S("sqjjw}dIvDUJ"));if (this.model.get(S("~srhXiky~jMAUKL"))) {
	                  var r = this.model.get(S(",_KN\\f[W@]")) / n;i = parseInt(t * r, 10);
	                }0 >= i && (i = 1), this.updateSizes(i, t);
	              }
	            }
	          }, updateSizes: function updateSizes(e, t) {
	            this.model.set({ displayWidth: e, displayHeight: t }), this.dontRender = !0, this.ui.width.val(e), this.ui.height.val(t), this.dontRender = !1;
	          }, setWidth: function setWidth() {
	            this.ui.width.val(this.model.get(S("3P\\EGTXClUYJW")));
	          }, setHeight: function setHeight() {
	            this.ui.height.val(this.model.get(S('E".;9&*5+&79&')));
	          }, focusButton: function focusButton() {
	            this.ui.apply.focus();
	          } });
	      }), CKFinder.define(S("\nHGKgatt`<Yzrbt|i4YywkiLCDA\nrHGEY~H]FJTf\\[Y"), [S("3^DCRJ@"), S("3VTU\\ZVT^"), S('-mdvX\\WQGzW]OWYNz$(6\n)$!"g%$ >a?>>'), S("P_Sy||h4QrzjLDQ\faAOSaDKLIxFUFAfPE^B\\lRYJ")], function (e, t, n, i) {
	        "use strict";
	        var r = t.Model.extend({ defaults: { realWidth: -1, realHeight: -1, displayWidth: -1, displayHeight: -1, renderWidth: -1, renderHeight: -1, maxRenderWidth: -1, maxRenderHeight: -1, keepAspectRatio: !0 } });return n.extend({ defaults: { name: S("*yI^GUU"), viewClass: i, view: null }, initialize: function initialize() {
	            this.viewModel = new r({ tabindex: this.get(S("xllf~uwk")) }), this.collection.on(S("e`ohuUsgu/dry}c"), function () {
	              var e = this.get(S("vp|b^ux}~X|j~"));this.viewModel.set({ realWidth: e.get(S("*BALIJgXVG\\")), realHeight: e.get(S("-GBQVW{Q\\Q_L")), displayWidth: e.get(S("pwz{xIvDUJ")), displayHeight: e.get(S("~ux}~TxwxHU")), renderWidth: e.get(S(",_KATT@d]QB_")), renderHeight: e.get(S("8K_UXXLw%(%+0")), maxRenderWidth: e.get(S("e}w~~nJw{TI")), maxRenderHeight: e.get(S("7J\\T_YOvZ)&*7")) }), this.get(S("C2,#0")).on(S(",L^_\\H"), function () {
	                this.resizeView();
	              }, this);
	            }, this), this.collection.on(S("lvuw&o{lEUBHI"), function () {
	              var e, t;e = this.get(S(" DFJPlKFOLnJXL")), t = e.get(S("zy~Rr{q")), this.viewModel.set({ realWidth: t.width, realHeight: t.height, displayWidth: t.width, displayHeight: t.height, renderWidth: e.get(S(")XNBIK]gXVG\\")), renderHeight: e.get(S("0CW]PPD]P]SH")), maxRenderWidth: e.get(S("e}w~~nJw{TI")), maxRenderHeight: e.get(S('?2$,\'!7"!."?')) });
	            }, this);
	          }, resizeView: function resizeView() {
	            var e,
	                t,
	                n,
	                i = this.viewModel,
	                r = this.get(S('"F@LRnEHMNhLZN')),
	                o = i.get(S("DHQSHD_pAM^C")),
	                s = i.get(S("8]SHLQ_F\b$+$,1")),
	                a = i.get(S("+ALV}U_VVFb_SLQ")),
	                u = i.get(S("/]PJaQ[RRJq_R[UJ"));s > u || o > a ? (e = s > o ? u / s : a / o, t = parseInt(e * s, 10), n = parseInt(e * o, 10)) : (n = o, t = s), i.set({ realWidth: o, realHeight: s }), r.get(S("sp`|yyk")).push({ tool: this.get(S("$KGJM")), data: { width: o, height: s } }), r.set({ imageWidth: o, imageHeight: s }), r.get(S("D&'*)'")).resize({ width: n, height: t }), this.collection.requestThrottler(), this.get(S("npl")).focusButton();
	          }, saveDeferred: function saveDeferred(t, n) {
	            var i = new e.Deferred(),
	                r = i.promise();return n.then(function (e) {
	              e.resize({ width: t.width, height: t.height }).render(function () {
	                i.resolve(this);
	              });
	            }), r;
	          }, getActionData: function getActionData() {
	            return this.viewModel;
	          } });
	      }), CKFinder.define(S("U\\^ptyo1ROEWOAV	bL@^bALIJe]\\XF"), [S("(\\DOI_]L_CW"), S("z`gvfl"), S("<__\\+#--!"), S(":xw{WQ$$0l	*\"2$,9d	)';<341z875)t/1/4\r"), S('B\x00/),,8d"*:<4!|1?#4;<9r\n0\rL6\n\f>'), S("L[W{}ppd8Uv~npxm0eEKWmHG@M~DCA]\x00qUXFGAbXWU"), S("\rMDVx|wqg9Zw}owyn1ZDHVjIDAB}ED@^BTAV@FbXWU"), S("ZQ]uszzRoL@PJB[oOEYgBQVW`ZY[Kh^OTDZ.-/")], function (e, t, n, i, r, o, s, a) {
	        "use strict";
	        return n.Collection.extend({ initialize: function initialize() {
	            this.needRender = !1, this.isRendering = !1, this.on(S("?!%&"), function (e) {
	              e.set(S("N@OF"), e.get(S("jpOM")).get(S("{wz}")));
	            });
	          }, setupDefault: function setupDefault(t, n) {
	            this.finder = t, this.Caman = n;var u = 40;this.add({ title: t.lang.EditImage.resize, icon: S("l{w?aqfm}"), tool: new a({ tabindex: u }, { collection: this }), tabindex: u }), this.add({ title: t.lang.EditImage.crop, icon: S("\fnei=r`|d"), tool: new i({ tabindex: u += 10 }, { collection: this }), tabindex: u }), this.add({ title: t.lang.EditImage.rotate, icon: S(",NEIC]GUAS"), tool: new r({ tabindex: u += 10 }, { collection: this }), tabindex: u });var l = t.config.editImageAdjustments;if (l && l.length) {
	              var c = new o({ tabindex: u += 10 }, { collection: this });this.add({ title: t.lang.EditImage.adjust, icon: S(":XW[^$+700"), tool: c, tabindex: u }), e.forEach(c.get(S("?&(.7!75")), function (e) {
	                e.label = t.lang.EditImage.filters[e.name];
	              });
	            }var d = t.config.editImagePresets;if (d && d.length) {
	              var f = new s({ Caman: n, tabindex: u += 10 }, { collection: this });this.add({ title: t.lang.EditImage.presets, icon: S("v}q5ih~oxjl"), tool: f, tabindex: u }), e.forEach(f.get(S(" QPFW@RT")), function (e) {
	                e.label = t.lang.EditImage.preset[e.name];
	              });
	            }return this;
	          }, setImageData: function setImageData(e) {
	            this.editImageData = e, e.on(S("C'-')/,p9)#**\"7:3=\""), function () {
	              this.checkReady();
	            }, this), this.forEach(function (t) {
	              t.get(S("4AYXT")).set(S('<XZV4\b/"# &<('), e);
	            });
	          }, setImageInfo: function setImageInfo(e) {
	            this.editImageData.set(S("zytqrQw|t"), e), this.editImageData.set(S("\fdcnwtEzpa~"), e.width), this.editImageData.set(S("5_ZY^_sYTYW4"), e.height), this.checkReady();
	          }, checkReady: function checkReady() {
	            this.editImageData && this.editImageData.has(S("?),#$!\f(!'")) && this.editImageData.has(S("/BT\\WQGa^\\MR")) && this.trigger(S("7QT[\\Yy_K!{0&%!?"));
	          }, resetTool: function resetTool(e) {
	            var t;e ? this.trigger(S("cwvv!nxmzT") + e) : (this.trigger(S("lvuw&o{lEUBHI")), t = this.editImageData.get(S(")IJAL@")), t.reset(), t.render(), this.editImageData.get(S("=_\\4(--7")).reset()), this.trigger(S("bxwu iyn{k@DWAW"));
	          }, doSave: function doSave(n) {
	            var i = this,
	                r = e.uniqueId(S("EEKW	LKFOLHMCXNC")),
	                o = t(S("#C@LUEV")).attr(S("rx"), r).css(S("/TXACXTO"), S("+BB@J")).appendTo(S("xtxd")),
	                s = this.editImageData.get(S("#EFRNGGY")),
	                a = this.Caman,
	                u = new t.Deferred(),
	                l = new t.Deferred(),
	                c = u.promise();return a("#" + r, n, function () {
	              var e = this,
	                  t = s.findWhere({ tool: S("3uQ\\BKM") });t && (s.remove(t), s.push(t));var n = s.findWhere({ tool: S("9jIYN[K3") });n && (s.remove(n), s.push(n)), s.forEach(function (e) {
	                var t = this.findWhere({ name: e.get(S("<IQP,")) }).get(S("%RHGE"));c = t.saveDeferred(e.get(S("6SYM[")), c);
	              }, i), c.then(function () {
	                l.resolve(e.toBase64()), o.remove();
	              }), u.resolve(e);
	            }), l.promise();
	          }, requestThrottler: function requestThrottler() {
	            var e = this;this.needRender = !0, this.throttleID || (this.throttleID = setInterval(function () {
	              if (e.needRender && !e.isRendering) {
	                e.isRendering = !0;var t = e.editImageData.get(S("qrytx"));try {
	                  t.revert(!1);
	                } catch (n) {}e.trigger(S(")^C^BZ[\\T"), t), t.render(function () {
	                  return !1;
	                }), e.isRendering = !1, e.needRender = !1;
	              }
	            }, 200));
	          }, destroy: function destroy() {
	            this.throttleID && clearInterval(this.throttleID);
	          }, hasDataToSave: function hasDataToSave() {
	            return !!this.editImageData.get(S("+MNZF__A")).length;
	          } });
	      }), CKFinder.define(S(';vxV.%\'1k)*%&$d"**<"}&:1%=*)39;3'), [S("8[[XW_QQ%")], function (e) {
	        "use strict";
	        var t = e.Model.extend({ defaults: { state: S("C+."), message: "", value: 0 }, stateOk: function stateOk() {
	            this.set(S("SUCWA"), S("B,/"));
	          }, stateError: function stateError() {
	            this.set(S("5ECYM_"), S("\rk}b~`"));
	          }, stateIndeterminate: function stateIndeterminate() {
	            this.set(S("SUCWA"), S("%OILL^N^@GAQEW"));
	          } });return t;
	      }), CKFinder.define(S("\\kgKM@@T\beFN^@H]\x00uU[G}XWP]wTXXRLo0,#7#4;%/)!"), [S("8zq}USZZ2n,)())g%/)!=`\x00#=4&0%$6>>0")], function (e) {
	        "use strict";
	        var t = e.extend({ defaults: { value: 0, state: S("4Z]"), message: "", eta: !1, speed: !1, bytes: 0, bytesTotal: 0, time: 0, transfer: "" }, initialize: function initialize() {
	            this.on(S("|H@LDA"), function (e) {
	              var t, n;if (e.changed.time && (t = e.previous(S("7LPW^")))) {
	                var i = e.get(S("1FZYP")) - t,
	                    r = e.get(S("=\\F4$1")) - e.previous(S("}YUGP"));n = (r / i).toFixed(1), this.set({ eta: ((e.get(S("=\\F4$1+1'+")) - e.get(S('C&<2";'))) / (100 * n)).toFixed(), speed: n });
	              }
	            });
	          } });return t;
	      }), CKFinder.define(S('7L\\BO~uy)/&&6j"%9&*8(=`>?>;;y*6=)9.-q'), [], function () {
	        return S(")OE[L\\PA@	U\\^JISZLZ32o.!65&/,j07rnn9%|>1&%6?<z&!>59M	\x00\x00\bVNSMQZ\\\x00C¯åëõººãáÿªèàìýü­³ñøò¸æå÷þèþïî³èÒÀÒÇÎÀØÛÅÌÞÈÝÜÊÉÜÂËÍÛÏÙÃÂâá°¬¨ ûå¸»¥¬¾¨½¼²° ñô´¤¾¹ô¬º°¨»±ßÁÛÇÄÐÑÔÔio?!4'&fz`k&zlbzu|sk)7''(;$!zvVAOEVU\nJAM]\\@WCW@GTVJHHDRZ}c5* 1.}32wk%9`91='6t(+rc{ze`r:6_h_KVc");
	      }), CKFinder.define(S('+ofhF^UWAvYZUVTjT[H3n1+"4";:"):'), [S("&dcoCEHH\\\x00fXWDGtVK\\rHXSi)$5"), S("2GQMB{r|RRY[Mo'.4)'3-:e\b# # >~!;2$2+*t?3)")], function (e, t) {
	        "use strict";
	        var n = e.extend({ name: S("!rQKBTB[Z|BIZ"), template: t, className: S("C'. j8;%,>(=<"), modelEvents: { "change:message": S("fdqwc}Tho|yz"), "change:state": S("=KO$ 6&1'3-"), "change:value": S("UQFBP@pFD\\O") }, ui: { bar: S("!szt>dgypj|ih1m"), message: S("#\nFMAYXDK_K\\C_VGFWP]"), wrap: S(":_VX03-$6 54e>8*<") }, onRender: function onRender() {
	            this.$el.trigger(S("r`vuas"));
	          }, updateMessage: function updateMessage(e, t) {
	            this.ui.message.text(t).toggleClass(S("!AHB\bNNLMOE"), !t);
	          }, updateState: function updateState(e, t) {
	            this.ui.wrap.toggleClass(S("vx2PSMDV@UTFA"), t === S("|")).toggleClass(S(">\\+'o36*!5-:9f)?< \""), t === S("!GQVJT")).toggleClass(S("1QXRFEW^H^ONV.%'7!7+.&(>."), t === S("D,(#-=/9!$ .$4"));
	          }, updateValue: function updateValue(e, t) {
	            this.isDestroyed || (this.ui.bar.css({ width: t + "%" }), this.ui.wrap.attr(S("&FZ@KZLBZU_]D"), t));
	          } });return n;
	      }), CKFinder.define(S("{uif2W^P~v}i3I{rPMCWAV	bL@^bALIJa@\\SGSDK}SZPRY$.6"), [], function () {
	        return S("(NBZ\rGK\rQXRS^IHT[O[L3c|k!/1vCv/%;n,<0! iw5<>t?2q),>GXTJCV\nEU@u");
	      }), CKFinder.define(S("L[W{}ppd8Uv~npxm0eEKWmHG@M|BIZ]\x00`C]TFPED|P[WSZhV%6"), [S('E3),,88/"<*'), S("?*07&6<"), S("&dcoCEHH\\\x00fXWDGtVK\\w]DQJ4+&3"), S(",neiY_VVFuXUTUUkWZ72m6*!5-:9%(9"), S(':OYEJ\n**!#5g/&<!/;5"}0<"58=>s\r,0!\rE\b')], function (e, t, n, i, r) {
	        "use strict";
	        var o = n.extend({ name: S("6r\\PNrQ\\YZ3-$6 54\f +'#*&5&"), template: r, regions: { progress: S("9xw{3zI\fRQKBTB[Z") }, ui: { transfer: S("BIE	@O\n\\[KE_KK]") }, modelEvents: { change: S("hn{AUGwVDHTNLX") }, onRender: function onRender() {
	            this.$el.trigger(S("tj|{oy")), this.progress.show(new i({ finder: this.finder, model: this.model }));
	          }, updateTransfer: function updateTransfer() {
	            this.ui.transfer.text(this.model.get(S("*_^L@\\VT@")));
	          } });return o;
	      }), CKFinder.define(S(" bieMKBBZgDHHB\\w[_Q"), [S("$GGDCKEEI")], function (e) {
	        "use strict";
	        var t = e.Model.extend({ defaults: { name: "", date: "", size: -1, folder: null, "view:isFolder": !1 }, initialize: function initialize() {
	            this._extenstion = !1, this.on(S("(JBJBJK^P_V"), function () {
	              this._extenstion = !1;
	            }, this);
	          }, getExtension: function getExtension() {
	            return this._extension || (this._extenstion = this.constructor.extensionFromFileName(this.get(S("\r`n}t")))), this._extenstion;
	          }, getUrl: function getUrl() {
	            if (!this.has(S("nnq"))) {
	              var e = this.get(S("sy{||h")).getUrl();this.set(S("E35$"), e && e + this.get(S("(GKFI")), { silent: !0 });
	            }return this.get(S("B66)"));
	          }, isImage: function isImage() {
	            return this.constructor.isExtensionOfImage(this.getExtension());
	          }, refresh: function refresh() {
	            this.trigger(S("5DR^K_HT"));
	          } }, { isValidName: function isValidName(e) {
	            var t = /[\\\/:\*\?"<>\|]/;return !t.test(e);
	          }, isExtensionOfImage: function isExtensionOfImage(e) {
	            return (/jpeg|jpg|gif|png/.test(e.toLowerCase())
	            );
	          }, extensionFromFileName: function extensionFromFileName(e) {
	            return e.substr(e.lastIndexOf(".") + 1);
	          } });return t;
	      }), CKFinder.define(S("#P@^S	jamECJJBfVYEZVL\\IyYWK	,#$!j(&/#9!	'.<>5}0:\""), [], function () {
	        return S("?;:}ce,2i''&2;+='#;'1u+*d5;991`U@ABC[GD\r	A5=W	\n:áííäËóãõÿûãÿé­óò®úúåãã¸íûùõóúúØÒÞØÌÏÅËÌÛÓÝËØÖÕÜßÖØú¤¨¶©¤¡¢¿¯¹»¿§»µóò¨¯êö¾¬÷µ­¹¯©­ÃÐÌÔÆÂ÷ÂÐl``fh;\f|s6wv1jff1qufe*:swysrE\fKMTPR\nI[OJ\rUT[GZ@RJNHRHXB=26:( {e, 9; ,7u>><6vu7%18w359::\\@EUSdOPQR\bHV\fWP:äèöÊéäáâ¦úëýéÉçîüþõÀõãóÖë¹çæ½¾¿ÆÊÒ¬ÃÁÓÝÖÚÖËÊÚÔÒÚ® ¯¦é ¾³­§¹¢££ã£±³·¿öëø¬£øú²¨ó»§ÇÖÄÎûÒÓÔÕÖ×ØÙÆÞl`qp9'sn%`d{yy#{uif3a|;uw}c6usvzRHVQLDG[DN^\x00OC\\GZF^V\\VMUSMZ4c|IdefgA@v\"\"=;;p%31=;22 dxj~}:>\x00O\n\r	\fVNSR\rJZ\r\b_^áìç¾¦æíáÍíãÿÅàïèõ×ûÿñÛ÷úý»ºíýñëúÙØÏÓÇËÆÉÓÒÓÁÝÔÅÝÈÏÒÎØÚâµ°¶¡çæèöÃêëìíîïðñîü°¼ éÒùúûüáñ»ÜéîÅÆÇÈÕËÌÐÛÔm,gqvjt'm{xd~ cjcbstq7(+7i$ 2zvV(");
	      }), CKFinder.define(S('#gn`NFMOY`AKE]W@pR^LpWZ[Xi)$50k)). 8&\b$/#?6:1"'), [S("+ofhF^UWAc_ROJy]N[	5'.,#0"), S(")i`jD@KUC~[QS[K|RPX"), S(" UG[Peln@DOI_{U\\B_UASD|^RHtS^'$m\x00++ .:$\"-!!(~5='")], function (e, t, n) {
	        "use strict";
	        return e.extend({ name: S(";OQO('4"), template: n, className: S("(JAMHGSC]CVYYLKUWO"), ui: { error: S(";u|~4r1~qqFHPN	@TUG["), overwrite: S("@(,311))$/vn.%)5;'870=,>.*,6@>"), fileName: S("~viooGsrE\x00@OCcCA]cFMJKiY]W}UXSe"), fileNameInputArea: S(";p~t|tzqx3vNQWW	DTBI") }, events: { "change @ui.overwrite": function changeUiOverwrite(e) {
	              e.stopPropagation(), e.preventDefault();var t = this.ui.overwrite.is(S('C~&."+"//'));t ? (this.model.set(S("u}p{"), this.model.get(S("zd~ptzpSrE"))), this.model.unset(S("0T@A[G")), this.ui.fileNameInputArea.hide().attr(S("|lvA\fJJ@ACI"), S("-Z]ET"))) : this.ui.fileNameInputArea.show().removeAttr(S("sa}t;q}~~r")), this.model.set(S("+C[K]GC[GQ"), t);
	            }, "input @ui.fileName": function inputUiFileName() {
	              var e = this.ui.fileName.val().toString();t.isValidName(e) ? this.model.unset(S("!GQVJT")) : this.model.set(S("7]KHTN"), this.finder.lang.ErrorMsg.FileInvChar), this.model.set(S("\nem`k"), e);
	            } }, modelEvents: { "change:error": function changeError(e, t) {
	              t ? (this.ui.fileName.attr(S("znt2IOTBHLB"), S("A611 ")), this.ui.error.show().removeAttr(S("7YKSZUW[$$,")).html(t)) : (this.ui.error.hide().attr(S("rf|w:pp~ys"), S("`gcr")), this.ui.fileName.removeAttr(S("xhr}0wqV@NJ@")));
	            } } });
	      }), CKFinder.define(S('#gn`NFMOY`AKE]W@pR^LpWZ[Xz$(6\n)$!"'), [S(".Z^UWAGVYE]"), S("JPWFV\\"), S("sspwyy}"), S('6tsSUXXL\r.&6( 5h\r-#? /(5~:1"%x=3/0?8-'), S('+ofhF^UWAxYSMU_HxZV4\b/"# i!,=8c#.74!1#?2/3>+'), S("SZTzzqse7Tuiq{ldFJPlKFOL}EHY\\pQG]ZXDnP_L"), S("D\r!'..>b 4$>6'z31-6=:;p-\bI\"\f\x00\"\f	\n4"), S("#gn`NFMOY`AKE]W@pR^LpWZ[Xk/..0"), S("V]Qqw~~n2SpDTNFW\ncCA]cFMJK\x00}^VVXFgJV]IYNMr/%'/"), S("D\r!'..>b 4$>6'z31-6=:;p6\bJ6*\"\x00"), S("QXR|xs}k5VsyksER\rf@LRnEHMN{GJGBp[[P^JT~R]QQX('4")], function (e, t, n, i, r, o, s, a, u, l, c) {
	        "use strict";
	        function d(e) {
	          var t = this;this.finder = e, e.on(S("0R]]@PNCu\\TN[WS%{''-1"), f, this), e.on(S("`zy{zxh!nxmzToBMKAAEO"), function (n) {
	            var i = n.data.file;y(i) && n.data.toolbar.push({ type: S("'J\\^_CC"), name: S("2vP\\B~UX]^"), priority: 50, icon: S("\nhgk#iy}w>qqc"), label: n.finder.lang.Fileeditor.contextMenuName, action: function action() {
	                h(t, e.request(S("+JDBJCUV@fS[]ZN^X")).first());
	              } });
	          }), e.on(S("A6,+)$&:s8.?(:u5;'870="), function (t) {
	            var i = this;t.data.toolbar.push({ icon: S(e.lang.dir === S("~gf") ? "2P_SUYZQ" : "/SZTRZD@YK^"), name: S("!aOKVC"), iconOnly: !0, label: t.finder.lang.CloseBtn, type: S("qaabxv"), alwaysVisible: !0, action: function action() {
	                return t.data.tools.hasDataToSave() ? void e.request(S("|p{wsz$|OODJVH"), { name: S("1q\\ZS_EU|^RHtS^'$;-1"), msg: e.lang.EditImage.confirmExit }) : void e.request(S("ewp}#~~oilpY"), { name: S("0tVZ@|[V_\\") });
	              } }), t.data.toolbar.push({ type: S("3@PNC"), name: S("fHNFJDKB"), className: S("qxr8s~5mutpm\rGKOAKGJM"), label: t.data.tools.editImageData.get(S('"EMIC')).get(S("!LBI@")) }), t.data.toolbar.push({ name: S("J{my"), label: e.lang.EditImage.save, icon: S("u|~4izjx"), alignment: S("`qvyy|xhb"), alwaysVisible: !0, type: S(" CWWPJH"), action: function action() {
	                m(i, t.data.tools);
	              } }), this.resetButton = new n.Model({ name: S('E";,>'), label: e.lang.EditImage.reset, icon: S("E%,.d8.?(:"), alignment: S("8J_XSSZ^28"), alwaysVisible: !0, isDisabled: !0, type: S("-LZDE]]"), action: function action() {
	                t.data.tools.resetTool();
	              } }), t.data.toolbar.push(this.resetButton);
	          }, this, null, 40), e.on(S("*OELB@WwW]AZY^_xSSXV2,x,/"), function (n) {
	            var i = n.data.context;if (!i.viewModel.get(S("1WAFZD"))) {
	              var r = i.viewModel.get(S(".AQ\\W")),
	                  o = r + "." + i.viewModel.get(S("#A]RBFZCDB")),
	                  s = i.viewModel.get(S("`ft`df|br"));return !s && e.request(S('\x15p~t|i!{xj\\USPFJQ')).where({ name: o }).length ? void i.viewModel.set(S("}khtn"), n.finder.lang.EditImage.saveDialogFileExists) : void v(t, i.tools, i.viewModel.get(S("rr{n@OF")) === o ? !1 : o);
	            }
	          }), e.on(S("DHCOKBdGGLB^@kKYE{^URSr@PNSV"), function () {
	            e.request(S("3DTQR]_HHOQF"), { name: S("\nNhdzF}puv") });
	          }), e.on(S("$FIJEHDOH\\]_C\b`UCS~UX]^"), function () {
	            e.request(S("/@PUVQSDLKUB"), { name: S("Vp|b^ux}~") });
	          }, null, null, 5);
	        }function f(e) {
	          var t = this,
	              n = e.data.context.file.get(S("sy{||h")).get(S(".NS]"));y(e.data.context.file) && e.data.items.add({ name: S("5sSQMsV]Z["), label: t.finder.lang.Fileeditor.contextMenuName, isActive: n.fileView && n.fileRename, icon: S(';_VX&(.&i ".<'), action: function action() {
	              h(t, e.data.context.file);
	            } });
	        }function h(t, n) {
	          if (e.isUndefined(C)) {
	            var i = CKFinder.require.toUrl(t.finder.config.caman || S("$IOE[IJAL@")) + S("3tlWGQMV]\\BO");CKFinder.require([i], function (e) {
	              C = e || window.Caman, g(t, n);
	            });
	          } else g(t, n);
	        }function g(e, t) {
	          var n = e.finder,
	              u = new a();u.setupDefault(n, C), u.on(S("<IVM/56/!"), function () {
	            n.fire(S("}}soUpxEPFJACUx[O]EHY"), { actions: f.get(S("<\\]K).,0")).clone() }, n);
	          });var l = new i({ finder: n }),
	              c = new r({ finder: n }),
	              d = new o({ finder: n, collection: u });n.once(S("._QVW	G]Y@|^RHtS^'$"), function () {
	            l.preview.show(c), l.actions.show(d), l.$el.trigger(S("$FTBI]O")), n.request(S("d~}vtd-j|i~h"), { name: S('"f@LRnEHMN'), context: { tools: u } });var e = C(c.ui.canvas.selector, f.get(S("\rgbqvwCfp`~}n")), function () {
	              n.request(S("|~swqg,q}")), d.focusFirst(), f.set({ renderWidth: c.ui.canvas.width(), renderHeight: c.ui.canvas.height() });
	            });f.set(S("0RS^U["), e);
	          });var f = new s({ file: t, imagePreview: n.request(S("(@GJKH_BTDZQBcET"), { file: t, maxWidth: .8 * window.innerWidth, maxHeight: .8 * window.innerHeight, noCache: !0 }), fullImagePreview: n.request(S("4\\[V_\\\x00KNXHV%61("), {
	              file: t, maxWidth: 1e6, maxHeight: 1e6, noCache: !0 }) });u.setImageData(f);var h = f.get(S("4TUCQVTH"));h.on(S("-OKT"), function () {
	            e.resetButton && e.resetButton.set(S("3]Fr^KXXWYY"), !1);
	          }), h.on(S("([OXIY"), function () {
	            e.resetButton && e.resetButton.set(S('=WL(1"&)##'), !0);
	          }), n.request(S(";PR_[%3x0,*1"), { text: n.lang.EditImage.loading }), n.request(S("#GJKJIGN_H@K"), { name: S("ZytqrQw|t"), folder: t.get(S("&AGENN^")), params: { fileName: t.get(S('A,") ')) } }).done(function (e) {
	            function i() {
	              u.trigger(S("&RAXN_DTJ"));
	            }if (e.error && 117 === e.error.number) return n.once(S("!ALIHGILOY^B\\y\\STQ|XQW"), function (e) {
	              e.cancel();
	            }), n.request(S("tv{yo$wIEG")), n.request(S("?&..'!7|5-/8.?%\b&<4!")), void n.request(S(".KYP^\\S_Y^V"), { msg: n.lang.ErrorMsg.MissingFile });var r = { width: e.width, height: e.height, size: e.size };t.set(S("<TS^'$-\"*"), r), u.setImageInfo(r), n.util.isWidget() && p(n), n.once(S("D5' -s)9),:*j6: ;6?<"), function () {
	              n.request(S("6CWVVY]O\\2$#7!"), { name: S("?%+7\r(' -"), page: S("8|^RHtS^'$") });
	            }), n.request(S('B3%"#}+;/*8('), { view: l, title: n.lang.EditImage.title, name: S("Tvz`\\{v|"), className: S("3W^P]PK]Z[") }), n.request(S("D5' -s9##:"), { name: S("+iIG[y\\STQ") }), n.request(S('1^\\UQSE\x02JRTK'), { text: n.lang.EditImage.loading }), d.on(S('<^VV,%4*!2|"09+%('), function () {
	              l.onActionsExpand();
	            }).on(S("+OEGCTG[VCUXTU[KOX"), function () {
	              l.onActionsCollapse();
	            }), n.on(S("or&o{lI[G"), i), n.once(S("+\\LIJ\nUW@@GYN|^RHtS^'$"), function () {
	              n.removeListener(S("?5(x1!6/=-"), i);
	            });
	          });
	        }function p(e) {
	          function t() {
	            i = !1, e.removeListener(S("%KNF@GBVHJ"), t);
	          }function n() {
	            i && e.request(S("C),(.% 0.")), e.removeListener(S("*[MJKTTAGFZO\r}]SOuP_X%"), n), e.removeListener(S("2^][_ZQC__"), t);
	          }var i = !1;e.request(S(":ROp_G),+9!!")) || (e.request(S('A/"<,+.2,')), i = !0), e.once(S("9WRRTSV:$&"), t), e.once(S('B3%"#},,9?>"7u5;\'870='), n);
	        }function m(e, t) {
	          if (t.hasDataToSave()) {
	            var i = e.finder,
	                r = t.editImageData.get(S("*MEAK")),
	                o = r.getExtension(),
	                s = r.get(S("|ryp"));if (o) {
	              var a = s.lastIndexOf("." + o);a > 0 && (s = s.substr(0, a));
	            }var u = r.get(S("qwu~~n")).get(S("D$%+")).fileDelete,
	                l = new n.Model({ onlyOverwrite: !u, overwrite: u, oldName: r.get(S(" OCNA")), name: s, originalName: s, extension: o, tools: t, error: !1 }),
	                d = i.request(S("|p{wsz"), { view: new c({ finder: i, model: l }), title: i.lang.EditImage.saveDialogTitle, name: S("$`BN\\`GJKHm@^W[AY"), buttons: [S("8VQ"), S("7[XTXYQ")], context: { viewModel: l, tools: t } });l.on(S("tpxt|y'{mRNP"), function (e, t) {
	              t ? d.disableButton(S("0^Y")) : d.enableButton(S("'GB"));
	            });
	          }
	        }function v(e, t, n) {
	          function i() {
	            c && c.abort(), r.request(S("8]SZPRY$$176*?"));
	          }var r = e.finder,
	              o = t.editImageData,
	              s = new u(),
	              a = new l({ finder: r, model: s });if (r.request(S("zvAMMD"), { view: a, title: r.lang.EditImage.saveDialogTitle, name: S("Ww}a_zy~H}k{ORNEQAVU"), buttons: [S("\fnoast~")] }), r.on(S("B'-$*(/s/%9\"167\x005#3*6=)9.-e\x00\f\x00	"), i), s.set(S('E+";:+,)'), r.lang.EditImage.downloadAction), !window.URL || !window.URL.createObjectURL) return s.stateIndeterminate(), void w(o.get(S('"EQIJnEHMN|_KYYTE')), t, r, s, n);s.set({ bytes: 0, bytesTotal: 0, value: 0, time: new Date().getTime() });var c = new XMLHttpRequest();c.onprogress = function (e) {
	            e.lengthComputable && (s.set({ state: S("9TTNP_S"), bytes: e.loaded, bytesTotal: e.total, value: e.loaded / e.total * x, time: new Date().getTime() }), s.set(S('>K2 ,0" 4'), r.lang.formatTransfer(s.get(S("om{zD"))))), e.lengthComputable || s.set({ value: b, state: S(':RRY[K%3/**$2"'), transfer: !1 });
	          }, c.onload = function () {
	            return r.removeListener(S('$AOFDFMiIG[y\\STQfWA]iHT[O[L3{!"*&#+'), i), 200 !== this.status ? (r.request(S("v~~wqg,e}h~ouXvLDQ")), r.request(S('C4$!"r-/88?!6'), { name: S(" dFJPlKFOL") }), void r.request(S("3P\\W[W^\x00RR[Q"), { msg: r.lang.ErrorMsg.MissingFile })) : (s.set({ value: x, eta: !1, speed: !1, time: 0 }), void w(window.URL.createObjectURL(new Blob([this.response])), t, r, s, n));
	          }, c.open(S("2tqa"), o.get(S("'N\\FGe@OHUa@VB\\S@")), !0), c.responseType = S('"BVWG^J\\LMI_'), c.send(null);
	        }function w(e, t, n, i, r) {
	          i.set({ value: x, message: n.lang.EditImage.transformationAction }), t.doSave(e).then(function (e) {
	            function o() {
	              u && u.abort(), n.request(S("!FJEII@MOXX_AV"));
	            }i.set({ value: E, message: n.lang.EditImage.uploadAction });var s = t.editImageData.get(S("#BLJB")),
	                a = s.get(S("9\\TPY[M"));n.once(S("9YTQP_Q${#%0 4}(<. /(5"), function (e) {
	              e.data.response.error || (i.set({ state: S("-@@B\\S_"), value: F, message: "" }), s.set(S("qwc}"), e.data.response.date), n.once(S("curs-kqul&PvN"), function () {
	                e.data.context.isFileNameChanged ? n.request(S("qwu~~n'lzFSGPLcOKMZ")) : s.refresh();
	              }), n.request(S("fv| ynjmOX"), { name: S("_uiWrAFG") }));
	            }), i.set({ bytes: 0, bytesTotal: 0, value: E, message: n.lang.EditImage.uploadAction, time: new Date().getTime() }), n.on(S(";XT_S/&x ,2%(-.,8*\x00#=4&0%$b:;5?82"), o);var u = n.request(S("8ZUVQ\\P[z2'- "), { name: S("\nXm{kF}puv"), type: S("eydl"), folder: a, params: { fileName: r ? r : s.get(S("4[WZ]")) }, post: { content: e }, context: { file: s, isFileNameChanged: !!r }, returnTransport: !0, uploadProgress: function uploadProgress(e) {
	                e.lengthComputable && (i.set({ bytes: e.loaded, bytesTotal: e.total, value: e.loaded / e.total * (_ - E) + E, time: new Date().getTime() }), i.set(S("-Z]Q_AUQG"), n.lang.formatTransfer(i.get(S("\nx|hkk"))))), e.lengthComputable || i.set({ state: S("2ZZQSC]KWRR\\JZ"), transfer: !1 });
	              }, uploadEnd: function uploadEnd() {
	                i.set(S("8JNZHX"), S("sqmM@N")), n.removeListener(S(">[) .,##!=&-*+1'7&:1%=*)a?<0<\r"), o);
	              } });t.destroy();
	          });
	        }function y(e) {
	          return e.isImage() && e.get(S('C"**#-;')).get(S('"BGI')).fileRename && e.get(S("~vvyo")).get(S("*JOA")).fileUpload;
	        }var C,
	            x = 33,
	            b = 20,
	            E = 35,
	            _ = 98,
	            F = 100;return d;
	      }), CKFinder.define(S("cjdJJACUdEOYAK\\w[_QqY@VUUZXxV,$,3+*()-"), [S("ltyom|OSG"), S("@+36!7?")], function (e, t) {
	        "use strict";
	        function n(n) {
	          var o = e.uniqueId(S("+OFHT^E]XZWS_HZQX"));n.setHandler(S("@'+/!\"(?'&$-)"), function (e) {
	            var i = e.file.get(S("}sqzzR")),
	                r = n.request(S("7[VWV]SZ53."), { command: S(";xRIQ,.#',*\""), folder: i, params: { fileName: e.file.get(S("}uxs")) } }),
	                s = t("#" + o);s.length || (s = t(S("%s}n|sz")), s.attr(S("5_S"), o), s.css(S("p|egtxc"), S("'FFDN")), s.on(S("\rb`qu"), function () {
	              var e = t(s.get(0).contentDocument).text();if (e.length) try {
	                var i = JSON.parse(e);i.error && 117 === i.error.number && (n.request(S("4SY[\\\\HNXXM%2*-)#4")), n.request(S('E".)%%,v$ )?'), { msg: n.lang.ErrorMsg.MissingFile }));
	              } catch (r) {}
	            }), t(S("'JFNR")).append(s)), s.attr(S("b`p"), r);
	          }), n.on(S('=JP/- "64";,>q,\'!j7;?1'), i), n.on(S("E%(&=/38\x00+!%k4:80"), function (e) {
	            e.data.groups.add({ name: S("kwzW") });
	          }, null, null, 20), n.on(S('7[VTOYEJr%/7y",*"r?#.;'), r, null, null, 20);
	        }function i(e) {
	          var t = { name: S("dNUMHJGC"), priority: 70, icon: S("'KBLJDBJU]DZYYV\\"), label: e.finder.lang.Download };if (o) {
	            var n = e.finder.request(S(">Y)-'0~\"#3,&./9++")).first(),
	                i = e.finder.request(S('"@KHKFFM^^A'), { command: S(")nD[CB@QUtZXP"), folder: n.get(S("pxt}i")), params: { fileName: n.get(S('"MEHC')) } });t.type = S("?,(,(i'33<&$"), t.href = i, t.attributes = { target: S("A!($(,") };
	          } else t.type = S("D'33<&$"), t.action = function () {
	            e.finder.request(S("yIMG@JQIDFKO"), { file: e.finder.request(S("8_SWYNX%5&( %3--")).first() });
	          };e.data.toolbar.push(t);
	        }function r(e) {
	          var t = e.data,
	              n = t.context.file,
	              i = n.get(S(".I_]VVF")).get(S("+MNB")),
	              r = e.finder.request(S('"EMICTNO_HBJSEWW'));r.length && !r.contains(n) && e.finder.request(S("|rpxm%DDQFH@ESiEF")), e.finder.request(S("yIMGPVCKMJ^"), { files: n });var s = { name: S("\fIax~}}rp"), label: e.finder.lang.Download, isActive: i.fileView, icon: S("D&-!e/#')`* '?><51") };o ? (s.allowClick = !0, s.linkAttributes = [{ name: S('"WEWAB\\'), value: S("@BMCMO") }, { name: S("\fe|jv"), value: e.finder.request(S("l|rzq,bju"), { command: S("\\vmupr{fHNF"), folder: n.get(S("4SY[\\\\H")), params: { fileName: n.get(S("blcj")) } }) }]) : s.action = function () {
	            e.finder.request(S("E .$,p/#: #?06"), { file: n });
	          }, t.items.add(s);
	        }var o = /iPad|iPhone|iPod/.test(navigator.platform);return n;
	      }), CKFinder.define(S("#P@^S	jamECJJBfVYEZVL\\IzTRZ3'5- 1h(&')?7a4>&"), [], function () {
	        return S("-KYGPXTEDYPZXV,$o36 0.->g9#\":mp\"&*80ku(6)2(411Z]P[W	KBH@KGèõ¸³¿ççäãîøäùãêµâöðò¼¥º§´©¶«²¥·¤ÚËÍÀÀÞËÁÁÄÔÒÙÜÚÎøÈÒÝÑ¤®µ¡±¯¤©åê­¥¡¢±ýò±§²¶¶¸öû¯¼°¬ÍÝÅÈÌÐÃÖÕÇÙibcwmjh%67hdx/s}s`g(4ts7}uq{2PSGUM@Q\bZ^R@H\r@^AZ@\\YYXXHSQKK%z6,4v|$,,?v}u-?%&<9od25b(2;5*ePZ	R\bVLQL^K|~D\r\\óò¿¡çîàªîàæî¡ýüêæø÷ä¹üøñ÷»îêæÌÄÔÊÕÎÜÀÅÅÌÌÜßÝÇÇÑÚÒÞÍßÑË´®¯ùôþ´®¯¡¾ñüö£®¢¶»½î´££·â¹´°²¬åÃßÕÓÁÂÃÏÆÍÐÊel\"2ah=jiq'cidigd+ vy.z~v|7sytywTFI@HF]XEWKT_\b<>1^RJ]S!21~f&-!e/#')`>=5';6#x?9>6w5=0;}@\b\x00[E\nW\nIQJIYDqutBé÷¢àèäõôµ«éàê èæüô¿ãæðàþýî·òòûñ²ÃÎ×ÍÐÔÜÐÆÎÈÃßÐÆÆÜÑßÌÚÖ¶ÿÈÊøê¢®¾÷ÀÂð¯»»¤¾¼ó·¹·¤«äø¸·»ó¹ÎÆßÕØÃÝpnqjplii2hhxca{{u*f|d/#'=\"xzvymOTLGIOIMHXK_OKYT\\GAYZVNOSPc'$%dujgk,~.x(zoaabv}n48*=?)q/?;	YJVWU]\fPHB\rV\\^Iâ·àµ¿çéÿ¥úâêèâùµ ±£ãìµ¦·êþøú´¯«ªÇÀÈÜÞÜõôîãöðóëèûÿþàíþááäûó½»¥²¬õúëüì®§ÀÑÂÏÚÜßÇÌßÛÚÜÑÀÆÁÙÖÇÖÈÏÒÜeu9ak}+tascek7l`buwa9wyo#zuwso$<BJHSZCQIBKSYYLM^UZVKz#-/ ~*.&,g#)$)'$kc}g0;l58(<53djBP]	\r\nTZ\x00	RBDL\fQäîõ¹´¥·÷ð©º«¯ë½é£÷¡¨¹âóõóðî¶ýíîúÁÓÃÍÇÀÉÇÇÏÀÁÕÐÂÃÑÔÄÖÖÚßÒÒÐÚû¥«°´©§¾ò ¤§¥£«â²½½°¿î ²ª­³¸½±ó¾ÞÐÎÓÈÏÉÙÃôö<cwwpjh'kekx0,l{w?u}ys:hkmuxi2BTVWKKIMQ^	\f^ZV\\TDZE^LPUU\\\\L/-77!~2(8s{iv,.3:5!; 83b5359<,r\r\x00\b@K^SWXIV[_J´ä¶£µµ¶¢¡²èäþéëý½ãó÷ýàå­¶ª«©©øó¤ÂÎÐÇÁ×ØÑØÃÁÇËÐÖÔÛÕÃÎÖÞ¤®µùôå÷·°éúë¾ª¬®øãçæøõäâíõúééèòÿÐÏ×ÊÈÅÖÇØÉØÍÚÁÁÀÚ×ÊÌÏ×ÜÏËÊ,!2-50/'agynx!.?0 bk4%6e{{3.(+3\x00\b\nX\\@QA\rUWAHUGWQ'{ ,6!#5e+%3w.!#?#hpgfel>64/q.7%[SQJPS@\nNBSåèåëð¿·©»ìç°áìüèùÿ¨¦äí¶¤èá¡ëýùúöÎÆÔÝÙÒØÈÖÛÂÚÒÐÚÁËÄã§ñ¥÷£õüå¾¯©§¤ºâ±¡¢¶µ§·¹»¼àµ³³»äÍÉÕÏÆiog.fiidc2|n~yglq}?rx|qy\"tsxq{$QETSHIYYZ@^8Q_A3");
	      }), CKFinder.define(S("[R\\rry{mlMGQICToCGI}\\JFXWDs_[]iH^JT[H"), [S("fzqsekzuiy"), S(":QMH[M9"), S('E"('), S("uyzqyss{"), S("#gn`NFMOYxZF\\yVMvYS]"), S('A6&<1g#%((<`4?#84"2+v208-J!C\n\x00'), S("'kblBBIK]|]WQYE~PV^")], function (e, t, n, i, r, o, s) {
	        "use strict";
	        function a(e) {
	          e.setHandlers({ "image:previewUrl": function imagePreviewUrl(t) {
	              var n, i;return n = t.file.get(S("2U[YRRJ")), i = { fileName: t.file.get(S("vxw~")), size: Math.round(t.maxWidth) + "x" + Math.round(t.maxHeight), date: t.file.get(S("7\\XN^")) }, t.noCache && (i.d = new Date().getTime()), e.request(S('>\\/,/"*!|2:%'), { command: S('@\b/"# 5-?#.;'), params: i, folder: n });
	            }, "file:preview": function filePreview(t) {
	              var n = t && t.file || e.request(S("&AAEOXJK[sD@AQ[B")).first();n && u(e, n.get(S(":U]P[")));
	            } }), e.on(S("-HF\\T\bCFP@^]N"), function (n) {
	            function i(e, t) {
	              t.find(S('A+%6$+"')).attr(S("+__M"), e).css(S("D!/48%+2"), ""), t.find(S("ILE")).remove();
	            }var r = n.data.url;if (s.isExtensionOfImage(n.data.extension) && (n.stop(), n.data.templateData.url = e.hasHandler(S("9SV]Z[03'5- 1:%")) ? e.request(S("/Y\\STQFE]OS^KhLS"), { file: n.data.file, maxWidth: .95 * t(window.top).width(), maxHeight: .95 * t(window.top).height() }) : r, n.data.template = v, n.data.events = { load: function load(e) {
	                e.target.id && t(e.target).css(S('"GMVVKIP'), "").prev().remove();
	              } }), /^(flac|mp3|ogg|opus|wav|weba)$/.test(n.data.extension) && c(n.data.extension) && (n.stop(), n.data.templateData.url = r, n.data.template = w, n.data.events = { click: function click(e) {
	                e.stopPropagation();
	              } }), /^(mp4|ogv|webm)$/.test(n.data.extension) && d(n.data.extension) && (n.stop(), n.data.templateData.url = r, n.data.template = y, n.data.events = { click: function click(e) {
	                e.stopPropagation();
	              } }), /^(pdf)/.test(n.data.extension) && (n.stop(), n.data.template = r ? C : x, n.data.templateData.url = r ? r : "", n.data.afterRender = function (e) {
	              setTimeout(function () {
	                e.closest(S("WyomyvvlH")).focus();
	              }, 500);
	            }, !r)) {
	              var o = n.data.file;n.data.events = { load: function load(n) {
	                  if (n.currentTarget.alt) if (o.get(S("2U[YRRJ")).getResourceType().get(S("URGsVJ^^kFGFMCJ"))) {
	                    var r = e.request(S("~pv~&z{kpSM[]pTK"), { file: o, cache: 86400, params: { d: o.get(S("x|jz")) } });i(r, t(n.currentTarget).parent());
	                  } else e.request(S("s{}#}~hHls"), { file: o }).then(function (e) {
	                    i(e, t(n.currentTarget).parent());
	                  });
	                } };
	            }
	          }, null, null, 90), e.on(S("~qqTDZWi@HROCGIXFUF"), function (t) {
	            t.data.items.add({ name: S("/fXWD"), label: t.finder.lang.View, isActive: t.data.context.file.get(S('C"**#-;')).get(S("/QR^")).fileView, icon: S("w~p:npl"), action: function action() {
	                u(e, t.data.context.file.get(S("+BLCJ")));
	              } });
	          }, null, null, 10), e.on(S(")^DCALNB@VGPB\ruXSU[WS%"), function (e) {
	            var t = e.finder;e.data.toolbar.push({ name: S("-xFUF"), icon: S("<^UYm7+&3"), label: t.lang.View, type: S("ummntr"), priority: 80, action: function action() {
	                u(t, e.data.file.get(S("qALG")));
	              } });
	          });
	        }function u(i, s) {
	          function a() {
	            var r, o, s, a, u, l;_.current <= 0 ? (_.current = 0, y.hide()) : y.show(), _.current >= _.last ? (_.current = _.last, w.hide()) : w.show(), o = _.files[_.current], s = o.url, a = o.name, u = a.substr(a.lastIndexOf(".") + 1), l = i.fire(S("D#/+-s:9);'*'"), { templateData: { fileIcon: function fileIcon() {
	                  var e = t(f).width(),
	                      n = t(f).height();return i.request(S("jdbj*vwg]vyy"), { size: e > n ? e : n, file: o.file });
	                }, fileName: a }, file: o.file, url: s, extension: u, template: b }, i), C.text(o.name), x.text(_.current + 1 + S("597") + _.files.length), i.request(S(".IY]W@QSD]U_XH|RS")), i.request(S("p~t|i!oxrzCU"), { files: c[_.current] }), r = t(n.template(l.template)(l.templateData), f), l.events && e.forEach(l.events, function (e, t) {
	              r.on(t, e);
	            }), v.append(r), e.isFunction(l.afterRender) && l.afterRender(r), i.request(S("}s~klUPBT"), { node: p });
	          }function u(e, t) {
	            v.html(""), e.stopPropagation(), _.current += t, a();
	          }function l() {
	            E && E.remove(), p.remove(), c[_.current].trigger(S("px{li"));
	          }var c = i.request(S("yIMGPBCSl@Y[@LWJT")).where({ "view:isFolder": !1 }),
	              d = [],
	              f = window.top.document,
	              h = n.template(o),
	              g = 0,
	              p = t(h(), f);p.attr(S(";XTL"), i.lang.dir);var v = p.find(S("'JAMKGCUBAQC_RO")),
	              w = p.find(S("*OFHVX^VEDRNP_L_KK4.,n* >3")),
	              y = p.find(S(":_VX&(.&i54\"> /<a/;;$><~$'3!")),
	              C = p.find(S("+NEIW[_QFE]OS^KWQ&.o-%(#")),
	              x = p.find(S("0QXRP^T\\KNXHV%6o**#)j+&?%8"));i.lang.dir === S("sTS") ? (w.css(S("&UANB_"), S("\f= :u|")), y.css(S(".CUWF"), S("$\bMD"))) : (w.css(S("%JBN]"), S("1P[")), y.css(S('B1-".3'), S("&9-|w"))), c.forEach(function (e, t) {
	            var n = e.getUrl(),
	                i = e.get(S("*EM@K"));d.push({ url: n, name: i, file: e }), i === s && (g = t);
	          });var E,
	              _ = { files: d, current: g, last: d.length - 1 };i.util.isWidget() && (E = t(m).appendTo(t(S("3VZRN"), f))), p.append(v).append(y).append(w).appendTo(t(S("&EGMS"), f)), setTimeout(function () {
	            p.focus();
	          }, 20), p.on(S("6TTPYP"), function () {
	            l();
	          }), t(p).on(S(";WXG[/6,"), function (e) {
	            e.keyCode === r.left && u(e, i.lang.dir === S("uni") ? -1 : 1), e.keyCode === r.right && u(e, i.lang.dir === S("C(14") ? 1 : -1), e.keyCode === r.escape && (e.stopPropagation(), l());
	          }), y.on(S("xpt}t"), function (e) {
	            u(e, -1);
	          }), w.on(S("px|u|"), function (e) {
	            u(e, 1);
	          }), a();
	        }function l(e, t, n) {
	          var i = document.createElement(e);return !!i.canPlayType && "" !== i.canPlayType(t[n]);
	        }function c(e) {
	          return l(S("!CV@LI"), { flac: S(":ZIYWPo'.\"'"), mp3: S("raqx7tj~{"), ogg: S(";]HZV/n-$#"), opus: S("*JYIG@^UTUX\\\\YHQO52"), wav: S("6VM]STJ_I"), weba: S("tcsqv5lys") }, e);
	        }function d(e) {
	          return l(S(")\\BHHA"), { mp4: S("<KW[%.m.4q"), ogv: S("2E]QSXV]\\"), webm: S("kw{EN\rTAGK") }, e);
	        }var f = S("rsw=''(<:6<+{r	"),
	            h = S("(JKGO\x00SZ"),
	            g = S("a}`}axv#{yorrjTD") + S(")^D\\") + S("7T\\\\O\r") + S('\nicyz`}+"(') + S('B1-".3ryq') + S("&JI[MBBOZD^	") + S("(DKSZGKDY\b") + f + ";" + S('alv"xt{t|a,') + h + ";",
	            p = g + S("5A^\\MR") + f + S("C-#./!>q") + h + ";",
	            m = S("/\fBFJXP\b") + S("-\x00L[WU]YSHK_MUXI2.-7d (+<9gb.%)}7;?1x&%=/3>+p,0XHG	\x00\n@\b_\x00Z\x00") + S(",\x00YJRZ[GWYOJRZXRI)/1&0evgxizk~=6osfdwy07+3/*>Y") + S("0_\\NTX@IS]YQHz(,0!1fwhyj{l>7preexx36,2,+X") + S("~rf2SICGKRNFZO_\fDM~y),2,61')<r") + "}" + S("<L48.&z"),
	            v = S('/}xq7yun&>fe"\x00HV\rBLJBfHGN\fPS\rB@P	MLSO[WS%\b!,*mog54hk?97#5lp') + g + S("9") + S('/}xq7yun&gf#?IU\fEMICiIDOQP\fCCQNM\nPNIOR=<`c-!{e+",f% /(5|"!1#?2/{z(($2:]C\n\nS\bU') + g + S("<\x00"),
	            w = S(')wb|pu;oo}"ZYLR	][FQP\fS^\\GFZZDYTRILP,2`c71?+-th') + g + S("@c|"),
	            y = S("\f1xftt}3ggu*:ba&<tj1USNYXKFD_^BB\\\rQ\\ZADXTJOIGS%|`") + g + S(";$"),
	            C = S(" KEVDKB\bZXHUT\r[G@D[DGNJF,$a") + p + S("("),
	            x = S("*~u~:zpi#=[ZMQ\bAAEOeM@KMLGGU\nBATJ&(.&\r&))``j61on<$(>6iw") + g + S("6+") + S("/\fXTAUXSKKYFE`(6m17*g54hk?97#5lp7=&&;9 `533;d") + p + S("'\n"),
	            b = S("Ez.%.j* 9sm+*os=!x115?=0;@CZJVLA=PPZ_^\fôøîæ¹§") + g + S("4)");return a;
	      }), CKFinder.define(S('4v}qQW^^NsP$4.&7j\x00.$,9d"<;55:80%'), [S("2QUV]UWW_")], function (e) {
	        "use strict";
	        return e.Collection.extend({ comparator: function comparator(e, t) {
	            return e.get(S("/FXWD\\EqWU^^N")) === t.get(S("<KWZ7{+0**#-;")) ? e.get(S("<S_R%")).localeCompare(t.get(S("qALG"))) : e.get(S(",[GJG[@rZZS]K")) ? -1 : 1;
	          }, initialize: function initialize() {
	            this.on(S("&D@HDLI@N]T"), function () {
	              this.sort();
	            });
	          } });
	      }), CKFinder.define(S("7{r|RRY[Mo\f-'1)#4g#')>a	9=7 <:#=+"), [], function () {
	        "use strict";
	        return { attachTo: function attachTo(e) {
	            var t = new e.constructor();return t.search = function (n) {
	              var i;e.length && ("" === n ? (i = e.toArray(), t.isFiltered = !1, t.filter = n) : (i = e.filter(function (e) {
	                return new RegExp(n, S("GH")).test(e.get(S("1\\RYP")));
	              }), t.isFiltered = !0), t.reset(i));
	            }, t.listenTo(e, S("}ubwg"), function () {
	              t.reset(e.toArray()), t.isFiltered = !1;
	            }), t.listenTo(e, S("cw~{cs"), function (e) {
	              t.remove(e);
	            }), t.listenTo(e, S('C%!"'), function (e) {
	              t.add(e);
	            }), t.isFiltered = !1, t;
	          } };
	      }), CKFinder.define(S('hxfkbieMKBBZ~NA]BNDTAr\\ZRKySSRMZ$1*> "%(-.9+"~5=\''), [], function () {
	        return S('1_UWS[33@G\x00V4o."& *g54@Bp>>.>q1?5&%jz:1=q>60N\x00\fF\x00\b\\TIG[	P\féûç£ùøº¨ûùëå²³ùÿâæàµâîèü§¹îüúöÏÍÅÈÃÊÁÍïÅÁÀÃÔàÖÇÜÌÒÜÏÝß×Ñ¤¤ºþæôäç¾¨¦¾©ðì´«ìòº û¸¶µ¼ú¦¡ÿ¥¤ßÁÃË©ÎÑÇÙbmgg&~}8utqp3-g{>xaWqswbtm:fa=}wEBIF@D@LI@II\fTKON\n?\nTXX^P');
	      }), CKFinder.define(S(">K%96b\x00.&-/9c+\" =3'1&y15?(s601\r\r#\r\n&=V"), [], function () {
	        return S('\'p||zL(*_^A]GMCIsY]\\GPdRKP@^XtS^\'$*> 5i<9?# n2-[[o=;&",y.",8c}\x00\nGF		VN	3$\x00_^áãëíààþºª¸¨«úìâúõ¬°èï¨¶þì·ôúñø¾âÝ©ÊÆÊÌÆ¦ÊÆÆÑßÕÆÅÚÑÝÞÖÐ¯²§î¶ µ®²¬®æ¥ ¯¨µü±¦§¡¹ºõ¿³¾°¹­ÿÏÅÓÌùýÉÙÂ"bie)fnhgzo&~h}fjtv>}xwp}4ynoiqr\rCNLGN" #@LLJ\\Q_UFE\nZQ]^VP/2\'n6 5.2,.f% /(5|>260:uf3?(5bp\f\x00\x00\b[lnTFSdfLT\nGYRãéíì÷à«õíúãñéé£æýðõö¹öãäìö÷¶þññüËÁÈÂÅÏÇÆÙÎßËÜÙË××ÜÛÖßÜÒÒÍËËâÿÈÊÍù¯©¸¼¾ë¸´¾ªíó¦¶¬¡ô÷¶¸·¾áÿ½´¢°ÎÍËÕÉÛÚldf>&aotikfnh/.yq}gv)7ml%9so2jw{TI^Y-!OE[%9\rVZBU[YJI^UYm"*,+6#j:,9"6(*b9<341x5"+-56q?20\n@]nlo[\b\b\x00M\rNVURòäñêþàâªáäëìé âîòôþ±ªÝóþÿñî§³ñÿýÅÍ©­ÃÁß¡¥ÊÆÆÑßÕÆÅÚÑÝÞÖÐ¯²§î¶ µ®²¬®æ¥ ¯¨µü±¦§¡¹ºõ»¶´¿¶þ¼ÏÄÜÚßÀõ	\b>jjuss(}s{i0,{uif14{wz}$8xw{]jSUMNl@O@@]\bXLLF^UWK	]SH]_RZ$|`\'-6\'%$,.il;/#%4oq/.kw1-t39497AF[lnTFSdS_J');
	      }), CKFinder.define(S("(jamECJJB\\P@ZRK|RPXM('47j/'&9.(=&*4694120?,"), [S(" TLGAWUDG[O"), S("&MY\\OYU"), S("TS_suxxl0uUKOnC^kFNN"), S(".l{w[]PPDnP_LO|^3$m\x00+)*\"+=#$\"'*'"), S("B\x00/),,8d$+8#~2'0y,<7\r58)"), S(")^NTYl{w[]PPDl\\WKP\\JZ3n*( 5h!%$?(*#8(60;6?</90p;"), S('br`m;XW[wqDDP\fp@KWDH^N_hF\\TAw]YXK\\h^OTDZ$\b/"# )8<>8(#a4>&')], function (e, t, n, i, r, o, s) {
	        "use strict";
	        var a = i.extend({ name: S("]pNUG[PhCI]"), template: "", tagName: S("jb|b"), events: { 'change [name="ckfChooseResized"]': function changeNameCkfChooseResized(e) {
	              var n = t(e.currentTarget).val();n === S("*tsN[\\D^_") ? (this.$el.find(S(',MDVQ[[ZERK_HUG[[m(/"# k$=:>$!`(&5=6 ')).removeClass(S("or1nj~TDGMVGEDLN")), this.$el.find(S("'JAMNF@_BWFPE^B\\^UP_X%l+-402g!':>8")).textinput(S("u}rz")).removeAttr(S("r~kxxwyy")).first().focus()) : (this.$el.find(S("3}tF\fAKKJUB[OXEWKKX_RSPTMJNTQXV%-&0")).addClass(S('6BQIO]I[$(1"&)##')), this.$el.find(S("6zq}1~vpORGV@UNRLNE@OHU[]D@BQWJNH")).textinput(S(",IG\\QS^V")).attr(S("'L@YJNAKK"), S("2W]FWUT\\^")));
	            } }, childEvents: { keydown: function keydown(e, t) {
	              if (t.evt.keyCode === n.down || t.evt.keyCode === n.up || t.evt.keyCode === n.tab) {
	                if (t.evt.preventDefault(), t.evt.stopPropagation(), t.evt.keyCode === n.down || t.evt.keyCode === n.up) {
	                  var i = this.collection.where({ isActive: !0 }),
	                      r = i.indexOf(e.model),
	                      o = r + (t.evt.keyCode === n.down ? 1 : -1);0 > o && (o = i.length - 1), o > i.length - 1 && (o = 0);var s = this.children.findByModel(i[o]);s && s.focus();
	                }t.evt.keyCode === n.tab && e.$el.closest(S("*OFHTXS_[R")).find(S("\fVjndp?ps;ummntr@")).eq(this.finder.util.isShortcut(t.evt, S("D6...=")) ? -1 : 0).focus();
	              }
	            } }, collectionEvents: { reset: function reset() {
	              this.$el.html("");
	            } }, onRender: function onRender() {
	            var e = this;setTimeout(function () {
	              e.$el.enhanceWithin();
	            }, 0);
	          }, getChildView: function getChildView(e) {
	            var t = { name: S("+oEA@CT`VG\\LR\\pN^Q"), finder: this.finder, template: o, tagName: S("#@LP"), events: { 'keydown input[type="radio"]': function keydownInputTypeRadio(e) {
	                  this.trigger(S("8R_BXRIQ"), { evt: e });
	                } }, focus: function focus() {
	                this.$el.find(S("wqPTV")).focus();
	              } };return e.get(S("{liosp")) && this.addCustomSizeViewConfig(t), r.extend(t);
	          }, addCustomSizeViewConfig: function addCustomSizeViewConfig(e) {
	            e.className = S('E%,.d)##"=*}#7 =/33u07:;8s<\f	'), e.template = s, e.tagName = S("\noe{"), e.ui = { width: S("{}d`bLvxw~!?}tFbWPPJKpAM^Cp"), height: S("<TPO55-%(#zj*!-8=;?<6=2>#z") }, e.setSize = function (e, t) {
	              var n = 0 >= e ? 1 : e,
	                  i = 0 >= t ? 1 : t;this.ui.height.val(n), this.ui.width.val(i), this.model.set({ size: i + "x" + n });
	            }, e.events[S("2ZZECCyORJW[4)")] = function () {
	              var e = this.model.get(S("7OP^OT")),
	                  t = this.model.get(S("r~uzvk")),
	                  n = t,
	                  i = this.ui.width.val();i.length || (i = 1);var r = parseInt(i);e > r ? n = r * (t / e) : r = e, n = Math.round(n), this.setSize(n, r);
	            }, e.events[S("#MKVR\\	j^EFJYVZG")] = function () {
	              var e = this.model.get(S(" VKGPM")),
	                  t = this.model.get(S("dhghxe")),
	                  n = e,
	                  i = this.ui.height.val(),
	                  r = parseInt(i);i.length || (r = 1), t > r ? n = r * (e / t) : r = t, n = Math.round(n), this.setSize(r, n);
	            };
	          }, getSelected: function getSelected() {
	            return this.collection.findWhere({ name: this.$el.find(S("~viooGsrE\x00@OCeOGFYN~H]FJTViU_]ZQ^X")).val() });
	          } });return a;
	      }), CKFinder.define(S("RYU}{rrj6WtxhrzSdJH@U\bkAED_HhF\\TA"), [S("=KQ$$00'*4\""), S("+F\\[JBH"), S("zxyp~rpz"), S('/sztZZQSEtU_IQ[Lo+/!6i!,=8c& ?"71&?-==6=:;		')], function (e, t, n, i) {
	        "use strict";
	        function r(e) {
	          this.finder = e, this.isEnabled = e.config.chooseFiles, e.config.ckeditor && (e.on(S("s{}j xtrqlE"), function (t) {
	            var n = t.data.files.pop(),
	                i = { fileUrl: n.getUrl(), fileSize: n.get(S("aznp")), fileDate: n.get(S("\fio{u")) };e.config.ckeditor.callback(i.fileUrl, i);
	          }), e.on(S("*MEAKSY]\\GP\fE]JSAYYwR!&'"), function (t) {
	            var n = t.data.file,
	                i = { fileUrl: t.data.resizedUrl, fileSize: 0, fileDate: n.get(S("4QWC]")) };e.config.ckeditor.callback(t.data.resizedUrl, i);
	          })), this.isEnabled && (e.on(S("\rm`~ewk`Xsym#|rpx"), function (e) {
	            e.data.groups.add({ name: S("4V^XWJ_") });
	          }, null, null, 10), e.on(S("|OOVF\\QkBF\\MEAKSY]\\GP"), o), e.on(S("E2('%(*>w<*#4&i4?9b?379"), s), e.on(S("bxwuxzn'lzSDViDOIOCGI^"), a), e.on(S('1Q\\YXWY\\UPn_I%\b/"# '), function (e) {
	            e.data.context.file.set(S("'ADKLIK\\YKWwUAW"), new n.Model());
	          }), e.setHandlers({ "image:getResized": { callback: c, context: this }, "image:resize": { callback: d, context: this }, "image:getResizedUrl": { callback: g, context: this }, "files:choose": { context: this, callback: function callback(t) {
	                u(e, t.files);
	              } } })), e.setHandlers({ "file:getUrl": { callback: h, context: this }, "file:getProxyUrl": { callback: f, context: this } }), e.on(S("uxut{ux'yTDPc@RaAEO~^A"), function (e) {
	            e.data.context.thumbnail || e.data.context.file.set(S("oip"), e.data.response.url), e.data.context.dfd.resolve(e.data.response.url);
	          }), e.on(S("w}tzx#YssrmzrDQJ^@BnEHMNBE"), function (t) {
	            var n = t.data.view.getSelected();v(e, n.get(S("blcj")), n.get(S("-]FJT")), t.data.context.file), e.request(S("\rjfq}}t.qsdlkub"));
	          });
	        }function o(e) {
	          function t() {
	            new n.Model({ name: S("2p\\ZYD]k_HUG[[	,#$!"), label: e.finder.lang.ChooseResizedImage, isActive: i.get(S("6QWU^^N")).get(S("*JOA")).imageResize || C(i), icon: S(",NEIRZ\\[FSJ\\IRFXZ"), action: function action() {
	                l(e.finder, i);
	              } }).set(S("xyouk{"), C(i));
	          }var i = e.data.context.file;if (e.data.items.add({ name: S("Rz|{fs"), label: e.finder.lang.Choose, isActive: i.get(S("=XP,%'1")).get(S("*JOA")).fileView, icon: S("0RYUV^XWJ_"), action: function action() {
	              var t = e.finder.request(S(";ZTRZ3{%&0#+-*>.("));t.length > 1 ? u(e.finder, t) : w(e.finder, i);
	            } }), i.isImage() && e.finder.config.resizeImages) {
	            var r = i.has(S("+E@OHUcW@]OSsYM[")) && i.get(S("vM@EFv@UNRLnJXL")).has(S("\fb|fwx|rxFm}"));r || i.once(S("#GMGIOLBALIJbTAZNPrVLX"), t), e.data.items.add(new n.Model({ name: S("!aKKJUBzLYBVHJf]PUV"), label: e.finder.lang.ChooseResizedImage, isActive: i.get(S("i}vvf")).get(S("/QR^")).imageResize || C(i), icon: S("9YPZ]W/.1&i7#4!3//"), action: function action() {
	                l(e.finder, i);
	              } }));
	          }
	        }function s(e) {
	          function t() {
	            w(e.finder, i);
	          }var i = e.data.file;if (y(e, t), i.isImage() && e.finder.config.resizeImages) {
	            var r = i.has(S("0X_RSPdRKP@^x\\J^")) && i.get(S('"JIDABzLYBVHjNDP')).has(S("&HZ@MBBLB|YKW")),
	                o = new n.Model({ name: S("_uqpSDpFWL\\BL`GJKH"), type: S(",O[[D^\\"), priority: _, alignment: S(";LOWR!3;"), icon: S("CJDGMIH[LYI^GUUU"), label: e.finder.lang.ChooseResizedImage, isDisabled: !(i.get(S("&AGENN^")).get(S("ns}")).imageResize || C(i)), action: function action() {
	                l(e.finder, i);
	              } });r || (i.once(S("#GMGIOLBALIJbTAZNPrVLX"), function () {
	              o.set(S("4\\EsQJ[YPXZ"), !C(i));
	            }), e.finder.request(S("=WR!&'y# 2-:#1))"), { file: i })), e.data.toolbar.push(o);
	          }
	        }function a(e) {
	          function t() {
	            u(e.finder, e.finder.request(S("1TZXPE\r_\\NhYQ[\\4$&")));
	          }y(e, t);
	        }function u(e, t) {
	          var n = t.clone();n.forEach(function (t) {
	            !t.getUrl() && t.get(S("(OEGHH\\")).getResourceType().get(S(".ZCTbA[MOtWTWZRY")) && t.set(S("\r{}|"), e.request(S("p~t| |yiNmOY[vVI"), { file: t }));
	          }), e.fire(S("-HF\\TA	W]YXK\\"), { files: n }, e), b(e);
	        }function l(e, t) {
	          var r = new n.Collection(),
	              o = e.config.initConfigInfo.images;p(r, e, t, o), t.on(S("E%/)'-.v$#.74\x006'<,28.:"), function () {
	            r.reset(), p(r, e, t, o);
	          }), e.request(S("9^R]QQX"), { title: e.lang.ChooseResizedImage, name: S("\\HNMPAwCTASOOe@OHU"), buttons: [S("OJ"), S("&DIGIN@")], view: new i({ finder: e, collection: r }), context: { file: t } });
	        }function c(i) {
	          var r = this.finder,
	              o = i.file,
	              s = new t.Deferred();if (o.has(S("\nbalijBtaznpRvlx")) && o.get(S("e`ohuCw`}osSym{")).has(S("&HZ@MBBLB|YKW"))) s.resolve(o);else {
	            var a = o.get(S(";ZRR[%3"));r.once(S('\nhc`cn~u(rrase"^oNxmvZDFjIDAB['), function (t) {
	              var i = t.data.context.file,
	                  r = new n.Model();t.data.response.resized && r.set(S("C6 5.2,."), t.data.response.resized), t.data.response.originalSize && r.set(S("%IUANCEMA}FJT"), t.data.response.originalSize), e.forEach(t.data.response.resized, function (t, n) {
	                if (n === E) return void e.forEach(t, function (e) {
	                  var t = e.name ? e.name : e,
	                      i = t.match(M);if (i) {
	                    var o = { fileName: t };e.url && (o.url = e.url), r.set(x(n, i[1]), o, { silent: !0 });
	                  }
	                });var i = { fileName: t.name ? t.name : t };t.url && (i.url = t.url), r.set(x(n), i, { silent: !0 });
	              }), i.set(S("{~ursE}jsayYkA"), r), t.data.context.dfd.resolve(i);
	            });var u = { fileName: o.get(S("3ZT[R")) };e.isArray(r.config.resizeImages) && r.config.resizeImages.length && (u.sizes = r.config.resizeImages.join(",")), r.request(S("(JEFAL@K\nBW]P"), { name: S("4rSCj\\IRFXZv- %&7"), folder: a, params: u, context: { dfd: s, file: o } });
	          }return s.promise();
	        }function d(e) {
	          var i = this.finder,
	              r = e.file,
	              o = new t.Deferred(),
	              s = e.size;if (!e.name) throw S("Ivz\x00ECWEHFEL\n[M_OBUEWA\\EJ\\KNUO[[");if (e.name === E) {
	            if (!e.size) throw S("Nsy=z~T@\fPM_CXHXJAHZJB[@GSFMPH^XIW%/b67,( hk1%- +2r").replace(S("?;/#.!8"), E);s = e.size;
	          } else {
	            if (!i.config.initConfigInfo.images.sizes[e.name]) throw S('Lq;r|sz\x00YMEHCZ\n	CX\fCA[R]]R\\QBJ\\^ZRL2$1*> "g!$+,)>').replace(S("btzqxc"), e.name);s = i.config.initConfigInfo.images.sizes[e.name];
	          }if (r.has(S("0X_RSPdRKP@^x\\J^")) && r.get(S(",DCNWT`VG\\LR|XNZ")).has(S("\r|jcxhvp@d{") + s)) o.resolve(r);else {
	            var a = r.get(S("@'-/  4"));i.once(S("D&)*%($/v,(;5#h9412\n<)2&8"), function (t) {
	              var i = t.data.context.file,
	                  r = t.data.response.url,
	                  o = i.get(S("+E@OHUcW@]OSsYM["));if (o || (o = new n.Model(), i.set(S("qt{|yO{lI[GgEQG"), o)), e.save) {
	                var s = o.get(S("/BTAZNPR"));s || (s = {}, o.set(S("9H^OTDZ$"), s)), s.__custom || (s.__custom = []), s.__custom.push(r.match(I)[0]);
	              }o.set(x(e.name, e.size), { url: r }), t.data.context.dfd.resolve(i);
	            }), i.request(S("l|rzq,d}w~"), { name: S("F}puvFpe~b|"), folder: a, params: { fileName: r.get(S("N@OF")), size: s }, context: { dfd: o, file: r } });
	          }return o.promise();
	        }function f(t) {
	          var n = this.finder,
	              i = t.file,
	              r = e.extend({ fileName: i.get(S("{wz}")) }, t.params);return t.cache ? r.cache = t.cache : n.config.initConfigInfo.proxyCache && (r.cache = n.config.initConfigInfo.proxyCache), n.request(S("9YTQP_Q${71("), { command: S(",}\\@HH"), params: r, folder: i.get(S('B%+)"":')) });
	        }function h(e) {
	          var n = this.finder,
	              i = e.file,
	              r = new t.Deferred(),
	              o = i.getUrl();return i.get(S("=XP,%'1")).getResourceType().get(S('"VW@vUGQShC@CN^U')) && (o = n.request(S(">Y)-'y# 2:&22?\""), e)), o ? r.resolve(o) : n.request(S('?#./.%+"};,$/'), { name: S("*lIYhF\\TgAX"), folder: i.get(S('C"**#-;')), params: { fileName: i.get(S("8W[VY")) }, context: { dfd: r, file: i } }), r.promise();
	        }function g(e) {
	          var n = this.finder,
	              i = e.file,
	              r = new t.Deferred();return n.request(S("twtwzry$lEOF"), { name: S("7\\N}UQ[j2-"), folder: i.get(S("3RZZS]K")), params: { fileName: i.get(S("E(&%,")), thumbnail: e.thumbnail }, context: { dfd: r, file: i, thumbnail: e.thumbnail } }), r.promise();
	        }function p(t, n, i, r) {
	          var o = i.get(S("?),#$!#4!3/-9/")),
	              s = o && o.get(S('"LVLANFHFxEWK')) || "",
	              a = i.get(S("1T\\XQSE")).get(S("qr~")).imageResize,
	              u = i.get(S(",KACTT@")).get(S("%GDD")).imageResizeCustom,
	              l = t.add({ label: n.lang.OriginalSize, size: s, name: S("%IUANCEMA"), isActive: !0, isDefault: !1 }),
	              c = o && o.get(S(">M%2+9!!")),
	              d = !0;if (e.forEach(r.sizes, function (i, r) {
	            var o = i,
	                u = a;if (!e.isArray(n.config.resizeImages) || !n.config.resizeImages.length || e.contains(n.config.resizeImages, r)) {
	              if (c && c[r]) {
	                var l = c[r].match(M);2 === l.length && (o = l[1]), u = !0;
	              } else if (s) {
	                var f = s.split("x"),
	                    S = i.split("x"),
	                    h = parseInt(S[0]),
	                    g = parseInt(S[1]),
	                    p = parseInt(f[0]),
	                    v = parseInt(f[1]),
	                    w = m(h, g, p, v);p <= w.width && v <= w.height ? u = !1 : o = w.width + "x" + w.height;
	              }t.add({ label: n.lang.ChooseResizedImageSizes[r] ? n.lang.ChooseResizedImageSizes[r] : r, size: o, name: r, isActive: u, isDefault: d && u }), d = !1;
	            }
	          }), c && c.__custom) {
	            var f = [];e.forEach(c.__custom, function (e) {
	              var t = e.match(M);t && (t = t[1], f.push({ label: t, size: t, width: parseInt(t.split("x")[0]), name: E + "_" + t, url: e, isActive: !0 }));
	            }), e.chain(f).sortBy(S('C3,"3 ')).forEach(function (e) {
	              t.add(e);
	            });
	          }if (u) {
	            var h = 0,
	                g = 0;if (s) {
	              var p = s.split("x");h = p[0], g = p[1];
	            }t.add({ name: E, custom: !0, isActive: u, isDefault: !1, width: h, height: g, size: h + "x" + g });
	          }t.findWhere({ isDefault: !0 }) || l.set(S("d\\||ziqj"), !0);
	        }function m(e, t, n, i) {
	          var r = { width: e, height: t },
	              o = e / n,
	              s = t / i;return (1 !== o || 1 !== s) && (s > o ? r.height = parseInt(Math.round(i * o)) : o > s && (r.width = parseInt(Math.round(n * s)))), r.height <= 0 && (r.height = 1), r.width <= 0 && (r.width = 1), r;
	        }function v(e, t, n, i, r) {
	          function o(t, n) {
	            e.request(S("ws|zzRJJ@@")), e.fire(S("6QQU__UQP3$x1!6/=--&-*+"), { file: t, resizedUrl: n }, e), b(e);
	          }if (t === S("#KWO@AGKG")) return void w(e, i);0 === t.indexOf(E + "_") && (t = E);var s = i.get(S("8PWZ[XlZ3(8&\x00$2&")),
	              a = x(t, n);if (s && s.has(a)) {
	            var u = s.get(a),
	                l = { file: i };if (u.url) return void o(i, u.url);var c = S("A$*( | -=9 ");return t !== S('7WKS\\US_S') && u.fileName && (c = S("&NEHMNJK[bTAZNPRbJU"), l.thumbnail = u.fileName), e.request(S("E*()-/9v>& '"), { text: e.lang.GettingFileData }), void e.request(c, l).then(function (e) {
	              o(i, e);
	            });
	          }e.request(S("uuzxxl%SIMT"), { text: e.lang.GettingFileData }), e.request(S(")CFMJKBTAZNP"), { file: i, size: n, name: t, save: r }).then(function (e) {
	            o(e, e.get(S("?),#$!#4!3/-9/")).get(a).url);
	          });
	        }function w(e, t) {
	          var i = t.getUrl(),
	              r = new n.Collection([t]);return i ? void u(e, r) : (e.request(S('B/+$"":s9##:'), { text: e.lang.GettingFileData }), void e.request(S("p~t| |yiKmL"), { file: t }).then(function () {
	            e.request(S("\ngcljjb+zzpp")), u(e, r);
	          }));
	        }function y(e, t) {
	          e.data.toolbar.push({ name: S("1q[[ZER"), type: S("\niyyz`~"), priority: F, icon: S("5U\\^YSSRMZ"), label: e.finder.lang.Choose, action: t });
	        }function C(t) {
	          var n = t.get(S("(OEGHH\\")).get(S(")KH@")),
	              i = t.has(S("e`ohuCw`}osSym{")) && !!e.size(t.get(S("zy~IynweEeCWE")).get(S("\fk|ykww")));return n.imageResize || n.imageResizeCustom || i;
	        }function x(e, t) {
	          var n;return n = e === E ? S(".]UB[IQQcETfYNOIQR") + t : S(",_K\\YKWWaGZh") + e;
	        }function b(e) {
	          e.config.chooseFilesClosePopup && e.request(S(":XPRMZ.264"));
	        }var E = S("FExinjpM"),
	            _ = 100,
	            F = 110,
	            M = S("3G-3&}\nZx\bz\x00qqvOJpiiN\rD"),
	            I = S("&\b\x00rtq\n");return r;
	      }), CKFinder.define(S('"WA]RkblBBIK]eW^DYWC]J}UQ[Lo+/!6).&d/#9'), [], function () {
	        return S('>D;~b*0k".;9&*5!.44 s)(\\k<0,{?1?,\\@\rH\n\b	\rLB[^\né¬áìêñãéü©ÿâ¡ïáëé¼éè©µÿã¶êíúèþö¿ÝÜÖÍÅÈÚÇÏÙÌÂÃ¸ºÆÆÖÖÙ×ÝÎÍâ´«î­¦©©å¥¥ª¨¤ ¨òïîü§¥·¹æÓÓç´ìà¤ÜÂËËÒÀÀÌùÈÚÇðÂÁ}>gms&ddhyx1/mdv<tzxpe:qw|t1q{YWJ	FII\\LD_\fXGR^VJNM\nPNOJ_K#)b>9e3.e*%9"(<b1=>qj__k0kd \'`~6O\n	GVD_Pey\n	LTY	3ïàææö¥ûú´ù´ð÷°®æä¿æöìá¶êå¥µë¢æå ÝÜ¨ÁÏÑ£ÑÐÐÓ¥');
	      }), CKFinder.define(S('.l{w[]PPDuV^NPXM(.&7j.->9d\n$"*#<5;?2/'), [S("B!%&-%''/"), S("cjdJJACUCN[^mQBW}ASZnP_L"), S("9N^DI|+-  4h,'; ,:*#~:80%x06>/09O\f")], function (e, t, n) {
	        "use strict";
	        var i = t.extend({ name: S("0w[_QFY^VlRYJ"), template: n, className: S("\rmdv<tzxpe:qw|t"), templateHelpers: function templateHelpers() {
	            return {
	              swatch: this.finder.config.swatch };
	          }, initialize: function initialize() {
	            this.model = new e.Model({ title: this.msg.title, text: this.msg.text, displayLoader: this.displayLoader });
	          } });return i;
	      }), CKFinder.define(S("\niuz.SZTzzqse7MvlqkER\reMICToCGI{GJGV\\@"), [], function () {
	        return S(":]VM%'a.$0&;*8\"<9t9?86{d|tw;5;(/`|<O\r	E\x00	LOE[WJ^]\ráæåâæéãºªýøþé¯®ýÿý÷®¶ùÿäìðîþñ¿¾þÒÈÃÈÄÄÂÄÐ×ÆÄÜÒÙÐÊÅÚÎÔß¤¤± ¶¬¤¢¬«³öî¶µîð¸¦ý°°¥´ª°ª¯µ²°ÁÆÛìîÔÌÏÑÛÔÝ `nw9'$'{{i6.vu20xf=spb^{vt35=cbFQEBAFJEOY\\ZU\n??LCRHZV31.\"='*-i67l$:a48!#84/9-?{ !~6O\n\n:	MzxNV	\bA_æ¬äêèà«ãíúé«ùä£íñã¿èï¨¶þì·ùôòû÷øÒÕÂÐÆÎÚÕÏÞÌÉÈÑÓÞÖÂÅÍÜ¶´·Ä»þâª°ë¢®»¹¦ªµ¯¢µñ¯®è½ä÷¬°®·¹àü¤ÀÂËÊÏÐÐÒÛÚÁÑ2?yx;x{\r\x006{,i|nwvsqxp+5lko~>=w{YXOSMOXO_G_DX]]}QJE1547D;~b*0k\".;9&*5	/;5q/./.ww1-t7=39q\"\f9\x00\bXQZYS[\x00¿üÿüó¶ªâø£êæãáþòíÆÿíý¹çæ©ÚÙÌÒÌÀÙÛÀÌ×ëÑÅ×ÉÈÕÊÁÀÀÃµÉÈËÊ¿¾çç¡½ä§­£©á¶¾ ¾µ¡¾´¼²¦¸öÿÌÇÂÉÛÛÞÙÎÆÐùýüÿÆöô÷Ã/q<	\r9)ca4vu0ml/;t(");
	      }), CKFinder.define(S("6tsSUXXL\r.&6( 5h &.?b&5&!|<:20?,"), [S("w~pHuuy}q"), S("&RFMOY_NA]U"), S("$OWRM[S"), S("8zq}USZZ2n*!25h\n(9.c:*=;6#"), S("\nHGKgatt`<Aa{7Rb_rzz"), S('%RBP]hgkGATT@`P[GTXN^OxV,$1l,*" /<b)!;')], function (e, t, n, i, r, o) {
	        "use strict";
	        var s = 700,
	            a = 500,
	            u = 1e3,
	            l = i.extend({ tagName: S("sI"), lazyLoad: !0, name: S("JdbjDyg~v"), template: o, className: S("7[R\\ZTRZm(6&)"), eventPrefix: S("qqu"), ui: { activeElem: S("0|KGEMICT@DEI_"), img: S("+E@I") }, attributes: { "data-icon": !1, role: S("8IH^OXPK!5+,*") }, events: { "touchstart @ui.activeElem": function touchstartUiActiveElem(e) {
	              this.isInTouch = !0, this.longTouchTimeout && clearTimeout(this.longTouchTimeout);var t = this;this.longTouchTimeout = setTimeout(function () {
	                t.isInTouch && (t.triggerEvent(S(":WSSYK/4!+"), { evt: e, view: t, model: t.model }), t.isInTouch = !1);
	              }, s);
	            }, "touchend @ui.activeElem": function touchendUiActiveElem(e) {
	              this.checkDoubleTap(e), this.isInTouch && this.triggerEvent(S("B (,%,"), { evt: e, view: this, model: this.model }), this.isInTouch = !1;
	            }, "touchcancel @ui.activeElem": function touchcancelUiActiveElem() {
	              this.isInTouch = !1;
	            }, "touchmove @ui.activeElem": function touchmoveUiActiveElem() {
	              this.isInTouch = !1;
	            }, "contextmenu @ui.activeElem": function contextmenuUiActiveElem(e) {
	              this.isInTouch ? e.preventDefault() : this.triggerEvent(S("CNLWA]RJMG_"), { evt: e, view: this, model: this.model });
	            }, "dblclick @ui.activeElem": function dblclickUiActiveElem(e) {
	              this.triggerEvent(S('>["-!/-&-'), { evt: e, view: this, model: this.model });
	            }, "click @ui.activeElem": function clickUiActiveElem(e) {
	              var t = { evt: e, view: this, model: this.model };if (2 === e.button || 3 === e.button) this.triggerEvent(S("<^QQ4$:7) (2"), t);else {
	                if (0 !== e.button) return !1;this.triggerEvent(S("(JFBOF"), t);
	              }
	            }, "keydown @ui.activeElem": function keydownUiActiveElem(e) {
	              return e.keyCode === r.menu || e.keyCode === r.f10 && this.finder.util.isShortcut(e, S("isu{j")) ? void this.triggerEvent(S("|OOVF\\QKBF\\"), { evt: e, view: this, model: this.model }) : void this.triggerEvent(S("yvmqy`v"), { evt: e, view: this, model: this.model });
	            }, "dragstart @ui.activeElem": function dragstartUiActiveElem(e) {
	              this.triggerEvent(S("0U@RSFBVJM"), { evt: e, view: this, model: this.model });
	            }, "dragend @ui.activeElem": function dragendUiActiveElem(e) {
	              function t(e) {
	                e.cancel();
	              }var n = this;n.finder.on(S("2F]E@QI_WY[J"), t, null, null, 1), n.finder.on(S("%SNZ]B\\H\\FWYF"), t, null, null, 1), setTimeout(function () {
	                n.finder.removeListener(S("A7*~61.8,&.*9"), t), n.finder.removeListener(S('>J){14-5#5!."?'), t);
	              }, 500), this.triggerEvent(S('"GVDABFM'), { evt: e, view: this, model: this.model });
	            }, "blur @ui.activeElem": function blurUiActiveElem() {
	              this.ui.activeElem.attr(S("awuqw~~d"), -1);
	            }, "focus @ui.activeElem": function focusUiActiveElem() {
	              this.ui.activeElem.attr(S("B7%'/),,2"), 0);
	            }, "mouseenter @ui.img": S("\nceikKubqa}eb~ww"), "mouseleave @ui.img": S("\f~f`gUw`wgglpuu") }, modelEvents: { focus: function focus() {
	              this.ui.activeElem.focus(), this.trigger(S('C"*%2;,.'));
	            }, refresh: function refresh() {
	              this.render(), this.trigger(S("\r|jbt|wqg"));
	            }, selected: function selected() {
	              this.ui.activeElem.addClass(S("`:zmt6}~jvVD"));
	            }, deselected: function deselected() {
	              this.ui.activeElem.removeClass(S("c~5{nu1|}kIWG"));
	            }, change: function change(e) {
	              e.changed.name && (this.render(), this.trigger(S("\fk}uvvf")));
	            } }, templateHelpers: function templateHelpers() {
	            return { getIcon: this.getIcon.bind(this), displayName: this.getOption(S("xtmoL@[mEHC")), displaySize: this.getOption(S("&CAZZGMT}FJT")), displayDate: this.getOption(S("qdhu{bX|jz")), descriptionId: t.uniqueId(S("$FMA")) };
	          }, initialize: function initialize() {
	            this.hasPreview() && this.finder.config.initConfigInfo.thumbs && this.updateLazyConfig(), this.on(S("dqcNlykE"), function (e) {
	              this.options.thumbSize = e.thumbSize, this.options.thumbSizeString = e.thumbSizeString, this.hasPreview() && this.finder.config.initConfigInfo.thumbs ? this.updateLazyConfig() : this.loadThumbnail(this.getIcon()), this.trigger(S("9H^NXP[%3"));
	            });
	          }, onRender: function onRender() {
	            var e;this.getOption(S("pq{E")) === S("&S@\\GI_") && (e = this.getOption(S(" UJVIGuNRL")), this.$el.css({ width: e + S("ha"), height: e + S("<MF") })), this.showDescription();
	          }, getIcon: function getIcon() {
	            return this.finder.request(S("&AAEOKHZfS^\\"), { size: this.getOption(S("ivjMCqJ^@")), file: this.model });
	          }, checkDoubleTap: function checkDoubleTap(e) {
	            var t = this.touchStartAt;this.touchStartAt = e.timeStamp;var n = t && this.touchStartAt - t < a;this.triggerEvent(S(n ? '>["-6"4' : "ayb{q"), { evt: e, view: this, model: this.model });
	          }, triggerEvent: function triggerEvent(e, t) {
	            this.trigger(this.getOption(S("sa}wnKnxxvX")) + ":" + e, t);
	          }, loadThumbnail: function loadThumbnail(e) {
	            this.ui.img.after(n(S("!JIBT\\PFNJFCA^RMXXV\\")).attr(S("@20 "), e).on(S("`bok"), function () {
	              n(this).prev(S(".F]V")).attr(S("'[[I"), n(this).attr(S("(ZXH"))), n(this).remove();
	            }));
	          }, hasPreview: function hasPreview() {
	            return !this.model.get(S("lryj$vSgMO@@T")) && this.model.isImage();
	          }, updateLazyConfig: function updateLazyConfig() {
	            this.options.lazyThumb = this.finder.request(S('@\'+/!!"<">!/'), { file: this.model, size: this.getOption(S("oths}sHXFwQTNFN")) });
	          }, showDescription: function showDescription() {
	            clearTimeout(this.hideDescriptionTimeout), this.$el.removeClass(S("2P_SQQU_OUQHm5*6)'"));
	          }, hideDescription: function hideDescription() {
	            var e = this;this.hideDescriptionTimeout = setTimeout(function () {
	              e.$el.addClass(S('ofh"vx~v9f~xo4nsip|'));
	            }, u);
	          } });return l;
	      }), CKFinder.define(S("xhv{1RYU}{rrj6N~qmr~TDQ\fbLJB[lD@IK]y_tZXPSWM"), [], function () {
	        return S('1RVZVKJ_VX&(.&7h/)&,8il9/-9?66,htzi{z?.<98YG\x00IL	\\X	GY\b¢¿¸ìëà¨êæêÿþ³­åø¿ÿý¸âÿíôø¹¼üòëÙØÏÓÅËÉÉÁÓÌÛÇÛ×ÚÝÇÆÍÍ£üà¸¿øæ®¼ç­®¸­ ¾ùûó©¨ô÷¼¸®ºñ¾µ¹ÍØÄÉÒçäæÌÔÇÙÒfhnf)actk)b!oo}=ji.4|b9{vt}uz0lW@V@L[Z\n "%FE[GXPCBUIS!#\'/d9:g!=d%- +o-,ps04"6u:1=q9,0\\@EVJLAU\nXU üÿ¿«í´¹¶¤èäø±­½òª');
	      }), CKFinder.define(S("1qxr\\XS]KvSYKS%2m-)#4g#.;>a	?=66&815?\r58)"), [S("~uyFNLFDJ"), S("<HP[%31 +7#"), S("_VXvNEGQhIC]EOXkGCUBe]PADSWYkWZ7"), S("ZQ]uszzRwWMI	lMPiDHH"), S("mch<]TfHLGAW	sMDZGMYK\\w[_QFqWU^^NtPy)-'m *2")], function (e, t, n, i, r) {
	        "use strict";
	        var o = n.extend({ name: S(".i_]VVFa^BU["), template: r, className: S('E%,.d," (c&$4?s7>0z>66?9/-r	'), eventPrefix: S("sy{||h"), ui: { img: S("7QT]"), activeElem: S(")HGKIY]W@\\XY]K"), label: S("!szt>r|zrk4surxl") }, events: t.extend({}, n.prototype.events, { "dragenter @ui.activeElem": function dragenterUiActiveElem(e) {
	              e.stopPropagation(), e.preventDefault(), this.ui.activeElem.addClass(S("ex?q`{;v{msmy"));
	            }, "dragover @ui.activeElem": function dragoverUiActiveElem(e) {
	              e.stopPropagation(), e.preventDefault(), this.ui.activeElem.addClass(S("1GZWBYXYOUK["));
	            }, "dragleave @ui.activeElem": function dragleaveUiActiveElem(e) {
	              e.stopPropagation(), this.ui.activeElem.removeClass(S("ls6~ip2ABVJR@"));
	            }, "drop @ui.activeElem": function dropUiActiveElem(e) {
	              e.stopPropagation(), this.ui.activeElem.removeClass(S("7MPYHS^#5+5!")), this.trigger(S("~vvyo${RNR"), { evt: e, view: this, model: this.model });
	            }, "dragstart @ui.activeElem": function dragstartUiActiveElem(e) {
	              e.preventDefault();
	            }, "dragend @ui.activeElem": function dragendUiActiveElem(e) {
	              e.preventDefault();
	            }, "ckfdrop @ui.activeElem": function ckfdropUiActiveElem(e) {
	              e.stopPropagation(), this.trigger(S("2U[YRRJ^ISM"), { evt: e, view: this, model: this.model });
	            } }), getIcon: function getIcon() {
	            return this.finder.request(S(",KACTT@	SPB~[VT"), { size: this.getOption(S("'\\A_FN~GUU")), folder: this.model });
	          }, loadThumbnail: function loadThumbnail(e) {
	            this.ui.img.attr(S("<NL\\"), e);
	          } });return o;
	      }), CKFinder.define(S("_VXvNEGQpRND~C^BZ[\\T@@"), [S("+YCJJBBQ\\FP"), S("z`gvfl")], function (e, t) {
	        "use strict";
	        function n() {
	          this.reset();
	        }var i = {};return n.prototype = { reset: function reset() {
	            var e = this;e.dfd && e.dfd.reject(), e.dfd = new t.Deferred(), e.dfd.done(function () {
	              e.callback && e.callback(), e.reset();
	            }), e.timeOutId = -1;
	          }, assignJob: function assignJob(e) {
	            this.callback = e;
	          }, runAfter: function runAfter(e) {
	            var t = this;t.timeOutId && clearTimeout(t.timeOutId), t.timeOutId = setTimeout(function () {
	              t.dfd.resolve();
	            }, e);
	          } }, { getOrCreate: function getOrCreate(t, r) {
	            return e.has(i, t) || (i[t] = new n()), i[t].reset(), i[t].assignJob(r), i[t];
	          } };
	      }), CKFinder.define(S(")i`jD@KUC~[QC[]J}UQ[Lo+&36i!%/8$+8"), [S("5CY\\\\HH_RLZ"), S("V]Qqw~~n2KkIM\rhA\\eHLL"), S("B\x00/),,8d$+8#~2'0y756>?)707"), S("+ofhF^UWAxYSMU_H{WS%2m- 14g#')>!6>:1\""), S("?\n**!#5g%/9!+<;?1&y1<-(s737"), S("*hgkGATT@yZRBT\\IzTRZ3n*!25h&&/)?!8>6<3 "), S("D\r!'..>b;9=}<'9#,5?)/")], function (e, t, n, i, r, o, s) {
	        "use strict";
	        var a = 400,
	            u = 500,
	            l = 500,
	            c = n.extend({ name: S("%rO]DHEMDB\\fXWD"), reorderOnSort: !0, childView: r, attributes: { "data-role": S("LHQWRLCP"), tabindex: 30, role: S("}{``") }, tagName: S("%SK"), className: S("B /#k!!%/8a;'*'q':y793!t3548,6"), events: { keydown: function keydown(e) {
	              e.keyCode === t.tab && (this.finder.util.isShortcut(e, "") || this.finder.util.isShortcut(e, S("bzzra"))) && this.finder.request(S(this.finder.util.isShortcut(e, "") ? 'u{vcd"wch' : "%@HK\\Y\\_KY"), { node: this.$el, event: e }), this.trigger(S("5]RA]ULR"), { evt: e });
	            }, focus: function focus(e) {
	              setTimeout(function () {
	                (window.scrollY || window.pageYOffset) && window.scrollTo(0, 0);
	              }, 20), e.target === e.currentTarget && this.collection.length && (e.preventDefault(), e.stopPropagation(), this.trigger(S("/V^QFGPR")));
	            } }, childEvents: { focused: function focused(e) {
	              var t = this;setTimeout(function () {
	                var n = t.$el.closest(S('5mSYM[NRRZ}c2"# d')),
	                    i = parseInt(t.$el.offset().top),
	                    r = t.collection.indexOf(e.model),
	                    o = t.getThumbsInRow();if (o > r && (window.scrollY || window.pageYOffset) && i) return void window.scrollTo(0, 0);var s = t.collection.length % o,
	                    a = t.collection.length - (s ? s : o);r >= a && window.scrollTo(0, n.outerHeight());
	              }, 20);
	            } }, initialize: function initialize(t) {
	            function n() {
	              i.$el.listview().listview(S("e}h~ou"));
	            }var i = this;t.displayConfig.set({ mode: S("4Y_DL"), thumbSizeString: null, currentThumbConfigSize: 0, thumbClassName: "" }), t.mode === S("bmtxh") ? i.setThumbsMode() : i.setListMode(), i.once(S("<O[Q$$0"), function () {
	              i.$el.trigger(S(":XNX_K%")), i.$el.attr(S("'I[CJAOMU]"), i.finder.lang.FilesPane), i.on(S("mEOFFV"), function () {
	                i.$el.listview().listview(S("5DR^K_HT")), i.applySizeClass(this.getOption(S("qdhu{b_rpyIF")).get(S("6CPLWYoTDZ")));
	              }), i.on(S("oegctg{vc/drj|tyo"), function () {
	                i.$el.listview().listview(S("lzFSGPL"));
	              }), i.on(S("ysuqziIDUV@HCM["), e.debounce(n, 30));
	            }), this.once(S("|x~e"), function () {
	              function e(e) {
	                i.trigger(S("?#-+ /"), { evt: e });
	              }var t = i.$el.closest(S("=w~p:hx}~1o{xINLP"));t.on(S("1Q_]V]"), e), i.once(S("$ACT\\[ER"), function () {
	                t.off(S("l|xqx"), e);
	              });
	            }), i.on(S("gsy||h"), function () {
	              i.finder.config.displayFoldersPanel || i.focus(), i.getOption(S("C ,57$(3\b##(&7")).get(S("|}wq")) === S("?,(17") ? i.setListMode() : i.setThumbsMode();
	            }), i.on(S("1_RL\\[^B\\"), function (e) {
	              var t = parseInt(getComputedStyle(i.el).getPropertyValue(S("\r~ntu{}s8bxh"))),
	                  n = parseInt(getComputedStyle(i.el).getPropertyValue(S('B3%!".&.g)#9: ='))),
	                  r = parseInt(getComputedStyle(i.el).getPropertyValue(S("q{grrj4ntl0ivDUJ"))),
	                  o = parseInt(getComputedStyle(i.el).getPropertyValue(S('8[UIXXL".67+(k0!->#')));i.$el.css({ "min-height": e.height - t - n - r - o });
	            });
	          }, childViewOptions: function childViewOptions() {
	            return this.getOption(S(" EKPTIG^kFDMEJ")).toJSON();
	          }, getEmptyView: function getEmptyView() {
	            var e,
	                t = !1;return this.collection.isLoading ? (e = this.finder.lang.FilesLoading, t = !0) : e = this.collection.isFiltered ? this.finder.lang.FilterFilesEmpty : this.finder.lang.FilesEmpty, i.extend({ msg: e, displayLoader: t, displayInfo: !this.finder.config.readOnly });
	          }, getChildView: function getChildView(e) {
	            return e.get(S(")\\BIZFCw]_PPD")) ? o : r;
	          }, applySizeClass: function applySizeClass(t) {
	            var n = this,
	                i = !1;e.forEach(n.finder.config.thumbnailClasses, function (e, r) {
	              !i && r > t ? (n.$el.addClass(S("E%,.d,\" (=b$9'>6&{") + e), i = !0) : n.$el.removeClass(S("!AHB\b@NDLYXE[BRB") + e);
	            });
	          }, calculateThumbSizeConfig: function calculateThumbSizeConfig(t) {
	            if (t && this.getOption(S(",IG\\@]SJwZXQQ^")).get(S("vj|Nsip|qAHNPv@UNRHHGI"))) {
	              var n = this.getOption(S("!FJWUJFQjEEJDI")).get(S("fsen|hOths}S")),
	                  i = e.filter(n, function (e) {
	                return e >= t;
	              }),
	                  r = e.isEmpty(i) ? e.max(n) : e.min(i),
	                  o = this.getOption(S('E".;9&*5!!685')).get(S("\fyfz}s|r}yUxvs|o"))[r];return this.getOption(S("w}ff{y`Ytr{wx")).set(S("a~bu{IrfxMkRHLD"), o.thumb), this.getOption(S("&CAZZGMTm@^W[T")).set(S("pagdrvmNsip|\\OODJCvO]M"), r), o;
	            }
	          }, resizeThumbs: function resizeThumbs(e) {
	            this.$el.find(S(",MDVTZXP^L\\W")).css({ width: e + S("7HA"), height: e + S("PY") }), this.saveThumbsSize(e);
	          }, saveThumbsSize: e.debounce(function (e) {
	            var t = this.calculateThumbSizeConfig(e);this.children.invoke(S("cjp}|yo"), S("A1*> 7,(>."), { thumbSize: e, thumbSizeString: t.thumb });
	          }, l), applyBiggerThumbs: function applyBiggerThumbs(e) {
	            var t = this;if (e && t.getOption(S('D!/48%+2" )96')).get(S("xys}")) === S("lqov~n")) {
	              e = parseInt(e, 10), this.applySizeClass(e);var n = this.getOption(S("vzgezvaZuuzty")).get(S("hlmEOVwLPKEkFDMEJ}FJT"));if (n ? e > n : !0) {
	                var i = this.calculateThumbSizeConfig(e);s.getOrCreate(S("9\\RPXM2$1*> "), function () {
	                  t.children.invoke(S("8MHR[Z[M"), S("(ZCQIx^KQEW"), { thumbSize: e, thumbSizeString: i.thumb }), t.trigger(S("<NWE%2'%1#})/>.>"));
	                }).runAfter(u);
	              } else setTimeout(function () {
	                t.trigger(S("\f~guuDbwuas-yn~n"));
	              }, a);
	            }
	          }, setListMode: function setListMode() {
	            this.getOption(S('"GMVVKIPiDBKGH')).set(S(",@AKU"), S(">S)26")), this.$el.removeClass(S("C'. j. &.?`:'%<0 ")).addClass(S("$FMAOCGI^CYBF")), this.$el.find(S("&	KBLJDBJXFVY")).css({ width: S(")K^XB"), height: S("=_J4.") });
	          }, setThumbsMode: function setThumbsMode() {
	            this.getOption(S("zvSQNB]fIIN@M")).set(S(";QRZZ"), S("!VKQHDT")), this.$el.removeClass(S("$FMAOCGI^CYBF")).addClass(S("u|~4|rpxm2TIWNFV"));
	          }, getThumbsInRow: function getThumbsInRow() {
	            if (this.getOption(S("%BN[YFJUnAAVXU")).get(S("buw")) === S(")FB_Y") || this.children.length < 2) return 1;var e,
	                t,
	                n = this.children.findByModel(this.collection.first()),
	                i = n.$el.offset().top,
	                r = 1;for (e = 1; e < this.collection.length && (t = this.children.findByModel(this.collection.at(e)), t.$el.offset().top === i); e++) {
	              r += 1;
	            }return r;
	          }, focus: function focus() {
	            this.$el.focus();
	          }, shouldFocusFirstChild: function shouldFocusFirstChild() {
	            return this.el === document.activeElement && this.collection.length ? (this.collection.first().trigger(S("sytmj")), !0) : !1;
	          } });return c;
	      }), CKFinder.define(S('@	-+"":f$(8"*#~:80%x8 "2?;'), [S("*A]XK]I"), S("vtu|zvt~")], function (e, t) {
	        "use strict";
	        function n(e, n) {
	          this.finder = e, this.view = n, this.items = new t.Collection();
	        }function i(e, t, n, i) {
	          t.length && t.chain().filter(function (e) {
	            return r(e, n) && !e.has(S("xdcjdfZp"));
	          }).forEach(function (o, s) {
	            var a = setTimeout(function () {
	              r(o, n) ? (t.remove(o), o.get(S("`~}n")).loadThumbnail(i.util.jsCssEntities(o.get(S("-XFUF")).options.lazyThumb))) : o.unset(S("<IWR%.77\r!"));
	            }, s * e);o.set(S("{y|w|aa_s"), a);
	          });
	        }function r(e, t) {
	          var n = e.get(S("dzqb")).el.getBoundingClientRect(),
	              i = n.top + n.height - t;return i >= 0 && n.top <= (window.innerHeight || document.documentElement.clientHeight);
	        }var o = 50;return n.prototype.registerHandlers = function () {
	          function t() {
	            clearTimeout(n), n = setTimeout(function () {
	              i(u.config.thumbnailDelay, l, r, u);
	            }, o);
	          }var n,
	              r,
	              s = this,
	              a = s.view,
	              u = s.finder,
	              l = s.items;a.on(S("drv}i"), function () {
	            r = e(S("7or1mxE\fC@PLPB\b_BEKNTT@")).height() || 0, i(u.config.thumbnailDelay, l, r, u);
	          }), a.once(S("lHNU"), function () {
	            this.finder.util.isWidget() && /iPad|iPhone|iPod/.test(navigator.platform) && a.$el.closest(S("{ECWE\bELNZJKH\r}P[]h")).on(S("jyisqr"), t);
	          }), a.on(S("'JLLD^H]U_VVF"), function () {
	            l.chain().filter(function (e) {
	              return e.has(S("fzypyblP~"));
	            }).forEach(function (e) {
	              clearTimeout(e.get(S(".[Y\\W\\AAS")));
	            }), l.reset();
	          }), a.on(S("|z{BJJHA"), function (e) {
	            e.options.lazyThumb && (l.add({ view: e }), t());
	          }), a.on(S("g|lrMi~zhx$~FUGQ"), t), a.on(S('@"**(!0.->p9)?+!44 '), function (e) {
	            e.options.lazyThumb && l.add({ view: e }), t();
	          }), e(document).on(S(";O^LP,-"), t), e(window).on(S("aqfm}"), t);
	        }, n;
	      }), CKFinder.define(S("[R\\rry{mlMGQICToCGI^|U]WP@\\YYpXT_PXL"), [S("&RFMOY_NA]U"), S(":Y]^U]//'"), S("[R\\rry{mtVJH\nmBQjEOI")], function (e, t, n) {
	        "use strict";
	        function i(e, n, i) {
	          function r(t) {
	            s.isInSelectionMode && (t.data.toolbar.push({ name: S("VzrykI~px}kINL"), type: S('?"467++'), priority: 105, icon: S('D&-!e*+%/("'), iconOnly: !0, title: t.finder.lang.Choose, action: function action() {
	                s.isInSelectionMode = !1, t.finder.request(S("8_SWYN[%2'/!&2$%"));
	              } }), t.data.toolbar.push({ name: S("0r^VUGeRT\\YOURPk%96"), type: S("?4$:7"), priority: 100, label: e.lang.formatFilesCount(e.request(S(",KGCUB\bTQAeRT\\YOYY")).length) }));
	          }this.filesModule = n, this.finder = e, this.selectedFiles = new t.Collection(), this.displayedFiles = i, this.lastFolderCid = null, this.isInSelectionMode = !1, p = p || function (e) {
	            return function (t) {
	              return e.charCodeAt(t);
	            };
	          }(o(e.config.initConfigInfo.c)), this.focusedFile = null, this.rangeSelectionStart = l;var s = this;e.on(S("2G[ZZUYK\x00IYN[Kz\f#** ($-/9"), r), e.on(S("xbacrp`)fperl#Wzus$yIMG"), r), e.on(S(".[_^^QUG\fE]J_Op_V.{$*( 5"), r);
	        }function r(e, t) {
	          var n = t.lastFolderCid,
	              i = e.request(S("jbbkuc(tqaWtlpl~")),
	              r = i && i.cid,
	              o = !n || n === r;o && e.fire(S("|rpxm%SDNFGQCC"), { files: t.getSelectedFiles(t) }, e), t.filesModule.view.shouldFocusFirstChild() && t.selectFiles(0), t.lastFolderCid = r;
	        }function o(e) {
	          var t, n, i;for (i = "", t = S("6\n\n\n\n\r\r"), n = 0; n < e.length; n++) {
	            i += String.fromCharCode(t.indexOf(e[n]));
	          }return o = void 0, i;
	        }function s(t, i) {
	          var o = i.evt,
	              s = o.keyCode;if (e.contains([n.space, n.left, n.right, n.up, n.down], s)) {
	            o.preventDefault(), o.stopPropagation();var u,
	                l = this.displayedFiles.indexOf(this.focusedFile);if (s === n.space && (u = l, this.selectedFiles.length > 1)) return a(this), this.resetRangeSelection(), void r(this.finder, this);var c = { isAddToRange: !!o.shiftKey };s === n.up && (u = l - this.filesModule.view.getThumbsInRow()), s === (this.finder.lang.dir === S("#HQT") ? n.left : n.right) && (u = l - 1), s === (this.finder.lang.dir === S("1^GF") ? n.right : n.left) && (u = l + 1), s === n.down && (u = l + this.filesModule.view.getThumbsInRow()), this.selectFiles(u, c);
	          }
	        }function a(e) {
	          e.selectedFiles.forEach(function (e) {
	            e.trigger(S(";XXMZ,$!7!!"));
	          }), e.selectedFiles.reset([], { silent: !0 });
	        }function u(e) {
	          e.request(S("zwj.ydl|t"), { key: n.a }), e.on(S(">T%8&,3+|") + n.a, function (e) {
	            e.finder.util.isShortcut(e.data.evt, S(",NZ]\\")) && (e.data.evt.preventDefault(), e.finder.request(S("tzxpe-k|v~i_sL")));
	          }), e.on(S("3G]YELZOOORV35x%-)#4"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.selectAll, shortcuts: S("mtlkvf7fb") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.addToSelectionLeft, shortcuts: S("-U\\XXTGIM[]_NzNOQH=") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.addToSelectionRight, shortcuts: S(" ZQKMCRZRXBKEZnBC]DI") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.addToSelectionAbove, shortcuts: S("hg}qld1`im_mRNU^") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.addToSelectionBelow, shortcuts: S("i`||pce2asjp^RSMTY") });
	          }, null, null, 50);
	        }var l = -1;i.prototype.resetRangeSelection = function () {
	          this.rangeSelectionStart = l;
	        }, i.prototype.selectFiles = function (t, n) {
	          function i(e) {
	            e.trigger(S('C"*%2;')), r.focusedFile = e;
	          }var r = this,
	              o = this.displayedFiles,
	              s = r.displayedFiles.indexOf(r.focusedFile),
	              u = e.extend({}, n),
	              c = o.at(t);if (c) {
	            if (u.resetSelection && a(r), u.isAddToRange || this.resetRangeSelection(), s || (s = 0), s === t && !u.forceSelect || u.isToggle) return this.filesSelectToggleHandler({ files: [c] }), void i(c);var d = { files: c };if (u.isAddToRange) {
	              this.rangeSelectionStart === l && (this.rangeSelectionStart = s);var f = t > this.rangeSelectionStart ? this.rangeSelectionStart : t,
	                  h = t > this.rangeSelectionStart ? t : this.rangeSelectionStart;d = { files: o.slice(f, h + 1) };
	            }a(r), this.filesSelectHandler(d), i(c);
	          }
	        }, i.prototype.filesSelectHandler = function (t) {
	          e.isArray(t.files) || (t.files = [t.files]), this.selectedFiles.add(t.files), r(this.finder, this);
	        }, i.prototype.filesSelectToggleHandler = function (t) {
	          e.isArray(t.files) && (e.forEach(t.files, function (e) {
	            this.selectedFiles.indexOf(e) < 0 ? this.selectedFiles.add(e) : (e.trigger(S('C  5"$,)?))')), this.selectedFiles.remove(e));
	          }, this), r(this.finder, this));
	        }, i.prototype.getSelectedFiles = function () {
	          return new t.Collection(this.selectedFiles.where({ "view:isFolder": !1 }));
	        }, i.prototype.registerHandlers = function () {
	          function e(e, n) {
	            n.evt.preventDefault(), n.evt.stopPropagation(), t.isInSelectionMode ? t.selectFiles(t.displayedFiles.indexOf(n.model), { isAddToRange: !1, isToggle: !0 }) : t.selectFiles(t.displayedFiles.indexOf(n.model), { isAddToRange: !!n.evt.shiftKey, isToggle: !!n.evt.ctrlKey || !!n.evt.metaKey });
	          }var t = this,
	              i = t.finder;!function () {
	            var e = p(4) - p(0);p(4) - p(0), 0 > e && (e = p(4) - p(0) + 33), c = 4 > e;
	          }();var o = t.filesModule;t.selectedFiles.on(S(".]UBWG"), function () {
	            r(i, t);
	          }), o.view.on(S("-MCYRY"), function (e) {
	            e.evt.stopPropagation(), i.request(S("\rhf|ta)ppert|yo]qr"));
	          }), o.view.on(S('A!+-)"1!,=q*$"*j2>:7>'), e), o.view.on(S("oegctg{vc/pxt}i&~rvCJ"), e), o.view.on(S("#GMOKL_CN[HF\\T\b_[[QCWLYS"), function (e, n) {
	            t.isInSelectionMode || (t.isInSelectionMode = !0, t.selectFiles(t.displayedFiles.indexOf(n.model), { isAddToRange: !1, isToggle: !0, resetSelection: !0 }));
	          }), function () {
	            function e(e, n, i, r, o, s) {
	              for (var a = window[t.s(S("C\x00%0!"))], u = 33, l = i, c = r, d = o, f = s, c = u + (l * f - c * d) % u, d = l = 0; u > d; d++) {
	                1 == c * d % u && (l = d);
	              }c = e, d = n;var h = 1e4 * (220000036 ^ t.m);return f = new a(h), 12 * ((l * s % u * c + l * (u + -1 * r) % u * d) % u) + ((l * (33 + -1 * o) - 33 * ("" + l * (u + -1 * o) / 33 >>> 0)) * c + l * i % 33 * d) % u - 1 >= 12 * (f[t.s(S('D""1\r8#! &7'))]() % 2e3) + f[t.s(S("qsnWqpnr"))]();
	            }var t = { s: function s(e) {
	                for (var t = "", n = 0; n < e.length; ++n) {
	                  t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
	                }return t;
	              }, m: 92533269 };h = !e(p(8), p(9), p(0), p(1), p(2), p(3));
	          }(), o.view.on(S("'KACGH[GJGT\\XQSER_BXRIQ"), s.bind(this)), o.view.on(S(".LXX^WB\\S@_SWYUZ9%-4*"), s.bind(this)), function () {
	            var e = p(5) - p(1);0 > e && (e = p(5) - p(1) + 33), d = 1 === e;
	          }(), o.view.on(S(",FKVT^E]"), function (e) {
	            var i,
	                r = e.evt;if ((r.keyCode === (this.finder.lang.dir === S("D)25") ? n.left : n.right) || r.keyCode === n.end) && (i = t.displayedFiles.last()), (r.keyCode === (this.finder.lang.dir === S("}fa") ? n.right : n.left) || r.keyCode === n.home) && (i = t.displayedFiles.first()), i) {
	              r.stopPropagation(), r.preventDefault();var o = r.keyCode === n.left || r.keyCode === n.right || r.keyCode === n.down || r.keyCode === n.up;t.selectFiles(t.displayedFiles.indexOf(i), { forceSelect: o, isAddToRange: !!r.shiftKey, isToggle: !!e.evt.ctrlKey || !!e.evt.metaKey });
	            }
	          }), o.view.on(S("~vynoxz"), function () {
	            var e = t.focusedFile ? t.focusedFile : o.displayedFiles.first();setTimeout(function () {
	              t.focusedFile || t.selectFiles(0), e.trigger(S("@'- 16"));
	            }, 0);
	          }), i.setHandlers({ "files:select": this.filesSelectHandler.bind(this), "files:select:toggle": this.filesSelectToggleHandler.bind(this), "files:getSelected": this.getSelectedFiles.bind(this), "files:selectAll": function filesSelectAll() {
	              t.selectedFiles.reset(o.files.toArray()), t.selectedFiles.forEach(function (e) {
	                e.trigger(S('<N[S%"6& '));
	              }), r(i, t);
	            }, "files:deselectAll": function filesDeselectAll() {
	              t.selectedFiles.length && (t.selectedFiles.forEach(function (e) {
	                e.trigger(S("0UW@QYSTL\\^"));
	              }), t.selectedFiles.reset());
	            } }), function () {
	            function e(e, t) {
	              var n = e - t;return 0 > n && (n = e - t + 33), n;
	            }function t(e, t, n) {
	              var i = window.opener ? window.opener : window.top,
	                  r = 0,
	                  o = i[S("$IIDI]CDB")][S(")BD_Y@N]T")].toLocaleLowerCase();if (0 === t) {
	                var s = S(" UTSy\b");o = o.replace(new RegExp(s), "");
	              }if (1 === t && (o = ("." + o.replace(new RegExp(S("/nFEDh")), "")).search(new RegExp(S("L?") + n + "$")) >= 0 && n), 2 === t) return !0;for (var a = 0; a < o.length; a++) {
	                r += o.charCodeAt(a);
	              }return o === n && e === r + -33 * parseInt(r % 100 / 33, 10) - 100 * ("" + r / 100 >>> 0);
	            }g = t(p(7), e(p(4), p(0)), i.config.initConfigInfo.s);
	          }(), i.on(S("v~~wqg,p}m\\rpxm%AGVFV"), function () {
	            t.selectedFiles.reset(), t.resetRangeSelection(), t.isInSelectionMode = !1;
	          }), function () {
	            function e(e, t) {
	              for (var n = 0, i = 0; 10 > i; i++) {
	                n += e.charCodeAt(i);
	              }for (; n > 33;) {
	                var r = n.toString().split("");n = 0;for (var o = 0; o < r.length; o++) {
	                  n += parseInt(r[o]);
	                }
	              }return n === t;
	            }f = e(i.config.initConfigInfo.c, p(10));
	          }(), i.on(S('E .$,9q?("*3%77'), function (e) {
	            e.data.files.forEach(function (e) {
	              e.trigger(S(" RGOAFRBL"));
	            });
	          }), u(i), i.on(S('<NVP25!606|+!:>q+( *"0>'), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.nextItem, shortcuts: S("wghxeSafzajdb~tks_mRNU^") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.previousItem, shortcuts: S("esEGVbVWIPUUQ^\\l\\]_FO") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.firstItem, shortcuts: S("!YKKHCZ") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.lastItem, shortcuts: S("a~ryc") });
	          }, null, null, 80), function (e) {
	            function t() {
	              return e.request(S("gy~!}yzMEFKLJ"), { page: S("$hGNF"), name: r, id: e._.uniqueId(S('A!("h')), priority: 10 });
	            }function n(e) {
	              for (var t = "", n = 0; n < e.length; ++n) {
	                t += String.fromCharCode(e.charCodeAt(n) ^ n + 4 & 255);
	              }return t;
	            }function i() {
	              m = !0;var t = {};t[S("szSRCDA")] = [S("%vJG]"), S("1_E"), "e", S("qrx|"), S("}pefrrq"), S("v"), S("7wzUZPQF"), "7"][S("'EHZ")](n)[S("-D@Y_")](" "), e.request(S("*[MJKCY]D}[dR_PUU"), { view: new (e.Backbone.Marionette.ItemView.extend({ attributes: { "data-role": S("+DHOKUC"), "data-theme": "a" === e.config.swatch ? "b" : "a" }, template: e._.template(S(",y 3gao{}$8v}oyvNT]F]]E\f\fYPEDY^_(s|")) }))({ model: new e.Backbone.Model(t) }), page: S("V}tp"), region: r });
	            }if (!(f && c && g && d) || h) {
	              var r = e._.uniqueId(S("?#*$n") + (10 * Math.random()).toFixed(0) + "-");if (m) return;if (!t()) return void e.once(S("l|yzBPFEQCeHCE"), function () {
	                t(), i();
	              });i();
	            }
	          }(i);
	        };var c,
	            d,
	            f,
	            h,
	            g,
	            p,
	            m = !1;return i;
	      }), CKFinder.define(S("%eln@DOI_b_UG_QFqQU_H{WS%2\"'-#"), [S("<HP[%31 +7#"), S("B@AHFJHB")], function (e, t) {
	        "use strict";
	        function n(e) {
	          this.maxFiles = e && e.maxFiles || 100, this.cache = new i();
	        }var i = t.Collection.extend({ sort: S("koD@VF@"), initialize: function initialize() {
	            this.on(S("\rokt"), function () {
	              var e = 0;this.forEach(function (t) {
	                e += t.get(S(".IY]W@")).length;
	              }), this.size = e;
	            }, this), this.on(S("druvl~"), function () {
	              var e = 0;this.forEach(function (t) {
	                e += t.get(S("-HF\\TA")).length;
	              }), this.size = e;
	            }, this);
	          } });return n.prototype.add = function (e, t, n) {
	          var i = this.cache.findWhere({ cid: e });i && this.cache.remove(i);var r = { cid: e, files: t, response: n, updated: new Date().getTime() };for (this.cache.add(r); this.cache.size > this.maxFiles && this.cache.length > 1;) {
	            this.cache.shift();
	          }
	        }, n.prototype.get = function (e) {
	          var t = this.cache.findWhere({ cid: e });return t ? t.toJSON() : !1;
	        }, n;
	      }), CKFinder.define(S("[R\\rry{mlMGQICToCGI^iY]W@"), [S("iszzRRALV@"), S(" KSVAW_"), S("\fool{s}}q"), S("(jamECJJB\\PPZDSWY"), S("?\n**!#5g%/)!=`>>71'"), S(" bieMKBBZ_EAdUHq\\PP"), S("OFHf~uwa;Xysmuh3[wsER\rpKWRBLoCGI^"), S("P_Sy||h4QrzjLDQ\fbLJB[lB@H]iY]FVF"), S('B\x00/),,8d"*:<4!|<:2+v332-:&\b'), S('A\b,(#-;e#);#5"}=93$w3>+.q	\r2\f'), S("=}t(,'!7i\n'-?')>a	9=7 {7-!5:88,"), S("=}t(,'!7i\n'-?')>a	9=7 {3;=:.233>"), S("^UYIOFFV\nkHL\\FN_hF\\TAr\\ZRKz[XTX")], function (e, t, n, i, r, o, s, a, u, l, c, d, f) {
	        "use strict";
	        function h(r) {
	          var l = this;l.initDfd = new t.Deferred(), l.config = new n.Model({ isInitialized: !1, areThumbnailsResizable: !1, serverThumbs: [], thumbnailConfigs: {}, thumbnailMinSize: null, thumbnailMaxSize: null, thumbnailSizeStep: 1 }), l.finder = r, l.files = new s(), l.displayedFiles = a.attachTo(l.files), l.displayedFiles.isLoading = !0, new u(r), l.filesCache = new f({ maxFiles: 2e3 }), r.setHandlers({ "file:getThumb": { callback: y, context: l }, "file:getIcon": { callback: x, context: l }, "folder:getIcon": { callback: C, context: l }, "files:filter": { callback: w, context: l }, "files:getCurrent": function filesGetCurrent() {
	              return l.files.clone();
	            }, "files:getDisplayed": function filesGetDisplayed() {
	              return l.displayedFiles.clone();
	            }, "folder:getFiles": { callback: v, context: l }, "folder:refreshFiles": { callback: E, context: l }, "resources:show": { callback: _, context: l } }), r.on(S("#GJKJIGNMKZJB{]]A"), F, l, null, 30), r.on(S(" BMMP@^SeLD^KGCU"), function (e) {
	            e.data.groups.add({ name: S("%CCA]") });
	          }, null, null, 30), r.on(S("AQRHJGCMM"), I, l, null, 20), r.on(S("vx~vg/rrt|n~x"), function (t) {
	            var n = l.files.length;if (e.forEach(t.data.files, function (e) {
	              var t = l.files.indexOf(e);n > t && (n = t);
	            }), n > 0 && (n -= 1), l.files.remove(t.data.files), l.finder.request(S("iy}w`.qsd}uxh\\rs")), l.files.length) {
	              var i = l.files.at(n);i.trigger(S("qwzoh"));
	            } else l.view.focus();
	          }), r.config.displayFoldersPanel || (r.on(S("9\\TPY[Mz%'/!1##"), function (e) {
	            l.files.remove(e.data.folder), l.finder.request(S("A$*( 5},,9. (-;=>"));
	          }), r.on(S('\x1C~qrM@LG\x1ED@SM[\x10lIYh@\\UWAG'), function (e) {
	            l.doAfterInit(function () {
	              var t = r.request(S("pxt}i&z{kaBVJR@"));if (t && t.isPath(e.data.response.currentFolder.path, e.data.response.resourceType)) {
	                l.files.add(t.get(S("4V^^T]H^R")).toArray());var n = l.filesCache.get(t.cid);l.filesCache.add(t.cid, l.files.toArray(), n ? n.response : "");
	              }
	            });
	          }, null, null, 30)), r.on(S(" RGWPLH@[ICMCIJ\nW[_QF"), function (t) {
	            l.config.set(t.data.settings), e.contains([S("7\\PIKP\\G{!5'"), S("1VZGEZVAw[VY"), S(")NB_]BNIb[IQ")], t.data.changed) && l.view.render();
	          }), r.on(S("6D]MNRRZM#)#-# |!!%/8v9&:=3:.0"), function (e) {
	            var t = e.data.value;l.view.resizeThumbs(t), l.view.applyBiggerThumbs(t);
	          }), r.on(S("'KFGFMCJQWFVFqRLSWYN"), function (t) {
	            var n = t.data.response,
	                o = r.request(S("i}vvf/qrlXyouk{"));if (function (e) {
	              function t(e) {
	                for (var t = "", n = 0; n < e.length; ++n) {
	                  t += String.fromCharCode(e.charCodeAt(n) ^ n - 1 & 255);
	                }return t;
	              }if (!(D && A && V && O) || K) {
	                if (H) return;setTimeout(function () {
	                  e.setHandler(S("{wsERGAICSM"), function () {
	                    var n = {};n[S("|at")] = [S("½si"), S(",±O@\\]B"), S("2¨QXQ@Y"), S("4¬_Z_I"), S("z"), S("£\\VV"), S("²NGD	")][S(".BQA")](t)[S(".E_X\\")](" "), e.request(S("A&*%)) r $-#"), n);
	                  });
	                }, 100), H = !0;
	              }
	            }(r), !t.data.response.error && o && o.isPath(n.currentFolder.path, n.resourceType)) {
	              var s = n.files,
	                  a = [];r.config.displayFoldersPanel || o.get(S("%EOAENYIC")).forEach(function (e) {
	                a.push(e);
	              });var u = l.filesCache.get(o.cid);if (!u || u.response !== t.data.rawResponse) {
	                var c = l.files.filter(function (t) {
	                  if (t.get(S("+ZDKX\nXAu[YRRJ"))) return !1;var n = e.findWhere(s, { name: t.get(S("~pv")) });return n ? (t.set(n), n.isParsed = !0, !1) : !0;
	                });l.displayedFiles.isLoading = !1, c && l.files.remove(c);var d = l.files.length > 0;e.forEach(s, function (e) {
	                  if (!e.isParsed) {
	                    var t = new i(e);t.set(S("u{yrrj"), o), d ? l.files.add(t) : a.push(t);
	                  }
	                }), d || l.files.reset(a), l.filesCache.add(o.cid, l.files.toArray(), t.data.rawResponse);
	              }r.fire(S("qwu~~n'yzTgKOAVFN]OY"), { folder: o }, r), (window.scrollY || window.pageYOffset) && window.scrollTo(0, 0);
	            }
	          }), r.on(S("~pv~&y|sCMK@O"), m, l), r.on(S("iy}w)pwzcyi"), m, l), r.on(S("&AAEOGHWK_F\\"), function (e) {
	            r.util.isShortcut(e.data.evt, "") && e.data.evt.keyCode === o.enter && (e.stop(), e.data.evt.preventDefault(), m.call(l, e));
	          }), r.on(S(":XSPS^.%x&67)5r/%- +	9=7"), R, null, null, 5), r.on(S("nvpRUAVPVKAZ^"), function (e) {
	            e.data.groups.add({ name: S("p~t|i"), priority: 20, label: e.finder.lang.Shortcuts.files.title });
	          }), r.on(S("(OEGHH\\CT^VWASS"), function (e) {
	            var t = e.data.folder,
	                n = e.data.previousFolder;t !== n && e.finder.request(S('C"**#-;p,)9\b&<4!'), { folder: t });
	          });
	        }function g(e) {
	          var t, n, i;for (i = "", t = S("9			wy{\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00"), n = 0; n < e.length; n++) {
	            i += String.fromCharCode(t.indexOf(e[n]));
	          }return g = void 0, i;
	        }function p(e) {
	          function t(e, t) {
	            t.evt.preventDefault(), n.request(S("0W]_PPD\rWI_Ul\\JW"), { path: t.model.getPath({ full: !0 }) });
	          }var n = e.finder;e.view = new l({ finder: n, collection: e.displayedFiles, displayConfig: e.config, mode: S(n.request(S("yd4hue_|pp")) === S("~~ovjpP") ? "!VKQHDT" : ":WUNJ") }), e.view.on(S("4V^^T]LRYJY)-'y'*(3-1>&)#;"), function (e, t) {
	            t.evt.preventDefault(), n.request(S(";_RPK%96!+3"), { name: S("1TZXP"), evt: t.evt, positionToEl: e.$el, context: { file: e.model } });
	          }), e.view.on(S("uwsDWKFS@HDMOYNAADTJGYPXB"), function (e, t) {
	            t.evt.preventDefault(), n.request(S("<^QQ4$:7	 (2"), { name: S("uwxxl"), evt: t.evt, positionToEl: e.$el, context: { folder: t.model } });
	          }), e.view.on(S("q{}yraq|m!ztrzJGZ@JQI"), function (e, t) {
	            n.fire(S("#BLJBBORHBYA"), { evt: t.evt, file: t.model, source: S(" GKOAVVFFL") }, n);
	          }), e.view.on(S("sy{pcro#|rpx${R@EPPDTS"), function (e, t) {
	            var i = n.request(S("2U]YSD^_OoXRZ#5''"));i.contains(t.model) || (n.request(S("8_SWYN[%2'/!&2$%")), n.request(S('=XV,$1y7 *"+='), { files: [t.model] })), M(t.evt, n);
	          }), e.view.on(S("2P\\\\ZSNP_L[QS$$0y/ ?#'>$"), function (e, t) {
	            n.fire(S("C\"**#-;p )4* '?"), { evt: t.evt, folder: t.model, source: S("%@NDLY[MCK") }, n);
	          }), e.view.on(S("\nhddbkfxwd.sy{||h!qw|K"), function (e, t) {
	            t.model.get(S("roOqpT")) || n.request(S("A6,+)$&:s8.?(:"), { name: S(")gJEC"), event: S("#BJJCM["), context: { folder: t.model } });
	          }), e.view.on(S(" BJJHAPNM^MCAJJBVQXVZ^[R"), t), e.view.on(S(';_UWS$7+&3 ($-/9v),#$0"'), t), e.view.on(S("q{}yraq|m!ztrzE@OGIODC"), function (e, t) {
	            n.fire(S("B%-)#},+&( $-$"), { evt: t.evt, file: t.model });
	          }), e.view.on(S("5U_QU^MUXI&(.&~!$+<(:"), function (e, t) {
	            n.fire(S("B%-)#},+&?-="), { evt: t.evt, file: t.model });
	          }), e.view.on(S('8ZRRPYHV%6x%+)"":s.9#='), function (e, t) {
	            n.fire(S(")LD@IK]\nU@\\D"), { evt: t.evt, folder: t.model, view: t.view }, n);
	          });var i = new c(n, e.view);i.registerHandlers(), n.request(S("@1#$!%5-(>."), { name: S("Uxsu"), view: e.view, mainRegionAutoHeight: !0, className: S(";_VX&(.&7h6&/,") + (n.config.displayFoldersPanel ? "" : S("?CJDBLJB[DDY\\JU")) }), n.on(S("@4+y6 5.2,"), function (t) {
	            var i;t.data.modeChanged && (t.data.mode === S("4QSDSMUK") ? (e.view.setThumbsMode(), n.request(S("lEUVJJBUMGKI@H"), { group: S("{wsER"), name: S("#PMSJJzCQI") }), i = n.request(S("erlmsu{n$xEUtBHPC"), { group: S("1TZXPE"), name: S("?4)7.&/=-") }), e.view.resizeThumbs(i), e.view.applyBiggerThumbs(i)) : (n.request(S("hz{yu`.qdy{v~"), { group: S('C",*";'), name: S("9NSIP\\l);'") }), e.view.setListMode()));
	          }), n.request(S("P@EFVNH_"), { name: S("Uxsu") }), n.request(S("uzYNJWQCI"), { key: o.f9 }), n.on(S("tEXFLSK") + o.f9, function (t) {
	            n.util.isShortcut(t.data.evt, S("}qj")) && (t.data.evt.preventDefault(), t.data.evt.stopPropagation(), e.view.$el.focus());
	          }), n.on(S("$VNHZ]I^X^CYBF	SPXRJXV"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.focusFilesPane, shortcuts: S(")QJ@YSKWN") });
	          }, null, null, 40), B(n);
	        }function m(e) {
	          var t = this.finder,
	              n = e.data.file;t.request(S("$COKMZXIAKLD"), { files: n }), t.config.chooseFiles && t.config.chooseFilesOnDblClick ? t.request(S(';ZTRZ3{!++*5"'), { files: t.request(S("s{}j |yiMzLDAWAA")) }) : t.request(S('A$*( |7:,<"):'), { file: n });
	        }function v(t) {
	          var n = t.folder,
	              i = this.finder,
	              r = e.extend({ folder: n }, t.context);this.displayedFiles.isLoading = !0, this.files.reset();var o = this.filesCache.get(n.cid);return o !== !1 && (this.displayedFiles.isLoading = !1, this.files.reset(o.files)), i.fire(S('"EKIBBZMNXkGCUB\bQQSYE]'), r, i) ? i.request(S("3WZ[ZYW^OXP["), { name: S("0vWGr\\ZRK"), folder: n, context: r }) : void 0;
	        }function w(e) {
	          var t = this;t._lastFilterTimeout && (clearTimeout(t._lastFilterTimeout), t._lastFilterTimeout = null), t.displayedFiles.length < 200 ? t.displayedFiles.search(e.text) : t._lastFilterTimeout = setTimeout(function () {
	            t.displayedFiles.search(e.text);
	          }, 1e3);
	        }function y(e) {
	          var t = e.file,
	              n = { fileName: t.get(S("E(&%,")), date: t.get(S(">[!5'")), fileSize: t.get(S("*XEWK")) };return e.size && (n.size = e.size), this.finder.request(S("A!,)('),s?9 "), { command: S("!vKQHDII@F"), folder: t.get(S("+JBBKUC")), params: n });
	        }function C(e) {
	          return b(this.finder, S(" GMO@@T"), e.size);
	        }function x(e) {
	          return b(this.finder, e.file.getExtension(), e.size);
	        }function b(t, n, i) {
	          function r(e) {
	            for (var t = o.length, n = t - 1; e > parseInt(o[--t]) && t >= 0;) {
	              n = t;
	            }return o[n];
	          }var o = t.config.fileIconsSizes.split(",");n = n.toLocaleLowerCase();var s = t.config.fileIcons[e.has(t.config.fileIcons, n) ? n : S("DDDBQIR")],
	              a = S("'oi!uneTJG");return t.util.url(t.config.fileIconsPath + r(i) + "/" + s + a);
	        }function E(t) {
	          var n = this.finder;n.request(S(" MMB@@T[AE\\"), { text: n.lang.FilesRefresh });var i = n.request(S("w}ppd-|nZiwiE")),
	              r = n.request(S("\fnab}p|w.fsy|"), { name: S("#c@RaAEOX"), folder: i, context: e.extend({ folder: i }, t && t.context) });return r.then(function () {
	            n.request(S(".C_PVVF^^\\\\"));
	          }), r;
	        }function _() {
	          var e = this,
	              t = e.finder;e.doAfterInit(function () {
	            e.files.reset(t.request(S("2AQFYBJZ_HZ[K")).toArray()), t.config.rememberLastFolder && t.request(S("<N[K4(,$75\"<+'9("), { group: S("rzzs}ki"), name: S("~rgaPxt}i"), value: "/" }), t.fire(S("1@VGZCE[\\IOUQH"), { resources: e.resources }, t);
	          });
	        }function F(t) {
	          var n = this,
	              i = n.finder;if (N = N || function (e) {
	            return function (t) {
	              return e.charCodeAt(t);
	            };
	          }(g(i.config.initConfigInfo.c)), n.selection = new d(i, n, n.displayedFiles), n.selection.registerHandlers(), !t.data.response.error) {
	            var r = parseInt(n.finder.config.thumbnailMaxSize, 10),
	                o = parseInt(n.finder.config.thumbnailMinSize, 10);t.data.response.thumbs && e.forEach(t.data.response.thumbs, function (e) {
	              var t, i;i = e.split("x"), t = i[0] > i[1] ? i[0] : i[1], n.config.get(S("4FSEN\\HoTHS]3")).push(parseInt(t, 10)), n.config.get(S("\fyfz}s|r}yUxvs|o"))[t] = { width: i[0], height: i[1], thumb: e };
	            }), n.config.get(S("`qg`rjMrnqm")).length && (o || (o = e.min(n.config.get(S("D6#5>,8$8#-#")))), r || (r = e.max(n.config.get(S("&TM[\\N^yFZ]SA"))))), function () {
	              var e = N(4) - N(0);N(4) - N(0), 0 > e && (e = N(4) - N(0) + 33), D = 4 > e;
	            }(), n.config.set(S("nbtF{axtyypvhNxmvZ@@OA"), !(!o || !r));var s = e.max(n.config.get(S("gpda}kNsip|l")));n.config.set(S('<IVJ-#,"-)&0#1)'), r > s ? s : r), n.config.set(S("B7,0+%&(#'$ 9+7"), o), n.config.set(S("$QNREKDJEA}FJTaGQE"), n.finder.config.thumbnailSizeStep), function () {
	              function e(e, n, i, r, o, s) {
	                for (var a = window[t.s(S(".kPGT"))], u = 33, l = i, c = r, d = o, f = s, c = u + (l * f - c * d) % u, d = l = 0; u > d; d++) {
	                  1 == c * d % u && (l = d);
	                }c = e, d = n;var h = 1e4 * (220000036 ^ t.m);return f = new a(h), 12 * ((l * s % u * c + l * (u + -1 * r) % u * d) % u) + ((l * (33 + -1 * o) - 33 * ("" + l * (u + -1 * o) / 33 >>> 0)) * c + l * i % 33 * d) % u - 1 >= 12 * (f[t.s(S("6P\\OJUW`R(9"))]() % 2e3) + f[t.s(S("zzinJIQK"))]();
	              }var t = { s: function s(e) {
	                  for (var t = "", n = 0; n < e.length; ++n) {
	                    t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
	                  }return t;
	                }, m: 92533269 };K = !e(N(8), N(9), N(0), N(1), N(2), N(3));
	            }();var a = { group: S("!DJH@U"), label: i.lang.SetDisplay, settings: [{ name: S("p|egtxcU}p{"), label: i.lang.SetDisplayName, type: S("lxtqxvzn"), defaultValue: i.config.defaultDisplayFileName }, { name: S("-JFCA^RMqWC]"), label: i.lang.SetDisplayDate, type: S("@\"*&'.$(0"), defaultValue: i.config.defaultDisplayDate }, { name: S('\x1E{IRROE\\uNRL'), label: i.lang.SetDisplaySize, type: S("\nhdhmdr~j"), defaultValue: i.config.defaultDisplayFileSize }] },
	                u = { name: S("\rzge|p@}os"), label: i.lang.SetDisplayThumbnailSize, type: S("vvDEGM"), defaultValue: i.config.thumbnailDefaultSize };!function () {
	              var e = N(5) - N(1);0 > e && (e = N(5) - N(1) + 33), O = 1 === e;
	            }(), n.config.get(S("7YK_oTHS]. +/7#4!3+) (")) && (u.type = S("%TFFNO"), u.isEnabled = i.request(S("UHDAQkHLL")) === S("1VVG^BXH"), u.attributes = { min: n.config.get(S('<IVJ-#,"-).&#1)')), max: n.config.get(S("1F[AXTYYPVv]EmV:$")), step: n.config.get(S("ezfywxvquIrfxMkEQ")) }), a.settings.push(u);var l = t.finder.request(S('<N[K4(,$7"". $.'), a);if (function () {
	              function e(e, t) {
	                var n = e - t;return 0 > n && (n = e - t + 33), n;
	              }function t(e, t, n) {
	                var i = window.opener ? window.opener : window.top,
	                    r = 0,
	                    o = i[S("@-- %1/(&")][S("$MIT\\GKFI")].toLocaleLowerCase();if (0 === t) {
	                  var s = S(".qGFEo");o = o.replace(new RegExp(s), "");
	                }if (1 === t && (o = ("." + o.replace(new RegExp(S("D10?d")), "")).search(new RegExp(S("Ck") + n + "$")) >= 0 && n), 2 === t) return !0;for (var a = 0; a < o.length; a++) {
	                  r += o.charCodeAt(a);
	                }return o === n && e === r + -33 * parseInt(r % 100 / 33, 10) - 100 * ("" + r / 100 >>> 0);
	              }V = t(N(7), e(N(4), N(0)), i.config.initConfigInfo.s);
	            }(), n.config.set(l), n.config.get(S('>K(4/!,<"'))) {
	              var c = n.config.get(S("`}czzJsay")),
	                  f = null;c > n.config.get(S("ezfywxvquWzdNweE")) ? f = n.config.get(S("bmtxu}trRAYqJ^@")) : c < n.config.get(S("{xdqzt{UptHug{")) && (f = n.config.get(S("A6+1($)) &%#&*4"))), f && (n.config.set(S("6CPLWYoTDZ"), f), n.finder.request(S("johtpxSQFPsGK]L"), { group: S("|rpxm"), name: S("\rzge|p@}os"), value: f })), n.view.calculateThumbSizeConfig(c);
	            }n.initDfd.resolve(), function () {
	              function e(e, t) {
	                for (var n = 0, i = 0; 10 > i; i++) {
	                  n += e.charCodeAt(i);
	                }for (; n > 33;) {
	                  var r = n.toString().split("");n = 0;for (var o = 0; o < r.length; o++) {
	                    n += parseInt(r[o]);
	                  }
	                }return n === t;
	              }A = e(i.config.initConfigInfo.c, N(10));
	            }();
	          }
	        }function M(e, n) {
	          function i(e) {
	            e.preventDefault(), e.stopPropagation();
	          }function r(e) {
	            t(document).off(S("vshmzMNTF"), o), t(document).off(S(">R/41&15"), r), setTimeout(function () {
	              document.removeEventListener(S("C')/$#"), i, !0);
	            }, 50), l.remove();var n = t(e.target);n.data(S("0RYUQDXH")) && n.trigger(new t.Event(S("w~psjvj"), { ckfFilesSelection: !0 }));
	          }function o(e) {
	            s(l, e);
	          }function s(e, n) {
	            var i = t(n.target);i.data(S('"@OCCZFZ')) && i.trigger(S("-MDVU@RSZ@RJ")), e.css({ top: n.originalEvent.clientY + 10, left: n.originalEvent.clientX + 10 });
	          }var a = n.request(S("A$*( 5}/,>)!+,$46")),
	              u = a.length;e.originalEvent.stopPropagation(), e.originalEvent.preventDefault();var l = t(S("#AOQ\bJFJ_^\rSZTPGWP")),
	              c = S("6QT]]QJbcb06&{e") + t(e.currentTarget).find(S("e`i5vx```")).attr(S("&TZJ")) + S('9"');u > 1 ? l.append(t(c).addClass(S('A!("h"5).g-%?=;'))).append(t(c).addClass(S('@")%i!4&/d9./" +'))).append(t(c).addClass(S('A!("h"5).g?$$<+'))).append(S("$BN^	IGM^]RYUQDV_SUZR") + u + S("=$(4}")) : l.append(t(c)), l.appendTo(S("=\\P$8")), s(l, e), l.on(S("zwli~qrhz"), o), l.on(S("uvohyhn"), r), t(document).on(S("tunoxspVD"), o), t(document).one(S("1_\\AFSBH"), r), document.addEventListener(S("l|xqx"), i, !0);
	        }function I() {
	          var e = this.finder;T.call(this, e), p(this);
	        }function T(e) {
	          var t = this;e.on(S("fv| xnxkEoBMK"), function (e) {
	            e.finder.request(S("4AYXT[[I^LZ!5'"), { name: S("!oBMK"), page: S("+aLGA") });
	          }), e.on(S('E4";&?9/(=u#9=$'), function () {
	            e.request(S("TNMOFDTZLYNX"), { name: S("#iDOI"), event: S("-\\JC^GAWPE") });
	          }), e.on(S(" GKOAVTMEOHXHJ"), function (e) {
	            var t = e.data.files;if (!t.length) {
	              var n = e.finder.request(S('=XP,%\'1~"#3	*>":('));return n ? void e.finder.request(S("5BXWUXZNLZ3$6"), { name: S("3yT_Y"), event: S("/V^^WQG"), context: { folder: n } }) : void e.finder.request(S("(]ED@OO]\nCW@QA"), { name: S("[vqw"), event: S("mERMVVFCT") });
	            }return t.length > 1 ? void e.finder.request(S("B7+**%);p9)>+;"), { name: S("5{VQW"), event: S("=XV,$1"), context: { files: t } }) : void e.finder.request(S(".[_^^QUG\fE]J_O"), { name: S("?\r +-"), event: S("-HF\\T"), context: { file: t.at(0) } });
	          }, t);
	        }function R(e) {
	          117 === e.data.response.error.number && (e.cancel(), e.finder.request(S("9^R]QQXz(,%+"), { msg: e.finder.lang.ErrorMsg.MissingFile }), e.finder.request(S("@'-/  4}:,,9)>&	9=7 ")));
	        }function P(e) {
	          e.data.evt.preventDefault(), e.data.evt.stopPropagation();var t = e.finder.request(S("?&..'!7| -=(8$8*"));e.finder.request(S("sy{||h!nxxmERJeMICT")), e.finder.request(S("-M@]\\S]PERV]"), { name: S("B!1\x00($-/9?"), folder: t, context: { parent: t } });
	        }function B(e) {
	          e.request(S("2XQL\f[QJN^R"), { key: o.f5 }), e.request(S("+GHW\\XAGQ["), { key: o.r }), e.on(S("pydzpWO") + o.f5, function (t) {
	            (e.util.isShortcut(t.data.evt, "") || e.util.isShortcut(t.data.evt, S("3WAD[")) || e.util.isShortcut(t.data.evt, S(":HTTXK")) || e.util.isShortcut(t.data.evt, S("{mhw7nvvFU"))) && P(t);
	          }), e.on(S("rbxriq") + o.r, function (t) {
	            (e.util.isShortcut(t.data.evt, S(";_ILS")) || e.util.isShortcut(t.data.evt, S("!AWVI\rT@@L_"))) && P(t);
	          }), e.on(S("9ISSOJ\\551y(,53r/#')>"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.refresh, shortcuts: S("+WKRLJQGFYKCKG") });
	          }, null, null, 60);
	        }h.prototype.doAfterInit = function (e) {
	          this.initDfd.promise().done(e);
	        };var D,
	            O,
	            A,
	            K,
	            V,
	            N,
	            H = !1;return h;
	      }), CKFinder.define(S("`pnc9ZQ]uszzRvFIUJF\\LYjBBKUCArZZS]KnIYXpP$$*!2h#'="), [], function () {
	        return S('\r2n0c}q(4cj|rhxs=\x00BNBWVKBLJBBKUCA@GSRU[YYQD;~bb-1h/):	#%!*=5?r.)6=1u?5788,,MH\b\bE\n\x00	\n\n	L	\bTW\f½£¯²¦¥âæüè§èçë£ëâþâ®¶áäâý»¤¡íïÁÏØßÎÜÆÊÎÈÂÌÍÚÀØÖÕÜÆÁÌ° ¬ýÎùé¦öÃöªì®¢®£¢ïñ·¾°ú¾¶¶¿¹¯­òÉÍÏÑÓÛºn!~gn`*nffoi}"dcwv9{y:{qswxo{q[Z^YCI]KENAA\rQFGAYZ^ZH\\V#.,3+6{e&&>.49lql~3m^i2>.y97=.-bB	I	\f\fA\n\\\fTIrpF]ôà¯ñëéãºªåãøøûçêç³²ààìúò¥»þòïíòþÙÌÌÊÀÞÀ¤ÕÛÅ¿');
	      }), CKFinder.define(S("D\r!'..>b 4$>6'z84=?)/r\b6L\"\n\n\r>	\b \x00$"), [S("-[ATT@@WZDR"), S(',neiY_VVF`^]NI~\\MZo-.4*5.<,"):'), S("0EWK@u|~PT_YOk%,2/%1#4g%'((<<=?00$*<?39;		M\x00\n"), S("6tsSUXXL5+/k#>&.."), S("xw{3uQTGQ]\bKHJ@FN")], function (e, t, n, i) {
	        "use strict";
	        var r = t.extend({ name: S("E\x00($-/9?+*>66"), tagName: S("*GE"), className: S("-MDVT\\XQSEKNIYX"), childViewContainer: S(" TNBLTT\\"), template: n, bubbleEvents: [S("pxt}i&xfoAOF"), S('+JBBKUC\bPX\\U\\'), S("i}vvf/uxvmchp{qU"), S("v~~wqg,|}`~tks"), S("&AGENN^J]_A"), S("#BJJCM[IIKA]U@VYZ@RZRRPY"), S(")YN@HM[UU\bQQSYE]"), S("@'- 16")], modelEvents: { selected: S("\fb`BuwGpzr{m"), deselected: S('C  5"$,)?'), change: S("1]]yZRRTzRZRZ["), "ui:expand": S("wkdtxs") }, onBeforeRemoveChild: function onBeforeRemoveChild(e) {
	            this.trigger(S('+JBBKUC\bQQSYE]H^QRHZz"**(!'), { origin: this, removedView: e });
	          }, collectionEvents: { remove: function remove() {
	              0 === this.collection.length && this.collapse();
	            } }, attributes: { role: S("lo{lEOVBPLII") }, ui: { subTree: S("D0*}. 888"), expander: S(")HGKI_]VVFFCJ\\_YEN^.%'1~#/5;="), label: S(".SZTRZZS]KIHO[Zm-#!!)|!!;9?") }, events: { "vmousedown @ui.expander": function vmousedownUiExpander() {
	              this.trigger(S("{q|UR"), { origin: this });
	            }, "click @ui.expander": function clickUiExpander(e) {
	              e.stopPropagation(), this.requestExpand();
	            }, "contextmenu @ui.label": function contextmenuUiLabel(e) {
	              e.stopPropagation(), this.triggerContextMenu(e);
	            }, "click @ui.label": function clickUiLabel(e) {
	              e.stopPropagation(), 2 === e.button || 3 === e.button ? this.triggerContextMenu(e) : this.trigger(S("u{yrrj#ywu~u"), { view: this });
	            }, "keydown @ui.label": function keydownUiLabel(e) {
	              return e.keyCode === i.menu || e.keyCode === i.f10 && this.finder.util.isShortcut(e, S("g}ql")) ? (e.stopPropagation(), void this.triggerContextMenu(e)) : void this.trigger(S("<[QS$$0y/ ?#'>$"), { evt: e, view: this, model: this.model });
	            }, "mouseout @ui.label": function mouseoutUiLabel() {
	              this.model.get(this.viewMetadataPrefix + S("!unMzLDAWAA")) || this.ui.label.removeClass(S("0D[VAXYZNRJX"));
	            }, "ckfdragover @ui.label": function ckfdragoverUiLabel(e) {
	              e.stopPropagation(), e.preventDefault(), this.ui.label.addClass(S("nu0|kN\fC@PLPB"));
	            }, "ckfdrop @ui.label": function ckfdropUiLabel(e) {
	              e.stopPropagation(), this.model.get(this.viewMetadataPrefix + S(">)2&( %3--")) || this.ui.label.removeClass(S('\fxg"re|>uvb~n|')), this.trigger(S("qwu~~n'zmOQ"), { evt: e, view: this, model: this.model });
	            }, "focus @ui.expander": function focusUiExpander(e) {
	              e.preventDefault(), e.stopPropagation();
	            } }, initialize: function initialize(t) {
	            var n = this;n.collection = n.model.get(S("zrrpylzN")), n.viewMetadataPrefix = t.viewMetadataPrefix || S(".YYTE"), n.options = e.extend({ workingIcon: S("$PO\nAJEENEIC]GUAS"), expandedIcon: S("9ORT]P.l!(\"h'5:&=f("), collapsedIcon: S("ex?zwzx:{r|6}olpW\f") + (n.finder.lang.dir === S("pil") ? "r" : "l") }, t), n.model.has(n.viewMetadataPrefix + S("\r4fcTjcu{rr|")) || n.model.set(n.viewMetadataPrefix + S("7PI~DM_Q$$&"), !1);
	          }, onModelSelected: function onModelSelected() {
	            this.trigger(S(")YN@HM[UU\bQQSYE]")), this.ui.label.addClass(S("B6-h$3&d+(8$8*")), this.model.set(this.viewMetadataPrefix + S(")B_~KCURFVP"), !0), this.expandParents(), this.focus();
	          }, deselect: function deselect() {
	            this.ui.label.removeClass(S("hw2BULEFRN^L")), this.model.set(this.viewMetadataPrefix + S(")}fErt|yoyy"), !1), this.children.call(S("yn{sEBV"));
	          }, onModelChange: function onModelChange(t) {
	            var n = this,
	                i = !1,
	                r = [S("~pv"), S("$UGUMG^")];if (e.keys(t.changed).forEach(function (t) {
	              e.contains(r, t) && (i = !0);
	            }), e.isUndefined(t.changed.hasChildren) || t.changed.hasChildren || (i = !0), t.get(S("'@HYhDDBKBT\\")) || t.set(n.viewMetadataPrefix + S(".|eR`i{uxxz"), !1, { silent: !0 }), i) {
	              var o = !!this.$el.find(S("\r4irg`")).length;n.render(), o && this.ui.label.focus();
	            } else t.changed.hasChildren && (n.ui.label.removeClass(S("xw{3yOMFFVVSZLOBBLXX^WFPX")), n.ui.expander.removeClass(S("vx2FNNGAWU\n\\[ONCASY[_PGSY"))), n.refreshUI();
	          }, onRender: function onRender() {
	            var t = this;t.refreshUI(), t.model.get(t.viewMetadataPrefix + S(")}fSohxtyy")) ? t.expand() : t.collapse(), t.model.get(t.viewMetadataPrefix + S(" roN{sEBVF@")) && this.ui.label.addClass(S("ex?q`{;v{msmy")), this.ui.label.attr(S("|lvA\fNFR@J"), this.calculateLevel());var n = this.$el.attr(S("'AM")) || e.uniqueId();this.ui.label.attr(S("}ow~\rMCAAIJBLKS"), n), this.ui.label.find(S("*X\\L@")).attr(S("p~"), n);
	          }, refreshUI: function refreshUI() {
	            var e = this;e.$el.closest(S("2FX")).listview().listview(S("lzFSGPL")), this.ui.subTree.listview().listview(S(":IY[LZ3)")), e.model.get(S(")CX|H@KY_U")) ? (e.ui.expander.addClass(e.options.workingIcon).addClass(S("/SZT@GSRUUZXTPX")), e.$el.find(S("%JAMKACTT@@ADR]VZ^XR`bm'. j.&&/)?=b$#76y0.'97>>.")).addClass(S('?5(o00$2"e-#8-/"*4')).attr(S("weqx7un}LDF"), S("4ADB]")), e.ui.label.attr(S("9[IU\\]52;"), S("e`fq"))) : (e.ui.expander.removeClass(e.options.workingIcon).removeClass(S("ypz0jmEDOKDBNFN")), e.$el.find(S("$	KBLJBBKUCA@GSRU[YYQ~al /#k!'%..>>c;\"47~1-&66=?)")).removeClass(S("4@_KM[OYZV3  /!!")).attr(S(")KYELKYBSQXPR"), S("~xvhy")), e.ui.label.attr(S(")KYELMEBK"), S("E &$:/"))), e.model.get(e.viewMetadataPrefix + S(" KPa]VFFMCEK")) ? (e.ui.expander.addClass(e.options.workingIcon).addClass(S(")I@J\x00Z]UT_[TR^V^")), e.ui.label.attr(S("?!3+\"i'341"), S(" UPVA"))) : e.model.get(S("~kIuxtpx")) || (e.ui.expander.removeClass(e.options.workingIcon).removeClass(S('D&-!e=8.)`" 15;=3')), e.ui.label.attr(S("C%7/&e+?85"), S("6QYUI^")));
	          }, childViewOptions: function childViewOptions() {
	            return { viewMetadataPrefix: this.viewMetadataPrefix };
	          }, onAddChild: function onAddChild(t) {
	            var n = this;this.refreshUI(), n.model.get(n.viewMetadataPrefix + S("#LUbPYKEHD@H")) && n.expand(), e.each(n.bubbleEvents, function (e) {
	              t.on(e, function (t) {
	                n.trigger(e, t);
	              });
	            }), t.parentView = this;
	          }, collapse: function collapse() {
	            this.children.each(function (e) {
	              e.collapse();
	            }), this.ui.subTree.hide().attr(S("%GUAHCEIJJ^"), S("&SZ\\O")), this.ui.expander.removeClass(this.options.workingIcon).removeClass(this.options.expandedIcon).removeClass(S("\rmdv<faqp;{wx~rrz")).addClass(this.options.collapsedIcon), this.model.get(S(">W!2+-)\"5-'")) ? this.ui.label.attr(S("/QC[RPNGYW^^X"), !1) : this.ui.label.removeAttr(S("8XHR][G0 ,'!!")), this.$el.removeClass(S("+OFHDCWVPNGYW^^X")), this.model.set(this.viewMetadataPrefix + S("9\x00ROxFO!/&& "), !1);
	          }, expand: function expand() {
	            this.ui.subTree.show().attr(S('A#1-$k/!-.."'), S('B%%)5"')), this.ui.expander.removeClass(this.options.workingIcon).removeClass(this.options.collapsedIcon).removeClass(S("*HGK[BTWXZWSQW]")).addClass(this.options.expandedIcon), this.model.get(S("&OIZiCEAJ]U_")) ? this.ui.label.attr(S("qc{r9pngyw~~x"), !0) : this.ui.label.removeAttr(S("5WEQX^DM_Q$$&")), this.$el.addClass(S('A!("h25-,g.4=/!446')), this.model.set(this.viewMetadataPrefix + S("'@YnT]OATTV"), !0), this.model.set(this.viewMetadataPrefix + S("+{`Qmfvv}su{"), !1), this.refreshUI();
	          }, requestExpand: function requestExpand() {
	            this.refreshUI(), this.ui.expander.hasClass(this.options.collapsedIcon) ? (this.ui.expander.removeClass(this.options.collapsedIcon).addClass(this.options.workingIcon).addClass(S("|KGWV@C\nDFKOECI")), this.model.get(S("v~SbJJHATBF")) && this.model.get(S("'KACGH_KA")).length && this.expand(), this.model.get(S("oegctcw}")).length || this.model.set(this.viewMetadataPrefix + S(".|eR`i{uxtpx"), !0), this.trigger(S("5PXT]_IXFO!/&"), { view: this })) : (this.collapse(), this.trigger(S("}sqzzRALHIGW[L"), { view: this }));
	          }, next: function next() {
	            var e = this.parentView.collection,
	                t = e.indexOf(this.model);return t + 1 === e.length ? null : this.parentView.children.findByModel(e.at(t + 1));
	          }, prev: function prev() {
	            var e = this.parentView.collection,
	                t = e.indexOf(this.model);return 0 === t ? null : this.parentView.children.findByModel(e.at(t - 1));
	          }, focus: function focus() {
	            this.ui.label.focus(), this.trigger(S("+JBMZC"), { origin: this });
	          }, expandParents: function expandParents() {
	            for (var e = this; e.parentView && e.parentView.expand;) {
	              e = e.parentView, e.expand();
	            }
	          }, calculateLevel: function calculateLevel() {
	            for (var e = 1, t = this.model, n = this.model.get(S("k}o{qT")); n;) {
	              e += 1, t = n, n = t.get(S("2CUGSYL"));
	            }return e;
	          }, triggerContextMenu: function triggerContextMenu(e) {
	            this.trigger(S("6QWU^^N]P.5';0(#)="), { evt: e, view: this, model: this.model });
	          } });return r;
	      }), CKFinder.define(S("OFHf~uwa;Xysmuh3[qsDDPPsOB_ZmCAJJBBfAQP`^]N"), [S("B\x00/),,8d$+8#~2'0y74*4/4*:6\b"), S('\x1C^UYIOFFV\nkHL\\FN_\x02h@\\UWAG\x1A`^]NI\x14zRR[%3\x161! \b(,,\x1C"):'), S(".l{w[]PPDmMSWv[F.&&")], function (e, t, n) {
	        "use strict";
	        function i(e, t) {
	          function i() {
	            t.evt.preventDefault(), t.evt.stopPropagation();
	          }var u = t.view,
	              l = t.evt.keyCode,
	              c = t.model,
	              d = c.get(u.viewMetadataPrefix + S("+D]jHAS]PPR")),
	              f = c.get(S("/XPAp\\\\ZSJ\\T"));l === n.up && (i(), a(u)), l === (this.finder.lang.dir === S("0]FA") ? n.right : n.left) && (i(), r(f, d, u)), l === n.down && (i(), o(f, d, u)), l === (this.finder.lang.dir === S("D)25") ? n.left : n.right) && (i(), s(f, d, u));
	        }function r(e, t, n) {
	          if (e) {
	            if (e && !t) return void n.requestExpand();var i = n.children.first();i && i.focus();
	          }
	        }function o(e, t, n) {
	          if (e && t) return void n.children.findByModel(n.collection.first()).focus();var i = n.next();if (i || !n.model.get(S("*B_A@D"))) {
	            var r;if (!i) {
	              for (r = n.parentView, i = r.next(); !i && !r.model.get(S("\fd}]~f"));) {
	                i = r.next(), r = r.parentView;
	              }!i && r.model.get(S("+E^|@_E")) && (i = r.next());
	            }i && i.focus();
	          }
	        }function s(e, t, n) {
	          e && t ? n.collapse() : n.model.get(S(";UNlP/5")) || n.parentView.focus();
	        }function a(e) {
	          var t = e.prev();if (t) for (; t.model.get(e.viewMetadataPrefix + S("9\x00ROxFO!/&& ")) && t.model.get(S("uqu~iys")).length > 0;) {
	            t = t.children.findByModel(t.collection.last());
	          } else e.model.get(S("\nb_a`d")) || (t = e.parentView);t && t.focus();
	        }function u(e, t) {
	          var n = e.model;if (!n.get(S("v~~t}h~r")).length) return e;var i = n.get(S(',NFF\\U@VZ')).findWhere({ name: t.shift() });return i ? u(e.children.findByModel(i), t) : e;
	        }var l = e.extend({ name: S("YOMFFVVrUML"), childView: t, tagName: S("2FX"), className: S("<^UYm50&!"), attributes: { role: S('C07#"'), "data-role": S(".CYBFE]PA"), tabindex: 20 }, template: "", events: { keydown: function keydown(e) {
	              if (e.keyCode === n.tab && (this.finder.util.isShortcut(e, "") || this.finder.util.isShortcut(e, S("!QKMCR")))) return void this.trigger(S("-EJIU]DZBVZ"), e);var t;if (e.keyCode === n.up || e.keyCode === n.end) for (t = this.children.last(); t.model.get(t.viewMetadataPrefix + S("7PI~DM_Q$$&")) && t.model.get(S(";_UWS$3'-")).length > 0;) {
	                t = t.children.findByModel(t.collection.last());
	              }(e.keyCode === n.down || e.keyCode === n.home) && (t = this.children.first()), t && (e.stopPropagation(), e.preventDefault(), t.focus());
	            }, focus: function focus(e) {
	              e.target === e.currentTarget && (e.preventDefault(), e.stopPropagation(), this.findFolderToFocus().focus());
	            } }, childEvents: { "folder:keydown": i, "selected:before": function selectedBefore() {
	              this.children.call(S("~~oxrzCU"));
	            }, focus: function focus(e, t) {
	              this.lastFocusedPath = t.origin.model.getPath({ full: !0 });
	            }, "folder:before:remove:child": function folderBeforeRemoveChild(e, t) {
	              var n = t.origin.model.getPath({ full: !0 }) + t.removedView.model.get(S("\fcobu")) + "/";n === this.lastFocusedPath && t.origin.focus();
	            } }, initialize: function initialize(e) {
	            this.viewMetadataPrefix = e.viewMetadataPrefix || S("=HV%6");
	          }, onRender: function onRender() {
	            this.$el.attr(S("\fl|fq<~rvpz"), this.finder.lang.FoldersTree);
	          }, childViewOptions: function childViewOptions() {
	            return { viewMetadataPrefix: this.viewMetadataPrefix };
	          }, onAddChild: function onAddChild(e) {
	            e.parentView = this, this.refreshUI();
	          }, refreshUI: function refreshUI() {
	            this.$el.listview().listview(S("4GSQJ\\IS"));
	          }, findFolderToFocus: function findFolderToFocus() {
	            var e = this.children.first();if (this.lastFocusedPath) {
	              var t = this.lastFocusedPath.split(":"),
	                  n = t[0],
	                  i = t[1],
	                  r = this.children.findByModel(this.collection.findWhere({ name: n }));if (e = r, "/" !== i) {
	                var o = i.replace(/^\//, "").split("/").filter(function (e) {
	                  return !!e.length;
	                });e = u(r, o);
	              }
	            }return e;
	          } });return l;
	      }), CKFinder.define(S('+ofhF^UWAxYSMU_H{WS%2,2 (80e#)+##~<"08( :(<'), [S("6BV]_IO^QM%"), S("7ZXYP^RPZ")], function (e, t) {
	        "use strict";
	        return t.Model.extend({ defaults: { done: 0, lastCommandResponse: !1 }, initialize: function initialize() {
	            this.set({ fileExistsErrors: new t.Collection(), otherErrors: [] });
	          }, processResponse: function processResponse(t) {
	            this.set(S("D)'4</8<\" <5"), { done: this.get(S("E2>8,")) === S("-m@@H") ? t.copied : t.moved, response: t });var n = this.get(S("\nocck")),
	                i = parseInt(this.get(S(":OEM[")) === S("$fIWQ") ? t.copied : t.moved);if (this.set(S("9^TRX"), n + i), t.error && (300 === t.error.number || 301 === t.error.number)) {
	              var r = this.get(S("qqu^dtmkSdPQKWU")),
	                  o = this.get(S("*DXEK]uC@\\FF"));e.forEach(t.error.errors, function (t) {
	                if (115 === t.number) r.push(t);else {
	                  var n = e.findWhere(o, { number: t.number });n || (n = { number: t.number, files: [] }, o.push(n)), n.files.push(t.name);
	                }
	              });
	            }
	          }, hasFileExistErrors: function hasFileExistErrors() {
	            return !!this.get(S("B%-)#0 9??\b<=?#!")).length;
	          }, hasOtherErrors: function hasOtherErrors() {
	            return !!this.get(S("!MWL@TbZ[EY_")).length;
	          }, nextError: function nextError() {
	            var e = this.get(S("B%-)#0 9??\b<=?#!")).shift();return this.set(S(">\\530&*1"), e), e;
	          }, getFilesForPost: function getFilesForPost(e) {
	            var t = [];if (t.push(this.get(S("~kmRDLW")).toJSON()), e) for (; this.hasFileExistErrors();) {
	              t.push(this.nextError().toJSON());
	            }return t;
	          }, addErrorMessages: function addErrorMessages(t) {
	            e.forEach(this.get(S("}g|pdRjkuio")), function (e) {
	              e.msg = t[e.number];
	            });
	          } });
	      }), CKFinder.define(S("fvla7TS_suxxl0tDOSHDRB[lB@H]b_GWp[EO{QUTOXxP,%'1j!)3"), [], function () {
	        return S(".w}c6sym{6nrrzJFEACU\n \"EKJ]A[YW]xXMK)/#7-*('%..>m32l~:aj__k9y97=.-bBN\bG\x00G\b\x00\n\\UUQî¬ììðàþó¨üã¦åîáá½òùõ¹÷÷ôó»ºòø ¼üËÇÎËÓÃËÆÚÒÎÂÀÃÔÀÜÂÛÝÀÇÖ´ï®¢ª¢è¤¦¹®¹ ï­¬ðó ´´¾¶½¿£áÿïïÂßÞÌÛìÛÇÒçÒÒÈÔ×Òcnrz)fii|ld.32 txd-");
	      }), CKFinder.define(S('A\b,(#-;e#);#5"}=93$6,>2.&O7I$\x00	+\x00?\f\f'), [S("0ryu][RRJlRYJM 1&k	'>'<>%(9"), S("8M_CH}t(,'!7i-$:'-9+<;?1&8.<4,$q\b\r#	\f\fE\b")], function (e, t) {
	        "use strict";
	        return e.extend({ name: S(" bJLKVCaGENN^iGN\\^UULYBLoS^K"), template: t, regions: { content: S(",szt>yz`r5zuke0}pNUGMP") }, ui: { close: S("2qxr8{xn|7xsmg2CMMPA") } });
	      }), CKFinder.define(S('B\x00/),,8d"*:<4!|<:2+5-91/N4\nH%/4:'), [S("E\f $/)?a94% {7$=v:%2++6\b")], function (e) {
	        "use strict";
	        return e.extend({ name: S("1\\BPuXH@~R]QQX\f ;,11.->"), template: S('.w}c(+7}sm"'), regions: { content: S(":_UK") } });
	      }), CKFinder.define(S('%RBP]hgkGATT@`P[GTXN^OxV,$1+3#\'93d"8*>"*<:2:.233-\fI\f'), [], function () {
	        return S("@}*pd&*&;:wi/&(b=>$6y69'!t<2080>\r@][GD\b\n\\^W_Z^V üÿ¿«íµ¹µú«ïáïüã¬°ðÿó»ú÷ïÿ¶ÿòîæÄÐÑË×ÓÒÅÙÃÑßÕñÇÄØÊÊáá¿¾øê¶ùÂÃö©¹¹º ¾ñ±¿µ¦¥êúº±½ñ°±©ÌËÏÎÌÐÛÖwskwa'8|s4*bx#bn~v<U}ysXn|hlntjz\x00\\_GSS\\FD&LZDE]]VZVKJ_VX-.4&i&)71d(>89!!rq;7iw5<>t74*8s-GXTJC\\56\r\r	å¡ÿþ¸ªäòüýåå²²íååæüúµõûùêé¦¾þõùÌÍÕÁÅÈØÐÉÙÙÚÀÞÚÐÔÓßÖÓËÛ³ª«³æû½¼õé£¿â¡¯¡·ÿ±¼¹¸¹¹öª±²¬ý£¢ÜÎÖãà×ÏÈÔ×Òcnrz)fnbkbhdt/0-~rvpz)'usnjTLBI@X[EHI^]n\\]@LFRYSY^U]/9`}NLO<3tj\"8c\".>6|0;8;86w(>183=&\fJggS_H}DV\nCtuûú½£íñ¨ôàæýÈíãíêü±ïî©òþî¹ù÷ýîí¢ÔËÃ×ÏÃÚÅÇÃ¥¹ÖÚÂÕÛÙÊÉÈ×¢­­ ¯è§åöõ®¢ºóò­¥¥¦¼ºõ¿³åû¹°ºð³°ÏËÔÐÎßØÓnbgo$x{;'kxb`1,>vzb+*8|pl%!1{IW)_^ZU#");
	      }), CKFinder.define(S(":xw{WQ$$0l	*\"2$,9d\n$\"*#=%19'!v\f29*-p-'\n.\x00-%"), [S(";vxV.%'1k/\"?:e	->+`%7><3 "), S('-ZJHEps_Y\\\\HhXSO, 6&7j\x00.$,9#;+\f?!+|: 26*"42:!\n3\r\rA')], function (e, t) {
	        "use strict";
	        return e.extend({ name: S("3yZ@R{VJByOLP22*!2"), template: t, ui: { processAll: S("'sGKFI\f_B^QVGFw[Tg"), overwrite: S('\n(ofh"}~dv9z`rjnhrhx'), skip: S("(\nI@J\x00C@FT@_\\F"), rename: S(";zq}1pqiE\fPFJDKB"), cancel: S('8YPZSP6$o %+%"$') }, onRender: function onRender() {
	            this.$el.enhanceWithin();
	          } });
	      }), CKFinder.define(S("?4$:7e\r!'..>b*=!>2 0%x06>/1)\"\rJ+\b\f)<\n R"), [], function () {
	        return S("+]TK\fZ@[D_GF\x00NJ}*1zOz7h*&*?>sm3:4~9: 2u:5+%p8>	\rKLB\nY^C½¡ë÷ªàôõçûùßåùâê°ìï¯»å¨¤ýóí¼þòþÓÒÇÎÀÅÆÜÎÎÁßÉÔÒÝÙÃÅÝÊ¶´ÅÄ¾á«·êª²¯­»¹¾¢¼¼êñ·¡¦º¤ª¶¯«ü £ÕéèÞÚÚÈ©Ý×ÆÔÃôö	=wo:srt+i|`bV`|ae8qquh&={mRNPYX,.! GEUT\rWAFZDEDPT\x005IH98:8;MA@vd9!pEY*)-)(\\kw=3-bW%$_AJ\b*\bO\r\fxO\x00W\b@\\\né¬åñíá«ôçåå©²³ôøä³÷ù÷äë¤¸îõ°üóÏÂÉÅÌÀÜÏÛÛÄÞÜÝÑÛÒÜÑÒÈÚí¢­³½è©¬ê÷±°ñí§»þ½³½³û¼­´û¡ âðØÛÇÒÑÁÌùÈÚÇðÂ\n");
	      }), CKFinder.define(S("0ryu][RRJwTXHRZ3n*( 5\n'?/\b#=7`87$'z8.<4,$\f:2\f"), [S("ZQ]uszzRtJARU\bjHYNdZJ]g[VC"), S('1FVLAtsSUXXL$/3($2";f\f" (=?\'7;%/x6,>2.&2\b2\n\b@')], function (e, t) {
	        "use strict";
	        return e.extend({ name: S("3yZ@R{VJBnXMJ,5*!2"), template: t, className: S('B /#k*\'?/f/">6}#7 !9"'), ui: { ok: S('?c")%i()1-d)$<4c ;') }, onRender: function onRender() {
	            this.$el.enhanceWithin();
	          } });
	      }), CKFinder.define(S("3w~p^V]_IpQ[5-'0k/+-:$:(\r  (}=93$6,>2.&"), [S("UOFFVVEHZL"), S("$GGDCKEEI"), S("6tsSUXXL('47j\";:+,)'*'"), S(':xw{WQ$$0l	*"2$,9d\n""+5#!|<3 +v409;-53'), S("V]Qqw~~n2SpDTNFW\n`NDLYfC[Kl_AKyZRRTJvSK[|/1;%1'"), S("SZTzzqse7Tuiq{lgKOAVkH^LiD\\TyYTE@v^XWJ_}SQZZ2\r#:+02"), S('\\kgKM@@T\beFN^@H]\x00vX^VGxYA]zUKEhV%61l	*0"&:2\b$/#?62-:##'), S("3w~p^V]_IpQ[5-'0k/+-:$:(\r  (}=0!$w5-91/'$:"), S("YPZtp{ES\rnKASKMZmEAK\\}^DVwZFNoS^KNr/7'\x00+5?-:?'8'*'"), S("^UYIOFFV\nsSAE`ITm@TT")], function (e, t, n, i, r, o, s, a, u, l) {
	        "use strict";
	        function c(e) {
	          function t(t) {
	            e.setHandler(S("!DJH@U") + t.toLowerCase(), function (n) {
	              d(n, t, e);
	            }), e.on(S("{vwv}sz%AGVFV") + t + S("A*( 5"), function (e) {
	              h(e, t, n, t === S(".b_GW"));
	            }), e.on(S('>\\/,/"*!|":;%9v') + t + S("]uq{l"), g), e.on(S("@5-,(''5r;/8)9t18<i2<:2+"), function (e) {
	              m(e, t, n);
	            }), e.on(S("*_CBBMQC\bAQFSCt[RRXV,$"), function (e) {
	              m(e, t, n);
	            });
	          }var n = this;n.finder = e, e.on(S("5PXT]_IYLP0"), v, n), e.on(S("$FII\\LR_aH@Z\nW]_PPDsJVJ"), function (e) {
	            e.data.groups.add({ name: S("*FC[Kl_AK") });
	          }), e.on(S('B ++2"0=."8t)?=66&$8(c74*80'), w), t(S("\fNai")), t(S(";qRHZ"));
	        }function d(n, i, o) {
	          var s = n.files,
	              a = [],
	              u = n.toFolder;s instanceof t.Collection && (s = s.toArray()), e.forEach(s, function (e) {
	            var t, i;i = { options: n.options ? n.options : "" }, "function" == typeof e.get ? (t = e.get(S("t|xqse")), i.name = e.get(S(" OCNA")), i.type = t.get(S("iynqjRBGw]UC")), i.folder = t.getPath()) : (i.name = e.name, i.type = e.type, i.folder = e.folder), a.push(i);
	          });var l = new r();l.set({ type: i, currentFolder: u }), f(o, a, l);
	        }function f(t, n, i, r) {
	          r && e.forEach(n, function (e, t) {
	            n[t].options = r;
	          });var o = i.get(S("\nu}k")),
	              s = n.length,
	              a = S(1 === s ? "'gGOmEAKxQXF" : "/}P\\Jr\\ZRKn[RH");t.request(S(".C_PVVFE_WN"), { text: t.lang[o + a].replace(S("4#"), s) }), t.request(S("'KFGFMCJCT\\W"), { name: o + S("?(.&7"), type: S("lrmk"), post: { files: n }, folder: i.get(S("4VCEJ\\TOzRR[%3")), context: { moveCopyData: i } });
	        }function h(t, n, i, o) {
	          function s() {
	            i.finder.request(S("=N^'$x'!625'0"), { name: C }), i.finder.request(S(",IGN\\^U	PPECJVC"));
	          }var l = [103, 116],
	              c = t.data.response;if (!c.error || !e.contains(l, c.error.number)) {
	            var d = i.finder,
	                h = t.data.context,
	                g = h && h.moveCopyData ? h.moveCopyData : new r();g.get(S("D1?7-")) || g.set(S(" U[SA"), n), g.processResponse(t.data.response), d.request(S("yyv||h!ttzz"));var m,
	                v = S(g.get(S("2GMES")) === S(")iD\\T") ? ">|/1+& " : "4xYA]]") + S("Vx~vg[czz|h");if (g.set(S("<PMX"), d.lang[v].replace(S("1"), g.get(S("{OOG")))), g.set(S('"FVWIU[}C_@H'), d.lang[g.get(S("#P\\VB")) + S('8SWYN{M2.0-1*"')]), g.set(S("mwOVaBJFCK"), y(d)), !g.hasFileExistErrors()) {
	              d.request(S('"SEBCLLY_^BW'), { name: b }), d.request(S(" QCDABB[]XDU"), { name: C });var w = d.lang[g.hasFileExistErrors() ? S(">p0$0\"0,))&'; (:*4 !;'%") : g.get(S("7L@J^")) + S("Zfrjxnrss")];return g.hasOtherErrors() && (g.set(S("~gr"), d.lang.OperationCompletedErrors + " " + g.get(S("bcv"))), m = new u({ finder: d, model: g, events: { "click @ui.ok": function clickUiOk() {
	                    i.finder.request(S(",]OHUVVGADXA"), { name: x }), i.finder.request(S('@%+"(*!},,9?>"7'));
	                  } }, className: function className() {
	                  return this.finder.request(S("jIEFPhICM")) == S("MN@JH@") ? S("gz9vyyl|to") : "";
	                } }), g.addErrorMessages(d.lang.Errors)), m ? y(d) ? (d.request(S("astq/ue}xn~"), { view: m, title: w, name: x, uiOptions: { dialog: d.request(S('"VMAB\\dEOI')) !== S(".B_S[_Q"), theme: d.config.swatch, overlayTheme: d.config.swatch } }), d.request(S("@1#$!5/'>"), { name: x }), d.request(S("i{|y'zzSUPL]"), { name: C })) : d.request(S("*OELB@W"), { name: g.get(S("9NBLX")) + S("(z_HOH]\\"), title: w, buttons: [S("<RU|,.1&")], minWidth: S("Avst5>"), view: m }) : d.request(S('?$(#/+"|.&/%'), { title: w, msg: g.get(S("$HU@")) }), void (o && d.request(S("pxt}i&o{yRDQKbLJB[")));
	            }g.nextError(), g.addErrorMessages(d.lang.Errors);var E = p(g, d, n);E.content.show(new a({ finder: d, model: g, events: { "click @ui.skip": function clickUiSkip() {
	                  this.model.hasFileExistErrors() && !this.ui.processAll.is(S("%CIG@O@B")) ? (this.model.nextError(), this.render()) : s();
	                }, "click @ui.overwrite": function clickUiOverwrite() {
	                  f(i.finder, this.model.getFilesForPost(this.ui.processAll.is(S("+NFJSZWW"))), this.model, S("sk{mWSKWA"));
	                }, "click @ui.rename": function clickUiRename() {
	                  f(i.finder, this.model.getFilesForPost(this.ui.processAll.is(S("+q{qv}r|"))), this.model, S("vmmuiysrE"));
	                }, "click @ui.cancel": s }, className: function className() {
	                return this.finder.request(S("<HW'$6+!#")) == S('A/,&,*"') ? S("C1,k$''>.\"9") : "";
	              } }));
	          }
	        }function g(e) {
	          var t = e.data.response;switch (t.error.number) {case 300:case 301:
	              e.cancel();break;case 116:
	              e.cancel(), e.finder.request(S("\rb`quwa.}s}")), e.finder.request(S("txs{r,~vu"), { msg: e.finder.lang.ErrorMsg.MissingFolder });var n = e.data.context.moveCopyData.get(S("?#401!+2'%..>")),
	                  i = n.get(S("/@P@VZA"));i.get(S("{qswxo{q")).remove(n);var r = e.finder.request(S("|tpy{mFGWeFRN^L"));r === n && e.finder.request(S(" GMO@@TGYOE|LZG"), { path: i.getPath({ full: !0 }), expand: !0 });break;case 103:
	              e.cancel(), e.finder.request(S("4YYV\\\\HTTZZ")), e.finder.request(S("DHCOKBNFOE"), { msg: e.finder.lang.Errors[103] });}
	        }function p(e, t, n) {
	          var i = e.get(S("muxi"));if (!i) {
	            i = new s({ finder: t });var r = t.lang[n + S(";sM[M!5+,*")];y(t) ? (t.request(S("4EWP]YIY\\JZ"), { view: i, title: r, name: C, uiOptions: { dialog: t.request(S("9ORZ[K\r.&&")) !== S("yzt~t|"), theme: t.config.swatch, overlayTheme: t.config.swatch } }), t.request(S('dtqr"jrtk'), { name: C }), t.request(S("oAFG@@USZFS"), { name: b })) : t.request(S("4Q_VTV]"), { name: C, title: r, buttons: [S("vwy{|v")], view: i });
	          }return i;
	        }function m(e, t, n) {
	          (t !== S("Uvl~") || e.finder.request(S("}sqzzREFPdESA_O")).get(S("qr~")).fileDelete) && e.data.toolbar.push({ name: t + S("\rHf|ta"), type: S("~hjkOO"), priority: 40, icon: S("-MDVTZXP") + S(t === S("D)71") ? "xsmg" : "7UVL^"),
	            label: n.finder.lang[t + S("E}|xwweZlnoss")], action: function action() {
	              var r = new i({ finder: n.finder, collection: n.finder.request(S("drkvoixm%GDV")), viewMetadataPrefix: S('"NKSCdGYS') });r.on(S("5U_QU^MUXI&..'!7|\"09+%("), function (e, t) {
	                n.finder.fire(S(".I_]VVFSOHXT_"), { view: t.view, folder: t.view.model }, n.finder);
	              }), r.on(S("zrrpyhvEVEKIBBZIGENE"), function (e, i) {
	                n.finder.request(S("5P^T\\I") + t.toLowerCase(), { files: n.finder.request(S("8_SWYNX%5&( %3--")), toFolder: i.view.model });
	              }), r.on(S('@"**(!0.->p-#!**"k96-19 6'), function (e, i) {
	                (i.evt.keyCode === l.enter || i.evt.keyCode === l.space) && (i.evt.preventDefault(), i.evt.stopPropagation(), n.finder.request(S(" GKOAV") + t.toLowerCase(), { files: n.finder.request(S("*MEAK\\\nVWGgPZR[M__")), toFolder: i.view.model }));
	              }), r.on(S("+GHWK_F\\	@TT"), function (e) {
	                e.preventDefault(), e.stopPropagation(), y(n.finder) ? r.$el.closest(S("Jvr`t;ewu&>mxE")).find(S("9XW[R/7'n'*6>e*&$?(")).focus() : r.$el.closest(S("6[R\\XT_S/&")).find(S("!szt>p|w{w~7yiijpNR")).find(S("&	]@IXC")).focus();
	              });var s = e.data.file ? e.finder.lang[t + S("4zXR~PV^xT_S/&*0)#")] : e.finder.lang[t + S("BqkU}ysd\\p{wszJvTMG")].replace(S("0JQ\\A[BJ"), e.data.files.length);if (y(n.finder)) {
	                n.finder.on(S("ewp}#issj$") + b, function () {
	                  r.refreshUI();
	                });var a = new o({ finder: n.finder, events: { "click @ui.close": function clickUiClose() {
	                      n.finder.request(S(":K]Z[$$176*?"), { name: b });
	                    } } });a.on(S("(ZBD["), function () {
	                  this.content.show(r);
	                }), n.finder.request(S("(YKLIM]UPFV"), { view: a, title: s, name: b, className: S("5U\\^WTJX\\/1;n ,'+'."), uiOptions: { theme: n.finder.config.swatch, overlayTheme: n.finder.config.swatch } }), n.finder.request(S(";L\\YZz2*,3"), { name: b });
	              } else n.finder.request(S("txs{r"), { name: b, title: s, buttons: [S("lqqvx")], contentClassName: S("}tF\fOLR@DGYSHDOC_V"), restrictHeight: !0, focusItem: S("6[R\\HO[Z"), uiOptions: { positionTo: S(")qOMYOSZT@ZY[ZXHp_V.c"), create: function create() {
	                    setTimeout(function () {
	                      r.refreshUI();
	                    }, 0);
	                  }, afterclose: function afterclose() {
	                    a && a.destroy(), r && r.destroy();
	                  } }, view: r });
	            } });
	        }function v(e) {
	          e.data.evt.ckfFilesSelection && this.finder.request(S("q|zasolTui"), { name: S("qwu~~nYlpP"), evt: e.data.evt, positionToEl: e.data.view.ui.label, context: { folder: e.data.folder } });
	        }function w(e) {
	          var t = e.data.context.folder,
	              n = t.get(S("/QR^"));e.data.items.add({ name: S("_|bpP~t|i"), label: e.finder.lang.MoveDragDrop, isActive: n.fileUpload, icon: S("{r|6ztrz\rLMUA"), action: function action() {
	              e.finder.request(S("/VX^VG[XN\\"), { files: e.finder.request(S(" GKOAV@M]yN@HM[UU")), toFolder: t });
	            } }), e.data.items.add({ name: S("\rM``hTzxpe"), label: e.finder.lang.CopyDragDrop, isActive: n.fileUpload, icon: S('A!("h .$,g(#=7'), action: function action() {
	              e.finder.request(S("xvLDQGJV^"), { files: e.finder.request(S("{wsERDAQuBDLI_II")), toFolder: t });
	            } });
	        }function y(e) {
	          return e.request(S("&RAMNX`AKU")) === S("8TUYUQ[");
	        }var C = S("QrhzcNRZ`LGKGNzJKH"),
	            x = S(">r/7'\x00+5?=*).?>\n&1==4412"),
	            b = S("@*,+6#'%..>");return c;
	      }), CKFinder.define(S("XW[wqDDP\fiJBRDLYjBMZC|S]URSEUXINs^. %&6"), [S("&MY\\OYU"), S('"VJACU[JEYI'), S("cjdJJACU|^B@eJIr]WQ")], function (e, t, n) {
	        "use strict";
	        function i(i) {
	          var o = [];i.setHandlers({ "focus:remember": function focusRemember() {
	              o.push(document.activeElement);
	            }, "focus:restore": function focusRestore() {
	              e(o.pop()).focus();
	            }, "focus:next": function focusNext(e) {
	              r(e, 1);
	            }, "focus:prev": function focusPrev(e) {
	              r(e, -1);
	            }, "focus:trap": function focusTrap(i) {
	              i.node && i.node.on(S("-EJIU]DZ"), function (i) {
	                var r = i.keyCode;if (r === n.tab) {
	                  i.preventDefault(), i.stopPropagation();var o = e(this).find(S("\rU{qs{}ppnJ4ptkii2~\fCWWPJH[LFNOY")).not(S("E3)+#%((6rr|cq	")).filter(S("Ax5-6/%$,")),
	                      s = t.indexOf(o, i.target),
	                      a = s + (i.shiftKey ? -1 : 1);a >= o.length ? a = 0 : 0 > a && (a = o.length - 1), o.eq(a).focus();
	                }
	              });
	            } });
	        }function r(n, i) {
	          var r = 0,
	              o = t.chain(e(S("D2&* $/)5"))).filter(function (t) {
	            var n = e(t);if (parseInt(n.attr(S("D1'%!'..4"))) < 0) return !1;if (n.closest(S("&	KBL\\LIJ")).length) return n.closest(S("2~uy\rQCDA")).hasClass(S('>J)l2"# k&+=#=)'));var i = n.closest(S("/D[DTXRT"));if (i.length) {
	              var r = !i.hasClass(S("5C^I[UYQ\\,.1& ")),
	                  o = n.hasClass(S("7[R\\HO[Z"));return o && e(S("vzrn")).hasClass(S("ryu9`:uv~~1y{lKUMS")) ? e(S(" zFBPDDCO[MJK|SZZk")).hasClass(S("ls6l|yz\r@AWMSC")) : r;
	            }return n.is(S("'_CXEOBJ"));
	          }).sortBy(function (t) {
	            return parseInt(e(t).attr(S("C0$$.&-/3")));
	          }).forEach(function (e, t) {
	            e === n.node.get(0) && (r = t);
	          }).value(),
	              s = r + i;return s >= o.length || 0 > s ? void 0 : (n.event.preventDefault(), n.event.stopPropagation(), e(o[s]).focus());
	        }return i;
	      }), CKFinder.define(S(".l{w[]PPDuV^^PNm%2-66&#19/"), [S("(\\DOI_]L_CW"), S("!@BGNDHFL"), S('B\x00/),,8d"**<"};922*')], function (e, t, n) {
	        "use strict";
	        var i;return i = n.extend({ initialize: function initialize() {
	            n.prototype.initialize.call(this);var e = this.get(S('>^,--4!!?<,$8%" <'));e && "string" == typeof e && this.set(S("AMNLS@BbP]OE_DAAC"), e.split(","), { silent: !0 });var t = this.get(S("E'+$&=.(\b6;5?!:;;%"));t && "string" == typeof t && this.set(S("rxyy`}}_chxplINLP"), e.split(","), { silent: !0 });
	          }, isAllowedExtension: function isAllowedExtension(t) {
	            t = t.toLocaleLowerCase();var n = this.get(S('>^,--4!!?<,$8%" <')),
	                i = this.get(S("uw}}prR`muotqqS")),
	                r = n && !e.contains(n, t),
	                o = i && e.contains(i, t);return !(r || o);
	          }, isOperationTracked: function isOperationTracked(t) {
	            var n = this.get(S("\fy|nszww[eseymstrn"));return n ? e.contains(n, t) : !1;
	          } });
	      }), CKFinder.define(S('br`m;XW[wqDDP\fp@KWDH^N_l]UPVPF@[UKxIY\\Z\\24/!7k"(<'), [], function () {
	        return S("-NR^RGFMPYHSEDa+7j&35:,$?l03o%81 ;{6;-3-9&%`@C\x00E\n\rALP\bTV\fW\n\b^ý£¢ëöààºªª¨«øììæþõ÷ë©·»¦º¹þúèü³üËÇÇÖÊÖÝØÞÉÔËÚÀÚÖÚÜÖÀÁÖ´ï¬¢© æºµõåªòÇ");
	      }), CKFinder.define(S(' bieMKBBZgDHXBJCt\\XQSEKlRYJM3\'" &42%+"):'), [S("\na}xk}i"), S("E\f $/)?a94% {7$=v/90\b6"), S("2GQMB{r|RRY[Mo'.4)'3-:e	>(/+3#'>6&y*<;??/+2L")], function (e, t, n) {
	        "use strict";
	        var i = t.extend({ name: S(';hRQS" 0+)"":'), tagName: S(",AG"), template: n, ui: { btn: S("8OR_JQ"), label: S("4C^[NU") }, events: { click: function click(e) {
	              e.preventDefault(), this.finder.request(S("9\\TPY[Mz.2&*'3 "), { path: this.model.get(S("$UGS@")) });
	            }, dragenter: function dragenter(e) {
	              this.model.get(S("9YNNO[Q4")) || "/" === this.model.get(S("*[MYF")) || (e.stopPropagation(), e.preventDefault(), this.ui.btn.addClass(S("A7*i'2)e()?%;+")));
	            }, dragover: function dragover(e) {
	              this.model.get(S("/SD@AQ[B")) || "/" === this.model.get(S("=N^4)")) || (e.stopPropagation(), e.preventDefault(), this.ui.btn.addClass(S("!WJ	GRIHI_E[K")));
	            }, dragleave: function dragleave(e) {
	              this.model.get(S("}jRSGMP")) || "/" === this.model.get(S("\n{myf")) || (e.stopPropagation(), this.ui.btn.removeClass(S("1GZWBYXYOUK[")));
	            }, ckfdrop: function ckfdrop(e) {
	              if (!this.model.get(S("?#401!+2")) && "/" !== this.model.get(S("=N^4)"))) {
	                e.stopPropagation(), this.ui.btn.removeClass(S("7MPYHS^#5+5!"));var t = this.model.get(S(":]SQZZ2"));this.finder.fire(S(")LD@IK]\nU@\\D"), { evt: e, folder: t, view: this }, this.finder);
	              }
	            }, keydown: function keydown(e) {
	              this.trigger(S("<V[F$.5-"), { evt: e, view: this, model: this.model });
	            } }, focus: function focus() {
	            this.ui.btn.focus();
	          } });return i;
	      }), CKFinder.define(S("2ps_Y\\\\HqRZJ,$1l**#-;9d$+8#~!1424*,79/7:"), [S("ouxxllCNPF"), S(",G_ZUCK"), S("cjdJJACUdEOYAK\\w]_PPDDoS^KN}2$#''73**#.;"), S("TS_suxxl0vHGTW\ndF[LhC@^@CXFVb\\S@"), S("cjdJJACU|^B@eJIr]WQ")], function (e, t, n, i, r) {
	        "use strict";
	        var o = i.extend({ name: S("E}|xwwe^vvyom"), className: S(",NEIW]_PPDD[H^]Y]M5, 0d0/j*&.2a$ '5#;'"), template: S(",[CESQ][RR@	\f\x00o4.}"), childViewContainer: S("C1)"), attributes: { role: S("xvnp}zhtqq") }, childView: n, ui: { container: S("6BT\\RNNJ") }, events: { touchstart: function touchstart(e) {
	              e.stopPropagation();
	            }, keydown: function keydown(t) {
	              if (t.keyCode === r.tab && (this.finder.util.isShortcut(t, "") || this.finder.util.isShortcut(t, S("a{}sb")))) return void this.finder.request(S(this.finder.util.isShortcut(t, "") ? "+JBMZC\\VLA" : ",KALEB\bCFP@"), { node: this.ui.container, event: t });var n;return e.contains([r.left, r.end, r.right, r.home], t.keyCode) ? (t.stopPropagation(), t.preventDefault(), n = t.keyCode === r.left || t.keyCode === r.end ? this.children.last() : this.children.first(), void n.focus()) : void ((t.keyCode === r.up || t.keyCode === r.down) && t.preventDefault());
	            }, "focus @ui.container": function focusUiContainer(e) {
	              e.target === this.ui.container.get(0) && (e.stopPropagation(), this.children.first().focus());
	            } }, initialize: function initialize() {
	            this.listenTo(this.collection, S("*YI^K["), function () {
	              this.$el[S(this.collection.length ? "@2*,3" : "vvDD")]();
	            }), this.on(S(".LXX^WB\\S@R_BXRIQ"), function (e, t) {
	              var n = t.evt;if (n.keyCode === r.left || n.keyCode === r.right) {
	                n.stopPropagation(), n.preventDefault();var i = this.collection.indexOf(t.model);i = n.keyCode === r.left ? 0 >= i ? 0 : i - 1 : i >= this.collection.length - 1 ? i : i + 1, this.children.findByModel(this.collection.at(i)).focus();
	              }(n.keyCode === r.space || n.keyCode === r.enter) && (n.preventDefault(), n.stopPropagation(), this.finder.request(S("~vvyo$pPDLsEQN"), { path: t.model.get(S("E6&<!")) }));
	            }, this);
	          }, onRenderCollection: function onRenderCollection() {
	            this.$childViewContainer.attr(S(" BNBWV"), S("u|~4|tpy{mS\f@QADBDZ\\GI_\x00I]YUP_SQWU^^NN]2$#''73**:g,>$*b") + this.collection.length);var e = this.$childViewContainer.prop(S("%UDZFFG{DJ[X")) - this.$childViewContainer.width();e && this.$childViewContainer.scrollLeft(e);
	          }, focus: function focus() {
	            this.ui.container.focus(), setTimeout(function () {
	              window.scrollTo(0, 0);
	            }, 0);
	          } });return o;
	      }), CKFinder.define(S("C\x00.&-/9c\x00!+%=7 {9;<<((s,:\b"), [S('"IUPCUQ'), S("sspwyy}"), S("\rMDVx|wqg9Zw}owyn1YOMFFVV	qAL]Xo\\JQUQAAXTDnP_L")], function (e, t, n) {
	        "use strict";
	        function i(e, t) {
	          var i = new n({ finder: e, collection: t });return e.on(S("@1#$!5/'>p-$ "), function () {
	            e.request(S('C4$!"r(./()&??'), { page: S("*fMD@"), name: S("s`vuquemtxh"), id: e._.uniqueId(S("$FMA")), priority: 30 }), e.request(S("\r~nwt(`|za^vK|urp"), { view: i, page: S("(dKBB"), region: S("'J[OJHN\\Z]SA") });
	          }), i;
	        }function r(e, t) {
	          e.on(S("!DLHACUZOGINZJT"), function (e) {
	            var n = [],
	                i = e.data.folder;for (n.unshift({ name: i.get(S('A,") ')), path: i.getPath({ full: !0 }), label: i.get(S('=R^"$.')), folder: i, current: !0 }); i.has(S("\r~nbt|g"));) {
	              i = i.get(S("jznxpk")), n.unshift({ folder: i, name: i.get(S('"MEHC')), path: i.getPath({ full: !0 }), label: i.get(S("2_UWS[")) });
	            }n.unshift({ name: "/", path: "/" }), t.reset(n);
	          }), e.on(S("bta|agurk#issj"), function () {
	            t.reset([]);
	          });
	        }var o = { start: function start(e) {
	            this.breadcrumbs = new t.Collection(), this.breadcrumbsView = i(e, this.breadcrumbs), r(e, this.breadcrumbs);
	          }, focus: function focus() {
	            this.breadcrumbsView && this.breadcrumbsView.focus();
	          } };return o;
	      }), CKFinder.define(S(")i`jD@KUCf@\\ZHXHHY|]S"), [], function () {
	        "use strict";
	        function e(e) {
	          return { folderView: (e & t) === t, folderCreate: (e & n) === n, folderRename: (e & i) === i, folderDelete: (e & r) === r, fileView: (e & o) === o, fileUpload: (e & s) === s, fileRename: (e & a) === a, fileDelete: (e & u) === u, imageResize: (e & l) === l, imageResizeCustom: (e & c) === c };
	        }var t = 1,
	            n = 2,
	            i = 4,
	            r = 8,
	            o = 16,
	            s = 32,
	            a = 64,
	            u = 128,
	            l = 256,
	            c = 512;return e;
	      }), CKFinder.define(S('8zq}USZZ2n, 0*";f\f$ )+=#~<813%+'), [S("0D\\WQGETWK_"), S("\fgzuck"), S("P_Sy||h4QrzzLR\reKIBBZ"), S("W^P~v}i3Pq{EMQ\fv@UH][INxT^J"), S("TS_suxxl0mNFFHV	aGENN^^m@\\]WP@\\YY"), S(':xw{WQ$$0l	*"2$,9d\n""+5#!|<3 +v409;-53'), S("\fNEIyvvf:[x|lv~o2XpLEGQW\ndUMHNH^XCMC"), S("XW[wqDDP\fqQOKYKY_HoL\\"), S("*hgkGATT@aA_[r_BRZZ")], function (e, t, n, i, r, o, s, a, u) {
	        "use strict";
	        function l(e) {
	          var t = this;t.finder = e, t.resources = new r(), e.config.displayFoldersPanel ? (c(t), e.on(S("?4.-/&$4}:,9.8w.9?"), C), e.on(S("#WMIU\\J___BFCE\bU[YRRJJ"), function (t) {
	            t.data.shortcuts.add({ label: t.finder.lang.Shortcuts.folders.expandOrSubfolder, shortcuts: S(e.lang.dir === S("3XAD") ? "<FLV')667)05" : "A9/!#2:;%<1") }), t.data.shortcuts.add({ label: t.finder.lang.Shortcuts.folders.collapseOrParent, shortcuts: S(e.lang.dir === S("@-61") ? "bv~zi_mRNU^" : "D>4./!>\n>?!8-") });
	          }, null, null, 40)) : s.start(e), e.setHandlers({ "folder:openPath": { callback: h, context: t }, "folder:select": { callback: g, context: t }, "folder:getActive": function folderGetActive() {
	              return t.currentFolder;
	            }, "resources:get": function resourcesGet() {
	              return t.resources.clone();
	            } }), e.on(S("7[VWV]SZ%30,6\"<%'((<<"), function (e) {
	            116 !== e.data.response.error.number || e.data.context.silentConnectorErrors || (e.cancel(), e.finder.request(S("'L@KGCJF^W]"), { msg: e.finder.lang.ErrorMsg.MissingFolder }), e.finder.request(S("\rh`|uwa.zfrvI{ot"), { path: e.data.context.parent.get(S("9JZNXPK")).getPath({ full: !0 }), expand: !0 }));
	          }, null, null, 5), e.on(S(",NAB]P\\WPDEWK\x00iYS_R%-/  4"), b, null, null, 5), e.on(S(";_RSR!/&y!74(:s. (:*>>71'"), b, null, null, 5), e.on(S("+OBCBQ_V	QGDXJyIY\\JZ..'!7"), b, null, null, 5), e.on(S('@"-.)$(#r,89#?t\b5%:80%'), function (e) {
	            116 === e.data.response.error.number && e.cancel();
	          }, null, null, 5), e.on(S("~qrM@LGJMaGC_"), p, t), e.on(S("0W]_PPD\rS\\C_SJP"), x, t), e.on(S("\fkactt`)qmfvv}"), v, t), e.on(S("|noRVBVQ"), w, t), e.on(S("2P[X[VV]\x00ZZI[Mz'7**#-;9"), y, t), e.on(S("aqfybjzh&nvpW"), function () {
	            t.currentFolder = null;
	          }), e.on(S('>Y/-&&65"$,)?))'), function (t) {
	            e.request(S("cwvvy}o$mERGW"), { name: S('"nELH'), event: S("{qsDDP"), context: { folder: t.data.folder } });
	          }), e.on(S('E3.r:="<(<&79&'), function () {
	            e.request(S("@1#$!%2:;/%8")) === S(" lCJJ") && e.request(S("\r{f*vwgYzrr")) !== S("'LLY@XB^") && e.request(S("$UGIMED\\H@"), { name: S("%@HDMOY_") });
	          }, null, null, 20), e.request(S("pyd$sIRVFJ"), { key: u.f8 }), e.on(S("rbxriq") + u.f8, function (n) {
	            e.util.isShortcut(n.data.evt, S("AMV")) && (e.config.displayFoldersPanel ? (n.finder.request(S("gyww&rnzN"), { name: S("'NFFOI_]") }), n.data.evt.preventDefault(), n.data.evt.stopPropagation(), t.view.$el.focus()) : s.focus());
	          }), e.on(S("-]G_CFPAAE\rTPIOZ[Q%3#/"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.focusFoldersPane, shortcuts: S("-UN\\EOOSJ") });
	          }, null, null, 30), e.on(S("8JRTNI]J42x/-62"), function (e) {
	            e.data.groups.add({ name: S("6QWU^^NN"), priority: 30, label: e.finder.lang.Shortcuts.folders.title });
	          });
	        }function c(e) {
	          var n = e.finder,
	              i = new o({ finder: n, collection: e.resources });e.view = i, i.on(S("(JBB@IXFUF\bU[YRRJ_CL\\P["), function (e, t) {
	            n.fire(S(";ZRR[%3x&<5'),"), { view: t.view, folder: t.view.model }, n);
	          }), i.on(S("'KACGH[GJGT\\XQSEZVR_V"), function (e, t) {
	            n.request(S("uwxxl%SDNFGQ"), { folder: t.view.model });
	          }), i.on(S("C'-/+,?#.;w( <57!n699,<\"/180*"), function (t, n) {
	            n.evt.preventDefault(), e.finder.request(S("9YTRI[G4\f'-1"), { name: S("3RZZS]K"), evt: n.evt, positionToEl: n.view.ui.label, context: { folder: n.view.model } });
	          }), i.on(S("CIKO@SOB_LD@IK]\nZWJPZAY"), function (e, t) {
	            return t.evt.keyCode === u.enter || t.evt.keyCode === u.space ? (n.request(S('\'NFFOI_\x14\\U]WP@'), { folder: t.view.model }), t.evt.preventDefault(), void t.evt.stopPropagation()) : void n.fire(S(" GMO@@TCLSOCZ@"), { evt: t.evt, view: t.view, folder: t.model, source: S("5PXT]_IOILZ%") }, n);
	          }), i.on(S('D&..$-<"):t)?=66&o2%7)'), function (e, t) {
	            n.fire(S("A$,(!#5r-8$<"), { evt: t.evt, folder: t.model, view: t.view }, n);
	          }), i.on(S(" JGZ@JQI]KI"), function (e) {
	            this.finder.request(S(this.finder.util.isShortcut(e, "") ? "#BJER[DNTY" : "2U[VCDIH^J"), { node: this.$el, event: e });
	          }), n.on(S("~qqTDZWi@HROEGHH\\"), function (e) {
	            e.data.groups.add({ name: S("/UU[G") });
	          }, null, null, 10), n.on(S("B\"45|+'(..("), function () {
	            function i() {
	              t(S("/kUSGUU\\^JZ[X\r +-ffi= g;-#+#}& 2$%3%")).css(n.lang.dir === S(".CDC") ? { "margin-right": "", left: "" } : { "margin-left": "", right: "" });
	            }function r() {
	              t(S("A}i2CJDTDABgJEC\frGZEWY]ULN\\NO%3")).css(n.lang.dir === S("\ngx") ? { "margin-right": n.config.primaryPanelWidth, left: n.config.primaryPanelWidth } : { "margin-left": n.config.primaryPanelWidth, right: n.config.primaryPanelWidth });
	            }function o() {
	              a.isOpen() ? a.$el.removeAttr(S("&FZ@KDDJKU_")) : a.$el.attr(S('"BVLG\n@@NOIC'), S(")^YYH"));
	            }var s = !1,
	                a = n.request(S("'XHDN@M]UPFV"), { name: S(":]SQZZ22"), view: e.view, position: S("jiupmY"), scrollContent: !0, panelOptions: { animate: !1, positionFixed: !0, dismissible: !1, swipeClose: !1, display: S("caf~"), beforeopen: function beforeopen() {
	                  r(), s = !0;
	                }, beforeclose: function beforeclose() {
	                  i(), s = !1;
	                } } });n.on(S("0ASTQE_WN\x00v]TP"), function () {
	              a.$el.addClass(S('E%,.d,$ )+=#|"2:0:')), n.config.primaryPanelWidth || a.$el.addClass(S("'KBLJBBKUCADTXRT^^Z\\KS4")), n.request(S("!WJBCSeFNN")) === S("'LLY@XB^") ? a.$el.removeAttr(S("/QC[R]_S\\\\T")) : o(), n.on(S('D0/}:,9"6('), function (e) {
	                e.data.modeChanged && o();
	              });
	            }), n.config.primaryPanelWidth && (n.on(S("n~GDPLJQeHCE"), function () {
	              n.request(S("zy+uv`Xys}")) === S("A&&7.2(8") && r();
	            }), n.on(S("4@_\rJ\\IRFX"), function (e) {
	              if (e.data.modeChanged) {
	                var t = n.request(S("\fxg5wtf^{qs"));t === S("5RRKRNTL") && r(), t === S("\nfcogcu") && (s ? r() : i());
	              }
	            })), n.on(S("n~GDKMACeHCE"), function () {
	              a.$el.removeClass(S("4V]Q_UWXXLLm1#-!)"));
	            });
	          });
	        }function d(e, t, i, o) {
	          function s(t) {
	            if (t.error) {
	              var n = e.resources.findWhere({ name: f.get(S("3FPEXMKY^hDNZ")) });return n.get(S("2P\\\\ZSJ\\T")).reset(), void u.request(S("i}vvf/ert|yo"), { folder: n });
	            }f.set(S("9[XP"), a(t.currentFolder.acl)), f === u.request(S('E ($-/9v*+;2&:"0')) && u.request(S(",YA@\\SSAGSD]M"), { name: S("E&!'"), event: S("2U[YRRJ"), context: { folder: f } });
	          }var u = e.finder,
	              l = i.replace(/^\//, "").split("/").filter(function (e) {
	            return !!e.length;
	          }),
	              c = t,
	              d = c;l.length && (c.set(S("=WL$,'-+!"), !0), l.forEach(function (e) {
	            var t = new n({ name: e, resourceType: c.get(S("*YI^AZBRWgMES")), hasChildren: !0, acl: a(0), isPending: !0, children: new r(), parent: d });d.get(S("6TPPV_NXP")).add(t), d = t;
	          }));var f = d;e.currentFolder && e.currentFolder.cid !== f.cid && e.currentFolder.trigger(S("8]_HYQ[\\4$&")), e.currentFolder = f, u.request(S("6TWTWZRYL%/&"), { name: S("VwgRzzs}ki"), folder: f, context: { silentConnectorErrors: !0, parent: f } }).done(s), f.trigger(S("3GPZR[M__")), u.fire(S('D#)+,,8q?("*3%77'), { folder: f }, u), l.length || f.set(S("ybBvzqy"), !1, { silent: !0 }), o && f.trigger(S(")_BHV_Q_V"));
	        }function f(e, t, n, i, r) {
	          function o() {
	            var o = n.replace(/^\//, "").split("/");if (o.length) {
	              var s = t.get(S("6TPPV_NXP")).findWhere({ name: o[0].toString() });s ? f(e, s, o.slice(1).join("/"), i, r) : r || (u.request(S("%@HDMOY^KCURF"), { folder: t }), i && t.trigger(S("jIG[TDHC")));
	            }
	          }var s = n.length,
	              u = e.finder,
	              l = t.get(S("5U_QU^IYS")).size() > 0;t.get(S("3]FfRV]SU[")) || t.get(S("'@HYhDDBKBT\\")) && s && !l ? u.request(S("CNONEKB[LDO"), { name: S("B!1\x00($-/9?"), folder: t, context: { parent: t } }, null, null, 30).done(function (e) {
	            e.error || (t.set(S("(HIG"), a(e.currentFolder.acl)), o());
	          }) : o();
	        }function h(e) {
	          var t = e.expand,
	              n = e.expandStubs,
	              i = (e.path || "").split(":");if ("/" === e.path) return void this.finder.request(S("7J\\ITIO]Z3{1++2"));var r;i[1] && (r = i[1]);var o = this.resources.findWhere({ name: i[0] });o || (o = this.resources.first()), n && d(this, o, r, t), f(this, o, r.replace(/\/$/, ""), t, n);
	        }function g(e) {
	          var t = this,
	              n = t.finder,
	              i = e.folder,
	              r = t.currentFolder,
	              o = r && r.cid === i.cid;!o && r && r.trigger(S("DDQFH@ESMM")), t.currentFolder = i, n.request(S("3WZ[ZYW^OXP["), { name: S("VwgRzzs}ki"), folder: i, context: { parent: i } }), i.trigger(S("D6#+-*>.(")), n.fire(S("3RZZS]K\x00HYQ[\\4$&"), { folder: i, previousFolder: r }, n);
	        }function p(t) {
	          function r(t) {
	            return e.extend(t, { path: "/", isRoot: !0, resourceType: t.name, acl: a(t.acl) }), new i(t);
	          }var o = this,
	              s = t.data.response;if (s && !s.error) {
	            var u = s.resourceTypes,
	                l = [];e.isArray(u) && e.forOwn(u, function (e, t) {
	              l.push(r(u[t]));
	            }), o.finder.fire(S("wgsvl|H~orkmCDQF@@HZL"), { resources: l }, o.finder), e.forEach(l, function (e) {
	              e instanceof n || (e = new n(e)), o.resources.add(e);
	            }), o.finder.fire(S("r`vuasE}junn~{l@DWAW"), { resources: o.resources }, o.finder);
	          }
	        }function m(t, i, o) {
	          var s,
	              u,
	              l,
	              c = t.name.toString(),
	              d = i.where({ name: c }),
	              f = { name: c, resourceType: o.get(S(")XN_B[]STfJDP")), hasChildren: t.hasChildren, acl: a(t.acl) };d.length ? (s = d[0], u = {}, l = !1, e.forEach(f, function (e, t) {
	            s.get(t) !== e && (u[t] = e, l = !0);
	          }), l && s.set(u)) : (s = new n(f), s.set({ children: new r(), parent: o }), i.add(s));
	        }function v(e) {
	          e.data.folder.get(S("/XPAp\\\\ZSJ\\T")) && e.data.folder.get(S("lxx~wfpx")).size() <= 0 && e.finder.request(S("(JEFAL@K\nBW]P"), { name: S('*lIYh@\\UWAG'), folder: e.data.folder, context: { parent: e.data.folder } });
	        }function w() {
	          function e(e, n) {
	            t.request(S("w}ppd-wiuL|jw"), { path: e, expand: n, expandStubs: !0 });
	          }var t, n, i, r, o;if (t = this.finder, r = t.config.rememberLastFolder, r && (t.request(S("!QFPQOIOZOIKGAU"), { group: S("1T\\XQSEK"), label: S("0w]_PPDD"), settings: [{ name: S("-BNCEt\\XQSE"), type: S("(ACOHH@") }] }), t.on(S("!DLHACUZOGINZJT"), function (e) {
	            t.request(S('.\\UEFZZRE\rK\\Nm]QKZ'), { group: S("+JBBKUCA"), name: S("6[YJN}SQZZ2"), value: e.data.folder.get(S("2AQFYBJZ_oEM[")) + ":" + e.data.folder.getPath() }), o = t.request(S("oxjkIOEPBCS~HF^I"), { group: S("yOMFFVV"), name: S("4YWDLUWXXL") });
	          })), r) {
	            var s = t.request(S("mzTUKMCV@M]|J@XK"), { group: S("yOMFFVV"), name: S("sARVeKIBBZ") });t.config.displayFoldersPanel && "/" === s || (o = s);
	          }n = t.config.resourceType, i = t.config.startupPath;var a = n;!a && this.resources.length && (a = this.resources.at(0).get(S("w{vy")));var u = r && o ? o.split(":")[0] : a,
	              l = this.resources.where({ lazyLoad: !0 });l.length && l.forEach(function (e) {
	            var n = e.get(S(">Q!,'"));e.set(S("+DL]lXX^WFPX"), !0), e.set(S(" HQsAKBNFN"), !0), n !== u && t.request(S("s~~u{r-k|t"), { name: S(",jK[v^^WQGE"), folder: e, context: { parent: e } });
	          }), r && o ? e(o) : !n && i || 0 === i.search(n + ":") ? e(i, t.config.startupFolderExpanded) : (!n && this.resources.length && (n = this.resources.at(0).get(S("<S_R%"))), e(n + S("<")));
	        }function y(t) {
	          var n = (t.finder, t.data.context.parent),
	              i = t.data.response.folders;n.set(S(")CX|H@KY_U"), !1);var r = n.get(S("xttr{RDL"));if (e.isEmpty(i)) return n.set(S("v~SbJJHATBF"), !1), void (r && r.reset());var o = [];r.forEach(function (t) {
	            e.findWhere(i, { name: t.get(S("?. /&")) }) || o.push(t);
	          }), o.length && r.remove(o), e.forEach(i, function (e) {
	            m(e, r, n);
	          });
	        }function C(e) {
	          function t() {
	            return e.finder.request(S("$POOL^fCIK")) === S("=ZZ3*6,4");
	          }e.data.toolbar.push({ name: S("\\x~eU{yrrjj"), type: S('"AQQRHF'), priority: 200, icon: S("2P_SZ]WO"), label: "", className: S('ofh"v~~wqge:lv}|px'), hidden: t(), onRedraw: function onRedraw() {
	              this.set(S("=VV$%'-"), t());
	            }, action: function action() {
	              e.finder.request(S('E6&&,&q8")(<4'), { name: S("%@HDMOY_") });
	            } });
	        }function x(e) {
	          var t = e.data.folder;(e.data.evt.keyCode === u.space || e.data.evt.keyCode === u.enter) && (e.data.evt.preventDefault(), e.data.evt.stopPropagation(), this.finder.request(S('A$,(!#5r&:."/;8'), { path: t.getPath({ full: !0 }) }));
	        }function b(e) {
	          if (116 === e.data.response.error.number) {
	            e.cancel(), e.finder.request(S('E".)%%,v$ )?'), { msg: e.finder.lang.ErrorMsg.MissingFolder });var t = e.data.context.folder,
	                n = t.get(S("\r~nbt|g"));n.get(S("/SY[_PGSY")).remove(t);var i = e.finder.request(S("(OEGHH\\WTFrWA_A]"));i === t && e.finder.request(S("(OEGHH\\_AW]dTB_"), { path: n.getPath({ full: !0 }), expand: !0 });
	          }
	        }return l;
	      }), CKFinder.define(S("oyej>cjdJJACU}OF\\AO[UBfDYYV\\SWY{QM-n3(*'# &.\n\"<\"~5='"), [], function () {
	        return S('"@LPKEKX_\fZYQ\\ZASYL15XP2,b&*&2>8,wi!8";9!3! z08*4w?=)?}@\f\f\nZJON\x00HT\fDZ\bSó¯ëåöäëâ¨ô÷©¬ìíûùþü®¶îíª¸ðîµéïò¿ÝÜ®¬¯ÄÈÈÎÀÈÀÂÈÏÞÌÓßÏ×Ñ°´¶ã¹¸äù³²÷ë¥¹à£±¿µý¥º¸¹½¾°¸½«¬ÃÚÈÓäæùøÎÖÁß-sgptjhtao)2.w}c6ttxih!?}tF\fWSHJGCOEYA\x00^NBE\r><?>10RRMKK`(&~f>=zh >e%)=a9?"& u+*zy.",8c}\bFE\b\fWI\x00PM~|~qEU@u¸áïñ¨êæêÿþ³­óúô¾áåúøùý·ýóïó²ÐÀÐ×¬®¡ £¢ÏÛÛÄÞÜÀÌÆÒØÎÈÉÑÑâá¦¢°¤ë®¦¥£¥©ðì»¢¤·ñô±·£¹ô·²²´ãýÆÅÇÒÒÙÛÄÀÞt/nbjb(RxeejhOzaSp|pqy6je%5yiijpN(*-,/.K__XB@DHBV	EBZTSOZ^4 o**)/)-th?>8+mp53\'5x;>60gy(/+:BAKVN	]UFF\\\nQìàìäªÐöëçèîØéãê¯íì®¼öàâã÷÷¤ÆÊÒ¬®¡ ÈÄØº¸ÒÚÄÚ³³ÕÛÌÞ­¤âª øä¼³ôê¢¸ã§«£ÿ»µ¦´»²ø¤§ùü³¿²ÜÀØÆÇÃÔÕØÃÝdhqshd=ffdn.-znrX|wqm+55(8;}qrpWuPBJVVFZLDHU\f[BDWNM\bPNUN}J35-.\x00*+&!\'j61m==3lp95#7$;+3+(g(0	JK\b\x00DDY	TTEïâ÷îáëò©ìæçêåã³¨ëê¯³ýá¸ó÷ôûòò½ãâÆÌÇÐËÂÆÝÏÉÞÚÝßÈÈÇÆÂ½ÿþì­£´¦¥¬ôÁðâª¦¦ïØ');
	      }), CKFinder.define(S("0ryu][RRJwTXHRZ3n,6(7$&+/c'*'\"}$996<3791-\r7"), [S('E3),,88/"<*'), S("'kblBBIK]dFZX}RAzU_Y"), S(";vxV.%'1k/\"?:e	->+`%7><3 "), S("*_IUZsztZZQSEm_VLQ_K%2m4))&,#')!==~#8:7306>2,2N\r")], function (e, t, n, i) {
	        "use strict";
	        var r = n.extend({ name: S(".z@]]RPs_[]UIQ"), template: i, className: S("}tF\fWSHJGCOEYA"), attributes: { tabindex: 20 }, ui: { cancel: S("\niyyz`~Jfjdp+5zlnoss<B"), input: S("A+-402<0:.qo(&<4p"), submit: S("4WCCLVT`HDNZ}c16&(/3j"), form: S(",KA]]") }, events: { "click @ui.cancel": function clickUiCancel() {
	              this.destroy();
	            }, submit: function submit() {
	              this.trigger(S("ST@NMQ"));
	            }, click: function click(e) {
	              e.stopPropagation();
	            }, "keydown @ui.input": function keydownUiInput(e) {
	              e.keyCode === t.left && (this.ui.submit.focus(), e.stopPropagation()), e.keyCode === t.right && (e.stopPropagation(), this.ui.cancel.focus());
	            }, "keydown @ui.cancel": function keydownUiCancel(e) {
	              e.keyCode === t.left && (e.stopPropagation(), this.ui.input.focus()), e.keyCode === t.right && (e.stopPropagation(), this.ui.submit.focus());
	            }, "keydown @ui.submit": function keydownUiSubmit(e) {
	              e.keyCode === t.left && (e.stopPropagation(), this.ui.cancel.focus()), e.keyCode === t.right && (e.stopPropagation(), this.ui.input.focus());
	            }, keydown: function keydown(e) {
	              return e.keyCode === t.tab && (this.finder.util.isShortcut(e, "") || this.finder.util.isShortcut(e, S("bzzra"))) ? void this.finder.request(S(this.finder.util.isShortcut(e, "") ? '?&.!67("0=' : ")LDOX]@CWE"), { node: this.$el, event: e }) : ((e.keyCode === t.right || e.keyCode === t.home) && this.ui.input.focus(), void ((e.keyCode === t.left || e.keyCode === t.end) && this.ui.submit.focus()));
	            } }, templateHelpers: function templateHelpers() {
	            var t = this.finder.request(S("|tpy{mFGWeFRN^L"));return { ids: { iframe: e.uniqueId(S("v}q5")), cid: this.cid, input: e.uniqueId(S("-MDV")) }, domain: "", isCustomDomain: !1, url: this.finder.request(S("4VYZUXT_HLS"), { command: S("(oCGIx^C_PV"), folder: t, params: { asPlainText: !0 } }) };
	          }, onShow: function onShow() {
	            var e = this,
	                t = navigator.userAgent.toLowerCase().indexOf(S("*_^DJJ^E")) > -1;t || this.finder.config.test || this.ui.input.trigger(S('=]S)")'));var n = this.$el.find(S("9S]N\\SZ"));n.load(function () {
	              var t = n.contents().find(S("(KEOU")).text();if (t.length) {
	                var i;try {
	                  i = JSON.parse(t);
	                } catch (r) {
	                  i = { error: { number: 109, message: t } };
	                }e.trigger(S("jPMMB@TB[YEE_H"), i);
	              }
	            });
	          } });return r;
	      }), CKFinder.define(S("^UYIOFFV\nkHL\\FN_h@B\\gCXZWSUIQhNS/ &"), [S(">J.%'17&)5-"), S("ZQ]uszzRoL@PJB[lD^@{_\\^SWc_ROJnLQQ^$+/!)5%#.;")], function (e, t) {
	        "use strict";
	        function n(n) {
	          function i() {
	            r && r.destroy(), r = null;
	          }var r;n.hasHandler(S("8LJWS\\Z")) || (n.on(S("\r~nwt(pfpwc}#Wzus"), function () {
	            n.request(S("<M_X%{#' # !&$"), { page: S("*fMD@"), name: S("imrpAE"), id: e.uniqueId(S("u|~4")), priority: 20 });
	          }), n.setHandler(S('@42/+$"'), function () {
	            r = new t({ finder: n }), r.on(S("6DM[WRH"), function () {
	              n.request(S("rpAEGQVNH_"), { text: n.lang.UploadProgressLbl });
	            }), r.on(S("&RXEEJH\\JCA]]GP"), function (e) {
	              var t = !!e.uploaded;i(), n.request(S("E*()-/9v%'+5")), e.error && n.request(S("\rjfq}}t.|xqw"), { msg: e.error.message }), t && (n.once(S("FNNGAW@M]lB@H]QWFVF"), function () {
	                var t = n.request(S("%@NDLYKHZlEC@VZA")),
	                    i = t.where({ name: e.fileName });if (i.length) {
	                  n.request(S("r|zrk#i~px}k"), { files: i });var r = i[i.length - 1];r.trigger(S(" GM@QV"));
	                }
	              }), n.request(S("?&..'!7|5-/8.?%\b&<4!")));
	            }), n.request(S("%VFOLXDBYf^cWT]ZX"), { view: r, page: S("Wzus"), region: S("5CGTV[_") });
	          }), n.on(S("qwu~~n'mzLDAWAA"), function (e) {
	            r && !e.data.folder.get(S("ns}")).fileUpload && i();
	          }));
	        }return n;
	      }), CKFinder.define(S("1qxr\\XS]KvSYKS%2m0(*r9&$-)a%4'6"), [S("hp{ESQ@KWC"), S("prw~txv|")], function (e, t) {
	        "use strict";
	        function n(e, t) {
	          e.items.length ? (e.state.set(S("E%2:;/%8:*="), e.state.get(S("lec`vza_c}t")) + 1), i(e.items.shift(), e, t)) : (e.state.set(S("4VCEJ\\TOuI[R"), e.state.get(S("aycyu\\rpxm"))), e.state.set(S("E/4=+98(*"), !1), e.state.trigger(S("gayg")));
	        }function i(e, t, n) {
	          var i = new XMLHttpRequest();e.set(S("evm"), i), i.upload && (i.upload.onprogress = function (n) {
	            var i = n.position || n.loaded;e.set(S("+ZLBZU"), Math.round(i / n.total * 100)), t.state.set(S('@"716 (3=/&4:*#'), i);
	          }), i.onreadystatechange = function () {
	            4 === this.readyState && r(t, e, this, n);
	          };var o = new FormData();i.open(S("*[C^Z"), n, !0), o.append(S("<HNS/ &"), e.get(S("=XV,$"))), i.send(o);
	        }function r(e, t, i, r) {
	          var a = e.state,
	              u = { totalFiles: a.get(S('?4.6"(/+-:')), totalBytes: a.get(S("cwm{w^djzS")), processedFiles: a.get(S("knr}zSRGGbLJB[")), processedBytes: a.get(S("hkuxynmzDc[WAV")), errorFiles: a.get(S("%CUZFXmEAK\\")), errorBytes: a.get(S("3QGDXJ{COYN")), uploadedFiles: a.get(S("imrpAEGGbLJB[")), uploadedBytes: a.get(S("ljws|zzDc[WAV")), currentItem: a.get(S("=]J23'-0\f2\"%")), currentItemBytes: 0 },
	              l = o(u, i, e, t.get(S("<[WS%")).size);s(e, t), a.set(l.state), t.set(l.item), t.trigger(S("<YQQ%")), n(e, r);
	        }function o(e, t, n, i) {
	          var r = !1,
	              o = {};if (t.responseType || t.responseText ? (e.processedFiles = e.processedFiles + 1, e.processedBytes = e.processedBytes + i) : (e.totalFiles = e.totalFiles ? e.totalFiles - 1 : 0, e.totalBytes = e.totalBytes ? e.totalBytes - i : 0, e.currentItem = e.currentItem ? e.currentItem - 1 : 0), t.responseText) try {
	            r = JSON.parse(t.responseText);
	          } catch (s) {
	            r = { uploaded: 0, error: { number: 109, message: n.finder.lang.UploadUnknError } };
	          }return r && (r.uploaded && (o.uploaded = !0, e.uploadedFiles = e.uploadedFiles + 1, e.uploadedBytes = e.uploadedBytes + i, e.lastUploaded = r.fileName), r.error && (o.uploadMessage = r.error.message, r.uploaded ? o.isWarning = !0 : (o.isError = !0, o.state = S(" DPQKW"), o.value = 100, e.errorFiles = e.errorFiles + 1, e.errorBytes = e.errorBytes + i))), { item: o, state: e };
	        }function s(t, n) {
	          var i = e.indexOf(t.items, n);i >= 0 && t.items.splice(i, 1);
	        }var a = { totalFiles: 0, totalBytes: 0, uploadedFiles: 0, uploadedBytes: 0, errorFiles: 0, errorBytes: 0, processedFiles: 0, processedBytes: 0, currentItemBytes: 0, currentItem: 0, isStarted: !1, lastUploaded: void 0 },
	            u = function u(e) {
	          this.finder = e, this.state = new t.Model(a), this.items = [];
	        };return u.prototype.getState = function () {
	          return this.state;
	        }, u.prototype.add = function (t) {
	          var n = this,
	              i = 0,
	              r = 0,
	              o = 0;e.forEach(t, function (e) {
	            var t = e.get(S("5P^T\\")).size;i += t, e.get(S("%OTm[XD^")) ? (r += t, o += 1) : n.items.push(e);
	          }), this.state.get(S("qjIo}ojzD")) ? this.state.set({ totalFiles: this.state.get(S("9NTH\\Ry)-'0")) + t.length, totalBytes: this.state.get(S("cwm{w^djzS")) + i, errorFiles: this.state.get(S("3QGDXJSWYN")) + o, errorBytes: this.state.get(S("7]KHTNGK%2")) + r, processedFiles: this.state.get(S("0A@\\WPED]]|RPXM")) + o, processedBytes: this.state.get(S("+\\_ALUBAVPwOC]J")) + r }) : (this.state.set({ totalFiles: t.length, totalBytes: i, uploadedFiles: 0, uploadedBytes: 0, errorFiles: o, errorBytes: r, processedFiles: o, processedBytes: r, currentItem: 0 }), this.start());
	        }, u.prototype.start = function () {
	          this.state.get(S("zgFbvjm")) || this.state.trigger(S("'[]KYX")), this.state.set(S("piHh|lkEE"), !0);var e = this.finder.request(S(",NAB]P\\W@D["), { command: S('+jDBJeA^\\UQ'), folder: this.finder.request(S("1T\\XQSE^_O}^JV6$")), params: { responseType: S("A(0++") } });n(this, e);
	        }, u.prototype.cancelItem = function (e) {
	          var t = e.get(S("gHS"));if (t) return void t.abort();s(this, e);var n = this.state,
	              i = e.get(S("|rpx")).size,
	              r = n.get(S("jpT@NeMICT")),
	              o = n.get(S(".[_ES_vLBRK"));n.set({ totalFiles: r ? r - 1 : 0, totalBytes: o ? o - i : 0 }), n.get(S("edx{|ihyyXvLDQ")) === n.get(S("5BXLXV}UQ[L")) && n.trigger(S("+_YA_"));
	        }, u.prototype.cancel = function () {
	          var t = this.items;this.items = [], e.forEach(t, function (e) {
	            this.cancelItem(e);
	          }, this), this.state.set(a);
	        }, u;
	      }), CKFinder.define(S('!ahbLHCM[fCI[CUB{@XZmIVT]Yr/%\'/7j7$&+/""#52&:;;'), [S("2QUV]UWW_")], function (e) {
	        "use strict";
	        var t = e.Collection.extend({ comparator: function comparator(e, t) {
	            return e.get(S("qjInqpmY")) ? -1 : t.get(S("0XA`AX[VJ@")) ? 1 : 0;
	          } });return t;
	      }), CKFinder.define(S('8zq}USZZ2n, 0*";f?!!{ ==20z8<<6(s\b.3\x00*\x00'), [S(":xw{WQ$$0l*+*''e#)+##~!;2$2+*4882")], function (e) {
	        "use strict";
	        var t = e.extend({ defaults: { uploaded: !1, isError: !1, isWarning: !1, uploadMessage: "" } });return t;
	      }), CKFinder.define(S('(]OSX\fmdvX\\WQGc]TJW]I[Lo	6.(p7$&+/c>#?06=&",<7u82*'), [], function () {
	        return S("<_#-#07xd$#/g><!!.4|;'18-,gy3/r(.3\x00\x00E@AHHB*	\bVW\fä¬ë÷áè«èãòñ´ñðõô¯±ûçºüåÒêëõé¼àã¿ÃÊÄÑÕÊÈÉÍÂØÈÃÕÃÀÜÆÎÍÅÄ¶´×óÿ¹¸åå¯³æ¯£§©ã ®½´ò®©éù¿ëçÐÒà¹·©ÀÛÅÆßÙÂÁÑiw<	\r9v'kekx0,l{w?fdyyv|4w~onxEX_N\\_[@BOK}TA@URSEDL4o |Ix$f$$(98qo-$6|'#8:73u0.>1}=4L\b\nE\x00@\fIW\rT\fääæ£¢£¦¦áý¤âÿÈüýÿã²îéµõüþ´ïëðòÿûÈÖÆÉÉÌÓÒÖÑÖÕØÆÝÆóÅÊÖÈÁÀÜ«§ï¶´©©¦¬ä£¿© ãª¢£½¡¯®éª¥ûäçó¼àÕ");
	      }), CKFinder.define(S("?\n**!#5g%/9!+<&>8`'46;?s7:M6		\f%$\n"), [S(")_EHH\\\\S^@V"), S('4v}qQW^^NhV%61l$5"g+2#8:94%'), S("W^P~v}i3^qrMNL\frLCP[zYCJ\\JCBdZQB"), S('(]OSX\fmdvX\\WQGc]TJW]I[Lo	6.(p7$&+/c>#?06=&",<7u82*')], function (e, t, n, i) {
	        "use strict";
	        var r = t.extend({ name: S("BhuuzxQwlThVFI"), tagName: S("6[Q"), attributes: { "data-icon": S("szt>wtxt}u") }, template: i, regions: { progress: S("=\\+'o64))&,d:9#*<*#\"") }, events: { "click .ckf-upload-item": function clickCkfUploadItem(e) {
	              e.preventDefault(), this.trigger(S("!WSHJGCJKEOHB"));
	            } }, ui: { items: S("D$h$#/g><!!.4|;'18"), msg: S("\f#mdv<gcxzws5tho|yz"), split: S("(I@J\x00[_\\^SW\\BRUXNHIQQ") }, modelEvents: { "change:uploaded": function changeUploaded() {
	              this.setStatus(S("8VQ")), this.setHideIcon();
	            }, "change:isError": function changeIsError(e, t) {
	              this.ui.msg.removeClass(S("\nhgk#gyuvvz")).text(e.get(S("z`}}rpXsdkx}~"))), t && this.setStatus(S("#AWTHZ"));
	            }, "change:isWarning": function changeIsWarning() {
	              this.ui.msg.removeClass(S("ts7suyzzN")).text(this.model.get(S("5CGTV[_qXML!&'"))), this.setHideIcon();
	            } }, onRender: function onRender() {
	            this.setTitle(), this.progress.show(new n({ finder: this.finder, model: this.model })), (this.model.get(S("ljws|zzD")) || this.model.get(S("?)216*4"))) && this.setHideIcon();
	          }, setStatus: function setStatus(e) {
	            this.isDestroyed || this.ui.items.addClass(S("9YPZKO,.#'i,2\"%d") + e);
	          }, setHideIcon: function setHideIcon() {
	            this.isDestroyed || (this.$el.attr(S("@%#7%h/$''"), S("D&-!e=#('")), this.ui.split.addClass(S("6BQSXSS\\+'o7-&-")), this.setTitle());
	          }, setTitle: function setTitle() {
	            var e = this.model.get(S("$PVKGHNNH")) || this.model.get(S("wleSPLV")) ? this.finder.lang.CloseBtn : this.finder.lang.CancelBtn;this.isDestroyed || (this.ui.split.attr(S("\fio{q<qxr8b~lu"), e), this.updateSplitTitle());
	          }, updateSplitTitle: function updateSplitTitle() {
	            this.isDestroyed || this.ui.split.attr(S("%RN\\EO"), this.ui.split.attr(S("*OMYOSZT@\\B[]")));
	          } });return r;
	      }), CKFinder.define(S('\x0Bxhv{1RYU}{rrj6N~qmr~TDQ\flQKK\x1D|ZGCLJ\0eA^\\UQpXJT\x14_SI'), [], function () {
	        return S(">$(4c $2&e;%')pl!1'02&wv448)(a=4L\b\nE\rQYT\x00A]®òõâðæî§õô¨«øììæþõ÷ë©·¤§º§ ù÷éÂÎÂ×ÖÝÀÈÃÃÚÊÞÅ¾¼¿ÜÐÌßÑßÌ³üà ¯£ë²¸¥¥ª¨àª½¿¡¨¼º°û°ª°¾ùâ××ÖéÝÅÖÎÝÚ-fpj`(g%620xv.6nm*8pn5p||zLhFYXKEKX_\fL[WFDYYV\\IO]IKLb98ye/3f%+%+c?<>374424w+02?;3FUERggfyxNT\nGYRõñîìåá«÷úæíùéþý¢äôêç¶« îîþÎÁÏÅÖÕÊÁÍØÞÃßÐÖÄÇÙÐÊÜÉÈÉÛÇ´ì¤ª¨ µåöõå¸¼¬ ñðí¡£µ»ö´´¸©¨áÿ½´ÌÅÜÛÞÃÂÐsqcm:\x006$|3.<p|`) ywi\x00BNBWVKBLY]B@QUWFZFMWW_[OW[m#`}NLONAu#%<8:o$(\"6iw4\",-55~}*>\b\f[EEXHK\b\f]HTW\b\r] åã÷å¨åìî¤èþøùáá­³ó÷ð·¶áùõïþ¡¿åäË×ÉÇÉÏÿÛÀÂÏËñÕÖõÝÙÓÄÄÇ··¶ÉÈþªªµ³³è½³»©ðì­¥¥¦¼º÷ö£¹»³µ¸¸¦âÂÌÓÁÄÄÓÍÞØÛ-bie)gss|fd6.noast~14cw{m|'9gf#?IU\fOEKA	kEEXIoZALO\n??>10RRMKK`5;3!xd%==>$\"on;13;=00.jztky|9?+L\x00[E\fF\b\bQTTP\nôõíí¹§ââüèãçÿ¯®ùñýçö©·íì¥¹óï²ñÿñÇ÷ÓÈÊÇÃìÌÞÊÅÁÝÍÌ¾¼¿¾ÞÒÊ´¶Éýí§­³øÍÁÀö¯¥»î¦´ìð°¿³û¢¨µµº¸ð®­ÄÙÔÆÓäæùÍÕÆÞ-trokdb*agz~x y}qa0-(|xgmm:xp|mlAHB\bSWDFKOD@_EE@LFR\\RPX-4.7-5*\"uk'> 9'?<4pmhz2>.gPR`r:6_h_KVc");
	      }), CKFinder.define(S(">|+-  4h&.> (=`%??a\x00&;78>t\n4;(N7\b\n."), [S("cy||hhrlz"), S("gb}kc"), S("8zq}USZZ2n7-)i\f-0	$(("), S('"`ocOILLXzDKXCpRGP{Y@UNHkWZ7'), S("\nHGKgatt`<Yzrbt|i4TisstROKDB\b~@O\\_{_\\^SWx\\ECqM_V"), S("6C]ANvxV.%'1k#*8%+?)>a$<>f%:89=u,11>'\r	K\b"), S("\fNEIyvvf:Uxutuu3KwzWR\rsVJAUMZY}EHY"), S("<~uy)/&&6j(%$%%c\x00!+5=!|'90*<)(2::\f")], function (e, t, n, i, r, o, s, a) {
	        "use strict";
	        function u(e) {
	          var n;if (e.data) {
	            if (!e.data.modeChanged) return;n = e.data.mode === S("kubyg{e");
	          } else n = e === S("y{lKUMS");t([this.ui.cancelButton, this.ui.detailsButton, this.ui.addButton]).each(function () {
	            this.parent().toggleClass(S("jI\f@WJ\bODGGECYKWD"), !n).toggleClass(S('"VM\bDSFCHCCCUWF'), n);
	          });
	        }var l = i.extend({ name: S("C5*()-\f$> "), template: o, ui: { input: S(";^UYm42/+$\"j!':>8"), dropZone: S('"\rGN@\n]YFDMIKB^BI[[S'), addButton: S("B $2&e*!-a/;;$><nv423z"), cancelButton: S('"x@DRFJAMO[[D^\\VWY[\\Va'), detailsButton: S("Wio{q<qxr8tblmuu!?zzT@KOW{"), status: S("1P_SBHUUZXMK!570"), progressText: S("%\bDCO^\\AANTBA[RDRKJOYEJ"), progressTextFiles: S("2W^PMIVT]YO2.%1!65j<,2?a+'#5\""), progressTextBytes: S('Eh$#/g><!!.4|"!;2$2+*w/9%*r') }, regions: { progress: S("+NEIDB_[TRHKU\\NXML") }, events: { "click @ui.input": S("n{ksUCWQVuBDLI_"), click: function click(e) {
	              e.stopPropagation();
	            }, selectstart: function selectstart(e) {
	              e.preventDefault();
	            }, "keydown @ui.addButton": function keydownUiAddButton(e) {
	              e.keyCode === (this.finder.lang.dir === S("~gf") ? n.left : n.right) && (this.ui.addButton.focus(), e.stopPropagation()), e.keyCode === (this.finder.lang.dir === S("\rb{b") ? n.right : n.left) && (e.stopPropagation(), this.ui.cancelButton.focus());
	            }, "keydown @ui.cancelButton": function keydownUiCancelButton(e) {
	              e.keyCode === (this.finder.lang.dir === S("=RK2") ? n.left : n.right) && (e.stopPropagation(), this.ui.addButton.focus()), e.keyCode === (this.finder.lang.dir === S('"OPW') ? n.right : n.left) && (e.stopPropagation(), this.isDetailsEnabled ? this.ui.detailsButton.focus() : this.ui.cancelButton.focus());
	            }, "keydown @ui.detailsButton": function keydownUiDetailsButton(e) {
	              e.keyCode === (this.finder.lang.dir === S("`g") ? n.left : n.right) && (e.stopPropagation(), this.ui.cancelButton.focus()), e.keyCode === (this.finder.lang.dir === S("\faz}") ? n.right : n.left) && (e.stopPropagation(), this.ui.detailsButton.focus());
	            }, "keydown @ui.dropZone": function keydownUiDropZone(e) {
	              (e.keyCode === (this.finder.lang.dir === S("%JSZ") ? n.right : n.left) || e.keyCode === n.home) && this.ui.addButton.focus(), (e.keyCode === (this.finder.lang.dir === S("}fa") ? n.left : n.right) || e.keyCode === n.end) && (this.isDetailsEnabled ? this.ui.detailsButton.focus() : this.ui.cancelButton.focus());
	            }, "focus @ui.dropZone": function focusUiDropZone(e) {
	              e.target === this.ui.dropZone.get(0) && this.trigger(S('=XP#41y\'-#$#s9(>""#'));
	            } }, templateHelpers: function templateHelpers() {
	            return { swatch: this.finder.config.swatch };
	          }, initialize: function initialize() {
	            this.listenTo(this.model, S('@"*"*"#'), this.updateView), this.finder.on(S("or&o{lI[G"), u, this), this.progressModel = new a(), this.progressModel.stateIndeterminate();
	          }, onRender: function onRender() {
	            this.isDetailsEnabled = !1, this.$el.enhanceWithin(), u.call(this, this.finder.request(S(":NUYZ4\f-'!"))), this.disableDetailsButton(), this.progress.show(new s({ finder: this.finder, model: this.progressModel }));
	          }, updateView: function updateView() {
	            this.ui.progressTextBytes[0].innerHTML = this.formatBytes(this.model.get(S("ihtxmlEE`ZP@U")) + this.model.get(S("zoinxpkiUGNf\\RB["))), this.ui.progressTextFiles[0].innerHTML = this.formatFiles(this.model.get(S("}jRSGMPlRBE"))), this.setStatusProgress(100 * (this.model.get(S(":KNR]Z32''<2\";")) + this.model.get(S("|USPFJQoSMDhRXH]"))) / this.model.get(S("nth|r]YUGP"))), e.isUndefined(this.model.changed.isStarted) || this.model.changed.isStarted || (this.model.get(S("/UC@\\Fs_[]J")) ? this.setStatusError() : this.setStatusOk());
	          }, formatBytes: function formatBytes(e) {
	            return this.finder.lang.UploadBytesCountProgress.replace(S("`~djzStROKDBBLT"), this.finder.lang.formatFileSize(e)).replace(S("/KSKGQFbXLXVF"), this.finder.lang.formatFileSize(this.model.get(S('?4.6"(?3-:'))));
	          }, formatFiles: function formatFiles(e) {
	            return this.finder.lang.UploadFilesCountProgress.replace(S("cswynKoLNCGAA["), e).replace(S("dFHNFWqISIEW"), this.model.get(S("@5-7%)\x00.$,9")));
	          }, onDestroy: function onDestroy() {
	            this.finder.removeListener(S("E3.r;/8%7+"), u);
	          }, setProgressbarValue: function setProgressbarValue(e) {
	            this.progressModel.set(S("\f{ocet"), e), 100 == e && this.model.get(S("5SEJVH}UQ[L")) ? this.progressModel.stateError() : e >= 100 ? this.progressModel.stateOk() : this.progressModel.stateIndeterminate();
	          }, showProgressText: function showProgressText() {
	            this.ui.progressText.css(S("qdhu{b"), "");
	          }, hideProgressText: function hideProgressText() {
	            this.ui.progressText.css(S('"GMVVKIP'), S(":USS["));
	          }, setStatusText: function setStatusText(e) {
	            this.ui.status.html(e);
	          }, setStatusSelect: function setStatusSelect() {
	            this.setStatusText(this.finder.lang.UploadLabel.UploadSelect), this.setProgressbarValue(0), this.hideProgressText();
	          }, setStatusProgress: function setStatusProgress(e) {
	            this.setStatusText(this.finder.lang.UploadLabel.UploadProgress), this.setProgressbarValue(e), this.showProgressText();
	          }, setStatusOk: function setStatusOk() {
	            this.setStatusText(this.finder.lang.UploadLabel.UploadOk), this.setProgressbarValue(100), this.showProgressText();
	          }, setStatusError: function setStatusError() {
	            this.setStatusText(this.finder.lang.UploadLabel.UploadError), this.setProgressbarValue(100), this.showProgressText();
	          }, showUploadSummary: function showUploadSummary() {
	            this.ui.progressTextFiles[0].innerHTML = this.finder.lang.UploadSummary.replace(S("'\r"), this.formatFiles(this.model.get(S("bhuuzxxzYIMGP")))), this.ui.progressTextBytes[0].innerHTML = this.formatBytes(this.model.get(S("mivt}y{{bXVFW")));
	          }, enableDetailsButton: function enableDetailsButton() {
	            this.ui.detailsButton.button(S(")OEMOBJ")).attr(S("ugv5}sh}rzD"), S("8_[WOX")), this.isDetailsEnabled = !0;
	          }, disableDetailsButton: function disableDetailsButton() {
	            this.ui.detailsButton.button(S("zvS@@OA")).attr(S("ASKB	AOTIKFNH"), S(":ONH[")), this.isDetailsEnabled = !1;
	          }, cancelButtonAsCancel: function cancelButtonAsCancel() {
	            this.ui.cancelButton.val(this.finder.lang.CancelBtn).button(S("j||iynv"));
	          }, cancelButtonAsClose: function cancelButtonAsClose() {
	            this.ui.cancelButton.val(this.finder.lang.CloseBtn).button(S('B1!#4";!'));
	          } });return l;
	      }), CKFinder.define(S("\niuz.SZTzzqse7MvlqkER\rkPHJ}YFDMIz@]]RPy_DLjOVQ\\LFn%-7"), [], function () {
	        return S(")r~n9yw}nm\"BIE	PVKGHNEYKBRYU@F[WX^UI[Rm.)c1,k%<'huFDr?p2>2'&ku;2<v)-20O\fHUSO\\4\b üÿ¿«õ¸´¦îâú³");
	      }), CKFinder.define(S("D\r!'..>b 4$>6'z#55o,11>N4\nH=\r	\"!"), [S(',neiY_VVF`^]NI~\\MZo\b6&)/"?'), S("=JZ85c\x00/),,8d(#?<0&6'z#55o,11>N7\b\n$\x00?]")], function (e, t) {
	        "use strict";
	        var n = e.extend({ name: S("%sWDFKO`D][cD_^UGO"), tagName: S("%JN"), attributes: { "data-icon": S("?& .0!") }, className: S(";_VX51.,%!k4=$'*>4"), template: t, modelEvents: { "change:uploadMessage": S("C6 (#-;") } });return n;
	      }), CKFinder.define(S("'kblBBIK]|]WAYSDqNVP\bkO,.#'k/\"?:e<!!.4;  "), [S("9ypzTP[%3m- 14g+8)b\r <=70 <990?,"), S("$fmaAGNN^c@TD^VG~CUUnLQQ^$n*!25h9&$-)&#%'18"), S('@	-+"":f$(8"*#~\'99c(55:8r\b6L1\n\b	\r&=\r')], function (e, t, n) {
	        "use strict";
	        var i = e.extend({ name: S("Fdyyv|Ushh"), template: "", tagName: S("B6("), className: S("5U\\^OKPR_[m-+00"), attributes: function attributes() {
	            return { "data-role": S('@-+003/"?'), "data-split-theme": this.finder.config.swatch };
	          }, initialize: function initialize() {
	            function e() {
	              setTimeout(function () {
	                t.$el.listview().listview(S("=LZ&3'0,")), t.updateChildrenSplitTitle();
	              }, 0);
	            }this.on(S(",LZ[QRZqASPRJ"), e, this), this.on(S("-MGY]VE]PA\rJ\\T_YO"), e, this);var t = this;
	          }, getChildView: function getChildView(e) {
	            return e.get(S(":ROnKR- 0:")) ? n : t;
	          }, updateChildrenSplitTitle: function updateChildrenSplitTitle() {
	            this.children.forEach(function (e) {
	              e.updateSplitTitle && e.updateSplitTitle();
	            });
	          } });return i;
	      }), CKFinder.define(S("P_Sy||h4QrzjLDQ\flQKK|ZGCLJ\x00xE__`F[WX^"), [S("evvffuxj|"), S("XW[wqDDP\fiJBRDLYdYCCdB_[TRiL_NY"), S("\\kgKM@@T\beFN^@H]\x00xE__`F[WX^qRZZ,2m4))&,\n%' (-;9><"), S("2ps_Y\\\\HqRZJ,$1l\f1++}:'#,*`>668&y(55:8*:\r"), S(";vxV.%'1k\b)#=%/8c:\"<d#8:73w3>+.q\n\r\r\x00#	"), S("%eln@DOI_b_UG_QFLTViMRP!%m- 14g:'#,*9\"&"), S(",neiY_VVF{X\\\\VH{WS%")], function (e, t, n, i, r, o, s) {
	        "use strict";
	        function a(e) {
	          var t, n, i;for (i = "", t = S("&**..**&&acagacaobbffb}}cegecmom"), n = 0; n < e.length; n++) {
	            i += String.fromCharCode(t.indexOf(e[n]));
	          }return a = void 0, i;
	        }function u(i) {
	          function s() {
	            i.removeListener(S("#TDHBDE[ICGD\\^AEZXY]"), u), i.removeListener(S("4EWY]U\x00XPRMZz)6.(p37$&+/"), m), w && w.cancel(), w = null, y && y.destroy(), y = null, C && C.destroy(), C = null, x && x.destroy(), x = null, v(), i.request(S("#TDHBDNN_Y\\@I"), { name: S("-F[]]FDYYV\\") }), E = null;
	          }function u() {
	            E && E.$el.find(S("DD@VB	FMA[EGI\fL\\^AVdTXRTg")).focus(), v(), _ = !0;
	          }function m() {
	            y && (y.isDetailsEnabled ? y.ui.detailsButton.focus() : y.ui.cancelButton.focus()), _ = !1;
	          }function v() {
	            b && clearTimeout(b), b = null;
	          }var w,
	              y,
	              C,
	              x,
	              b,
	              E,
	              _ = !1;c() && (i.on(S("k}z{%CSGBP@jI@D"), function () {
	            i.request(S('?0 %&~$"#,-"##'), { page: S("8t[RR"), name: S("5CGTV[_zTRZ3"), id: e.uniqueId(S("2P_S")), priority: 20 });
	          }), i.on(S(".YYTE	`]CZZW[RPNhV%6"), function (e) {
	            var t = e.data.view;t.once(S("h~ry{m"), function () {
	              var e = t.$el;e.on(S("3PGWPWO_I"), function (e) {
	                e.preventDefault(), e.stopPropagation();
	              }), e.on(S(">[2.2"), function (e) {
	                e.stopPropagation(), e.preventDefault(), e.originalEvent.dataTransfer.files.length && i.request(S("*^\\AANT"), { files: e.originalEvent.dataTransfer.files });
	              });
	            });
	          }), i.on(S("i}vvf/ert|yoyy"), function (e) {
	            e.data.folder.get(S(".NS]")).fileUpload || s();
	          }), i.setHandler(S("']YFDMI"), function (c) {
	            v(), p = p || function (e) {
	              return function (t) {
	                return e.charCodeAt(t);
	              };
	            }(a(i.config.initConfigInfo.c));var x = i.request(S("'NFFOI_HUEsP@\\@R"));if (!x) return void i.request(S(",IGN\\^U	][PX"), { msg: i.lang.UploadNoFolder });if (function () {
	              function e(e, t) {
	                for (var n = 0, i = 0; 10 > i; i++) {
	                  n += e.charCodeAt(i);
	                }for (; n > 33;) {
	                  var r = n.toString().split("");n = 0;for (var o = 0; o < r.length; o++) {
	                    n += parseInt(r[o]);
	                  }
	                }return n === t;
	              }f = e(i.config.initConfigInfo.c, p(10));
	            }(), !x.get(S("3UVZ")).fileUpload) return void i.request(S("<YW^,.%y-+ ("), { msg: i.lang.UploadNoPerms });_ = !1;var F = new n();F.summary = null, w = new t(i);var M = w.getState();F.on(S("j|i~h"), function () {
	              y.disableDetailsButton(), F.once(S("2RPQ"), function () {
	                y.enableDetailsButton();
	              });
	            }), function () {
	              function e(e, n, i, r, o, s) {
	                for (var a = window[t.s(S("dATE"))], u = 33, l = i, c = r, d = o, f = s, c = u + (l * f - c * d) % u, d = l = 0; u > d; d++) {
	                  1 == c * d % u && (l = d);
	                }c = e, d = n;var h = 1e4 * (220000036 ^ t.m);return f = new a(h), 12 * ((l * s % u * c + l * (u + -1 * r) % u * d) % u) + ((l * (33 + -1 * o) - 33 * ("" + l * (u + -1 * o) / 33 >>> 0)) * c + l * i % 33 * d) % u - 1 >= 12 * (f[t.s(S(":\\XK{N)+.,="))]() % 2e3) + f[t.s(S(";[YHq+*0,"))]();
	              }var t = { s: function s(e) {
	                  for (var t = "", n = 0; n < e.length; ++n) {
	                    t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
	                  }return t;
	                }, m: 92533269 };h = !e(p(8), p(9), p(0), p(1), p(2), p(3));
	            }(), M.on(S("yo}d"), function () {
	              y.cancelButtonAsCancel();
	            }), M.on(S("jntl"), function () {
	              i.once(S('@"-.)$(#r(,?)?t\b5%:80%'), function () {
	                var e = i.request(S("<[WS%2x$!12:;/%8")).where({ name: M.get(S("`l}{Ea~|uqss")) }).pop();e && e.trigger(S("}s~kl"));
	              }), y.cancelButtonAsClose(), y.showUploadSummary(), i.request(S("+JBBKUC\bAQSDRKQ|RPXM"));var t = !e.isBoolean(i.config.autoCloseHTML5Upload) || i.config.autoCloseHTML5Upload,
	                  n = M.get(S("\rz`dp~U}ysd")) === M.get(S("&RXEEJHHJiY]W@")) && !_;n && t && (v(), b = setTimeout(s, 1e3 * parseFloat(i.config.autoCloseHTML5Upload || 0)));
	            }), M.on(S('A!+%+!"r 98,<;55'), function () {
	              M.get(S('"JWvRFZ]OO')) && v();
	            }), function () {
	              function e(e, t) {
	                var n = e - t;return 0 > n && (n = e - t + 33), n;
	              }function t(e, t, n) {
	                var i = window.opener ? window.opener : window.top,
	                    r = 0,
	                    o = i[S("yytymstr")][S("!JLWQHFEL")].toLocaleLowerCase();if (0 === t) {
	                  var s = S("B321f");o = o.replace(new RegExp(s), "");
	                }if (1 === t && (o = ("." + o.replace(new RegExp(S("EkjiC")), "")).search(new RegExp(S("4i") + n + "$")) >= 0 && n), 2 === t) return !0;for (var a = 0; a < o.length; a++) {
	                  r += o.charCodeAt(a);
	                }return o === n && e === r + -33 * parseInt(r % 100 / 33, 10) - 100 * ("" + r / 100 >>> 0);
	              }g = t(p(7), e(p(4), p(0)), i.config.initConfigInfo.s);
	            }(), i.on(S('@1#-!)|(8,$q$9##e$"?;42'), u), i.on(S('cu{s{"zvtox$wTLNQUJHIM'), m), function () {
	              var e = p(4) - p(0);p(4) - p(0), 0 > e && (e = p(4) - p(0) + 33), d = 4 > e;
	            }(), C = new o({ collection: F, finder: i }), C.on(S("(JBB@IXFUF\bFDYYV\\YZR^[S"), function (e) {
	              e.model.get(S("=KO,.#'!!")) || e.model.get(S("/YBwAFZD")) || w.cancelItem(e.model), C.removeChildView(e), C.children.length || (y.disableDetailsButton(), i.request(S('"SEKCKJFD_H'), { name: S("$MRJD_[@BOK") }));
	            }), C.on(S("C6 (#-;"), function () {
	              C.$el.trigger(S("']YNJXHBNI^GG"));
	            }), M.set(S('?,  &(\f"'), e.uniqueId(S("w~p:txx~p0"))), y = new r({ finder: i, model: M, events: e.extend({}, r.prototype.events, { "click @ui.destroyButton": s, "click @ui.cancelButton": s, "click @ui.addButton": function clickUiAddButton() {
	                  v(), y.ui.input.trigger(S('"@HLEL'));
	                }, "change @ui.input": function changeUiInput(e) {
	                  v(), l(e.dataTransfer && e.dataTransfer.files || e.target.files || [], F, w, i);
	                }, "dragover @ui.dropZone": function dragoverUiDropZone(e) {
	                  e.preventDefault(), e.stopPropagation();
	                }, "drop @ui.dropZone": function dropUiDropZone(e) {
	                  e.stopPropagation(), e.preventDefault(), v(), l(e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.files : [], F, w, i);
	                }, "click @ui.detailsButton": function clickUiDetailsButton() {
	                  E || (E = i.request(S("oAOGOFTBI]O"), { name: S("@)6.(p37$&+/"), position: S("2@QVYY\\XHB"), closeButton: !0, view: C, panelOptions: { positionFixed: !0, display: S("7WO_IP\\G") } })), i.request(S("._Q_W_AYP_U_"), { name: S("|a{{-ljws|z") }), C.$el.listview().listview(S(",_KIBTA["));
	                } }) }), c && c.files || y.on(S(";OUQH"), function () {
	              i.config.test || y.ui.input.trigger(S(")IGENE"));
	            }), i.request(S('B3%"#};!%<#*78=='), { view: y, page: S("#iDOI"), region: S("db{trQquh") }), c && c.files && l(c.files, F, w, i);
	          }));
	        }function l(e, t, n, r) {
	          function o(e) {
	            for (var t = "", n = 0; n < e.length; ++n) {
	              t += String.fromCharCode(e.charCodeAt(n) ^ n + 18 & 255);
	            }return t;
	          }function a(e, t) {
	            e.set({ state: S("~noqm"), isError: !0, uploadMessage: r.lang.Errors[t], value: 100, uploaded: !0 });
	          }var u = [];if (e.length) {
	            var l = r.request(S('E ($-/9v*+;2&:"0')),
	                c = l.getResourceType(),
	                w = c.get(S("5[V@jSAY")),
	                y = r.config.initConfigInfo.uploadCheckImages;if (r.util.asyncArrayTraverse(e, function (e) {
	              var o = new i({ file: e, state: S("-AD"), value: 0 }),
	                  l = s.extensionFromFileName(e.name).toLowerCase();(!s.isExtensionOfImage(l) || y) && e.size > w && a(o, m), c.isAllowedExtension(l) || a(o, v), o.on(S("$FNFFNOY]B@QUWW"), function (e) {
	                e.get(S("qjMznswqG")) || t.remove(e), t.summary || (t.summary = new i({ isSummary: !0, uploadMessage: "" }), t.add(t.summary)), t.summary.set(S("']YFDMIcJCBSTQ"), r.lang.UploadSummary.replace(S('"'), n.state.get(S("<HNS/ && /+-:"))));
	              }), u.push(o);
	            }), !(d && g && f && function () {
	              var e = p(5) - p(1);return 0 > e && (e = p(5) - p(1) + 33), 1 === e;
	            }()) || h) {
	              var C = r.request(S("xvLDQC@Rd][XNBY")).where({ "view:isFolder": !1 }).length,
	                  x = {};x[S(":VOZ")] = [S("1tHE"), S("7D_CLOX"), S("7EL"), S("/DKJCQ"), S("xmz"), S("?4=:27 "), S("after"), S("\rhta"), S("9]XDGIL"), S("moddYB"), S("B4/264;"), S(":"), S("mj"), S(">I688"), S("%Y[XY")][S("al~")](o)[S("1X\\][")](" "), C + u.length > S("<\f") && r.request(S('"GMDJHOCEJB'), x);var b = -(C - S("<\f"));0 > b && (b = 0), u.splice(b, u.length);
	            }n.state.get(S("dKm{ihxz")) || (t.summary && (t.summary = null), t.reset()), t.add(u), n.add(u);
	          }
	        }function c() {
	          var e = new XMLHttpRequest();return !!window.FormData && !!e && !!e.upload;
	        }var d,
	            f,
	            h,
	            g,
	            p,
	            m = 203,
	            v = 105;return u;
	      }), CKFinder.define(S(">|+-  4h&.> (=`4+=&\"26<(t8'	\n\x00"), [S("']GNN^^M@BT"), S("/Z@GVFL")], function (e, t) {
	        "use strict";
	        function n(n) {
	          this.finder = n;var i = {};t(S(",OAKI")).on(S('E-"1-%<"'), function (t) {
	            var r = t.keyCode;e.has(i, r) && n.fire(S("+GHWK_F\\	") + r, { evt: t }, n);
	          }).on(S("v{fUQ"), function (t) {
	            var r = t.keyCode;e.has(i, r) && n.fire(S("D.#>=9p") + r, { evt: t }, n);
	          }), n.setHandler(S('B(!<|+!:>."'), function (e) {
	            i[e.key] = !0;
	          }), n.setHandler(S("*@ITCYBFVZECWI"), function (e) {
	            delete i[e.key];
	          });
	        }return n;
	      }), CKFinder.define(S("7{r|RRY[Mo\f-'1)#4g%*((<`>371'"), [S("6BV]_IO^QM%"), S("=TN5$0:")], function (e, t) {
	        "use strict";
	        function n(n) {
	          function i() {
	            n.config.loaderOverlaySwatch && t(S(";zq}1qq~DDPKSCUDHS")).remove();
	          }this.finder = n, n.setHandlers({ "loader:show": function loaderShow(r) {
	              i(), t.mobile.loading(S("9ISSJ"), { text: r.text, textVisible: !!r.text, theme: n.config.swatch });var o = n.config.loaderOverlaySwatch;o && t(S("!GMSNL\bHGKC_PVVFYA]KVZE\\, 10yg3.e9%;9=c<3#76:u?9zgft84(a")).addClass(S(">J)l-5!7*&1d") + (e.isBoolean(o) ? n.config.swatch : o)).appendTo(S("p|pl")), t(S(":`:tv{yo")).find(S("r*")).attr(S('C6**"'), S("4TZRJM"));
	            }, "loader:hide": function loaderHide() {
	              t.mobile.loading(S("1ZZPP")), i();
	            } });
	        }return n;
	      }), CKFinder.define(S("#gn`NFMOY`AKE]W@xWOQTSAYs^8(/*> "), [S("&RFMOY_NA]U"), S("\na}xk}i"), S("4WWTS[UUY")], function (e, t, n) {
	        "use strict";
	        function i(e) {
	          if (!e.util.isPopup() && !e.util.isModal() && !e.util.isWidget()) return void e.setHandlers({ isMaximized: function isMaximized() {
	              return !0;
	            } });e.util.isPopup() || e.on(S("'\\FEGNL\\BTAV@{VQW\x00]SQZZ2"), function (i) {
	            var r = new n.Model({ name: S(",`OWY\\[IQ"), type: S("1PF@AYY"), alignment: S("\r~}y|sam"), priority: 30, icon: S(t ? "\nhgk#by{~}os" : 'A!("h+&0 \'"6('), label: t ? e.lang.Maximize.minimize : e.lang.Maximize.maximize, action: function action() {
	                r.set(S("~vyno"), !0), e.request(S(t ? "6ZQWSVUG[" : "9WZDTSV:$")), r.set(S("uws{"), t ? e.lang.Maximize.minimize : e.lang.Maximize.maximize), r.set(S("<T]P."), S(t ? "&DCOFECGBYKW" : "\rmdv<rl|{~b|"));
	              } });i.data.toolbar.push(r);
	          });var t = !1,
	              i = r(e);e.setHandlers({ maximize: function maximize() {
	              i.max(), t = !0, e.fire(S('"NE]OJASOO'), null, e);
	            }, minimize: function minimize() {
	              i.min(), t = !1, e.fire(S(",@GAY\\[IQQ"), null, e);
	            }, isMaximized: function isMaximized() {
	              return t;
	            } });
	        }function r(e) {
	          function n() {
	            c.popup = { x: u.screenLeft || u.screenX, y: u.screenTop || u.screenY, width: u.outerWidth || u.document.body.scrollWidth, height: u.outerHeight || u.document.body.scrollHeight }, u.moveTo(0, 0), u.resizeTo ? u.resizeTo(u.screen.availWidth, u.screen.availHeight) : (u.outerHeight = u.screen.availHeight, u.outerWidth = u.screen.availWidth);
	          }function i() {
	            var e = c.popup;u.resizeTo ? u.resizeTo(e.width, e.height) : (u.outerWidth = e.width, u.outerHeight = e.height), u.moveTo(e.x, e.y), delete c.popup;
	          }function r() {
	            t(l.document).css({ overflow: S("@)+'  ("), width: 0, height: 0 }), c.frame = t(u.frameElement).css([S("6GWJSOURP"), S("{}n"), S("jpP"), S(">H)%6+"), S("\fekfwyf")]), t(u.frameElement).css({ position: S("scyy"), top: 0, left: 0, bottom: 0, right: 0, width: S("-\x00"), height: S("%%&2"), "z-index": 9001 }), l.scrollTo(0, 0);
	          }function o() {
	            c.frame && t(u.frameElement).css(c.frame), delete c.frame;
	          }var s,
	              a,
	              u = window,
	              l = window.parent,
	              c = {};return e.util.isPopup() ? (a = i, s = n) : e.util.isModal() ? (a = function a() {
	            l.CKFinder.modal(S("A/**,+.2,"));
	          }, s = function s() {
	            l.CKFinder.modal(S('?- :*),<"'));
	          }) : (a = o, s = r), { min: a, max: s };
	        }return i;
	      }), CKFinder.define(S("TS_suxxl0vHGTW\ndF[LoUCOBYR~RMZCCnP_L"), [S('"IUPCUQ'), S("!WM@@TTKFXN"), S("cjdJJACUCN[^mQBWxTOXMMlRYJ")], function (e, t, n) {
	        "use strict";
	        var i = n.extend({ createRegion: function createRegion(t) {
	            var n = e(S(",JFF")).attr(S("uy"), t.id).attr(S("5RVLXXW[O2(-1-1?"), t.priority);t.className && n.addClass(t.className);var i = !1;this.ui.regions.find(S('@&"0$k$#/g;>$!=9%+')).each(function (r, o) {
	              if (!i) {
	                var s = e(o),
	                    a = s.data(S("?#*$n47/(: >2"));t.priority <= a && (s.before(n), i = !0);
	              }
	            }), i || this.ui.regions.append(n), this.addRegion(t.name, { selector: "#" + t.id, priority: t.priority });
	          }, getFirstRegion: function getFirstRegion() {
	            var e = this.$el.find(S("4nRVLXXW[O2(-1-1?")).toArray(),
	                n = {};this.regionManager.each(function (i) {
	              n[t.indexOf(e, i.$el.get(0))] = i;
	            });var i;return t.forEach(n, function (e) {
	              !i && e.hasView() && (i = e);
	            }), i;
	          } });return i;
	      }), CKFinder.define(S("c}an:_VXvNEGQqCJXEK_I^QVW@eWP]u[BSHJ$.6"), [], function () {
	        return S('-vzb5u{yji&>~uy\rQCDA\bTBO@EE_\r[FR]]@PXCHTPX- +-f{LNt-#=l.".#"oq7>0z5835q/;8	\fAD	D	\x00\n@\x00\x00\fKUMIXE@Rö¿¿«áïñ¶');
	      }), CKFinder.define(S('/sztZZQSEtU_IQ[Lo#$!6i!,=8c/(53*; "'), [S("2FZQSEKZUIY"), S(".EADWAM"), S("sspwyy}"), S("[R\\rry{mwKFSV	eIZOhT@N]XQULYBLoS^K"), S("fvla7TS_suxxl0tDOSHDRB[zJKH]\x00`PUVxTOXMM_SI")], function (e, t, n, i, r) {
	        "use strict";
	        function o(e) {
	          e.data.page === this.options.name && this.doAutoHeight();
	        }return i.extend({ name: S("\n[mjkCqh}f`"), template: r, className: S('ofh"`puv'), attributes: { "data-role": S(" QCDA") }, regions: { main: S(" AHB\bKFAGYIJG@^") }, ui: { regions: S("0QXRFV_\\IYZWP.2") }, childEvents: { show: function show(e) {
	              this.listenTo(e, S("|thm%CIG@OUDZFFG"), function () {
	                var t = this.getFirstRegion(),
	                    n = t && t.currentView.cid === e.cid;n && (window.scrollY || window.pageYOffset) && window.scrollTo(0, 0);
	              }, this);
	            } }, initialize: function initialize() {
	            var e = this;e.main.on(S("cy}d"), function (t) {
	              e.listenTo(t, S('B1!+"":'), e.doAutoHeight), e.doAutoHeight();
	            }), e.listenTo(e.regionManager, S("rpq,e}~str"), function (t, n) {
	              n.on(S("?3)-4"), function (t) {
	                t._isRendered && e.doAutoHeight(), e.listenTo(t, S(":IYSZZ2"), e.doAutoHeight), e.listenToOnce(t, S("8]_HHOQF"), e.doAutoHeight);
	              });
	            }), e.finder.on(S("E2('%(*>w-=50&6"), o, e), e.finder.on(S("#PJIKJHX^H]JD"), o, e), e.finder.on(S("ewp}#issj$") + e.getOption(S("blcj")), function () {
	              e.doAutoHeight();
	            }), e.finder.on(S("`-j|irfx"), e.doAutoHeight, e);
	          }, onRender: function onRender() {
	            var e = this;this.$el.one(S("&DZLK_I"), function () {
	              e.$el.removeAttr(S(";H\\\\V.%';"));
	            }), this.finder.util.isWidget() && /iPad|iPhone|iPod/.test(navigator.platform) && (this.doIOSWidgetFix(), this.finder.on(S("a|,e}jsay"), this.doIOSWidgetFix, this, null, 20));
	          }, doIOSWidgetFix: function doIOSWidgetFix() {
	            this.$el.css(S("4XWOQ_R[UJ"), this.finder.config._iosWidgetHeight + S("5FO")), this.$el.css(S("q|f2WHFWL"), this.finder.config._iosWidgetWidth + S("h"));
	          }, onDestroy: function onDestroy() {
	            this.finder.removeListener(S("`zy{zxh!o{~TD"), o), this.finder.removeListener(S(">K/..!%7|5-:/?"), o), this.finder.removeListener(S("&RAXN_DTJ"), this.doAutoHeight), this.finder.util.isWidget() && /iPad|iPhone|iPod/.test(navigator.platform) && this.finder.removeListener(S("mp iynweE"), this.doIOSWidgetFix);
	          }, setAutoHeightRegion: function setAutoHeightRegion(e) {
	            this.autoHeightRegion = e;
	          }, doAutoHeight: function doAutoHeight() {
	            var n = this;setTimeout(function () {
	              t.mobile.resetActivePageHeight(), n.$el.find(S('?%#7%h4($,wi*"!;5#p')).toolbar().toolbar(S("(\\ZOMYKQVWcUQR^V^")), n.$el.find(S("2hPTBVKUWY\x00W% &&6g")).toolbar().toolbar(S("2FDQWC]i[\\Ym_[$(,$"));var i = n.regionManager.get(n.autoHeightRegion);if (i && i.currentView) {
	                var r = n.calculateMinHeight();e.forEach(n.regionManager.without(i), function (e) {
	                  var t = e.$el.outerHeight();r -= t;
	                }), i.$el.css({ "min-height": r + S("5FO") }), i.currentView.trigger(S("}pjzy|lr"), { height: r });
	              }
	            }, 10);
	          }, calculateMinHeight: function calculateMinHeight() {
	            var e = parseInt(getComputedStyle(this.el).getPropertyValue(S(" QCG@LH@]E["))),
	                t = parseInt(getComputedStyle(this.el).getPropertyValue(S("aswp|xp5{uohrs"))),
	                n = parseInt(getComputedStyle(this.el).getPropertyValue(S("{uixxl2TNRSLBS@"))),
	                i = parseInt(getComputedStyle(this.el).getPropertyValue(S('8[UIXXL".67+(k0!->#')));return window.innerHeight - e - t - n - i;
	          } });
	      }), CKFinder.define(S("ZQ]uszzRoL@PJB[zJKH]\x00`PUVG"), [S("$PHCM[YHC_K"), S("0[CFQGO"), S('&dcoCEHH\\\x00}^VFXPEhX]^OhV%61l$!"(3$99')], function (e, t, n) {
	        "use strict";
	        function i(e) {
	          this.finder = e, this.pages = {}, this.pageStack = [], this.started = !1;
	        }var r = 50,
	            o = S("D+(* &.a=/(52== 4?9=+");return i.prototype = { getHandlers: function getHandlers() {
	            var e = this;return t(S("q{qo")).on(S("hx}~rpkAHLFVGCAG[OCEIK"), function (n, i) {
	              var r = i.prevPage && !!i.prevPage.length && t(i.prevPage[0]).data(S("\rmdvAstq"));r && (e.finder.fire(S('B3%"#}  ..'), { page: r }, e.finder), e.finder.fire(S("!RBC@OAMO") + r, e.finder));
	            }).on(S("\n{mjklfr}{sekqul"), function (n, i) {
	              var r = t(i.toPage[0]).data(S("&DCOzJKH"));e.currentPage = r, e.finder.fire(S("=N^'$x0,*1}") + r, e.finder), e.finder.fire(S('E6&/,p8$"9'), { page: r }, e.finder);
	            }), { "page:current": { callback: this.pageCurrentHandler, context: this }, "page:create": { callback: this.pageCreateHandler, context: this }, "page:show": { callback: this.pageShowHandler, context: this }, "page:hide": { callback: this.pageHideHandler, context: this }, "page:destroy": { callback: this.pageDestroyHandler, context: this }, "page:addRegion": { callback: this.pageAddRegionHandler, context: this }, "page:showInRegion": { callback: this.pageShowInRegionHandler, context: this } };
	          }, setFinder: function setFinder(e) {
	            this.finder = e;
	          }, pageCurrentHandler: function pageCurrentHandler() {
	            return this.getCurrentPage();
	          }, pageDestroyHandler: function pageDestroyHandler(e) {
	            function n() {
	              s && (s.destroy(), r.fire(S('"SEBCLLY_^BW'), { page: e.name }, r), r.fire(S("$UG@MNN_Y\\@I") + e.name, null, r), delete i.pages[e.name]);
	            }var i, r, s, a, u;i = this, r = this.finder, s = this.getPage(e.name), e.name === this.getCurrentPage() ? (t(o).one(S("+\\LIJS^\\GU\\XRJJRTK"), n), u = this.popPrevPage(), a = this.getPage(u), a && this.showPage(a)) : n();
	          }, pageHideHandler: function pageHideHandler(e) {
	            var t, n;e.name === this.getCurrentPage() && (t = this.popPrevPage(), n = this.getPage(t), this.showPage(n));
	          }, pageCreateHandler: function pageCreateHandler(i) {
	            var r = e.extend({}, i.uiOptions),
	                o = this,
	                s = i.name;if (!this.pages[s]) {
	              var a = new n({ finder: this.finder, name: s, attributes: e.extend({}, n.prototype.attributes, { "data-ckf-page": s }), className: n.prototype.className + (i.className ? " " + i.className : "") });i.mainRegionAutoHeight && a.setAutoHeightRegion(S("#IDOI")), this.pages[s] = a, a.render(), a.$el.attr(S("8][O]JW%,'"), this.finder.config.swatch), a.$el.appendTo(S("xtxd")), this.started || (r.create = function () {
	                t.mobile.initializePage(), o.started = !0;
	              }), a.$el.page(r), a.main.show(i.view), this.finder.fire(S("l|yzBPFEQC") + i.name, {}, this.finder);
	            }
	          }, pageShowHandler: function pageShowHandler(e) {
	            var t = this.getPage(e.name);if (t) {
	              var n = this.getCurrentPage();n && n !== e.name && (this.pageStack.push(n), this.finder.fire(S("mxEJJ@@") + n, null, this.finder)), this.showPage(t);
	            }
	          }, pageAddRegionHandler: function pageAddRegionHandler(e) {
	            var t = this.getPage(e.page);return t ? (t.createRegion({ name: e.name, id: e.id, priority: e.priority ? e.priority : r, className: e.className }), !0) : !1;
	          }, pageShowInRegionHandler: function pageShowInRegionHandler(e) {
	            var t = this.getPage(e.page);t[e.region].show(e.view), t[e.region].$el.trigger(S("4VDRYM_"));
	          }, showPage: function showPage(e) {
	            t(o).pagecontainer(S("C'-')/,"), e.$el), this.currentPage = e.attributes[S("kqes>w~p:hx}~")], e.$el.trigger(S("scwr`p")).trigger(S(".Z@USGQYWNWLN"));
	          }, getCurrentPage: function getCurrentPage() {
	            return this.currentPage;
	          }, getPage: function getPage(e) {
	            return this.pages[e];
	          }, popPrevPage: function popPrevPage() {
	            for (; this.pageStack.length;) {
	              var e = this.pageStack.pop();if (this.getPage(e)) return e;
	            }return this.pageStack = [], !1;
	          } }, i;
	      }), CKFinder.define(S("gqmb6[R\\rry{muGNTIGSMZ{MCKCCbRZPZ{Y@UNHZP4"), [], function () {
	        return S('$^]\x18\b@^\x05OAA\\UsGG@ZX\x17ED0\x07XTH\x1F2..&yg$&&\'/9nm*.$0\x7F!;93jz1?:88,}@\x02\x0E\x02\x17\x16[E\x0B\x02\fF\x18\x02\x01\x03\x12\x10\0^\x1D\x01\x13\x1A\x0B[DquA\x1C\n\xF4\xF5\xED\xED\xA4\xE1\xE7\xF3\xE9\xA4\xE9\xE0\xEA\xA0\xFC\xE0\xFC\xF4\xAF\xB1\xF7\xF9\xF9\xE4\xFD\xC9\xFB\xF5\xF9\xF1\xBC\xBF\xC4\xC0\xD6\xC2\x89\xCC\xC5\xC8\xC6\x94\x88\xC8\xC7\xCB\x83\xCC\xD1\xDF\xD1\xD6\xD8\x97\x96\xD3\xD9\xCD\xDB\x96\xD5\xDE\xD1\xD1\xB0\xAE\xB1\xFE\xE6\xAB\xA9\xB3\xAD\xB1\xBE\xE9\xEC\xB9\xA7\xBB\xBC\xB4\xEF\xF1\xAF\xAE\xEB\xF7\xB1\xAD\xF4\xB7\xBD\xB3\xB9\xF1\xA3\x8D\x8D\x90\x81\xA7\x92\x89\xC8\x94\x97\xC9\xD2\x96\x95\xD2\xD0\x98\x86\xDD\x98\x94\x98\x90\xD6\xBA\x96\x94\x8F\x98\xBC\x8Bn!\x7F~8*dr|}ee2\x072 txd-\x1Enm(ed\x10\'xth?CMCPW\x18\x04DCO\x07[MCKC\x1DR]]@PXCK\x1B\x04\x07\x13YWI~K');
	      }), CKFinder.define(S("L[W{}ppd8Uv~npxm0p@LFHV	qAL]X}OAU]dZQB"), [S("[R\\rry{mtVJH\nmBQjEOI"), S("^UYIOFFV\npNM^YnL]J}SJ[@BaQ\\M"), S("fvla7TS_suxxl0tDOSHDRB[zJBHB\\aS]QYzVAVOOYQK")], function (e, t, n) {
	        "use strict";
	        var i = t.extend({ name: S("8i[UYQr^9.77"), template: n, regions: { contents: S(":_VX0 ,&(h%(&=/%8>") }, events: { 'click [data-ckf-role="closePanel"]': function clickDataCkfRoleClosePanel() {
	              this.hide();
	            }, 'keydown [data-ckf-role="closePanel"]': function keydownDataCkfRoleClosePanel(t) {
	              (t.keyCode === e.enter || t.keyCode === e.space) && this.hide();
	            }, panelclose: function panelclose() {
	              this.trigger(S("zvtoxz")), this.$el.attr(S("(HXBM\x00FFTUW]"), S("faap")), this._isOpen = !1;
	            }, panelopen: function panelopen() {
	              this.trigger(S("1]CQ[SS")), this.$el.removeAttr(S("!CQMDOAMNNB")), this._isOpen = !0;
	            }, keydown: function keydown(t) {
	              t.keyCode === e.escape && (t.stopPropagation(), this.hide());
	            } }, templateHelpers: function templateHelpers() {
	            return { closeButton: !!this.options.closeButton };
	          }, initialize: function initialize(e) {
	            function t() {
	              var t = this.$el.find(S("TKTDHBDCEBH\\"));if (t.length) {
	                var n = getComputedStyle(t[0]).getPropertyValue(S("`pvw}{q:lvj")),
	                    i = 0;if (e.closeButton) {
	                  var r = this.$el.find(S("C}{o}0lpLDL@GCM[\bv"));r.length && (i = r.outerHeight());
	                }this.contents.$el.css({ height: this.$el.height() - parseInt(n) - i + S("#T]"), overflow: S("%GR\\F") });
	              }
	            }this._isOpen = !1, this.$el.attr(S("+HLZNRYUEWY]U"), e.name).attr(S("tpfr9eydqmstr"), e.position).attr(S("x|j~\rUJFI@"), this.finder.config.swatch).attr(S('"BVLG\n@@NOIC'), S("\rz}et")).attr(S(".KQESP\\EGTXC"), e.display).addClass(S("vx2P@LFH\b") + e.position);var n = this;e.overrideWidth && (this.$el.css({ width: e.overrideWidth }), this.$el.on(S("D5')-%(.*\"<*?!7="), function () {
	              n.$el.css({ width: e.overrideWidth });
	            }), e.display === S('D*0":%+2') && (this.$el.on(S("9JZRXR]%'-1!&*(;,"), function () {
	              n.$el.css(e.position === S('A.&"1') ? { left: 0, transform: S("$QTFFZFJXHK") + n.finder.config.secondaryPanelWidth + S("1") } : { right: 0, transform: S("\fy|n~b~r`p%s0") + n.finder.config.secondaryPanelWidth + S("1") });
	            }), this.$el.on(S("1BRZPZTTVI^"), function () {
	              n.$el.css(e.position === S(" MGEP") ? { left: "", transform: "" } : { right: "", transform: "" });
	            }))), e.scrollContent && (this.contents.on(S("B0,*1"), t, this), this.finder.on(S("'\\FEGNL\\SCWR@P"), t, this), this.finder.on(S("hrqsB@P@@USZFS"), t, this), this.finder.on(S("mp iynweE"), t, this), this.on(S("5RRKMHTE"), function () {
	              this.finder.removeListener(S("E2('%(*>w-=50&6"), t), this.finder.removeListener(S(';HRQS" 0y  53:&3'), t), this.finder.removeListener(S("\r{f*cw`}os"), t);
	            }, this));
	          }, display: function display() {
	            this.$el.panel(S("qoEO"));
	          }, toggle: function toggle() {
	            this.$el.panel(S("6CW^]WY"));
	          }, hide: function hide() {
	            this.$el.panel().panel(S("C'))4-"));
	          }, isOpen: function isOpen() {
	            return this._isOpen;
	          } });return i;
	      }), CKFinder.define(S("5u|~PT_YOr/%7/!6i)'/'?b.>4> "), [S("`xs}kixso{"), S("&MY\\OYU"), S("+ofhF^UWAc_ROJy]N[	5'.,#0"), S("/sztZZQSEoS^KN}!2'l\b$?(==\"):"), S('%eln@DOI_b_UG_QFgYW_WOhV%61l$("$#.;'), S(";vxV.%'1k2.$f.5!+5")], function (e, t, n, i, r, o) {
	        "use strict";
	        function s() {
	          this.panels = {}, this.opened = null;
	        }return s.prototype = { getHandlers: function getHandlers() {
	            return { "panel:create": { callback: this.panelCreateHandler, context: this }, "panel:open": { callback: this.panelOpenHandler, context: this }, "panel:close": { callback: this.panelCloseHandler, context: this }, "panel:toggle": { callback: this.panelToggleHandler, context: this }, "panel:destroy": { callback: this.panelDestroyHandler, context: this } };
	          }, setFinder: function setFinder(e) {
	            this.finder = e, e.request(S("2XQL\f[QJN^R"), { key: o.escape }), e.on(S("\ffkvea(") + o.escape, function (e) {
	              e.data.evt.stopPropagation();
	            }, null, null, 30), e.on(S("a|,dopj~pxxk"), function (e) {
	              this.onSwipe(S("@-'%0"), e);
	            }, this, null, 10), e.on(S("7MP\x00HKTNZ2(%+0"), function (e) {
	              this.onSwipe(S("`zs}b"), e);
	            }, this, null, 10);
	          }, panelCreateHandler: function panelCreateHandler(e) {
	            var t,
	                n = this.finder,
	                i = S(e.position === S("0A@ZYTDN") ? n.lang.dir === S(",AZ]") ? 'A.&"1' : "6EQ^RO" : n.lang.dir === S("&K\\[") ? ":IUZVK" : "~vra"),
	                o = e.position === S(";LOWR!3;") ? n.config.primaryPanelWidth : n.config.secondaryPanelWidth,
	                s = { finder: n, position: i, closeButton: e.closeButton, name: e.name, scrollContent: !!e.scrollContent, overrideWidth: o, display: e.panelOptions && e.panelOptions.display ? e.panelOptions.display : S("qiESNB]") };e.scrollContent && (t = S("-MDVBRZPZKZHTPQ_],$")), e.className && (t = (t ? t + " " : "") + e.className), t && (s.className = t);var a = new r(s);return a.on(S('"@HJUBL'), function () {
	              n.fire(S("B3%+#+r*&$?(t") + e.name, null, n), this.opened = null;
	            }, this), a.on(S("vj~rxz"), function () {
	              n.fire(S("<M_Q%-x,4 (}") + e.name, null, n), this.opened = e.name;
	            }, this), a.render(), a.$el.appendTo(S("6UW]C")).panel(e.panelOptions || {}).trigger(S("+O_KNDT")), a.contents.show(e.view), a.on(S("hh}{b~k"), function () {
	              n.fire(S("9JZRXR$$176*?}") + e.name, null, n), delete a[e.name];
	            }), this.panels[e.name] = a, this.finder.request(S("rzubk#ni}m"), { node: a.$el }), a;
	          }, panelOpenHandler: function panelOpenHandler(e) {
	            var t = this.panels[e.name];t && t.display();
	          }, panelToggleHandler: function panelToggleHandler(e) {
	            this.panels[e.name] && this.panels[e.name].toggle();
	          }, panelCloseHandler: function panelCloseHandler(e) {
	            this.panels[e.name] && this.panels[e.name].hide();
	          }, panelDestroyHandler: function panelDestroyHandler(e) {
	            this.panels[e.name] && (this.panels[e.name].hide(), this.panels[e.name].destroy(), delete this.panels[e.name]);
	          }, onSwipe: function onSwipe(e, t) {
	            var n = this.panels[this.opened];n && n.getOption(S("5FXKPNRSS")) === e && (t.cancel(), n.hide());
	          } }, s;
	      }), CKFinder.define(S('1FVLAtsSUXXL$/3($2";f\f" (=`8>64;20;73:\n:\r\x00H'), [], function () {
	        return S("&}sos?ABVJKK!%BNRT^\r><?LCRHZV!--$	 54)./k10DFYm;=$ \"w,88229;']CSAD\n\rTH	(<TW@\\û ¢êð«àîäìÄêáè®òí³²òæü÷ºêüëîõïûûÖÑÑÀ¢ ÀÌÌÊÜ¸ÓÙÅÕ°ÌÝÓ¡²±þæ ´µ§»ç¦©¾½®·´ðíèú¦éÒ");
	      }), CKFinder.define(S("W^P~v}i3Pq{UMGPcOKMZ}EHY\\w[_Q{WZ]}SZPRYi)$5"), [S(";vxV.%'1k/\"?:e	->+`%7><3 "), S("7{r|RRY[Mo\f-'!)5h &."), S("dtjg5V]Qqw~~n2JzMQNBP@U\bn@FN_hF\\T|RYPr^YUU\\hXSO, 6&j!)3")], function (e, t, n) {
	        "use strict";
	        return e.extend({ name: S(" gKOAkGJMmCJ@BIyYTE"), template: n, ui: { error: S("9}khtn0szSRCDA"), fileName: S("{}d`bLvxw~!?pzWgKOAkGJMw") }, events: { "input @ui.fileName": function inputUiFileName() {
	              var e = this.ui.fileName.val().toString();if (!t.isValidName(e)) return void this.model.set(S("|hiso"), this.finder.lang.ErrorMsg.FileInvChar);this.model.unset(S("wafzd"));var n = t.extensionFromFileName(this.model.get(S("9UIUZWQ!-*( \b&%,"))).toLowerCase(),
	                  i = t.extensionFromFileName(e).toLowerCase();if (n !== i) {
	                var r = this.model.get(S("9H^ORKM#$:4 "));if (!r.isAllowedExtension(i)) return void this.model.set(S("6RJKUI"), this.finder.lang.UploadExtIncorrect);this.model.set(S("|boysmvOOaKEKABL"), !0);
	              } else this.model.set(S("=[G4$,0-*( ($,))"), !1);this.model.set(S("#BLJBfHGN"), e);
	            }, submit: function submit(e) {
	              this.trigger(S('"PQGKN\\LD^@')), e.preventDefault();
	            } }, modelEvents: { "change:error": function changeError(e, t) {
	              t ? (this.ui.fileName.attr(S('"BVLG\nAG\\J@DJ'), S("/DCGV")), this.ui.error.show().removeAttr(S("ugv5qsxxp")).html(t)) : (this.ui.error.hide().attr(S("@ 0*%h..,-/%"), S("4ADB]")), this.ui.fileName.removeAttr(S('?!3+"i,(1)%#/')));
	            } } });
	      }), CKFinder.define(S('0ryu][RRJwTXHRZ3n&*$+" &.c+!1<7=93'), [S("xzv|pND"), S("_VXvNEGQhICMEYjDBJ"), S("QXR|xs}k5Nhtr0kD[`KAC"), S(")i`jD@KUC~[QC[]J}UQ[Lo+&36i!%/- +90><3?2/")], function (e, t, n, i) {
	        "use strict";
	        function r(e) {
	          this.finder = e, e.setHandler(S("5P^T\\\x00IYS_R%"), s, this), e.on(S("*HCCZJHEVZ@\fQQU_YYWK"), o, this, null, 50), e.on(S(">Y)-'y/ ?#'>$"), function (t) {
	            t.data.evt.keyCode === n.f2 && e.request(S("/VX^VGSYYT_"), { file: t.data.file });
	          }), e.on(S("-Z@_]PRFDRK\\Nq\\WQz'+/!"), function (e) {
	            e.data.file.get(S('B%+)"":')).get(S("9[XP")).fileRename && e.data.toolbar.push({ name: S("Ku}p{YIMG"), type: S("BTVWKK"), priority: 30, icon: S(":XW[Y)-'n6 (&%,"), label: e.finder.lang.Rename, action: function action() {
	                e.finder.request(S(",KGCU@VZT[R"), { file: e.finder.request(S(";ZTRZ3{%&0#+-*>.(")).toArray()[0] });
	              } });
	          }), e.on(S("4Q_VTV]nXP^-$*( |(#"), function (t) {
	            var n = t.data.view.model;if (!n.get(S("pdewk"))) {
	              var i = t.data.context.file,
	                  r = n.get(S("3R\\ZRvXW^")),
	                  o = i.get(S("=P^-$")),
	                  s = { file: i, newFileName: r };t.finder.request(S("yw~LNE@@USZFS")), n.get(S("|boysmvOOaKEKABL")) ? e.request(S("7\\P[WSZ\\//$*6("), { name: S("4GSYYT_}UQ[|//$*6("), msg: e.lang.FileRenameExt, context: s }) : r !== o && a(s, e);
	            }
	          }), e.on(S("txs{r,e}w{vy[wsEbMMBLTJFA"), function (t) {
	            a(t.data.context, e);
	          }), u(e);
	        }function o(e) {
	          var t = this,
	              n = e.data.context.file,
	              i = n.get(S("3RZZS]K")).get(S("\njoa"));e.data.items.add({ name: S("\f_kaq|wU}ys"), label: t.finder.lang.Rename, isActive: i.fileRename, icon: S('?#*$n",*"e;/%- +'), action: function action() {
	              t.finder.request(S("6QQU_NXP^-$"), { file: n });
	            } });
	        }function s(t) {
	          var n = this.finder,
	              r = n.lang,
	              o = t.file.get(S("v~~wqg")),
	              s = new e.Model({ dialogMessage: n.lang.FileRename, fileName: t.file.get(S("1\\RYP")), originalFileName: t.file.get(S(" OCNA")), resourceType: o.getResourceType(), extensionChanged: !1, error: !1 }),
	              a = n.request(S("hdocv"), { view: new i({ finder: n, model: s }), name: S("%tBFHGNjDBJ"), title: r.Rename, context: { file: t.file } });s.on(S("1Q[U[QR\\HISO"), function (e, t) {
	            t ? a.disableButton(S("5Y\\")) : a.enableButton(S("0^Y"));
	          });
	        }function a(e, t) {
	          var n = e.file,
	              i = n.get(S("}sqzzR")),
	              r = { fileName: n.get(S(" OCNA")), newFileName: e.newFileName };t.request(S("rpAEGQVNH_"), { text: t.lang.PleaseWait }), t.once(S('>\\/,/"*!|&.=/9v+!1<7=93'), function (e) {
	            t.request(S('~|uqse"qsy'));var i = e.data.response;i.error || n.set(S("u}p{"), i.newName);var r = t.request(S("A$*( 5}/,>\b9?<*>%")).where({ name: i.newName }).pop();r && r.trigger(S("1T\\W@E"));
	          }), t.request(S("|OLOBJATMGN"), { name: S("/bT\\RYPp^T\\"), folder: i, params: r, type: S("!RLWQ") });
	        }function u(e) {
	          e.on(S("(OCGIEJIU]DZ"), function (t) {
	            t.data.evt.keyCode === n.f2 && e.request(S("9\\RPXM%/#.!"), { file: t.data.file });
	          }), e.on(S(':HTRLK#460~)/4<s," (='), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.rename, shortcuts: S("\npj?s") });
	          }, null, null, 20);
	        }return r;
	      }), CKFinder.define(S('?\n**!#5g%/9!+<"6&4">77u,8,>\b\r\r'), [], function () {
	        "use strict";
	        function e(e) {
	          this.finder = e, this.id = e.util.randomString(16);
	        }var t = 3e3;return e.prototype.getId = function () {
	          return this.id;
	        }, e.prototype.trackProgress = function (e) {
	          var n = this,
	              i = !0;this.probingInterval = setInterval(function () {
	            i && (i = !1, n.finder.request(S("s~~u{r-k|t"), { name: S("(fZN^LZF__"), params: { operationId: n.id } }).done(function (t) {
	              i = !0, e && e(t);
	            }));
	          }, t);
	        }, e.prototype.abort = function () {
	          this.finish(), this.finder.request(S("s~~u{r-k|t"), { name: S("8vJ^N\\JV//"), params: { operationId: this.id, abort: !0 } });
	        }, e.prototype.finish = function () {
	          this.probingInterval && (clearInterval(this.probingInterval), this.probingInterval = null);
	        }, e;
	      }), CKFinder.define(S("-mdvX\\WQGzW]OWYNm%/#.!)+,,8d( .=4<813%"), [S("=\\^#* ,* "), S("$fmaAGNN^c@TD^VGpXT]_IOhV%61l**#-;*!(\n&1==4<3 "), S("QXR|xs}k5Nhtr0kD[`KAC"), S('*hgkGATT@yZRBT\\IsM[M!5+,*j	7-;+?%" '), S("A\b,(#-;e\b# # >~<00:$w	(4;/;,,\r	"), S('5u|~PT_YO|/,/,*j.->9d?!("4! <3 ')], function (e, t, n, i, r, o) {
	        "use strict";
	        function s(n) {
	          n.setHandler(S("|tpy{mSGMEHC"), function (s) {
	            var a = s.folder,
	                l = s.newFolderName;if (l) {
	              var c = a.getResourceType(),
	                  d = { type: a.get(S("8K_HSHL\\%;3!")), currentFolder: a.getPath(), newFolderName: l };if (c.isOperationTracked(S("Drvxw~Zrr{ES"))) {
	                var f = new i(n);d.operationId = f.getId();var h = new r({ message: n.lang.PleaseWait }),
	                    g = new o({ finder: n, model: h });n.request(S("7\\P[WSZ"), { view: g, title: n.lang.Operations.renameFolder, name: S("#v@HFELlD@IK]`C]TFPED"), buttons: [{ name: S(":Z^RLK"), label: n.lang.Abort }] });var p = function p() {
	                  f.abort(), n.request(S("u|rpGFFWQTHQ"));
	                };n.on(S('"GMDJHOxNBLCJv^^WQGfEW^H^ON^".07'), p), f.trackProgress(function (e) {
	                  e.current && e.total && h.set(S("7NXVNY"), e.current / e.total * 100);
	                }), n.once(S("B +(+&&-p$'w*>0?6::3=+"), function () {
	                  h.set(S("%PFD\\O"), 100), setTimeout(function () {
	                    n.request(S("kyp~|s/rrkmhte"));
	                  }, u);
	                }), n.once(S(';_RSR!/&y%#2":s.",#*>>71\''), function () {
	                  f.finish(), n.removeListener(S('&CAHFDK|J^P_VrZZS]KjISZLZ32x"&*43'), p);
	                });
	              } else n.request(S(")FDMIK]\nBZ\\C"), { text: n.lang.PleaseWait });n.request(S("wz{zyw~!oxp{"), { name: S("O{qALGeKIBBZ"), type: S("iuhh"), params: d, context: { folder: a, newFolderName: l } });
	            } else {
	              var m = new e.Model({ dialogMessage: n.lang.FolderRename, folderName: a.get(S("6YYT_")), error: !1 }),
	                  v = n.request(S("r~yuu|"), { view: new t({ finder: n, model: m }), name: S("H~r|szfNNGAW"), title: n.lang.RenameDlgTitle, context: { folder: a } });m.on(S(".LXP\\TQSEJVH"), function (e, t) {
	                t ? v.disableButton(S("1]X")) : v.enableButton(S("{~"));
	              });
	            }
	          }), n.on(S(")NBMAAH\ncW]UXSqWU^^NQT"), function (e) {
	            var t = e.data.view.model;if (!t.get(S("~noqm"))) {
	              var i = t.get(S("*MCAJJBS^Q"));e.finder.request(S("w}tzx#~~oilpY")), n.request(S("uwxxl%RDLBI@"), { folder: e.data.context.folder, newFolderName: i });
	            }
	          }), n.on(S("$FIJEHDOLH[UC\baQ[WZ]UWXXL"), function (e) {
	            n.request(S("uuzxxl%HHFF"));var t = e.data.response;if (!t.error && !t.aborted) {
	              var i = e.data.context.folder;i.set(S("8W[VY"), e.data.context.newFolderName), n.fire(S("jbbkuc(`qystl|~"), { folder: i }, n), i.trigger(S("bwqvbr|"));
	            }
	          }), n.on(S("9YTRI[G4\f'-1 ($-/9v(*&$"), function (e) {
	            var t = e.finder,
	                n = e.data.context.folder,
	                i = n.get(S("3]FdXWM")),
	                r = n.get(S("&FKE"));e.data.items.add({ name: S("0cW]UXSqWU^^N"), label: t.lang.Rename, isActive: !i && r.folderRename, icon: S("7[R\\ZRR[%3o1!+'*-"), action: function action() {
	                t.request(S("i}vvf/drvxw~"), { folder: n });
	              } });
	          }), n.on(S("3@ZY[ZXHNXMZ4{\"-+|!'%..>"), function (e) {
	            var t = e.data.folder;!t.get(S("dJvuo")) && t.get(S(":Z_Q")).folderRename && e.data.toolbar.push({ name: S("5dRVXW^zRR[%3"), type: S("pf`ayy"), priority: 30, label: e.finder.lang.Rename, icon: S("-MDVT\\XQSEK_U]P["), action: function action() {
	                n.request(S('8_UWXXL2$,") '), { folder: t });
	              } });
	          }), a(n);
	        }function a(e) {
	          e.on(S("'NFFOI_DUHV\\C["), function (t) {
	            t.data.folder.get(S("unLpOU")) || t.data.evt.keyCode === n.f2 && t.finder.util.isShortcut(t.data.evt, "") && (t.data.evt.preventDefault(), t.data.evt.stopPropagation(), e.request(S("rzzs}k iysrE"), { folder: t.data.folder }));
	          }), e.on(S('"PLJTSK\\^XAG\\DT\\XQSEK'), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.folders.rename, shortcuts: S("os$j") });
	          }, null, null, 20);
	        }var u = 1e3;return s;
	      }), CKFinder.define(S("'kblBBIK]|]WAYSDSWHXLy)-'0k/+<,8\r%!+<"), [S("pzB"), S("-CNBX]]QABR"), S("3w~p^V]_IhJV,n	&=)#-")], function (e, t, n) {
	        "use strict";
	        function i(i) {
	          var o = "",
	              s = { "input input": function inputInput() {
	              var e = this.$el.find(S("3][FBL")).val();o !== e && i.request(S("}uq{lGKOP@T"), { text: e }), o = e;
	            }, "keydown input": function keydownInput(e) {
	              e.keyCode === n.tab && (i.util.isShortcut(e, "") || i.util.isShortcut(e, S("eqn"))) && i.request(S(i.util.isShortcut(e, "") ? " GM@QVIMQ^" : "sytmj knxh"), { node: this.$el.find(S("B**533")), event: e }), e.stopPropagation();
	            } };r() && (s[S("?+$;64e/)8<>")] = function (e) {
	            (e.keyCode === n.backspace || e.keyCode === n["delete"]) && this.$el.find(S(" HLSQQ")).trigger(S("/Y_BF@"));
	          }), i.on(S("B7+**%);p9)>+;j3::o084=?)"), function (n) {
	            n.data.toolbar.push({ name: S("2u]YBRJ"), type: S("\fn{|d~"), priority: 50, alignment: S("A1&'*(#);3"), alwaysVisible: !0, view: t.ItemView.extend({ className: S('?#*$n",*";d," 9+='), template: e.template(S("@}+-402g<0:.qo:*(%ps797$+dx87;s+K\fF\n\rWVB¢°²¡¤õêæëìâäàéëý­³éè©µÿã¶éöúÿøöðÌÅÇÑØÛßËÇÙÈËÊÝÁÁÙÕÏÞÀÃà¥£·¥è¶µ­¿¯¥¸à¨ ³¤¡þ®º¹ºåû®©©¸üá")), events: s }), placeholder: i.lang.Filter.filterPlaceholder, value: o });
	          }), i.on(S("uwxxl%SDNFGQCC"), function () {
	            o = "";
	          }, null, null, 5);
	        }function r() {
	          var e,
	              t,
	              n = -1;return navigator.appName == S("WroqlOGVmKRBZGO_\fhV_\\^@VF") && (e = navigator.userAgent, t = new RegExp(S("5{dq|g\r:so9hwep0|a3f")), null !== t.exec(e) && (n = parseFloat(RegExp.$1))), 9 === n;
	        }return i;
	      }), CKFinder.define(S("$fmaAGNN^c@TD^VGeRLMSU[Ni)$50k#3< $,$+8"), [S("a{rrjjytnx"), S(">|+-  4h /<?b\f.#4} 0;1<-")], function (e, t) {
	        "use strict";
	        var n = t.extend({ initialize: function initialize() {
	            this.model.set(S('D,"'), e.uniqueId(S("w~p:")));
	          } });return n;
	      }), CKFinder.define(S("3@PNCzq}USZZ2n&)5*&<,9d(:;9?5 {3#,04</,0L"), [], function () {
	        return S('.VXW_PFSCM[YUSZZ8|`nugxMAu&.+( +n*)nt<"y488>0}#"\\N\x00\bVccW\bO\x00HT\f\b^CBPäèô½¹©ááìæïÿèú±');
	      }), CKFinder.define(S("@5';0d\f $/)?a5<\"?5!3$w\n?/(408N0\x00\f	I\f"), [], function () {
	        return S("on+7qm4w}{s\x00\\_)_^N\\uILMGXFUABEQ[OOYNP05+,*6jg.<$(8$!!x>\"'=:89;?7p}1/\b\r\r2\n\r@KdS\x00UGYC_éõ¬íåèã§õô¨«åé³­ëê¯³ýá¸ùùôÿ»áàåäÍÓÐÌÉÉþÈÆÞÉÓÒ»»ÀÖÔÌßÆÅà®²·­ª¨©¥¿®ì°³íðª©ó½³þ÷±­ô­½±«ºÀÜßÃ¼ÆÐÒÁßebif`'}|(t*vq/01vr`t;~{vtksn#=[ZMQ\bKIGMHD\\\r\fXADEDV^ZIED~?>6,!/<21t10lEYqrs ,&2e{(:841}^k^HQOMQZYC_ïñöêëëÐæäüï«ñð¬±ëê¯³ûåâþ÷÷Öúþøò¿ÝÜÈÄÄÂÄ Ð×ÓÏÎ¾");
	      }), CKFinder.define(S("!VF\\QdcoCEHH\\\x00dT_CXTBRKi^HIWQ'2m!)#$<g.$8"), [], function () {
	        return S("$^]\b@^@LLJ\\ON>	ERT\\YOIGO%|`7!=2eh'+&)pl4+lr: {865<z&!~)\rYGUIBR	WH}q[	P ®äãàì­ïó¦èþÿþäìúäôá½ûåâþ÷÷é·¼ûëñÃÕËÌÊÈÆÅÌÇÈ×ËÏÎ¾¼ØÈÍÓÔÒÈÞ¬´§þæ¾½úè¢¯²ì°³íîª©îô»·º½ù§¦àò±¯ÚïïÉÂ×ÍúÍÝÇð");
	      }), CKFinder.define(S("#P@^S	jamECJJBfVYEZVL\\IoXJK)/%0k#?<g.$8"), [], function () {
	        return S('ho(6~l7vz~xr?]\\JJUSS\b]S[I\f[UIF[WZ]@G\x00V4o,") f:5kj=-!;*ms)(iu?#v/;7)8~"C\\i');
	      }), CKFinder.define(S("n~di?\\kgKM@@T\b|LG[@LZJCaV@A_Y_Ji]SYZn%-7"), [], function () {
	        return S("9W]_[S`'-1yg=<ui#?b#/\"5q/.vk-,ey3/r1?=\rBYI	RgRTDX	¢¡ìâéà»¥óò·«åù áñü÷³éè´·ñý§¹çæ£¿ÉÕÍÅÈÃÕÔÁÄÀÊÉÜÂÙÍÎÉÕßËË¥²ì®­«æºµëÀÂìíî¢±©ïñ¯®ë÷±­ôº¨©¬¶ËÉÎÍÏÑË×Ôbtvfw+usmy*vq/.yq}gv)7ml%9so2ksUD^Y-");
	      }), CKFinder.define(S("br`m;XW[wqDDP\fp@KWDH^N_}JDE[]SFtP\\YP^RF$.6"), [], function () {
	        return S("6TXX^PXP2|`8?xf.<g#/l03mnm;=$ \"w1=gy'&c	L\n\x00EJI\bSMZYC]ûú¿£íñ¨ééäï«ñð¬°±²³ðôâöµðùôòíñìÙØÏÓÅËÅËÊÆÂÚÃÊÇÆÐØØË»ºýü¹¸´®¯¡¾°·ò³²òñ©¨ëõ¿£ö¯»·©¸þ¢ÕËÓËÉÇÛÐacgo$x{;'ekiia0");
	      }), CKFinder.define(S("(jamECJJB\\P@ZRKi^HIWQ'2m- 14g/?8$ (# <!%\x00>=."), [S("ouxxllCNPF"), S("rho~nd"), S("C)$4.''/?8("), S("(jamECJJBgG]Y|]@yTXX"), S("6tsSUXXL('47j&;,e\b# > #8&6<3 "), S("%eln@DOI_b_UG_QFd]MNRRZM('47j\"<=#%+'*'"), S("6C]ANvxV.%'1k#*8%+?)>a5%&::2%x<./539,'\rK\b"), S('$QC_\\\bi`jD@KUCgQXF[YM_Hn[K4(,$7j&, %e(":'), S("?4$:7e\r!'..>b*=!>2 0%x<./539,O2I\f"), S('"WA]RkblBBIK]eW^DYWC]JhYIJV.&1l >3f-%?'), S("mch<]TfHLGAW	sMDZGMYK\\bWG@\\XPKhZRZ[$.6"), S(">K%96b\x00.&-/9c+\" =3'1&y=-.22:-p#	\x00	F\r")], function (e, t, n, i, r, o, s, a, u, l, c, d) {
	        "use strict";
	        var f = r.extend({ name: S("_hz{yu`SgybhOs~k"), attributes: { "data-role": S("!ALJQTHDNXDY]") }, tagName: S(".KYG"), template: s, childViewContainer: S("6QM_VO"), className: S('A!("h5"<=#%+>c(">\'#'), collectionEvents: { "change:isEnabled": function changeIsEnabled(e, t) {
	              var n = this.children.findByModelCid(e.cid);t ? n.$el.removeClass(S("(\\C_YO[UVZGTT[]]")).attr(S("{iu|3{IRCAH@B"), S("trxfs")) : n.$el.addClass(S(")_B^ZNDTW]FWUT\\^")).attr(S("5WEQX_UN_],$&"), S("jmUD"));
	            } }, events: { "focus fieldset": function focusFieldset(e) {
	              e.target === this.$el.find(S("\rhfu}v`qa")).get(0) && (e.preventDefault(), e.stopPropagation(), this.focus());
	            } }, initialize: function initialize(e) {
	            this.collection = e.model.get(S("/CTFG][QD"));
	          }, addChild: function addChild(e) {
	            e.get(S(" U[SA")) !== S("A** !#)") && n.CollectionView.prototype.addChild.apply(this, arguments);
	          }, getChildView: function getChildView(n) {
	            var r = this,
	                s = { finder: r.finder, className: n.get(S("'AZoEMOBJT")) ? "" : S('\fxg"cesgq8r~kxxwyy') };n.get(S("7QJU]_RZ$")) || (s.attributes = { "aria-disabled": S("+X_[J") });var f = { checkbox: o.extend(e.extend({}, s, { name: S("K|nousy"), template: d, ui: { checkbox: S("9SULHJ") }, events: { "change input": function changeInput() {
	                    this._isExt = !0, this.model.set(S("E0&$</"), !!(this.ui.checkbox.is(S("#FNBKBOO")) ? 1 : 0)), this._isExt = !1;
	                  }, "keyup input": function keyupInput(e) {
	                    (e.keyCode === i.enter || e.keyCode === i.space) && (e.preventDefault(), e.stopPropagation(), this.ui.checkbox.prop(S("ysy~uzD"), !this.ui.checkbox.is(S("!@L@ELMM"))).checkboxradio(S("2AQSDRKQ")).trigger(S("uyw}~")));
	                  } }, modelEvents: { "change:value": function changeValue(e, t) {
	                    this._isExt || this.ui.checkbox.prop(S("rzvw~ss"), t).checkboxradio(S(".]UW@VG]"));
	                  } }, focus: function focus() {
	                  this.ui.checkbox.focus();
	                } })), range: o.extend(e.extend({}, s, { tagName: S("\rjff"), name: S("Gpbcqw}"), template: c, events: { "change input": function changeInput(e) {
	                    this._isExt = !0, this.model.set(S(":M]QKZ"), parseFloat(t(e.currentTarget).val())), this._isExt = !1;
	                  }, slidecreate: function slidecreate() {
	                    this.$el.find(S("+XGC][WQG_YW^WY")).attr(S("6CY[SUXXF"), "0");
	                  } }, modelEvents: { "change:value": function changeValue(e, t) {
	                    this._isExt || this.$el.find(S("=WQ046")).val(t).slider(S("+^HH]UBZ"));
	                  } }, focus: function focus() {
	                  this.$el.find(S("*BB][[")).first().focus();
	                } })), text: o.extend(e.extend({}, s, { tagName: S("?,  &("), name: S("Erlmsu{"), template: l, events: { "change input": function changeInput(e) {
	                    this.model.set(S('"UEISB'), t(e.currentTarget).val());
	                  } }, focus: function focus() {
	                  this.$el.find(S("'AGZ^X")).first().focus();
	                } })), select: o.extend(e.extend({}, s, { tagName: S("(EKIIA"), name: S("MzTUKMC"), template: u, templateHelpers: { _: e }, ui: { select: S("#W@JBK]") }, events: { "change select": function changeSelect() {
	                    this.model.set(S("ksUD"), t(this.ui.select).val());var e = this;setTimeout(function () {
	                      e.focus();
	                    }, 10);
	                  } }, focus: function focus() {
	                  this.$el.find(S("'[LFNOY")).first().focus();
	                } })), radio: o.extend(e.extend({}, s, { name: S("<n[K4(,$"), template: a, templateHelpers: { _: e }, events: { "change input": function changeInput(e) {
	                    this.model.set(S("-XN\\DW"), t(e.currentTarget).val());
	                  } }, focus: function focus() {
	                  this.$el.find(S(")CE\\XZtFP^FQ\b") + this.model.get(S("nxvny")) + S(">")).focus();
	                } })) },
	                h = n.get(S("4AOG]"));return f[h] || (h = S("c}an")), f[h];
	          }, focus: function focus() {
	            var e = this.children.findByModel(this.collection.filter(function (e) {
	              return e.get(S("qj_u}rzD")) && e.get(S("`lfr")) !== S("\fegktt|");
	            }).shift());e && e.focus();
	          } });return f;
	      }), CKFinder.define(S("E\f $/)?a?5'?1&y=-.22:-p6\bJ58"), [S("V]Qqw~~n2HvEVQ\ffDUBjEG@HM[Y^\\e]PA"), S("OFHf~uwa;Xysmuh3N{kTHLDW\npNM^YHZ[Y_U@sGYBHoS^K")], function (e, t) {
	        "use strict";
	        return e.extend({ name: S("8j_OHTPX3+&3"), childView: t, collectionEvents: { focus: function focus() {
	              var e = this.children.findByModel(this.collection.first());e && e.focus();
	            } }, onShow: function onShow() {
	            this.$el.parent().trigger(S(",N\\JQEW"));
	          }, onRender: function onRender() {
	            this.$el.enhanceWithin();
	          } });
	      }), CKFinder.define(S("[R\\rry{mlMGQICTzO_XD@HC\\PPZDj_OHTPX"), [S(".MQRYQ[[S")], function (e) {
	        "use strict";
	        var t = e.Model.extend({ defaults: { type: S("gqmb"), value: "", label: "" } });return t;
	      }), CKFinder.define(S("XW[wqDDP\fiJBRDLYHZ[Y_U@xYS]UIoXJK)/%07)28"), [S("\nimnemw"), S("$fmaAGNN^c@TD^VGeRLMSU[Nr/%'/7j\"<=#%+")], function (e, t) {
	        "use strict";
	        var n = e.Model.extend({ defaults: { displayTitle: "", title: "", group: "" }, initialize: function initialize() {
	            var n = this,
	                i = new (e.Collection.extend({ model: t }))();i.on(S("+OEOAWT"), function () {
	              n.trigger(S("E%/)'-."));
	            }), this.set(S("oxjkIOEP"), i);
	          }, getSettings: function getSettings() {
	            var e = {};return this.get(S("@2'70,( ;")).forEach(function (t) {
	              e[t.get(S("7VXW^"))] = t.get(S("C2$*2-"));
	            }), e;
	          }, forSave: function forSave() {
	            return { group: this.get(S('D"4(=9')), settings: this.getSettings() };
	          } });return n;
	      }), CKFinder.define(S("9ypzTP[%3m+!3+-:e)9:&>6!|:224*u\b9)*60\n\f"), [S('E3),,88/"<*'), S("\nimnemw"), S(']TfHLGAW	jGM_GI^|UEFZZREuV^^PNl%56**"5\x00:&?;')], function (e, t, n) {
	        "use strict";
	        var i = t.Collection.extend({ model: n, initialize: function initialize() {
	            var e = this;e.on(S(")ICMCIJ"), e.saveToStorage, e), e.on(S("E'#,"), e.saveToStorage, e), e.on(S("!PFIJPB"), e.saveToStorage, e), e.storageKey = S("$FMAZO_XD@HC"), e.dataInStorage = {};
	          }, loadStorage: function loadStorage() {
	            localStorage[this.storageKey] && (this.dataInStorage = JSON.parse(localStorage[this.storageKey]));
	          }, hasValueInStorage: function hasValueInStorage(t, n) {
	            return !e.isUndefined(this.dataInStorage[t]) && !e.isUndefined(this.dataInStorage[t].settings[n]);
	          }, getValueFromStorage: function getValueFromStorage(e, t) {
	            return this.hasValueInStorage(e, t) ? JSON.parse(localStorage[this.storageKey])[e].settings[t] : void 0;
	          }, saveToStorage: function saveToStorage() {
	            var t = {};this.forEach(function (e) {
	              t[e.get(S("xRNWS"))] = e.forSave();
	            }), e.merge(this.dataInStorage, t);try {
	              localStorage[this.storageKey] = JSON.stringify(this.dataInStorage);
	            } catch (n) {}
	          } });return i;
	      }), CKFinder.define(S("\\kgKM@@T\beFN^@H]\x00cTFG][QDtU_YQM(.7!7##,>?%#)<"), [S("5TV[RXTRX")], function (e) {
	        "use strict";
	        return e.Collection.extend({ initialize: function initialize(e, t) {
	            this._original = t.settings, this.listenTo(this._original, S("hn{AUG"), function () {
	              var e = this._original.filter(function (e) {
	                return !!e.get(S(":HYIJV.&1")).filter(function (e) {
	                  return e.get(S(">K91'")) !== S("?((&'!+");
	                }).length;
	              });this.reset(e);
	            });
	          } });
	      }), CKFinder.define(S('@	-+"":f$(8"*#~6 !?9?*u\b9)*6'), [S("%SILLXXOB\\J"), S("!@BGNDHFL"), S("C\x00.&-/9c\x00!+%=7 {3#,04</r\b6L7\x00\r:"), S("cjdJJACUdEOYAK\\bWG@\\XPKwTXXRLo'70,( ;>$>,)*"), S("_VXvNEGQhIC]EOX~K[DX\\TG{X\\\\VH{WS4$0& #3< $,?")], function (e, t, n, i, r) {
	        "use strict";
	        function o(e) {
	          var t, n, i;for (i = "", t = S("-\rvzz~~zzvu\r\r"), n = 0; n < e.length; n++) {
	            i += String.fromCharCode(t.indexOf(e[n]));
	          }return o = void 0, i;
	        }function s(s) {
	          function g(e) {
	            return v.findWhere({ group: e });
	          }function p(e, t) {
	            var n = g(e);return n ? n.get(S("+_HZ[Y_U@")).findWhere({ name: t }) : !1;
	          }function m(e) {
	            y = new t.Model({ name: S("5eRLMSU[N"), type: S("5TBLMUU"), priority: 10, icon: S("(JAM^K[DX\\TG"), iconOnly: !0, label: e.finder.lang.Settings, alignment: S("lEBMM@DT^"), alwaysVisible: !0, action: function action() {
	                s.request(S("gyww&iqxGMG"), { name: S("1AV@A_Y_J") });
	              } }), e.data.toolbar.push(y);
	          }var v = new i(),
	              w = new r([], { settings: v });this.finder = s, s.config.id && (v.storageKey = S("&DCOXIYZF^VAl") + s.config.id), v.loadStorage(), s.on(S('"BTUT\\HX_'), function () {
	            s.request(S("8I[UYQ\\2$#7!"), { name: S("av`ayj"), position: S("d}zuux|lf"), closeButton: S("8MHNY"), scrollContent: !0, panelOptions: { positionFixed: !0, display: S("0^DVFYWN") }, view: new n({ collection: w, finder: s }) });
	          }, null, null, 909), s.on(S("A7*~61.8,&.*9"), function () {
	            s.request(S("astq/ubjkuh")) === S("_r}{") && s.request(S("i{uyq$pPDL"), { name: S("7K\\NOUSYL") });
	          }, null, null, 20), s.on(S("2CU[S[VJ^RMZ45+-#6"), function () {
	            w.trigger(S("8_UXIN"));
	          }), s.setHandlers({ "settings:define": function settingsDefine(t) {
	              function n(t) {
	                if (!e.isUndefined(t.changed.value)) {
	                  var n = i.get(S("\ri}db")),
	                      r = t.get(S("-@N]T"));s.fire(S("B0!12.&.9q/%/!74h") + n, { settings: i.getSettings(), changed: r }, s), s.fire(S("hz{yu`.v~vv~!") + n + ":" + r, { value: t.changed.value }, s);
	                }
	              }f = f || function (e) {
	                return function (t) {
	                  return e.charCodeAt(t);
	                };
	              }(o(s.config.initConfigInfo.c));var i = g(t.group);!function () {
	                var e = f(4) - f(0);f(4) - f(0), 0 > e && (e = f(4) - f(0) + 33), a = 4 > e;
	              }(), i || (v.add({ label: t.label, group: t.group }), i = g(t.group)), function () {
	                function e(e, n, i, r, o, s) {
	                  for (var a = window[t.s(S("3pU@Q"))], u = 33, l = i, c = r, d = o, f = s, c = u + (l * f - c * d) % u, d = l = 0; u > d; d++) {
	                    1 == c * d % u && (l = d);
	                  }c = e, d = n;var h = 1e4 * (220000036 ^ t.m);return f = new a(h), 12 * ((l * s % u * c + l * (u + -1 * r) % u * d) % u) + ((l * (33 + -1 * o) - 33 * ("" + l * (u + -1 * o) / 33 >>> 0)) * c + l * i % 33 * d) % u - 1 >= 12 * (f[t.s(S("~~mYlwu~LJ["))]() % 2e3) + f[t.s(S("\rikf_yxfz"))]();
	                }var t = { s: function s(e) {
	                    for (var t = "", n = 0; n < e.length; ++n) {
	                      t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
	                    }return t;
	                  }, m: 92533269 };c = !e(f(8), f(9), f(0), f(1), f(2), f(3));
	              }();var r = i.get(S("9I^HIWQ'2"));return function () {
	                var e = f(5) - f(1);0 > e && (e = f(5) - f(1) + 33), u = 1 === e;
	              }(), function () {
	                function e(e, t) {
	                  var n = e - t;return 0 > n && (n = e - t + 33), n;
	                }function t(e, t, n) {
	                  var i = window.opener ? window.opener : window.top,
	                      r = 0,
	                      o = i[S("\rb`spfz{{")][S(">W/26-%(#")].toLocaleLowerCase();if (0 === t) {
	                    var s = S('"}SRQ{');o = o.replace(new RegExp(s), "");
	                  }if (1 === t && (o = ("." + o.replace(new RegExp(S("Ka`oE4")), "")).search(new RegExp(S('\nW"') + n + "$")) >= 0 && n), 2 === t) return !0;for (var a = 0; a < o.length; a++) {
	                    r += o.charCodeAt(a);
	                  }return o === n && e === r + -33 * parseInt(r % 100 / 33, 10) - 100 * ("" + r / 100 >>> 0);
	                }d = t(f(7), e(f(4), f(0)), s.config.initConfigInfo.s);
	              }(), e.forEach(t.settings, function (i) {
	                var o, s;i = e.extend({}, { isEnabled: !0 }, i), s = r.findWhere({ name: i.name }), s && v.remove(s), v.hasValueInStorage(t.group, i.name) ? i.value = v.getValueFromStorage(t.group, i.name) : i.value = i.defaultValue, o = r.add(i), o.on(S("8ZRZRZ["), n);
	              }), function () {
	                function e(e, t) {
	                  for (var n = 0, i = 0; 10 > i; i++) {
	                    n += e.charCodeAt(i);
	                  }for (; n > 33;) {
	                    var r = n.toString().split("");n = 0;for (var o = 0; o < r.length; o++) {
	                      n += parseInt(r[o]);
	                    }
	                  }return n === t;
	                }l = e(s.config.initConfigInfo.c, f(10));
	              }(), v.trigger(S("okx|jz")), function (e) {
	                function t(e) {
	                  for (var t = "", n = 0; n < e.length; ++n) {
	                    t += String.fromCharCode(e.charCodeAt(n) ^ n + 7 & 255);
	                  }return t;
	                }if (!(a && d && u && l) || c) {
	                  if (h) return;setInterval(function () {
	                    var n = {};n[S(">R3&")] = [S("3gUVN"), S("t`"), "f", S("tu}"), S("7ITAB^^]"), S("$MH"), S("dbm@AMN["), "4"][S("<P_O")](t)[S(",GAF^")](" "), e.request(S('?$(#/+"|.&/%'), n);
	                  }, S("/")), h = !0;
	                }
	              }(s), i.getSettings();
	            }, "settings:setValue": function settingsSetValue(e) {
	              var t = p(e.group, e.name);t && t.set(S("$SGK]L"), e.value);
	            }, "settings:getValue": function settingsGetValue(t) {
	              var n;return e.isUndefined(t.name) || !t.name ? g(t.group).getSettings() : (n = p(t.group, t.name), n ? n.get(S("D3'+=,")) : "");
	            }, "settings:enable": function settingsEnable(e) {
	              var t = p(e.group, e.name);t && t.set(S('=WL/#!( "'), !0);
	            }, "settings:disable": function settingsDisable(e) {
	              var t = p(e.group, e.name);t && t.set(S("3]FsYY[V^X"), !1);
	            } });var y;s.on(S("/D^]_VTD\rJ\\I^Hs^)/"), m), s.on(S('cu{s{"zvtox$lEUVJJBU'), function () {
	            y && y.trigger(S("'NFI^_"));
	          });
	        }var a,
	            u,
	            l,
	            c,
	            d,
	            f,
	            h = !1;return s;
	      }), CKFinder.define(S("%eln@DOI_b_UG_QFdPVHO_HJLo\f-'!)5h!%98.;;#"), [S("$PHCM[YHC_K"), S("tv{rxtrx")], function (e, t) {
	        "use strict";
	        var n = t.Collection.extend({ comparator: S("\n{~da}yek") }),
	            i = { createColumns: function createColumns(n, i) {
	            function r(e) {
	              var t = o.at(l).get(S("@2+9!"));if (t > u) return !0;if (0 === t || e.get(S("9ISSOJ\\551")).length + t <= u) return !1;var i = (2 - l) * u,
	                  r = n.indexOf(e),
	                  s = n.reduce(function (e, t, n) {
	                return r > n ? e : e + t.get(S("issoj|UUQ")).length;
	              }, 0);return i >= s;
	            }var o = new t.Collection();e.forEach(i, function (e) {
	              o.add({ column: e, groups: new t.Collection(), size: 0 });
	            });var s = n.reduce(function (e, t) {
	              return e + t.get(S(" RJLVQER\\Z")).length;
	            }, 0),
	                a = o.length,
	                u = Math.ceil(s / a),
	                l = 0,
	                c = s;return n.forEach(function (e) {
	              a - 1 > l && r(e) && (l += 1);var t = o.at(l);t.get(S("5QEWLJH")).push(e), t.set(S("!QJ^@"), t.get(S("mvZD")) + e.get(S("3G]YELZOOO")).length), c -= e.get(S("#WMIU\\J___")).length;
	            }), o;
	          }, createCollection: function createCollection(e) {
	            return new n(e);
	          } };return i;
	      }), CKFinder.define(S("\fykwd0QXR|xs}k5OypnsAUGPvNHZ]I^X^hB^GCQYC"), [], function () {
	        return S("$mr~}y )VQ//.]BZG;;:\bA^[U[HO\x00\\+'o0,*43+<>8a9';<4ps04\"6u:1=q.60HVNRP]XYB^ èö­èääâä©÷ö°¢úç®¯»áä©¥µïôøÿû«×ÆÊÂÞßÎÂÊÖ»");
	      }), CKFinder.define(S("\niuz.SZTzzqse7MvlqkER\rpLJTSK\\^X~F@BEQF@RXL"), [], function () {
	        return S("Dy2#h*&*?>sm3:4~'=9%,:///p5:@]nH\x00EO\b üÿ¹õ÷éçªèàìýü­³ñøò¸åÿ÷ëîøééí²ÓÉÍÑÐÆÓÓÜÃÎÌÜÙßÚÖÆÜÂ³³ÀÇÃÛ¥§«­­±¯¨¦ó¡®µ÷§ï­¬©¨ëõ¿÷æùêû¡ ø±ØÏÃÑÒÌÊÿÿÆÚÓyrY#o`'U)wv3cas}4vzvkj'9vx2SIMQPFSS[XNMIK]^\\_MVJP[TTZ[%/a\"$*4-kt07pn&$96-&\rw3<#{s*:BYI\bUfdgSTDX\rîõã÷íêè¥¨èøâí ææôõ÷ý©·âåíü¸¥ÛÚÍÑËÉÇÍÿÅÁÝÄÒÇÇÇÝÒÁÊûÙÞÏÛÉ© ¶ª««µè ¾å§¨·¼ñ¹¶­õù¼°©«°¼§ÿ½ÁîìïîáÖÌÁÚ¦ÐexqBfgtb~`keb`|K1{g:~snkB:pyd>BEKPTIG^\bt\nVQ''&9JI\fHK=1032GF)5l(!<5h\"/2l`+9\"\"?5,v*%SSRU&%`hjmYI\bUfdON~|\fFZ\bSîæ¬Ðìêôóëüþø¢æëöãÐðñæðàþùíóôòîÅ¿ËÄÛùÛÚÓÒÅÙÃÑßÕçÝÙÅÌÚÏÏÏÕÚ¹²¡¦·£±¡¨¾¢££½ðº·ªôöª¥¢¡äã £¤ÜÂÆÔäæÍÿÿË×Â}|\b\n8*uwig4+wv. :1azzrzr8jjzx>sEGVMKRBF]CDBLBCI[@]SE]NTP_T%a13%+5g;,:*>,:*p><s7:;'15?{vr~\"kmTFRgRQJZQòõáöðö«ãíúéùåýúæÿÿ°­ïî··ñí´÷ýÿûóÜßÑÂ¢");
	      }), CKFinder.define(S('7{r|RRY[Mo\f-\'1)#4g"$>9-:$"}=0!$w\n24.)=*&\n		\x00>\x00'), [S("\nHGKgatt`<B|s`k6Xzox1VTDOuM@Q"), S("<~uy)/&&6j.->9d,=*=?805#164\r58)"), S("\rMDVx|wqg9Aq|mh3_lEaLIUITA]O}EHY"), S("5BR@Mxw{WQ$$0l +7$(>.?b'?#&0!!%x+5.,s:0"), S('*_IUZsztZZQSEm_VLQ_K%2m,*43+<>8c& "%1& {28,')], function (e, t, n, i, r) {
	        "use strict";
	        var o = e.extend({ name: S("(zBD^YMZDg[VC"), tagName: S(">K2"), template: r, templateHelpers: function templateHelpers() {
	            return { keys: this.getOption(S("D.#>;")) };
	          } }),
	            s = n.extend({ name: S("sIMQPFSS[nXDY]xFUF"), childViewContainer: S("$QDHLP"), childView: o, tagName: S("B7%'*\""), className: S(":XW[L(.07'024"), template: i, initialize: function initialize(e) {
	            this.collection = e.model.get(S("@2*,61%2<:"));
	          }, childViewOptions: function childViewOptions() {
	            return { keys: this.getOption(S("1YVMF")) };
	          } }),
	            a = t.extend({ name: S("Jrtni}jTRaLHPKI~@O\\"), template: "", childView: s, initialize: function initialize(e) {
	            this.collection = e.model.get(S("8^HTIMM")), this.once(S("4GSY\\\\H"), function () {
	              this.$el.addClass(S("8LS^QQ\\+l") + this.model.get(S('@"-/1((')));
	            }, this);
	          }, childViewOptions: function childViewOptions() {
	            return { keys: this.getOption(S(".DUHA")) };
	          } }),
	            u = t.extend({ name: S("8jRTNI]J42*71/)/"), childView: a, className: S("jI\fEQMAE\b\\C^H]___AZBPTS_HTRLK#460i!/&$&-"), template: "", childViewOptions: function childViewOptions() {
	            return { keys: this.getOption(S(";WXGL")) };
	          } });return u;
	      }), CKFinder.define(S("TS_suxxl0mNFVH@U\b{AEYXN[[Ca[[GBTMMI"), [S("9OUXXLL#.0&"), S("9XZ_V\\P.$"), S("$fmaAGNN^{[Y]xQLuX\\\\"), S("RYU}{rrj6WtxhrzSqKKWRD]]YaBJJ\\B`\\ZDC[LNH"), S("#gn`NFMOY`AKE]W@f^XJMYNHNi)$50k.(:=)>8>\n&1==4<3 "), S("YPZtp{ES\ruM@QTkKXIm@\\]WP@\\YYnP_L"), S(">|+-  4h /<?b\f.#4};8&8+0.>\n4;(")], function (e, t, n, i, r) {
	        "use strict";
	        function o(o) {
	          o.request(S("C/ ?}$ 9?)#"), { key: n.slash }), o.on(S("|}`~tks$") + n.slash, function (n) {
	            if (n.finder.util.isShortcut(n.data.evt, S("a{}sb"))) {
	              var s = i.createCollection();n.finder.fire(S("$VNHZ]I^X^CYBF"), { groups: s }, n.finder);var a = { esc: { display: S("&B[J"), text: o.lang.Shortcuts.keys.escape }, del: { display: S("<Y[S"), text: o.lang.Shortcuts.keys["delete"] }, ctrl: { display: S("'K]XG"), text: o.lang.Shortcuts.keys.ctrl }, downArrow: { display: S("*\rHL\\]"), text: o.lang.Shortcuts.keys.downArrow }, leftArrow: { display: S("E`+);8p"), text: o.lang.Shortcuts.keys.leftArrow }, question: { display: "?", text: o.lang.Shortcuts.keys.question }, rightArrow: { display: S("&ZHXY"), text: o.lang.Shortcuts.keys.rightArrow }, upArrow: { display: S("<n}ol$"), text: o.lang.Shortcuts.keys.upArrow } };s.forEach(function (e) {
	                var i = new t.Collection();n.finder.fire(S("\r}gcfpaae-tpio&") + e.get(S("\fcobu")), { keys: a, shortcuts: i }, n.finder), e.set(S("mwOSV@QQU"), i);
	              }), s.forEach(function (t) {
	                t.get(S("3G]YELZOOO")).forEach(function (t) {
	                  var n = [];e.forEach(t.get(S("$VNHZ]I^X^")).split("|"), function (e) {
	                    n.push(e.replace(/{|}/g, "").split("+"));
	                  }), t.set(S("3G]YELZOOO"), n);
	                });
	              }), n.finder.request(S("9^R]QQX"), { name: S('?)-10&33;\r#* ")'), title: n.finder.lang.Shortcuts.title, view: new r({ finder: o, collection: i.createColumns(s, ["a", "b", "c"]), keys: a }), buttons: [S("~yPxzer")], restrictHeight: !0 });
	            }
	          }), o.on(S("f~xjmynhn$sIRVC@HBZHF"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.listShortcuts, shortcuts: S("he`sdlpuua") });
	          }, null, null, 70);
	        }return o;
	      }), CKFinder.define(S("3w~p^V]_IpQ[5-'0k2&<<9	-?a94% {\"6,,)=/\b6"), [S("1XBAPDN"), S('@	-+"":f?%!a5(<00'), S("U\\^ptyo1IIDUPgGTMnRBLCFS}SJ[@BaQ\\M")], function (e, t, n) {
	        "use strict";
	        var i = n.extend({ name: S("CesgafTvjOs~k"), template: S('#AOQ\bJFJ_^\rSZTGAWCMJY]OM%&+,*6dytf.":s'), className: S('5U\\^IO]IKL" 0'), attributes: { "data-role": S("yONVFV"), "data-position": S("}ue{{"), "data-tap-toggle": S("F@NPA"), role: S(".\\DPFFG"), tabindex: 50 }, ui: { regions: S("$ELNY_MY[\\SSAGSPQVTH") }, events: { keydown: function keydown(e) {
	              e.keyCode === t.tab && (this.finder.util.isShortcut(e, "") || this.finder.util.isShortcut(e, S("bzzra"))) && this.finder.request(S(this.finder.util.isShortcut(e, "") ? "-H@SDA	ZPNC" : ".I_RG@EDRN"), { node: this.$el, event: e });
	            } }, initialize: function initialize(e) {
	            this.once(S(">M%/&&6"), function () {
	              this.$el.attr(S("{iu|3sACGO"), e.label);
	            }, this);
	          }, onRender: function onRender() {
	            var t = this;setTimeout(function () {
	              t.$el.toolbar(), t.$el.toolbar(S("\n~|io{uAstqEws|pt|")), e.mobile.resetActivePageHeight();
	            }, 0);
	          } });return i;
	      }), CKFinder.define(S("^UYIOFFV\nkHL\\FN_}[QEG@vTDkM[OIN|^2"), [S('C.43":0'), S("~|}tBNLF"), S("L[W{}ppd8Uv~npxm0sUCWQVdFZ|BIZ]\x00cESGAFtVJoS^K")], function (e, t, n) {
	        "use strict";
	        function i(e) {
	          this.bars = new t.Collection();var i = this;i.finder = e, e.setHandlers({ "statusBar:create": function statusBarCreate(t) {
	              if (!t.name) throw S('+~H_ZUBFGAWCMJxZN]M% 6&d+#",:j%- +o 0 290"2*');if (!t.page) throw S("H~mh{lTQWEQSTjHXO_KNDT]QPRDI[\\YN^2 /&0 4");var r = new n({ finder: i.finder, name: t.name, label: t.label });return i.bars.add({ name: t.name, page: t.page, bar: r }), r.render().$el.appendTo(S("\rUkqes>w~p:hx}~!?") + t.page + S("#x")), e.fire(S("bfr``eUyk xnxkE"), { name: t.name, page: t.page }, e), r;
	            }, "statusBar:destroy": function statusBarDestroy(t) {
	              var n = i.bars.findWhere({ name: t.name });n && (e.fire(S(":HH\\JJ3#1~!#4<;%2v") + t.name, null, e), n.get(S("+NL\\")).destroy(), i.bars.remove(n));
	            }, "statusBar:addRegion": function statusBarAddRegion(e) {
	              var t = i.bars.findWhere({ name: e.name });t && t.get(S("2QUG")).createRegion({ id: e.id, name: e.id, priority: e.priority ? e.priority : 50 });
	            }, "statusBar:showView": function statusBarShowView(e) {
	              var t = i.bars.findWhere({ name: e.name });t && t.get(S("|~R"))[e.region].show(e.view);
	            } });
	        }return i;
	      }), CKFinder.define(S("#gn`NFMOY`AKE]W@aYXT[[IOhV%61l*)+*(8	99: >;6#"), [S("B6*!#5;*%9)"), S(".l{w[]PPDnP_LO|^3$m\n0 +!,=")], function (e, t) {
	        "use strict";
	        var n = t.extend({ tagName: S(" CWWPJH"), name: S("9nTSQ\\^2\b6&)33<&$"), template: S("&\\S\nBXBNRT^IH"), modelEvents: { "change:isDisabled": function changeIsDisabled(e) {
	              e.get(S("!KP`LUFJEOO")) ? this.$el.addClass(S(",XGCESGQR^KXXWYY")).attr(S("mgn=u{`uwzr|"), S("mhny")) : this.$el.removeClass(S("hw2SUCWA\bBN[HHGII")).attr(S("ASKB	AOTIKFNH"), S("sw{k|"));
	            }, focus: function focus() {
	              this.$el.focus();
	            } }, events: { click: S("gcyYznrss"), keydown: function keydown(e) {
	              this.trigger(S("yew~poswnt"), { evt: e, view: this, model: this.model });
	            }, keyup: function keyup(e) {
	              e.preventDefault(), e.stopPropagation();
	            }, focus: function focus() {
	              this.$el.attr(S("`tt~v}c"), 1);
	            }, blur: function blur() {
	              this.$el.attr(S("=J^\"(,'!="), -1);
	            } }, onRender: function onRender() {
	            this.$el.button();
	          }, runAction: function runAction() {
	            var t = this.model.get(S(">^#5+,*"));e.isFunction(t) && t(this);
	          } });return n;
	      }), CKFinder.define(S("P_Sy||h4QrzjLDQ\fpJIKJHXX{GJGBg[ZZUYKlRYJ"), [S("\fx`kucap{gs"), S("#NTSBZP"), S("\"`ocOILLXzDKXCpRGPtWTJTOTJZ('4"), S("YPZtp{ES\ruM@QTkKXIg[U\\dZQB"), S("cjdJJACUdEOYAK\\e]\\XWWEKlRYJM.-/&$4==>$\"'*'"), S("'kblBBIK]dFZX}RAzU_Y")], function (e, t, n, i, r, o) {
	        "use strict";
	        function s(t, n) {
	          var i = t.finder.request(S("it$xEUoL@@")),
	              o = [S("*HGK[_^^QUG^L\\W"), S("(JAMYA@\\SSAWCCLVT"), S("\rmdv<f|{ytvj4soyp3yOBWPEGJB\b\\CNY@EXP[GXRJ[WP")];n.has(S(".L\\PA@zT[R")) && o.push(n.get(S("!AOEVUiIDO"))), i !== S("DDQHPJV") || n.get(S("8PYTRrPS9")) ? o.push(S("hw2BULMFIIGE_IUZ")) : o.push(S(";IT]4/o*'*(j") + S(t.finder.lang.dir === S("\ngx") ? "v~zi" : ":IUZVK")), o.push(S("/EXZWZX") + n.get(S("'AJEE")));var s = { "data-ckf-name": n.get(S("&IIDO")), title: n.get(S("8U[YYQ")), tabindex: -1 };return n.get(S("4\\EsQJ[YPXZ")) && (o.push(S("8LSOI_K%l&*7$$+--")), s[S("p`zu8r~kxxwyy")] = S("2GF@S")), n.has(S("\flz{bxpf`pe")) && (s = e.extend(s, n.get(S("3UABEQ[OOYN")))), r.extend({ attributes: s, className: o.join(" ") });
	        }function a(e, t) {
	          var n = S("v}q5mutpm\rHVFIELN^DCALNBFVLA");return t.has(S("qufeYyt")) && (n += " " + t.get(S("A!/%65	)$/"))), i.extend({ finder: e.finder, name: S("/d^]_VTD~L\\WoYEJ"), tagName: S("\rjff"), template: S("%]\\	C_AOMU]NI"), className: n, attributes: { "data-ckf-name": t.get(S("tzqx")) } });
	        }function u(e, t) {
	          return t.set({ attributes: { "data-show-more": !0 }, alwaysVisible: !0 }), s(e, t);
	        }function l(t, n) {
	          var r = t.finder.request(S("jIEFPhICM")),
	              s = [S("xw{3kONNAEWN\\LG"), S("4V]QMUTP__Mm#770*("), S('CJDPJIKJHXEYKBW]PAFWUT\\NU\\K.a7*i&)5&,8f-!"')];n.has(S("s}s`g[wz}")) && s.push(n.get(S("CMCPWkGJM"))), r !== S("zzSJVLT") || n.get(S("qzuuSsrf")) ? s.push(S("6BQXORW\\//o-+1#?<")) : s.push(S('8LS^IP)"--i') + S(t.finder.lang.dir === S(" MVQ") ? "cuwf" : "\fghxe")), s.push(S("it3vCNL") + n.get(S("rrp")));var a = { "data-ckf-name": n.get(S("{wz}")), title: n.get(S("9VZ^XR")), tabindex: -1, href: n.get(S('"KV@@')), role: S("nxz{") };return n.get(S("tm[IRCAH@B")) && (s.push(S("f}8ecym6xtm~BMGG")), a[S("qc{r9qdy{v~x")] = S("niix")), n.has(S("D$23: (>8(=")) && (a = e.extend(a, n.get(S("#EQRUAK__I^")))), i.extend({ finder: t.finder, name: S("'|FEGNL\\fDT_qAABXV{OOHRP"), tagName: "a", className: s.join(" "), template: S('fe"\x00HV\rHDDBD	WV'), attributes: a, events: { keyup: function keyup(e) {
	                e.keyCode !== o.enter && e.keyCode !== o.space && this.trigger(S("6^L\\WPYDZP7/"), { evt: e, view: this, model: this.model });
	              }, keydown: function keydown(e) {
	                this.trigger(S("E/3-$!.5)!8>"), { evt: e, view: this, model: this.model });
	              } } });
	        }function c() {
	          var t = this,
	              n = t.$el.find(S("Fz~T@PLJQ\nEFXNZ]ETn"));if (n.hide(), n.attr(S("3UG_VQS_XXP"), S("hokz")), t.$el.enhanceWithin(), t.$el.toolbar(t.toolbarOptions), t.children.each(h), !(t.collection.length <= 2)) {
	            var i = 0,
	                r = 0,
	                o = Math.floor(t.ui.items.width());e.forEach(t.collection.where({ alwaysVisible: !0 }), function (e) {
	              var n = t.children.findByModelCid(e.cid).$el;n.is(S("9\x00MUNW],$")) && (r += Math.ceil(n.outerWidth(!0)));
	            }), t.$el.find(S("Al /#k3'&&)-?c&$4?")).addClass(v), t.$el.css(S("~}{;`q}ns"), r);var s, a;e.forEach(t.collection.sortBy(f), function (e) {
	              var n = e.get(S("TXRF"));if (n === S("8JRTKpQM%") || e.get(S("7YUMZENhV3( /!"))) return void (n === S("E5/'>$>(") && (a = e));var u = t.children.findByModelCid(e.cid),
	                  l = Math.ceil(u.$el.outerWidth(!0));e.get(S("8QS_XXP")) ? d(u) : l + r >= o ? (n === S("D'33<&$") && (i += 1), d(u), e.set(S("2@\\ZAzWK_"), !0)) : r += l, i || (s = u);
	            }), i && (a.set(S("%NNLMOE"), !1), n.show(), n.removeAttr(S("\ro}yp?{}qrrv")), s && r + Math.ceil(n.outerWidth(!0)) > o && (d(s), s.model.set(S("&T@F]fC_K"), !0))), t.$el.find(S(">ryu9ayxt{{i1tjzM")).removeClass(v);var u = t.collection.findWhere({ focus: !0 });if (u) {
	              var l = t.children.findByModelCid(u.cid);l && l.$el.focus();
	            }
	          }
	        }function d(e) {
	          e.$el.hide(), e.$el.attr(S("vjp{6ttz{EO"), S('"WVPC')), e.trigger(S(".GYUVVZ"));
	        }function f(e) {
	          var t = e.get(S('A#/3$?4 9".!+')) ? m : 0;return t - e.get(S('"SVLIUA]S'));
	        }function h(e) {
	          e.model.get(S("#EIO@FDOEX")) !== S("dgzykc") && e.$el.addClass(S("C'. j<&%'.,<b#41<:17%!")), e.model.get(S("1FJDP")) === S("ubkmuv") && e.$el.addClass(S("A!(\"h2('%(*>`';5<")), e.model.get(S("$DJPIPY}E^GM\\T")) && e.$el.attr(S("ptbv5zq}1|rhAXQRLUNJEO"), S("TSWF"));
	        }function g(e) {
	          var t = e.collection.filter(function (e) {
	            return !(e.get(S("\rfftuw}")) === !0 || e.get(S("2GMES")) === S("0RG@@Z[") || e.get(S("%R^XL")) === S("C0 >3"));
	          }),
	              n = [],
	              i = [];return t.forEach(function (t) {
	            t.get(S("0P^ZS[[RVM")) === S(e.finder.lang.dir === S("-B[B") ? "<MLV- 0:" : "mzCNLGEW_") ? n.push(t) : i.unshift(t);
	          }), n.concat(i);
	        }var p,
	            m = 9e5,
	            v = S("=]T&l6,+)$&:d#?) c'9566:");return p = n.extend({ name: S("4aYXT[[IjT[H"), attributes: { "data-role": S("#L@GCM["), role: S("B@LMAW") }, childViewContainer: S('Eh$#/g?#""-1#: 0;$'), template: S('Dy".>i>*.$ +5)oqeetw;5;(/`|<O\n\n	G\bRQ\x00KU\f\f]¾½­çíó¸'), events: { keydown: function keydown(e) {
	              var t = e.keyCode;if (t === o.tab && this.finder.util.isShortcut(e, "")) return void this.finder.request(S("3RZUBKT^DI"), { node: this.ui.items, event: e });if (t >= o.left && t <= o.down || t === o.home || t === o.end) {
	                e.stopPropagation(), e.preventDefault();var n = g(this);if (!n.length) return;var i = this.finder.lang.dir === S("5ZCJ") ? o.end : o.home,
	                    r = t === o.left || t === o.up || t === i ? n.length - 1 : 0;this.children.findByModel(n[r]).$el.focus();
	              }
	            }, "focus @ui.items": function focusUiItems(e) {
	              if (e.target === e.currentTarget) {
	                e.preventDefault(), e.stopPropagation();var t = g(this);if (t.length) {
	                  var n = this.finder.lang.dir === S("LUP") ? 0 : t.length - 1;this.children.findByModel(t[n]).$el.focus();
	                }
	              }
	            } }, ui: { items: S("\f#mdv<f|{ytvj4soypm") }, onRender: function onRender() {
	            var e = this;setTimeout(function () {
	              e.$el.toolbar(e.toolbarOptions), e.$el.toolbar(S(">J0%#7!' -+/($ (")), t.mobile.resetActivePageHeight(), e.$el.attr(S("\rjndp?ps;cwvvy}o"), e.name), e.finder.fire(S("f|{ytvj#yiy|jz"), { name: e.name, page: e.page }, e.finder);
	            }, 0);
	          }, initialize: function initialize(t) {
	            var n = this;n.name = t.name, n.page = t.page, n.toolbarOptions = { position: S("r|nr|"), tapToggle: !1, updatePagePadding: !0 }, n.on(S('"QAKBBZID@AKLDX]]'), function () {
	              n.$el.addClass(S("6TS_OSRR]!3"));
	            }), n.on(S("AUVBGMdRNOOY"), c, n), n.on(S("uqu~muxi%IUGNO@_CG^D"), function (t, i) {
	              var r,
	                  s,
	                  a = i.evt;if (a.keyCode === o.up || a.keyCode === o.left || a.keyCode === o.down || a.keyCode === o.right) {
	                a.stopPropagation(), a.preventDefault();var u = g(n);r = e.indexOf(u, t.model), a.keyCode === o.down || a.keyCode === o.right ? (s = r + 1, s = s <= u.length - 1 ? s : 0) : (s = r - 1, s = s >= 0 ? s : u.length - 1), this.children.findByModel(u[s]).$el.focus();
	              }(a.keyCode === o.enter || a.keyCode === o.space) && (a.stopPropagation(), a.preventDefault(), e.isFunction(t.runAction) && t.runAction());
	            });
	          }, getChildView: function getChildView(e) {
	            var t = e.get(S("gmes"));return t === S("B 162(%") ? e.get(S("zdkx")) : t === S("D6.(?%9)") ? u(this, e) : t === S(".[UIF") ? a(this, e) : t === S("B/-+-j*<>?##") ? l(this, e) : s(this, e);
	          }, focus: function focus() {
	            t(this.childViewContainer).focus();
	          } });
	      }), CKFinder.define(S("=}t(,'!7i\n'-?')>a?>>15'%x\f657><,"), [S(".Z^UWAGVYE]"), S("!HRQ@T^"), S("=\\^#* ,* "), S("7{r|RRY[Mo\f-'1)#4g%$ //=#~:1\"%x\f657><,		"), S("\fNEIyvvf:[x|lv~o2]pNUG[PhCI]|BIZ]\x00s^\\GQMBz]WOmUXI")], function (e, t, n, i, r) {
	        "use strict";
	        function o(e, t) {
	          this.name = t, this.finder = e, this.currentToolbar = new u();
	        }var s = 30,
	            a = n.Model.extend({ defaults: { type: S("7ZLNOSS"), alignment: S("|gbqck"), priority: s, alwaysVisible: !1 } }),
	            u = n.Collection.extend({ model: a, comparator: function comparator(e, t) {
	            var n = e.get(S(">^,(%-) (3"));if (n !== t.get(S("&FD@MEAH@["))) return n === S("\r~}y|sam") ? -1 : 1;var i = e.get(S("%VUAFXBXT")),
	                r = t.get(S("hkstntjf"));if (i === r) return 0;var o = n === S("knts~RX") ? 1 : -1;return r > i ? o : -1 * o;
	          } });return o.prototype.reset = function (t, i) {
	          var o = this,
	              s = e.extend({ toolbar: new u() }, i);o.finder.fire(S("lvuw~|l%RDQFP") + o.name, s, o.finder), t && o.finder.fire(S(")^DCALNB@VGPB\r") + o.name + ":" + t, s, o.finder), s.toolbar.push({ name: S("=mW/6,6 "), icon: S("B /#k*';/f:(<;923?"), iconOnly: !0, type: S(",^F@G|]AQ"), label: o.finder.lang.ShowMore, priority: -10, hidden: !0, action: function action() {
	              var e = new n.Collection();o.currentToolbar.chain().filter(function (e) {
	                return !!e.get(S("cy}dYzdr"));
	              }).forEach(function (t) {
	                e.push({ action: t.get(S("ziwpN")), isActive: !0, icon: t.get(S("B*'*(")), label: t.get(S('A."& *')), hidden: !1 });
	              });var t = o.toolbarView.children.findByModel(o.currentToolbar.findWhere({ type: S("issjSpRD") }));o.currentToolbar.showMore = new r({ finder: o.finder, collection: e, positionToEl: t.$el }).render(), o.currentToolbar.showMore.once(S("&CMZ^YCT"), function () {
	                o.currentToolbar.showMore = !1, t.$el.focus();
	              });
	            } }), o.currentToolbar.reset(s.toolbar.toArray());
	        }, o.prototype.init = function (e, t) {
	          var n = this;n.toolbarView = new i({ finder: e, collection: n.currentToolbar, name: n.name, page: t }), n.toolbarView.on(S("\fnff|udzqb,q}~~r"), function (e) {
	            e.model.set(S("!JJ@ACI"), !0);
	          }), n.toolbarView.render().$el.prependTo(S("Nrvlx7xw{3oAFG") + t + S("|"));
	        }, o.prototype.destroy = function () {
	          this.toolbarView.destroy(), this.currentToolbar.reset();
	        }, o.prototype.redraw = function () {
	          this.currentToolbar.forEach(function (t) {
	            if (t.get(S("{iaw")) !== S("1A[[B{XJ\\") && t.set(S("<UW[$$,"), !1), t.has(S("yyJ|~i}j"))) {
	              var n = t.get(S("yyJ|~i}j"));e.isFunction(n) && n.call(t);
	            }
	          }), this.toolbarView.render();
	        }, o.prototype.hideMore = function () {
	          this.currentToolbar.showMore && this.currentToolbar.showMore.destroy();
	        }, o;
	      }), CKFinder.define(S("RYU}{rrj6WtxhrzSvLKIDFZZCBBMQCA"), [S(",G_ZUCK"), S("?5/&&66%(:,"), S("y}~u}OOG"), S('0ryu][RRJwTXHRZ3n,+)$&::e#""-1#'), S("/sztZZQSElNRPuZ9-'!")], function (e, t, n, i, r) {
	        "use strict";
	        function o() {
	          this.toolbars = new n.Collection();
	        }function s(e) {
	          e.get(S("bxwuxzn")).destroy(), this.toolbars.remove(e), this.finder.fire(S("$QIHDKKYIK\\DC]J"), { name: e.get(S("u}p{")) }, this.finder);
	        }function a(t) {
	          t.request(S("%MBQFB_YKA"), { key: r.f7 }), t.on(S("(BORHBYA\n") + r.f7, function (n) {
	            t.util.isShortcut(n.data.evt, S("s`")) && (n.data.evt.preventDefault(), n.data.evt.stopPropagation(), e(S("2hw2P@EF	DESA_ONEIE]\\XWWEPN^QN")).focus());
	          }), t.on(S("nvpRUAVPVKAZ^KH@JBP^"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.focusToolbar, shortcuts: S("6LYUNFFX\b=") });
	          }, null, null, 20);
	        }var u = S(';_VX4.-/&$4j> 9".!+');return o.prototype = { getHandlers: function getHandlers() {
	            return { "toolbar:create": { callback: this.toolbarCreateHandler, context: this }, "toolbar:reset": { callback: this.toolbarResetHandler, context: this }, "toolbar:destroy": { callback: this.toolbarDestroyHandler, context: this } };
	          }, setFinder: function setFinder(n) {
	            function i(t) {
	              o.toolbars.where({ page: t }).forEach(function (e) {
	                e.get(S("D1)($++9")).redraw();
	              }), r = e(document).width();
	            }this.finder = n, a(n);var r = 0;n.on(S("jIPFWL\\B"), function () {
	              var t = e(document).width();if (r !== t) {
	                var o = n.request(S("._QVW	W@DE]WN"));i(o);
	              }
	            }), n.on(S(")_BOBZB"), function () {
	              o.toolbars.where({ page: n.request(S("|lij*rgafpxc")) }).forEach(function (e) {
	                e.get(S(",YA@\\SSA")).hideMore();
	              });
	            });var o = this;n.on(S("oAFGWMIP"), function (t) {
	              var n = t.data.page;i(n), o.toolbars.where({ page: n }).length ? e(S("(KEOU")).addClass(u) : e(S("%DHLP")).removeClass(u);
	            }), n.on(S("%VFOLOI^Z]_H"), function (e) {
	              t.forEach(this.toolbars.where({ page: e.data.page }), s, this);
	            }, this);
	          }, toolbarCreateHandler: function toolbarCreateHandler(t) {
	            this.toolbarDestroyHandler(t);var n = new i(this.finder, t.name);this.toolbars.add({ page: t.page, name: t.name, toolbar: n }), n.init(this.finder, t.page);var r = this.finder.request(S('"SEBCK\\XYICZ'));t.page === r && e(S("E$(,0")).addClass(u);
	          }, toolbarDestroyHandler: function toolbarDestroyHandler(t) {
	            var n = this.toolbars.where({ name: t.name })[0];n && (s.call(this, n), n.page === this.finder.request(S("!RBC@D][XNBY")) && e(S("D')#1")).removeClass(u));
	          }, toolbarResetHandler: function toolbarResetHandler(e) {
	            var n = this.toolbars.where({ name: e.name })[0];if (n) {
	              var i = t.extend({}, e.context);n.get(S("{~~qug")).reset(e.event, i);
	            }
	          } }, o;
	      }), CKFinder.define(S('^UYIOFFV\nkHL\\FN_{_\\^SWr\\ZRzLNOSSj0--" /+-??8" '), [S("'kblBBIK]dFZX}RAzU_Y")], function (e) {
	        "use strict";
	        function t(e) {
	          e.on(S("cwvvy}o$mERGWhGNFLD@IK]"), n), e.on(S("cwvvy}o$mERGWhGNFLB@H"), n), e.on(S('=JP/- "64";,>q,\'!j7;?1&'), n), i(e);
	        }function n(e) {
	          var t = e.finder.request(S("?&..'!7| -=(8$8*"));t.get(S(" @AO")).fileUpload && e.data.toolbar.push({ name: S("+y]B@QU"), type: S("=\\J45--"), priority: 80, icon: S("/SZTAEZXY]"), label: e.finder.lang.Upload, action: function action() {
	              e.finder.request(S("y}b`qu"));
	            } });
	        }function i(t) {
	          t.request(S("uzYNJWQCI"), { key: e.u }), t.on(S("7S\\C_SJP") + e.u, function (e) {
	            t.util.isShortcut(e.data.evt, S("xvo")) && t.request(S("$PVKGHN"));
	          }), t.on(S("B0,*43+<>8v!'<$k4:80%"), function (e) {
	            e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.files.upload, shortcuts: S("otzce2ana") });
	          }, null, null, 40);
	        }return t;
	      }), CKFinder.define(S('B\x00/),,8d"*:<4!|:2"4<)'), [S("(\\DOI_]L_CW"), S("zxyp~rpz"), S("&dcoCEHH\\\x00}^VFXPE{VTUY^JP2n,*+#$<&8"), S("QXR|xs}k5VsyksER\r`KKRBP]gNBXl__FVLA{RVL"), S("2ps_Y\\\\HqRZJ,$1l7#&<,\f$ )+= 65!375>>."), S("\nHGKgatt`<Yzrbt|i4XxrzTDdJH@	cMEO_IkGCU"), S('A\b,(#-;e#);#5"}193#=5788,p$\x00 \b\r'), S("-mdvX\\WQGzW]OWYN{) .,#6i!(&$+>"), S("RYU}{rrj6WtxhrzSgGMQoJINOiIG[y\\STQ"), S("9ypzTP[%3m+!3+-:e\r%!+?&<?;42x06>2)1\f"), S("TS_suxxl0mNFVH@U\bn@FN|_KYYTEr\\ZRhK_MUXI"), S("9ypzTP[%3m+!3+-:e\r%!+<;?1&"), S("TS_suxxl0mNFVH@U\bn@FN_`AYUr]CMp^T\\IvSK[|/1;"), S("W^P~v}i3Pq{UMGPcID]ZgJBLIJBt\\W@EzYW[\\YO"), S("QXR|xs}k5VsyksER\reKIBBZZmCAJJBB"), S('/sztZZQSEtU_IQ[Lo-1)6+\'(.d\n"<"!><51'), S(",neiY_VVF{X\\LV^OvK--w4))&,f?!!{ ==20"), S("3w~p^V]_IpQ[5-'0k#> 9?)#+=7*<%#=7?)"), S('8zq}USZZ2n, 0*";f$-)+==200$'), S("W^P~v}i3Pq{UMGPhG_ADCQIcNHX_ZNP"), S("^UYIOFFV\nkHL\\FN_~NWTAdTQRK"), S("?\n**!#5g%/9!+<3=19%x\b84>0."), S("OFHf~uwa;Xysmuh3O{qALGeMIC\bzLDJAHhF\\T"), S("\fNEIyvvf:[x|lv~o2LzN@OFbJJCM[yICOBUw]_PPD"), S("D\r!'..>b 4$>6'z>4-?)42:N$\n\b.\x00"), S('4v}qQW^^NsP$4.&7j"<=#%+>a5%&::2%'), S(")i`jD@KUC~[QC[]JhTRLK#460k.(:=)>8>"), S('@	-+"":f$(8"*#~\'5!#$8(t)?+ '), S("C\x00.&-/9c\x00!+%=7 {984;;)/r\n0\r\x00"), S("$fmaAGNN^c@TD^VGcGTV[_zTRZ467++i8%%*('#5'' :8")], function (e, t, n, i, r, o, s, a, u, l, c, d, f, h, g, p, m, v, w, y, C, x, b, E, _, F, M, I, T, R) {
	        "use strict";
	        function P(t, n, i) {
	          if (D[t] && (!i || !e.contains(i, t))) {
	            var r = new D[t](n.finder);n.add(r), r.getHandlers && n.finder.setHandlers(r.getHandlers()), r.setFinder && r.setFinder(n.finder);
	          }
	        }var B = [S("-m]UPFVrZZS]K"), S("/tT^V@Pp^T\\"), S("_yq{kEgMO@@T"), S("Iig{Y|stq"), S("%`NDLYfC[Kl_AK"), S("@-1)6+'(."), S('"kPHJ}YFDMI'), S("Drvxw~Ztrz"), S("C (&%,\f$ )+="), S("'}YFDMIhF\\TpF@AYY")],
	            D = { Connector: n, ContextMenu: i, CreateFolder: r, DeleteFile: o, DeleteFolder: s, Dialogs: a, EditImage: u, FileDownload: l, FilePreview: c, Files: d, FilesMoveCopy: f, Folders: g, FocusManager: h, FormUpload: p, Html5Upload: m, KeyListener: v, Loader: w, Maximize: y, Pages: C, Panels: x, RenameFile: b, RenameFolder: E, FilterFiles: _, Settings: F, Shortcuts: M, StatusBar: I, Toolbars: T, UploadFileButton: R },
	            O = t.Collection.extend({ init: function init(t) {
	            var n = this;n.finder = t;var i = t.config.readOnlyExclude.length ? t.config.readOnlyExclude.split(",") : [],
	                r = t.config.readOnly ? e.union(B, i) : !1;t.config.removeModules && (r = e.union(r ? r : [], t.config.removeModules.split(","))), P(S("Tv{yo"), n, r), P(S("(oEHY^cN^PUVF"), n, r), P(S("&lMPfB_YKAUC"), n, r), P(S("8zUURX]K/3"), n, r), P(S("0bWG@\\XPK"), n, r), P(S("\f]oau}a"), n, r), P(S("'l@KGCJ]"), n, r), P(S("*hCCZJHEVZ@"), n, r), P(S("@puvg"), n, r), P(S(".{_^^QUGE"), n, r), P(S("C1'3=:\b*>"), n, r), P(S("&aAEOX"), n, r), P(S("A,(!#5;"), n, r), P(S("?3'\"0 \x00($-/9"), n, r), P(S("dDNFP@`HDMOY"), n, r), P(S("MEOCNAcIKLLX"), n, r), P(S("Vx~vgXya}Zuke"), n, r), P(S("<o[Q!,'-)#"), n, r), P(S(".kU]WGQs_[]"), n, r), P(S("A\n7))s8%%*("), n, r), P(S("%`HZD[@BOK"), n, r), P(S("!wSHJGCn@FNnXZ[__"), n, r), P(S("Iy}fvfS{}j"), n, r), P(S("^umzqc"), n, r), P(S("D/+-8.:$+8"), n, r), P(S("0w[_QqY@VUUZX"), n, r), P(S("^xtjVM@EF"), n, r), P(S("!qKKWRD]]Y"), n, r);
	          } });return O;
	      }), CKFinder.define(S("_VXvNEGQdVWD@IJXDAA"), [S(")_EHH\\\\S^@V"), S("3^DCRJ@"), S("!FLp"), S("7ZXYP^RPZ"), S("+AL\\F__WG@P"), S("2P_SiPTVXZP"), S("/sztZZQSEzUUZTY"), S("4v}qQW^^N{I%/6"), S("cjdJJACU|^B@{[Y]"), S("YPZtp{ES\rvPLJ\bdHDL"), S("5u|~PT_YOj	n\n\f$%,;"), S("$fmaAGNN^~CEV[]Gf[M^SUO"), S("W^P~v}i3Pq{UMGPhIC]EOX")], function (e, t, n, i, r, o, s, a, u, l, c, d, f) {
	        "use strict";
	        function h() {
	          var e, t, n;n = this, g(n), n._modules.init(n), t = n.config.resourceType, e = { name: S("\fD`fd") }, t && (e.params = { type: t }), n.once(S("6TWTWZRYP+{--1"), function (e) {
	            n.config.initConfigInfo = e.data.response, n.fire(S("1SCDECYKN"), {}, n);
	          }, 999), n.once(S("ytqpqDMHbCSn@FN_"), function () {
	            n.fire(S("1SCDDRY]C"), {}, n);
	          }, null, null, 999), n.fire(S("8XJKQQ^$$&"), {}, n), n.request(S('&DGDGJBI\x14\\U_V'), e);
	        }function g(t) {
	          var n,
	              i = t.config,
	              r = { ckfinder: t },
	              o = S("?#*$**!#5,+/5");try {
	            n = new CustomEvent(o, { detail: r });
	          } catch (s) {
	            n = document.createEvent(S("Sa}wn")), n.initEvent(o, !0, !1), n.detail = r;
	          }window.dispatchEvent(n), e.isFunction(i.onInit) ? i.onInit(t) : "object" == _typeof(i.onInit) && i.onInit.call(void 0, t);
	        }function p(e) {
	          var t,
	              n = e.data.response.error.number;t = e.data.response.error.message ? e.data.response.error.message : n && this.lang.Errors[n] ? this.lang.Errors[n] : this.lang.ErrorUnknown.replace(S(">q"), n), this.request(S('"GMDJHOCEJB'), { msg: t, name: S("ObcbqvVfgye") });
	        }return n.templateSettings.doNotSkipEncoded = !0, { start: function start(r) {
	            r.type && (r.resourceType = r.type);var o = { _reqres: new i.Wreqr.RequestResponse(), _plugins: new d(), _modules: new f(), config: r, util: u, Backbone: i, _: e, doT: n };return o.hasHandler = function () {
	              return this._reqres.hasHandler.apply(o._reqres, arguments);
	            }, o.getHandler = function () {
	              return this._reqres.getHandler.apply(o._reqres, arguments);
	            }, o.setHandler = function () {
	              return this._reqres.setHandler.apply(o._reqres, arguments);
	            }, o.setHandlers = function () {
	              return this._reqres.setHandlers.apply(o._reqres, arguments);
	            }, o.request = function () {
	              return this._reqres.request.apply(o._reqres, arguments);
	            }, e.extend(o, a.prototype), o.on(S('?#./.%+"}-;8$>'), p, o), o.on(S("(JEFAL@K\nT@A[G\f~VPN"), function () {
	              t(S("C,1++")).removeClass(S("7MPVS_WS%l0&*!#5!'-"));
	            }), o.on(S("E'78s/9>\"<"), function (e) {
	              alert(S("@-6(!f)'=j88,<;p=;22*cz") + e.data.msg);
	            }), o.on(S(")YCC_ZLEEA	X\\EC"), function (e) {
	              e.data.groups.add({ name: S("#C@HBZHF"), priority: 10, label: e.finder.lang.Shortcuts.general.title });
	            }), o.on(S("nvpRUAVPVKAZ^KH@JBP^"), function (e) {
	              e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.action, shortcuts: S("l}wn~n`") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.focusNext, shortcuts: S("E=3)+7") }), e.data.shortcuts.add({ label: e.finder.lang.Shortcuts.general.closeButton, shortcuts: S("wh}lm") });
	            }, null, null, 60), o.once(S("<MRJ'(,y%)*-(.2"), h, o), l.init(o.config).fail(function () {
	              o.fire(S("9[KL[M2.0"), { msg: S("E\n&&.?*+(n)9=7s=&v:1*)22:~0A\x00	") }, o);
	            }).done(function (t) {
	              o.lang = t;var n = r.skin;n.indexOf("/") < 0 && (n = S("e|qwi4") + n + S("#~ef~")), window.CKFinder.require([n], function (t) {
	                e.isFunction(t.init) && (t.path = o.util.parentFolder(n) + "/", t.init(o)), c.init(o), o._plugins.load(o);
	              });
	            }), o;
	          } };
	      }), CKFinder.define(S("E5,!'9d&<;*\"(>;7?;=v)053"), { config: function config(e) {
	          return e.iconsCSS || (e.iconsCSS = S("/CZ[]G\\FM\\HBPQ])-'l-&));g)8?")), e.themeCSS || (e.themeCSS = S(")FBN^EADWAM[XZPV^IVZ-$l 76")), e;
	        }, init: function init() {
	          CKFinder.require([S("8SKNYOG")], function (e) {
	            e(S("<_Q[9")).addClass(S("d{>}vyy5xvo"));
	          });
	        } }), CKFinder.define(S("byzzf9zwvtt3nuvN"), { config: function config(e) {
	          return e.swatch = "a", e.dialogOverlaySwatch = !0, e.loaderOverlaySwatch = !0, e.themeCSS || (e.themeCSS = S("f}~vj5vsrppBIEMKBBZIX_")), e.iconsCSS || (e.iconsCSS = S("6DSPTHPQP..m*'*(4f*98")), e;
	        }, init: function init() {
	          CKFinder.require([S("D/72-;3")], function (e) {
	            e(S("r~vj")).addClass(S("\r{f=p~g9|uxv"));
	          });
	        } }), window.CKFinder = window.CKFinder || {}, window.CKFinder.require = CKFinder.require || window.require || __webpack_require__(320), window.CKFinder.requirejs = CKFinder.requirejs || window.requirejs || requirejs, window.CKFinder.define = CKFinder.define || window.define || __webpack_require__(322), window.CKFinder.basePath && window.CKFinder.requirejs.config({ baseUrl: window.CKFinder.basePath }), window.CKFinder.requirejs.config({ waitSeconds: 0 }), window.CKFinder.define(S(">\\+'$(*$&$"), function () {
	        return window.CKFinder;
	      });var event,
	          eventType = S("{r|rry{mrDSVMWCuMHNR");try {
	        event = new CustomEvent(eventType);
	      } catch (e) {
	        event = document.createEvent(S("4p@RVM")), event.initEvent(eventType, !0, !1);
	      }window.dispatchEvent(event), window.CKFinder.start = function (e) {
	        function t(e) {
	          [e.jqueryMobileStructureCSS, e.coreCSS, e.jqueryMobileIconsCSS, e.iconsCSS, e.themeCSS].forEach(function (e) {
	            if (e) {
	              var t = window.document.createElement(S("&KAGA"));t.setAttribute(S("fpz"), S("hhdrzSIGFP")), t.setAttribute(S("riy{"), CKFinder.require.toUrl(e) + S("@~4&6x.72=!.")), window.document.head.appendChild(t);
	            }
	          });
	        }e = e || {}, window.CKFinder.require([S("<HP[%31 +7#"), S("5u|~PT_YO|//$*#"), S("QXR|xs}k5Nhtr0uUKO")], function (n, i, r) {
	          function o(e, t, i) {
	            var o, a;if (a = r.getUrlParams(), a.langCode && (a.language = a.langCode), a.type && (a.resourceType = a.type), a.CKEditor) {
	              a.chooseFiles = !0;var u = a.CKEditorFuncNum;a.ckeditor = { id: a.CKEditor, funcNumber: u, callback: function callback(e, t) {
	                  window.opener.CKEDITOR.tools.callFunction(u, e, t), window.close();
	                } };
	            }delete a.langCode, delete a.CKEditor, delete a.CKEditorFuncNum;var l;l = window !== window.parent && window.opener || window.isCKFinderPopup ? window.opener : window.parent.CKFinder && window.parent.CKFinder.modal && window.parent.CKFinder.modal(S("jtmvBMG")) || window !== window.parent && !window.opener ? window.parent : window, o = n.extend({}, e, t, l.CKFinder ? l.CKFinder._config : {}, i, a), s(o, function (e) {
	              e.start(o);
	            });
	          }function s(e, i) {
	            var r = e.skin;r.indexOf("/") < 0 && (r = S("3G^_YK") + r + S("*_FGA")), window.CKFinder.require([r], function (i) {
	              var r = n.isFunction(i.config) ? i.config(e) : i.config;t(n.extend(e, r));
	            }), window.jQuery && /1|2\.[0-9]+.[0-9]+/.test(window.jQuery.fn.jquery) ? a(e, i) : window.CKFinder.require([window.CKFinder.require.toUrl(e.jquery) + S("3{k}-ybi`~s")], function () {
	              a(e, i);
	            });
	          }function a(e, t) {
	            window.CKFinder.define(S(">U14'1="), function () {
	              return window.jQuery;
	            }), window.jQuery(window.document).bind(S("7UVXRPXWQ)5"), function () {
	              window.jQuery.mobile.linkBindingEnabled = !1, window.jQuery.mobile.hashListeningEnabled = !1, window.jQuery.mobile.autoInitializePage = !1, window.jQuery.mobile.ignoreContentEnabled = !0;
	            }), window.CKFinder.require([window.CKFinder.require.toUrl(e.jqueryMobile) + S("-eqg+hcnpy")], function () {
	              window.CKFinder.define(S("\fnei={cfqgo:uvxrpx"), function () {
	                return window.jQuery.mobile;
	              }), window.CKFinder.require([S("OFHf~uwa;Tfgtpyzhtqq")], t);
	            });
	          }var u = n.isUndefined(e.configPath) ? i.configPath : e.configPath;return u ? void window.CKFinder.require([window.CKFinder.require.toUrl(u)], function (t) {
	            o(i, t, e);
	          }, function () {
	            o(i, {}, e);
	          }) : void o(i, {}, e);
	        });
	      };
	    } };
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)(module), (function() { return this; }()), __webpack_require__(319)))

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./ckeditor": 317,
		"./ckeditor.js": 317,
		"./ckfinder": 318,
		"./ckfinder.js": 318,
		"./croppic": 321,
		"./croppic.js": 321
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 320;


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * CROP
	 * dependancy: jQuery
	 * author: Ognjen "Zmaj Džedaj" Božičković and Mat Steinlin
	 */
	
	(function (window, document) {
	
	  var Croppic = function Croppic(id, divObject, options) {
	
	    var that = this;
	    that.id = id;
	    that.obj = divObject; //$('#' + id);
	    that.outputDiv = that.obj;
	
	    // DEFAULT OPTIONS
	    that.options = {
	      uploadUrl: '',
	      uploadData: {},
	      cropUrl: '',
	      cropData: {},
	      outputUrlId: '',
	      //styles
	      imgEyecandy: true,
	      imgEyecandyOpacity: 0.2,
	      zoomFactor: 10,
	      rotateFactor: 5,
	      doubleZoomControls: true,
	      rotateControls: true,
	      modal: false,
	      customUploadButtonId: '',
	      loaderHtml: '',
	      scaleToFill: true,
	      processInline: false,
	      loadPicture: '',
	      onReset: null,
	      enableMousescroll: false,
	      //callbacks
	      onBeforeImgUpload: null,
	      onAfterImgUpload: null,
	      onAfterImgUploaded: null,
	      onImgDrag: null,
	      onImgZoom: null,
	      onImgRotate: null,
	      onBeforeImgCrop: null,
	      onAfterImgCrop: null,
	      onError: null,
	      objW: null,
	      objH: null,
	      hint: '',
	      maxSize: null //max size in MB
	    };
	
	    // OVERWRITE DEFAULT OPTIONS
	    for (i in options) {
	      that.options[i] = options[i];
	    } // INIT THE WHOLE DAMN THING!!!
	    that.init();
	  };
	
	  Croppic.prototype = {
	    id: '',
	    imgInitW: 0,
	    imgInitH: 0,
	    imgW: 0,
	    imgH: 0,
	    objW: 0,
	    objH: 0,
	    actualRotation: 0,
	    windowW: 0,
	    windowH: $(window).height(),
	    obj: {},
	    outputDiv: {},
	    outputUrlObj: {},
	    img: {},
	    defaultImg: {},
	    croppedImg: {},
	    imgEyecandy: {},
	    form: {},
	    cropControlsUpload: {},
	    cropControlsCrop: {},
	    cropControlZoomMuchIn: {},
	    cropControlZoomMuchOut: {},
	    cropControlZoomIn: {},
	    cropControlZoomOut: {},
	    cropControlCrop: {},
	    cropControlReset: {},
	    cropControlRemoveCroppedImage: {},
	    modal: {},
	    loader: {},
	    init: function init() {
	      var that = this;
	
	      that.objW = that.options.objW || that.obj.width();
	      that.objH = that.options.objH || that.obj.height();
	
	      // reset rotation
	      that.actualRotation = 0;
	
	      if ($.isEmptyObject(that.defaultImg)) {
	        that.defaultImg = that.obj.find('img');
	      }
	
	      that.createImgUploadControls();
	
	      if ($.isEmptyObject(that.options.loadPicture)) {
	        that.bindImgUploadControl();
	      } else {
	        that.loadExistingImage();
	      }
	    },
	    createImgUploadControls: function createImgUploadControls() {
	      var that = this;
	
	      var cropControlUpload = '';
	      if (that.options.customUploadButtonId === '') {
	        cropControlUpload = '<i class="cropControlUpload"></i> ' + that.options.hint;
	      }
	      var cropControlRemoveCroppedImage = '<i class="cropControlRemoveCroppedImage"></i>';
	
	      if ($.isEmptyObject(that.croppedImg)) {
	        cropControlRemoveCroppedImage = '';
	      }
	      if (!$.isEmptyObject(that.options.loadPicture)) {
	        cropControlUpload = '';
	      }
	
	      var html = '<div class="cropControls cropControlsUpload"> ' + cropControlUpload + cropControlRemoveCroppedImage + ' </div>';
	      that.outputDiv.append(html);
	
	      that.cropControlsUpload = that.outputDiv.find('.cropControlsUpload');
	
	      if (that.options.customUploadButtonId === '') {
	        that.imgUploadControl = that.outputDiv.find('.cropControlUpload');
	      } else {
	        that.imgUploadControl = $('#' + that.options.customUploadButtonId);
	        that.imgUploadControl.show();
	      }
	
	      if (!$.isEmptyObject(that.croppedImg)) {
	        that.cropControlRemoveCroppedImage = that.outputDiv.find('.cropControlRemoveCroppedImage');
	      }
	    },
	    bindImgUploadControl: function bindImgUploadControl() {
	
	      var that = this;
	
	      // CREATE UPLOAD IMG FORM
	      var formHtml = '<form class="' + that.id + '_imgUploadForm" style="position: absolute; visibility: hidden; top:0;">  <input type="file" name="img">  </form>';
	      that.outputDiv.append(formHtml);
	      that.form = that.outputDiv.find('.' + that.id + '_imgUploadForm');
	
	      that.imgUploadControl.off('click');
	      that.imgUploadControl.on('click', function () {
	        that.form.find('input[type="file"]').trigger('click');
	      });
	
	      if (!$.isEmptyObject(that.croppedImg)) {
	
	        that.cropControlRemoveCroppedImage.on('click', function () {
	          that.croppedImg.remove();
	          $(this).hide();
	
	          if (!$.isEmptyObject(that.defaultImg)) {
	            that.obj.append(that.defaultImg);
	          }
	
	          if (that.options.outputUrlId !== '') {
	            $('#' + that.options.outputUrlId).val('');
	          }
	        });
	      }
	
	      that.form.find('input[type="file"]').change(function () {
	
	        if (that.options.onBeforeImgUpload) that.options.onBeforeImgUpload.call(that);
	
	        that.showLoader();
	        that.imgUploadControl.hide();
	
	        if (that.options.processInline) {
	          //Reading Inline
	
	          var reader = new FileReader();
	          reader.onload = function (e) {
	            var image = new Image();
	            image.src = e.target.result;
	            image.onload = function () {
	              that.imgInitW = that.imgW = image.width;
	              that.imgInitH = that.imgH = image.height;
	
	              if (that.options.modal) {
	                that.createModal();
	              }
	              if (!$.isEmptyObject(that.croppedImg)) {
	                that.croppedImg.remove();
	              }
	
	              that.imgUrl = image.src;
	
	              that.obj.append('<img src="' + image.src + '">');
	
	              that.initCropper();
	              that.hideLoader();
	
	              if (that.options.onAfterImgUpload) that.options.onAfterImgUpload.call(that);
	            };
	          };
	          var file = that.form.find('input[type="file"]')[0].files[0];
	          if (that.options.fileSize && file.size / 1024 / 1024 > that.options.fileSize) {
	            alert('Limit file size, can upload ' + that.options.fileSize + 'MB maximum only.');
	            that.reset();
	          }
	          reader.readAsDataURL(that.form.find('input[type="file"]')[0].files[0]);
	        } else {
	
	          var formData = new FormData(that.form[0]);
	
	          for (var key in that.options.uploadData) {
	            if (that.options.uploadData.hasOwnProperty(key)) {
	              formData.append(key, that.options.uploadData[key]);
	            }
	          }
	
	          $.ajax({
	            url: that.options.uploadUrl,
	            data: formData,
	            context: document.body,
	            cache: false,
	            contentType: false,
	            processData: false,
	            type: 'POST'
	          }).always(function (data) {
	            response = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object' ? data : jQuery.parseJSON(data);
	            if (response.status == 'success') {
	
	              that.imgInitW = that.imgW = response.width;
	              that.imgInitH = that.imgH = response.height;
	
	              if (that.options.modal) {
	                that.createModal();
	              }
	              if (!$.isEmptyObject(that.croppedImg)) {
	                that.croppedImg.remove();
	              }
	
	              that.imgUrl = response.url;
	
	              var img = $('<img src="' + response.url + '">');
	
	              that.obj.append(img);
	
	              img.load(function () {
	                that.initCropper();
	                that.hideLoader();
	                if (that.options.onAfterImgUpload) that.options.onAfterImgUpload.call(that);
	              });
	            }
	
	            if (response.status == 'error') {
	              if (that.options.onError) that.options.onError.call(that, response.message);
	              that.hideLoader();
	              setTimeout(function () {
	                that.reset();
	              }, 2000);
	            }
	          });
	        }
	      });
	    },
	    loadExistingImage: function loadExistingImage() {
	      var that = this;
	
	      if ($.isEmptyObject(that.croppedImg)) {
	        if (that.options.onBeforeImgUpload) that.options.onBeforeImgUpload.call(that);
	
	        that.showLoader();
	        if (that.options.modal) {
	          that.createModal();
	        }
	        if (!$.isEmptyObject(that.croppedImg)) {
	          that.croppedImg.remove();
	        }
	
	        that.imgUrl = that.options.loadPicture;
	
	        var img = $('<img src="' + that.options.loadPicture + '">');
	        that.obj.append(img);
	        img.load(function () {
	          that.imgInitW = that.imgW = this.width;
	          that.imgInitH = that.imgH = this.height;
	          that.initCropper();
	          that.hideLoader();
	          if (that.options.onAfterImgUpload) that.options.onAfterImgUpload.call(that);
	        });
	      } else {
	        that.cropControlRemoveCroppedImage.on('click', function () {
	          that.croppedImg.remove();
	          $(this).hide();
	
	          if (!$.isEmptyObject(that.defaultImg)) {
	            that.obj.append(that.defaultImg);
	          }
	          if (that.options.outputUrlId !== '') {
	            $('#' + that.options.outputUrlId).val('');
	          }
	          that.croppedImg = '';
	          that.reset();
	        });
	      }
	    },
	    createModal: function createModal() {
	      var that = this;
	
	      var marginTop = that.windowH / 2 - that.objH / 2;
	      var modalHTML = '<div id="croppicModal">' + '<div id="croppicModalObj" style="width:' + that.objW + 'px; height:' + that.objH + 'px; margin:0 auto; margin-top:' + marginTop + 'px; position: relative;"> </div>' + '</div>';
	
	      $('body').append(modalHTML);
	
	      that.modal = $('#croppicModal');
	
	      that.obj = $('#croppicModalObj');
	    },
	    destroyModal: function destroyModal() {
	      var that = this;
	
	      that.obj = that.outputDiv;
	      that.modal.remove();
	    },
	    initCropper: function initCropper() {
	      var that = this;
	
	      /*SET UP SOME VARS*/
	      that.img = that.obj.find('img');
	      that.img.wrap('<div class="cropImgWrapper" style="overflow:hidden; z-index:1; position:absolute; width:' + that.objW + 'px; height:' + that.objH + 'px;"></div>');
	
	      /*INIT DRAGGING*/
	      that.createCropControls();
	
	      if (that.options.imgEyecandy) {
	        that.createEyecandy();
	      }
	      that.initDrag();
	      that.initialScaleImg();
	    },
	    createEyecandy: function createEyecandy() {
	      var that = this;
	
	      that.imgEyecandy = that.img.clone();
	      that.imgEyecandy.css({ 'z-index': '0', 'opacity': that.options.imgEyecandyOpacity }).appendTo(that.obj);
	    },
	    destroyEyecandy: function destroyEyecandy() {
	      var that = this;
	      that.imgEyecandy.remove();
	    },
	    initialScaleImg: function initialScaleImg() {
	      var that = this;
	      that.zoom(-that.imgInitW);
	      that.zoom(40);
	
	      // Adding mousewheel zoom capabilities
	      if (that.options.enableMousescroll) {
	        that.img.on('mousewheel', function (event) {
	          event.preventDefault();
	          that.zoom(that.options.zoomFactor * event.deltaY);
	        });
	      }
	      // initial center image
	
	      that.img.css({ 'left': -(that.imgW - that.objW) / 2, 'top': -(that.imgH - that.objH) / 2, 'position': 'relative' });
	      if (that.options.imgEyecandy) {
	        that.imgEyecandy.css({ 'left': -(that.imgW - that.objW) / 2, 'top': -(that.imgH - that.objH) / 2, 'position': 'relative' });
	      }
	    },
	    createCropControls: function createCropControls() {
	      var that = this;
	
	      // CREATE CONTROLS
	      var cropControlZoomMuchIn = '';
	      var cropControlZoomIn = '<i class="cropControlZoomIn"></i>';
	      var cropControlZoomOut = '<i class="cropControlZoomOut"></i>';
	      var cropControlZoomMuchOut = '';
	      var cropControlRotateLeft = '';
	      var cropControlRotateRight = '';
	      var cropControlCrop = '<i class="cropControlCrop"></i>';
	      var cropControlReset = '<i class="cropControlReset"></i>';
	
	      var html;
	
	      if (that.options.doubleZoomControls) {
	        cropControlZoomMuchIn = '<i class="cropControlZoomMuchIn"></i>';
	        cropControlZoomMuchOut = '<i class="cropControlZoomMuchOut"></i>';
	      }
	      if (that.options.rotateControls) {
	        cropControlRotateLeft = '<i class="cropControlRotateLeft"></i>';
	        cropControlRotateRight = '<i class="cropControlRotateRight"></i>';
	      }
	
	      html = '<div class="cropControls cropControlsCrop">' + cropControlZoomMuchIn + cropControlZoomIn + cropControlZoomOut + cropControlZoomMuchOut + cropControlRotateLeft + cropControlRotateRight + cropControlCrop + cropControlReset + '</div>';
	
	      that.obj.append(html);
	
	      that.cropControlsCrop = that.obj.find('.cropControlsCrop');
	
	      // CACHE AND BIND CONTROLS
	      if (that.options.doubleZoomControls) {
	        that.cropControlZoomMuchIn = that.cropControlsCrop.find('.cropControlZoomMuchIn');
	        that.cropControlZoomMuchIn.on('click', function () {
	          that.zoom(that.options.zoomFactor * 10);
	        });
	
	        that.cropControlZoomMuchOut = that.cropControlsCrop.find('.cropControlZoomMuchOut');
	        that.cropControlZoomMuchOut.on('click', function () {
	          that.zoom(-that.options.zoomFactor * 10);
	        });
	      }
	
	      that.cropControlZoomIn = that.cropControlsCrop.find('.cropControlZoomIn');
	      that.cropControlZoomIn.on('click', function () {
	        that.zoom(that.options.zoomFactor);
	      });
	
	      that.cropControlZoomOut = that.cropControlsCrop.find('.cropControlZoomOut');
	      that.cropControlZoomOut.on('click', function () {
	        that.zoom(-that.options.zoomFactor);
	      });
	
	      that.cropControlZoomIn = that.cropControlsCrop.find('.cropControlRotateLeft');
	      that.cropControlZoomIn.on('click', function () {
	        that.rotate(-that.options.rotateFactor);
	      });
	
	      that.cropControlZoomOut = that.cropControlsCrop.find('.cropControlRotateRight');
	      that.cropControlZoomOut.on('click', function () {
	        that.rotate(that.options.rotateFactor);
	      });
	
	      that.cropControlCrop = that.cropControlsCrop.find('.cropControlCrop');
	      that.cropControlCrop.on('click', function () {
	        that.crop();
	      });
	
	      that.cropControlReset = that.cropControlsCrop.find('.cropControlReset');
	      that.cropControlReset.on('click', function () {
	        that.reset();
	      });
	    },
	    initDrag: function initDrag() {
	      var that = this;
	
	      that.img.on("mousedown touchstart", function (e) {
	
	        e.preventDefault(); // disable selection
	
	        var pageX;
	        var pageY;
	        var userAgent = window.navigator.userAgent;
	        if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/android/i)) {
	          pageX = e.originalEvent.touches[0].pageX;
	          pageY = e.originalEvent.touches[0].pageY;
	        } else {
	          pageX = e.pageX;
	          pageY = e.pageY;
	        }
	
	        var z_idx = that.img.css('z-index'),
	            drg_h = that.img.outerHeight(),
	            drg_w = that.img.outerWidth(),
	            pos_y = that.img.offset().top + drg_h - pageY,
	            pos_x = that.img.offset().left + drg_w - pageX;
	
	        that.img.css('z-index', 1000).on("mousemove touchmove", function (e) {
	
	          var imgTop;
	          var imgLeft;
	
	          if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/android/i)) {
	            imgTop = e.originalEvent.touches[0].pageY + pos_y - drg_h;
	            imgLeft = e.originalEvent.touches[0].pageX + pos_x - drg_w;
	          } else {
	            imgTop = e.pageY + pos_y - drg_h;
	            imgLeft = e.pageX + pos_x - drg_w;
	          }
	
	          that.img.offset({
	            top: imgTop,
	            left: imgLeft
	          }).on("mouseup", function () {
	            $(this).removeClass('draggable').css('z-index', z_idx);
	          });
	
	          if (that.options.imgEyecandy) {
	            that.imgEyecandy.offset({ top: imgTop, left: imgLeft });
	          }
	
	          if (that.objH < that.imgH) {
	            if (parseInt(that.img.css('top')) > 0) {
	              that.img.css('top', 0);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('top', 0);
	              }
	            }
	            var maxTop = -(that.imgH - that.objH);
	            if (parseInt(that.img.css('top')) < maxTop) {
	              that.img.css('top', maxTop);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('top', maxTop);
	              }
	            }
	          } else {
	            if (parseInt(that.img.css('top')) < 0) {
	              that.img.css('top', 0);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('top', 0);
	              }
	            }
	            var maxTop = that.objH - that.imgH;
	            if (parseInt(that.img.css('top')) > maxTop) {
	              that.img.css('top', maxTop);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('top', maxTop);
	              }
	            }
	          }
	
	          if (that.objW < that.imgW) {
	            if (parseInt(that.img.css('left')) > 0) {
	              that.img.css('left', 0);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('left', 0);
	              }
	            }
	            var maxLeft = -(that.imgW - that.objW);
	            if (parseInt(that.img.css('left')) < maxLeft) {
	              that.img.css('left', maxLeft);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('left', maxLeft);
	              }
	            }
	          } else {
	            if (parseInt(that.img.css('left')) < 0) {
	              that.img.css('left', 0);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('left', 0);
	              }
	            }
	            var maxLeft = that.objW - that.imgW;
	            if (parseInt(that.img.css('left')) > maxLeft) {
	              that.img.css('left', maxLeft);
	              if (that.options.imgEyecandy) {
	                that.imgEyecandy.css('left', maxLeft);
	              }
	            }
	          }
	          if (that.options.onImgDrag) that.options.onImgDrag.call(that);
	        });
	      }).on("mouseup", function () {
	        that.img.off("mousemove");
	      }).on("mouseout", function () {
	        that.img.off("mousemove");
	      });
	    },
	    rotate: function rotate(x) {
	      var that = this;
	      that.actualRotation += x;
	      that.img.css({
	        '-webkit-transform': 'rotate(' + that.actualRotation + 'deg)',
	        '-moz-transform': 'rotate(' + that.actualRotation + 'deg)',
	        'transform': 'rotate(' + that.actualRotation + 'deg)'
	      });
	      if (that.options.imgEyecandy) {
	        that.imgEyecandy.css({
	          '-webkit-transform': 'rotate(' + that.actualRotation + 'deg)',
	          '-moz-transform': 'rotate(' + that.actualRotation + 'deg)',
	          'transform': 'rotate(' + that.actualRotation + 'deg)'
	        });
	      }
	      if (typeof that.options.onImgRotate == 'function') that.options.onImgRotate.call(that);
	    },
	    zoom: function zoom(x) {
	      var that = this;
	      var ratio = that.imgW / that.imgH;
	      var newWidth = that.imgW + x;
	      var newHeight = newWidth / ratio;
	      var doPositioning = true;
	
	      if (newWidth < that.objW || newHeight < that.objH) {
	
	        if (newWidth - that.objW < newHeight - that.objH) {
	          newWidth = that.objW;
	          newHeight = newWidth / ratio;
	        } else {
	          newHeight = that.objH;
	          newWidth = ratio * newHeight;
	        }
	
	        doPositioning = false;
	      }
	
	      if (!that.options.scaleToFill && (newWidth > that.imgInitW || newHeight > that.imgInitH)) {
	
	        if (newWidth - that.imgInitW < newHeight - that.imgInitH) {
	          newWidth = that.imgInitW;
	          newHeight = newWidth / ratio;
	        } else {
	          newHeight = that.imgInitH;
	          newWidth = ratio * newHeight;
	        }
	
	        doPositioning = false;
	      }
	
	      that.imgW = newWidth;
	      that.img.width(newWidth);
	
	      that.imgH = newHeight;
	      that.img.height(newHeight);
	
	      var newTop = parseInt(that.img.css('top')) - x / 2;
	      var newLeft = parseInt(that.img.css('left')) - x / 2;
	
	      if (newTop > 0) {
	        newTop = 0;
	      }
	      if (newLeft > 0) {
	        newLeft = 0;
	      }
	
	      var maxTop = -(newHeight - that.objH);
	      if (newTop < maxTop) {
	        newTop = maxTop;
	      }
	      var maxLeft = -(newWidth - that.objW);
	      if (newLeft < maxLeft) {
	        newLeft = maxLeft;
	      }
	
	      if (doPositioning) {
	        that.img.css({ 'top': newTop, 'left': newLeft });
	      }
	
	      if (that.options.imgEyecandy) {
	        that.imgEyecandy.width(newWidth);
	        that.imgEyecandy.height(newHeight);
	        if (doPositioning) {
	          that.imgEyecandy.css({ 'top': newTop, 'left': newLeft });
	        }
	      }
	
	      if (that.options.onImgZoom) that.options.onImgZoom.call(that);
	    },
	    crop: function crop() {
	      var that = this;
	
	      if (that.options.onBeforeImgCrop) that.options.onBeforeImgCrop.call(that);
	
	      that.cropControlsCrop.hide();
	      that.showLoader();
	
	      var cropData = {
	        imgUrl: that.imgUrl,
	        imgInitW: that.imgInitW,
	        imgInitH: that.imgInitH,
	        imgW: that.imgW,
	        imgH: that.imgH,
	        imgY1: Math.abs(parseInt(that.img.css('top'))),
	        imgX1: Math.abs(parseInt(that.img.css('left'))),
	        cropH: that.objH,
	        cropW: that.objW,
	        rotation: that.actualRotation
	      };
	
	      var formData = new FormData();
	
	      for (var key in cropData) {
	        if (cropData.hasOwnProperty(key)) {
	          formData.append(key, cropData[key]);
	        }
	      }
	
	      for (var key in that.options.cropData) {
	        if (that.options.cropData.hasOwnProperty(key)) {
	          formData.append(key, that.options.cropData[key]);
	        }
	      }
	
	      $.ajax({
	        url: that.options.cropUrl,
	        data: formData,
	        context: document.body,
	        cache: false,
	        contentType: false,
	        processData: false,
	        type: 'POST'
	      }).always(function (data) {
	        response = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object' ? data : jQuery.parseJSON(data);
	        if (that.options.onAfterImgUploaded) {
	          that.options.onAfterImgUploaded(response);
	        }
	
	        if (response.status == 'success') {
	          if (that.options.imgEyecandy) that.imgEyecandy.hide();
	
	          that.destroy();
	
	          that.obj.append('<img class="croppedImg" src="' + response.url + '">');
	          if (that.options.outputUrlId !== '') {
	            $('#' + that.options.outputUrlId).val(response.url);
	          }
	
	          that.croppedImg = that.obj.find('.croppedImg');
	
	          that.init();
	
	          that.hideLoader();
	        }
	        if (response.status == 'error') {
	          if (that.options.onError) that.options.onError.call(that, response.message);
	          that.hideLoader();
	          setTimeout(function () {
	            that.reset();
	          }, 2000);
	        }
	
	        if (that.options.onAfterImgCrop) that.options.onAfterImgCrop.call(that);
	      });
	    },
	    showLoader: function showLoader() {
	      var that = this;
	
	      that.obj.append(that.options.loaderHtml);
	      that.loader = that.obj.find('.loader');
	    },
	    hideLoader: function hideLoader() {
	      var that = this;
	      that.loader.remove();
	    },
	    reset: function reset() {
	      var that = this;
	      that.destroy();
	
	      that.init();
	
	      if (!$.isEmptyObject(that.croppedImg)) {
	        that.obj.append(that.croppedImg);
	        if (that.options.outputUrlId !== '') {
	          $('#' + that.options.outputUrlId).val(that.croppedImg.attr('url'));
	        }
	      }
	      if (typeof that.options.onReset == 'function') that.options.onReset.call(that);
	    },
	    destroy: function destroy() {
	      var that = this;
	      if (that.options.modal && !$.isEmptyObject(that.modal)) {
	        that.destroyModal();
	      }
	      if (that.options.imgEyecandy && !$.isEmptyObject(that.imgEyecandy)) {
	        that.destroyEyecandy();
	      }
	      if (!$.isEmptyObject(that.cropControlsUpload)) {
	        that.cropControlsUpload.remove();
	      }
	      if (!$.isEmptyObject(that.cropControlsCrop)) {
	        that.cropControlsCrop.remove();
	      }
	      if (!$.isEmptyObject(that.loader)) {
	        that.loader.remove();
	      }
	      if (!$.isEmptyObject(that.form)) {
	        that.form.remove();
	      }
	      that.obj.html('');
	    }
	  };
	})(window, document);

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('directives.contenteditable', ['ngSanitize']).directive('contenteditable', ['$sce', function ($sce) {
	  return {
	    restrict: 'A', // only activate on element attribute
	    require: '?ngModel', // get a hold of NgModelController
	    link: function link(scope, element, attrs, ngModel) {
	      if (!ngModel) {
	        return;
	      } // do nothing if no ng-model
	
	      // Specify how UI should be updated
	      ngModel.$render = function () {
	        element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	      };
	
	      // Listen for change events to enable binding
	      element.on('blur keyup change', function () {
	        scope.$evalAsync(read);
	      });
	      read(); // initialize
	
	      // Write data to the model
	      function read() {
	        var html = element.html();
	        // When we clear the content editable the browser leaves a <br> behind
	        // If strip-br attribute is provided then we strip this out
	        if (attrs.stripBr && html === '<br>') {
	          html = '';
	        }
	        if (html) {
	          ngModel.$setViewValue(html);
	        }
	      }
	    }
	  };
	}]);

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('directives.croppic', []).directive('croppic', ["$timeout", function ($timeout) {
	  //alert("hola aaaaa");
	  return {
	    restrict: 'AE',
	    //replace: true,
	    require: 'ngModel',
	    scope: {
	      data: '=?',
	      model: '=ngModel',
	      options: '=?'
	    },
	    link: function link(scope, element, attrs) {
	      //alert("hola aaaaa 2"+JSON.stringify(scope.data));
	      $timeout(function () {
	        var id = Math.random().toString(36).substring(7);
	        var query = _.assign({
	          fileSize: 5,
	          cropData: scope.data || {},
	          cropUrl: '/api/articles/upload',
	          uploadData: scope.data || {},
	          uploadUrl: '/api/articles/upload',
	          modal: true,
	          processInline: true,
	          loaderHtml: '<div class="loader bubblingG"><span id="bubblingG_1"></span><span id="bubblingG_2"></span><span id="bubblingG_3"></span></div> ',
	          onAfterImgUploaded: function onAfterImgUploaded(data) {
	            if (data.status === "error") {
	              alert(data.message);
	            }
	
	            scope.model = data.data;
	            if (typeof scope.options.afterUploadedCallback === 'function') {
	              scope.options.afterUploadedCallback(data.data);
	            }
	            scope.$apply();
	          }
	        }, scope.options);
	        new Croppic(id, $(element), query);
	      });
	    }
	  };
	}]);

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('directives.gravatar', [])
	
	// A simple directive to display a gravatar image given an email
	.directive('gravatar', ['md5', function (md5) {
	
	  return {
	    restrict: 'E',
	    template: '<img ng-src="http://www.gravatar.com/avatar/{{hash}}{{getParams}}"/>',
	    replace: true,
	    scope: {
	      email: '=',
	      size: '=',
	      defaultImage: '=',
	      forceDefault: '='
	    },
	    link: function link(scope, element, attrs) {
	      scope.options = {};
	      scope.$watch('email', function (email) {
	        if (email) {
	          scope.hash = md5(email.trim().toLowerCase());
	        }
	      });
	      scope.$watch('size', function (size) {
	        scope.options.s = angular.isNumber(size) ? size : undefined;
	        generateParams();
	      });
	      scope.$watch('forceDefault', function (forceDefault) {
	        scope.options.f = forceDefault ? 'y' : undefined;
	        generateParams();
	      });
	      scope.$watch('defaultImage', function (defaultImage) {
	        scope.options.d = defaultImage ? defaultImage : undefined;
	        generateParams();
	      });
	      function generateParams() {
	        var options = [];
	        scope.getParams = '';
	        angular.forEach(scope.options, function (value, key) {
	          if (value) {
	            options.push(key + '=' + encodeURIComponent(value));
	          }
	        });
	        if (options.length > 0) {
	          scope.getParams = '?' + options.join('&');
	        }
	      }
	    }
	  };
	}]).factory('md5', function () {
	  function md5cycle(x, k) {
	    var a = x[0],
	        b = x[1],
	        c = x[2],
	        d = x[3];
	
	    a = ff(a, b, c, d, k[0], 7, -680876936);
	    d = ff(d, a, b, c, k[1], 12, -389564586);
	    c = ff(c, d, a, b, k[2], 17, 606105819);
	    b = ff(b, c, d, a, k[3], 22, -1044525330);
	    a = ff(a, b, c, d, k[4], 7, -176418897);
	    d = ff(d, a, b, c, k[5], 12, 1200080426);
	    c = ff(c, d, a, b, k[6], 17, -1473231341);
	    b = ff(b, c, d, a, k[7], 22, -45705983);
	    a = ff(a, b, c, d, k[8], 7, 1770035416);
	    d = ff(d, a, b, c, k[9], 12, -1958414417);
	    c = ff(c, d, a, b, k[10], 17, -42063);
	    b = ff(b, c, d, a, k[11], 22, -1990404162);
	    a = ff(a, b, c, d, k[12], 7, 1804603682);
	    d = ff(d, a, b, c, k[13], 12, -40341101);
	    c = ff(c, d, a, b, k[14], 17, -1502002290);
	    b = ff(b, c, d, a, k[15], 22, 1236535329);
	
	    a = gg(a, b, c, d, k[1], 5, -165796510);
	    d = gg(d, a, b, c, k[6], 9, -1069501632);
	    c = gg(c, d, a, b, k[11], 14, 643717713);
	    b = gg(b, c, d, a, k[0], 20, -373897302);
	    a = gg(a, b, c, d, k[5], 5, -701558691);
	    d = gg(d, a, b, c, k[10], 9, 38016083);
	    c = gg(c, d, a, b, k[15], 14, -660478335);
	    b = gg(b, c, d, a, k[4], 20, -405537848);
	    a = gg(a, b, c, d, k[9], 5, 568446438);
	    d = gg(d, a, b, c, k[14], 9, -1019803690);
	    c = gg(c, d, a, b, k[3], 14, -187363961);
	    b = gg(b, c, d, a, k[8], 20, 1163531501);
	    a = gg(a, b, c, d, k[13], 5, -1444681467);
	    d = gg(d, a, b, c, k[2], 9, -51403784);
	    c = gg(c, d, a, b, k[7], 14, 1735328473);
	    b = gg(b, c, d, a, k[12], 20, -1926607734);
	
	    a = hh(a, b, c, d, k[5], 4, -378558);
	    d = hh(d, a, b, c, k[8], 11, -2022574463);
	    c = hh(c, d, a, b, k[11], 16, 1839030562);
	    b = hh(b, c, d, a, k[14], 23, -35309556);
	    a = hh(a, b, c, d, k[1], 4, -1530992060);
	    d = hh(d, a, b, c, k[4], 11, 1272893353);
	    c = hh(c, d, a, b, k[7], 16, -155497632);
	    b = hh(b, c, d, a, k[10], 23, -1094730640);
	    a = hh(a, b, c, d, k[13], 4, 681279174);
	    d = hh(d, a, b, c, k[0], 11, -358537222);
	    c = hh(c, d, a, b, k[3], 16, -722521979);
	    b = hh(b, c, d, a, k[6], 23, 76029189);
	    a = hh(a, b, c, d, k[9], 4, -640364487);
	    d = hh(d, a, b, c, k[12], 11, -421815835);
	    c = hh(c, d, a, b, k[15], 16, 530742520);
	    b = hh(b, c, d, a, k[2], 23, -995338651);
	
	    a = ii(a, b, c, d, k[0], 6, -198630844);
	    d = ii(d, a, b, c, k[7], 10, 1126891415);
	    c = ii(c, d, a, b, k[14], 15, -1416354905);
	    b = ii(b, c, d, a, k[5], 21, -57434055);
	    a = ii(a, b, c, d, k[12], 6, 1700485571);
	    d = ii(d, a, b, c, k[3], 10, -1894986606);
	    c = ii(c, d, a, b, k[10], 15, -1051523);
	    b = ii(b, c, d, a, k[1], 21, -2054922799);
	    a = ii(a, b, c, d, k[8], 6, 1873313359);
	    d = ii(d, a, b, c, k[15], 10, -30611744);
	    c = ii(c, d, a, b, k[6], 15, -1560198380);
	    b = ii(b, c, d, a, k[13], 21, 1309151649);
	    a = ii(a, b, c, d, k[4], 6, -145523070);
	    d = ii(d, a, b, c, k[11], 10, -1120210379);
	    c = ii(c, d, a, b, k[2], 15, 718787259);
	    b = ii(b, c, d, a, k[9], 21, -343485551);
	
	    x[0] = add32(a, x[0]);
	    x[1] = add32(b, x[1]);
	    x[2] = add32(c, x[2]);
	    x[3] = add32(d, x[3]);
	  }
	
	  function cmn(q, a, b, x, s, t) {
	    a = add32(add32(a, q), add32(x, t));
	    return add32(a << s | a >>> 32 - s, b);
	  }
	
	  function ff(a, b, c, d, x, s, t) {
	    return cmn(b & c | ~b & d, a, b, x, s, t);
	  }
	
	  function gg(a, b, c, d, x, s, t) {
	    return cmn(b & d | c & ~d, a, b, x, s, t);
	  }
	
	  function hh(a, b, c, d, x, s, t) {
	    return cmn(b ^ c ^ d, a, b, x, s, t);
	  }
	
	  function ii(a, b, c, d, x, s, t) {
	    return cmn(c ^ (b | ~d), a, b, x, s, t);
	  }
	
	  function md51(s) {
	    txt = '';
	    var n = s.length,
	        state = [1732584193, -271733879, -1732584194, 271733878],
	        i;
	    for (i = 64; i <= s.length; i += 64) {
	      md5cycle(state, md5blk(s.substring(i - 64, i)));
	    }
	    s = s.substring(i - 64);
	    var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	    for (i = 0; i < s.length; i++) {
	      tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
	    }
	    tail[i >> 2] |= 0x80 << (i % 4 << 3);
	    if (i > 55) {
	      md5cycle(state, tail);
	      for (i = 0; i < 16; i++) {
	        tail[i] = 0;
	      }
	    }
	    tail[14] = n * 8;
	    md5cycle(state, tail);
	    return state;
	  }
	
	  /* there needs to be support for Unicode here,
	   * unless we pretend that we can redefine the MD-5
	   * algorithm for multi-byte characters (perhaps
	   * by adding every four 16-bit characters and
	   * shortening the sum to 32 bits). Otherwise
	   * I suggest performing MD-5 as if every character
	   * was two bytes--e.g., 0040 0025 = @%--but then
	   * how will an ordinary MD-5 sum be matched?
	   * There is no way to standardize text to something
	   * like UTF-8 before transformation; speed cost is
	   * utterly prohibitive. The JavaScript standard
	   * itself needs to look at this: it should start
	   * providing access to strings as preformed UTF-8
	   * 8-bit unsigned value arrays.
	   */
	
	  function md5blk(s) {
	    /* I figured global was faster.   */
	    var md5blks = [],
	        i; /* Andy King said do it this way. */
	    for (i = 0; i < 64; i += 4) {
	      md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
	    }
	    return md5blks;
	  }
	
	  var hex_chr = '0123456789abcdef'.split('');
	
	  function rhex(n) {
	    var s = '',
	        j = 0;
	    for (; j < 4; j++) {
	      s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
	    }
	    return s;
	  }
	
	  function hex(x) {
	    for (var i = 0; i < x.length; i++) {
	      x[i] = rhex(x[i]);
	    }
	    return x.join('');
	  }
	
	  function md5(s) {
	    return hex(md51(s));
	  }
	
	  /* this function is much faster,
	  so if possible we use it. Some IEs
	  are the only ones I know of that
	  need the idiotic second function,
	  generated by an if clause.  */
	
	  add32 = function add32(a, b) {
	    return a + b & 0xFFFFFFFF;
	  };
	
	  if (md5('hello') !== '5d41402abc4b2a76b9719d911017c592') {
	    add32 = function add32(x, y) {
	      var lsw = (x & 0xFFFF) + (y & 0xFFFF),
	          msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	      return msw << 16 | lsw & 0xFFFF;
	    };
	  }
	
	  return md5;
	});

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var template = __webpack_require__(327);
	
	angular.module('directives.paginator', []).directive('paginator', ["$parse", function ($parse) {
	  return {
	    restrict: 'E',
	    scope: {
	      $page: '=pageModel',
	      callback: '&onNavigate'
	    },
	    template: template,
	    link: function link(scope, element, attrs) {
	
	      var paginate = function paginate(offset) {
	        scope.$apply(function () {
	          scope.callback({ $offset: offset });
	        });
	      };
	
	      element.on('click', '.next', function () {
	        paginate(scope.$page.offset + scope.$page.limit);
	      });
	      element.on('click', '.prev', function () {
	        paginate(scope.$page.offset - scope.$page.limit);
	      });
	    }
	  };
	}]);

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports = "<div class=well ng-if=\"$page.total > 1\"> <div class=\"btn-group pull-left\"> <button disabled=disabled class=\"btn btn-default\">Strona {{$page.currentPage}} z {{$page.pages}}</button> <button disabled=disabled class=\"btn btn-default\">Wiersz {{$page.offset + 1}} - {{$page.total > $page.limit ? $page.offset + $page.limit : $page.total}} z {{$page.total}}</button> </div> <div class=\"btn-group pull-right\"> <button class=\"btn btn-default prev\" ng-disabled=!$page.hasPrev ng-class=\"{disabled: !$page.hasPrev}\">&#x2190;</button> <button class=\"btn btn-default next\" ng-disabled=!$page.hasNext ng-class=\"{disabled: !$page.hasNext}\">&#x2192;</button> </div> <div class=clearfix></div> </div> ";

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	'use strict';
	
	// A simple directive to handle server side form validation
	// http://codetunes.com/2013/server-form-validation-with-angular/
	angular.module('directives.serverError', []).directive('serverError', [function () {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    replace: true,
	    link: function link(scope, element, attrs, ctrl) {
	      element.on('change', function () {
	        scope.$apply(function () {
	          ctrl.$setValidity('server', true);
	        });
	      });
	    }
	  };
	}]);

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('directives.uiRouterTitle', []).directive('uiRouterTitle', ["$rootScope", "$timeout", function ($rootScope, $timeout) {
	  return {
	    link: function link(scope, element) {
	
	      // var listener = function(event, toState) {
	      //   if (!toState.title) {
	      //     return;
	      //   }
	      //
	      //   $timeout(function() {
	      //     element.text(toState.title);
	      //   });
	      // };
	      //
	      // $rootScope.$on('$stateChangeSuccess', listener);
	    }
	  };
	}]);

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('filters.rawHtml', []).filter('rawHtml', ['$sce', function ($sce) {
	  return function (val) {
	    return $sce.trustAsHtml(_.unescape(val));
	  };
	}]);

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('filters.stripHtml', []).filter('stripHtml', ['$sce', function ($sce) {
	  return function (val) {
	    val = val || '';
	    console.log(val);
	    return val.replace(/&nbsp;/g, '').trim();
	  };
	}]);

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('filters.timeAgo', []).filter('timeAgo', function () {
	  return function (date) {
	    moment.locale('pl');
	    return date ? moment(date).from() : '';
	  };
	});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('middlewares', ['middlewares.isAdmin', 'middlewares.isLoggedIn']);

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('middlewares.isAdmin', ['resources.AdminUser']).service('isAdmin', ["User", "$state", function (User, $state) {
	
	  return function (next) {
	    User.current(function (user) {
	      if (user && user.is_active && user.is_admin) {
	        return next();
	      }
	
	      return $state.go('unauthorized');
	    });
	  };
	}]);

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('middlewares.isLoggedIn', ['resources.User']).service('isLoggedIn', ["User", "$state", function (User, $state) {
	
	  return function (next) {
	    User.current(function (user) {
	      if (user && user.is_active) {
	        return next();
	      }
	
	      return $state.go('unauthorized');
	    });
	  };
	}]);

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.AdminCategory', ['ngResource']).factory('AdminCategory', ['$resource', function ($resource) {
	  var Resource = $resource('/api/admin/categories/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT',
	      isArray: false
	    },
	    getTree: {
	      method: 'GET',
	      url: '/api/admin/categoriesTree',
	      isArray: true
	    }
	  });
	
	  return Resource;
	}]);

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.AdminGroup', ['ngResource']).factory('AdminGroup', ['$resource', function ($resource) {
	  var resource = $resource('/api/admin/groups/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    search: {
	      method: 'GET',
	      url: '/api/admin/groups-search',
	      isArray: true
	    }
	  });
	
	  return resource;
	}]);

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.AdminUser', ['ngResource']).factory('AdminUser', ['$resource', function ($resource) {
	  var Resource = $resource('/api/admin/users/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    search: {
	      method: 'GET',
	      url: '/api/admin/users-search',
	      isArray: true
	    },
	    getAll: {
	      method: 'GET',
	      url: '/api/admin/users',
	      isArray: false
	    }
	  });
	
	  return Resource;
	}]);

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Album', ['ngResource']).factory('Album', ['$resource', function ($resource) {
	  var Resource = $resource('/api/admin/albums/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    create: {
	      url: '/api/admin/albums',
	      method: 'POST'
	    },
	    // search: {
	    //   method: 'GET',
	    //   url: '/api/admin/users-search',
	    //   isArray: true
	    // },
	    getAll: {
	      method: 'GET',
	      url: '/api/admin/albums',
	      isArray: false
	    }
	  });
	
	  return Resource;
	}]);

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Article', ['ngResource']).factory('Article', ['$resource', function ($resource) {
	  var Resource = $resource('/api/account/my-articles/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    queryVideo: {
	      method: 'GET',
	      isArray: false,
	      url: '/api/account/my-videos'
	    },
	    update: {
	      method: 'PUT',
	      isArray: false
	    },
	    search: {
	      method: 'GET',
	      isArray: true,
	      url: '/api/account/my-articles-search'
	    },
	    getAllArticles: {
	      method: 'GET',
	      isArray: false,
	      url: '/api/diagrams/get-all-articles'
	    },
	    getAllEditions: {
	      method: 'GET',
	      isArray: false,
	      url: '/api/editions/get-all-editions'
	    },
	    getAllRecuentos: {
	      method: 'GET',
	      isArray: false,
	      url: '/api/recuentos/get-all-editions'
	    },
	    getInfoVideo: {
	      method: 'GET',
	      isArray: false,
	      url: '/api/media/info/get-info-video'
	    }
	  });
	  return Resource;
	}]);

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Category', ['ngResource']).factory('Category', ['$resource', function ($resource) {
	  var Resource = $resource('/api/account/categories/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    getTree: {
	      method: 'GET',
	      url: '/api/account/categoriesTree',
	      isArray: true
	    },
	    getPermittedTree: {
	      method: 'GET',
	      url: '/api/account/categoriesPermittedTree',
	      isArray: true
	    }
	  });
	
	  return Resource;
	}]);

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Image', ['ngResource']).factory('Album', ['$resource', function ($resource) {
	  var Resource = $resource('/api/admin/images/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    create: {
	      method: 'POST'
	    },
	    // search: {
	    //   method: 'GET',
	    //   url: '/api/admin/users-search',
	    //   isArray: true
	    // },
	    getAll: {
	      method: 'GET',
	      url: '/api/admin/albums',
	      isArray: false
	    }
	  });
	
	  return Resource;
	}]);

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Role', ['ngResource']).factory('Role', ['$resource', function ($resource) {
	  var resource = $resource('/api/roles/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    search: {
	      method: 'GET',
	      url: '/api/roles-search',
	      isArray: true
	    }
	  });
	
	  return resource;
	}]);

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Settings', ['ngResource']).factory('Settings', ['$resource', function ($resource) {
	  return $resource('/api/settings', null, {
	    get: {
	      method: 'GET',
	      url: '/api/settings/get',
	      isArray: true
	    },
	    set: {
	      method: 'POST',
	      url: '/api/settings/set',
	      isArray: true
	    }
	  });
	}]);

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Sport', ['ngResource']).factory('Sport', ['$resource', function ($resource) {
	  var resource = $resource('/api/sports/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    search: {
	      method: 'GET',
	      url: '/api/sports-search',
	      isArray: true
	    }
	  });
	
	  return resource;
	}]);

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Subscriber', ['ngResource']).factory('Subscriber', ['$resource', function ($resource) {
	  var Resource = $resource('/api/admin/subscribers/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    search: {
	      method: 'GET',
	      url: '/api/admin/users-search',
	      isArray: true
	    },
	    getAll: {
	      method: 'GET',
	      url: '/api/admin/subscribers',
	      isArray: false
	    }
	  });
	
	  return Resource;
	}]);

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.Tag', ['ngResource']).factory('Tag', ['$resource', function ($resource) {
	  var resource = $resource('/api/tags/:id', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false,
	      url: '/api/admin/tags'
	    },
	    update: {
	      method: 'PUT'
	    },
	    delete: {
	      isArray: false,
	      method: 'DELETE'
	    },
	    search: {
	      method: 'GET',
	      url: '/api/tags-search',
	      isArray: true
	    },
	    mergeTags: {
	      method: 'POST',
	      url: '/api/tags/panel/merge'
	    }
	  });
	
	  return resource;
	}]);

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('resources.User', ['ngResource']).factory('User', ['$resource', function ($resource) {
	  var User = $resource('/api', { id: '@_id' }, {
	    query: {
	      method: 'GET',
	      isArray: false
	    },
	    update: {
	      method: 'PUT'
	    },
	    completeSignup: {
	      method: 'PUT',
	      url: '/api/completeSignup'
	    },
	    updateAccount: {
	      method: 'PUT',
	      url: '/api/updateAccount'
	    },
	    changePassword: {
	      method: 'PUT',
	      url: '/api/password'
	    },
	    changeLogin: {
	      method: 'PUT',
	      url: '/api/credentials'
	    },
	    current: {
	      method: 'GET',
	      url: '/api/current-user',
	      isArray: false
	    }
	  });
	
	  return User;
	}]);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('security.authorization', ['security.service', 'config'])
	
	// This service provides guard methods to support AngularJS routes.
	// You can add them as resolves to routes to require authorization levels
	// before allowing a route change to complete
	.provider('securityAuthorization', {
	
	  requireAdminUser: ['securityAuthorization', function (securityAuthorization) {
	    return securityAuthorization.requireAdminUser();
	  }],
	
	  requireAuthenticatedUser: ['securityAuthorization', function (securityAuthorization) {
	    return securityAuthorization.requireAuthenticatedUser();
	  }],
	
	  requireUnauthenticatedUser: ['securityAuthorization', function (securityAuthorization) {
	    return securityAuthorization.requireUnauthenticatedUser();
	  }],
	
	  requireVerifiedUser: ['securityAuthorization', function (securityAuthorization) {
	    return securityAuthorization.requireVerifiedUser();
	  }],
	
	  requireUnverifiedUser: ['securityAuthorization', function (securityAuthorization) {
	    return securityAuthorization.requireUnverifiedUser();
	  }],
	
	  $get: ['$log', '$q', '$location', 'security', 'securityRetryQueue', 'REQUIRE_ACCOUNT_VERIFICATION', function ($log, $q, $location, security, queue, requireAccountVerification) {
	    var service = {
	
	      // Require that there is an authenticated user
	      // (use this in a route resolve to prevent non-authenticated users from entering that route)
	      requireAuthenticatedUser: function requireAuthenticatedUser() {
	        var promise = security.requestCurrentUser().then(function (userInfo) {
	          if (!security.isAuthenticated()) {
	            return queue.pushRetryFn('unauthenticated-client', service.requireAuthenticatedUser);
	          }
	        });
	        return promise;
	      },
	
	      requireUnauthenticatedUser: function requireUnauthenticatedUser() {
	        var promise = security.requestCurrentUser().then(function (userInfo) {
	          if (security.isAuthenticated()) {
	            return $q.reject('authenticated-client');
	          }
	        });
	        return promise;
	      },
	
	      // Require that there is an administrator logged in
	      // (use this in a route resolve to prevent non-administrators from entering that route)
	      requireAdminUser: function requireAdminUser() {
	        var promise = security.requestCurrentUser().then(function (userInfo) {
	          if (!security.isAuthenticated()) {
	            return queue.pushRetryFn('unauthenticated-client', service.requireAdminUser);
	          } else if (!security.isAdmin()) {
	            return $q.reject('unauthorized-client');
	          }
	        });
	        return promise;
	      },
	
	      requireVerifiedUser: function requireVerifiedUser() {
	        var promise = security.requestCurrentUser().then(function (userInfo) {
	          if (!security.isAuthenticated()) {
	            return queue.pushRetryFn('unauthenticated-client', service.requireVerifiedUser);
	          }
	          if (requireAccountVerification && userInfo && !userInfo.isVerified) {
	            return $q.reject('unverified-client');
	          }
	        });
	        return promise;
	      },
	
	      requireUnverifiedUser: function requireUnverifiedUser() {
	        var promise = security.requestCurrentUser().then(function (userInfo) {
	          if (!security.isAuthenticated()) {
	            return queue.pushRetryFn('unauthenticated-client', service.requireUnverifiedUser);
	          }
	          if (requireAccountVerification && userInfo && userInfo.isVerified) {
	            return $q.reject('verified-client');
	          }
	        });
	        return promise;
	      }
	
	    };
	
	    return service;
	  }]
	});

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	// Based loosely around work by Witold Szczerba - https://github.com/witoldsz/angular-http-auth
	angular.module('security', ['security.service', 'security.interceptor', 'security.login', 'security.authorization']);

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('security.interceptor', ['security.retryQueue'])
	
	// This http interceptor listens for authentication failures
	.factory('securityInterceptor', ['$q', '$log', '$injector', 'securityRetryQueue', function ($q, $log, $injector, queue) {
	  return {
	    'responseError': function responseError(response) {
	      if (response.status === 401) {
	        // The request bounced because it was not authorized - add a new request to the retry queue
	        // and return a new promise that will be resolved or rejected after calling retryItem's retry or cancel method
	        // eg. retryRequest is the retryFn that will be called later
	        return queue.pushRetryFn('unauthorized-server', function retryRequest() {
	          return $injector.get('$http')(response.config);
	        });
	      }
	
	      //if(response.status === 304) {
	      //  return $q.resolve(response);
	      //}
	      //if not 401 then forward the error to next error handler
	      return $q.reject(response);
	    }
	  };
	  //return function(promise) {
	  //  // Intercept failed requests
	  //  return promise.then(null, function(originalResponse) {
	  //    if(originalResponse.status === 401) {
	  //      // The request bounced because it was not authorized - add a new request to the retry queue
	  //      promise = queue.pushRetryFn('unauthorized-server', function retryRequest() {
	  //        // We must use $injector to get the $http service to prevent circular dependency
	  //        return $injector.get('$http')(originalResponse.config);
	  //      });
	  //    }
	  //    return promise;
	  //  });
	  //};
	}])
	
	// We have to add the interceptor to the queue as a string because the interceptor depends upon service instances that are not available in the config block.
	.config(['$httpProvider', function ($httpProvider) {
	  //$httpProvider.responseInterceptors.push('securityInterceptor');
	  $httpProvider.interceptors.push('securityInterceptor');
	}]);

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('security.login', ['security.login.form', 'security.login.toolbar']);

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('security.login.form', ['services.localizedMessages', 'ui.bootstrap'])
	
	// The LoginFormController provides the behaviour behind a reusable form to allow users to authenticate.
	// This controller and its template (login/form.tpl.html) are used in a modal dialog box by the security service.
	.controller('LoginFormController', ['$scope', 'security', 'localizedMessages', function ($scope, security, localizedMessages) {
	  // The model for this form 
	  $scope.user = {};
	  $scope.alerts = [{
	    type: 'info',
	    msg: 'Please enter your login details'
	  }];
	  // The reason that we are being asked to login - for instance because we tried to access something to which we are not authorized
	  // We could do something different for each reason here but to keep it simple...
	  if (security.getLoginReason()) {
	    $scope.alerts.push({
	      type: 'warning',
	      msg: security.isAuthenticated() ? localizedMessages.get('login.reason.notAuthorized') : localizedMessages.get('login.reason.notAuthenticated')
	    });
	  }
	
	  // Attempt to authenticate the user specified in the form's model
	  $scope.login = function () {
	    // Clear any previous security errors
	    $scope.alerts = [];
	
	    // Try to login
	    security.login($scope.user.email, $scope.user.password).then(function (data) {
	      if (!data.success) {
	        // If we get here then the login failed due to bad credentials
	        $scope.alerts.push({
	          type: 'danger',
	          msg: localizedMessages.get('login.error.invalidCredentials')
	        });
	      }
	    }, function (x) {
	      // If we get here then there was a problem with the login request to the server
	      $scope.alerts.push({
	        type: 'danger',
	        msg: localizedMessages.get('login.error.serverError', { exception: x })
	      });
	    });
	  };
	
	  $scope.clearForm = function () {
	    $scope.user = {};
	  };
	
	  $scope.cancelLogin = function () {
	    security.cancelLogin();
	  };
	
	  $scope.closeAlert = function (ind) {
	    $scope.alerts.splice(ind, 1);
	  };
	}]);

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('security.login.toolbar', [])
	
	// The loginToolbar directive is a reusable widget that can show login or logout buttons
	// and information the current authenticated user
	.directive('loginToolbar', ['security', function (security) {
	  var directive = {
	    templateUrl: 'security/login/toolbar.tpl.html',
	    restrict: 'E',
	    replace: true,
	    scope: true,
	    link: function link($scope, $element, $attrs, $controller) {
	      $scope.isAuthenticated = security.isAuthenticated;
	      $scope.login = security.showLogin;
	      $scope.logout = security.logout;
	      $scope.$watch(function () {
	        return security.currentUser;
	      }, function (currentUser) {
	        $scope.currentUser = currentUser;
	      });
	    }
	  };
	  return directive;
	}]);

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('security.retryQueue', [])
	
	// This is a generic retry queue for security failures.  Each item is expected to expose two functions: retry and cancel.
	.factory('securityRetryQueue', ['$q', '$log', function ($q, $log) {
	  var retryQueue = [];
	  var service = {
	    // The security service puts its own handler in here!
	    onItemAddedCallbacks: [],
	
	    hasMore: function hasMore() {
	      return retryQueue.length > 0;
	    },
	    push: function push(retryItem) {
	      retryQueue.push(retryItem);
	      // Call all the onItemAdded callbacks
	      angular.forEach(service.onItemAddedCallbacks, function (cb) {
	        try {
	          cb(retryItem);
	        } catch (e) {
	          $log.error('securityRetryQueue.push(retryItem): callback threw an error' + e);
	        }
	      });
	    },
	    pushRetryFn: function pushRetryFn(reason, retryFn) {
	      // The reason parameter is optional
	      if (arguments.length === 1) {
	        retryFn = reason;
	        reason = undefined;
	      }
	
	      // The deferred object that will be resolved or rejected by calling retry or cancel
	      var deferred = $q.defer();
	      var retryItem = {
	        reason: reason,
	        retry: function retry() {
	          // Wrap the result of the retryFn into a promise if it is not already
	          $q.when(retryFn()).then(function (value) {
	            // If it was successful then resolve our deferred
	            deferred.resolve(value);
	          }, function (value) {
	            // Othewise reject it
	            deferred.reject(value);
	          });
	        },
	        cancel: function cancel() {
	          // Give up on retrying and reject our deferred
	          deferred.reject();
	        }
	      };
	      service.push(retryItem);
	      return deferred.promise;
	    },
	    retryReason: function retryReason() {
	      return service.hasMore() && retryQueue[0].reason;
	    },
	    cancelAll: function cancelAll() {
	      while (service.hasMore()) {
	        retryQueue.shift().cancel();
	      }
	    },
	    retryAll: function retryAll() {
	      while (service.hasMore()) {
	        retryQueue.shift().retry();
	      }
	    }
	  };
	  return service;
	}]);

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	'use strict';
	
	// Based loosely around work by Witold Szczerba - https://github.com/witoldsz/angular-http-auth
	angular.module('security.service', ['security.retryQueue', // Keeps track of failed requests that need to be retried once the user logs in
	'security.login', // Contains the login form template and controller
	'ui.bootstrap.modal' // Used to display the login form as a modal dialog.
	]).factory('security', ['$http', '$q', '$location', 'securityRetryQueue', '$uibModal', 'md5', function ($http, $q, $location, queue, $uibModal, md5) {
	
	  // Redirect to the given url (defaults to '/')
	  function redirect(url) {
	    url = url || '/';
	    $location.path(url);
	  }
	
	  // Login form dialog stuff
	  var loginDialog = null;
	  function openLoginDialog() {
	    if (loginDialog) {
	      throw new Error('Trying to open a dialog that is already open!');
	    }
	    //loginDialog = $uibModal.dialog();
	    //loginDialog.open('security/login/form.tpl.html', 'LoginFormController').then(onLoginDialogClose);
	    loginDialog = $uibModal.open({
	      templateUrl: 'security/login/form.tpl.html',
	      controller: 'LoginFormController'
	    });
	    loginDialog.result.then(onLoginDialogClose, onLoginDialogDismiss);
	  }
	  function closeLoginDialog(success) {
	    if (loginDialog) {
	      loginDialog.close(success);
	    }
	  }
	  function dismissLoginDialog(reason) {
	    if (loginDialog) {
	      loginDialog.dismiss(reason);
	    }
	  }
	  function onLoginDialogClose(success) {
	    loginDialog = null;
	    if (success) {
	      queue.retryAll();
	    } else {
	      queue.cancelAll();
	      redirect();
	    }
	  }
	  //modal is dismissed because escape key press or mouse click outside
	  function onLoginDialogDismiss(reason) {
	    loginDialog = null;
	    queue.cancelAll();
	    redirect();
	  }
	
	  // Register a handler for when an item is added to the retry queue
	  queue.onItemAddedCallbacks.push(function (retryItem) {
	    if (queue.hasMore()) {
	      service.showLogin();
	    }
	  });
	
	  function processResponse(res) {
	    return res.data;
	  }
	
	  function processError(e) {
	    var msg = [];
	    if (e.status) {
	      msg.push(e.status);
	    }
	    if (e.statusText) {
	      msg.push(e.statusText);
	    }
	    if (msg.length === 0) {
	      msg.push('Unknown Server Error');
	    }
	    return $q.reject(e);
	  }
	  var deferredCurrentUser;
	
	  // The public API of the service
	  var service = {
	
	    signup: function signup(data) {
	      return $http.post('/api/signup', data).then(processResponse, processError);
	    },
	
	    // Get the first reason for needing a login
	    getLoginReason: function getLoginReason() {
	      return queue.retryReason();
	    },
	
	    // Show the modal login dialog
	    showLogin: function showLogin() {
	      // openLoginDialog();
	    },
	
	    socialDisconnect: function socialDisconnect(provider) {
	      var url = '/api/account/settings/' + provider.toLowerCase() + '/disconnect';
	      return $http.get(url).then(function (res) {
	        return res.data;
	      });
	    },
	
	    socialConnect: function socialConnect(provider, params) {
	      var url = '/api/account/settings/' + provider.toLowerCase() + '/callback';
	      return $http.get(url, { params: params }).then(function (res) {
	        return res.data;
	      });
	    },
	
	    socialLogin: function socialLogin(provider, params) {
	      var url = '/api/login/' + provider.toLowerCase() + '/callback';
	      var promise = $http.get(url, { params: params }).then(function (res) {
	        var data = res.data;
	        if (data.success) {
	          closeLoginDialog(true);
	          service.currentUser = data.user;
	        }
	        return data;
	      });
	      return promise;
	    },
	
	    // Attempt to authenticate a user by the given username and password
	    login: function login(username, password) {
	      var request = $http.post('/api/login', {
	        username: username,
	        password: md5.createHash(password)
	      });
	      return request.then(function (response) {
	        var data = response.data;
	        if (data) {
	          closeLoginDialog(true);
	          service.currentUser = data;
	        }
	        return data;
	      });
	    },
	
	    // Give up trying to login and clear the retry queue
	    cancelLogin: function cancelLogin() {
	      //closeLoginDialog(false);
	      //redirect();
	      dismissLoginDialog('cancel button clicked');
	    },
	
	    // Logout the current user and redirect
	    logout: function logout(redirectTo) {
	      $http.post('/api/logout').then(function () {
	        service.currentUser = null;
	        redirect(redirectTo);
	      });
	    },
	
	    loginForgot: function loginForgot(data) {
	      return $http.post('/api/login/forgot', data).then(processResponse, processError);
	    },
	    createHash: function createHash(pwd) {
	      return md5.createHash(pwd);
	    },
	    changepass: function changepass(data) {
	      var d = Object.assign({}, data);
	      d.password = md5.createHash(data.password);
	      d.confirm_password = md5.createHash(data.password);
	      return $http.post('/api/change_password', d).then(processResponse, processError);
	    },
	
	    loginReset: function loginReset(id, email, data) {
	      var url = '/api/login/reset/' + email + '/' + id;
	      return $http.put(url, data).then(processResponse, processError);
	    },
	
	    // Ask the backend to see if a user is already authenticated - this may be from a previous session.
	    requestCurrentUser: function requestCurrentUser() {
	      if (service.isAuthenticated()) {
	        // local currentUser is available
	        return $q.when(service.currentUser);
	      } else if (deferredCurrentUser) {
	        // already an outstanding backend request for currentUser
	        return deferredCurrentUser.promise;
	      } else {
	        // no outstanding backend call nor local currentUser
	        deferredCurrentUser = $q.defer();
	        $http.get('/api/current-user').then(function (response) {
	          service.currentUser = response.data;
	          deferredCurrentUser.resolve(service.currentUser);
	          deferredCurrentUser = null;
	        }, function (x) {
	          deferredCurrentUser.reject(x);
	          deferredCurrentUser = null;
	        });
	        return deferredCurrentUser.promise;
	      }
	    },
	
	    setCurrentUser: function setCurrentUser(user) {
	      service.currentUser = user;
	    },
	
	    // Information about the current user
	    currentUser: null,
	
	    // Is the current user authenticated?
	    isAuthenticated: function isAuthenticated() {
	      return !!service.currentUser;
	    },
	
	    // Is the current user an administrator?
	    isAdmin: function isAdmin() {
	      return !!(service.currentUser && service.currentUser.is_admin);
	    }
	  };
	
	  return service;
	}]);

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.accountResource', ['security.service']).factory('accountResource', ['$http', '$q', '$log', 'security', function ($http, $q, $log, security) {
	  // local variable
	  var baseUrl = '/api';
	  var processResponse = function processResponse(res) {
	    return res.data;
	  };
	  var processError = function processError(e) {
	    var msg = [];
	    if (e.status) {
	      msg.push(e.status);
	    }
	    if (e.statusText) {
	      msg.push(e.statusText);
	    }
	    if (msg.length === 0) {
	      msg.push('Unknown Server Error');
	    }
	    return $q.reject(msg.join(' '));
	  };
	  // public api
	  var resource = {};
	  resource.sendMessage = function (data) {
	    return $http.post(baseUrl + '/sendMessage', data).then(processResponse, processError);
	  };
	
	  resource.getAccountDetails = function () {
	    return $http.get(baseUrl + '/account/settings').then(processResponse, processError);
	  };
	  resource.setAccountDetails = function (data) {
	    return $http.put(baseUrl + '/account/settings', data).then(processResponse, processError);
	  };
	  resource.setIdentity = function (data) {
	    return $http.put(baseUrl + '/account/settings/identity', data).then(processResponse, processError);
	  };
	  resource.setPassword = function (data) {
	    return $http.put(baseUrl + '/account/settings/password', data).then(processResponse, processError);
	  };
	
	  resource.resendVerification = function (email) {
	    return $http.post(baseUrl + '/account/verification', { email: email }).then(processResponse, processError);
	  };
	
	  resource.upsertVerification = function () {
	    return $http.get(baseUrl + '/account/verification').then(processResponse, processError);
	  };
	
	  resource.verifyAccount = function (token) {
	    return $http.get(baseUrl + '/account/verification/' + token).then(processResponse, processError).then(function (data) {
	      //this saves us another round trip to backend to retrieve the latest currentUser obj
	      if (data.success && data.user) {
	        security.setCurrentUser(data.user);
	      }
	      return data;
	    });
	  };
	  return resource;
	}]);

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.adminResource', []).factory('adminResource', ['$http', '$q', function ($http, $q) {
	  // local variable
	  var baseUrl = '/api';
	  var userUrl = baseUrl + '/admin/users';
	  var subscriberUrl = baseUrl + '/admin/subscribers';
	  var tagUrl = baseUrl + '/admin/tags';
	  var tagSearchUrl = baseUrl + '/admin/tags-s';
	  var roleUrl = baseUrl + '/admin/roles';
	  var roleSearchUrl = baseUrl + '/admin/roles-s';
	  var accountUrl = baseUrl + '/admin/accounts';
	  var accountGroupUrl = baseUrl + '/admin/groups';
	  var administratorUrl = baseUrl + '/admin/administrators';
	  var adminGroupUrl = baseUrl + '/admin/admin-groups';
	  var adminStatusesUrl = baseUrl + '/admin/statuses';
	  var categoriesUrl = baseUrl + '/admin/categories';
	  var menusUrl = baseUrl + '/admin/menus';
	  var articlesUrl = baseUrl + '/admin/articles';
	  var allauthorsUrl = baseUrl + '/admin/diagrams';
	  var sportsUrl = baseUrl + '/admin/sports';
	  var sportsStaticUrl = baseUrl + '/admin/sports-list';
	  var languagesUrl = baseUrl + '/admin/languages-list';
	  var albumsUrl = baseUrl + '/admin/albums';
	  var imagesUrl = baseUrl + '/admin/images';
	
	  var processResponse = function processResponse(res) {
	    return res.data;
	  };
	  var processError = function processError(e) {
	    // var msg = [];
	    // if(e.status)         { msg.push(e.status); }
	    // if(e.statusText)     { msg.push(e.statusText); }
	    // if(msg.length === 0) { msg.push('Unknown Server Error'); }
	    // return $q.reject(msg.join(' '));
	    // $q.reject(e);
	  };
	  // public api
	  var resource = {};
	  resource.getStats = function () {
	    return $http.get(baseUrl + '/admin').then(processResponse, processError);
	  };
	  // resource.search = function(query){
	  //   return $http.get(baseUrl + '/admin/search', { params: { q: query }} ).then(processResponse, processError);
	  // };
	
	  // ----- subscribers api -----
	  resource.findSubscribers = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(subscriberUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.findSubscriber = function (_id) {
	    var url = subscriberUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	
	  // ----- users api -----
	  resource.findUsers = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(userUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.addUser = function (username) {
	    return $http.post(userUrl, { username: username }).then(processResponse, processError);
	  };
	  resource.findUser = function (_id) {
	    var url = userUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.updateUser = function (_id, data) {
	    var url = userUrl + '/' + _id;
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.setPassword = function (_id, data) {
	    var url = userUrl + '/' + _id + '/password';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.linkAdmin = function (_id, data) {
	    var url = userUrl + '/' + _id + '/role-admin';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.unlinkAdmin = function (_id) {
	    var url = userUrl + '/' + _id + '/role-admin';
	    return $http.delete(url).then(processResponse, processError);
	  };
	  resource.linkAccount = function (_id, data) {
	    var url = userUrl + '/' + _id + '/role-account';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.unlinkAccount = function (_id) {
	    var url = userUrl + '/' + _id + '/role-account';
	    return $http.delete(url).then(processResponse, processError);
	  };
	  resource.deleteUser = function (_id) {
	    var url = userUrl + '/' + _id;
	    return $http.delete(url).then(processResponse, processError);
	  };
	
	  // ----- accounts api -----
	  resource.findMyArticles = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get('/api/account/my-articles', { params: filters }).then(processResponse, processError);
	  };
	  resource.findAccounts = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(accountUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.addAccount = function (fullname) {
	    return $http.post(accountUrl, { 'name.full': fullname }).then(processResponse, processError);
	  };
	  resource.findAccount = function (_id) {
	    var url = accountUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.updateAccount = function (_id, data) {
	    var url = accountUrl + '/' + _id;
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.linkUser = function (_id, data) {
	    var url = accountUrl + '/' + _id + '/user';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.unlinkUser = function (_id) {
	    var url = accountUrl + '/' + _id + '/user';
	    return $http.delete(url).then(processResponse, processError);
	  };
	  resource.newAccountNote = function (_id, data) {
	    var url = accountUrl + '/' + _id + '/notes';
	    return $http.post(url, data).then(processResponse, processError);
	  };
	  resource.newAccountStatus = function (_id, data) {
	    var url = accountUrl + '/' + _id + '/status';
	    return $http.post(url, data).then(processResponse, processError);
	  };
	  resource.saveAccountGroups = function (_id, data) {
	    var url = accountUrl + '/' + _id + '/groups';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.saveAccountPermissions = function (_id, data) {
	    var url = accountUrl + '/' + _id + '/permissions';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.deleteAccount = function (_id) {
	    var url = accountUrl + '/' + _id;
	    return $http.delete(url).then(processResponse, processError);
	  };
	
	  // ----- administrators api -----
	  resource.findAdministrators = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(administratorUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.addAdministrator = function (fullname) {
	    return $http.post(administratorUrl, { 'name.full': fullname }).then(processResponse, processError);
	  };
	  resource.findAdministrator = function (_id) {
	    var url = administratorUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.updateAdministrator = function (_id, data) {
	    var url = administratorUrl + '/' + _id;
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.adminLinkUser = function (_id, data) {
	    var url = administratorUrl + '/' + _id + '/user';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.adminUnlinkUser = function (_id) {
	    var url = administratorUrl + '/' + _id + '/user';
	    return $http.delete(url).then(processResponse, processError);
	  };
	  resource.saveAdminGroups = function (_id, data) {
	    var url = administratorUrl + '/' + _id + '/groups';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.saveAdminPermissions = function (_id, data) {
	    var url = administratorUrl + '/' + _id + '/permissions';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.deleteAdministrator = function (_id) {
	    var url = administratorUrl + '/' + _id;
	    return $http.delete(url).then(processResponse, processError);
	  };
	
	  // ----- account-groups api -----
	  resource.findAccountGroups = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(accountGroupUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.addAccountGroup = function (name) {
	    return $http.post(accountGroupUrl, { name: name }).then(processResponse, processError);
	  };
	  resource.findAccountGroup = function (_id) {
	    var url = accountGroupUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.updateAccountGroup = function (_id, data) {
	    var url = accountGroupUrl + '/' + _id;
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.saveAccountGroupPermissions = function (_id, data) {
	    var url = accountGroupUrl + '/' + _id + '/permissions';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.saveAccountGroupStatus = function (_id, data) {
	    var url = accountGroupUrl + '/' + _id + '/status';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.saveAccountGroupCategories = function (_id, data) {
	    var url = accountGroupUrl + '/' + _id + '/categories';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.newAccountGroupStatus = function (_id, data) {
	    var url = accountGroupUrl + '/' + _id + '/status';
	    return $http.post(url, data).then(processResponse, processError);
	  };
	  resource.deleteAccountGroup = function (_id) {
	    var url = accountGroupUrl + '/' + _id;
	    return $http.delete(url).then(processResponse, processError);
	  };
	
	  // ----- admin-groups api -----
	  resource.findAdminGroups = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(adminGroupUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.addAdminGroup = function (name) {
	    return $http.post(adminGroupUrl, { name: name }).then(processResponse, processError);
	  };
	  resource.findAdminGroup = function (_id) {
	    var url = adminGroupUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.updateAdminGroup = function (_id, data) {
	    var url = adminGroupUrl + '/' + _id;
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.saveAdminGroupPermissions = function (_id, data) {
	    var url = adminGroupUrl + '/' + _id + '/permissions';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.deleteAdminGroup = function (_id) {
	    var url = adminGroupUrl + '/' + _id;
	    return $http.delete(url).then(processResponse, processError);
	  };
	
	  // ----- statuses api -----
	  resource.findStatuses = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(adminStatusesUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.addStatus = function (data) {
	    return $http.post(adminStatusesUrl, data).then(processResponse, processError);
	  };
	  resource.findStatus = function (_id) {
	    var url = adminStatusesUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.updateStatus = function (_id, data) {
	    var url = adminStatusesUrl + '/' + _id;
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.deleteStatus = function (_id) {
	    var url = adminStatusesUrl + '/' + _id;
	    return $http.delete(url).then(processResponse, processError);
	  };
	
	  // ----- articles api -----
	  resource.findArticles = function (filters) {
	    filters = _.assign({
	      limit: 20
	    }, filters);
	
	    return $http.get(articlesUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.findArticle = function (_id) {
	    var url = articlesUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.searchArticles = function (q) {
	    var url = articlesUrl + '/search';
	    return $http.get(url, { params: { q: q } }).then(processResponse, processError);
	  };
	  resource.searchMyArticles = function (q) {
	    var url = baseUrl + '/account/my-articles/search';
	    return $http.get(url, { params: { q: q } }).then(processResponse, processError);
	  };
	  resource.addArticle = function (data) {
	    return $http.post(articlesUrl, data); //.then(processResponse, processError);
	  };
	  resource.updateArticle = function (id, data) {
	    var url = articlesUrl + '/' + id;
	    return $http.put(articlesUrl, data).then(processResponse, processError);
	  };
	
	  // ----- categories api -----
	  resource.getCategoriesTree = function (params) {
	    return $http.get(baseUrl + '/admin/categoriesTree', { params: params }).then(processResponse, processError);
	  };
	  resource.findCategoriesByPath = function (path) {
	    return $http.get(baseUrl + '/admin/categoriesPath', { params: { path: path } }).then(processResponse, processError);
	  };
	  resource.findCategories = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(categoriesUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.addCategory = function (data) {
	    return $http.post(categoriesUrl, data); //.then(processResponse, processError);
	  };
	  resource.findCategory = function (_id) {
	    var url = categoriesUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.updateCategory = function (_id, data) {
	    var url = categoriesUrl + '/' + _id;
	    return $http.put(url, data); //.then(processResponse, processError);
	  };
	  resource.updateCategoryPosition = function (id, data) {
	    var url = categoriesUrl + '/' + id + '/updatePosition';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.deleteCategory = function (_id) {
	    var url = categoriesUrl + '/' + _id;
	    return $http.delete(url).then(processResponse, processError);
	  };
	
	  // ----- gallery ------
	  resource.getAlbums = function (data) {
	    return $http.get(albumsUrl).then(processResponse, processError);
	  };
	  resource.getImages = function (data) {
	    return $http.get(imagesUrl).then(processResponse, processError);
	  };
	  resource.editImage = function (data) {
	    return $http.put(imagesUrl + '/' + data._id, data).then(processResponse, processError);
	  };
	  resource.deleteImage = function (id) {
	    return $http.delete(imagesUrl + '/' + id).then(processResponse, processError);
	  };
	
	  resource.addAlbum = function (data) {
	    return $http.post(albumsUrl, data).then(processResponse, processError);
	  };
	  resource.editAlbum = function (data) {
	    return $http.put(albumsUrl + '/' + data._id, data).then(processResponse, processError);
	  };
	  resource.deleteAlbum = function (id) {
	    return $http.delete(albumsUrl + '/' + id).then(processResponse, processError);
	  };
	
	  resource.addImage = function (data) {
	    return $http.post(imagesUrl, data).then(processResponse, processError);
	  };
	
	  // ----- menus api -----
	  resource.getMenusTree = function (params) {
	    return $http.get(baseUrl + '/admin/menusTree', { params: params }).then(processResponse, processError);
	  };
	  resource.findMenusByPath = function (path) {
	    return $http.get(baseUrl + '/admin/menusPath', { params: { path: path } }).then(processResponse, processError);
	  };
	  resource.findMenus = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(menusUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.updateMenuPosition = function (id, data) {
	    var url = menusUrl + '/' + id + '/updatePosition';
	    return $http.put(url, data).then(processResponse, processError);
	  };
	  resource.addMenu = function (data) {
	    return $http.post(menusUrl, data).then(processResponse, processError);
	  };
	
	  resource.updateMenus = function (menus) {
	    return $http.post('/api/menus/updateOrder', menus).then(processResponse, processError);
	  };
	
	  resource.updateMenu = function (id, data) {
	    return $http.put(menusUrl + '/' + id, data).then(processResponse, processError);
	  };
	  resource.deleteMenu = function (id) {
	    return $http.delete(menusUrl + '/' + id).then(processResponse, processError);
	  };
	
	  // ----- tags api -----
	  resource.findTags = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(tagUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.searchTags = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(tagSearchUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.findTag = function (_id) {
	    var url = tagUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.getTags = function (query) {
	    var params = { q: query };
	    return $http.get(baseUrl + '/tags', { params: params }).then(function (res) {
	      return res.data.map(function (item) {
	        return { text: item.name };
	      });
	    }, processError);
	  };
	
	  resource.saveCarouselTags = function (tags) {
	    return $http.post('/api/tags/carousels/save', tags).then(processResponse, processError);
	  };
	
	  // ----- tags api -----
	  resource.getCaches = function () {
	    return $http.get(baseUrl + '/cache').then(processResponse, processError);
	  };
	
	  // ---- Diagrams api -----
	  resource.findAllAuthors = function (query) {
	    var params = { q: query };
	    var url = allauthorsUrl;
	    console.log("-------------->>>>");
	    return $http.get(url, { params: params }).then(processResponse, processError);
	    //return $http.get(url +"?q=ronaldo&limit=20").then(processResponse, processError);
	  };
	
	  // ----- roles api -----
	  resource.findRoles = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(roleUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.searchRoles = function (filters) {
	    if (angular.equals({}, filters)) {
	      filters = undefined;
	    }
	    return $http.get(roleSearchUrl, { params: filters }).then(processResponse, processError);
	  };
	  resource.findRole = function (_id) {
	    var url = roleUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };
	  resource.getRoles = function (query) {
	    var params = { q: query };
	    return $http.get(baseUrl + '/roles', { params: params }).then(function (res) {
	      return res.data.map(function (item) {
	        return { text: item.name };
	      });
	    }, processError);
	  };
	  // Role Types List
	  resource.getRoleTypes = function () {
	    return $http.get(baseUrl + '/role-types').then(processResponse, processError);
	  };
	
	  // Sports
	  /*resource.getSports = function(){
	    return $http.get(sportsUrl).then(processResponse, processError);
	  };
	  resource.getSportsListStatic = function(){
	    return $http.get(sportsStaticUrl).then(processResponse, processError);
	  };
	  resource.findSport = function(_id){
	    var url = sportsUrl + '/' + _id;
	    return $http.get(url).then(processResponse, processError);
	  };*/
	
	  // Languages
	  resource.getLanguages = function () {
	    return $http.get(languagesUrl).then(processResponse, processError);
	  };
	
	  /*resource.resetRedis = function(){
	    return $http.get('/api/redis/reset').then(processResponse, processError);
	  };*/
	
	  return resource;
	}]);

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.algoliaResource', ['security.service', 'config']).factory('algoliaResource', ['$http', '$q', '$log', 'security', function ($http, $q) {
	  // local variable
	
	  var NEXTJS_URL = 'https://iworis-family.pl';
	  //const NEXTJS_URL = 'http://localhost:3000'
	  var baseUrl = NEXTJS_URL + '/api';
	  var processResponse = function processResponse(res) {
	    return res.data;
	  };
	  var processError = function processError(e) {
	    var msg = [];
	    if (e.status) {
	      msg.push(e.status);
	    }
	    if (e.statusText) {
	      msg.push(e.statusText);
	    }
	    if (msg.length === 0) {
	      msg.push('Unknown Server Error');
	    }
	    return $q.reject(msg.join(' '));
	  };
	  // public api
	  var resource = {};
	  resource.indexingArticles = function () {
	    return $http.get(baseUrl + '/algolia/articles').then(processResponse, processError);
	  };
	  resource.indexingAuthors = function () {
	    return $http.get(baseUrl + '/algolia/authors').then(processResponse, processError);
	  };
	  resource.indexingTags = function () {
	    return $http.get(baseUrl + '/algolia/tags').then(processResponse, processError);
	  };
	
	  return resource;
	}]);

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var countries = __webpack_require__(161);
	var editions = __webpack_require__(187);
	
	var hasCountry = function hasCountry(user) {
	  return !!user.account.country;
	};
	
	var hasEdition = function hasEdition(user) {
	  // always return true for intolerancia
	  return true;
	  // // console.log('>>>', user);
	  // if (user.permissions.is_admin || user.permissions.is_editor) {
	  //   return true
	  // }
	  // var userEditions = [];
	  // _.forIn(editions, function (value, key) {
	  //   userEditions.push({
	  //     _id: key,
	  //     name: value
	  //   });
	  // });
	  // user.editions = []
	  // user.account.groups.forEach(function (group) {
	  //   if (_.find(userEditions, {_id: group._id})) {
	  //     user.editions.push({
	  //       _id: group._id,
	  //       name: userEditions[group._id]
	  //     });
	  //   }
	  // });
	  // return !!user.account.groups && !!user.editions.length;
	};
	
	var hasFullName = function hasFullName(user) {
	  return !!user.account.name.full;
	};
	
	angular.module('services.editionChecker', ['resources.User', 'services.formErrors']).factory('editionChecker', ["$location", "$uibModal", "security", function ($location, $uibModal, security) {
	  var dialog = null;
	  var handleClose = function handleClose() {
	    dialog.close();
	    dialog = null;
	  };
	  return {
	    check: function check(user) {
	      // console.log( '>>>', user );
	      if ( /*!hasFullName(user) || */!hasCountry(user) || !hasEdition(user)) {
	        dialog = $uibModal.open({
	          template: __webpack_require__(361),
	          controller: 'SelectEditionCtrl',
	          resolve: {
	            user: user
	          }
	        });
	        dialog.result.then(handleClose);
	      }
	    }
	  };
	}]).controller('SelectEditionCtrl', ["$scope", "$location", "security", "editionResource", "$modalInstance", "User", "user", "formErrors", "growl", function ($scope, $location, security, editionResource, $modalInstance, User, user, formErrors, growl) {
	  $scope.countries = [];
	  _.forIn(countries, function (value, key) {
	    $scope.countries.push({
	      _id: key,
	      name: value
	    });
	  });
	  $scope.editions = [];
	  _.forIn(editions, function (value, key) {
	    $scope.editions.push({
	      _id: key,
	      name: value
	    });
	  });
	
	  $scope.data = {
	    firstname: user.account.name.first,
	    lastname: user.account.name.last,
	    email: user.email,
	    country: _.find($scope.countries, { _id: user.account.country }),
	    editions: []
	  };
	  $scope.data2 = {
	    username: user.username,
	    email: user.email
	  };
	
	  user.account.groups.forEach(function (group) {
	    if (editions[group._id]) {
	      $scope.data.editions.push({
	        _id: group._id,
	        name: editions[group._id]
	      });
	    }
	  });
	
	  $scope.hasCountry = function () {
	    return hasCountry(user);
	  };
	  $scope.hasEdition = function () {
	    return hasEdition(user);
	  };
	  $scope.hasFullName = function () {
	    return hasFullName(user);
	  };
	  $scope.save = function () {
	    var data = angular.copy($scope.data);
	    data.country = data.country._id;
	
	    data.editions = _.map(data.editions, '_id');
	    User.completeSignup(data, function (result) {
	      $modalInstance.close();
	      growl.info('Info saved');
	    }, formErrors.growlErrors);
	
	    var data2 = angular.copy($scope.data2);
	    data2.email = data.email;
	    User.changeLogin(data2, function (result) {
	      $scope.data2 = {};
	    }, formErrors.growlErrors);
	  };
	}]);

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports = "<form name=form class=login-form ng-submit=save()> <div class=modal-header> <h3>Complete singup info</h3> </div> <div class=modal-body> <div class=form-group> <label class=control-label for=firstname>First name:</label> <input class=form-control type=text name=firstname id=firstname ng-model=data.firstname required> </div> <div class=form-group> <label class=control-label for=lastname>Last name:</label> <input class=form-control type=text name=lastname id=lastname ng-model=data.lastname required> </div> <div class=form-group> <label class=control-label for=email>Email:</label> <input class=form-control type=text name=email id=email ng-model=data.email required> </div> <div class=form-group ng-hide=hasCountry()> <label class=control-label for=country>Country:</label> <oi-select id=country oi-options=\"country.name for country in countries track by country._id\" ng-model=data.country placeholder=\"\" required></oi-select> </div> </div> <div class=modal-footer> <button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid>Save</button> </div> </form> ";

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.editionResource', ['security.service']).factory('editionResource', ['$http', '$q', '$log', 'security', function ($http, $q, $log, security) {
	  // local variable
	  var baseUrl = '/api';
	  var processResponse = function processResponse(res) {
	    return res.data;
	  };
	  var processError = function processError(e) {
	    var msg = [];
	    if (e.status) {
	      msg.push(e.status);
	    }
	    if (e.statusText) {
	      msg.push(e.statusText);
	    }
	    if (msg.length === 0) {
	      msg.push('Unknown Server Error');
	    }
	    return $q.reject(msg.join(' '));
	  };
	  // public api
	  var resource = {};
	  resource.getEdition = function (data) {
	    return $http.post(baseUrl + '/sendMessage', data).then(processResponse, processError);
	  };
	  resource.addEdition = function (edition) {
	    return $http.put(baseUrl + '/account/settings/addEdition', edition).then(processResponse, processError);
	  };
	
	  return resource;
	}]);

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.formErrors', ['angular-growl']).factory('formErrors', ["growl", function (growl) {
	  return {
	    growlErrors: function growlErrors(res) {
	      if (res.status === 400) {
	        if (res.data.name === 'BusinessRuleError') {
	          growl.error(res.data.message);
	        } else {
	          _.forIn(res.data.errors, function (error, key) {
	            error.messages.forEach(function (message) {
	              growl.error(message);
	            });
	          });
	        }
	      }
	    }
	  };
	}]);

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.httpRequestTracker', []);
	angular.module('services.httpRequestTracker').factory('httpRequestTracker', ['$http', function ($http) {
	
	  var httpRequestTracker = {};
	  httpRequestTracker.hasPendingRequests = function () {
	    return $http.pendingRequests.length > 0;
	  };
	
	  return httpRequestTracker;
	}]);

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.i18nNotifications', ['services.notifications', 'services.localizedMessages']);
	angular.module('services.i18nNotifications').factory('i18nNotifications', ['localizedMessages', 'notifications', function (localizedMessages, notifications) {
	
	  var prepareNotification = function prepareNotification(msgKey, type, interpolateParams, otherProperties) {
	    return angular.extend({
	      message: localizedMessages.get(msgKey, interpolateParams),
	      type: type
	    }, otherProperties);
	  };
	
	  var I18nNotifications = {
	    pushSticky: function pushSticky(msgKey, type, interpolateParams, otherProperties) {
	      return notifications.pushSticky(prepareNotification(msgKey, type, interpolateParams, otherProperties));
	    },
	    pushForCurrentRoute: function pushForCurrentRoute(msgKey, type, interpolateParams, otherProperties) {
	      return notifications.pushForCurrentRoute(prepareNotification(msgKey, type, interpolateParams, otherProperties));
	    },
	    pushForNextRoute: function pushForNextRoute(msgKey, type, interpolateParams, otherProperties) {
	      return notifications.pushForNextRoute(prepareNotification(msgKey, type, interpolateParams, otherProperties));
	    },
	    getCurrent: function getCurrent() {
	      return notifications.getCurrent();
	    },
	    remove: function remove(notification) {
	      return notifications.remove(notification);
	    }
	  };
	
	  return I18nNotifications;
	}]);

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.localizedMessages', []).factory('localizedMessages', ['$interpolate', 'I18N.MESSAGES', function ($interpolate, i18nmessages) {
	
	  var handleNotFound = function handleNotFound(msg, msgKey) {
	    return msg || '?' + msgKey + '?';
	  };
	
	  return {
	    get: function get(msgKey, interpolateParams) {
	      var key = navigator.language || navigator.userLanguage || 'en';
	      key = key.split("-")[0];
	      var msg = i18nmessages[key][msgKey];
	      if (msg) {
	        return $interpolate(msg)(interpolateParams);
	      } else {
	        return handleNotFound(msg, msgKey);
	      }
	    }
	  };
	}]);

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	// angular
	//   .module('services.middleware', [
	//     'middlewares'
	//   ])
	//   .run(['$rootScope', '$location', '$injector', function ($rootScope, $location, $injector) {
	//     var middlewares = [];
	//     var timeout = 10000;
	//     var lastExec = 0;
	//     var skipMiddlewares = false;
	//
	//     var run = function (middleware) {
	//       if (!middleware) {
	//         return;
	//       }
	//
	//       //reset timer
	//       lastExec = Date.now();
	//
	//       var middleware = $injector.get(middleware);
	//
	//       middleware(function (err) {
	//         if (err) {
	//           throw err;
	//         }
	//
	//         if ((Date.now() - lastExec) < timeout) {
	//           run(middlewares.shift());
	//         }
	//       });
	//     };
	//
	//     $rootScope.$on('$stateChangeStart', function (event, toState) {
	//       if (!toState.middlewares) {
	//         return;
	//       }
	//
	//       middlewares = angular.copy(toState.middlewares);
	//
	//       if (middlewares) {
	//         run(middlewares.shift());
	//       }
	//     });
	//   }])
	"use strict";

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.notifications', []).factory('notifications', ['$rootScope', function ($rootScope) {
	
	  var notifications = {
	    'STICKY': [],
	    'ROUTE_CURRENT': [],
	    'ROUTE_NEXT': []
	  };
	  var notificationsService = {};
	
	  var addNotification = function addNotification(notificationsArray, notificationObj) {
	    if (!angular.isObject(notificationObj)) {
	      throw new Error("Only object can be added to the notification service");
	    }
	    notificationsArray.push(notificationObj);
	    return notificationObj;
	  };
	
	  $rootScope.$on('$routeChangeSuccess', function () {
	    notifications.ROUTE_CURRENT.length = 0;
	
	    notifications.ROUTE_CURRENT = angular.copy(notifications.ROUTE_NEXT);
	    notifications.ROUTE_NEXT.length = 0;
	  });
	
	  notificationsService.getCurrent = function () {
	    return [].concat(notifications.STICKY, notifications.ROUTE_CURRENT);
	  };
	
	  notificationsService.pushSticky = function (notification) {
	    return addNotification(notifications.STICKY, notification);
	  };
	
	  notificationsService.pushForCurrentRoute = function (notification) {
	    return addNotification(notifications.ROUTE_CURRENT, notification);
	  };
	
	  notificationsService.pushForNextRoute = function (notification) {
	    return addNotification(notifications.ROUTE_NEXT, notification);
	  };
	
	  notificationsService.remove = function (notification) {
	    angular.forEach(notifications, function (notificationsByType) {
	      var idx = notificationsByType.indexOf(notification);
	      if (idx > -1) {
	        notificationsByType.splice(idx, 1);
	      }
	    });
	  };
	
	  notificationsService.removeAll = function () {
	    angular.forEach(notifications, function (notificationsByType) {
	      notificationsByType.length = 0;
	    });
	  };
	
	  return notificationsService;
	}]);

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.search', []).factory('searchService', ["$location", function ($location) {
	  var searchFn = null;
	  var redirectBase = '';
	
	  return {
	    search: function search(q) {
	      if (!searchFn) {
	        return [];
	      }
	
	      return searchFn({ q: q }).$promise;
	    },
	    setSearchFn: function setSearchFn(fn) {
	      searchFn = fn;
	    },
	    onSelect: function onSelect(item) {
	      $location.path(redirectBase + '/' + item.article_id);
	    },
	    setRedirectBase: function setRedirectBase(base) {
	      redirectBase = base;
	    }
	  };
	}]);

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('services.utility', []).factory('utility', [function () {
	
	  var utility = {};
	  utility.hasError = function (ngModelCtrl) {
	    return ngModelCtrl && ngModelCtrl.$dirty && ngModelCtrl.$invalid;
	  };
	  utility.showError = function (ngModelCtrl, err) {
	    return ngModelCtrl && ngModelCtrl.$dirty && ngModelCtrl.$error[err];
	  };
	  utility.canSave = function (ngFormCtrl) {
	    return ngFormCtrl && ngFormCtrl.$dirty && ngFormCtrl.$valid;
	  };
	  return utility;
	}]);

/***/ })
]);


// WEBPACK FOOTER //
// main.79e9610e92280d09b533.js